/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: any;
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: any;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in `Decimal` scalar type. */
  Decimal: any;
  JSON: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The multiplier path scalar represents a valid GraphQL multiplier path string. */
  MultiplierPath: any;
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: any;
  UUID: any;
};

/** Данные комментария для расценки или прочей Акта КС-2 */
export type ActKc2CommentData = {
  __typename?: 'ActKC2CommentData';
  /** Идентификатор Акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Комментарий */
  comment?: Maybe<Scalars['String']>;
  /** Идентификатор расценки СМР или прочей */
  priceId: Scalars['Long'];
};

/** Данные комментария для расценки или прочей Акта КС-2 */
export type ActKc2CommentDataInput = {
  /** Идентификатор Акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']>;
  /** Идентификатор расценки СМР или прочей */
  priceId: Scalars['Long'];
};

export type ActKc2CorrectionUpdateInput = {
  correctionDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  status: ActKc2StatusEnum;
};

export type ActKc2CreateInput = {
  costGroup: CostGroupEnum;
  date?: InputMaybe<Scalars['Date']>;
  inflationSeasonId?: InputMaybe<Scalars['Long']>;
  number?: InputMaybe<Scalars['Long']>;
  objectId: Scalars['Long'];
  reportingFinishDate?: InputMaybe<Scalars['Date']>;
  reportingStartDate?: InputMaybe<Scalars['Date']>;
  seasonId: Scalars['Long'];
  status: ActKc2StatusEnum;
};

export type ActKc2Data = {
  __typename?: 'ActKC2Data';
  authoredBy: Scalars['String'];
  /** Признак возможности создания корректировочного акта */
  canCreateCorrection?: Maybe<Scalars['Boolean']>;
  contractor?: Maybe<Scalars['String']>;
  contractorAddress?: Maybe<Scalars['String']>;
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  costGroup: CostGroupEnum;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  inflationSeason: WorkOrderSeasonData;
  isCopied?: Maybe<Scalars['Boolean']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  isDistributionOfMtrInflation: Scalars['Boolean'];
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied: Scalars['Boolean'];
  /** Признак того, что копирование объёма из СКзС заблокировано */
  isSKzSCopyLock: Scalars['Boolean'];
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated: Scalars['Boolean'];
  number?: Maybe<Scalars['Long']>;
  object: WorkOrderObjectData;
  primaryId?: Maybe<Scalars['Long']>;
  reportingFinishDate?: Maybe<Scalars['Date']>;
  reportingStartDate?: Maybe<Scalars['Date']>;
  season: WorkOrderSeasonData;
  status: ActKc2StatusEnum;
  statusFollowers: Array<ActKc2StatusEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActKc2DataInput = {
  authoredBy: Scalars['String'];
  /** Признак возможности создания корректировочного акта */
  canCreateCorrection?: InputMaybe<Scalars['Boolean']>;
  contractor?: InputMaybe<Scalars['String']>;
  contractorAddress?: InputMaybe<Scalars['String']>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<Scalars['Long']>;
  costGroup: CostGroupEnum;
  createdAt: Scalars['DateTime'];
  date?: InputMaybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['Long'];
  inflationSeason: WorkOrderSeasonDataInput;
  isCopied?: InputMaybe<Scalars['Boolean']>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  isDistributionOfMtrInflation: Scalars['Boolean'];
  /** Признак неактивного акта */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied: Scalars['Boolean'];
  /** Признак того, что копирование объёма из СКзС заблокировано */
  isSKzSCopyLock: Scalars['Boolean'];
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated: Scalars['Boolean'];
  number?: InputMaybe<Scalars['Long']>;
  object: WorkOrderObjectDataInput;
  primaryId?: InputMaybe<Scalars['Long']>;
  reportingFinishDate?: InputMaybe<Scalars['Date']>;
  reportingStartDate?: InputMaybe<Scalars['Date']>;
  season: WorkOrderSeasonDataInput;
  status: ActKc2StatusEnum;
  statusFollowers: Array<ActKc2StatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Атрибуты группы */
export type ActKc2GroupAttributeData = {
  __typename?: 'ActKC2GroupAttributeData';
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

/** Атрибуты группы */
export type ActKc2GroupAttributeDataInput = {
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

/** Входные данные группы */
export type ActKc2GroupInput = {
  /** Идентификаторы Актов КС-2 */
  actKC2Ids: Array<ActKc2GroupItemInput>;
  /** Наименование группы */
  groupName: Scalars['String'];
};

/** Модель входных данных */
export type ActKc2GroupItemInput = {
  /** Идентификатор Акта КС2 для включения в группу */
  actKC2Id: Scalars['Long'];
};

/** Перечисление для типов группировки актов КС2 */
export enum ActKc2GroupTypeEnum {
  /** По виду строительства */
  ByConstructionType = 'BY_CONSTRUCTION_TYPE',
  /** По группе затрат */
  ByCostGroup = 'BY_COST_GROUP',
  /** По месяцу */
  ByMonth = 'BY_MONTH',
  /** По объекту */
  ByObject = 'BY_OBJECT',
  /** По статусу СКзС */
  ByStatusSkzs = 'BY_STATUS_SKZS',
  /** По году */
  ByYear = 'BY_YEAR',
  /** Ручная группировка */
  Custom = 'CUSTOM'
}

export type ActKc2Item = {
  __typename?: 'ActKC2Item';
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  costGroup: CostGroupEnum;
  date?: Maybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['Long']>;
  object: WorkOrderObjectData;
  status: ActKc2StatusEnum;
};

export type ActKc2ItemFilterInput = {
  and?: InputMaybe<Array<ActKc2ItemFilterInput>>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  number?: InputMaybe<LongOperationFilterInput>;
  object?: InputMaybe<WorkOrderObjectDataFilterInput>;
  or?: InputMaybe<Array<ActKc2ItemFilterInput>>;
  status?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
};

export type ActKc2ItemInput = {
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<Scalars['Long']>;
  costGroup: CostGroupEnum;
  date?: InputMaybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  number?: InputMaybe<Scalars['Long']>;
  object: WorkOrderObjectDataInput;
  status: ActKc2StatusEnum;
};

export type ActKc2ItemSortInput = {
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<SortEnumType>;
  costGroup?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  object?: InputMaybe<WorkOrderObjectDataSortInput>;
  status?: InputMaybe<SortEnumType>;
};

/** Лимиты по виду строительства лимитированной затраты акта КС-2 */
export type ActKc2LimitedCostConstructionTypeLimitData = {
  __typename?: 'ActKC2LimitedCostConstructionTypeLimitData';
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Лимиты затрат по сезонам */
  seasonLimits: Array<ActKc2LimitedCostSeasonLimitData>;
};

/** Лимиты по виду строительства лимитированной затраты акта КС-2 */
export type ActKc2LimitedCostConstructionTypeLimitDataFilterInput = {
  and?: InputMaybe<Array<ActKc2LimitedCostConstructionTypeLimitDataFilterInput>>;
  /** % лимитированных */
  calculatingValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  or?: InputMaybe<Array<ActKc2LimitedCostConstructionTypeLimitDataFilterInput>>;
  /** Лимиты затрат по сезонам */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfActKc2LimitedCostSeasonLimitDataFilterInput>;
};

/** Модель данных лимитированной затраты акта КС-2 для списка */
export type ActKc2LimitedCostItemData = {
  __typename?: 'ActKC2LimitedCostItemData';
  /** Идентификатор акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<Scalars['String']>;
  /** Лимиты по виду строительства */
  constructionTypeLimits: Array<ActKc2LimitedCostConstructionTypeLimitData>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Шифр ДТ */
  key?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
};

/** Модель данных лимитированной затраты акта КС-2 для списка */
export type ActKc2LimitedCostItemDataFilterInput = {
  /** Идентификатор акта КС-2 */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ActKc2LimitedCostItemDataFilterInput>>;
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Лимиты по виду строительства */
  constructionTypeLimits?: InputMaybe<ListFilterInputTypeOfActKc2LimitedCostConstructionTypeLimitDataFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Шифр ДТ */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ActKc2LimitedCostItemDataFilterInput>>;
};

/** Модель данных лимитированной затраты акта КС-2 для списка */
export type ActKc2LimitedCostItemDataSortInput = {
  /** Идентификатор акта КС-2 */
  actKC2Id?: InputMaybe<SortEnumType>;
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Шифр ДТ */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
};

/** Сезонный лимит лимитированной затраты акта КС-2 */
export type ActKc2LimitedCostSeasonLimitData = {
  __typename?: 'ActKC2LimitedCostSeasonLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Сезонный лимит лимитированной затраты акта КС-2 */
export type ActKc2LimitedCostSeasonLimitDataFilterInput = {
  and?: InputMaybe<Array<ActKc2LimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ActKc2LimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Строка реестра актов */
export type ActKc2ListItemData = {
  __typename?: 'ActKC2ListItemData';
  /** Дата актав в заданной тайм зоне */
  actDate?: Maybe<Scalars['Date']>;
  /** Идентификатор акта */
  actKC2Id: Scalars['Long'];
  /** Месяц даты акта в заданной тайм зоне */
  actMonth?: Maybe<Scalars['Int']>;
  /** Год даты акта в заданной тайм зоне */
  actYear?: Maybe<Scalars['Int']>;
  /** Вид строительства */
  constructionType: ConstructionType;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['String']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Стоимость без НДС */
  costWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Дата акта */
  date?: Maybe<Scalars['Date']>;
  /** Дата окончания отчетного периода */
  finishDate?: Maybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Итог группы */
  groupCostWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Количество актов в группе */
  groupCount: Scalars['Int'];
  /** Идентификатор группы */
  groupId?: Maybe<Scalars['Long']>;
  /** Наименование группы */
  groupName?: Maybe<Scalars['String']>;
  /** Строковый идентификатор группы */
  groupUniqueId?: Maybe<Scalars['String']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Номер акта */
  number?: Maybe<Scalars['String']>;
  /** Дата начала отчетного периода */
  startDate?: Maybe<Scalars['Date']>;
  /** Статус акта */
  status?: Maybe<ActKc2StatusEnum>;
  /** Статус акта из СКзС */
  statusSKzS?: Maybe<SkzsActKc2StatusEnum>;
  /** Идентификатор объекта строительства */
  workOrderObjectId: Scalars['Long'];
  /** Наименование объекта строительства */
  workOrderObjectName: Scalars['String'];
};

/** Строка реестра актов */
export type ActKc2ListItemDataFilterInput = {
  /** Дата актав в заданной тайм зоне */
  actDate?: InputMaybe<DateOperationFilterInput>;
  /** Идентификатор акта */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  /** Месяц даты акта в заданной тайм зоне */
  actMonth?: InputMaybe<IntOperationFilterInput>;
  /** Год даты акта в заданной тайм зоне */
  actYear?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<ActKc2ListItemDataFilterInput>>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата акта */
  date?: InputMaybe<DateOperationFilterInput>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<DateOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Итог группы */
  groupCostWithoutTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество актов в группе */
  groupCount?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор группы */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование группы */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Строковый идентификатор группы */
  groupUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер акта */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ActKc2ListItemDataFilterInput>>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<DateOperationFilterInput>;
  /** Статус акта */
  status?: InputMaybe<NullableOfActKc2StatusEnumOperationFilterInput>;
  /** Статус акта из СКзС */
  statusSKzS?: InputMaybe<NullableOfSkzsActKc2StatusEnumOperationFilterInput>;
  /** Идентификатор объекта строительства */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Строка реестра актов */
export type ActKc2ListItemDataSortInput = {
  /** Дата актав в заданной тайм зоне */
  actDate?: InputMaybe<SortEnumType>;
  /** Идентификатор акта */
  actKC2Id?: InputMaybe<SortEnumType>;
  /** Месяц даты акта в заданной тайм зоне */
  actMonth?: InputMaybe<SortEnumType>;
  /** Год даты акта в заданной тайм зоне */
  actYear?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeSortInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<SortEnumType>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<SortEnumType>;
  /** Группа затрат */
  costGroup?: InputMaybe<SortEnumType>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<SortEnumType>;
  /** Дата акта */
  date?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Итог группы */
  groupCostWithoutTax?: InputMaybe<SortEnumType>;
  /** Количество актов в группе */
  groupCount?: InputMaybe<SortEnumType>;
  /** Идентификатор группы */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование группы */
  groupName?: InputMaybe<SortEnumType>;
  /** Строковый идентификатор группы */
  groupUniqueId?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  isIncluded?: InputMaybe<SortEnumType>;
  /** Номер акта */
  number?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<SortEnumType>;
  /** Статус акта */
  status?: InputMaybe<SortEnumType>;
  /** Статус акта из СКзС */
  statusSKzS?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта строительства */
  workOrderObjectId?: InputMaybe<SortEnumType>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<SortEnumType>;
};

export type ActKc2MtrItemInput = {
  inflationSeasonId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId: Scalars['Long'];
};

export type ActKc2NavData = {
  __typename?: 'ActKC2NavData';
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Дата создания акта */
  date?: Maybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор Акта КС2 */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Внутренний номкр акта */
  number?: Maybe<Scalars['Long']>;
  /** Сезон акта */
  season: ContractSeasonNav;
  /** Статус акта */
  status: ActKc2StatusEnum;
};

export type ActKc2NavDataInput = {
  /** Дата коррекции */
  correctionDate?: InputMaybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<Scalars['Long']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Дата создания акта */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  /** Идентификатор Акта КС2 */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Внутренний номкр акта */
  number?: InputMaybe<Scalars['Long']>;
  /** Сезон акта */
  season: ContractSeasonNavInput;
  /** Статус акта */
  status: ActKc2StatusEnum;
};

export type ActKc2OtherPriceItem = {
  __typename?: 'ActKC2OtherPriceItem';
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Стоимость выполненных работ */
  costAccepted?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сущности позиции */
  itemId: Scalars['Long'];
  /** Наименование работы */
  name?: Maybe<Scalars['String']>;
  /** Id конечного объекта */
  objectId?: Maybe<Scalars['Long']>;
  /** Тип позиции */
  type?: Maybe<WorkOrderPriceTypeEnum>;
};

export type ActKc2OtherPriceItemFilterInput = {
  and?: InputMaybe<Array<ActKc2OtherPriceItemFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость выполненных работ */
  costAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сущности позиции */
  itemId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование работы */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id конечного объекта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ActKc2OtherPriceItemFilterInput>>;
  /** Тип позиции */
  type?: InputMaybe<NullableOfWorkOrderPriceTypeEnumOperationFilterInput>;
};

/** Акт КС-2 */
export type ActKc2SelectionData = {
  __typename?: 'ActKC2SelectionData';
  /** Дата акта в заданной тайм зоне */
  actDate?: Maybe<Scalars['Date']>;
  /** Идентификатор акта */
  actKC2Id: Scalars['Long'];
  /** Вид строительства */
  constructionType: ConstructionType;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Стоимость без НДС */
  costWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Дата акта */
  date?: Maybe<Scalars['Date']>;
  /** Дата окончания отчетного периода */
  finishDate?: Maybe<Scalars['Date']>;
  /** Идентификатор группы */
  groupId?: Maybe<Scalars['Long']>;
  /** Наименование группы */
  groupName?: Maybe<Scalars['String']>;
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Номер акта */
  number?: Maybe<Scalars['String']>;
  /** Дата начала отчетного периода */
  startDate?: Maybe<Scalars['Date']>;
  /** Статус акта */
  status?: Maybe<ActKc2StatusEnum>;
  /** Наименование объекта строительства */
  workOrderObjectName: Scalars['String'];
};

/** Акт КС-2 */
export type ActKc2SelectionDataFilterInput = {
  /** Дата акта в заданной тайм зоне */
  actDate?: InputMaybe<DateOperationFilterInput>;
  /** Идентификатор акта */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<ActKc2SelectionDataFilterInput>>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeFilterInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата акта */
  date?: InputMaybe<DateOperationFilterInput>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<DateOperationFilterInput>;
  /** Идентификатор группы */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование группы */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер акта */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ActKc2SelectionDataFilterInput>>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<DateOperationFilterInput>;
  /** Статус акта */
  status?: InputMaybe<NullableOfActKc2StatusEnumOperationFilterInput>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Акт КС-2 */
export type ActKc2SelectionDataSortInput = {
  /** Дата акта в заданной тайм зоне */
  actDate?: InputMaybe<SortEnumType>;
  /** Идентификатор акта */
  actKC2Id?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeSortInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<SortEnumType>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<SortEnumType>;
  /** Дата акта */
  date?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<SortEnumType>;
  /** Идентификатор группы */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование группы */
  groupName?: InputMaybe<SortEnumType>;
  isIncluded?: InputMaybe<SortEnumType>;
  /** Номер акта */
  number?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<SortEnumType>;
  /** Статус акта */
  status?: InputMaybe<SortEnumType>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<SortEnumType>;
};

export type ActKc2SmrPriceItem = {
  __typename?: 'ActKC2SmrPriceItem';
  /** Шифр позиции */
  code?: Maybe<Scalars['String']>;
  /** Стоимость выполненных работ */
  costAccepted?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сущности позиции */
  itemId: Scalars['Long'];
  /** Наименование работы */
  name?: Maybe<Scalars['String']>;
  /** Id конечного объекта */
  objectId?: Maybe<Scalars['Long']>;
  /** Тип позиции */
  type?: Maybe<WorkOrderPriceTypeEnum>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Выполнено работ (количество) */
  volumeAccepted?: Maybe<Scalars['Decimal']>;
};

export type ActKc2SmrPriceItemFilterInput = {
  and?: InputMaybe<Array<ActKc2SmrPriceItemFilterInput>>;
  /** Шифр позиции */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость выполненных работ */
  costAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сущности позиции */
  itemId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование работы */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id конечного объекта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ActKc2SmrPriceItemFilterInput>>;
  /** Тип позиции */
  type?: InputMaybe<NullableOfWorkOrderPriceTypeEnumOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Выполнено работ (количество) */
  volumeAccepted?: InputMaybe<DecimalOperationFilterInput>;
};

export type ActKc2StatusData = {
  __typename?: 'ActKC2StatusData';
  /** Статусы возможные для перехода из Status */
  followers: Array<ActKc2StatusEnum>;
  /** Статус */
  status: ActKc2StatusEnum;
};

export type ActKc2StatusDataInput = {
  /** Статусы возможные для перехода из Status */
  followers: Array<ActKc2StatusEnum>;
  /** Статус */
  status: ActKc2StatusEnum;
};

export enum ActKc2StatusEnum {
  /** Согласован */
  Accepted = 'ACCEPTED',
  /** В работе */
  InProgress = 'IN_PROGRESS',
  /** На проверке */
  OnCheck = 'ON_CHECK'
}

export type ActKc2StatusEnumOperationFilterInput = {
  eq?: InputMaybe<ActKc2StatusEnum>;
  in?: InputMaybe<Array<ActKc2StatusEnum>>;
  neq?: InputMaybe<ActKc2StatusEnum>;
  nin?: InputMaybe<Array<ActKc2StatusEnum>>;
};

/** Модель результата импорта шаблона акта */
export type ActKc2TemplateImport = {
  __typename?: 'ActKC2TemplateImport';
  /** Идентификатор акта */
  actKC2Id: Scalars['Long'];
  /** Идентификатор вида строительства объекта акта */
  constructionTypeId: Scalars['Long'];
  /** Идентификатор корневого объекта НЗ акта */
  workOrderObjectId: Scalars['Long'];
};

/** Модель результата импорта шаблона акта */
export type ActKc2TemplateImportInput = {
  /** Идентификатор акта */
  actKC2Id: Scalars['Long'];
  /** Идентификатор вида строительства объекта акта */
  constructionTypeId: Scalars['Long'];
  /** Идентификатор корневого объекта НЗ акта */
  workOrderObjectId: Scalars['Long'];
};

/** Параметры шаблона Акта КС2 */
export type ActKc2TemplateInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Long'];
  /** Группа затрат (СМР/Прочие) */
  costGroup: CostGroupEnum;
  /** Идентификаторы объектов НЗ */
  workOrderObjectIds: Array<Scalars['Long']>;
  /** Идентификатор сезона НЗ */
  workOrderSeasonId: Scalars['Long'];
};

export type ActKc2TotalItem = {
  __typename?: 'ActKC2TotalItem';
  /** Признак итога акта */
  isActKC2Total: Scalars['Boolean'];
  /** Признак корректировочного акта */
  isCorrection: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine?: Maybe<Scalars['Boolean']>;
  /** Имя */
  name?: Maybe<Scalars['String']>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Стоимость */
  totalCost?: Maybe<Scalars['Decimal']>;
};

export type ActKc2TotalItemFilterInput = {
  and?: InputMaybe<Array<ActKc2TotalItemFilterInput>>;
  /** Признак итога акта */
  isActKC2Total?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки заголовка (серая строка) */
  isHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ActKc2TotalItemFilterInput>>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Стоимость */
  totalCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные диаграммы ФО НЗ по расценкам */
export type ActKc2UerCostChartData = {
  __typename?: 'ActKC2UerCostChartData';
  /** Принято */
  rimActKC2WorkCost: Scalars['Decimal'];
  /** Согласованно СКзС */
  skzsActKC2WorkCost: Scalars['Decimal'];
  /** Код расценки УЕР */
  uerCode: Scalars['String'];
  /** Наименование расценки */
  uerName: Scalars['String'];
};

/** Данные диаграммы ФО НЗ по расценкам */
export type ActKc2UerCostChartDataFilterInput = {
  and?: InputMaybe<Array<ActKc2UerCostChartDataFilterInput>>;
  or?: InputMaybe<Array<ActKc2UerCostChartDataFilterInput>>;
  /** Принято */
  rimActKC2WorkCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Согласованно СКзС */
  skzsActKC2WorkCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Код расценки УЕР */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование расценки */
  uerName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные диаграммы ФО НЗ по расценкам */
export type ActKc2UerCostChartDataSortInput = {
  /** Принято */
  rimActKC2WorkCost?: InputMaybe<SortEnumType>;
  /** Согласованно СКзС */
  skzsActKC2WorkCost?: InputMaybe<SortEnumType>;
  /** Код расценки УЕР */
  uerCode?: InputMaybe<SortEnumType>;
  /** Наименование расценки */
  uerName?: InputMaybe<SortEnumType>;
};

/** Данные диаграммы ФО НЗ по сезонам */
export type ActKc2UerCostPlotData = {
  __typename?: 'ActKC2UerCostPlotData';
  /** Дата */
  date: Scalars['Date'];
  /** Принято */
  rimActKC2WorkCost: Scalars['Decimal'];
  /** Согласованно СКзС */
  skzsActKC2WorkCost: Scalars['Decimal'];
};

/** Данные диаграммы ФО НЗ по сезонам */
export type ActKc2UerCostPlotDataFilterInput = {
  and?: InputMaybe<Array<ActKc2UerCostPlotDataFilterInput>>;
  /** Дата */
  date?: InputMaybe<DateOperationFilterInput>;
  or?: InputMaybe<Array<ActKc2UerCostPlotDataFilterInput>>;
  /** Принято */
  rimActKC2WorkCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Согласованно СКзС */
  skzsActKC2WorkCost?: InputMaybe<DecimalOperationFilterInput>;
};

export type ActKc2UpdateInput = {
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['Long'];
  inflationSeasonId?: InputMaybe<Scalars['Long']>;
  number?: InputMaybe<Scalars['Long']>;
  reportingFinishDate?: InputMaybe<Scalars['Date']>;
  reportingStartDate?: InputMaybe<Scalars['Date']>;
  seasonId: Scalars['Long'];
  status: ActKc2StatusEnum;
};

export type ActKc2VolumeVariableSelectionItem = {
  __typename?: 'ActKC2VolumeVariableSelectionItem';
  /** Коэффициенты для позиции УЕР */
  coefficients: Array<Scalars['String']>;
  /** Позиция УЕР */
  isMtr: Scalars['Boolean'];
  /** Позиция МТР */
  isUer: Scalars['Boolean'];
  /** Наименование переменной */
  name: Scalars['String'];
  /** ID позиции */
  uniqueId: Scalars['String'];
};

export type ActKc2VolumeVariableSelectionItemFilterInput = {
  and?: InputMaybe<Array<ActKc2VolumeVariableSelectionItemFilterInput>>;
  /** Коэффициенты для позиции УЕР */
  coefficients?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Позиция УЕР */
  isMtr?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция МТР */
  isUer?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование переменной */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ActKc2VolumeVariableSelectionItemFilterInput>>;
  /** ID позиции */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные индивидуального значения в акте по позиции НЗ */
export type ActKc2WorkVolumeData = {
  __typename?: 'ActKC2WorkVolumeData';
  /** Идентификатор Акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Комментарий к объёму акта */
  comment?: Maybe<Scalars['String']>;
  /** Ошибки вычисления факта */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Формула для расчёта факта */
  formula?: Maybe<Scalars['String']>;
  /** Признак наличия ошибок вычисления по формуле */
  hasErrors: Scalars['Boolean'];
  /** Признак наличия формулы для вычисления значения */
  hasFormula: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор строки прайса наряд-заказа */
  priceId: Scalars['Long'];
  /** Объем (согласовано) */
  volumeAccepted?: Maybe<Scalars['Decimal']>;
  /** Отклонение объема (согласовано) */
  volumeAcceptedDeviation?: Maybe<DeviationEnum>;
  /** Объем (план) */
  volumePlan?: Maybe<Scalars['Decimal']>;
  /** Отклонение объема (план) */
  volumePlanDeviation?: Maybe<DeviationEnum>;
};

/** Данные индивидуального значения в акте по позиции НЗ */
export type ActKc2WorkVolumeDataInput = {
  /** Идентификатор Акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Комментарий к объёму акта */
  comment?: InputMaybe<Scalars['String']>;
  /** Ошибки вычисления факта */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Формула для расчёта факта */
  formula?: InputMaybe<Scalars['String']>;
  /** Признак наличия ошибок вычисления по формуле */
  hasErrors: Scalars['Boolean'];
  /** Признак наличия формулы для вычисления значения */
  hasFormula: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор строки прайса наряд-заказа */
  priceId: Scalars['Long'];
  /** Объем (согласовано) */
  volumeAccepted?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение объема (согласовано) */
  volumeAcceptedDeviation?: InputMaybe<DeviationEnum>;
  /** Объем (план) */
  volumePlan?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение объема (план) */
  volumePlanDeviation?: InputMaybe<DeviationEnum>;
};

/** Элемент списка Актов КС-2 Справки КС-3 */
export type ActKc3ActsKc2SelectionItem = {
  __typename?: 'ActKC3ActsKC2SelectionItem';
  /** Корректировочный номер Акта КС-2 */
  actKC2CorrectionNumber?: Maybe<Scalars['Long']>;
  /** Группа затрат Акта КС-2 */
  actKC2CostGroup: CostGroupEnum;
  /** Дата Акта КС-2 */
  actKC2Date?: Maybe<Scalars['Date']>;
  /** Дата окончания отчетного периода Акта КС-2 */
  actKC2FinishDate?: Maybe<Scalars['Date']>;
  /** Полный номер Акта КС-2 */
  actKC2FullNumber: Scalars['String'];
  /** Идентификатор Акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Признак корректировочного Акта КС-2 */
  actKC2IsCorrection?: Maybe<Scalars['Boolean']>;
  /** Акт КС-2 является основанием для корректировочной Справки КС-3 */
  actKC2IsCorrectionOfActKC3: Scalars['Boolean'];
  /** Признак неактивного Акта КС-2 */
  actKC2IsInactive?: Maybe<Scalars['Boolean']>;
  /** Акт КС-2 включен в состав родительской Справки КС-3 */
  actKC2IsIncludedToPrimaryActKC3?: Maybe<Scalars['Boolean']>;
  /** Номер Акта КС-2 */
  actKC2Number?: Maybe<Scalars['Long']>;
  /** Дата начала отчетного периода Акта КС-2 */
  actKC2StartDate?: Maybe<Scalars['Date']>;
  /** Статус Акта КС-2 */
  actKC2Status: ActKc2StatusEnum;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Наименование вида строительства */
  constructionTypeName: Scalars['String'];
  /** Сокращенное наименование вида строительства */
  constructionTypeShortName: Scalars['String'];
  /** Идентификатор Договора */
  contractId: Scalars['Long'];
  /** Идентификатор объекта Договора */
  contractObjectId?: Maybe<Scalars['Long']>;
  /** Наименование объекта Договора */
  contractObjectName: Scalars['String'];
  /** Признак выделения */
  isSelected: Scalars['Boolean'];
  /** Дата Наряд-Заказа */
  workOrderDate?: Maybe<Scalars['DateTime']>;
  /** Идентификатор Наряд-Заказа */
  workOrderId: Scalars['Long'];
  /** Внутренний номер Наряд-Заказа */
  workOrderInternalNumber?: Maybe<Scalars['String']>;
  /** Наименование Наряд-Заказа (метка из номера и даты) */
  workOrderName?: Maybe<Scalars['String']>;
  /** Идентификатор объекта Наряд-Заказа */
  workOrderObjectId: Scalars['Long'];
  /** Статус Наряд-Заказа */
  workOrderStatus: WorkOrderStatusEnum;
  /** Предмет Наряд-Заказа */
  workOrderSubject?: Maybe<Scalars['String']>;
};

/** Элемент списка Актов КС-2 Справки КС-3 */
export type ActKc3ActsKc2SelectionItemFilterInput = {
  /** Корректировочный номер Акта КС-2 */
  actKC2CorrectionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Группа затрат Акта КС-2 */
  actKC2CostGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Дата Акта КС-2 */
  actKC2Date?: InputMaybe<DateOperationFilterInput>;
  /** Дата окончания отчетного периода Акта КС-2 */
  actKC2FinishDate?: InputMaybe<DateOperationFilterInput>;
  /** Полный номер Акта КС-2 */
  actKC2FullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор Акта КС-2 */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочного Акта КС-2 */
  actKC2IsCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Акт КС-2 является основанием для корректировочной Справки КС-3 */
  actKC2IsCorrectionOfActKC3?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного Акта КС-2 */
  actKC2IsInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Акт КС-2 включен в состав родительской Справки КС-3 */
  actKC2IsIncludedToPrimaryActKC3?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер Акта КС-2 */
  actKC2Number?: InputMaybe<LongOperationFilterInput>;
  /** Дата начала отчетного периода Акта КС-2 */
  actKC2StartDate?: InputMaybe<DateOperationFilterInput>;
  /** Статус Акта КС-2 */
  actKC2Status?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  and?: InputMaybe<Array<ActKc3ActsKc2SelectionItemFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Наименование вида строительства */
  constructionTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Сокращенное наименование вида строительства */
  constructionTypeShortName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор Договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта Договора */
  contractObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование объекта Договора */
  contractObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак выделения */
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ActKc3ActsKc2SelectionItemFilterInput>>;
  /** Дата Наряд-Заказа */
  workOrderDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Идентификатор Наряд-Заказа */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Внутренний номер Наряд-Заказа */
  workOrderInternalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование Наряд-Заказа (метка из номера и даты) */
  workOrderName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор объекта Наряд-Заказа */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус Наряд-Заказа */
  workOrderStatus?: InputMaybe<WorkOrderStatusEnumOperationFilterInput>;
  /** Предмет Наряд-Заказа */
  workOrderSubject?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Элемент списка Актов КС-2 Справки КС-3 */
export type ActKc3ActsKc2SelectionItemSortInput = {
  /** Корректировочный номер Акта КС-2 */
  actKC2CorrectionNumber?: InputMaybe<SortEnumType>;
  /** Группа затрат Акта КС-2 */
  actKC2CostGroup?: InputMaybe<SortEnumType>;
  /** Дата Акта КС-2 */
  actKC2Date?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода Акта КС-2 */
  actKC2FinishDate?: InputMaybe<SortEnumType>;
  /** Полный номер Акта КС-2 */
  actKC2FullNumber?: InputMaybe<SortEnumType>;
  /** Идентификатор Акта КС-2 */
  actKC2Id?: InputMaybe<SortEnumType>;
  /** Признак корректировочного Акта КС-2 */
  actKC2IsCorrection?: InputMaybe<SortEnumType>;
  /** Акт КС-2 является основанием для корректировочной Справки КС-3 */
  actKC2IsCorrectionOfActKC3?: InputMaybe<SortEnumType>;
  /** Признак неактивного Акта КС-2 */
  actKC2IsInactive?: InputMaybe<SortEnumType>;
  /** Акт КС-2 включен в состав родительской Справки КС-3 */
  actKC2IsIncludedToPrimaryActKC3?: InputMaybe<SortEnumType>;
  /** Номер Акта КС-2 */
  actKC2Number?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода Акта КС-2 */
  actKC2StartDate?: InputMaybe<SortEnumType>;
  /** Статус Акта КС-2 */
  actKC2Status?: InputMaybe<SortEnumType>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Наименование вида строительства */
  constructionTypeName?: InputMaybe<SortEnumType>;
  /** Сокращенное наименование вида строительства */
  constructionTypeShortName?: InputMaybe<SortEnumType>;
  /** Идентификатор Договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Договора */
  contractObjectId?: InputMaybe<SortEnumType>;
  /** Наименование объекта Договора */
  contractObjectName?: InputMaybe<SortEnumType>;
  /** Признак выделения */
  isSelected?: InputMaybe<SortEnumType>;
  /** Дата Наряд-Заказа */
  workOrderDate?: InputMaybe<SortEnumType>;
  /** Идентификатор Наряд-Заказа */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Внутренний номер Наряд-Заказа */
  workOrderInternalNumber?: InputMaybe<SortEnumType>;
  /** Наименование Наряд-Заказа (метка из номера и даты) */
  workOrderName?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Наряд-Заказа */
  workOrderObjectId?: InputMaybe<SortEnumType>;
  /** Статус Наряд-Заказа */
  workOrderStatus?: InputMaybe<SortEnumType>;
  /** Предмет Наряд-Заказа */
  workOrderSubject?: InputMaybe<SortEnumType>;
};

export type ActKc3Data = {
  __typename?: 'ActKC3Data';
  /** &gt;Список идентификаторов актов КС2 включенных в КС3 */
  actKC2Ids?: Maybe<Array<Scalars['Long']>>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Номер коррекции справки */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Дата */
  date?: Maybe<Scalars['Date']>;
  /** Полный номер справки, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак корректировочной справки */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивной справки */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Номер */
  number?: Maybe<Scalars['Long']>;
  /** &gt;Конец отчетного периода. Вычисляется из списка актов */
  reportingFinishDate?: Maybe<Scalars['Date']>;
  /** Начало отчетного периода. Вычисляется из списка актов */
  reportingStartDate?: Maybe<Scalars['Date']>;
};

export type ActKc3DataInput = {
  /** &gt;Список идентификаторов актов КС2 включенных в КС3 */
  actKC2Ids?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Номер коррекции справки */
  correctionNumber?: InputMaybe<Scalars['Long']>;
  /** Дата */
  date?: InputMaybe<Scalars['Date']>;
  /** Полный номер справки, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак корректировочной справки */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивной справки */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Номер */
  number?: InputMaybe<Scalars['Long']>;
  /** &gt;Конец отчетного периода. Вычисляется из списка актов */
  reportingFinishDate?: InputMaybe<Scalars['Date']>;
  /** Начало отчетного периода. Вычисляется из списка актов */
  reportingStartDate?: InputMaybe<Scalars['Date']>;
};

export type ActKc3DataWithActs = {
  __typename?: 'ActKC3DataWithActs';
  /** &gt;Список идентификаторов актов КС2 включенных в КС3 */
  actKC2Ids?: Maybe<Array<Scalars['Long']>>;
  /**
   * Список актов КС2 как уже включенных
   *             так и доступных для добавления в текущую справку КС3
   */
  actsKC2?: Maybe<Array<ActKc2Item>>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Номер коррекции справки */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Дата */
  date?: Maybe<Scalars['Date']>;
  /** Полный номер справки, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак корректировочной справки */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивной справки */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Номер */
  number?: Maybe<Scalars['Long']>;
  /** &gt;Конец отчетного периода. Вычисляется из списка актов */
  reportingFinishDate?: Maybe<Scalars['Date']>;
  /** Начало отчетного периода. Вычисляется из списка актов */
  reportingStartDate?: Maybe<Scalars['Date']>;
};

export type ActKc3DataWithActsInput = {
  /** &gt;Список идентификаторов актов КС2 включенных в КС3 */
  actKC2Ids?: InputMaybe<Array<Scalars['Long']>>;
  /**
   * Список актов КС2 как уже включенных
   *             так и доступных для добавления в текущую справку КС3
   */
  actsKC2?: InputMaybe<Array<ActKc2ItemInput>>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Номер коррекции справки */
  correctionNumber?: InputMaybe<Scalars['Long']>;
  /** Дата */
  date?: InputMaybe<Scalars['Date']>;
  /** Полный номер справки, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак корректировочной справки */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивной справки */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Номер */
  number?: InputMaybe<Scalars['Long']>;
  /** &gt;Конец отчетного периода. Вычисляется из списка актов */
  reportingFinishDate?: InputMaybe<Scalars['Date']>;
  /** Начало отчетного периода. Вычисляется из списка актов */
  reportingStartDate?: InputMaybe<Scalars['Date']>;
};

export type ActKc3Input = {
  /** &gt;Список идентификаторов актов КС2 включенных в КС3 */
  actKC2Ids?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Дата */
  date?: InputMaybe<Scalars['Date']>;
  /** Признак обязательности коррекции итогов справки */
  isTotalsCorrectionRequired?: InputMaybe<Scalars['Boolean']>;
  /** Номер */
  number?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта строительства */
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<Scalars['Long']>;
};

/** Уровень справки КС-3 */
export enum ActKc3LevelEnum {
  /** Договор */
  Contract = 'CONTRACT',
  /** Объект строительства */
  Object = 'OBJECT',
  /** Наряд-Заказ */
  WorkOrder = 'WORK_ORDER'
}

export type ActKc3NavData = {
  __typename?: 'ActKC3NavData';
  /** Акты включенные в справку */
  actsKC2?: Maybe<Array<ActKc2NavData>>;
  /** Номер коррекции справки */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Дата */
  date?: Maybe<Scalars['DateTime']>;
  /** Полный номер справки, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак корректировочной справки */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивной справки */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Номер */
  number?: Maybe<Scalars['Long']>;
};

export type ActKc3NavDataInput = {
  /** Акты включенные в справку */
  actsKC2?: InputMaybe<Array<ActKc2NavDataInput>>;
  /** Номер коррекции справки */
  correctionNumber?: InputMaybe<Scalars['Long']>;
  /** Дата */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Полный номер справки, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак корректировочной справки */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивной справки */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Номер */
  number?: InputMaybe<Scalars['Long']>;
};

/** Модель элемента реестра справок КС-3 */
export type ActKc3RegistryItem = {
  __typename?: 'ActKC3RegistryItem';
  /** Дата акта КС-2 */
  actKC2Date?: Maybe<Scalars['Date']>;
  /** Номер акта КС-2 */
  actKC2FullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Дата окончания отчетного периода акта КС-2 */
  actKC2ReportingFinishDate?: Maybe<Scalars['Date']>;
  /** Дата начала отчетного периода акта КС-2 */
  actKC2ReportingStartDate?: Maybe<Scalars['Date']>;
  /** Статус */
  actKC2Status: ActKc2StatusEnum;
  /** Итоги Акта КС-2 ("Всего по Акту КС-2") */
  actKC2TotalCost?: Maybe<Scalars['Decimal']>;
  /** Итоги Акта КС-2 ("Всего по Акту КС-2") + 20% */
  actKC2TotalCostWithTax?: Maybe<Scalars['Decimal']>;
  /** Признак возможности удаления справки КС-3 */
  actKC3CanDelete?: Maybe<Scalars['Boolean']>;
  /** Признак возможности редактирования справки КС-3 */
  actKC3CanEdit?: Maybe<Scalars['Boolean']>;
  /** Номер корректировки справки КС-3 */
  actKC3CorrectionNumber?: Maybe<Scalars['Long']>;
  /** Дата справки КС-3 */
  actKC3Date?: Maybe<Scalars['Date']>;
  /** Стоимость с начала работ */
  actKC3FromWorkStartCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость с начала года */
  actKC3FromYearStartCost?: Maybe<Scalars['Decimal']>;
  /** Полный номер справки КС-3 */
  actKC3FullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор справки КС-3 */
  actKC3Id: Scalars['Long'];
  /** Признак корректировочной справки КС-3 */
  actKC3IsCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивной справки КС-3 */
  actKC3IsInactive?: Maybe<Scalars['Boolean']>;
  /** Номер справки КС-3 */
  actKC3Number?: Maybe<Scalars['Long']>;
  /** Стоимость за отчетный период */
  actKC3ReportedPeriodCost?: Maybe<Scalars['Decimal']>;
  /** Дата окончания отчетного периода справки КС-3 */
  actKC3ReportingFinishDate?: Maybe<Scalars['Date']>;
  /** Дата начала отчетного периода справки КС-3 */
  actKC3ReportingStartDate?: Maybe<Scalars['Date']>;
  /** Всего с НДС */
  actKC3TotalCostWithTax?: Maybe<Scalars['Decimal']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Признак того что справка КС-3 является последней в рамках заданного уровня справки в договоре */
  isFinal: Scalars['Boolean'];
  /** Идентификатор объекта строительства */
  rootContractObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор наряд-заказа */
  workOrderId?: Maybe<Scalars['Long']>;
};

/** Модель элемента реестра справок КС-3 */
export type ActKc3RegistryItemFilterInput = {
  /** Дата акта КС-2 */
  actKC2Date?: InputMaybe<DateOperationFilterInput>;
  /** Номер акта КС-2 */
  actKC2FullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор акта КС-2 */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  /** Дата окончания отчетного периода акта КС-2 */
  actKC2ReportingFinishDate?: InputMaybe<DateOperationFilterInput>;
  /** Дата начала отчетного периода акта КС-2 */
  actKC2ReportingStartDate?: InputMaybe<DateOperationFilterInput>;
  /** Статус */
  actKC2Status?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  /** Итоги Акта КС-2 ("Всего по Акту КС-2") */
  actKC2TotalCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Итоги Акта КС-2 ("Всего по Акту КС-2") + 20% */
  actKC2TotalCostWithTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Признак возможности удаления справки КС-3 */
  actKC3CanDelete?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак возможности редактирования справки КС-3 */
  actKC3CanEdit?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер корректировки справки КС-3 */
  actKC3CorrectionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Дата справки КС-3 */
  actKC3Date?: InputMaybe<DateOperationFilterInput>;
  /** Стоимость с начала работ */
  actKC3FromWorkStartCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость с начала года */
  actKC3FromYearStartCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Полный номер справки КС-3 */
  actKC3FullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор справки КС-3 */
  actKC3Id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочной справки КС-3 */
  actKC3IsCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивной справки КС-3 */
  actKC3IsInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер справки КС-3 */
  actKC3Number?: InputMaybe<LongOperationFilterInput>;
  /** Стоимость за отчетный период */
  actKC3ReportedPeriodCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата окончания отчетного периода справки КС-3 */
  actKC3ReportingFinishDate?: InputMaybe<DateOperationFilterInput>;
  /** Дата начала отчетного периода справки КС-3 */
  actKC3ReportingStartDate?: InputMaybe<DateOperationFilterInput>;
  /** Всего с НДС */
  actKC3TotalCostWithTax?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ActKc3RegistryItemFilterInput>>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Признак того что справка КС-3 является последней в рамках заданного уровня справки в договоре */
  isFinal?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ActKc3RegistryItemFilterInput>>;
  /** Идентификатор объекта строительства */
  rootContractObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
};

/** Модель элемента реестра справок КС-3 */
export type ActKc3RegistryItemSortInput = {
  /** Дата акта КС-2 */
  actKC2Date?: InputMaybe<SortEnumType>;
  /** Номер акта КС-2 */
  actKC2FullNumber?: InputMaybe<SortEnumType>;
  /** Идентификатор акта КС-2 */
  actKC2Id?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода акта КС-2 */
  actKC2ReportingFinishDate?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода акта КС-2 */
  actKC2ReportingStartDate?: InputMaybe<SortEnumType>;
  /** Статус */
  actKC2Status?: InputMaybe<SortEnumType>;
  /** Итоги Акта КС-2 ("Всего по Акту КС-2") */
  actKC2TotalCost?: InputMaybe<SortEnumType>;
  /** Итоги Акта КС-2 ("Всего по Акту КС-2") + 20% */
  actKC2TotalCostWithTax?: InputMaybe<SortEnumType>;
  /** Признак возможности удаления справки КС-3 */
  actKC3CanDelete?: InputMaybe<SortEnumType>;
  /** Признак возможности редактирования справки КС-3 */
  actKC3CanEdit?: InputMaybe<SortEnumType>;
  /** Номер корректировки справки КС-3 */
  actKC3CorrectionNumber?: InputMaybe<SortEnumType>;
  /** Дата справки КС-3 */
  actKC3Date?: InputMaybe<SortEnumType>;
  /** Стоимость с начала работ */
  actKC3FromWorkStartCost?: InputMaybe<SortEnumType>;
  /** Стоимость с начала года */
  actKC3FromYearStartCost?: InputMaybe<SortEnumType>;
  /** Полный номер справки КС-3 */
  actKC3FullNumber?: InputMaybe<SortEnumType>;
  /** Идентификатор справки КС-3 */
  actKC3Id?: InputMaybe<SortEnumType>;
  /** Признак корректировочной справки КС-3 */
  actKC3IsCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивной справки КС-3 */
  actKC3IsInactive?: InputMaybe<SortEnumType>;
  /** Номер справки КС-3 */
  actKC3Number?: InputMaybe<SortEnumType>;
  /** Стоимость за отчетный период */
  actKC3ReportedPeriodCost?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода справки КС-3 */
  actKC3ReportingFinishDate?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода справки КС-3 */
  actKC3ReportingStartDate?: InputMaybe<SortEnumType>;
  /** Всего с НДС */
  actKC3TotalCostWithTax?: InputMaybe<SortEnumType>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Признак того что справка КС-3 является последней в рамках заданного уровня справки в договоре */
  isFinal?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта строительства */
  rootContractObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<SortEnumType>;
};

/** Итог справки КС-3 */
export type ActKc3TotalData = {
  __typename?: 'ActKC3TotalData';
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Флаг Прочая затрата */
  isOtherCost: Scalars['Boolean'];
  /** Наименование итога */
  name: Scalars['String'];
  /** Стоимость за отчетный период */
  reportingPeriodCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость с начала проведения работ */
  startWorkCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость с начала года */
  startYearCost?: Maybe<Scalars['Decimal']>;
  /** Сквозной тип элемента итогов */
  totalType?: Maybe<UerTotal_AlcTypeEnum>;
};

/** Итог справки КС-3 */
export type ActKc3TotalDataInput = {
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Флаг Прочая затрата */
  isOtherCost: Scalars['Boolean'];
  /** Наименование итога */
  name: Scalars['String'];
  /** Стоимость за отчетный период */
  reportingPeriodCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость с начала проведения работ */
  startWorkCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость с начала года */
  startYearCost?: InputMaybe<Scalars['Decimal']>;
  /** Сквозной тип элемента итогов */
  totalType?: InputMaybe<UerTotal_AlcTypeEnum>;
};

export type ActKc3UpdateInput = {
  /** &gt;Список идентификаторов актов КС2 включенных в КС3 */
  actKC2Ids?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Дата */
  date?: InputMaybe<Scalars['Date']>;
  /** Идентификатор справки КС3 */
  id: Scalars['Long'];
  /** Признак обязательности коррекции итогов справки */
  isTotalsCorrectionRequired?: InputMaybe<Scalars['Boolean']>;
  /** Номер */
  number?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта строительства */
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<Scalars['Long']>;
};

/** Данные для добавления Мтр к расценке в Вор */
export type AddCollectionMtrToWorkVolumeInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор МТР */
  collectionMtrIds: Array<Scalars['Long']>;
  /** Идентификатор ВОР */
  worId: Scalars['Long'];
};

export enum AddRatioToActKc2StrategyEnum {
  CorrectOriginal = 'CORRECT_ORIGINAL',
  DuplicateWithExtendedCoefficients = 'DUPLICATE_WITH_EXTENDED_COEFFICIENTS'
}

/** Данные для добавления коэффициентов к расценке в Вор */
export type AddRatiosMassToWorkVolumeInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификаторы коэффициентов */
  collectionRatioIds: Array<Scalars['Long']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Long'];
};

/** Данные для добавления коэффициентов к расценке в Вор */
export type AddRatiosToWorkVolumeInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификаторы коэффициентов */
  collectionRatioIds: Array<Scalars['Long']>;
  /** Идентификатор ВОР */
  worId: Scalars['Long'];
};

/** Результат добавления выбранных расценок из справочника в сборник расценок Расчёта НМЦ */
export type AddUersToCollectionUerBaseCostData = {
  __typename?: 'AddUersToCollectionUERBaseCostData';
  /** Список видов строительства, для которых добавлены расценки */
  constructionTypes: Array<Scalars['Int']>;
  /** Массив идентификаторов добавленных расценок в Сборнике */
  data: Array<Scalars['Long']>;
};

/** Результат добавления выбранных расценок из справочника в сборник расценок Расчёта НМЦ */
export type AddUersToCollectionUerBaseCostDataInput = {
  /** Список видов строительства, для которых добавлены расценки */
  constructionTypes: Array<Scalars['Int']>;
  /** Массив идентификаторов добавленных расценок в Сборнике */
  data: Array<Scalars['Long']>;
};

/** Данные для добавления выбранных расценок из справочника в сборник расценок Расчёта НМЦ */
export type AddUersToCollectionUerBaseCostInput = {
  /** Список видов строительства, для которых добавляются расценки */
  calculationConstructionTypes: Array<Scalars['Int']>;
  /** Идентификатор расчёта НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификаторы выбранных расценок справочника */
  catalogUerBaseCostIds: Array<Scalars['Long']>;
  /** Уникальный идентификатор справочника расценок */
  catalogUerBaseUniqueId: Scalars['String'];
};

/**
 * Ответ мутаций создания/обновления укрупнённой сметы: заголовок (как AggregateLocalEstimateData)
 * плюс стоимостные показатели по базовым и текущим ценам.
 */
export type AggregateLocalEstimateCreateUpdateData = {
  __typename?: 'AggregateLocalEstimateCreateUpdateData';
  /** Идентификатор объекта/подобъекта структуры расчёта (негарантированный объём). */
  calculationObjectId?: Maybe<Scalars['Long']>;
  /** Глава сметы. */
  chapter: Scalars['String'];
  /** Коэффициент. */
  coefficient?: Maybe<Scalars['Decimal']>;
  currentEmm?: Maybe<Scalars['Decimal']>;
  currentMp?: Maybe<Scalars['Decimal']>;
  currentMtr?: Maybe<Scalars['Decimal']>;
  currentMz?: Maybe<Scalars['Decimal']>;
  currentNr?: Maybe<Scalars['Decimal']>;
  currentOp?: Maybe<Scalars['Decimal']>;
  currentOthers?: Maybe<Scalars['Decimal']>;
  currentOz?: Maybe<Scalars['Decimal']>;
  currentOzp?: Maybe<Scalars['Decimal']>;
  currentSmrTotal?: Maybe<Scalars['Decimal']>;
  currentSp?: Maybe<Scalars['Decimal']>;
  currentTotal?: Maybe<Scalars['Decimal']>;
  currentTzm?: Maybe<Scalars['Decimal']>;
  currentTzr?: Maybe<Scalars['Decimal']>;
  currentZpm?: Maybe<Scalars['Decimal']>;
  emm?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Состав укрупнённой сметы (ЛСР). */
  lsrs: Array<AggregateLocalEstimateLsrData>;
  mp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  mz?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  op?: Maybe<Scalars['Decimal']>;
  others?: Maybe<Scalars['Decimal']>;
  oz?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  /** Идентификатор корневого объекта/подобъекта структуры расчёта. */
  rootObjectId: Scalars['Long'];
  smrTotal?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  total?: Maybe<Scalars['Decimal']>;
  tzm?: Maybe<Scalars['Decimal']>;
  tzr?: Maybe<Scalars['Decimal']>;
  /** Шифр (Value_Code). */
  valueCode: Scalars['String'];
  /** Наименование (Value_Name). */
  valueName: Scalars['String'];
  /** Кол-во сейчас. */
  valueQuantityNow?: Maybe<Scalars['Decimal']>;
  /** Кол-во по целевым показателям. */
  valueQuantityTarget?: Maybe<Scalars['Decimal']>;
  /** Ед. изм (Value_Unit). */
  valueUnit: Scalars['String'];
  zpm?: Maybe<Scalars['Decimal']>;
};

/**
 * Ответ мутаций создания/обновления укрупнённой сметы: заголовок (как AggregateLocalEstimateData)
 * плюс стоимостные показатели по базовым и текущим ценам.
 */
export type AggregateLocalEstimateCreateUpdateDataInput = {
  /** Идентификатор объекта/подобъекта структуры расчёта (негарантированный объём). */
  calculationObjectId?: InputMaybe<Scalars['Long']>;
  /** Глава сметы. */
  chapter: Scalars['String'];
  /** Коэффициент. */
  coefficient?: InputMaybe<Scalars['Decimal']>;
  currentEmm?: InputMaybe<Scalars['Decimal']>;
  currentMp?: InputMaybe<Scalars['Decimal']>;
  currentMtr?: InputMaybe<Scalars['Decimal']>;
  currentMz?: InputMaybe<Scalars['Decimal']>;
  currentNr?: InputMaybe<Scalars['Decimal']>;
  currentOp?: InputMaybe<Scalars['Decimal']>;
  currentOthers?: InputMaybe<Scalars['Decimal']>;
  currentOz?: InputMaybe<Scalars['Decimal']>;
  currentOzp?: InputMaybe<Scalars['Decimal']>;
  currentSmrTotal?: InputMaybe<Scalars['Decimal']>;
  currentSp?: InputMaybe<Scalars['Decimal']>;
  currentTotal?: InputMaybe<Scalars['Decimal']>;
  currentTzm?: InputMaybe<Scalars['Decimal']>;
  currentTzr?: InputMaybe<Scalars['Decimal']>;
  currentZpm?: InputMaybe<Scalars['Decimal']>;
  emm?: InputMaybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Состав укрупнённой сметы (ЛСР). */
  lsrs: Array<AggregateLocalEstimateLsrDataInput>;
  mp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  mz?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  op?: InputMaybe<Scalars['Decimal']>;
  others?: InputMaybe<Scalars['Decimal']>;
  oz?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор корневого объекта/подобъекта структуры расчёта. */
  rootObjectId: Scalars['Long'];
  smrTotal?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  total?: InputMaybe<Scalars['Decimal']>;
  tzm?: InputMaybe<Scalars['Decimal']>;
  tzr?: InputMaybe<Scalars['Decimal']>;
  /** Шифр (Value_Code). */
  valueCode: Scalars['String'];
  /** Наименование (Value_Name). */
  valueName: Scalars['String'];
  /** Кол-во сейчас. */
  valueQuantityNow?: InputMaybe<Scalars['Decimal']>;
  /** Кол-во по целевым показателям. */
  valueQuantityTarget?: InputMaybe<Scalars['Decimal']>;
  /** Ед. изм (Value_Unit). */
  valueUnit: Scalars['String'];
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Укрупнённая смета (ответ по GraphQL-контракту). */
export type AggregateLocalEstimateData = {
  __typename?: 'AggregateLocalEstimateData';
  /** Идентификатор объекта/подобъекта структуры расчёта (негарантированный объём). */
  calculationObjectId?: Maybe<Scalars['Long']>;
  /** Глава сметы. */
  chapter: Scalars['String'];
  /** Коэффициент. */
  coefficient?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Состав укрупнённой сметы (ЛСР). */
  lsrs: Array<AggregateLocalEstimateLsrData>;
  /** Идентификатор корневого объекта/подобъекта структуры расчёта. */
  rootObjectId: Scalars['Long'];
  /** Шифр (Value_Code). */
  valueCode: Scalars['String'];
  /** Наименование (Value_Name). */
  valueName: Scalars['String'];
  /** Кол-во сейчас. */
  valueQuantityNow?: Maybe<Scalars['Decimal']>;
  /** Кол-во по целевым показателям. */
  valueQuantityTarget?: Maybe<Scalars['Decimal']>;
  /** Ед. изм (Value_Unit). */
  valueUnit: Scalars['String'];
};

/** Укрупнённая смета (ответ по GraphQL-контракту). */
export type AggregateLocalEstimateDataInput = {
  /** Идентификатор объекта/подобъекта структуры расчёта (негарантированный объём). */
  calculationObjectId?: InputMaybe<Scalars['Long']>;
  /** Глава сметы. */
  chapter: Scalars['String'];
  /** Коэффициент. */
  coefficient?: InputMaybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Состав укрупнённой сметы (ЛСР). */
  lsrs: Array<AggregateLocalEstimateLsrDataInput>;
  /** Идентификатор корневого объекта/подобъекта структуры расчёта. */
  rootObjectId: Scalars['Long'];
  /** Шифр (Value_Code). */
  valueCode: Scalars['String'];
  /** Наименование (Value_Name). */
  valueName: Scalars['String'];
  /** Кол-во сейчас. */
  valueQuantityNow?: InputMaybe<Scalars['Decimal']>;
  /** Кол-во по целевым показателям. */
  valueQuantityTarget?: InputMaybe<Scalars['Decimal']>;
  /** Ед. изм (Value_Unit). */
  valueUnit: Scalars['String'];
};

/** Строка состава укрупнённой сметы (ссылка на ЛСР). */
export type AggregateLocalEstimateLsrData = {
  __typename?: 'AggregateLocalEstimateLsrData';
  /** Идентификатор ЛСР (простой сметы), включённой в укрупнённую смету. */
  id: Scalars['Long'];
  /** Порядковый номер ЛСР в составе (1..N). */
  number: Scalars['Int'];
};

/** Строка состава укрупнённой сметы (ссылка на ЛСР). */
export type AggregateLocalEstimateLsrDataInput = {
  /** Идентификатор ЛСР (простой сметы), включённой в укрупнённую смету. */
  id: Scalars['Long'];
  /** Порядковый номер ЛСР в составе (1..N). */
  number: Scalars['Int'];
};

export type AppHealthCheckData = {
  __typename?: 'AppHealthCheckData';
  duration: Scalars['String'];
  healthChecks?: Maybe<Array<AppHealthCheckInfo>>;
  status: HealthStatus;
};

export type AppHealthCheckDataFilterInput = {
  and?: InputMaybe<Array<AppHealthCheckDataFilterInput>>;
  duration?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  healthChecks?: InputMaybe<ListFilterInputTypeOfAppHealthCheckInfoFilterInput>;
  or?: InputMaybe<Array<AppHealthCheckDataFilterInput>>;
  status?: InputMaybe<HealthStatusOperationFilterInput>;
};

export type AppHealthCheckDataInput = {
  duration: Scalars['String'];
  healthChecks?: InputMaybe<Array<AppHealthCheckInfoInput>>;
  status: HealthStatus;
};

export type AppHealthCheckDataSortInput = {
  duration?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type AppHealthCheckInfo = {
  __typename?: 'AppHealthCheckInfo';
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status: HealthStatus;
  validation?: Maybe<Array<ValidationMessage>>;
};

export type AppHealthCheckInfoFilterInput = {
  and?: InputMaybe<Array<AppHealthCheckInfoFilterInput>>;
  description?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  duration?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  error?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<AppHealthCheckInfoFilterInput>>;
  status?: InputMaybe<HealthStatusOperationFilterInput>;
  validation?: InputMaybe<ListFilterInputTypeOfValidationMessageFilterInput>;
};

export type AppHealthCheckInfoInput = {
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['String'];
  error?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: HealthStatus;
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type AppModuleInfo = {
  __typename?: 'AppModuleInfo';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type AppModuleInfoInput = {
  branch: Scalars['String'];
  buildDate?: InputMaybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};

export type AppModuleReport = {
  __typename?: 'AppModuleReport';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  healthCheckData?: Maybe<AppHealthCheckData>;
  id: Scalars['String'];
  moduleResources?: Maybe<AppModuleResources>;
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type AppModuleReportFilterInput = {
  and?: InputMaybe<Array<AppModuleReportFilterInput>>;
  branch?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  buildDate?: InputMaybe<DateTimeOperationFilterInput>;
  commit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  description?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  healthCheckData?: InputMaybe<AppHealthCheckDataFilterInput>;
  id?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  moduleResources?: InputMaybe<AppModuleResourcesFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<AppModuleReportFilterInput>>;
  release?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  tag?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type AppModuleReportInput = {
  branch: Scalars['String'];
  buildDate?: InputMaybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  healthCheckData?: InputMaybe<AppHealthCheckDataInput>;
  id: Scalars['String'];
  moduleResources?: InputMaybe<AppModuleResourcesInput>;
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};

export type AppModuleReportSortInput = {
  branch?: InputMaybe<SortEnumType>;
  buildDate?: InputMaybe<SortEnumType>;
  commit?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  healthCheckData?: InputMaybe<AppHealthCheckDataSortInput>;
  id?: InputMaybe<SortEnumType>;
  moduleResources?: InputMaybe<AppModuleResourcesSortInput>;
  name?: InputMaybe<SortEnumType>;
  release?: InputMaybe<SortEnumType>;
  tag?: InputMaybe<SortEnumType>;
};

export type AppModuleResources = {
  __typename?: 'AppModuleResources';
  cpuUsedPercentage: Scalars['String'];
  guaranteedToMaxCpu: Scalars['String'];
  guaranteedToMaxMemory: Scalars['String'];
  memoryUsedInBytes: Scalars['String'];
  memoryUsedPercentage: Scalars['String'];
  time: Scalars['String'];
};

export type AppModuleResourcesFilterInput = {
  and?: InputMaybe<Array<AppModuleResourcesFilterInput>>;
  cpuUsedPercentage?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  guaranteedToMaxCpu?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  guaranteedToMaxMemory?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  memoryUsedInBytes?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  memoryUsedPercentage?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<AppModuleResourcesFilterInput>>;
  time?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type AppModuleResourcesInput = {
  cpuUsedPercentage: Scalars['String'];
  guaranteedToMaxCpu: Scalars['String'];
  guaranteedToMaxMemory: Scalars['String'];
  memoryUsedInBytes: Scalars['String'];
  memoryUsedPercentage: Scalars['String'];
  time: Scalars['String'];
};

export type AppModuleResourcesSortInput = {
  cpuUsedPercentage?: InputMaybe<SortEnumType>;
  guaranteedToMaxCpu?: InputMaybe<SortEnumType>;
  guaranteedToMaxMemory?: InputMaybe<SortEnumType>;
  memoryUsedInBytes?: InputMaybe<SortEnumType>;
  memoryUsedPercentage?: InputMaybe<SortEnumType>;
  time?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AppModulesReportCollectionSegment = {
  __typename?: 'AppModulesReportCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ServiceDataResultOfAppModuleReport>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export enum AuditLogClientOperationEnum {
  Login = 'LOGIN',
  LoginError = 'LOGIN_ERROR',
  Logout = 'LOGOUT',
  LogoutError = 'LOGOUT_ERROR',
  Refresh = 'REFRESH',
  RefreshError = 'REFRESH_ERROR'
}

/** Общие данные Расчета НМЦ */
export type Bimc_CalculationCommonData = {
  __typename?: 'BIMC_CalculationCommonData';
  /** Навигация Расчета */
  calculationNavigation: BimcCalculationNavigationData;
  /** Данные стоимости Расчета */
  calculationPrice?: Maybe<CalculationPriceData>;
};

/**
 * Флаги, указывающие на произошедшие изменения в Расчёте НМЦ,
 * на основании которых UI может показать уведомления (пересчёт итогов).
 */
export enum Bimc_ChangeNoticeFlags {
  None = 'NONE',
  OnCoefficientsChange = 'ON_COEFFICIENTS_CHANGE',
  OnCostRoundingChange = 'ON_COST_ROUNDING_CHANGE',
  OnEstimatesChange = 'ON_ESTIMATES_CHANGE',
  OnObjectStructureChange = 'ON_OBJECT_STRUCTURE_CHANGE',
  OnSeasonsChange = 'ON_SEASONS_CHANGE',
  OnTaxPercentChange = 'ON_TAX_PERCENT_CHANGE'
}

/** Общие данные Договора */
export type Bimc_ContractCommonData = {
  __typename?: 'BIMC_ContractCommonData';
  /** Навигация Договора */
  contractNavigation: BimcContractNavigationData;
  /** Данные стоимости Договора */
  contractPrice: ContractPriceData;
};

export type Bimc_ServiceDataResultOfCalculationNavigationData = {
  __typename?: 'BIMC_ServiceDataResultOfCalculationNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcCalculationNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Bimc_ServiceDataResultOfContractNavigationData = {
  __typename?: 'BIMC_ServiceDataResultOfContractNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcContractNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

/** Общие данные Расчета НМЦ */
export type Bim_CalculationCommonData = {
  __typename?: 'BIM_CalculationCommonData';
  /** Навигация Расчета */
  calculationNavigation: BimCalculationNavigationData;
  /** Данные стоимости Расчета */
  calculationPrice?: Maybe<CalculationPriceData>;
};

/** Общие данные Договора */
export type Bim_ContractCommonData = {
  __typename?: 'BIM_ContractCommonData';
  /** Навигация Договора */
  contractNavigation: BimContractNavigationData;
  /** Данные стоимости Договора */
  contractPrice: ContractPriceData;
};

export type Bim_ServiceDataResultOfAppHealthCheckData = {
  __typename?: 'BIM_ServiceDataResultOfAppHealthCheckData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimAppHealthCheckData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Bim_ServiceDataResultOfAppModuleInfo = {
  __typename?: 'BIM_ServiceDataResultOfAppModuleInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimAppModuleInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Bim_ServiceDataResultOfAppModuleReport = {
  __typename?: 'BIM_ServiceDataResultOfAppModuleReport';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimAppModuleReport>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Bim_ServiceDataResultOfCalculationNavigationData = {
  __typename?: 'BIM_ServiceDataResultOfCalculationNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimCalculationNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Bim_ServiceDataResultOfContractNavigationData = {
  __typename?: 'BIM_ServiceDataResultOfContractNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimContractNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

/** Акт КС-2 */
export type BimActKc2Data = {
  __typename?: 'BimActKC2Data';
  /** Метод расчета итогов Акта КС-2 */
  calcMethod: BimActKc2TotalCalcMethodEnum;
  /** Доступен для удаления */
  canRemoved: Scalars['Boolean'];
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Всего по Акту в текущем уровне цен */
  currentPriceTotal?: Maybe<Scalars['Decimal']>;
  /** Дата */
  date: Scalars['DateTime'];
  /** Дата окончания */
  finishDate: Scalars['DateTime'];
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Признак наличия дефлятора */
  hasDeflation?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Отчетный месяц */
  month: Scalars['Byte'];
  /** Номер */
  number: Scalars['String'];
  /** Дата начала */
  startDate: Scalars['DateTime'];
  /** Флаг - учитывать инфляцию, установленную в смете */
  useInflationValue: Scalars['Boolean'];
  /** Данные */
  value: BimWorkOrderPriceValue;
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Акт КС-2 */
export type BimActKc2DataFilterInput = {
  and?: InputMaybe<Array<BimActKc2DataFilterInput>>;
  /** Метод расчета итогов Акта КС-2 */
  calcMethod?: InputMaybe<BimActKc2TotalCalcMethodEnumOperationFilterInput>;
  /** Доступен для удаления */
  canRemoved?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Всего по Акту в текущем уровне цен */
  currentPriceTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Дата окончания */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия дефлятора */
  hasDeflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Отчетный месяц */
  month?: InputMaybe<ByteOperationFilterInput>;
  /** Номер */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2DataFilterInput>>;
  /** Дата начала */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Флаг - учитывать инфляцию, установленную в смете */
  useInflationValue?: InputMaybe<BooleanOperationFilterInput>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Акт КС-2 */
export type BimActKc2DataSortInput = {
  /** Метод расчета итогов Акта КС-2 */
  calcMethod?: InputMaybe<SortEnumType>;
  /** Доступен для удаления */
  canRemoved?: InputMaybe<SortEnumType>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<SortEnumType>;
  /** Всего по Акту в текущем уровне цен */
  currentPriceTotal?: InputMaybe<SortEnumType>;
  /** Дата */
  date?: InputMaybe<SortEnumType>;
  /** Дата окончания */
  finishDate?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Признак наличия дефлятора */
  hasDeflation?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  /** Отчетный месяц */
  month?: InputMaybe<SortEnumType>;
  /** Номер */
  number?: InputMaybe<SortEnumType>;
  /** Дата начала */
  startDate?: InputMaybe<SortEnumType>;
  /** Флаг - учитывать инфляцию, установленную в смете */
  useInflationValue?: InputMaybe<SortEnumType>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Год сезона */
  year?: InputMaybe<SortEnumType>;
};

/** Атрибуты группы */
export type BimActKc2GroupAttributeData = {
  __typename?: 'BimActKC2GroupAttributeData';
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

/** Атрибуты группы */
export type BimActKc2GroupAttributeDataInput = {
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

/** A segment of a collection. */
export type BimActKc2GroupChapterFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfBimChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActKc2GroupConstructionTypeFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupConstructionTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActKc2GroupCostGroupFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupCostGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCostGroupEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActKc2GroupDateFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateTime>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Входные данные группы */
export type BimActKc2GroupInput = {
  /** Идентификаторы Актов КС-2 */
  actKC2Ids: Array<BimActKc2GroupItemInput>;
  /** Наименование группы */
  groupName: Scalars['String'];
};

/** Элемент группы акта */
export type BimActKc2GroupItemInput = {
  /** Id Акта КС2 дял включение в группу */
  actKC2Id?: InputMaybe<Scalars['Long']>;
  /** Id Акта КС2 прочих дял включение в группу */
  actKC2OtherId?: InputMaybe<Scalars['Long']>;
};

/** A segment of a collection. */
export type BimActKc2GroupNumberFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupNumberFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActKc2GroupObjectFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Перечисление для типов группировки актов КС2. */
export enum BimActKc2GroupTypeEnum {
  /** По виду строительства. */
  ByConstructionType = 'BY_CONSTRUCTION_TYPE',
  /** По группе затрат. */
  ByCostGroup = 'BY_COST_GROUP',
  /** По месяцу. */
  ByMonth = 'BY_MONTH',
  /** По объекту. */
  ByObject = 'BY_OBJECT',
  /** По году. */
  ByYear = 'BY_YEAR',
  /** Ручная группировка. */
  Custom = 'CUSTOM'
}

/** A segment of a collection. */
export type BimActKc2GroupWorkOrderPriceCodeFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupWorkOrderPriceCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActKc2GroupWorkOrderPriceNameFilterCollectionSegment = {
  __typename?: 'BimActKC2GroupWorkOrderPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimActKc2ListItemData = {
  __typename?: 'BimActKC2ListItemData';
  /** Дата акта в заданной тайм зоне */
  actDate?: Maybe<Scalars['DateTime']>;
  /** Id акта */
  actId: Scalars['Long'];
  /** Месяц даты акта в заданной тайм зоне */
  actMonth?: Maybe<Scalars['Int']>;
  /** Год даты акта в заданной тайм зоне */
  actYear?: Maybe<Scalars['Int']>;
  /** Глава расчета */
  chapter?: Maybe<BimChapterEnum>;
  /** Значение главы расчета */
  chapterTip: Scalars['String'];
  /** Вид строительства */
  constructionType: ConstructionType;
  /** Id dblf строительства */
  constructionTypeId: Scalars['Int'];
  /** Дата корректировки */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Стоимость без НДС */
  costWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Дата акта */
  date?: Maybe<Scalars['DateTime']>;
  /** Дата окончания отчетного периода */
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Итог группы */
  groupCostWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Количество актов в группе */
  groupCount: Scalars['Int'];
  /** Идентификатор группы */
  groupId?: Maybe<Scalars['Long']>;
  /** Наименование группы */
  groupName?: Maybe<Scalars['String']>;
  /** Строковый идентификатор группы */
  groupUniqueId?: Maybe<Scalars['String']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Номер акта */
  number?: Maybe<Scalars['String']>;
  /** Дата начала отчетного периода */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Статус акта */
  status?: Maybe<BimActKc2StatusEnum>;
  /** Значение статуса акта */
  statusTip: Scalars['String'];
  /** Id объекта строительства */
  workOrderObjectId: Scalars['Long'];
  /** Наименование объекта строительства */
  workOrderObjectName: Scalars['String'];
  /** Шифр сметы */
  workOrderPriceCode?: Maybe<Scalars['String']>;
  /** Наименование сметы */
  workOrderPriceName?: Maybe<Scalars['String']>;
};

export type BimActKc2ListItemDataFilterInput = {
  /** Дата акта в заданной тайм зоне */
  actDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Id акта */
  actId?: InputMaybe<LongOperationFilterInput>;
  /** Месяц даты акта в заданной тайм зоне */
  actMonth?: InputMaybe<IntOperationFilterInput>;
  /** Год даты акта в заданной тайм зоне */
  actYear?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<BimActKc2ListItemDataFilterInput>>;
  /** Глава расчета */
  chapter?: InputMaybe<NullableOfBimChapterEnumOperationFilterInput>;
  /** Значение главы расчета */
  chapterTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeFilterInput>;
  /** Id dblf строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Дата корректировки */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата акта */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Итог группы */
  groupCostWithoutTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество актов в группе */
  groupCount?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор группы */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование группы */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Строковый идентификатор группы */
  groupUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер акта */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2ListItemDataFilterInput>>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Статус акта */
  status?: InputMaybe<NullableOfBimActKc2StatusEnumOperationFilterInput>;
  /** Значение статуса акта */
  statusTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id объекта строительства */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр сметы */
  workOrderPriceCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование сметы */
  workOrderPriceName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type BimActKc2ListItemDataSortInput = {
  /** Дата акта в заданной тайм зоне */
  actDate?: InputMaybe<SortEnumType>;
  /** Id акта */
  actId?: InputMaybe<SortEnumType>;
  /** Месяц даты акта в заданной тайм зоне */
  actMonth?: InputMaybe<SortEnumType>;
  /** Год даты акта в заданной тайм зоне */
  actYear?: InputMaybe<SortEnumType>;
  /** Глава расчета */
  chapter?: InputMaybe<SortEnumType>;
  /** Значение главы расчета */
  chapterTip?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeSortInput>;
  /** Id dblf строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Дата корректировки */
  correctionDate?: InputMaybe<SortEnumType>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<SortEnumType>;
  /** Группа затрат */
  costGroup?: InputMaybe<SortEnumType>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<SortEnumType>;
  /** Дата акта */
  date?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Итог группы */
  groupCostWithoutTax?: InputMaybe<SortEnumType>;
  /** Количество актов в группе */
  groupCount?: InputMaybe<SortEnumType>;
  /** Идентификатор группы */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование группы */
  groupName?: InputMaybe<SortEnumType>;
  /** Строковый идентификатор группы */
  groupUniqueId?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  isIncluded?: InputMaybe<SortEnumType>;
  /** Номер акта */
  number?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<SortEnumType>;
  /** Статус акта */
  status?: InputMaybe<SortEnumType>;
  /** Значение статуса акта */
  statusTip?: InputMaybe<SortEnumType>;
  /** Id объекта строительства */
  workOrderObjectId?: InputMaybe<SortEnumType>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<SortEnumType>;
  /** Шифр сметы */
  workOrderPriceCode?: InputMaybe<SortEnumType>;
  /** Наименование сметы */
  workOrderPriceName?: InputMaybe<SortEnumType>;
};

export type BimActKc2OtherCorrectionCreateInput = {
  correctionDate?: InputMaybe<Scalars['DateTime']>;
  primaryActKC2Id: Scalars['Long'];
};

export type BimActKc2OtherCorrectionUpdateInput = {
  correctionDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  status: BimActKc2OtherStatusEnum;
};

export type BimActKc2OtherCostData = {
  __typename?: 'BimActKC2OtherCostData';
  /** Идентификатор Акта КС-2 на прочие */
  actKC2Id: Scalars['Long'];
  /** Комментарий */
  comment?: Maybe<Scalars['String']>;
  /** Стоимость (согласовано) */
  costAccepted?: Maybe<Scalars['Decimal']>;
  /** Стоимость (план) */
  costPlan?: Maybe<Scalars['Decimal']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
};

export type BimActKc2OtherCostDataFilterInput = {
  /** Идентификатор Акта КС-2 на прочие */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<BimActKc2OtherCostDataFilterInput>>;
  /** Комментарий */
  comment?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость (согласовано) */
  costAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость (план) */
  costPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimActKc2OtherCostDataFilterInput>>;
};

export type BimActKc2OtherCostDataInput = {
  /** Идентификатор Акта КС-2 на прочие */
  actKC2Id: Scalars['Long'];
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']>;
  /** Стоимость (согласовано) */
  costAccepted?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость (план) */
  costPlan?: InputMaybe<Scalars['Decimal']>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<Scalars['Boolean']>;
};

/** Создание Акта КС-2 для прочих */
export type BimActKc2OtherCreateInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Дата */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Номер */
  number?: InputMaybe<Scalars['Int']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
  /** Идентификатор объекта строительства наряд-заказа */
  workOrderObjectId: Scalars['Long'];
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId: Scalars['Long'];
};

/** Акт КС-2 для прочих */
export type BimActKc2OtherData = {
  __typename?: 'BimActKC2OtherData';
  authoredBy?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: Maybe<Scalars['String']>;
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** Дата */
  date?: Maybe<Scalars['DateTime']>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Признак наличия значений в полк Стоимость(План) */
  hasPlanValues: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Номер */
  number?: Maybe<Scalars['Int']>;
  /** Дата начала */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
  /** Статусы-последователи */
  statusFollowers: Array<BimActKc2OtherStatusEnum>;
  /** Внешний идентификатор */
  uniqueId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
  /** Объект строительства наряд-заказа */
  workOrderObject: BimWorkOrderObjectData;
  /** Сезон наряд-заказа */
  workOrderSeason: BimWorkOrderSeasonData;
};

/** Акт КС-2 для прочих */
export type BimActKc2OtherDataInput = {
  authoredBy?: InputMaybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: InputMaybe<Scalars['String']>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** Дата */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<Scalars['String']>;
  /** Признак наличия значений в полк Стоимость(План) */
  hasPlanValues: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Номер */
  number?: InputMaybe<Scalars['Int']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
  /** Статусы-последователи */
  statusFollowers: Array<BimActKc2OtherStatusEnum>;
  /** Внешний идентификатор */
  uniqueId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
  /** Объект строительства наряд-заказа */
  workOrderObject: BimWorkOrderObjectDataInput;
  /** Сезон наряд-заказа */
  workOrderSeason: BimWorkOrderSeasonDataInput;
};

export type BimActKc2OtherDefaultData = {
  __typename?: 'BimActKC2OtherDefaultData';
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: Maybe<Scalars['String']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
};

export type BimActKc2OtherDefaultDataInput = {
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: InputMaybe<Scalars['String']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
};

export type BimActKc2OtherItemData = {
  __typename?: 'BimActKC2OtherItemData';
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Дата */
  date?: Maybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Номер */
  number?: Maybe<Scalars['Int']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
};

export type BimActKc2OtherItemDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2OtherItemDataFilterInput>>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Дата */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BimActKc2OtherItemDataFilterInput>>;
  /** Статус */
  status?: InputMaybe<BimActKc2OtherStatusEnumOperationFilterInput>;
};

export type BimActKc2OtherItemDataSortInput = {
  /** Дата коррекции */
  correctionDate?: InputMaybe<SortEnumType>;
  /** Дата */
  date?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  /** Номер */
  number?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
};

/** Статус Акта КС-2 на прочие */
export enum BimActKc2OtherStatusEnum {
  /** Согласован */
  Accepted = 'ACCEPTED',
  /** В работе */
  InProgress = 'IN_PROGRESS',
  /** На проверке */
  OnCheck = 'ON_CHECK'
}

export type BimActKc2OtherStatusEnumOperationFilterInput = {
  eq?: InputMaybe<BimActKc2OtherStatusEnum>;
  in?: InputMaybe<Array<BimActKc2OtherStatusEnum>>;
  neq?: InputMaybe<BimActKc2OtherStatusEnum>;
  nin?: InputMaybe<Array<BimActKc2OtherStatusEnum>>;
};

export type BimActKc2OtherTotalItemData = {
  __typename?: 'BimActKC2OtherTotalItemData';
  /** Признаки того, что для данного акта есть рассчитанные итоги */
  hasTotals: Scalars['Boolean'];
  /** Идентификатор строки */
  id: Scalars['Long'];
  /** Флаг запись является инфляцией */
  isInflation: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Порядок сортировки */
  sortOrder: Scalars['Short'];
  /** Всего */
  total?: Maybe<Scalars['Decimal']>;
  /** Идентификатор активного сезона наряд-заказа */
  workOrderActiveSeasonId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: Maybe<Scalars['Long']>;
};

export type BimActKc2OtherTotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2OtherTotalItemDataFilterInput>>;
  /** Признаки того, что для данного акта есть рассчитанные итоги */
  hasTotals?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор строки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2OtherTotalItemDataFilterInput>>;
  /** Порядок сортировки */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Всего */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор активного сезона наряд-заказа */
  workOrderActiveSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
};

export type BimActKc2OtherTotalItemDataSortInput = {
  /** Признаки того, что для данного акта есть рассчитанные итоги */
  hasTotals?: InputMaybe<SortEnumType>;
  /** Идентификатор строки */
  id?: InputMaybe<SortEnumType>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Порядок сортировки */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Всего */
  total?: InputMaybe<SortEnumType>;
  /** Идентификатор активного сезона наряд-заказа */
  workOrderActiveSeasonId?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimActKc2OtherTotalsCollectionSegment = {
  __typename?: 'BimActKC2OtherTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2OtherTotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimActKc2OtherUpdateInput = {
  /** Дата */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Номер */
  number?: InputMaybe<Scalars['Int']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
};

export type BimActKc2PriceRowData = {
  __typename?: 'BimActKC2PriceRowData';
  /** Номер единичной расценки */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Неактивная позиция МТР */
  inactiveMtr?: Maybe<Scalars['Boolean']>;
  /** Наименование работ */
  name: Scalars['String'];
  /** Номер позиции по смете */
  number?: Maybe<Scalars['String']>;
  /** Количество на ед./всего */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Идентификатор раздела */
  sectionId?: Maybe<Scalars['Long']>;
  /** Наименование раздела */
  sectionName?: Maybe<Scalars['String']>;
  /** Номер по порядку */
  serialNumber: Scalars['Int'];
  /** Стоимость */
  total?: Maybe<Scalars['Decimal']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Цена за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
};

export type BimActKc2PriceRowDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2PriceRowDataFilterInput>>;
  /** Номер единичной расценки */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг Неактивная позиция МТР */
  inactiveMtr?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Номер позиции по смете */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2PriceRowDataFilterInput>>;
  /** Количество на ед./всего */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Номер по порядку */
  serialNumber?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Цена за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
};

export type BimActKc2PriceRowDataSortInput = {
  /** Номер единичной расценки */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Флаг Неактивная позиция МТР */
  inactiveMtr?: InputMaybe<SortEnumType>;
  /** Наименование работ */
  name?: InputMaybe<SortEnumType>;
  /** Номер позиции по смете */
  number?: InputMaybe<SortEnumType>;
  /** Количество на ед./всего */
  quantity?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<SortEnumType>;
  /** Наименование раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Номер по порядку */
  serialNumber?: InputMaybe<SortEnumType>;
  /** Стоимость */
  total?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Цена за единицу */
  unitCost?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimActKc2PriceRowsCollectionSegment = {
  __typename?: 'BimActKC2PriceRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2PriceRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Акт КС-2 */
export type BimActKc2SelectionData = {
  __typename?: 'BimActKC2SelectionData';
  /** Дата акта в заданной тайм зоне */
  actDate?: Maybe<Scalars['DateTime']>;
  /** Id акта */
  actId: Scalars['Long'];
  /** Глава расчета */
  chapter?: Maybe<BimChapterEnum>;
  /** Значение главы расчета */
  chapterTip: Scalars['String'];
  /** Вид строительства */
  constructionType: ConstructionType;
  /** Дата корректировки */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Стоимость без НДС */
  costWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Дата акта */
  date?: Maybe<Scalars['DateTime']>;
  /** Дата окончания отчетного периода */
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Id группы */
  groupId?: Maybe<Scalars['Long']>;
  /** Наименование группы */
  groupName?: Maybe<Scalars['String']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Номер акта */
  number?: Maybe<Scalars['String']>;
  /** Дата начала отчетного периода */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Статус акта */
  status?: Maybe<BimActKc2StatusEnum>;
  /** Значение статуса акта */
  statusTip: Scalars['String'];
  /** Наименование объекта строительства */
  workOrderObjectName: Scalars['String'];
  /** Шифр сметы */
  workOrderPriceCode?: Maybe<Scalars['String']>;
  /** Наименование сметы */
  workOrderPriceName?: Maybe<Scalars['String']>;
};

/** Акт КС-2 */
export type BimActKc2SelectionDataFilterInput = {
  /** Дата акта в заданной тайм зоне */
  actDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Id акта */
  actId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<BimActKc2SelectionDataFilterInput>>;
  /** Глава расчета */
  chapter?: InputMaybe<NullableOfBimChapterEnumOperationFilterInput>;
  /** Значение главы расчета */
  chapterTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeFilterInput>;
  /** Дата корректировки */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата акта */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id группы */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование группы */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер акта */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2SelectionDataFilterInput>>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Статус акта */
  status?: InputMaybe<NullableOfBimActKc2StatusEnumOperationFilterInput>;
  /** Значение статуса акта */
  statusTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр сметы */
  workOrderPriceCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование сметы */
  workOrderPriceName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Акт КС-2 */
export type BimActKc2SelectionDataSortInput = {
  /** Дата акта в заданной тайм зоне */
  actDate?: InputMaybe<SortEnumType>;
  /** Id акта */
  actId?: InputMaybe<SortEnumType>;
  /** Глава расчета */
  chapter?: InputMaybe<SortEnumType>;
  /** Значение главы расчета */
  chapterTip?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeSortInput>;
  /** Дата корректировки */
  correctionDate?: InputMaybe<SortEnumType>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<SortEnumType>;
  /** Группа затрат */
  costGroup?: InputMaybe<SortEnumType>;
  /** Стоимость без НДС */
  costWithoutTax?: InputMaybe<SortEnumType>;
  /** Дата акта */
  date?: InputMaybe<SortEnumType>;
  /** Дата окончания отчетного периода */
  finishDate?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Id группы */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование группы */
  groupName?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  isIncluded?: InputMaybe<SortEnumType>;
  /** Номер акта */
  number?: InputMaybe<SortEnumType>;
  /** Дата начала отчетного периода */
  startDate?: InputMaybe<SortEnumType>;
  /** Статус акта */
  status?: InputMaybe<SortEnumType>;
  /** Значение статуса акта */
  statusTip?: InputMaybe<SortEnumType>;
  /** Наименование объекта строительства */
  workOrderObjectName?: InputMaybe<SortEnumType>;
  /** Шифр сметы */
  workOrderPriceCode?: InputMaybe<SortEnumType>;
  /** Наименование сметы */
  workOrderPriceName?: InputMaybe<SortEnumType>;
};

/** Статус Акта КС-2 */
export enum BimActKc2StatusEnum {
  /** Согласован */
  Accepted = 'ACCEPTED',
  /** В работе */
  InProgress = 'IN_PROGRESS',
  /** На проверке */
  OnCheck = 'ON_CHECK'
}

/** Метод расчета итогов Акта КС-2 */
export enum BimActKc2TotalCalcMethodEnum {
  /** Итоги считаны из файла XML */
  FromXml = 'FROM_XML',
  /** Расчет итогов Системой */
  SystemCalculated = 'SYSTEM_CALCULATED',
  /** Корректировка Пользователем */
  UserCorrected = 'USER_CORRECTED'
}

export type BimActKc2TotalCalcMethodEnumOperationFilterInput = {
  eq?: InputMaybe<BimActKc2TotalCalcMethodEnum>;
  in?: InputMaybe<Array<BimActKc2TotalCalcMethodEnum>>;
  neq?: InputMaybe<BimActKc2TotalCalcMethodEnum>;
  nin?: InputMaybe<Array<BimActKc2TotalCalcMethodEnum>>;
};

/** Строка итога Акта КС-2 */
export type BimActKc2TotalItemData = {
  __typename?: 'BimActKC2TotalItemData';
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Идентификатор строки */
  id: Scalars['Long'];
  /** Флаг Доступно для редактирования */
  isEditable: Scalars['Boolean'];
  /** Флаг запись является инфляцией */
  isInflation: Scalars['Boolean'];
  /** Флаг Cкорректировано пользователем */
  isInputValue: Scalars['Boolean'];
  /** Флаг Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Флаг Выбранное значение */
  isSelected: Scalars['Boolean'];
  /** Тип лимитированной затраты */
  limitedCostType?: Maybe<BimLimitedCostTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Идентификатор родительской записи итога */
  parentId?: Maybe<Scalars['Int']>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: Maybe<Scalars['Decimal']>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Идентификатор итога */
  totalId?: Maybe<Scalars['Long']>;
  /** Трудозатраты */
  tzr?: Maybe<Scalars['Decimal']>;
  /** Идентификатор активного сезона наряд-заказа */
  workOrderActiveSeasonId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: Maybe<Scalars['Long']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Строка итога Акта КС-2 */
export type BimActKc2TotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2TotalItemDataFilterInput>>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор строки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг Доступно для редактирования */
  isEditable?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Cкорректировано пользователем */
  isInputValue?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Лимитированная затрата */
  isLimitPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Выбранное значение */
  isSelected?: InputMaybe<BooleanOperationFilterInput>;
  /** Тип лимитированной затраты */
  limitedCostType?: InputMaybe<NullableOfBimLimitedCostTypeEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2TotalItemDataFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор родительской записи итога */
  parentId?: InputMaybe<IntOperationFilterInput>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Идентификатор итога */
  totalId?: InputMaybe<LongOperationFilterInput>;
  /** Трудозатраты */
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор активного сезона наряд-заказа */
  workOrderActiveSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Строка итога Акта КС-2 */
export type BimActKc2TotalItemDataSortInput = {
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Идентификатор строки */
  id?: InputMaybe<SortEnumType>;
  /** Флаг Доступно для редактирования */
  isEditable?: InputMaybe<SortEnumType>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<SortEnumType>;
  /** Флаг Cкорректировано пользователем */
  isInputValue?: InputMaybe<SortEnumType>;
  /** Флаг Лимитированная затрата */
  isLimitPrice?: InputMaybe<SortEnumType>;
  /** Флаг Выбранное значение */
  isSelected?: InputMaybe<SortEnumType>;
  /** Тип лимитированной затраты */
  limitedCostType?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Идентификатор родительской записи итога */
  parentId?: InputMaybe<SortEnumType>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор итога */
  totalId?: InputMaybe<SortEnumType>;
  /** Трудозатраты */
  tzr?: InputMaybe<SortEnumType>;
  /** Идентификатор активного сезона наряд-заказа */
  workOrderActiveSeasonId?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<SortEnumType>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimActKc2TotalsCollectionSegment = {
  __typename?: 'BimActKC2TotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2TotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Акт КС-2 версии НЗ */
export type BimActKc2VersionData = {
  __typename?: 'BimActKC2VersionData';
  /** Метод расчета итогов Акта КС-2 */
  calcMethod: BimActKc2TotalCalcMethodEnum;
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Всего по Акту в текущем уровне цен */
  currentPriceTotal?: Maybe<Scalars['Decimal']>;
  /** Дата */
  date: Scalars['DateTime'];
  /** Дата окончания */
  finishDate: Scalars['DateTime'];
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Отчетный месяц */
  month: Scalars['Byte'];
  /** Номер */
  number: Scalars['String'];
  /** Дата начала */
  startDate: Scalars['DateTime'];
  /** Данные */
  value: BimWorkOrderPriceValue;
  /** Идентификатор версии НЗ */
  workOrderVersionId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Акт КС-2 версии НЗ */
export type BimActKc2VersionDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2VersionDataFilterInput>>;
  /** Метод расчета итогов Акта КС-2 */
  calcMethod?: InputMaybe<BimActKc2TotalCalcMethodEnumOperationFilterInput>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Всего по Акту в текущем уровне цен */
  currentPriceTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Дата окончания */
  finishDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Отчетный месяц */
  month?: InputMaybe<ByteOperationFilterInput>;
  /** Номер */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2VersionDataFilterInput>>;
  /** Дата начала */
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор версии НЗ */
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Акт КС-2 версии НЗ */
export type BimActKc2VersionDataSortInput = {
  /** Метод расчета итогов Акта КС-2 */
  calcMethod?: InputMaybe<SortEnumType>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<SortEnumType>;
  /** Всего по Акту в текущем уровне цен */
  currentPriceTotal?: InputMaybe<SortEnumType>;
  /** Дата */
  date?: InputMaybe<SortEnumType>;
  /** Дата окончания */
  finishDate?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  /** Отчетный месяц */
  month?: InputMaybe<SortEnumType>;
  /** Номер */
  number?: InputMaybe<SortEnumType>;
  /** Дата начала */
  startDate?: InputMaybe<SortEnumType>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор версии НЗ */
  workOrderVersionId?: InputMaybe<SortEnumType>;
  /** Год сезона */
  year?: InputMaybe<SortEnumType>;
};

/** Акт КС-2 на прочие затраты версии НЗ */
export type BimActKc2VersionOtherData = {
  __typename?: 'BimActKC2VersionOtherData';
  authoredBy?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Дата */
  date?: Maybe<Scalars['DateTime']>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Признак наличия значений в поле Стоимость(План) */
  hasPlanValues: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Номер */
  number?: Maybe<Scalars['Int']>;
  /** Дата начала */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
  /** Статусы-последователи */
  statusFollowers: Array<BimActKc2OtherStatusEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  /** Идентификатор версии НЗ */
  workOrderVersionId: Scalars['Long'];
  /** Объект строительства версии НЗ */
  workOrderVersionObject: BimWorkOrderVersionObjectData;
  /** Сезон версии наряд-заказа */
  workOrderVersionSeason: BimWorkOrderVersionSeasonData;
};

/** Акт КС-2 на прочие затраты версии НЗ */
export type BimActKc2VersionOtherDataInput = {
  authoredBy?: InputMaybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Дата */
  date?: InputMaybe<Scalars['DateTime']>;
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Признак наличия значений в поле Стоимость(План) */
  hasPlanValues: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Номер */
  number?: InputMaybe<Scalars['Int']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
  /** Статусы-последователи */
  statusFollowers: Array<BimActKc2OtherStatusEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  /** Идентификатор версии НЗ */
  workOrderVersionId: Scalars['Long'];
  /** Объект строительства версии НЗ */
  workOrderVersionObject: BimWorkOrderVersionObjectDataInput;
  /** Сезон версии наряд-заказа */
  workOrderVersionSeason: BimWorkOrderVersionSeasonDataInput;
};

export type BimActKc2VersionOtherItemData = {
  __typename?: 'BimActKC2VersionOtherItemData';
  /** Дата коррекции */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Дата */
  date?: Maybe<Scalars['DateTime']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Номер */
  number?: Maybe<Scalars['Int']>;
  /** Статус */
  status: BimActKc2OtherStatusEnum;
};

export type BimActKc2VersionOtherItemDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2VersionOtherItemDataFilterInput>>;
  /** Дата коррекции */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Дата */
  date?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<BimActKc2VersionOtherItemDataFilterInput>>;
  /** Статус */
  status?: InputMaybe<BimActKc2OtherStatusEnumOperationFilterInput>;
};

export type BimActKc2VersionOtherItemDataSortInput = {
  /** Дата коррекции */
  correctionDate?: InputMaybe<SortEnumType>;
  /** Дата */
  date?: InputMaybe<SortEnumType>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<SortEnumType>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<SortEnumType>;
  /** Номер */
  number?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
};

export type BimActKc2VersionOtherTotalItemData = {
  __typename?: 'BimActKC2VersionOtherTotalItemData';
  /** Идентификатор строки */
  id: Scalars['Long'];
  /** Флаг запись является инфляцией */
  isInflation: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Всего */
  total?: Maybe<Scalars['Decimal']>;
  /** Идентификатор активного сезона версии наряд-заказа */
  workOrderVersionActiveSeasonId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона версии наряд-заказа */
  workOrderVersionSeasonId?: Maybe<Scalars['Long']>;
};

export type BimActKc2VersionOtherTotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2VersionOtherTotalItemDataFilterInput>>;
  /** Идентификатор строки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2VersionOtherTotalItemDataFilterInput>>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Всего */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор активного сезона версии наряд-заказа */
  workOrderVersionActiveSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона версии наряд-заказа */
  workOrderVersionSeasonId?: InputMaybe<LongOperationFilterInput>;
};

export type BimActKc2VersionOtherTotalItemDataSortInput = {
  /** Идентификатор строки */
  id?: InputMaybe<SortEnumType>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Всего */
  total?: InputMaybe<SortEnumType>;
  /** Идентификатор активного сезона версии наряд-заказа */
  workOrderVersionActiveSeasonId?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона версии наряд-заказа */
  workOrderVersionSeasonId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimActKc2VersionOtherTotalsCollectionSegment = {
  __typename?: 'BimActKC2VersionOtherTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2VersionOtherTotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Позиция состава акта КС-2 версии НЗ */
export type BimActKc2VersionPriceRowData = {
  __typename?: 'BimActKC2VersionPriceRowData';
  /** Номер единичной расценки */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Неактивная позиция МТР */
  inactiveMtr?: Maybe<Scalars['Boolean']>;
  /** Наименование работ */
  name: Scalars['String'];
  /** Номер позиции по смете */
  number?: Maybe<Scalars['String']>;
  /** Количество на ед./всего */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Идентификатор раздела */
  sectionId?: Maybe<Scalars['Long']>;
  /** Наименование раздела */
  sectionName?: Maybe<Scalars['String']>;
  /** Номер по порядку */
  serialNumber: Scalars['Int'];
  /** Стоимость */
  total?: Maybe<Scalars['Decimal']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Цена за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
};

/** Позиция состава акта КС-2 версии НЗ */
export type BimActKc2VersionPriceRowDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2VersionPriceRowDataFilterInput>>;
  /** Номер единичной расценки */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг Неактивная позиция МТР */
  inactiveMtr?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Номер позиции по смете */
  number?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2VersionPriceRowDataFilterInput>>;
  /** Количество на ед./всего */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Номер по порядку */
  serialNumber?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Цена за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Позиция состава акта КС-2 версии НЗ */
export type BimActKc2VersionPriceRowDataSortInput = {
  /** Номер единичной расценки */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Флаг Неактивная позиция МТР */
  inactiveMtr?: InputMaybe<SortEnumType>;
  /** Наименование работ */
  name?: InputMaybe<SortEnumType>;
  /** Номер позиции по смете */
  number?: InputMaybe<SortEnumType>;
  /** Количество на ед./всего */
  quantity?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<SortEnumType>;
  /** Наименование раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Номер по порядку */
  serialNumber?: InputMaybe<SortEnumType>;
  /** Стоимость */
  total?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Цена за единицу */
  unitCost?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimActKc2VersionPriceRowsCollectionSegment = {
  __typename?: 'BimActKC2VersionPriceRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2VersionPriceRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Строка итога Акта КС-2 версии НЗ */
export type BimActKc2VersionTotalItemData = {
  __typename?: 'BimActKC2VersionTotalItemData';
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Идентификатор строки */
  id: Scalars['Long'];
  /** Флаг запись является инфляцией */
  isInflation: Scalars['Boolean'];
  /** Флаг Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Идентификатор родительской записи итога */
  parentId?: Maybe<Scalars['Int']>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: Maybe<Scalars['Decimal']>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Идентификатор итога */
  totalId?: Maybe<Scalars['Long']>;
  /** Трудозатраты */
  tzr?: Maybe<Scalars['Decimal']>;
  /** Идентификатор активного сезона версии НЗ */
  workOrderVersionActiveSeasonId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона версии НЗ */
  workOrderVersionSeasonId?: Maybe<Scalars['Long']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Строка итога Акта КС-2 версии НЗ */
export type BimActKc2VersionTotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimActKc2VersionTotalItemDataFilterInput>>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор строки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Лимитированная затрата */
  isLimitPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimActKc2VersionTotalItemDataFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор родительской записи итога */
  parentId?: InputMaybe<IntOperationFilterInput>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Идентификатор итога */
  totalId?: InputMaybe<LongOperationFilterInput>;
  /** Трудозатраты */
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор активного сезона версии НЗ */
  workOrderVersionActiveSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона версии НЗ */
  workOrderVersionSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Строка итога Акта КС-2 версии НЗ */
export type BimActKc2VersionTotalItemDataSortInput = {
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Идентификатор строки */
  id?: InputMaybe<SortEnumType>;
  /** Флаг запись является инфляцией */
  isInflation?: InputMaybe<SortEnumType>;
  /** Флаг Лимитированная затрата */
  isLimitPrice?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Идентификатор родительской записи итога */
  parentId?: InputMaybe<SortEnumType>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор итога */
  totalId?: InputMaybe<SortEnumType>;
  /** Трудозатраты */
  tzr?: InputMaybe<SortEnumType>;
  /** Идентификатор активного сезона версии НЗ */
  workOrderVersionActiveSeasonId?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона версии НЗ */
  workOrderVersionSeasonId?: InputMaybe<SortEnumType>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimActKc2VersionTotalsCollectionSegment = {
  __typename?: 'BimActKC2VersionTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2VersionTotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActsKc2CollectionSegment = {
  __typename?: 'BimActsKC2CollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2Data>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActsKc2OtherCollectionSegment = {
  __typename?: 'BimActsKC2OtherCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2OtherItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActsKc2VersionCollectionSegment = {
  __typename?: 'BimActsKC2VersionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2VersionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimActsKc2VersionOtherCollectionSegment = {
  __typename?: 'BimActsKC2VersionOtherCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2VersionOtherItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Перечисление для определения способа расчета инфляции в Акте */
export enum BimCalculateInflationEnum {
  /** Установлено в смете */
  DefinedInPrice = 'DEFINED_IN_PRICE',
  /** Рассчитано в системе */
  SystemCalculated = 'SYSTEM_CALCULATED'
}

/** Расчет договора */
export type BimCalculationData = {
  __typename?: 'BimCalculationData';
  /** НЗ содержит акты */
  hasActsKC2?: Maybe<Scalars['Boolean']>;
  /** НЗ содержит акты прочих */
  hasOtherActsKC2?: Maybe<Scalars['Boolean']>;
  /** НЗ содержит акты СМР */
  hasSMRActsKC2?: Maybe<Scalars['Boolean']>;
  /** Идентификатор расчета */
  id: Scalars['Long'];
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: Maybe<Scalars['Boolean']>;
  /** Процент распределения итогов по сезонам */
  seasonDistributions?: Maybe<Array<BimWorkOrderSeasonDistributionData>>;
  /** Сезоны Расчета */
  seasons?: Maybe<Array<BimWorkOrderSeasonData>>;
  /** Статус */
  status: WorkOrderStatusEnum;
  /** Переходы статуса */
  statusFollowers: Array<WorkOrderStatusEnum>;
};

/** Расчет договора */
export type BimCalculationDataInput = {
  /** НЗ содержит акты */
  hasActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** НЗ содержит акты прочих */
  hasOtherActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** НЗ содержит акты СМР */
  hasSMRActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор расчета */
  id: Scalars['Long'];
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: InputMaybe<Scalars['Boolean']>;
  /** Процент распределения итогов по сезонам */
  seasonDistributions?: InputMaybe<Array<BimWorkOrderSeasonDistributionDataInput>>;
  /** Сезоны Расчета */
  seasons?: InputMaybe<Array<BimWorkOrderSeasonDataInput>>;
  /** Статус */
  status: WorkOrderStatusEnum;
  /** Переходы статуса */
  statusFollowers: Array<WorkOrderStatusEnum>;
};

/** Навигация расчета */
export type BimCalculationNavigationData = {
  __typename?: 'BimCalculationNavigationData';
  /** Данные расчета */
  calculationNavData: Uer_CalculationNavData;
  /** Список элементов навигации расчета */
  calculationNavItems?: Maybe<Array<Uer_CalculationItemNavData>>;
};

/** Расчет договора - данные для редактирования */
export type BimCalculationUpdateInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Статус */
  status: WorkOrderStatusEnum;
};

/** Глава */
export enum BimChapterEnum {
  /** Глава 1 */
  Chapter1 = 'CHAPTER1',
  /** Глава 2 */
  Chapter2 = 'CHAPTER2',
  /** Глава 3 */
  Chapter3 = 'CHAPTER3',
  /** Глава 4 */
  Chapter4 = 'CHAPTER4',
  /** Глава 5 */
  Chapter5 = 'CHAPTER5',
  /** Глава 6 */
  Chapter6 = 'CHAPTER6',
  /** Глава 7 */
  Chapter7 = 'CHAPTER7',
  /** Глава 8 */
  Chapter8 = 'CHAPTER8',
  /** Глава 9 */
  Chapter9 = 'CHAPTER9',
  /** Глава 12 */
  Chapter12 = 'CHAPTER12',
  /** Прочие */
  Others = 'OTHERS'
}

export type BimChapterEnumOperationFilterInput = {
  eq?: InputMaybe<BimChapterEnum>;
  in?: InputMaybe<Array<BimChapterEnum>>;
  neq?: InputMaybe<BimChapterEnum>;
  nin?: InputMaybe<Array<BimChapterEnum>>;
};

/** Объект строительства */
export type BimConstructionObjectInput = {
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Id объекта строительства */
  id: Scalars['Long'];
};

export type BimConstructionTypeCompletedResultData = {
  __typename?: 'BimConstructionTypeCompletedResultData';
  /** Выполнено по вид строительства (статус Акта: "Согласован") */
  completedPrice?: Maybe<Scalars['Decimal']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Отклонение Выполнено по виду строительства от Плана по виду строительства */
  deviation?: Maybe<DeviationEnum>;
};

export type BimConstructionTypeCompletedResultDataInput = {
  /** Выполнено по вид строительства (статус Акта: "Согласован") */
  completedPrice?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Отклонение Выполнено по виду строительства от Плана по виду строительства */
  deviation?: InputMaybe<DeviationEnum>;
};

/** Прочая затрата договора - данные для создания со статусом Условие договора */
export type BimContractConditionOtherCostInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Лимиты прочей затраты договора */
  otherCostLimits: Array<BimContractOtherCostLimitInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

/** Вид строительства договора */
export type BimContractConstructionTypeData = {
  __typename?: 'BimContractConstructionTypeData';
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  iconCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Используется в структуре объектов */
  usedInObjectStructure: Scalars['Boolean'];
};

/** Вид строительства договора */
export type BimContractConstructionTypeDataInput = {
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  iconCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  uniqueId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Используется в структуре объектов */
  usedInObjectStructure: Scalars['Boolean'];
};

export type BimContractConstructionTypeResultData = {
  __typename?: 'BimContractConstructionTypeResultData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по НЗ */
  contractPlan?: Maybe<Scalars['Decimal']>;
};

export type BimContractConstructionTypeResultDataInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по НЗ */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
};

/** Индексы перевода в текущий уровень цен */
export type BimContractConversionIndexData = {
  __typename?: 'BimContractConversionIndexData';
  /** Коэффициенты конвертации */
  coefficients: ConversionCoefficientsData;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор */
  id: Scalars['Long'];
};

/** Индексы перевода в текущий уровень цен */
export type BimContractConversionIndexDataInput = {
  /** Коэффициенты конвертации */
  coefficients: ConversionCoefficientsDataInput;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор */
  id: Scalars['Long'];
};

/** Индексы перевода в текущий уровень цен */
export type BimContractConversionIndexInput = {
  /** Коэффициенты конвертации */
  coefficients: ConversionCoefficientsInput;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
};

/** Договор */
export type BimContractCreateInput = {
  /** Идентификаторы видов строительства */
  constructionTypeIds: Array<Scalars['Int']>;
  /** Индексы перевода в текущий уровень цен */
  conversionIndices: Array<BimContractConversionIndexInput>;
  /** Окончательный сезон */
  finishSeasonYear: Scalars['Short'];
  /** Общие данные */
  generalInfo: BimContractGeneralInput;
  /** Способ расчета лимитированных затрат */
  limitedCostCalcMethod: BimLimitedCostCalcMethodEnum;
  /** Лимитированные затраты */
  limitedCosts: Array<BimContractLimitedCostInput>;
  /** Распределение по сезонам итогов непредвидимых и мотивационных расходов */
  otherDistributions: Array<BimContractSeasonDistributionInput>;
  /** Редактируемые свойства накопительной ведомости */
  plan: Array<BimContractPlanInput>;
  /** Внешний идентификатор проекта */
  projectUniqueId: Scalars['String'];
  /** Инфляция по сезонам */
  seasonsInflation: Array<BimContractSeasonInflationInput>;
  /** Распределение по сезонам итогов глав 1-12 */
  smrDistributions: Array<BimContractSeasonDistributionInput>;
  /** Начальный сезон */
  startSeasonYear: Scalars['Short'];
  /** Статус */
  status: BimContractStatusEnum;
  /** Базис поставки */
  supplyBasis: Scalars['String'];
};

/** Договор */
export type BimContractData = {
  __typename?: 'BimContractData';
  /** Фактическая стоимость */
  actualCost?: Maybe<Scalars['Decimal']>;
  /** Автор */
  authoredBy: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<BimContractConstructionTypeData>;
  /** Тип договора в проекте */
  contractType: ProjectContractTypeEnum;
  /** Индексы перевода в текущий уровень цен */
  conversionIndices: Array<BimContractConversionIndexData>;
  /** Cтоимость договора */
  cost: ContractCostData;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Общие данные */
  generalInfo: BimContractGeneralData;
  /** Признак заполненности полей 'Адрес заказчика' и 'Адрес подрядчика' */
  hasFilledAddresses: Scalars['Boolean'];
  /** Признак заполненности обязательных свойств договора */
  hasFilledMandatoryProperties: Scalars['Boolean'];
  /** Признак договоров без плана разделенного по видам строительства */
  hasNoPlanByConstructionType?: Maybe<Scalars['Boolean']>;
  /** Имеет структуру объектов */
  hasObjectStructure: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Способ расчета лимитированных затрат */
  limitedCostCalcMethod: BimLimitedCostCalcMethodEnum;
  /** Лимитированные затраты */
  limitedCosts: Array<BimContractLimitedCostData>;
  /** Распределение по сезонам итогов непредвидимых и мотивационных расходов */
  otherDistributions: Array<BimContractSeasonDistributionData>;
  /** Редактируемые свойства столбца план по договору накопительной ведомости */
  plan: BimContractPlanData;
  /** Внешний идентификатор проекта */
  projectUniqueId: Scalars['String'];
  /** Список плановых значений Накопительной ведомости договора */
  resultPlan: Array<BimContractResultPlanData>;
  /** Сезоны договора */
  seasons: Array<BimContractSeasonData>;
  /** Инфляция по сезонам */
  seasonsInflation: Array<BimContractSeasonInflationData>;
  /** Распределение по сезонам итогов глав 1-12 */
  smrDistributions: Array<BimContractSeasonDistributionData>;
  /** Статус */
  status: BimContractStatusEnum;
  /** Статусы доступные для установки из текущего статуса */
  statusFollowers: Array<BimContractStatusEnum>;
  /** Базис поставки */
  supplyBasis: Scalars['String'];
  /** Внешний идентификатор */
  uniqueId: Scalars['String'];
};

/** Договор */
export type BimContractDataInput = {
  /** Фактическая стоимость */
  actualCost?: InputMaybe<Scalars['Decimal']>;
  /** Автор */
  authoredBy: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<BimContractConstructionTypeDataInput>;
  /** Тип договора в проекте */
  contractType: ProjectContractTypeEnum;
  /** Индексы перевода в текущий уровень цен */
  conversionIndices: Array<BimContractConversionIndexDataInput>;
  /** Cтоимость договора */
  cost: ContractCostDataInput;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Общие данные */
  generalInfo: BimContractGeneralDataInput;
  /** Признак заполненности полей 'Адрес заказчика' и 'Адрес подрядчика' */
  hasFilledAddresses: Scalars['Boolean'];
  /** Признак заполненности обязательных свойств договора */
  hasFilledMandatoryProperties: Scalars['Boolean'];
  /** Признак договоров без плана разделенного по видам строительства */
  hasNoPlanByConstructionType?: InputMaybe<Scalars['Boolean']>;
  /** Имеет структуру объектов */
  hasObjectStructure: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Способ расчета лимитированных затрат */
  limitedCostCalcMethod: BimLimitedCostCalcMethodEnum;
  /** Лимитированные затраты */
  limitedCosts: Array<BimContractLimitedCostDataInput>;
  /** Распределение по сезонам итогов непредвидимых и мотивационных расходов */
  otherDistributions: Array<BimContractSeasonDistributionDataInput>;
  /** Редактируемые свойства столбца план по договору накопительной ведомости */
  plan: BimContractPlanDataInput;
  /** Внешний идентификатор проекта */
  projectUniqueId: Scalars['String'];
  /** Список плановых значений Накопительной ведомости договора */
  resultPlan: Array<BimContractResultPlanDataInput>;
  /** Сезоны договора */
  seasons: Array<BimContractSeasonDataInput>;
  /** Инфляция по сезонам */
  seasonsInflation: Array<BimContractSeasonInflationDataInput>;
  /** Распределение по сезонам итогов глав 1-12 */
  smrDistributions: Array<BimContractSeasonDistributionDataInput>;
  /** Статус */
  status: BimContractStatusEnum;
  /** Статусы доступные для установки из текущего статуса */
  statusFollowers: Array<BimContractStatusEnum>;
  /** Базис поставки */
  supplyBasis: Scalars['String'];
  /** Внешний идентификатор */
  uniqueId: Scalars['String'];
};

/** Данные договора по умолчанию */
export type BimContractDefaultData = {
  __typename?: 'BimContractDefaultData';
  /** Автор */
  authoredBy: Scalars['String'];
  /** Тип договора в проекте */
  contractType: ProjectContractTypeEnum;
  /** Заказчик */
  customer: Scalars['String'];
  /** Список плановых значений Накопительной ведомости договора */
  resultPlan: Array<BimContractResultPlanData>;
  /** Статус */
  status: BimContractStatusEnum;
};

/** Данные договора по умолчанию */
export type BimContractDefaultDataInput = {
  /** Автор */
  authoredBy: Scalars['String'];
  /** Тип договора в проекте */
  contractType: ProjectContractTypeEnum;
  /** Заказчик */
  customer: Scalars['String'];
  /** Список плановых значений Накопительной ведомости договора */
  resultPlan: Array<BimContractResultPlanDataInput>;
  /** Статус */
  status: BimContractStatusEnum;
};

/** Общие данные договора */
export type BimContractGeneralData = {
  __typename?: 'BimContractGeneralData';
  /** Сумма с НДС */
  amountWithTax?: Maybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: Maybe<Scalars['String']>;
  /** ОКПО подрядчика */
  contractorOKPO?: Maybe<Scalars['String']>;
  /** Заказчик */
  customer: Scalars['String'];
  /** Адрес заказчика */
  customerAddress?: Maybe<Scalars['String']>;
  /** ОКПО заказчика */
  customerOKPO?: Maybe<Scalars['String']>;
  /** Дата окончания действия */
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Наименование */
  name?: Maybe<Scalars['String']>;
  /** Примечание */
  note?: Maybe<Scalars['String']>;
  /** Вид деятельности ДО по ОКПД */
  okpd?: Maybe<Scalars['String']>;
  /** Форма ДО по ОКУД */
  okud?: Maybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Дата начала действия */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Предмет договора */
  subject: Scalars['String'];
  /** НДС */
  tax?: Maybe<Scalars['Decimal']>;
};

/** Общие данные договора */
export type BimContractGeneralDataInput = {
  /** Сумма с НДС */
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: InputMaybe<Scalars['String']>;
  /** ОКПО подрядчика */
  contractorOKPO?: InputMaybe<Scalars['String']>;
  /** Заказчик */
  customer: Scalars['String'];
  /** Адрес заказчика */
  customerAddress?: InputMaybe<Scalars['String']>;
  /** ОКПО заказчика */
  customerOKPO?: InputMaybe<Scalars['String']>;
  /** Дата окончания действия */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Наименование */
  name?: InputMaybe<Scalars['String']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']>;
  /** Вид деятельности ДО по ОКПД */
  okpd?: InputMaybe<Scalars['String']>;
  /** Форма ДО по ОКУД */
  okud?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Дата начала действия */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Предмет договора */
  subject: Scalars['String'];
  /** НДС */
  tax?: InputMaybe<Scalars['Decimal']>;
};

/** Общие данные договора */
export type BimContractGeneralInput = {
  /** Сумма с НДС */
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  /** Подрядчик */
  contractor: Scalars['String'];
  /** Адрес подрядчика */
  contractorAddress?: InputMaybe<Scalars['String']>;
  /** Адрес заказчика */
  customerAddress?: InputMaybe<Scalars['String']>;
  /** Дата окончания действия */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Наименование */
  name?: InputMaybe<Scalars['String']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Дата начала действия */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Предмет */
  subject: Scalars['String'];
  /** НДС */
  tax?: InputMaybe<Scalars['Decimal']>;
};

/** Лимитированная затрата */
export type BimContractLimitedCostData = {
  __typename?: 'BimContractLimitedCostData';
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Статьи затрат */
  items: Array<BimContractLimitedCostItemData>;
  /** Районный коэффициент */
  regionalFactor?: Maybe<Scalars['Decimal']>;
};

/** Лимитированная затрата */
export type BimContractLimitedCostDataInput = {
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Статьи затрат */
  items: Array<BimContractLimitedCostItemDataInput>;
  /** Районный коэффициент */
  regionalFactor?: InputMaybe<Scalars['Decimal']>;
};

/** Лимитированная затрата */
export type BimContractLimitedCostInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Статьи затрат */
  items: Array<BimContractLimitedCostItemInput>;
  /** Районный коэффициент */
  regionalFactor?: InputMaybe<Scalars['Decimal']>;
};

/** Статья лимитированной затраты */
export type BimContractLimitedCostItemData = {
  __typename?: 'BimContractLimitedCostItemData';
  /** ФОТ */
  fotValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Значение затраты */
  rateValue: Scalars['Decimal'];
  /** Тип лимитированной затраты */
  type: BimLimitedCostTypeEnum;
};

/** Статья лимитированной затраты */
export type BimContractLimitedCostItemDataInput = {
  /** ФОТ */
  fotValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Значение затраты */
  rateValue: Scalars['Decimal'];
  /** Тип лимитированной затраты */
  type: BimLimitedCostTypeEnum;
};

/** Статья лимитированной затраты */
export type BimContractLimitedCostItemInput = {
  /** ФОТ */
  fotValue?: InputMaybe<Scalars['Decimal']>;
  /** Значение затраты */
  rateValue: Scalars['Decimal'];
  /** Тип лимитированной затраты */
  type: BimLimitedCostTypeEnum;
};

/** Навигация договора */
export type BimContractNavigationData = {
  __typename?: 'BimContractNavigationData';
  /** Данные договора */
  contractNavData: Uer_ContractNavData;
  /** Список элементов навигации договора (ДС, прейскуранты, лимиты прочих затрат) */
  contractNavItems?: Maybe<Array<Uer_ContractItemNavData>>;
  /** Список навигации НЗ */
  workOrderNavs?: Maybe<Array<BimWorkOrderNavData>>;
};

/** Объект договора */
export type BimContractObjectCreateInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Объект/подобъект договора */
export type BimContractObjectData = {
  __typename?: 'BimContractObjectData';
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionData>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
};

/** Объект/подобъект договора */
export type BimContractObjectDataFilterInput = {
  and?: InputMaybe<Array<BimContractObjectDataFilterInput>>;
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам итогов */
  objectSeasonDistributions?: InputMaybe<ListFilterInputTypeOfBimContractObjectSeasonDistributionDataFilterInput>;
  or?: InputMaybe<Array<BimContractObjectDataFilterInput>>;
  /** Порядковое значение */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<BimContractObjectStatusEnumOperationFilterInput>;
};

/** Объект/подобъект договора */
export type BimContractObjectDataInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionDataInput>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
};

/** Объект/подобъект договора */
export type BimContractObjectDataSortInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Порядковое значение */
  order?: InputMaybe<SortEnumType>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
};

/** Распределение итогов по сезонам */
export type BimContractObjectSeasonDistributionData = {
  __typename?: 'BimContractObjectSeasonDistributionData';
  /** Сезон договора */
  contractSeason: BimContractSeasonData;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Значение по сезону */
  seasonValue: Scalars['Decimal'];
};

/** Распределение итогов по сезонам */
export type BimContractObjectSeasonDistributionDataFilterInput = {
  and?: InputMaybe<Array<BimContractObjectSeasonDistributionDataFilterInput>>;
  /** Сезон договора */
  contractSeason?: InputMaybe<BimContractSeasonDataFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimContractObjectSeasonDistributionDataFilterInput>>;
  /** Значение по сезону */
  seasonValue?: InputMaybe<DecimalOperationFilterInput>;
};

/** Распределение итогов по сезонам */
export type BimContractObjectSeasonDistributionDataInput = {
  /** Сезон договора */
  contractSeason: BimContractSeasonDataInput;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Значение по сезону */
  seasonValue: Scalars['Decimal'];
};

/** Распределение итогов по сезонам */
export type BimContractObjectSeasonDistributionInput = {
  /** Идентификатор сезона договора */
  contractSeasonId: Scalars['Long'];
  /** Значение по сезону */
  seasonValue: Scalars['Decimal'];
};

/** Статус объекта договора */
export enum BimContractObjectStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type BimContractObjectStatusEnumOperationFilterInput = {
  eq?: InputMaybe<BimContractObjectStatusEnum>;
  in?: InputMaybe<Array<BimContractObjectStatusEnum>>;
  neq?: InputMaybe<BimContractObjectStatusEnum>;
  nin?: InputMaybe<Array<BimContractObjectStatusEnum>>;
};

/** Объект договора */
export type BimContractObjectUpdateInput = {
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Прочая затрата договора - основные данные */
export type BimContractOtherCostBaseData = {
  __typename?: 'BimContractOtherCostBaseData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочих */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: BimContractOtherStatusEnum;
};

/** Прочая затрата договора - основные данные */
export type BimContractOtherCostBaseDataInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочих */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status: BimContractOtherStatusEnum;
};

/** Прочая затрата договора */
export type BimContractOtherCostData = {
  __typename?: 'BimContractOtherCostData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочих */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Лимиты прочей затраты договора */
  otherCostLimits: Array<BimContractOtherCostLimitData>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: BimContractOtherStatusEnum;
};

/** Прочая затрата договора */
export type BimContractOtherCostDataInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочих */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Лимиты прочей затраты договора */
  otherCostLimits: Array<BimContractOtherCostLimitDataInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status: BimContractOtherStatusEnum;
};

/** Прочая затрата договора - данные для создания из справочника методик расчета */
export type BimContractOtherCostFromCatalogInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId: Scalars['Long'];
  /** Лимиты прочей затраты договора */
  otherCostLimits: Array<BimContractOtherCostLimitInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** A segment of a collection. */
export type BimContractOtherCostIncludedInActKc2FilterCollectionSegment = {
  __typename?: 'BimContractOtherCostIncludedInActKC2FilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimContractOtherCostIncludedInWorkOrderFilterCollectionSegment = {
  __typename?: 'BimContractOtherCostIncludedInWorkOrderFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Прочая затрата договора - данные для создания вручную */
export type BimContractOtherCostInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Лимиты прочей затраты договора */
  otherCostLimits: Array<BimContractOtherCostLimitInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Прочая затрата договора - данные для списка */
export type BimContractOtherCostItemData = {
  __typename?: 'BimContractOtherCostItemData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Лимиты по прочим */
  cost: Scalars['Decimal'];
  /** Формула прочих */
  formula?: Maybe<Scalars['String']>;
  /** Признак заполнения типа прочей для прочей типа Расчет */
  hasEmptyOtherCostType: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Включено в Акт КС-2 */
  isIncludedInActKc2?: Maybe<Scalars['Boolean']>;
  /** Включено в наряд-заказ */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: BimContractOtherStatusEnum;
};

/** Прочая затрата договора - данные для списка */
export type BimContractOtherCostItemDataFilterInput = {
  and?: InputMaybe<Array<BimContractOtherCostItemDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Лимиты по прочим */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  /** Формула прочих */
  formula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак заполнения типа прочей для прочей типа Расчет */
  hasEmptyOtherCostType?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в Акт КС-2 */
  isIncludedInActKc2?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в наряд-заказ */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimContractOtherCostItemDataFilterInput>>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<BimContractOtherStatusEnumOperationFilterInput>;
};

/** Прочая затрата договора - данные для списка */
export type BimContractOtherCostItemDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataSortInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Лимиты по прочим */
  cost?: InputMaybe<SortEnumType>;
  /** Формула прочих */
  formula?: InputMaybe<SortEnumType>;
  /** Признак заполнения типа прочей для прочей типа Расчет */
  hasEmptyOtherCostType?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Флаг Прочая затрата из справочника методик расчета */
  isGlobalOtherCost?: InputMaybe<SortEnumType>;
  /** Включено в Акт КС-2 */
  isIncludedInActKc2?: InputMaybe<SortEnumType>;
  /** Включено в наряд-заказ */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
};

/** Лимит прочей затраты договора */
export type BimContractOtherCostLimitData = {
  __typename?: 'BimContractOtherCostLimitData';
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Стоимость */
  cost: Scalars['Decimal'];
};

/** Лимит прочей затраты договора */
export type BimContractOtherCostLimitDataInput = {
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Стоимость */
  cost: Scalars['Decimal'];
};

export type BimContractOtherCostLimitInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
};

/** Входные данные для изменения свойств прочей затраты используемых в договоре */
export type BimContractOtherCostModifyInput = {
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей вида вычисления Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты */
  id: Scalars['Long'];
};

/** A segment of a collection. */
export type BimContractOtherCostNameFilterCollectionSegment = {
  __typename?: 'BimContractOtherCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimContractOtherCostTypesCollectionSegment = {
  __typename?: 'BimContractOtherCostTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Прочая затрата договора - данные для обновления */
export type BimContractOtherCostUpdateInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Лимиты прочей затраты договора */
  otherCostLimits: Array<BimContractOtherCostLimitInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

/** A segment of a collection. */
export type BimContractOtherCostsCollectionSegment = {
  __typename?: 'BimContractOtherCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimContractOtherCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Статус прочей затраты договора */
export enum BimContractOtherStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type BimContractOtherStatusEnumOperationFilterInput = {
  eq?: InputMaybe<BimContractOtherStatusEnum>;
  in?: InputMaybe<Array<BimContractOtherStatusEnum>>;
  neq?: InputMaybe<BimContractOtherStatusEnum>;
  nin?: InputMaybe<Array<BimContractOtherStatusEnum>>;
};

/** Редактируемые свойства накопительной ведомости */
export type BimContractPlanData = {
  __typename?: 'BimContractPlanData';
  /** СМР Главы 1-7 */
  chapter1_7?: Maybe<Scalars['Decimal']>;
  /** СМР Глава 8 */
  chapter8?: Maybe<Scalars['Decimal']>;
  /** СМР Глава 9 */
  chapter9?: Maybe<Scalars['Decimal']>;
  /** СМР Глава 12 */
  chapter12?: Maybe<Scalars['Decimal']>;
  /** МТР ОП, Оборудование подрядчик */
  equipmentContractor?: Maybe<Scalars['Decimal']>;
  /** МТР ОЗ, Оборудование заказчика */
  equipmentCustomer?: Maybe<Scalars['Decimal']>;
  /** МТР МП, Материалы подрядчик */
  materialContractor?: Maybe<Scalars['Decimal']>;
  /** МТР МЗ, Материалы заказчика */
  materialCustomer?: Maybe<Scalars['Decimal']>;
  /** Северная надбавка */
  northernAllowance?: Maybe<Scalars['Decimal']>;
};

/** Редактируемые свойства накопительной ведомости */
export type BimContractPlanDataInput = {
  /** СМР Главы 1-7 */
  chapter1_7?: InputMaybe<Scalars['Decimal']>;
  /** СМР Глава 8 */
  chapter8?: InputMaybe<Scalars['Decimal']>;
  /** СМР Глава 9 */
  chapter9?: InputMaybe<Scalars['Decimal']>;
  /** СМР Глава 12 */
  chapter12?: InputMaybe<Scalars['Decimal']>;
  /** МТР ОП, Оборудование подрядчик */
  equipmentContractor?: InputMaybe<Scalars['Decimal']>;
  /** МТР ОЗ, Оборудование заказчика */
  equipmentCustomer?: InputMaybe<Scalars['Decimal']>;
  /** МТР МП, Материалы подрядчик */
  materialContractor?: InputMaybe<Scalars['Decimal']>;
  /** МТР МЗ, Материалы заказчика */
  materialCustomer?: InputMaybe<Scalars['Decimal']>;
  /** Северная надбавка */
  northernAllowance?: InputMaybe<Scalars['Decimal']>;
};

/** Редактируемые свойства накопительной ведомости */
export type BimContractPlanInput = {
  /** СМР Главы 1-7 */
  chapter1_7?: InputMaybe<Scalars['Decimal']>;
  /** СМР Глава 8 */
  chapter8?: InputMaybe<Scalars['Decimal']>;
  /** СМР Глава 9 */
  chapter9?: InputMaybe<Scalars['Decimal']>;
  /** СМР Глава 12 */
  chapter12?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** МТР ОП, Оборудование подрядчик */
  equipmentContractor?: InputMaybe<Scalars['Decimal']>;
  /** МТР ОЗ, Оборудование заказчика */
  equipmentCustomer?: InputMaybe<Scalars['Decimal']>;
  /** МТР МП, Материалы подрядчик */
  materialContractor?: InputMaybe<Scalars['Decimal']>;
  /** МТР МЗ, Материалы заказчика */
  materialCustomer?: InputMaybe<Scalars['Decimal']>;
};

export type BimContractResultData = {
  __typename?: 'BimContractResultData';
  /** Факт освоения по НЗ */
  completed?: Maybe<Scalars['Decimal']>;
  /** Отклонение освоения от плана */
  completedDeviation?: Maybe<DeviationEnum>;
  /** Остаток с учётом освоения */
  completedRemainder?: Maybe<Scalars['Decimal']>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  completedRemainderDeviationTip?: Maybe<DeviationTipEnum>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: Maybe<Array<BimContractConstructionTypeResultData>>;
  /** План по договору */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Остаток по договору */
  contractRemainder?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  deviationTip?: Maybe<DeviationTipEnum>;
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование строки Итога */
  name: Scalars['String'];
  /** Тип итога */
  totalType?: Maybe<BimTotal_AlcTypeEnum>;
  /** Сумма планов по Наряд-заказу * */
  workOrderPlanSum?: Maybe<Scalars['Decimal']>;
  /** Список значений по каждому НЗ в Договоре */
  workOrderResults: Array<BimContractWorkOrderResultData>;
};

export type BimContractResultDataInput = {
  /** Факт освоения по НЗ */
  completed?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение освоения от плана */
  completedDeviation?: InputMaybe<DeviationEnum>;
  /** Остаток с учётом освоения */
  completedRemainder?: InputMaybe<Scalars['Decimal']>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  completedRemainderDeviationTip?: InputMaybe<DeviationTipEnum>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: InputMaybe<Array<BimContractConstructionTypeResultDataInput>>;
  /** План по договору */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Остаток по договору */
  contractRemainder?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<DeviationEnum>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  deviationTip?: InputMaybe<DeviationTipEnum>;
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование строки Итога */
  name: Scalars['String'];
  /** Тип итога */
  totalType?: InputMaybe<BimTotal_AlcTypeEnum>;
  /** Сумма планов по Наряд-заказу * */
  workOrderPlanSum?: InputMaybe<Scalars['Decimal']>;
  /** Список значений по каждому НЗ в Договоре */
  workOrderResults: Array<BimContractWorkOrderResultDataInput>;
};

export type BimContractResultPlanData = {
  __typename?: 'BimContractResultPlanData';
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: Maybe<Array<BimContractConstructionTypeResultData>>;
  /** План по договору */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Сезон договора */
  contractSeasonYear?: Maybe<Scalars['Short']>;
  /** Флаг Есть сезон (итог рассчитывается для сезона НЗ) */
  hasSeason: Scalars['Boolean'];
  /** Флаг Доступно для редактирования */
  isEditable: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Флаг Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Наименование строки Итога */
  name: Scalars['String'];
  /** Тип итога */
  totalType?: Maybe<BimTotal_AlcTypeEnum>;
};

export type BimContractResultPlanDataInput = {
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: InputMaybe<Array<BimContractConstructionTypeResultDataInput>>;
  /** План по договору */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Сезон договора */
  contractSeasonYear?: InputMaybe<Scalars['Short']>;
  /** Флаг Есть сезон (итог рассчитывается для сезона НЗ) */
  hasSeason: Scalars['Boolean'];
  /** Флаг Доступно для редактирования */
  isEditable: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Флаг Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Наименование строки Итога */
  name: Scalars['String'];
  /** Тип итога */
  totalType?: InputMaybe<BimTotal_AlcTypeEnum>;
};

export type BimContractResultsViewData = {
  __typename?: 'BimContractResultsViewData';
  contractResults?: Maybe<Array<BimContractResultData>>;
  workOrders?: Maybe<Array<BimWorkOrderNavData>>;
};

export type BimContractResultsViewDataInput = {
  contractResults?: InputMaybe<Array<BimContractResultDataInput>>;
  workOrders?: InputMaybe<Array<WorkOrderNavDataInput>>;
};

/** Сезон договора */
export type BimContractSeasonData = {
  __typename?: 'BimContractSeasonData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Сезон договора */
export type BimContractSeasonDataFilterInput = {
  and?: InputMaybe<Array<BimContractSeasonDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimContractSeasonDataFilterInput>>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Сезон договора */
export type BimContractSeasonDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Сезон договора */
export type BimContractSeasonDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Год сезона */
  year?: InputMaybe<SortEnumType>;
};

/** Распределение по сезонам итогов */
export type BimContractSeasonDistributionData = {
  __typename?: 'BimContractSeasonDistributionData';
  contractConstructionTypeData?: Maybe<ConstructionTypeData>;
  /** Сезон договора */
  contractSeason: BimContractSeasonData;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Плановое значение сезона */
  seasonValue?: Maybe<Scalars['Decimal']>;
};

/** Распределение по сезонам итогов */
export type BimContractSeasonDistributionDataInput = {
  contractConstructionTypeData?: InputMaybe<ConstructionTypeDataInput>;
  /** Сезон договора */
  contractSeason: BimContractSeasonDataInput;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Плановое значение сезона */
  seasonValue?: InputMaybe<Scalars['Decimal']>;
};

/** Распределение по сезонам итогов */
export type BimContractSeasonDistributionInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Сезон договора/&gt; */
  contractSeasonYear: Scalars['Short'];
  /** Плановое значение сезона */
  seasonValue?: InputMaybe<Scalars['Decimal']>;
};

/** Инфляция сезона */
export type BimContractSeasonInflationData = {
  __typename?: 'BimContractSeasonInflationData';
  /** Сезон договора */
  contractSeason: BimContractSeasonData;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
};

/** Инфляция сезона */
export type BimContractSeasonInflationDataInput = {
  /** Сезон договора */
  contractSeason: BimContractSeasonDataInput;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
};

/** Инфляция сезона */
export type BimContractSeasonInflationInput = {
  /** Сезон договора/&gt; */
  contractSeasonYear: Scalars['Short'];
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
};

/** Статус договора */
export enum BimContractStatusEnum {
  /** Завершен */
  Completed = 'COMPLETED',
  /** Отложен */
  Delayed = 'DELAYED',
  /** На реализации */
  InImplementation = 'IN_IMPLEMENTATION'
}

/** Подобъект договора */
export type BimContractSubObjectCreateInput = {
  /** Идентификатор родительского объекта/подобъекта */
  contractObjectId: Scalars['Long'];
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Подобъект договора */
export type BimContractSubObjectUpdateInput = {
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Договор */
export type BimContractUpdateInput = {
  /** Идентификаторы видов строительства */
  constructionTypeIds: Array<Scalars['Int']>;
  /** Индексы перевода в текущий уровень цен */
  conversionIndices: Array<BimContractConversionIndexInput>;
  /** Окончательный сезон */
  finishSeasonYear: Scalars['Short'];
  /** Общие данные */
  generalInfo: BimContractGeneralInput;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Способ расчета лимитированных затрат */
  limitedCostCalcMethod: BimLimitedCostCalcMethodEnum;
  /** Лимитированные затраты */
  limitedCosts: Array<BimContractLimitedCostInput>;
  /** Распределение по сезонам итогов непредвидимых и мотивационных расходов */
  otherDistributions: Array<BimContractSeasonDistributionInput>;
  /** Редактируемые свойства накопительной ведомости */
  plan: Array<BimContractPlanInput>;
  /** Инфляция по сезонам */
  seasonsInflation: Array<BimContractSeasonInflationInput>;
  /** Распределение по сезонам итогов глав 1-12 */
  smrDistributions: Array<BimContractSeasonDistributionInput>;
  /** Начальный сезон */
  startSeasonYear: Scalars['Short'];
  /** Статус */
  status: BimContractStatusEnum;
  /** Базис поставки */
  supplyBasis: Scalars['String'];
};

export type BimContractWorkOrderResultData = {
  __typename?: 'BimContractWorkOrderResultData';
  /** Выполнено по НЗ для всех Актов, входящих в данный НЗ (статус Акта: "Согласован") */
  completedPrice?: Maybe<Scalars['Decimal']>;
  /** Итоги по видам строительства */
  constructionTypeResults: Array<BimWorkOrderConstructionTypeResultData>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Суммарная стоимость работ по НЗ */
  planPrice?: Maybe<Scalars['Decimal']>;
  /** Идентификатор НЗ (для перехода) */
  workOrderId: Scalars['Long'];
};

export type BimContractWorkOrderResultDataInput = {
  /** Выполнено по НЗ для всех Актов, входящих в данный НЗ (статус Акта: "Согласован") */
  completedPrice?: InputMaybe<Scalars['Decimal']>;
  /** Итоги по видам строительства */
  constructionTypeResults: Array<BimWorkOrderConstructionTypeResultDataInput>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<DeviationEnum>;
  /** Суммарная стоимость работ по НЗ */
  planPrice?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор НЗ (для перехода) */
  workOrderId: Scalars['Long'];
};

/** Индексы перевода в текущий уровень цен (10 статей, соответствуют owned-типу BimConversionCoefficients). */
export type BimConversionCoefficientsData = {
  __typename?: 'BimConversionCoefficientsData';
  kemm?: Maybe<Scalars['Decimal']>;
  keqp?: Maybe<Scalars['Decimal']>;
  kmtr?: Maybe<Scalars['Decimal']>;
  kmz?: Maybe<Scalars['Decimal']>;
  knr?: Maybe<Scalars['Decimal']>;
  koz?: Maybe<Scalars['Decimal']>;
  kozp?: Maybe<Scalars['Decimal']>;
  kpir?: Maybe<Scalars['Decimal']>;
  ksp?: Maybe<Scalars['Decimal']>;
  kzpm?: Maybe<Scalars['Decimal']>;
};

/** Индексы перевода в текущий уровень цен (10 статей, соответствуют owned-типу BimConversionCoefficients). */
export type BimConversionCoefficientsDataInput = {
  kemm?: InputMaybe<Scalars['Decimal']>;
  keqp?: InputMaybe<Scalars['Decimal']>;
  kmtr?: InputMaybe<Scalars['Decimal']>;
  kmz?: InputMaybe<Scalars['Decimal']>;
  knr?: InputMaybe<Scalars['Decimal']>;
  koz?: InputMaybe<Scalars['Decimal']>;
  kozp?: InputMaybe<Scalars['Decimal']>;
  kpir?: InputMaybe<Scalars['Decimal']>;
  ksp?: InputMaybe<Scalars['Decimal']>;
  kzpm?: InputMaybe<Scalars['Decimal']>;
};

/** Коэффициенты конвертации */
export type BimConversionCoefficientsInput = {
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования подрядчика */
  keqp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материалов подрядчика */
  kmtr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материалов заказчика */
  kmz?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования заказчика */
  koz?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент заработной платы машинистов */
  kzpm?: InputMaybe<Scalars['Decimal']>;
};

/** A segment of a collection. */
export type BimGlobalOtherCostsForContractCollectionSegment = {
  __typename?: 'BimGlobalOtherCostsForContractCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Строка аналитических данных по разделу/подразделу сметы ЛСР */
export type BimHeaderAnalyticsRowData = {
  __typename?: 'BimHeaderAnalyticsRowData';
  /** Список названий свойств с измененными значениями */
  changedProperties?: Maybe<Array<Scalars['String']>>;
  /** Порядок раздела/подраздела в файле сметы */
  order: Scalars['Int'];
  /** Данные раздела/подраздела сравниваемой сметы */
  refHeaderValue?: Maybe<BimWorkOrderPriceSectionData>;
  /** Аналитический статус раздела/подраздела */
  status: BimPriceAnalyticsItemStatus;
  /** Идентификатор раздела/подраздела из файла сметы */
  sysId: Scalars['Long'];
  /** Данные раздела/подраздела выбранной сметы */
  topHeaderValue?: Maybe<BimWorkOrderPriceSectionData>;
};

/** Строка аналитических данных по разделу/подразделу сметы ЛСР */
export type BimHeaderAnalyticsRowDataFilterInput = {
  and?: InputMaybe<Array<BimHeaderAnalyticsRowDataFilterInput>>;
  /** Список названий свойств с измененными значениями */
  changedProperties?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimHeaderAnalyticsRowDataFilterInput>>;
  /** Порядок раздела/подраздела в файле сметы */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Данные раздела/подраздела сравниваемой сметы */
  refHeaderValue?: InputMaybe<BimWorkOrderPriceSectionDataFilterInput>;
  /** Аналитический статус раздела/подраздела */
  status?: InputMaybe<BimPriceAnalyticsItemStatusOperationFilterInput>;
  /** Идентификатор раздела/подраздела из файла сметы */
  sysId?: InputMaybe<LongOperationFilterInput>;
  /** Данные раздела/подраздела выбранной сметы */
  topHeaderValue?: InputMaybe<BimWorkOrderPriceSectionDataFilterInput>;
};

/** Строка аналитических данных по разделу/подразделу сметы ЛСР */
export type BimHeaderAnalyticsRowDataSortInput = {
  /** Порядок раздела/подраздела в файле сметы */
  order?: InputMaybe<SortEnumType>;
  /** Данные раздела/подраздела сравниваемой сметы */
  refHeaderValue?: InputMaybe<BimWorkOrderPriceSectionDataSortInput>;
  /** Аналитический статус раздела/подраздела */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела/подраздела из файла сметы */
  sysId?: InputMaybe<SortEnumType>;
  /** Данные раздела/подраздела выбранной сметы */
  topHeaderValue?: InputMaybe<BimWorkOrderPriceSectionDataSortInput>;
};

/** Способ расчета лимитированных затрат */
export enum BimLimitedCostCalcMethodEnum {
  /** Не учитывать МТР заказчика */
  IgnoreCustomerMtr = 'IGNORE_CUSTOMER_MTR',
  /** Учитывать МТР заказчика */
  TakeCustomerMtr = 'TAKE_CUSTOMER_MTR'
}

/** Тип лимитированных затрат */
export enum BimLimitedCostTypeEnum {
  /** Затраты на дополнительную транспортировку материалов */
  MaterialsTransportationExtraCost = 'MATERIALS_TRANSPORTATION_EXTRA_COST',
  /** Обеспечение нормальных условий труда */
  ProvidingWorkCondition = 'PROVIDING_WORK_CONDITION',
  /** Надбавка к заработной плате за стаж работы в районе Крайнего Севера */
  SalarySupplementWorkingFarNorth = 'SALARY_SUPPLEMENT_WORKING_FAR_NORTH',
  /** Надбавка к заработной плате за стаж работы в местностях, приравненных к районам Крайнего Севера */
  SalarySupplementWorkingFarNorthEquatedAreas = 'SALARY_SUPPLEMENT_WORKING_FAR_NORTH_EQUATED_AREAS',
  /** Затраты на организацию работ вахтовым методом */
  ShiftMethodOrganizationCost = 'SHIFT_METHOD_ORGANIZATION_COST',
  /** Снегоборьба */
  Snowfighting = 'SNOWFIGHTING',
  /** Временные здания и сооружения */
  TemporaryConstruction = 'TEMPORARY_CONSTRUCTION',
  /** Зимнее удорожание */
  WinterPriceRising = 'WINTER_PRICE_RISING'
}

export type BimNormalContractResultData = {
  __typename?: 'BimNormalContractResultData';
  /** Сумма Актов КС-2 */
  actKC2CompletedSum?: Maybe<Scalars['Decimal']>;
  constructionTypeCompletedResult: Array<BimConstructionTypeCompletedResultData>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: Maybe<Array<BimContractConstructionTypeResultData>>;
  /** План по договору */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Остаток по договору */
  contractRemainder?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  deviationTip?: Maybe<DeviationTipEnum>;
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование строки Итога */
  name: Scalars['String'];
  /** Тип итога */
  totalType?: Maybe<BimTotal_AlcTypeEnum>;
};

export type BimNormalContractResultDataInput = {
  /** Сумма Актов КС-2 */
  actKC2CompletedSum?: InputMaybe<Scalars['Decimal']>;
  constructionTypeCompletedResult: Array<BimConstructionTypeCompletedResultDataInput>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: InputMaybe<Array<BimContractConstructionTypeResultDataInput>>;
  /** План по договору */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Остаток по договору */
  contractRemainder?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<DeviationEnum>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  deviationTip?: InputMaybe<DeviationTipEnum>;
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование строки Итога */
  name: Scalars['String'];
  /** Тип итога */
  totalType?: InputMaybe<BimTotal_AlcTypeEnum>;
};

/** Общие аналитические данные сметы ЛСР */
export type BimPriceAnalyticsData = {
  __typename?: 'BimPriceAnalyticsData';
  /** Список названий свойств с измененными значениями */
  changedProperties?: Maybe<Array<Scalars['String']>>;
  /** Идентификатор сравниваемой сметы */
  refPriceId: Scalars['Long'];
  /** Данные сравниваемой сметы */
  refPriceValue?: Maybe<BimWorkOrderPriceValue>;
  /** Счетчики количества статусов */
  statusCounts: Array<BimPriceAnalyticsStatusItem>;
  /** Идентификатор выбранной сметы */
  topPriceId: Scalars['Long'];
  /** Данные выбранной сметы */
  topPriceValue?: Maybe<BimWorkOrderPriceValue>;
};

/** Общие аналитические данные сметы ЛСР */
export type BimPriceAnalyticsDataInput = {
  /** Список названий свойств с измененными значениями */
  changedProperties?: InputMaybe<Array<Scalars['String']>>;
  /** Идентификатор сравниваемой сметы */
  refPriceId: Scalars['Long'];
  /** Данные сравниваемой сметы */
  refPriceValue?: InputMaybe<BimWorkOrderPriceValueInput>;
  /** Счетчики количества статусов */
  statusCounts: Array<BimPriceAnalyticsStatusItemInput>;
  /** Идентификатор выбранной сметы */
  topPriceId: Scalars['Long'];
  /** Данные выбранной сметы */
  topPriceValue?: InputMaybe<BimWorkOrderPriceValueInput>;
};

/** Строка аналитических данных по позиции сметы ЛСР */
export type BimPriceAnalyticsItem = {
  __typename?: 'BimPriceAnalyticsItem';
  /** Данные по позиции в составе сметы */
  price: BimPriceAnalyticsRowData;
  /** Данные по разделу состава сметы */
  section: BimHeaderAnalyticsRowData;
  /** Данные по подразделу состава сметы */
  subsection?: Maybe<BimHeaderAnalyticsRowData>;
};

/** Строка аналитических данных по позиции сметы ЛСР */
export type BimPriceAnalyticsItemFilterInput = {
  and?: InputMaybe<Array<BimPriceAnalyticsItemFilterInput>>;
  or?: InputMaybe<Array<BimPriceAnalyticsItemFilterInput>>;
  /** Данные по позиции в составе сметы */
  price?: InputMaybe<BimPriceAnalyticsRowDataFilterInput>;
  /** Данные по разделу состава сметы */
  section?: InputMaybe<BimHeaderAnalyticsRowDataFilterInput>;
  /** Данные по подразделу состава сметы */
  subsection?: InputMaybe<BimHeaderAnalyticsRowDataFilterInput>;
};

/** Строка аналитических данных по позиции сметы ЛСР */
export type BimPriceAnalyticsItemSortInput = {
  /** Данные по позиции в составе сметы */
  price?: InputMaybe<BimPriceAnalyticsRowDataSortInput>;
  /** Данные по разделу состава сметы */
  section?: InputMaybe<BimHeaderAnalyticsRowDataSortInput>;
  /** Данные по подразделу состава сметы */
  subsection?: InputMaybe<BimHeaderAnalyticsRowDataSortInput>;
};

/** Статусы аналитики */
export enum BimPriceAnalyticsItemStatus {
  Added = 'ADDED',
  Changed = 'CHANGED',
  Equals = 'EQUALS',
  None = 'NONE',
  Removed = 'REMOVED',
  Replaced = 'REPLACED'
}

export type BimPriceAnalyticsItemStatusOperationFilterInput = {
  eq?: InputMaybe<BimPriceAnalyticsItemStatus>;
  in?: InputMaybe<Array<BimPriceAnalyticsItemStatus>>;
  neq?: InputMaybe<BimPriceAnalyticsItemStatus>;
  nin?: InputMaybe<Array<BimPriceAnalyticsItemStatus>>;
};

/** Строка аналитических данных по позиции сметы ЛСР */
export type BimPriceAnalyticsRowData = {
  __typename?: 'BimPriceAnalyticsRowData';
  /** Список названий свойств с измененными значениями */
  changedProperties?: Maybe<Array<Scalars['String']>>;
  /** Порядок позиции в файле сметы */
  order: Scalars['Int'];
  /** Данные позиции сравниваемой сметы */
  refPriceValue?: Maybe<BimWorkOrderPriceValue>;
  /** Аналитический статус позиции */
  status: BimPriceAnalyticsItemStatus;
  /** Идентификатор позиции из файла сметы */
  sysId: Scalars['Long'];
  /** Данные позиции выбранной сметы */
  topPriceValue?: Maybe<BimWorkOrderPriceValue>;
};

/** Строка аналитических данных по позиции сметы ЛСР */
export type BimPriceAnalyticsRowDataFilterInput = {
  and?: InputMaybe<Array<BimPriceAnalyticsRowDataFilterInput>>;
  /** Список названий свойств с измененными значениями */
  changedProperties?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimPriceAnalyticsRowDataFilterInput>>;
  /** Порядок позиции в файле сметы */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Данные позиции сравниваемой сметы */
  refPriceValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Аналитический статус позиции */
  status?: InputMaybe<BimPriceAnalyticsItemStatusOperationFilterInput>;
  /** Идентификатор позиции из файла сметы */
  sysId?: InputMaybe<LongOperationFilterInput>;
  /** Данные позиции выбранной сметы */
  topPriceValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
};

/** Строка аналитических данных по позиции сметы ЛСР */
export type BimPriceAnalyticsRowDataSortInput = {
  /** Порядок позиции в файле сметы */
  order?: InputMaybe<SortEnumType>;
  /** Данные позиции сравниваемой сметы */
  refPriceValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Аналитический статус позиции */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор позиции из файла сметы */
  sysId?: InputMaybe<SortEnumType>;
  /** Данные позиции выбранной сметы */
  topPriceValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
};

/** Элемент счетчика статусов */
export type BimPriceAnalyticsStatusItem = {
  __typename?: 'BimPriceAnalyticsStatusItem';
  /** Количество элементов аналитики, включая раздел/подраздел и позиции, в указанном статусе */
  count: Scalars['Int'];
  /** Аналитический статус */
  status: BimPriceAnalyticsItemStatus;
};

/** Элемент счетчика статусов */
export type BimPriceAnalyticsStatusItemInput = {
  /** Количество элементов аналитики, включая раздел/подраздел и позиции, в указанном статусе */
  count: Scalars['Int'];
  /** Аналитический статус */
  status: BimPriceAnalyticsItemStatus;
};

/** Уровень цен */
export enum BimPriceLevelEnum {
  /** Базисный уровень цен */
  BasicPriceLevel = 'BASIC_PRICE_LEVEL',
  /** Текущий уровень цен */
  CurrentPriceLevel = 'CURRENT_PRICE_LEVEL'
}

/** A segment of a collection. */
export type BimPriceRowAnalyticsCodeFilterCollectionSegment = {
  __typename?: 'BimPriceRowAnalyticsCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimPriceRowAnalyticsCollectionSegment = {
  __typename?: 'BimPriceRowAnalyticsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimPriceAnalyticsItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimPriceRowAnalyticsNameFilterCollectionSegment = {
  __typename?: 'BimPriceRowAnalyticsNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimPriceRowAnalyticsSectionFilterCollectionSegment = {
  __typename?: 'BimPriceRowAnalyticsSectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimPriceRowAnalyticsSubsectionFilterCollectionSegment = {
  __typename?: 'BimPriceRowAnalyticsSubsectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimPriceRowAnalyticsUnitFilterCollectionSegment = {
  __typename?: 'BimPriceRowAnalyticsUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum BimTotal_AlcTypeEnum {
  CleanPriceChapter1 = 'CLEAN_PRICE_CHAPTER1',
  CleanPriceChapter1_7 = 'CLEAN_PRICE_CHAPTER1_7',
  CleanPriceChapter2 = 'CLEAN_PRICE_CHAPTER2',
  CleanPriceChapter3 = 'CLEAN_PRICE_CHAPTER3',
  CleanPriceChapter4 = 'CLEAN_PRICE_CHAPTER4',
  CleanPriceChapter5 = 'CLEAN_PRICE_CHAPTER5',
  CleanPriceChapter6 = 'CLEAN_PRICE_CHAPTER6',
  CleanPriceChapter7 = 'CLEAN_PRICE_CHAPTER7',
  CleanPriceChapter8 = 'CLEAN_PRICE_CHAPTER8',
  CleanPriceChapter9 = 'CLEAN_PRICE_CHAPTER9',
  CleanPriceChapter12 = 'CLEAN_PRICE_CHAPTER12',
  CurrentPriceChapter1 = 'CURRENT_PRICE_CHAPTER1',
  CurrentPriceChapter2 = 'CURRENT_PRICE_CHAPTER2',
  CurrentPriceChapter3 = 'CURRENT_PRICE_CHAPTER3',
  CurrentPriceChapter4 = 'CURRENT_PRICE_CHAPTER4',
  CurrentPriceChapter5 = 'CURRENT_PRICE_CHAPTER5',
  CurrentPriceChapter6 = 'CURRENT_PRICE_CHAPTER6',
  CurrentPriceChapter7 = 'CURRENT_PRICE_CHAPTER7',
  CurrentPriceChapter8 = 'CURRENT_PRICE_CHAPTER8',
  CurrentPriceChapter9 = 'CURRENT_PRICE_CHAPTER9',
  CurrentPriceChapter12 = 'CURRENT_PRICE_CHAPTER12',
  CustomerLimits = 'CUSTOMER_LIMITS',
  LimitedCostsChapter9 = 'LIMITED_COSTS_CHAPTER9',
  LimitedCostChapter8 = 'LIMITED_COST_CHAPTER8',
  /** Затраты на дополнительную транспортировку материалов. Лимитированная затрата (глава 8) */
  LimitPriceMaterialsTransportationExtraCost = 'LIMIT_PRICE_MATERIALS_TRANSPORTATION_EXTRA_COST',
  /** Обеспечение нормальных условий труда. Лимитированная затрата (глава 9) */
  LimitPriceProvidingWorkCondition = 'LIMIT_PRICE_PROVIDING_WORK_CONDITION',
  /** Надбавка к заработной плате за стаж работы в районе Крайнего Севера. Лимитированная затрата (глава 9) */
  LimitPriceSalarySupplementWorkingFarNorth = 'LIMIT_PRICE_SALARY_SUPPLEMENT_WORKING_FAR_NORTH',
  /** Надбавка к заработной плате за стаж работы в районах, приравненных к Крайнему Северу. Лимитированная затрата (глава 9) */
  LimitPriceSalarySupplementWorkingFarNorthEquatedAreas = 'LIMIT_PRICE_SALARY_SUPPLEMENT_WORKING_FAR_NORTH_EQUATED_AREAS',
  /** Затраты на организацию работ вахтовым методом. Лимитированная затрата (глава 9) */
  LimitPriceShiftMethodOrganizationCost = 'LIMIT_PRICE_SHIFT_METHOD_ORGANIZATION_COST',
  /** Снегоборьба. Лимитированная затрата (глава 9) */
  LimitPriceSnowfighting = 'LIMIT_PRICE_SNOWFIGHTING',
  /** Временные здания и сооружения. Лимитированная затрата (глава 8) */
  LimitPriceTemporaryConstruction = 'LIMIT_PRICE_TEMPORARY_CONSTRUCTION',
  /** Зимнее удорожание. Лимитированная затрата (глава 9) */
  LimitPriceWinterPriceRising = 'LIMIT_PRICE_WINTER_PRICE_RISING',
  OtherCosts = 'OTHER_COSTS',
  SeasonCosts = 'SEASON_COSTS',
  SeasonCostsGroup = 'SEASON_COSTS_GROUP',
  SeasonInflation = 'SEASON_INFLATION',
  SeasonInflationGroup = 'SEASON_INFLATION_GROUP',
  SeasonWithUnforeseenCosts = 'SEASON_WITH_UNFORESEEN_COSTS',
  SeasonWithUnforeseenCostsGroup = 'SEASON_WITH_UNFORESEEN_COSTS_GROUP',
  Tax = 'TAX',
  Total = 'TOTAL',
  /** Итого по главам 1-7 в текущем уровне цен (Всего СМР) */
  TotalChapter1_7 = 'TOTAL_CHAPTER1_7',
  TotalChapter1_7Mp = 'TOTAL_CHAPTER1_7_MP',
  TotalChapter1_7Mz = 'TOTAL_CHAPTER1_7_MZ',
  /** Оборудование Подрядчика */
  TotalChapter1_7Op = 'TOTAL_CHAPTER1_7_OP',
  TotalChapter1_7Oz = 'TOTAL_CHAPTER1_7_OZ',
  /** Итого по Главам 1-8 */
  TotalChapter1_8 = 'TOTAL_CHAPTER1_8',
  TotalChapter1_9 = 'TOTAL_CHAPTER1_9',
  TotalChapter1_12 = 'TOTAL_CHAPTER1_12',
  TotalChapter1_12WithInflatioin = 'TOTAL_CHAPTER1_12_WITH_INFLATIOIN',
  TotalChapter8 = 'TOTAL_CHAPTER8',
  TotalChapter8WithLimitedCost = 'TOTAL_CHAPTER8_WITH_LIMITED_COST',
  TotalChapter9 = 'TOTAL_CHAPTER9',
  TotalChapter9WithOtherCost = 'TOTAL_CHAPTER9_WITH_OTHER_COST',
  TotalChapter12 = 'TOTAL_CHAPTER12',
  TotalWithTax = 'TOTAL_WITH_TAX',
  TotalWithUnforeseenCosts = 'TOTAL_WITH_UNFORESEEN_COSTS'
}

/** A segment of a collection. */
export type BimWorkOrderActsKc2CollectionSegment = {
  __typename?: 'BimWorkOrderActsKC2CollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2ListItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderActsKc2SelectionListCollectionSegment = {
  __typename?: 'BimWorkOrderActsKC2SelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimActKc2SelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные главы Изма к НЗ */
export type BimWorkOrderChangeChapterData = {
  __typename?: 'BimWorkOrderChangeChapterData';
  /** Глава */
  chapter: BimChapterEnum;
  /** Количество загруженных смет */
  pricesCount: Scalars['Int'];
};

/** Данные главы Изма к НЗ */
export type BimWorkOrderChangeChapterDataInput = {
  /** Глава */
  chapter: BimChapterEnum;
  /** Количество загруженных смет */
  pricesCount: Scalars['Int'];
};

/** Лимит прочей с данными распределения */
export type BimWorkOrderChangeCostLimitDistributionData = {
  __typename?: 'BimWorkOrderChangeCostLimitDistributionData';
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Стоимость, включенная в Изм */
  includedCost?: Maybe<Scalars['Decimal']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Остаток по договору */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Лимит прочей с данными распределения */
export type BimWorkOrderChangeCostLimitDistributionDataInput = {
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Стоимость, включенная в Изм */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Остаток по договору */
  totalRemainderCost?: InputMaybe<Scalars['Decimal']>;
};

/** Изм наряд-заказа */
export type BimWorkOrderChangeCreateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']>;
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
};

/** Изм наряд-заказа */
export type BimWorkOrderChangeData = {
  __typename?: 'BimWorkOrderChangeData';
  /** Автор */
  authoredBy: Scalars['String'];
  /** Комментарий */
  comment?: Maybe<Scalars['String']>;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Перераспределение итогов по сезонам */
  seasonDistributions: Array<BimWorkOrderChangeSeasonDistributionData>;
  /** Сезоны */
  seasons: Array<BimWorkOrderChangeSeasonData>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Последователи статуса */
  statusFollowers: Array<WorkOrderChangeStatusEnum>;
  /** Предмет */
  subject?: Maybe<Scalars['String']>;
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Кем изменено */
  updatedBy?: Maybe<Scalars['String']>;
  /** Id НЗ изма */
  workOrderId: Scalars['Long'];
};

/** Изм наряд-заказа */
export type BimWorkOrderChangeDataInput = {
  /** Автор */
  authoredBy: Scalars['String'];
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']>;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Перераспределение итогов по сезонам */
  seasonDistributions: Array<BimWorkOrderChangeSeasonDistributionDataInput>;
  /** Сезоны */
  seasons: Array<BimWorkOrderChangeSeasonDataInput>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Последователи статуса */
  statusFollowers: Array<WorkOrderChangeStatusEnum>;
  /** Предмет */
  subject?: InputMaybe<Scalars['String']>;
  /** Дата изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Кем изменено */
  updatedBy?: InputMaybe<Scalars['String']>;
  /** Id НЗ изма */
  workOrderId: Scalars['Long'];
};

/** Данные по умолчанию изма наряд-заказа */
export type BimWorkOrderChangeDefaultData = {
  __typename?: 'BimWorkOrderChangeDefaultData';
  /** Автор */
  authoredBy: Scalars['String'];
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Перераспределение итогов по сезонам */
  seasonDistributions: Array<BimWorkOrderChangeSeasonDistributionDefaultData>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Предмет */
  subject?: Maybe<Scalars['String']>;
};

/** Данные по умолчанию изма наряд-заказа */
export type BimWorkOrderChangeDefaultDataInput = {
  /** Автор */
  authoredBy: Scalars['String'];
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Перераспределение итогов по сезонам */
  seasonDistributions: Array<BimWorkOrderChangeSeasonDistributionDefaultDataInput>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Предмет */
  subject?: InputMaybe<Scalars['String']>;
};

/** Изм НЗ - данные для списка */
export type BimWorkOrderChangeItem = {
  __typename?: 'BimWorkOrderChangeItem';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
};

/** Изм НЗ - данные для списка */
export type BimWorkOrderChangeItemFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeItemFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeItemFilterInput>>;
  /** Дата подписания */
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Изм НЗ - данные для списка */
export type BimWorkOrderChangeItemInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
};

/** Изм НЗ - данные для списка */
export type BimWorkOrderChangeItemSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<SortEnumType>;
  /** Дата подписания */
  signingDate?: InputMaybe<SortEnumType>;
};

export type BimWorkOrderChangeNavData = {
  __typename?: 'BimWorkOrderChangeNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания изма */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус изма */
  status: WorkOrderChangeStatusEnum;
  /** Внутренний номер изма */
  workOrderChangeNumber: Scalars['String'];
  /** Внутренний номер НЗ */
  workOrderNumber: Scalars['String'];
};

/** Объект Изма НЗ */
export type BimWorkOrderChangeObjectData = {
  __typename?: 'BimWorkOrderChangeObjectData';
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Позиция добавлена в НЗ */
  fromWorkOrder: Scalars['Boolean'];
  /** Позиция добавлена в Изме НЗ */
  fromWorkOrderChange: Scalars['Boolean'];
  /** Признак наличия у объекта дочерних элементов */
  hasChildren?: Maybe<Scalars['Boolean']>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Позиция добавлена в Акте КС-2 */
  isActKC2Object: Scalars['Boolean'];
  /** Позиция добавлена в изме НЗ */
  isAddedObject?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedObject?: Maybe<Scalars['Boolean']>;
  /** Признак требования удаления позиции */
  isRemovedObject?: Maybe<Scalars['Boolean']>;
  /** Флаг Корневой объект */
  isRootObject: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionData>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Объект Изма НЗ */
export type BimWorkOrderChangeObjectDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeObjectDataFilterInput>>;
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Позиция добавлена в НЗ */
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в Изме НЗ */
  fromWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия у объекта дочерних элементов */
  hasChildren?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Позиция добавлена в Акте КС-2 */
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления позиции */
  isRemovedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Корневой объект */
  isRootObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам итогов */
  objectSeasonDistributions?: InputMaybe<ListFilterInputTypeOfBimContractObjectSeasonDistributionDataFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeObjectDataFilterInput>>;
  /** Порядковое значение */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<BimContractObjectStatusEnumOperationFilterInput>;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Объект Изма НЗ */
export type BimWorkOrderChangeObjectDataInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Позиция добавлена в НЗ */
  fromWorkOrder: Scalars['Boolean'];
  /** Позиция добавлена в Изме НЗ */
  fromWorkOrderChange: Scalars['Boolean'];
  /** Признак наличия у объекта дочерних элементов */
  hasChildren?: InputMaybe<Scalars['Boolean']>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Позиция добавлена в Акте КС-2 */
  isActKC2Object: Scalars['Boolean'];
  /** Позиция добавлена в изме НЗ */
  isAddedObject?: InputMaybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedObject?: InputMaybe<Scalars['Boolean']>;
  /** Признак требования удаления позиции */
  isRemovedObject?: InputMaybe<Scalars['Boolean']>;
  /** Флаг Корневой объект */
  isRootObject: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionDataInput>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Объект Изма с данными распределения прочей затраты */
export type BimWorkOrderChangeObjectDistributionData = {
  __typename?: 'BimWorkOrderChangeObjectDistributionData';
  /** Идентификатор объекта договора */
  contractObjectId: Scalars['Long'];
  /** Стоимость позиции прочей по объекту строительства */
  cost?: Maybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Включено в наряд-заказ */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта наряд-заказа */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Объект Изма с данными распределения прочей затраты */
export type BimWorkOrderChangeObjectDistributionDataInput = {
  /** Идентификатор объекта договора */
  contractObjectId: Scalars['Long'];
  /** Стоимость позиции прочей по объекту строительства */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Включено в наряд-заказ */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта наряд-заказа */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Входные данные по объектам Изма для изменния распределения прочей затраты */
export type BimWorkOrderChangeObjectDistributionInput = {
  /** Стоимость */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта наряд-заказа */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Идентификаторы объекта Изма */
export type BimWorkOrderChangeObjectIdsInput = {
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** &gt;Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Объекта Изма НЗ - модель для списка */
export type BimWorkOrderChangeObjectItem = {
  __typename?: 'BimWorkOrderChangeObjectItem';
  /** Идентификатор объекта Договора */
  contractObjectId: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Объекта Изма НЗ - модель для списка */
export type BimWorkOrderChangeObjectItemFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeObjectItemFilterInput>>;
  /** Идентификатор объекта Договора */
  contractObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeObjectItemFilterInput>>;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Объекта Изма НЗ - модель для списка */
export type BimWorkOrderChangeObjectItemSortInput = {
  /** Идентификатор объекта Договора */
  contractObjectId?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** Строка итога прочиз затрат по объекту */
export type BimWorkOrderChangeObjectOtherTotalData = {
  __typename?: 'BimWorkOrderChangeObjectOtherTotalData';
  /** Выполнено */
  completed?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (выполнено) */
  planValue: BimWorkOrderOtherPriceValue;
  /** Oстаток */
  remainder?: Maybe<Scalars['Decimal']>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
};

/** Строка итога прочиз затрат по объекту */
export type BimWorkOrderChangeObjectOtherTotalDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeObjectOtherTotalDataFilterInput>>;
  /** Выполнено */
  completed?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeObjectOtherTotalDataFilterInput>>;
  /** Данные (выполнено) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueFilterInput>;
  /** Oстаток */
  remainder?: InputMaybe<DecimalOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
};

/** Строка итога прочиз затрат по объекту */
export type BimWorkOrderChangeObjectOtherTotalDataSortInput = {
  /** Выполнено */
  completed?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueSortInput>;
  /** Oстаток */
  remainder?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangeObjectOtherTotalsCollectionSegment = {
  __typename?: 'BimWorkOrderChangeObjectOtherTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeObjectOtherTotalData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Строка итога СМР по объекту */
export type BimWorkOrderChangeObjectSmrTotalData = {
  __typename?: 'BimWorkOrderChangeObjectSMRTotalData';
  /** Выполнено */
  completed?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (выполнено) */
  planValue: BimWorkOrderPriceValue;
  /** Oстаток */
  remainder?: Maybe<Scalars['Decimal']>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
};

/** Строка итога СМР по объекту */
export type BimWorkOrderChangeObjectSmrTotalDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeObjectSmrTotalDataFilterInput>>;
  /** Выполнено */
  completed?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeObjectSmrTotalDataFilterInput>>;
  /** Данные (выполнено) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Oстаток */
  remainder?: InputMaybe<DecimalOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
};

/** Строка итога СМР по объекту */
export type BimWorkOrderChangeObjectSmrTotalDataSortInput = {
  /** Выполнено */
  completed?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Oстаток */
  remainder?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangeObjectSmrTotalsCollectionSegment = {
  __typename?: 'BimWorkOrderChangeObjectSMRTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeObjectSmrTotalData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Объект выбора Изма НЗ */
export type BimWorkOrderChangeObjectSelectionData = {
  __typename?: 'BimWorkOrderChangeObjectSelectionData';
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Позиция добавлена в НЗ */
  fromWorkOrder: Scalars['Boolean'];
  /** Позиция добавлена в Изме НЗ */
  fromWorkOrderChange: Scalars['Boolean'];
  /** Флаг В состав объекта загружены Акты КС-2 */
  hasActsKC2: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Флаг В состав объекта загружены сметы */
  hasPrices: Scalars['Boolean'];
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Позиция добавлена в Акте КС-2 */
  isActKC2Object: Scalars['Boolean'];
  /** Позиция добавлена в изме НЗ */
  isAddedObject?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedObject?: Maybe<Scalars['Boolean']>;
  /** Признак использования объекта */
  isInUse?: Maybe<Scalars['Boolean']>;
  /** Флаг Включен в Изм */
  isIncluded: Scalars['Boolean'];
  /** Признак требования удаления позиции */
  isRemovedObject?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionData>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  /** Идентификатор Изма НЗ */
  workOrderChangeId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор НЗ */
  workOrderId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Объект выбора Изма НЗ */
export type BimWorkOrderChangeObjectSelectionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeObjectSelectionDataFilterInput>>;
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Позиция добавлена в НЗ */
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в Изме НЗ */
  fromWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг В состав объекта загружены Акты КС-2 */
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг В состав объекта загружены сметы */
  hasPrices?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Позиция добавлена в Акте КС-2 */
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак использования объекта */
  isInUse?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Включен в Изм */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления позиции */
  isRemovedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам итогов */
  objectSeasonDistributions?: InputMaybe<ListFilterInputTypeOfBimContractObjectSeasonDistributionDataFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeObjectSelectionDataFilterInput>>;
  /** Порядковое значение */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<BimContractObjectStatusEnumOperationFilterInput>;
  /** Идентификатор Изма НЗ */
  workOrderChangeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Объект выбора Изма НЗ */
export type BimWorkOrderChangeObjectSelectionDataSortInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в НЗ */
  fromWorkOrder?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в Изме НЗ */
  fromWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Флаг В состав объекта загружены Акты КС-2 */
  hasActsKC2?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Флаг В состав объекта загружены сметы */
  hasPrices?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в Акте КС-2 */
  isActKC2Object?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в изме НЗ */
  isAddedObject?: InputMaybe<SortEnumType>;
  /** Признак исключения позиции */
  isExcludedObject?: InputMaybe<SortEnumType>;
  /** Признак использования объекта */
  isInUse?: InputMaybe<SortEnumType>;
  /** Флаг Включен в Изм */
  isIncluded?: InputMaybe<SortEnumType>;
  /** Признак требования удаления позиции */
  isRemovedObject?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Порядковое значение */
  order?: InputMaybe<SortEnumType>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор Изма НЗ */
  workOrderChangeId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Изма НЗ */
  workOrderChangeObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangeObjectSelectionListCollectionSegment = {
  __typename?: 'BimWorkOrderChangeObjectSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeObjectSelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangeObjectsCollectionSegment = {
  __typename?: 'BimWorkOrderChangeObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeObjectData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Прочая затрата Изма с данными распределения */
export type BimWorkOrderChangeOtherDistributionData = {
  __typename?: 'BimWorkOrderChangeOtherDistributionData';
  /** Прочая затрата наряд-заказа договора */
  contractOtherCost: BimContractOtherCostBaseData;
  /** Лимит прочей с данными распределения */
  limit: BimWorkOrderChangeCostLimitDistributionData;
  /** Объекты наряд-заказа, по которым распределена прочая затрата */
  objectDistribution: Array<BimWorkOrderChangeObjectDistributionData>;
};

/** Прочая затрата Изма с данными распределения */
export type BimWorkOrderChangeOtherDistributionDataInput = {
  /** Прочая затрата наряд-заказа договора */
  contractOtherCost: BimContractOtherCostBaseDataInput;
  /** Лимит прочей с данными распределения */
  limit: BimWorkOrderChangeCostLimitDistributionDataInput;
  /** Объекты наряд-заказа, по которым распределена прочая затрата */
  objectDistribution: Array<BimWorkOrderChangeObjectDistributionDataInput>;
};

/** Входные данные для изменния распределения в Изме */
export type BimWorkOrderChangeOtherDistributionInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость, которую необходимо включить в Изм */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Идентификаторы объектов для распределения стоимости прочих затрат */
  objectList: Array<BimWorkOrderChangeObjectDistributionInput>;
};

export type BimWorkOrderChangeOtherInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Список прочих затрат для добавления в Изм */
  otherPrices: Array<BimWorkOrderChangeOtherPriceInput>;
  /** Идентификатор Изма */
  workOrderChangeId: Scalars['Long'];
};

/** A segment of a collection. */
export type BimWorkOrderChangeOtherNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangeOtherNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderChangeOtherPriceCalcInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификаторы объектов для распределения */
  workOrderChangeObjectIds: Array<BimWorkOrderChangeObjectIdsInput>;
};

export type BimWorkOrderChangeOtherPriceCostData = {
  __typename?: 'BimWorkOrderChangeOtherPriceCostData';
  /** Ошибки вычисления значения прочей */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors: Scalars['Boolean'];
  others?: Maybe<Scalars['Decimal']>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

export type BimWorkOrderChangeOtherPriceCostDataInput = {
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors: Scalars['Boolean'];
  others?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Прочая затрата Изма к НЗ */
export type BimWorkOrderChangeOtherPriceData = {
  __typename?: 'BimWorkOrderChangeOtherPriceData';
  /** Способ начисления */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Признак возможности применения операции исключения к позиции */
  canExcludeRow: Scalars['Boolean'];
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Oтклонение Выполнено (Всего) от Остаток (Всего) */
  completedOtherDeviation?: Maybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Флаг наличия согласованной стоимости по актам */
  hasActAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price: Scalars['Boolean'];
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedRow?: Maybe<Scalars['Boolean']>;
  /** Признак требования удаления позиции */
  isRemovedRow?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (план) */
  planValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  rationale?: Maybe<Scalars['String']>;
  /** Данные (остаток) */
  remainderValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status?: Maybe<BimContractOtherStatusEnum>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: Maybe<Scalars['Long']>;
};

/** Прочая затрата Изма к НЗ */
export type BimWorkOrderChangeOtherPriceDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeOtherPriceDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Признак возможности применения операции исключения к позиции */
  canExcludeRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Oтклонение Выполнено (Всего) от Остаток (Всего) */
  completedOtherDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Флаг наличия согласованной стоимости по актам */
  hasActAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeOtherPriceDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfBimContractOtherStatusEnumOperationFilterInput>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<LongOperationFilterInput>;
};

/** Прочая затрата Изма к НЗ */
export type BimWorkOrderChangeOtherPriceDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Признак возможности применения операции исключения к позиции */
  canExcludeRow?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Oтклонение Выполнено (Всего) от Остаток (Всего) */
  completedOtherDeviation?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<SortEnumType>;
  /** Флаг наличия согласованной стоимости по актам */
  hasActAcceptedCost?: InputMaybe<SortEnumType>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<SortEnumType>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<SortEnumType>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  rationale?: InputMaybe<SortEnumType>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: InputMaybe<SortEnumType>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<SortEnumType>;
};

/** Идентификаторы прочих затрат Изма */
export type BimWorkOrderChangeOtherPriceIdsInput = {
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};

export type BimWorkOrderChangeOtherPriceInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификаторы объектов для распределения стоимости прочих затрат */
  objectIdList: Array<BimWorkOrderChangeObjectIdsInput>;
};

/** A segment of a collection. */
export type BimWorkOrderChangeOtherPricesCollectionSegment = {
  __typename?: 'BimWorkOrderChangeOtherPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeOtherPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderChangeOtherSelectionData = {
  __typename?: 'BimWorkOrderChangeOtherSelectionData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонения остатка от лимита по договру */
  deviation: DeviationTipEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Раздел */
  status: BimContractOtherStatusEnum;
  /** Остаток по договору */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

export type BimWorkOrderChangeOtherSelectionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeOtherSelectionDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Лимит по договору */
  costLimit?: InputMaybe<DecimalOperationFilterInput>;
  /** Диапазон отклонения остатка от лимита по договру */
  deviation?: InputMaybe<DeviationTipEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeOtherSelectionDataFilterInput>>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Раздел */
  status?: InputMaybe<BimContractOtherStatusEnumOperationFilterInput>;
  /** Остаток по договору */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

export type BimWorkOrderChangeOtherSelectionDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataSortInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<SortEnumType>;
  /** Лимит по договору */
  costLimit?: InputMaybe<SortEnumType>;
  /** Диапазон отклонения остатка от лимита по договру */
  deviation?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Раздел */
  status?: InputMaybe<SortEnumType>;
  /** Остаток по договору */
  totalRemainderCost?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangeOtherSelectionListCollectionSegment = {
  __typename?: 'BimWorkOrderChangeOtherSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeOtherSelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePreviousVersionsAsyncCollectionSegment = {
  __typename?: 'BimWorkOrderChangePreviousVersionsAsyncCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionListItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderChangePriceData = {
  __typename?: 'BimWorkOrderChangePriceData';
  /** Доступен для удаления */
  canRemoved: Scalars['Boolean'];
  /** Глава */
  chapter: BimChapterEnum;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedTotalDeviation?: Maybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue: BimWorkOrderPriceValue;
  /** Наличие Актов КС-2 по смете */
  hasActKC2: Scalars['Boolean'];
  /** Наличие ревизий сметы */
  hasRevisions: Scalars['Boolean'];
  /** Наличие обновлений по смете */
  hasUpdates: Scalars['Boolean'];
  /** Добавлена для Акта КС-2 */
  isActKC2Price: Scalars['Boolean'];
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedRow?: Maybe<Scalars['Boolean']>;
  /** Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Признак требования удаления позиции */
  isRemovedRow?: Maybe<Scalars['Boolean']>;
  /** Ревизия сметы */
  isRevisionPrice?: Maybe<Scalars['Boolean']>;
  /** Обновление по смете */
  isUpdatedPrice?: Maybe<Scalars['Boolean']>;
  /** Объект/подобъекта Изма к НЗ */
  object: BimWorkOrderChangeObjectItem;
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  priceRows?: Maybe<Array<BimWorkOrderChangePriceRowData>>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Данные (остаток) */
  remainderValue: BimWorkOrderPriceValue;
  /** Сортировка */
  sortOrder?: Maybe<Scalars['Short']>;
  /** Идентификатор объекта/подобъекта Изма к НЗ */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта/подобъекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: Maybe<Scalars['Long']>;
};

export type BimWorkOrderChangePriceDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangePriceDataFilterInput>>;
  /** Доступен для удаления */
  canRemoved?: InputMaybe<BooleanOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<BimChapterEnumOperationFilterInput>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedTotalDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Наличие Актов КС-2 по смете */
  hasActKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие ревизий сметы */
  hasRevisions?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие обновлений по смете */
  hasUpdates?: InputMaybe<BooleanOperationFilterInput>;
  /** Добавлена для Акта КС-2 */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Лимитированная затрата */
  isLimitPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Объект/подобъекта Изма к НЗ */
  object?: InputMaybe<BimWorkOrderChangeObjectItemFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangePriceDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  priceRows?: InputMaybe<ListFilterInputTypeOfBimWorkOrderChangePriceRowDataFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Идентификатор объекта/подобъекта Изма к НЗ */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта/подобъекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderChangePriceDataSortInput = {
  /** Доступен для удаления */
  canRemoved?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedTotalDeviation?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Наличие Актов КС-2 по смете */
  hasActKC2?: InputMaybe<SortEnumType>;
  /** Наличие ревизий сметы */
  hasRevisions?: InputMaybe<SortEnumType>;
  /** Наличие обновлений по смете */
  hasUpdates?: InputMaybe<SortEnumType>;
  /** Добавлена для Акта КС-2 */
  isActKC2Price?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<SortEnumType>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<SortEnumType>;
  /** Лимитированная затрата */
  isLimitPrice?: InputMaybe<SortEnumType>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<SortEnumType>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<SortEnumType>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  /** Объект/подобъекта Изма к НЗ */
  object?: InputMaybe<BimWorkOrderChangeObjectItemSortInput>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта/подобъекта Изма к НЗ */
  workOrderChangeObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта/подобъекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: InputMaybe<SortEnumType>;
};

/** Идентификаторы сметы ЛСР Изма */
export type BimWorkOrderChangePriceIdsInput = {
  /** Идентификаторы сметы Изма */
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  /** Идентификаторы сметы НЗ */
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceObjectNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRationaleFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRationaleFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные для обновления обоснования сметы Изма к НЗ */
export type BimWorkOrderChangePriceRationaleUpdateInput = {
  /** Обоснование сметы Изма к НЗ */
  rationale?: InputMaybe<Scalars['String']>;
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRevisionCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRevisionCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderChangePriceRevisionData = {
  __typename?: 'BimWorkOrderChangePriceRevisionData';
  /** Выполнено */
  completedValue: BimWorkOrderPriceValue;
  /** Ревизия сметы */
  isRevisionPrice?: Maybe<Scalars['Boolean']>;
  /** Обновление по смете */
  isUpdatedPrice?: Maybe<Scalars['Boolean']>;
  /** Сортировка */
  order?: Maybe<Scalars['Int']>;
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  /** Дата обновления по смете */
  priceUpdateDate?: Maybe<Scalars['DateTime']>;
  /** Остаток */
  remainderValue: BimWorkOrderPriceValue;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: Maybe<Scalars['Long']>;
};

export type BimWorkOrderChangePriceRevisionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangePriceRevisionDataFilterInput>>;
  /** Выполнено */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangePriceRevisionDataFilterInput>>;
  /** Сортировка */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Дата обновления по смете */
  priceUpdateDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Остаток */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderChangePriceRevisionDataSortInput = {
  /** Выполнено */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<SortEnumType>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  /** Сортировка */
  order?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Дата обновления по смете */
  priceUpdateDate?: InputMaybe<SortEnumType>;
  /** Остаток */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: InputMaybe<SortEnumType>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRevisionNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRevisionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRevisionsCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRevisionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangePriceRevisionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRowCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRowCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderChangePriceRowData = {
  __typename?: 'BimWorkOrderChangePriceRowData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование секции сметы */
  sectionName?: Maybe<Scalars['String']>;
  /** Тип строки сметы */
  type: BimWorkOrderPriceRowTypeEnum;
  /** Данные */
  value: BimWorkOrderPriceValue;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор секции сметы Изма к НЗ */
  workOrderChangeSectionId?: Maybe<Scalars['Long']>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор секции сметы НЗ */
  workOrderSectionId?: Maybe<Scalars['Long']>;
};

export type BimWorkOrderChangePriceRowDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangePriceRowDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangePriceRowDataFilterInput>>;
  /** Наименование секции сметы */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Тип строки сметы */
  type?: InputMaybe<BimWorkOrderPriceRowTypeEnumOperationFilterInput>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор секции сметы Изма к НЗ */
  workOrderChangeSectionId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор секции сметы НЗ */
  workOrderSectionId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderChangePriceRowDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование секции сметы */
  sectionName?: InputMaybe<SortEnumType>;
  /** Тип строки сметы */
  type?: InputMaybe<SortEnumType>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор сметы Изма к НЗ */
  workOrderChangePriceId?: InputMaybe<SortEnumType>;
  /** Идентификатор секции сметы Изма к НЗ */
  workOrderChangeSectionId?: InputMaybe<SortEnumType>;
  /** Идентификатор сметы НЗ */
  workOrderPriceId?: InputMaybe<SortEnumType>;
  /** Идентификатор секции сметы НЗ */
  workOrderSectionId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRowNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRowNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePriceRowsCollectionSegment = {
  __typename?: 'BimWorkOrderChangePriceRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangePriceRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Cостояние позиций Изма */
export type BimWorkOrderChangePriceStatesData = {
  __typename?: 'BimWorkOrderChangePriceStatesData';
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на прочие затраты */
  hasExcessCompletedOthers: Scalars['Boolean'];
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на СМР */
  hasExcessCompletedTotalSMR: Scalars['Boolean'];
};

/** Cостояние позиций Изма */
export type BimWorkOrderChangePriceStatesDataInput = {
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на прочие затраты */
  hasExcessCompletedOthers: Scalars['Boolean'];
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на СМР */
  hasExcessCompletedTotalSMR: Scalars['Boolean'];
};

/** A segment of a collection. */
export type BimWorkOrderChangePricesCollectionSegment = {
  __typename?: 'BimWorkOrderChangePricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangePriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Сезон изма наряд-заказа */
export type BimWorkOrderChangeSeasonData = {
  __typename?: 'BimWorkOrderChangeSeasonData';
  /** Сезон договора */
  contractSeason: BimContractSeasonData;
  /** Идентификатор */
  id?: Maybe<Scalars['Long']>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedRow?: Maybe<Scalars['Boolean']>;
  /** Признак требования удаления позиции */
  isRemovedRow?: Maybe<Scalars['Boolean']>;
  /** Сезон наряд-заказа */
  workOrderSeason?: Maybe<BimWorkOrderSeasonData>;
};

/** Сезон изма наряд-заказа */
export type BimWorkOrderChangeSeasonDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeSeasonDataFilterInput>>;
  /** Сезон договора */
  contractSeason?: InputMaybe<BimContractSeasonDataFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeSeasonDataFilterInput>>;
  /** Сезон наряд-заказа */
  workOrderSeason?: InputMaybe<BimWorkOrderSeasonDataFilterInput>;
};

/** Сезон изма наряд-заказа */
export type BimWorkOrderChangeSeasonDataInput = {
  /** Сезон договора */
  contractSeason: BimContractSeasonDataInput;
  /** Идентификатор */
  id?: InputMaybe<Scalars['Long']>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<Scalars['Boolean']>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<Scalars['Boolean']>;
  /** Сезон наряд-заказа */
  workOrderSeason?: InputMaybe<BimWorkOrderSeasonDataInput>;
};

/** Сезон изма наряд-заказа */
export type BimWorkOrderChangeSeasonDataSortInput = {
  /** Сезон договора */
  contractSeason?: InputMaybe<BimContractSeasonDataSortInput>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в изме НЗ */
  isAddedRow?: InputMaybe<SortEnumType>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<SortEnumType>;
  /** Признак требования удаления позиции */
  isRemovedRow?: InputMaybe<SortEnumType>;
  /** Сезон наряд-заказа */
  workOrderSeason?: InputMaybe<BimWorkOrderSeasonDataSortInput>;
};

/** Распределение итогов по сезонам */
export type BimWorkOrderChangeSeasonDistributionData = {
  __typename?: 'BimWorkOrderChangeSeasonDistributionData';
  /** Значение по сезону */
  seasonValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона изма наряд-заказа */
  workOrderChangeSeasonId: Scalars['Long'];
};

/** Распределение итогов по сезонам */
export type BimWorkOrderChangeSeasonDistributionDataInput = {
  /** Значение по сезону */
  seasonValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона изма наряд-заказа */
  workOrderChangeSeasonId: Scalars['Long'];
};

/** Перераспределение итогов по сезонам */
export type BimWorkOrderChangeSeasonDistributionDefaultData = {
  __typename?: 'BimWorkOrderChangeSeasonDistributionDefaultData';
  /** Значение по сезону */
  seasonValue?: Maybe<Scalars['Decimal']>;
  /** Год сезона */
  year: Scalars['Short'];
};

/** Перераспределение итогов по сезонам */
export type BimWorkOrderChangeSeasonDistributionDefaultDataInput = {
  /** Значение по сезону */
  seasonValue?: InputMaybe<Scalars['Decimal']>;
  /** Год сезона */
  year: Scalars['Short'];
};

/** A segment of a collection. */
export type BimWorkOrderChangeSeasonSelectionListCollectionSegment = {
  __typename?: 'BimWorkOrderChangeSeasonSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeSeasonData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Интервал сезонов Изма НЗ */
export type BimWorkOrderChangeSeasonsData = {
  __typename?: 'BimWorkOrderChangeSeasonsData';
  /** Первый сезон */
  firstSeason: BimWorkOrderChangeSeasonData;
  /** Последний сезон */
  lastSeason: BimWorkOrderChangeSeasonData;
};

/** Интервал сезонов Изма НЗ */
export type BimWorkOrderChangeSeasonsDataInput = {
  /** Первый сезон */
  firstSeason: BimWorkOrderChangeSeasonDataInput;
  /** Последний сезон */
  lastSeason: BimWorkOrderChangeSeasonDataInput;
};

export type BimWorkOrderChangeTotalData = {
  __typename?: 'BimWorkOrderChangeTotalData';
  /** Идентификаторы обновленных элементов Изма */
  itemIds?: Maybe<Array<Scalars['Long']>>;
  /** Идентификатор Изма */
  workOrderChangeId: Scalars['Long'];
};

export type BimWorkOrderChangeTotalDataInput = {
  /** Идентификаторы обновленных элементов Изма */
  itemIds?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификатор Изма */
  workOrderChangeId: Scalars['Long'];
};

/** Строка Итога Изма */
export type BimWorkOrderChangeTotalItemData = {
  __typename?: 'BimWorkOrderChangeTotalItemData';
  /** Данные (выполнено) */
  completedValue: BimWorkOrderPriceValue;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (выполнено) */
  planValue: BimWorkOrderPriceValue;
  /** Количество */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Данные (остаток) */
  remainderValue: BimWorkOrderPriceValue;
  /** Сортировка */
  sortOrder: Scalars['Short'];
};

/** Строка Итога Изма */
export type BimWorkOrderChangeTotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderChangeTotalItemDataFilterInput>>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderChangeTotalItemDataFilterInput>>;
  /** Данные (выполнено) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Количество */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
};

/** Строка Итога Изма */
export type BimWorkOrderChangeTotalItemDataSortInput = {
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Количество */
  quantity?: InputMaybe<SortEnumType>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderChangeTotalsCollectionSegment = {
  __typename?: 'BimWorkOrderChangeTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderChangeTotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Изм наряд-заказа */
export type BimWorkOrderChangeUpdateInput = {
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
};

/** Данные главы */
export type BimWorkOrderChapterData = {
  __typename?: 'BimWorkOrderChapterData';
  /** Глава */
  chapter: BimChapterEnum;
  /** Количество загруженных смет */
  pricesCount: Scalars['Int'];
};

/** Данные главы */
export type BimWorkOrderChapterDataInput = {
  /** Глава */
  chapter: BimChapterEnum;
  /** Количество загруженных смет */
  pricesCount: Scalars['Int'];
};

export type BimWorkOrderConstructionTypeResultData = {
  __typename?: 'BimWorkOrderConstructionTypeResultData';
  /** Выполнено по вид строительства (статус Акта: "Согласован") */
  completedPrice?: Maybe<Scalars['Decimal']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по виду строительства */
  planPrice?: Maybe<Scalars['Decimal']>;
};

export type BimWorkOrderConstructionTypeResultDataInput = {
  /** Выполнено по вид строительства (статус Акта: "Согласован") */
  completedPrice?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по виду строительства */
  planPrice?: InputMaybe<Scalars['Decimal']>;
};

/** Лимит прочей с данными распределения */
export type BimWorkOrderCostLimitDistributionData = {
  __typename?: 'BimWorkOrderCostLimitDistributionData';
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Стоимость, включенная в наряд-заказ */
  includedCost?: Maybe<Scalars['Decimal']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Остаток по договору */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Лимит прочей с данными распределения */
export type BimWorkOrderCostLimitDistributionDataInput = {
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Стоимость, включенная в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Остаток по договору */
  totalRemainderCost?: InputMaybe<Scalars['Decimal']>;
};

export type BimWorkOrderData = {
  __typename?: 'BimWorkOrderData';
  /** Сумма с НДС */
  amountWithTax?: Maybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: Maybe<Scalars['Decimal']>;
  authoredBy?: Maybe<Scalars['String']>;
  /** Подрядчик */
  contractor: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Дата окончания */
  finishDate?: Maybe<Scalars['DateTime']>;
  formationStage?: Maybe<BimWorkOrderFormationStageEnum>;
  /** НЗ содержит акты */
  hasActsKC2?: Maybe<Scalars['Boolean']>;
  /** НЗ содержит акты прочих */
  hasOtherActsKC2?: Maybe<Scalars['Boolean']>;
  /** НЗ содержит акты СМР */
  hasSMRActsKC2?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: Maybe<Scalars['Boolean']>;
  /** Остаток */
  remainder?: Maybe<Scalars['Decimal']>;
  /** Процент распределения по сезонам */
  seasonDistributions?: Maybe<Array<BimWorkOrderSeasonDistributionData>>;
  /** Сезоны НЗ */
  seasons?: Maybe<Array<BimWorkOrderSeasonData>>;
  /** Дата выпуска */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Дата начала */
  startDate?: Maybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
  statusFollowers: Array<WorkOrderStatusEnum>;
  /** Предмет */
  subject?: Maybe<Scalars['String']>;
  /** НДС */
  tax?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  /** Изм НЗ */
  workOrderChange?: Maybe<BimWorkOrderChangeItem>;
};

export type BimWorkOrderDataInput = {
  /** Сумма с НДС */
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  authoredBy?: InputMaybe<Scalars['String']>;
  /** Подрядчик */
  contractor: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  formationStage?: InputMaybe<BimWorkOrderFormationStageEnum>;
  /** НЗ содержит акты */
  hasActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** НЗ содержит акты прочих */
  hasOtherActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** НЗ содержит акты СМР */
  hasSMRActsKC2?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: InputMaybe<Scalars['Boolean']>;
  /** Остаток */
  remainder?: InputMaybe<Scalars['Decimal']>;
  /** Процент распределения по сезонам */
  seasonDistributions?: InputMaybe<Array<BimWorkOrderSeasonDistributionDataInput>>;
  /** Сезоны НЗ */
  seasons?: InputMaybe<Array<BimWorkOrderSeasonDataInput>>;
  /** Дата выпуска */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
  statusFollowers: Array<WorkOrderStatusEnum>;
  /** Предмет */
  subject?: InputMaybe<Scalars['String']>;
  /** НДС */
  tax?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  /** Изм НЗ */
  workOrderChange?: InputMaybe<BimWorkOrderChangeItemInput>;
};

/** Этап формирования наряд-заказа */
export enum BimWorkOrderFormationStageEnum {
  /** Формирование структуры объектов */
  ObjectsFormation = 'OBJECTS_FORMATION',
  /** Формирование затрат */
  PricesFormation = 'PRICES_FORMATION'
}

/** Данные навигации НЗ */
export type BimWorkOrderNavData = {
  __typename?: 'BimWorkOrderNavData';
  /** Список актов НЗ */
  actKC2Navs?: Maybe<Array<ActKc2NavData>>;
  /** Список справок НЗ */
  actKC3Navs?: Maybe<Array<ActKc3NavData>>;
  /** Узел навигации реестра актов КС-2 */
  actsKC2Node?: Maybe<Uer_ContractItemNavData>;
  /** Узел навигации реестра справок КС-3 */
  actsKC3Node?: Maybe<Uer_ContractItemNavData>;
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Внутренний номкр НЗ */
  internalNumber: Scalars['String'];
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания НЗ */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Ствтус НЗ */
  status: WorkOrderStatusEnum;
  /** Изм примененый к НЗ */
  workOrderChange?: Maybe<BimWorkOrderChangeNavData>;
  /** Список навигации измов НЗ */
  workOrderChanges?: Maybe<Array<BimWorkOrderChangeNavData>>;
};

export type BimWorkOrderObjectData = {
  __typename?: 'BimWorkOrderObjectData';
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  fromWorkOrder: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  isActKC2Object: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionData>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};

export type BimWorkOrderObjectDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderObjectDataFilterInput>>;
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам итогов */
  objectSeasonDistributions?: InputMaybe<ListFilterInputTypeOfBimContractObjectSeasonDistributionDataFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderObjectDataFilterInput>>;
  /** Порядковое значение */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<BimContractObjectStatusEnumOperationFilterInput>;
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderObjectDataInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  fromWorkOrder: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  isActKC2Object: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionDataInput>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};

export type BimWorkOrderObjectDataSortInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  fromWorkOrder?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  isActKC2Object?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Порядковое значение */
  order?: InputMaybe<SortEnumType>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** Объект наряд-заказа с данными распределения прочей затраты */
export type BimWorkOrderObjectDistributionData = {
  __typename?: 'BimWorkOrderObjectDistributionData';
  /** Стоимость позиции прочей по объекту строительства */
  cost?: Maybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Включено в наряд-заказ */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор объекта наряд-заказа */
  workOrderObjectId: Scalars['Long'];
};

/** Объект наряд-заказа с данными распределения прочей затраты */
export type BimWorkOrderObjectDistributionDataInput = {
  /** Стоимость позиции прочей по объекту строительства */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Включено в наряд-заказ */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор объекта наряд-заказа */
  workOrderObjectId: Scalars['Long'];
};

export type BimWorkOrderObjectItem = {
  __typename?: 'BimWorkOrderObjectItem';
  contractObjectId: Scalars['Long'];
  id: Scalars['Long'];
  name: Scalars['String'];
};

export type BimWorkOrderObjectItemFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderObjectItemFilterInput>>;
  contractObjectId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderObjectItemFilterInput>>;
};

export type BimWorkOrderObjectItemSortInput = {
  contractObjectId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type BimWorkOrderObjectSelectionData = {
  __typename?: 'BimWorkOrderObjectSelectionData';
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume: Scalars['Boolean'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  fromWorkOrder: Scalars['Boolean'];
  hasActsKC2: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  hasPrices: Scalars['Boolean'];
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  isActKC2Object: Scalars['Boolean'];
  isIncluded: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimContractObjectSeasonDistributionData>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  workOrderId?: Maybe<Scalars['Long']>;
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

export type BimWorkOrderObjectSelectionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderObjectSelectionDataFilterInput>>;
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  hasPrices?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам итогов */
  objectSeasonDistributions?: InputMaybe<ListFilterInputTypeOfBimContractObjectSeasonDistributionDataFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderObjectSelectionDataFilterInput>>;
  /** Порядковое значение */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<BimContractObjectStatusEnumOperationFilterInput>;
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderObjectSelectionDataSortInput = {
  /** Cвойство-идикатор возможности установки гаранта/// */
  canSetGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  fromWorkOrder?: InputMaybe<SortEnumType>;
  hasActsKC2?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  hasPrices?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  isActKC2Object?: InputMaybe<SortEnumType>;
  isIncluded?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Порядковое значение */
  order?: InputMaybe<SortEnumType>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderObjectSelectionListCollectionSegment = {
  __typename?: 'BimWorkOrderObjectSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderObjectSelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderObjectsCollectionSegment = {
  __typename?: 'BimWorkOrderObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderObjectData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Прочая затрата для включения в НЗ */
export type BimWorkOrderOtherData = {
  __typename?: 'BimWorkOrderOtherData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонения остатка от лимита по договру */
  deviation: DeviationTipEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Раздел */
  status: BimContractOtherStatusEnum;
  /** Остаток по договору */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Прочая затрата для включения в НЗ */
export type BimWorkOrderOtherDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderOtherDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Лимит по договору */
  costLimit?: InputMaybe<DecimalOperationFilterInput>;
  /** Диапазон отклонения остатка от лимита по договру */
  deviation?: InputMaybe<DeviationTipEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderOtherDataFilterInput>>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Раздел */
  status?: InputMaybe<BimContractOtherStatusEnumOperationFilterInput>;
  /** Остаток по договору */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Прочая затрата для включения в НЗ */
export type BimWorkOrderOtherDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataSortInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<SortEnumType>;
  /** Лимит по договору */
  costLimit?: InputMaybe<SortEnumType>;
  /** Диапазон отклонения остатка от лимита по договру */
  deviation?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Раздел */
  status?: InputMaybe<SortEnumType>;
  /** Остаток по договору */
  totalRemainderCost?: InputMaybe<SortEnumType>;
};

/** Прочая затрата наряд-заказа с данными распределения */
export type BimWorkOrderOtherDistributionData = {
  __typename?: 'BimWorkOrderOtherDistributionData';
  /** Прочая затрата наряд-заказа договора */
  contractOtherCost: BimContractOtherCostBaseData;
  /** Лимит прочей с данными распределения */
  limit: BimWorkOrderCostLimitDistributionData;
  /** Объекты наряд-заказа, по которым распределена прочая затрата */
  objectDistribution: Array<BimWorkOrderObjectDistributionData>;
};

/** Прочая затрата наряд-заказа с данными распределения */
export type BimWorkOrderOtherDistributionDataInput = {
  /** Прочая затрата наряд-заказа договора */
  contractOtherCost: BimContractOtherCostBaseDataInput;
  /** Лимит прочей с данными распределения */
  limit: BimWorkOrderCostLimitDistributionDataInput;
  /** Объекты наряд-заказа, по которым распределена прочая затрата */
  objectDistribution: Array<BimWorkOrderObjectDistributionDataInput>;
};

/** Прочая затрата наряд-заказа - данные для добавления (ручного распределения) */
export type BimWorkOrderOtherDistributionInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Идентификаторы объектов для распределения стоимости прочих затрат */
  objectList: Array<BimConstructionObjectInput>;
};

/** A segment of a collection. */
export type BimWorkOrderOtherForActCollectionSegment = {
  __typename?: 'BimWorkOrderOtherForActCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderOtherData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Прочие затраты наряд-заказа - данные для добавления */
export type BimWorkOrderOtherInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Список прочих затрат для добавления в наряд-заказе */
  otherPrices: Array<BimWorkOrderOtherPriceInput>;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
};

/** Прочая затрата наряд-заказа - данные для расчета */
export type BimWorkOrderOtherPriceCalcInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификаторы объектов для распределения */
  workOrderObjectIds: Array<Scalars['Long']>;
};

/** Стоимость объекта строительства */
export type BimWorkOrderOtherPriceCostData = {
  __typename?: 'BimWorkOrderOtherPriceCostData';
  /** Ошибки вычисления значения прочей */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors: Scalars['Boolean'];
  others?: Maybe<Scalars['Decimal']>;
  /** Id объекта строительства */
  workOrderObjectId: Scalars['Long'];
};

/** Стоимость объекта строительства */
export type BimWorkOrderOtherPriceCostDataInput = {
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors: Scalars['Boolean'];
  others?: InputMaybe<Scalars['Decimal']>;
  /** Id объекта строительства */
  workOrderObjectId: Scalars['Long'];
};

/** Прочая затрата НЗ */
export type BimWorkOrderOtherPriceData = {
  __typename?: 'BimWorkOrderOtherPriceData';
  /** Список стоимости прочих затрат по актам */
  actKC2OtherCosts: Array<BimActKc2OtherCostData>;
  /** Способ начисления */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: Maybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  hasActualCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedRow?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (план) */
  planValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Данные (остаток) */
  remainderValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status?: Maybe<BimContractOtherStatusEnum>;
};

/** Прочая затрата НЗ */
export type BimWorkOrderOtherPriceDataFilterInput = {
  /** Список стоимости прочих затрат по актам */
  actKC2OtherCosts?: InputMaybe<ListFilterInputTypeOfBimActKc2OtherCostDataFilterInput>;
  and?: InputMaybe<Array<BimWorkOrderOtherPriceDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  hasActualCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderOtherPriceDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfBimContractOtherStatusEnumOperationFilterInput>;
};

/** Прочая затрата НЗ */
export type BimWorkOrderOtherPriceDataInput = {
  /** Список стоимости прочих затрат по актам */
  actKC2OtherCosts: Array<BimActKc2OtherCostDataInput>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: InputMaybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  hasActualCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataInput>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status?: InputMaybe<BimContractOtherStatusEnum>;
};

/** Прочая затрата НЗ */
export type BimWorkOrderOtherPriceDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<SortEnumType>;
  hasActualCost?: InputMaybe<SortEnumType>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<SortEnumType>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<SortEnumType>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
};

/** Прочая затрата наряд-заказа - данные для добавления */
export type BimWorkOrderOtherPriceInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификаторы объектов для распределения стоимости прочих затрат */
  objectIdList: Array<Scalars['Long']>;
};

export type BimWorkOrderOtherPriceValue = {
  __typename?: 'BimWorkOrderOtherPriceValue';
  /** Ошибки вычисления значения прочей */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Прочие затраты */
  others?: Maybe<Scalars['Decimal']>;
  /** Обшая стоимость */
  total?: Maybe<Scalars['Decimal']>;
};

export type BimWorkOrderOtherPriceValueData = {
  __typename?: 'BimWorkOrderOtherPriceValueData';
  /** Ошибки вычисления значения прочей */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Прочие затраты */
  others?: Maybe<Scalars['Decimal']>;
  /** Обшая стоимость */
  total?: Maybe<Scalars['Decimal']>;
};

export type BimWorkOrderOtherPriceValueDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderOtherPriceValueDataFilterInput>>;
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderOtherPriceValueDataFilterInput>>;
  /** Прочие затраты */
  others?: InputMaybe<DecimalOperationFilterInput>;
  /** Обшая стоимость */
  total?: InputMaybe<DecimalOperationFilterInput>;
};

export type BimWorkOrderOtherPriceValueDataInput = {
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  /** Прочие затраты */
  others?: InputMaybe<Scalars['Decimal']>;
  /** Обшая стоимость */
  total?: InputMaybe<Scalars['Decimal']>;
};

export type BimWorkOrderOtherPriceValueDataSortInput = {
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<SortEnumType>;
  /** Прочие затраты */
  others?: InputMaybe<SortEnumType>;
  /** Обшая стоимость */
  total?: InputMaybe<SortEnumType>;
};

export type BimWorkOrderOtherPriceValueFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderOtherPriceValueFilterInput>>;
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderOtherPriceValueFilterInput>>;
  /** Прочие затраты */
  others?: InputMaybe<DecimalOperationFilterInput>;
  /** Обшая стоимость */
  total?: InputMaybe<DecimalOperationFilterInput>;
};

export type BimWorkOrderOtherPriceValueSortInput = {
  /** Прочие затраты */
  others?: InputMaybe<SortEnumType>;
  /** Обшая стоимость */
  total?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderOtherPricesCollectionSegment = {
  __typename?: 'BimWorkOrderOtherPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderOtherPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderOthersCollectionSegment = {
  __typename?: 'BimWorkOrderOthersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderOtherData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderPriceCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderPriceData = {
  __typename?: 'BimWorkOrderPriceData';
  /** Доступен для удаления на этапе приемки */
  canRemovedToActKC2: Scalars['Boolean'];
  chapter: BimChapterEnum;
  /** Oтклонение Выполнено по НЗ (Всего) от Плана по НЗ (Всего) */
  completedTotalDeviation?: Maybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue: BimWorkOrderPriceValue;
  /** Наличие Актов КС-2 по смете */
  hasActKC2: Scalars['Boolean'];
  /** Наличие ревизий сметы */
  hasRevisions: Scalars['Boolean'];
  /** Наличие обновлений по смете */
  hasUpdates: Scalars['Boolean'];
  id: Scalars['Long'];
  /** Добавлена для Акта КС-2 */
  isActKC2Price: Scalars['Boolean'];
  /** Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Ревизия сметы */
  isRevisionPrice?: Maybe<Scalars['Boolean']>;
  /** Обновление по смете */
  isUpdatedPrice?: Maybe<Scalars['Boolean']>;
  object: BimWorkOrderObjectItem;
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  priceRows?: Maybe<Array<BimWorkOrderPriceRowData>>;
  /** Данные (остаток) */
  remainderValue: BimWorkOrderPriceValue;
  /** Сортировка */
  sortOrder?: Maybe<Scalars['Short']>;
  /** Статус сметы */
  status?: Maybe<BimWorkOrderPriceStatusEnum>;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};

export type BimWorkOrderPriceDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderPriceDataFilterInput>>;
  /** Доступен для удаления на этапе приемки */
  canRemovedToActKC2?: InputMaybe<BooleanOperationFilterInput>;
  chapter?: InputMaybe<BimChapterEnumOperationFilterInput>;
  /** Oтклонение Выполнено по НЗ (Всего) от Плана по НЗ (Всего) */
  completedTotalDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Наличие Актов КС-2 по смете */
  hasActKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие ревизий сметы */
  hasRevisions?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие обновлений по смете */
  hasUpdates?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Добавлена для Акта КС-2 */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Лимитированная затрата */
  isLimitPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  object?: InputMaybe<BimWorkOrderObjectItemFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderPriceDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  priceRows?: InputMaybe<ListFilterInputTypeOfBimWorkOrderPriceRowDataFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Статус сметы */
  status?: InputMaybe<NullableOfBimWorkOrderPriceStatusEnumOperationFilterInput>;
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderPriceDataSortInput = {
  /** Доступен для удаления на этапе приемки */
  canRemovedToActKC2?: InputMaybe<SortEnumType>;
  chapter?: InputMaybe<SortEnumType>;
  /** Oтклонение Выполнено по НЗ (Всего) от Плана по НЗ (Всего) */
  completedTotalDeviation?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Наличие Актов КС-2 по смете */
  hasActKC2?: InputMaybe<SortEnumType>;
  /** Наличие ревизий сметы */
  hasRevisions?: InputMaybe<SortEnumType>;
  /** Наличие обновлений по смете */
  hasUpdates?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Добавлена для Акта КС-2 */
  isActKC2Price?: InputMaybe<SortEnumType>;
  /** Лимитированная затрата */
  isLimitPrice?: InputMaybe<SortEnumType>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<SortEnumType>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  object?: InputMaybe<BimWorkOrderObjectItemSortInput>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Статус сметы */
  status?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** Данные МТР для распределения */
export type BimWorkOrderPriceMtrDistributionData = {
  __typename?: 'BimWorkOrderPriceMTRDistributionData';
  /** Материалы подрядчика */
  mp?: Maybe<Scalars['Decimal']>;
  /** Материалы заказчика */
  mz?: Maybe<Scalars['Decimal']>;
  /** Оборудование подрядчика */
  op?: Maybe<Scalars['Decimal']>;
  /** Оборудование заказчика */
  oz?: Maybe<Scalars['Decimal']>;
  /** Обшая стоимость по формуле "Всего" + "Справочно МЗ" + "Справочно ОЗ" */
  total?: Maybe<Scalars['Decimal']>;
};

/** Данные МТР для распределения */
export type BimWorkOrderPriceMtrDistributionDataInput = {
  /** Материалы подрядчика */
  mp?: InputMaybe<Scalars['Decimal']>;
  /** Материалы заказчика */
  mz?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование подрядчика */
  op?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование заказчика */
  oz?: InputMaybe<Scalars['Decimal']>;
  /** Обшая стоимость по формуле "Всего" + "Справочно МЗ" + "Справочно ОЗ" */
  total?: InputMaybe<Scalars['Decimal']>;
};

/** Входные данные для перераспределения МТР */
export type BimWorkOrderPriceMtrDistributionInput = {
  /** Материалы подрядчика */
  mp?: InputMaybe<Scalars['Decimal']>;
  /** Материалы заказчика */
  mz?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование подрядчика */
  op?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование заказчика */
  oz?: InputMaybe<Scalars['Decimal']>;
};

/** Данные об отклонении стоимости от исходной стоимости сметы */
export type BimWorkOrderPriceMtrDistributionTotalData = {
  __typename?: 'BimWorkOrderPriceMTRDistributionTotalData';
  /** Oтклонение от исходной стоимости сметы */
  deviation?: Maybe<DeviationEnum>;
  /** Обшая стоимость по формуле "Всего" + "Справочно МЗ" + "Справочно ОЗ" */
  total?: Maybe<Scalars['Decimal']>;
};

/** Данные об отклонении стоимости от исходной стоимости сметы */
export type BimWorkOrderPriceMtrDistributionTotalDataInput = {
  /** Oтклонение от исходной стоимости сметы */
  deviation?: InputMaybe<DeviationEnum>;
  /** Обшая стоимость по формуле "Всего" + "Справочно МЗ" + "Справочно ОЗ" */
  total?: InputMaybe<Scalars['Decimal']>;
};

/** A segment of a collection. */
export type BimWorkOrderPriceNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderPriceObjectNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderPriceRevisionCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceRevisionCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Ревизия сметы */
export type BimWorkOrderPriceRevisionData = {
  __typename?: 'BimWorkOrderPriceRevisionData';
  /** Выполнено */
  completedValue: BimWorkOrderPriceValue;
  /** Идентификатор сметы */
  id: Scalars['Long'];
  /** Ревизия сметы */
  isRevisionPrice?: Maybe<Scalars['Boolean']>;
  /** Обновление по смете */
  isUpdatedPrice?: Maybe<Scalars['Boolean']>;
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  /** Дата обновления по смете */
  priceUpdateDate?: Maybe<Scalars['DateTime']>;
  /** Остаток */
  remainderValue: BimWorkOrderPriceValue;
};

/** Ревизия сметы */
export type BimWorkOrderPriceRevisionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderPriceRevisionDataFilterInput>>;
  /** Выполнено */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор сметы */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderPriceRevisionDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Дата обновления по смете */
  priceUpdateDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Остаток */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
};

/** Ревизия сметы */
export type BimWorkOrderPriceRevisionDataSortInput = {
  /** Выполнено */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор сметы */
  id?: InputMaybe<SortEnumType>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<SortEnumType>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Дата обновления по смете */
  priceUpdateDate?: InputMaybe<SortEnumType>;
  /** Остаток */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
};

/** A segment of a collection. */
export type BimWorkOrderPriceRevisionNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceRevisionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderPriceRevisionsCollectionSegment = {
  __typename?: 'BimWorkOrderPriceRevisionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderPriceRevisionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderPriceRowCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceRowCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderPriceRowData = {
  __typename?: 'BimWorkOrderPriceRowData';
  id: Scalars['Long'];
  sectionId?: Maybe<Scalars['Long']>;
  sectionNane?: Maybe<Scalars['String']>;
  type: BimWorkOrderPriceRowTypeEnum;
  /** Данные */
  value: BimWorkOrderPriceValue;
  workOrderId: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
};

export type BimWorkOrderPriceRowDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderPriceRowDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderPriceRowDataFilterInput>>;
  sectionId?: InputMaybe<LongOperationFilterInput>;
  sectionNane?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  type?: InputMaybe<BimWorkOrderPriceRowTypeEnumOperationFilterInput>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
};

export type BimWorkOrderPriceRowDataSortInput = {
  id?: InputMaybe<SortEnumType>;
  sectionId?: InputMaybe<SortEnumType>;
  sectionNane?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  workOrderId?: InputMaybe<SortEnumType>;
  workOrderPriceId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderPriceRowNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderPriceRowNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Тип строки сметы наряд-заказа */
export enum BimWorkOrderPriceRowTypeEnum {
  /** Расценка */
  Price = 'PRICE',
  /** Материально-технический ресурс */
  Resource = 'RESOURCE'
}

export type BimWorkOrderPriceRowTypeEnumOperationFilterInput = {
  eq?: InputMaybe<BimWorkOrderPriceRowTypeEnum>;
  in?: InputMaybe<Array<BimWorkOrderPriceRowTypeEnum>>;
  neq?: InputMaybe<BimWorkOrderPriceRowTypeEnum>;
  nin?: InputMaybe<Array<BimWorkOrderPriceRowTypeEnum>>;
};

/** A segment of a collection. */
export type BimWorkOrderPriceRowsCollectionSegment = {
  __typename?: 'BimWorkOrderPriceRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderPriceRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Аналитические данные раздела/подраздела сметы ЛСР */
export type BimWorkOrderPriceSectionData = {
  __typename?: 'BimWorkOrderPriceSectionData';
  /** Наименование */
  name?: Maybe<Scalars['String']>;
};

/** Аналитические данные раздела/подраздела сметы ЛСР */
export type BimWorkOrderPriceSectionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderPriceSectionDataFilterInput>>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderPriceSectionDataFilterInput>>;
};

/** Аналитические данные раздела/подраздела сметы ЛСР */
export type BimWorkOrderPriceSectionDataSortInput = {
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
};

/** Cостояние позиций наряд-заказ */
export type BimWorkOrderPriceStatesData = {
  __typename?: 'BimWorkOrderPriceStatesData';
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на прочие затраты */
  hasExcessCompletedOthers: Scalars['Boolean'];
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на СМР */
  hasExcessCompletedTotalSMR: Scalars['Boolean'];
};

/** Cостояние позиций наряд-заказ */
export type BimWorkOrderPriceStatesDataInput = {
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на прочие затраты */
  hasExcessCompletedOthers: Scalars['Boolean'];
  /** Флаг - НЗ имеет превышение Выполнено в Актах КС-2 на СМР */
  hasExcessCompletedTotalSMR: Scalars['Boolean'];
};

/** Статус сметы наряд-заказа */
export enum BimWorkOrderPriceStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Новая запись */
  NewRecord = 'NEW_RECORD',
  /** Условие Изма к НЗ */
  WorkOrderChangeCondition = 'WORK_ORDER_CHANGE_CONDITION'
}

/** Данные сметы наряд-заказа */
export type BimWorkOrderPriceValue = {
  __typename?: 'BimWorkOrderPriceValue';
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Материалы подрядчика */
  mp?: Maybe<Scalars['Decimal']>;
  /** Материалы заказчика */
  mz?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  name?: Maybe<Scalars['String']>;
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Оборудование подрядчика */
  op?: Maybe<Scalars['Decimal']>;
  /** Прочие затраты */
  others?: Maybe<Scalars['Decimal']>;
  /** Оборудование заказчика */
  oz?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Количество */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: Maybe<Scalars['Decimal']>;
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** Общая стоимость */
  total?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tzr?: Maybe<Scalars['Decimal']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость единицы */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Данные сметы наряд-заказа */
export type BimWorkOrderPriceValueFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderPriceValueFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Материалы подрядчика */
  mp?: InputMaybe<DecimalOperationFilterInput>;
  /** Материалы заказчика */
  mz?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование подрядчика */
  op?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderPriceValueFilterInput>>;
  /** Прочие затраты */
  others?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование заказчика */
  oz?: InputMaybe<DecimalOperationFilterInput>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Общая стоимость */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Трудозатраты */
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные сметы наряд-заказа */
export type BimWorkOrderPriceValueInput = {
  /** Шифр */
  code?: InputMaybe<Scalars['String']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Материалы подрядчика */
  mp?: InputMaybe<Scalars['Decimal']>;
  /** Материалы заказчика */
  mz?: InputMaybe<Scalars['Decimal']>;
  /** Наименование */
  name?: InputMaybe<Scalars['String']>;
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование подрядчика */
  op?: InputMaybe<Scalars['Decimal']>;
  /** Прочие затраты */
  others?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование заказчика */
  oz?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Количество */
  quantity?: InputMaybe<Scalars['Decimal']>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<Scalars['Decimal']>;
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** Общая стоимость */
  total?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tzr?: InputMaybe<Scalars['Decimal']>;
  /** Единица измерения */
  unit?: InputMaybe<Scalars['String']>;
  /** Стоимость единицы */
  unitCost?: InputMaybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Данные сметы наряд-заказа */
export type BimWorkOrderPriceValueSortInput = {
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Материалы подрядчика */
  mp?: InputMaybe<SortEnumType>;
  /** Материалы заказчика */
  mz?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Накладные расходы */
  nr?: InputMaybe<SortEnumType>;
  /** Оборудование подрядчика */
  op?: InputMaybe<SortEnumType>;
  /** Прочие затраты */
  others?: InputMaybe<SortEnumType>;
  /** Оборудование заказчика */
  oz?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Количество */
  quantity?: InputMaybe<SortEnumType>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<SortEnumType>;
  /** Сметная прибыль */
  sp?: InputMaybe<SortEnumType>;
  /** Общая стоимость */
  total?: InputMaybe<SortEnumType>;
  /** Трудозатраты */
  tzr?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы */
  unitCost?: InputMaybe<SortEnumType>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderPricesCollectionSegment = {
  __typename?: 'BimWorkOrderPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonData = {
  __typename?: 'BimWorkOrderSeasonData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderSeasonDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderSeasonDataFilterInput>>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<SortEnumType>;
  /** Год сезона */
  year?: InputMaybe<SortEnumType>;
};

export type BimWorkOrderSeasonDistributionData = {
  __typename?: 'BimWorkOrderSeasonDistributionData';
  seasonValue?: Maybe<Scalars['Decimal']>;
  workOrderSeasonId: Scalars['Long'];
};

export type BimWorkOrderSeasonDistributionDataInput = {
  seasonValue?: InputMaybe<Scalars['Decimal']>;
  workOrderSeasonId: Scalars['Long'];
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonSelectionData = {
  __typename?: 'BimWorkOrderSeasonSelectionData';
  /** Идентификатор сезона договора */
  contractSeasonId: Scalars['Long'];
  /** Сезон включен в наряд-заказ */
  isIncluded: Scalars['Boolean'];
  /** Идентификатор наряд-заказа */
  workOrderId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: Maybe<Scalars['Long']>;
  /** Год сезона */
  year: Scalars['Short'];
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonSelectionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderSeasonSelectionDataFilterInput>>;
  /** Идентификатор сезона договора */
  contractSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон включен в наряд-заказ */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderSeasonSelectionDataFilterInput>>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Сезон наряд-заказа */
export type BimWorkOrderSeasonSelectionDataSortInput = {
  /** Идентификатор сезона договора */
  contractSeasonId?: InputMaybe<SortEnumType>;
  /** Сезон включен в наряд-заказ */
  isIncluded?: InputMaybe<SortEnumType>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<SortEnumType>;
  /** Год сезона */
  year?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderSeasonSelectionListCollectionSegment = {
  __typename?: 'BimWorkOrderSeasonSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderSeasonSelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderSeasonsCollectionSegment = {
  __typename?: 'BimWorkOrderSeasonsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderSeasonData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type BimWorkOrderSeasonsData = {
  __typename?: 'BimWorkOrderSeasonsData';
  firstSeason: BimWorkOrderSeasonData;
  lastSeason: BimWorkOrderSeasonData;
};

export type BimWorkOrderSeasonsDataInput = {
  firstSeason: BimWorkOrderSeasonDataInput;
  lastSeason: BimWorkOrderSeasonDataInput;
};

export type BimWorkOrderSeasonsInput = {
  firstContractSeasonId: Scalars['Long'];
  lastContractSeasonId: Scalars['Long'];
};

export type BimWorkOrderTotalData = {
  __typename?: 'BimWorkOrderTotalData';
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: Maybe<Scalars['Boolean']>;
  /** Идентификаторы обновленных элементов НЗ\Расчета */
  itemIds?: Maybe<Array<Scalars['Long']>>;
  /** идентификатор операции загрузки актов */
  uploadPriceActs?: Maybe<Scalars['String']>;
  /** Идентификатор НЗ\Расчета */
  workOrderId: Scalars['Long'];
};

export type BimWorkOrderTotalDataInput = {
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: InputMaybe<Scalars['Boolean']>;
  /** Идентификаторы обновленных элементов НЗ\Расчета */
  itemIds?: InputMaybe<Array<Scalars['Long']>>;
  /** идентификатор операции загрузки актов */
  uploadPriceActs?: InputMaybe<Scalars['String']>;
  /** Идентификатор НЗ\Расчета */
  workOrderId: Scalars['Long'];
};

export type BimWorkOrderTotalItemData = {
  __typename?: 'BimWorkOrderTotalItemData';
  /** Данные (выполнено) */
  completedValue: BimWorkOrderPriceValue;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Материалы подрядчика */
  mp?: Maybe<Scalars['Decimal']>;
  /** Материалы заказчика */
  mz?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Оборудование подрядчика */
  op?: Maybe<Scalars['Decimal']>;
  /** Прочие затраты */
  others?: Maybe<Scalars['Decimal']>;
  /** Оборудование заказчика */
  oz?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Количество */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Данные (остаток) */
  remainderValue: BimWorkOrderPriceValue;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: Maybe<Scalars['Decimal']>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** Обшая стоимость */
  total?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tzr?: Maybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type BimWorkOrderTotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderTotalItemDataFilterInput>>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Материалы подрядчика */
  mp?: InputMaybe<DecimalOperationFilterInput>;
  /** Материалы заказчика */
  mz?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование подрядчика */
  op?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderTotalItemDataFilterInput>>;
  /** Прочие затраты */
  others?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование заказчика */
  oz?: InputMaybe<DecimalOperationFilterInput>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Обшая стоимость */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Трудозатраты */
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

export type BimWorkOrderTotalItemDataSortInput = {
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Материалы подрядчика */
  mp?: InputMaybe<SortEnumType>;
  /** Материалы заказчика */
  mz?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Накладные расходы */
  nr?: InputMaybe<SortEnumType>;
  /** Оборудование подрядчика */
  op?: InputMaybe<SortEnumType>;
  /** Прочие затраты */
  others?: InputMaybe<SortEnumType>;
  /** Оборудование заказчика */
  oz?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Количество */
  quantity?: InputMaybe<SortEnumType>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Общая стоимость строительно-монтажных работ */
  smrTotal?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Сметная прибыль */
  sp?: InputMaybe<SortEnumType>;
  /** Обшая стоимость */
  total?: InputMaybe<SortEnumType>;
  /** Трудозатраты */
  tzr?: InputMaybe<SortEnumType>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderTotalsCollectionSegment = {
  __typename?: 'BimWorkOrderTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderTotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Наряд-заказ */
export type BimWorkOrderUpdateInput = {
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Дата выпуска */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderStatusEnum;
  /** Предмет */
  subject?: InputMaybe<Scalars['String']>;
};

/** Данные главы версии НЗ */
export type BimWorkOrderVersionChapterData = {
  __typename?: 'BimWorkOrderVersionChapterData';
  /** Глава */
  chapter: BimChapterEnum;
  /** Количество загруженных смет */
  pricesCount: Scalars['Int'];
};

/** Данные главы версии НЗ */
export type BimWorkOrderVersionChapterDataInput = {
  /** Глава */
  chapter: BimChapterEnum;
  /** Количество загруженных смет */
  pricesCount: Scalars['Int'];
};

export type BimWorkOrderVersionData = {
  __typename?: 'BimWorkOrderVersionData';
  /** Сумма с НДС */
  amountWithTax?: Maybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Подрядчик */
  contractor?: Maybe<Scalars['String']>;
  /** Дата окончания */
  finishDate?: Maybe<Scalars['DateTime']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Остаток */
  remainder?: Maybe<Scalars['Decimal']>;
  /** Процент распределения по сезонам */
  seasonDistributions?: Maybe<Array<BimWorkOrderVersionSeasonDistributionData>>;
  /** Дата выпуска */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Дата начала */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderStatusEnum;
  /** Предмет */
  subject?: Maybe<Scalars['String']>;
  /** НДС */
  tax?: Maybe<Scalars['Decimal']>;
  /** Номер Изм к НЗ */
  workOrderChangeNumber?: Maybe<Scalars['String']>;
  /** Дата подписания Изма к НЗ */
  workOrderChangeSigningDate?: Maybe<Scalars['DateTime']>;
};

export type BimWorkOrderVersionDataInput = {
  /** Сумма с НДС */
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  /** Подрядчик */
  contractor?: InputMaybe<Scalars['String']>;
  /** Дата окончания */
  finishDate?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Остаток */
  remainder?: InputMaybe<Scalars['Decimal']>;
  /** Процент распределения по сезонам */
  seasonDistributions?: InputMaybe<Array<BimWorkOrderVersionSeasonDistributionDataInput>>;
  /** Дата выпуска */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Дата начала */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderStatusEnum;
  /** Предмет */
  subject?: InputMaybe<Scalars['String']>;
  /** НДС */
  tax?: InputMaybe<Scalars['Decimal']>;
  /** Номер Изм к НЗ */
  workOrderChangeNumber?: InputMaybe<Scalars['String']>;
  /** Дата подписания Изма к НЗ */
  workOrderChangeSigningDate?: InputMaybe<Scalars['DateTime']>;
};

/** Версия НЗ - данные для списка */
export type BimWorkOrderVersionItem = {
  __typename?: 'BimWorkOrderVersionItem';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
};

/** Версия НЗ - данные для списка */
export type BimWorkOrderVersionItemFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionItemFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionItemFilterInput>>;
  /** Дата подписания */
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Версия НЗ - данные для списка */
export type BimWorkOrderVersionItemSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<SortEnumType>;
  /** Дата подписания */
  signingDate?: InputMaybe<SortEnumType>;
};

/** Версии НЗ - данные для списка */
export type BimWorkOrderVersionListItem = {
  __typename?: 'BimWorkOrderVersionListItem';
  /** Изм НЗ */
  workOrderChangeItem?: Maybe<BimWorkOrderChangeItem>;
  /** Версия НЗ */
  workOrderVersionItem: BimWorkOrderVersionItem;
};

/** Версии НЗ - данные для списка */
export type BimWorkOrderVersionListItemFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionListItemFilterInput>>;
  or?: InputMaybe<Array<BimWorkOrderVersionListItemFilterInput>>;
  /** Изм НЗ */
  workOrderChangeItem?: InputMaybe<BimWorkOrderChangeItemFilterInput>;
  /** Версия НЗ */
  workOrderVersionItem?: InputMaybe<BimWorkOrderVersionItemFilterInput>;
};

/** Версии НЗ - данные для списка */
export type BimWorkOrderVersionListItemSortInput = {
  /** Изм НЗ */
  workOrderChangeItem?: InputMaybe<BimWorkOrderChangeItemSortInput>;
  /** Версия НЗ */
  workOrderVersionItem?: InputMaybe<BimWorkOrderVersionItemSortInput>;
};

/** Объект версии НЗ */
export type BimWorkOrderVersionObjectData = {
  __typename?: 'BimWorkOrderVersionObjectData';
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Создан при формировании наряд-заказа */
  fromWorkOrder: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Создан на этапе приемки наряд-заказа */
  isActKC2Object: Scalars['Boolean'];
  /** Флаг Корневой объект */
  isRootObject: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimWorkOrderVersionObjectSeasonDistributionData>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
};

/** Объект версии НЗ */
export type BimWorkOrderVersionObjectDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionObjectDataFilterInput>>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Создан при формировании наряд-заказа */
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Создан на этапе приемки наряд-заказа */
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Корневой объект */
  isRootObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам итогов */
  objectSeasonDistributions?: InputMaybe<ListFilterInputTypeOfBimWorkOrderVersionObjectSeasonDistributionDataFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionObjectDataFilterInput>>;
  /** Порядковое значение */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<BimContractObjectStatusEnumOperationFilterInput>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
};

/** Объект версии НЗ */
export type BimWorkOrderVersionObjectDataInput = {
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Создан при формировании наряд-заказа */
  fromWorkOrder: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Создан на этапе приемки наряд-заказа */
  isActKC2Object: Scalars['Boolean'];
  /** Флаг Корневой объект */
  isRootObject: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimWorkOrderVersionObjectSeasonDistributionDataInput>;
  /** Порядковое значение */
  order: Scalars['Int'];
  /** Порядковое значение относительно родителя */
  parentBasedOrder: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Статус объекта */
  status: BimContractObjectStatusEnum;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
};

/** Объект версии НЗ */
export type BimWorkOrderVersionObjectDataSortInput = {
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Создан при формировании наряд-заказа */
  fromWorkOrder?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Создан на этапе приемки наряд-заказа */
  isActKC2Object?: InputMaybe<SortEnumType>;
  /** Флаг Корневой объект */
  isRootObject?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Порядковое значение */
  order?: InputMaybe<SortEnumType>;
  /** Порядковое значение относительно родителя */
  parentBasedOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<SortEnumType>;
};

/** Объект версии НЗ - данные для списка */
export type BimWorkOrderVersionObjectItem = {
  __typename?: 'BimWorkOrderVersionObjectItem';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
};

/** Объект версии НЗ - данные для списка */
export type BimWorkOrderVersionObjectItemFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionObjectItemFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionObjectItemFilterInput>>;
};

/** Объект версии НЗ - данные для списка */
export type BimWorkOrderVersionObjectItemSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
};

export type BimWorkOrderVersionObjectSeasonDistributionData = {
  __typename?: 'BimWorkOrderVersionObjectSeasonDistributionData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Сезон версии НЗ */
  season?: Maybe<BimWorkOrderVersionSeasonData>;
  /** Значение по сезону */
  seasonValue: Scalars['Decimal'];
};

export type BimWorkOrderVersionObjectSeasonDistributionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionObjectSeasonDistributionDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionObjectSeasonDistributionDataFilterInput>>;
  /** Сезон версии НЗ */
  season?: InputMaybe<BimWorkOrderVersionSeasonDataFilterInput>;
  /** Значение по сезону */
  seasonValue?: InputMaybe<DecimalOperationFilterInput>;
};

export type BimWorkOrderVersionObjectSeasonDistributionDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Сезон версии НЗ */
  season?: InputMaybe<BimWorkOrderVersionSeasonDataInput>;
  /** Значение по сезону */
  seasonValue: Scalars['Decimal'];
};

export type BimWorkOrderVersionObjectViewData = {
  __typename?: 'BimWorkOrderVersionObjectViewData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimWorkOrderVersionObjectSeasonDistributionData>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
};

export type BimWorkOrderVersionObjectViewDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Распределение по сезонам итогов */
  objectSeasonDistributions: Array<BimWorkOrderVersionObjectSeasonDistributionDataInput>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** A segment of a collection. */
export type BimWorkOrderVersionObjectsCollectionSegment = {
  __typename?: 'BimWorkOrderVersionObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionObjectData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Прочая затрата версии НЗ */
export type BimWorkOrderVersionOtherPriceData = {
  __typename?: 'BimWorkOrderVersionOtherPriceData';
  /** Список стоимости прочих затрат по актам */
  actKC2OtherCosts: Array<BimActKc2OtherCostData>;
  /** Способ начисления */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: Maybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  hasActualCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedRow?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Данные (план) */
  planValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Данные (остаток) */
  remainderValue?: Maybe<BimWorkOrderOtherPriceValueData>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status?: Maybe<BimContractOtherStatusEnum>;
};

/** Прочая затрата версии НЗ */
export type BimWorkOrderVersionOtherPriceDataFilterInput = {
  /** Список стоимости прочих затрат по актам */
  actKC2OtherCosts?: InputMaybe<ListFilterInputTypeOfBimActKc2OtherCostDataFilterInput>;
  and?: InputMaybe<Array<BimWorkOrderVersionOtherPriceDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  hasActualCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionOtherPriceDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfBimContractOtherStatusEnumOperationFilterInput>;
};

/** Прочая затрата версии НЗ */
export type BimWorkOrderVersionOtherPriceDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedOtherDeviation?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<SortEnumType>;
  hasActualCost?: InputMaybe<SortEnumType>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<SortEnumType>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<SortEnumType>;
  /** Признак исключения позиции */
  isExcludedRow?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderOtherPriceValueDataSortInput>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderVersionOtherPriceNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionOtherPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionOtherPricesCollectionSegment = {
  __typename?: 'BimWorkOrderVersionOtherPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionOtherPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Смета версии НЗ */
export type BimWorkOrderVersionPriceData = {
  __typename?: 'BimWorkOrderVersionPriceData';
  /** Глава */
  chapter: BimChapterEnum;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedTotalDeviation?: Maybe<DeviationEnum>;
  /** Данные (выполнено) */
  completedValue: BimWorkOrderPriceValue;
  /** Наличие Актов КС-2 по смете */
  hasActKC2: Scalars['Boolean'];
  /** Наличие ревизий сметы */
  hasRevisions: Scalars['Boolean'];
  /** Наличие обновлений по смете */
  hasUpdates: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Добавлена для Акта КС-2 */
  isActKC2Price: Scalars['Boolean'];
  /** Лимитированная затрата */
  isLimitPrice: Scalars['Boolean'];
  /** Ревизия сметы */
  isRevisionPrice?: Maybe<Scalars['Boolean']>;
  /** Обновление по смете */
  isUpdatedPrice?: Maybe<Scalars['Boolean']>;
  /** Объект/подобъект версии наряд-заказа */
  object: BimWorkOrderVersionObjectItem;
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  /** Список строк сметы версии НЗ */
  priceRows?: Maybe<Array<BimWorkOrderVersionPriceRowData>>;
  /** Данные (остаток) */
  remainderValue: BimWorkOrderPriceValue;
  /** Сортировка */
  sortOrder?: Maybe<Scalars['Short']>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
  /** Идентификатор объекта/подобъекта версии наряд-заказа */
  workOrderVersionObjectId: Scalars['Long'];
};

/** Смета версии НЗ */
export type BimWorkOrderVersionPriceDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionPriceDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<BimChapterEnumOperationFilterInput>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedTotalDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Наличие Актов КС-2 по смете */
  hasActKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие ревизий сметы */
  hasRevisions?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие обновлений по смете */
  hasUpdates?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Добавлена для Акта КС-2 */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Лимитированная затрата */
  isLimitPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Объект/подобъект версии наряд-заказа */
  object?: InputMaybe<BimWorkOrderVersionObjectItemFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionPriceDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Список строк сметы версии НЗ */
  priceRows?: InputMaybe<ListFilterInputTypeOfBimWorkOrderVersionPriceRowDataFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта/подобъекта версии наряд-заказа */
  workOrderVersionObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Смета версии НЗ */
export type BimWorkOrderVersionPriceDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Oтклонение Выполнено по НЗ (Всего) от Остаток по НЗ (Всего) */
  completedTotalDeviation?: InputMaybe<SortEnumType>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Наличие Актов КС-2 по смете */
  hasActKC2?: InputMaybe<SortEnumType>;
  /** Наличие ревизий сметы */
  hasRevisions?: InputMaybe<SortEnumType>;
  /** Наличие обновлений по смете */
  hasUpdates?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Добавлена для Акта КС-2 */
  isActKC2Price?: InputMaybe<SortEnumType>;
  /** Лимитированная затрата */
  isLimitPrice?: InputMaybe<SortEnumType>;
  /** Ревизия сметы */
  isRevisionPrice?: InputMaybe<SortEnumType>;
  /** Обновление по смете */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  /** Объект/подобъект версии наряд-заказа */
  object?: InputMaybe<BimWorkOrderVersionObjectItemSortInput>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта/подобъекта версии наряд-заказа */
  workOrderVersionObjectId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceObjectNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceRevisionCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceRevisionCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Ревизия сметы версии НЗ */
export type BimWorkOrderVersionPriceRevisionData = {
  __typename?: 'BimWorkOrderVersionPriceRevisionData';
  /** Выполнено */
  completedValue: BimWorkOrderPriceValue;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Флаг Ревизия сметы */
  isRevisionPrice?: Maybe<Scalars['Boolean']>;
  /** Флаг Обновление по смете */
  isUpdatedPrice?: Maybe<Scalars['Boolean']>;
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  /** Дата обновления по смете */
  priceUpdateDate?: Maybe<Scalars['DateTime']>;
  /** Остаток */
  remainderValue: BimWorkOrderPriceValue;
};

/** Ревизия сметы версии НЗ */
export type BimWorkOrderVersionPriceRevisionDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionPriceRevisionDataFilterInput>>;
  /** Выполнено */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг Ревизия сметы */
  isRevisionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Обновление по смете */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionPriceRevisionDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Дата обновления по смете */
  priceUpdateDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Остаток */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
};

/** Ревизия сметы версии НЗ */
export type BimWorkOrderVersionPriceRevisionDataSortInput = {
  /** Выполнено */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Флаг Ревизия сметы */
  isRevisionPrice?: InputMaybe<SortEnumType>;
  /** Флаг Обновление по смете */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Дата обновления по смете */
  priceUpdateDate?: InputMaybe<SortEnumType>;
  /** Остаток */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceRevisionNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceRevisionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceRevisionsCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceRevisionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionPriceRevisionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceRowCodeFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceRowCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Строка сметы версии НЗ */
export type BimWorkOrderVersionPriceRowData = {
  __typename?: 'BimWorkOrderVersionPriceRowData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор раздела */
  sectionId?: Maybe<Scalars['Long']>;
  /** Наименование раздела */
  sectionName?: Maybe<Scalars['String']>;
  /** Тип строки сметы наряд-заказа */
  type: BimWorkOrderPriceRowTypeEnum;
  /** Данные */
  value: BimWorkOrderPriceValue;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
  /** Идентификатор сметы версии наряд-заказа */
  workOrderVersionPriceId: Scalars['Long'];
};

/** Строка сметы версии НЗ */
export type BimWorkOrderVersionPriceRowDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionPriceRowDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionPriceRowDataFilterInput>>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Тип строки сметы наряд-заказа */
  type?: InputMaybe<BimWorkOrderPriceRowTypeEnumOperationFilterInput>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сметы версии наряд-заказа */
  workOrderVersionPriceId?: InputMaybe<LongOperationFilterInput>;
};

/** Строка сметы версии НЗ */
export type BimWorkOrderVersionPriceRowDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<SortEnumType>;
  /** Наименование раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Тип строки сметы наряд-заказа */
  type?: InputMaybe<SortEnumType>;
  /** Данные */
  value?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<SortEnumType>;
  /** Идентификатор сметы версии наряд-заказа */
  workOrderVersionPriceId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceRowNameFilterCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceRowNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPriceRowsCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPriceRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionPriceRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimWorkOrderVersionPricesCollectionSegment = {
  __typename?: 'BimWorkOrderVersionPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Cезон версии наряд-заказа */
export type BimWorkOrderVersionSeasonData = {
  __typename?: 'BimWorkOrderVersionSeasonData';
  /** Идентификатор сезона версии наряд-заказа */
  id: Scalars['Long'];
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Cезон версии наряд-заказа */
export type BimWorkOrderVersionSeasonDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionSeasonDataFilterInput>>;
  /** Идентификатор сезона версии наряд-заказа */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionSeasonDataFilterInput>>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Cезон версии наряд-заказа */
export type BimWorkOrderVersionSeasonDataInput = {
  /** Идентификатор сезона версии наряд-заказа */
  id: Scalars['Long'];
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

export type BimWorkOrderVersionSeasonDistributionData = {
  __typename?: 'BimWorkOrderVersionSeasonDistributionData';
  /** Значение по сезону */
  seasonValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  workOrderVersionSeasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

export type BimWorkOrderVersionSeasonDistributionDataInput = {
  /** Значение по сезону */
  seasonValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  workOrderVersionSeasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Интервал сезонов версии наряд-заказа */
export type BimWorkOrderVersionSeasonsData = {
  __typename?: 'BimWorkOrderVersionSeasonsData';
  /** Первый сезон */
  firstSeason: BimWorkOrderVersionSeasonData;
  /** Последний сезон */
  lastSeason: BimWorkOrderVersionSeasonData;
};

/** Интервал сезонов версии наряд-заказа */
export type BimWorkOrderVersionSeasonsDataInput = {
  /** Первый сезон */
  firstSeason: BimWorkOrderVersionSeasonDataInput;
  /** Последний сезон */
  lastSeason: BimWorkOrderVersionSeasonDataInput;
};

export type BimWorkOrderVersionSubObjectViewData = {
  __typename?: 'BimWorkOrderVersionSubObjectViewData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
};

export type BimWorkOrderVersionSubObjectViewDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Строка итога версии НЗ */
export type BimWorkOrderVersionTotalItemData = {
  __typename?: 'BimWorkOrderVersionTotalItemData';
  /** Данные (выполнено) */
  completedValue: BimWorkOrderPriceValue;
  /** Наименование итога */
  name: Scalars['String'];
  /** Данные (план) */
  planValue: BimWorkOrderPriceValue;
  /** Данные (остаток) */
  remainderValue: BimWorkOrderPriceValue;
  /** Сортировка */
  sortOrder: Scalars['Short'];
};

/** Строка итога версии НЗ */
export type BimWorkOrderVersionTotalItemDataFilterInput = {
  and?: InputMaybe<Array<BimWorkOrderVersionTotalItemDataFilterInput>>;
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Наименование итога */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimWorkOrderVersionTotalItemDataFilterInput>>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
};

/** Строка итога версии НЗ */
export type BimWorkOrderVersionTotalItemDataSortInput = {
  /** Данные (выполнено) */
  completedValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Наименование итога */
  name?: InputMaybe<SortEnumType>;
  /** Данные (план) */
  planValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Данные (остаток) */
  remainderValue?: InputMaybe<BimWorkOrderPriceValueSortInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BimWorkOrderVersionTotalsCollectionSegment = {
  __typename?: 'BimWorkOrderVersionTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimWorkOrderVersionTotalItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcAggregateEstimateCompositionCodeFilterCollectionSegment = {
  __typename?: 'BimcAggregateEstimateCompositionCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcAggregateEstimateCompositionCollectionSegment = {
  __typename?: 'BimcAggregateEstimateCompositionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<LocalEstimateTableItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcAggregateEstimateCompositionNameFilterCollectionSegment = {
  __typename?: 'BimcAggregateEstimateCompositionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcAggregateEstimateCompositionObjectFilterCollectionSegment = {
  __typename?: 'BimcAggregateEstimateCompositionObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcAggregateEstimateCompositionSubObjectFilterCollectionSegment = {
  __typename?: 'BimcAggregateEstimateCompositionSubObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные вида строительства для карточки расчёта БИМ. */
export type BimcCalculationConstructionTypeData = {
  __typename?: 'BimcCalculationConstructionTypeData';
  /** Индексы перевода в текущий уровень цен (owned, 10 статей). */
  coefficients?: Maybe<BimConversionCoefficientsData>;
  /** Каталоговый вид строительства (id/name/code/shortName/description). */
  constructionType?: Maybe<ConstructionTypeData>;
  /** Идентификатор вида строительства. */
  id: Scalars['Long'];
  /** Наименование вида строительства. */
  name: Scalars['String'];
};

/** Данные вида строительства для карточки расчёта БИМ. */
export type BimcCalculationConstructionTypeDataInput = {
  /** Индексы перевода в текущий уровень цен (owned, 10 статей). */
  coefficients?: InputMaybe<BimConversionCoefficientsDataInput>;
  /** Каталоговый вид строительства (id/name/code/shortName/description). */
  constructionType?: InputMaybe<ConstructionTypeDataInput>;
  /** Идентификатор вида строительства. */
  id: Scalars['Long'];
  /** Наименование вида строительства. */
  name: Scalars['String'];
};

/** Input привязки вида строительства к расчёту (ТЗ 501.1). */
export type BimcCalculationConstructionTypeInput = {
  /** Индексы перевода в текущий уровень цен, привязанные к этому ВиС (образец UERC). */
  coefficients: BimConversionCoefficientsInput;
  /** Идентификатор вида строительства из справочника Core. */
  constructionTypeId: Scalars['Int'];
};

/** Input создания карточки БИМ */
export type BimcCalculationCreateInput = {
  /** Привязка видов строительства к расчёту. */
  constructionTypes: Array<BimcCalculationConstructionTypeInput>;
  contractType: ContractTypeEnum;
  /** Количество знаков после запятой при округлении (0 — целое, 2 — два знака). */
  costRounding: Scalars['Int'];
  customerAddress?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  projectUniqueId: Scalars['String'];
  /** Инфляция по сезонам (4 знака). */
  seasonsInflation: Array<BimcCalculationSeasonInflationInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: CalculationStatusEnum;
  subject?: InputMaybe<Scalars['String']>;
  /** Базис поставки (обязательное поле по ТЗ). */
  supplyBasis: Scalars['String'];
  /** Ставка НДС в процентах (null — «не менять»). */
  taxPercent?: InputMaybe<Scalars['Decimal']>;
};

/** Данные карточки расчёта НМЦ (БИМ) для GraphQL */
export type BimcCalculationData = {
  __typename?: 'BimcCalculationData';
  authoredBy: Scalars['String'];
  changeDate?: Maybe<Scalars['DateTime']>;
  /** Флаги изменений Расчёта НМЦ для уведомлений UI. */
  changeNotices: Bimc_ChangeNoticeFlags;
  constructionTypes: Array<BimcCalculationConstructionTypeData>;
  contractType: ContractTypeEnum;
  /** Количество знаков после запятой при округлении (0 — целое, 2 — два знака). */
  costRounding: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customer: Scalars['String'];
  customerAddress?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  lastComputedAt?: Maybe<Scalars['DateTime']>;
  nmcWithNmdc: Scalars['Decimal'];
  nmcWithoutNmdc: Scalars['Decimal'];
  nmdc: Scalars['Decimal'];
  note?: Maybe<Scalars['String']>;
  projectUniqueId: Scalars['String'];
  seasons: Array<BimcCalculationSeasonData>;
  seasonsInflation: Array<BimcCalculationSeasonInflationData>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: CalculationStatusEnum;
  /** Статусы, доступные для установки из текущего статуса. */
  statusFollowers: Array<CalculationStatusEnum>;
  subject: Scalars['String'];
  supplyBasis: Scalars['String'];
  /** Ставка НДС в процентах. */
  taxPercent?: Maybe<Scalars['Decimal']>;
  uniqueId: Scalars['String'];
};

/** Данные карточки расчёта НМЦ (БИМ) для GraphQL */
export type BimcCalculationDataInput = {
  authoredBy: Scalars['String'];
  changeDate?: InputMaybe<Scalars['DateTime']>;
  /** Флаги изменений Расчёта НМЦ для уведомлений UI. */
  changeNotices: Bimc_ChangeNoticeFlags;
  constructionTypes: Array<BimcCalculationConstructionTypeDataInput>;
  contractType: ContractTypeEnum;
  /** Количество знаков после запятой при округлении (0 — целое, 2 — два знака). */
  costRounding: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customer: Scalars['String'];
  customerAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['Long'];
  lastComputedAt?: InputMaybe<Scalars['DateTime']>;
  nmcWithNmdc: Scalars['Decimal'];
  nmcWithoutNmdc: Scalars['Decimal'];
  nmdc: Scalars['Decimal'];
  note?: InputMaybe<Scalars['String']>;
  projectUniqueId: Scalars['String'];
  seasons: Array<BimcCalculationSeasonDataInput>;
  seasonsInflation: Array<BimcCalculationSeasonInflationDataInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: CalculationStatusEnum;
  /** Статусы, доступные для установки из текущего статуса. */
  statusFollowers: Array<CalculationStatusEnum>;
  subject: Scalars['String'];
  supplyBasis: Scalars['String'];
  /** Ставка НДС в процентах. */
  taxPercent?: InputMaybe<Scalars['Decimal']>;
  uniqueId: Scalars['String'];
};

/** Значения по умолчанию для предзаполнения карточки расчёта НМЦ. */
export type BimcCalculationDefaultData = {
  __typename?: 'BimcCalculationDefaultData';
  authoredBy: Scalars['String'];
  contractType: ContractTypeEnum;
  /** Количество знаков после запятой при округлении (0 — целое, 2 — два знака). */
  costRounding: Scalars['Int'];
  customer: Scalars['String'];
  supplyBasis?: Maybe<Scalars['String']>;
  /** Ставка НДС по умолчанию (ТЗ 501.1: 22%). */
  taxPercent: Scalars['Decimal'];
};

/** Значения по умолчанию для предзаполнения карточки расчёта НМЦ. */
export type BimcCalculationDefaultDataInput = {
  authoredBy: Scalars['String'];
  contractType: ContractTypeEnum;
  /** Количество знаков после запятой при округлении (0 — целое, 2 — два знака). */
  costRounding: Scalars['Int'];
  customer: Scalars['String'];
  supplyBasis?: InputMaybe<Scalars['String']>;
  /** Ставка НДС по умолчанию (ТЗ 501.1: 22%). */
  taxPercent: Scalars['Decimal'];
};

/** DTO связи «лимитированная затрата - вид строительства». */
export type BimcCalculationLimitedCostConstructionTypeData = {
  __typename?: 'BimcCalculationLimitedCostConstructionTypeData';
  /** «% по видам строительства» лимитированной затраты. */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
};

/** DTO связи «лимитированная затрата - вид строительства». */
export type BimcCalculationLimitedCostConstructionTypeDataInput = {
  /** «% по видам строительства» лимитированной затраты. */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
};

/** Входные данные связи лимитированной затраты и вида строительства. */
export type BimcCalculationLimitedCostConstructionTypeInput = {
  /** «% по видам строительства» лимитированной затраты. */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
};

/** Строка списка лимитированных затрат (БИМ, блок ТЗ 504). */
export type BimcCalculationLimitedCostData = {
  __typename?: 'BimcCalculationLimitedCostData';
  /** «% лимитированных» для выбранного вида строительства. */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов лимитированных (NULL — «вручную»). */
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава (8/9; доп.транспорт — гл. 1–7). */
  chapter: ChapterEnum;
  /** Формула «% по видам строительства». */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий лимитированных (NULL — «вручную»). */
  globalLimitedCostId?: Maybe<Scalars['Long']>;
  /** Признак учёта лимитированных затрат в СМР («Процент лимитированных затрат в СМР»). */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Признак ошибки формулы (UI). */
  hasFormulaError: Scalars['Boolean'];
  /** Идентификатор лимитированной затраты. */
  id: Scalars['Long'];
  /** Возможность редактировать лимитированную затрату. */
  isEditable: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Признак «северной надбавки» по гл. 8/9. */
  isNorthernAllowance: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: Maybe<Scalars['String']>;
  /** Наименование. */
  name: Scalars['String'];
  /** Обоснование. */
  rationale?: Maybe<Scalars['String']>;
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: Maybe<Array<BimcCalculationLimitedCostLimitData>>;
};

/** Данные для создания / обновления лимитированной затраты расчёта НМЦ (БИМ). */
export type BimcCalculationLimitedCostInput = {
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов лимитированных. */
  catalogLimitedCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава (8/9; доп.транспорт — гл. 1–7). */
  chapter: ChapterEnum;
  /** Виды строительства, для которых лимитированная затрата будет применена. */
  constructionTypes: Array<BimcCalculationLimitedCostConstructionTypeInput>;
  /** Содержимое файла-шаблона/расчёта (для доп.транспорта). */
  file?: InputMaybe<FileInput>;
  /** Формула «% по видам строительства». */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий лимитированных (NULL — «вручную»). */
  globalLimitedCostId?: InputMaybe<Scalars['Long']>;
  /** Признак учёта лимитированных затрат в СМР («Процент лимитированных затрат в СМР»). */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Признак «Вручную/Автоматически» распределения лимитов по видам строительства. */
  isManualLimitsDistribution?: InputMaybe<Scalars['Boolean']>;
  /** Признак «северной надбавки» по гл. 8/9. */
  isNorthernAllowance: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты лимитированной по видам строительства и сезонам (ручной режим). */
  limits?: InputMaybe<Array<BimcCalculationLimitedCostLimitInput>>;
  /** Наименование. */
  name: Scalars['String'];
  /** Обоснование (по постановке обязательное). */
  rationale?: InputMaybe<Scalars['String']>;
};

/** DTO «Лимит лимитированной затраты по сезону». */
export type BimcCalculationLimitedCostLimitData = {
  __typename?: 'BimcCalculationLimitedCostLimitData';
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона. */
  seasonId: Scalars['Long'];
};

/** DTO «Лимит лимитированной затраты по сезону». */
export type BimcCalculationLimitedCostLimitDataInput = {
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона. */
  seasonId: Scalars['Long'];
};

/** Входные данные лимита лимитированной затраты по сезону. */
export type BimcCalculationLimitedCostLimitInput = {
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона. */
  seasonId: Scalars['Long'];
};

/** A segment of a collection. */
export type BimcCalculationLimitedCostNameFilterCollectionSegment = {
  __typename?: 'BimcCalculationLimitedCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationLimitedCostTypesCollectionSegment = {
  __typename?: 'BimcCalculationLimitedCostTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogLimitedCostTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные лимитированной затраты для редактора («на обновление»). */
export type BimcCalculationLimitedCostUpdateData = {
  __typename?: 'BimcCalculationLimitedCostUpdateData';
  /** «% лимитированных» для выбранного вида строительства. */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Запись справочника типа лимитированных. */
  catalogLimitedCostType?: Maybe<CatalogLimitedCostTypeData>;
  /** Идентификатор записи справочника типов лимитированных (NULL — «вручную»). */
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава (8/9; доп.транспорт — гл. 1–7). */
  chapter: ChapterEnum;
  /** Файл шаблона/расчёта (для скачивания). */
  file?: Maybe<FileContent>;
  /** Формула «% по видам строительства». */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий лимитированных (NULL — «вручную»). */
  globalLimitedCostId?: Maybe<Scalars['Long']>;
  /** Связь «лимитированная затрата - вид строительства» («% по видам строительства»). */
  groupConstructionLimits?: Maybe<Array<BimcCalculationLimitedCostConstructionTypeData>>;
  /** Признак учёта лимитированных затрат в СМР («Процент лимитированных затрат в СМР»). */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Флаг незаполненной формулы. */
  hasEmptyFormula?: Maybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа лимитированной. */
  hasEmptyLimitedCostType?: Maybe<Scalars['Boolean']>;
  /** Признак ошибки формулы (UI). */
  hasFormulaError: Scalars['Boolean'];
  /** Идентификатор лимитированной затраты. */
  id: Scalars['Long'];
  /** Возможность редактировать лимитированную затрату. */
  isEditable: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Признак «северной надбавки» по гл. 8/9. */
  isNorthernAllowance: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: Maybe<Scalars['String']>;
  /** Лимиты лимитированной по видам строительства и сезонам. */
  limits?: Maybe<Array<BimcCalculationLimitedCostLimitData>>;
  /** Наименование. */
  name: Scalars['String'];
  /** Обоснование. */
  rationale?: Maybe<Scalars['String']>;
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: Maybe<Array<BimcCalculationLimitedCostLimitData>>;
  /** Технический идентификатор для ссылок формул (@Ссылки). */
  uniqueId: Scalars['String'];
};

/** Данные лимитированной затраты для редактора («на обновление»). */
export type BimcCalculationLimitedCostUpdateDataInput = {
  /** «% лимитированных» для выбранного вида строительства. */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Запись справочника типа лимитированных. */
  catalogLimitedCostType?: InputMaybe<CatalogLimitedCostTypeDataInput>;
  /** Идентификатор записи справочника типов лимитированных (NULL — «вручную»). */
  catalogLimitedCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава (8/9; доп.транспорт — гл. 1–7). */
  chapter: ChapterEnum;
  /** Файл шаблона/расчёта (для скачивания). */
  file?: InputMaybe<FileContentInput>;
  /** Формула «% по видам строительства». */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий лимитированных (NULL — «вручную»). */
  globalLimitedCostId?: InputMaybe<Scalars['Long']>;
  /** Связь «лимитированная затрата - вид строительства» («% по видам строительства»). */
  groupConstructionLimits?: InputMaybe<Array<BimcCalculationLimitedCostConstructionTypeDataInput>>;
  /** Признак учёта лимитированных затрат в СМР («Процент лимитированных затрат в СМР»). */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Флаг незаполненной формулы. */
  hasEmptyFormula?: InputMaybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа лимитированной. */
  hasEmptyLimitedCostType?: InputMaybe<Scalars['Boolean']>;
  /** Признак ошибки формулы (UI). */
  hasFormulaError: Scalars['Boolean'];
  /** Идентификатор лимитированной затраты. */
  id: Scalars['Long'];
  /** Возможность редактировать лимитированную затрату. */
  isEditable: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Признак «северной надбавки» по гл. 8/9. */
  isNorthernAllowance: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты лимитированной по видам строительства и сезонам. */
  limits?: InputMaybe<Array<BimcCalculationLimitedCostLimitDataInput>>;
  /** Наименование. */
  name: Scalars['String'];
  /** Обоснование. */
  rationale?: InputMaybe<Scalars['String']>;
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: InputMaybe<Array<BimcCalculationLimitedCostLimitDataInput>>;
  /** Технический идентификатор для ссылок формул (@Ссылки). */
  uniqueId: Scalars['String'];
};

/** A segment of a collection. */
export type BimcCalculationLimitedCostsCollectionSegment = {
  __typename?: 'BimcCalculationLimitedCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimcCalculationLimitedCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Навигация расчета */
export type BimcCalculationNavigationData = {
  __typename?: 'BimcCalculationNavigationData';
  /** Данные расчета */
  calculationNavData: Uer_CalculationNavData;
  /** Список элементов навигации расчета */
  calculationNavItems?: Maybe<Array<Uer_CalculationItemNavData>>;
};

/** Input создания объекта структуры расчёта (БИМ). */
export type BimcCalculationObjectCreateInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Идентификатор вида строительства, к которому принадлежит объект. */
  constructionTypeId: Scalars['Int'];
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume: Scalars['Boolean'];
  name: Scalars['String'];
  /** Распределение итогов по сезонам на объект/подобъект (сумма = 100 для уровней 1/2). */
  seasons: Array<CalculationObjectSeasonInput>;
};

/** Данные объекта структуры расчёта (БИМ, блок ТЗ 502.1-502.2). */
export type BimcCalculationObjectData = {
  __typename?: 'BimcCalculationObjectData';
  calculationId: Scalars['Long'];
  /** Код объекта (числа через точку) для интеграций. */
  codeWBS?: Maybe<Scalars['String']>;
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume: Scalars['Boolean'];
  id: Scalars['Long'];
  name: Scalars['String'];
  /** Порядок среди сиблингов одной ветки. */
  order: Scalars['Int'];
  /** Идентификатор родительского объекта/подобъекта, null — корневой. */
  parentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства. */
  rootObjectId: Scalars['Long'];
  /** Распределение итогов по сезонам на объект/подобъект. */
  seasons: Array<CalculationObjectSeasonData>;
};

/** Input обновления объекта структуры расчёта (БИМ). */
export type BimcCalculationObjectUpdateInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume: Scalars['Boolean'];
  id: Scalars['Long'];
  name: Scalars['String'];
  /** Распределение итогов по сезонам на объект/подобъект (сумма = 100 для уровней 1/2). */
  seasons: Array<CalculationObjectSeasonInput>;
};

/** DTO «Связь прочие затраты - вид строительства». */
export type BimcCalculationOtherCostConstructionTypeData = {
  __typename?: 'BimcCalculationOtherCostConstructionTypeData';
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Способ распределения лимитов по сезонам. */
  distributionMethod?: Maybe<Uerc_LimitDistributionMethodEnum>;
  /** Лимит прочей для текущего вида строительства. */
  totalCostLimit?: Maybe<Scalars['Decimal']>;
};

/** DTO «Связь прочие затраты - вид строительства». */
export type BimcCalculationOtherCostConstructionTypeDataInput = {
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Способ распределения лимитов по сезонам. */
  distributionMethod?: InputMaybe<Uerc_LimitDistributionMethodEnum>;
  /** Лимит прочей для текущего вида строительства. */
  totalCostLimit?: InputMaybe<Scalars['Decimal']>;
};

/** Входные данные связи прочей затраты и вида строительства. */
export type BimcCalculationOtherCostConstructionTypeInput = {
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Лимит прочей для текущего вида строительства. */
  costLimit?: InputMaybe<Scalars['Decimal']>;
  /** Способ распределения лимитов по сезонам. */
  distributionMethod?: InputMaybe<Uerc_LimitDistributionMethodEnum>;
};

/** Строка списка прочих затрат (БИМ). «Всего» и лимиты по сезонам — вычисляются из лимитов. */
export type BimcCalculationOtherCostData = {
  __typename?: 'BimcCalculationOtherCostData';
  /** Способ начисления. */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % для CalculatingType = Percent; сумма лимитов прочих для CalculatingType = Calculation. */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов прочих. */
  catalogOtherCostTypeId: Scalars['Int'];
  /** Глава (nullable: NULL — для «Лимиты Заказчика»). */
  chapter?: Maybe<ChapterEnum>;
  /** Дата и время добавления записи */
  createdAt: Scalars['DateTime'];
  /** Идентификатор записи справочника методологий прочих (NULL — «вручную»). */
  globalOtherCostId?: Maybe<Scalars['Long']>;
  /** Признак необходимости учитывать прочие затраты в СМР. */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Признак ошибки формулы (UI). */
  hasFormulaError: Scalars['Boolean'];
  /** Идентификатор прочей затраты. */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату. */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Признак, что сумма лимитов прочих загружена из файла. */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: Maybe<Scalars['String']>;
  /** Наименование. */
  name: Scalars['String'];
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: Maybe<Array<BimcCalculationOtherCostLimitData>>;
  /** Раздел (nullable). */
  section?: Maybe<SectionEnum>;
  /** «Всего» по прочей = сумма лимитов по сезонам для текущего вида строительства. */
  total: Scalars['Decimal'];
};

/** Строка списка прочих затрат (БИМ). «Всего» и лимиты по сезонам — вычисляются из лимитов. */
export type BimcCalculationOtherCostDataFilterInput = {
  and?: InputMaybe<Array<BimcCalculationOtherCostDataFilterInput>>;
  /** Способ начисления. */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % для CalculatingType = Percent; сумма лимитов прочих для CalculatingType = Calculation. */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор расчёта НМЦ. */
  calculationId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор записи справочника типов прочих. */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава (nullable: NULL — для «Лимиты Заказчика»). */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Дата и время добавления записи */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Идентификатор записи справочника методологий прочих (NULL — «вручную»). */
  globalOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Признак необходимости учитывать прочие затраты в СМР. */
  hasCalculatingParticipation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак ошибки формулы (UI). */
  hasFormulaError?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор прочей затраты. */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Возможность редактировать прочую затрату. */
  isEditable?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак, что сумма лимитов прочих загружена из файла. */
  isLimitsTotalFromFile?: InputMaybe<BooleanOperationFilterInput>;
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution?: InputMaybe<BooleanOperationFilterInput>;
  /** Код (уникален в рамках расчёта). */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование. */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimcCalculationOtherCostDataFilterInput>>;
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: InputMaybe<ListFilterInputTypeOfBimcCalculationOtherCostLimitDataFilterInput>;
  /** Раздел (nullable). */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** «Всего» по прочей = сумма лимитов по сезонам для текущего вида строительства. */
  total?: InputMaybe<DecimalOperationFilterInput>;
};

/** Строка списка прочих затрат (БИМ). «Всего» и лимиты по сезонам — вычисляются из лимитов. */
export type BimcCalculationOtherCostDataSortInput = {
  /** Способ начисления. */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Величина, % для CalculatingType = Percent; сумма лимитов прочих для CalculatingType = Calculation. */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Идентификатор расчёта НМЦ. */
  calculationId?: InputMaybe<SortEnumType>;
  /** Идентификатор записи справочника типов прочих. */
  catalogOtherCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава (nullable: NULL — для «Лимиты Заказчика»). */
  chapter?: InputMaybe<SortEnumType>;
  /** Дата и время добавления записи */
  createdAt?: InputMaybe<SortEnumType>;
  /** Идентификатор записи справочника методологий прочих (NULL — «вручную»). */
  globalOtherCostId?: InputMaybe<SortEnumType>;
  /** Признак необходимости учитывать прочие затраты в СМР. */
  hasCalculatingParticipation?: InputMaybe<SortEnumType>;
  /** Признак ошибки формулы (UI). */
  hasFormulaError?: InputMaybe<SortEnumType>;
  /** Идентификатор прочей затраты. */
  id?: InputMaybe<SortEnumType>;
  /** Возможность редактировать прочую затрату. */
  isEditable?: InputMaybe<SortEnumType>;
  /** Признак, что сумма лимитов прочих загружена из файла. */
  isLimitsTotalFromFile?: InputMaybe<SortEnumType>;
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution?: InputMaybe<SortEnumType>;
  /** Код (уникален в рамках расчёта). */
  key?: InputMaybe<SortEnumType>;
  /** Наименование. */
  name?: InputMaybe<SortEnumType>;
  /** Раздел (nullable). */
  section?: InputMaybe<SortEnumType>;
  /** «Всего» по прочей = сумма лимитов по сезонам для текущего вида строительства. */
  total?: InputMaybe<SortEnumType>;
};

/** Данные для создания / обновления прочей затраты расчёта НМЦ (БИМ). */
export type BimcCalculationOtherCostInput = {
  /** Способ начисления. */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % для CalculatingType = Percent; сумма лимитов прочих для CalculatingType = Calculation. */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов прочих. */
  catalogOtherCostTypeId: Scalars['Int'];
  /** Глава (nullable: NULL — для «Лимиты Заказчика»). */
  chapter?: InputMaybe<ChapterEnum>;
  /** Виды строительства, для которых прочая будет применена. */
  constructionTypes: Array<BimcCalculationOtherCostConstructionTypeInput>;
  /** Содержимое файла-шаблона, использованного в качестве источника значения (способ «Расчет»). */
  file?: InputMaybe<FileInput>;
  /** Формула прочих способа расчёта «Процент». */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих (NULL — «вручную»). */
  globalOtherCostId?: InputMaybe<Scalars['Long']>;
  /** Признак «Процент прочих затрат в СМР» (УСР, name от постановки IsSmrParticipation). */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Признак, что сумма лимитов прочих загружена из файла. */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Признак «Вручную/Автоматически» распределения лимитов по видам строительства. */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей по видам строительства и сезонам (ручной режим). */
  limits?: InputMaybe<Array<BimcCalculationOtherCostLimitInput>>;
  /** Наименование. */
  name: Scalars['String'];
  /** Раздел (nullable). */
  section?: InputMaybe<SectionEnum>;
};

/** DTO «Лимит прочей по сезону». */
export type BimcCalculationOtherCostLimitData = {
  __typename?: 'BimcCalculationOtherCostLimitData';
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона. */
  seasonId: Scalars['Long'];
};

/** DTO «Лимит прочей по сезону». */
export type BimcCalculationOtherCostLimitDataFilterInput = {
  and?: InputMaybe<Array<BimcCalculationOtherCostLimitDataFilterInput>>;
  /** Идентификатор вида строительства. */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BimcCalculationOtherCostLimitDataFilterInput>>;
  /** Идентификатор сезона. */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** DTO «Лимит прочей по сезону». */
export type BimcCalculationOtherCostLimitDataInput = {
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона. */
  seasonId: Scalars['Long'];
};

/** Входные данные лимита прочей по сезону. */
export type BimcCalculationOtherCostLimitInput = {
  /** Идентификатор вида строительства. */
  constructionTypeId: Scalars['Int'];
  /** Стоимость лимита за сезон, руб. без НДС. */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона. */
  seasonId: Scalars['Long'];
};

/** A segment of a collection. */
export type BimcCalculationOtherCostNameFilterCollectionSegment = {
  __typename?: 'BimcCalculationOtherCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationOtherCostTypesCollectionSegment = {
  __typename?: 'BimcCalculationOtherCostTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные прочей затраты для редактора («на обновление»). */
export type BimcCalculationOtherCostUpdateData = {
  __typename?: 'BimcCalculationOtherCostUpdateData';
  /** Способ начисления. */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % для CalculatingType = Percent; сумма лимитов прочих для CalculatingType = Calculation. */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Запись справочника типа прочих. */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих. */
  catalogOtherCostTypeId: Scalars['Int'];
  /** Глава (nullable: NULL — для «Лимиты Заказчика»). */
  chapter?: Maybe<ChapterEnum>;
  /** Дата и время добавления записи */
  createdAt: Scalars['DateTime'];
  /** Файл шаблона (для скачивания). */
  file?: Maybe<FileContent>;
  /** Формула прочих способа расчёта «Процент». */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих (NULL — «вручную»). */
  globalOtherCostId?: Maybe<Scalars['Long']>;
  /** Связь «прочие затраты - вид строительства». */
  groupConstructionLimits?: Maybe<Array<BimcCalculationOtherCostConstructionTypeData>>;
  /** Признак необходимости учитывать прочие затраты в СМР. */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Флаг незаполненной формулы прочей. */
  hasEmptyFormula?: Maybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей. */
  hasEmptyOtherCostType?: Maybe<Scalars['Boolean']>;
  /** Признак ошибки формулы (UI). */
  hasFormulaError: Scalars['Boolean'];
  /** Идентификатор прочей затраты. */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату. */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Признак, что сумма лимитов прочих загружена из файла. */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: Maybe<Scalars['String']>;
  /** Лимиты прочей по видам строительства и сезонам. */
  limits?: Maybe<Array<BimcCalculationOtherCostLimitData>>;
  /** Наименование. */
  name: Scalars['String'];
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: Maybe<Array<BimcCalculationOtherCostLimitData>>;
  /** Раздел (nullable). */
  section?: Maybe<SectionEnum>;
  /** «Всего» по прочей = сумма лимитов по сезонам для текущего вида строительства. */
  total: Scalars['Decimal'];
  /** Технический идентификатор для ссылок формул (@Ссылки). */
  uniqueId: Scalars['String'];
};

/** Данные прочей затраты для редактора («на обновление»). */
export type BimcCalculationOtherCostUpdateDataInput = {
  /** Способ начисления. */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % для CalculatingType = Percent; сумма лимитов прочих для CalculatingType = Calculation. */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор расчёта НМЦ. */
  calculationId: Scalars['Long'];
  /** Запись справочника типа прочих. */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих. */
  catalogOtherCostTypeId: Scalars['Int'];
  /** Глава (nullable: NULL — для «Лимиты Заказчика»). */
  chapter?: InputMaybe<ChapterEnum>;
  /** Дата и время добавления записи */
  createdAt: Scalars['DateTime'];
  /** Файл шаблона (для скачивания). */
  file?: InputMaybe<FileContentInput>;
  /** Формула прочих способа расчёта «Процент». */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих (NULL — «вручную»). */
  globalOtherCostId?: InputMaybe<Scalars['Long']>;
  /** Связь «прочие затраты - вид строительства». */
  groupConstructionLimits?: InputMaybe<Array<BimcCalculationOtherCostConstructionTypeDataInput>>;
  /** Признак необходимости учитывать прочие затраты в СМР. */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Флаг незаполненной формулы прочей. */
  hasEmptyFormula?: InputMaybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей. */
  hasEmptyOtherCostType?: InputMaybe<Scalars['Boolean']>;
  /** Признак ошибки формулы (UI). */
  hasFormulaError: Scalars['Boolean'];
  /** Идентификатор прочей затраты. */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату. */
  isEditable?: InputMaybe<Scalars['Boolean']>;
  /** Признак, что сумма лимитов прочих загружена из файла. */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически). */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код (уникален в рамках расчёта). */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей по видам строительства и сезонам. */
  limits?: InputMaybe<Array<BimcCalculationOtherCostLimitDataInput>>;
  /** Наименование. */
  name: Scalars['String'];
  /** Лимиты по сезонам (для таблицы страницы). */
  seasonAmounts?: InputMaybe<Array<BimcCalculationOtherCostLimitDataInput>>;
  /** Раздел (nullable). */
  section?: InputMaybe<SectionEnum>;
  /** «Всего» по прочей = сумма лимитов по сезонам для текущего вида строительства. */
  total: Scalars['Decimal'];
  /** Технический идентификатор для ссылок формул (@Ссылки). */
  uniqueId: Scalars['String'];
};

/** A segment of a collection. */
export type BimcCalculationOtherCostsCollectionSegment = {
  __typename?: 'BimcCalculationOtherCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimcCalculationOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationPreviewCodeFilterCollectionSegment = {
  __typename?: 'BimcCalculationPreviewCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationPreviewCollectionSegment = {
  __typename?: 'BimcCalculationPreviewCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BimcCalculationPreviewRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationPreviewNameFilterCollectionSegment = {
  __typename?: 'BimcCalculationPreviewNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationPreviewObjectFilterCollectionSegment = {
  __typename?: 'BimcCalculationPreviewObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Плоская строка предварительного просмотра расчёта НМЦ. */
export type BimcCalculationPreviewRowData = {
  __typename?: 'BimcCalculationPreviewRowData';
  /** Шифр. */
  code?: Maybe<Scalars['String']>;
  emm?: Maybe<Scalars['Decimal']>;
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Уровень строки в дереве. */
  level: CalculationPreviewRowTypeEnum;
  mp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  mz?: Maybe<Scalars['Decimal']>;
  /** Наименование. */
  name?: Maybe<Scalars['String']>;
  nr?: Maybe<Scalars['Decimal']>;
  /** Наименование листового подобъекта. */
  objectName?: Maybe<Scalars['String']>;
  op?: Maybe<Scalars['Decimal']>;
  others?: Maybe<Scalars['Decimal']>;
  oz?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  /** Количество. */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Идентификатор корневого объекта. */
  rootObjectId: Scalars['Long'];
  /** Наименование корневого объекта. */
  rootObjectName?: Maybe<Scalars['String']>;
  /** Распределение по сезонам. */
  seasons: Array<BimcCalculationPreviewSeasonData>;
  /**
   * Ярлык строки, зависящий от уровня: для строки объекта — наименование объекта,
   * строки главы — полное наименование главы, ЛСР — краткое «Глава N»,
   * прочих/лимитированных — наименование раздела («Прочие затраты»/«Лимитированные»).
   */
  sectionName?: Maybe<Scalars['String']>;
  smrTotal?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  total?: Maybe<Scalars['Decimal']>;
  tzm?: Maybe<Scalars['Decimal']>;
  tzr?: Maybe<Scalars['Decimal']>;
  /** Единицы измерения. */
  unit?: Maybe<Scalars['String']>;
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Плоская строка предварительного просмотра расчёта НМЦ. */
export type BimcCalculationPreviewRowDataFilterInput = {
  and?: InputMaybe<Array<BimcCalculationPreviewRowDataFilterInput>>;
  /** Шифр. */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Уровень строки в дереве. */
  level?: InputMaybe<CalculationPreviewRowTypeEnumOperationFilterInput>;
  mp?: InputMaybe<DecimalOperationFilterInput>;
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  mz?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование. */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  nr?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование листового подобъекта. */
  objectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  op?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<BimcCalculationPreviewRowDataFilterInput>>;
  others?: InputMaybe<DecimalOperationFilterInput>;
  oz?: InputMaybe<DecimalOperationFilterInput>;
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор корневого объекта. */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование корневого объекта. */
  rootObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Распределение по сезонам. */
  seasons?: InputMaybe<ListFilterInputTypeOfBimcCalculationPreviewSeasonDataFilterInput>;
  /**
   * Ярлык строки, зависящий от уровня: для строки объекта — наименование объекта,
   * строки главы — полное наименование главы, ЛСР — краткое «Глава N»,
   * прочих/лимитированных — наименование раздела («Прочие затраты»/«Лимитированные»).
   */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  sp?: InputMaybe<DecimalOperationFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
  tzm?: InputMaybe<DecimalOperationFilterInput>;
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Единицы измерения. */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Плоская строка предварительного просмотра расчёта НМЦ. */
export type BimcCalculationPreviewRowDataSortInput = {
  /** Шифр. */
  code?: InputMaybe<SortEnumType>;
  emm?: InputMaybe<SortEnumType>;
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Уровень строки в дереве. */
  level?: InputMaybe<SortEnumType>;
  mp?: InputMaybe<SortEnumType>;
  mtr?: InputMaybe<SortEnumType>;
  mz?: InputMaybe<SortEnumType>;
  /** Наименование. */
  name?: InputMaybe<SortEnumType>;
  nr?: InputMaybe<SortEnumType>;
  /** Наименование листового подобъекта. */
  objectName?: InputMaybe<SortEnumType>;
  op?: InputMaybe<SortEnumType>;
  others?: InputMaybe<SortEnumType>;
  oz?: InputMaybe<SortEnumType>;
  ozp?: InputMaybe<SortEnumType>;
  /** Количество. */
  quantity?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта. */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Наименование корневого объекта. */
  rootObjectName?: InputMaybe<SortEnumType>;
  /**
   * Ярлык строки, зависящий от уровня: для строки объекта — наименование объекта,
   * строки главы — полное наименование главы, ЛСР — краткое «Глава N»,
   * прочих/лимитированных — наименование раздела («Прочие затраты»/«Лимитированные»).
   */
  sectionName?: InputMaybe<SortEnumType>;
  smrTotal?: InputMaybe<SortEnumType>;
  sp?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  tzm?: InputMaybe<SortEnumType>;
  tzr?: InputMaybe<SortEnumType>;
  /** Единицы измерения. */
  unit?: InputMaybe<SortEnumType>;
  zpm?: InputMaybe<SortEnumType>;
};

/** Сезон строки предпросмотра. */
export type BimcCalculationPreviewSeasonData = {
  __typename?: 'BimcCalculationPreviewSeasonData';
  /** Стоимость в выбранном уровне цен. */
  cost?: Maybe<Scalars['Decimal']>;
  /** Ошибки расчёта значения в сезоне (используется для прочих/лимитированных). */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Доля сезона, %. */
  percent: Scalars['Decimal'];
  /** Год сезона. */
  season: Scalars['Short'];
};

/** Сезон строки предпросмотра. */
export type BimcCalculationPreviewSeasonDataFilterInput = {
  and?: InputMaybe<Array<BimcCalculationPreviewSeasonDataFilterInput>>;
  /** Стоимость в выбранном уровне цен. */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  /** Ошибки расчёта значения в сезоне (используется для прочих/лимитированных). */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<BimcCalculationPreviewSeasonDataFilterInput>>;
  /** Доля сезона, %. */
  percent?: InputMaybe<DecimalOperationFilterInput>;
  /** Год сезона. */
  season?: InputMaybe<ShortOperationFilterInput>;
};

/** A segment of a collection. */
export type BimcCalculationPreviewSeasonFilterCollectionSegment = {
  __typename?: 'BimcCalculationPreviewSeasonFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfInt16>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationPreviewSectionFilterCollectionSegment = {
  __typename?: 'BimcCalculationPreviewSectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcCalculationPreviewSubObjectFilterCollectionSegment = {
  __typename?: 'BimcCalculationPreviewSubObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/**
 * Данные итогов расчёта НМЦ БИМ. Единый метод просмотра: передаваемые фильтры
 * (constructionTypeId, objectId, chapter) определяют объём данных —
 * строка подобъекта, уровень объекта/вида строительства/расчёта или диалог главы.
 * Строки возвращаются плоским списком с признаком гарантированного объёма.
 */
export type BimcCalculationResultData = {
  __typename?: 'BimcCalculationResultData';
  /** Строки итогов. */
  rows: Array<BimcCalculationResultRowData>;
};

/**
 * Данные итогов расчёта НМЦ БИМ. Единый метод просмотра: передаваемые фильтры
 * (constructionTypeId, objectId, chapter) определяют объём данных —
 * строка подобъекта, уровень объекта/вида строительства/расчёта или диалог главы.
 * Строки возвращаются плоским списком с признаком гарантированного объёма.
 */
export type BimcCalculationResultDataInput = {
  /** Строки итогов. */
  rows: Array<BimcCalculationResultRowDataInput>;
};

/** Строка итогов расчёта НМЦ БИМ. */
export type BimcCalculationResultRowData = {
  __typename?: 'BimcCalculationResultRowData';
  emm?: Maybe<Scalars['Decimal']>;
  /** Признак гарантированного объёма. Значение не имеет смысла на уровне подобъекта и в диалоге главы — там срез единственный. */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Признак строки-заголовка группы. */
  isHeadLine: Scalars['Boolean'];
  mp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  mz?: Maybe<Scalars['Decimal']>;
  /** Наименование строки. */
  name: Scalars['String'];
  nr?: Maybe<Scalars['Decimal']>;
  op?: Maybe<Scalars['Decimal']>;
  others?: Maybe<Scalars['Decimal']>;
  oz?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  /** Сквозной тип строки итогов. */
  resultType: BimcCalculationResultTypeEnum;
  /** Распределение строки по сезонам («в т.ч. [год]»). */
  seasons: Array<BimcCalculationResultSeasonData>;
  smrTotal?: Maybe<Scalars['Decimal']>;
  /** Порядок строки в срезе (устойчивая сортировка). */
  sortOrder: Scalars['Float'];
  sp?: Maybe<Scalars['Decimal']>;
  total?: Maybe<Scalars['Decimal']>;
  tzm?: Maybe<Scalars['Decimal']>;
  tzr?: Maybe<Scalars['Decimal']>;
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Строка итогов расчёта НМЦ БИМ. */
export type BimcCalculationResultRowDataInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Признак гарантированного объёма. Значение не имеет смысла на уровне подобъекта и в диалоге главы — там срез единственный. */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Признак строки-заголовка группы. */
  isHeadLine: Scalars['Boolean'];
  mp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  mz?: InputMaybe<Scalars['Decimal']>;
  /** Наименование строки. */
  name: Scalars['String'];
  nr?: InputMaybe<Scalars['Decimal']>;
  op?: InputMaybe<Scalars['Decimal']>;
  others?: InputMaybe<Scalars['Decimal']>;
  oz?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Сквозной тип строки итогов. */
  resultType: BimcCalculationResultTypeEnum;
  /** Распределение строки по сезонам («в т.ч. [год]»). */
  seasons: Array<BimcCalculationResultSeasonDataInput>;
  smrTotal?: InputMaybe<Scalars['Decimal']>;
  /** Порядок строки в срезе (устойчивая сортировка). */
  sortOrder: Scalars['Float'];
  sp?: InputMaybe<Scalars['Decimal']>;
  total?: InputMaybe<Scalars['Decimal']>;
  tzm?: InputMaybe<Scalars['Decimal']>;
  tzr?: InputMaybe<Scalars['Decimal']>;
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Сезонное значение строки итогов. */
export type BimcCalculationResultSeasonData = {
  __typename?: 'BimcCalculationResultSeasonData';
  emm?: Maybe<Scalars['Decimal']>;
  mp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  mz?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  op?: Maybe<Scalars['Decimal']>;
  others?: Maybe<Scalars['Decimal']>;
  oz?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  /** Доля сезона, % (информационно, только для уровней с собственным распределением). */
  percent: Scalars['Decimal'];
  smrTotal?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  total?: Maybe<Scalars['Decimal']>;
  tzm?: Maybe<Scalars['Decimal']>;
  tzr?: Maybe<Scalars['Decimal']>;
  /** Год сезона. */
  year: Scalars['Short'];
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Сезонное значение строки итогов. */
export type BimcCalculationResultSeasonDataInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  mp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  mz?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  op?: InputMaybe<Scalars['Decimal']>;
  others?: InputMaybe<Scalars['Decimal']>;
  oz?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Доля сезона, % (информационно, только для уровней с собственным распределением). */
  percent: Scalars['Decimal'];
  smrTotal?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  total?: InputMaybe<Scalars['Decimal']>;
  tzm?: InputMaybe<Scalars['Decimal']>;
  tzr?: InputMaybe<Scalars['Decimal']>;
  /** Год сезона. */
  year: Scalars['Short'];
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Сквозной тип строки итогов расчёта НМЦ по методологии БИМ. */
export enum BimcCalculationResultTypeEnum {
  /** Дополнительная транспортировка глав 1-7 (группа строк, уровень объекта и выше). */
  AdditionalTransportation = 'ADDITIONAL_TRANSPORTATION',
  /** Лимиты Заказчика (группа строк, уровень объекта и выше). */
  CustomerLimits = 'CUSTOMER_LIMITS',
  /** Итоговая строка уровня («Итого по подобъекту/объекту/виду строительства/расчёту НМЦ»). */
  GrandTotal = 'GRAND_TOTAL',
  /** Размер инфляции на год (сезонные значения строки итогов по главам). */
  Inflation = 'INFLATION',
  /** Лимитированные затраты главы 8 (группа строк, уровень объекта и выше). */
  LimitedCostsChapter8 = 'LIMITED_COSTS_CHAPTER8',
  /** Лимитированные затраты главы 9 (группа строк, уровень объекта и выше). */
  LimitedCostsChapter9 = 'LIMITED_COSTS_CHAPTER9',
  /** Прочие затраты главы 9 (группа строк, уровень объекта и выше). */
  OthersChapter9 = 'OTHERS_CHAPTER9',
  /** Итого по главам 1-7 в ценах 2001 г. */
  TotalChapter1_7Base = 'TOTAL_CHAPTER1_7_BASE',
  /** Итого по главам 1-7 в текущем уровне цен. */
  TotalChapter1_7Current = 'TOTAL_CHAPTER1_7_CURRENT',
  /** Итого по главам 1-7 в текущем уровне цен с учётом ДТ (уровень объекта и выше). */
  TotalChapter1_7WithTransport = 'TOTAL_CHAPTER1_7_WITH_TRANSPORT',
  /** Итого по главам 1-8 в текущем уровне цен. */
  TotalChapter1_8Current = 'TOTAL_CHAPTER1_8_CURRENT',
  /** Итого по главам 1-9 в текущем уровне цен. */
  TotalChapter1_9Current = 'TOTAL_CHAPTER1_9_CURRENT',
  /** Итого по главам 1-12 в текущем уровне цен (при наличии главы 12). */
  TotalChapter1_12Current = 'TOTAL_CHAPTER1_12_CURRENT',
  /** Итого по главе 8 в ценах 2001 г. */
  TotalChapter8Base = 'TOTAL_CHAPTER8_BASE',
  /** Итого ЛСР по главе 8 в текущем уровне цен. */
  TotalChapter8Current = 'TOTAL_CHAPTER8_CURRENT',
  /** Итого по главе 8 «Временные здания и сооружения». */
  TotalChapter8Temporary = 'TOTAL_CHAPTER8_TEMPORARY',
  /** Итого по главе 9 в ценах 2001 г. */
  TotalChapter9Base = 'TOTAL_CHAPTER9_BASE',
  /** Итого ЛСР по главе 9 в текущем уровне цен. */
  TotalChapter9Current = 'TOTAL_CHAPTER9_CURRENT',
  /** Итого по главе 9 «Прочие работы и затраты». */
  TotalChapter9OtherWorks = 'TOTAL_CHAPTER9_OTHER_WORKS',
  /** Итого ЛСР по главе 12 в ценах 2001 г. (при наличии главы 12). */
  TotalChapter12Base = 'TOTAL_CHAPTER12_BASE',
  /** Итого ЛСР по главе 12 в текущем уровне цен (при наличии главы 12). */
  TotalChapter12Current = 'TOTAL_CHAPTER12_CURRENT',
  /** Итого лимитированные затраты по главе 8. */
  TotalLimitedCostsChapter8 = 'TOTAL_LIMITED_COSTS_CHAPTER8',
  /** Итого лимитированные затраты по главе 9. */
  TotalLimitedCostsChapter9 = 'TOTAL_LIMITED_COSTS_CHAPTER9',
  /** Итого прочие затраты по главе 9. */
  TotalOthersChapter9 = 'TOTAL_OTHERS_CHAPTER9',
  /** ИТОГО с непредвиденными и мотивационными затратами. */
  TotalWithCustomerLimits = 'TOTAL_WITH_CUSTOMER_LIMITS',
  /** ИТОГО по главам с учётом инфляции. */
  TotalWithInflation = 'TOTAL_WITH_INFLATION',
  /** Индексы перевода в текущий уровень цен (не рассчитывается). */
  TransferIndex = 'TRANSFER_INDEX'
}

/** Данные сезона расчёта БИМ (строк звено, «Сезон» = год). */
export type BimcCalculationSeasonData = {
  __typename?: 'BimcCalculationSeasonData';
  /** Идентификатор строки-звена CalculationSeason. */
  id: Scalars['Long'];
  /** Значение инфляции сезона (4 знака). */
  inflation: Scalars['Decimal'];
  isActive: Scalars['Boolean'];
  /** Год сезона. */
  year: Scalars['Int'];
};

/** Данные сезона расчёта БИМ (строк звено, «Сезон» = год). */
export type BimcCalculationSeasonDataInput = {
  /** Идентификатор строки-звена CalculationSeason. */
  id: Scalars['Long'];
  /** Значение инфляции сезона (4 знака). */
  inflation: Scalars['Decimal'];
  isActive: Scalars['Boolean'];
  /** Год сезона. */
  year: Scalars['Int'];
};

/** Инфляция по сезону (год) расчёта БИМ (4 знака). */
export type BimcCalculationSeasonInflationData = {
  __typename?: 'BimcCalculationSeasonInflationData';
  /** Значение инфляции для сезона (4 знака). */
  inflation: Scalars['Decimal'];
  /** Год сезона. */
  year: Scalars['Int'];
};

/** Инфляция по сезону (год) расчёта БИМ (4 знака). */
export type BimcCalculationSeasonInflationDataInput = {
  /** Значение инфляции для сезона (4 знака). */
  inflation: Scalars['Decimal'];
  /** Год сезона. */
  year: Scalars['Int'];
};

/** Input инфляции по сезону (год) (ТЗ 501.1, 4 знака). */
export type BimcCalculationSeasonInflationInput = {
  inflation: Scalars['Decimal'];
  year: Scalars['Short'];
};

/** Input смены статуса карточки БИМ */
export type BimcCalculationStatusInput = {
  calculationUniqueId: Scalars['String'];
  status: CalculationStatusEnum;
};

/** Input создания подобъекта структуры расчёта (БИМ). */
export type BimcCalculationSubObjectCreateInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Признак гарантированного объёма. */
  hasGuaranteedVolume: Scalars['Boolean'];
  name: Scalars['String'];
  /** Родительский объект/подобъект. */
  objectId: Scalars['Long'];
  /** Распределение итогов по сезонам на объект/подобъект (сумма = 100 для уровней 1/2). */
  seasons: Array<CalculationObjectSeasonInput>;
};

/** Input обновления карточки БИМ */
export type BimcCalculationUpdateInput = {
  /** Привязка видов строительства к расчёту. */
  constructionTypes: Array<BimcCalculationConstructionTypeInput>;
  contractType: ContractTypeEnum;
  /** Количество знаков после запятой при округлении (0 — целое, 2 — два знака). */
  costRounding: Scalars['Int'];
  customerAddress?: InputMaybe<Scalars['String']>;
  id: Scalars['Long'];
  note?: InputMaybe<Scalars['String']>;
  /** Инфляция по сезонам (4 знака). */
  seasonsInflation: Array<BimcCalculationSeasonInflationInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: CalculationStatusEnum;
  subject?: InputMaybe<Scalars['String']>;
  /** Базис поставки (обязательное поле по ТЗ). */
  supplyBasis: Scalars['String'];
  /** Ставка НДС в процентах (null — «не менять»). */
  taxPercent?: InputMaybe<Scalars['Decimal']>;
};

/** Навигация договора */
export type BimcContractNavigationData = {
  __typename?: 'BimcContractNavigationData';
  /** Данные договора */
  contractNavData: Uer_ContractNavData;
  /** Список элементов навигации договора (ДС, прейскуранты, лимиты прочих затрат) */
  contractNavItems?: Maybe<Array<Uer_ContractItemNavData>>;
  /** Список навигации НЗ */
  workOrderNavs?: Maybe<Array<Uerc_WorkOrderNavData>>;
};

/** A segment of a collection. */
export type BimcGlobalLimitedCostsForCalculationCollectionSegment = {
  __typename?: 'BimcGlobalLimitedCostsForCalculationCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalLimitedCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcGlobalOtherCostsForCalculationCollectionSegment = {
  __typename?: 'BimcGlobalOtherCostsForCalculationCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcLocalEstimateCompositionCodeFilterCollectionSegment = {
  __typename?: 'BimcLocalEstimateCompositionCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcLocalEstimateCompositionCollectionSegment = {
  __typename?: 'BimcLocalEstimateCompositionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<LocalEstimateCompositionRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcLocalEstimateCompositionNameFilterCollectionSegment = {
  __typename?: 'BimcLocalEstimateCompositionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcLocalEstimateTableCodeFilterCollectionSegment = {
  __typename?: 'BimcLocalEstimateTableCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcLocalEstimateTableNameFilterCollectionSegment = {
  __typename?: 'BimcLocalEstimateTableNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type BimcLocalEstimateTableObjectFilterCollectionSegment = {
  __typename?: 'BimcLocalEstimateTableObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Тип сметы, простая или укрупненная */
export enum BimcLocalEstimateTypeEnum {
  /** Укрупненная смета */
  Aggregate = 'AGGREGATE',
  /** Простая смета */
  Simple = 'SIMPLE'
}

export type BimcLocalEstimateTypeEnumOperationFilterInput = {
  eq?: InputMaybe<BimcLocalEstimateTypeEnum>;
  in?: InputMaybe<Array<BimcLocalEstimateTypeEnum>>;
  neq?: InputMaybe<BimcLocalEstimateTypeEnum>;
  nin?: InputMaybe<Array<BimcLocalEstimateTypeEnum>>;
};

/** A segment of a collection. */
export type BimcLocalEstimatesTableCollectionSegment = {
  __typename?: 'BimcLocalEstimatesTableCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<LocalEstimateTableItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Уровень цен для отображения сумм сметы (базисный/текущий). */
export enum BimcPriceLevelEnum {
  /** Базисный уровень цен. */
  BasicPriceLevel = 'BASIC_PRICE_LEVEL',
  /** Текущий уровень цен. */
  CurrentPriceLevel = 'CURRENT_PRICE_LEVEL'
}

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']>>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

/** Общие данные Расчета НМЦ */
export type CalculationCommonData = {
  __typename?: 'CalculationCommonData';
  /** Навигация Расчета */
  calculationNavigation: CalculationNavigationData;
  /** Данные стоимости Расчета */
  calculationPrice?: Maybe<CalculationPriceData>;
};

/** Общие данные Расчета НМЦ */
export type CalculationCommonDataInput = {
  /** Навигация Расчета */
  calculationNavigation: CalculationNavigationDataInput;
  /** Данные стоимости Расчета */
  calculationPrice?: InputMaybe<CalculationPriceDataInput>;
};

/** Строка итогов расчета НМЦ */
export type CalculationComputeRow = {
  __typename?: 'CalculationComputeRow';
  /** Глава позиции */
  chapter?: Maybe<ChapterEnum>;
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Id строки расчета */
  computedCostId?: Maybe<Scalars['Long']>;
  /** Идентификатор сущности строки (расценки, коэфициента, МТР, прочей, лимитированной) */
  entityId: Scalars['Long'];
  /** Тип сущности, по которой сформирована строка итогов */
  entityType?: Maybe<ComputeRowTypeEnum>;
  /** Наимеование */
  name?: Maybe<Scalars['String']>;
  /** Id объекта */
  objectId?: Maybe<Scalars['Long']>;
  /** Название конечного объекта (подобъекта) */
  objectName?: Maybe<Scalars['String']>;
  /** Id корневого объекта */
  rootObjectId: Scalars['Long'];
  /** Название корневого объекта */
  rootObjectName: Scalars['String'];
  /** Значения по сезонам по строке */
  seasonValues?: Maybe<Array<CalculationComputeSeasonValue>>;
  /** Общая стоимость по строке, руб. без НДС */
  totalCost?: Maybe<Scalars['Decimal']>;
  /** Общий объем по строке */
  totalVolume?: Maybe<Scalars['Decimal']>;
  /** Шифр расценки УЕР из сборника */
  uerCode?: Maybe<Scalars['String']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: Maybe<WorkInSumEnum>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

/** Строка итогов расчета НМЦ */
export type CalculationComputeRowFilterInput = {
  and?: InputMaybe<Array<CalculationComputeRowFilterInput>>;
  /** Глава позиции */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id строки расчета */
  computedCostId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сущности строки (расценки, коэфициента, МТР, прочей, лимитированной) */
  entityId?: InputMaybe<LongOperationFilterInput>;
  /** Тип сущности, по которой сформирована строка итогов */
  entityType?: InputMaybe<NullableOfComputeRowTypeEnumOperationFilterInput>;
  /** Наимеование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id объекта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  /** Название конечного объекта (подобъекта) */
  objectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CalculationComputeRowFilterInput>>;
  /** Id корневого объекта */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Название корневого объекта */
  rootObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Значения по сезонам по строке */
  seasonValues?: InputMaybe<ListFilterInputTypeOfCalculationComputeSeasonValueFilterInput>;
  /** Общая стоимость по строке, руб. без НДС */
  totalCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий объем по строке */
  totalVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр расценки УЕР из сборника */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<NullableOfWorkInSumEnumOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Строка итогов расчета НМЦ */
export type CalculationComputeRowInput = {
  /** Глава позиции */
  chapter?: InputMaybe<ChapterEnum>;
  /** Шифр */
  code?: InputMaybe<Scalars['String']>;
  /** Id строки расчета */
  computedCostId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор сущности строки (расценки, коэфициента, МТР, прочей, лимитированной) */
  entityId: Scalars['Long'];
  /** Тип сущности, по которой сформирована строка итогов */
  entityType?: InputMaybe<ComputeRowTypeEnum>;
  /** Наимеование */
  name?: InputMaybe<Scalars['String']>;
  /** Id объекта */
  objectId?: InputMaybe<Scalars['Long']>;
  /** Название конечного объекта (подобъекта) */
  objectName?: InputMaybe<Scalars['String']>;
  /** Id корневого объекта */
  rootObjectId: Scalars['Long'];
  /** Название корневого объекта */
  rootObjectName: Scalars['String'];
  /** Значения по сезонам по строке */
  seasonValues?: InputMaybe<Array<CalculationComputeSeasonValueInput>>;
  /** Общая стоимость по строке, руб. без НДС */
  totalCost?: InputMaybe<Scalars['Decimal']>;
  /** Общий объем по строке */
  totalVolume?: InputMaybe<Scalars['Decimal']>;
  /** Шифр расценки УЕР из сборника */
  uerCode?: InputMaybe<Scalars['String']>;
  /** Единица измерения */
  unit?: InputMaybe<Scalars['String']>;
  /** Стоимость за единицу */
  unitCost?: InputMaybe<Scalars['Decimal']>;
  /** Шифр */
  workCode?: InputMaybe<Scalars['String']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<WorkInSumEnum>;
  /** Наименование */
  workName?: InputMaybe<Scalars['String']>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<Scalars['Decimal']>;
  /** К перехода */
  workRatio?: InputMaybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: InputMaybe<Scalars['String']>;
};

export type CalculationComputeSeasonValue = {
  __typename?: 'CalculationComputeSeasonValue';
  /** Стоимость в сезоне для прочих */
  cost?: Maybe<Scalars['Decimal']>;
  /** Ошибки при расчете стоимости по сезону */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Значение объема в сезоне */
  volume?: Maybe<Scalars['Decimal']>;
};

export type CalculationComputeSeasonValueFilterInput = {
  and?: InputMaybe<Array<CalculationComputeSeasonValueFilterInput>>;
  /** Стоимость в сезоне для прочих */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  /** Ошибки при расчете стоимости по сезону */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CalculationComputeSeasonValueFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Значение объема в сезоне */
  volume?: InputMaybe<DecimalOperationFilterInput>;
};

export type CalculationComputeSeasonValueInput = {
  /** Стоимость в сезоне для прочих */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Ошибки при расчете стоимости по сезону */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Значение объема в сезоне */
  volume?: InputMaybe<Scalars['Decimal']>;
};

export type CalculationComputeTotalData = {
  __typename?: 'CalculationComputeTotalData';
  guaranteedVolume?: Maybe<Array<CalculationComputeTotalRow>>;
  nonguaranteedVolume?: Maybe<Array<CalculationComputeTotalRow>>;
  summary: Array<CalculationComputeTotalRow>;
};

/** Строка итога */
export type CalculationComputeTotalRow = {
  __typename?: 'CalculationComputeTotalRow';
  isHeadLine: Scalars['Boolean'];
  name: Scalars['String'];
  /** Значения итога по сезонам */
  seasonTotal: Array<SeasonTotalData>;
  totalCost: Scalars['Decimal'];
};

/** Данные элемента навигации расчета */
export type CalculationItemNavData = {
  __typename?: 'CalculationItemNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Данные элемента навигации расчета */
export type CalculationItemNavDataInput = {
  /** Идентификатор объекта */
  id?: InputMaybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Данные навигации расчета */
export type CalculationNavData = {
  __typename?: 'CalculationNavData';
  /** Флаг наличия расчета */
  hasCalculation: Scalars['Boolean'];
  /** Флаг наличия объектов строительства */
  hasCalculationObjects: Scalars['Boolean'];
  /** Флаг наличия ВОР */
  hasWOR: Scalars['Boolean'];
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Данные навигации расчета */
export type CalculationNavDataInput = {
  /** Флаг наличия расчета */
  hasCalculation: Scalars['Boolean'];
  /** Флаг наличия объектов строительства */
  hasCalculationObjects: Scalars['Boolean'];
  /** Флаг наличия ВОР */
  hasWOR: Scalars['Boolean'];
  /** Идентификатор объекта */
  id?: InputMaybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Навигация расчета */
export type CalculationNavigationData = {
  __typename?: 'CalculationNavigationData';
  /** Данные расчета */
  calculationNavData: CalculationNavData;
  /** Список элементов навигации расчета */
  calculationNavItems?: Maybe<Array<CalculationItemNavData>>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
};

/** Навигация расчета */
export type CalculationNavigationDataInput = {
  /** Данные расчета */
  calculationNavData: CalculationNavDataInput;
  /** Список элементов навигации расчета */
  calculationNavItems?: InputMaybe<Array<CalculationItemNavDataInput>>;
};

/** Входные данные для копирования объекта */
export type CalculationObjectCopyInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор копируемого объекта */
  copyCalculationObjectId: Scalars['Int'];
  /** Расположить новый объект после данного объекта */
  placeAfterCalculationObjectId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор объекта внутрь которого скопировать копируемый объект */
  placeInsideCalculationObjectId?: InputMaybe<Scalars['Int']>;
};

/** Входные данные для создания объекта */
export type CalculationObjectCreateInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
};

/** Объект\подобъект Расчета НМЦ */
export type CalculationObjectData = {
  __typename?: 'CalculationObjectData';
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Имеет ли объект/подобъект записи ВОР (без учёта наличия введенных объёмов) */
  hasWorItems: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Номер объекта\подобъекта в структуре */
  order?: Maybe<Scalars['Int']>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
};

/** Объект\подобъект Расчета НМЦ */
export type CalculationObjectDataInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Имеет ли объект/подобъект записи ВОР (без учёта наличия введенных объёмов) */
  hasWorItems: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Номер объекта\подобъекта в структуре */
  order?: InputMaybe<Scalars['Int']>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
};

/** Объект\подобъект Расчета НМЦ */
export type CalculationObjectDataSortInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Имеет ли объект/подобъект записи ВОР (без учёта наличия введенных объёмов) */
  hasWorItems?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Номер объекта\подобъекта в структуре */
  order?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
};

/** Входные данные установки признака гаранта объекту\подобъекту */
export type CalculationObjectGuaranteedVolumeInput = {
  /** Признак гарантированного объема */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Идентификатор объекта\подобъекта */
  objectId: Scalars['Long'];
};

/** Input перемещения объекта/подобъекта структуры расчёта (БИМ). */
export type CalculationObjectMoveInput = {
  /** Объект, после которого вставить перемещаемый (0 — в начало ветки). */
  insertAfterObjectId?: InputMaybe<Scalars['Long']>;
  /** Новый родитель (null — перемещение на уровень корня в рамках вида). */
  newParentObjectId?: InputMaybe<Scalars['Long']>;
  objectId: Scalars['Long'];
};

/** Распределение итогов по сезонам на объект/подобъект структуры расчёта (БИМ). */
export type CalculationObjectSeasonData = {
  __typename?: 'CalculationObjectSeasonData';
  /** Ссылка на сезон расчёта (Id). */
  calculationSeasonId: Scalars['Long'];
  id: Scalars['Long'];
  /** Распределение в процентах (0.00–100.00). */
  percent: Scalars['Decimal'];
  /** Год сезона. */
  year: Scalars['Int'];
};

/** Распределение итогов по сезонам для одного объекта/подобъекта структуры расчёта (БИМ). */
export type CalculationObjectSeasonDistributionInput = {
  /** Идентификатор объекта/подобъекта. */
  objectId: Scalars['Long'];
  /** Распределение итогов по сезонам (сумма = 100 для уровней 1/2). */
  seasons: Array<CalculationObjectSeasonInput>;
};

/** Распределение итогов по сезонам на объект/подобъект структуры расчёта (БИМ). */
export type CalculationObjectSeasonInput = {
  /** Ссылка на сезон расчёта. */
  calculationSeasonId: Scalars['Long'];
  /** Распределение в процентах (0.00–100.00). */
  percent: Scalars['Decimal'];
};

/** Входные данные для обновления объекта\подобъекта */
export type CalculationObjectUpdateInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор объекта */
  objectId: Scalars['Long'];
};

export type CalculationOtherCostTotalSum = {
  __typename?: 'CalculationOtherCostTotalSum';
  sum: Scalars['Decimal'];
};

export type CalculationOtherCostTotalSumInput = {
  sum: Scalars['Decimal'];
};

/** Тип строки среза предварительного просмотра расчёта НМЦ. */
export enum CalculationPreviewRowTypeEnum {
  /** Доп. транспорт. */
  AditionalTransportation = 'ADITIONAL_TRANSPORTATION',
  /** Глава сметы. */
  Chapter = 'CHAPTER',
  /** Лимитированные затраты. */
  LimitedCost = 'LIMITED_COST',
  /** Локальная смета (ЛСР) или укрупнённая ЛСР. */
  Lsr = 'LSR',
  /** Объект/подобъект структуры расчёта. */
  Object = 'OBJECT',
  /** Прочие затраты. */
  OtherCost = 'OTHER_COST'
}

export type CalculationPreviewRowTypeEnumOperationFilterInput = {
  eq?: InputMaybe<CalculationPreviewRowTypeEnum>;
  in?: InputMaybe<Array<CalculationPreviewRowTypeEnum>>;
  neq?: InputMaybe<CalculationPreviewRowTypeEnum>;
  nin?: InputMaybe<Array<CalculationPreviewRowTypeEnum>>;
};

/** Cтоимость расчета */
export type CalculationPriceData = {
  __typename?: 'CalculationPriceData';
  /** Цена расчета без НДС */
  priceNMC?: Maybe<Scalars['Decimal']>;
};

/** Cтоимость расчета */
export type CalculationPriceDataInput = {
  /** Цена расчета без НДС */
  priceNMC?: InputMaybe<Scalars['Decimal']>;
};

/** Статусы расчета НМЦ */
export enum CalculationStatusEnum {
  /** Сформирован */
  Completed = 'COMPLETED',
  /** На формировании */
  OnFormation = 'ON_FORMATION'
}

/** Входные данные для создания подобъекта */
export type CalculationSubObjectCreateInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Гарантированный объем */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  objectId: Scalars['Long'];
};

/** Данные изменений справочника видов строительства */
export type CatalogConstructionTypeChangesData = {
  __typename?: 'CatalogConstructionTypeChangesData';
  /** Идентификатор справочника */
  catalogId: Scalars['Long'];
  /** Дата последнего изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Данные изменений справочника видов строительства */
export type CatalogConstructionTypeChangesDataInput = {
  /** Идентификатор справочника */
  catalogId: Scalars['Long'];
  /** Дата последнего изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CatalogConstructionTypeCreateInput = {
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  fullName: Scalars['String'];
  iconCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  shortName: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogConstructionTypeItemsCollectionSegment = {
  __typename?: 'CatalogConstructionTypeItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConstructionTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogConstructionTypeUpdateInput = {
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  fullName: Scalars['String'];
  iconCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogConstructionTypesCollectionSegment = {
  __typename?: 'CatalogConstructionTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConstructionTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Справочник */
export type CatalogCreateInput = {
  /** Наименование */
  name?: InputMaybe<Scalars['String']>;
  /** Уникальный идентификатор типа */
  typeUniqueId: Scalars['String'];
};

/** Справочник */
export type CatalogData = {
  __typename?: 'CatalogData';
  /** Автор */
  authoredBy?: Maybe<Scalars['String']>;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Идентификатор справочника */
  id: Scalars['Long'];
  /** Метаданные справочника */
  metadata?: Maybe<Scalars['JSON']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор дочернего общества */
  subsidiaryId?: Maybe<Scalars['Long']>;
  /** Наименование дочернего общества */
  subsidiaryName?: Maybe<Scalars['String']>;
  /** Тип справочника */
  type: CatalogTypeData;
  /** Уникальный идентификатор справочника */
  uniqueId: Scalars['String'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Справочник */
export type CatalogDataInput = {
  /** Автор */
  authoredBy?: InputMaybe<Scalars['String']>;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Идентификатор справочника */
  id: Scalars['Long'];
  /** Метаданные справочника */
  metadata?: InputMaybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор дочернего общества */
  subsidiaryId?: InputMaybe<Scalars['Long']>;
  /** Наименование дочернего общества */
  subsidiaryName?: InputMaybe<Scalars['String']>;
  /** Тип справочника */
  type: CatalogTypeDataInput;
  /** Уникальный идентификатор справочника */
  uniqueId: Scalars['String'];
  /** Дата изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Справочник */
export type CatalogItemData = {
  __typename?: 'CatalogItemData';
  /** Автор */
  authoredBy?: Maybe<Scalars['String']>;
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Идентификатор справочника */
  id: Scalars['Long'];
  /** Метаданные справочника */
  metadata?: Maybe<Scalars['JSON']>;
  /** Наименование */
  name: Scalars['String'];
  subsidiaryId?: Maybe<Scalars['Long']>;
  /** Наименование дочернего общества */
  subsidiaryName?: Maybe<Scalars['String']>;
  /** Тип справочника */
  type: CatalogTypeData;
  /** Уникальный идентификатор справочника */
  uniqueId: Scalars['String'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Справочник */
export type CatalogItemDataFilterInput = {
  and?: InputMaybe<Array<CatalogItemDataFilterInput>>;
  /** Автор */
  authoredBy?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Дата создания */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Идентификатор справочника */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Метаданные справочника */
  metadata?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogItemDataFilterInput>>;
  subsidiaryId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование дочернего общества */
  subsidiaryName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Тип справочника */
  type?: InputMaybe<CatalogTypeDataFilterInput>;
  /** Уникальный идентификатор справочника */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Дата изменения */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Справочник */
export type CatalogItemDataSortInput = {
  /** Автор */
  authoredBy?: InputMaybe<SortEnumType>;
  /** Дата создания */
  createdAt?: InputMaybe<SortEnumType>;
  /** Идентификатор справочника */
  id?: InputMaybe<SortEnumType>;
  /** Метаданные справочника */
  metadata?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  subsidiaryId?: InputMaybe<SortEnumType>;
  /** Наименование дочернего общества */
  subsidiaryName?: InputMaybe<SortEnumType>;
  /** Тип справочника */
  type?: InputMaybe<CatalogTypeDataSortInput>;
  /** Уникальный идентификатор справочника */
  uniqueId?: InputMaybe<SortEnumType>;
  /** Дата изменения */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Тип лимитированной из каталога */
export type CatalogLimitedCostTypeData = {
  __typename?: 'CatalogLimitedCostTypeData';
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип лимитированной из каталога */
export type CatalogLimitedCostTypeDataFilterInput = {
  and?: InputMaybe<Array<CatalogLimitedCostTypeDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogLimitedCostTypeDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Тип лимитированной из каталога */
export type CatalogLimitedCostTypeDataInput = {
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип лимитированной из каталога */
export type CatalogLimitedCostTypeDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Тип лимитированной из каталога с атрибутами для редактирования */
export type CatalogLimitedCostTypeExtendedData = {
  __typename?: 'CatalogLimitedCostTypeExtendedData';
  /** Признак возможности удаления */
  canDelete: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Признак системного типа */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип лимитированной из каталога с атрибутами для редактирования */
export type CatalogLimitedCostTypeExtendedDataFilterInput = {
  and?: InputMaybe<Array<CatalogLimitedCostTypeExtendedDataFilterInput>>;
  /** Признак возможности удаления */
  canDelete?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Признак системного типа */
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogLimitedCostTypeExtendedDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Тип лимитированной из каталога с атрибутами для редактирования */
export type CatalogLimitedCostTypeExtendedDataInput = {
  /** Признак возможности удаления */
  canDelete: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Признак системного типа */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип лимитированной из каталога с атрибутами для редактирования */
export type CatalogLimitedCostTypeExtendedDataSortInput = {
  /** Признак возможности удаления */
  canDelete?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак системного типа */
  isSystem?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Входные данные для создания типа лимитированных */
export type CatalogLimitedCostTypeInput = {
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogNameFilterCollectionSegment = {
  __typename?: 'CatalogNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Тип прочей из каталога */
export type CatalogOtherCostTypeBase = {
  __typename?: 'CatalogOtherCostTypeBase';
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип прочей из каталога */
export type CatalogOtherCostTypeBaseFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostTypeBaseFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostTypeBaseFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Тип прочей из каталога */
export type CatalogOtherCostTypeBaseInput = {
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип прочей из каталога */
export type CatalogOtherCostTypeBaseSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Входные данные для создания типа прочих */
export type CatalogOtherCostTypeCreateInput = {
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
};

/** Тип прочей из каталога с атрибутами для редактирования */
export type CatalogOtherCostTypeData = {
  __typename?: 'CatalogOtherCostTypeData';
  /** Признак возможности удаления */
  canDelete: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Признак системного типа */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип прочей из каталога с атрибутами для редактирования */
export type CatalogOtherCostTypeDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostTypeDataFilterInput>>;
  /** Признак возможности удаления */
  canDelete?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Признак системного типа */
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostTypeDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Тип прочей из каталога с атрибутами для редактирования */
export type CatalogOtherCostTypeDataInput = {
  /** Признак возможности удаления */
  canDelete: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Признак системного типа */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип прочей из каталога с атрибутами для редактирования */
export type CatalogOtherCostTypeDataSortInput = {
  /** Признак возможности удаления */
  canDelete?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак системного типа */
  isSystem?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Входные данные для обновления типа прочих */
export type CatalogOtherCostTypeUpdateInput = {
  /** Идентификатор типа прочих */
  id: Scalars['Int'];
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
};

/** Переменная для прочих затрат */
export type CatalogOtherCostVariableCreateInput = {
  /** Идентификатор справочника */
  catalogUniqueId: Scalars['String'];
  /** Идентификатор источника данных */
  dataSourceId?: InputMaybe<Scalars['Int']>;
  /** Сущности переменной */
  entityUniqueIds?: InputMaybe<Array<Scalars['String']>>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор группы переменных */
  groupId: Scalars['Int'];
  /** Создаваемая переменная должна быть добавлена в глобальный справочник? */
  isGlobal: Scalars['Boolean'];
  /** Идентификатор записи типа переменной из справочника */
  limitedCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Тип переменной */
  type: CatalogOtherCostVariableTypeEnum;
};

/** Переменная для прочих затрат */
export type CatalogOtherCostVariableData = {
  __typename?: 'CatalogOtherCostVariableData';
  /** Источник данных */
  dataSource?: Maybe<CatalogOtherCostVariableDataSourceData>;
  /** Сущности */
  entities: Array<CatalogOtherCostVariableEntityData>;
  /** Формула */
  formula?: Maybe<Scalars['String']>;
  /** Группа переменных */
  group: CatalogOtherCostVariableGroupData;
  /** Идентификатор переменной */
  id: Scalars['Long'];
  /** Системная переменная? */
  isSystem: Scalars['Boolean'];
  /** Идентификатор записи типа лимитированной из каталог */
  limitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: Maybe<Scalars['Int']>;
  subsidiaryId?: Maybe<Scalars['Long']>;
  /** Наименование дочернего общества */
  subsidiaryName?: Maybe<Scalars['String']>;
  /** Тип переменной */
  type: CatalogOtherCostVariableTypeEnum;
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Переменная для прочих затрат */
export type CatalogOtherCostVariableDataInput = {
  /** Источник данных */
  dataSource?: InputMaybe<CatalogOtherCostVariableDataSourceDataInput>;
  /** Сущности */
  entities: Array<CatalogOtherCostVariableEntityDataInput>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Группа переменных */
  group: CatalogOtherCostVariableGroupDataInput;
  /** Идентификатор переменной */
  id: Scalars['Long'];
  /** Системная переменная? */
  isSystem: Scalars['Boolean'];
  /** Идентификатор записи типа лимитированной из каталог */
  limitedCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: InputMaybe<Scalars['Int']>;
  subsidiaryId?: InputMaybe<Scalars['Long']>;
  /** Наименование дочернего общества */
  subsidiaryName?: InputMaybe<Scalars['String']>;
  /** Тип переменной */
  type: CatalogOtherCostVariableTypeEnum;
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Источник данных */
export type CatalogOtherCostVariableDataSourceData = {
  __typename?: 'CatalogOtherCostVariableDataSourceData';
  /** Строка источника в базе данных */
  dataSourceId: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
};

/** Источник данных */
export type CatalogOtherCostVariableDataSourceDataInput = {
  /** Строка источника в базе данных */
  dataSourceId: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
};

/** Источник данных */
export type CatalogOtherCostVariableDataSourceItemData = {
  __typename?: 'CatalogOtherCostVariableDataSourceItemData';
  /** Идентификатор источника в базе данных */
  dataSourceId: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование источника данных */
  name: Scalars['String'];
};

/** Источник данных */
export type CatalogOtherCostVariableDataSourceItemDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostVariableDataSourceItemDataFilterInput>>;
  /** Идентификатор источника в базе данных */
  dataSourceId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Наименование источника данных */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostVariableDataSourceItemDataFilterInput>>;
};

/** Источник данных */
export type CatalogOtherCostVariableDataSourceItemDataSortInput = {
  /** Идентификатор источника в базе данных */
  dataSourceId?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование источника данных */
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CatalogOtherCostVariableDataSourcesCollectionSegment = {
  __typename?: 'CatalogOtherCostVariableDataSourcesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostVariableDataSourceItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Сущность для переменной */
export type CatalogOtherCostVariableEntityData = {
  __typename?: 'CatalogOtherCostVariableEntityData';
  /** Системная сущность? */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Сущность для переменной */
export type CatalogOtherCostVariableEntityDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostVariableEntityDataFilterInput>>;
  /** Системная сущность? */
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostVariableEntityDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Сущность для переменной */
export type CatalogOtherCostVariableEntityDataInput = {
  /** Системная сущность? */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Сущность для переменной */
export type CatalogOtherCostVariableEntityItemData = {
  __typename?: 'CatalogOtherCostVariableEntityItemData';
  /** Системная сущность? */
  isSystem: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Сущность для переменной */
export type CatalogOtherCostVariableEntityItemDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostVariableEntityItemDataFilterInput>>;
  /** Системная сущность? */
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostVariableEntityItemDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Сущность для переменной */
export type CatalogOtherCostVariableEntityItemDataSortInput = {
  /** Системная сущность? */
  isSystem?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Данные для создания Группы переменных для прочих затрат */
export type CatalogOtherCostVariableGroupCreateInput = {
  /** Уникальный идентификатор справочника */
  catalogUniqueId: Scalars['String'];
  /** Создаваемая группа должна быть добавлена в список глобальных групп? */
  isGlobal: Scalars['Boolean'];
  /** Методология */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
};

/** Группа переменных */
export type CatalogOtherCostVariableGroupData = {
  __typename?: 'CatalogOtherCostVariableGroupData';
  /** Идентификатор */
  id: Scalars['Int'];
  /** Методология */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор дочернего общества */
  subsidiaryId?: Maybe<Scalars['Long']>;
};

/** Группа переменных */
export type CatalogOtherCostVariableGroupDataInput = {
  /** Идентификатор */
  id: Scalars['Int'];
  /** Методология */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор дочернего общества */
  subsidiaryId?: InputMaybe<Scalars['Long']>;
};

/** Сущность для группы переменных */
export type CatalogOtherCostVariableGroupItemData = {
  __typename?: 'CatalogOtherCostVariableGroupItemData';
  /** Идентификатор */
  id: Scalars['Int'];
  /** Методология */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор дочернего общества */
  subsidiaryId?: Maybe<Scalars['Long']>;
  /** Количество переменных в группе */
  variableCount: Scalars['Int'];
};

/** Сущность для группы переменных */
export type CatalogOtherCostVariableGroupItemDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostVariableGroupItemDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Методология */
  methodology?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostVariableGroupItemDataFilterInput>>;
  /** Идентификатор дочернего общества */
  subsidiaryId?: InputMaybe<LongOperationFilterInput>;
  /** Количество переменных в группе */
  variableCount?: InputMaybe<IntOperationFilterInput>;
};

/** Сущность для группы переменных */
export type CatalogOtherCostVariableGroupItemDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Методология */
  methodology?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор дочернего общества */
  subsidiaryId?: InputMaybe<SortEnumType>;
  /** Количество переменных в группе */
  variableCount?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CatalogOtherCostVariableGroupListCollectionSegment = {
  __typename?: 'CatalogOtherCostVariableGroupListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostVariableGroupItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные для обновления Группы переменных для прочих затрат */
export type CatalogOtherCostVariableGroupUpdateInput = {
  /** Уникальный идентификатор справочника */
  catalogUniqueId: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
};

export type CatalogOtherCostVariableISelectionItemData = {
  __typename?: 'CatalogOtherCostVariableISelectionItemData';
  /** Строка источника данных */
  dataSourceId?: Maybe<Scalars['String']>;
  /** Наименование источника данных */
  dataSourceName?: Maybe<Scalars['String']>;
  /** Наименование */
  entityName: Scalars['String'];
  /** Уникальный идентификатор */
  entityUniqueId: Scalars['String'];
  /** Признак глобальной переменной (SubsidiaryId == null) */
  isGlobal: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор типа прочих */
  otherTypeUniqueId?: Maybe<Scalars['String']>;
  /** Дочернее общество, которому принадлежит локальная переменная (null — глобальная) */
  subsidiaryId?: Maybe<Scalars['Long']>;
  /** Тип переменной */
  type: CatalogOtherCostVariableTypeEnum;
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

export type CatalogOtherCostVariableISelectionItemDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostVariableISelectionItemDataFilterInput>>;
  /** Строка источника данных */
  dataSourceId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование источника данных */
  dataSourceName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  entityName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор */
  entityUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак глобальной переменной (SubsidiaryId == null) */
  isGlobal?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostVariableISelectionItemDataFilterInput>>;
  /** Уникальный идентификатор типа прочих */
  otherTypeUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Дочернее общество, которому принадлежит локальная переменная (null — глобальная) */
  subsidiaryId?: InputMaybe<LongOperationFilterInput>;
  /** Тип переменной */
  type?: InputMaybe<CatalogOtherCostVariableTypeEnumOperationFilterInput>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type CatalogOtherCostVariableISelectionItemDataSortInput = {
  /** Строка источника данных */
  dataSourceId?: InputMaybe<SortEnumType>;
  /** Наименование источника данных */
  dataSourceName?: InputMaybe<SortEnumType>;
  /** Наименование */
  entityName?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  entityUniqueId?: InputMaybe<SortEnumType>;
  /** Признак глобальной переменной (SubsidiaryId == null) */
  isGlobal?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор типа прочих */
  otherTypeUniqueId?: InputMaybe<SortEnumType>;
  /** Дочернее общество, которому принадлежит локальная переменная (null — глобальная) */
  subsidiaryId?: InputMaybe<SortEnumType>;
  /** Тип переменной */
  type?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Переменная для прочих затрат */
export type CatalogOtherCostVariableItemData = {
  __typename?: 'CatalogOtherCostVariableItemData';
  /** Признак возможности удаления */
  canDelete: Scalars['Boolean'];
  /** Идентификатор источника данных */
  dataSourceId?: Maybe<Scalars['String']>;
  /** Идентификатор источника данных */
  dataSourceName?: Maybe<Scalars['String']>;
  /** Сущности */
  entities: Array<CatalogOtherCostVariableEntityData>;
  /** Формула */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор группы переменных */
  groupId: Scalars['Int'];
  /** Идентификатор группы переменных */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Тип лимитированной из каталога */
  limitedCostType?: Maybe<CatalogLimitedCostTypeExtendedData>;
  /** Идентификатор записи типа лимитированной из каталог */
  limitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Наименование */
  name: Scalars['String'];
  /** Тип переменной из справочника */
  otherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: Maybe<Scalars['Int']>;
  subsidiaryId?: Maybe<Scalars['Long']>;
  /** Наименование дочернего общества */
  subsidiaryName?: Maybe<Scalars['String']>;
  /** Тип переменной */
  type: CatalogOtherCostVariableTypeEnum;
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Переменная для прочих затрат */
export type CatalogOtherCostVariableItemDataFilterInput = {
  and?: InputMaybe<Array<CatalogOtherCostVariableItemDataFilterInput>>;
  /** Признак возможности удаления */
  canDelete?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор источника данных */
  dataSourceId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор источника данных */
  dataSourceName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Сущности */
  entities?: InputMaybe<ListFilterInputTypeOfCatalogOtherCostVariableEntityDataFilterInput>;
  /** Формула */
  formula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор группы переменных */
  groupId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор группы переменных */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Тип лимитированной из каталога */
  limitedCostType?: InputMaybe<CatalogLimitedCostTypeExtendedDataFilterInput>;
  /** Идентификатор записи типа лимитированной из каталог */
  limitedCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogOtherCostVariableItemDataFilterInput>>;
  /** Тип переменной из справочника */
  otherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  subsidiaryId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование дочернего общества */
  subsidiaryName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Тип переменной */
  type?: InputMaybe<CatalogOtherCostVariableTypeEnumOperationFilterInput>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Переменная для прочих затрат */
export type CatalogOtherCostVariableItemDataSortInput = {
  /** Признак возможности удаления */
  canDelete?: InputMaybe<SortEnumType>;
  /** Идентификатор источника данных */
  dataSourceId?: InputMaybe<SortEnumType>;
  /** Идентификатор источника данных */
  dataSourceName?: InputMaybe<SortEnumType>;
  /** Формула */
  formula?: InputMaybe<SortEnumType>;
  /** Идентификатор группы переменных */
  groupId?: InputMaybe<SortEnumType>;
  /** Идентификатор группы переменных */
  groupName?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Тип лимитированной из каталога */
  limitedCostType?: InputMaybe<CatalogLimitedCostTypeExtendedDataSortInput>;
  /** Идентификатор записи типа лимитированной из каталог */
  limitedCostTypeId?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Тип переменной из справочника */
  otherCostType?: InputMaybe<CatalogOtherCostTypeDataSortInput>;
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: InputMaybe<SortEnumType>;
  subsidiaryId?: InputMaybe<SortEnumType>;
  /** Наименование дочернего общества */
  subsidiaryName?: InputMaybe<SortEnumType>;
  /** Тип переменной */
  type?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CatalogOtherCostVariableSelectionItemsCollectionSegment = {
  __typename?: 'CatalogOtherCostVariableSelectionItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostVariableISelectionItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Тип переменной из справочника */
export enum CatalogOtherCostVariableTypeEnum {
  /** Составная */
  Composite = 'COMPOSITE',
  /** Ссылка на тип лимитированных */
  LimitedCostType = 'LIMITED_COST_TYPE',
  /** Ссылка на тип прочих */
  OtherCostType = 'OTHER_COST_TYPE',
  /** Простая */
  Simple = 'SIMPLE'
}

export type CatalogOtherCostVariableTypeEnumOperationFilterInput = {
  eq?: InputMaybe<CatalogOtherCostVariableTypeEnum>;
  in?: InputMaybe<Array<CatalogOtherCostVariableTypeEnum>>;
  neq?: InputMaybe<CatalogOtherCostVariableTypeEnum>;
  nin?: InputMaybe<Array<CatalogOtherCostVariableTypeEnum>>;
};

/** Данные для обновления Переменной для прочих затрат */
export type CatalogOtherCostVariableUpdateInput = {
  /** Идентификатор справочника */
  catalogUniqueId: Scalars['String'];
  /** Идентификатор источника данных */
  dataSourceId?: InputMaybe<Scalars['Int']>;
  /** Сущности переменной */
  entityUniqueIds?: InputMaybe<Array<Scalars['String']>>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор группы переменных */
  groupId: Scalars['Int'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор записи типа переменной из справочника */
  limitedCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор записи типа переменной из справочника */
  otherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Тип переменной */
  type: CatalogOtherCostVariableTypeEnum;
};

/** A segment of a collection. */
export type CatalogOtherCostVariablesCollectionSegment = {
  __typename?: 'CatalogOtherCostVariablesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostVariableItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogOtherCostVariablesGroupFilterCollectionSegment = {
  __typename?: 'CatalogOtherCostVariablesGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogOtherCostVariablesNameFilterCollectionSegment = {
  __typename?: 'CatalogOtherCostVariablesNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogOtherCostVariablesSubsidiaryNameFilterCollectionSegment = {
  __typename?: 'CatalogOtherCostVariablesSubsidiaryNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogRatioCodeFilterCollectionSegment = {
  __typename?: 'CatalogRatioCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Объект данных, передаваемых для создания коэффициента */
export type CatalogRatioCreateInput = {
  /** Идентификатор группы работ для коэффициентов стесненности. */
  catalogRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Строка справочника коэффициентов */
export type CatalogRatioData = {
  __typename?: 'CatalogRatioData';
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: Maybe<Scalars['String']>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Причина изменения коэффициента */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CatalogRatioDataFilterInput = {
  and?: InputMaybe<Array<CatalogRatioDataFilterInput>>;
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Причина изменения коэффициента */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Условия производства работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogRatioDataFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Строка справочника коэффициентов */
export type CatalogRatioDataForList = {
  __typename?: 'CatalogRatioDataForList';
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: Maybe<Scalars['String']>;
  /** Код шифра */
  code: Scalars['String'];
  /** прикреплена ли к коэффициенту хотя бы одна расценка */
  hasCosts: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Причина изменения коэффициента */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CatalogRatioDataForListFilterInput = {
  and?: InputMaybe<Array<CatalogRatioDataForListFilterInput>>;
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** прикреплена ли к коэффициенту хотя бы одна расценка */
  hasCosts?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Причина изменения коэффициента */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Условия производства работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogRatioDataForListFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Строка справочника коэффициентов */
export type CatalogRatioDataForListSortInput = {
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<SortEnumType>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<SortEnumType>;
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** прикреплена ли к коэффициенту хотя бы одна расценка */
  hasCosts?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Причина изменения коэффициента */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  name?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Строка справочника коэффициентов */
export type CatalogRatioDataInput = {
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<Scalars['String']>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Причина изменения коэффициента */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CatalogRatioDataSortInput = {
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<SortEnumType>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<SortEnumType>;
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Причина изменения коэффициента */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  name?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CatalogRatioGroupData = {
  __typename?: 'CatalogRatioGroupData';
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской группы */
  parentId?: Maybe<Scalars['Long']>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CatalogRatioGroupDataFilterInput = {
  and?: InputMaybe<Array<CatalogRatioGroupDataFilterInput>>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<NullableOfDismantlingCoefficientTypeEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogRatioGroupDataFilterInput>>;
  /** Идентификатор родительской группы */
  parentId?: InputMaybe<LongOperationFilterInput>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CatalogRatioGroupDataInput = {
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской группы */
  parentId?: InputMaybe<Scalars['Long']>;
};

/** A segment of a collection. */
export type CatalogRatioGroupFilterCollectionSegment = {
  __typename?: 'CatalogRatioGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Измененные данные расценки */
export type CatalogRatioHistoryChange = {
  __typename?: 'CatalogRatioHistoryChange';
  /** Код шифра */
  code?: Maybe<Scalars['String']>;
  /** Наименование изменено? */
  codeCng?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Обоснование изменено? */
  justificationCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент эксплуатации машин */
  kem?: Maybe<Scalars['Decimal']>;
  /** Коэффициент эксплуатации машин изменен? */
  kemCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент материалов изменен? */
  kmatCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент накладных расходов */
  knr?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов изменен? */
  knrCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент основной заработной платы */
  kozp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы изменен? */
  kozpCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент сметной прибыли */
  ksp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли изменен? */
  kspCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: Maybe<Scalars['Decimal']>;
  /** Коэффициент трудозатрат рабочих изменен? */
  ktzCng?: Maybe<Scalars['Boolean']>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: Maybe<Scalars['Decimal']>;
  /** Коэффициент заработной платы машинистов изменен? */
  ktzzpmCng?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name?: Maybe<Scalars['String']>;
  /** Наименование изменено? */
  nameCng?: Maybe<Scalars['Boolean']>;
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  ratioGroupId?: Maybe<Scalars['Long']>;
  /** Группа изменено? */
  ratioGroupIdCng?: Maybe<Scalars['Boolean']>;
  /** Группа работ для коэффициентов стесненности/демонтажа. */
  ratioGroupName?: Maybe<Scalars['String']>;
  /** Название группы изменено? */
  ratioGroupNameCng?: Maybe<Scalars['Boolean']>;
  /** Тип коэффициента */
  ratioType?: Maybe<RatioTypeEnum>;
  /** Наименование изменено? */
  ratioTypeCng?: Maybe<Scalars['Boolean']>;
  /** Идентификатор пользователя, внесшего последнее изменеение */
  updatedByProfileId?: Maybe<Scalars['Long']>;
  /** Идентификатор пользователя, внесшего последнее изменеение. Изменен? */
  updatedByProfileIdCng?: Maybe<Scalars['Boolean']>;
};

/** Измененные данные расценки */
export type CatalogRatioHistoryChangeFilterInput = {
  and?: InputMaybe<Array<CatalogRatioHistoryChangeFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование изменено? */
  codeCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Обоснование изменено? */
  justificationCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент эксплуатации машин изменен? */
  kemCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов изменен? */
  kmatCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов изменен? */
  knrCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы изменен? */
  kozpCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли изменен? */
  kspCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих изменен? */
  ktzCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов изменен? */
  ktzzpmCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование изменено? */
  nameCng?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CatalogRatioHistoryChangeFilterInput>>;
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  ratioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Группа изменено? */
  ratioGroupIdCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Группа работ для коэффициентов стесненности/демонтажа. */
  ratioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Название группы изменено? */
  ratioGroupNameCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<NullableOfRatioTypeEnumOperationFilterInput>;
  /** Наименование изменено? */
  ratioTypeCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор пользователя, внесшего последнее изменеение */
  updatedByProfileId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор пользователя, внесшего последнее изменеение. Изменен? */
  updatedByProfileIdCng?: InputMaybe<BooleanOperationFilterInput>;
};

/** Измененные данные расценки */
export type CatalogRatioHistoryChangeSortInput = {
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Наименование изменено? */
  codeCng?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Обоснование изменено? */
  justificationCng?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин изменен? */
  kemCng?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов изменен? */
  kmatCng?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов изменен? */
  knrCng?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы изменен? */
  kozpCng?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли изменен? */
  kspCng?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих изменен? */
  ktzCng?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов изменен? */
  ktzzpmCng?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Наименование изменено? */
  nameCng?: InputMaybe<SortEnumType>;
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  ratioGroupId?: InputMaybe<SortEnumType>;
  /** Группа изменено? */
  ratioGroupIdCng?: InputMaybe<SortEnumType>;
  /** Группа работ для коэффициентов стесненности/демонтажа. */
  ratioGroupName?: InputMaybe<SortEnumType>;
  /** Название группы изменено? */
  ratioGroupNameCng?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Наименование изменено? */
  ratioTypeCng?: InputMaybe<SortEnumType>;
  /** Идентификатор пользователя, внесшего последнее изменеение */
  updatedByProfileId?: InputMaybe<SortEnumType>;
  /** Идентификатор пользователя, внесшего последнее изменеение. Изменен? */
  updatedByProfileIdCng?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CatalogRatioHistoryCodeFilterCollectionSegment = {
  __typename?: 'CatalogRatioHistoryCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Исторические данные о действии над коэффициентом в формате подходящем для отрисовки в AgGridTable в React */
export type CatalogRatioHistoryData = {
  __typename?: 'CatalogRatioHistoryData';
  /** Идентификатор группы для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: Maybe<Scalars['String']>;
  /** Идентификатор коэффициента */
  catalogRatioId?: Maybe<Scalars['Long']>;
  /** Данные коэффициента в json */
  changeData?: Maybe<CatalogRatioHistoryChange>;
  /** Дата записи истории */
  changeDate?: Maybe<Scalars['DateTime']>;
  /** Тип записи истории */
  changeType?: Maybe<HistoryChangeType>;
  /** Шифр коэффициента */
  code?: Maybe<Scalars['String']>;
  /** Идентификатор записи истории */
  id?: Maybe<Scalars['Long']>;
  /** Флаг, указывающий на то, что данная строка - это строка подзаголовка с шифром */
  isHeadLine?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Наименование коэффициента */
  name?: Maybe<Scalars['String']>;
  /** Тип коэффициента */
  ratioType?: Maybe<RatioTypeEnum>;
};

/** Исторические данные о действии над коэффициентом в формате подходящем для отрисовки в AgGridTable в React */
export type CatalogRatioHistoryDataFilterInput = {
  and?: InputMaybe<Array<CatalogRatioHistoryDataFilterInput>>;
  /** Идентификатор группы для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Название группы для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор коэффициента */
  catalogRatioId?: InputMaybe<LongOperationFilterInput>;
  /** Данные коэффициента в json */
  changeData?: InputMaybe<CatalogRatioHistoryChangeFilterInput>;
  /** Дата записи истории */
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Тип записи истории */
  changeType?: InputMaybe<NullableOfHistoryChangeTypeOperationFilterInput>;
  /** Шифр коэффициента */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор записи истории */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Флаг, указывающий на то, что данная строка - это строка подзаголовка с шифром */
  isHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование коэффициента */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogRatioHistoryDataFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<NullableOfRatioTypeEnumOperationFilterInput>;
};

/** Исторические данные о действии над коэффициентом в формате подходящем для отрисовки в AgGridTable в React */
export type CatalogRatioHistoryDataSortInput = {
  /** Идентификатор группы для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupId?: InputMaybe<SortEnumType>;
  /** Название группы для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента */
  catalogRatioId?: InputMaybe<SortEnumType>;
  /** Данные коэффициента в json */
  changeData?: InputMaybe<CatalogRatioHistoryChangeSortInput>;
  /** Дата записи истории */
  changeDate?: InputMaybe<SortEnumType>;
  /** Тип записи истории */
  changeType?: InputMaybe<SortEnumType>;
  /** Шифр коэффициента */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор записи истории */
  id?: InputMaybe<SortEnumType>;
  /** Флаг, указывающий на то, что данная строка - это строка подзаголовка с шифром */
  isHeadLine?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Наименование коэффициента */
  name?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CatalogRatioHistoryGroupFilterCollectionSegment = {
  __typename?: 'CatalogRatioHistoryGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogRatioHistoryItemsCollectionSegment = {
  __typename?: 'CatalogRatioHistoryItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogRatioHistoryData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogRatioHistoryJustificationFilterCollectionSegment = {
  __typename?: 'CatalogRatioHistoryJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogRatioHistoryNameFilterCollectionSegment = {
  __typename?: 'CatalogRatioHistoryNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogRatioHistoryTypeFilterCollectionSegment = {
  __typename?: 'CatalogRatioHistoryTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfRatioTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Объект данных, передаваемых для массового применения коэффициентов */
export type CatalogRatioMassApplyInput = {
  /** Идентификаторы групп коэффициентов */
  ratioGroupIds: Array<Scalars['Long']>;
  /** Идентификаторы коэффициентов */
  ratiosIds: Array<Scalars['Long']>;
  /** Идентификаторы расценок */
  uerBaseCostIds: Array<Scalars['Long']>;
};

/** A segment of a collection. */
export type CatalogRatioNameFilterCollectionSegment = {
  __typename?: 'CatalogRatioNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Краткая строка справочника коэффициентов */
export type CatalogRatioShortData = {
  __typename?: 'CatalogRatioShortData';
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: Maybe<Scalars['Long']>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Краткая строка справочника коэффициентов */
export type CatalogRatioShortDataInput = {
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** A segment of a collection. */
export type CatalogRatioTypeFilterCollectionSegment = {
  __typename?: 'CatalogRatioTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogRatioTypesCollectionSegment = {
  __typename?: 'CatalogRatioTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RatioTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Объект данных, передаваемых для редактирования коэффициента */
export type CatalogRatioUpdateInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** A segment of a collection. */
export type CatalogRatiosCollectionSegment = {
  __typename?: 'CatalogRatiosCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogRatioDataForList>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogSubsidiaryFilterCollectionSegment = {
  __typename?: 'CatalogSubsidiaryFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Тип справочника */
export type CatalogTypeData = {
  __typename?: 'CatalogTypeData';
  /** Возможность создавать несколько справочников данного вида (в рамка ДО) */
  allowMultiple: Scalars['Boolean'];
  /** Признак возможности создания справочника данного типа */
  canCreate: Scalars['Boolean'];
  /** Методологии */
  methodologies: Array<ProjectMethodologyEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип справочника */
export type CatalogTypeDataFilterInput = {
  /** Возможность создавать несколько справочников данного вида (в рамка ДО) */
  allowMultiple?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CatalogTypeDataFilterInput>>;
  /** Признак возможности создания справочника данного типа */
  canCreate?: InputMaybe<BooleanOperationFilterInput>;
  /** Методологии */
  methodologies?: InputMaybe<ListProjectMethodologyEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogTypeDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Тип справочника */
export type CatalogTypeDataInput = {
  /** Возможность создавать несколько справочников данного вида (в рамка ДО) */
  allowMultiple: Scalars['Boolean'];
  /** Признак возможности создания справочника данного типа */
  canCreate: Scalars['Boolean'];
  /** Методологии */
  methodologies: Array<ProjectMethodologyEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
};

/** Тип справочника */
export type CatalogTypeDataSortInput = {
  /** Возможность создавать несколько справочников данного вида (в рамка ДО) */
  allowMultiple?: InputMaybe<SortEnumType>;
  /** Признак возможности создания справочника данного типа */
  canCreate?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

export type CatalogUerBaseCostChangeData = {
  __typename?: 'CatalogUERBaseCostChangeData';
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  chapterCng?: Maybe<Scalars['Boolean']>;
  /** Код */
  code?: Maybe<Scalars['String']>;
  codeCng?: Maybe<Scalars['Boolean']>;
  constructionTypeCng?: Maybe<Scalars['Boolean']>;
  /** Идентификаторы видов строительства */
  constructionTypeIdsTip?: Maybe<Scalars['String']>;
  /** Виды строительства */
  constructionTypes?: Maybe<Array<ConstructionTypeData>>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  emmCng?: Maybe<Scalars['Boolean']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  eqpCng?: Maybe<Scalars['Boolean']>;
  /** ФОТ */
  fot?: Maybe<Scalars['Decimal']>;
  fotCng?: Maybe<Scalars['Boolean']>;
  /** Шифр подраздела */
  groupCode?: Maybe<Scalars['String']>;
  groupCodeCng?: Maybe<Scalars['Boolean']>;
  /** Имя подраздела */
  groupFullName?: Maybe<Scalars['String']>;
  groupFullNameCng?: Maybe<Scalars['Boolean']>;
  /** Флаг показывающий есть ли составы работ в статусе изменен */
  hasWorkScopesHistory?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  justificationCng?: Maybe<Scalars['Boolean']>;
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  mtrCng?: Maybe<Scalars['Boolean']>;
  /** Имя */
  name?: Maybe<Scalars['String']>;
  nameCng?: Maybe<Scalars['Boolean']>;
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  nrCng?: Maybe<Scalars['Boolean']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  ozpCng?: Maybe<Scalars['Boolean']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  pirCng?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  rationaleCng?: Maybe<Scalars['Boolean']>;
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  spCng?: Maybe<Scalars['Boolean']>;
  /** ТЗМ */
  tm?: Maybe<Scalars['Decimal']>;
  tmCng?: Maybe<Scalars['Boolean']>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  trnCng?: Maybe<Scalars['Boolean']>;
  /** ТЗ */
  tz?: Maybe<Scalars['Decimal']>;
  tzCng?: Maybe<Scalars['Boolean']>;
  /** Код классификатора УЕР */
  uerClassifier?: Maybe<UerClassifierEnum>;
  uerClassifierCng?: Maybe<Scalars['Boolean']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  unitCng?: Maybe<Scalars['Boolean']>;
  /** Стоимость единицы (всего) */
  unitCost?: Maybe<Scalars['Decimal']>;
  unitCostCng?: Maybe<Scalars['Boolean']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
  zpmCng?: Maybe<Scalars['Boolean']>;
};

export type CatalogUerBaseCostChangeDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostChangeDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  chapterCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Код */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  codeCng?: InputMaybe<BooleanOperationFilterInput>;
  constructionTypeCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификаторы видов строительства */
  constructionTypeIdsTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Виды строительства */
  constructionTypes?: InputMaybe<ListFilterInputTypeOfConstructionTypeDataFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  emmCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Оборудование */
  eqp?: InputMaybe<DecimalOperationFilterInput>;
  eqpCng?: InputMaybe<BooleanOperationFilterInput>;
  /** ФОТ */
  fot?: InputMaybe<DecimalOperationFilterInput>;
  fotCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Шифр подраздела */
  groupCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupCodeCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Имя подраздела */
  groupFullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupFullNameCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг показывающий есть ли составы работ в статусе изменен */
  hasWorkScopesHistory?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  justificationCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  mtrCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  nameCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  nrCng?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostChangeDataFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  ozpCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<DecimalOperationFilterInput>;
  pirCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  rationaleCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  spCng?: InputMaybe<BooleanOperationFilterInput>;
  /** ТЗМ */
  tm?: InputMaybe<DecimalOperationFilterInput>;
  tmCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Перевозка */
  trn?: InputMaybe<DecimalOperationFilterInput>;
  trnCng?: InputMaybe<BooleanOperationFilterInput>;
  /** ТЗ */
  tz?: InputMaybe<DecimalOperationFilterInput>;
  tzCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Код классификатора УЕР */
  uerClassifier?: InputMaybe<NullableOfUerClassifierEnumOperationFilterInput>;
  uerClassifierCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  unitCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Стоимость единицы (всего) */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  unitCostCng?: InputMaybe<BooleanOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
  zpmCng?: InputMaybe<BooleanOperationFilterInput>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostChangeFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostChangeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfUerBaseCostChangeType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostChapterFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostCodeFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostConstructionTypesCollectionSegment = {
  __typename?: 'CatalogUERBaseCostConstructionTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConstructionTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostData = {
  __typename?: 'CatalogUERBaseCostData';
  catFile?: Maybe<Scalars['String']>;
  /** Виды работ */
  catalogUERBaseCostWorkScopes: Array<CatalogUerBaseCostWorkScopeData>;
  /** Глава в расчете */
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<ConstructionTypeData>;
  directCost?: Maybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  /** ФОТ */
  fot?: Maybe<Scalars['Decimal']>;
  /** Id подраздела */
  groupId: Scalars['Long'];
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  /** Id раздела */
  sectionId: Scalars['Long'];
  /** Имя раздела */
  sectionName: Scalars['String'];
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: Maybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: Maybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: Maybe<UerClassifierEnum>;
  uerNacl?: Maybe<Scalars['Long']>;
  uerPlan?: Maybe<Scalars['Long']>;
  /** Идентификатор */
  uniqueId: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Версия */
  version?: Maybe<Scalars['String']>;
  workID?: Maybe<Scalars['String']>;
  /** Вид работ */
  workType: CatalogUerBaseWorkData;
  /** Вид работ (каталог) */
  workTypeItems?: Maybe<Array<CatalogUerEstimateWorkTypeItem>>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type CatalogUerBaseCostDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostDataFilterInput>>;
  catFile?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Виды работ */
  catalogUERBaseCostWorkScopes?: InputMaybe<ListFilterInputTypeOfCatalogUerBaseCostWorkScopeDataFilterInput>;
  /** Глава в расчете */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Виды строительства */
  constructionTypes?: InputMaybe<ListFilterInputTypeOfConstructionTypeDataFilterInput>;
  directCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование */
  eqp?: InputMaybe<DecimalOperationFilterInput>;
  /** ФОТ */
  fot?: InputMaybe<DecimalOperationFilterInput>;
  /** Id подраздела */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Имя подраздела */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostDataFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<DecimalOperationFilterInput>;
  /** Id раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Имя раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** ЗТМ */
  tm?: InputMaybe<DecimalOperationFilterInput>;
  /** Перевозка */
  trn?: InputMaybe<DecimalOperationFilterInput>;
  /** Трудозатраты */
  tz?: InputMaybe<DecimalOperationFilterInput>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<NullableOfUerClassifierEnumOperationFilterInput>;
  uerNacl?: InputMaybe<LongOperationFilterInput>;
  uerPlan?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Версия */
  version?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  workID?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид работ */
  workType?: InputMaybe<CatalogUerBaseWorkDataFilterInput>;
  /** Вид работ (каталог) */
  workTypeItems?: InputMaybe<ListFilterInputTypeOfCatalogUerEstimateWorkTypeItemFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

export type CatalogUerBaseCostDataInput = {
  catFile?: InputMaybe<Scalars['String']>;
  /** Виды работ */
  catalogUERBaseCostWorkScopes: Array<CatalogUerBaseCostWorkScopeDataInput>;
  /** Глава в расчете */
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<ConstructionTypeDataInput>;
  directCost?: InputMaybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** ФОТ */
  fot?: InputMaybe<Scalars['Decimal']>;
  /** Id подраздела */
  groupId: Scalars['Long'];
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** Id раздела */
  sectionId: Scalars['Long'];
  /** Имя раздела */
  sectionName: Scalars['String'];
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: InputMaybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  uerNacl?: InputMaybe<Scalars['Long']>;
  uerPlan?: InputMaybe<Scalars['Long']>;
  /** Идентификатор */
  uniqueId: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Версия */
  version?: InputMaybe<Scalars['String']>;
  workID?: InputMaybe<Scalars['String']>;
  /** Вид работ */
  workType: CatalogUerBaseWorkDataInput;
  /** Вид работ (каталог) */
  workTypeItems?: InputMaybe<Array<CatalogUerEstimateWorkTypeItemInput>>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type CatalogUerBaseCostDataSortInput = {
  catFile?: InputMaybe<SortEnumType>;
  /** Глава в расчете */
  chapter?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  directCost?: InputMaybe<SortEnumType>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Оборудование */
  eqp?: InputMaybe<SortEnumType>;
  /** ФОТ */
  fot?: InputMaybe<SortEnumType>;
  /** Id подраздела */
  groupId?: InputMaybe<SortEnumType>;
  /** Имя подраздела */
  groupName?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<SortEnumType>;
  /** Имя */
  name?: InputMaybe<SortEnumType>;
  /** Накладные расходы */
  nr?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<SortEnumType>;
  /** Id раздела */
  sectionId?: InputMaybe<SortEnumType>;
  /** Имя раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Сметная прибыль */
  sp?: InputMaybe<SortEnumType>;
  /** ЗТМ */
  tm?: InputMaybe<SortEnumType>;
  /** Перевозка */
  trn?: InputMaybe<SortEnumType>;
  /** Трудозатраты */
  tz?: InputMaybe<SortEnumType>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<SortEnumType>;
  uerNacl?: InputMaybe<SortEnumType>;
  uerPlan?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  /** Версия */
  version?: InputMaybe<SortEnumType>;
  workID?: InputMaybe<SortEnumType>;
  /** Вид работ */
  workType?: InputMaybe<CatalogUerBaseWorkDataSortInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

export type CatalogUerBaseCostDetailedData = {
  __typename?: 'CatalogUERBaseCostDetailedData';
  catFile?: Maybe<Scalars['String']>;
  /** Виды работ */
  catalogUERBaseCostWorkScopes: Array<CatalogUerBaseCostWorkScopeData>;
  /** Глава в расчете */
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<ConstructionTypeData>;
  directCost?: Maybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  /** ФОТ */
  fot?: Maybe<Scalars['Decimal']>;
  /** Id подраздела */
  groupId: Scalars['Long'];
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  ratioGroups: Array<CatalogRatioGroupData>;
  ratios: Array<CatalogRatioShortData>;
  /** Id раздела */
  sectionId: Scalars['Long'];
  /** Имя раздела */
  sectionName: Scalars['String'];
  sections?: Maybe<Array<CatalogUerBaseCostEstimateBasisSectionData>>;
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: Maybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: Maybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: Maybe<UerClassifierEnum>;
  uerNacl?: Maybe<Scalars['Long']>;
  uerPlan?: Maybe<Scalars['Long']>;
  /** Идентификатор */
  uniqueId: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Версия */
  version?: Maybe<Scalars['String']>;
  workID?: Maybe<Scalars['String']>;
  /** Вид работ */
  workType: CatalogUerBaseWorkData;
  /** Вид работ (каталог) */
  workTypeItems?: Maybe<Array<CatalogUerEstimateWorkTypeItem>>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type CatalogUerBaseCostDetailedDataInput = {
  catFile?: InputMaybe<Scalars['String']>;
  /** Виды работ */
  catalogUERBaseCostWorkScopes: Array<CatalogUerBaseCostWorkScopeDataInput>;
  /** Глава в расчете */
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<ConstructionTypeDataInput>;
  directCost?: InputMaybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** ФОТ */
  fot?: InputMaybe<Scalars['Decimal']>;
  /** Id подраздела */
  groupId: Scalars['Long'];
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  ratioGroups: Array<CatalogRatioGroupDataInput>;
  ratios: Array<CatalogRatioShortDataInput>;
  /** Id раздела */
  sectionId: Scalars['Long'];
  /** Имя раздела */
  sectionName: Scalars['String'];
  sections?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisSectionDataInput>>;
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: InputMaybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  uerNacl?: InputMaybe<Scalars['Long']>;
  uerPlan?: InputMaybe<Scalars['Long']>;
  /** Идентификатор */
  uniqueId: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Версия */
  version?: InputMaybe<Scalars['String']>;
  workID?: InputMaybe<Scalars['String']>;
  /** Вид работ */
  workType: CatalogUerBaseWorkDataInput;
  /** Вид работ (каталог) */
  workTypeItems?: InputMaybe<Array<CatalogUerEstimateWorkTypeItemInput>>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostEstimateBasisCollectionSegment = {
  __typename?: 'CatalogUERBaseCostEstimateBasisCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogUerBaseCostEstimateBasisItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные для создания позиции расценки в смете-основании */
export type CatalogUerBaseCostEstimateBasisCreateInput = {
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  quantity: CatalogUerBaseCostEstimateBasisQuantityDataInput;
  resources?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisResourceCreateInput>>;
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisTotalCostDataInput>;
  totalWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisWorkCostDataInput>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisUnitCostDataInput>;
  unitWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisWorkCostDataInput>;
  vr2001?: InputMaybe<Scalars['String']>;
};

/** Позиция расценки в смете-основании */
export type CatalogUerBaseCostEstimateBasisData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisData';
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  name: Scalars['String'];
  quantity: CatalogUerBaseCostEstimateBasisQuantityData;
  resources?: Maybe<Array<CatalogUerBaseCostEstimateBasisResourceData>>;
  totalCost?: Maybe<CatalogUerBaseCostEstimateBasisTotalCostData>;
  totalWorkCost?: Maybe<CatalogUerBaseCostEstimateBasisWorkCostData>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: Maybe<CatalogUerBaseCostEstimateBasisUnitCostData>;
  unitWorkCost?: Maybe<CatalogUerBaseCostEstimateBasisWorkCostData>;
  vr2001?: Maybe<Scalars['String']>;
};

export enum CatalogUerBaseCostEstimateBasisDataGroupEnum {
  /** Не ценообразующие МТР */
  Mat = 'MAT',
  /** Машины и механизмы */
  Mch = 'MCH',
  /** Ценообразующие МТР */
  Mtr = 'MTR',
  /** Трудозатраты */
  TzTm = 'TZ_TM'
}

export type CatalogUerBaseCostEstimateBasisDataGroupEnumOperationFilterInput = {
  eq?: InputMaybe<CatalogUerBaseCostEstimateBasisDataGroupEnum>;
  in?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisDataGroupEnum>>;
  neq?: InputMaybe<CatalogUerBaseCostEstimateBasisDataGroupEnum>;
  nin?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisDataGroupEnum>>;
};

/** Позиция расценки в смете-основании */
export type CatalogUerBaseCostEstimateBasisDataInput = {
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  name: Scalars['String'];
  quantity: CatalogUerBaseCostEstimateBasisQuantityDataInput;
  resources?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisResourceDataInput>>;
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisTotalCostDataInput>;
  totalWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisWorkCostDataInput>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisUnitCostDataInput>;
  unitWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisWorkCostDataInput>;
  vr2001?: InputMaybe<Scalars['String']>;
};

export type CatalogUerBaseCostEstimateBasisItem = {
  __typename?: 'CatalogUERBaseCostEstimateBasisItem';
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Группа к которой относятся данные */
  group: CatalogUerBaseCostEstimateBasisDataGroupEnum;
  /** Идентификатор */
  id?: Maybe<Scalars['Long']>;
  /** Позиция удалена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHeadLine: Scalars['Boolean'];
  /** Не имеет количества */
  isNotCount?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: Maybe<Scalars['Decimal']>;
};

export type CatalogUerBaseCostEstimateBasisItemFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisItemFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Группа к которой относятся данные */
  group?: InputMaybe<CatalogUerBaseCostEstimateBasisDataGroupEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Позиция удалена */
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisItemFilterInput>>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Количественных данные для позиции */
export type CatalogUerBaseCostEstimateBasisQuantityData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisQuantityData';
  /** Норма расхода */
  consumptionRateMtr?: Maybe<Scalars['Decimal']>;
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Количественных данные для позиции */
export type CatalogUerBaseCostEstimateBasisQuantityDataInput = {
  /** Норма расхода */
  consumptionRateMtr?: InputMaybe<Scalars['Decimal']>;
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

export type CatalogUerBaseCostEstimateBasisResourceCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisResourceCostData';
  /** Машины и механизмы ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** Неценообразующие МТР */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты (машинистов и рабочих) */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** Машины и механизмы ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type CatalogUerBaseCostEstimateBasisResourceCostDataInput = {
  /** Машины и механизмы ЭММ */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Неценообразующие МТР */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты (машинистов и рабочих) */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** Машины и механизмы ЗПМ */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для создания ресурса расценки */
export type CatalogUerBaseCostEstimateBasisResourceCreateInput = {
  /** Шифр */
  code: Scalars['String'];
  /** Позиция удалена */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CatalogUerBaseCostEstimateBasisResourceQuantityDataInput;
  /** Общая стоимость */
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisResourceCostDataInput>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisResourceCostDataInput>;
};

/** Ресурс расценки */
export type CatalogUerBaseCostEstimateBasisResourceData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisResourceData';
  /** Шифр */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Позиция удалена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CatalogUerBaseCostEstimateBasisResourceQuantityData;
  /** Общая стоимость */
  totalCost?: Maybe<CatalogUerBaseCostEstimateBasisResourceCostData>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: Maybe<CatalogUerBaseCostEstimateBasisResourceCostData>;
};

/** Ресурс расценки */
export type CatalogUerBaseCostEstimateBasisResourceDataInput = {
  /** Шифр */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Позиция удалена */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CatalogUerBaseCostEstimateBasisResourceQuantityDataInput;
  /** Общая стоимость */
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisResourceCostDataInput>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisResourceCostDataInput>;
};

/** Количественные данные для позиции */
export type CatalogUerBaseCostEstimateBasisResourceQuantityData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisResourceQuantityData';
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Количественные данные для позиции */
export type CatalogUerBaseCostEstimateBasisResourceQuantityDataInput = {
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Данные для обновления ресурса расценки */
export type CatalogUerBaseCostEstimateBasisResourceUpdateInput = {
  /** Шифр */
  code: Scalars['String'];
  /** Идентификатор */
  id?: InputMaybe<Scalars['Long']>;
  /** Позиция удалена */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CatalogUerBaseCostEstimateBasisResourceQuantityDataInput;
  /** Общая стоимость */
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisResourceCostDataInput>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisResourceCostDataInput>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostEstimateBasisResourcesCollectionSegment = {
  __typename?: 'CatalogUERBaseCostEstimateBasisResourcesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogUerBaseCostEstimateBasisItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostEstimateBasisRow = {
  __typename?: 'CatalogUERBaseCostEstimateBasisRow';
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Общая стоимость с учетом НР и СП */
  estimateTotal?: Maybe<Scalars['Decimal']>;
  /** Позиция удалена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: Maybe<Scalars['Boolean']>;
  /** Признак того что строка является заголовком расценки */
  isPriceHeadLine: Scalars['Boolean'];
  /** Признак того сто строка является заголовком раздела */
  isSectionHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Порядковый номер раздела или расценки */
  number?: Maybe<Scalars['Int']>;
  /** Идентификатор строки родителя */
  parentRowId?: Maybe<Scalars['String']>;
  /** Идентификатор расценки */
  priceId?: Maybe<Scalars['Long']>;
  /** Количественные данные для позиции */
  quantity?: Maybe<CatalogUerBaseCostEstimateBasisRowQuantityData>;
  /** Идентификатор ресурса */
  resourceId?: Maybe<Scalars['Long']>;
  /** Идентификатор строки */
  rowId: Scalars['String'];
  /** Идентификатор раздела */
  sectionId: Scalars['Long'];
  /** Порядковый номер раздела */
  sectionOrder?: Maybe<Scalars['Int']>;
  /** Общая стоимость */
  totalCost?: Maybe<CatalogUerBaseCostEstimateBasisRowTotalCostData>;
  /** Трудозатраты всего */
  totalWorkCost?: Maybe<CatalogUerBaseCostEstimateBasisRowWorkCostData>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость на единицу */
  unitCost?: Maybe<CatalogUerBaseCostEstimateBasisRowUnitCostData>;
  /** Трудозатраты на единицу */
  unitWorkCost?: Maybe<CatalogUerBaseCostEstimateBasisRowWorkCostData>;
};

export type CatalogUerBaseCostEstimateBasisRowFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Общая стоимость с учетом НР и СП */
  estimateTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Позиция удалена */
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того что строка является заголовком расценки */
  isPriceHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того сто строка является заголовком раздела */
  isSectionHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Порядковый номер раздела или расценки */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowFilterInput>>;
  /** Идентификатор строки родителя */
  parentRowId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор расценки */
  priceId?: InputMaybe<LongOperationFilterInput>;
  /** Количественные данные для позиции */
  quantity?: InputMaybe<CatalogUerBaseCostEstimateBasisRowQuantityDataFilterInput>;
  /** Идентификатор ресурса */
  resourceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор строки */
  rowId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Порядковый номер раздела */
  sectionOrder?: InputMaybe<IntOperationFilterInput>;
  /** Общая стоимость */
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisRowTotalCostDataFilterInput>;
  /** Трудозатраты всего */
  totalWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisRowWorkCostDataFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость на единицу */
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisRowUnitCostDataFilterInput>;
  /** Трудозатраты на единицу */
  unitWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisRowWorkCostDataFilterInput>;
};

/** Количественных данные для позиции */
export type CatalogUerBaseCostEstimateBasisRowQuantityData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisRowQuantityData';
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Количественных данные для позиции */
export type CatalogUerBaseCostEstimateBasisRowQuantityDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowQuantityDataFilterInput>>;
  or?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowQuantityDataFilterInput>>;
  /** Общее количество */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество на одну единицу */
  unit?: InputMaybe<DecimalOperationFilterInput>;
};

/** Общая стоимость */
export type CatalogUerBaseCostEstimateBasisRowTotalCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisRowTotalCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** НР */
  nr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** СП */
  sp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Общая стоимость */
export type CatalogUerBaseCostEstimateBasisRowTotalCostDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowTotalCostDataFilterInput>>;
  /** ЭММ */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** МАТ */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** НР */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowTotalCostDataFilterInput>>;
  /** ОЗП */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** СП */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Всего */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** ЗПМ */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Стоимость на единицу */
export type CatalogUerBaseCostEstimateBasisRowUnitCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisRowUnitCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Стоимость на единицу */
export type CatalogUerBaseCostEstimateBasisRowUnitCostDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowUnitCostDataFilterInput>>;
  /** ЭММ */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** МАТ */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowUnitCostDataFilterInput>>;
  /** ОЗП */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Всего */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** ЗПМ */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Трудозатраты */
export type CatalogUerBaseCostEstimateBasisRowWorkCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisRowWorkCostData';
  /** Трудозатраты ЗТм */
  tm?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТ */
  tz?: Maybe<Scalars['Decimal']>;
};

/** Трудозатраты */
export type CatalogUerBaseCostEstimateBasisRowWorkCostDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowWorkCostDataFilterInput>>;
  or?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisRowWorkCostDataFilterInput>>;
  /** Трудозатраты ЗТм */
  tm?: InputMaybe<DecimalOperationFilterInput>;
  /** Трудозатраты ЗТ */
  tz?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные для создания раздела позиций расценок в смете-основании */
export type CatalogUerBaseCostEstimateBasisSectionCreateInput = {
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  prices?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisCreateInput>>;
};

export type CatalogUerBaseCostEstimateBasisSectionData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisSectionData';
  /** Идентификатор */
  id: Scalars['Long'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  prices?: Maybe<Array<CatalogUerBaseCostEstimateBasisData>>;
};

export type CatalogUerBaseCostEstimateBasisSectionDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  prices?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisDataInput>>;
};

/** Данные для обновления раздела позиций расценок в смете-основании */
export type CatalogUerBaseCostEstimateBasisSectionUpdateInput = {
  /** Идентификатор */
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  prices?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisUpdateInput>>;
};

/** Общая Стоимость позиции в базисном уровне цен */
export type CatalogUerBaseCostEstimateBasisTotalCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisTotalCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** НР */
  nr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** СП */
  sp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Общая Стоимость позиции в базисном уровне цен */
export type CatalogUerBaseCostEstimateBasisTotalCostDataInput = {
  /** ЭММ */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** НР */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** СП */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Стоимость позиции на одну единицу в базисном уровне цен */
export type CatalogUerBaseCostEstimateBasisUnitCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisUnitCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Стоимость позиции на одну единицу в базисном уровне цен */
export type CatalogUerBaseCostEstimateBasisUnitCostDataInput = {
  /** ЭММ */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для обновления позиции расценки в смете-основании */
export type CatalogUerBaseCostEstimateBasisUpdateInput = {
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  quantity: CatalogUerBaseCostEstimateBasisQuantityDataInput;
  resources?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisResourceUpdateInput>>;
  totalCost?: InputMaybe<CatalogUerBaseCostEstimateBasisTotalCostDataInput>;
  totalWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisWorkCostDataInput>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<CatalogUerBaseCostEstimateBasisUnitCostDataInput>;
  unitWorkCost?: InputMaybe<CatalogUerBaseCostEstimateBasisWorkCostDataInput>;
  vr2001?: InputMaybe<Scalars['String']>;
};

/** Трудозатраты */
export type CatalogUerBaseCostEstimateBasisWorkCostData = {
  __typename?: 'CatalogUERBaseCostEstimateBasisWorkCostData';
  /** Трудозатраты ЗТм */
  tm?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТ */
  tz?: Maybe<Scalars['Decimal']>;
};

/** Трудозатраты */
export type CatalogUerBaseCostEstimateBasisWorkCostDataInput = {
  /** Трудозатраты ЗТм */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТ */
  tz?: InputMaybe<Scalars['Decimal']>;
};

/** Выбранные значения каскадной фильтрации справочника расценок УЭР (BFF) */
export type CatalogUerBaseCostFilterInput = {
  chapters?: InputMaybe<Array<InputMaybe<ChapterEnum>>>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  groupFullNames?: InputMaybe<Array<Scalars['String']>>;
  groupNames?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  sectionNames?: InputMaybe<Array<Scalars['String']>>;
  uerClassifiers?: InputMaybe<Array<InputMaybe<UerClassifierEnum>>>;
  workInSums?: InputMaybe<Array<WorkInSumEnum>>;
  worktypeNames?: InputMaybe<Array<Scalars['String']>>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostGroupFullNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostGroupNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostGroupNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryChapterFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryCodeFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostHistoryData = {
  __typename?: 'CatalogUERBaseCostHistoryData';
  /** Идентификатор спарвочника */
  catalogId?: Maybe<Scalars['Long']>;
  /** Данные расценки в json */
  catalogUERBaseCostChange?: Maybe<CatalogUerBaseCostChangeData>;
  /** Идентификатор */
  id?: Maybe<Scalars['Long']>;
  isHeadLine?: Maybe<Scalars['Boolean']>;
  uerBaseCostChangeType?: Maybe<UerBaseCostChangeType>;
  /** Шифр расценки, чья история */
  uerBaseCostCode?: Maybe<Scalars['String']>;
  /** Идентификатор расценки, чья история */
  uerBaseCostId?: Maybe<Scalars['Long']>;
  /** Дата обновления расценки */
  updateUerDate?: Maybe<Scalars['DateTime']>;
};

export type CatalogUerBaseCostHistoryDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostHistoryDataFilterInput>>;
  /** Идентификатор спарвочника */
  catalogId?: InputMaybe<LongOperationFilterInput>;
  /** Данные расценки в json */
  catalogUERBaseCostChange?: InputMaybe<CatalogUerBaseCostChangeDataFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  isHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostHistoryDataFilterInput>>;
  uerBaseCostChangeType?: InputMaybe<NullableOfUerBaseCostChangeTypeOperationFilterInput>;
  /** Шифр расценки, чья история */
  uerBaseCostCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор расценки, чья история */
  uerBaseCostId?: InputMaybe<LongOperationFilterInput>;
  /** Дата обновления расценки */
  updateUerDate?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryGroupFullNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCatalogUerBaseCostGroupFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryItemsCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogUerBaseCostHistoryData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryJustificationFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostHistoryStatusCountData = {
  __typename?: 'CatalogUERBaseCostHistoryStatusCountData';
  deletedCostsCount: Scalars['Int'];
  newCostsCount: Scalars['Int'];
  updatedCostsCount: Scalars['Int'];
};

export type CatalogUerBaseCostHistoryStatusCountDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostHistoryStatusCountDataFilterInput>>;
  deletedCostsCount?: InputMaybe<IntOperationFilterInput>;
  newCostsCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostHistoryStatusCountDataFilterInput>>;
  updatedCostsCount?: InputMaybe<IntOperationFilterInput>;
};

export type CatalogUerBaseCostHistoryStatusCountDataInput = {
  deletedCostsCount: Scalars['Int'];
  newCostsCount: Scalars['Int'];
  updatedCostsCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryUerClassifierFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryUerClassifierFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfUerClassifierEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryUpdateUerDateFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryUpdateUERDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfDateOnly>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryWorkScopeFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryWorkScopeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Maybe<FilterValueOfNullableOfUerBaseCostChangeType>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostHistoryWorkScopeNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostHistoryWorkScopeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostItemsCollectionSegment = {
  __typename?: 'CatalogUERBaseCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogUerBaseCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные для массового обновления расценок */
export type CatalogUerBaseCostPropertiesInput = {
  /** Глава в расчете */
  chapter: ChapterEnum;
  /** Тип расценки */
  uerClassifier: UerClassifierEnum;
  /** Идентификаторы УЕР */
  uerIds: Array<Scalars['Long']>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostSectionNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostTotalItem = {
  __typename?: 'CatalogUERBaseCostTotalItem';
  hasIndent: Scalars['Boolean'];
  isHeadLine: Scalars['Boolean'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  value?: Maybe<Scalars['Decimal']>;
};

/** A segment of a collection. */
export type CatalogUerBaseCostUerClassifierFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostUerClassifierFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfUerClassifierEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostUpdateDateFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostUpdateDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateTime>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostWorkScopeBaseData = {
  __typename?: 'CatalogUERBaseCostWorkScopeBaseData';
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
};

export type CatalogUerBaseCostWorkScopeBaseDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostWorkScopeBaseDataFilterInput>>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Нумерация состава работ */
  number?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostWorkScopeBaseDataFilterInput>>;
};

export type CatalogUerBaseCostWorkScopeBaseDataInput = {
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostWorkScopeChangeFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostWorkScopeChangeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfUerBaseCostChangeType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostWorkScopeData = {
  __typename?: 'CatalogUERBaseCostWorkScopeData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
};

export type CatalogUerBaseCostWorkScopeDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostWorkScopeDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Нумерация состава работ */
  number?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostWorkScopeDataFilterInput>>;
};

export type CatalogUerBaseCostWorkScopeDataInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
};

export type CatalogUerBaseCostWorkScopeHistoryStatusCount = {
  __typename?: 'CatalogUERBaseCostWorkScopeHistoryStatusCount';
  deletedScopesCount: Scalars['Int'];
  newScopesCount: Scalars['Int'];
  updatedScopesCount: Scalars['Int'];
};

export type CatalogUerBaseCostWorkScopeHistoryStatusCountFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostWorkScopeHistoryStatusCountFilterInput>>;
  deletedScopesCount?: InputMaybe<IntOperationFilterInput>;
  newScopesCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostWorkScopeHistoryStatusCountFilterInput>>;
  updatedScopesCount?: InputMaybe<IntOperationFilterInput>;
};

export type CatalogUerBaseCostWorkScopeHistoryStatusCountInput = {
  deletedScopesCount: Scalars['Int'];
  newScopesCount: Scalars['Int'];
  updatedScopesCount: Scalars['Int'];
};

export type CatalogUerBaseCostWorkScopeHistoryWithStatusCount = {
  __typename?: 'CatalogUERBaseCostWorkScopeHistoryWithStatusCount';
  counts: CatalogUerBaseCostWorkScopeHistoryStatusCount;
  workScopeItems: Array<CatalogUerBaseCostWorkScopeItems>;
};

export type CatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput>>;
  counts?: InputMaybe<CatalogUerBaseCostWorkScopeHistoryStatusCountFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput>>;
  workScopeItems?: InputMaybe<ListFilterInputTypeOfCatalogUerBaseCostWorkScopeItemsFilterInput>;
};

export type CatalogUerBaseCostWorkScopeHistoryWithStatusCountInput = {
  counts: CatalogUerBaseCostWorkScopeHistoryStatusCountInput;
  workScopeItems: Array<CatalogUerBaseCostWorkScopeItemsInput>;
};

export type CatalogUerBaseCostWorkScopeItems = {
  __typename?: 'CatalogUERBaseCostWorkScopeItems';
  changeType?: Maybe<UerBaseCostChangeType>;
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
  /** Дата обновления расценки */
  updateUerDate: Scalars['DateTime'];
  workScopeNameCng?: Maybe<Scalars['Boolean']>;
  workScopeNumberCng?: Maybe<Scalars['Boolean']>;
};

export type CatalogUerBaseCostWorkScopeItemsFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostWorkScopeItemsFilterInput>>;
  changeType?: InputMaybe<NullableOfUerBaseCostChangeTypeOperationFilterInput>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Нумерация состава работ */
  number?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostWorkScopeItemsFilterInput>>;
  /** Дата обновления расценки */
  updateUerDate?: InputMaybe<DateTimeOperationFilterInput>;
  workScopeNameCng?: InputMaybe<BooleanOperationFilterInput>;
  workScopeNumberCng?: InputMaybe<BooleanOperationFilterInput>;
};

export type CatalogUerBaseCostWorkScopeItemsInput = {
  changeType?: InputMaybe<UerBaseCostChangeType>;
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
  /** Дата обновления расценки */
  updateUerDate: Scalars['DateTime'];
  workScopeNameCng?: InputMaybe<Scalars['Boolean']>;
  workScopeNumberCng?: InputMaybe<Scalars['Boolean']>;
};

/** Данные для обновления работы из состава расценки справочника */
export type CatalogUerBaseCostWorkScopeUpdateInput = {
  /** Наименование работы */
  name: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostWorkScopesCollectionSegment = {
  __typename?: 'CatalogUERBaseCostWorkScopesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogUerBaseCostWorkScopeBaseData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseCostWorkTypeItemInput = {
  caption?: InputMaybe<Scalars['String']>;
  catFile: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  nacl?: InputMaybe<Scalars['String']>;
  naclCurr?: InputMaybe<Scalars['String']>;
  naclMask?: InputMaybe<Scalars['String']>;
  nrCode?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  planCurr?: InputMaybe<Scalars['String']>;
  planMask?: InputMaybe<Scalars['String']>;
  spCode?: InputMaybe<Scalars['String']>;
  workID: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostWorktypeFOsummFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostWorktypeFOsummFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogUerBaseCostWorktypeNameFilterCollectionSegment = {
  __typename?: 'CatalogUERBaseCostWorktypeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBaseWorkData = {
  __typename?: 'CatalogUERBaseWorkData';
  /** Шифр вида работ */
  workCode?: Maybe<Scalars['String']>;
  /** Участие в суммировании ФО по виду работ */
  workInSum: WorkInSumEnum;
  /** Наименование вида работ */
  workName?: Maybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: Maybe<Scalars['String']>;
  /** Ед.изм. вида работ */
  workUnit?: Maybe<Scalars['String']>;
};

export type CatalogUerBaseWorkDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseWorkDataFilterInput>>;
  or?: InputMaybe<Array<CatalogUerBaseWorkDataFilterInput>>;
  /** Шифр вида работ */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Участие в суммировании ФО по виду работ */
  workInSum?: InputMaybe<WorkInSumEnumOperationFilterInput>;
  /** Наименование вида работ */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Ед.изм. вида работ */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type CatalogUerBaseWorkDataInput = {
  /** Шифр вида работ */
  workCode?: InputMaybe<Scalars['String']>;
  /** Участие в суммировании ФО по виду работ */
  workInSum: WorkInSumEnum;
  /** Наименование вида работ */
  workName?: InputMaybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<Scalars['Decimal']>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<Scalars['String']>;
  /** Ед.изм. вида работ */
  workUnit?: InputMaybe<Scalars['String']>;
};

export type CatalogUerBaseWorkDataSortInput = {
  /** Шифр вида работ */
  workCode?: InputMaybe<SortEnumType>;
  /** Участие в суммировании ФО по виду работ */
  workInSum?: InputMaybe<SortEnumType>;
  /** Наименование вида работ */
  workName?: InputMaybe<SortEnumType>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<SortEnumType>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<SortEnumType>;
  /** Ед.изм. вида работ */
  workUnit?: InputMaybe<SortEnumType>;
};

/** DTO объект "Шаблон прочих затрат" */
export type CatalogUerOtherCostTemplateData = {
  __typename?: 'CatalogUEROtherCostTemplateData';
  /** Идентификатор сущности */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Профиль пользователя, изменившего сущность */
  updatedBy?: Maybe<UserProfile>;
};

/** DTO объект "Шаблон прочих затрат" */
export type CatalogUerOtherCostTemplateDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerOtherCostTemplateDataFilterInput>>;
  /** Идентификатор сущности */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogUerOtherCostTemplateDataFilterInput>>;
  /** Дата изменения */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Профиль пользователя, изменившего сущность */
  updatedBy?: InputMaybe<UserProfileFilterInput>;
};

/** DTO объект "Шаблон прочих затрат" */
export type CatalogUerOtherCostTemplateDataInput = {
  /** Идентификатор сущности */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Дата изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Профиль пользователя, изменившего сущность */
  updatedBy?: InputMaybe<UserProfileInput>;
};

/** DTO объект "Шаблон прочих затрат" */
export type CatalogUerOtherCostTemplateDataSortInput = {
  /** Идентификатор сущности */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Дата изменения */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Профиль пользователя, изменившего сущность */
  updatedBy?: InputMaybe<UserProfileSortInput>;
};

/** DTO объект "Шаблон прочих затрат" */
export type CatalogUerOtherCostTemplateExtendedData = {
  __typename?: 'CatalogUEROtherCostTemplateExtendedData';
  /** Файл шаблона */
  file: FileContent;
  /** Идентификатор сущности */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Профиль пользователя, изменившего сущность */
  updatedBy?: Maybe<UserProfile>;
};

/** DTO объект "Шаблон прочих затрат" */
export type CatalogUerOtherCostTemplateExtendedDataInput = {
  /** Файл шаблона */
  file: FileContentInput;
  /** Идентификатор сущности */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Дата изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Профиль пользователя, изменившего сущность */
  updatedBy?: InputMaybe<UserProfileInput>;
};

/** DTO объект "Шаблон прочих затрат" (для создания/редактирования) */
export type CatalogUerOtherCostTemplateInput = {
  /** Файл шаблона */
  file: FileInput;
  /** Наименование */
  name: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogUerOtherCostTemplatesCollectionSegment = {
  __typename?: 'CatalogUEROtherCostTemplatesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogUerOtherCostTemplateData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type CatalogUerBase = {
  __typename?: 'CatalogUerBase';
  /** Наличие видов работ в справочнике расценок */
  hasWorkKind?: Maybe<Scalars['Boolean']>;
  /** Наименование справочника расценок */
  name?: Maybe<Scalars['String']>;
  /** Идентификатор справочника расценок */
  uniqueId?: Maybe<Scalars['String']>;
  /** Версия методики в справочнике (2017 или 2020) */
  version?: Maybe<Scalars['String']>;
};

export type CatalogUerBaseCostGroupFilterData = {
  __typename?: 'CatalogUerBaseCostGroupFilterData';
  /** Шифр подраздела */
  groupCode?: Maybe<Scalars['String']>;
  /** Наименование подраздела */
  groupName?: Maybe<Scalars['String']>;
};

export type CatalogUerBaseCostGroupFilterDataFilterInput = {
  and?: InputMaybe<Array<CatalogUerBaseCostGroupFilterDataFilterInput>>;
  /** Шифр подраздела */
  groupCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование подраздела */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogUerBaseCostGroupFilterDataFilterInput>>;
};

export type CatalogUerBaseCostGroupFilterDataSortInput = {
  /** Шифр подраздела */
  groupCode?: InputMaybe<SortEnumType>;
  /** Наименование подраздела */
  groupName?: InputMaybe<SortEnumType>;
};

export type CatalogUerBaseInput = {
  /** Наличие видов работ в справочнике расценок */
  hasWorkKind?: InputMaybe<Scalars['Boolean']>;
  /** Наименование справочника расценок */
  name?: InputMaybe<Scalars['String']>;
  /** Идентификатор справочника расценок */
  uniqueId?: InputMaybe<Scalars['String']>;
  /** Версия методики в справочнике (2017 или 2020) */
  version?: InputMaybe<Scalars['String']>;
};

export type CatalogUerEstimateWorkTypeItem = {
  __typename?: 'CatalogUerEstimateWorkTypeItem';
  caption?: Maybe<Scalars['String']>;
  catFile: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  nacl?: Maybe<Scalars['String']>;
  naclCurr?: Maybe<Scalars['String']>;
  naclMask?: Maybe<Scalars['String']>;
  nrCode?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  planCurr?: Maybe<Scalars['String']>;
  planMask?: Maybe<Scalars['String']>;
  spCode?: Maybe<Scalars['String']>;
  workID: Scalars['String'];
};

export type CatalogUerEstimateWorkTypeItemFilterInput = {
  and?: InputMaybe<Array<CatalogUerEstimateWorkTypeItemFilterInput>>;
  caption?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  catFile?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  category?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  nacl?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  naclCurr?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  naclMask?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  nrCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogUerEstimateWorkTypeItemFilterInput>>;
  plan?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  planCurr?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  planMask?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  spCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  workID?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type CatalogUerEstimateWorkTypeItemInput = {
  caption?: InputMaybe<Scalars['String']>;
  catFile: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  nacl?: InputMaybe<Scalars['String']>;
  naclCurr?: InputMaybe<Scalars['String']>;
  naclMask?: InputMaybe<Scalars['String']>;
  nrCode?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  planCurr?: InputMaybe<Scalars['String']>;
  planMask?: InputMaybe<Scalars['String']>;
  spCode?: InputMaybe<Scalars['String']>;
  workID: Scalars['String'];
};

export type CatalogUpdatedAtData = {
  __typename?: 'CatalogUpdatedAtData';
  catalogUniqueId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CatalogUpsertArchiveUerBaseCostBasisesInput = {
  /** ID каталога */
  catalogId: Scalars['Long'];
  /** Глава расчет */
  chapter?: InputMaybe<ChapterEnum>;
  /** Файл zip сметы-основания */
  content: FileInput;
  /** Файлы Xml сметы-основания */
  justification: Scalars['String'];
  /** Тип УЕР */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
};

export type CatalogUpsertMultiUerBaseCostBasisesInput = {
  /** ID каталога */
  catalogId: Scalars['Long'];
  /** Глава расчет */
  chapter?: InputMaybe<ChapterEnum>;
  /** Файлы Xml сметы-основания */
  contents: Array<FileInput>;
  /** Файлы Xml сметы-основания */
  justification: Scalars['String'];
  /** Тип УЕР */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
};

/** Изменения справочника видов работ методологии УЕР */
export type CatalogWorkTypeChangesData = {
  __typename?: 'CatalogWorkTypeChangesData';
  /** id справочника */
  catalogId: Scalars['Long'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Изменения справочника видов работ методологии УЕР */
export type CatalogWorkTypeChangesDataInput = {
  /** id справочника */
  catalogId: Scalars['Long'];
  /** Дата изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** A segment of a collection. */
export type CatalogWorkTypeCodeFilterCollectionSegment = {
  __typename?: 'CatalogWorkTypeCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Входные данные для создания вида работ */
export type CatalogWorkTypeCreateInput = {
  /** Id справочника */
  catalogId: Scalars['Long'];
  /** Код */
  code: Scalars['String'];
  /** Наименование */
  name: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
};

/** Справочник видов работ методологии УЕР */
export type CatalogWorkTypeData = {
  __typename?: 'CatalogWorkTypeData';
  /** Код */
  code: Scalars['String'];
  hasPrice: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Справочник видов работ методологии УЕР */
export type CatalogWorkTypeDataFilterInput = {
  and?: InputMaybe<Array<CatalogWorkTypeDataFilterInput>>;
  /** Код */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  hasPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CatalogWorkTypeDataFilterInput>>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Дата изменения */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Справочник видов работ методологии УЕР */
export type CatalogWorkTypeDataInput = {
  /** Код */
  code: Scalars['String'];
  hasPrice: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Дата изменения */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Справочник видов работ методологии УЕР */
export type CatalogWorkTypeDataSortInput = {
  /** Код */
  code?: InputMaybe<SortEnumType>;
  hasPrice?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Дата изменения */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CatalogWorkTypeItemsCollectionSegment = {
  __typename?: 'CatalogWorkTypeItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogWorkTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogWorkTypeNameFilterCollectionSegment = {
  __typename?: 'CatalogWorkTypeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Входные данные для обновления вида работ */
export type CatalogWorkTypeUpdateInput = {
  /** Id справочника */
  catalogId: Scalars['Long'];
  /** Код */
  code: Scalars['String'];
  /** Идентификатор вида работ */
  id: Scalars['Int'];
  /** Наименование */
  name: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
};

/** A segment of a collection. */
export type CatalogWorkTypesCollectionSegment = {
  __typename?: 'CatalogWorkTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogWorkTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogsCollectionSegment = {
  __typename?: 'CatalogsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type CatalogsNameFilterCollectionSegment = {
  __typename?: 'CatalogsNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/**
 * Флаги уведомления об изменениях связанных объектов.
 * Фронтенд может отображать различные уведомления в зависимости от их наличия.
 */
export enum ChangeNoticeFlags {
  None = 'NONE',
  OnCostRoundingChange = 'ON_COST_ROUNDING_CHANGE',
  OnObjectStructureChange = 'ON_OBJECT_STRUCTURE_CHANGE',
  OnSeasonsChange = 'ON_SEASONS_CHANGE',
  OnTaxPercentChange = 'ON_TAX_PERCENT_CHANGE'
}

export type ChangeSeasonWorkVolumeInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Список идентификаторов объектов/подобъектов */
  calculationObjectIds: Array<Scalars['Long']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Значение множителя */
  multiplierValue: Scalars['Decimal'];
  /** Идентификатор сезона-источника объемов */
  sourceSeasonId: Scalars['Long'];
  /** Идентификатор сезона для изменения объема */
  targetSeasonId: Scalars['Long'];
};

export enum ChapterEnum {
  /** Глава 1-7 */
  Chapter1_7 = 'CHAPTER1_7',
  /** Глава 8 */
  Chapter8 = 'CHAPTER8',
  /** Глава 9 */
  Chapter9 = 'CHAPTER9',
  /** Доптранспорт и лимитированные затраты */
  LimitedCosts = 'LIMITED_COSTS',
  /** Прочие */
  Others = 'OTHERS'
}

export type ChapterEnumOperationFilterInput = {
  eq?: InputMaybe<ChapterEnum>;
  in?: InputMaybe<Array<ChapterEnum>>;
  neq?: InputMaybe<ChapterEnum>;
  nin?: InputMaybe<Array<ChapterEnum>>;
};

/** Результат проверки доступности добавления расценок из справочника по видам строительства */
export type CheckConstructionTypesToAddUersData = {
  __typename?: 'CheckConstructionTypesToAddUersData';
  /** Список видов строительства с признаком доступности */
  data: Array<ConstructionTypeAvailabilityData>;
};

/** Результат проверки доступности добавления расценок из справочника по видам строительства */
export type CheckConstructionTypesToAddUersDataInput = {
  /** Список видов строительства с признаком доступности */
  data: Array<ConstructionTypeAvailabilityDataInput>;
};

/** Коэффициенты инфляции по сезонам */
export type CoefficientInflationRateInput = {
  /** ID сезона в договоре */
  contractSeasonId: Scalars['Long'];
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
};

/** Данные объекта/подобъекта */
export type CollectionMtrCalculationObjectData = {
  __typename?: 'CollectionMtrCalculationObjectData';
  /** Идентификатор объекта/подобъекта */
  calculationObjectId: Scalars['Long'];
  /** Код вида строительства */
  constructionTypeCode: Scalars['String'];
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Long'];
  /** Краткое наименование вида строительства */
  constructionTypeShortName: Scalars['String'];
  /** Наименование объекта строительства */
  name: Scalars['String'];
  /** Номер по порядку */
  order?: Maybe<Scalars['Int']>;
};

/** Данные объекта/подобъекта */
export type CollectionMtrCalculationObjectDataInput = {
  /** Идентификатор объекта/подобъекта */
  calculationObjectId: Scalars['Long'];
  /** Код вида строительства */
  constructionTypeCode: Scalars['String'];
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Long'];
  /** Краткое наименование вида строительства */
  constructionTypeShortName: Scalars['String'];
  /** Наименование объекта строительства */
  name: Scalars['String'];
  /** Номер по порядку */
  order?: InputMaybe<Scalars['Int']>;
};

/** Позиция МТР для переименования */
export type CollectionMtrForReplacementData = {
  __typename?: 'CollectionMtrForReplacementData';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: Maybe<Scalars['Decimal']>;
};

/** Позиции Ведомости МТР */
export type CollectionMtrItem = {
  __typename?: 'CollectionMtrItem';
  code?: Maybe<Scalars['String']>;
  /** Величина нормы расхода ресурса */
  consumptionRate?: Maybe<Scalars['Decimal']>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr: Scalars['Boolean'];
  id: Scalars['Long'];
  /** Признак учета/не учета в расчете доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Рекомендованные позиции МТР, которые содержатся в Сборнике расценок в составе расценки Type = Mtr. */
  isRecommended: Scalars['Boolean'];
  isUpdatedFromUERBaseCosts: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: Maybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Тип ценообразования */
  pricingType?: Maybe<PricingTypeEnum>;
  /** Статус записи */
  status?: Maybe<MtrStatus>;
  /** Кем поставляется */
  supplyBy?: Maybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: Maybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: Maybe<Scalars['Decimal']>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Позиции Ведомости МТР */
export type CollectionMtrItemInput = {
  code?: InputMaybe<Scalars['String']>;
  /** Величина нормы расхода ресурса */
  consumptionRate?: InputMaybe<Scalars['Decimal']>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr: Scalars['Boolean'];
  id: Scalars['Long'];
  /** Признак учета/не учета в расчете доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Рекомендованные позиции МТР, которые содержатся в Сборнике расценок в составе расценки Type = Mtr. */
  isRecommended: Scalars['Boolean'];
  isUpdatedFromUERBaseCosts: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Тип ценообразования */
  pricingType?: InputMaybe<PricingTypeEnum>;
  /** Статус записи */
  status?: InputMaybe<MtrStatus>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
  /** Дата обновления */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Позиции Ведомости МТР */
export type CollectionMtrItemShort = {
  __typename?: 'CollectionMtrItemShort';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Кем поставляется */
  supplyBy?: Maybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
};

/** Позиции Ведомости МТР */
export type CollectionMtrItemShortFilterInput = {
  and?: InputMaybe<Array<CollectionMtrItemShortFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Тип МТР */
  mtrType?: InputMaybe<NullableOfMtrTypeEnumOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionMtrItemShortFilterInput>>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<NullableOfContragentTypeEnumOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Значения позиций Ведомости МТР */
export type CollectionMtrItemValue = {
  __typename?: 'CollectionMtrItemValue';
  /** Идентификатор МТР */
  id?: Maybe<Scalars['Long']>;
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  /** Данные ВОР по сезонам */
  seasonsData: Array<ObjectSeasonsData>;
  /** Кем поставляется */
  supplyBy?: Maybe<ContragentTypeEnum>;
  /** Объем, Гарант */
  totalGuaranteedVolume?: Maybe<Scalars['Decimal']>;
  /** Объем, Негарант */
  totalNotGuaranteedVolume?: Maybe<Scalars['Decimal']>;
  /** Объемы по всем сезонам по всем подобъектам для корневого объекта по строке позиции МТР */
  totalVolume?: Maybe<Scalars['Decimal']>;
};

/** Значения позиций Ведомости МТР */
export type CollectionMtrItemValueInput = {
  /** Идентификатор МТР */
  id?: InputMaybe<Scalars['Long']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Данные ВОР по сезонам */
  seasonsData: Array<ObjectSeasonsDataInput>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Объем, Гарант */
  totalGuaranteedVolume?: InputMaybe<Scalars['Decimal']>;
  /** Объем, Негарант */
  totalNotGuaranteedVolume?: InputMaybe<Scalars['Decimal']>;
  /** Объемы по всем сезонам по всем подобъектам для корневого объекта по строке позиции МТР */
  totalVolume?: InputMaybe<Scalars['Decimal']>;
};

/** Значения позиций Ведомости МТР с итоговой стоимостью в текущем уровне цен для позиций Материалов и Оборудования Подрядчика */
export type CollectionMtrItemValueTotals = {
  __typename?: 'CollectionMtrItemValueTotals';
  /** Все объекты/подобъекты по расчету НМЦ */
  calculationObjects: Array<CollectionMtrCalculationObjectData>;
  /** Значения позиций Ведомости МТР */
  collectionMtrItemValues: Array<CollectionMtrItemValue>;
  /** Итоговая стоимости в текущем уровне цен для позиций Материалов и Оборудования Подрядчика на форме Ведомости МТР */
  collectionMtrTotals: CollectionMtrTotals;
  /** Все сезоны по расчету НМЦ */
  seasons: Array<Scalars['Short']>;
};

/** Итоговая стоимость в текущем уровне цен для позиций Материалов и Оборудования */
export type CollectionMtrTotals = {
  __typename?: 'CollectionMtrTotals';
  /** цена за оборудоване */
  equipment: Scalars['Decimal'];
  /** цена за материалы */
  material: Scalars['Decimal'];
};

/** Итоговая стоимость в текущем уровне цен для позиций Материалов и Оборудования */
export type CollectionMtrTotalsInput = {
  /** цена за оборудоване */
  equipment: Scalars['Decimal'];
  /** цена за материалы */
  material: Scalars['Decimal'];
};

export type CollectionMtrUersItem = {
  __typename?: 'CollectionMtrUersItem';
  code?: Maybe<Scalars['String']>;
  /** Наименование кода группы */
  codeGroupName: MtrGroupName;
  /**
   * 0 - осли порядковый номер не установлен
   * максимальное значение 9999
   */
  codeGroupNumber: Scalars['Int'];
  /** Величина нормы расхода ресурса */
  consumptionRate?: Maybe<Scalars['Decimal']>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr: Scalars['Boolean'];
  /** Наличие у Мтр связных объектов в ВОР */
  hasWOR: Scalars['Boolean'];
  id: Scalars['Long'];
  /** Признак учета/не учета в расчете доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Рекомендованные позиции МТР, которые содержатся в Сборнике расценок в составе расценки Type = Mtr. */
  isRecommended: Scalars['Boolean'];
  isUpdatedFromUERBaseCosts: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: Maybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Тип ценообразования */
  pricingType?: Maybe<PricingTypeEnum>;
  /** Статус записи */
  status?: Maybe<MtrStatus>;
  /** Кем поставляется */
  supplyBy?: Maybe<ContragentTypeEnum>;
  /** Список расценок */
  uers?: Maybe<Array<CollectionUerBaseCostItemMinimal>>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: Maybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: Maybe<Scalars['Decimal']>;
  /** Дата обновления */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CollectionMtrUersItemFilterInput = {
  and?: InputMaybe<Array<CollectionMtrUersItemFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование кода группы */
  codeGroupName?: InputMaybe<MtrGroupNameOperationFilterInput>;
  /**
   * 0 - осли порядковый номер не установлен
   * максимальное значение 9999
   */
  codeGroupNumber?: InputMaybe<IntOperationFilterInput>;
  /** Величина нормы расхода ресурса */
  consumptionRate?: InputMaybe<DecimalOperationFilterInput>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие у Мтр связных объектов в ВОР */
  hasWOR?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак учета/не учета в расчете доп. транспорта */
  isIncludedInTransportCalculation?: InputMaybe<BooleanOperationFilterInput>;
  /** Рекомендованные позиции МТР, которые содержатся в Сборнике расценок в составе расценки Type = Mtr. */
  isRecommended?: InputMaybe<BooleanOperationFilterInput>;
  isUpdatedFromUERBaseCosts?: InputMaybe<BooleanOperationFilterInput>;
  /** Код МТР */
  mtrKind?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Тип МТР */
  mtrType?: InputMaybe<NullableOfMtrTypeEnumOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionMtrUersItemFilterInput>>;
  /** Тип ценообразования */
  pricingType?: InputMaybe<NullableOfPricingTypeEnumOperationFilterInput>;
  /** Статус записи */
  status?: InputMaybe<NullableOfMtrStatusOperationFilterInput>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<NullableOfContragentTypeEnumOperationFilterInput>;
  /** Список расценок */
  uers?: InputMaybe<ListFilterInputTypeOfCollectionUerBaseCostItemMinimalFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<DecimalOperationFilterInput>;
  /** Дата обновления */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CollectionMtrUersItemInput = {
  code?: InputMaybe<Scalars['String']>;
  /** Наименование кода группы */
  codeGroupName: MtrGroupName;
  /**
   * 0 - осли порядковый номер не установлен
   * максимальное значение 9999
   */
  codeGroupNumber: Scalars['Int'];
  /** Величина нормы расхода ресурса */
  consumptionRate?: InputMaybe<Scalars['Decimal']>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr: Scalars['Boolean'];
  /** Наличие у Мтр связных объектов в ВОР */
  hasWOR: Scalars['Boolean'];
  id: Scalars['Long'];
  /** Признак учета/не учета в расчете доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Рекомендованные позиции МТР, которые содержатся в Сборнике расценок в составе расценки Type = Mtr. */
  isRecommended: Scalars['Boolean'];
  isUpdatedFromUERBaseCosts: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Тип ценообразования */
  pricingType?: InputMaybe<PricingTypeEnum>;
  /** Статус записи */
  status?: InputMaybe<MtrStatus>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Список расценок */
  uers?: InputMaybe<Array<CollectionUerBaseCostItemMinimalInput>>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
  /** Дата обновления */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Данные Области применения */
export type CollectionRatioApplicationAreaInput = {
  /** Идентификаторы коэффициентов */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Идентификаторы расценок */
  uerBaseCostIds?: InputMaybe<Array<Scalars['Long']>>;
};

/** Объект данных, передаваемых для создания коэффициента */
export type CollectionRatioCreateInput = {
  /** Данные об области применения */
  applicationArea?: InputMaybe<CollectionRatioApplicationAreaInput>;
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор группы */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Наименование */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Строка справочника коэффициентов */
export type CollectionRatioData = {
  __typename?: 'CollectionRatioData';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак коэффициента созданного вручную */
  isCustom: Scalars['Boolean'];
  /** Причина изменения коэффициента */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: CollectionRatioStatusEnum;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataForList = {
  __typename?: 'CollectionRatioDataForList';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: Maybe<Scalars['String']>;
  /** прикреплена ли к коэффициенту хотя бы одна расценка */
  hasCosts: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак коэффициента созданного вручную */
  isCustom: Scalars['Boolean'];
  /** Используется лм коэффициент в ВОР и/или расчете НМЦ */
  isUsed: Scalars['Boolean'];
  /** Причина изменения коэффициента */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: CollectionRatioStatusEnum;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataForListFilterInput = {
  and?: InputMaybe<Array<CollectionRatioDataForListFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** прикреплена ли к коэффициенту хотя бы одна расценка */
  hasCosts?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак коэффициента созданного вручную */
  isCustom?: InputMaybe<BooleanOperationFilterInput>;
  /** Используется лм коэффициент в ВОР и/или расчете НМЦ */
  isUsed?: InputMaybe<BooleanOperationFilterInput>;
  /** Причина изменения коэффициента */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Условия производства работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionRatioDataForListFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Статус коэффициента */
  status?: InputMaybe<CollectionRatioStatusEnumOperationFilterInput>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataForListSortInput = {
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: InputMaybe<SortEnumType>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: InputMaybe<SortEnumType>;
  /** прикреплена ли к коэффициенту хотя бы одна расценка */
  hasCosts?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак коэффициента созданного вручную */
  isCustom?: InputMaybe<SortEnumType>;
  /** Используется лм коэффициент в ВОР и/или расчете НМЦ */
  isUsed?: InputMaybe<SortEnumType>;
  /** Причина изменения коэффициента */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  name?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  status?: InputMaybe<SortEnumType>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataInput = {
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак коэффициента созданного вручную */
  isCustom: Scalars['Boolean'];
  /** Причина изменения коэффициента */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: CollectionRatioStatusEnum;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataShort = {
  __typename?: 'CollectionRatioDataShort';
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: Maybe<Scalars['String']>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataShortFilterInput = {
  and?: InputMaybe<Array<CollectionRatioDataShortFilterInput>>;
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Условия производства работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionRatioDataShortFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataShortSortInput = {
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: InputMaybe<SortEnumType>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<SortEnumType>;
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  name?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataWithCosts = {
  __typename?: 'CollectionRatioDataWithCosts';
  /** Код шифра */
  code: Scalars['String'];
  /** Группа работ, включает расценки. */
  collectionRatioGroup?: Maybe<CollectionRatioGroupDataWithCosts>;
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак коэффициента созданного вручную */
  isCustom: Scalars['Boolean'];
  /** Причина изменения коэффициента */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: CollectionRatioStatusEnum;
  /** Список расценок привязанных к данному коэффициенту */
  uerBaseCostItems: Array<CollectionUerBaseCostItemMinimal>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioDataWithCostsInput = {
  /** Код шифра */
  code: Scalars['String'];
  /** Группа работ, включает расценки. */
  collectionRatioGroup?: InputMaybe<CollectionRatioGroupDataWithCostsInput>;
  /** Идентификатор группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  collectionRatioGroupName?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак коэффициента созданного вручную */
  isCustom: Scalars['Boolean'];
  /** Причина изменения коэффициента */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: CollectionRatioStatusEnum;
  /** Список расценок привязанных к данному коэффициенту */
  uerBaseCostItems: Array<CollectionUerBaseCostItemMinimalInput>;
  /** Дата/Время последнего изменеения записи */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CollectionRatioGroupData = {
  __typename?: 'CollectionRatioGroupData';
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской группы */
  parentId?: Maybe<Scalars['Long']>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CollectionRatioGroupDataInput = {
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской группы */
  parentId?: InputMaybe<Scalars['Long']>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CollectionRatioGroupDataWithCosts = {
  __typename?: 'CollectionRatioGroupDataWithCosts';
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской группы */
  parentId?: Maybe<Scalars['Long']>;
  /** Список расценок привязанных к данному коэффициенту */
  uerBaseCostItems: Array<CollectionUerBaseCostItemMinimal>;
};

/** Группа коэффициентов типов Стесненности или Демонтажа */
export type CollectionRatioGroupDataWithCostsInput = {
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской группы */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Список расценок привязанных к данному коэффициенту */
  uerBaseCostItems: Array<CollectionUerBaseCostItemMinimalInput>;
};

/** Краткая строка справочника коэффициентов */
export type CollectionRatioShortData = {
  __typename?: 'CollectionRatioShortData';
  /** Шифр коэффициента */
  code: Scalars['String'];
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  collectionRatioGroupId?: Maybe<Scalars['Long']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Краткая строка справочника коэффициентов */
export type CollectionRatioShortDataInput = {
  /** Шифр коэффициента */
  code: Scalars['String'];
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Возможные статусы коэффициента в сборнике */
export enum CollectionRatioStatusEnum {
  /** Условие расчета */
  CalculationCondition = 'CALCULATION_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  New = 'NEW'
}

export type CollectionRatioStatusEnumOperationFilterInput = {
  eq?: InputMaybe<CollectionRatioStatusEnum>;
  in?: InputMaybe<Array<CollectionRatioStatusEnum>>;
  neq?: InputMaybe<CollectionRatioStatusEnum>;
  nin?: InputMaybe<Array<CollectionRatioStatusEnum>>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioUersDataShort = {
  __typename?: 'CollectionRatioUersDataShort';
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: Maybe<Scalars['Long']>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: Maybe<Scalars['String']>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat: Scalars['Decimal'];
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Условия производства работ */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Строка справочника коэффициентов */
export type CollectionRatioUersDataShortFilterInput = {
  and?: InputMaybe<Array<CollectionRatioUersDataShortFilterInput>>;
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Условия производства работ */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionRatioUersDataShortFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
};

/** Строка справочника коэффициентов */
export type CollectionRatioUersDataShortSortInput = {
  /** Идентификатор группы работ для коэффициентов стесненности/демонтажа. */
  catalogRatioGroupId?: InputMaybe<SortEnumType>;
  /** Название группы работ для коэффициентов стесненности / демонтажа. */
  catalogRatioGroupName?: InputMaybe<SortEnumType>;
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  name?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
};

/** Объект данных, передаваемых для редактирования коэффициента */
export type CollectionRatioUpdateInput = {
  /** Данные об области применения */
  applicationArea?: InputMaybe<CollectionRatioApplicationAreaInput>;
  /** Идентификатор группы */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Наименование */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type CollectionUerBaseCostData = {
  __typename?: 'CollectionUERBaseCostData';
  /** Глава в расчете */
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<ConstructionTypeData>;
  directCost?: Maybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  /** Разделы */
  estimateBasisSections: Array<CollectionUerBaseCostEstimateBasisSectionData>;
  /** ФОТ */
  fot?: Maybe<Scalars['Decimal']>;
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  /** Группы коэффициентов */
  ratioGroups: Array<CollectionRatioGroupData>;
  /** Коэффициенты */
  ratios: Array<CollectionRatioShortData>;
  /** Имя раздела */
  sectionName: Scalars['String'];
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: Maybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: Maybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: Maybe<UerClassifierEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  /** Виды работ */
  workScopes: Array<CollectionUerBaseCostWorkScopeData>;
  workType: CollectionUerBaseWorkData;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type CollectionUerBaseCostDataInput = {
  /** Глава в расчете */
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypes: Array<ConstructionTypeDataInput>;
  directCost?: InputMaybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** Разделы */
  estimateBasisSections: Array<CollectionUerBaseCostEstimateBasisSectionDataInput>;
  /** ФОТ */
  fot?: InputMaybe<Scalars['Decimal']>;
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** Группы коэффициентов */
  ratioGroups: Array<CollectionRatioGroupDataInput>;
  /** Коэффициенты */
  ratios: Array<CollectionRatioShortDataInput>;
  /** Имя раздела */
  sectionName: Scalars['String'];
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: InputMaybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  /** Виды работ */
  workScopes: Array<CollectionUerBaseCostWorkScopeDataInput>;
  workType: CollectionUerBaseWorkDataInput;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type CollectionUerBaseCostEstimateBasisData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisData';
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Группа к которой относятся данные */
  group: CollectionUerBaseCostEstimateBasisDataGroupEnum;
  /** Идентификатор */
  id?: Maybe<Scalars['Long']>;
  /** Позиция удалена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  isHeadLine: Scalars['Boolean'];
  /** Не имеет количества */
  isNotCount?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: Maybe<Scalars['Decimal']>;
};

export type CollectionUerBaseCostEstimateBasisDataFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisDataFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Группа к которой относятся данные */
  group?: InputMaybe<CollectionUerBaseCostEstimateBasisDataGroupEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Позиция удалена */
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisDataFilterInput>>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
};

export enum CollectionUerBaseCostEstimateBasisDataGroupEnum {
  /** Неценообразующие МТР */
  Mat = 'MAT',
  /** Машины и механизмы */
  Mch = 'MCH',
  /** Ценообразующие МТР */
  Mtr = 'MTR',
  /** Трудозатраты */
  TzTm = 'TZ_TM'
}

export type CollectionUerBaseCostEstimateBasisDataGroupEnumOperationFilterInput = {
  eq?: InputMaybe<CollectionUerBaseCostEstimateBasisDataGroupEnum>;
  in?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisDataGroupEnum>>;
  neq?: InputMaybe<CollectionUerBaseCostEstimateBasisDataGroupEnum>;
  nin?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisDataGroupEnum>>;
};

/** Позиция расценки в смете-основании */
export type CollectionUerBaseCostEstimateBasisDetailedData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisDetailedData';
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  name: Scalars['String'];
  quantity: CollectionUerBaseCostEstimateBasisQuantityData;
  resources: Array<CollectionUerBaseCostEstimateBasisResourceData>;
  totalCost?: Maybe<CollectionUerBaseCostEstimateBasisTotalCostData>;
  totalWorkCost?: Maybe<CollectionUerBaseCostEstimateBasisWorkCostData>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: Maybe<CollectionUerBaseCostEstimateBasisUnitCostData>;
  unitWorkCost?: Maybe<CollectionUerBaseCostEstimateBasisWorkCostData>;
};

/** Позиция расценки в смете-основании */
export type CollectionUerBaseCostEstimateBasisDetailedDataInput = {
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  name: Scalars['String'];
  quantity: CollectionUerBaseCostEstimateBasisQuantityDataInput;
  resources: Array<CollectionUerBaseCostEstimateBasisResourceDataInput>;
  totalCost?: InputMaybe<CollectionUerBaseCostEstimateBasisTotalCostDataInput>;
  totalWorkCost?: InputMaybe<CollectionUerBaseCostEstimateBasisWorkCostDataInput>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<CollectionUerBaseCostEstimateBasisUnitCostDataInput>;
  unitWorkCost?: InputMaybe<CollectionUerBaseCostEstimateBasisWorkCostDataInput>;
};

/** Количественных данные для позиции */
export type CollectionUerBaseCostEstimateBasisQuantityData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisQuantityData';
  /** Норма расхода */
  consumptionRateMtr?: Maybe<Scalars['Decimal']>;
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Количественных данные для позиции */
export type CollectionUerBaseCostEstimateBasisQuantityDataInput = {
  /** Норма расхода */
  consumptionRateMtr?: InputMaybe<Scalars['Decimal']>;
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

export type CollectionUerBaseCostEstimateBasisResourceCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisResourceCostData';
  /** Машины и механизмы ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** Неценообразующие МТР */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты (машинистов и рабочих) */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** Машины и механизмы ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type CollectionUerBaseCostEstimateBasisResourceCostDataInput = {
  /** Машины и механизмы ЭММ */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Неценообразующие МТР */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты (машинистов и рабочих) */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** Машины и механизмы ЗПМ */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Ресурс расценки */
export type CollectionUerBaseCostEstimateBasisResourceData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisResourceData';
  /** Шифр */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Позиция удалена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CollectionUerBaseCostEstimateBasisResourceQuantityData;
  /** Общая стоимость */
  totalCost?: Maybe<CollectionUerBaseCostEstimateBasisResourceCostData>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: Maybe<CollectionUerBaseCostEstimateBasisResourceCostData>;
};

/** Ресурс расценки */
export type CollectionUerBaseCostEstimateBasisResourceDataInput = {
  /** Шифр */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Позиция удалена */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CollectionUerBaseCostEstimateBasisResourceQuantityDataInput;
  /** Общая стоимость */
  totalCost?: InputMaybe<CollectionUerBaseCostEstimateBasisResourceCostDataInput>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: InputMaybe<CollectionUerBaseCostEstimateBasisResourceCostDataInput>;
};

/** Количественные данные для позиции */
export type CollectionUerBaseCostEstimateBasisResourceQuantityData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisResourceQuantityData';
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Количественные данные для позиции */
export type CollectionUerBaseCostEstimateBasisResourceQuantityDataInput = {
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Данные для обновления ресурса расценки */
export type CollectionUerBaseCostEstimateBasisResourceUpdateInput = {
  /** Шифр */
  code: Scalars['String'];
  /** Идентификатор */
  id?: InputMaybe<Scalars['Long']>;
  /** Позиция удалена */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Количественные данные */
  quantity: CollectionUerBaseCostEstimateBasisResourceQuantityDataInput;
  /** Общая стоимость */
  totalCost?: InputMaybe<CollectionUerBaseCostEstimateBasisResourceCostDataInput>;
  /** Тип ресурса */
  type: UerBasisResourceCostTypeEnum;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost?: InputMaybe<CollectionUerBaseCostEstimateBasisResourceCostDataInput>;
};

export type CollectionUerBaseCostEstimateBasisRow = {
  __typename?: 'CollectionUERBaseCostEstimateBasisRow';
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Общая стоимость с учетом НР и СП */
  estimateTotal?: Maybe<Scalars['Decimal']>;
  /** Позиция удалена */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Не имеет количества */
  isNotCount?: Maybe<Scalars['Boolean']>;
  /** Признак того что строка является заголовком расценки */
  isPriceHeadLine: Scalars['Boolean'];
  /** Признак того сто строка является заголовком раздела */
  isSectionHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Порядковый номер раздела или расценки */
  number?: Maybe<Scalars['Int']>;
  /** Идентификатор строки родителя */
  parentRowId?: Maybe<Scalars['String']>;
  /** Идентификатор расценки */
  priceId?: Maybe<Scalars['Long']>;
  /** Количественные данные для позиции */
  quantity?: Maybe<CollectionUerBaseCostEstimateBasisRowQuantityData>;
  /** Идентификатор ресурса */
  resourceId?: Maybe<Scalars['Long']>;
  /** Идентификатор строки */
  rowId: Scalars['String'];
  /** Идентификатор раздела */
  sectionId: Scalars['Long'];
  /** Порядковый номер */
  sectionOrder?: Maybe<Scalars['Int']>;
  /** Общая стоимость */
  totalCost?: Maybe<CollectionUerBaseCostEstimateBasisRowTotalCostData>;
  /** Трудозатраты всего */
  totalWorkCost?: Maybe<CollectionUerBaseCostEstimateBasisRowWorkCostData>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость на единицу */
  unitCost?: Maybe<CollectionUerBaseCostEstimateBasisRowUnitCostData>;
  /** Трудозатраты на единицу */
  unitWorkCost?: Maybe<CollectionUerBaseCostEstimateBasisRowWorkCostData>;
};

export type CollectionUerBaseCostEstimateBasisRowFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Общая стоимость с учетом НР и СП */
  estimateTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** Позиция удалена */
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  /** Не имеет количества */
  isNotCount?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того что строка является заголовком расценки */
  isPriceHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того сто строка является заголовком раздела */
  isSectionHeadLine?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Порядковый номер раздела или расценки */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowFilterInput>>;
  /** Идентификатор строки родителя */
  parentRowId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор расценки */
  priceId?: InputMaybe<LongOperationFilterInput>;
  /** Количественные данные для позиции */
  quantity?: InputMaybe<CollectionUerBaseCostEstimateBasisRowQuantityDataFilterInput>;
  /** Идентификатор ресурса */
  resourceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор строки */
  rowId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Порядковый номер */
  sectionOrder?: InputMaybe<IntOperationFilterInput>;
  /** Общая стоимость */
  totalCost?: InputMaybe<CollectionUerBaseCostEstimateBasisRowTotalCostDataFilterInput>;
  /** Трудозатраты всего */
  totalWorkCost?: InputMaybe<CollectionUerBaseCostEstimateBasisRowWorkCostDataFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость на единицу */
  unitCost?: InputMaybe<CollectionUerBaseCostEstimateBasisRowUnitCostDataFilterInput>;
  /** Трудозатраты на единицу */
  unitWorkCost?: InputMaybe<CollectionUerBaseCostEstimateBasisRowWorkCostDataFilterInput>;
};

/** Количественных данные для позиции */
export type CollectionUerBaseCostEstimateBasisRowQuantityData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisRowQuantityData';
  /** Общее количество */
  total: Scalars['Decimal'];
  /** Количество на одну единицу */
  unit: Scalars['Decimal'];
};

/** Количественных данные для позиции */
export type CollectionUerBaseCostEstimateBasisRowQuantityDataFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowQuantityDataFilterInput>>;
  or?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowQuantityDataFilterInput>>;
  /** Общее количество */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** Количество на одну единицу */
  unit?: InputMaybe<DecimalOperationFilterInput>;
};

/** Общая стоимость */
export type CollectionUerBaseCostEstimateBasisRowTotalCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisRowTotalCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** НР */
  nr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** СП */
  sp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Общая стоимость */
export type CollectionUerBaseCostEstimateBasisRowTotalCostDataFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowTotalCostDataFilterInput>>;
  /** ЭММ */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** МАТ */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** НР */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowTotalCostDataFilterInput>>;
  /** ОЗП */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** СП */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Всего */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** ЗПМ */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Стоимость на единицу */
export type CollectionUerBaseCostEstimateBasisRowUnitCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisRowUnitCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Стоимость на единицу */
export type CollectionUerBaseCostEstimateBasisRowUnitCostDataFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowUnitCostDataFilterInput>>;
  /** ЭММ */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** МАТ */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowUnitCostDataFilterInput>>;
  /** ОЗП */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Всего */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** ЗПМ */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Трудозатраты */
export type CollectionUerBaseCostEstimateBasisRowWorkCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisRowWorkCostData';
  /** Трудозатраты ЗТм */
  tm?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТ */
  tz?: Maybe<Scalars['Decimal']>;
};

/** Трудозатраты */
export type CollectionUerBaseCostEstimateBasisRowWorkCostDataFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowWorkCostDataFilterInput>>;
  or?: InputMaybe<Array<CollectionUerBaseCostEstimateBasisRowWorkCostDataFilterInput>>;
  /** Трудозатраты ЗТм */
  tm?: InputMaybe<DecimalOperationFilterInput>;
  /** Трудозатраты ЗТ */
  tz?: InputMaybe<DecimalOperationFilterInput>;
};

export type CollectionUerBaseCostEstimateBasisSectionData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisSectionData';
  /** Дочерние расценки */
  estimateBasisRows: Array<CollectionUerBaseCostEstimateBasisDetailedData>;
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Порядковый номер */
  order?: Maybe<Scalars['Int']>;
};

export type CollectionUerBaseCostEstimateBasisSectionDataInput = {
  /** Дочерние расценки */
  estimateBasisRows: Array<CollectionUerBaseCostEstimateBasisDetailedDataInput>;
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Порядковый номер */
  order?: InputMaybe<Scalars['Int']>;
};

export type CollectionUerBaseCostEstimateBasisSectionUpdateInput = {
  /** Дочерние расценки */
  estimateBasisRows: Array<CollectionUerBaseCostEstimateBasisUpdateInput>;
  id?: InputMaybe<Scalars['Long']>;
  /** Наименование */
  name: Scalars['String'];
  /** Порядковый номер */
  order?: InputMaybe<Scalars['Int']>;
};

/** Общая Стоимость позиции в базисном уровне цен */
export type CollectionUerBaseCostEstimateBasisTotalCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisTotalCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** НР */
  nr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** СП */
  sp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Общая Стоимость позиции в базисном уровне цен */
export type CollectionUerBaseCostEstimateBasisTotalCostDataInput = {
  /** ЭММ */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** НР */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** СП */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Стоимость позиции на одну единицу в базисном уровне цен */
export type CollectionUerBaseCostEstimateBasisUnitCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisUnitCostData';
  /** ЭММ */
  emm?: Maybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: Maybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Стоимость позиции на одну единицу в базисном уровне цен */
export type CollectionUerBaseCostEstimateBasisUnitCostDataInput = {
  /** ЭММ */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** МАТ */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** ОЗП */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Всего */
  total: Scalars['Decimal'];
  /** ЗПМ */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для обновления позиции расценки в смете-основании */
export type CollectionUerBaseCostEstimateBasisUpdateInput = {
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  quantity: CollectionUerBaseCostEstimateBasisQuantityDataInput;
  resources: Array<CollectionUerBaseCostEstimateBasisResourceUpdateInput>;
  totalCost?: InputMaybe<CollectionUerBaseCostEstimateBasisTotalCostDataInput>;
  totalWorkCost?: InputMaybe<CollectionUerBaseCostEstimateBasisWorkCostDataInput>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<CollectionUerBaseCostEstimateBasisUnitCostDataInput>;
  unitWorkCost?: InputMaybe<CollectionUerBaseCostEstimateBasisWorkCostDataInput>;
};

/** Трудозатраты */
export type CollectionUerBaseCostEstimateBasisWorkCostData = {
  __typename?: 'CollectionUERBaseCostEstimateBasisWorkCostData';
  /** Трудозатраты ЗТм */
  tm?: Maybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТ */
  tz?: Maybe<Scalars['Decimal']>;
};

/** Трудозатраты */
export type CollectionUerBaseCostEstimateBasisWorkCostDataInput = {
  /** Трудозатраты ЗТм */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТ */
  tz?: InputMaybe<Scalars['Decimal']>;
};

export type CollectionUerBaseCostImportFilesInput = {
  /** Глава в расчете */
  chapter: ChapterEnum;
  /** Идентификаторы видов строительства */
  constructionTypeIds: Array<Scalars['Int']>;
  /** Флаг, определяющий необходимо ли копировать связи расценка-коэффициент и расценка-группы коэффициентов */
  copyRatios: Scalars['Boolean'];
  /** Тип расценки */
  uerClassifier: UerClassifierEnum;
};

/** Данные для массового обновления расценок в расчёте НМЦ */
export type CollectionUerBaseCostSetPropertiesInput = {
  /** Идентификаторы расценок из сборника */
  baseRowIds: Array<Scalars['Long']>;
  /** Глава в расчете */
  chapter: ChapterEnum;
  /** Тип расценки */
  uerClassifier: UerClassifierEnum;
};

/** Статус записи */
export enum CollectionUerBaseCostStatus {
  /**
   * Условие расчета
   * для всех позиций расценок, добавленных в Сборник на основании справочника расценок / готового сборника расценок / загруженных смет-оснований
   */
  CalculationCondition = 'CALCULATION_CONDITION',
  /**
   * Черновик
   * для позиций расценок, добавленных в Сборник расценок при импорте ВОР (xlsx, xml)
   */
  Draft = 'DRAFT'
}

/** Строка итога расценки */
export type CollectionUerBaseCostTotalItem = {
  __typename?: 'CollectionUERBaseCostTotalItem';
  /** Признак наличия отступа */
  hasIndent: Scalars['Boolean'];
  /** Признак заголовка */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Порядок */
  sortOrder: Scalars['Int'];
  /** Значение */
  value?: Maybe<Scalars['Decimal']>;
};

export type CollectionUerBaseCostUpdateInput = {
  /** Глава в расчете */
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypeIds: Array<Scalars['Int']>;
  directCost?: InputMaybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** Разделы */
  estimateBasisSections: Array<CollectionUerBaseCostEstimateBasisSectionUpdateInput>;
  /** ФОТ */
  fot?: InputMaybe<Scalars['Decimal']>;
  /** Имя подраздела */
  groupName: Scalars['String'];
  /** Признак обновления сметы основания. Должен быть установлен, если объект содержит данные из файла */
  hasEstimateBasisChanged: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** Идентификаторы групп коэффициентов */
  ratioGroups: Array<Scalars['Long']>;
  /** Идентификаторы коэффициентов */
  ratios: Array<Scalars['Long']>;
  /** Наименование раздела */
  sectionName: Scalars['String'];
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** ЗТМ */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: InputMaybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  /** Виды работ */
  workScopes: Array<CollectionUerBaseCostWorkScopeUpdateInput>;
  workType: CollectionUerBaseWorkDataInput;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Работа из состава работ для расценки */
export type CollectionUerBaseCostWorkScopeData = {
  __typename?: 'CollectionUERBaseCostWorkScopeData';
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
};

/** Работа из состава работ для расценки */
export type CollectionUerBaseCostWorkScopeDataFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostWorkScopeDataFilterInput>>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Нумерация состава работ */
  number?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostWorkScopeDataFilterInput>>;
};

/** Работа из состава работ для расценки */
export type CollectionUerBaseCostWorkScopeDataInput = {
  /** Имя */
  name: Scalars['String'];
  /** Нумерация состава работ */
  number: Scalars['Long'];
};

/** Работа из состава работ для расценки */
export type CollectionUerBaseCostWorkScopeUpdateInput = {
  /** Имя */
  name: Scalars['String'];
};

export type CollectionUerBaseWorkData = {
  __typename?: 'CollectionUERBaseWorkData';
  /** Шифр вида работ */
  workCode?: Maybe<Scalars['String']>;
  /** Участие в суммировании ФО по виду работ */
  workInSum: WorkInSumEnum;
  /** Наименование вида работ */
  workName?: Maybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: Maybe<Scalars['String']>;
  /** Ед.изм. вида работ */
  workUnit?: Maybe<Scalars['String']>;
};

export type CollectionUerBaseWorkDataInput = {
  /** Шифр вида работ */
  workCode?: InputMaybe<Scalars['String']>;
  /** Участие в суммировании ФО по виду работ */
  workInSum: WorkInSumEnum;
  /** Наименование вида работ */
  workName?: InputMaybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<Scalars['Decimal']>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<Scalars['String']>;
  /** Ед.изм. вида работ */
  workUnit?: InputMaybe<Scalars['String']>;
};

/** Источник наполнения сборника расценок */
export enum CollectionUerDataSourceEnum {
  Catalog = 'CATALOG',
  Collection = 'COLLECTION',
  Estimate = 'ESTIMATE'
}

export type CollectionUerDataSourceEnumOperationFilterInput = {
  eq?: InputMaybe<CollectionUerDataSourceEnum>;
  in?: InputMaybe<Array<CollectionUerDataSourceEnum>>;
  neq?: InputMaybe<CollectionUerDataSourceEnum>;
  nin?: InputMaybe<Array<CollectionUerDataSourceEnum>>;
};

/** Выбранные значения фильтров каскадной фильтрации сборника расценок УЭР */
export type CollectionUerFilterInput = {
  chapters?: InputMaybe<Array<ChapterEnum>>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  fullNames?: InputMaybe<Array<Scalars['String']>>;
  groupNames?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  sectionNames?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<CollectionUerBaseCostStatus>>;
  uerClassifiers?: InputMaybe<Array<UerClassifierEnum>>;
  workInSum?: InputMaybe<Array<WorkInSumEnum>>;
  workNames?: InputMaybe<Array<Scalars['String']>>;
};

/** Информация о сборнике расценок */
export type CollectionUerInfoData = {
  __typename?: 'CollectionUERInfoData';
  /** Источник заполнения расценок в сборнике */
  dataSource?: Maybe<CollectionUerDataSourceEnum>;
  /** Признак того что в сборнике расценок есть хотя бы одна расценка с источником из справочника */
  hasCatalogPrices: Scalars['Boolean'];
  /** Признак наличия хотя бы одной расценки на странице "Сборник расценок" */
  hasPrices: Scalars['Boolean'];
  /** Признак наличия хотя бы одной записи ВОР */
  hasWorItems: Scalars['Boolean'];
  /** Количество расценок без главы или типа */
  pricesWithoutUerClassifierOrChapterCount: Scalars['Int'];
  /** Идентификаторы видов строительства используемых в расценках */
  usedInUerCollectionConstructionTypeIds: Array<Scalars['Int']>;
};

/** Информация о сборнике расценок */
export type CollectionUerInfoDataInput = {
  /** Источник заполнения расценок в сборнике */
  dataSource?: InputMaybe<CollectionUerDataSourceEnum>;
  /** Признак того что в сборнике расценок есть хотя бы одна расценка с источником из справочника */
  hasCatalogPrices: Scalars['Boolean'];
  /** Признак наличия хотя бы одной расценки на странице "Сборник расценок" */
  hasPrices: Scalars['Boolean'];
  /** Признак наличия хотя бы одной записи ВОР */
  hasWorItems: Scalars['Boolean'];
  /** Количество расценок без главы или типа */
  pricesWithoutUerClassifierOrChapterCount: Scalars['Int'];
  /** Идентификаторы видов строительства используемых в расценках */
  usedInUerCollectionConstructionTypeIds: Array<Scalars['Int']>;
};

/** Выбранные значения фильтров каскадной фильтрации УЭР при добавлении в ведомость объёмов работ */
export type CollectionUerToAddToWorFilterInput = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  groupNames?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  sectionNames?: InputMaybe<Array<Scalars['String']>>;
};

/** Идентификатор */
export type CollectionUerBaseCostItem = {
  __typename?: 'CollectionUerBaseCostItem';
  /** Глава в расчете */
  chapter?: Maybe<ChapterEnum>;
  /** Шифр */
  code: Scalars['String'];
  /** Виды строительства */
  constructionTypeNames: Array<Scalars['String']>;
  /** Источник заполнения */
  dataSource: CollectionUerDataSourceEnum;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName: Scalars['String'];
  /** Подраздел */
  groupName: Scalars['String'];
  hasRatios: Scalars['Boolean'];
  id: Scalars['Long'];
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  /** Раздел */
  sectionName: Scalars['String'];
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** Статус расценки */
  status?: Maybe<CollectionUerBaseCostStatus>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  /** Тип УЕР */
  uerClassifier?: Maybe<UerClassifierEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  /** Вид работ */
  workType: CatalogUerBaseWorkData;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Идентификатор */
export type CollectionUerBaseCostItemFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostItemFilterInput>>;
  /** Глава в расчете */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Виды строительства */
  constructionTypeNames?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Источник заполнения */
  dataSource?: InputMaybe<CollectionUerDataSourceEnumOperationFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование */
  eqp?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Подраздел */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  hasRatios?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** Имя */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostItemFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<DecimalOperationFilterInput>;
  /** Раздел */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Статус расценки */
  status?: InputMaybe<NullableOfCollectionUerBaseCostStatusOperationFilterInput>;
  /** Перевозка */
  trn?: InputMaybe<DecimalOperationFilterInput>;
  /** Тип УЕР */
  uerClassifier?: InputMaybe<NullableOfUerClassifierEnumOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Вид работ */
  workType?: InputMaybe<CatalogUerBaseWorkDataFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostItemMinimal = {
  __typename?: 'CollectionUerBaseCostItemMinimal';
  /** Шифр */
  code: Scalars['String'];
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostItemMinimalFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostItemMinimalFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostItemMinimalFilterInput>>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostItemMinimalInput = {
  /** Шифр */
  code: Scalars['String'];
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Единица измерения */
  unit: Scalars['String'];
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostItemMinimalSortInput = {
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
};

/** Идентификатор */
export type CollectionUerBaseCostItemSortInput = {
  /** Глава в расчете */
  chapter?: InputMaybe<SortEnumType>;
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  /** Источник заполнения */
  dataSource?: InputMaybe<SortEnumType>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Оборудование */
  eqp?: InputMaybe<SortEnumType>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<SortEnumType>;
  /** Подраздел */
  groupName?: InputMaybe<SortEnumType>;
  hasRatios?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<SortEnumType>;
  /** Имя */
  name?: InputMaybe<SortEnumType>;
  /** Накладные расходы */
  nr?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<SortEnumType>;
  /** Раздел */
  sectionName?: InputMaybe<SortEnumType>;
  /** Сметная прибыль */
  sp?: InputMaybe<SortEnumType>;
  /** Статус расценки */
  status?: InputMaybe<SortEnumType>;
  /** Перевозка */
  trn?: InputMaybe<SortEnumType>;
  /** Тип УЕР */
  uerClassifier?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<SortEnumType>;
  /** Вид работ */
  workType?: InputMaybe<CatalogUerBaseWorkDataSortInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostRatioMinimal = {
  __typename?: 'CollectionUerBaseCostRatioMinimal';
  /** Шифр */
  code: Scalars['String'];
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор расценки */
  ratioId: Scalars['Long'];
  /** Статус расценки */
  status?: Maybe<CollectionUerBaseCostStatus>;
  /** Единица измерения */
  unit: Scalars['String'];
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostRatioMinimalFilterInput = {
  and?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalFilterInput>>;
  /** Идентификатор расценки */
  ratioId?: InputMaybe<LongOperationFilterInput>;
  /** Статус расценки */
  status?: InputMaybe<NullableOfCollectionUerBaseCostStatusOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Минимальная информация о расценке - Идентификатор, Шифр, Наименование, Единица измерения */
export type CollectionUerBaseCostRatioMinimalSortInput = {
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  /** Шифр группы + Наименование группы + Наименование расценки */
  fullName?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор расценки */
  ratioId?: InputMaybe<SortEnumType>;
  /** Статус расценки */
  status?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
};

/** Компания */
export type Company = {
  __typename?: 'Company';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор компании в домене (SID) */
  uniqueId: Scalars['String'];
};

export type CompanyData = {
  __typename?: 'CompanyData';
  id: Scalars['Long'];
  name: Scalars['String'];
};

export type CompanyDataFilterInput = {
  and?: InputMaybe<Array<CompanyDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CompanyDataFilterInput>>;
};

export type CompanyDataInput = {
  id: Scalars['Long'];
  name: Scalars['String'];
};

export type CompanyDataSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** Компания */
export type CompanyFilterInput = {
  and?: InputMaybe<Array<CompanyFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  /** Уникальный идентификатор компании в домене (SID) */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Компания */
export type CompanyInput = {
  /** Идентификатор */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Уникальный идентификатор компании в домене (SID) */
  uniqueId: Scalars['String'];
};

/** Компания */
export type CompanySortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор компании в домене (SID) */
  uniqueId?: InputMaybe<SortEnumType>;
};

export enum ComputeRowTypeEnum {
  /** Коэффициент */
  Coefficient = 'COEFFICIENT',
  /** Коэффициент стесненности (КОУ) */
  ConstraintCoefficient = 'CONSTRAINT_COEFFICIENT',
  /** Коэффициент демонтажа (КД) */
  DismantlingCoefficient = 'DISMANTLING_COEFFICIENT',
  /** Прочая */
  LimitedCost = 'LIMITED_COST',
  /** Раздел Прочих */
  LimitedGroup = 'LIMITED_GROUP',
  /** МТР */
  Mtr = 'MTR',
  /** МТР (оборудование подрядчика) */
  MtrContractorEquipment = 'MTR_CONTRACTOR_EQUIPMENT',
  /** МТР (материал подрядчика) */
  MtrContractorMaterial = 'MTR_CONTRACTOR_MATERIAL',
  /** МТР (оборудование заказчика) */
  MtrCustomerEquipment = 'MTR_CUSTOMER_EQUIPMENT',
  /** МТР (материал заказчика) */
  MtrCustomerMaterial = 'MTR_CUSTOMER_MATERIAL',
  /** Нет */
  None = 'NONE',
  /** Конечный объект */
  Object = 'OBJECT',
  /** Прочая */
  Other = 'OTHER',
  /** Раздел Прочих */
  OtherGroup = 'OTHER_GROUP',
  /** Корневой объект */
  RootObject = 'ROOT_OBJECT',
  /** Коэффициент технической части (К) */
  TechPartCoefficient = 'TECH_PART_COEFFICIENT',
  /** УЕР */
  Uer = 'UER'
}

export type ConstructionObjectInput = {
  /** Стоимость позиции прочей */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор объекта строительства */
  objectId: Scalars['Long'];
  /** Идентификатор cезона */
  seasonId: Scalars['Long'];
};

/** Вид строительства */
export type ConstructionType = {
  __typename?: 'ConstructionType';
  /** Идентификатор справочника */
  catalogId: Scalars['Long'];
  /** Код */
  code: Scalars['String'];
  /** Наименование используемое в расчетном файле */
  contractFileName: Scalars['String'];
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Полное наименование */
  fullName: Scalars['String'];
  /** Код иконки */
  iconCode?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Int'];
  /** Наименование. Использовать в Системе */
  name: Scalars['String'];
  /** Короткое наименование */
  shortName: Scalars['String'];
  /** Уникальный идентификатор */
  uniqueId: Scalars['String'];
  /** Дата изменения */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConstructionTypeAttributeData = {
  __typename?: 'ConstructionTypeAttributeData';
  constructionType: ConstructionTypeData;
  /** Северная надбавка в процентах */
  northernAllowancePercent?: Maybe<Scalars['Decimal']>;
  /** Значение процента прочих в УЕР */
  uerOthersPercent?: Maybe<Scalars['Decimal']>;
};

export type ConstructionTypeAttributeDataInput = {
  constructionType: ConstructionTypeDataInput;
  /** Северная надбавка в процентах */
  northernAllowancePercent?: InputMaybe<Scalars['Decimal']>;
  /** Значение процента прочих в УЕР */
  uerOthersPercent?: InputMaybe<Scalars['Decimal']>;
};

/** Атрибуты видов строительства */
export type ConstructionTypeAttributeInput = {
  /** ID вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Северная надбавка */
  northernAllowancePercent?: InputMaybe<Scalars['Decimal']>;
  /** Значение процента прочих в УЕР */
  uerOtherPercent?: InputMaybe<Scalars['Decimal']>;
};

/** Данные о доступности добавления расценок из справочника по виду строительства */
export type ConstructionTypeAvailabilityData = {
  __typename?: 'ConstructionTypeAvailabilityData';
  /** Вид строительства */
  calculationConstructionType: Scalars['Int'];
  /** Наличие расценок для добавления в сборник по виду строительства */
  status: Scalars['Boolean'];
};

/** Данные о доступности добавления расценок из справочника по виду строительства */
export type ConstructionTypeAvailabilityDataInput = {
  /** Вид строительства */
  calculationConstructionType: Scalars['Int'];
  /** Наличие расценок для добавления в сборник по виду строительства */
  status: Scalars['Boolean'];
};

export type ConstructionTypeData = {
  __typename?: 'ConstructionTypeData';
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  iconCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConstructionTypeDataFilterInput = {
  and?: InputMaybe<Array<ConstructionTypeDataFilterInput>>;
  catalogId?: InputMaybe<LongOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  contractFileName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  iconCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ConstructionTypeDataFilterInput>>;
  shortName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ConstructionTypeDataInput = {
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  iconCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  uniqueId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ConstructionTypeDataSortInput = {
  catalogId?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  contractFileName?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  iconCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
  uniqueId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Вид строительства */
export type ConstructionTypeFilterInput = {
  and?: InputMaybe<Array<ConstructionTypeFilterInput>>;
  /** Идентификатор справочника */
  catalogId?: InputMaybe<LongOperationFilterInput>;
  /** Код */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование используемое в расчетном файле */
  contractFileName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Дата создания */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Полное наименование */
  fullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код иконки */
  iconCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<IntOperationFilterInput>;
  /** Наименование. Использовать в Системе */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ConstructionTypeFilterInput>>;
  /** Короткое наименование */
  shortName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Дата изменения */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Лимиты по виду строительства */
export type ConstructionTypeLimitData = {
  __typename?: 'ConstructionTypeLimitData';
  /** Виде строительства */
  constructionType: ConstructionTypeData;
  /** Статус связи */
  relationStatus: ContractOtherConstructionTypeRelationStatusEnum;
  /** Лимиты затрат по сезонам */
  seasonLimits: Array<ContractOtherCostSeasonLimitData>;
};

/** Лимиты по виду строительства */
export type ConstructionTypeLimitDataFilterInput = {
  and?: InputMaybe<Array<ConstructionTypeLimitDataFilterInput>>;
  /** Виде строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  or?: InputMaybe<Array<ConstructionTypeLimitDataFilterInput>>;
  /** Статус связи */
  relationStatus?: InputMaybe<ContractOtherConstructionTypeRelationStatusEnumOperationFilterInput>;
  /** Лимиты затрат по сезонам */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfContractOtherCostSeasonLimitDataFilterInput>;
};

/** Вид строительства */
export type ConstructionTypeSortInput = {
  /** Идентификатор справочника */
  catalogId?: InputMaybe<SortEnumType>;
  /** Код */
  code?: InputMaybe<SortEnumType>;
  /** Наименование используемое в расчетном файле */
  contractFileName?: InputMaybe<SortEnumType>;
  /** Дата создания */
  createdAt?: InputMaybe<SortEnumType>;
  /** Полное наименование */
  fullName?: InputMaybe<SortEnumType>;
  /** Код иконки */
  iconCode?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Наименование. Использовать в Системе */
  name?: InputMaybe<SortEnumType>;
  /** Короткое наименование */
  shortName?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
  /** Дата изменения */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ContractChangeData = {
  __typename?: 'ContractChangeData';
  /** Имя пользователя создавшего ДС */
  authoredBy: Scalars['String'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Дата создания ДС */
  createdAt: Scalars['DateTime'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Количество МТР включенных в ДС */
  mtrRowCount?: Maybe<Scalars['Int']>;
  /** Количество Прочих включенных в ДС */
  otherRowCount?: Maybe<Scalars['Int']>;
  /** Количество Коэффициентов включенных в ДС */
  ratioRowCount?: Maybe<Scalars['Int']>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: ContractChangeStatusEnum;
  /** Переходы статуса */
  statusFollowers: Array<ContractChangeStatusEnum>;
  /** Предмет договора */
  subject?: Maybe<Scalars['String']>;
  /** Количество УЕР включенных в ДС */
  uerRowCount?: Maybe<Scalars['Int']>;
};

export type ContractChangeDataInput = {
  /** Имя пользователя создавшего ДС */
  authoredBy: Scalars['String'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Дата создания ДС */
  createdAt: Scalars['DateTime'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Количество МТР включенных в ДС */
  mtrRowCount?: InputMaybe<Scalars['Int']>;
  /** Количество Прочих включенных в ДС */
  otherRowCount?: InputMaybe<Scalars['Int']>;
  /** Количество Коэффициентов включенных в ДС */
  ratioRowCount?: InputMaybe<Scalars['Int']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: ContractChangeStatusEnum;
  /** Переходы статуса */
  statusFollowers: Array<ContractChangeStatusEnum>;
  /** Предмет договора */
  subject?: InputMaybe<Scalars['String']>;
  /** Количество УЕР включенных в ДС */
  uerRowCount?: InputMaybe<Scalars['Int']>;
};

/** Реквизиты ДС для создания сущности */
export type ContractChangeInput = {
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Номер */
  number?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: ContractChangeStatusEnum;
  /** Предмет договора */
  subject?: InputMaybe<Scalars['String']>;
};

/** Модель данных реквизитов Доп. соглашения для списка */
export type ContractChangeItemData = {
  __typename?: 'ContractChangeItemData';
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Дата создания ДС */
  createdAt: Scalars['DateTime'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Количество МТР включенных в ДС */
  mtrRowCount?: Maybe<Scalars['Int']>;
  /** Количество Прочих включенных в ДС */
  otherRowCount?: Maybe<Scalars['Int']>;
  /** Количество Коэффициентов включенных в ДС */
  ratioRowCount?: Maybe<Scalars['Int']>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: ContractChangeStatusEnum;
  /** Предмет договора */
  subject?: Maybe<Scalars['String']>;
  /** Количество УЕР включенных в ДС */
  uerRowCount?: Maybe<Scalars['Int']>;
};

/** Модель данных реквизитов Доп. соглашения для списка */
export type ContractChangeItemDataFilterInput = {
  and?: InputMaybe<Array<ContractChangeItemDataFilterInput>>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Дата создания ДС */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Количество МТР включенных в ДС */
  mtrRowCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContractChangeItemDataFilterInput>>;
  /** Количество Прочих включенных в ДС */
  otherRowCount?: InputMaybe<IntOperationFilterInput>;
  /** Количество Коэффициентов включенных в ДС */
  ratioRowCount?: InputMaybe<IntOperationFilterInput>;
  /** Дата подписания */
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<ContractChangeStatusEnumOperationFilterInput>;
  /** Предмет договора */
  subject?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Количество УЕР включенных в ДС */
  uerRowCount?: InputMaybe<IntOperationFilterInput>;
};

/** Модель данных реквизитов Доп. соглашения для списка */
export type ContractChangeItemDataSortInput = {
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Дата создания ДС */
  createdAt?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<SortEnumType>;
  /** Количество МТР включенных в ДС */
  mtrRowCount?: InputMaybe<SortEnumType>;
  /** Количество Прочих включенных в ДС */
  otherRowCount?: InputMaybe<SortEnumType>;
  /** Количество Коэффициентов включенных в ДС */
  ratioRowCount?: InputMaybe<SortEnumType>;
  /** Дата подписания */
  signingDate?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
  /** Предмет договора */
  subject?: InputMaybe<SortEnumType>;
  /** Количество УЕР включенных в ДС */
  uerRowCount?: InputMaybe<SortEnumType>;
};

/** Статусы Доп. соглашения */
export enum ContractChangeStatusEnum {
  /** Согласован */
  Approved = 'APPROVED',
  /** На согласовании */
  Approving = 'APPROVING',
  /** Отложен */
  Delayed = 'DELAYED',
  /** На формировании */
  Formation = 'FORMATION'
}

export type ContractChangeStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractChangeStatusEnum>;
  in?: InputMaybe<Array<ContractChangeStatusEnum>>;
  neq?: InputMaybe<ContractChangeStatusEnum>;
  nin?: InputMaybe<Array<ContractChangeStatusEnum>>;
};

/** Реквизиты ДС для редактирования сущности */
export type ContractChangeUpdateInput = {
  /** Идентификатор ДС */
  contractChangeId: Scalars['Long'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Номер */
  number?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: ContractChangeStatusEnum;
  /** Предмет договора */
  subject?: InputMaybe<Scalars['String']>;
};

/** Общие данные Договора */
export type ContractCommonData = {
  __typename?: 'ContractCommonData';
  /** Навигация Договора */
  contractNavigation: ContractNavigationData;
  /** Данные стоимости Договора */
  contractPrice: ContractPriceData;
};

/** Общие данные Договора */
export type ContractCommonDataInput = {
  /** Навигация Договора */
  contractNavigation: ContractNavigationDataInput;
  /** Данные стоимости Договора */
  contractPrice: ContractPriceDataInput;
};

/** Входные данные для создания прочей затраты в условия по договору */
export type ContractConditionOtherCreateInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей вида вычисления Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты договора */
  limits: Array<ContractOtherCostLimitInput>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

/** Входные данные для редактирования прочей затраты в условия по договору */
export type ContractConditionOtherUpdateInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей вида вычисления Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты */
  id: Scalars['Long'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты договора */
  limits: Array<ContractOtherCostLimitInput>;
  /** Наименование */
  name?: InputMaybe<Scalars['String']>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

export type ContractConstructionTypeResultData = {
  __typename?: 'ContractConstructionTypeResultData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по НЗ */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Данные заимствований по сезонам плана по Договору */
  contractPlanSeasons?: Maybe<Array<SeasonResultData>>;
  /** Статус связи с видом строительства */
  status?: Maybe<ContractOtherConstructionTypeRelationStatusEnum>;
  /** Суммы планов по сезонам всех НЗ */
  workOrderPlanSumSeasons?: Maybe<Array<SeasonResultData>>;
};

export type ContractConstructionTypeResultDataInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по НЗ */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Данные заимствований по сезонам плана по Договору */
  contractPlanSeasons?: InputMaybe<Array<SeasonResultDataInput>>;
  /** Статус связи с видом строительства */
  status?: InputMaybe<ContractOtherConstructionTypeRelationStatusEnum>;
  /** Суммы планов по сезонам всех НЗ */
  workOrderPlanSumSeasons?: InputMaybe<Array<SeasonResultDataInput>>;
};

export type ContractConversionIndexData = {
  __typename?: 'ContractConversionIndexData';
  constructionType: ConstructionTypeData;
  id: Scalars['Long'];
  kemm?: Maybe<Scalars['Decimal']>;
  keqp?: Maybe<Scalars['Decimal']>;
  kmtr?: Maybe<Scalars['Decimal']>;
  knr?: Maybe<Scalars['Decimal']>;
  kozp?: Maybe<Scalars['Decimal']>;
  kpir?: Maybe<Scalars['Decimal']>;
  ksp?: Maybe<Scalars['Decimal']>;
};

export type ContractConversionIndexDataInput = {
  constructionType: ConstructionTypeDataInput;
  id: Scalars['Long'];
  kemm?: InputMaybe<Scalars['Decimal']>;
  keqp?: InputMaybe<Scalars['Decimal']>;
  kmtr?: InputMaybe<Scalars['Decimal']>;
  knr?: InputMaybe<Scalars['Decimal']>;
  kozp?: InputMaybe<Scalars['Decimal']>;
  kpir?: InputMaybe<Scalars['Decimal']>;
  ksp?: InputMaybe<Scalars['Decimal']>;
};

/** Cтоимость договора */
export type ContractCostData = {
  __typename?: 'ContractCostData';
  /** Сумма без НДС */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** % остатка */
  contractPlanReminderPercent?: Maybe<Scalars['Decimal']>;
  /** Остаток с учётом планов по НЗ с НДС */
  contractPlanReminderWithTax?: Maybe<Scalars['Decimal']>;
  /** НДС */
  contractPlanTax?: Maybe<Scalars['Decimal']>;
  /** Сумма с НДС */
  contractPlanWithTax?: Maybe<Scalars['Decimal']>;
  /** Отклонение % остатка */
  deviationTip?: Maybe<DeviationTipEnum>;
  /** Сумма планов НЗ */
  workOrdersPlanCost?: Maybe<Scalars['Decimal']>;
  /** Сумма планов НЗ с НДС */
  workOrdersPlanCostWithTax?: Maybe<Scalars['Decimal']>;
};

/** Cтоимость договора */
export type ContractCostDataInput = {
  /** Сумма без НДС */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** % остатка */
  contractPlanReminderPercent?: InputMaybe<Scalars['Decimal']>;
  /** Остаток с учётом планов по НЗ с НДС */
  contractPlanReminderWithTax?: InputMaybe<Scalars['Decimal']>;
  /** НДС */
  contractPlanTax?: InputMaybe<Scalars['Decimal']>;
  /** Сумма с НДС */
  contractPlanWithTax?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение % остатка */
  deviationTip?: InputMaybe<DeviationTipEnum>;
  /** Сумма планов НЗ */
  workOrdersPlanCost?: InputMaybe<Scalars['Decimal']>;
  /** Сумма планов НЗ с НДС */
  workOrdersPlanCostWithTax?: InputMaybe<Scalars['Decimal']>;
};

export enum ContractImportEnum {
  /** Ценовые параметры, прейскуранты, прочие затраты */
  Full = 'FULL',
  /** Прейскуранты, прочие затраты */
  PriceListsAndOthers = 'PRICE_LISTS_AND_OTHERS',
  /** Прейскуранты и ценовые параметры */
  PriceListsAndPriceParameters = 'PRICE_LISTS_AND_PRICE_PARAMETERS',
  /** Прейскуранты */
  PriceListsOnly = 'PRICE_LISTS_ONLY'
}

/** Данные навигации договора */
export type ContractItemNavData = {
  __typename?: 'ContractItemNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Данные навигации договора */
export type ContractItemNavDataInput = {
  /** Идентификатор объекта */
  id?: InputMaybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Лимиты по виду строительства */
export type ContractLimitedCostConstructionTypeLimitData = {
  __typename?: 'ContractLimitedCostConstructionTypeLimitData';
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Лимиты затрат по сезонам */
  seasonLimits: Array<ContractLimitedCostSeasonLimitData>;
};

/** Лимиты по виду строительства */
export type ContractLimitedCostConstructionTypeLimitDataFilterInput = {
  and?: InputMaybe<Array<ContractLimitedCostConstructionTypeLimitDataFilterInput>>;
  /** % лимитированных */
  calculatingValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  or?: InputMaybe<Array<ContractLimitedCostConstructionTypeLimitDataFilterInput>>;
  /** Лимиты затрат по сезонам */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfContractLimitedCostSeasonLimitDataFilterInput>;
};

/** Модель данных лимитированной затраты договора для списка */
export type ContractLimitedCostItemData = {
  __typename?: 'ContractLimitedCostItemData';
  /** Глава */
  chapter?: Maybe<Scalars['String']>;
  /** Лимиты по виду строительства */
  constructionTypeLimits: Array<ContractLimitedCostConstructionTypeLimitData>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Шифр ДТ */
  key?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
};

/** Модель данных лимитированной затраты договора для списка */
export type ContractLimitedCostItemDataFilterInput = {
  and?: InputMaybe<Array<ContractLimitedCostItemDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Лимиты по виду строительства */
  constructionTypeLimits?: InputMaybe<ListFilterInputTypeOfContractLimitedCostConstructionTypeLimitDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Шифр ДТ */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ContractLimitedCostItemDataFilterInput>>;
};

/** Модель данных лимитированной затраты договора для списка */
export type ContractLimitedCostItemDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Шифр ДТ */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
};

/** Сезонный лимит лимитированной затраты */
export type ContractLimitedCostSeasonLimitData = {
  __typename?: 'ContractLimitedCostSeasonLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Сезонный лимит лимитированной затраты */
export type ContractLimitedCostSeasonLimitDataFilterInput = {
  and?: InputMaybe<Array<ContractLimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ContractLimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные навигации договора */
export type ContractNavData = {
  __typename?: 'ContractNavData';
  /** Имя создателя сущности договора */
  authoredBy?: Maybe<Scalars['String']>;
  /** Время зоздания сущности договора */
  createdAt: Scalars['DateTime'];
  /** Флаг наличия договора */
  hasContract: Scalars['Boolean'];
  /** Флаг наличия НЗ */
  hasWorkOrders: Scalars['Boolean'];
  /** Идентификатор договора */
  id: Scalars['Long'];
  /** Внутренний номер договора */
  internalNumber?: Maybe<Scalars['String']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Статус договора */
  status: ContractStatusEnum;
};

/** Данные навигации договора */
export type ContractNavDataInput = {
  /** Имя создателя сущности договора */
  authoredBy?: InputMaybe<Scalars['String']>;
  /** Время зоздания сущности договора */
  createdAt: Scalars['DateTime'];
  /** Флаг наличия договора */
  hasContract: Scalars['Boolean'];
  /** Флаг наличия НЗ */
  hasWorkOrders: Scalars['Boolean'];
  /** Идентификатор договора */
  id: Scalars['Long'];
  /** Внутренний номер договора */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Статус договора */
  status: ContractStatusEnum;
};

/** Навигация договора */
export type ContractNavigationData = {
  __typename?: 'ContractNavigationData';
  /** Данные договора */
  contractNavData: ContractNavData;
  /** Список элементов навигации договора (ДС, прейскуранты, лимиты прочих затрат) */
  contractNavItems?: Maybe<Array<ContractItemNavData>>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Список навигации НЗ */
  workOrderNavs?: Maybe<Array<WorkOrderNavData>>;
};

/** Навигация договора */
export type ContractNavigationDataInput = {
  /** Данные договора */
  contractNavData: ContractNavDataInput;
  /** Список элементов навигации договора (ДС, прейскуранты, лимиты прочих затрат) */
  contractNavItems?: InputMaybe<Array<ContractItemNavDataInput>>;
  /** Список навигации НЗ */
  workOrderNavs?: InputMaybe<Array<WorkOrderNavDataInput>>;
};

/** Объект договора */
export type ContractObjectCreateInput = {
  /** Код */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
};

/** Объект/подобъект договора */
export type ContractObjectData = {
  __typename?: 'ContractObjectData';
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR: Scalars['Boolean'];
  /** Наличие Актов КС-2 */
  hasActsKC2?: Maybe<Scalars['Boolean']>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: ContractObjectStatusEnum;
};

/** Объект/подобъект договора */
export type ContractObjectDataFilterInput = {
  and?: InputMaybe<Array<ContractObjectDataFilterInput>>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR?: InputMaybe<BooleanOperationFilterInput>;
  /** Наличие Актов КС-2 */
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ContractObjectDataFilterInput>>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<ContractObjectStatusEnumOperationFilterInput>;
};

/** Объект/подобъект договора */
export type ContractObjectDataInput = {
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR: Scalars['Boolean'];
  /** Наличие Актов КС-2 */
  hasActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Статус объекта */
  status: ContractObjectStatusEnum;
};

/** Объект/подобъект договора */
export type ContractObjectDataSortInput = {
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR?: InputMaybe<SortEnumType>;
  /** Наличие Актов КС-2 */
  hasActsKC2?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
};

/** Статус объекта договора */
export enum ContractObjectStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type ContractObjectStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractObjectStatusEnum>;
  in?: InputMaybe<Array<ContractObjectStatusEnum>>;
  neq?: InputMaybe<ContractObjectStatusEnum>;
  nin?: InputMaybe<Array<ContractObjectStatusEnum>>;
};

/** Объект договора */
export type ContractObjectUpdateInput = {
  /** Код */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Идентификатор объекта */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
};

/** Статус прочей затраты договора */
export enum ContractOtherConstructionTypeRelationStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type ContractOtherConstructionTypeRelationStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractOtherConstructionTypeRelationStatusEnum>;
  in?: InputMaybe<Array<ContractOtherConstructionTypeRelationStatusEnum>>;
  neq?: InputMaybe<ContractOtherConstructionTypeRelationStatusEnum>;
  nin?: InputMaybe<Array<ContractOtherConstructionTypeRelationStatusEnum>>;
};

/** Данные прочей договора */
export type ContractOtherCostBase = {
  __typename?: 'ContractOtherCostBase';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Раздел */
  status: ContractOtherStatusEnum;
};

/** Базовая прочая затрата договора */
export type ContractOtherCostBaseData = {
  __typename?: 'ContractOtherCostBaseData';
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Формула прочей способа расчета Процент */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Базовая прочая затрата договора */
export type ContractOtherCostBaseDataInput = {
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Формула прочей способа расчета Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: InputMaybe<Scalars['Boolean']>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Секция */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Данные прочей договора */
export type ContractOtherCostBaseFilterInput = {
  and?: InputMaybe<Array<ContractOtherCostBaseFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ContractOtherCostBaseFilterInput>>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Раздел */
  status?: InputMaybe<ContractOtherStatusEnumOperationFilterInput>;
};

/** Прочая затрата договора */
export type ContractOtherCostData = {
  __typename?: 'ContractOtherCostData';
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Формула прочей способа расчета Процент */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: Maybe<Scalars['String']>;
  /** Список лимитов прочей затраты договора */
  limits: Array<ContractOtherCostLimitData>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Прочая затрата договора */
export type ContractOtherCostDataInput = {
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Формула прочей способа расчета Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: InputMaybe<Scalars['Boolean']>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Список лимитов прочей затраты договора */
  limits: Array<ContractOtherCostLimitDataInput>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Секция */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Входные данные для создания лимита прочей затраты договора */
export type ContractOtherCostGroupConstructionLimitData = {
  __typename?: 'ContractOtherCostGroupConstructionLimitData';
  /** Возможность редактирования видов строительства на вкладке "Лимиты по договору" */
  canEditConstructionType: Scalars['Boolean'];
  /** Возможность редактирования значения лимита по виду строительства и изменение способа распределения лимита по сезонам */
  canEditCost: Scalars['Boolean'];
  /** Возможность редактирования способа распределения на вкладке "Лимиты по договору" */
  canEditDistributionMethod: Scalars['Boolean'];
  /** Возможность редактирования лимитов на вкладке "Лимиты по договору" */
  canEditLimit: Scalars['Boolean'];
  /**
   * Возможность редактирования прочей для этого вида строительства
   * (Нельзя редактировать если из этой прочей занимает другая прочая)
   */
  canEditLimitSpan: Scalars['Boolean'];
  /** Возможность исключения лимита по виду строительства */
  canExclude: Scalars['Boolean'];
  /** Dид строительства */
  constructionType: ConstructionTypeData;
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Способ распределения лимитов по сезонам */
  distributionMethod: LimitDistributionMethodEnum;
  /** Наличие факта выполнения по прочей в договоре */
  hasActualCost: Scalars['Boolean'];
  /** Прочую заимствует в счёт других затрат */
  hasLimitSpan: Scalars['Boolean'];
  /**
   * Возможность редактирования вида строительства для прочей
   * (Нельзя редактировать если используется в другом НЗ или Изме)
   */
  isInUse: Scalars['Boolean'];
  /** Статус связи лимита и вида строительства */
  linkageStatus?: Maybe<ContractOtherConstructionTypeRelationStatusEnum>;
};

/** Входные данные для создания лимита прочей затраты договора */
export type ContractOtherCostGroupConstructionLimitDataInput = {
  /** Возможность редактирования видов строительства на вкладке "Лимиты по договору" */
  canEditConstructionType: Scalars['Boolean'];
  /** Возможность редактирования значения лимита по виду строительства и изменение способа распределения лимита по сезонам */
  canEditCost: Scalars['Boolean'];
  /** Возможность редактирования способа распределения на вкладке "Лимиты по договору" */
  canEditDistributionMethod: Scalars['Boolean'];
  /** Возможность редактирования лимитов на вкладке "Лимиты по договору" */
  canEditLimit: Scalars['Boolean'];
  /**
   * Возможность редактирования прочей для этого вида строительства
   * (Нельзя редактировать если из этой прочей занимает другая прочая)
   */
  canEditLimitSpan: Scalars['Boolean'];
  /** Возможность исключения лимита по виду строительства */
  canExclude: Scalars['Boolean'];
  /** Dид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Способ распределения лимитов по сезонам */
  distributionMethod: LimitDistributionMethodEnum;
  /** Наличие факта выполнения по прочей в договоре */
  hasActualCost: Scalars['Boolean'];
  /** Прочую заимствует в счёт других затрат */
  hasLimitSpan: Scalars['Boolean'];
  /**
   * Возможность редактирования вида строительства для прочей
   * (Нельзя редактировать если используется в другом НЗ или Изме)
   */
  isInUse: Scalars['Boolean'];
  /** Статус связи лимита и вида строительства */
  linkageStatus?: InputMaybe<ContractOtherConstructionTypeRelationStatusEnum>;
};

/** Модель данных прочей затраты договора для списка */
export type ContractOtherCostItemData = {
  __typename?: 'ContractOtherCostItemData';
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Лимиты по виду строительства */
  constructionTypeLimits: Array<ConstructionTypeLimitData>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей способа расчета Процент */
  formula?: Maybe<Scalars['String']>;
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: Maybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: Maybe<Scalars['Boolean']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Включено в Акт КС-2 */
  isIncludedInActKc2?: Maybe<Scalars['Boolean']>;
  /** Включено в ДС */
  isIncludedInContractChange?: Maybe<Scalars['Boolean']>;
  /** Включено в наряд-заказ */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Сезонные лимиты прочей затраты */
  seasonLimits: Array<ContractOtherCostSeasonLimitData>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Модель данных прочей затраты договора для списка */
export type ContractOtherCostItemDataFilterInput = {
  and?: InputMaybe<Array<ContractOtherCostItemDataFilterInput>>;
  /** Тип расчета прочей затраты */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Возможность удалить прочую затрату */
  canDelete?: InputMaybe<BooleanOperationFilterInput>;
  /** Возможность редактировать прочую затрату */
  canEdit?: InputMaybe<BooleanOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Лимиты по виду строительства */
  constructionTypeLimits?: InputMaybe<ListFilterInputTypeOfConstructionTypeLimitDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Формула прочей способа расчета Процент */
  formula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор прочей затраты договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Прочая создана вручную */
  isEditable?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Используется в НЗ или Изм */
  isInUse?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в Акт КС-2 */
  isIncludedInActKc2?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в ДС */
  isIncludedInContractChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в наряд-заказ */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ContractOtherCostItemDataFilterInput>>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Сезонные лимиты прочей затраты */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfContractOtherCostSeasonLimitDataFilterInput>;
  /** Секция */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<ContractOtherStatusEnumOperationFilterInput>;
};

/** Модель данных прочей затраты договора для списка */
export type ContractOtherCostItemDataSortInput = {
  /** Тип расчета прочей затраты */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Возможность удалить прочую затрату */
  canDelete?: InputMaybe<SortEnumType>;
  /** Возможность редактировать прочую затрату */
  canEdit?: InputMaybe<SortEnumType>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataSortInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Формула прочей способа расчета Процент */
  formula?: InputMaybe<SortEnumType>;
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: InputMaybe<SortEnumType>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: InputMaybe<SortEnumType>;
  /** Идентификатор прочей затраты договора */
  id?: InputMaybe<SortEnumType>;
  /** Прочая создана вручную */
  isEditable?: InputMaybe<SortEnumType>;
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost?: InputMaybe<SortEnumType>;
  /** Используется в НЗ или Изм */
  isInUse?: InputMaybe<SortEnumType>;
  /** Включено в Акт КС-2 */
  isIncludedInActKc2?: InputMaybe<SortEnumType>;
  /** Включено в ДС */
  isIncludedInContractChange?: InputMaybe<SortEnumType>;
  /** Включено в наряд-заказ */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Секция */
  section?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
};

export type ContractOtherCostLimitData = {
  __typename?: 'ContractOtherCostLimitData';
  constructionType: ConstructionTypeData;
  cost: Scalars['Decimal'];
  season: ContractSeasonData;
};

export type ContractOtherCostLimitDataInput = {
  constructionType: ConstructionTypeDataInput;
  cost: Scalars['Decimal'];
  season: ContractSeasonDataInput;
};

/** Входные данные для создания лимита прочей затраты договора */
export type ContractOtherCostLimitInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Способ распределения лимитов по сезонам */
  distributionMethod: LimitDistributionMethodEnum;
  /** Заимствования для прочей */
  limitSpans?: InputMaybe<Array<ContractOtherCostLimitSpanInput>>;
  /** Данные распределения лимитов по сезонам при распределении вручную */
  seasonDistributions?: InputMaybe<Array<ContractOtherCostSeasonLimitInput>>;
};

/** Заимствование для прочей в счёт других затрат */
export type ContractOtherCostLimitSpanInput = {
  /** Величина заимствования в счёт прочей */
  cost: Scalars['Decimal'];
  /**
   * Уникальный идентификатор типа прочей,
   *             в счёт которой замещается величина лимита прочей
   */
  otherCostTypeUniqueId?: InputMaybe<Scalars['String']>;
  /** Заимствования для прочей по сезонам */
  spanSeasons?: InputMaybe<Array<ContractOtherCostLimitSpanSeasonInput>>;
  /** Источник заимствования для прочей */
  spanType: ContractOtherCostLimitSpanTypeEnum;
  /** Тип итога, в счет которого замещается величина лимита прочей */
  totalType?: InputMaybe<UerTotal_AlcTypeEnum>;
};

/** Заимствование для прочей в счёт других затрат по сезону */
export type ContractOtherCostLimitSpanSeasonInput = {
  /** Идентификатор сезона договора */
  contractSeasonId: Scalars['Long'];
  /** Величина заимствования по сезону */
  cost: Scalars['Decimal'];
};

export type ContractOtherCostLimitSpanSelectionItem = {
  __typename?: 'ContractOtherCostLimitSpanSelectionItem';
  actual: Scalars['Decimal'];
  constructionTypeId: Scalars['Long'];
  cost?: Maybe<Scalars['Decimal']>;
  isSelected: Scalars['Boolean'];
  name: Scalars['String'];
  otherCostId?: Maybe<Scalars['Long']>;
  otherCostTypeUniqueId?: Maybe<Scalars['String']>;
  plan: Scalars['Decimal'];
  reminder: Scalars['Decimal'];
  spanId?: Maybe<Scalars['Long']>;
  spanSeasons?: Maybe<Array<LimitSpanReminderSeason>>;
  spanType: ContractOtherCostLimitSpanTypeEnum;
  totalType?: Maybe<UerTotal_AlcTypeEnum>;
};

/** Источник заимствования для прочей в счёт других затрат */
export enum ContractOtherCostLimitSpanTypeEnum {
  /** Заимствование из лимитов по прочим затратам */
  Other = 'OTHER',
  /** Заимствование из итогов */
  Total = 'TOTAL'
}

export type ContractOtherCostSeasonLimitData = {
  __typename?: 'ContractOtherCostSeasonLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

export type ContractOtherCostSeasonLimitDataFilterInput = {
  and?: InputMaybe<Array<ContractOtherCostSeasonLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ContractOtherCostSeasonLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Входные данные распределения по сезону */
export type ContractOtherCostSeasonLimitInput = {
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Прочая затрата договора */
export type ContractOtherCostUpdateData = {
  __typename?: 'ContractOtherCostUpdateData';
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Возможность редактировать "Способ расчета" на вкладке "Общие данные" */
  canEditCalculationType?: Maybe<Scalars['Boolean']>;
  /** Возможность редактирования величины % на вкладке "Общие данные" */
  canEditCalculationTypeValue?: Maybe<Scalars['Boolean']>;
  /** Возможность редактирования кода на вкладке "Общие данные" */
  canEditKey?: Maybe<Scalars['Boolean']>;
  /** Возможность редактирования вкладки прочей "Лимиты по договору" */
  canEditLimits: Scalars['Boolean'];
  /** Возможность редактирования наименования на вкладке "Общие данные" */
  canEditName?: Maybe<Scalars['Boolean']>;
  /** Возможность редактирования "Раздела" на вкладке "Общие данные" */
  canEditSection: Scalars['Boolean'];
  /** Возможность редактирования "Типа прочих" на вкладке "Общие данные" */
  canEditType?: Maybe<Scalars['Boolean']>;
  /** Возможность редактирования заимствований на вкладке "Лимиты по договору" */
  canUseOtherSpans: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Формула прочей способа расчета Процент */
  formula?: Maybe<Scalars['String']>;
  /** Список лимитов прочей затраты договора, сгруппированный по видам строительства */
  groupConstructionLimits: Array<ContractOtherCostGroupConstructionLimitData>;
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: Maybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: Maybe<Scalars['Boolean']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Возможность редактирования формулы на вкладке "Формула" */
  isFormulaEditable: Scalars['Boolean'];
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: Maybe<Scalars['String']>;
  /** Список лимитов прочей затраты договора по сезонам */
  limits: Array<ContractOtherCostLimitData>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Прочая затрата договора */
export type ContractOtherCostUpdateDataInput = {
  /** Тип расчета прочей затраты */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Значение типа расчета прочей затраты, если тип рачсета % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Возможность удалить прочую затрату */
  canDelete: Scalars['Boolean'];
  /** Возможность редактировать прочую затрату */
  canEdit: Scalars['Boolean'];
  /** Возможность редактировать "Способ расчета" на вкладке "Общие данные" */
  canEditCalculationType?: InputMaybe<Scalars['Boolean']>;
  /** Возможность редактирования величины % на вкладке "Общие данные" */
  canEditCalculationTypeValue?: InputMaybe<Scalars['Boolean']>;
  /** Возможность редактирования кода на вкладке "Общие данные" */
  canEditKey?: InputMaybe<Scalars['Boolean']>;
  /** Возможность редактирования вкладки прочей "Лимиты по договору" */
  canEditLimits: Scalars['Boolean'];
  /** Возможность редактирования наименования на вкладке "Общие данные" */
  canEditName?: InputMaybe<Scalars['Boolean']>;
  /** Возможность редактирования "Раздела" на вкладке "Общие данные" */
  canEditSection: Scalars['Boolean'];
  /** Возможность редактирования "Типа прочих" на вкладке "Общие данные" */
  canEditType?: InputMaybe<Scalars['Boolean']>;
  /** Возможность редактирования заимствований на вкладке "Лимиты по договору" */
  canUseOtherSpans: Scalars['Boolean'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Формула прочей способа расчета Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Список лимитов прочей затраты договора, сгруппированный по видам строительства */
  groupConstructionLimits: Array<ContractOtherCostGroupConstructionLimitDataInput>;
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: InputMaybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор прочей затраты договора */
  id: Scalars['Long'];
  /** Прочая создана вручную */
  isEditable?: InputMaybe<Scalars['Boolean']>;
  /** Возможность редактирования формулы на вкладке "Формула" */
  isFormulaEditable: Scalars['Boolean'];
  /** Флаг, является ли прочая добавленной из справочника методик расчета */
  isGlobalOtherCost: Scalars['Boolean'];
  /** Используется в НЗ или Изм */
  isInUse: Scalars['Boolean'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Список лимитов прочей затраты договора по сезонам */
  limits: Array<ContractOtherCostLimitDataInput>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale?: InputMaybe<Scalars['String']>;
  /** Секция */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status: ContractOtherStatusEnum;
};

/** Входные данные для создания прочей затраты договора из справочника методик расчета */
export type ContractOtherCreateFromCatalogInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId: Scalars['Long'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты договора */
  limits: Array<ContractOtherCostLimitInput>;
};

/** Входные данные для создания прочей затраты договора вручную */
export type ContractOtherCreateInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей вида вычисления Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты договора */
  limits: Array<ContractOtherCostLimitInput>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

/** Входные данные для изменения свойств прочей затраты используемых в договоре */
export type ContractOtherModifyInput = {
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей вида вычисления Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты */
  id: Scalars['Long'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
};

/** Статус прочей затраты договора */
export enum ContractOtherStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type ContractOtherStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractOtherStatusEnum>;
  in?: InputMaybe<Array<ContractOtherStatusEnum>>;
  neq?: InputMaybe<ContractOtherStatusEnum>;
  nin?: InputMaybe<Array<ContractOtherStatusEnum>>;
};

/** Входные данные для обновления прочей затраты договора */
export type ContractOtherUpdateInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Формула прочей вида вычисления Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор прочей затраты */
  id: Scalars['Long'];
  /** Уникальный идентификатор элемента затрат (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты договора */
  limits: Array<ContractOtherCostLimitInput>;
  /** Наименование */
  name?: InputMaybe<Scalars['String']>;
};

/** Данные стоимости Договора */
export type ContractPriceData = {
  __typename?: 'ContractPriceData';
  /** Цена договора без НДС */
  actualCost?: Maybe<Scalars['Decimal']>;
  /** Цена фактическая без НДС */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Флаг наличия фактической стоимости */
  hasActualCost?: Maybe<Scalars['Boolean']>;
};

/** Данные стоимости Договора */
export type ContractPriceDataInput = {
  /** Цена договора без НДС */
  actualCost?: InputMaybe<Scalars['Decimal']>;
  /** Цена фактическая без НДС */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Флаг наличия фактической стоимости */
  hasActualCost?: InputMaybe<Scalars['Boolean']>;
};

/** Модель для обновления ценовых параметров договора */
export type ContractPriceParamsUpdateInput = {
  coefficientInflationRates: Array<CoefficientInflationRateInput>;
  constructionTypeAttributes: Array<ConstructionTypeAttributeInput>;
  conversionIndexes: Array<ConversionIndexSetInput>;
};

export type ContractRatioRowData = {
  __typename?: 'ContractRatioRowData';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы коэффициента */
  groupId?: Maybe<Scalars['Long']>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: Maybe<Scalars['Boolean']>;
  /** Наименование группы коэффициента */
  groupName?: Maybe<Scalars['String']>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент создан вручную */
  isCustom?: Maybe<Scalars['Boolean']>;
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Номер из шифра */
  number?: Maybe<Scalars['Int']>;
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: RatioRecordStatusEnum;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: Maybe<Scalars['Long']>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: Maybe<Scalars['String']>;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

export type ContractRatioRowDataFilterInput = {
  and?: InputMaybe<Array<ContractRatioRowDataFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<NullableOfDismantlingCoefficientTypeEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Номер из шифра */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContractRatioRowDataFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Статус коэффициента */
  status?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Условия производства работ */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type ContractRatioRowDataSortInput = {
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<SortEnumType>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<SortEnumType>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<SortEnumType>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<SortEnumType>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<SortEnumType>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Включено в изм наряд-заказа */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Номер из шифра */
  number?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<SortEnumType>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  workConditions?: InputMaybe<SortEnumType>;
};

export type ContractResultData = {
  __typename?: 'ContractResultData';
  /** Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Факт освоения по НЗ */
  completed?: Maybe<Scalars['Decimal']>;
  /** Отклонение освоения от плана */
  completedDeviation?: Maybe<DeviationEnum>;
  /** Остаток с учётом освоения */
  completedRest?: Maybe<Scalars['Decimal']>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  completedRestDeviationTip?: Maybe<DeviationTipEnum>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: Maybe<Array<ContractConstructionTypeResultData>>;
  /** План по договору */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Остаток с учётом планов НЗ */
  contractRest?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  deviationTip?: Maybe<DeviationTipEnum>;
  /** Плановое значение по договору возможно редактировать */
  isEditable: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Договор №n от ДД.ММ.ГГГГ */
  name: Scalars['String'];
  /** Раздел прочей затраты */
  otherCostSection?: Maybe<SectionEnum>;
  /** Статус прочей затраты */
  otherCostStatus?: Maybe<ContractOtherStatusEnum>;
  /** Тип прочей для строк с типом "Прочая" */
  otherCostTypeUniqueId?: Maybe<Scalars['String']>;
  /** Тип строки */
  rowType: ContractResultRowTypeEnum;
  /** Тип итогов для строк с типом "Итог" */
  totalType?: Maybe<UerTotal_AlcTypeEnum>;
  /** Тип строки результата */
  type?: Maybe<ContractResultEnum>;
  /** Сумма планов по Наряд-заказу * */
  workOrderPlanSum?: Maybe<Scalars['Decimal']>;
  /** Список значений по каждому НЗ в Договоре */
  workOrderResults: Array<ContractWorkOrderResultData>;
};

export type ContractResultDataInput = {
  /** Зарезервировано */
  code?: InputMaybe<Scalars['String']>;
  /** Факт освоения по НЗ */
  completed?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение освоения от плана */
  completedDeviation?: InputMaybe<DeviationEnum>;
  /** Остаток с учётом освоения */
  completedRest?: InputMaybe<Scalars['Decimal']>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  completedRestDeviationTip?: InputMaybe<DeviationTipEnum>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: InputMaybe<Array<ContractConstructionTypeResultDataInput>>;
  /** План по договору */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Остаток с учётом планов НЗ */
  contractRest?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<DeviationEnum>;
  /** Диапазон отклонения остатка от заданного плана по договору */
  deviationTip?: InputMaybe<DeviationTipEnum>;
  /** Плановое значение по договору возможно редактировать */
  isEditable: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Договор №n от ДД.ММ.ГГГГ */
  name: Scalars['String'];
  /** Раздел прочей затраты */
  otherCostSection?: InputMaybe<SectionEnum>;
  /** Статус прочей затраты */
  otherCostStatus?: InputMaybe<ContractOtherStatusEnum>;
  /** Тип прочей для строк с типом "Прочая" */
  otherCostTypeUniqueId?: InputMaybe<Scalars['String']>;
  /** Тип строки */
  rowType: ContractResultRowTypeEnum;
  /** Тип итогов для строк с типом "Итог" */
  totalType?: InputMaybe<UerTotal_AlcTypeEnum>;
  /** Тип строки результата */
  type?: InputMaybe<ContractResultEnum>;
  /** Сумма планов по Наряд-заказу * */
  workOrderPlanSum?: InputMaybe<Scalars['Decimal']>;
  /** Список значений по каждому НЗ в Договоре */
  workOrderResults: Array<ContractWorkOrderResultDataInput>;
};

export enum ContractResultEnum {
  /** Лимиты Заказчика */
  CustomerLimits = 'CUSTOMER_LIMITS',
  /** Итого с НДС */
  Gross = 'GROSS',
  /** Инфляция */
  Inflation = 'INFLATION',
  /** МТР */
  Mtr = 'MTR',
  /** Прочие */
  Others = 'OTHERS',
  /** Прочие затраты Главы 9 */
  OthersChapter9 = 'OTHERS_CHAPTER9',
  /** СМР */
  Smr = 'SMR',
  /** НДС, 20% */
  Tax = 'TAX',
  /** Итого */
  Total = 'TOTAL'
}

export type ContractResultPlanData = {
  __typename?: 'ContractResultPlanData';
  /** Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: Maybe<Array<ContractConstructionTypeResultData>>;
  /** План по договору */
  contractPlan?: Maybe<Scalars['Decimal']>;
  /** Плановое значение по договору возможно редактировать */
  isEditable: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Договор №n от ДД.ММ.ГГГГ */
  name: Scalars['String'];
  /** Раздел прочей затраты */
  otherCostSection?: Maybe<SectionEnum>;
  /** Статус прочей затраты */
  otherCostStatus?: Maybe<ContractOtherStatusEnum>;
  /** Сквозной тип элемента итогов */
  totalType?: Maybe<UerTotal_AlcTypeEnum>;
  /** Тип строки результата */
  type?: Maybe<ContractResultEnum>;
};

export type ContractResultPlanDataInput = {
  /** Зарезервировано */
  code?: InputMaybe<Scalars['String']>;
  /** Список плановых значений по каждому виду строительства в Договоре */
  constructionTypePlanResults?: InputMaybe<Array<ContractConstructionTypeResultDataInput>>;
  /** План по договору */
  contractPlan?: InputMaybe<Scalars['Decimal']>;
  /** Плановое значение по договору возможно редактировать */
  isEditable: Scalars['Boolean'];
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Договор №n от ДД.ММ.ГГГГ */
  name: Scalars['String'];
  /** Раздел прочей затраты */
  otherCostSection?: InputMaybe<SectionEnum>;
  /** Статус прочей затраты */
  otherCostStatus?: InputMaybe<ContractOtherStatusEnum>;
  /** Сквозной тип элемента итогов */
  totalType?: InputMaybe<UerTotal_AlcTypeEnum>;
  /** Тип строки результата */
  type?: InputMaybe<ContractResultEnum>;
};

/** Тип строки в накопительной ведомости */
export enum ContractResultRowTypeEnum {
  /** прочая затрата */
  Other = 'OTHER',
  /** итого */
  Total = 'TOTAL'
}

export type ContractResultsViewData = {
  __typename?: 'ContractResultsViewData';
  contractResults?: Maybe<Array<ContractResultData>>;
  workOrders?: Maybe<Array<UerWorkOrderNavData>>;
};

export type ContractResultsViewDataInput = {
  contractResults?: InputMaybe<Array<ContractResultDataInput>>;
  workOrders?: InputMaybe<Array<WorkOrderNavDataInput>>;
};

/** Модель сезона договора */
export type ContractSeasonData = {
  __typename?: 'ContractSeasonData';
  /** Идентификатор сезона договора */
  id: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Модель сезона договора */
export type ContractSeasonDataFilterInput = {
  and?: InputMaybe<Array<ContractSeasonDataFilterInput>>;
  /** Идентификатор сезона договора */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<ContractSeasonDataFilterInput>>;
  /** Год сезона */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Модель сезона договора */
export type ContractSeasonDataInput = {
  /** Идентификатор сезона договора */
  id: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

export type ContractSeasonInflationData = {
  __typename?: 'ContractSeasonInflationData';
  id: Scalars['Long'];
  inflationRate: Scalars['Decimal'];
  year: Scalars['Short'];
};

export type ContractSeasonInflationDataInput = {
  id: Scalars['Long'];
  inflationRate: Scalars['Decimal'];
  year: Scalars['Short'];
};

export type ContractSeasonNav = {
  __typename?: 'ContractSeasonNav';
  /** ID сезона */
  id: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

export type ContractSeasonNavInput = {
  /** ID сезона */
  id: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

export type ContractStatusData = {
  __typename?: 'ContractStatusData';
  followers: Array<ContractStatusEnum>;
  status: ContractStatusEnum;
};

export type ContractStatusDataInput = {
  followers: Array<ContractStatusEnum>;
  status: ContractStatusEnum;
};

/** Статусы договора */
export enum ContractStatusEnum {
  /** Завершен */
  Completed = 'COMPLETED',
  /** Отложен */
  Delayed = 'DELAYED',
  /** На реализации */
  InImplementation = 'IN_IMPLEMENTATION'
}

/** Подобъект договора */
export type ContractSubObjectCreateInput = {
  /** Код */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта Договора */
  parentId: Scalars['Long'];
  /** Обоснование */
  rationale: Scalars['String'];
};

/** Подобъект договора */
export type ContractSubObjectUpdateInput = {
  /** Код */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Идентификатор подобъекта */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
};

/** Тип договора проекта при расчёте НМЦ (П-500, 501). */
export enum ContractTypeEnum {
  /** Рамочный договор. */
  Frame = 'FRAME',
  /** Обычный договор. */
  Regular = 'REGULAR'
}

export type ContractUpdateInput = {
  account?: InputMaybe<Scalars['String']>;
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  codeOKPD?: InputMaybe<Scalars['String']>;
  codeOKUD?: InputMaybe<Scalars['String']>;
  contractor: Scalars['String'];
  contractorAddress?: InputMaybe<Scalars['String']>;
  contractorOKPO?: InputMaybe<Scalars['String']>;
  costRounding: Scalars['Int'];
  customer?: InputMaybe<Scalars['String']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerOKPO?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  internalNumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  priceParameters?: InputMaybe<ContractPriceParamsUpdateInput>;
  remainder?: InputMaybe<Scalars['Decimal']>;
  signingDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: ContractStatusEnum;
  subject: Scalars['String'];
  supplyBasis?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['Decimal']>;
  /** @deprecated Использовать значение из атрибутов по виду строительства */
  uerOthersPercent?: InputMaybe<Scalars['Decimal']>;
};

/** Данные о наряд-заказе в рамках договора */
export type ContractWorkOrderData = {
  __typename?: 'ContractWorkOrderData';
  /** Наличие Актов КС-2 */
  hasActsKC2?: Maybe<Scalars['Boolean']>;
  /** Внутренний номер НЗ */
  internalNumber: Scalars['String'];
  /** Дата подписания НЗ */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус НЗ */
  status: WorkOrderStatusEnum;
  /** Изм примененый к НЗ */
  workOrderChange?: Maybe<UerWorkOrderChangeNavData>;
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

/** Данные о наряд-заказе в рамках договора */
export type ContractWorkOrderDataFilterInput = {
  and?: InputMaybe<Array<ContractWorkOrderDataFilterInput>>;
  /** Наличие Актов КС-2 */
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Внутренний номер НЗ */
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ContractWorkOrderDataFilterInput>>;
  /** Дата подписания НЗ */
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Статус НЗ */
  status?: InputMaybe<WorkOrderStatusEnumOperationFilterInput>;
  /** Изм примененый к НЗ */
  workOrderChange?: InputMaybe<WorkOrderChangeNavDataFilterInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные о наряд-заказе в рамках договора */
export type ContractWorkOrderDataSortInput = {
  /** Наличие Актов КС-2 */
  hasActsKC2?: InputMaybe<SortEnumType>;
  /** Внутренний номер НЗ */
  internalNumber?: InputMaybe<SortEnumType>;
  /** Дата подписания НЗ */
  signingDate?: InputMaybe<SortEnumType>;
  /** Статус НЗ */
  status?: InputMaybe<SortEnumType>;
  /** Изм примененый к НЗ */
  workOrderChange?: InputMaybe<WorkOrderChangeNavDataSortInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<SortEnumType>;
};

export type ContractWorkOrderResultData = {
  __typename?: 'ContractWorkOrderResultData';
  /** Выполнено по НЗ для всех Актов, входящих в данный НЗ (статус Акта: "Согласован") */
  completedPrice?: Maybe<Scalars['Decimal']>;
  constructionTypeResults: Array<WorkOrderConstructionTypeResultData>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Суммарная стоимость работ по НЗ */
  planPrice?: Maybe<Scalars['Decimal']>;
  /** Идентификатор НЗ (для перехода) */
  workOrderId: Scalars['Long'];
};

export type ContractWorkOrderResultDataInput = {
  /** Выполнено по НЗ для всех Актов, входящих в данный НЗ (статус Акта: "Согласован") */
  completedPrice?: InputMaybe<Scalars['Decimal']>;
  constructionTypeResults: Array<WorkOrderConstructionTypeResultDataInput>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<DeviationEnum>;
  /** Суммарная стоимость работ по НЗ */
  planPrice?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор НЗ (для перехода) */
  workOrderId: Scalars['Long'];
};

export enum ContragentTypeEnum {
  /** Подрядчик */
  Contractor = 'CONTRACTOR',
  /** Заказчик */
  Customer = 'CUSTOMER'
}

export type ContragentTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ContragentTypeEnum>;
  in?: InputMaybe<Array<ContragentTypeEnum>>;
  neq?: InputMaybe<ContragentTypeEnum>;
  nin?: InputMaybe<Array<ContragentTypeEnum>>;
};

/** Коэффициенты конвертации */
export type ConversionCoefficientsData = {
  __typename?: 'ConversionCoefficientsData';
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: Maybe<Scalars['Decimal']>;
  /** Коэффициент оборудования */
  keqp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент материально-технических ресурсов */
  kmtr?: Maybe<Scalars['Decimal']>;
  /** Коэффициент материалов заказчика */
  kmz?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: Maybe<Scalars['Decimal']>;
  /** Коэффициент оборудования заказчика */
  koz?: Maybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: Maybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент заработной платы машинистов */
  kzpm?: Maybe<Scalars['Decimal']>;
};

/** Коэффициенты конвертации */
export type ConversionCoefficientsDataInput = {
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования */
  keqp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материально-технических ресурсов */
  kmtr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материалов заказчика */
  kmz?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования заказчика */
  koz?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент заработной платы машинистов */
  kzpm?: InputMaybe<Scalars['Decimal']>;
};

/** Коэффициенты конвертации */
export type ConversionCoefficientsInput = {
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования */
  keqp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материально-технических ресурсов */
  kmtr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материалов заказчика */
  kmz?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования заказчика */
  koz?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент заработной платы машинистов */
  kzpm?: InputMaybe<Scalars['Decimal']>;
};

/** Индексы перевода в текущий уровень цен */
export type ConversionIndexSetInput = {
  /** ID вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования */
  keqp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материально-технических ресурсов */
  kmtr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<Scalars['Decimal']>;
};

export enum CostGroupEnum {
  /** СМР */
  Cmr = 'CMR',
  /** Прочие */
  Others = 'OTHERS'
}

export type CostGroupEnumOperationFilterInput = {
  eq?: InputMaybe<CostGroupEnum>;
  in?: InputMaybe<Array<CostGroupEnum>>;
  neq?: InputMaybe<CostGroupEnum>;
  nin?: InputMaybe<Array<CostGroupEnum>>;
};

export type CountData = {
  __typename?: 'CountData';
  count: Scalars['Int'];
};

export type CountDataInput = {
  count: Scalars['Int'];
};

/** Input создания укрупнённой сметы. */
export type CreateAggregateEstimateInput = {
  /** Глава сметы. */
  chapter: BimChapterEnum;
  /** Коэффициент. */
  coefficient: Scalars['Decimal'];
  /** Участвует ли агрегат в расчёте процента прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Идентификаторы ЛСР (простых смет), включаемых в укрупнённую смету. */
  localEstimateIds: Array<Scalars['Long']>;
  /** Идентификатор объекта/подобъекта структуры расчёта (негарантированный объём). */
  objectId: Scalars['Long'];
  /** Идентификатор корневого объекта/подобъекта структуры расчёта. Если не передан — вычисляется. */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Шифр (Value_Code). */
  valueCode: Scalars['String'];
  /** Наименование (Value_Name). */
  valueName: Scalars['String'];
  /** Кол-во сейчас. */
  valueQuantityNow: Scalars['Decimal'];
  /** Кол-во по целевым показателям. */
  valueQuantityTarget: Scalars['Decimal'];
  /** Ед. изм (Value_Unit). */
  valueUnit: Scalars['String'];
};

export type CreateCatalogUerBaseCostInput = {
  /** Каталог видов работ (CatFile из Vids_Rab) */
  catFile?: InputMaybe<Scalars['String']>;
  /** Идентификатор каталога */
  catalogId: Scalars['Long'];
  /** Виды работ */
  catalogUERBaseCostWorkScopes?: InputMaybe<Array<CatalogUerBaseCostWorkScopeBaseDataInput>>;
  /** Глава в расчете */
  chapter?: InputMaybe<ChapterEnum>;
  /** Код */
  code: Scalars['String'];
  /** Типы строительства */
  constructionTypes: Array<Scalars['Int']>;
  /** Прямые затраты */
  directCost?: InputMaybe<Scalars['Decimal']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** ФОТ */
  fot?: InputMaybe<Scalars['Decimal']>;
  /** Подраздел */
  groupCode: Scalars['String'];
  /** Подраздел */
  groupName: Scalars['String'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** коэффициенты */
  ratioGroups: Array<Scalars['Long']>;
  /** коэффициенты */
  ratios: Array<Scalars['Long']>;
  /** Раздел */
  sectionName: Scalars['String'];
  sections?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisSectionCreateInput>>;
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты ЗТм */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: InputMaybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  /** Накладные расходы для УЕР (проценты) */
  uerNacl?: InputMaybe<Scalars['Long']>;
  /** Плановая прибыль для УЕР (проценты) */
  uerPlan?: InputMaybe<Scalars['Long']>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  /** Версия справочника */
  version?: InputMaybe<Scalars['String']>;
  workID?: InputMaybe<Scalars['String']>;
  /** Вид работ */
  workType: CatalogUerBaseWorkDataInput;
  /** Виды работ из Гранд-сметы, используемые в расценке */
  workTypeItems?: InputMaybe<Array<CatalogUerBaseCostWorkTypeItemInput>>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для создания МТР в Ведомости МТР */
export type CreateCollectionMtrInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Величина нормы расхода ресурса */
  consumptionrateMtr?: InputMaybe<Scalars['Decimal']>;
  /**  Признак исключения/включения из расчета доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для создания МТР в ВОР */
export type CreateCollectionMtrToWorkVolumeInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Величина нормы расхода ресурса */
  consumptionrateMtr?: InputMaybe<Scalars['Decimal']>;
  /**  Признак исключения/включения из расчета доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор ВОР */
  worId: Scalars['Long'];
};

export type CreateCollectionRatioMassToWorkVolumeInput = {
  /** Данные об области применения */
  applicationArea?: InputMaybe<CollectionRatioApplicationAreaInput>;
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор группы */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Long'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Наименование */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
};

/** Данные для создания коэффициента в ВОР */
export type CreateCollectionRatioToWorkVolumeInput = {
  /** Данные об области применения */
  applicationArea?: InputMaybe<CollectionRatioApplicationAreaInput>;
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор группы */
  collectionRatioGroupId?: InputMaybe<Scalars['Long']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Наименование */
  name: Scalars['String'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Идентификатор ВОР */
  worId: Scalars['Long'];
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']>;
  gt?: InputMaybe<Scalars['Date']>;
  gte?: InputMaybe<Scalars['Date']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  lt?: InputMaybe<Scalars['Date']>;
  lte?: InputMaybe<Scalars['Date']>;
  neq?: InputMaybe<Scalars['Date']>;
  ngt?: InputMaybe<Scalars['Date']>;
  ngte?: InputMaybe<Scalars['Date']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']>>>;
  nlt?: InputMaybe<Scalars['Date']>;
  nlte?: InputMaybe<Scalars['Date']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

/** Перечисление возможных отклонений */
export enum DeviationEnum {
  /** Понижение */
  Down = 'DOWN',
  /** Нет оклонения */
  None = 'NONE',
  /** Превышение */
  Up = 'UP'
}

/** Перечисление возможных диапазонов отклонений */
export enum DeviationTipEnum {
  /** Значение равно нулю */
  EqualZero = 'EQUAL_ZERO',
  /** Значение меньще 30% от заданного */
  LessThan30 = 'LESS_THAN30',
  /** Значение меньше нуля */
  Negative = 'NEGATIVE',
  /** Нет оклонения */
  None = 'NONE'
}

export type DeviationTipEnumOperationFilterInput = {
  eq?: InputMaybe<DeviationTipEnum>;
  in?: InputMaybe<Array<DeviationTipEnum>>;
  neq?: InputMaybe<DeviationTipEnum>;
  nin?: InputMaybe<Array<DeviationTipEnum>>;
};

/** Значения перечисления для типов коэффициентов демонтажа */
export enum DismantlingCoefficientTypeEnum {
  /** Строительные и специальные строительные работы */
  ConstructionWorks = 'CONSTRUCTION_WORKS',
  /** Монтаж оборудования (монтажные работы) */
  EquipmentInstallation = 'EQUIPMENT_INSTALLATION'
}

/** Год/версия тегов локальной сметы при импорте ЛСР (2017 / 2020). */
export enum EstimateYearEnum {
  /** Теги сметной документации 2017 года. */
  Year2017 = 'YEAR2017',
  /** Теги сметной документации 2020 года. */
  Year2020 = 'YEAR2020'
}

export type FileContent = {
  __typename?: 'FileContent';
  /** Количество TODO: */
  count: Scalars['Int'];
  /** Файл в виде Data URI */
  dataUrl: Scalars['String'];
  /** Имя файла */
  name: Scalars['String'];
  /** Размер файла в байтах */
  size: Scalars['Long'];
};

export type FileContentInput = {
  /** Количество TODO: */
  count: Scalars['Int'];
  /** Файл в виде Data URI */
  dataUrl: Scalars['String'];
  /** Имя файла */
  name: Scalars['String'];
  /** Размер файла в байтах */
  size: Scalars['Long'];
};

export type FileInput = {
  /** Файл в виде Data URI */
  dataUrl: Scalars['String'];
  /** Имя файла */
  name: Scalars['String'];
};

export type FilterValueContainerOfString = {
  __typename?: 'FilterValueContainerOfString';
  id: Scalars['Long'];
  value?: Maybe<Scalars['String']>;
};

export type FilterValueContainerOfStringFilterInput = {
  and?: InputMaybe<Array<FilterValueContainerOfStringFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<FilterValueContainerOfStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type FilterValueContainerOfStringSortInput = {
  id?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfBoolean = {
  __typename?: 'FilterValueOfBoolean';
  value: Scalars['Boolean'];
};

export type FilterValueOfBooleanFilterInput = {
  and?: InputMaybe<Array<FilterValueOfBooleanFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfBooleanFilterInput>>;
  value?: InputMaybe<BooleanOperationFilterInput>;
};

export type FilterValueOfBooleanSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfCatalogUerBaseCostGroupFilterData = {
  __typename?: 'FilterValueOfCatalogUerBaseCostGroupFilterData';
  value?: Maybe<CatalogUerBaseCostGroupFilterData>;
};

export type FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput = {
  and?: InputMaybe<Array<FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput>>;
  value?: InputMaybe<CatalogUerBaseCostGroupFilterDataFilterInput>;
};

export type FilterValueOfCatalogUerBaseCostGroupFilterDataSortInput = {
  value?: InputMaybe<CatalogUerBaseCostGroupFilterDataSortInput>;
};

export type FilterValueOfChapterEnum = {
  __typename?: 'FilterValueOfChapterEnum';
  value: ChapterEnum;
};

export type FilterValueOfCollectionRatioStatusEnum = {
  __typename?: 'FilterValueOfCollectionRatioStatusEnum';
  value: CollectionRatioStatusEnum;
};

export type FilterValueOfCollectionUerBaseCostStatus = {
  __typename?: 'FilterValueOfCollectionUERBaseCostStatus';
  value: CollectionUerBaseCostStatus;
};

export type FilterValueOfCompanyData = {
  __typename?: 'FilterValueOfCompanyData';
  value?: Maybe<CompanyData>;
};

export type FilterValueOfCompanyDataFilterInput = {
  and?: InputMaybe<Array<FilterValueOfCompanyDataFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfCompanyDataFilterInput>>;
  value?: InputMaybe<CompanyDataFilterInput>;
};

export type FilterValueOfCompanyDataSortInput = {
  value?: InputMaybe<CompanyDataSortInput>;
};

export type FilterValueOfContractOtherConstructionTypeRelationStatusEnum = {
  __typename?: 'FilterValueOfContractOtherConstructionTypeRelationStatusEnum';
  value: ContractOtherConstructionTypeRelationStatusEnum;
};

export type FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput>>;
  value?: InputMaybe<ContractOtherConstructionTypeRelationStatusEnumOperationFilterInput>;
};

export type FilterValueOfContractOtherConstructionTypeRelationStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfContractOtherStatusEnum = {
  __typename?: 'FilterValueOfContractOtherStatusEnum';
  value: ContractOtherStatusEnum;
};

export type FilterValueOfContractOtherStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfContractOtherStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfContractOtherStatusEnumFilterInput>>;
  value?: InputMaybe<ContractOtherStatusEnumOperationFilterInput>;
};

export type FilterValueOfContractOtherStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfContragentTypeEnum = {
  __typename?: 'FilterValueOfContragentTypeEnum';
  value: ContragentTypeEnum;
};

export type FilterValueOfContragentTypeEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfContragentTypeEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfContragentTypeEnumFilterInput>>;
  value?: InputMaybe<ContragentTypeEnumOperationFilterInput>;
};

export type FilterValueOfContragentTypeEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfCostGroupEnum = {
  __typename?: 'FilterValueOfCostGroupEnum';
  value: CostGroupEnum;
};

export type FilterValueOfCostGroupEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfCostGroupEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfCostGroupEnumFilterInput>>;
  value?: InputMaybe<CostGroupEnumOperationFilterInput>;
};

export type FilterValueOfCostGroupEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfDateOnly = {
  __typename?: 'FilterValueOfDateOnly';
  value: Scalars['Date'];
};

export type FilterValueOfDateOnlyFilterInput = {
  and?: InputMaybe<Array<FilterValueOfDateOnlyFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfDateOnlyFilterInput>>;
  value?: InputMaybe<DateOperationFilterInput>;
};

export type FilterValueOfDateOnlySortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfDateTime = {
  __typename?: 'FilterValueOfDateTime';
  value: Scalars['DateTime'];
};

export type FilterValueOfDateTimeFilterInput = {
  and?: InputMaybe<Array<FilterValueOfDateTimeFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfDateTimeFilterInput>>;
  value?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FilterValueOfDateTimeSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfDecimal = {
  __typename?: 'FilterValueOfDecimal';
  value: Scalars['Decimal'];
};

export type FilterValueOfDecimalFilterInput = {
  and?: InputMaybe<Array<FilterValueOfDecimalFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfDecimalFilterInput>>;
  value?: InputMaybe<DecimalOperationFilterInput>;
};

export type FilterValueOfInt16 = {
  __typename?: 'FilterValueOfInt16';
  value: Scalars['Short'];
};

export type FilterValueOfInt32 = {
  __typename?: 'FilterValueOfInt32';
  value: Scalars['Int'];
};

export type FilterValueOfInt32FilterInput = {
  and?: InputMaybe<Array<FilterValueOfInt32FilterInput>>;
  or?: InputMaybe<Array<FilterValueOfInt32FilterInput>>;
  value?: InputMaybe<IntOperationFilterInput>;
};

export type FilterValueOfInt32SortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfMtrRecordStatusEnum = {
  __typename?: 'FilterValueOfMtrRecordStatusEnum';
  value: MtrRecordStatusEnum;
};

export type FilterValueOfMtrRecordStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfMtrRecordStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfMtrRecordStatusEnumFilterInput>>;
  value?: InputMaybe<MtrRecordStatusEnumOperationFilterInput>;
};

export type FilterValueOfMtrRecordStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfMtrTypeEnum = {
  __typename?: 'FilterValueOfMtrTypeEnum';
  value: MtrTypeEnum;
};

export type FilterValueOfMtrTypeEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfMtrTypeEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfMtrTypeEnumFilterInput>>;
  value?: InputMaybe<MtrTypeEnumOperationFilterInput>;
};

export type FilterValueOfMtrTypeEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfBimChapterEnum = {
  __typename?: 'FilterValueOfNullableOfBimChapterEnum';
  value?: Maybe<BimChapterEnum>;
};

export type FilterValueOfNullableOfBimChapterEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfBimChapterEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfBimChapterEnumFilterInput>>;
  value?: InputMaybe<NullableOfBimChapterEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfBimChapterEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfBoolean = {
  __typename?: 'FilterValueOfNullableOfBoolean';
  value?: Maybe<Scalars['Boolean']>;
};

export type FilterValueOfNullableOfBooleanFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfBooleanFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfBooleanFilterInput>>;
  value?: InputMaybe<BooleanOperationFilterInput>;
};

export type FilterValueOfNullableOfBooleanSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfChapterEnum = {
  __typename?: 'FilterValueOfNullableOfChapterEnum';
  value?: Maybe<ChapterEnum>;
};

export type FilterValueOfNullableOfChapterEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumFilterInput>>;
  value?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfChapterEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfContractChangeStatusEnum = {
  __typename?: 'FilterValueOfNullableOfContractChangeStatusEnum';
  value?: Maybe<ContractChangeStatusEnum>;
};

export type FilterValueOfNullableOfContractChangeStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfContractChangeStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfContractChangeStatusEnumFilterInput>>;
  value?: InputMaybe<NullableOfContractChangeStatusEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfContractChangeStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfContractOtherStatusEnum = {
  __typename?: 'FilterValueOfNullableOfContractOtherStatusEnum';
  value?: Maybe<ContractOtherStatusEnum>;
};

export type FilterValueOfNullableOfContractOtherStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfContractOtherStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfContractOtherStatusEnumFilterInput>>;
  value?: InputMaybe<NullableOfContractOtherStatusEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfContractOtherStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfDateOnly = {
  __typename?: 'FilterValueOfNullableOfDateOnly';
  value?: Maybe<Scalars['Date']>;
};

export type FilterValueOfNullableOfDateOnlyFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfDateOnlyFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfDateOnlyFilterInput>>;
  value?: InputMaybe<DateOperationFilterInput>;
};

export type FilterValueOfNullableOfDateOnlySortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfDateTime = {
  __typename?: 'FilterValueOfNullableOfDateTime';
  value?: Maybe<Scalars['DateTime']>;
};

export type FilterValueOfNullableOfDateTimeFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfDateTimeFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfDateTimeFilterInput>>;
  value?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FilterValueOfNullableOfDateTimeSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfDecimal = {
  __typename?: 'FilterValueOfNullableOfDecimal';
  value?: Maybe<Scalars['Decimal']>;
};

export type FilterValueOfNullableOfDecimalFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfDecimalFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfDecimalFilterInput>>;
  value?: InputMaybe<DecimalOperationFilterInput>;
};

export type FilterValueOfNullableOfDecimalSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfRatioRecordStatusEnum = {
  __typename?: 'FilterValueOfNullableOfRatioRecordStatusEnum';
  value?: Maybe<RatioRecordStatusEnum>;
};

export type FilterValueOfNullableOfRatioRecordStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfRatioRecordStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfRatioRecordStatusEnumFilterInput>>;
  value?: InputMaybe<NullableOfRatioRecordStatusEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfRatioRecordStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfRatioTypeEnum = {
  __typename?: 'FilterValueOfNullableOfRatioTypeEnum';
  value?: Maybe<RatioTypeEnum>;
};

export type FilterValueOfNullableOfUerBaseCostChangeType = {
  __typename?: 'FilterValueOfNullableOfUerBaseCostChangeType';
  value?: Maybe<UerBaseCostChangeType>;
};

export type FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput>>;
  value?: InputMaybe<NullableOfUerBaseCostChangeTypeOperationFilterInput>;
};

export type FilterValueOfNullableOfUerBaseCostChangeTypeSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfUerClassifierEnum = {
  __typename?: 'FilterValueOfNullableOfUerClassifierEnum';
  value?: Maybe<UerClassifierEnum>;
};

export type FilterValueOfNullableOfUerClassifierEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumFilterInput>>;
  value?: InputMaybe<NullableOfUerClassifierEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfUerClassifierEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfNullableOfWorkInSumEnum = {
  __typename?: 'FilterValueOfNullableOfWorkInSumEnum';
  value?: Maybe<WorkInSumEnum>;
};

export type FilterValueOfNullableOfWorkInSumEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfWorkInSumEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfWorkInSumEnumFilterInput>>;
  value?: InputMaybe<NullableOfWorkInSumEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfWorkOrderPriceStatusEnum = {
  __typename?: 'FilterValueOfNullableOfWorkOrderPriceStatusEnum';
  value?: Maybe<WorkOrderPriceStatusEnum>;
};

export type FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>>;
  value?: InputMaybe<NullableOfWorkOrderPriceStatusEnumOperationFilterInput>;
};

export type FilterValueOfNullableOfWorkOrderPriceStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfOtherCostCalculationTypeEnum = {
  __typename?: 'FilterValueOfOtherCostCalculationTypeEnum';
  value: OtherCostCalculationTypeEnum;
};

export type FilterValueOfOtherCostCalculationTypeEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfOtherCostCalculationTypeEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfOtherCostCalculationTypeEnumFilterInput>>;
  value?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
};

export type FilterValueOfOtherCostCalculationTypeEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfPriceConstructionTypeRelationStatusEnum = {
  __typename?: 'FilterValueOfPriceConstructionTypeRelationStatusEnum';
  value: PriceConstructionTypeRelationStatusEnum;
};

export type FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput>>;
  value?: InputMaybe<PriceConstructionTypeRelationStatusEnumOperationFilterInput>;
};

export type FilterValueOfPriceConstructionTypeRelationStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfProjectContractTypeEnum = {
  __typename?: 'FilterValueOfProjectContractTypeEnum';
  value: ProjectContractTypeEnum;
};

export type FilterValueOfProjectContractTypeEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfProjectContractTypeEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfProjectContractTypeEnumFilterInput>>;
  value?: InputMaybe<ProjectContractTypeEnumOperationFilterInput>;
};

export type FilterValueOfProjectContractTypeEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfProjectMethodologyEnum = {
  __typename?: 'FilterValueOfProjectMethodologyEnum';
  value: ProjectMethodologyEnum;
};

export type FilterValueOfProjectMethodologyEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfProjectMethodologyEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfProjectMethodologyEnumFilterInput>>;
  value?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
};

export type FilterValueOfProjectMethodologyEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfProjectStageEnum = {
  __typename?: 'FilterValueOfProjectStageEnum';
  value: ProjectStageEnum;
};

export type FilterValueOfProjectStageEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfProjectStageEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfProjectStageEnumFilterInput>>;
  value?: InputMaybe<ProjectStageEnumOperationFilterInput>;
};

export type FilterValueOfProjectStageEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfProjectStatusEnum = {
  __typename?: 'FilterValueOfProjectStatusEnum';
  value: ProjectStatusEnum;
};

export type FilterValueOfProjectStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfProjectStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfProjectStatusEnumFilterInput>>;
  value?: InputMaybe<ProjectStatusEnumOperationFilterInput>;
};

export type FilterValueOfProjectStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfRatioRecordStatusEnum = {
  __typename?: 'FilterValueOfRatioRecordStatusEnum';
  value: RatioRecordStatusEnum;
};

export type FilterValueOfRatioRecordStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumFilterInput>>;
  value?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
};

export type FilterValueOfRatioRecordStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfRatioTypeEnum = {
  __typename?: 'FilterValueOfRatioTypeEnum';
  value: RatioTypeEnum;
};

export type FilterValueOfString = {
  __typename?: 'FilterValueOfString';
  value?: Maybe<Scalars['String']>;
};

export type FilterValueOfStringAndString = {
  __typename?: 'FilterValueOfStringAndString';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  value?: Maybe<Scalars['String']>;
};

export type FilterValueOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<FilterValueOfStringAndStringFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<FilterValueOfStringAndStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type FilterValueOfStringAndStringSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfStringFilterInput = {
  and?: InputMaybe<Array<FilterValueOfStringFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type FilterValueOfStringSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfUerBaseCostChangeType = {
  __typename?: 'FilterValueOfUerBaseCostChangeType';
  value: UerBaseCostChangeType;
};

export type FilterValueOfUerBaseCostChangeTypeFilterInput = {
  and?: InputMaybe<Array<FilterValueOfUerBaseCostChangeTypeFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfUerBaseCostChangeTypeFilterInput>>;
  value?: InputMaybe<UerBaseCostChangeTypeOperationFilterInput>;
};

export type FilterValueOfUerBaseCostChangeTypeSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfUerRecordStatusEnum = {
  __typename?: 'FilterValueOfUerRecordStatusEnum';
  value: UerRecordStatusEnum;
};

export type FilterValueOfUerRecordStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfUerRecordStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfUerRecordStatusEnumFilterInput>>;
  value?: InputMaybe<UerRecordStatusEnumOperationFilterInput>;
};

export type FilterValueOfUerRecordStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfWorkInSumEnum = {
  __typename?: 'FilterValueOfWorkInSumEnum';
  value: WorkInSumEnum;
};

export type FilterValueOfWorkInSumEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfWorkInSumEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfWorkInSumEnumFilterInput>>;
  value?: InputMaybe<WorkInSumEnumOperationFilterInput>;
};

export type FilterValueOfWorkInSumEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfWorkOrderChangePriceCodeFilterData = {
  __typename?: 'FilterValueOfWorkOrderChangePriceCodeFilterData';
  value?: Maybe<WorkOrderChangePriceCodeFilterData>;
};

export type FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput>>;
  value?: InputMaybe<WorkOrderChangePriceCodeFilterDataFilterInput>;
};

export type FilterValueOfWorkOrderChangePriceCodeFilterDataSortInput = {
  value?: InputMaybe<WorkOrderChangePriceCodeFilterDataSortInput>;
};

export type FilterValueOfWorkOrderPriceCodeFilterData = {
  __typename?: 'FilterValueOfWorkOrderPriceCodeFilterData';
  value?: Maybe<WorkOrderPriceCodeFilterData>;
};

export type FilterValueOfWorkOrderPriceCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<FilterValueOfWorkOrderPriceCodeFilterDataFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfWorkOrderPriceCodeFilterDataFilterInput>>;
  value?: InputMaybe<WorkOrderPriceCodeFilterDataFilterInput>;
};

export type FilterValueOfWorkOrderPriceCodeFilterDataSortInput = {
  value?: InputMaybe<WorkOrderPriceCodeFilterDataSortInput>;
};

export type FilterValueOfWorkOrderPriceItemCodeFilterData = {
  __typename?: 'FilterValueOfWorkOrderPriceItemCodeFilterData';
  value?: Maybe<WorkOrderPriceItemCodeFilterData>;
};

export type FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>>;
  value?: InputMaybe<WorkOrderPriceItemCodeFilterDataFilterInput>;
};

export type FilterValueOfWorkOrderPriceStatusEnum = {
  __typename?: 'FilterValueOfWorkOrderPriceStatusEnum';
  value: WorkOrderPriceStatusEnum;
};

export type FilterValueOfWorkOrderPriceStatusEnumFilterInput = {
  and?: InputMaybe<Array<FilterValueOfWorkOrderPriceStatusEnumFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfWorkOrderPriceStatusEnumFilterInput>>;
  value?: InputMaybe<WorkOrderPriceStatusEnumOperationFilterInput>;
};

export type FilterValueOfWorkOrderPriceStatusEnumSortInput = {
  value?: InputMaybe<SortEnumType>;
};

export type FilterValueOfWorkVolumeItemCodeFilterData = {
  __typename?: 'FilterValueOfWorkVolumeItemCodeFilterData';
  value?: Maybe<WorkVolumeItemCodeFilterData>;
};

export type FilterValueOfWorkVolumeItemCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<FilterValueOfWorkVolumeItemCodeFilterDataFilterInput>>;
  or?: InputMaybe<Array<FilterValueOfWorkVolumeItemCodeFilterDataFilterInput>>;
  value?: InputMaybe<WorkVolumeItemCodeFilterDataFilterInput>;
};

/** Результат получения списка расценок для выбора из справочника */
export type FindUersToAddData = {
  __typename?: 'FindUersToAddData';
  /** Список видов строительства, указанных на вкладке «Выбор вида строительства» */
  constructionTypes: Array<Scalars['Int']>;
  /** Массив идентификаторов найденных расценок, доступных для добавления в сборник */
  ids: Array<Scalars['Long']>;
};

/** Результат получения списка расценок для выбора из справочника */
export type FindUersToAddDataInput = {
  /** Список видов строительства, указанных на вкладке «Выбор вида строительства» */
  constructionTypes: Array<Scalars['Int']>;
  /** Массив идентификаторов найденных расценок, доступных для добавления в сборник */
  ids: Array<Scalars['Long']>;
};

/** A segment of a collection. */
export type GlobalConstructionTypesCollectionSegment = {
  __typename?: 'GlobalConstructionTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConstructionTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Входные данные для создания записи справочника лимитированных затрат */
export type GlobalLimitedCostCreateInput = {
  /** Идентификатор записи справочника типов лимитированных */
  catalogLimitedCostTypeUniqueId: Scalars['String'];
  /** Глава */
  chapter: ChapterEnum;
  /** Формула */
  formula: Scalars['String'];
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
};

/** DTO для записи справочника лимитированных затрат */
export type GlobalLimitedCostData = {
  __typename?: 'GlobalLimitedCostData';
  /** Запись справочника типа прочих */
  catalogLimitedCostType?: Maybe<CatalogLimitedCostTypeData>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Формула */
  formula?: Maybe<Scalars['String']>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак системной записи */
  isSystem: Scalars['Boolean'];
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
};

/** DTO для записи справочника лимитированных затрат */
export type GlobalLimitedCostDataFilterInput = {
  and?: InputMaybe<Array<GlobalLimitedCostDataFilterInput>>;
  /** Запись справочника типа прочих */
  catalogLimitedCostType?: InputMaybe<CatalogLimitedCostTypeDataFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Формула */
  formula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак системной записи */
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  /** Методология расчета */
  methodology?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<GlobalLimitedCostDataFilterInput>>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
};

/** DTO для записи справочника лимитированных затрат */
export type GlobalLimitedCostDataInput = {
  /** Запись справочника типа прочих */
  catalogLimitedCostType?: InputMaybe<CatalogLimitedCostTypeDataInput>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак системной записи */
  isSystem: Scalars['Boolean'];
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

/** DTO для записи справочника лимитированных затрат */
export type GlobalLimitedCostDataSortInput = {
  /** Запись справочника типа прочих */
  catalogLimitedCostType?: InputMaybe<CatalogLimitedCostTypeDataSortInput>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Формула */
  formula?: InputMaybe<SortEnumType>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак системной записи */
  isSystem?: InputMaybe<SortEnumType>;
  /** Методология расчета */
  methodology?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
};

/**
 * Входные данные для обновления записи справочника лимитированных затрат.
 *             После создания не редактируются Методология и Глава.
 */
export type GlobalLimitedCostUpdateInput = {
  /** Идентификатор записи справочника типов лимитированных */
  catalogLimitedCostTypeUniqueId?: InputMaybe<Scalars['String']>;
  /** Формула */
  formula: Scalars['String'];
  /** Идентификатор записи */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
};

/** A segment of a collection. */
export type GlobalLimitedCostsCollectionSegment = {
  __typename?: 'GlobalLimitedCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalLimitedCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Входные данные для создания записи справочника прочих затрат */
export type GlobalOtherCostCreateInput = {
  /** Способ вычисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeUniqueId?: InputMaybe<Scalars['String']>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section: SectionEnum;
};

/** Модель данных для прочих справочника методологий */
export type GlobalOtherCostData = {
  __typename?: 'GlobalOtherCostData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Формула */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак системной записи */
  isSystem: Scalars['Boolean'];
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Данные о типе прочей в каталоге */
  otherCostType: CatalogOtherCostTypeBase;
  /** Раздел */
  section?: Maybe<SectionEnum>;
};

/** Модель данных для прочих справочника методологий */
export type GlobalOtherCostDataFilterInput = {
  and?: InputMaybe<Array<GlobalOtherCostDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Формула */
  formula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак системной записи */
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  /** Методология расчета */
  methodology?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<GlobalOtherCostDataFilterInput>>;
  /** Данные о типе прочей в каталоге */
  otherCostType?: InputMaybe<CatalogOtherCostTypeBaseFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
};

/** Модель данных для прочих справочника методологий */
export type GlobalOtherCostDataInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак системной записи */
  isSystem: Scalars['Boolean'];
  /** Методология расчета */
  methodology: ProjectMethodologyEnum;
  /** Наименование */
  name: Scalars['String'];
  /** Данные о типе прочей в каталоге */
  otherCostType: CatalogOtherCostTypeBaseInput;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
};

/** Модель данных для прочих справочника методологий */
export type GlobalOtherCostDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Формула */
  formula?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак системной записи */
  isSystem?: InputMaybe<SortEnumType>;
  /** Методология расчета */
  methodology?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Данные о типе прочей в каталоге */
  otherCostType?: InputMaybe<CatalogOtherCostTypeBaseSortInput>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
};

/**
 * Входные данные для обновления записи справочника прочих затрат.
 *             После создания не редактируются Методология, Раздел и Способ начисления.
 */
export type GlobalOtherCostUpdateInput = {
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeUniqueId?: InputMaybe<Scalars['String']>;
  /** Формула */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи */
  id: Scalars['Long'];
  /** Наименование */
  name: Scalars['String'];
};

/** A segment of a collection. */
export type GlobalOtherCostsCollectionSegment = {
  __typename?: 'GlobalOtherCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type GlobalOtherCostsSelectionCollectionSegment = {
  __typename?: 'GlobalOtherCostsSelectionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum HealthStatus {
  Degraded = 'DEGRADED',
  Healthy = 'HEALTHY',
  Unhealthy = 'UNHEALTHY'
}

export type HealthStatusOperationFilterInput = {
  eq?: InputMaybe<HealthStatus>;
  in?: InputMaybe<Array<HealthStatus>>;
  neq?: InputMaybe<HealthStatus>;
  nin?: InputMaybe<Array<HealthStatus>>;
};

/** Возможные вырианты записи истории изменений сущности */
export enum HistoryChangeType {
  /** Удаление элемента */
  Deleted = 'DELETED',
  /** Добавление нового элемента */
  New = 'NEW',
  /** Редактирование существующего элемента */
  Updated = 'UPDATED'
}

/** Данные о количестве операций добавления, редактирования и удаления */
export type HistoryStatusCountData = {
  __typename?: 'HistoryStatusCountData';
  /** Количество редактирований */
  deletedCount: Scalars['Int'];
  /** Количество добавлений */
  newCount: Scalars['Int'];
  /** Количество удалений */
  updatedCount: Scalars['Int'];
};

/** Данные о количестве операций добавления, редактирования и удаления */
export type HistoryStatusCountDataFilterInput = {
  and?: InputMaybe<Array<HistoryStatusCountDataFilterInput>>;
  /** Количество редактирований */
  deletedCount?: InputMaybe<IntOperationFilterInput>;
  /** Количество добавлений */
  newCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<HistoryStatusCountDataFilterInput>>;
  /** Количество удалений */
  updatedCount?: InputMaybe<IntOperationFilterInput>;
};

/** Данные о количестве операций добавления, редактирования и удаления */
export type HistoryStatusCountDataInput = {
  /** Количество редактирований */
  deletedCount: Scalars['Int'];
  /** Количество добавлений */
  newCount: Scalars['Int'];
  /** Количество удалений */
  updatedCount: Scalars['Int'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

/** Способ распределения лимитов по сезонам */
export enum LimitDistributionMethodEnum {
  /** Равномерно по сезонам */
  EvenlyBySeason = 'EVENLY_BY_SEASON',
  /** Из файла */
  File = 'FILE',
  /** Первый сезон */
  FirstSeason = 'FIRST_SEASON',
  /** Последний сезон */
  LastSeason = 'LAST_SEASON',
  /** Вручную */
  Manual = 'MANUAL'
}

/** Модель статьи заимствования прочей по сезону */
export type LimitSpanReminderSeason = {
  __typename?: 'LimitSpanReminderSeason';
  /** Фактическое выполнение статьи по сезону */
  actual?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона договора */
  contractSeasonId: Scalars['Long'];
  /** Значение перераспределения (заимствования) */
  cost?: Maybe<Scalars['Decimal']>;
  /** Плановое значение статьи по сезону */
  plan?: Maybe<Scalars['Decimal']>;
  /** Остаток статьи по сезону */
  reminder?: Maybe<Scalars['Decimal']>;
  /** Год сезона договора */
  year: Scalars['Short'];
};

export type ListDecimalOperationFilterInput = {
  all?: InputMaybe<DecimalOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DecimalOperationFilterInput>;
  some?: InputMaybe<DecimalOperationFilterInput>;
};

export type ListFilterInputTypeOfActKc2LimitedCostConstructionTypeLimitDataFilterInput = {
  all?: InputMaybe<ActKc2LimitedCostConstructionTypeLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActKc2LimitedCostConstructionTypeLimitDataFilterInput>;
  some?: InputMaybe<ActKc2LimitedCostConstructionTypeLimitDataFilterInput>;
};

export type ListFilterInputTypeOfActKc2LimitedCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<ActKc2LimitedCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActKc2LimitedCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<ActKc2LimitedCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfAppHealthCheckInfoFilterInput = {
  all?: InputMaybe<AppHealthCheckInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AppHealthCheckInfoFilterInput>;
  some?: InputMaybe<AppHealthCheckInfoFilterInput>;
};

export type ListFilterInputTypeOfBimActKc2OtherCostDataFilterInput = {
  all?: InputMaybe<BimActKc2OtherCostDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimActKc2OtherCostDataFilterInput>;
  some?: InputMaybe<BimActKc2OtherCostDataFilterInput>;
};

export type ListFilterInputTypeOfBimContractObjectSeasonDistributionDataFilterInput = {
  all?: InputMaybe<BimContractObjectSeasonDistributionDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimContractObjectSeasonDistributionDataFilterInput>;
  some?: InputMaybe<BimContractObjectSeasonDistributionDataFilterInput>;
};

export type ListFilterInputTypeOfBimWorkOrderChangePriceRowDataFilterInput = {
  all?: InputMaybe<BimWorkOrderChangePriceRowDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimWorkOrderChangePriceRowDataFilterInput>;
  some?: InputMaybe<BimWorkOrderChangePriceRowDataFilterInput>;
};

export type ListFilterInputTypeOfBimWorkOrderPriceRowDataFilterInput = {
  all?: InputMaybe<BimWorkOrderPriceRowDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimWorkOrderPriceRowDataFilterInput>;
  some?: InputMaybe<BimWorkOrderPriceRowDataFilterInput>;
};

export type ListFilterInputTypeOfBimWorkOrderVersionObjectSeasonDistributionDataFilterInput = {
  all?: InputMaybe<BimWorkOrderVersionObjectSeasonDistributionDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimWorkOrderVersionObjectSeasonDistributionDataFilterInput>;
  some?: InputMaybe<BimWorkOrderVersionObjectSeasonDistributionDataFilterInput>;
};

export type ListFilterInputTypeOfBimWorkOrderVersionPriceRowDataFilterInput = {
  all?: InputMaybe<BimWorkOrderVersionPriceRowDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimWorkOrderVersionPriceRowDataFilterInput>;
  some?: InputMaybe<BimWorkOrderVersionPriceRowDataFilterInput>;
};

export type ListFilterInputTypeOfBimcCalculationOtherCostLimitDataFilterInput = {
  all?: InputMaybe<BimcCalculationOtherCostLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimcCalculationOtherCostLimitDataFilterInput>;
  some?: InputMaybe<BimcCalculationOtherCostLimitDataFilterInput>;
};

export type ListFilterInputTypeOfBimcCalculationPreviewSeasonDataFilterInput = {
  all?: InputMaybe<BimcCalculationPreviewSeasonDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BimcCalculationPreviewSeasonDataFilterInput>;
  some?: InputMaybe<BimcCalculationPreviewSeasonDataFilterInput>;
};

export type ListFilterInputTypeOfCalculationComputeSeasonValueFilterInput = {
  all?: InputMaybe<CalculationComputeSeasonValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CalculationComputeSeasonValueFilterInput>;
  some?: InputMaybe<CalculationComputeSeasonValueFilterInput>;
};

export type ListFilterInputTypeOfCatalogOtherCostVariableEntityDataFilterInput = {
  all?: InputMaybe<CatalogOtherCostVariableEntityDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CatalogOtherCostVariableEntityDataFilterInput>;
  some?: InputMaybe<CatalogOtherCostVariableEntityDataFilterInput>;
};

export type ListFilterInputTypeOfCatalogUerBaseCostWorkScopeDataFilterInput = {
  all?: InputMaybe<CatalogUerBaseCostWorkScopeDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CatalogUerBaseCostWorkScopeDataFilterInput>;
  some?: InputMaybe<CatalogUerBaseCostWorkScopeDataFilterInput>;
};

export type ListFilterInputTypeOfCatalogUerBaseCostWorkScopeItemsFilterInput = {
  all?: InputMaybe<CatalogUerBaseCostWorkScopeItemsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CatalogUerBaseCostWorkScopeItemsFilterInput>;
  some?: InputMaybe<CatalogUerBaseCostWorkScopeItemsFilterInput>;
};

export type ListFilterInputTypeOfCatalogUerEstimateWorkTypeItemFilterInput = {
  all?: InputMaybe<CatalogUerEstimateWorkTypeItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CatalogUerEstimateWorkTypeItemFilterInput>;
  some?: InputMaybe<CatalogUerEstimateWorkTypeItemFilterInput>;
};

export type ListFilterInputTypeOfCollectionUerBaseCostItemMinimalFilterInput = {
  all?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
  some?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
};

export type ListFilterInputTypeOfConstructionTypeDataFilterInput = {
  all?: InputMaybe<ConstructionTypeDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ConstructionTypeDataFilterInput>;
  some?: InputMaybe<ConstructionTypeDataFilterInput>;
};

export type ListFilterInputTypeOfConstructionTypeLimitDataFilterInput = {
  all?: InputMaybe<ConstructionTypeLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ConstructionTypeLimitDataFilterInput>;
  some?: InputMaybe<ConstructionTypeLimitDataFilterInput>;
};

export type ListFilterInputTypeOfContractLimitedCostConstructionTypeLimitDataFilterInput = {
  all?: InputMaybe<ContractLimitedCostConstructionTypeLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContractLimitedCostConstructionTypeLimitDataFilterInput>;
  some?: InputMaybe<ContractLimitedCostConstructionTypeLimitDataFilterInput>;
};

export type ListFilterInputTypeOfContractLimitedCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<ContractLimitedCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContractLimitedCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<ContractLimitedCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfContractOtherCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<ContractOtherCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ContractOtherCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<ContractOtherCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfLocalEstimateRatioDataFilterInput = {
  all?: InputMaybe<LocalEstimateRatioDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<LocalEstimateRatioDataFilterInput>;
  some?: InputMaybe<LocalEstimateRatioDataFilterInput>;
};

export type ListFilterInputTypeOfPriceListUerRowPriceCurrentDataFilterInput = {
  all?: InputMaybe<PriceListUerRowPriceCurrentDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PriceListUerRowPriceCurrentDataFilterInput>;
  some?: InputMaybe<PriceListUerRowPriceCurrentDataFilterInput>;
};

export type ListFilterInputTypeOfPriceListUerWorkScopeDataFilterInput = {
  all?: InputMaybe<PriceListUerWorkScopeDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PriceListUerWorkScopeDataFilterInput>;
  some?: InputMaybe<PriceListUerWorkScopeDataFilterInput>;
};

export type ListFilterInputTypeOfSkzsRatioDataFilterInput = {
  all?: InputMaybe<SkzsRatioDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SkzsRatioDataFilterInput>;
  some?: InputMaybe<SkzsRatioDataFilterInput>;
};

export type ListFilterInputTypeOfSkzsWorkScopeFilterInput = {
  all?: InputMaybe<SkzsWorkScopeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SkzsWorkScopeFilterInput>;
  some?: InputMaybe<SkzsWorkScopeFilterInput>;
};

export type ListFilterInputTypeOfUercCalculationLimitedCostLimitDataFilterInput = {
  all?: InputMaybe<UercCalculationLimitedCostLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UercCalculationLimitedCostLimitDataFilterInput>;
  some?: InputMaybe<UercCalculationLimitedCostLimitDataFilterInput>;
};

export type ListFilterInputTypeOfUercCalculationOtherCostLimitDataFilterInput = {
  all?: InputMaybe<UercCalculationOtherCostLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UercCalculationOtherCostLimitDataFilterInput>;
  some?: InputMaybe<UercCalculationOtherCostLimitDataFilterInput>;
};

export type ListFilterInputTypeOfValidationMessageFilterInput = {
  all?: InputMaybe<ValidationMessageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ValidationMessageFilterInput>;
  some?: InputMaybe<ValidationMessageFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderActKc2DataFilterInput = {
  all?: InputMaybe<WorkOrderActKc2DataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderActKc2DataFilterInput>;
  some?: InputMaybe<WorkOrderActKc2DataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderActKc2PriceDataFilterInput = {
  all?: InputMaybe<WorkOrderActKc2PriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderActKc2PriceDataFilterInput>;
  some?: InputMaybe<WorkOrderActKc2PriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeCostLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeCostLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeCostLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeCostLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeLimitedCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeLimitedCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeLimitedCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeLimitedCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeOtherCostObjectItemFilterInput = {
  all?: InputMaybe<WorkOrderChangeOtherCostObjectItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeOtherCostObjectItemFilterInput>;
  some?: InputMaybe<WorkOrderChangeOtherCostObjectItemFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeOtherCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeOtherCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeOtherCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeOtherCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeOtherSeasonPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeOtherSeasonPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeOtherSeasonPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeOtherSeasonPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangePriceSeasonValueFilterInput = {
  all?: InputMaybe<WorkOrderChangePriceSeasonValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangePriceSeasonValueFilterInput>;
  some?: InputMaybe<WorkOrderChangePriceSeasonValueFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeSeasonPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeSeasonPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeSeasonPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeSeasonPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderChangeSeasonResultDataFilterInput = {
  all?: InputMaybe<WorkOrderChangeSeasonResultDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderChangeSeasonResultDataFilterInput>;
  some?: InputMaybe<WorkOrderChangeSeasonResultDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderCostResultDataFilterInput = {
  all?: InputMaybe<WorkOrderCostResultDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderCostResultDataFilterInput>;
  some?: InputMaybe<WorkOrderCostResultDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderLimitedCostConstructionTypeLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderLimitedCostConstructionTypeLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderLimitedCostConstructionTypeLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderLimitedCostConstructionTypeLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderLimitedCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderLimitedCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderLimitedCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderLimitedCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderOtherActKc2PriceDataFilterInput = {
  all?: InputMaybe<WorkOrderOtherActKc2PriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderOtherActKc2PriceDataFilterInput>;
  some?: InputMaybe<WorkOrderOtherActKc2PriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderOtherCostObjectItemFilterInput = {
  all?: InputMaybe<WorkOrderOtherCostObjectItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderOtherCostObjectItemFilterInput>;
  some?: InputMaybe<WorkOrderOtherCostObjectItemFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderOtherCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderOtherCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderOtherCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderOtherCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderOtherSeasonPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderOtherSeasonPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderOtherSeasonPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderOtherSeasonPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderPriceActValueFilterInput = {
  all?: InputMaybe<WorkOrderPriceActValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderPriceActValueFilterInput>;
  some?: InputMaybe<WorkOrderPriceActValueFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderPriceSeasonValueFilterInput = {
  all?: InputMaybe<WorkOrderPriceSeasonValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderPriceSeasonValueFilterInput>;
  some?: InputMaybe<WorkOrderPriceSeasonValueFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderSeasonDataFilterInput = {
  all?: InputMaybe<WorkOrderSeasonDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderSeasonDataFilterInput>;
  some?: InputMaybe<WorkOrderSeasonDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderSeasonPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderSeasonPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderSeasonPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderSeasonPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionActKc2VersionPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionActKc2VersionPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionActKc2VersionPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionActKc2VersionPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionActKc2VersionResultDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionActKc2VersionResultDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionActKc2VersionResultDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionActKc2VersionResultDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionCostResultDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionCostResultDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionCostResultDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionCostResultDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionLimitedCostSeasonLimitDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionLimitedCostSeasonLimitDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionLimitedCostSeasonLimitDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionLimitedCostSeasonLimitDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionOtherActKc2VersionPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionOtherActKc2VersionPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionOtherActKc2VersionPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionOtherActKc2VersionPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionOtherSeasonPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionOtherSeasonPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionOtherSeasonPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionOtherSeasonPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionPriceActValueFilterInput = {
  all?: InputMaybe<WorkOrderVersionPriceActValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionPriceActValueFilterInput>;
  some?: InputMaybe<WorkOrderVersionPriceActValueFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionPriceSeasonValueFilterInput = {
  all?: InputMaybe<WorkOrderVersionPriceSeasonValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionPriceSeasonValueFilterInput>;
  some?: InputMaybe<WorkOrderVersionPriceSeasonValueFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionSeasonPriceDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionSeasonPriceDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionSeasonPriceDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionSeasonPriceDataFilterInput>;
};

export type ListFilterInputTypeOfWorkOrderVersionSeasonResultDataFilterInput = {
  all?: InputMaybe<WorkOrderVersionSeasonResultDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkOrderVersionSeasonResultDataFilterInput>;
  some?: InputMaybe<WorkOrderVersionSeasonResultDataFilterInput>;
};

export type ListFilterInputTypeOfWorkVolumeValueDataFilterInput = {
  all?: InputMaybe<WorkVolumeValueDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WorkVolumeValueDataFilterInput>;
  some?: InputMaybe<WorkVolumeValueDataFilterInput>;
};

export type ListProjectMethodologyEnumOperationFilterInput = {
  all?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
  some?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
};

export type ListShortOperationFilterInput = {
  all?: InputMaybe<ShortOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ShortOperationFilterInput>;
  some?: InputMaybe<ShortOperationFilterInput>;
};

export type ListStringOperationFilterInputTypeExFilterInput = {
  all?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  some?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Элемент состава сметы ЛСР (плоская строка окна «Состав сметы»). */
export type LocalEstimateCompositionRowData = {
  __typename?: 'LocalEstimateCompositionRowData';
  id: Scalars['Long'];
  /** Коэффициенты элемента (по возрастанию SrcOrder). */
  ratios: Array<LocalEstimateRatioData>;
  /** Идентификатор раздела/подраздела, к которому относится элемент. */
  sectionId?: Maybe<Scalars['Long']>;
  /** Наименование раздела/подраздела, к которому относится элемент. */
  sectionName?: Maybe<Scalars['String']>;
  /** Порядковый номер в загружаемом файле. */
  srcOrder: Scalars['Int'];
  /** Тип элемента: "Price" — расценка, "Resource" — МТР. */
  type: Scalars['String'];
  /** Стоимостные данные элемента (в соответствии с выбранным уровнем цен). */
  value: LocalEstimateCompositionValueData;
};

/** Элемент состава сметы ЛСР (плоская строка окна «Состав сметы»). */
export type LocalEstimateCompositionRowDataFilterInput = {
  and?: InputMaybe<Array<LocalEstimateCompositionRowDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<LocalEstimateCompositionRowDataFilterInput>>;
  /** Коэффициенты элемента (по возрастанию SrcOrder). */
  ratios?: InputMaybe<ListFilterInputTypeOfLocalEstimateRatioDataFilterInput>;
  /** Идентификатор раздела/подраздела, к которому относится элемент. */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела/подраздела, к которому относится элемент. */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Порядковый номер в загружаемом файле. */
  srcOrder?: InputMaybe<IntOperationFilterInput>;
  /** Тип элемента: "Price" — расценка, "Resource" — МТР. */
  type?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимостные данные элемента (в соответствии с выбранным уровнем цен). */
  value?: InputMaybe<LocalEstimateCompositionValueDataFilterInput>;
};

/** Элемент состава сметы ЛСР (плоская строка окна «Состав сметы»). */
export type LocalEstimateCompositionRowDataSortInput = {
  id?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела/подраздела, к которому относится элемент. */
  sectionId?: InputMaybe<SortEnumType>;
  /** Наименование раздела/подраздела, к которому относится элемент. */
  sectionName?: InputMaybe<SortEnumType>;
  /** Порядковый номер в загружаемом файле. */
  srcOrder?: InputMaybe<SortEnumType>;
  /** Тип элемента: "Price" — расценка, "Resource" — МТР. */
  type?: InputMaybe<SortEnumType>;
  /** Стоимостные данные элемента (в соответствии с выбранным уровнем цен). */
  value?: InputMaybe<LocalEstimateCompositionValueDataSortInput>;
};

/** Стоимостные данные элемента ЛСР (в соответствии с выбранным уровнем цен). */
export type LocalEstimateCompositionValueData = {
  __typename?: 'LocalEstimateCompositionValueData';
  /** Шифр. */
  code?: Maybe<Scalars['String']>;
  /** ЭММ. */
  emm?: Maybe<Scalars['Decimal']>;
  /** МП. */
  mp?: Maybe<Scalars['Decimal']>;
  /** В том числе ЦО МТР. */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Справочно МЗ. */
  mz?: Maybe<Scalars['Decimal']>;
  /** Наименование работ, затрат. */
  name?: Maybe<Scalars['String']>;
  /** НР. */
  nr?: Maybe<Scalars['Decimal']>;
  /** ОП. */
  op?: Maybe<Scalars['Decimal']>;
  /** Прочие затраты. */
  others?: Maybe<Scalars['Decimal']>;
  /** Справочно ОЗ. */
  oz?: Maybe<Scalars['Decimal']>;
  /** ОЗП. */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Кол-во. */
  quantity?: Maybe<Scalars['Decimal']>;
  /** Всего СМР. */
  smrTotal?: Maybe<Scalars['Decimal']>;
  /** СП. */
  sp?: Maybe<Scalars['Decimal']>;
  /** Всего. */
  total?: Maybe<Scalars['Decimal']>;
  /** ТЗР мех., чел.час. */
  tzm?: Maybe<Scalars['Decimal']>;
  /** ТЗР, чел.час. */
  tzr?: Maybe<Scalars['Decimal']>;
  /** Единица измерения. */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость единицы. */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** В том числе ЗПМ. */
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Стоимостные данные элемента ЛСР (в соответствии с выбранным уровнем цен). */
export type LocalEstimateCompositionValueDataFilterInput = {
  and?: InputMaybe<Array<LocalEstimateCompositionValueDataFilterInput>>;
  /** Шифр. */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** ЭММ. */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** МП. */
  mp?: InputMaybe<DecimalOperationFilterInput>;
  /** В том числе ЦО МТР. */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** Справочно МЗ. */
  mz?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование работ, затрат. */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** НР. */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  /** ОП. */
  op?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<LocalEstimateCompositionValueDataFilterInput>>;
  /** Прочие затраты. */
  others?: InputMaybe<DecimalOperationFilterInput>;
  /** Справочно ОЗ. */
  oz?: InputMaybe<DecimalOperationFilterInput>;
  /** ОЗП. */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Кол-во. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  /** Всего СМР. */
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  /** СП. */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Всего. */
  total?: InputMaybe<DecimalOperationFilterInput>;
  /** ТЗР мех., чел.час. */
  tzm?: InputMaybe<DecimalOperationFilterInput>;
  /** ТЗР, чел.час. */
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Единица измерения. */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы. */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** В том числе ЗПМ. */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Стоимостные данные элемента ЛСР (в соответствии с выбранным уровнем цен). */
export type LocalEstimateCompositionValueDataSortInput = {
  /** Шифр. */
  code?: InputMaybe<SortEnumType>;
  /** ЭММ. */
  emm?: InputMaybe<SortEnumType>;
  /** МП. */
  mp?: InputMaybe<SortEnumType>;
  /** В том числе ЦО МТР. */
  mtr?: InputMaybe<SortEnumType>;
  /** Справочно МЗ. */
  mz?: InputMaybe<SortEnumType>;
  /** Наименование работ, затрат. */
  name?: InputMaybe<SortEnumType>;
  /** НР. */
  nr?: InputMaybe<SortEnumType>;
  /** ОП. */
  op?: InputMaybe<SortEnumType>;
  /** Прочие затраты. */
  others?: InputMaybe<SortEnumType>;
  /** Справочно ОЗ. */
  oz?: InputMaybe<SortEnumType>;
  /** ОЗП. */
  ozp?: InputMaybe<SortEnumType>;
  /** Кол-во. */
  quantity?: InputMaybe<SortEnumType>;
  /** Всего СМР. */
  smrTotal?: InputMaybe<SortEnumType>;
  /** СП. */
  sp?: InputMaybe<SortEnumType>;
  /** Всего. */
  total?: InputMaybe<SortEnumType>;
  /** ТЗР мех., чел.час. */
  tzm?: InputMaybe<SortEnumType>;
  /** ТЗР, чел.час. */
  tzr?: InputMaybe<SortEnumType>;
  /** Единица измерения. */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы. */
  unitCost?: InputMaybe<SortEnumType>;
  /** В том числе ЗПМ. */
  zpm?: InputMaybe<SortEnumType>;
};

/** Данные окна «Редактирование ЛСР» */
export type LocalEstimateEditData = {
  __typename?: 'LocalEstimateEditData';
  /** Глава сметы (например "Chapter3"). */
  chapter?: Maybe<Scalars['String']>;
  /** Шифр сметы (LocNum). */
  code: Scalars['String'];
  /** Идентификатор ЛСР. */
  id: Scalars['Long'];
  /** Участвует ли ЛСР в расчёте процента прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Идентификатор объекта/подобъекта структуры расчёта. */
  objectId?: Maybe<Scalars['Long']>;
  /** Наименование объекта/подобъекта структуры расчёта. */
  objectName?: Maybe<Scalars['String']>;
};

/** Данные окна «Редактирование ЛСР» */
export type LocalEstimateEditDataInput = {
  /** Глава сметы (например "Chapter3"). */
  chapter?: InputMaybe<Scalars['String']>;
  /** Шифр сметы (LocNum). */
  code: Scalars['String'];
  /** Идентификатор ЛСР. */
  id: Scalars['Long'];
  /** Участвует ли ЛСР в расчёте процента прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Идентификатор объекта/подобъекта структуры расчёта. */
  objectId?: InputMaybe<Scalars['Long']>;
  /** Наименование объекта/подобъекта структуры расчёта. */
  objectName?: InputMaybe<Scalars['String']>;
};

/** Результат загрузки одной ЛСР. */
export type LocalEstimateImportItemData = {
  __typename?: 'LocalEstimateImportItemData';
  /** Шифр сметы (Value_Code). */
  code?: Maybe<Scalars['String']>;
  /** Имя загруженного файла. */
  fileName: Scalars['String'];
  /** Идентификатор сохранённой ЛСР. */
  localEstimateId?: Maybe<Scalars['Long']>;
  /** Наименование сметы (Value_Name). */
  name?: Maybe<Scalars['String']>;
};

/** Результат загрузки одной ЛСР. */
export type LocalEstimateImportItemDataInput = {
  /** Шифр сметы (Value_Code). */
  code?: InputMaybe<Scalars['String']>;
  /** Имя загруженного файла. */
  fileName: Scalars['String'];
  /** Идентификатор сохранённой ЛСР. */
  localEstimateId?: InputMaybe<Scalars['Long']>;
  /** Наименование сметы (Value_Name). */
  name?: InputMaybe<Scalars['String']>;
};

/** Input загрузки ЛСР (локальных сметных расчётов) для мутации LoadLocalEstimates. */
export type LocalEstimateImportMutationInput = {
  /** Идентификатор расчёта НМЦ, к которому относится объект. */
  calculationId: Scalars['Long'];
  /** Глава. */
  chapter?: InputMaybe<BimChapterEnum>;
  /** Год/версия тегов сметной документации (2017 / 2020). */
  estimateYear?: InputMaybe<EstimateYearEnum>;
  /** Загружаемые файлы смет. */
  files: Array<FileInput>;
  /** Участвует ли ЛСР в расчёте процента прочих и лимитированных затрат. */
  inPercentOtherAndLimit?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор объекта/подобъекта структуры расчёта, к которому добавляется ЛСР. */
  objectId: Scalars['Long'];
};

/** Данные окна «Перераспределение МТР» ЛСР. */
export type LocalEstimateMtrDistributionData = {
  __typename?: 'LocalEstimateMtrDistributionData';
  /** Глава сметы. */
  chapter?: Maybe<Scalars['String']>;
  /** Шифр ЛСР. */
  code?: Maybe<Scalars['String']>;
  /** Материалы подрядчика. */
  mp?: Maybe<Scalars['Decimal']>;
  /** Материалы заказчика. */
  mz?: Maybe<Scalars['Decimal']>;
  /** Объект структуры расчёта. */
  object?: Maybe<Scalars['String']>;
  /** Оборудование подрядчика. */
  op?: Maybe<Scalars['Decimal']>;
  /** Оборудование заказчика. */
  oz?: Maybe<Scalars['Decimal']>;
  /** Итоговая стоимость сметы (Всего + МЗ + ОЗ). */
  total?: Maybe<Scalars['Decimal']>;
};

/** Данные окна «Перераспределение МТР» ЛСР. */
export type LocalEstimateMtrDistributionDataInput = {
  /** Глава сметы. */
  chapter?: InputMaybe<Scalars['String']>;
  /** Шифр ЛСР. */
  code?: InputMaybe<Scalars['String']>;
  /** Материалы подрядчика. */
  mp?: InputMaybe<Scalars['Decimal']>;
  /** Материалы заказчика. */
  mz?: InputMaybe<Scalars['Decimal']>;
  /** Объект структуры расчёта. */
  object?: InputMaybe<Scalars['String']>;
  /** Оборудование подрядчика. */
  op?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование заказчика. */
  oz?: InputMaybe<Scalars['Decimal']>;
  /** Итоговая стоимость сметы (Всего + МЗ + ОЗ). */
  total?: InputMaybe<Scalars['Decimal']>;
};

/** Входные данные перераспределения МТР в ЛСР. */
export type LocalEstimateMtrDistributionInput = {
  /** Материалы подрядчика (Value_Mp). */
  mp?: InputMaybe<Scalars['Decimal']>;
  /** Материалы заказчика (Value_Mz). */
  mz?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование подрядчика (Value_Op). */
  op?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование заказчика (Value_Oz). */
  oz?: InputMaybe<Scalars['Decimal']>;
};

/** Предрасчёт итога и отклонения стоимости сметы при перераспределении МТР */
export type LocalEstimateMtrDistributionTotalData = {
  __typename?: 'LocalEstimateMtrDistributionTotalData';
  /** Отклонение от исходной стоимости сметы. */
  deviation?: Maybe<DeviationEnum>;
  /** Итоговая стоимость сметы (Всего + МЗ + ОЗ) с введёнными значениями. */
  total?: Maybe<Scalars['Decimal']>;
};

/** Предрасчёт итога и отклонения стоимости сметы при перераспределении МТР */
export type LocalEstimateMtrDistributionTotalDataInput = {
  /** Отклонение от исходной стоимости сметы. */
  deviation?: InputMaybe<DeviationEnum>;
  /** Итоговая стоимость сметы (Всего + МЗ + ОЗ) с введёнными значениями. */
  total?: InputMaybe<Scalars['Decimal']>;
};

/** Коэффициент к элементу ЛСР (BimсWorkOrderPriceRatio) — плоская запись для окна «Состав сметы». */
export type LocalEstimateRatioData = {
  __typename?: 'LocalEstimateRatioData';
  /** Шифр коэффициента. */
  code: Scalars['String'];
  /** Коэффициент ЭММ. */
  em?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Коэффициент МП. */
  mt?: Maybe<Scalars['Decimal']>;
  /** Наименование коэффициента. */
  name: Scalars['String'];
  /** Коэффициент ОЗП. */
  oz?: Maybe<Scalars['Decimal']>;
  /** Коэффициент PZ. */
  pz?: Maybe<Scalars['Decimal']>;
  /** Идентификатор элемента, к которому относится коэффициент. */
  rowId: Scalars['Long'];
  /** Порядковый номер в загружаемом файле. */
  srcOrder: Scalars['Int'];
  /** Коэффициент ТЗР. */
  tz?: Maybe<Scalars['Decimal']>;
  /** Коэффициент ТЗР мех. */
  tzm?: Maybe<Scalars['Decimal']>;
  /** Коэффициент ЗПМ. */
  zm?: Maybe<Scalars['Decimal']>;
};

/** Коэффициент к элементу ЛСР (BimсWorkOrderPriceRatio) — плоская запись для окна «Состав сметы». */
export type LocalEstimateRatioDataFilterInput = {
  and?: InputMaybe<Array<LocalEstimateRatioDataFilterInput>>;
  /** Шифр коэффициента. */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент ЭММ. */
  em?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент МП. */
  mt?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование коэффициента. */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<LocalEstimateRatioDataFilterInput>>;
  /** Коэффициент ОЗП. */
  oz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент PZ. */
  pz?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор элемента, к которому относится коэффициент. */
  rowId?: InputMaybe<LongOperationFilterInput>;
  /** Порядковый номер в загружаемом файле. */
  srcOrder?: InputMaybe<IntOperationFilterInput>;
  /** Коэффициент ТЗР. */
  tz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент ТЗР мех. */
  tzm?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент ЗПМ. */
  zm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Input запроса массового удаления ЛСР */
export type LocalEstimateRemoveMutationInput = {
  /** Кортеж удаляемых ЛСР */
  removeLsrs: Array<RemoveLsrRequestInput>;
};

/** Уровень строки в плоском представлении дерева «Объект → Глава → ЛСР». */
export enum LocalEstimateRowTypeEnum {
  /** Глава сметы (уровень 2). */
  Chapter = 'CHAPTER',
  /** ЛСР (уровень 3). */
  Lsr = 'LSR',
  /** Объект/подобъект структуры расчёта (уровень 1). */
  Object = 'OBJECT'
}

export type LocalEstimateRowTypeEnumOperationFilterInput = {
  eq?: InputMaybe<LocalEstimateRowTypeEnum>;
  in?: InputMaybe<Array<LocalEstimateRowTypeEnum>>;
  neq?: InputMaybe<LocalEstimateRowTypeEnum>;
  nin?: InputMaybe<Array<LocalEstimateRowTypeEnum>>;
};

/** Строка вкладки «Локальные сметные расчёты» */
export type LocalEstimateTableItemData = {
  __typename?: 'LocalEstimateTableItemData';
  /** Глава сметы (например "Chapter3"). */
  chapter?: Maybe<Scalars['String']>;
  /** Шифр сметы. */
  code?: Maybe<Scalars['String']>;
  emm?: Maybe<Scalars['Decimal']>;
  /** Уровень строки в дереве (объект/глава/ЛСР). */
  entityType: LocalEstimateRowTypeEnum;
  /** Признак гарантированного объёма объекта/подобъекта структуры расчёта. */
  hasGuaranteedVolume: Scalars['Boolean'];
  /** Имеются ли в составе укрупнённой сметы удалённые ЛСР (индикатор). */
  hasRemovedLsrs?: Maybe<Scalars['Boolean']>;
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Выполнялось ли перераспределение МТР. */
  isUpdatedPrice: Scalars['Boolean'];
  /** Идентификатор ЛСР (для строк уровня Lsr). */
  localEstimateId?: Maybe<Scalars['Long']>;
  /** Тип ЛСР */
  localEstimateType: BimcLocalEstimateTypeEnum;
  mp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  mz?: Maybe<Scalars['Decimal']>;
  /** Наименование сметы. */
  name?: Maybe<Scalars['String']>;
  nr?: Maybe<Scalars['Decimal']>;
  /** Идентификатор объекта/подобъекта структуры расчёта. */
  objectId?: Maybe<Scalars['Long']>;
  /** Наименование объекта/подобъекта (колонка «Элемент расчета»). */
  objectName?: Maybe<Scalars['String']>;
  op?: Maybe<Scalars['Decimal']>;
  others?: Maybe<Scalars['Decimal']>;
  oz?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  /** Кол-во. */
  quantity?: Maybe<Scalars['Decimal']>;
  smrTotal?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  /** Наименование подобъекта, к которому относится ЛСР. Пусто, если ЛСР загружена на уровне корневого объекта. */
  subObjectName?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Decimal']>;
  tzm?: Maybe<Scalars['Decimal']>;
  tzr?: Maybe<Scalars['Decimal']>;
  /** Единицы измерения. */
  unit?: Maybe<Scalars['String']>;
  zpm?: Maybe<Scalars['Decimal']>;
};

/** Строка вкладки «Локальные сметные расчёты» */
export type LocalEstimateTableItemDataFilterInput = {
  and?: InputMaybe<Array<LocalEstimateTableItemDataFilterInput>>;
  /** Глава сметы (например "Chapter3"). */
  chapter?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр сметы. */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Уровень строки в дереве (объект/глава/ЛСР). */
  entityType?: InputMaybe<LocalEstimateRowTypeEnumOperationFilterInput>;
  /** Признак гарантированного объёма объекта/подобъекта структуры расчёта. */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Имеются ли в составе укрупнённой сметы удалённые ЛСР (индикатор). */
  hasRemovedLsrs?: InputMaybe<BooleanOperationFilterInput>;
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit?: InputMaybe<BooleanOperationFilterInput>;
  /** Выполнялось ли перераспределение МТР. */
  isUpdatedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор ЛСР (для строк уровня Lsr). */
  localEstimateId?: InputMaybe<LongOperationFilterInput>;
  /** Тип ЛСР */
  localEstimateType?: InputMaybe<BimcLocalEstimateTypeEnumOperationFilterInput>;
  mp?: InputMaybe<DecimalOperationFilterInput>;
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  mz?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование сметы. */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  nr?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор объекта/подобъекта структуры расчёта. */
  objectId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование объекта/подобъекта (колонка «Элемент расчета»). */
  objectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  op?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<LocalEstimateTableItemDataFilterInput>>;
  others?: InputMaybe<DecimalOperationFilterInput>;
  oz?: InputMaybe<DecimalOperationFilterInput>;
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Кол-во. */
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  smrTotal?: InputMaybe<DecimalOperationFilterInput>;
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование подобъекта, к которому относится ЛСР. Пусто, если ЛСР загружена на уровне корневого объекта. */
  subObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  total?: InputMaybe<DecimalOperationFilterInput>;
  tzm?: InputMaybe<DecimalOperationFilterInput>;
  tzr?: InputMaybe<DecimalOperationFilterInput>;
  /** Единицы измерения. */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

/** Строка вкладки «Локальные сметные расчёты» */
export type LocalEstimateTableItemDataSortInput = {
  /** Глава сметы (например "Chapter3"). */
  chapter?: InputMaybe<SortEnumType>;
  /** Шифр сметы. */
  code?: InputMaybe<SortEnumType>;
  emm?: InputMaybe<SortEnumType>;
  /** Уровень строки в дереве (объект/глава/ЛСР). */
  entityType?: InputMaybe<SortEnumType>;
  /** Признак гарантированного объёма объекта/подобъекта структуры расчёта. */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Имеются ли в составе укрупнённой сметы удалённые ЛСР (индикатор). */
  hasRemovedLsrs?: InputMaybe<SortEnumType>;
  /** Учитывать в знаменателе формулы % прочих и лимитированных затрат. */
  inPercentOtherAndLimit?: InputMaybe<SortEnumType>;
  /** Выполнялось ли перераспределение МТР. */
  isUpdatedPrice?: InputMaybe<SortEnumType>;
  /** Идентификатор ЛСР (для строк уровня Lsr). */
  localEstimateId?: InputMaybe<SortEnumType>;
  /** Тип ЛСР */
  localEstimateType?: InputMaybe<SortEnumType>;
  mp?: InputMaybe<SortEnumType>;
  mtr?: InputMaybe<SortEnumType>;
  mz?: InputMaybe<SortEnumType>;
  /** Наименование сметы. */
  name?: InputMaybe<SortEnumType>;
  nr?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта/подобъекта структуры расчёта. */
  objectId?: InputMaybe<SortEnumType>;
  /** Наименование объекта/подобъекта (колонка «Элемент расчета»). */
  objectName?: InputMaybe<SortEnumType>;
  op?: InputMaybe<SortEnumType>;
  others?: InputMaybe<SortEnumType>;
  oz?: InputMaybe<SortEnumType>;
  ozp?: InputMaybe<SortEnumType>;
  /** Кол-во. */
  quantity?: InputMaybe<SortEnumType>;
  smrTotal?: InputMaybe<SortEnumType>;
  sp?: InputMaybe<SortEnumType>;
  /** Наименование подобъекта, к которому относится ЛСР. Пусто, если ЛСР загружена на уровне корневого объекта. */
  subObjectName?: InputMaybe<SortEnumType>;
  total?: InputMaybe<SortEnumType>;
  tzm?: InputMaybe<SortEnumType>;
  tzr?: InputMaybe<SortEnumType>;
  /** Единицы измерения. */
  unit?: InputMaybe<SortEnumType>;
  zpm?: InputMaybe<SortEnumType>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

/** Сервисные компоненты системы */
export enum ModuleEnum {
  /** Proxy BFF */
  Bff = 'BFF',
  /** БИМ мониторинг */
  Bim = 'BIM',
  /** УЕР мониторинг */
  Uer = 'UER',
  /** УЕР Расчет */
  Uerc = 'UERC'
}

/** Позиция Ведомости МТР, предлагаемая пользователю для ручного сопоставления */
export type MtrCandidateItem = {
  __typename?: 'MtrCandidateItem';
  code?: Maybe<Scalars['String']>;
  consumptionRateMtr?: Maybe<Scalars['Decimal']>;
  contragentType?: Maybe<ContragentTypeEnum>;
  cost?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  mtrType?: Maybe<MtrTypeEnum>;
  name: Scalars['String'];
  unit: Scalars['String'];
};

/** Позиция Ведомости МТР, предлагаемая пользователю для ручного сопоставления */
export type MtrCandidateItemInput = {
  code?: InputMaybe<Scalars['String']>;
  consumptionRateMtr?: InputMaybe<Scalars['Decimal']>;
  contragentType?: InputMaybe<ContragentTypeEnum>;
  cost?: InputMaybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  mtrType?: InputMaybe<MtrTypeEnum>;
  name: Scalars['String'];
  unit: Scalars['String'];
};

export type MtrCodeFilter = {
  __typename?: 'MtrCodeFilter';
  codes: Array<Scalars['String']>;
  groupName: Scalars['String'];
};

/** Выбранные значения фильтров каскадной фильтрации МТР */
export type MtrFilterInput = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  mtrTypes?: InputMaybe<Array<MtrTypeEnum>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  pricingTypes?: InputMaybe<Array<PricingTypeEnum>>;
  supplyBy?: InputMaybe<Array<ContragentTypeEnum>>;
};

/** Названия групп(шифров) возможных при создании МТР (рассположены в иерархическом порядке) */
export enum MtrGroupName {
  /** Материал Подрядчика */
  Mp = 'MP',
  /** Материал Заказчика */
  Mz = 'MZ',
  /** Новый */
  New = 'NEW',
  /** Неценообразующий материал */
  None = 'NONE',
  /** Оборудование Подрядчика */
  Op = 'OP',
  /** Оборудование Заказчика */
  Oz = 'OZ'
}

export type MtrGroupNameOperationFilterInput = {
  eq?: InputMaybe<MtrGroupName>;
  in?: InputMaybe<Array<MtrGroupName>>;
  neq?: InputMaybe<MtrGroupName>;
  nin?: InputMaybe<Array<MtrGroupName>>;
};

/** Pекомендованный МТР (из файла ВОР) с перечнем кандидатов из Ведомости МТР для ручного выбора */
export type MtrImportCandidate = {
  __typename?: 'MtrImportCandidate';
  candidates: Array<MtrCandidateItem>;
  consumptionRate?: Maybe<Scalars['Decimal']>;
  key: Scalars['String'];
  name: Scalars['String'];
  selectedCollectionMtrId?: Maybe<Scalars['Long']>;
  uerCode: Scalars['String'];
  unit: Scalars['String'];
};

/** Pекомендованный МТР (из файла ВОР) с перечнем кандидатов из Ведомости МТР для ручного выбора */
export type MtrImportCandidateInput = {
  candidates: Array<MtrCandidateItemInput>;
  consumptionRate?: InputMaybe<Scalars['Decimal']>;
  key: Scalars['String'];
  name: Scalars['String'];
  selectedCollectionMtrId?: InputMaybe<Scalars['Long']>;
  uerCode: Scalars['String'];
  unit: Scalars['String'];
};

export enum MtrRecordStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type MtrRecordStatusEnumOperationFilterInput = {
  eq?: InputMaybe<MtrRecordStatusEnum>;
  in?: InputMaybe<Array<MtrRecordStatusEnum>>;
  neq?: InputMaybe<MtrRecordStatusEnum>;
  nin?: InputMaybe<Array<MtrRecordStatusEnum>>;
};

/** Выбранные позиции Ведомости МТР для множественных вариантов */
export type MtrSelectionInput = {
  collectionMtrId: Scalars['Long'];
  mtrKey: Scalars['String'];
};

/** Статус записи МТР */
export enum MtrStatus {
  /** Условие расчета */
  CalculationCondition = 'CALCULATION_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

/** Энумирация, совмещающая в себе ContragentTypeEnum и MtrTypeEnum */
export enum MtrSupplyAndTypeEnum {
  /** МТР (оборудование подрядчика) */
  ContractorEquipment = 'CONTRACTOR_EQUIPMENT',
  /** МТР (материал подрядчика) */
  ContractorMaterial = 'CONTRACTOR_MATERIAL',
  /** МТР (оборудование заказчика) */
  CustomerEquipment = 'CUSTOMER_EQUIPMENT',
  /** МТР (материал заказчика) */
  CustomerMaterial = 'CUSTOMER_MATERIAL',
  /** Новый */
  New = 'NEW'
}

export type MtrSupplyAndTypeEnumOperationFilterInput = {
  eq?: InputMaybe<MtrSupplyAndTypeEnum>;
  in?: InputMaybe<Array<MtrSupplyAndTypeEnum>>;
  neq?: InputMaybe<MtrSupplyAndTypeEnum>;
  nin?: InputMaybe<Array<MtrSupplyAndTypeEnum>>;
};

export enum MtrTypeEnum {
  /** Оборудование */
  Equipment = 'EQUIPMENT',
  /** Материал */
  Material = 'MATERIAL'
}

export type MtrTypeEnumOperationFilterInput = {
  eq?: InputMaybe<MtrTypeEnum>;
  in?: InputMaybe<Array<MtrTypeEnum>>;
  neq?: InputMaybe<MtrTypeEnum>;
  nin?: InputMaybe<Array<MtrTypeEnum>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Добавляет прочие затраты в Изм
   *
   *
   * **Returns:**
   * Список добавленных прочих затрат Изма
   */
  bimAddWorkOrderChangeOthers: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  /**
   * Добавляет прочие затраты для акта КС-2
   *
   *
   * **Returns:**
   * Список идентификаторов добавленных прочих затрат НЗ
   */
  bimAddWorkOrderOtherForAct: ServiceDataResultOfWorkOrderModifyItemIds;
  /**
   * Добавляет прочие затраты в наряд-заказ
   *
   *
   * **Returns:**
   * Список добавленных прочих затрат
   */
  bimAddWorkOrderOthers: ServiceDataResultOfWorkOrderModifyItemIds;
  /**
   * Завершает этап формирования структуры объектов наряд-заказа и
   * переводит его в на этап формирования ценовых данных
   *
   *
   * **Returns:**
   * Данные реквизитов нового созданного наряд-заказа
   */
  bimCompleteStructureFormation: ServiceDataResultOfBimWorkOrderData;
  /**
   * Копирует Договор Проекта
   *
   *
   * **Returns:**
   * Уникальный идентификатор скопированного Договора
   */
  bimCopyContract: ServiceDataResultOfString;
  /**
   * Создает Акт КС-2 для прочих
   *
   *
   * **Returns:**
   * Созданный Акт КС-2 для прочих
   */
  bimCreateActKC2Other: ServiceDataResultOfBimActKc2OtherData;
  /** Создать корректировку Акта КС-2 для прочих */
  bimCreateActKC2OtherCorrection: ServiceDataResultOfBimActKc2OtherData;
  /**
   * Создает договор
   *
   *
   * **Returns:**
   * Созданный договор
   */
  bimCreateContract: ServiceDataResultOfBimContractData;
  /**
   * Создает прочую затрату договора в условия по договору
   *
   *
   * **Returns:**
   * Прочая затрата договора
   */
  bimCreateContractConditionOtherCost: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Создает объект договора
   *
   *
   * **Returns:**
   * Созданный объект договора
   */
  bimCreateContractObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Создает прочую затрату договора вручную
   *
   *
   * **Returns:**
   * Прочая затрата договора
   */
  bimCreateContractOtherCost: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Создает прочую затрату договора из справочника методик расчета
   *
   *
   * **Returns:**
   * Прочая затрата договора
   */
  bimCreateContractOtherCostFromCatalog: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Создает подобъект договора
   *
   *
   * **Returns:**
   * Созданный подобъект договора
   */
  bimCreateContractSubObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Создает новый наряд-заказ или рассчет в зависимости от типа договора
   *
   *
   * **Returns:**
   * Данные реквизитов нового созданного наряд-заказа
   */
  bimCreateWorkOrder: ServiceDataResultOfBimWorkOrderData;
  /**
   * Создает пользовательскую группу актов.
   *
   *
   * **Returns:**
   * Результат выполнения операции.
   */
  bimCreateWorkOrderActsKC2Group: ServiceIdResultOfInt64;
  /**
   * Создает изм наряд-заказа
   *
   *
   * **Returns:**
   * Созданный изм наряд-заказа
   */
  bimCreateWorkOrderChange: ServiceDataResultOfBimWorkOrderChangeData;
  /**
   * Создает объект изма наряд-заказа
   *
   *
   * **Returns:**
   * Созданный объект изма наряд-заказа
   */
  bimCreateWorkOrderChangeObject: ServiceDataResultOfBimWorkOrderChangeObjectData;
  /**
   * Создает прочую затрату справочника методик расчета из Изма
   *
   *
   * **Returns:**
   * Идентификатор прочей затраты справочника методик расчета
   */
  bimCreateWorkOrderChangeOtherFromCatalog: ServiceIdResultOfInt64;
  /**
   * Создает прочую затрату договора вручную из Изма
   *
   *
   * **Returns:**
   * Идентификатор прочей затраты договора, созданной вручную
   */
  bimCreateWorkOrderChangeOtherFromInput: ServiceIdResultOfInt64;
  /**
   * Создает подобъект изма наряд-заказа
   *
   *
   * **Returns:**
   * Созданный подобъект изма наряд-заказа
   */
  bimCreateWorkOrderChangeSubObject: ServiceDataResultOfBimWorkOrderChangeObjectData;
  /**
   * Создать объект НЗ
   *
   * **Returns:**
   * ИД созданного объекта НЗ
   */
  bimCreateWorkOrderObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Создает прочую затрату справочника методик расчета договора из НЗ
   *
   *
   * **Returns:**
   * Прочая затрата справочника методик расчета договора
   */
  bimCreateWorkOrderOtherFromCatalog: ServiceIdResultOfInt64;
  /**
   * Создает прочую затрату справочника методик расчета договора для акта КС-2
   *
   *
   * **Returns:**
   * Идентификатор прочей затраты справочника методик расчета договора
   */
  bimCreateWorkOrderOtherFromCatalogForAct: ServiceIdResultOfInt64;
  /**
   * Создает прочую затрату договора вручную из НЗ
   *
   *
   * **Returns:**
   * Прочая затрата договора, созданная вручную
   */
  bimCreateWorkOrderOtherFromInput: ServiceIdResultOfInt64;
  /**
   * Создает прочую затрату договора вручную для акта КС-2
   *
   *
   * **Returns:**
   * Идентификатор прочей затраты договора, созданной вручную
   */
  bimCreateWorkOrderOtherFromInputForAct: ServiceIdResultOfInt64;
  /**
   * Создать подобъект НЗ
   *
   * **Returns:**
   * ИД созданного подобъекта НЗ
   */
  bimCreateWorkOrderSubObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Удаляет объект/подобъект договора и его дочерние подобъекты
   *
   *
   * **Returns:**
   * Результат операции
   */
  bimDeleteContractObject: ServiceResult;
  /**
   * Удаляет прочую затрату договора
   *
   *
   * **Returns:**
   * Идентификатор удаленной прочей затраты
   */
  bimDeleteContractOtherCost: ServiceIdResultOfInt64;
  /**
   * Удаляет изм наряд-заказа
   *
   *
   * **Returns:**
   * Идентификатор удаленного изма наряд-заказа
   */
  bimDeleteWorkOrderChange: ServiceIdResultOfInt64;
  /**
   * Исключить все объекты из НЗ
   *
   * **Returns:**
   * ИД исключенных объектов
   */
  bimExcludeAllObjectsFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Исключить объект Договора из НЗ
   *
   * **Returns:**
   * ИД исключенных объектов
   */
  bimExcludeContractObjectFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Исключить объект Договора из изма НЗ
   *
   * **Returns:**
   * Идентификаторы исключенных объектов
   */
  bimExcludeContractObjectFromWorkOrderChange: ServiceDataResultOfInt64__;
  /**
   * Исключает прочую затрату из Изма
   *
   *
   * **Returns:**
   * Идентификатор прочей затраты Изма
   */
  bimExcludeWorkOrderChangeOther: ServiceIdResultOfInt64;
  /**
   * Исключить (удалить) сезон из наряд-заказа
   *
   * **Returns:**
   * Идентификатор удаленного сезона наряд-заказа
   */
  bimExcludeWorkOrderSeason: ServiceIdResultOfInt64;
  /**
   * Импортирует файл структуры объектов договора
   *
   *
   * **Returns:**
   * Договор с импортированной структурой объектов
   */
  bimImportContractObjects: ServiceDataResultOfBimContractData;
  /**
   * Включить все объекты в НЗ
   *
   * **Returns:**
   * ИД включенных объектов
   */
  bimIncludeAllObjectsToWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Включить объект Договора в НЗ
   *
   * **Returns:**
   * ИД включенных объектов
   */
  bimIncludeContractObjectToWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Включить объект Договора в изм НЗ
   *
   * **Returns:**
   * Идентификаторы включенных объектов
   */
  bimIncludeContractObjectToWorkOrderChange: ServiceDataResultOfInt64__;
  /**
   * Включить (добавить) сезон к наряд-заказу
   *
   * **Returns:**
   * Идентификатор добавленного сезона наряд-заказа
   */
  bimIncludeWorkOrderSeason: ServiceIdResultOfInt64;
  /**
   * Изменяет прочую затрату договора
   *
   *
   * **Returns:**
   * Прочая затрата договора
   */
  bimModifyContractOtherCost: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Переместить объект\подобъект по структуре
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimMoveContractObject: ServiceIdResultOfInt64;
  /**
   * Удаляет Акт КС-2 для прочих
   *
   *
   * **Returns:**
   * Идентификатор удаленного Акта КС-2 для прочих
   */
  bimRemoveActKC2Other: ServiceIdResultOfInt64;
  /**
   * Удаляет Акты КС-2
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных актов
   */
  bimRemoveActsKC2: ServiceDataResultOfInt64__;
  /**
   * Удаляет наряд-заказ из договора
   *
   *
   * **Returns:**
   * Идентификатор удаленного наряд-заказа
   */
  bimRemoveWorkOrder: ServiceIdResultOfInt64;
  /**
   * Удаляет существующую пользовательскую группу актов.
   *
   *
   * **Returns:**
   * Результат выполнения операции.
   */
  bimRemoveWorkOrderActsKC2Group: ServiceResult;
  /**
   * Удалить объект\подобъект изма наряд-заказа
   *
   * **Returns:**
   * Идентификаторы удаленных объектов
   */
  bimRemoveWorkOrderChangeObject: ServiceResult;
  /**
   * Удаляет прочие затраты из Изма
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных прочих затрат Изма
   */
  bimRemoveWorkOrderChangeOthers: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  /**
   * Удаляет сметы ЛСР из Изма к НЗ
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных смет
   */
  bimRemoveWorkOrderChangePrices: ServiceDataResultOfInt64__;
  /**
   * Удалить объект\подобъект НЗ
   *
   * **Returns:**
   * ИД удаленного объекта
   */
  bimRemoveWorkOrderObject: ServiceDataResultOfWorkOrderModifyItemIds;
  /**
   * Удалает прочую затрату для акта КС-2
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных прочих затрат НЗ
   */
  bimRemoveWorkOrderOtherForAct: ServiceDataResultOfWorkOrderModifyItemIds;
  /**
   * Удаляет прочие затраты из НЗ
   *
   *
   * **Returns:**
   * Идентификаторы удаленных прочих затрат
   */
  bimRemoveWorkOrderOthers: ServiceDataResultOfInt64__;
  /** Удаляет смет ЛСР из НЗ */
  bimRemoveWorkOrderPrices: ServiceDataResultOfBimWorkOrderTotalData;
  /**
   * Удаляет сметы на этапе приемки
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных смет
   */
  bimRemoveWorkOrderPricesToActKC2: ServiceDataResultOfWorkOrderModifyItemIds;
  /**
   * Сбрасывает всё в расчетные значения
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimResetActKC2AllCalculatedTotal: ServiceResult;
  /**
   * Сбрасывает позицию итогов в расчетное значение
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimResetActKC2CalculatedTotalItem: ServiceResult;
  /**
   * Устанавливает кастомное значение позиции итогов акта
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimSetActKC2InputValue: ServiceResult;
  /**
   * Устанавливает согласованную стоимость Акта КС-2 на прочие затраты
   *
   *
   * **Returns:**
   * Результат установки стоимости
   */
  bimSetActKC2OtherAcceptedCost: ServiceResult;
  /**
   * Ввести комментарий для фактической стоимости позиции прочей Акта КС-2
   *
   *
   * **Returns:**
   * Результат установки стоимости
   */
  bimSetActKC2OtherCostComment: ServiceResult;
  /**
   * Устанавливает плановую стоимость Акта КС-2 на прочие затраты
   *
   *
   * **Returns:**
   * Результат установки стоимости
   */
  bimSetActKC2OtherPlanCost: ServiceResult;
  /**
   * Изменяет Акт КС-2 для прочих
   *
   *
   * **Returns:**
   * Измененный Акт КС-2 для прочих
   */
  bimUpdateActKC2Other: ServiceDataResultOfBimActKc2OtherData;
  /** Обновить корректировку Акта КС-2 для прочих */
  bimUpdateActKC2OtherCorrection: ServiceDataResultOfBimActKc2OtherData;
  /**
   * Обновляет итоги Актов КС-2
   *
   *
   * **Returns:**
   * Список идентификаторов Актов КС-2, по которым обновлены итоги
   */
  bimUpdateActKC2Totals: ServiceDataResultOfInt64__;
  /**
   * Обновляет расчет договора
   *
   *
   * **Returns:**
   * Измененный расчета
   */
  bimUpdateCalculation: ServiceDataResultOfBimCalculationData;
  /**
   * Изменяет договор
   *
   *
   * **Returns:**
   * Измененный договор
   */
  bimUpdateContract: ServiceDataResultOfBimContractData;
  /**
   * Изменяет объект договора
   *
   *
   * **Returns:**
   * Измененный объект договора
   */
  bimUpdateContractObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Обновляет прочую затрату договора
   *
   *
   * **Returns:**
   * Прочая затрата договора
   */
  bimUpdateContractOtherCost: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Изменяет подобъект договора
   *
   *
   * **Returns:**
   * Измененный подобъект договора
   */
  bimUpdateContractSubObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Изменяет распределение прочей затраты в Изме
   *
   *
   * **Returns:**
   * Идентификатор измененной прочей затраты
   */
  bimUpdateWorkChangeOrderOtherDistribution: ServiceIdResultOfInt64;
  /**
   * Изменяет наряд-заказ
   *
   *
   * **Returns:**
   * Измененный наряд-заказ
   */
  bimUpdateWorkOrder: ServiceDataResultOfBimWorkOrderData;
  /**
   * Редактирует существующую пользовательскую группу актов.
   *
   *
   * **Returns:**
   * Результат выполнения операции.
   */
  bimUpdateWorkOrderActsKC2Group: ServiceResult;
  /**
   * Обновляет изм наряд-заказа
   *
   *
   * **Returns:**
   * Обновленный изм наряд-заказа
   */
  bimUpdateWorkOrderChange: ServiceDataResultOfBimWorkOrderChangeData;
  /**
   * Изменяет объект изма наряд-заказа
   *
   *
   * **Returns:**
   * Измененный объект изма наряд-заказа
   */
  bimUpdateWorkOrderChangeObject: ServiceDataResultOfBimWorkOrderChangeObjectData;
  /**
   * Обновляет прочую затрату Изма к НЗ
   *
   *
   * **Returns:**
   * Идентификатор обновленной прочей затраты Изма
   */
  bimUpdateWorkOrderChangeOther: ServiceIdResultOfInt64;
  /**
   * Обновляет обоснование сметы Изма к НЗ
   *
   *
   * **Returns:**
   * Идентификатор обновленной сметы
   */
  bimUpdateWorkOrderChangePriceRationale: ServiceIdResultOfInt64;
  /**
   * Обновляет последний сезон Изма НЗ
   *
   *
   * **Returns:**
   * Последний сезон Изма НЗ
   */
  bimUpdateWorkOrderChangeSeasons: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  /**
   * Изменяет подобъект изма наряд-заказа
   *
   *
   * **Returns:**
   * Измененный подобъект изма наряд-заказа
   */
  bimUpdateWorkOrderChangeSubObject: ServiceDataResultOfBimWorkOrderChangeObjectData;
  /**
   * Обновить объект НЗ
   *
   * **Returns:**
   * ИД обновленного объекта НЗ
   */
  bimUpdateWorkOrderObject: ServiceDataResultOfBimContractObjectData;
  /**
   * Обновить прочую затрату НЗ
   *
   *
   * **Returns:**
   * Обновленная прочая затрата НЗ
   */
  bimUpdateWorkOrderOther: ServiceDataResultOfBimWorkOrderOtherPriceData;
  /**
   * Перераспределяет прочие затраты (путем изменения лимита)
   *
   *
   * **Returns:**
   * Результат выполнения
   */
  bimUpdateWorkOrderOtherDistribution: ServiceIdResultOfInt64;
  /**
   * Изменяет распределение прочей затраты для акта КС-2
   *
   *
   * **Returns:**
   * Идентификатор прочей затраты НЗ
   */
  bimUpdateWorkOrderOtherDistributionForAct: ServiceIdResultOfInt64;
  /**
   * Изменить распределение прочей затраты на этапе приемки
   *
   *
   * **Returns:**
   * Идентификатор измененной прочей затраты наряд-заказа
   */
  bimUpdateWorkOrderOtherDistributionToActKC2: ServiceResult;
  /**
   * Обновляет прочую затрату для акта КС-2
   *
   *
   * **Returns:**
   * Идентификатор обновленной прочей затраты НЗ
   */
  bimUpdateWorkOrderOtherForAct: ServiceIdResultOfInt64;
  /**
   * Обновляет данные распределения МТР в смете
   *
   *
   * **Returns:**
   * Идентификатор обновленной сметы
   */
  bimUpdateWorkOrderPriceMTRDistribution: ServiceIdResultOfInt64;
  /**
   * Изменить сезоны наряд-заказа
   *
   * **Returns:**
   * Сезоны наряд-заказа
   */
  bimUpdateWorkOrderSeasons: ServiceDataResultOfBimWorkOrderSeasonsData;
  /**
   * Обновить подобъект НЗ
   *
   * **Returns:**
   * ИД обновленного подобъекта НЗ
   */
  bimUpdateWorkOrderSubObject: ServiceDataResultOfBimContractObjectData;
  /** Прототип метода загрузки смет с актами */
  bimUploadPriceActs: ServiceDataResultOfBimWorkOrderTotalData;
  /** Загружает файлы смет ЛСР в наряд-заказ */
  bimUploadPriceFiles: ServiceDataResultOfBimWorkOrderTotalData;
  /**
   * Загружает файлы смет ЛСР в Изм к НЗ
   *
   *
   * **Returns:**
   * Данные о загруженных сметах
   */
  bimUploadPriceFilesForWorkOrderChange: ServiceDataResultOfBimWorkOrderChangeTotalData;
  /**
   * Устанавливает способ расчета инфляции для Акта КС-2
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimUseActKC2InflationValue: ServiceResult;
  /**
   * Устанавливает значение сезона для акта прочих
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimUseActKC2OtherTotalInflation: ServiceResult;
  /**
   * Устанавливает значение сезона для акта
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimUseActKC2TotalInflation: ServiceResult;
  /**
   * Включает/исключает лимитированную в итогах Акта КС-2
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  bimUseActKC2TotalLimited: ServiceResult;
  /** Сформировать расчёт: полный пересчёт и сохранение среза предпросмотра (БИМ, 505). */
  bimcComputeCalculation: ServiceResult;
  /** Копировать расчёт НМЦ в другой проект. */
  bimcCopyCalculation: ServiceDataResultOfString;
  /** Сформировать укрупнённую смету из выбранных ЛСР гарантированного объёма. */
  bimcCreateAggregateEstimate: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  /** Создать расчёт НМЦ (БИМ). */
  bimcCreateCalculation: ServiceDataResultOfBimcCalculationData;
  /** Создать лимитированную затрату (БИМ). */
  bimcCreateCalculationLimitedCost: ServiceIdResultOfInt64;
  /** Создать объект структуры (БИМ). */
  bimcCreateCalculationObject: ServiceIdResultOfInt64;
  /** Создать прочую затрату (БИМ). */
  bimcCreateCalculationOtherCost: ServiceIdResultOfInt64;
  /** Создать подобъект структуры (БИМ). */
  bimcCreateCalculationSubObject: ServiceIdResultOfInt64;
  /** Загрузить структуру расчёта из файла .xlsx (полная замена) (БИМ). */
  bimcImportCalculationStructure: ServiceDataResultOfCountData;
  /** Загрузить файлы ЛСР для объекта структуры расчёта. */
  bimcLoadLocalEstimates: ServiceDataResultOfListOfLocalEstimateImportItemData;
  /** Переместить объект/подобъект структуры (БИМ). */
  bimcMoveCalculationObject: Scalars['Boolean'];
  /** Перераспределение МТР в ЛСР */
  bimcRedistributeLocalEstimateMtr: ServiceIdResultOfInt64;
  /** Удалить укрупнённую смету. */
  bimcRemoveAggregateEstimate: ServiceResult;
  /** Удалить лимитированные затраты (БИМ). */
  bimcRemoveCalculationLimitedCosts: ServiceResult;
  /** Удалить объект структуры (БИМ). */
  bimcRemoveCalculationObject: ServiceResult;
  /** Удалить прочие затраты (БИМ). */
  bimcRemoveCalculationOtherCosts: ServiceResult;
  /** Удаление обычных ЛСР (одиночное/массовое) из карточки НМЦ. */
  bimcRemoveLocalEstimates: ServiceResult;
  /** Установить признак гарантированного объёма (БИМ). */
  bimcSetCalculationObjectGuaranteedVolume: Scalars['Boolean'];
  /** Обновить укрупнённую смету (состав/коэффициент с пересчётом). */
  bimcUpdateAggregateEstimate: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  /** Обновить расчёт НМЦ (БИМ). */
  bimcUpdateCalculation: ServiceDataResultOfBimcCalculationData;
  /** Обновить лимитированную затрату (БИМ). */
  bimcUpdateCalculationLimitedCost: ServiceResult;
  /** Обновить объект структуры (БИМ). */
  bimcUpdateCalculationObject: ServiceResult;
  /** Обновить прочую затрату (БИМ). */
  bimcUpdateCalculationOtherCost: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  /** Сменить статус расчёта НМЦ (БИМ). */
  bimcUpdateCalculationStatus: ServiceResult;
  /** Редактирование ЛСР: установка признака учёта в % прочих/лимитированных затрат. */
  bimcUpdateLocalEstimate: ServiceResult;
  /** Обновить распределение итогов по сезонам для набора объектов/подобъектов (БИМ). */
  bimcUpdateSeasonDistribution: Scalars['Boolean'];
  catalogCreateConstructionType: ServiceDataResultOfConstructionTypeData;
  catalogCreateUerBaseCost: ServiceDataResultOfCatalogUerBaseCostData;
  catalogCreateWorkType: ServiceDataResultOfCatalogWorkTypeData;
  catalogImportUerBaseCostWorkTypes: ServiceResult;
  catalogRatioMassApply: ServiceResult;
  catalogRemoveConstructionType: ServiceIdResultOfInt32;
  catalogRemoveUerBaseCost: ServiceDataResultOfInt64__;
  catalogRemoveWorkType: ServiceIdResultOfInt32;
  catalogRemoveWorkTypes: ServiceDataResultOfInt32__;
  catalogUpdateConstructionType: ServiceDataResultOfConstructionTypeData;
  catalogUpdateUerBaseCost: ServiceDataResultOfCatalogUerBaseCostData;
  catalogUpdateWorkType: ServiceDataResultOfCatalogWorkTypeData;
  catalogUpsertArchiveUerBaseCostBasises: ServiceDataResultOfListOfCatalogUerBaseCostData;
  catalogUpsertMultiUerBaseCostBasises: ServiceDataResultOfListOfCatalogUerBaseCostData;
  copyProject: ServiceDataResultOfProjectData;
  createCatalog: ServiceDataResultOfCatalogData;
  createCatalogLimitedCostType: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  createCatalogOtherCostType: ServiceDataResultOfCatalogOtherCostTypeData;
  createCatalogOtherCostVariable: ServiceDataResultOfCatalogOtherCostVariableData;
  createCatalogOtherCostVariableGroup: ServiceDataResultOfCatalogOtherCostVariableGroupData;
  createCatalogRatio: ServiceDataResultOfCatalogRatioData;
  createCatalogUEROtherCostTemplate: ServiceIdResultOfInt32;
  createGlobalLimitedCost: ServiceDataResultOfGlobalLimitedCostData;
  createGlobalOtherCost: ServiceDataResultOfGlobalOtherCostData;
  createProject: ServiceDataResultOfProjectData;
  deleteProject: ServiceDataResultOfString;
  logNotAuthenticated: ServiceResult;
  logUserClient: ServiceResult;
  removeCatalogLimitedCostType: ServiceIdResultOfInt32;
  removeCatalogOtherCostType: ServiceIdResultOfInt32;
  removeCatalogOtherCostVariable: ServiceDataResultOfCatalogOtherCostVariableData;
  removeCatalogOtherCostVariableGroup: ServiceDataResultOfCatalogOtherCostVariableGroupData;
  removeCatalogRatio: ServiceIdResultOfInt64;
  removeCatalogUEROtherCostTemplates: ServiceResult;
  removeGlobalLimitedCost: ServiceIdResultOfInt64;
  removeGlobalOtherCost: ServiceIdResultOfInt64;
  setCatalogUERBaseCostProperties: ServiceResult;
  /**
   * Скопировать факт из столбца "Объем (План СКзС)" в столбец "Объем (План)" для всех расценок в Акте КС-2 СКзС
   *
   *
   * **Returns:**
   * ID Акта КС-2
   */
  uerActKC2CopyPlanVolumeSKzS: ServiceDataResultOfActKc2WorkVolumeData__;
  /**
   * Скопировать факт из столбца "Объем (План СКзС)" в столбец "Объем (План)" для указанной расценки в Акте КС-2 СКзС
   *
   *
   * **Returns:**
   * ID Акта КС-2
   */
  uerActKC2CopyPlanVolumeSKzSUER: ServiceDataResultOfActKc2WorkVolumeData;
  /**
   * Метод добавляет новый МТР
   *
   *
   * **Returns:**
   * Новый МТР
   */
  uerAddMtrRow: ServiceDataResultOfPriceListMtrRowData;
  /**
   * Метод добавления МТР к расценке в Акте КС-2
   *
   *
   * **Returns:**
   * Идентификаторы добавленных МТР
   */
  uerAddMtrToActKC2PriceList: ServiceDataResultOfInt64__;
  /** Добавляет МТР к Изму */
  uerAddMtrToWorkOrderChange: ServiceDataResultOfInt64__;
  /**
   * Метод добавляет МТР из прейскуранта в наряд-заказ
   *
   *
   * **Returns:**
   * Идентификаторы добавленных строк прайса наряд-заказа
   */
  uerAddMtrToWorkOrderFromPriceList: ServiceDataResultOfInt64__;
  /**
   * Метод добавления МТР в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список идентификаторов добавленных строк расценок ДС
   */
  uerAddMtrsToContractChange: ServiceDataResultOfInt64__;
  uerAddObjectToWorkOrderChange: ServiceIdResultOfInt64;
  /**
   * Добавить прочие затраты для Актов КС-2
   *
   *
   * **Returns:**
   * Массив идентификаторов прочих затрат договора, добавленных в наряд-заказ
   */
  uerAddOtherCostToActKC2: ServiceDataResultOfInt64__;
  /**
   * Метод добавления прочих затра в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список идентификаторов добавленных строк прочих затрат ДС
   */
  uerAddOthersToContractChange: ServiceDataResultOfInt64__;
  /**
   * Метод добавления коэффициентов при формировании Актов КС-2
   *
   *
   * **Returns:**
   * Идентификаторы добавленных коэффициентов
   */
  uerAddRatioToActKC2: ServiceDataResultOfInt64__;
  /** Добавляет коэффициент к Изму */
  uerAddRatioToWorkOrderChange: ServiceDataResultOfInt64__;
  /**
   * Метод добавляет коэффициенты из прейскуранта в наряд-заказ
   *
   *
   * **Returns:**
   * Идентификаторы добавленных строк прайса наряд-заказа
   */
  uerAddRatioToWorkOrderFromPriceList: ServiceDataResultOfInt64__;
  /**
   * Метод добавления Коэффициентов в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список идентификаторов добавленных строк расценок ДС
   */
  uerAddRatiosToContractChange: ServiceDataResultOfInt64__;
  /**
   * Метод добавления расценок при формировании Актов КС-2
   *
   *
   * **Returns:**
   * Идентификаторы добавленных МТР
   */
  uerAddUerToActKC2PriceList: ServiceDataResultOfInt64__;
  /**
   * Метод добавляет расценку в наряд-заказ
   *
   *
   * **Returns:**
   * Идентификатор добавленной строки прайса наряд-заказа
   * @deprecated Используйте метод AddUersToWorkOrderObjectsAsync
   */
  uerAddUerToWorkOrder: ServiceIdResultOfInt64;
  /** Добавляет расценку УЕР в Изм */
  uerAddUerToWorkOrderChange: ServiceDataResultOfInt64__;
  /**
   * Метод добавляет расценки из прейскуранта в наряд-заказ
   *
   *
   * **Returns:**
   * Идентификаторы добавленных строк прайса наряд-заказа
   * @deprecated Используйте метод AddUersToWorkOrderObjectsAsync
   */
  uerAddUerToWorkOrderFromPriceList: ServiceDataResultOfInt64__;
  /**
   * Метод добавления Расценок в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список идентификаторов добавленных строк расценок ДС
   */
  uerAddUersToContractChange: ServiceDataResultOfInt64__;
  /**
   * Добавить расценок к объектам Изма Наряд-Заказа
   *
   *
   * **Returns:**
   * Идентификаторы расценок Изма
   */
  uerAddUersToWorkOrderChangeObjects: ServiceDataResultOfInt64__;
  /**
   * Добавить расценки к объектам Наряд-Заказа
   *
   *
   * **Returns:**
   * Идентификаторы расценок Наряд-Заказа
   */
  uerAddUersToWorkOrderObjects: ServiceDataResultOfInt64__;
  /**
   * Добавить xml файлы ВОР в Изм к НЗ
   *
   *
   * **Returns:**
   * Измененный наряд-заказ
   */
  uerAddWorkOrderChangeFromXml: ServiceDataResultOfWorkOrderChangeData;
  /**
   * Добавить в Изм прочие затраты
   *
   *
   * **Returns:**
   * Идентификатор добавленных прочих затрат Изма
   */
  uerAddWorkOrderChangeOtherCost: ServiceDataResultOfInt64__;
  /**
   * Метод добавляет xml файлы ВОР в наряд-заказ
   *
   *
   * **Returns:**
   * Измененный наряд-заказ
   */
  uerAddWorkOrderFromXml: ServiceDataResultOfWorkOrderData;
  /**
   * Добавить в наряд-заказ прочие затраты
   * @deprecated Используйте метод UpdateWorkOrderOtherCostItemsAsync
   */
  uerAddWorkOrderOtherCost: ServiceDataResultOfWorkOrderOtherPriceData__;
  /**
   * Сопоставляет МТР НЗ и прейскуранта на этапе приемки
   *
   *
   * **Returns:**
   * Идентификатор позиции НЗ
   */
  uerApplyMtrToActKC2FromPriceList: ServiceIdResultOfInt64;
  /**
   * Применить МТР к позиции Изма
   *
   *
   * **Returns:**
   * Идентификатор обновленной позиции в Изме
   */
  uerApplyMtrToWorkOrderChangeFromPriceList: ServiceIdResultOfInt64;
  /**
   * Сопоставляет МТР НЗ и прейскуранта
   * Для записи НЗ типа МТР устанавливает МТР из прейскуранта
   *
   *
   * **Returns:**
   * Id записи позиции НЗ
   */
  uerApplyMtrToWorkOrderFromPriceList: ServiceIdResultOfInt64;
  /**
   * Метод создает новые связи "Коэффициент-расценка"
   *
   *
   * **Returns:**
   * Количество сохраненных элементов
   */
  uerApplyPriceListUerRatioRows: ServiceDataResultOfCountData;
  /**
   * Применяет коэффициенты расценок к списку объектов наряд-заказа.
   *
   *
   * **Returns:**
   * Возвращает true, если операция прошла успешно, иначе false.
   */
  uerApplyRatioToWorkOrderObjects: ServiceResult;
  /**
   * Применяет коэффициенты расценок к полученному списку id объектов нижнего уровня иерархии Изм к НЗ.
   *
   *
   * **Returns:**
   * Возвращает true, если операция прошла успешно, иначе false.
   */
  uerApplyWorkOrderChangePriceRatiosToObjects: ServiceResult;
  /**
   * Применяет коэффициенты расценок к корневому объекту наряд-заказа.
   *
   *
   * **Returns:**
   * Возвращает true, если операция прошла успешно, иначе false.
   */
  uerApplyWorkOrderChangePriceRatiosToRootObject: ServiceResult;
  uerApplyWorkOrderPriceRatiosToRootObject: ServiceResult;
  /** Изменить уровень справки КС-3 */
  uerChangeActKC3Level: ServiceResult;
  /**
   * Метод копирует Акт КС-2
   *
   *
   * **Returns:**
   * Созданную копию Акт КС-2
   */
  uerCopyActKC2: ServiceDataResultOfActKc2Data;
  /**
   * Метод создает Акт КС-2
   *
   *
   * **Returns:**
   * Созданный Акт КС-2
   */
  uerCreateActKC2: ServiceDataResultOfActKc2Data;
  /** Метод создает корректировку Акта КС-2 */
  uerCreateActKC2Correction: ServiceDataResultOfActKc2Data;
  /**
   * Метод создает Справку КС-3
   *
   *
   * **Returns:**
   * Созданная Справка КС-3
   */
  uerCreateActKC3: ServiceDataResultOfActKc3Data;
  /**
   * Создать закрывающий изм к наряд-заказу
   *
   *
   * **Returns:**
   * Модель данных реквизитов изма к НЗ
   */
  uerCreateClosingWorkOrderChange: ServiceDataResultOfWorkOrderChangeData;
  /** Импортирует контракт из Excel файла. */
  uerCreateContract: ServiceDataResultOfUerContractData;
  /**
   * Метод создает дополнительное соглашение
   *
   *
   * **Returns:**
   * Модель данных реквизитов доп. соглашения
   */
  uerCreateContractChange: ServiceDataResultOfContractChangeData;
  /** Создать прочую затрату договора в условия по договору */
  uerCreateContractConditionOtherCost: ServiceDataResultOfContractOtherCostData;
  /**
   * Создает новый объект контракта.
   *
   *
   * **Returns:**
   * Данные созданного объекта контракта или сообщение об ошибке.
   */
  uerCreateContractObject: ServiceDataResultOfContractObjectData;
  /** Создать прочую затрату договора вручную */
  uerCreateContractOtherCost: ServiceDataResultOfContractOtherCostData;
  /** Создать прочую затрату договора из справочника методик расчета */
  uerCreateContractOtherCostFromCatalog: ServiceDataResultOfContractOtherCostData;
  /**
   * Создает новый под-объект контракта.
   *
   *
   * **Returns:**
   * Данные созданного под-объекта контракта или сообщение об ошибке.
   */
  uerCreateContractSubObject: ServiceDataResultOfContractObjectData;
  /**
   * Добавляет коэффициент в прейскурант
   *
   *
   * **Returns:**
   * Добавленная строка коэффициента
   */
  uerCreateRatioRow: ServiceDataResultOfPriceListRatioGroupedRowData;
  /**
   * Создает новую расценку
   *
   *
   * **Returns:**
   * Добавленная расценка
   */
  uerCreateUerRow: ServiceDataResultOfPriceListUerRowData;
  /**
   * Создает пользовательскую группу актов
   *
   *
   * **Returns:**
   * Идентификатор новой группы
   */
  uerCreateWorkOrderActsKC2Group: ServiceIdResultOfInt64;
  /**
   * Метод создает изм к НЗ
   *
   *
   * **Returns:**
   * Модель данных реквизитов изма к НЗ
   */
  uerCreateWorkOrderChange: ServiceDataResultOfWorkOrderChangeData;
  /**
   * Создает объект Изма к НЗ
   *
   * **Returns:**
   * Идентификатор объекта
   */
  uerCreateWorkOrderChangeObject: ServiceIdResultOfInt64;
  /**
   * Создает подобъект Изма к НЗ
   *
   * **Returns:**
   * Идентификатор подобъекта
   */
  uerCreateWorkOrderChangeSubObject: ServiceIdResultOfInt64;
  /**
   * Создает объект Наряд-заказа
   *
   * **Returns:**
   * Созданный объект Наряд-заказа
   */
  uerCreateWorkOrderObject: ServiceDataResultOfWorkOrderObjectData;
  /**
   * Создает подобъект Наряд-заказа
   *
   * **Returns:**
   * Созданный подобъект Наряд-заказа
   */
  uerCreateWorkOrderSubObject: ServiceDataResultOfWorkOrderObjectData;
  /**
   * Метод создает версию наряд-заказа
   *
   *
   * **Returns:**
   * Созданная версия наряд-заказа
   */
  uerCreateWorkOrderVersion: ServiceDataResultOfWorkOrderVersionData;
  /**
   * Метод удаляет Акт КС-2
   *
   *
   * **Returns:**
   * Идентификатор удаленного Акта КС-2
   */
  uerDeleteActKC2: ServiceIdResultOfInt64;
  /**
   * Метод удаляет Справку КС-3
   *
   *
   * **Returns:**
   * Идентификатор удаленной Справки КС-3
   */
  uerDeleteActKC3: ServiceIdResultOfInt64;
  /**
   * Метод удаляет дополнительное соглашение
   *
   *
   * **Returns:**
   * Результат выполнения сервиса с идентификатором ДС
   */
  uerDeleteContractChange: ServiceIdResultOfInt64;
  /** Удалить прочую затрату договора */
  uerDeleteContractOtherCost: ServiceIdResultOfInt64;
  /**
   * Метод удаляет наряд-заказ
   *
   *
   * **Returns:**
   * Идентификатор удаленного наряд-заказа
   */
  uerDeleteWorkOrder: ServiceIdResultOfInt64;
  /**
   * Метод удаляет Изм к НЗ
   *
   *
   * **Returns:**
   * Идентификатор удаленного Изма к НЗ
   */
  uerDeleteWorkOrderChange: ServiceIdResultOfInt64;
  /**
   * Исключить объект договора из наряд-заказа
   *
   * **Returns:**
   * Идентификаторы исключенных объектов
   */
  uerExcludeContractObjectFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Исключает объект Договора в Изм к НЗ
   *
   *
   * **Returns:**
   * Идентификатор обновленной строки
   */
  uerExcludeContractObjectFromWorkOrderChange: ServiceDataResultOfInt64__;
  uerImportActKC2TemplateAsExcel: ServiceDataResultOfActKc2TemplateImport__;
  uerImportPriceListCollection: ServiceResult;
  /**
   * Метод импортирует сжатый файл ВОР rivx в наряд-заказ
   *
   *
   * **Returns:**
   * Импортированный наряд-заказ
   */
  uerImportWorkOrderFromRivx: ServiceDataResultOfWorkOrderData;
  /**
   * Метод импортирует xml файлы ВОР в наряд-заказ
   *
   *
   * **Returns:**
   * Импортированный наряд-заказ
   */
  uerImportWorkOrderFromXml: ServiceDataResultOfWorkOrderData;
  /**
   * Включить объект договора в наряд-заказ
   *
   * **Returns:**
   * Идентификаторы включенных объектов
   */
  uerIncludeContractObjectToWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Включает объект Договора в Изм к НЗ
   *
   *
   * **Returns:**
   * Идентификатор обновленной строки
   */
  uerIncludeContractObjectToWorkOrderChange: ServiceDataResultOfInt64__;
  /** Изменить прочую затрату договора в работе или на формировании НЗ и Измов */
  uerModifyContractOtherCost: ServiceDataResultOfContractOtherCostData;
  /**
   * Переместить объект\подобъект по структуре
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  uerMoveWorkOrderChangeObject: ServiceIdResultOfInt64;
  /** Переносит объемы для объектов Изма из одного сезона в другой */
  uerMoveWorkOrderChangeObjectReminders: ServiceDataResultOfWorkOrderChangePriceIds__;
  /** Переносит объемы для позиций Изма из одного сезона в другой */
  uerMoveWorkOrderChangeUerReminders: ServiceDataResultOfWorkOrderChangePriceIds__;
  /**
   * Возврат к расчётному: пересчёт лимитированных затрат акта КС-2 по формуле «сторона объекта × %ДТ».
   * Доступно только в статусах «В работе» и «На проверке»; в «Согласован» запрещено.
   */
  uerRecalculateActKC2LimitedCost: ServiceResult;
  /**
   * Возврат к расчётному: пересчёт плана по сезону лимитированных затрат «Изм. к НЗ»
   * по формуле «сторона объекта × %ДТ». Доступно только в статусе «На формировании».
   */
  uerRecalculateWorkOrderChangeLimitedCostPlan: ServiceResult;
  /**
   * Возврат к расчётному: пересчёт плана по сезону лимитированных затрат
   * по формуле «сторона объекта × %ДТ». Доступно только в статусе «На формировании».
   */
  uerRecalculateWorkOrderLimitedCostPlan: ServiceResult;
  /**
   * Возврат к расчётному: пересчёт плана по сезону лимитированных затрат версии наряд-заказа
   * по формуле «сторона объекта × %ДТ». Доступно только в статусе «На формировании».
   */
  uerRecalculateWorkOrderVersionLimitedCostPlan: ServiceResult;
  /**
   * Метод удаляет прочие актов КС-2 из Наряд-Заказа
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных прайсов прочих
   */
  uerRemoveActKC2OtherFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Метод удаляет строки прайса актов КС-2 из наряд-заказа
   *
   *
   * **Returns:**
   * Идентификаторы удаленных строк прайса наряд-заказа
   */
  uerRemoveActKC2PriceFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Метод производит групповое удаление Справок КС-3
   *
   *
   * **Returns:**
   * Идентификатор удаленных Справок КС-3
   */
  uerRemoveActsKC3: ServiceDataResultOfInt64__;
  /**
   * Удаляет объект контракта.
   *
   *
   * **Returns:**
   * Результат выполнения операции.
   */
  uerRemoveContractObject: ServiceResult;
  /**
   * Метод удаления МТР из дополнительного соглашения
   *
   *
   * **Returns:**
   * Список идентификаторов МТР удалённых из ДС
   */
  uerRemoveMtrsFromContractChange: ServiceDataResultOfInt64__;
  /** Метод удаления прочих затрат из ДС */
  uerRemoveOtherCostsFromContractChange: ServiceDataResultOfInt64__;
  /**
   * Метод удаляет прочие из Наряд-Заказа
   *
   *
   * **Returns:**
   * Список идентификаторов удаленных прайсов прочих
   * @deprecated Используйте метод RemoveWorkOrderPriceItemsAsync
   */
  uerRemoveOtherFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Метод удаляет строки прайса наряд-заказа
   *
   *
   * **Returns:**
   * Идентификаторы удаленных строк прайса наряд-заказа
   * @deprecated Используйте метод RemoveWorkOrderPriceItemsAsync
   */
  uerRemovePriceFromWorkOrder: ServiceDataResultOfInt64__;
  /**
   * Метод удаления Коэффициентов из дополнительного соглашения
   *
   *
   * **Returns:**
   * Список идентификаторов Коэффициентов удалённых из ДС
   */
  uerRemoveRatiosFromContractChange: ServiceDataResultOfInt64__;
  /**
   * Метод удаления Расценок из дополнительного соглашения
   *
   *
   * **Returns:**
   * Список идентификаторов Расценок удалённых из ДС
   */
  uerRemoveUersFromContractChange: ServiceDataResultOfInt64__;
  /**
   * Удалить неиспользуемые прочие затраты договора
   *
   *
   * **Returns:**
   * Идентификаторы удаленных прочих затрат договора
   */
  uerRemoveUnusedContractOtherCosts: ServiceDataResultOfInt64__;
  /**
   * Метод удаляет неиспользуемые строки МТР
   *
   *
   * **Returns:**
   * Кол-во удаленных строчек
   */
  uerRemoveUnusedMtrRows: ServiceDataResultOfCountData;
  /**
   * Метод удаляет неиспользуемые строки прейскуранта коэффициентов
   *
   *
   * **Returns:**
   * Кол-во удаленных строчек
   */
  uerRemoveUnusedRatioRows: ServiceDataResultOfCountData;
  /**
   * Метод удаляет неиспользуемые строки УЕР
   *
   *
   * **Returns:**
   * Кол-во удаленных строчек
   */
  uerRemoveUnusedUerRows: ServiceDataResultOfCountData;
  /**
   * Удаляет существующую пользовательскую группу актов
   *
   *
   * **Returns:**
   * Результат выполнения операции
   */
  uerRemoveWorkOrderActsKC2Group: ServiceResult;
  uerRemoveWorkOrderChangeObject: ServiceDataResultOfInt64__;
  /**
   * Удаляет объект \ подобъект Изма к НЗ
   *
   * **Returns:**
   * Результат
   */
  uerRemoveWorkOrderChangeObjectItem: ServiceResult;
  /**
   * Удалить прочие затраты из Изма
   *
   *
   * **Returns:**
   * Массив идентификаторов удаленных прочих затрат Изма
   */
  uerRemoveWorkOrderChangeOtherCost: ServiceDataResultOfInt64__;
  /**
   * Удаление позиций Изма НЗ
   *
   *
   * **Returns:**
   * Количество удаленных позиций
   */
  uerRemoveWorkOrderChangePriceItems: ServiceDataResultOfCountData;
  /**
   * Удаляет позиции из Изма
   * @deprecated Метод старого представления Изма
   */
  uerRemoveWorkOrderChangePrices: ServiceDataResultOfInt64__;
  /**
   * Удаляет объект\подобъект наряд-заказа
   *
   * **Returns:**
   * Результат операции
   */
  uerRemoveWorkOrderObject: ServiceResult;
  /**
   * Удаление позиций НЗ
   *
   *
   * **Returns:**
   * Количество удаленных позиций
   */
  uerRemoveWorkOrderPriceItems: ServiceDataResultOfCountData;
  uerRenameWorkOrderChangeObject: ServiceResult;
  /**
   * Метод заменяет наряд-заказ из сжатого файла ВОР rivx
   *
   *
   * **Returns:**
   * Измененный наряд-заказ
   */
  uerReplaceWorkOrderFromRivx: ServiceDataResultOfWorkOrderData;
  /**
   * Метод заменяет наряд-заказ из xml файлов ВОР
   *
   *
   * **Returns:**
   * Измененный наряд-заказ
   */
  uerReplaceWorkOrderFromXml: ServiceDataResultOfWorkOrderData;
  /**
   * Откатывает изменения согласованного Изма к НЗ
   *
   *
   * **Returns:**
   * Результат выполнения
   */
  uerRollbackWorkOrderChange: ServiceResult;
  /** Устанавливает или обновляет объем по сезону для позиции Изма */
  uerSaveOrUpdateWorkOrderChangeSeasonVolume: ServiceDataResultOfInt64__;
  /**
   * Метод устанавливает объем (согласовано) для Акта КС-2
   *
   *
   * **Returns:**
   * Идентификаторы измененных позиций НЗ
   */
  uerSetActKC2AcceptedCost: ServiceDataResultOfInt64__;
  /**
   * Метод устанавливает объем (согласовано) для Акта КС-2
   *
   *
   * **Returns:**
   * Новый объем работ
   */
  uerSetActKC2AcceptedVolume: ServiceDataResultOfInt64__;
  /** Установить формулу для расчёта позиции Акта КС-2 */
  uerSetActKC2Formula: ServiceDataResultOfInt64__;
  /** Метод устанавливает стоимость прочих (согласовано) для Акта КС-2 */
  uerSetActKC2OtherCostAcceptedCost: ServiceDataResultOfInt64__;
  /**
   * Задать комментарий к прочей затрате в Акте КС-2
   *
   *
   * **Returns:**
   * Обновлённые данные по комментарию
   */
  uerSetActKC2OtherCostComment: ServiceDataResultOfActKc2CommentData;
  /** Метод устанавливает стоимость прочих (план) для Акта КС-2 */
  uerSetActKC2OtherCostPlanCost: ServiceDataResultOfInt64__;
  /**
   * Метод устанавливает стоимость (план) для Акта КС-2
   *
   *
   * **Returns:**
   * Идентификаторы измененных позиций НЗ
   */
  uerSetActKC2PlanCost: ServiceDataResultOfInt64__;
  /**
   * Метод устанавливает объем (план) для Акта КС-2
   *
   *
   * **Returns:**
   * Новый объем работ
   */
  uerSetActKC2PlanVolume: ServiceDataResultOfInt64__;
  /**
   * Задать комментарий к расценке в Акте КС-2
   *
   *
   * **Returns:**
   * Обновлённые данные по комментарию
   */
  uerSetActKC2WorkVolumeComment: ServiceDataResultOfActKc2CommentData;
  /** Устанавливает сезоны для договора */
  uerSetContractSeasons: ServiceResult;
  /**
   * Устанавливает конечный сезон Изма к НЗ
   *
   * **Returns:**
   * Идентификатор сезона Договора
   */
  uerSetWorkOrderChangeLastSeason: ServiceIdResultOfInt64;
  /** Установить значение коэффициента перехода работы для расценки Изма */
  uerSetWorkOrderChangeWorkRatio: ServiceIdResultOfInt64;
  /** Установить значение коэффициента перехода работы для расценки */
  uerSetWorkOrderWorkRatio: ServiceResult;
  /** Обновить журналы КС6а из СКзС */
  uerSkzsUpdateKC6a: ServiceResult;
  /** Загрузить журналы КС6а из СКзС */
  uerSkzsUploadKC6a: ServiceDataResultOfSkzsActKc2Data__;
  /**
   * Метод изменяет Акт КС-2
   *
   *
   * **Returns:**
   * Измененный Акт КС-2
   */
  uerUpdateActKC2: ServiceDataResultOfActKc2Data;
  /** Метод обновляет корректировку Акта КС-2 */
  uerUpdateActKC2Correction: ServiceDataResultOfActKc2Data;
  /**
   * Ручная правка значения %ДТ лимитированной затраты акта КС-2.
   * Доступно только в статусах «В работе» и «На проверке».
   */
  uerUpdateActKC2LimitedCost: ServiceResult;
  /**
   * Ручная правка стоимости по сезону лимитированной затраты акта КС-2.
   * Доступно только в статусах «В работе» и «На проверке».
   */
  uerUpdateActKC2LimitedCostSeasonCost: ServiceResult;
  /**
   * Метод обновляет Справку КС-3
   *
   *
   * **Returns:**
   * Измененная Справка КС-3
   */
  uerUpdateActKC3: ServiceDataResultOfActKc3Data;
  /**
   * Метод изменяет договор по переданным данным
   *
   *
   * **Returns:**
   * Измененный договор
   */
  uerUpdateContract: ServiceDataResultOfUerContractData;
  /**
   * Метод обновления реквизитов дополнительного соглашения
   *
   *
   * **Returns:**
   * Модель данных реквизитов доп. соглашения
   */
  uerUpdateContractChange: ServiceDataResultOfContractChangeData;
  /** Обновить прочую затрату договора в условия по договору */
  uerUpdateContractConditionOtherCost: ServiceDataResultOfContractOtherCostData;
  /**
   * Обновляет существующий объект контракта.
   *
   *
   * **Returns:**
   * Данные обновленного объекта контракта или сообщение об ошибке.
   */
  uerUpdateContractObject: ServiceDataResultOfContractObjectData;
  /** Обновить прочую затрату договора */
  uerUpdateContractOtherCost: ServiceDataResultOfContractOtherCostData;
  /** Обновить прочую затрату договора из справочника методик расчета */
  uerUpdateContractOtherCostFromCatalog: ServiceDataResultOfContractOtherCostData;
  /**
   * Обновляет прочую затрату договора в Изме
   *
   *
   * **Returns:**
   * Идентификатор обновленной прочей затраты Изма
   * @deprecated Редактирование доступно только на странице 'Лимиты по прочим затратам договора'
   */
  uerUpdateContractOtherCostToWorkOrderChangeFromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновляет прочую затрату договора
   *
   *
   * **Returns:**
   * Идентификатор обновленной прочей затраты НЗ
   * @deprecated Редактирование доступно только на странице 'Лимиты по прочим затратам договора'
   */
  uerUpdateContractOtherCostToWorkOrderFromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновляет существующий под-объект контракта.
   *
   *
   * **Returns:**
   * Данные обновленного под-объекта контракта или сообщение об ошибке.
   */
  uerUpdateContractSubObject: ServiceDataResultOfContractObjectData;
  /**
   * Метод изменяет МТР
   *
   *
   * **Returns:**
   * Измененный МТР
   */
  uerUpdateMtrRow: ServiceDataResultOfPriceListMtrRowData;
  /**
   * Обновляет МТР в прейскуранте на этапе приемки
   *
   *
   * **Returns:**
   * Идентификатор позиции НЗ
   */
  uerUpdateMtrToActKC2FromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновить МТР в Изме
   *
   *
   * **Returns:**
   * Идентификатор обновленной позиции в Изме
   */
  uerUpdateMtrToWorkOrderChangeFromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновляет МТР в прейскуранте
   *
   *
   * **Returns:**
   * Id записи позиции НЗ
   */
  uerUpdateMtrToWorkOrderFromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновляет обоснование добавления прочей в Изм к НЗ
   *
   *
   * **Returns:**
   * Идентификатор обновленной строки
   */
  uerUpdateOrderChangeOtherPriceRationale: ServiceIdResultOfInt64;
  /**
   * Обновляет обоснование добавления расценки/МТР/коэффициента в Изм к НЗ
   *
   *
   * **Returns:**
   * Идентификатор обновленной строки
   */
  uerUpdateOrderChangePriceRationale: ServiceIdResultOfInt64;
  /**
   * Обновить прочую затрату Акта КС-2
   *
   *
   * **Returns:**
   * Данные прочей затраты
   * @deprecated Редактирование доступно только на странице 'Лимиты по прочим затратам договора'
   */
  uerUpdateOtherCostToActKC2: ServiceDataResultOfContractOtherCostData;
  /**
   * Обновляет коэффициент в прейскуранте
   *
   *
   * **Returns:**
   * Обновленная строка коэффициента
   */
  uerUpdateRatioRow: ServiceDataResultOfPriceListRatioGroupedRowData;
  /**
   * Метод обновляет коэффициент на этапе приемки
   *
   *
   * **Returns:**
   * Идентификатор позиции НЗ
   */
  uerUpdateRatioToActKC2FromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновить коэффициент в Изме
   *
   *
   * **Returns:**
   * Идентификатор обновленной позиции в Изме
   */
  uerUpdateRatioToWorkOrderChangeFromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновляет коэффициент в прейскуранте
   *
   *
   * **Returns:**
   * Идентификатор записи позиции НЗ
   */
  uerUpdateRatioToWorkOrderFromPriceList: ServiceIdResultOfInt64;
  /**
   * Метод изменяет объем сезона строки прайса наряд-заказа
   *
   *
   * **Returns:**
   * Идентификаторы измененных строк прайса наряд-заказа
   */
  uerUpdateSeasonVolume: ServiceDataResultOfInt64__;
  /**
   * Обновляет расценку УЕР.
   * Подробнее: CancellationToken)
   *
   *
   * **Returns:**
   * Обновленную расценку УЕР.
   */
  uerUpdateUerRow: ServiceDataResultOfPriceListUerRowData;
  /**
   * Метод обновляет расценку на этапе приемки
   *
   *
   * **Returns:**
   * Идентификатор позиции наряд-заказа
   */
  uerUpdateUerToActKC2FromPriceList: ServiceIdResultOfInt64;
  /**
   * Обновить УЕР в Изме
   *
   *
   * **Returns:**
   * Идентификатор обновленной позиции в Изме
   */
  uerUpdateUerToWorkOrderChangeFromPriceList: ServiceIdResultOfInt64;
  /**
   * Метод обновляет расценку в прейскуранте и ее свойства в позиции наряд-заказе
   *
   *
   * **Returns:**
   * идентификатор позиции наряд-заказа
   */
  uerUpdateUerToWorkOrderFromPriceList: ServiceIdResultOfInt64;
  /**
   * Метод изменяет наряд-заказ
   *
   *
   * **Returns:**
   * Измененный наряд-заказ
   */
  uerUpdateWorkOrder: ServiceDataResultOfWorkOrderData;
  /**
   * Метод обновляет сезоны для начисления инфляции по позициям МТР
   *
   *
   * **Returns:**
   * Результат выполнения операции
   */
  uerUpdateWorkOrderActKC2MTRForInflationDistribution: ServiceResult;
  /**
   * Редактирует существующую пользовательскую группу актов.
   *
   *
   * **Returns:**
   * Результат выполнения операции
   */
  uerUpdateWorkOrderActsKC2Group: ServiceResult;
  /**
   * Метод обновляет изм к НЗ
   *
   *
   * **Returns:**
   * Модель данных реквизитов изма к НЗ
   */
  uerUpdateWorkOrderChange: ServiceDataResultOfWorkOrderChangeData;
  /**
   * Ручная правка плана по сезону лимитированной затраты «Изм. к НЗ».
   * Доступно только в статусе «На формировании».
   */
  uerUpdateWorkOrderChangeLimitedCostSeasonCost: ServiceResult;
  /**
   * Обновляет объект Изма к НЗ
   *
   * **Returns:**
   * Идентификатор объекта
   */
  uerUpdateWorkOrderChangeObject: ServiceIdResultOfInt64;
  /**
   * Обновляет прочие затраты Изма по виду строительства
   *
   *
   * **Returns:**
   * Идентификаторы прочих затрат договора, добавленных в Изм
   */
  uerUpdateWorkOrderChangeOtherCostItems: ServiceDataResultOfInt64__;
  /**
   * Изменить распределение прочей затраты в Изме
   *
   *
   * **Returns:**
   * Идентификатор обновленных прочих затрат Изма
   */
  uerUpdateWorkOrderChangeOtherDistribution: ServiceDataResultOfInt64__;
  /**
   * Обновляет подобъект Изма к НЗ
   *
   * **Returns:**
   * Идентификатор подобъекта
   */
  uerUpdateWorkOrderChangeSubObject: ServiceIdResultOfInt64;
  /**
   * Ручная правка плана по сезону лимитированной затраты наряд-заказа.
   * Доступно только в статусе «На формировании».
   */
  uerUpdateWorkOrderLimitedCostSeasonCost: ServiceResult;
  /**
   * Изменяет объект наряд-заказа
   *
   * **Returns:**
   * Измененный объект наряд-заказа
   */
  uerUpdateWorkOrderObject: ServiceDataResultOfWorkOrderObjectData;
  /**
   * Обновляет прочие затраты НЗ по виду строительства
   *
   *
   * **Returns:**
   * Массив идентификаторов прочих затрат договора, добавленных в наряд-заказ
   */
  uerUpdateWorkOrderOtherCostItems: ServiceDataResultOfInt64__;
  /**
   * Изменить распределение прочей затраты наряд-заказа
   *
   *
   * **Returns:**
   * Идентификатор измененной прочей затраты наряд-заказа
   */
  uerUpdateWorkOrderOtherDistribution: ServiceResult;
  /**
   * Изменить распределение прочей затраты на этапе приемки
   *
   *
   * **Returns:**
   * Идентификатор измененной прочей затраты наряд-заказа
   */
  uerUpdateWorkOrderOtherDistributionToActKC2: ServiceResult;
  /**
   * Обновляет обоснование добавления прочей в Акт КС-2
   *
   *
   * **Returns:**
   * Идентификатор обновленной строки
   */
  uerUpdateWorkOrderOtherPriceRationale: ServiceIdResultOfInt64;
  /**
   * Обновляет обоснование добавления расценки/МТР/коэффициента в Акт КС-2
   *
   *
   * **Returns:**
   * Идентификатор обновленной строки
   */
  uerUpdateWorkOrderPriceRationale: ServiceIdResultOfInt64;
  uerUpdateWorkOrderSeasons: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  /**
   * Изменяет подобъект наряд-заказа
   *
   * **Returns:**
   * Измененный подобъект наряд-заказа
   */
  uerUpdateWorkOrderSubObject: ServiceDataResultOfWorkOrderObjectData;
  /**
   * Ручная правка плана по сезону лимитированной затраты версии наряд-заказа.
   * Доступно только в статусе «На формировании».
   */
  uerUpdateWorkOrderVersionLimitedCostSeasonCost: ServiceResult;
  /**
   * Добавляет переданные расценки в ВОР
   *
   *
   * **Returns:**
   * Результат операции включая ошибки валидации
   */
  uercAddCostsToWor: ServiceResult;
  /** Добавление коэффициентов к расценке в ВОР */
  uercAddMtrsToWorkVolumeFromCollectionMTR: ServiceResult;
  /** Массовое добавление коэффициентов к расценкам в ВОР */
  uercAddRatiosMassToWorkVolumeFromCollectionRatio: ServiceResult;
  /** Добавление коэффициентов к расценке в ВОР */
  uercAddRatiosToWorkVolumeFromCollectionRatio: ServiceResult;
  /**
   * Добавить выбранные расценки из справочника в сборник расценок Расчёта НМЦ
   *
   * **Returns:**
   * Идентификаторы добавленных расценок
   */
  uercAddUersToCollectionUERBaseCost: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  /** Изменение объемов в сезоне для выбранных объектов/подобъектов */
  uercChangeSeasonWorkVolume: ServiceResult;
  /**
   * Пересчитать итоги расчета НМЦ
   *
   *
   * **Returns:**
   * Результат операции
   */
  uercComputeCalculation: ServiceResult;
  /**
   * Метод копирует сущности расчета НМЦ в новый проект
   *
   *
   * **Returns:**
   * Уникальный идентификатор скопированного расчета НМЦ
   */
  uercCopyCalculation: ServiceDataResultOfString;
  /**
   * Копирует объект Расчета НМЦ
   *
   *
   * **Returns:**
   * Идентификатор нового объекта
   */
  uercCopyCalculationObject: ServiceIdResultOfInt64;
  /**
   * Метод создает новый коэффициент в сборнике.
   *
   *
   * **Returns:**
   * Данные созданного коэффициента.
   */
  uercCopyCatalogRatiosToCollection: ServiceResult;
  /** Скопировать набор расценок из справочника */
  uercCopyCollectionUERBaseCostsFromCatalog: ServiceResult;
  /**
   * Создать расчёт НМЦ
   *
   *
   * **Returns:**
   * Данные созданного расчета
   */
  uercCreateCalculation: ServiceDataResultOfUercCalculationData;
  /**
   * Создание нового объекта лимитированной затраты
   *
   *
   * **Returns:**
   * Результат операции, содержащий идентификатор созданного объекта
   */
  uercCreateCalculationLimitedCost: ServiceIdResultOfInt64;
  /**
   * Создает новый объект Расчета НМЦ
   *
   *
   * **Returns:**
   * Идентификатор объекта
   */
  uercCreateCalculationObject: ServiceIdResultOfInt64;
  /**
   * Создание нового объекта прочей затраты
   *
   *
   * **Returns:**
   * Результат операции, содержащий идентификатор созданного объекта
   */
  uercCreateCalculationOtherCost: ServiceIdResultOfInt64;
  /**
   * Создает новый подобъект Расчета НМЦ
   *
   *
   * **Returns:**
   * Идентификатор подобъекта
   */
  uercCreateCalculationSubObject: ServiceIdResultOfInt64;
  /**
   * Создать позицию МТР
   *
   *
   * **Returns:**
   * Данные обновленной позиции
   */
  uercCreateCollectionMtr: ServiceDataResultOfUpdateResponseCollectionMtrData;
  /** Создание МТРов к расценке в ВОР */
  uercCreateCollectionMtrToWorkVolume: ServiceDataResultOfUpdateResponseCollectionMtrData;
  /**
   * Метод создает новый коэффициент в сборнике.
   *
   *
   * **Returns:**
   * Данные созданного коэффициента.
   */
  uercCreateCollectionRatio: ServiceDataResultOfCollectionRatioDataWithCosts;
  /** Создание коэффициента к расценкам в ВОР */
  uercCreateCollectionRatioMassToWorkVolume: ServiceDataResultOfCollectionRatioData;
  /** Создание коэффициента к расценке в ВОР */
  uercCreateCollectionRatioToWorkVolume: ServiceDataResultOfCollectionRatioData;
  /**
   * Импортирует структуру объектов Расчета НМЦ
   *
   *
   * **Returns:**
   * Структура Расчета
   */
  uercImportCalculationObjects: ServiceDataResultOfCountData;
  /**
   * Импортирует структуру объектов Расчета НМЦ
   *
   *
   * **Returns:**
   * Структура Расчета
   */
  uercImportCollectionMtr: ServiceResult;
  /**
   * Выполнить импорт связей «Расценка — вид работ» из xlsx-файла в сборник
   *
   * **Returns:**
   * Результат импорта
   */
  uercImportCollectionUerBaseCostWorkTypes: ServiceResult;
  /**
   * Выполнить импорт файлов сметы основания
   *
   * **Returns:**
   * Идентификаторы новых расценок
   */
  uercImportEstimateBasisFiles: ServiceDataResultOfInt64__;
  /**
   * Импортирует файл ВОР Excel
   *
   *
   * **Returns:**
   * Структура Расчета
   */
  uercImportExcelWor: ServiceDataResultOfWorkVolumeImportResult;
  /**
   * Выполнить импорт расценок из XML файлов в сборник
   *
   * **Returns:**
   * Идентификаторы новых расценок
   */
  uercImportUerBaseCostCollection: ServiceDataResultOfInt64__;
  /**
   * Импортирует файлы ВОР XML
   *
   *
   * **Returns:**
   * Результат операции включая ошибки валидации
   */
  uercImportWorkVolumeXml: ServiceDataResultOfWorkVolumeImportResult;
  /**
   * Перемещает подобъект по структуре в рамках объекта
   *
   *
   * **Returns:**
   * Идентификатор подобъекта
   */
  uercMoveCalculationObject: ServiceIdResultOfInt64;
  /** Удалить все расценки из расчёта НМЦ */
  uercRemoveAllCollectionUERBaseCostRows: ServiceDataResultOfInt64__;
  /** Удаление лимитированных затрат */
  uercRemoveCalculationLimitedCosts: ServiceResult;
  /**
   * Удаляет объект\подобъект Расчета НМЦ
   *
   *
   * **Returns:**
   * Идентификатор подобъекта
   */
  uercRemoveCalculationObject: ServiceResult;
  /** Удаление прочих затрат */
  uercRemoveCalculationOtherCosts: ServiceResult;
  /** Удалить позицию МТР */
  uercRemoveCollectionMtr: ServiceResult;
  /**
   * Метод удаляет коэффициент из сборника.
   *
   *
   * **Returns:**
   * Идентификатор удаленного коэффициента.
   */
  uercRemoveCollectionRatio: ServiceIdResultOfInt64;
  /** Удалить выбранные расценки из расчёта НМЦ */
  uercRemoveCollectionUERBaseCostRows: ServiceDataResultOfInt64__;
  /**
   * Удаляет переданные Расценки, Коэффициенты, МТР из ВОР
   *
   *
   * **Returns:**
   * Результат операции включая ошибки валидации
   */
  uercRemoveFromWor: ServiceResult;
  /** Удалить позиции МТР */
  uercRemoveUnusedCollectionMtr: ServiceResult;
  /** Удаление неиспользуемых МТР в ВОР */
  uercRemoveUnusedCollectionMtrToWorkVolume: ServiceResult;
  /**
   * Переносит расценку УЕР листового объекта на форме предпросмотра расчета НМЦ.
   *
   *
   * **Returns:**
   * Результат операции
   */
  uercReorderCalculationComputedUer: ServiceResult;
  /** Метод замены выбранных позиций на одну (новую или текущую из Ведомости МТР) */
  uercReplaceCollectionMtrItem: ServiceDataResultOfReplaceCollectionMtrItemData;
  /**
   * Устанавливает признак гарантированного объема объекта\подобъекта Расчета НМЦ
   *
   *
   * **Returns:**
   * Идентификаторы обновленных объектов\подобъектов
   */
  uercSetCalculationObjectGuaranteedVolume: ServiceDataResultOfInt64__;
  /** Выполнить массовую обновление свойств расценок */
  uercSetCollectionUERBaseCostRowProperties: ServiceDataResultOfInt64__;
  /** Записывает значение объёма или формулу в ячейку ВОР */
  uercSetWorkVolumeValue: ServiceDataResultOfWorkVolumeValueData__;
  /** Перенос объемов между сезонами для выбранных объектов/подобъектов */
  uercTransferWorkVolume: ServiceResult;
  /**
   * Метод изменяет расчет НМЦ по переданным данным
   *
   *
   * **Returns:**
   * Данные измененного расчета
   */
  uercUpdateCalculation: ServiceDataResultOfUercCalculationData;
  /**
   * Обновление данных лимитированной затраты расчета НМЦ
   *
   *
   * **Returns:**
   * Результат операции, содержащий обновленное состояние объекта
   */
  uercUpdateCalculationLimitedCost: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  /**
   * Обновляет объект Расчета НМЦ
   *
   *
   * **Returns:**
   * Данные объекта
   */
  uercUpdateCalculationObject: ServiceDataResultOfCalculationObjectData;
  /**
   * Обновление данных прочей затраты расчета НМЦ
   *
   *
   * **Returns:**
   * Результат операции, содержащий обновленное состояние объекта
   */
  uercUpdateCalculationOtherCost: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  /**
   * Метод изменяет статус расчета НМЦ
   *
   *
   * **Returns:**
   * Данные измененного расчета
   */
  uercUpdateCalculationStatus: ServiceResult;
  /**
   * Обновляет подобъект Расчета НМЦ
   *
   *
   * **Returns:**
   * Данные подобъекта
   */
  uercUpdateCalculationSubObject: ServiceDataResultOfCalculationObjectData;
  /**
   * Обновить позицию МТР
   *
   *
   * **Returns:**
   * Данные обновленной позиции
   */
  uercUpdateCollectionMtr: ServiceDataResultOfUpdateResponseCollectionMtrData;
  /** Обновление МТРов у расценки в ВОР */
  uercUpdateCollectionMtrToWorkVolume: ServiceDataResultOfUpdateResponseCollectionMtrData;
  /**
   * Обновить позицию МТР
   *
   *
   * **Returns:**
   * Данные обновленной позиции
   */
  uercUpdateCollectionMtrUnitCurrentPrice: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  /**
   * Метод обновляет коэффициент в сборнике.
   *
   *
   * **Returns:**
   * Данные обновленного коэффициента.
   */
  uercUpdateCollectionRatio: ServiceDataResultOfCollectionRatioDataWithCosts;
  /** Обновить расценку из сборника, в расчёте НМЦ */
  uercUpdateCollectionUERBaseCost: ServiceDataResultOfCollectionUerBaseCostData;
  /** Обновить состав работ в расценке */
  uercUpdateCollectionUERBaseCostWorkScopes: ServiceResult;
  /**
   * Обновить коэффициент перехода секции "Вид работ" для рассчитанной строки затрат расчета НМЦ.
   *
   *
   * **Returns:**
   * Результат операции
   */
  uercUpdateComputedCostWorkRatio: ServiceDataResultOfCalculationComputeRow;
  /**
   * Обновить позицию МТР
   *
   *
   * **Returns:**
   * Данные обновленной позиции
   */
  uercUpdateIsIncludedInTransportCalculation: ServiceDataResultOfUpdateResponseCollectionMtrData;
  updateCatalogLimitedCostType: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  updateCatalogOtherCostType: ServiceDataResultOfCatalogOtherCostTypeData;
  updateCatalogOtherCostVariable: ServiceDataResultOfCatalogOtherCostVariableData;
  updateCatalogOtherCostVariableGroup: ServiceDataResultOfCatalogOtherCostVariableGroupData;
  updateCatalogRatio: ServiceDataResultOfCatalogRatioData;
  updateCatalogUERBaseCostWorkScopes: ServiceResult;
  updateCatalogUEROtherCostTemplate: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  updateGlobalLimitedCost: ServiceDataResultOfGlobalLimitedCostData;
  updateGlobalOtherCost: ServiceDataResultOfGlobalOtherCostData;
  updateProject: ServiceDataResultOfProjectData;
};


export type MutationBimAddWorkOrderChangeOthersArgs = {
  input: BimWorkOrderChangeOtherInput;
};


export type MutationBimAddWorkOrderOtherForActArgs = {
  contractOtherCostIds: Array<Scalars['Long']>;
  workOrderObjectId: Scalars['Long'];
};


export type MutationBimAddWorkOrderOthersArgs = {
  contractType: ProjectContractTypeEnum;
  input: BimWorkOrderOtherInput;
};


export type MutationBimCompleteStructureFormationArgs = {
  workOrderId: Scalars['Long'];
};


export type MutationBimCopyContractArgs = {
  contractUniqueId: Scalars['String'];
  projectUniqueId: Scalars['String'];
};


export type MutationBimCreateActKc2OtherArgs = {
  input: BimActKc2OtherCreateInput;
};


export type MutationBimCreateActKc2OtherCorrectionArgs = {
  input: BimActKc2OtherCorrectionCreateInput;
};


export type MutationBimCreateContractArgs = {
  contractInput: BimContractCreateInput;
};


export type MutationBimCreateContractConditionOtherCostArgs = {
  input: BimContractConditionOtherCostInput;
};


export type MutationBimCreateContractObjectArgs = {
  input: BimContractObjectCreateInput;
};


export type MutationBimCreateContractOtherCostArgs = {
  input: BimContractOtherCostInput;
};


export type MutationBimCreateContractOtherCostFromCatalogArgs = {
  input: BimContractOtherCostFromCatalogInput;
};


export type MutationBimCreateContractSubObjectArgs = {
  input: BimContractSubObjectCreateInput;
};


export type MutationBimCreateWorkOrderArgs = {
  contractId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderActsKc2GroupArgs = {
  input: BimActKc2GroupInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderChangeArgs = {
  input: BimWorkOrderChangeCreateInput;
};


export type MutationBimCreateWorkOrderChangeObjectArgs = {
  input: BimContractObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderChangeOtherFromCatalogArgs = {
  input: BimContractOtherCostFromCatalogInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderChangeOtherFromInputArgs = {
  input: BimContractOtherCostInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderChangeSubObjectArgs = {
  input: BimContractSubObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderObjectArgs = {
  input: BimContractObjectCreateInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderOtherFromCatalogArgs = {
  input: BimContractOtherCostFromCatalogInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderOtherFromCatalogForActArgs = {
  input: BimContractOtherCostFromCatalogInput;
  workOrderObjectId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderOtherFromInputArgs = {
  input: BimContractOtherCostInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderOtherFromInputForActArgs = {
  input: BimContractOtherCostInput;
  workOrderObjectId: Scalars['Long'];
};


export type MutationBimCreateWorkOrderSubObjectArgs = {
  input: BimContractSubObjectCreateInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimDeleteContractObjectArgs = {
  contractObjectId: Scalars['Long'];
};


export type MutationBimDeleteContractOtherCostArgs = {
  contractOtherCostId: Scalars['Long'];
};


export type MutationBimDeleteWorkOrderChangeArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimExcludeAllObjectsFromWorkOrderArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
};


export type MutationBimExcludeContractObjectFromWorkOrderArgs = {
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationBimExcludeContractObjectFromWorkOrderChangeArgs = {
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimExcludeWorkOrderChangeOtherArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId: BimWorkOrderChangeOtherPriceIdsInput;
};


export type MutationBimExcludeWorkOrderSeasonArgs = {
  contractSeasonId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationBimImportContractObjectsArgs = {
  contractId: Scalars['Long'];
  fileContent: FileInput;
};


export type MutationBimIncludeAllObjectsToWorkOrderArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
};


export type MutationBimIncludeContractObjectToWorkOrderArgs = {
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationBimIncludeContractObjectToWorkOrderChangeArgs = {
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimIncludeWorkOrderSeasonArgs = {
  contractSeasonId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationBimModifyContractOtherCostArgs = {
  input: BimContractOtherCostModifyInput;
};


export type MutationBimMoveContractObjectArgs = {
  contractObjectId: Scalars['Long'];
  insertAfterObjectId?: InputMaybe<Scalars['Long']>;
  newParentObjectId?: InputMaybe<Scalars['Long']>;
};


export type MutationBimRemoveActKc2OtherArgs = {
  actKC2OtherId: Scalars['Long'];
};


export type MutationBimRemoveActsKc2Args = {
  actKC2Ids: Array<Scalars['Long']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationBimRemoveWorkOrderArgs = {
  workOrderId: Scalars['Long'];
};


export type MutationBimRemoveWorkOrderActsKc2GroupArgs = {
  actKC2GroupId: Scalars['Long'];
};


export type MutationBimRemoveWorkOrderChangeObjectArgs = {
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimRemoveWorkOrderChangeOthersArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceIds: Array<BimWorkOrderChangeOtherPriceIdsInput>;
};


export type MutationBimRemoveWorkOrderChangePricesArgs = {
  priceIds: Array<BimWorkOrderChangePriceIdsInput>;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimRemoveWorkOrderObjectArgs = {
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationBimRemoveWorkOrderOtherForActArgs = {
  workOrderObjectId: Scalars['Long'];
  workOrderOtherIds: Array<Scalars['Long']>;
};


export type MutationBimRemoveWorkOrderOthersArgs = {
  workOrderId: Scalars['Long'];
  workOrderOtherIds: Array<Scalars['Long']>;
};


export type MutationBimRemoveWorkOrderPricesArgs = {
  workOrderId: Scalars['Long'];
  workOrderPriceIds: Array<Scalars['Long']>;
};


export type MutationBimRemoveWorkOrderPricesToActKc2Args = {
  workOrderId: Scalars['Long'];
  workOrderPriceIds: Array<Scalars['Long']>;
};


export type MutationBimResetActKc2AllCalculatedTotalArgs = {
  actKC2Id: Scalars['Long'];
  useCalculated: Scalars['Boolean'];
};


export type MutationBimResetActKc2CalculatedTotalItemArgs = {
  actKC2Id: Scalars['Long'];
  actKC2TotalItemId: Scalars['Long'];
  useCalculated: Scalars['Boolean'];
};


export type MutationBimSetActKc2InputValueArgs = {
  actKC2Id: Scalars['Long'];
  actKC2TotalItemId: Scalars['Long'];
  value: Scalars['Decimal'];
};


export type MutationBimSetActKc2OtherAcceptedCostArgs = {
  actKC2OtherId: Scalars['Long'];
  cost?: InputMaybe<Scalars['Decimal']>;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimSetActKc2OtherCostCommentArgs = {
  actKC2OtherId: Scalars['Long'];
  comment?: InputMaybe<Scalars['String']>;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimSetActKc2OtherPlanCostArgs = {
  actKC2OtherId: Scalars['Long'];
  cost?: InputMaybe<Scalars['Decimal']>;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateActKc2OtherArgs = {
  input: BimActKc2OtherUpdateInput;
};


export type MutationBimUpdateActKc2OtherCorrectionArgs = {
  input: BimActKc2OtherCorrectionUpdateInput;
};


export type MutationBimUpdateActKc2TotalsArgs = {
  actsKC2Ids: Array<Scalars['Long']>;
  uploadId: Scalars['String'];
  workOrderId: Scalars['Long'];
};


export type MutationBimUpdateCalculationArgs = {
  calculationInput: BimCalculationUpdateInput;
};


export type MutationBimUpdateContractArgs = {
  contractInput: BimContractUpdateInput;
};


export type MutationBimUpdateContractObjectArgs = {
  input: BimContractObjectUpdateInput;
};


export type MutationBimUpdateContractOtherCostArgs = {
  input: BimContractOtherCostUpdateInput;
};


export type MutationBimUpdateContractSubObjectArgs = {
  input: BimContractSubObjectUpdateInput;
};


export type MutationBimUpdateWorkChangeOrderOtherDistributionArgs = {
  input: BimWorkOrderChangeOtherDistributionInput;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationBimUpdateWorkOrderArgs = {
  workOrderInput: BimWorkOrderUpdateInput;
};


export type MutationBimUpdateWorkOrderActsKc2GroupArgs = {
  actKC2GroupId: Scalars['Long'];
  input: BimActKc2GroupInput;
};


export type MutationBimUpdateWorkOrderChangeArgs = {
  input: BimWorkOrderChangeUpdateInput;
};


export type MutationBimUpdateWorkOrderChangeObjectArgs = {
  input: BimContractObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderChangeOtherArgs = {
  input: BimContractOtherCostUpdateInput;
  workOrderChangeOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderChangePriceRationaleArgs = {
  input: BimWorkOrderChangePriceRationaleUpdateInput;
  workOrderChangePriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderChangeSeasonsArgs = {
  contractSeasonId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderChangeSubObjectArgs = {
  input: BimContractSubObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderObjectArgs = {
  input: BimContractObjectUpdateInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderOtherArgs = {
  input: BimContractOtherCostUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderOtherDistributionArgs = {
  input: BimWorkOrderOtherDistributionInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderOtherDistributionForActArgs = {
  input: BimWorkOrderOtherDistributionInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderOtherDistributionToActKc2Args = {
  input: BimWorkOrderOtherDistributionInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderOtherForActArgs = {
  input: BimContractOtherCostUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderPriceMtrDistributionArgs = {
  input: BimWorkOrderPriceMtrDistributionInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderSeasonsArgs = {
  input: BimWorkOrderSeasonsInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimUpdateWorkOrderSubObjectArgs = {
  input: BimContractSubObjectUpdateInput;
  workOrderId: Scalars['Long'];
};


export type MutationBimUploadPriceActsArgs = {
  chapter: BimChapterEnum;
  filesContent: Array<FileInput>;
  hasTotalsFromXml?: Scalars['Boolean'];
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};


export type MutationBimUploadPriceFilesArgs = {
  chapter: BimChapterEnum;
  filesContent: Array<FileInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};


export type MutationBimUploadPriceFilesForWorkOrderChangeArgs = {
  chapter: BimChapterEnum;
  filesContent: Array<FileInput>;
  rationale: Scalars['String'];
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type MutationBimUseActKc2InflationValueArgs = {
  actKC2Id: Scalars['Long'];
  calculateInflation: BimCalculateInflationEnum;
};


export type MutationBimUseActKc2OtherTotalInflationArgs = {
  actKC2OtherId: Scalars['Long'];
  workOrderSeasonId?: InputMaybe<Scalars['Long']>;
};


export type MutationBimUseActKc2TotalInflationArgs = {
  actKC2Id: Scalars['Long'];
  workOrderSeasonId: Scalars['Long'];
};


export type MutationBimUseActKc2TotalLimitedArgs = {
  actKC2Id: Scalars['Long'];
  limitedItems: Array<BimLimitedCostTypeEnum>;
  useLimited: Scalars['Boolean'];
};


export type MutationBimcComputeCalculationArgs = {
  calculationId: Scalars['Long'];
};


export type MutationBimcCopyCalculationArgs = {
  calculationUniqueId: Scalars['String'];
  projectUniqueId: Scalars['String'];
};


export type MutationBimcCreateAggregateEstimateArgs = {
  input: CreateAggregateEstimateInput;
};


export type MutationBimcCreateCalculationArgs = {
  input: BimcCalculationCreateInput;
};


export type MutationBimcCreateCalculationLimitedCostArgs = {
  input: BimcCalculationLimitedCostInput;
};


export type MutationBimcCreateCalculationObjectArgs = {
  input: BimcCalculationObjectCreateInput;
};


export type MutationBimcCreateCalculationOtherCostArgs = {
  input: BimcCalculationOtherCostInput;
};


export type MutationBimcCreateCalculationSubObjectArgs = {
  input: BimcCalculationSubObjectCreateInput;
};


export type MutationBimcImportCalculationStructureArgs = {
  calculationId: Scalars['Long'];
  fileContent: FileInput;
};


export type MutationBimcLoadLocalEstimatesArgs = {
  input: LocalEstimateImportMutationInput;
};


export type MutationBimcMoveCalculationObjectArgs = {
  input: CalculationObjectMoveInput;
};


export type MutationBimcRedistributeLocalEstimateMtrArgs = {
  input: LocalEstimateMtrDistributionInput;
  localEstimateId: Scalars['Long'];
};


export type MutationBimcRemoveAggregateEstimateArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
};


export type MutationBimcRemoveCalculationLimitedCostsArgs = {
  calculationId: Scalars['Long'];
  ids: Array<Scalars['Long']>;
};


export type MutationBimcRemoveCalculationObjectArgs = {
  objectId: Scalars['Long'];
};


export type MutationBimcRemoveCalculationOtherCostsArgs = {
  calculationId: Scalars['Long'];
  ids: Array<Scalars['Long']>;
};


export type MutationBimcRemoveLocalEstimatesArgs = {
  input: LocalEstimateRemoveMutationInput;
};


export type MutationBimcSetCalculationObjectGuaranteedVolumeArgs = {
  input: CalculationObjectGuaranteedVolumeInput;
};


export type MutationBimcUpdateAggregateEstimateArgs = {
  input: UpdateAggregateEstimateInput;
};


export type MutationBimcUpdateCalculationArgs = {
  calculationInput: BimcCalculationUpdateInput;
};


export type MutationBimcUpdateCalculationLimitedCostArgs = {
  id: Scalars['Long'];
  input: BimcCalculationLimitedCostInput;
};


export type MutationBimcUpdateCalculationObjectArgs = {
  input: BimcCalculationObjectUpdateInput;
};


export type MutationBimcUpdateCalculationOtherCostArgs = {
  id: Scalars['Long'];
  input: BimcCalculationOtherCostInput;
};


export type MutationBimcUpdateCalculationStatusArgs = {
  input: BimcCalculationStatusInput;
};


export type MutationBimcUpdateLocalEstimateArgs = {
  inPercentOtherAndLimit: Scalars['Boolean'];
  localEstimateId: Scalars['Long'];
};


export type MutationBimcUpdateSeasonDistributionArgs = {
  calculationId: Scalars['Long'];
  items: Array<CalculationObjectSeasonDistributionInput>;
};


export type MutationCatalogCreateConstructionTypeArgs = {
  input: CatalogConstructionTypeCreateInput;
};


export type MutationCatalogCreateUerBaseCostArgs = {
  costData: CreateCatalogUerBaseCostInput;
};


export type MutationCatalogCreateWorkTypeArgs = {
  input: CatalogWorkTypeCreateInput;
};


export type MutationCatalogImportUerBaseCostWorkTypesArgs = {
  catalogId: Scalars['Long'];
  file: FileInput;
};


export type MutationCatalogRatioMassApplyArgs = {
  input: CatalogRatioMassApplyInput;
};


export type MutationCatalogRemoveConstructionTypeArgs = {
  catalogConstructionTypeId: Scalars['Int'];
};


export type MutationCatalogRemoveUerBaseCostArgs = {
  uerBaseCostIds: Array<Scalars['Long']>;
};


export type MutationCatalogRemoveWorkTypeArgs = {
  catalogWorkTypeId: Scalars['Int'];
};


export type MutationCatalogRemoveWorkTypesArgs = {
  catalogWorkTypeIds: Array<Scalars['Int']>;
};


export type MutationCatalogUpdateConstructionTypeArgs = {
  input: CatalogConstructionTypeUpdateInput;
};


export type MutationCatalogUpdateUerBaseCostArgs = {
  costData: UpdateCatalogUerBaseCostInput;
};


export type MutationCatalogUpdateWorkTypeArgs = {
  input: CatalogWorkTypeUpdateInput;
};


export type MutationCatalogUpsertArchiveUerBaseCostBasisesArgs = {
  input: CatalogUpsertArchiveUerBaseCostBasisesInput;
};


export type MutationCatalogUpsertMultiUerBaseCostBasisesArgs = {
  input: CatalogUpsertMultiUerBaseCostBasisesInput;
};


export type MutationCopyProjectArgs = {
  uniqueId: Scalars['String'];
};


export type MutationCreateCatalogArgs = {
  catalogInput: CatalogCreateInput;
};


export type MutationCreateCatalogLimitedCostTypeArgs = {
  input: CatalogLimitedCostTypeInput;
};


export type MutationCreateCatalogOtherCostTypeArgs = {
  input: CatalogOtherCostTypeCreateInput;
};


export type MutationCreateCatalogOtherCostVariableArgs = {
  input: CatalogOtherCostVariableCreateInput;
};


export type MutationCreateCatalogOtherCostVariableGroupArgs = {
  input: CatalogOtherCostVariableGroupCreateInput;
};


export type MutationCreateCatalogRatioArgs = {
  input: CatalogRatioCreateInput;
};


export type MutationCreateCatalogUerOtherCostTemplateArgs = {
  input: CatalogUerOtherCostTemplateInput;
};


export type MutationCreateGlobalLimitedCostArgs = {
  input: GlobalLimitedCostCreateInput;
};


export type MutationCreateGlobalOtherCostArgs = {
  input: GlobalOtherCostCreateInput;
};


export type MutationCreateProjectArgs = {
  projectInput: ProjectCreateInput;
};


export type MutationDeleteProjectArgs = {
  uniqueId: Scalars['String'];
};


export type MutationLogNotAuthenticatedArgs = {
  message?: InputMaybe<Scalars['String']>;
  uniqueId: Scalars['String'];
};


export type MutationLogUserClientArgs = {
  loginOp: AuditLogClientOperationEnum;
  userName: Scalars['String'];
};


export type MutationRemoveCatalogLimitedCostTypeArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCatalogOtherCostTypeArgs = {
  catalogOtherCostTypeId: Scalars['Int'];
};


export type MutationRemoveCatalogOtherCostVariableArgs = {
  otherCostVariableId: Scalars['Long'];
};


export type MutationRemoveCatalogOtherCostVariableGroupArgs = {
  groupId: Scalars['Int'];
};


export type MutationRemoveCatalogRatioArgs = {
  catalogRatioId: Scalars['Long'];
};


export type MutationRemoveCatalogUerOtherCostTemplatesArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationRemoveGlobalLimitedCostArgs = {
  id: Scalars['Long'];
};


export type MutationRemoveGlobalOtherCostArgs = {
  id: Scalars['Long'];
};


export type MutationSetCatalogUerBaseCostPropertiesArgs = {
  catalogId: Scalars['Long'];
  input: CatalogUerBaseCostPropertiesInput;
};


export type MutationUerActKc2CopyPlanVolumeSKzSArgs = {
  actKC2Id: Scalars['Long'];
};


export type MutationUerActKc2CopyPlanVolumeSKzSuerArgs = {
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerAddMtrRowArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  input: PriceListMtrRowCreateInput;
};


export type MutationUerAddMtrToActKc2PriceListArgs = {
  mtrInputs: Array<PriceListMtrRowInput>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerAddMtrToWorkOrderChangeArgs = {
  mtrInputs: Array<PriceListMtrRowInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerAddMtrToWorkOrderFromPriceListArgs = {
  mtrRowIds: Array<Scalars['Long']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerAddMtrsToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  mtrRowIds: Array<Scalars['Long']>;
};


export type MutationUerAddObjectToWorkOrderChangeArgs = {
  input: WorkOrderChangeObjectInput;
};


export type MutationUerAddOtherCostToActKc2Args = {
  otherInputs: Array<UerOtherCostInput>;
  workOrderObjectId: Scalars['Long'];
};


export type MutationUerAddOthersToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  contractOtherCostIds: Array<Scalars['Long']>;
};


export type MutationUerAddRatioToActKc2Args = {
  actKC2Id: Scalars['Long'];
  ratioInputs: Array<PriceListRatioRowInput>;
  strategy: AddRatioToActKc2StrategyEnum;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerAddRatioToWorkOrderChangeArgs = {
  ratioInputs: Array<PriceListRatioRowInput>;
  strategy?: InputMaybe<AddRatioToActKc2StrategyEnum>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerAddRatioToWorkOrderFromPriceListArgs = {
  ratioRowIds: Array<Scalars['Long']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerAddRatiosToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  ratioRowIds: Array<Scalars['Long']>;
};


export type MutationUerAddUerToActKc2PriceListArgs = {
  chapter: ChapterEnum;
  uerInputs: Array<PriceListUerRowInput>;
  workOrderObjectId: Scalars['Long'];
};


export type MutationUerAddUerToWorkOrderArgs = {
  priceListUerRowInput: PriceListUerRowCreateInput;
  workOrderObjectId: Scalars['Long'];
};


export type MutationUerAddUerToWorkOrderChangeArgs = {
  chapter: ChapterEnum;
  uerInputs: Array<PriceListUerRowInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerAddUerToWorkOrderFromPriceListArgs = {
  chapter: ChapterEnum;
  uerBaseRowIds: Array<Scalars['Long']>;
  workOrderObjectId: Scalars['Long'];
};


export type MutationUerAddUersToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  uerBaseRowIds: Array<Scalars['Long']>;
};


export type MutationUerAddUersToWorkOrderChangeObjectsArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  uerInputs: Array<PriceListUerRowInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectIds: Array<WorkOrderChangeObjectIdInput>;
};


export type MutationUerAddUersToWorkOrderObjectsArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  uerInputs: Array<PriceListUerRowInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type MutationUerAddWorkOrderChangeFromXmlArgs = {
  constructionTypeId: Scalars['Int'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput>;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerAddWorkOrderChangeOtherCostArgs = {
  input: WorkOrderChangeOthersInput;
};


export type MutationUerAddWorkOrderFromXmlArgs = {
  constructionTypeId: Scalars['Int'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput>;
  workOrderId: Scalars['Long'];
};


export type MutationUerAddWorkOrderOtherCostArgs = {
  otherCostInput: UpdateWorkOrderOtherCostInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerApplyMtrToActKc2FromPriceListArgs = {
  mtrRowId: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerApplyMtrToWorkOrderChangeFromPriceListArgs = {
  mtrRowId: Scalars['Long'];
  workOrderChangePriceId: Scalars['Long'];
};


export type MutationUerApplyMtrToWorkOrderFromPriceListArgs = {
  mtrRowId: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerApplyPriceListUerRatioRowsArgs = {
  ratioRowIds: Array<Scalars['Long']>;
  uerBaseRowId: Scalars['Long'];
};


export type MutationUerApplyRatioToWorkOrderObjectsArgs = {
  priceListRatioIds: Array<Scalars['Long']>;
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type MutationUerApplyWorkOrderChangePriceRatiosToObjectsArgs = {
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  priceListRatioIds: Array<PriceListRatioRowInput>;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerApplyWorkOrderChangePriceRatiosToRootObjectArgs = {
  constructionTypeId: Scalars['Int'];
  priceListRatioIds: Array<PriceListRatioRowInput>;
  rootObjectIds: WorkOrderChangeObjectIdInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerApplyWorkOrderPriceRatiosToRootObjectArgs = {
  priceListRatioIds: Array<Scalars['Long']>;
  workOrderObjectId: Scalars['Long'];
};


export type MutationUerChangeActKc3LevelArgs = {
  actKC3Level: ActKc3LevelEnum;
  contractId: Scalars['Long'];
};


export type MutationUerCopyActKc2Args = {
  actKC2Id: Scalars['Long'];
};


export type MutationUerCreateActKc2Args = {
  actKC2Input: ActKc2CreateInput;
};


export type MutationUerCreateActKc2CorrectionArgs = {
  primaryActKC2Id: Scalars['Long'];
};


export type MutationUerCreateActKc3Args = {
  actKC3Input: ActKc3Input;
};


export type MutationUerCreateClosingWorkOrderChangeArgs = {
  input: WorkOrderChangeClosingInput;
};


export type MutationUerCreateContractArgs = {
  catalogUERBaseUniqueId?: InputMaybe<Scalars['String']>;
  fileContent: FileInput;
  importOption?: InputMaybe<ContractImportEnum>;
  projectUniqueId: Scalars['String'];
};


export type MutationUerCreateContractChangeArgs = {
  input: ContractChangeInput;
};


export type MutationUerCreateContractConditionOtherCostArgs = {
  input: ContractConditionOtherCreateInput;
};


export type MutationUerCreateContractObjectArgs = {
  input: ContractObjectCreateInput;
};


export type MutationUerCreateContractOtherCostArgs = {
  contractId: Scalars['Long'];
  createInput: ContractOtherCreateInput;
};


export type MutationUerCreateContractOtherCostFromCatalogArgs = {
  contractId: Scalars['Long'];
  createInput: ContractOtherCreateFromCatalogInput;
};


export type MutationUerCreateContractSubObjectArgs = {
  contractId: Scalars['Long'];
  input: ContractSubObjectCreateInput;
};


export type MutationUerCreateRatioRowArgs = {
  input: PriceListRatioRowCreateInput;
};


export type MutationUerCreateUerRowArgs = {
  input: PriceListUerRowCreateInput;
};


export type MutationUerCreateWorkOrderActsKc2GroupArgs = {
  input: ActKc2GroupInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerCreateWorkOrderChangeArgs = {
  input: WorkOrderChangeInput;
};


export type MutationUerCreateWorkOrderChangeObjectArgs = {
  input: ContractObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerCreateWorkOrderChangeSubObjectArgs = {
  input: ContractSubObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerCreateWorkOrderObjectArgs = {
  input: ContractObjectCreateInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerCreateWorkOrderSubObjectArgs = {
  input: ContractSubObjectCreateInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerCreateWorkOrderVersionArgs = {
  workOrderId: Scalars['Long'];
};


export type MutationUerDeleteActKc2Args = {
  actKC2Id: Scalars['Long'];
};


export type MutationUerDeleteActKc3Args = {
  actKC3Id: Scalars['Long'];
};


export type MutationUerDeleteContractChangeArgs = {
  contractChangeId: Scalars['Long'];
};


export type MutationUerDeleteContractOtherCostArgs = {
  contractOtherCostId: Scalars['Long'];
};


export type MutationUerDeleteWorkOrderArgs = {
  workOrderId: Scalars['Long'];
};


export type MutationUerDeleteWorkOrderChangeArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerExcludeContractObjectFromWorkOrderArgs = {
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationUerExcludeContractObjectFromWorkOrderChangeArgs = {
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerImportActKc2TemplateAsExcelArgs = {
  actKC2Template: FileInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerImportPriceListCollectionArgs = {
  contractId: Scalars['Long'];
  fileContent: FileInput;
};


export type MutationUerImportWorkOrderFromRivxArgs = {
  contractId: Scalars['Long'];
  fileContent: FileInput;
};


export type MutationUerImportWorkOrderFromXmlArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput>;
};


export type MutationUerIncludeContractObjectToWorkOrderArgs = {
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationUerIncludeContractObjectToWorkOrderChangeArgs = {
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerModifyContractOtherCostArgs = {
  input: ContractOtherModifyInput;
};


export type MutationUerMoveWorkOrderChangeObjectArgs = {
  insertAfterObjectId?: InputMaybe<Scalars['Long']>;
  newParentObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId: Scalars['Long'];
};


export type MutationUerMoveWorkOrderChangeObjectRemindersArgs = {
  input: WorkOrderChangeObjectVolumesTransferInput;
};


export type MutationUerMoveWorkOrderChangeUerRemindersArgs = {
  input: WorkOrderChangeUerVolumesTransferInput;
};


export type MutationUerRecalculateActKc2LimitedCostArgs = {
  actKC2Id: Scalars['Long'];
};


export type MutationUerRecalculateWorkOrderChangeLimitedCostPlanArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerRecalculateWorkOrderLimitedCostPlanArgs = {
  workOrderId: Scalars['Long'];
};


export type MutationUerRecalculateWorkOrderVersionLimitedCostPlanArgs = {
  workOrderVersionId: Scalars['Long'];
};


export type MutationUerRemoveActKc2OtherFromWorkOrderArgs = {
  workOrderOtherPriceIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveActKc2PriceFromWorkOrderArgs = {
  workOrderPriceIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveActsKc3Args = {
  actKC3Ids: Array<Scalars['Long']>;
  contractId: Scalars['Long'];
};


export type MutationUerRemoveContractObjectArgs = {
  objectId: Scalars['Long'];
};


export type MutationUerRemoveMtrsFromContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  mtrIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveOtherCostsFromContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  contractOtherCostIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveOtherFromWorkOrderArgs = {
  workOrderOtherPriceIds: Array<Scalars['Long']>;
};


export type MutationUerRemovePriceFromWorkOrderArgs = {
  workOrderPriceIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveRatiosFromContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  ratioIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveUersFromContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  uerIds: Array<Scalars['Long']>;
};


export type MutationUerRemoveUnusedContractOtherCostsArgs = {
  contractId: Scalars['Long'];
};


export type MutationUerRemoveUnusedMtrRowsArgs = {
  contractId: Scalars['Long'];
};


export type MutationUerRemoveUnusedRatioRowsArgs = {
  contractId: Scalars['Long'];
};


export type MutationUerRemoveUnusedUerRowsArgs = {
  contractId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderActsKc2GroupArgs = {
  actKC2GroupId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderChangeObjectArgs = {
  workOrderChangeObjectId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderChangeObjectItemArgs = {
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderChangeOtherCostArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceIds: Array<WorkOrderChangeOtherPriceIdsInput>;
};


export type MutationUerRemoveWorkOrderChangePriceItemsArgs = {
  constructionTypeId: Scalars['Int'];
  otherPriceIds: Array<WorkOrderChangeOtherPriceIdsInput>;
  priceIds: Array<WorkOrderChangePriceIdsInput>;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderChangePricesArgs = {
  priceIds: Array<WorkOrderChangePriceIdsInput>;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderObjectArgs = {
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationUerRemoveWorkOrderPriceItemsArgs = {
  workOrderId: Scalars['Long'];
  workOrderOtherPriceIds: Array<Scalars['Long']>;
  workOrderPriceIds: Array<Scalars['Long']>;
};


export type MutationUerRenameWorkOrderChangeObjectArgs = {
  name: Scalars['String'];
  workOrderChangeObjectId: Scalars['Long'];
};


export type MutationUerReplaceWorkOrderFromRivxArgs = {
  fileContent: FileInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerReplaceWorkOrderFromXmlArgs = {
  constructionTypeId: Scalars['Int'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput>;
  workOrderId: Scalars['Long'];
};


export type MutationUerRollbackWorkOrderChangeArgs = {
  workOrderId: Scalars['Long'];
};


export type MutationUerSaveOrUpdateWorkOrderChangeSeasonVolumeArgs = {
  volume: Scalars['Decimal'];
  workOrderChangeId: Scalars['Long'];
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangeSeasonId: Scalars['Long'];
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerSetActKc2AcceptedCostArgs = {
  actKC2Id: Scalars['Long'];
  cost: Scalars['Decimal'];
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerSetActKc2AcceptedVolumeArgs = {
  actKC2Id: Scalars['Long'];
  volume?: InputMaybe<Scalars['Decimal']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerSetActKc2FormulaArgs = {
  actKC2Id: Scalars['Long'];
  formula?: InputMaybe<Scalars['String']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerSetActKc2OtherCostAcceptedCostArgs = {
  actKC2Id: Scalars['Long'];
  cost: Scalars['Decimal'];
  workOrderOtherId: Scalars['Long'];
};


export type MutationUerSetActKc2OtherCostCommentArgs = {
  actKC2Id: Scalars['Long'];
  comment?: InputMaybe<Scalars['String']>;
  otherPriceId: Scalars['Long'];
};


export type MutationUerSetActKc2OtherCostPlanCostArgs = {
  actKC2Id: Scalars['Long'];
  cost: Scalars['Decimal'];
  workOrderOtherId: Scalars['Long'];
};


export type MutationUerSetActKc2PlanCostArgs = {
  actKC2Id: Scalars['Long'];
  cost: Scalars['Decimal'];
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerSetActKc2PlanVolumeArgs = {
  actKC2Id: Scalars['Long'];
  volume?: InputMaybe<Scalars['Decimal']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerSetActKc2WorkVolumeCommentArgs = {
  actKC2Id: Scalars['Long'];
  comment?: InputMaybe<Scalars['String']>;
  priceId: Scalars['Long'];
};


export type MutationUerSetContractSeasonsArgs = {
  contractId: Scalars['Long'];
  years: Array<Scalars['Short']>;
};


export type MutationUerSetWorkOrderChangeLastSeasonArgs = {
  contractSeasonId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerSetWorkOrderChangeWorkRatioArgs = {
  ratio?: InputMaybe<Scalars['Decimal']>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerSetWorkOrderWorkRatioArgs = {
  ratio?: InputMaybe<Scalars['Decimal']>;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerSkzsUpdateKc6aArgs = {
  contractUniqueId: Scalars['String'];
  inputs: Array<SkzsKc6aUpdateInput>;
};


export type MutationUerSkzsUploadKc6aArgs = {
  contractUniqueId: Scalars['String'];
  inputs: Array<SkzsKc6aCreateInput>;
};


export type MutationUerUpdateActKc2Args = {
  actKC2Input: ActKc2UpdateInput;
};


export type MutationUerUpdateActKc2CorrectionArgs = {
  input: ActKc2CorrectionUpdateInput;
};


export type MutationUerUpdateActKc2LimitedCostArgs = {
  actKC2Id: Scalars['Long'];
  calculatingValue: Scalars['Decimal'];
  cost: Scalars['Decimal'];
  seasonPriceId: Scalars['Long'];
};


export type MutationUerUpdateActKc2LimitedCostSeasonCostArgs = {
  actKC2Id: Scalars['Long'];
  cost: Scalars['Decimal'];
  seasonPriceId: Scalars['Long'];
};


export type MutationUerUpdateActKc3Args = {
  actKC3Input: ActKc3UpdateInput;
};


export type MutationUerUpdateContractArgs = {
  contractInput: ContractUpdateInput;
};


export type MutationUerUpdateContractChangeArgs = {
  contractChangeInput: ContractChangeUpdateInput;
};


export type MutationUerUpdateContractConditionOtherCostArgs = {
  contractId: Scalars['Long'];
  updateInput: ContractConditionOtherUpdateInput;
};


export type MutationUerUpdateContractObjectArgs = {
  contractId: Scalars['Long'];
  input: ContractObjectUpdateInput;
};


export type MutationUerUpdateContractOtherCostArgs = {
  contractId: Scalars['Long'];
  updateInput: ContractOtherUpdateInput;
};


export type MutationUerUpdateContractOtherCostFromCatalogArgs = {
  contractId: Scalars['Long'];
  updateInput: ContractOtherUpdateInput;
};


export type MutationUerUpdateContractOtherCostToWorkOrderChangeFromPriceListArgs = {
  input: ContractOtherUpdateInput;
  workOrderChangeOtherPriceId: Scalars['Long'];
};


export type MutationUerUpdateContractOtherCostToWorkOrderFromPriceListArgs = {
  input: ContractOtherUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationUerUpdateContractSubObjectArgs = {
  contractId: Scalars['Long'];
  input: ContractSubObjectUpdateInput;
};


export type MutationUerUpdateMtrRowArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  input: PriceListMtrRowUpdateInput;
};


export type MutationUerUpdateMtrToActKc2FromPriceListArgs = {
  input: PriceListMtrRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateMtrToWorkOrderChangeFromPriceListArgs = {
  input: PriceListMtrRowUpdateInput;
  workOrderChangePriceId: Scalars['Long'];
};


export type MutationUerUpdateMtrToWorkOrderFromPriceListArgs = {
  input: PriceListMtrRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateOrderChangeOtherPriceRationaleArgs = {
  input: WorkOrderChangeOtherPriceRationaleUpdateInput;
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerUpdateOrderChangePriceRationaleArgs = {
  input: WorkOrderChangePriceRationaleUpdateInput;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerUpdateOtherCostToActKc2Args = {
  updateInput: ContractOtherUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationUerUpdateRatioRowArgs = {
  input: PriceListRatioRowUpdateInput;
};


export type MutationUerUpdateRatioToActKc2FromPriceListArgs = {
  input: PriceListRatioRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateRatioToWorkOrderChangeFromPriceListArgs = {
  input: PriceListRatioRowUpdateInput;
  workOrderChangePriceId: Scalars['Long'];
};


export type MutationUerUpdateRatioToWorkOrderFromPriceListArgs = {
  input: PriceListRatioRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateSeasonVolumeArgs = {
  volume: Scalars['Decimal'];
  workOrderPriceId: Scalars['Long'];
  workOrderSeasonId: Scalars['Long'];
};


export type MutationUerUpdateUerRowArgs = {
  input: PriceListUerRowUpdateInput;
};


export type MutationUerUpdateUerToActKc2FromPriceListArgs = {
  input: PriceListUerRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateUerToWorkOrderChangeFromPriceListArgs = {
  input: PriceListUerRowUpdateInput;
  workOrderChangePriceId: Scalars['Long'];
};


export type MutationUerUpdateUerToWorkOrderFromPriceListArgs = {
  input: PriceListUerRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderArgs = {
  workOrderInput: WorkOrderUpdateInput;
};


export type MutationUerUpdateWorkOrderActKc2MtrForInflationDistributionArgs = {
  actKC2Id: Scalars['Long'];
  actKC2MtrItems: Array<ActKc2MtrItemInput>;
  useInflationMTR: Scalars['Boolean'];
};


export type MutationUerUpdateWorkOrderActsKc2GroupArgs = {
  actKC2GroupId: Scalars['Long'];
  input: ActKc2GroupInput;
};


export type MutationUerUpdateWorkOrderChangeArgs = {
  workOrderChangeInput: WorkOrderChangeUpdateInput;
};


export type MutationUerUpdateWorkOrderChangeLimitedCostSeasonCostArgs = {
  cost: Scalars['Decimal'];
  seasonPriceId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderChangeObjectArgs = {
  input: ContractObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderChangeOtherCostItemsArgs = {
  constructionTypeId: Scalars['Int'];
  otherPriceInputs: Array<UpdateWorkOrderChangeOtherPriceItemInput>;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderChangeOtherDistributionArgs = {
  input: WorkOrderChangeOtherCostDistributionInput;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type MutationUerUpdateWorkOrderChangeSubObjectArgs = {
  input: ContractObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderLimitedCostSeasonCostArgs = {
  cost: Scalars['Decimal'];
  seasonPriceId: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderObjectArgs = {
  input: ContractObjectUpdateInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderOtherCostItemsArgs = {
  constructionTypeId: Scalars['Int'];
  otherPriceInputs: Array<UpdateWorkOrderOtherPriceItemInput>;
  workOrderId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderOtherDistributionArgs = {
  updateInput: WorkOrderOtherDistributionUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderOtherDistributionToActKc2Args = {
  updateInput: WorkOrderOtherDistributionUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderOtherPriceRationaleArgs = {
  input: WorkOrderOtherPriceRationaleUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderPriceRationaleArgs = {
  input: WorkOrderPriceRationaleUpdateInput;
  workOrderPriceId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderSeasonsArgs = {
  input: WorkOrderSeasonsInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderSubObjectArgs = {
  input: ContractObjectUpdateInput;
  workOrderId: Scalars['Long'];
};


export type MutationUerUpdateWorkOrderVersionLimitedCostSeasonCostArgs = {
  cost: Scalars['Decimal'];
  seasonPriceId: Scalars['Long'];
  workOrderVersionId: Scalars['Long'];
};


export type MutationUercAddCostsToWorArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  costIds: Array<Scalars['Long']>;
};


export type MutationUercAddMtrsToWorkVolumeFromCollectionMtrArgs = {
  input: AddCollectionMtrToWorkVolumeInput;
};


export type MutationUercAddRatiosMassToWorkVolumeFromCollectionRatioArgs = {
  input: AddRatiosMassToWorkVolumeInput;
};


export type MutationUercAddRatiosToWorkVolumeFromCollectionRatioArgs = {
  input: AddRatiosToWorkVolumeInput;
};


export type MutationUercAddUersToCollectionUerBaseCostArgs = {
  input: AddUersToCollectionUerBaseCostInput;
};


export type MutationUercChangeSeasonWorkVolumeArgs = {
  input: ChangeSeasonWorkVolumeInput;
};


export type MutationUercComputeCalculationArgs = {
  calculationId: Scalars['Long'];
  sortType?: InputMaybe<WorUerSortType>;
};


export type MutationUercCopyCalculationArgs = {
  calculationUniqueId: Scalars['String'];
  projectUniqueId: Scalars['String'];
};


export type MutationUercCopyCalculationObjectArgs = {
  input: CalculationObjectCopyInput;
};


export type MutationUercCopyCatalogRatiosToCollectionArgs = {
  calculationId: Scalars['Long'];
  catalogRatioIdList: Array<Scalars['Long']>;
};


export type MutationUercCopyCollectionUerBaseCostsFromCatalogArgs = {
  calculationId: Scalars['Long'];
};


export type MutationUercCreateCalculationArgs = {
  calculationInput: UercCalculationCreateInput;
};


export type MutationUercCreateCalculationLimitedCostArgs = {
  input: UercCalculationLimitedCostInput;
};


export type MutationUercCreateCalculationObjectArgs = {
  input: CalculationObjectCreateInput;
};


export type MutationUercCreateCalculationOtherCostArgs = {
  input: UercCalculationOtherCostInput;
};


export type MutationUercCreateCalculationSubObjectArgs = {
  input: CalculationSubObjectCreateInput;
};


export type MutationUercCreateCollectionMtrArgs = {
  input: CreateCollectionMtrInput;
};


export type MutationUercCreateCollectionMtrToWorkVolumeArgs = {
  input: CreateCollectionMtrToWorkVolumeInput;
};


export type MutationUercCreateCollectionRatioArgs = {
  input: CollectionRatioCreateInput;
};


export type MutationUercCreateCollectionRatioMassToWorkVolumeArgs = {
  input: CreateCollectionRatioMassToWorkVolumeInput;
};


export type MutationUercCreateCollectionRatioToWorkVolumeArgs = {
  input: CreateCollectionRatioToWorkVolumeInput;
};


export type MutationUercImportCalculationObjectsArgs = {
  calculationId: Scalars['Long'];
  fileContent: FileInput;
};


export type MutationUercImportCollectionMtrArgs = {
  calculationId: Scalars['Long'];
  fileContent: FileInput;
};


export type MutationUercImportCollectionUerBaseCostWorkTypesArgs = {
  calculationId: Scalars['Long'];
  file: FileInput;
};


export type MutationUercImportEstimateBasisFilesArgs = {
  calculationId: Scalars['Long'];
  files: Array<FileInput>;
  input: CollectionUerBaseCostImportFilesInput;
};


export type MutationUercImportExcelWorArgs = {
  calculationId: Scalars['Long'];
  fileContent: FileInput;
  fileType?: InputMaybe<WorExcelFileType>;
  mtrSelections?: InputMaybe<Array<MtrSelectionInput>>;
};


export type MutationUercImportUerBaseCostCollectionArgs = {
  calculationId: Scalars['Long'];
  constructionTypeIds: Array<Scalars['Int']>;
  copyRatios: Scalars['Boolean'];
  file: FileInput;
};


export type MutationUercImportWorkVolumeXmlArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  files: Array<FileInput>;
  mtrSelections?: InputMaybe<Array<MtrSelectionInput>>;
  seasonId: Scalars['Long'];
};


export type MutationUercMoveCalculationObjectArgs = {
  calculationObjectId: Scalars['Long'];
  insertAfterObjectId: Scalars['Long'];
  newParentObjectId?: InputMaybe<Scalars['Long']>;
};


export type MutationUercRemoveAllCollectionUerBaseCostRowsArgs = {
  calculationId: Scalars['Long'];
};


export type MutationUercRemoveCalculationLimitedCostsArgs = {
  calculationId: Scalars['Long'];
  limitedCostIds: Array<Scalars['Long']>;
};


export type MutationUercRemoveCalculationObjectArgs = {
  calculationObjectId: Scalars['Long'];
};


export type MutationUercRemoveCalculationOtherCostsArgs = {
  calculationId: Scalars['Long'];
  calculationOtherCostIds: Array<Scalars['Long']>;
};


export type MutationUercRemoveCollectionMtrArgs = {
  input: RemoveCollectionMtrInput;
};


export type MutationUercRemoveCollectionRatioArgs = {
  calculationId: Scalars['Long'];
  collectionRatioId: Scalars['Long'];
};


export type MutationUercRemoveCollectionUerBaseCostRowsArgs = {
  baseRowIds: Array<Scalars['Long']>;
  calculationId: Scalars['Long'];
};


export type MutationUercRemoveFromWorArgs = {
  calculationId: Scalars['Long'];
  worRowIds: Array<Scalars['Long']>;
};


export type MutationUercRemoveUnusedCollectionMtrArgs = {
  calculationId: Scalars['Long'];
};


export type MutationUercRemoveUnusedCollectionMtrToWorkVolumeArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
};


export type MutationUercReorderCalculationComputedUerArgs = {
  calculationId: Scalars['Long'];
  movedComputedCostId: Scalars['Long'];
  placeAfterComputedCostId?: InputMaybe<Scalars['Long']>;
};


export type MutationUercReplaceCollectionMtrItemArgs = {
  input: ReplaceCollectionMtrItemInput;
};


export type MutationUercSetCalculationObjectGuaranteedVolumeArgs = {
  input: CalculationObjectGuaranteedVolumeInput;
};


export type MutationUercSetCollectionUerBaseCostRowPropertiesArgs = {
  calculationId: Scalars['Long'];
  input: CollectionUerBaseCostSetPropertiesInput;
};


export type MutationUercSetWorkVolumeValueArgs = {
  input: SetWorkVolumeValueInput;
};


export type MutationUercTransferWorkVolumeArgs = {
  input: TransferWorkVolumeInput;
};


export type MutationUercUpdateCalculationArgs = {
  calculationInput: UercCalculationUpdateInput;
};


export type MutationUercUpdateCalculationLimitedCostArgs = {
  id: Scalars['Long'];
  input: UercCalculationLimitedCostInput;
};


export type MutationUercUpdateCalculationObjectArgs = {
  input: CalculationObjectUpdateInput;
};


export type MutationUercUpdateCalculationOtherCostArgs = {
  id: Scalars['Long'];
  input: UercCalculationOtherCostInput;
};


export type MutationUercUpdateCalculationStatusArgs = {
  input: UercCalculationStatusInput;
};


export type MutationUercUpdateCalculationSubObjectArgs = {
  input: CalculationObjectUpdateInput;
};


export type MutationUercUpdateCollectionMtrArgs = {
  input: UpdateCollectionMtrInput;
};


export type MutationUercUpdateCollectionMtrToWorkVolumeArgs = {
  input: UpdateCollectionMtrToWorkVolumeInput;
};


export type MutationUercUpdateCollectionMtrUnitCurrentPriceArgs = {
  input: UpdateCollectionMtrUnitCurrentPriceInput;
};


export type MutationUercUpdateCollectionRatioArgs = {
  calculationId: Scalars['Long'];
  input: CollectionRatioUpdateInput;
};


export type MutationUercUpdateCollectionUerBaseCostArgs = {
  calculationId: Scalars['Long'];
  input: CollectionUerBaseCostUpdateInput;
};


export type MutationUercUpdateCollectionUerBaseCostWorkScopesArgs = {
  baseRowId: Scalars['Long'];
  inputs: Array<CollectionUerBaseCostWorkScopeUpdateInput>;
};


export type MutationUercUpdateComputedCostWorkRatioArgs = {
  calculationId: Scalars['Long'];
  computedCostId: Scalars['Long'];
  ratio: Scalars['Decimal'];
};


export type MutationUercUpdateIsIncludedInTransportCalculationArgs = {
  input: UpdateIsIncludedInTransportCalculationInput;
};


export type MutationUpdateCatalogLimitedCostTypeArgs = {
  id: Scalars['Int'];
  input: CatalogLimitedCostTypeInput;
};


export type MutationUpdateCatalogOtherCostTypeArgs = {
  input: CatalogOtherCostTypeUpdateInput;
};


export type MutationUpdateCatalogOtherCostVariableArgs = {
  input: CatalogOtherCostVariableUpdateInput;
};


export type MutationUpdateCatalogOtherCostVariableGroupArgs = {
  input: CatalogOtherCostVariableGroupUpdateInput;
};


export type MutationUpdateCatalogRatioArgs = {
  input: CatalogRatioUpdateInput;
};


export type MutationUpdateCatalogUerBaseCostWorkScopesArgs = {
  inputs: Array<CatalogUerBaseCostWorkScopeUpdateInput>;
  uerBaseCostId: Scalars['Long'];
};


export type MutationUpdateCatalogUerOtherCostTemplateArgs = {
  id: Scalars['Int'];
  input: CatalogUerOtherCostTemplateInput;
};


export type MutationUpdateGlobalLimitedCostArgs = {
  input: GlobalLimitedCostUpdateInput;
};


export type MutationUpdateGlobalOtherCostArgs = {
  input: GlobalOtherCostUpdateInput;
};


export type MutationUpdateProjectArgs = {
  projectInput: ProjectUpdateInput;
};

export type NullableOfActKc2StatusEnumOperationFilterInput = {
  eq?: InputMaybe<ActKc2StatusEnum>;
  in?: InputMaybe<Array<InputMaybe<ActKc2StatusEnum>>>;
  neq?: InputMaybe<ActKc2StatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<ActKc2StatusEnum>>>;
};

export type NullableOfBimActKc2StatusEnumOperationFilterInput = {
  eq?: InputMaybe<BimActKc2StatusEnum>;
  in?: InputMaybe<Array<InputMaybe<BimActKc2StatusEnum>>>;
  neq?: InputMaybe<BimActKc2StatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<BimActKc2StatusEnum>>>;
};

export type NullableOfBimChapterEnumOperationFilterInput = {
  eq?: InputMaybe<BimChapterEnum>;
  in?: InputMaybe<Array<InputMaybe<BimChapterEnum>>>;
  neq?: InputMaybe<BimChapterEnum>;
  nin?: InputMaybe<Array<InputMaybe<BimChapterEnum>>>;
};

export type NullableOfBimContractOtherStatusEnumOperationFilterInput = {
  eq?: InputMaybe<BimContractOtherStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<BimContractOtherStatusEnum>>>;
  neq?: InputMaybe<BimContractOtherStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<BimContractOtherStatusEnum>>>;
};

export type NullableOfBimLimitedCostTypeEnumOperationFilterInput = {
  eq?: InputMaybe<BimLimitedCostTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<BimLimitedCostTypeEnum>>>;
  neq?: InputMaybe<BimLimitedCostTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<BimLimitedCostTypeEnum>>>;
};

export type NullableOfBimWorkOrderPriceStatusEnumOperationFilterInput = {
  eq?: InputMaybe<BimWorkOrderPriceStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<BimWorkOrderPriceStatusEnum>>>;
  neq?: InputMaybe<BimWorkOrderPriceStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<BimWorkOrderPriceStatusEnum>>>;
};

export type NullableOfCalculationStatusEnumOperationFilterInput = {
  eq?: InputMaybe<CalculationStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<CalculationStatusEnum>>>;
  neq?: InputMaybe<CalculationStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<CalculationStatusEnum>>>;
};

export type NullableOfChapterEnumOperationFilterInput = {
  eq?: InputMaybe<ChapterEnum>;
  in?: InputMaybe<Array<InputMaybe<ChapterEnum>>>;
  neq?: InputMaybe<ChapterEnum>;
  nin?: InputMaybe<Array<InputMaybe<ChapterEnum>>>;
};

export type NullableOfCollectionUerBaseCostStatusOperationFilterInput = {
  eq?: InputMaybe<CollectionUerBaseCostStatus>;
  in?: InputMaybe<Array<InputMaybe<CollectionUerBaseCostStatus>>>;
  neq?: InputMaybe<CollectionUerBaseCostStatus>;
  nin?: InputMaybe<Array<InputMaybe<CollectionUerBaseCostStatus>>>;
};

export type NullableOfComputeRowTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ComputeRowTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<ComputeRowTypeEnum>>>;
  neq?: InputMaybe<ComputeRowTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<ComputeRowTypeEnum>>>;
};

export type NullableOfContractChangeStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractChangeStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<ContractChangeStatusEnum>>>;
  neq?: InputMaybe<ContractChangeStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<ContractChangeStatusEnum>>>;
};

export type NullableOfContractOtherStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractOtherStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<ContractOtherStatusEnum>>>;
  neq?: InputMaybe<ContractOtherStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<ContractOtherStatusEnum>>>;
};

export type NullableOfContractStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ContractStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<ContractStatusEnum>>>;
  neq?: InputMaybe<ContractStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<ContractStatusEnum>>>;
};

export type NullableOfContragentTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ContragentTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<ContragentTypeEnum>>>;
  neq?: InputMaybe<ContragentTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<ContragentTypeEnum>>>;
};

export type NullableOfDeviationEnumOperationFilterInput = {
  eq?: InputMaybe<DeviationEnum>;
  in?: InputMaybe<Array<InputMaybe<DeviationEnum>>>;
  neq?: InputMaybe<DeviationEnum>;
  nin?: InputMaybe<Array<InputMaybe<DeviationEnum>>>;
};

export type NullableOfDeviationTipEnumOperationFilterInput = {
  eq?: InputMaybe<DeviationTipEnum>;
  in?: InputMaybe<Array<InputMaybe<DeviationTipEnum>>>;
  neq?: InputMaybe<DeviationTipEnum>;
  nin?: InputMaybe<Array<InputMaybe<DeviationTipEnum>>>;
};

export type NullableOfDismantlingCoefficientTypeEnumOperationFilterInput = {
  eq?: InputMaybe<DismantlingCoefficientTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<DismantlingCoefficientTypeEnum>>>;
  neq?: InputMaybe<DismantlingCoefficientTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<DismantlingCoefficientTypeEnum>>>;
};

export type NullableOfHistoryChangeTypeOperationFilterInput = {
  eq?: InputMaybe<HistoryChangeType>;
  in?: InputMaybe<Array<InputMaybe<HistoryChangeType>>>;
  neq?: InputMaybe<HistoryChangeType>;
  nin?: InputMaybe<Array<InputMaybe<HistoryChangeType>>>;
};

export type NullableOfMtrStatusOperationFilterInput = {
  eq?: InputMaybe<MtrStatus>;
  in?: InputMaybe<Array<InputMaybe<MtrStatus>>>;
  neq?: InputMaybe<MtrStatus>;
  nin?: InputMaybe<Array<InputMaybe<MtrStatus>>>;
};

export type NullableOfMtrTypeEnumOperationFilterInput = {
  eq?: InputMaybe<MtrTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<MtrTypeEnum>>>;
  neq?: InputMaybe<MtrTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<MtrTypeEnum>>>;
};

export type NullableOfOtherCostCalculationTypeEnumOperationFilterInput = {
  eq?: InputMaybe<OtherCostCalculationTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<OtherCostCalculationTypeEnum>>>;
  neq?: InputMaybe<OtherCostCalculationTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<OtherCostCalculationTypeEnum>>>;
};

export type NullableOfPriceConstructionTypeRelationStatusEnumOperationFilterInput = {
  eq?: InputMaybe<PriceConstructionTypeRelationStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<PriceConstructionTypeRelationStatusEnum>>>;
  neq?: InputMaybe<PriceConstructionTypeRelationStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<PriceConstructionTypeRelationStatusEnum>>>;
};

export type NullableOfPricingTypeEnumOperationFilterInput = {
  eq?: InputMaybe<PricingTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<PricingTypeEnum>>>;
  neq?: InputMaybe<PricingTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<PricingTypeEnum>>>;
};

export type NullableOfProjectContractTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ProjectContractTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<ProjectContractTypeEnum>>>;
  neq?: InputMaybe<ProjectContractTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<ProjectContractTypeEnum>>>;
};

export type NullableOfRatioRecordStatusEnumOperationFilterInput = {
  eq?: InputMaybe<RatioRecordStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<RatioRecordStatusEnum>>>;
  neq?: InputMaybe<RatioRecordStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<RatioRecordStatusEnum>>>;
};

export type NullableOfRatioTypeEnumOperationFilterInput = {
  eq?: InputMaybe<RatioTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<RatioTypeEnum>>>;
  neq?: InputMaybe<RatioTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<RatioTypeEnum>>>;
};

export type NullableOfSectionEnumOperationFilterInput = {
  eq?: InputMaybe<SectionEnum>;
  in?: InputMaybe<Array<InputMaybe<SectionEnum>>>;
  neq?: InputMaybe<SectionEnum>;
  nin?: InputMaybe<Array<InputMaybe<SectionEnum>>>;
};

export type NullableOfSkzsActKc2StatusEnumOperationFilterInput = {
  eq?: InputMaybe<SkzsActKc2StatusEnum>;
  in?: InputMaybe<Array<InputMaybe<SkzsActKc2StatusEnum>>>;
  neq?: InputMaybe<SkzsActKc2StatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<SkzsActKc2StatusEnum>>>;
};

export type NullableOfUerBaseCostChangeTypeOperationFilterInput = {
  eq?: InputMaybe<UerBaseCostChangeType>;
  in?: InputMaybe<Array<InputMaybe<UerBaseCostChangeType>>>;
  neq?: InputMaybe<UerBaseCostChangeType>;
  nin?: InputMaybe<Array<InputMaybe<UerBaseCostChangeType>>>;
};

export type NullableOfUerClassifierEnumOperationFilterInput = {
  eq?: InputMaybe<UerClassifierEnum>;
  in?: InputMaybe<Array<InputMaybe<UerClassifierEnum>>>;
  neq?: InputMaybe<UerClassifierEnum>;
  nin?: InputMaybe<Array<InputMaybe<UerClassifierEnum>>>;
};

export type NullableOfWorkInSumEnumOperationFilterInput = {
  eq?: InputMaybe<WorkInSumEnum>;
  in?: InputMaybe<Array<InputMaybe<WorkInSumEnum>>>;
  neq?: InputMaybe<WorkInSumEnum>;
  nin?: InputMaybe<Array<InputMaybe<WorkInSumEnum>>>;
};

export type NullableOfWorkOrderPriceStatusEnumOperationFilterInput = {
  eq?: InputMaybe<WorkOrderPriceStatusEnum>;
  in?: InputMaybe<Array<InputMaybe<WorkOrderPriceStatusEnum>>>;
  neq?: InputMaybe<WorkOrderPriceStatusEnum>;
  nin?: InputMaybe<Array<InputMaybe<WorkOrderPriceStatusEnum>>>;
};

export type NullableOfWorkOrderPriceTypeEnumOperationFilterInput = {
  eq?: InputMaybe<WorkOrderPriceTypeEnum>;
  in?: InputMaybe<Array<InputMaybe<WorkOrderPriceTypeEnum>>>;
  neq?: InputMaybe<WorkOrderPriceTypeEnum>;
  nin?: InputMaybe<Array<InputMaybe<WorkOrderPriceTypeEnum>>>;
};

/** Составной идентификатор объекта строительства */
export type ObjectIds = {
  __typename?: 'ObjectIds';
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Составной идентификатор объекта строительства */
export type ObjectIdsFilterInput = {
  and?: InputMaybe<Array<ObjectIdsFilterInput>>;
  or?: InputMaybe<Array<ObjectIdsFilterInput>>;
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Составной идентификатор объекта строительства */
export type ObjectIdsInput = {
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Данные ВОР по сезонам */
export type ObjectSeasonsData = {
  __typename?: 'ObjectSeasonsData';
  /** Идентификатор объекта/подобъекта */
  calculationObjectId: Scalars['Long'];
  /** Стоимость, руб */
  seasonPrice?: Maybe<Scalars['Decimal']>;
  /** Объем */
  seasonVolume?: Maybe<Scalars['Decimal']>;
  /** Год */
  year: Scalars['Short'];
};

/** Данные ВОР по сезонам */
export type ObjectSeasonsDataInput = {
  /** Идентификатор объекта/подобъекта */
  calculationObjectId: Scalars['Long'];
  /** Стоимость, руб */
  seasonPrice?: InputMaybe<Scalars['Decimal']>;
  /** Объем */
  seasonVolume?: InputMaybe<Scalars['Decimal']>;
  /** Год */
  year: Scalars['Short'];
};

export type ObjectTransferItemInput = {
  /** Идентификатор объекта/подобъекта */
  calculationObjectId: Scalars['Long'];
  /** Процент переноса (0..100) */
  transferPercent: Scalars['Decimal'];
};

/** Данные объекта для переноса объёма из одного сезона в другой */
export type ObjectVolumeTransferDataInput = {
  /** Значение переноса в процентах */
  transferPercentValue: Scalars['Decimal'];
  /** ID объекта Изма к НЗ для которого нужно выполнить перенос */
  workOrderObjectChangeId?: InputMaybe<Scalars['Long']>;
  /**
   * ID объекта НЗ, для которого нужно создать объект Изма к НЗ при его отсутствии,
   *             и выполнить перенос в объект Изма к НЗ
   */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Виды вычисления стоимости прочих затрат договора */
export enum OtherCostCalculationTypeEnum {
  /** Расчет */
  Calculation = 'CALCULATION',
  /** По проценту */
  Percent = 'PERCENT'
}

export type OtherCostCalculationTypeEnumOperationFilterInput = {
  eq?: InputMaybe<OtherCostCalculationTypeEnum>;
  in?: InputMaybe<Array<OtherCostCalculationTypeEnum>>;
  neq?: InputMaybe<OtherCostCalculationTypeEnum>;
  nin?: InputMaybe<Array<OtherCostCalculationTypeEnum>>;
};

/** Статус связи Расценка-Вид строительства */
export enum PriceConstructionTypeRelationStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type PriceConstructionTypeRelationStatusEnumOperationFilterInput = {
  eq?: InputMaybe<PriceConstructionTypeRelationStatusEnum>;
  in?: InputMaybe<Array<PriceConstructionTypeRelationStatusEnum>>;
  neq?: InputMaybe<PriceConstructionTypeRelationStatusEnum>;
  nin?: InputMaybe<Array<PriceConstructionTypeRelationStatusEnum>>;
};

/** Признак наличия незаполненных К перехода */
export type PriceItemWorkRatioInfo = {
  __typename?: 'PriceItemWorkRatioInfo';
  /** В НЗ/Изме есть К перехода без значений */
  hasEmptyWorkRatios: Scalars['Boolean'];
};

/** Признак наличия незаполненных К перехода */
export type PriceItemWorkRatioInfoInput = {
  /** В НЗ/Изме есть К перехода без значений */
  hasEmptyWorkRatios: Scalars['Boolean'];
};

export type PriceListMtrRowCreateInput = {
  code: Scalars['String'];
  contractId: Scalars['Long'];
  justification?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  mtrType: MtrTypeEnum;
  name: Scalars['String'];
  supplyBy: ContragentTypeEnum;
  unit: Scalars['String'];
  unitCost: Scalars['Decimal'];
  unitWeight?: InputMaybe<Scalars['Decimal']>;
  volume?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListMtrRowData = {
  __typename?: 'PriceListMtrRowData';
  /** Признак редактируемости кода МТР */
  canEditKey: Scalars['Boolean'];
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  hasDuplicateNeighbours: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор элемента затрат на МТР (Код) */
  key?: Maybe<Scalars['String']>;
  /** Совмещенные MtrType и SupplyBasis */
  mtrSupplyAndType: MtrSupplyAndTypeEnum;
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Примечание */
  note?: Maybe<Scalars['String']>;
  /** Тип ценообразования */
  pricingType: PricingTypeEnum;
  /** Статус записи */
  status: MtrRecordStatusEnum;
  /** Базис поставки */
  supplyBasis?: Maybe<Scalars['String']>;
  /** Кем поставляется */
  supplyBy?: Maybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost: Scalars['Decimal'];
  /** Вес единицы */
  unitWeight?: Maybe<Scalars['Decimal']>;
  /** Объем */
  volume?: Maybe<Scalars['Decimal']>;
};

export type PriceListMtrRowDataFilterInput = {
  and?: InputMaybe<Array<PriceListMtrRowDataFilterInput>>;
  /** Признак редактируемости кода МТР */
  canEditKey?: InputMaybe<BooleanOperationFilterInput>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  hasDuplicateNeighbours?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор элемента затрат на МТР (Код) */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Совмещенные MtrType и SupplyBasis */
  mtrSupplyAndType?: InputMaybe<MtrSupplyAndTypeEnumOperationFilterInput>;
  /** Тип МТР */
  mtrType?: InputMaybe<NullableOfMtrTypeEnumOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Примечание */
  note?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<PriceListMtrRowDataFilterInput>>;
  /** Тип ценообразования */
  pricingType?: InputMaybe<PricingTypeEnumOperationFilterInput>;
  /** Статус записи */
  status?: InputMaybe<MtrRecordStatusEnumOperationFilterInput>;
  /** Базис поставки */
  supplyBasis?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<NullableOfContragentTypeEnumOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Вес единицы */
  unitWeight?: InputMaybe<DecimalOperationFilterInput>;
  /** Объем */
  volume?: InputMaybe<DecimalOperationFilterInput>;
};

export type PriceListMtrRowDataInput = {
  /** Признак редактируемости кода МТР */
  canEditKey: Scalars['Boolean'];
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  hasDuplicateNeighbours: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Уникальный идентификатор элемента затрат на МТР (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** Совмещенные MtrType и SupplyBasis */
  mtrSupplyAndType: MtrSupplyAndTypeEnum;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Примечание */
  note?: InputMaybe<Scalars['String']>;
  /** Тип ценообразования */
  pricingType: PricingTypeEnum;
  /** Статус записи */
  status: MtrRecordStatusEnum;
  /** Базис поставки */
  supplyBasis?: InputMaybe<Scalars['String']>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы */
  unitCost: Scalars['Decimal'];
  /** Вес единицы */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
  /** Объем */
  volume?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListMtrRowDataSortInput = {
  /** Признак редактируемости кода МТР */
  canEditKey?: InputMaybe<SortEnumType>;
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  hasDuplicateNeighbours?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<SortEnumType>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор элемента затрат на МТР (Код) */
  key?: InputMaybe<SortEnumType>;
  /** Совмещенные MtrType и SupplyBasis */
  mtrSupplyAndType?: InputMaybe<SortEnumType>;
  /** Тип МТР */
  mtrType?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Примечание */
  note?: InputMaybe<SortEnumType>;
  /** Тип ценообразования */
  pricingType?: InputMaybe<SortEnumType>;
  /** Статус записи */
  status?: InputMaybe<SortEnumType>;
  /** Базис поставки */
  supplyBasis?: InputMaybe<SortEnumType>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы */
  unitCost?: InputMaybe<SortEnumType>;
  /** Вес единицы */
  unitWeight?: InputMaybe<SortEnumType>;
  /** Объем */
  volume?: InputMaybe<SortEnumType>;
};

/** Входные данные для добавления МТР в Акт КС-2 */
export type PriceListMtrRowInput = {
  /** Идентификатор МТР */
  mtrRowId: Scalars['Long'];
  /** Обоснование добавления (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
};

export type PriceListMtrRowUpdateInput = {
  /** Шифр МТР */
  code: Scalars['String'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Уникальный идентификатор элемента затрат на МТР (Код) */
  key?: InputMaybe<Scalars['String']>;
  /** ID PriceListMtrRow */
  mtrRowId: Scalars['Long'];
  /** Тип МТР */
  mtrType: MtrTypeEnum;
  /** Кем поставляется */
  supplyBy: ContragentTypeEnum;
  /** Стоимость единицы */
  unitCost: Scalars['Decimal'];
  /** Вес единицы */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListRatioAppliesToData = {
  __typename?: 'PriceListRatioAppliesToData';
  /** Область применения */
  appliesToCode: Scalars['String'];
  /** Область применения (имя УЕР) */
  appliesToCodeName: Scalars['String'];
  /** Область применения (Идентификатор УЕР) */
  appliesToId: Scalars['Long'];
  /** Активная связь */
  isUsedLink: Scalars['Boolean'];
  /** Код группы УЕР прайс-листа */
  uerPriceListGroupCode?: Maybe<Scalars['String']>;
  /** ID для UerPriceListGroupName */
  uerPriceListGroupId?: Maybe<Scalars['Long']>;
  /** Имя группы УЕР прайс-листа */
  uerPriceListGroupName?: Maybe<Scalars['String']>;
  /** Идентификатор секции коэффициента */
  uerPriceListSectionId?: Maybe<Scalars['Long']>;
  /** Наименование секции коэффициента */
  uerPriceListSectionName?: Maybe<Scalars['String']>;
};

export type PriceListRatioAppliesToDataInput = {
  /** Область применения */
  appliesToCode: Scalars['String'];
  /** Область применения (имя УЕР) */
  appliesToCodeName: Scalars['String'];
  /** Область применения (Идентификатор УЕР) */
  appliesToId: Scalars['Long'];
  /** Активная связь */
  isUsedLink: Scalars['Boolean'];
  /** Код группы УЕР прайс-листа */
  uerPriceListGroupCode?: InputMaybe<Scalars['String']>;
  /** ID для UerPriceListGroupName */
  uerPriceListGroupId?: InputMaybe<Scalars['Long']>;
  /** Имя группы УЕР прайс-листа */
  uerPriceListGroupName?: InputMaybe<Scalars['String']>;
  /** Идентификатор секции коэффициента */
  uerPriceListSectionId?: InputMaybe<Scalars['Long']>;
  /** Наименование секции коэффициента */
  uerPriceListSectionName?: InputMaybe<Scalars['String']>;
};

/** Структура данных для отображения табличной части Прейскуранта коэффициентов (УЕР) */
export type PriceListRatioCoefficientRowData = {
  __typename?: 'PriceListRatioCoefficientRowData';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Статус коэффициента */
  status: RatioRecordStatusEnum;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

/** Структура данных для отображения табличной части Прейскуранта коэффициентов (УЕР) */
export type PriceListRatioCoefficientRowDataFilterInput = {
  and?: InputMaybe<Array<PriceListRatioCoefficientRowDataFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PriceListRatioCoefficientRowDataFilterInput>>;
  /** Статус коэффициента */
  status?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  /** Условия производства работ */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Структура данных для отображения табличной части Прейскуранта коэффициентов (УЕР) */
export type PriceListRatioCoefficientRowDataSortInput = {
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<SortEnumType>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  status?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  workConditions?: InputMaybe<SortEnumType>;
};

export type PriceListRatioFilterData = {
  __typename?: 'PriceListRatioFilterData';
  /** Код коэффициента */
  ratioCode: Scalars['String'];
  /** Код УЕР, к которому применяется коэффициент */
  uerCode: Scalars['String'];
};

export type PriceListRatioFilterDataFilterInput = {
  and?: InputMaybe<Array<PriceListRatioFilterDataFilterInput>>;
  or?: InputMaybe<Array<PriceListRatioFilterDataFilterInput>>;
  /** Код коэффициента */
  ratioCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код УЕР, к которому применяется коэффициент */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type PriceListRatioFilterDataSortInput = {
  /** Код коэффициента */
  ratioCode?: InputMaybe<SortEnumType>;
  /** Код УЕР, к которому применяется коэффициент */
  uerCode?: InputMaybe<SortEnumType>;
};

export type PriceListRatioGroupedRowData = {
  __typename?: 'PriceListRatioGroupedRowData';
  appliesTo: Array<PriceListRatioAppliesToData>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы коэффициента */
  groupId?: Maybe<Scalars['Long']>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: Maybe<Scalars['Boolean']>;
  /** Наименование группы коэффициента */
  groupName?: Maybe<Scalars['String']>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент создан вручную */
  isCustom?: Maybe<Scalars['Boolean']>;
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /**
   * Коэффициент используется в НЗ\Изм в статусе "На формировании"
   *             или в НЗ в статусе "В работе" без указания значений в Актах КС-2
   */
  onFormationOrInProgressWithNoActualCostUsage: Scalars['Boolean'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус расценки */
  status: RatioRecordStatusEnum;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

export type PriceListRatioGroupedRowDataInput = {
  appliesTo: Array<PriceListRatioAppliesToDataInput>;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<Scalars['Long']>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<Scalars['Boolean']>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<Scalars['String']>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<Scalars['Boolean']>;
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /**
   * Коэффициент используется в НЗ\Изм в статусе "На формировании"
   *             или в НЗ в статусе "В работе" без указания значений в Актах КС-2
   */
  onFormationOrInProgressWithNoActualCostUsage: Scalars['Boolean'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус расценки */
  status: RatioRecordStatusEnum;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

/** Данные фильтра по наименованию коэффициента или расценки */
export type PriceListRatioNameFilterData = {
  __typename?: 'PriceListRatioNameFilterData';
  /** Признак того, что имя является коэффициентом */
  isRatio: Scalars['Boolean'];
  /** Признак того, что имя является расценкой */
  isUer: Scalars['Boolean'];
  /** Наименование коэффициента или расценки */
  name: Scalars['String'];
};

/** Данные фильтра по наименованию коэффициента или расценки */
export type PriceListRatioNameFilterDataFilterInput = {
  and?: InputMaybe<Array<PriceListRatioNameFilterDataFilterInput>>;
  /** Признак того, что имя является коэффициентом */
  isRatio?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что имя является расценкой */
  isUer?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование коэффициента или расценки */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<PriceListRatioNameFilterDataFilterInput>>;
};

/** Данные фильтра по наименованию коэффициента или расценки */
export type PriceListRatioNameFilterDataSortInput = {
  /** Признак того, что имя является коэффициентом */
  isRatio?: InputMaybe<SortEnumType>;
  /** Признак того, что имя является расценкой */
  isUer?: InputMaybe<SortEnumType>;
  /** Наименование коэффициента или расценки */
  name?: InputMaybe<SortEnumType>;
};

export type PriceListRatioRowCreateInput = {
  appliesToUerRowIds?: InputMaybe<Array<Scalars['Long']>>;
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  justification?: InputMaybe<Scalars['String']>;
  kem: Scalars['Decimal'];
  kmat: Scalars['Decimal'];
  knr: Scalars['Decimal'];
  kozp: Scalars['Decimal'];
  ksp: Scalars['Decimal'];
  ktz: Scalars['Decimal'];
  ktzzpm: Scalars['Decimal'];
  ratioGroupId?: InputMaybe<Scalars['Long']>;
  ratioType: RatioTypeEnum;
  targetUerId?: InputMaybe<Scalars['Long']>;
  workConditions: Scalars['String'];
};

/** Структура данных представления коэффициента для отображения в прейскуранте */
export type PriceListRatioRowData = {
  __typename?: 'PriceListRatioRowData';
  /** Область применения (Код) */
  appliesToCode: Scalars['String'];
  /** Область применения (имя УЕР) */
  appliesToCodeName: Scalars['String'];
  /** Полное имя расценки УЕР */
  appliesToFullName: Scalars['String'];
  /** Область применения (идентификатор) */
  appliesToId: Scalars['Long'];
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus: RatioRecordStatusEnum;
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы коэффициента */
  groupId?: Maybe<Scalars['Long']>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: Maybe<Scalars['Boolean']>;
  /** Наименование группы коэффициента */
  groupName?: Maybe<Scalars['String']>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент создан вручную */
  isCustom?: Maybe<Scalars['Boolean']>;
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Номер из шифра */
  number?: Maybe<Scalars['Int']>;
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: RatioRecordStatusEnum;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: Maybe<Scalars['Long']>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: Maybe<Scalars['String']>;
  /** Код группы УЕР прайс-листа */
  uerPriceListGroupCode?: Maybe<Scalars['String']>;
  /** Полное имя группы УЕР прайс-листа */
  uerPriceListGroupFullName?: Maybe<Scalars['String']>;
  /** Идентификатор группы УЕР прайс-листа */
  uerPriceListGroupId?: Maybe<Scalars['Long']>;
  /** Имя группы УЕР прайс-листа */
  uerPriceListGroupName?: Maybe<Scalars['String']>;
  /** Идентификатор секции коэффициента */
  uerPriceListSectionId?: Maybe<Scalars['Long']>;
  /** Наименование секции коэффициента */
  uerPriceListSectionName?: Maybe<Scalars['String']>;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

/** Структура данных представления коэффициента для отображения в прейскуранте */
export type PriceListRatioRowDataFilterInput = {
  and?: InputMaybe<Array<PriceListRatioRowDataFilterInput>>;
  /** Область применения (Код) */
  appliesToCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Область применения (имя УЕР) */
  appliesToCodeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Полное имя расценки УЕР */
  appliesToFullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Область применения (идентификатор) */
  appliesToId?: InputMaybe<LongOperationFilterInput>;
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<NullableOfDismantlingCoefficientTypeEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Номер из шифра */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PriceListRatioRowDataFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Статус коэффициента */
  status?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код группы УЕР прайс-листа */
  uerPriceListGroupCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Полное имя группы УЕР прайс-листа */
  uerPriceListGroupFullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор группы УЕР прайс-листа */
  uerPriceListGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Имя группы УЕР прайс-листа */
  uerPriceListGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор секции коэффициента */
  uerPriceListSectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование секции коэффициента */
  uerPriceListSectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Условия производства работ */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Структура данных представления коэффициента для отображения в прейскуранте */
export type PriceListRatioRowDataSortInput = {
  /** Область применения (Код) */
  appliesToCode?: InputMaybe<SortEnumType>;
  /** Область применения (имя УЕР) */
  appliesToCodeName?: InputMaybe<SortEnumType>;
  /** Полное имя расценки УЕР */
  appliesToFullName?: InputMaybe<SortEnumType>;
  /** Область применения (идентификатор) */
  appliesToId?: InputMaybe<SortEnumType>;
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus?: InputMaybe<SortEnumType>;
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<SortEnumType>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<SortEnumType>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<SortEnumType>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<SortEnumType>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<SortEnumType>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Номер из шифра */
  number?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<SortEnumType>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<SortEnumType>;
  /** Код группы УЕР прайс-листа */
  uerPriceListGroupCode?: InputMaybe<SortEnumType>;
  /** Полное имя группы УЕР прайс-листа */
  uerPriceListGroupFullName?: InputMaybe<SortEnumType>;
  /** Идентификатор группы УЕР прайс-листа */
  uerPriceListGroupId?: InputMaybe<SortEnumType>;
  /** Имя группы УЕР прайс-листа */
  uerPriceListGroupName?: InputMaybe<SortEnumType>;
  /** Идентификатор секции коэффициента */
  uerPriceListSectionId?: InputMaybe<SortEnumType>;
  /** Наименование секции коэффициента */
  uerPriceListSectionName?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  workConditions?: InputMaybe<SortEnumType>;
};

/** Входные данные для добавления коэффициента в Акт КС-2 */
export type PriceListRatioRowInput = {
  /** Идентификатор коэффициента */
  ratioRowId: Scalars['Long'];
  /** Обоснование добавления (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
};

export type PriceListRatioRowUpdateInput = {
  appliesToUerRowIds?: InputMaybe<Array<Scalars['Long']>>;
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  justification?: InputMaybe<Scalars['String']>;
  kem: Scalars['Decimal'];
  kmat: Scalars['Decimal'];
  knr: Scalars['Decimal'];
  kozp: Scalars['Decimal'];
  ksp: Scalars['Decimal'];
  ktz: Scalars['Decimal'];
  ktzzpm: Scalars['Decimal'];
  ratioGroupId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор коэффициента */
  ratioRowId: Scalars['Long'];
  ratioType: RatioTypeEnum;
  targetUerId?: InputMaybe<Scalars['Long']>;
  workConditions: Scalars['String'];
};

/** Структура данных для отображения расценок из области применения коэффициента */
export type PriceListRatioUerRowData = {
  __typename?: 'PriceListRatioUerRowData';
  /** Шифр расценки */
  appliesToCode: Scalars['String'];
  /** Наименование расценки */
  appliesToCodeName: Scalars['String'];
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId: Scalars['Long'];
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus: RatioRecordStatusEnum;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  ratioRowId: Scalars['Long'];
};

/** Структура данных для отображения расценок из области применения коэффициента */
export type PriceListRatioUerRowDataFilterInput = {
  and?: InputMaybe<Array<PriceListRatioUerRowDataFilterInput>>;
  /** Шифр расценки */
  appliesToCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование расценки */
  appliesToCodeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId?: InputMaybe<LongOperationFilterInput>;
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  or?: InputMaybe<Array<PriceListRatioUerRowDataFilterInput>>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  ratioRowId?: InputMaybe<LongOperationFilterInput>;
};

/** Структура данных для отображения расценок из области применения коэффициента */
export type PriceListRatioUerRowDataSortInput = {
  /** Шифр расценки */
  appliesToCode?: InputMaybe<SortEnumType>;
  /** Наименование расценки */
  appliesToCodeName?: InputMaybe<SortEnumType>;
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId?: InputMaybe<SortEnumType>;
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  ratioRowId?: InputMaybe<SortEnumType>;
};

/** Структура данных для отображения расценок к коэффициенту по объекту Изм. к НЗ */
export type PriceListRatioUerRowForWorkOrderChange = {
  __typename?: 'PriceListRatioUerRowForWorkOrderChange';
  /** Шифр расценки */
  appliesToCode: Scalars['String'];
  /** Наименование расценки */
  appliesToCodeName: Scalars['String'];
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId: Scalars['Long'];
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus: WorkOrderPriceStatusEnum;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id: Scalars['Long'];
};

/** Структура данных для отображения расценок к коэффициенту по объекту Изм. к НЗ */
export type PriceListRatioUerRowForWorkOrderChangeFilterInput = {
  and?: InputMaybe<Array<PriceListRatioUerRowForWorkOrderChangeFilterInput>>;
  /** Шифр расценки */
  appliesToCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование расценки */
  appliesToCodeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId?: InputMaybe<LongOperationFilterInput>;
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus?: InputMaybe<WorkOrderPriceStatusEnumOperationFilterInput>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PriceListRatioUerRowForWorkOrderChangeFilterInput>>;
};

/** Структура данных для отображения расценок к коэффициенту по объекту Изм. к НЗ */
export type PriceListRatioUerRowForWorkOrderChangeSortInput = {
  /** Шифр расценки */
  appliesToCode?: InputMaybe<SortEnumType>;
  /** Наименование расценки */
  appliesToCodeName?: InputMaybe<SortEnumType>;
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId?: InputMaybe<SortEnumType>;
  /** Статус связи коэффициент расценка */
  appliesToLinkStatus?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id?: InputMaybe<SortEnumType>;
};

export enum PriceListTypeEnum {
  /** МТР */
  Mtr = 'MTR',
  /** Прочие */
  Others = 'OTHERS',
  /** Коэффициенты */
  Ratio = 'RATIO',
  /** Расценки */
  Uer = 'UER'
}

export type PriceListUerAndWorkScopeNameData = {
  __typename?: 'PriceListUerAndWorkScopeNameData';
  /** Идентификатор расценки */
  id: Scalars['Long'];
  /** Признак, что запись является группой */
  isGroup: Scalars['Boolean'];
  /** Признак, что запись является секцией */
  isSection: Scalars['Boolean'];
  /** Признак, что запись является расценкой */
  isUer: Scalars['Boolean'];
  /** Признак, что запись является работой */
  isWorkScope: Scalars['Boolean'];
  /** Наименование расценки или работы */
  name: Scalars['String'];
};

export type PriceListUerAndWorkScopeNameDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerAndWorkScopeNameDataFilterInput>>;
  /** Идентификатор расценки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак, что запись является группой */
  isGroup?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак, что запись является секцией */
  isSection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак, что запись является расценкой */
  isUer?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак, что запись является работой */
  isWorkScope?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование расценки или работы */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<PriceListUerAndWorkScopeNameDataFilterInput>>;
};

export type PriceListUerAndWorkScopeNameDataSortInput = {
  /** Идентификатор расценки */
  id?: InputMaybe<SortEnumType>;
  /** Признак, что запись является группой */
  isGroup?: InputMaybe<SortEnumType>;
  /** Признак, что запись является секцией */
  isSection?: InputMaybe<SortEnumType>;
  /** Признак, что запись является расценкой */
  isUer?: InputMaybe<SortEnumType>;
  /** Признак, что запись является работой */
  isWorkScope?: InputMaybe<SortEnumType>;
  /** Наименование расценки или работы */
  name?: InputMaybe<SortEnumType>;
};

export type PriceListUerDismantlingRatioData = {
  __typename?: 'PriceListUerDismantlingRatioData';
  clientId: Scalars['String'];
  /** Признак того, что Id расценки находится в массиве preselectedUerBaseRowIds */
  isPreselected?: Maybe<Scalars['Boolean']>;
  /** Признак родительского коэффициента */
  isRatio?: Maybe<Scalars['Boolean']>;
  /** Признак строки расценки */
  isUerBaseRow?: Maybe<Scalars['Boolean']>;
  /** Шифр коэффциента */
  ratioCode?: Maybe<Scalars['String']>;
  /** Id коэффициента */
  ratioId?: Maybe<Scalars['Long']>;
  /** Шифр расценки */
  uerCode?: Maybe<Scalars['String']>;
  /** Шифр группы */
  uerGroupCode?: Maybe<Scalars['String']>;
  /** Имя группы */
  uerGroupName?: Maybe<Scalars['String']>;
  /** Id расценки */
  uerId?: Maybe<Scalars['Long']>;
  /** Наименовение расценки */
  uerName?: Maybe<Scalars['String']>;
  /** Ед. изм */
  unit?: Maybe<Scalars['String']>;
};

export type PriceListUerDismantlingRatioDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerDismantlingRatioDataFilterInput>>;
  clientId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак того, что Id расценки находится в массиве preselectedUerBaseRowIds */
  isPreselected?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак родительского коэффициента */
  isRatio?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки расценки */
  isUerBaseRow?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PriceListUerDismantlingRatioDataFilterInput>>;
  /** Шифр коэффциента */
  ratioCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id коэффициента */
  ratioId?: InputMaybe<LongOperationFilterInput>;
  /** Шифр расценки */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр группы */
  uerGroupCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Имя группы */
  uerGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id расценки */
  uerId?: InputMaybe<LongOperationFilterInput>;
  /** Наименовение расценки */
  uerName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Ед. изм */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type PriceListUerDismantlingRatioDataSortInput = {
  clientId?: InputMaybe<SortEnumType>;
  /** Признак того, что Id расценки находится в массиве preselectedUerBaseRowIds */
  isPreselected?: InputMaybe<SortEnumType>;
  /** Признак родительского коэффициента */
  isRatio?: InputMaybe<SortEnumType>;
  /** Признак строки расценки */
  isUerBaseRow?: InputMaybe<SortEnumType>;
  /** Шифр коэффциента */
  ratioCode?: InputMaybe<SortEnumType>;
  /** Id коэффициента */
  ratioId?: InputMaybe<SortEnumType>;
  /** Шифр расценки */
  uerCode?: InputMaybe<SortEnumType>;
  /** Шифр группы */
  uerGroupCode?: InputMaybe<SortEnumType>;
  /** Имя группы */
  uerGroupName?: InputMaybe<SortEnumType>;
  /** Id расценки */
  uerId?: InputMaybe<SortEnumType>;
  /** Наименовение расценки */
  uerName?: InputMaybe<SortEnumType>;
  /** Ед. изм */
  unit?: InputMaybe<SortEnumType>;
};

/** Коэффициент для добавления расценки в его область применения */
export type PriceListUerRatioRow = {
  __typename?: 'PriceListUerRatioRow';
  /** Шифр коэффициента */
  code: Scalars['String'];
  /** Идентификатор вида работ */
  groupId?: Maybe<Scalars['Long']>;
  /** Наименование вида работ коэффициента */
  groupName?: Maybe<Scalars['String']>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id: Scalars['Long'];
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Номер коэфа из шифра */
  number: Scalars['Int'];
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: RatioRecordStatusEnum;
  /** Наименование коэффициента */
  workConditions: Scalars['String'];
};

/** Коэффициент для добавления расценки в его область применения */
export type PriceListUerRatioRowFilterInput = {
  and?: InputMaybe<Array<PriceListUerRatioRowFilterInput>>;
  /** Шифр коэффициента */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор вида работ */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование вида работ коэффициента */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Номер коэфа из шифра */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PriceListUerRatioRowFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Статус коэффициента */
  status?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  /** Наименование коэффициента */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Коэффициент для добавления расценки в его область применения */
export type PriceListUerRatioRowSortInput = {
  /** Шифр коэффициента */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор вида работ */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование вида работ коэффициента */
  groupName?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Номер коэфа из шифра */
  number?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  status?: InputMaybe<SortEnumType>;
  /** Наименование коэффициента */
  workConditions?: InputMaybe<SortEnumType>;
};

export type PriceListUerRowBase = {
  __typename?: 'PriceListUerRowBase';
  /** Глава расценки */
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  groupCode?: Maybe<Scalars['String']>;
  groupId: Scalars['Long'];
  groupName: Scalars['String'];
  id: Scalars['Long'];
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Статус связи */
  linkStatus: PriceConstructionTypeRelationStatusEnum;
  name: Scalars['String'];
  sectionId: Scalars['Long'];
  sectionIsArtificial?: Maybe<Scalars['Boolean']>;
  sectionName: Scalars['String'];
  /** Статус расценки */
  status: UerRecordStatusEnum;
  /** Тип расценки */
  uerClassifier?: Maybe<UerClassifierEnum>;
  unit: Scalars['String'];
};

export type PriceListUerRowBaseFilterInput = {
  and?: InputMaybe<Array<PriceListUerRowBaseFilterInput>>;
  /** Глава расценки */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupId?: InputMaybe<LongOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус связи */
  linkStatus?: InputMaybe<PriceConstructionTypeRelationStatusEnumOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<PriceListUerRowBaseFilterInput>>;
  sectionId?: InputMaybe<LongOperationFilterInput>;
  sectionIsArtificial?: InputMaybe<BooleanOperationFilterInput>;
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус расценки */
  status?: InputMaybe<UerRecordStatusEnumOperationFilterInput>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<NullableOfUerClassifierEnumOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type PriceListUerRowBaseSortInput = {
  /** Глава расценки */
  chapter?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  groupCode?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  groupName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Статус связи */
  linkStatus?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sectionId?: InputMaybe<SortEnumType>;
  sectionIsArtificial?: InputMaybe<SortEnumType>;
  sectionName?: InputMaybe<SortEnumType>;
  /** Статус расценки */
  status?: InputMaybe<SortEnumType>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
};

export type PriceListUerRowBasisData = {
  __typename?: 'PriceListUerRowBasisData';
  basePrice: PriceListUerRowPriceBasisData;
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  currentPrices: Array<PriceListUerRowPriceCurrentBasisData>;
  group: Scalars['String'];
  name: Scalars['String'];
  section: Scalars['String'];
  unit: Scalars['String'];
  version?: Maybe<Scalars['String']>;
  workScopes: Array<PriceListUerWorkScopeBasisData>;
};

export type PriceListUerRowBasisDataInput = {
  basePrice: PriceListUerRowPriceBasisDataInput;
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  currentPrices: Array<PriceListUerRowPriceCurrentBasisDataInput>;
  group: Scalars['String'];
  name: Scalars['String'];
  section: Scalars['String'];
  unit: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
  workScopes: Array<PriceListUerWorkScopeBasisDataInput>;
};

export type PriceListUerRowCreateInput = {
  basePrice: PriceListUerRowPriceInput;
  chapter: ChapterEnum;
  code: Scalars['String'];
  contractId?: InputMaybe<Scalars['Long']>;
  currentPrices: Array<PriceListUerRowPriceCurrentCreateInput>;
  group: Scalars['String'];
  justification?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  ratioIds?: InputMaybe<Array<Scalars['Long']>>;
  section: Scalars['String'];
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  unit: Scalars['String'];
  version: Scalars['String'];
  workKind: PriceListUerRowWorkInput;
  workScopes: Array<PriceListUerWorkScopeCreateInput>;
};

/** Сглаженная структура сущности УЕР прайс-листа (base row с ссылками на значения зависимых сущностей) */
export type PriceListUerRowData = {
  __typename?: 'PriceListUerRowData';
  basePrice: PriceListUerRowPriceData;
  /** Глава расценки */
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  currentPrices: Array<PriceListUerRowPriceCurrentData>;
  groupCode?: Maybe<Scalars['String']>;
  /** Полное имя группы (подраздела) */
  groupFullName: Scalars['String'];
  groupId: Scalars['Long'];
  groupName: Scalars['String'];
  /** Есть виды строительства со статусом новая запись */
  hasNewConstructionTypeRelations?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Статус связи */
  linkStatus: PriceConstructionTypeRelationStatusEnum;
  name: Scalars['String'];
  sectionId: Scalars['Long'];
  sectionIsArtificial?: Maybe<Scalars['Boolean']>;
  sectionName: Scalars['String'];
  /** Статус расценки */
  status: UerRecordStatusEnum;
  /** Тип расценки */
  uerClassifier?: Maybe<UerClassifierEnum>;
  unit: Scalars['String'];
  /** Версия */
  version?: Maybe<Scalars['String']>;
  /** Виды работ */
  workKind: PriceListUerRowWorkData;
  /** Состав работ для этого УЕР */
  workScopes: Array<PriceListUerWorkScopeData>;
};

/** Сглаженная структура сущности УЕР прайс-листа (base row с ссылками на значения зависимых сущностей) */
export type PriceListUerRowDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerRowDataFilterInput>>;
  basePrice?: InputMaybe<PriceListUerRowPriceDataFilterInput>;
  /** Глава расценки */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  currentPrices?: InputMaybe<ListFilterInputTypeOfPriceListUerRowPriceCurrentDataFilterInput>;
  groupCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Полное имя группы (подраздела) */
  groupFullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupId?: InputMaybe<LongOperationFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Есть виды строительства со статусом новая запись */
  hasNewConstructionTypeRelations?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус связи */
  linkStatus?: InputMaybe<PriceConstructionTypeRelationStatusEnumOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<PriceListUerRowDataFilterInput>>;
  sectionId?: InputMaybe<LongOperationFilterInput>;
  sectionIsArtificial?: InputMaybe<BooleanOperationFilterInput>;
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус расценки */
  status?: InputMaybe<UerRecordStatusEnumOperationFilterInput>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<NullableOfUerClassifierEnumOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Версия */
  version?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Виды работ */
  workKind?: InputMaybe<PriceListUerRowWorkDataFilterInput>;
  /** Состав работ для этого УЕР */
  workScopes?: InputMaybe<ListFilterInputTypeOfPriceListUerWorkScopeDataFilterInput>;
};

/** Сглаженная структура сущности УЕР прайс-листа (base row с ссылками на значения зависимых сущностей) */
export type PriceListUerRowDataInput = {
  basePrice: PriceListUerRowPriceDataInput;
  /** Глава расценки */
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  currentPrices: Array<PriceListUerRowPriceCurrentDataInput>;
  groupCode?: InputMaybe<Scalars['String']>;
  /** Полное имя группы (подраздела) */
  groupFullName: Scalars['String'];
  groupId: Scalars['Long'];
  groupName: Scalars['String'];
  /** Есть виды строительства со статусом новая запись */
  hasNewConstructionTypeRelations?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Статус связи */
  linkStatus: PriceConstructionTypeRelationStatusEnum;
  name: Scalars['String'];
  sectionId: Scalars['Long'];
  sectionIsArtificial?: InputMaybe<Scalars['Boolean']>;
  sectionName: Scalars['String'];
  /** Статус расценки */
  status: UerRecordStatusEnum;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  unit: Scalars['String'];
  /** Версия */
  version?: InputMaybe<Scalars['String']>;
  /** Виды работ */
  workKind: PriceListUerRowWorkDataInput;
  /** Состав работ для этого УЕР */
  workScopes: Array<PriceListUerWorkScopeDataInput>;
};

/** Сглаженная структура сущности УЕР прайс-листа (base row с ссылками на значения зависимых сущностей) */
export type PriceListUerRowDataSortInput = {
  basePrice?: InputMaybe<PriceListUerRowPriceDataSortInput>;
  /** Глава расценки */
  chapter?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  groupCode?: InputMaybe<SortEnumType>;
  /** Полное имя группы (подраздела) */
  groupFullName?: InputMaybe<SortEnumType>;
  groupId?: InputMaybe<SortEnumType>;
  groupName?: InputMaybe<SortEnumType>;
  /** Есть виды строительства со статусом новая запись */
  hasNewConstructionTypeRelations?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  /** Есть в акте? */
  isIncludedInAct?: InputMaybe<SortEnumType>;
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Статус связи */
  linkStatus?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  sectionId?: InputMaybe<SortEnumType>;
  sectionIsArtificial?: InputMaybe<SortEnumType>;
  sectionName?: InputMaybe<SortEnumType>;
  /** Статус расценки */
  status?: InputMaybe<SortEnumType>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<SortEnumType>;
  /** Версия */
  version?: InputMaybe<SortEnumType>;
  /** Виды работ */
  workKind?: InputMaybe<PriceListUerRowWorkDataSortInput>;
};

/** Входные данные для добавления расценки в Акт КС-2 */
export type PriceListUerRowInput = {
  /** Обоснование добавления (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор расценки */
  uerBaseRowId: Scalars['Long'];
};

export type PriceListUerRowPriceBasisData = {
  __typename?: 'PriceListUerRowPriceBasisData';
  emm?: Maybe<Scalars['Decimal']>;
  eqp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  pir?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  trn?: Maybe<Scalars['Decimal']>;
  unitCost?: Maybe<Scalars['Decimal']>;
  zpm?: Maybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceBasisDataInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  eqp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  pir?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  trn?: InputMaybe<Scalars['Decimal']>;
  unitCost?: InputMaybe<Scalars['Decimal']>;
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceCurrentBasisData = {
  __typename?: 'PriceListUerRowPriceCurrentBasisData';
  constructionTypeId: Scalars['Int'];
  emm?: Maybe<Scalars['Decimal']>;
  eqp?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  pir?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  trn?: Maybe<Scalars['Decimal']>;
  unitCost?: Maybe<Scalars['Decimal']>;
  unitCostWithOther?: Maybe<Scalars['Decimal']>;
  zpm?: Maybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceCurrentBasisDataInput = {
  constructionTypeId: Scalars['Int'];
  emm?: InputMaybe<Scalars['Decimal']>;
  eqp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  pir?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  trn?: InputMaybe<Scalars['Decimal']>;
  unitCost?: InputMaybe<Scalars['Decimal']>;
  unitCostWithOther?: InputMaybe<Scalars['Decimal']>;
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceCurrentCreateInput = {
  constructionTypeId: Scalars['Int'];
  emm?: InputMaybe<Scalars['Decimal']>;
  eqp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  pir?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  trn?: InputMaybe<Scalars['Decimal']>;
  unitCost?: InputMaybe<Scalars['Decimal']>;
  unitCostWithOther?: InputMaybe<Scalars['Decimal']>;
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceCurrentData = {
  __typename?: 'PriceListUerRowPriceCurrentData';
  constructionTypeId: Scalars['Int'];
  constructionTypeName: Scalars['String'];
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: Maybe<PriceConstructionTypeRelationStatusEnum>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: Maybe<Scalars['Decimal']>;
  unitCostWithOther?: Maybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceCurrentDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerRowPriceCurrentDataFilterInput>>;
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  constructionTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: InputMaybe<NullableOfPriceConstructionTypeRelationStatusEnumOperationFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование */
  eqp?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PriceListUerRowPriceCurrentDataFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<DecimalOperationFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Перевозка */
  trn?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  unitCostWithOther?: InputMaybe<DecimalOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

export type PriceListUerRowPriceCurrentDataInput = {
  constructionTypeId: Scalars['Int'];
  constructionTypeName: Scalars['String'];
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: InputMaybe<PriceConstructionTypeRelationStatusEnum>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<Scalars['Decimal']>;
  unitCostWithOther?: InputMaybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceData = {
  __typename?: 'PriceListUerRowPriceData';
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: Maybe<PriceConstructionTypeRelationStatusEnum>;
  /** Эксплуатация машин и механизмов */
  emm?: Maybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: Maybe<Scalars['Decimal']>;
  /** Материально-технические ресурсы */
  mtr?: Maybe<Scalars['Decimal']>;
  /** Накладные расходы */
  nr?: Maybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: Maybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: Maybe<Scalars['Decimal']>;
  /** Сметная прибыль */
  sp?: Maybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: Maybe<Scalars['Decimal']>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: Maybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerRowPriceDataFilterInput>>;
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: InputMaybe<NullableOfPriceConstructionTypeRelationStatusEnumOperationFilterInput>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<DecimalOperationFilterInput>;
  /** Оборудование */
  eqp?: InputMaybe<DecimalOperationFilterInput>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<DecimalOperationFilterInput>;
  /** Накладные расходы */
  nr?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<PriceListUerRowPriceDataFilterInput>>;
  /** Основная заработная плата */
  ozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<DecimalOperationFilterInput>;
  /** Сметная прибыль */
  sp?: InputMaybe<DecimalOperationFilterInput>;
  /** Перевозка */
  trn?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<DecimalOperationFilterInput>;
};

export type PriceListUerRowPriceDataInput = {
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: InputMaybe<PriceConstructionTypeRelationStatusEnum>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<Scalars['Decimal']>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type PriceListUerRowPriceDataSortInput = {
  /** Статус связи расценка-вид строительства */
  constructionTypeRelationStatus?: InputMaybe<SortEnumType>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<SortEnumType>;
  /** Оборудование */
  eqp?: InputMaybe<SortEnumType>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<SortEnumType>;
  /** Накладные расходы */
  nr?: InputMaybe<SortEnumType>;
  /** Основная заработная плата */
  ozp?: InputMaybe<SortEnumType>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<SortEnumType>;
  /** Сметная прибыль */
  sp?: InputMaybe<SortEnumType>;
  /** Перевозка */
  trn?: InputMaybe<SortEnumType>;
  /** Стоимость единицы в базовом уровне цен */
  unitCost?: InputMaybe<SortEnumType>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<SortEnumType>;
};

export type PriceListUerRowPriceInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  eqp?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  pir?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  trn?: InputMaybe<Scalars['Decimal']>;
  unitCost?: InputMaybe<Scalars['Decimal']>;
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Информация об установки свойств главы и типа расценок */
export type PriceListUerRowReadyInfo = {
  __typename?: 'PriceListUerRowReadyInfo';
  /** Идентификатор контракта */
  contractId: Scalars['Long'];
  /** Признак загрузки сборника расценок */
  isPriceCollectionLoaded: Scalars['Boolean'];
  /** Счетчик расценок с неустановленной главой или типом */
  unreadyUerRowCount: Scalars['Int'];
};

/** Информация об установки свойств главы и типа расценок */
export type PriceListUerRowReadyInfoInput = {
  /** Идентификатор контракта */
  contractId: Scalars['Long'];
  /** Признак загрузки сборника расценок */
  isPriceCollectionLoaded: Scalars['Boolean'];
  /** Счетчик расценок с неустановленной главой или типом */
  unreadyUerRowCount: Scalars['Int'];
};

export type PriceListUerRowUpdateInput = {
  basePrice?: InputMaybe<PriceListUerRowPriceInput>;
  chapter?: InputMaybe<ChapterEnum>;
  currentPrices?: InputMaybe<Array<PriceListUerRowPriceCurrentCreateInput>>;
  estimateUploaded: Scalars['Boolean'];
  group?: InputMaybe<Scalars['String']>;
  id: Scalars['Long'];
  justification?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  ratioIds?: InputMaybe<Array<Scalars['Long']>>;
  section?: InputMaybe<Scalars['String']>;
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  version: Scalars['String'];
  workKind: PriceListUerRowWorkInput;
};

export type PriceListUerRowWithRatioData = {
  __typename?: 'PriceListUerRowWithRatioData';
  basePrice: PriceListUerRowPriceData;
  /** Глава расценки */
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  constructionTypes: Array<UerRowConstructionTypeData>;
  currentPrices: Array<PriceListUerRowPriceCurrentData>;
  groupCode?: Maybe<Scalars['String']>;
  /** Полное имя группы (подраздела) */
  groupFullName: Scalars['String'];
  groupId: Scalars['Long'];
  groupName: Scalars['String'];
  /** Есть виды строительства со статусом новая запись */
  hasNewConstructionTypeRelations?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: Maybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Статус связи */
  linkStatus: PriceConstructionTypeRelationStatusEnum;
  name: Scalars['String'];
  ratioGroups: Array<UerRowRatioGroupData>;
  ratioItems: Array<UerRowRatioItemData>;
  sectionId: Scalars['Long'];
  sectionIsArtificial?: Maybe<Scalars['Boolean']>;
  sectionName: Scalars['String'];
  /** Статус расценки */
  status: UerRecordStatusEnum;
  /** Тип расценки */
  uerClassifier?: Maybe<UerClassifierEnum>;
  unit: Scalars['String'];
  /** Версия */
  version?: Maybe<Scalars['String']>;
  /** Виды работ */
  workKind: PriceListUerRowWorkData;
  /** Состав работ для этого УЕР */
  workScopes: Array<PriceListUerWorkScopeData>;
};

export type PriceListUerRowWithRatioDataInput = {
  basePrice: PriceListUerRowPriceDataInput;
  /** Глава расценки */
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  constructionTypes: Array<UerRowConstructionTypeDataInput>;
  currentPrices: Array<PriceListUerRowPriceCurrentDataInput>;
  groupCode?: InputMaybe<Scalars['String']>;
  /** Полное имя группы (подраздела) */
  groupFullName: Scalars['String'];
  groupId: Scalars['Long'];
  groupName: Scalars['String'];
  /** Есть виды строительства со статусом новая запись */
  hasNewConstructionTypeRelations?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  /** Есть в акте? */
  isIncludedInAct: Scalars['Boolean'];
  /** Есть в наряд-заказе? */
  isIncludedInWorkOrder?: InputMaybe<Scalars['Boolean']>;
  /** Есть в изме наряд-заказа? */
  isIncludedInWorkOrderChange?: InputMaybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Статус связи */
  linkStatus: PriceConstructionTypeRelationStatusEnum;
  name: Scalars['String'];
  ratioGroups: Array<UerRowRatioGroupDataInput>;
  ratioItems: Array<UerRowRatioItemDataInput>;
  sectionId: Scalars['Long'];
  sectionIsArtificial?: InputMaybe<Scalars['Boolean']>;
  sectionName: Scalars['String'];
  /** Статус расценки */
  status: UerRecordStatusEnum;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  unit: Scalars['String'];
  /** Версия */
  version?: InputMaybe<Scalars['String']>;
  /** Виды работ */
  workKind: PriceListUerRowWorkDataInput;
  /** Состав работ для этого УЕР */
  workScopes: Array<PriceListUerWorkScopeDataInput>;
};

/** Данные по видам работ */
export type PriceListUerRowWorkData = {
  __typename?: 'PriceListUerRowWorkData';
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum: WorkInSumEnum;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: Maybe<Scalars['String']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

/** Данные по видам работ */
export type PriceListUerRowWorkDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerRowWorkDataFilterInput>>;
  or?: InputMaybe<Array<PriceListUerRowWorkDataFilterInput>>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<WorkInSumEnumOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные по видам работ */
export type PriceListUerRowWorkDataInput = {
  /** Шифр */
  workCode?: InputMaybe<Scalars['String']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum: WorkInSumEnum;
  /** Наименование */
  workName?: InputMaybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<Scalars['Decimal']>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<Scalars['String']>;
  /** Ед.изм. */
  workUnit?: InputMaybe<Scalars['String']>;
};

/** Данные по видам работ */
export type PriceListUerRowWorkDataSortInput = {
  /** Шифр */
  workCode?: InputMaybe<SortEnumType>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<SortEnumType>;
  /** Наименование */
  workName?: InputMaybe<SortEnumType>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<SortEnumType>;
  /** UUID - идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<SortEnumType>;
  /** Ед.изм. */
  workUnit?: InputMaybe<SortEnumType>;
};

/** Вид работы */
export type PriceListUerRowWorkInput = {
  /** Шифр */
  workCode?: InputMaybe<Scalars['String']>;
  /** Участие в суммировании ФО */
  workInSum: WorkInSumEnum;
  /** Наименование */
  workName?: InputMaybe<Scalars['String']>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор вида работ */
  workUniqueId?: InputMaybe<Scalars['String']>;
  /** Ед.изм. */
  workUnit?: InputMaybe<Scalars['String']>;
};

/** Данные раздела расценки */
export type PriceListUerSectionData = {
  __typename?: 'PriceListUerSectionData';
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  isArtificial?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
};

/** Данные раздела расценки */
export type PriceListUerSectionDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerSectionDataFilterInput>>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  isArtificial?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<PriceListUerSectionDataFilterInput>>;
};

/** Данные раздела расценки */
export type PriceListUerSectionDataSortInput = {
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  isArtificial?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
};

export type PriceListUerWorkScopeBasisData = {
  __typename?: 'PriceListUerWorkScopeBasisData';
  description: Scalars['String'];
  number: Scalars['Int'];
};

export type PriceListUerWorkScopeBasisDataInput = {
  description: Scalars['String'];
  number: Scalars['Int'];
};

export type PriceListUerWorkScopeCreateInput = {
  description: Scalars['String'];
  number: Scalars['Int'];
};

export type PriceListUerWorkScopeData = {
  __typename?: 'PriceListUerWorkScopeData';
  description: Scalars['String'];
  id: Scalars['Long'];
  number: Scalars['Int'];
};

export type PriceListUerWorkScopeDataFilterInput = {
  and?: InputMaybe<Array<PriceListUerWorkScopeDataFilterInput>>;
  description?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PriceListUerWorkScopeDataFilterInput>>;
};

export type PriceListUerWorkScopeDataInput = {
  description: Scalars['String'];
  id: Scalars['Long'];
  number: Scalars['Int'];
};

export enum PricingTypeEnum {
  /** Неценообразующие */
  NoPricing = 'NO_PRICING',
  /** Ценообразующие */
  Pricing = 'PRICING'
}

export type PricingTypeEnumOperationFilterInput = {
  eq?: InputMaybe<PricingTypeEnum>;
  in?: InputMaybe<Array<PricingTypeEnum>>;
  neq?: InputMaybe<PricingTypeEnum>;
  nin?: InputMaybe<Array<PricingTypeEnum>>;
};

/** Данные модулей проекта */
export type ProjectCommonData = {
  __typename?: 'ProjectCommonData';
  /** Данные навигации проекта */
  navigationData: ProjectNavigationData;
  /** Данные стоимости проекта */
  priceData: ProjectPriceData;
};

/** Тип договора проекта */
export enum ProjectContractTypeEnum {
  /** Рамочный договор */
  Frame = 'FRAME',
  /** Обычный договор */
  Normal = 'NORMAL'
}

export type ProjectContractTypeEnumOperationFilterInput = {
  eq?: InputMaybe<ProjectContractTypeEnum>;
  in?: InputMaybe<Array<ProjectContractTypeEnum>>;
  neq?: InputMaybe<ProjectContractTypeEnum>;
  nin?: InputMaybe<Array<ProjectContractTypeEnum>>;
};

/** Входная модель параметров запроса на создание проекта. */
export type ProjectCreateInput = {
  /** Код проекта */
  code?: InputMaybe<Scalars['String']>;
  /** Тип договора Проекта. Необходим при создании проекта со стадии Мониторинга */
  contractType?: InputMaybe<ProjectContractTypeEnum>;
  /** Методология Проекта */
  methodology: ProjectMethodologyEnum;
  /** Наименование Проекта */
  name: Scalars['String'];
  /** Этап Проекта */
  stage: ProjectStageEnum;
  /** Статус Проекта */
  status: ProjectStatusEnum;
};

export type ProjectData = {
  __typename?: 'ProjectData';
  /** @deprecated Использовать ContractPrice.Data?.ActualCost */
  actualPrice?: Maybe<Scalars['Decimal']>;
  authoredBy: Scalars['String'];
  calculationId?: Maybe<Scalars['Long']>;
  calculationNavigation?: Maybe<ServiceDataResultOfCalculationNavigationData>;
  calculationPrice?: Maybe<ServiceDataResultOfCalculationPriceData>;
  calculationStatus?: Maybe<CalculationStatusEnum>;
  calculationUniqueId?: Maybe<Scalars['String']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  code?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['Long']>;
  contractInternalNumber?: Maybe<Scalars['String']>;
  /** @deprecated Использовать CalculationNavigation и ContractNavigation */
  contractNavData?: Maybe<ContractNavData>;
  /** @deprecated Использовать CalculationNavigation и ContractNavigation */
  contractNavItems?: Maybe<Array<ContractItemNavData>>;
  contractNavigation?: Maybe<ServiceDataResultOfContractNavigationData>;
  contractPrice?: Maybe<ServiceDataResultOfContractPriceData>;
  contractStatus?: Maybe<ContractStatusEnum>;
  contractType?: Maybe<ProjectContractTypeEnum>;
  contractUniqueId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** @deprecated Использовать ContractPrice.Data?.HasActualCost */
  hasActualCost?: Maybe<Scalars['Boolean']>;
  /** @deprecated Использовать ContractPrice.Data?.ContractPlan */
  lotPrice?: Maybe<Scalars['Decimal']>;
  methodology: ProjectMethodologyEnum;
  name: Scalars['String'];
  /** @deprecated Использовать CalculationPrice.Data?.PriceNMC */
  priceNMC?: Maybe<Scalars['Decimal']>;
  stage: ProjectStageEnum;
  stageFollowers: Array<ProjectStageEnum>;
  status: ProjectStatusEnum;
  statusFollowers: Array<ProjectStatusEnum>;
  subsidiary?: Maybe<CompanyData>;
  uniqueId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Использовать CalculationNavigation и ContractNavigation */
  workOrderNavs?: Maybe<Array<WorkOrderNavData>>;
};

export type ProjectDataInput = {
  /** @deprecated Использовать ContractPrice.Data?.ActualCost */
  actualPrice?: InputMaybe<Scalars['Decimal']>;
  authoredBy: Scalars['String'];
  calculationId?: InputMaybe<Scalars['Long']>;
  calculationNavigation?: InputMaybe<ServiceDataResultOfCalculationNavigationDataInput>;
  calculationPrice?: InputMaybe<ServiceDataResultOfCalculationPriceDataInput>;
  calculationStatus?: InputMaybe<CalculationStatusEnum>;
  calculationUniqueId?: InputMaybe<Scalars['String']>;
  closedAt?: InputMaybe<Scalars['DateTime']>;
  code?: InputMaybe<Scalars['String']>;
  contractId?: InputMaybe<Scalars['Long']>;
  contractInternalNumber?: InputMaybe<Scalars['String']>;
  /** @deprecated Использовать CalculationNavigation и ContractNavigation */
  contractNavData?: InputMaybe<ContractNavDataInput>;
  /** @deprecated Использовать CalculationNavigation и ContractNavigation */
  contractNavItems?: InputMaybe<Array<ContractItemNavDataInput>>;
  contractNavigation?: InputMaybe<ServiceDataResultOfContractNavigationDataInput>;
  contractPrice?: InputMaybe<ServiceDataResultOfContractPriceDataInput>;
  contractStatus?: InputMaybe<ContractStatusEnum>;
  contractType?: InputMaybe<ProjectContractTypeEnum>;
  contractUniqueId?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** @deprecated Использовать ContractPrice.Data?.HasActualCost */
  hasActualCost?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated Использовать ContractPrice.Data?.ContractPlan */
  lotPrice?: InputMaybe<Scalars['Decimal']>;
  methodology: ProjectMethodologyEnum;
  name: Scalars['String'];
  /** @deprecated Использовать CalculationPrice.Data?.PriceNMC */
  priceNMC?: InputMaybe<Scalars['Decimal']>;
  stage: ProjectStageEnum;
  stageFollowers: Array<ProjectStageEnum>;
  status: ProjectStatusEnum;
  statusFollowers: Array<ProjectStatusEnum>;
  subsidiary?: InputMaybe<CompanyDataInput>;
  uniqueId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** @deprecated Использовать CalculationNavigation и ContractNavigation */
  workOrderNavs?: InputMaybe<Array<WorkOrderNavDataInput>>;
};

export type ProjectItemData = {
  __typename?: 'ProjectItemData';
  actualPrice?: Maybe<Scalars['Decimal']>;
  authoredBy: Scalars['String'];
  calculationStatus?: Maybe<CalculationStatusEnum>;
  calculationUniqueId?: Maybe<Scalars['String']>;
  contractStatus?: Maybe<ContractStatusEnum>;
  contractType?: Maybe<ProjectContractTypeEnum>;
  contractUniqueId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  isOwn: Scalars['Boolean'];
  lotPrice?: Maybe<Scalars['Decimal']>;
  methodology: ProjectMethodologyEnum;
  name: Scalars['String'];
  priceNMC?: Maybe<Scalars['Decimal']>;
  stage: ProjectStageEnum;
  status: ProjectStatusEnum;
  subsidiaryId?: Maybe<Scalars['Long']>;
  subsidiaryName?: Maybe<Scalars['String']>;
  uniqueId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProjectItemDataFilterInput = {
  actualPrice?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<ProjectItemDataFilterInput>>;
  authoredBy?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  calculationStatus?: InputMaybe<NullableOfCalculationStatusEnumOperationFilterInput>;
  calculationUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  contractStatus?: InputMaybe<NullableOfContractStatusEnumOperationFilterInput>;
  contractType?: InputMaybe<NullableOfProjectContractTypeEnumOperationFilterInput>;
  contractUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  isOwn?: InputMaybe<BooleanOperationFilterInput>;
  lotPrice?: InputMaybe<DecimalOperationFilterInput>;
  methodology?: InputMaybe<ProjectMethodologyEnumOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ProjectItemDataFilterInput>>;
  priceNMC?: InputMaybe<DecimalOperationFilterInput>;
  stage?: InputMaybe<ProjectStageEnumOperationFilterInput>;
  status?: InputMaybe<ProjectStatusEnumOperationFilterInput>;
  subsidiaryId?: InputMaybe<LongOperationFilterInput>;
  subsidiaryName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ProjectItemDataSortInput = {
  actualPrice?: InputMaybe<SortEnumType>;
  authoredBy?: InputMaybe<SortEnumType>;
  calculationStatus?: InputMaybe<SortEnumType>;
  calculationUniqueId?: InputMaybe<SortEnumType>;
  contractStatus?: InputMaybe<SortEnumType>;
  contractType?: InputMaybe<SortEnumType>;
  contractUniqueId?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  isOwn?: InputMaybe<SortEnumType>;
  lotPrice?: InputMaybe<SortEnumType>;
  methodology?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  priceNMC?: InputMaybe<SortEnumType>;
  stage?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  subsidiaryId?: InputMaybe<SortEnumType>;
  subsidiaryName?: InputMaybe<SortEnumType>;
  uniqueId?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum ProjectMethodologyEnum {
  /** БИМ */
  Bim = 'BIM',
  /** ЕТР */
  Etr = 'ETR',
  /** N/A */
  None = 'NONE',
  /** УЕР */
  Uer = 'UER'
}

export type ProjectMethodologyEnumOperationFilterInput = {
  eq?: InputMaybe<ProjectMethodologyEnum>;
  in?: InputMaybe<Array<ProjectMethodologyEnum>>;
  neq?: InputMaybe<ProjectMethodologyEnum>;
  nin?: InputMaybe<Array<ProjectMethodologyEnum>>;
};

export type ProjectNavigationData = {
  __typename?: 'ProjectNavigationData';
  calculationNav?: Maybe<Uer_ServiceDataResultOfCalculationNavigationData>;
  contractNav?: Maybe<Uer_ServiceDataResultOfContractNavigationData>;
};

/** Данные стоимости Проекта */
export type ProjectPriceData = {
  __typename?: 'ProjectPriceData';
  /** Данные стоимости Расчета НМЦ */
  calculationPrice?: Maybe<ServiceDataResultOfCalculationPriceData>;
  /** Данные стоимости Договора */
  contractPrice?: Maybe<ServiceDataResultOfContractPriceData>;
};

/** Этапы проекта */
export enum ProjectStageEnum {
  /** Расчет НМЦ */
  Calculation = 'CALCULATION',
  /** Реализация */
  Implementation = 'IMPLEMENTATION'
}

export type ProjectStageEnumOperationFilterInput = {
  eq?: InputMaybe<ProjectStageEnum>;
  in?: InputMaybe<Array<ProjectStageEnum>>;
  neq?: InputMaybe<ProjectStageEnum>;
  nin?: InputMaybe<Array<ProjectStageEnum>>;
};

/** Статусы проекта */
export enum ProjectStatusEnum {
  /** Рассчитан */
  Calculated = 'CALCULATED',
  /** Отменен */
  Canceled = 'CANCELED',
  /** Завершен */
  Completed = 'COMPLETED',
  /** Отложен */
  Delayed = 'DELAYED',
  /** Рассчитывается */
  InCalculation = 'IN_CALCULATION',
  /** На реализации */
  InImplementation = 'IN_IMPLEMENTATION'
}

export type ProjectStatusEnumOperationFilterInput = {
  eq?: InputMaybe<ProjectStatusEnum>;
  in?: InputMaybe<Array<ProjectStatusEnum>>;
  neq?: InputMaybe<ProjectStatusEnum>;
  nin?: InputMaybe<Array<ProjectStatusEnum>>;
};

/** Входная модель параметров запроса на обновление проекта. */
export type ProjectUpdateInput = {
  /** Код проекта */
  code?: InputMaybe<Scalars['String']>;
  /** Тип договора Проекта. Необходим при создании проекта со стадии Мониторинга */
  contractType?: InputMaybe<ProjectContractTypeEnum>;
  /** Наименование Проекта */
  name: Scalars['String'];
  /** Этап Проекта */
  stage: ProjectStageEnum;
  /** Статус Проекта */
  status: ProjectStatusEnum;
  /** Идентификатор Проекта */
  uniqueId: Scalars['String'];
};

/** A segment of a collection. */
export type ProjectsAuthoredByFilterCollectionSegment = {
  __typename?: 'ProjectsAuthoredByFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsCollectionSegment = {
  __typename?: 'ProjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ProjectItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsContractTypeFilterCollectionSegment = {
  __typename?: 'ProjectsContractTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfProjectContractTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsMethodologyFilterCollectionSegment = {
  __typename?: 'ProjectsMethodologyFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfProjectMethodologyEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsNameFilterCollectionSegment = {
  __typename?: 'ProjectsNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsStageFilterCollectionSegment = {
  __typename?: 'ProjectsStageFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfProjectStageEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsStatusFilterCollectionSegment = {
  __typename?: 'ProjectsStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfProjectStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type ProjectsSubsidiaryFilterCollectionSegment = {
  __typename?: 'ProjectsSubsidiaryFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCompanyData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  appModuleHealthChecks: ServiceDataResultOfAppHealthCheckData;
  appModuleInfo: ServiceDataResultOfAppModuleInfo;
  appModuleReport: ServiceDataResultOfAppModuleReport;
  appModulesReport?: Maybe<AppModulesReportCollectionSegment>;
  /**
   * Получить данные для фильтрации по главе
   *
   *
   * **Returns:**
   * Данные для фильтрации по главе
   */
  bimActKC2GroupChapterFilter?: Maybe<BimActKc2GroupChapterFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по виду строительства
   *
   *
   * **Returns:**
   * Данные для фильтрации по виду строительства
   */
  bimActKC2GroupConstructionTypeFilter?: Maybe<BimActKc2GroupConstructionTypeFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по группе затрат Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по группе затрат Акта КС-2
   */
  bimActKC2GroupCostGroupFilter?: Maybe<BimActKc2GroupCostGroupFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по дате Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по дате Акта КС-2
   */
  bimActKC2GroupDateFilter?: Maybe<BimActKc2GroupDateFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по номеру Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по номеру Акта КС-2
   */
  bimActKC2GroupNumberFilter?: Maybe<BimActKc2GroupNumberFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по объекту
   *
   *
   * **Returns:**
   * Данные для фильтрации по объекту
   */
  bimActKC2GroupObjectFilter?: Maybe<BimActKc2GroupObjectFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по шифру
   *
   *
   * **Returns:**
   * Данные для фильтрации по главе
   */
  bimActKC2GroupWorkOrderPriceCodeFilter?: Maybe<BimActKc2GroupWorkOrderPriceCodeFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по смете
   *
   *
   * **Returns:**
   * Данные для фильтрации по главе
   */
  bimActKC2GroupWorkOrderPriceNameFilter?: Maybe<BimActKc2GroupWorkOrderPriceNameFilterCollectionSegment>;
  /**
   * Получает Акт КС-2 для прочих
   *
   *
   * **Returns:**
   * Акт КС-2 для прочих
   */
  bimActKC2Other: ServiceDataResultOfBimActKc2OtherData;
  /**
   * Получает данные Акта КС-2 на прочие по умолчанию
   *
   *
   * **Returns:**
   * Данные Акта КС-2 на прочие по умолчанию
   */
  bimActKC2OtherDefaults: ServiceDataResultOfBimActKc2OtherDefaultData;
  /**
   * Получает итоги Акта КС-2 на прочие затраты
   *
   *
   * **Returns:**
   * Список итогов Акта КС-2 на прочие затраты
   */
  bimActKC2OtherTotals?: Maybe<BimActKc2OtherTotalsCollectionSegment>;
  /**
   * Получает список позиций состава акта КС-2
   *
   *
   * **Returns:**
   * Список позиций состава акта КС-2
   */
  bimActKC2PriceRows?: Maybe<BimActKc2PriceRowsCollectionSegment>;
  /**
   * Получает итоги Акта КС-2
   *
   *
   * **Returns:**
   * Список итогов Акта КС-2
   */
  bimActKC2Totals?: Maybe<BimActKc2TotalsCollectionSegment>;
  /**
   * Получает Акт КС-2 на прочие затраты для версии НЗ
   *
   *
   * **Returns:**
   * Акт КС-2 на прочие затраты
   */
  bimActKC2VersionOther: ServiceDataResultOfBimActKc2VersionOtherData;
  /**
   * Получает итоги Акта КС-2 на прочие затраты для версии НЗ
   *
   *
   * **Returns:**
   * Список итогов Акта КС-2 на прочие затраты для версии НЗ
   */
  bimActKC2VersionOtherTotals?: Maybe<BimActKc2VersionOtherTotalsCollectionSegment>;
  /**
   * Получает список позиций состава акта КС-2 версии НЗ
   *
   *
   * **Returns:**
   * Список позиций состава акта КС-2 версии НЗ
   */
  bimActKC2VersionPriceRows?: Maybe<BimActKc2VersionPriceRowsCollectionSegment>;
  /**
   * Получает итоги Акта КС-2 версии НЗ
   *
   *
   * **Returns:**
   * Список итогов Акта КС-2 версии НЗ
   */
  bimActKC2VersionTotals?: Maybe<BimActKc2VersionTotalsCollectionSegment>;
  /**
   * Получает список актов КС-2 для сметы
   *
   *
   * **Returns:**
   * Список актов КС-2
   */
  bimActsKC2?: Maybe<BimActsKc2CollectionSegment>;
  /**
   * Получает список атрибутов группы актов
   *
   *
   * **Returns:**
   * Возвращает атрибуты группы.
   */
  bimActsKC2Group: ServiceDataResultOfBimActKc2GroupAttributeData;
  /**
   * Получает список актов прочих затрат
   *
   *
   * **Returns:**
   * Список актов прочих затрат
   */
  bimActsKC2Other?: Maybe<BimActsKc2OtherCollectionSegment>;
  /**
   * Получает список актов КС-2 версии НЗ
   *
   *
   * **Returns:**
   * Список актов КС-2 версии НЗ
   */
  bimActsKC2Version?: Maybe<BimActsKc2VersionCollectionSegment>;
  /**
   * Получает список Актов КС-2 на прочие затраты для версии НЗ
   *
   *
   * **Returns:**
   * Список Актов КС-2 на прочие затраты для версии НЗ
   */
  bimActsKC2VersionOther?: Maybe<BimActsKc2VersionOtherCollectionSegment>;
  bimAppModuleHealthChecks: ServiceDataResultOfAppHealthCheckData;
  bimAppModuleInfo: ServiceDataResultOfAppModuleInfo;
  bimAppModuleReport: ServiceDataResultOfAppModuleReport;
  /**
   * Рассчитывает значения распределения прочей Изма по объектам
   *
   *
   * **Returns:**
   * Список значений прочей затраты с распределением по объектам
   */
  bimCalcWorkOrderChangeOtherDistribution: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  /**
   * Метод расчета значений распределения прочих
   *
   *
   * **Returns:**
   * Результрат распределения прочих
   */
  bimCalcWorkOrderOtherDistribution: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  /**
   * Получает реквизиты расчета договора БИМ
   *
   *
   * **Returns:**
   * Данные реквизитов расчета договора
   */
  bimCalculation: ServiceDataResultOfBimCalculationData;
  /**
   * Получает договор
   *
   *
   * **Returns:**
   * Договор
   */
  bimContract: ServiceDataResultOfBimContractData;
  /**
   * Получает общие данные Договора
   *
   *
   * **Returns:**
   * Общие данные Договора
   */
  bimContractCommonData: ServiceDataResultOfContractCommonData;
  /**
   * Метод получения видов строительства договора
   *
   *
   * **Returns:**
   * Список видов строительства договора
   */
  bimContractConstructionTypes: ServiceDataResultOfConstructionTypeData__;
  /**
   * Получает данные договора по умолчанию
   *
   *
   * **Returns:**
   * Данные договора по умолчанию
   */
  bimContractDefaults: ServiceDataResultOfBimContractDefaultData;
  /**
   * Получает список объектов договора
   *
   *
   * **Returns:**
   * Список объектов договора
   */
  bimContractObjects: Array<BimContractObjectData>;
  /**
   * Получает прочую затрату договора
   *
   *
   * **Returns:**
   * Прочая затрата договора с данными для обновления
   */
  bimContractOtherCost: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Получает данные для фильтрации прочих затрат договора по столбцу Используется в Актах
   *
   *
   * **Returns:**
   * Данные фильтрации прочих затрат договора по столбцу Используется в Актах
   */
  bimContractOtherCostIncludedInActKC2Filter?: Maybe<BimContractOtherCostIncludedInActKc2FilterCollectionSegment>;
  /**
   * Получает данные для фильтрации прочих затрат договора по столбцу Используется в НЗ
   *
   *
   * **Returns:**
   * Данные фильтрации прочих затрат договора по столбцу Используется в НЗ
   */
  bimContractOtherCostIncludedInWorkOrderFilter?: Maybe<BimContractOtherCostIncludedInWorkOrderFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации прочих затрат договора по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные фильтрации прочих затрат договора по столбцу Наименование
   */
  bimContractOtherCostNameFilter?: Maybe<BimContractOtherCostNameFilterCollectionSegment>;
  /**
   * Метод получает список типов прочих затрат, не используемых в прочих договора
   *
   *
   * **Returns:**
   * Список прочих затрат договора
   */
  bimContractOtherCostTypes?: Maybe<BimContractOtherCostTypesCollectionSegment>;
  /**
   * Получает список прочих затрат договора
   *
   *
   * **Returns:**
   * Список прочих затрат договора
   */
  bimContractOtherCosts?: Maybe<BimContractOtherCostsCollectionSegment>;
  /**
   * Получает сезоны Договора
   *
   *
   * **Returns:**
   * Сзоны Договора
   */
  bimContractSeasons: ServiceDataResultOfBimContractSeasonData__;
  /** Экспортировать наряд-заказ в Excel */
  bimExportWorkOrder: ServiceDataResultOfFileContent;
  /**
   * Выгружает печатную форму Изма к НЗ (БИМ)
   *
   *
   * **Returns:**
   * Excel файл печатной формы Изма к НЗ
   */
  bimExportWorkOrderChange: ServiceDataResultOfFileContent;
  /**
   * Выгружает Excel файла с аналитикой Изменений
   *
   *
   * **Returns:**
   * Excel файл с аналитикой Изменений
   */
  bimExportWorkOrderChangeAnalyticsAsExcel: ServiceDataResultOfFileContent;
  /** Экспортировать накопительную ведомость НЗ в Excel */
  bimExportWorkOrderPrices: ServiceDataResultOfFileContent;
  /**
   * Получает данные накопительной ведомости договора с учетом данных о Наряд-заказах и Актах КС-2
   *
   *
   * **Returns:**
   * Данные накопительной ведомости договора с учетом данных о Наряд-заказах и Актах КС-2
   */
  bimFrameContractResults: ServiceDataResultOfBimContractResultsViewData;
  /**
   * Получает список записей справочника методологий прочих для договора
   *
   *
   * **Returns:**
   * Список записей справочника методологий прочих для договора
   */
  bimGlobalOtherCostsForContract?: Maybe<BimGlobalOtherCostsForContractCollectionSegment>;
  /** Используется ли вид строительства с указанным кодом в каком-либо договоре (БИМ) */
  bimIsContractConstructionTypeUsed: ServiceDataResultOfObject;
  /**
   * Проверяет уникальность наименования Группы актов КС-2
   *
   *
   * **Returns:**
   * результаты проверки
   */
  bimIsUniqueActKC2GroupName: ServiceResult;
  /** Проверяет является ли номер акта прочих уникальным в рамках НЗ */
  bimIsUniqueActKC2OtherInternalNumber: ServiceResult;
  /**
   * Проверяет, является ли внутренний номер договора уникальным
   *
   *
   * **Returns:**
   * Результат проверки
   */
  bimIsUniqueContractInternalNumber: ServiceResult;
  /**
   * Проверяет, является ли наименование объекта договора уникальным в рамках вида строительства
   *
   *
   * **Returns:**
   * Результат проверки
   */
  bimIsUniqueContractObjectName: ServiceResult;
  /**
   * Проверяет уникальность прочей затраты договора по наименованию, разделу и способу расчета
   *
   *
   * **Returns:**
   * Результат проверки уникальности прочей затраты
   */
  bimIsUniqueContractOtherCost: ServiceResult;
  /**
   * Проверяет уникальность наименования прочей в рамках договора
   *
   *
   * **Returns:**
   * Результат проверки уникальности имени прочей затраты договора
   */
  bimIsUniqueContractOtherCostName: ServiceResult;
  /**
   * Проверяет, является ли наименование подобъекта уникальным в рамках родительского объекта
   *
   *
   * **Returns:**
   * Результат проверки
   */
  bimIsUniqueContractSubObjectName: ServiceResult;
  /**
   * Проверяет, является ли внутренний номер изма наряд-заказа уникальным
   *
   *
   * **Returns:**
   * Результат проверки
   */
  bimIsUniqueWorkOrderChangeInternalNumber: ServiceResult;
  /**
   * Получает данные накопительной ведомости обычного договора с учетом данных о Расчете и Актах КС-2
   *
   *
   * **Returns:**
   * Данные данные накопительной ведомости обычного договора с учетом данных о Расчете и Актах КС-2
   */
  bimNormalContractResults: ServiceDataResultOfBimNormalContractResultData__;
  /**
   * Получение данных аналитики сметы ЛСР
   *
   *
   * **Returns:**
   * Данные аналитики по смете в целом и счетчики статусов позиций состава сметы
   */
  bimPriceAnalytics: ServiceDataResultOfBimPriceAnalyticsData;
  /**
   * Получение данных аналитики состава сметы ЛСР
   *
   *
   * **Returns:**
   * Список элементов аналитики сметы, соответствующие составу сметы
   */
  bimPriceRowAnalytics?: Maybe<BimPriceRowAnalyticsCollectionSegment>;
  /**
   * Получение данных фильта по шифрам позиций сметы
   *
   *
   * **Returns:**
   * Список уникальных строк шифров
   */
  bimPriceRowAnalyticsCodeFilter?: Maybe<BimPriceRowAnalyticsCodeFilterCollectionSegment>;
  /**
   * Получение данных фильта по наименованию позиции сметы
   *
   *
   * **Returns:**
   * Список уникальных строк наименований позиций сметы
   */
  bimPriceRowAnalyticsNameFilter?: Maybe<BimPriceRowAnalyticsNameFilterCollectionSegment>;
  /**
   * Получение данных фильта по названию раздела
   *
   *
   * **Returns:**
   * Список уникальных строк названий разделов
   */
  bimPriceRowAnalyticsSectionFilter?: Maybe<BimPriceRowAnalyticsSectionFilterCollectionSegment>;
  /**
   * Получение данных фильта по названию подраздела
   *
   *
   * **Returns:**
   * Список уникальных строк названий подразделов
   */
  bimPriceRowAnalyticsSubsectionFilter?: Maybe<BimPriceRowAnalyticsSubsectionFilterCollectionSegment>;
  /**
   * Получение данных фильта по единицам измерений в смете
   *
   *
   * **Returns:**
   * Список уникальных строк единиц измерений в смете
   */
  bimPriceRowAnalyticsUnitFilter?: Maybe<BimPriceRowAnalyticsUnitFilterCollectionSegment>;
  /**
   * Получает реквизиты наряд-заказа БИМ
   *
   *
   * **Returns:**
   * Данные реквизитов НЗ
   */
  bimWorkOrder: ServiceDataResultOfBimWorkOrderData;
  /**
   * Возвращает плоский список актов СМР и Прочих.
   *
   *
   * **Returns:**
   * Плоский список актов.
   */
  bimWorkOrderActsKC2?: Maybe<BimWorkOrderActsKc2CollectionSegment>;
  /**
   * Получить плоский список актов СМР и Прочих.
   *
   *
   * **Returns:**
   * Возвращает атрибуты группы.
   */
  bimWorkOrderActsKC2SelectionList?: Maybe<BimWorkOrderActsKc2SelectionListCollectionSegment>;
  /**
   * Получает реквизиты изма наряд-заказа
   *
   *
   * **Returns:**
   * Реквизиты изма наряд-заказа
   */
  bimWorkOrderChange: ServiceDataResultOfBimWorkOrderChangeData;
  /**
   * Получает список глав с количеством загруженных в главу смет Изма к НЗ
   *
   *
   * **Returns:**
   * Список глав с количеством загруженных в главу смет Изма к НЗ
   */
  bimWorkOrderChangeChapterPriceCounts: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  /**
   * Получает список видов строительства изма
   *
   *
   * **Returns:**
   * Список видов строительства изма
   */
  bimWorkOrderChangeConstructionTypes: ServiceDataResultOfConstructionTypeData__;
  /**
   * Получает данные изма наряд-заказа по умолчанию
   *
   *
   * **Returns:**
   * Данные изма наряд-заказа по умолчанию
   */
  bimWorkOrderChangeDefaults: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  /**
   * Получить список сезонов договора, которые можно установить как конечный сезон изма
   *
   *
   * **Returns:**
   * Запрос на список допустимых сезонов из договора
   */
  bimWorkOrderChangeLastSeasonSelectionList: Array<BimContractSeasonData>;
  /**
   * Получает список итогов прочих затрат по объекту Изма
   *
   *
   * **Returns:**
   * Список итогов прочих затрат по объекту Изма
   */
  bimWorkOrderChangeObjectOtherTotals?: Maybe<BimWorkOrderChangeObjectOtherTotalsCollectionSegment>;
  /**
   * Получает список итогов СМР по объекту и главе Изма
   *
   *
   * **Returns:**
   * Список итогов СМР по объекту и главе Изма
   */
  bimWorkOrderChangeObjectSMRTotals?: Maybe<BimWorkOrderChangeObjectSmrTotalsCollectionSegment>;
  /**
   * Получает список выбора объектов для Изма НЗ
   *
   *
   * **Returns:**
   * Cписок выбора объектов для Изма НЗ
   */
  bimWorkOrderChangeObjectSelectionList?: Maybe<BimWorkOrderChangeObjectSelectionListCollectionSegment>;
  /**
   * Получает список объектов Изма НЗ
   *
   *
   * **Returns:**
   * Список объектов Изма НЗ
   */
  bimWorkOrderChangeObjects?: Maybe<BimWorkOrderChangeObjectsCollectionSegment>;
  /**
   * Получает данные прочей затраты Изма к НЗ
   *
   *
   * **Returns:**
   * Данные прочей затраты
   */
  bimWorkOrderChangeOtherData: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Получает данные распределения прочей затраты Изма
   *
   *
   * **Returns:**
   * Lанные распределения прочей затраты Изма
   */
  bimWorkOrderChangeOtherDistribution: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  /**
   * Получает данные для фильтрации списка прочих затрат по столбцу Наименование работ, затрат
   *
   *
   * **Returns:**
   * Данные для фильтрации списка прочих затрат по столбцу Наименование работ, затрат
   */
  bimWorkOrderChangeOtherNameFilter?: Maybe<BimWorkOrderChangeOtherNameFilterCollectionSegment>;
  /**
   * Получает список прочих затрат Изма к НЗ
   *
   *
   * **Returns:**
   * Cписок прочих затрат Изма к НЗ
   */
  bimWorkOrderChangeOtherPrices?: Maybe<BimWorkOrderChangeOtherPricesCollectionSegment>;
  /**
   * Получает список прочих затрат для включения в Изм
   *
   *
   * **Returns:**
   * Список прочих затрат для включения в Изм
   */
  bimWorkOrderChangeOtherSelectionList?: Maybe<BimWorkOrderChangeOtherSelectionListCollectionSegment>;
  /**
   * Получить список версий НЗ предыдущих по отношению к указанному изму
   *
   *
   * **Returns:**
   * Список версий НЗ предыдущих по отношению к указанному изму
   */
  bimWorkOrderChangePreviousVersionsAsync?: Maybe<BimWorkOrderChangePreviousVersionsAsyncCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет Изма к НЗ по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Шифр
   */
  bimWorkOrderChangePriceCodeFilter?: Maybe<BimWorkOrderChangePriceCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет Изма к НЗ по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Наименование
   */
  bimWorkOrderChangePriceNameFilter?: Maybe<BimWorkOrderChangePriceNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет Изма к НЗ по столбцу Наименование подобъекта
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Наименование подобъекта
   */
  bimWorkOrderChangePriceObjectNameFilter?: Maybe<BimWorkOrderChangePriceObjectNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет Изма к НЗ по столбцу Обоснование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Обоснование
   */
  bimWorkOrderChangePriceRationaleFilter?: Maybe<BimWorkOrderChangePriceRationaleFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка ревизий сметы Изма к НЗ по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка ревизий сметы по столбцу Шифр
   */
  bimWorkOrderChangePriceRevisionCodeFilter?: Maybe<BimWorkOrderChangePriceRevisionCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка ревизий сметы Изма к НЗ по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка ревизий сметы по столбцу Наименование
   */
  bimWorkOrderChangePriceRevisionNameFilter?: Maybe<BimWorkOrderChangePriceRevisionNameFilterCollectionSegment>;
  /**
   * Получает список ревизий/обновлений сметы ЛСР Изма к НЗ
   *
   *
   * **Returns:**
   * Список ревизий/обновлений сметы ЛСР Изма к НЗ
   */
  bimWorkOrderChangePriceRevisions?: Maybe<BimWorkOrderChangePriceRevisionsCollectionSegment>;
  /**
   * Получает данные для фильтрации списка позиций состава сметы Изма к НЗ по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка позиций состава сметы по столбцу Шифр
   */
  bimWorkOrderChangePriceRowCodeFilter?: Maybe<BimWorkOrderChangePriceRowCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка позиций состава сметы Изма к НЗ по столбцу Наименование работ
   *
   *
   * **Returns:**
   * Данные для фильтрации списка позиций состава сметы по столбцу Наименование работ
   */
  bimWorkOrderChangePriceRowNameFilter?: Maybe<BimWorkOrderChangePriceRowNameFilterCollectionSegment>;
  /**
   * Получает список состава сметы ЛСР Изма к НЗ
   *
   *
   * **Returns:**
   * Список состава сметы ЛСР Изма к НЗ
   */
  bimWorkOrderChangePriceRows?: Maybe<BimWorkOrderChangePriceRowsCollectionSegment>;
  /**
   * Получает данные состояния позиций Изма
   *
   *
   * **Returns:**
   * Данные состояния позиций Изма
   */
  bimWorkOrderChangePriceStates: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  /**
   * Получает список позиций смет ЛСР Изма к НЗ
   *
   *
   * **Returns:**
   * Список позиций смет ЛСР Изма к НЗ
   */
  bimWorkOrderChangePrices?: Maybe<BimWorkOrderChangePricesCollectionSegment>;
  /**
   * Получает список сезонов для обновления завершающего сезона
   *
   *
   * **Returns:**
   * Список сезонов для обновления завершающего сезона
   */
  bimWorkOrderChangeSeasonSelectionList?: Maybe<BimWorkOrderChangeSeasonSelectionListCollectionSegment>;
  /**
   * Получает список сезонов изма НЗ
   *
   *
   * **Returns:**
   * Список сезонов изма НЗ
   */
  bimWorkOrderChangeSeasons: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  /**
   * Получает список итогов Изма
   *
   *
   * **Returns:**
   * Список итогов Изма
   */
  bimWorkOrderChangeTotals?: Maybe<BimWorkOrderChangeTotalsCollectionSegment>;
  /**
   * Получает полный список глав НЗ с количеством загруженных в главу смет
   *
   *
   * **Returns:**
   * Полный список глав НЗ с количеством загруженных в главу смет
   */
  bimWorkOrderChapterData: ServiceDataResultOfBimWorkOrderChapterData__;
  /**
   * Метод получения видов строительства НЗ/Расчета
   *
   *
   * **Returns:**
   * Список видов строительства договора
   */
  bimWorkOrderConstructionTypes: ServiceDataResultOfConstructionTypeData__;
  /**
   * Получить общий список объектов для НЗ
   *
   * **Returns:**
   * Общий список объектов
   */
  bimWorkOrderObjectSelectionList?: Maybe<BimWorkOrderObjectSelectionListCollectionSegment>;
  /**
   * Получить список объектов НЗ
   *
   * **Returns:**
   * Список объектов
   */
  bimWorkOrderObjects?: Maybe<BimWorkOrderObjectsCollectionSegment>;
  /**
   * Получить данные прочей затраты НЗ
   *
   *
   * **Returns:**
   * Данные прочей затраты НЗ
   */
  bimWorkOrderOtherData: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Получить перераспределение прочей затраты
   *
   *
   * **Returns:**
   * Результат выполнения
   */
  bimWorkOrderOtherDistribution: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  /**
   * Получает список прочих затрат для включения в наряд-заказ/расчет для акта КС-2
   *
   *
   * **Returns:**
   * Список список прочих затрат для включения в наряд-заказ/расчет для акта КС-2
   */
  bimWorkOrderOtherForAct?: Maybe<BimWorkOrderOtherForActCollectionSegment>;
  /**
   * Получает список прочих затрат НЗ
   *
   *
   * **Returns:**
   * Список прочих затрат НЗ
   */
  bimWorkOrderOtherPrices?: Maybe<BimWorkOrderOtherPricesCollectionSegment>;
  /**
   * Получает список прочих затрат для включения в наряд-заказ/расчет по договору
   *
   *
   * **Returns:**
   * Список прочих затрат для включения в наряд-заказ/расчет по договору
   */
  bimWorkOrderOthers?: Maybe<BimWorkOrderOthersCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Шифр
   */
  bimWorkOrderPriceCodeFilter?: Maybe<BimWorkOrderPriceCodeFilterCollectionSegment>;
  /**
   * Получает данные МТР для распределения
   *
   *
   * **Returns:**
   * Данные МТР для распределения
   */
  bimWorkOrderPriceMTRDistribution: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  /**
   * Получает данные об отклонении итоговой стоимости при перераспределении МТР
   *
   *
   * **Returns:**
   * Данные об отклонении итоговой стоимости
   */
  bimWorkOrderPriceMTRDistributionTotal: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  /**
   * Получает данные для фильтрации списка смет по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Наименование
   */
  bimWorkOrderPriceNameFilter?: Maybe<BimWorkOrderPriceNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет по столбцу Наименование подобъекта
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Наименование подобъекта
   */
  bimWorkOrderPriceObjectNameFilter?: Maybe<BimWorkOrderPriceObjectNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка ревизий сметы ЛСР по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка ревизий сметы ЛСР по столбцу Шифр
   */
  bimWorkOrderPriceRevisionCodeFilter?: Maybe<BimWorkOrderPriceRevisionCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка ревизий сметы ЛСР по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка ревизий сметы ЛСР по столбцу Наименование
   */
  bimWorkOrderPriceRevisionNameFilter?: Maybe<BimWorkOrderPriceRevisionNameFilterCollectionSegment>;
  /**
   * Получает список ревизий/обновлений сметы ЛСР НЗ
   *
   *
   * **Returns:**
   * Список ревизий/обновлений сметы ЛСР
   */
  bimWorkOrderPriceRevisions?: Maybe<BimWorkOrderPriceRevisionsCollectionSegment>;
  /**
   * Получает данные для фильтрации списка позиций состава сметы ЛСР по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка позиций состава сметы ЛСР по столбцу Шифр
   */
  bimWorkOrderPriceRowCodeFilter?: Maybe<BimWorkOrderPriceRowCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка позиций состава сметы ЛСР по столбцу Наименование работ
   *
   *
   * **Returns:**
   * Данные для фильтрации списка позиций состава сметы ЛСР по столбцу Наименование работ
   */
  bimWorkOrderPriceRowNameFilter?: Maybe<BimWorkOrderPriceRowNameFilterCollectionSegment>;
  /**
   * Получает список позиций состава сметы ЛСР
   *
   *
   * **Returns:**
   * Список позиций состава сметы
   */
  bimWorkOrderPriceRows?: Maybe<BimWorkOrderPriceRowsCollectionSegment>;
  /**
   * Получает данные состояния позиций наряд-заказа
   *
   *
   * **Returns:**
   * Данные состояния наряд-заказа
   */
  bimWorkOrderPriceStates: ServiceDataResultOfBimWorkOrderPriceStatesData;
  /**
   * Получает список позиций смет ЛСР заданного НЗ
   *
   *
   * **Returns:**
   * Список позиций ЛСР НЗ
   */
  bimWorkOrderPrices?: Maybe<BimWorkOrderPricesCollectionSegment>;
  /**
   * Получить общий список сезонов для НЗ
   *
   * **Returns:**
   * Общий список сезонов
   */
  bimWorkOrderSeasonSelectionList?: Maybe<BimWorkOrderSeasonSelectionListCollectionSegment>;
  /**
   * Получить список сезонов НЗ
   *
   * **Returns:**
   * Список сезонов
   */
  bimWorkOrderSeasons?: Maybe<BimWorkOrderSeasonsCollectionSegment>;
  /**
   * Получает сезоны наряд-заказа
   *
   *
   * **Returns:**
   * Сезоны наряд-заказа
   */
  bimWorkOrderSeasonsRange: ServiceDataResultOfBimWorkOrderSeasonsData;
  /**
   * Получить итоги Наряд-заказа
   *
   *
   * **Returns:**
   * Список итогов НЗ
   */
  bimWorkOrderTotals?: Maybe<BimWorkOrderTotalsCollectionSegment>;
  /**
   * Получает реквизиты версии НЗ
   *
   *
   * **Returns:**
   * Реквизиты версии НЗ
   */
  bimWorkOrderVersion: ServiceDataResultOfBimWorkOrderVersionData;
  /**
   * Получает список глав версии НЗ с количеством загруженных в главу смет
   *
   *
   * **Returns:**
   * Полный список глав НЗ с количеством загруженных в главу смет
   */
  bimWorkOrderVersionChapterPriceCounts: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  /**
   * Получает список видов строительства версии НЗ
   *
   *
   * **Returns:**
   * Список видов строительства версии НЗ
   */
  bimWorkOrderVersionConstructionTypes: ServiceDataResultOfConstructionTypeData__;
  /**
   * Получает данные по объекту версии НЗ для просмотра
   *
   *
   * **Returns:**
   * Данные по объекту версии НЗ для просмотра
   */
  bimWorkOrderVersionObject: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  /**
   * Получает список объектов версии НЗ
   *
   *
   * **Returns:**
   * Cписок объектов версии НЗ
   */
  bimWorkOrderVersionObjects?: Maybe<BimWorkOrderVersionObjectsCollectionSegment>;
  /**
   * Получает данные прочей затраты версии НЗ
   *
   *
   * **Returns:**
   * Данные прочей затраты версии НЗ
   */
  bimWorkOrderVersionOtherData: ServiceDataResultOfBimContractOtherCostData;
  /**
   * Получает данные для фильтрации списка прочих затрат по столбцу Наименование работ
   *
   *
   * **Returns:**
   * Данные для фильтрации списка прочих затрат по столбцу Наименование работ
   */
  bimWorkOrderVersionOtherPriceNameFilter?: Maybe<BimWorkOrderVersionOtherPriceNameFilterCollectionSegment>;
  /**
   * Получает список прочих затрат версии НЗ
   *
   *
   * **Returns:**
   * Cписок прочих затрат версии НЗ
   */
  bimWorkOrderVersionOtherPrices?: Maybe<BimWorkOrderVersionOtherPricesCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Шифр
   */
  bimWorkOrderVersionPriceCodeFilter?: Maybe<BimWorkOrderVersionPriceCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Наименование
   */
  bimWorkOrderVersionPriceNameFilter?: Maybe<BimWorkOrderVersionPriceNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка смет по столбцу Наименование подобъекта
   *
   *
   * **Returns:**
   * Данные для фильтрации списка смет по столбцу Наименование подобъекта
   */
  bimWorkOrderVersionPriceObjectNameFilter?: Maybe<BimWorkOrderVersionPriceObjectNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка ревизий сметы по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка ревизий сметы по столбцу Шифр
   */
  bimWorkOrderVersionPriceRevisionCodeFilter?: Maybe<BimWorkOrderVersionPriceRevisionCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка ревизий сметы по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации списка ревизий сметы по столбцу Наименование
   */
  bimWorkOrderVersionPriceRevisionNameFilter?: Maybe<BimWorkOrderVersionPriceRevisionNameFilterCollectionSegment>;
  /**
   * Получает список ревизий или обновлений по смете в версии НЗ
   *
   *
   * **Returns:**
   * Список ревизий или обновлений по смете в версии НЗ
   */
  bimWorkOrderVersionPriceRevisions?: Maybe<BimWorkOrderVersionPriceRevisionsCollectionSegment>;
  /**
   * Получает данные для фильтрации списка позиций состава сметы по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации списка позиций состава сметы по столбцу Шифр
   */
  bimWorkOrderVersionPriceRowCodeFilter?: Maybe<BimWorkOrderVersionPriceRowCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации списка позиций состава сметы по столбцу Наименование работ
   *
   *
   * **Returns:**
   * Данные для фильтрации списка позиций состава сметы по столбцу Наименование работ
   */
  bimWorkOrderVersionPriceRowNameFilter?: Maybe<BimWorkOrderVersionPriceRowNameFilterCollectionSegment>;
  /**
   * Получает список строк сметы в версии НЗ
   *
   *
   * **Returns:**
   * Список строк сметы в версии НЗ
   */
  bimWorkOrderVersionPriceRows?: Maybe<BimWorkOrderVersionPriceRowsCollectionSegment>;
  /**
   * Получает данные состояния позиций версии НЗ
   *
   *
   * **Returns:**
   * Данные состояния позиций версии НЗ
   */
  bimWorkOrderVersionPriceStates: ServiceDataResultOfBimWorkOrderPriceStatesData;
  /**
   * Получает список актуальных смет версии НЗ
   *
   *
   * **Returns:**
   * Список актуальных смет версии НЗ
   */
  bimWorkOrderVersionPrices?: Maybe<BimWorkOrderVersionPricesCollectionSegment>;
  /**
   * Получает интервал сезонов версии НЗ
   *
   *
   * **Returns:**
   * Интервал сезонов версии НЗ
   */
  bimWorkOrderVersionSeasons: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  /**
   * Получает данные по подобъекту версии НЗ для просмотра
   *
   *
   * **Returns:**
   * Данные по подобъекту версии НЗ для просмотра
   */
  bimWorkOrderVersionSubObject: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  /**
   * Получает итоги версии НЗ
   *
   *
   * **Returns:**
   * Список итогов версии НЗ
   */
  bimWorkOrderVersionTotals?: Maybe<BimWorkOrderVersionTotalsCollectionSegment>;
  /**
   * Получает список версий НЗ
   *
   *
   * **Returns:**
   * Список версий НЗ
   */
  bimWorkOrderVersions: Array<BimWorkOrderVersionListItem>;
  /** Получить укрупнённую смету с составом (для окна создания/редактирования). */
  bimcAggregateEstimate: ServiceDataResultOfAggregateLocalEstimateData;
  /** Состав укрупнённой сметы: структура (строки) входящих простых ЛСР. */
  bimcAggregateEstimateComposition?: Maybe<BimcAggregateEstimateCompositionCollectionSegment>;
  /** Возможные значения фильтра по колонке «Шифр» состава укрупнённой сметы. */
  bimcAggregateEstimateCompositionCodeFilter?: Maybe<BimcAggregateEstimateCompositionCodeFilterCollectionSegment>;
  /** Возможные значения фильтра по колонке «Наименование» состава укрупнённой сметы. */
  bimcAggregateEstimateCompositionNameFilter?: Maybe<BimcAggregateEstimateCompositionNameFilterCollectionSegment>;
  /** Возможные значения фильтра по колонке «Объект» состава укрупнённой сметы. */
  bimcAggregateEstimateCompositionObjectFilter?: Maybe<BimcAggregateEstimateCompositionObjectFilterCollectionSegment>;
  /** Возможные значения фильтра по колонке «Подобъект» состава укрупнённой сметы. */
  bimcAggregateEstimateCompositionSubObjectFilter?: Maybe<BimcAggregateEstimateCompositionSubObjectFilterCollectionSegment>;
  /** Доступные ЛСР (гарантированный объём) для окна «Добавление ЛСР». */
  bimcAggregateEstimateLsrSelection: Array<LocalEstimateTableItemData>;
  bimcAppModuleHealthChecks: ServiceDataResultOfAppHealthCheckData;
  bimcAppModuleInfo: ServiceDataResultOfAppModuleInfo;
  bimcAppModuleReport: ServiceDataResultOfAppModuleReport;
  /** Получение карточки расчёта НМЦ (БИМ). */
  bimcCalculation: ServiceDataResultOfBimcCalculationData;
  /** Общие данные расчёта НМЦ (БИМ) для карточки проекта. */
  bimcCalculationCommonData: ServiceDataResultOfCalculationCommonData;
  /** Список видов строительства, использованных в расчёте НМЦ (БИМ), по уникальному коду расчёта. */
  bimcCalculationConstructionTypeByCalculationUniqueId: Array<ConstructionTypeData>;
  /** Значения по умолчанию для предзаполнения карточки расчёта. */
  bimcCalculationDefaults: ServiceDataResultOfBimcCalculationDefaultData;
  /** Данные лимитированной затраты для редактирования. */
  bimcCalculationLimitedCostForUpdate: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  /** Значения для фильтра лимитированных по наименованию (БИМ). */
  bimcCalculationLimitedCostNameFilter?: Maybe<BimcCalculationLimitedCostNameFilterCollectionSegment>;
  /** Список типов лимитированных из каталога (методика БИМ). */
  bimcCalculationLimitedCostTypes?: Maybe<BimcCalculationLimitedCostTypesCollectionSegment>;
  /** Получение списка лимитированных затрат расчёта (БИМ) с пагинацией. */
  bimcCalculationLimitedCosts?: Maybe<BimcCalculationLimitedCostsCollectionSegment>;
  /** Получение структуры объектов расчёта (БИМ). */
  bimcCalculationObjects: Array<BimcCalculationObjectData>;
  /** Данные прочей для редактирования. */
  bimcCalculationOtherCostForUpdate: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  /** Значения фильтра прочих по наименованию. */
  bimcCalculationOtherCostNameFilter?: Maybe<BimcCalculationOtherCostNameFilterCollectionSegment>;
  /** Список типов прочих (неиспользованных в расчёте + текущая). */
  bimcCalculationOtherCostTypes?: Maybe<BimcCalculationOtherCostTypesCollectionSegment>;
  /** Получение списка прочих затрат расчёта (БИМ). */
  bimcCalculationOtherCosts?: Maybe<BimcCalculationOtherCostsCollectionSegment>;
  /** Дерево строк предварительного просмотра расчёта НМЦ (БИМ). */
  bimcCalculationPreview?: Maybe<BimcCalculationPreviewCollectionSegment>;
  /** Значения фильтра предпросмотра по шифру. */
  bimcCalculationPreviewCodeFilter?: Maybe<BimcCalculationPreviewCodeFilterCollectionSegment>;
  /** Значения фильтра предпросмотра по наименованию. */
  bimcCalculationPreviewNameFilter?: Maybe<BimcCalculationPreviewNameFilterCollectionSegment>;
  /** Значения фильтра предпросмотра по объекту. */
  bimcCalculationPreviewObjectFilter?: Maybe<BimcCalculationPreviewObjectFilterCollectionSegment>;
  /** Значения фильтра предпросмотра по сезону (году). */
  bimcCalculationPreviewSeasonFilter?: Maybe<BimcCalculationPreviewSeasonFilterCollectionSegment>;
  /** Значения фильтра предпросмотра по разделу/секции. */
  bimcCalculationPreviewSectionFilter?: Maybe<BimcCalculationPreviewSectionFilterCollectionSegment>;
  /** Значения фильтра предпросмотра по подобъекту. */
  bimcCalculationPreviewSubObjectFilter?: Maybe<BimcCalculationPreviewSubObjectFilterCollectionSegment>;
  /** Получение сезонов расчёта (БИМ). */
  bimcCalculationSeasons: Array<BimcCalculationSeasonData>;
  /**
   * Строки итогов расчёта НМЦ. Единый метод просмотра: переданные фильтры
   * (constructionTypeId, objectId, chapter) определяют объём данных —
   * листовой подобъект, уровень объекта/вида строительства/расчёта или диалог «Итоги главы».
   */
  bimcCalculationTotals: ServiceDataResultOfBimcCalculationResultData;
  /** Скачать файл шаблона прочей. */
  bimcDownloadCalculationOtherCostFile: ServiceDataResultOfFileContent;
  /** Считать «Всего» из файла-шаблона до сохранения. */
  bimcExtractTotalSum: ServiceDataResultOfCalculationOtherCostTotalSum;
  /** Справочник методик лимитированных для выбора в расчёте (методика БИМ), не использованных в расчёте. */
  bimcGlobalLimitedCostsForCalculation?: Maybe<BimcGlobalLimitedCostsForCalculationCollectionSegment>;
  /** Справочник методик прочих для выбора в расчёте. */
  bimcGlobalOtherCostsForCalculation?: Maybe<BimcGlobalOtherCostsForCalculationCollectionSegment>;
  /** Используется ли вид строительства с указанным кодом в каком-либо расчёте НМЦ (БИМ) */
  bimcIsCalculationConstructionTypeUsed: ServiceDataResultOfObject;
  /** Проверка уникальности кода лимитированной в рамках расчёта. */
  bimcIsCalculationLimitedCostCodeUnique: ServiceIdResultOfBoolean;
  /** Проверка уникальности наименования лимитированной в рамках расчёта. */
  bimcIsCalculationLimitedCostNameUnique: ServiceIdResultOfBoolean;
  /** Проверка уникальности кода прочей в рамках расчёта. */
  bimcIsCalculationOtherCostCodeUnique: ServiceIdResultOfBoolean;
  /** Проверка уникальности наименования прочей в рамках расчёта. */
  bimcIsCalculationOtherCostNameUnique: ServiceIdResultOfBoolean;
  /** Проверка уникальности кода объекта в расчёте. */
  bimcIsUniqueCalculationObjectCode: Scalars['Boolean'];
  /** Проверка уникальности имени объекта в расчёте. */
  bimcIsUniqueCalculationObjectName: Scalars['Boolean'];
  /** Проверка уникальности имени подобъекта в ветке родителя. */
  bimcIsUniqueCalculationSubObjectName: Scalars['Boolean'];
  /** Получение элементов состава ЛСР */
  bimcLocalEstimateComposition?: Maybe<BimcLocalEstimateCompositionCollectionSegment>;
  /**
   * Возможные значения фильтра по колонке «Шифр» состава ЛСР.
   *
   * **Returns:**
   * Значения фильтра.
   */
  bimcLocalEstimateCompositionCodeFilter?: Maybe<BimcLocalEstimateCompositionCodeFilterCollectionSegment>;
  /**
   * Возможные значения фильтра по колонке «Наименование» состава ЛСР.
   *
   * **Returns:**
   * Значения фильтра.
   */
  bimcLocalEstimateCompositionNameFilter?: Maybe<BimcLocalEstimateCompositionNameFilterCollectionSegment>;
  /** Получение данных окна «Редактирование ЛСР». */
  bimcLocalEstimateEditData: ServiceDataResultOfLocalEstimateEditData;
  /** Данные окна «Перераспределение МТР» ЛСР. */
  bimcLocalEstimateMtrDistribution: ServiceDataResultOfLocalEstimateMtrDistributionData;
  /** Предрасчёт итога и отклонения стоимости при перераспределении МТР. */
  bimcLocalEstimateMtrDistributionTotal: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  /**
   * Возможные значения колоночного фильтра «Шифр» таблицы ЛСР.
   *
   * **Returns:**
   * Значения фильтра.
   */
  bimcLocalEstimateTableCodeFilter?: Maybe<BimcLocalEstimateTableCodeFilterCollectionSegment>;
  /**
   * Возможные значения колоночного фильтра «Наименование работ, затрат» таблицы ЛСР.
   *
   * **Returns:**
   * Значения фильтра.
   */
  bimcLocalEstimateTableNameFilter?: Maybe<BimcLocalEstimateTableNameFilterCollectionSegment>;
  /**
   * Возможные значения колоночного фильтра «Элемент расчета» таблицы ЛСР.
   *
   * **Returns:**
   * Значения фильтра.
   */
  bimcLocalEstimateTableObjectFilter?: Maybe<BimcLocalEstimateTableObjectFilterCollectionSegment>;
  /** Список ЛСР табличного представления вкладки «Локальные сметные расчёты». */
  bimcLocalEstimatesTable?: Maybe<BimcLocalEstimatesTableCollectionSegment>;
  catalog: ServiceDataResultOfCatalogData;
  catalogConstructionTypeIsUsedInProjects: ServiceResult;
  catalogConstructionTypeItems?: Maybe<CatalogConstructionTypeItemsCollectionSegment>;
  catalogConstructionTypes?: Maybe<CatalogConstructionTypesCollectionSegment>;
  catalogConstructionTypesUpdatedDate: ServiceDataResultOfCatalogConstructionTypeChangesData;
  catalogIsUniqueConstructionTypeCode: ServiceResult;
  catalogIsUniqueConstructionTypeFields: ServiceResult;
  catalogIsUniqueWorkTypeCode: ServiceResult;
  catalogNameFilter?: Maybe<CatalogNameFilterCollectionSegment>;
  catalogOtherCostVariable: ServiceDataResultOfCatalogOtherCostVariableData;
  catalogOtherCostVariableDataSources?: Maybe<CatalogOtherCostVariableDataSourcesCollectionSegment>;
  catalogOtherCostVariableEntities: Array<CatalogOtherCostVariableEntityItemData>;
  catalogOtherCostVariableGroupList?: Maybe<CatalogOtherCostVariableGroupListCollectionSegment>;
  catalogOtherCostVariableSelectionItems?: Maybe<CatalogOtherCostVariableSelectionItemsCollectionSegment>;
  catalogOtherCostVariables?: Maybe<CatalogOtherCostVariablesCollectionSegment>;
  catalogOtherCostVariablesGroupFilter?: Maybe<CatalogOtherCostVariablesGroupFilterCollectionSegment>;
  catalogOtherCostVariablesNameFilter?: Maybe<CatalogOtherCostVariablesNameFilterCollectionSegment>;
  catalogOtherCostVariablesSubsidiaryNameFilter?: Maybe<CatalogOtherCostVariablesSubsidiaryNameFilterCollectionSegment>;
  catalogParseUerBaseCostBasis: ServiceDataResultOfUerEstimateBaseCostData;
  catalogRatio: ServiceDataResultOfCatalogRatioData;
  catalogRatioCodeFilter?: Maybe<CatalogRatioCodeFilterCollectionSegment>;
  catalogRatioGroupFilter?: Maybe<CatalogRatioGroupFilterCollectionSegment>;
  catalogRatioGroups: Array<CatalogRatioGroupData>;
  catalogRatioHistoryCodeFilter?: Maybe<CatalogRatioHistoryCodeFilterCollectionSegment>;
  catalogRatioHistoryGroupFilter?: Maybe<CatalogRatioHistoryGroupFilterCollectionSegment>;
  catalogRatioHistoryItems?: Maybe<CatalogRatioHistoryItemsCollectionSegment>;
  catalogRatioHistoryJustificationFilter?: Maybe<CatalogRatioHistoryJustificationFilterCollectionSegment>;
  catalogRatioHistoryNameFilter?: Maybe<CatalogRatioHistoryNameFilterCollectionSegment>;
  catalogRatioHistoryStatusCounts: ServiceDataResultOfHistoryStatusCountData;
  catalogRatioHistoryTypeFilter?: Maybe<CatalogRatioHistoryTypeFilterCollectionSegment>;
  catalogRatioNameFilter?: Maybe<CatalogRatioNameFilterCollectionSegment>;
  catalogRatioSubGroups: Array<CatalogRatioGroupData>;
  catalogRatioTypeFilter?: Maybe<CatalogRatioTypeFilterCollectionSegment>;
  catalogRatioTypes?: Maybe<CatalogRatioTypesCollectionSegment>;
  catalogRatios?: Maybe<CatalogRatiosCollectionSegment>;
  catalogSubsidiaryFilter?: Maybe<CatalogSubsidiaryFilterCollectionSegment>;
  catalogTypes: Array<CatalogTypeData>;
  catalogUERBaseCost: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  catalogUERBaseCostChangeFilter?: Maybe<CatalogUerBaseCostChangeFilterCollectionSegment>;
  catalogUERBaseCostChapterFilter?: Maybe<CatalogUerBaseCostChapterFilterCollectionSegment>;
  catalogUERBaseCostCodeFilter?: Maybe<CatalogUerBaseCostCodeFilterCollectionSegment>;
  catalogUERBaseCostConstructionTypes?: Maybe<CatalogUerBaseCostConstructionTypesCollectionSegment>;
  catalogUERBaseCostEstimateBasis?: Maybe<CatalogUerBaseCostEstimateBasisCollectionSegment>;
  catalogUERBaseCostEstimateBasisResources?: Maybe<CatalogUerBaseCostEstimateBasisResourcesCollectionSegment>;
  catalogUERBaseCostEstimateBasisRows: Array<CatalogUerBaseCostEstimateBasisRow>;
  catalogUERBaseCostGroupFullNameFilter?: Maybe<CatalogUerBaseCostGroupFullNameFilterCollectionSegment>;
  catalogUERBaseCostGroupNameFilter?: Maybe<CatalogUerBaseCostGroupNameFilterCollectionSegment>;
  catalogUERBaseCostHistoryChapterFilter?: Maybe<CatalogUerBaseCostHistoryChapterFilterCollectionSegment>;
  catalogUERBaseCostHistoryCodeFilter?: Maybe<CatalogUerBaseCostHistoryCodeFilterCollectionSegment>;
  catalogUERBaseCostHistoryGroupFullNameFilter?: Maybe<CatalogUerBaseCostHistoryGroupFullNameFilterCollectionSegment>;
  catalogUERBaseCostHistoryItems?: Maybe<CatalogUerBaseCostHistoryItemsCollectionSegment>;
  catalogUERBaseCostHistoryJustificationFilter?: Maybe<CatalogUerBaseCostHistoryJustificationFilterCollectionSegment>;
  catalogUERBaseCostHistoryNameFilter?: Maybe<CatalogUerBaseCostHistoryNameFilterCollectionSegment>;
  catalogUERBaseCostHistoryStatusCounts: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  catalogUERBaseCostHistoryUerClassifierFilter?: Maybe<CatalogUerBaseCostHistoryUerClassifierFilterCollectionSegment>;
  catalogUERBaseCostHistoryUpdateUERDateFilter?: Maybe<CatalogUerBaseCostHistoryUpdateUerDateFilterCollectionSegment>;
  catalogUERBaseCostHistoryWorkScopeFilter?: Maybe<CatalogUerBaseCostHistoryWorkScopeFilterCollectionSegment>;
  catalogUERBaseCostHistoryWorkScopeNameFilter?: Maybe<CatalogUerBaseCostHistoryWorkScopeNameFilterCollectionSegment>;
  catalogUERBaseCostHistoryWorkScopes: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  catalogUERBaseCostItems?: Maybe<CatalogUerBaseCostItemsCollectionSegment>;
  catalogUERBaseCostNameFilter?: Maybe<CatalogUerBaseCostNameFilterCollectionSegment>;
  catalogUERBaseCostSectionNameFilter?: Maybe<CatalogUerBaseCostSectionNameFilterCollectionSegment>;
  catalogUERBaseCostTotals: Array<CatalogUerBaseCostTotalItem>;
  catalogUERBaseCostUerClassifierFilter?: Maybe<CatalogUerBaseCostUerClassifierFilterCollectionSegment>;
  catalogUERBaseCostUpdateDateFilter?: Maybe<CatalogUerBaseCostUpdateDateFilterCollectionSegment>;
  catalogUERBaseCostWorkScopeChangeFilter?: Maybe<CatalogUerBaseCostWorkScopeChangeFilterCollectionSegment>;
  catalogUERBaseCostWorkScopes?: Maybe<CatalogUerBaseCostWorkScopesCollectionSegment>;
  catalogUERBaseCostWorktypeFOsummFilter?: Maybe<CatalogUerBaseCostWorktypeFOsummFilterCollectionSegment>;
  catalogUERBaseCostWorktypeNameFilter?: Maybe<CatalogUerBaseCostWorktypeNameFilterCollectionSegment>;
  catalogUEROtherCostTemplate: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  catalogUEROtherCostTemplateFiles: ServiceDataResultOfFileContent;
  catalogUEROtherCostTemplates?: Maybe<CatalogUerOtherCostTemplatesCollectionSegment>;
  catalogUpdatedAt: Array<CatalogUpdatedAtData>;
  catalogWorkTypeCodeFilter?: Maybe<CatalogWorkTypeCodeFilterCollectionSegment>;
  catalogWorkTypeItems?: Maybe<CatalogWorkTypeItemsCollectionSegment>;
  catalogWorkTypeNameFilter?: Maybe<CatalogWorkTypeNameFilterCollectionSegment>;
  catalogWorkTypes?: Maybe<CatalogWorkTypesCollectionSegment>;
  catalogWorkTypesUpdatedDate: ServiceDataResultOfCatalogWorkTypeChangesData;
  catalogs?: Maybe<CatalogsCollectionSegment>;
  catalogsMethodologyFilter: Array<FilterValueOfProjectMethodologyEnum>;
  catalogsNameFilter?: Maybe<CatalogsNameFilterCollectionSegment>;
  exportCatalogUERAsExcel: ServiceDataResultOfFileContent;
  exportCatalogUERBaseCostHistoryAsExcel: ServiceDataResultOfFileContent;
  globalConstructionTypes?: Maybe<GlobalConstructionTypesCollectionSegment>;
  globalLimitedCostCandidateTypes: Array<CatalogLimitedCostTypeExtendedData>;
  globalLimitedCosts?: Maybe<GlobalLimitedCostsCollectionSegment>;
  globalOtherCostCandidateTypes: Array<CatalogOtherCostTypeData>;
  globalOtherCosts?: Maybe<GlobalOtherCostsCollectionSegment>;
  globalOtherCostsSelection?: Maybe<GlobalOtherCostsSelectionCollectionSegment>;
  isUniqueGlobalLimitedCost: ServiceResult;
  isUniqueGlobalOtherCost: ServiceResult;
  isUniqueLimitedCostType: ServiceResult;
  isUniqueOtherCostType: ServiceResult;
  isUniqueProjectCode: ServiceResult;
  isUniqueProjectName: ServiceResult;
  isUniqueVariableGroup: ServiceResult;
  isUniqueVariableName: ServiceResult;
  limitedCostTypes: Array<CatalogLimitedCostTypeExtendedData>;
  otherCostTypes: Array<CatalogOtherCostTypeData>;
  project: ServiceDataResultOfProjectData;
  projects?: Maybe<ProjectsCollectionSegment>;
  projectsAuthoredByFilter?: Maybe<ProjectsAuthoredByFilterCollectionSegment>;
  projectsContractTypeFilter?: Maybe<ProjectsContractTypeFilterCollectionSegment>;
  projectsMethodologyFilter?: Maybe<ProjectsMethodologyFilterCollectionSegment>;
  projectsNameFilter?: Maybe<ProjectsNameFilterCollectionSegment>;
  projectsStageFilter?: Maybe<ProjectsStageFilterCollectionSegment>;
  projectsStatusFilter?: Maybe<ProjectsStatusFilterCollectionSegment>;
  projectsSubsidiaryFilter?: Maybe<ProjectsSubsidiaryFilterCollectionSegment>;
  /**
   * Получает Акт КС-2
   *
   *
   * **Returns:**
   * Акт КС-2
   */
  uerActKC2: ServiceDataResultOfActKc2Data;
  /**
   * Получить данные для фильтрации по виду строительства
   *
   *
   * **Returns:**
   * Данные для фильтрации по виду строительства
   */
  uerActKC2GroupConstructionTypeFilter?: Maybe<UerActKc2GroupConstructionTypeFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по группе затрат Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по группе затрат Акта КС-2
   */
  uerActKC2GroupCostGroupFilter?: Maybe<UerActKc2GroupCostGroupFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по дате Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по дате Акта КС-2
   */
  uerActKC2GroupDateFilter?: Maybe<UerActKc2GroupDateFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по номеру Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по номеру Акта КС-2
   */
  uerActKC2GroupNumberFilter?: Maybe<UerActKc2GroupNumberFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по объекту
   *
   *
   * **Returns:**
   * Данные для фильтрации по объекту
   */
  uerActKC2GroupObjectFilter?: Maybe<UerActKc2GroupObjectFilterCollectionSegment>;
  uerActKC2LimitedCostItems?: Maybe<UerActKc2LimitedCostItemsCollectionSegment>;
  /**
   * Метод получения позиций прочих Акта
   *
   *
   * **Returns:**
   * Список позиций прочих Акта
   */
  uerActKC2OtherPriceItems?: Maybe<UerActKc2OtherPriceItemsCollectionSegment>;
  /**
   * Метод получение итогов Акта на прочие затраты
   *
   *
   * **Returns:**
   * Список итогов Акта на прочие затраты
   */
  uerActKC2OtherTotals?: Maybe<UerActKc2OtherTotalsCollectionSegment>;
  /**
   * Метод получения позиций СРМ Акта
   *
   *
   * **Returns:**
   * Список позиций СРМ Акта
   */
  uerActKC2SmrPriceItems?: Maybe<UerActKc2SmrPriceItemsCollectionSegment>;
  /**
   * Метод получение итоговой стоимости по Акту КС-2
   *
   *
   * **Returns:**
   * Список итогов акта
   */
  uerActKC2SmrTotals?: Maybe<UerActKc2SmrTotalsCollectionSegment>;
  /**
   * Получает значение в акта по позиции
   *
   *
   * **Returns:**
   * Данные значения акта по позиции
   */
  uerActKC2SmrValue: ServiceDataResultOfActKc2WorkVolumeData;
  /**
   * Получает статусы Акта КС-2
   *
   *
   * **Returns:**
   * Cтатусы акта КС-2
   */
  uerActKC2Statuses: ServiceDataResultOfActKc2StatusData__;
  /**
   * Получить доступные переменные для позиции Акта КС-2
   *
   *
   * **Returns:**
   * Список доступных для выбора в качестве переменных позиций НЗ
   */
  uerActKC2VolumeVariableSelectionItems?: Maybe<UerActKc2VolumeVariableSelectionItemsCollectionSegment>;
  /**
   * Метод возвращает Справку КС-3
   *
   *
   * **Returns:**
   * Справка КС-3
   */
  uerActKC3: ServiceDataResultOfActKc3Data;
  /**
   * Метод возвращает список согласованных Актов КС-2 указанного договора, не входящих в другие КС-3
   *
   *
   * **Returns:**
   * Список согласованных Актов КС-2 указанного НЗ
   */
  uerActKC3Acts?: Maybe<UerActKc3ActsCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Вид строительства
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Вид строительства
   */
  uerActKC3ActsConstructionTypeFilter?: Maybe<UerActKc3ActsConstructionTypeFilterCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Группа затрат
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Группа затрат
   */
  uerActKC3ActsCostGroupFilter?: Maybe<UerActKc3ActsCostGroupFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по группе затрат Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по группе затрат Акта КС-2
   */
  uerActKC3ActsKC2ActKC2CostGroupFilter?: Maybe<UerActKc3ActsKc2ActKc2CostGroupFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по дате Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по дате Акта КС-2
   */
  uerActKC3ActsKC2ActKC2DateFilter?: Maybe<UerActKc3ActsKc2ActKc2DateFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по дате окончания отчетного периода Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по дате окончания отчетного периода Акта КС-2
   */
  uerActKC3ActsKC2ActKC2FinishDateFilter?: Maybe<UerActKc3ActsKc2ActKc2FinishDateFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по номеру Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по номеру Акта КС-2
   */
  uerActKC3ActsKC2ActKC2NumberFilter?: Maybe<UerActKc3ActsKc2ActKc2NumberFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по дате начала отчетного периода Акта КС-2
   *
   *
   * **Returns:**
   * Данные для фильтрации по дате начала отчетного периода Акта КС-2
   */
  uerActKC3ActsKC2ActKC2StartDateFilter?: Maybe<UerActKc3ActsKc2ActKc2StartDateFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по идентификатору вида строительства
   *
   *
   * **Returns:**
   * Данные для фильтрации по идентификатору вида строительства
   */
  uerActKC3ActsKC2ConstructionTypeIdFilter?: Maybe<UerActKc3ActsKc2ConstructionTypeIdFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по наименованию объекта Договора
   *
   *
   * **Returns:**
   * Данные для фильтрации по наименованию объекта Договора
   */
  uerActKC3ActsKC2ContractObjectNameFilter?: Maybe<UerActKc3ActsKc2ContractObjectNameFilterCollectionSegment>;
  /**
   * Получает список Актов КС-2 заданной Справки КС-3 или список всех Актов Договора
   *
   *
   * **Returns:**
   * Список Актов КС-2
   */
  uerActKC3ActsKC2SelectionList?: Maybe<UerActKc3ActsKc2SelectionListCollectionSegment>;
  /**
   * Получает данные для фильтрации по внутреннему номеру НЗ
   *
   *
   * **Returns:**
   * Данные для фильтрации по внутреннему номеру НЗ
   */
  uerActKC3ActsKC2WorkOrderInternalNumberFilter?: Maybe<UerActKc3ActsKc2WorkOrderInternalNumberFilterCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Объект
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Объект
   */
  uerActKC3ActsObjectFilter?: Maybe<UerActKc3ActsObjectFilterCollectionSegment>;
  /**
   * Получает итоги справки КС-3
   *
   *
   * **Returns:**
   * Список итогов справки КС-3
   */
  uerActKC3Totals: ServiceDataResultOfActKc3TotalData__;
  /**
   * Метод возвращает данные Справки КС3 с Актами
   *
   *
   * **Returns:**
   * Данные Справки КС3 с Актами
   */
  uerActKC3WithActs: ServiceDataResultOfActKc3DataWithActs;
  /**
   * Получить аналитику фактического освоения наряд-заказа по месяцам
   *
   *
   * **Returns:**
   * Данные диаграммы ФО НЗ по сезонам
   */
  uerActsKC2AnalyticsBySeasons?: Maybe<UerActsKc2AnalyticsBySeasonsCollectionSegment>;
  /**
   * Получить аналитику фактического освоения наряд-заказа по расценкам
   *
   *
   * **Returns:**
   * Данные для построения диаграмм ФО НЗ по расценкам
   */
  uerActsKC2AnalyticsByUer?: Maybe<UerActsKc2AnalyticsByUerCollectionSegment>;
  /**
   * Получает список атрибутов группы актов
   *
   *
   * **Returns:**
   * Атрибуты группы
   */
  uerActsKC2Group: ServiceDataResultOfActKc2GroupAttributeData;
  uerAppModuleHealthChecks: ServiceDataResultOfAppHealthCheckData;
  uerAppModuleInfo: ServiceDataResultOfAppModuleInfo;
  uerAppModuleReport: ServiceDataResultOfAppModuleReport;
  /**
   * Рассчитывает значения распределения прочей затраты Изма
   *
   *
   * **Returns:**
   * Результрат расчета распределения прочей
   */
  uerCalcWorkOrderChangeOtherDistribution: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  /** Рассчитывает значения распределения прочих */
  uerCalcWorkOrderOtherDistribution: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  uerCatalogs?: Maybe<UerCatalogsCollectionSegment>;
  /** Получить значения по умолчанию для закрывающего Изма к НЗ */
  uerClosingWorkOrderChangeDefaults: ServiceDataResultOfWorkOrderChangeData;
  /**
   * Получает договор
   *
   *
   * **Returns:**
   * Договор
   */
  uerContract: ServiceDataResultOfUerContractData;
  /** Получить записи истории изменений договора */
  uerContractActionLogEntries?: Maybe<UerContractActionLogEntriesCollectionSegment>;
  /**
   * Получает данные реестра справок КС-3 по договору
   *
   *
   * **Returns:**
   * Список справок КС-3 с данными по Актам КС-2
   */
  uerContractActsKC3?: Maybe<UerContractActsKc3CollectionSegment>;
  /**
   * Получить данные для фильтрации по дате Справки КС-3
   *
   *
   * **Returns:**
   * Данные для фильтрации по дате Справки КС-3
   */
  uerContractActsKC3DateFilter?: Maybe<UerContractActsKc3DateFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по полному номеру Справки КС-3
   *
   *
   * **Returns:**
   * Данные для фильтрации по номеру Справки КС-3
   */
  uerContractActsKC3FullNumberFilter?: Maybe<UerContractActsKc3FullNumberFilterCollectionSegment>;
  /**
   * Метод получает реквизиты дополнительного соглашения
   *
   *
   * **Returns:**
   * Модель данных реквизитов дополнительного соглашения
   */
  uerContractChange: ServiceDataResultOfContractChangeData;
  uerContractChangeCreatedAtFilter?: Maybe<UerContractChangeCreatedAtFilterCollectionSegment>;
  uerContractChangeInternalNumberFilter?: Maybe<UerContractChangeInternalNumberFilterCollectionSegment>;
  uerContractChangeMtrCodeFilter?: Maybe<UerContractChangeMtrCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Шифр в списке МТР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerContractChangeMtrForIncludingCodeFilter?: Maybe<UerContractChangeMtrForIncludingCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Используется в Акте в списке МТР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeMtrForIncludingIsIncludedInActFilter?: Maybe<UerContractChangeMtrForIncludingIsIncludedInActFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Используется в НЗ в списке МТР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в НЗ
   */
  uerContractChangeMtrForIncludingIsIncludedInWorkOrderFilter?: Maybe<UerContractChangeMtrForIncludingIsIncludedInWorkOrderFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Наименование в списке МТР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerContractChangeMtrForIncludingNameFilter?: Maybe<UerContractChangeMtrForIncludingNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Статус записи в списке МТР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус записи
   */
  uerContractChangeMtrForIncludingStatusFilter?: Maybe<UerContractChangeMtrForIncludingStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Единица измерения в списке МТР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Единица измерения
   */
  uerContractChangeMtrForIncludingUnitFilter?: Maybe<UerContractChangeMtrForIncludingUnitFilterCollectionSegment>;
  uerContractChangeMtrJustificationFilter?: Maybe<UerContractChangeMtrJustificationFilterCollectionSegment>;
  uerContractChangeMtrNameFilter?: Maybe<UerContractChangeMtrNameFilterCollectionSegment>;
  uerContractChangeMtrStatusFilter?: Maybe<UerContractChangeMtrStatusFilterCollectionSegment>;
  uerContractChangeMtrSupplyByFilter?: Maybe<UerContractChangeMtrSupplyByFilterCollectionSegment>;
  uerContractChangeMtrUnitFilter?: Maybe<UerContractChangeMtrUnitFilterCollectionSegment>;
  /**
   * Получить список получения прочих затрат Доп. Соглашения.
   *
   *
   * **Returns:**
   * Cписком прочих затрат Доп. Соглашения
   */
  uerContractChangeOtherCostRows?: Maybe<UerContractChangeOtherCostRowsCollectionSegment>;
  /**
   * Получить список получения прочих затрат для добавления в ДС
   *
   *
   * **Returns:**
   * Cписком прочих затрат для добавления в ДС
   */
  uerContractChangeOtherCostRowsForIncluding?: Maybe<UerContractChangeOtherCostRowsForIncludingCollectionSegment>;
  /**
   * Метод получает список МТР дополнительного соглашения
   *
   *
   * **Returns:**
   * Список МТР дополнительного соглашения
   */
  uerContractChangePriceListMtr?: Maybe<UerContractChangePriceListMtrCollectionSegment>;
  /**
   * Метод получает список Коэффициентов дополнительного соглашения
   *
   *
   * **Returns:**
   * Список Коэффициентов дополнительного соглашения
   */
  uerContractChangePriceListRatio?: Maybe<UerContractChangePriceListRatioCollectionSegment>;
  /**
   * Метод получает список коэффициентов для отображения табличной части вкладки "Коэффициенты" в ДС (УЕР)
   *
   *
   * **Returns:**
   * Список Коэффициентов для отображения табличной части вкладки "Коэффициенты" в ДС (УЕР)
   */
  uerContractChangePriceListRatioRows?: Maybe<UerContractChangePriceListRatioRowsCollectionSegment>;
  /**
   * Метод получает список УЕР дополнительного соглашения
   *
   *
   * **Returns:**
   * Список УЕР дополнительного соглашения
   */
  uerContractChangePriceListUer?: Maybe<UerContractChangePriceListUerCollectionSegment>;
  /**
   * Получает данные для фильтрации по Расценке в табличной части вкладки "Коэффициенты"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioAppliesToCodeNameFilter?: Maybe<UerContractChangeRatioAppliesToCodeNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации фильтр по Статусу связи в табличной части вкладки "Коэффициенты"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioAppliesToLinkStatusFilter?: Maybe<UerContractChangeRatioAppliesToLinkStatusFilterCollectionSegment>;
  uerContractChangeRatioCodeAndAppliesNamesToFilter?: Maybe<UerContractChangeRatioCodeAndAppliesNamesToFilterCollectionSegment>;
  uerContractChangeRatioCodeAndAppliesToFilter?: Maybe<UerContractChangeRatioCodeAndAppliesToFilterCollectionSegment>;
  uerContractChangeRatioCodeFilter?: Maybe<UerContractChangeRatioCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации фильтр по Шифру в диалоге со списком расценок по коэффициенту
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioForIncludingAppliesToCodeFilter?: Maybe<UerContractChangeRatioForIncludingAppliesToCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации фильтр по Наименованию в диалоге со списком расценок по коэффициенту
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioForIncludingAppliesToCodeNameFilter?: Maybe<UerContractChangeRatioForIncludingAppliesToCodeNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации фильтр по Статусу связи в диалоге со списком расценок по коэффициенту
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioForIncludingAppliesToLinkStatusFilter?: Maybe<UerContractChangeRatioForIncludingAppliesToLinkStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Шифр в списке коэффициентов для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerContractChangeRatioForIncludingCodeFilter?: Maybe<UerContractChangeRatioForIncludingCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Используется в Акте в списке коэффициентов для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioForIncludingIsIncludedInActFilter?: Maybe<UerContractChangeRatioForIncludingIsIncludedInActFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Используется в НЗ в списке коэффициентов для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в НЗ
   */
  uerContractChangeRatioForIncludingIsIncludedInWorkOrderFilter?: Maybe<UerContractChangeRatioForIncludingIsIncludedInWorkOrderFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Статус связи в списке коэффициентов для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус связи
   */
  uerContractChangeRatioForIncludingLinkStatusFilter?: Maybe<UerContractChangeRatioForIncludingLinkStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Статус записи в списке коэффициентов для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус записи
   */
  uerContractChangeRatioForIncludingStatusFilter?: Maybe<UerContractChangeRatioForIncludingStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Наименование в списке коэффициентов для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerContractChangeRatioForIncludingWorkConditionsFilter?: Maybe<UerContractChangeRatioForIncludingWorkConditionsFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Подразделу в табличной части вкладки "Коэффициенты"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioGroupFullNameFilter?: Maybe<UerContractChangeRatioGroupFullNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации фильтр по Использованию записи в Изм. к НЗ в диалоге добавления коэффициента / в табличной части вкладки "Коэффициенты"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioIsIncludedInWorkOrderChange?: Maybe<UerContractChangeRatioIsIncludedInWorkOrderChangeCollectionSegment>;
  /**
   * Получает данные для фильтрации фильтр по Использованию записи в Изм. к НЗ в диалоге добавления коэффициента / в табличной части вкладки "Коэффициенты"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioRowForIncludingIsIncludedInWorkOrderChange?: Maybe<UerContractChangeRatioRowForIncludingIsIncludedInWorkOrderChangeCollectionSegment>;
  /**
   * Получает данные для фильтрации по Разделу в табличной части вкладки "Коэффициенты"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeRatioSectionNameFilter?: Maybe<UerContractChangeRatioSectionNameFilterCollectionSegment>;
  uerContractChangeRatioStatusFilter?: Maybe<UerContractChangeRatioStatusFilterCollectionSegment>;
  uerContractChangeRatioWorkConditionsFilter?: Maybe<UerContractChangeRatioWorkConditionsFilterCollectionSegment>;
  uerContractChangeRatioWorkTypeFilter?: Maybe<UerContractChangeRatioWorkTypeFilterCollectionSegment>;
  uerContractChangeSigningDateFilter?: Maybe<UerContractChangeSigningDateFilterCollectionSegment>;
  uerContractChangeStatusFilter?: Maybe<UerContractChangeStatusFilterCollectionSegment>;
  uerContractChangeSubjectFilter?: Maybe<UerContractChangeSubjectFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Наименование, включая работы, в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование, включая работы
   * @deprecated Использовать метод GetContractChangeUerForIncludingNameFilter для фильтрации
   */
  uerContractChangeUerAndWorkScopeForIncludingNameFilter?: Maybe<UerContractChangeUerAndWorkScopeForIncludingNameFilterCollectionSegment>;
  /** @deprecated Использовать метод GetContractChangeUerNameFilter для фильтрации */
  uerContractChangeUerAndWorkScopeNameFilter?: Maybe<UerContractChangeUerAndWorkScopeNameFilterCollectionSegment>;
  uerContractChangeUerChapterFilter?: Maybe<UerContractChangeUerChapterFilterCollectionSegment>;
  uerContractChangeUerCodeFilter?: Maybe<UerContractChangeUerCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Шифр в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerContractChangeUerForIncludingCodeFilter?: Maybe<UerContractChangeUerForIncludingCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Подразделу в диалоге добавления расценки (УЕР)
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerForIncludingGroupFullNameFilter?: Maybe<UerContractChangeUerForIncludingGroupFullNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Используется в Акте в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerForIncludingIsIncludedInActFilter?: Maybe<UerContractChangeUerForIncludingIsIncludedInActFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Используется в НЗ в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в НЗ
   */
  uerContractChangeUerForIncludingIsIncludedInWorkOrderFilter?: Maybe<UerContractChangeUerForIncludingIsIncludedInWorkOrderFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Статус связи в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус связи
   */
  uerContractChangeUerForIncludingLinkStatusFilter?: Maybe<UerContractChangeUerForIncludingLinkStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Наименование в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerContractChangeUerForIncludingNameFilter?: Maybe<UerContractChangeUerForIncludingNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Разделу в диалоге добавления расценки (УЕР)
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerForIncludingSectionNameFilter?: Maybe<UerContractChangeUerForIncludingSectionNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Статус записи в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус записи
   */
  uerContractChangeUerForIncludingStatusFilter?: Maybe<UerContractChangeUerForIncludingStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Единица измерения в списке УЕР для добавления в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Единица измерения
   */
  uerContractChangeUerForIncludingUnitFilter?: Maybe<UerContractChangeUerForIncludingUnitFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Подразделу в табличной части вкладки "Расценки"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerGroupFullNameFilter?: Maybe<UerContractChangeUerGroupFullNameFilterCollectionSegment>;
  uerContractChangeUerJustificationFilter?: Maybe<UerContractChangeUerJustificationFilterCollectionSegment>;
  uerContractChangeUerNameFilter?: Maybe<UerContractChangeUerNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Разделу в табличной части вкладки "Расценки"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerSectionNameFilter?: Maybe<UerContractChangeUerSectionNameFilterCollectionSegment>;
  uerContractChangeUerStatusFilter?: Maybe<UerContractChangeUerStatusFilterCollectionSegment>;
  uerContractChangeUerTypeFilter?: Maybe<UerContractChangeUerTypeFilterCollectionSegment>;
  uerContractChangeUerUnitFilter?: Maybe<UerContractChangeUerUnitFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Наименованию в диалоге состава работ по расценке
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerWorkScopDescriptionFilter?: Maybe<UerContractChangeUerWorkScopDescriptionFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Участие в суммировании ФО по виду работ в табличной части вкладки "Расценки"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerWorkTypeInSumFilter?: Maybe<UerContractChangeUerWorkTypeInSumFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Наименованию вида работ в табличной части вкладки "Расценки"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Используется в Акте
   */
  uerContractChangeUerWorkTypeNameFilter?: Maybe<UerContractChangeUerWorkTypeNameFilterCollectionSegment>;
  /**
   * Метод получает список дополнительных соглашений
   *
   *
   * **Returns:**
   * Список дополнительных соглашений
   */
  uerContractChanges?: Maybe<UerContractChangesCollectionSegment>;
  /**
   * Получает общие данные Договора
   *
   *
   * **Returns:**
   * Общие данные Договора
   */
  uerContractCommonData: ServiceDataResultOfContractCommonData;
  /**
   * Метод получения видов строительства договора
   *
   *
   * **Returns:**
   * Список видов строительства договора
   */
  uerContractConstructionTypes: ServiceDataResultOfConstructionTypeData__;
  /**
   * Метод получает список лимитированных затрат договора
   *
   *
   * **Returns:**
   * Список лимитированных затрат договора
   */
  uerContractLimitedCostItems?: Maybe<UerContractLimitedCostItemsCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Наименование
   */
  uerContractLimitedCostNameFilter?: Maybe<UerContractLimitedCostNameFilterCollectionSegment>;
  /**
   * Получает список объектов договора
   *
   *
   * **Returns:**
   * Список объектов договора
   */
  uerContractObjects: Array<ContractObjectData>;
  uerContractObjectsToAddToWorkOrderChange: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  /**
   * Метод получает данные для фильтрации по столбцу Способ расчета
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Способ расчета
   */
  uerContractOtherCostCalculatingTypeFilter?: Maybe<UerContractOtherCostCalculatingTypeFilterCollectionSegment>;
  /** Метод получения прочую затрату договора с данными для обновления */
  uerContractOtherCostForUpdate: ServiceDataResultOfContractOtherCostUpdateData;
  /** Получить суммы для перераспределения лимитов по договору */
  uerContractOtherCostLimitSpanSelectionList: Array<ContractOtherCostLimitSpanSelectionItem>;
  /**
   * Метод получает данные для фильтрации по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Наименование
   */
  uerContractOtherCostNameFilter?: Maybe<UerContractOtherCostNameFilterCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Статус
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Статус
   */
  uerContractOtherCostStatusFilter?: Maybe<UerContractOtherCostStatusFilterCollectionSegment>;
  /**
   * Метод получает список типов прочих затрат, не используемых в прочих договора
   *
   *
   * **Returns:**
   * Список прочих затрат договора
   */
  uerContractOtherCostTypes?: Maybe<UerContractOtherCostTypesCollectionSegment>;
  /**
   * Метод получает список прочих затрат договора
   *
   *
   * **Returns:**
   * Список прочих затрат договора
   */
  uerContractOtherCosts?: Maybe<UerContractOtherCostsCollectionSegment>;
  /**
   * Метод получает список прочих затрат договора
   *
   *
   * **Returns:**
   * Список прочих затрат договора
   */
  uerContractOtherCostsConstructionTypeLimit?: Maybe<UerContractOtherCostsConstructionTypeLimitCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Статус связи
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу Статус связи
   */
  uerContractOtherRelationStatusFilter?: Maybe<UerContractOtherRelationStatusFilterCollectionSegment>;
  /**
   * Метод получения данных накопительной ведомости по Договору
   *
   *
   * **Returns:**
   * Данные накопительной ведомости
   */
  uerContractResults: ServiceDataResultOfContractResultsViewData;
  /**
   * Получает сезоны Договора
   *
   *
   * **Returns:**
   * Сзоны Договора
   */
  uerContractSeasons: ServiceDataResultOfContractSeasonData__;
  /**
   * Получает статусы договора
   *
   *
   * **Returns:**
   * Cтатусы договора
   */
  uerContractStatuses: ServiceDataResultOfContractStatusData__;
  /** Получить информацию о наряд-заказах для указанного договора */
  uerContractWorkOrders: Array<ContractWorkOrderData>;
  /** Возвращает вычисления текущей стоимости для видов строительства расценки в статусе "Условие договора"  */
  uerCurrentEstimateBasis: ServiceDataResultOfPriceListUerRowBasisData;
  /** Экспортирует Акт КС-2 в Excel файл. */
  uerExportActKC2AsExcel: ServiceDataResultOfFileContent;
  uerExportActKC2TemplateAsExcel: ServiceDataResultOfFileContent;
  /** Экспортирует Справку КС-3 в Excel файл */
  uerExportActKC3AsExcel: ServiceDataResultOfFileContent;
  /** Метод выгрузки Excel файла аналитики Дополнительного Соглашения. */
  uerExportContractChangeAnalyticsAsExcel: ServiceDataResultOfFileContent;
  /**
   * Экспортировать накопительную ведомость по Договору в Excel
   *
   *
   * **Returns:**
   * Накопительную ведомость по Договору
   */
  uerExportContractResults: ServiceDataResultOfFileContent;
  /**
   * Экспортировать аналитику Изменений НЗ в Excel
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerExportWorkOrderChangeAnalytics: ServiceDataResultOfFileContent;
  /**
   * Экспортировать аналитику Изменений НЗ в Excel
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerExportWorkOrderChangeAsExcel: ServiceDataResultOfFileContent;
  /**
   * Экспортировать накопительную ведомость НЗ в Excel
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerExportWorkOrderPrices: ServiceDataResultOfFileContent;
  /** Получает список прочих для заданной методологии и договора */
  uerGlobalOtherCostsForContract?: Maybe<UerGlobalOtherCostsForContractCollectionSegment>;
  /** Используется ли вид строительства с указанным кодом в каком-либо договоре (УЕР) */
  uerIsContractConstructionTypeUsed: ServiceDataResultOfObject;
  /**
   * Проверяет уникальность наименования Группы актов КС-2
   *
   *
   * **Returns:**
   * результаты проверки
   */
  uerIsUniqueActKC2GroupName: ServiceResult;
  /**
   * Проверка - является ли внутренний номер акта уникальным
   *
   *
   * **Returns:**
   * результаты проверки
   */
  uerIsUniqueActKC2InternalNumber: ServiceResult;
  /**
   * Метод проверяет, является ли Внутренний номер Справки КС3 уникальным в пределах указанного договора
   *
   *
   * **Returns:**
   * Является ли Внутренний номер Справки КС3 уникальным
   */
  uerIsUniqueActKC3InternalNumber: ServiceResult;
  /**
   * Метод проверяет уникальность номера ДС
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  uerIsUniqueContractChangeInternalNumber: ServiceResult;
  /**
   * Проверка - является ли внутренний номер договора уникальным
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniqueContractInternalNumber: ServiceResult;
  /**
   * Проверяет уникальность кода объекта/подобъекта в рамках договора
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniqueContractObjectCode: ServiceResult;
  /**
   * Проверяет, является ли наименование объекта договора уникальным в рамках вида строительства
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniqueContractObjectName: ServiceResult;
  /**
   * Проверяет уникальность кода прочей затраты в рамках договора
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniqueContractOtherCostKey: ServiceResult;
  /** Проверка уникальности наименования прочей в рамках договора */
  uerIsUniqueContractOtherName: ServiceResult;
  /**
   * Проверяет, является ли наименование подобъекта уникальным в рамках родительского объекта
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniqueContractSubObjectName: ServiceResult;
  /**
   * Проверяет уникальность Шифра МТР в рамках договора
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniquePriceListMtrRowCode: ServiceResult;
  /**
   * Проверяет уникальность кода МТР в рамках договора
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uerIsUniquePriceListMtrRowKey: ServiceResult;
  /** Проверяет уникальность наименования коэффициента в заданном прейскуранте */
  uerIsUniqueRatioWorkConditions: ServiceResult;
  /**
   * Метод проверяет уникальность номера изма к НЗ
   *
   *
   * **Returns:**
   * Результат выполнения сервиса
   */
  uerIsUniqueWorkOrderChangeInternalNumber: ServiceResult;
  /** Проверить валидность даты справки КС-3 */
  uerIsValidActKC3Date: ServiceResult;
  /**
   * Возвращает список МТР для сопоставления с другим МТР по Id
   *
   *
   * **Returns:**
   * Список МТР сопоставимых с заданным
   */
  uerMtrRowsForComparison?: Maybe<UerMtrRowsForComparisonCollectionSegment>;
  /**
   * Получает данные для фильтрации по Способу расчета прочих при добавлении в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Способ расчета
   */
  uerOthersForIncludingToContractChangeCalculatingTypeFilter?: Maybe<UerOthersForIncludingToContractChangeCalculatingTypeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Наименование прочих при добавлении в ДС
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerOthersForIncludingToContractChangeNameFilter?: Maybe<UerOthersForIncludingToContractChangeNameFilterCollectionSegment>;
  /** Возвращает данные расценки считанные из сметы-основания */
  uerParsedEstimateBasis: ServiceDataResultOfPriceListUerRowBasisData;
  /** Возвращает расценку МТР прайслиста по фильтру. */
  uerPriceListMtr?: Maybe<UerPriceListMtrCollectionSegment>;
  uerPriceListMtrCodeFilter?: Maybe<UerPriceListMtrCodeFilterCollectionSegment>;
  /**
   * Метод получает список МТР для включения в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список МТР для включения в дополнительное соглашение
   */
  uerPriceListMtrForIncludingToContractChange?: Maybe<UerPriceListMtrForIncludingToContractChangeCollectionSegment>;
  uerPriceListMtrJustificationFilter?: Maybe<UerPriceListMtrJustificationFilterCollectionSegment>;
  uerPriceListMtrNameFilter?: Maybe<UerPriceListMtrNameFilterCollectionSegment>;
  /** Возвращает расценку МТР по Id. */
  uerPriceListMtrRow: ServiceDataResultOfPriceListMtrRowData;
  uerPriceListMtrStatusFilter?: Maybe<UerPriceListMtrStatusFilterCollectionSegment>;
  uerPriceListMtrSupplyByFilter?: Maybe<UerPriceListMtrSupplyByFilterCollectionSegment>;
  uerPriceListMtrTypeFilter?: Maybe<UerPriceListMtrTypeFilterCollectionSegment>;
  uerPriceListMtrUnitFilter?: Maybe<UerPriceListMtrUnitFilterCollectionSegment>;
  /** Возвращает сглаженный прейскурант коэффициентов */
  uerPriceListRatio?: Maybe<UerPriceListRatioCollectionSegment>;
  uerPriceListRatioAppliesToFullNameFilter?: Maybe<UerPriceListRatioAppliesToFullNameFilterCollectionSegment>;
  uerPriceListRatioCodeAndAppliesNamesToFilter?: Maybe<UerPriceListRatioCodeAndAppliesNamesToFilterCollectionSegment>;
  uerPriceListRatioCodeAndAppliesToFilter?: Maybe<UerPriceListRatioCodeAndAppliesToFilterCollectionSegment>;
  uerPriceListRatioCodeFilter?: Maybe<UerPriceListRatioCodeFilterCollectionSegment>;
  /**
   * Метод получает список Коэффициентов для включения в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список Коэффициентов для включения в дополнительное соглашение
   */
  uerPriceListRatioForIncludingToContractChange?: Maybe<UerPriceListRatioForIncludingToContractChangeCollectionSegment>;
  /**
   * Получает данные для фильтрации по Шифру в диалоге расценки к коэффициенту
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerPriceListRatioForIncludingToContractChangeCodeFilter?: Maybe<UerPriceListRatioForIncludingToContractChangeCodeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Наименованию в диалоге расценки к коэффициенту
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerPriceListRatioForIncludingToContractChangeNameFilter?: Maybe<UerPriceListRatioForIncludingToContractChangeNameFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по Статус связи в диалоге расценки к коэффициенту
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус связи
   */
  uerPriceListRatioForIncludingToContractChangeStatusFilter?: Maybe<UerPriceListRatioForIncludingToContractChangeStatusFilterCollectionSegment>;
  uerPriceListRatioGroupFullNameFilter?: Maybe<UerPriceListRatioGroupFullNameFilterCollectionSegment>;
  /** Возвращает коэффициент из прейскуранта по его идентификатору */
  uerPriceListRatioRow: ServiceDataResultOfPriceListRatioGroupedRowData;
  /** Возвращает структуру прейскуранта коэффициентов (УЕР) */
  uerPriceListRatioRows?: Maybe<UerPriceListRatioRowsCollectionSegment>;
  /** Возвращает коэффициенты для последующего добавления выбранной расценки в их области применения. */
  uerPriceListRatioRowsWithScopes?: Maybe<UerPriceListRatioRowsWithScopesCollectionSegment>;
  uerPriceListRatioSectionNameFilter?: Maybe<UerPriceListRatioSectionNameFilterCollectionSegment>;
  uerPriceListRatioStatusFilter?: Maybe<UerPriceListRatioStatusFilterCollectionSegment>;
  /** Возвращает структуру расценок из области применения коэффициента */
  uerPriceListRatioUerRows?: Maybe<UerPriceListRatioUerRowsCollectionSegment>;
  uerPriceListRatioWorkConditionsFilter?: Maybe<UerPriceListRatioWorkConditionsFilterCollectionSegment>;
  uerPriceListRatioWorkTypeFilter?: Maybe<UerPriceListRatioWorkTypeFilterCollectionSegment>;
  /** Возвращает сглаженное представление списка расценок УЕР для представления прейскуранта */
  uerPriceListUer?: Maybe<UerPriceListUerCollectionSegment>;
  uerPriceListUerAndWorkScopeNameFilter?: Maybe<UerPriceListUerAndWorkScopeNameFilterCollectionSegment>;
  uerPriceListUerChapterFilter?: Maybe<UerPriceListUerChapterFilterCollectionSegment>;
  uerPriceListUerCodeFilter?: Maybe<UerPriceListUerCodeFilterCollectionSegment>;
  /** Возвращает список расценок для определения области определения коэффициента стесненности */
  uerPriceListUerForConstraintRatio?: Maybe<UerPriceListUerForConstraintRatioCollectionSegment>;
  /** Возвращает области применения коэффициента на демонтаж расценками */
  uerPriceListUerForDismantlingRatio?: Maybe<UerPriceListUerForDismantlingRatioCollectionSegment>;
  /**
   * Сервис фильтрации для получения данных по расценокам для коэффициента демонтаж
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу шифр расценки
   */
  uerPriceListUerForDismantlingRatioUerCodeFilter?: Maybe<UerPriceListUerForDismantlingRatioUerCodeFilterCollectionSegment>;
  /**
   * Сервис фильтрации для получения данных по расценокам для коэффициента демонтаж
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу группа расценки
   */
  uerPriceListUerForDismantlingRatioUerGroupFilter?: Maybe<UerPriceListUerForDismantlingRatioUerGroupFilterCollectionSegment>;
  /**
   * Сервис фильтрации для получения данных по расценокам для коэффициента демонтаж
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу наименование расценки
   */
  uerPriceListUerForDismantlingRatioUerNameFilter?: Maybe<UerPriceListUerForDismantlingRatioUerNameFilterCollectionSegment>;
  /**
   * Сервис фильтрации для получения данных по расценокам для коэффициента демонтаж
   *
   *
   * **Returns:**
   * Данные для фильтров по столбцу ед. измерения
   */
  uerPriceListUerForDismantlingRatioUerUnitFilter?: Maybe<UerPriceListUerForDismantlingRatioUerUnitFilterCollectionSegment>;
  /**
   * Метод получает список УЕР для включения в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список УЕР для включения в дополнительное соглашение
   */
  uerPriceListUerForIncludingToContractChange?: Maybe<UerPriceListUerForIncludingToContractChangeCollectionSegment>;
  /** Возвращает список расценок для определения области определения коэффициента технической части */
  uerPriceListUerForTechPartRatio?: Maybe<UerPriceListUerForTechPartRatioCollectionSegment>;
  uerPriceListUerGroupDataFilter?: Maybe<UerPriceListUerGroupDataFilterCollectionSegment>;
  uerPriceListUerGroupFullNameFilter?: Maybe<UerPriceListUerGroupFullNameFilterCollectionSegment>;
  uerPriceListUerJustificationFilter?: Maybe<UerPriceListUerJustificationFilterCollectionSegment>;
  uerPriceListUerNameFilter?: Maybe<UerPriceListUerNameFilterCollectionSegment>;
  /** Метод получает данные для фильтрации по столбцу Шифр в окне Добавления коэффициента из прейскуранта коэффициентов */
  uerPriceListUerRatioRowsCodeFilter?: Maybe<UerPriceListUerRatioRowsCodeFilterCollectionSegment>;
  /** Метод получает данные для фильтрации по столбцу Наименование в окне Добавления коэффициента из прейскуранта коэффициентов */
  uerPriceListUerRatioRowsNameFilter?: Maybe<UerPriceListUerRatioRowsNameFilterCollectionSegment>;
  /** Возвращает данные расценки УЕР по ее идентификатору */
  uerPriceListUerRow: ServiceDataResultOfPriceListUerRowData;
  /** Возвращает данные расценки УЕР, включая данные по коэффициентам входящим в расценку, по ее идентификатору */
  uerPriceListUerRowWithRatio: ServiceDataResultOfPriceListUerRowWithRatioData;
  /** Возвращает список разделов расценок доступных для назначения коэффициентам стесненности */
  uerPriceListUerSectionForConstraintRatio?: Maybe<UerPriceListUerSectionForConstraintRatioCollectionSegment>;
  uerPriceListUerSectionNameFilter?: Maybe<UerPriceListUerSectionNameFilterCollectionSegment>;
  uerPriceListUerStatusFilter?: Maybe<UerPriceListUerStatusFilterCollectionSegment>;
  uerPriceListUerTypeFilter?: Maybe<UerPriceListUerTypeFilterCollectionSegment>;
  uerPriceListUerUnitFilter?: Maybe<UerPriceListUerUnitFilterCollectionSegment>;
  uerPriceListUerWorkCodeFilter?: Maybe<UerPriceListUerWorkCodeFilterCollectionSegment>;
  uerPriceListUerWorkInSumFilter?: Maybe<UerPriceListUerWorkInSumFilterCollectionSegment>;
  uerPriceListUerWorkNameFilter?: Maybe<UerPriceListUerWorkNameFilterCollectionSegment>;
  uerPriceListUerWorkUnitFilter?: Maybe<UerPriceListUerWorkUnitFilterCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Шифр в табличной форме коэффициентов
   *
   *
   * **Returns:**
   * Данные для для фильтрации по столбцу Шифр в табличной форме коэффициентов
   */
  uerRatioAppliesToCodeFilter?: Maybe<UerRatioAppliesToCodeFilterCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Наименование в табличной форме коэффициентов
   *
   *
   * **Returns:**
   * Данные для для фильтрации по столбцу Наименование в табличной форме коэффициентов
   */
  uerRatioAppliesToCodeNameFilter?: Maybe<UerRatioAppliesToCodeNameFilterCollectionSegment>;
  /**
   * Метод получает данные для фильтрации по столбцу Статус связи в табличной форме коэффициентов
   *
   *
   * **Returns:**
   * Данные для для фильтрации по столбцу Статус связи в табличной форме коэффициентов
   */
  uerRatioAppliesToLinkStatusFilter?: Maybe<UerRatioAppliesToLinkStatusFilterCollectionSegment>;
  /** Возвращает коллекцию коэффициентов из прейскуранта */
  uerRatioCollection?: Maybe<UerRatioCollectionCollectionSegment>;
  /**
   * Получает значения по умолчанию для некоторых свойств при создании нового коэффициента
   *
   *
   * **Returns:**
   * Данные по умолчентю для нового коэффициента
   */
  uerRatioRowDefaults: ServiceDataResultOfRatioRowData;
  /**
   * Метод получает список Коэффициентов без связи с их расценками для включения в дополнительное соглашение
   *
   *
   * **Returns:**
   * Список Коэффициентов для включения в дополнительное соглашение
   */
  uerRatioRowForIncludingToContractChange?: Maybe<UerRatioRowForIncludingToContractChangeCollectionSegment>;
  /** Возвращает список расценок к коэффициенту по подобъектам Изм. к НЗ */
  uerRatioUerRowItemListForWorkOrderObjects?: Maybe<UerRatioUerRowItemListForWorkOrderObjectsCollectionSegment>;
  /** Возвращает список расценок к коэффициенту по корневому объекту Изм. к НЗ */
  uerRatioUerRowItemListForWorkOrderRootObject?: Maybe<UerRatioUerRowItemListForWorkOrderRootObjectCollectionSegment>;
  /**
   * Получение коэффициентов для включения к измененным объектам наряд-заказа.
   *
   *
   * **Returns:**
   * Список коэффициентов и расценок для включения в наряд-заказ
   */
  uerRatioUerRowItemsForWorkOrderObjects?: Maybe<UerRatioUerRowItemsForWorkOrderObjectsCollectionSegment>;
  /**
   * Получение коэффициентов для включения к измененным объектам наряд-заказа.
   *
   *
   * **Returns:**
   * Список коэффициентов и расценок для включения в наряд-заказ
   */
  uerRatioUerRowItemsForWorkOrderRootObject?: Maybe<UerRatioUerRowItemsForWorkOrderRootObjectCollectionSegment>;
  /** Получить данные договора для СКзС по его внутреннему номеру */
  uerSkzsContract: ServiceDataResultOfSkzsContractData;
  /**
   * Получить список договоров на реализации для использования в СКзС
   *
   *
   * **Returns:**
   * Список договоров
   */
  uerSkzsContractsInProgress?: Maybe<UerSkzsContractsInProgressCollectionSegment>;
  /**
   * Метод получает расценки прейскуранта договора для использования в СКзС
   *
   *
   * **Returns:**
   * Список расценок прейскуранта
   */
  uerSkzsUerPriceList?: Maybe<UerSkzsUerPriceListCollectionSegment>;
  /** Получить объекты наряд-заказа для СКзС */
  uerSkzsWorkOrderObjects?: Maybe<UerSkzsWorkOrderObjectsCollectionSegment>;
  /** Получить расценки наряд-заказа для СКзС */
  uerSkzsWorkOrderPrices?: Maybe<UerSkzsWorkOrderPricesCollectionSegment>;
  /** Получить наряд заказы в статуте 'В работе', для договора */
  uerSkzsWorkOrdersInProgress?: Maybe<UerSkzsWorkOrdersInProgressCollectionSegment>;
  /** Возвращает информацию о загруженных главах и типах прейскуранта рсценок */
  uerUerRowReadyInfo: ServiceDataResultOfPriceListUerRowReadyInfo;
  /**
   * Возвращает наряд-заказ
   *
   *
   * **Returns:**
   * Наряд-заказ
   */
  uerWorkOrder: ServiceDataResultOfWorkOrderData;
  /**
   * Возвращает ограниченный список позиций из Наряд-заказа - записи МТР с признаком поставки "Подрядчик" (ОП и МП) в составе родительских расценок
   *
   *
   * **Returns:**
   * Ограниченный список позиций из Наряд-заказа - записи МТР с признаком поставки "Подрядчик" (ОП и МП) в составе родительских расценок
   */
  uerWorkOrderActKC2MtrForInflationDistribution?: Maybe<UerWorkOrderActKc2MtrForInflationDistributionCollectionSegment>;
  /** Метод получения актов НЗ */
  uerWorkOrderActs?: Maybe<UerWorkOrderActsCollectionSegment>;
  /**
   * Получает список Актов для корневого объекта НЗ
   *
   *
   * **Returns:**
   * Список Актов для корневого объекта НЗ
   */
  uerWorkOrderActsKC2?: Maybe<UerWorkOrderActsKc2CollectionSegment>;
  /**
   * Возвращает плоский список актов
   *
   *
   * **Returns:**
   * Плоский список актов
   */
  uerWorkOrderActsKC2Registry?: Maybe<UerWorkOrderActsKc2RegistryCollectionSegment>;
  /**
   * Получить плоский список актов СМР и Прочих
   *
   *
   * **Returns:**
   * Плоский список актов
   */
  uerWorkOrderActsKC2RegistrySelectionList?: Maybe<UerWorkOrderActsKc2RegistrySelectionListCollectionSegment>;
  /**
   * Метод получает реквизиты изма к НЗ
   *
   *
   * **Returns:**
   * Реквизиты Изма к НЗ
   */
  uerWorkOrderChange: ServiceDataResultOfWorkOrderChangeData;
  /**
   * Получить список сезонов договора, которые либо входят в Изм, либо могут быть добавлены в Изм
   *
   *
   * **Returns:**
   * Запрос на список допустимых сезонов из договора
   */
  uerWorkOrderChangeAllowedSeasons: Array<ContractSeasonData>;
  /** /Получить данные по черновикам Изма к НЗ */
  uerWorkOrderChangeDraftInfo: ServiceDataResultOfWorkOrderChangeDraftInfo;
  /**
   * Получить список сезонов договора, которые можно установить как конечный сезон изма
   *
   *
   * **Returns:**
   * Запрос на список допустимых сезонов из договора
   */
  uerWorkOrderChangeLastSeasonSelectionList: Array<ContractSeasonData>;
  /**
   * Метод получения лимитированных затрат (Доп. транспорт) Изма к НЗ
   *
   *
   * **Returns:**
   * Список лимитированных затрат Изма к НЗ
   */
  uerWorkOrderChangeLimitedCostItems?: Maybe<UerWorkOrderChangeLimitedCostItemsCollectionSegment>;
  /**
   * Получает список объектов Изма к НЗ
   *
   *
   * **Returns:**
   * Список объектов Изма к НЗ
   */
  uerWorkOrderChangeObjectItems?: Maybe<UerWorkOrderChangeObjectItemsCollectionSegment>;
  /**
   * Получить итоги Изма по объекту строительства и главе
   * @deprecated Field no longer supported
   */
  uerWorkOrderChangeObjectResult: Array<WorkOrderChangeObjectResultData>;
  /**
   * Получает список для выбора объектов Изма к НЗ
   *
   *
   * **Returns:**
   * Cписок выбора объектов для Изма к НЗ
   */
  uerWorkOrderChangeObjectSelectionList?: Maybe<UerWorkOrderChangeObjectSelectionListCollectionSegment>;
  /**
   * Получить итоги по объекту Изма к НЗ
   *
   *
   * **Returns:**
   * Список итогов по объекту Изма
   */
  uerWorkOrderChangeObjectTotals: ServiceDataResultOfWorkOrderChangeTotalData__;
  /**
   * Получает одну страницу объектов изма НЗ
   *
   *
   * **Returns:**
   * Страница данных объектов изма с учетом параметров запроса
   * @deprecated Используйте новый метод GetWorkOrderChangeObjectItemsAsync
   */
  uerWorkOrderChangeObjects?: Maybe<UerWorkOrderChangeObjectsCollectionSegment>;
  /** Получить объекты для переноса объёмов в Измах */
  uerWorkOrderChangeObjectsForReminders: ServiceDataResultOfWorkOrderChangeObjectData__;
  /**
   * Метод получает список прочих с данными их привязки к объектам Изма для выбора и установки по виду строительства
   *
   *
   * **Returns:**
   * Список прочих с объектами и данными их привязки к объектам Изма
   */
  uerWorkOrderChangeOtherCostSelectonList: Array<WorkOrderChangeOtherCostItem>;
  /**
   * Получить прочую затрату Изма с данными распределения лимита на сезонам и объектам
   *
   *
   * **Returns:**
   * Прочую затрату Изма с данными распределения лимита на сезонам и объектам
   */
  uerWorkOrderChangeOtherForDistribution: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  /** Метод получает список прочих затрат, не включенных в Изм, по виду строительства */
  uerWorkOrderChangeOtherListQuery?: Maybe<UerWorkOrderChangeOtherListQueryCollectionSegment>;
  /**
   * Метод получает одну страницу прочих затрат Изма к НЗ
   *
   *
   * **Returns:**
   * Сраница прочих затрат изма с учетом параметров запроса
   */
  uerWorkOrderChangeOtherPriceList?: Maybe<UerWorkOrderChangeOtherPriceListCollectionSegment>;
  /**
   * Получает данные для фильтрации прочих затрат по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации прочих затрат по столбцу Наименование
   */
  uerWorkOrderChangeOtherPriceNameFilter?: Maybe<UerWorkOrderChangeOtherPriceNameFilterCollectionSegment>;
  /**
   * Получает данные для редактирования обоснования добавления прочей в Изм к НЗ
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerWorkOrderChangeOtherPriceRationale: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  /**
   * Получает данные для фильтрации прочих затрат по столбцу Статус
   *
   *
   * **Returns:**
   * Данные для фильтрации прочих затрат по столбцу Статус
   */
  uerWorkOrderChangeOtherPriceStatusFilter?: Maybe<UerWorkOrderChangeOtherPriceStatusFilterCollectionSegment>;
  /**
   * Получить список версий НЗ для выгрузки аналитики Изменения
   *
   *
   * **Returns:**
   * Список версий НЗ
   */
  uerWorkOrderChangePreviousVersions: Array<WorkOrderVersionListItem>;
  /**
   * Получает данные для фильтрации по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerWorkOrderChangePriceCodeFilter?: Maybe<UerWorkOrderChangePriceCodeFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме глав позиций по виду строительства
   *
   *
   * **Returns:**
   * Список глав Изма
   */
  uerWorkOrderChangePriceItemChapterFilter?: Maybe<UerWorkOrderChangePriceItemChapterFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме шифров позиций по виду строительства
   *
   *
   * **Returns:**
   * Список шифров прозиций Изма
   */
  uerWorkOrderChangePriceItemCodeFilter?: Maybe<UerWorkOrderChangePriceItemCodeFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме наименований позиций по виду строительства
   *
   *
   * **Returns:**
   * Список наименований прозиций Изма
   */
  uerWorkOrderChangePriceItemNameFilter?: Maybe<UerWorkOrderChangePriceItemNameFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме статусов позиций по виду строительства
   *
   *
   * **Returns:**
   * Список статусов прозиций Изма
   */
  uerWorkOrderChangePriceItemStatusFilter?: Maybe<UerWorkOrderChangePriceItemStatusFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме единиц позиций по виду строительства
   *
   *
   * **Returns:**
   * Список единиц прозиций Изма
   */
  uerWorkOrderChangePriceItemUnitFilter?: Maybe<UerWorkOrderChangePriceItemUnitFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме значений участия в суммировании ФО по виду работ Изма
   *
   *
   * **Returns:**
   * Список значений участия в суммировании ФО по виду работ Изма
   */
  uerWorkOrderChangePriceItemWorkInSumFilter?: Maybe<UerWorkOrderChangePriceItemWorkInSumFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме названий видов работ позиций по виду строительства
   *
   *
   * **Returns:**
   * Список названий видов работ прозиций Изма
   */
  uerWorkOrderChangePriceItemWorkNameFilter?: Maybe<UerWorkOrderChangePriceItemWorkNameFilterCollectionSegment>;
  /**
   * Получает список имеющихся в Изме плановых значений видов работ
   *
   *
   * **Returns:**
   * Список имеющихся в Изме плановых значений видов работ
   */
  uerWorkOrderChangePriceItemWorkPlanFilter?: Maybe<UerWorkOrderChangePriceItemWorkPlanFilterCollectionSegment>;
  /**
   * Получает одну страницу позиций изма НЗ
   *
   *
   * **Returns:**
   * Сраницу данных запрошенного изма с учетом параметров запроса
   */
  uerWorkOrderChangePriceItems?: Maybe<UerWorkOrderChangePriceItemsCollectionSegment>;
  /**
   * Получает одну страницу позиций изма НЗ
   *
   *
   * **Returns:**
   * Сраницу данных запрошенного изма с учетом параметров запроса
   */
  uerWorkOrderChangePriceList?: Maybe<UerWorkOrderChangePriceListCollectionSegment>;
  uerWorkOrderChangePriceListMtrQuery?: Maybe<UerWorkOrderChangePriceListMtrQueryCollectionSegment>;
  /**
   * Получение списка коэффициентов стесненности по полученному списку id объектов нижнего уровня иерархии Изм к НЗ.
   *
   *
   * **Returns:**
   * Список коэффициентов стесненности
   */
  uerWorkOrderChangePriceListRatioForObjects?: Maybe<UerWorkOrderChangePriceListRatioForObjectsCollectionSegment>;
  /**
   * Получение списка коэффициентов для массового применения к корневому объекту Изм. к НЗ
   *
   *
   * **Returns:**
   * Список коэффициентов стесненности
   */
  uerWorkOrderChangePriceListRatioForRootObject?: Maybe<UerWorkOrderChangePriceListRatioForRootObjectCollectionSegment>;
  uerWorkOrderChangePriceListRatioQuery?: Maybe<UerWorkOrderChangePriceListRatioQueryCollectionSegment>;
  uerWorkOrderChangePriceListUerQuery?: Maybe<UerWorkOrderChangePriceListUerQueryCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerWorkOrderChangePriceNameFilter?: Maybe<UerWorkOrderChangePriceNameFilterCollectionSegment>;
  /**
   * Получает данные для редактирования обоснования добавления расценки/МТР/коэффициента в Изм к НЗ
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerWorkOrderChangePriceRationale: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  /**
   * Получает данные для фильтрации по столбцу Статус
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус
   */
  uerWorkOrderChangePriceStatusFilter?: Maybe<UerWorkOrderChangePriceStatusFilterCollectionSegment>;
  /**
   * Получить итоги Изма
   * @deprecated Field no longer supported
   */
  uerWorkOrderChangeResult: Array<WorkOrderChangeResultData>;
  /**
   * Получает данные для фильтрации по столбцу Сезон,выполнено Объем
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Сезон,выполнено Объем
   */
  uerWorkOrderChangeSeasonPriceCompletedVolumeFilter?: Maybe<UerWorkOrderChangeSeasonPriceCompletedVolumeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Сезон,план Объем
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Сезон,план Объем
   */
  uerWorkOrderChangeSeasonPricePlanVolumeFilter?: Maybe<UerWorkOrderChangeSeasonPricePlanVolumeFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Сезон,остаток Объем
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Сезон,остаток Объем
   */
  uerWorkOrderChangeSeasonPriceRemainderVolumeFilter?: Maybe<UerWorkOrderChangeSeasonPriceRemainderVolumeFilterCollectionSegment>;
  /**
   * Получает одну страницу сезонов изма НЗ
   *
   *
   * **Returns:**
   * Сраницу данных сезонов изма с учетом параметров запроса
   */
  uerWorkOrderChangeSeasons?: Maybe<UerWorkOrderChangeSeasonsCollectionSegment>;
  /**
   * Метод получает список статусов с описание переходов между статусами
   *
   *
   * **Returns:**
   * Список статусов
   */
  uerWorkOrderChangeStatuses: ServiceDataResultOfWorkOrderChangeStatusData__;
  /**
   * Получить итоги Изма к НЗ
   *
   *
   * **Returns:**
   * Список итогов Изма к НЗ
   */
  uerWorkOrderChangeTotals: ServiceDataResultOfWorkOrderChangeTotalData__;
  /** Получить остаток для позиций объёмов Изма */
  uerWorkOrderChangeUerRemainders: Array<WorkOrderChangeSeasonPriceRemainder>;
  /**
   * Получает список позиций Изма НЗ
   *
   *
   * **Returns:**
   * Список позиций Изма НЗ
   */
  uerWorkOrderChangeUersSelectionList?: Maybe<UerWorkOrderChangeUersSelectionListCollectionSegment>;
  /** Возвращает фильтр для стобца шифр */
  uerWorkOrderChangeUsersSelectionListCodeFilter?: Maybe<UerWorkOrderChangeUsersSelectionListCodeFilterCollectionSegment>;
  /** Возвращает фильтр столбца подраздел */
  uerWorkOrderChangeUsersSelectionListGroupFilter?: Maybe<UerWorkOrderChangeUsersSelectionListGroupFilterCollectionSegment>;
  /** Возвращает фильтр стобца Наименование */
  uerWorkOrderChangeUsersSelectionListNameFilter?: Maybe<UerWorkOrderChangeUsersSelectionListNameFilterCollectionSegment>;
  /** Возвращает фильтр столбца раздел */
  uerWorkOrderChangeUsersSelectionListSectionFilter?: Maybe<UerWorkOrderChangeUsersSelectionListSectionFilterCollectionSegment>;
  /**
   * Метод получения признака наличия К перехода
   *
   *
   * **Returns:**
   * Данные К перехода
   */
  uerWorkOrderChangeWorkRatioInfo: ServiceDataResultOfPriceItemWorkRatioInfo;
  /**
   * Возвращает виды строительства наряд-заказа
   *
   *
   * **Returns:**
   * Виды строительства наряд-заказа
   */
  uerWorkOrderConstructionTypes: Array<ConstructionTypeData>;
  /**
   * Получить количество черновиков Наряд-заказа
   *
   *
   * **Returns:**
   * Количество черновиков НЗ
   */
  uerWorkOrderDraftInfo: ServiceDataResultOfWorkOrderDraftInfo;
  /** Экспортирует наряд-заказ в Excel файл. */
  uerWorkOrderExportAsExcel: ServiceDataResultOfFileContent;
  /**
   * Метод получения лимитированных затрат (Доп. транспорт) наряд-заказа
   *
   *
   * **Returns:**
   * Список лимитированных затрат НЗ
   */
  uerWorkOrderLimitedCostItems?: Maybe<UerWorkOrderLimitedCostItemsCollectionSegment>;
  /** Возвращает список мтр для сопоставления с другим мтр, за исключением уже добавленных мтр к расценке. */
  uerWorkOrderMtrRowsForComparison?: Maybe<UerWorkOrderMtrRowsForComparisonCollectionSegment>;
  /**
   * Возвращает итоги наряд-заказа по объекту строительства и главе
   * @deprecated Используйте метод GetWorkOrderObjectTotalsAsync
   */
  uerWorkOrderObjectResult: Array<WorkOrderObjectResultData>;
  /**
   * Получить общий список объектов для наряд-заказа
   *
   * **Returns:**
   * Общий список объектов
   */
  uerWorkOrderObjectSelectionList?: Maybe<UerWorkOrderObjectSelectionListCollectionSegment>;
  /**
   * Возвращает итоги объекта Наряд-Заказа
   *
   *
   * **Returns:**
   * Список итогов объекта Наряд-Заказа
   */
  uerWorkOrderObjectTotals: ServiceDataResultOfWorkOrderTotalData__;
  /**
   * Возвращает объекты и подобъекты наряд-заказа
   *
   *
   * **Returns:**
   * Объекты и подобъекты наряд-заказа
   */
  uerWorkOrderObjects: Array<WorkOrderObjectData>;
  /** Получить список прочих для наряд-заказа по типу строительства */
  uerWorkOrderOther: Array<WorkOrderOtherAggregationData>;
  /**
   * Метод получает список прочих с данными их привязки к объектам НЗ для выбора и установки по виду строительства
   *
   *
   * **Returns:**
   * Список прочих с объектами и данными их привязки к НЗ
   */
  uerWorkOrderOtherCostSelectionList: Array<WorkOrderOtherCostItem>;
  /** Получить прочую затрату наряд-заказа с данными для изменения распределения */
  uerWorkOrderOtherForDistribution: ServiceDataResultOfWorkOrderOtherDistributionData;
  /**
   * Возвращает прочие затраты наряд-заказа
   * @deprecated Используйте метод GetWorkOrderPriceItems
   */
  uerWorkOrderOtherPriceList: WorkOrderOtherViewData;
  /**
   * Получает данные для фильтрации по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerWorkOrderOtherPriceNameFilter?: Maybe<UerWorkOrderOtherPriceNameFilterCollectionSegment>;
  /**
   * Получает данные для редактирования обоснования добавления прочей в Акт КС-2
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerWorkOrderOtherPriceRationale: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  /**
   * Получает данные для фильтрации по столбцу Статус
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус
   */
  uerWorkOrderOtherPriceStatusFilter?: Maybe<UerWorkOrderOtherPriceStatusFilterCollectionSegment>;
  /**
   * Получает список прочих затрат наряд-заказа
   *
   *
   * **Returns:**
   * Cписок прочих затрат наряд-заказа
   * @deprecated Используйте метод GetWorkOrderPriceItems
   */
  uerWorkOrderOtherPrices?: Maybe<UerWorkOrderOtherPricesCollectionSegment>;
  /**
   * Получить список прочих затрат договора для актов КС-2
   *
   *
   * **Returns:**
   * Список прочих затрат
   */
  uerWorkOrderOthersForActKC2: Array<WorkOrderActKc2OtherAggregationData>;
  /**
   * Получает данные для фильтрации по столбцу Шифр
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerWorkOrderPriceCodeFilter?: Maybe<UerWorkOrderPriceCodeFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ глав позиций по виду строительства
   *
   *
   * **Returns:**
   * Список глав НЗ
   */
  uerWorkOrderPriceItemChapterFilter?: Maybe<UerWorkOrderPriceItemChapterFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ шифров позиций по виду строительства
   *
   *
   * **Returns:**
   * Список шифров прозиций НЗ
   */
  uerWorkOrderPriceItemCodeFilter?: Maybe<UerWorkOrderPriceItemCodeFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ наименований позиций по виду строительства
   *
   *
   * **Returns:**
   * Список наименований прозиций НЗ
   */
  uerWorkOrderPriceItemNameFilter?: Maybe<UerWorkOrderPriceItemNameFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ конечных объектов
   *
   *
   * **Returns:**
   * Список конечных объектов НЗ
   */
  uerWorkOrderPriceItemObjectNameFilter?: Maybe<UerWorkOrderPriceItemObjectNameFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ корневых объектов
   *
   *
   * **Returns:**
   * Список корневых объектов НЗ
   */
  uerWorkOrderPriceItemRootObjectNameFilter?: Maybe<UerWorkOrderPriceItemRootObjectNameFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ статусов позиций по виду строительства
   *
   *
   * **Returns:**
   * Список статусов прозиций НЗ
   */
  uerWorkOrderPriceItemStatusFilter?: Maybe<UerWorkOrderPriceItemStatusFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ единиц позиций по виду строительства
   *
   *
   * **Returns:**
   * Список единиц прозиций НЗ
   */
  uerWorkOrderPriceItemUnitFilter?: Maybe<UerWorkOrderPriceItemUnitFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ типов коэффициентов перехода позиций по виду строительства
   *
   *
   * **Returns:**
   * Список типов коэффициентов перехода прозиций НЗ
   */
  uerWorkOrderPriceItemWorkInSumFilter?: Maybe<UerWorkOrderPriceItemWorkInSumFilterCollectionSegment>;
  /**
   * Получает список имеющихся в НЗ названий видов работ позиций по виду строительства
   *
   *
   * **Returns:**
   * Список названий видов работ прозиций НЗ
   */
  uerWorkOrderPriceItemWorkNameFilter?: Maybe<UerWorkOrderPriceItemWorkNameFilterCollectionSegment>;
  /**
   * Метод получения позиций НЗ
   *
   *
   * **Returns:**
   * Список позиций НЗ
   */
  uerWorkOrderPriceItems?: Maybe<UerWorkOrderPriceItemsCollectionSegment>;
  /**
   * Возвращает прайс-лист наряд-заказа
   *
   *
   * **Returns:**
   * Прайс-лист наряд-заказа
   * @deprecated Используйте метод GetWorkOrderPriceItems
   */
  uerWorkOrderPriceList: WorkOrderViewData;
  /**
   * Возвращает прейскурант МТР, не содержит МТР уже включенные в состав расценки
   *
   *
   * **Returns:**
   * Прейскурант МТР
   */
  uerWorkOrderPriceListMtr?: Maybe<UerWorkOrderPriceListMtrCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Шифр в диалоговом окне "Сопоставление МТР"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerWorkOrderPriceListMtrAssignCodeFilter?: Maybe<UerWorkOrderPriceListMtrAssignCodeFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Наименование в диалоговом окне "Сопоставление МТР"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerWorkOrderPriceListMtrAssignNameFilter?: Maybe<UerWorkOrderPriceListMtrAssignNameFilterCollectionSegment>;
  /**
   * Возвращает прейскурант коэффициентов, не содержит коэффициенты уже включенные в состав расценки
   *
   *
   * **Returns:**
   * Прейскурант коэффициентов
   */
  uerWorkOrderPriceListRatio?: Maybe<UerWorkOrderPriceListRatioCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Шифр в диалоговом окне "Добавление коэффициента к расценке"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerWorkOrderPriceListRatioCodeFilter?: Maybe<UerWorkOrderPriceListRatioCodeFilterCollectionSegment>;
  /**
   * Получение списка коэффициентов стесненности по полученному списку id объектов нижнего уровня иерархии.
   *
   *
   * **Returns:**
   * Список коэффициентов стесненности
   */
  uerWorkOrderPriceListRatioForObjects?: Maybe<UerWorkOrderPriceListRatioForObjectsCollectionSegment>;
  /**
   * Получение списка коэффициентов для массового применения к корневому объекту
   *
   *
   * **Returns:**
   * Список коэффициентов стесненности
   */
  uerWorkOrderPriceListRatioForRootObject?: Maybe<UerWorkOrderPriceListRatioForRootObjectCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Наименование в диалоговом окне "Добавление коэффициента к расценке"
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerWorkOrderPriceListRatioNameFilter?: Maybe<UerWorkOrderPriceListRatioNameFilterCollectionSegment>;
  /**
   * Возвращает прейскурант расценок, не содержит расценки уже включенные в состав объекта (подобъекта)
   *
   *
   * **Returns:**
   * Прейскурант расценок
   */
  uerWorkOrderPriceListUer?: Maybe<UerWorkOrderPriceListUerCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Шифр в списке добавления расценок НЗ
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Шифр
   */
  uerWorkOrderPriceListUerCodeFilter?: Maybe<UerWorkOrderPriceListUerCodeFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Наименование в списке добавления расценок НЗ
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerWorkOrderPriceListUerNameFilter?: Maybe<UerWorkOrderPriceListUerNameFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Раздел в списке добавления расценок НЗ
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Раздел
   */
  uerWorkOrderPriceListUerSectionFilter?: Maybe<UerWorkOrderPriceListUerSectionFilterCollectionSegment>;
  /**
   * Получить данные для фильтрации по столбцу Подраздел в списке добавления расценок НЗ
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Подраздел
   */
  uerWorkOrderPriceListUerSubSectionFilter?: Maybe<UerWorkOrderPriceListUerSubSectionFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Наименование
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Наименование
   */
  uerWorkOrderPriceNameFilter?: Maybe<UerWorkOrderPriceNameFilterCollectionSegment>;
  /**
   * Получает данные для редактирования обоснования добавления расценки/МТР/коэффициента в Акт КС-2
   *
   *
   * **Returns:**
   * Данные для редактирования обоснования
   */
  uerWorkOrderPriceRationale: ServiceDataResultOfWorkOrderPriceRationaleData;
  /**
   * Получает данные для фильтрации по столбцу Статус
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Статус
   */
  uerWorkOrderPriceStatusFilter?: Maybe<UerWorkOrderPriceStatusFilterCollectionSegment>;
  /**
   * Получает данные для фильтрации по столбцу Единицы измерения
   *
   *
   * **Returns:**
   * Данные для фильтрации по столбцу Единицы измерения
   */
  uerWorkOrderPriceUnitFilter?: Maybe<UerWorkOrderPriceUnitFilterCollectionSegment>;
  /**
   * Получает список позиций НЗ
   *
   *
   * **Returns:**
   * Список позиций НЗ
   * @deprecated Используйте метод GetWorkOrderPriceItems
   */
  uerWorkOrderPrices?: Maybe<UerWorkOrderPricesCollectionSegment>;
  /**
   * Возвращает итоги наряд-заказа
   * @deprecated Используйте метод GetWorkOrderTotalsAsync
   */
  uerWorkOrderResult: WorkOrderResultViewData;
  /** Получить информацию о свойствах СКзС указанного НЗ */
  uerWorkOrderSKzSInfo: ServiceDataResultOfWorkOrderSKzSInfo;
  /**
   * Возвращает сезоны наряд-заказа
   *
   *
   * **Returns:**
   * Сезоны наряд-заказа
   */
  uerWorkOrderSeasons?: Maybe<UerWorkOrderSeasonsCollectionSegment>;
  /**
   * Возвращает итоги наряд-заказа
   *
   *
   * **Returns:**
   * Список итогов НЗ
   */
  uerWorkOrderTotals: ServiceDataResultOfWorkOrderTotalData__;
  /**
   * Получает список позиций НЗ
   *
   *
   * **Returns:**
   * Список позиций НЗ
   */
  uerWorkOrderUersSelectionListAsync?: Maybe<UerWorkOrderUersSelectionListAsyncCollectionSegment>;
  /** Возвращает фильтр для стобца шифр */
  uerWorkOrderUsersSelectionListCodeFilter?: Maybe<UerWorkOrderUsersSelectionListCodeFilterCollectionSegment>;
  /** Возвращает фильтр столбца подраздел */
  uerWorkOrderUsersSelectionListGroupFilter?: Maybe<UerWorkOrderUsersSelectionListGroupFilterCollectionSegment>;
  /** Возвращает фильтр стобца Наименование */
  uerWorkOrderUsersSelectionListNameFilter?: Maybe<UerWorkOrderUsersSelectionListNameFilterCollectionSegment>;
  /** Возвращает фильтр столбца раздел */
  uerWorkOrderUsersSelectionListSectionFilter?: Maybe<UerWorkOrderUsersSelectionListSectionFilterCollectionSegment>;
  /**
   * Возвращает версию наряд-заказа
   *
   *
   * **Returns:**
   * Версия наряд-заказа
   */
  uerWorkOrderVersion: ServiceDataResultOfWorkOrderVersionData;
  /** Метод получения актов версий НЗ */
  uerWorkOrderVersionActs?: Maybe<UerWorkOrderVersionActsCollectionSegment>;
  /**
   * Возвращает Акты КС2 объекта версии наряд-заказа
   *
   *
   * **Returns:**
   * Акты КС2 объекта версии наряд-заказа
   */
  uerWorkOrderVersionActsKC2Version: Array<WorkOrderVersionActKc2VersionData>;
  /**
   * Возвращает лимитированные затраты версии наряд-заказа
   *
   *
   * **Returns:**
   * Список лимитированных затрат версии наряд-заказа
   */
  uerWorkOrderVersionLimitedCostItems?: Maybe<UerWorkOrderVersionLimitedCostItemsCollectionSegment>;
  /**
   * Возвращает итоги версии наряд-заказа по объекту строительства и главе/секции
   *
   *
   * **Returns:**
   * Итоги версии наряд-заказа по объекту строительства и главе/секции
   * @deprecated Field no longer supported
   */
  uerWorkOrderVersionObjectResults: Array<WorkOrderVersionObjectResultData>;
  /**
   * Возвращает список итогов версии наряд-заказа по объекту
   *
   *
   * **Returns:**
   * Список итогов версии наряд-заказа по объекту
   */
  uerWorkOrderVersionObjectTotals: ServiceDataResultOfWorkOrderVersionTotalData__;
  /**
   * Возвращает объекты версии наряд-заказа
   *
   *
   * **Returns:**
   * Объекты версии наряд-заказа
   */
  uerWorkOrderVersionObjects?: Maybe<UerWorkOrderVersionObjectsCollectionSegment>;
  /**
   * Возвращает прочие затраты версии наряд-заказа
   *
   *
   * **Returns:**
   * Прочие затраты версии наряд-заказа
   */
  uerWorkOrderVersionOtherPriceList?: Maybe<UerWorkOrderVersionOtherPriceListCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ глав позиций по виду строительства
   *
   *
   * **Returns:**
   * Список глав версии НЗ
   */
  uerWorkOrderVersionPriceItemChapterFilter?: Maybe<UerWorkOrderVersionPriceItemChapterFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ шифров позиций по виду строительства
   *
   *
   * **Returns:**
   * Список шифров позиций версии НЗ
   */
  uerWorkOrderVersionPriceItemCodeFilter?: Maybe<UerWorkOrderVersionPriceItemCodeFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ наименований позиций по виду строительства
   *
   *
   * **Returns:**
   * Список наименований позиций версии НЗ
   */
  uerWorkOrderVersionPriceItemNameFilter?: Maybe<UerWorkOrderVersionPriceItemNameFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ конечных объектов
   *
   *
   * **Returns:**
   * Список конечных объектов версии НЗ
   */
  uerWorkOrderVersionPriceItemObjectNameFilter?: Maybe<UerWorkOrderVersionPriceItemObjectNameFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ корневых объектов
   *
   *
   * **Returns:**
   * Список корневых объектов версии НЗ
   */
  uerWorkOrderVersionPriceItemRootObjectNameFilter?: Maybe<UerWorkOrderVersionPriceItemRootObjectNameFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ статусов позиций по виду строительства
   *
   *
   * **Returns:**
   * Список статусов позиций версии НЗ
   */
  uerWorkOrderVersionPriceItemStatusFilter?: Maybe<UerWorkOrderVersionPriceItemStatusFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ единиц позиций по виду строительства
   *
   *
   * **Returns:**
   * Список единиц позиций версии НЗ
   */
  uerWorkOrderVersionPriceItemUnitFilter?: Maybe<UerWorkOrderVersionPriceItemUnitFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ типов коэффициентов перехода позиций по виду строительства
   *
   *
   * **Returns:**
   * Список типов коэффициентов перехода позиций версии НЗ
   */
  uerWorkOrderVersionPriceItemWorkInSumFilter?: Maybe<UerWorkOrderVersionPriceItemWorkInSumFilterCollectionSegment>;
  /**
   * Получить список имеющихся в версии НЗ названий видов работ позиций по виду строительства
   *
   *
   * **Returns:**
   * Список названий видов работ позиций версии НЗ
   */
  uerWorkOrderVersionPriceItemWorkNameFilter?: Maybe<UerWorkOrderVersionPriceItemWorkNameFilterCollectionSegment>;
  /**
   * Метод получения позиций версии НЗ
   *
   *
   * **Returns:**
   * Список позиций версии НЗ
   */
  uerWorkOrderVersionPriceItems?: Maybe<UerWorkOrderVersionPriceItemsCollectionSegment>;
  /**
   * Возвращает прайс-лист версии наряд-заказа
   *
   *
   * **Returns:**
   * Прайс-лист версии наряд-заказа
   */
  uerWorkOrderVersionPriceList?: Maybe<UerWorkOrderVersionPriceListCollectionSegment>;
  /**
   * Возвращает итоги версии наряд-заказа
   *
   *
   * **Returns:**
   * Итоги версии наряд-заказа
   * @deprecated Field no longer supported
   */
  uerWorkOrderVersionResults: Array<WorkOrderVersionResultData>;
  /**
   * Возвращает сезоны версии наряд-заказа
   *
   *
   * **Returns:**
   * Сезоны версии наряд-заказа
   */
  uerWorkOrderVersionSeasons: Array<WorkOrderVersionSeasonData>;
  /**
   * Возвращает список итогов версии наряд-заказа
   *
   *
   * **Returns:**
   * Список итогов версии наряд-заказа
   */
  uerWorkOrderVersionTotals: ServiceDataResultOfWorkOrderVersionTotalData__;
  /**
   * Получает список версий наряд-заказа
   *
   *
   * **Returns:**
   * Список версий наряд-заказа
   */
  uerWorkOrderVersions: Array<WorkOrderVersionListItem>;
  /**
   * Метод получения признака наличия К перехода
   *
   *
   * **Returns:**
   * Данные К перехода
   */
  uerWorkOrderWorkRatioInfo: ServiceDataResultOfPriceItemWorkRatioInfo;
  uercAppModuleHealthChecks: ServiceDataResultOfAppHealthCheckData;
  uercAppModuleInfo: ServiceDataResultOfAppModuleInfo;
  uercAppModuleReport: ServiceDataResultOfAppModuleReport;
  /**
   * Получает данные расчета НМЦ
   *
   *
   * **Returns:**
   * Расчет НМЦ
   */
  uercCalculation: ServiceDataResultOfUercCalculationData;
  /**
   * Получает общие данные расчета НМЦ
   *
   *
   * **Returns:**
   * Общие данные расчета НМЦ
   */
  uercCalculationCommonData: ServiceDataResultOfCalculationCommonData;
  /**
   * Метод получения позиций итогов расчета НМЦ
   *
   *
   * **Returns:**
   * Список позиций итогов расчета НМЦ
   */
  uercCalculationComputedData?: Maybe<UercCalculationComputedDataCollectionSegment>;
  /**
   * Получает возможные значения фильтра по колонке "Глава"
   *
   *
   * **Returns:**
   * Данные фильтра
   */
  uercCalculationComputedRowsChapterFilter?: Maybe<UercCalculationComputedRowsChapterFilterCollectionSegment>;
  /**
   * Получает возможные значения фильтра по колонке "Шифр" в расширеном формате
   *
   *
   * **Returns:**
   * Данные фильтра
   */
  uercCalculationComputedRowsCodeExtendedFilter?: Maybe<UercCalculationComputedRowsCodeExtendedFilterCollectionSegment>;
  /**
   * Получает возможные значения фильтра по колонке "Шифр"
   *
   *
   * **Returns:**
   * Данные фильтра
   */
  uercCalculationComputedRowsCodeFilter?: Maybe<UercCalculationComputedRowsCodeFilterCollectionSegment>;
  /**
   * Получает возможные значения фильтра по колонке "Наименование"
   *
   *
   * **Returns:**
   * Данные фильтра
   */
  uercCalculationComputedRowsNameFilter?: Maybe<UercCalculationComputedRowsNameFilterCollectionSegment>;
  /**
   * Получает возможные значения фильтра по колонке "Участие в суммировании ФО по виду работ"
   *
   *
   * **Returns:**
   * Данные фильтра
   */
  uercCalculationComputedRowsWorkInSumFilter?: Maybe<UercCalculationComputedRowsWorkInSumFilterCollectionSegment>;
  /**
   * Получает возможные значения фильтра по колонке "Наименование вида работ"
   *
   *
   * **Returns:**
   * Данные фильтра
   */
  uercCalculationComputedRowsWorkNameFilter?: Maybe<UercCalculationComputedRowsWorkNameFilterCollectionSegment>;
  /**
   * Метод получения позиций итогов расчета НМЦ
   *
   *
   * **Returns:**
   * Список позиций итогов расчета НМЦ
   */
  uercCalculationComputedTotals: CalculationComputeTotalData;
  /** Получить объекты строительства в указанном расчёте НМЦ */
  uercCalculationConstructionTypes: Array<ConstructionTypeData>;
  /**
   * Получить данные расчёта НМЦ по умолчанию
   *
   *
   * **Returns:**
   * Данные расчёта НМЦ по умолчанию
   */
  uercCalculationDefaults: ServiceDataResultOfUercCalculationDefaultData;
  /** Метод получения лимитированной затраты расчета НМЦ с данными для обновления */
  uercCalculationLimitedCostForUpdate: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  /** Получить значения для фильтра лимитированных по имени */
  uercCalculationLimitedCostNameFilter?: Maybe<UercCalculationLimitedCostNameFilterCollectionSegment>;
  /**
   * Метод получает список типов лимитированных затрат, не используемых в лимитированных расчета НЦМ
   *
   *
   * **Returns:**
   * Список лимитированных затрат расчета НЦМ
   */
  uercCalculationLimitedCostTypes?: Maybe<UercCalculationLimitedCostTypesCollectionSegment>;
  /** Получить данные лимитированных затрат для отображения */
  uercCalculationLimitedCosts?: Maybe<UercCalculationLimitedCostsCollectionSegment>;
  /**
   * Получает структуру объектов Расчета НМЦ
   *
   *
   * **Returns:**
   * Структура объектов Расчета НМЦ
   */
  uercCalculationObjects: Array<CalculationObjectData>;
  /**
   * Получение объектов расчета, имеющих записи объёмов напрямую или ниже по иерархии хотя бы в одном из сезонов
   *
   *
   * **Returns:**
   * Объекты, имеющие записи объёмов напрямую или ниже по иерархии
   */
  uercCalculationObjectsWithVolumes: Array<CalculationObjectData>;
  /** Метод получения прочей затраты расчета НМЦ с данными для обновления */
  uercCalculationOtherCostForUpdate: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  /** Получить значения для фильтра прочих по имени */
  uercCalculationOtherCostNameFilter?: Maybe<UercCalculationOtherCostNameFilterCollectionSegment>;
  /**
   * Метод получает список типов прочих затрат, не используемых в прочих расчета НЦМ
   *
   *
   * **Returns:**
   * Список прочих затрат расчета НЦМ
   */
  uercCalculationOtherCostTypesQuery?: Maybe<UercCalculationOtherCostTypesQueryCollectionSegment>;
  /** Получить данные прочих затрат для отображения */
  uercCalculationOtherCosts?: Maybe<UercCalculationOtherCostsCollectionSegment>;
  /**
   * Получает данные сезонах расчета НМЦ
   *
   *
   * **Returns:**
   * Расчет НМЦ
   */
  uercCalculationSeasons: Array<UercCalculationSeasonData>;
  /**
   * Получает список всех доступных коэффициентов справочника (CatalogRatio), которые еще не добавлены в сборник коэффициентов.
   *
   *
   * **Returns:**
   * Коллекционный сегмент (CollectionSegment) объектов CollectionRatio, представляющих данные о коэффициентов.
   */
  uercCatalogRatiosNotInCollection?: Maybe<UercCatalogRatiosNotInCollectionCollectionSegment>;
  /** Проверить доступность добавления расценок из справочника по видам строительства */
  uercCheckConstructionTypesToAddUers: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  /**
   * Фильтр по шифру
   * В фильтре предусмотреть сортировку расположения значений по шифру от меньшего к большему с учетом групп МТР
   */
  uercCollectionMtrItemCodeFilterQuery: Array<MtrCodeFilter>;
  /** Фильтр Тип */
  uercCollectionMtrItemMtrTypeFilterQuery: Array<MtrTypeEnum>;
  /**
   * Фильтр понаименованию
   *             В фильтре предусмотреть сортировку расположения значений по наименованию  - в алфавитном порядке
   */
  uercCollectionMtrItemNameFilterQuery: Array<Scalars['String']>;
  /** Фильтр Вид МТР */
  uercCollectionMtrItemPricingTypeFilterQuery: Array<PricingTypeEnum>;
  /**
   * Получение позиции ведомости МТР
   *
   *
   * **Returns:**
   * Данные списка позиций Ведомости
   */
  uercCollectionMtrItemQuery: ServiceDataResultOfCollectionMtrItem;
  /** Фильтр Поставка */
  uercCollectionMtrItemSupplyByFilterQuery: Array<ContragentTypeEnum>;
  /** Метод получения значений позиций ведомости МТР с итоговой стоимостью в текущем уровне цен для позиций Материалов и Оборудования Подрядчика на форме Ведомости МТР */
  uercCollectionMtrItemValuesTotalsQuery: CollectionMtrItemValueTotals;
  /** Неценообразующие МТР */
  uercCollectionMtrItemsByGroupQuery: Array<CollectionMtrItem>;
  /** Неценообразующие МТР */
  uercCollectionMtrItemsNoPricingQuery: Array<CollectionMtrItem>;
  /**
   * Метод получения списка позиций ведомости МТР
   *
   *
   * **Returns:**
   * Данные списка позиций Ведомости
   */
  uercCollectionMtrItemsQuery: Array<CollectionMtrUersItem>;
  /** Метод предоставления списка МТР для переименования */
  uercCollectionMtrSelectionList: Array<CollectionMtrForReplacementData>;
  /**
   * Получает данные коэффициента по его идентификатору
   *
   *
   * **Returns:**
   * Результат операции
   */
  uercCollectionRatio: ServiceDataResultOfCollectionRatioDataWithCosts;
  /**
   * Возвращает список кодов коэффициентов с поддержкой пагинации, фильтрации и сортировки.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных кодов коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioCodeFilter?: Maybe<UercCollectionRatioCodeFilterCollectionSegment>;
  /**
   * Возвращает список групп коэффициентов с поддержкой пагинации, фильтрации и сортировки.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных групп коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioGroupFilter?: Maybe<UercCollectionRatioGroupFilterCollectionSegment>;
  /**
   * Возвращает список групп коэффициентов, доступных для указанного типа коэффициента.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список групп коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioGroups: Array<CollectionRatioGroupData>;
  /**
   * Возвращает список групп коэффициентов, доступных для указанного типа коэффициента, включая прикрепленные к ним расценки.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список групп коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioGroupsWithCosts: Array<CollectionRatioGroupDataWithCosts>;
  /**
   * Возвращает список обоснований изменений коэффициентов с поддержкой пагинации.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных обоснований изменений коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioJustificationFilter?: Maybe<UercCollectionRatioJustificationFilterCollectionSegment>;
  /**
   * Возвращает список наименований коэффициентов с поддержкой пагинации, фильтрации и сортировки.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных наименований коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioNameFilter?: Maybe<UercCollectionRatioNameFilterCollectionSegment>;
  /**
   * Возвращает список статусов коэффициентов с поддержкой пагинации.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных типов коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioStatusFilter?: Maybe<UercCollectionRatioStatusFilterCollectionSegment>;
  /**
   * Возвращает список типов коэффициентов с поддержкой пагинации.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных типов коэффициентов в виде объектов FilterValue`1.
   */
  uercCollectionRatioTypeFilter?: Maybe<UercCollectionRatioTypeFilterCollectionSegment>;
  /**
   * Возвращает список типов коэффициентов с поддержкой пагинации.
   *
   *
   * **Returns:**
   *
   * Запрос, который возвращает список уникальных типов коэффициентов в виде списка объектов RatioTypeEnum/&gt;.
   */
  uercCollectionRatioTypes?: Maybe<UercCollectionRatioTypesCollectionSegment>;
  /**
   * Получает список коэффициентов (CollectionRatio) из сборника. Допустима пагинация, фильтрация и сортировка.
   *
   *
   * **Returns:**
   * Коллекционный сегмент (CollectionSegment) объектов CollectionRatio, представляющих данные о коэффициентов.
   */
  uercCollectionRatios?: Maybe<UercCollectionRatiosCollectionSegment>;
  /** Получить данные для редактирования расценки */
  uercCollectionUERBaseCost: ServiceDataResultOfCollectionUerBaseCostData;
  /** Получить значения для фильтра расценок по главе */
  uercCollectionUERBaseCostChapterFilter?: Maybe<UercCollectionUerBaseCostChapterFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по шифру */
  uercCollectionUERBaseCostCodeFilter?: Maybe<UercCollectionUerBaseCostCodeFilterCollectionSegment>;
  /** Получить машины механизмы рабочие */
  uercCollectionUERBaseCostEstimateBasis?: Maybe<UercCollectionUerBaseCostEstimateBasisCollectionSegment>;
  /** Получить состав ресурсов */
  uercCollectionUERBaseCostEstimateBasisResources?: Maybe<UercCollectionUerBaseCostEstimateBasisResourcesCollectionSegment>;
  /** Получить состав сметы-основания в сборнике расценок */
  uercCollectionUERBaseCostEstimateBasisRows: Array<CollectionUerBaseCostEstimateBasisRow>;
  /** Получить значения для фильтра расценок по полному имени (шифр группы + наименование группы + наименование расценки) */
  uercCollectionUERBaseCostFullNameFilter?: Maybe<UercCollectionUerBaseCostFullNameFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по имени подраздела */
  uercCollectionUERBaseCostGroupNameFilter?: Maybe<UercCollectionUerBaseCostGroupNameFilterCollectionSegment>;
  /** Получить набор расценок */
  uercCollectionUERBaseCostItems?: Maybe<UercCollectionUerBaseCostItemsCollectionSegment>;
  /**
   * Получает коллекцию объектов расценок, которые можно добавлять к новой расценке на Демонтаж раздела "Строительные и специальные строительные работы"
   *
   *
   * **Returns:**
   * Коллекционный сегмент (CollectionSegment) объектов CollectionUerBaseCostItemMinimal, представляющих данные о расценке.
   */
  uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroup?: Maybe<UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCollectionSegment>;
  /** Список расценок ассоциированных с коэффициентом */
  uercCollectionUERBaseCostItemsHavingRatio?: Maybe<UercCollectionUerBaseCostItemsHavingRatioCollectionSegment>;
  /** Список расценок ассоциированных с группой коэффициентом */
  uercCollectionUERBaseCostItemsHavingRatioGroup?: Maybe<UercCollectionUerBaseCostItemsHavingRatioGroupCollectionSegment>;
  /** Список расценок, которые можно добавить в ВОР для указанного Вида Строительства */
  uercCollectionUERBaseCostItemsToAddToWOR?: Maybe<UercCollectionUerBaseCostItemsToAddToWorCollectionSegment>;
  /** Получить уникальные значения фильтра по колонке «Шифр» для расценок, которые можно добавить в ВОР */
  uercCollectionUERBaseCostItemsToAddToWorCodeFilter?: Maybe<UercCollectionUerBaseCostItemsToAddToWorCodeFilterCollectionSegment>;
  /** Получить уникальные значения фильтра по колонке «Подраздел» для расценок, которые можно добавить в ВОР */
  uercCollectionUERBaseCostItemsToAddToWorGroupNameFilter?: Maybe<UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterCollectionSegment>;
  /** Получить уникальные значения фильтра по колонке «Наименование» для расценок, которые можно добавить в ВОР */
  uercCollectionUERBaseCostItemsToAddToWorNameFilter?: Maybe<UercCollectionUerBaseCostItemsToAddToWorNameFilterCollectionSegment>;
  /** Получить уникальные значения фильтра по колонке «Раздел» для расценок, которые можно добавить в ВОР */
  uercCollectionUERBaseCostItemsToAddToWorSectionNameFilter?: Maybe<UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по имени */
  uercCollectionUERBaseCostNameFilter?: Maybe<UercCollectionUerBaseCostNameFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по имени раздела */
  uercCollectionUERBaseCostSectionNameFilter?: Maybe<UercCollectionUerBaseCostSectionNameFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по имени раздела */
  uercCollectionUERBaseCostStatusFilter?: Maybe<UercCollectionUerBaseCostStatusFilterCollectionSegment>;
  /** Получить итоги сметы основания */
  uercCollectionUERBaseCostTotals: Array<CollectionUerBaseCostTotalItem>;
  /** Получить значения для фильтра расценок по типу */
  uercCollectionUERBaseCostUerClassifierFilter?: Maybe<UercCollectionUerBaseCostUerClassifierFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по участию в суммировании ФО вида работ */
  uercCollectionUERBaseCostWorkInSumFilter?: Maybe<UercCollectionUerBaseCostWorkInSumFilterCollectionSegment>;
  /** Получить значения для фильтра расценок по имени вида работ */
  uercCollectionUERBaseCostWorkNameFilter?: Maybe<UercCollectionUerBaseCostWorkNameFilterCollectionSegment>;
  /** Получить состав работ */
  uercCollectionUERBaseCostWorkScopes?: Maybe<UercCollectionUerBaseCostWorkScopesCollectionSegment>;
  /**
   * Получает содержимое файла, приложенного к лимитированной затрате
   *
   *
   * **Returns:**
   * Содержимое файла или null, если файл не был приложен
   */
  uercDownloadCalculationLimitedCostFile: ServiceDataResultOfFileContent;
  /**
   * Получает содержимое файла, приложенного к прочей затрате
   *
   *
   * **Returns:**
   * Содержимое файла или null, если файл не был приложен
   */
  uercDownloadCalculationOtherCostFile: ServiceDataResultOfFileContent;
  /**
   * Выгружает ведомость МТР для заданного расчета НМЦ в формате xlsx
   *
   *
   * **Returns:**
   * Результат операции, содержащий DTO объект файла
   */
  uercExportCollectionMtrAsExcel: ServiceDataResultOfFileContent;
  /**
   * Экспорт печатной формы НМЦ
   *
   * **Returns:**
   * Файл печатной формы
   */
  uercExportPrintForm: ServiceDataResultOfFileContent;
  /**
   * Выгружает ВОР для заданного расчета НМЦ в формате xlsx
   *
   *
   * **Returns:**
   * Результат операции, содержащий Excel файл ВОР
   */
  uercExportWorAsExcel: ServiceDataResultOfFileContent;
  /**
   * Выгружает шаблон ВОР для заданного расчета НМЦ в формате xlsx
   *
   *
   * **Returns:**
   * Результат операции, содержащий Excel файл шаблона ВОР
   */
  uercExportWorTemplateAsExcel: ServiceDataResultOfFileContent;
  /**
   * Парсит xlsx файл и вытаскивает значение итогового процента
   *
   * **Returns:**
   * Значение строки итогового процента, используемое в качестве % лимитированнных для видов строительства
   */
  uercExtractCalculationLimitedCostsTotalPercentage: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  /**
   * Парсит xlsx файл и вытаскивает значение "Всего"
   *
   * **Returns:**
   * Значение строки "Всего", используемое в качестве суммы лимитов прочих
   */
  uercExtractTotalSum: ServiceDataResultOfCalculationOtherCostTotalSum;
  /** Получить список расценок для выбора из справочника */
  uercFindUersToAdd: ServiceDataResultOfFindUersToAddData;
  /** Получает список лимитированных для заданной методологии и расчета НЦМ */
  uercGlobalLimitedCostsForCalculation?: Maybe<UercGlobalLimitedCostsForCalculationCollectionSegment>;
  /** Получает список прочих для заданной методологии и расчета НЦМ */
  uercGlobalOtherCostsForCalculation?: Maybe<UercGlobalOtherCostsForCalculationCollectionSegment>;
  /** Проверка наличия более одной позиции МТР оператора поставки "Подрядчик" (SupplyBy) или записи ценообразующих МТР (PricingType) */
  uercHasMtrForReplacement: Scalars['Boolean'];
  /** Используется ли вид строительства с указанным кодом в каком-либо расчёте НМЦ (УЕР) */
  uercIsCalculationConstructionTypeUsed: ServiceDataResultOfObject;
  /**
   * Проверяет строку кода лимитированной на уникальность в рамках текущего расчета НМЦ
   *
   *
   * **Returns:**
   * Объект результата, содержащий признак уникальности
   */
  uercIsCalculationLimitedCostCodeUnique: ServiceIdResultOfBoolean;
  /**
   * Проверяет наименование лимитированной на уникальность в рамках текущего расчета НМЦ
   *
   *
   * **Returns:**
   * Объект результата, содержащий признак уникальности
   */
  uercIsCalculationLimitedCostNameUnique: ServiceIdResultOfBoolean;
  /**
   * Проверяет строку кода прочей на уникальность в рамках текущего расчета НМЦ
   *
   *
   * **Returns:**
   * Объект результата, содержащий признак уникальности
   */
  uercIsCalculationOtherCostCodeUnique: ServiceIdResultOfBoolean;
  /**
   * Проверяет уникальность наименования коэффициента в рамках сборника
   *
   *
   * **Returns:**
   * Возвращает правду если наименование уникальное
   */
  uercIsCollectionRatioNameUnique: ServiceResult;
  /**
   * Проверяет уникальность кода объекта/подобъекта в рамках Расчета НМЦ
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uercIsUniqueCalculationObjectCode: ServiceResult;
  /**
   * Проверяет уникальность наименования объекта в рамках вида строительства
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uercIsUniqueCalculationObjectName: ServiceResult;
  /**
   * Проверяет уникальность наименования подобъекта в рамках родительского объекта\подобъекта
   *
   *
   * **Returns:**
   * Результат проверки
   */
  uercIsUniqueCalculationSubObjectName: ServiceResult;
  /** Выполнить парсинг сметы-основания */
  uercParseUerBaseCostBasis: ServiceDataResultOfUerEstimateBaseCostData;
  /**
   * Получить значения фильтра по колонке «Шифр» для расценок, доступных для добавления из справочника
   *
   * **Returns:**
   * Шифры расценок
   */
  uercUersToAddCodeFilter?: Maybe<UercUersToAddCodeFilterCollectionSegment>;
  /**
   * Получить значения фильтра по колонке «Вид строительства» для расценок, доступных для добавления из справочника
   *
   * **Returns:**
   * Значения вида строительства
   */
  uercUersToAddConstructionTypeFilter?: Maybe<UercUersToAddConstructionTypeFilterCollectionSegment>;
  /**
   * Получить значения фильтра по колонке «Подраздел» для расценок, доступных для добавления из справочника
   *
   * **Returns:**
   * Наименования подразделов
   */
  uercUersToAddGroupNameFilter?: Maybe<UercUersToAddGroupNameFilterCollectionSegment>;
  /**
   * Получить значения фильтра по колонке «Наименование» для расценок, доступных для добавления из справочника
   *
   * **Returns:**
   * Наименования расценок
   */
  uercUersToAddNameFilter?: Maybe<UercUersToAddNameFilterCollectionSegment>;
  /**
   * Получить значения фильтра по колонке «Раздел» для расценок, доступных для добавления из справочника
   *
   * **Returns:**
   * Наименования разделов
   */
  uercUersToAddSectionNameFilter?: Maybe<UercUersToAddSectionNameFilterCollectionSegment>;
  /**
   * Получает список всех используемых типов лимитированных среди всех расчетов НМЦ.
   *
   *
   * **Returns:**
   * Объект результата, содержащий идентификаторы типов лимитированных, используемых в лимитированных затратах
   */
  uercUsedLimitedCostTypes: ServiceDataResultOfInt32__;
  /**
   * Получает данные ведомости объемов работ
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolume: WorkVolumeData;
  /**
   * Получает переменные для использования в формуле ВОР.
   *
   *
   * **Returns:**
   * Список переменных для использования в формуле ВОР
   */
  uercWorkVolumeFormulaVariables?: Maybe<UercWorkVolumeFormulaVariablesCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Шифр" в расширенном формате
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemCodeExtendedFilter?: Maybe<UercWorkVolumeItemCodeExtendedFilterCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Шифр"
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemCodeFilter?: Maybe<UercWorkVolumeItemCodeFilterCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Наименование"
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemNameFilter?: Maybe<UercWorkVolumeItemNameFilterCollectionSegment>;
  /**
   * Получает группу работ для коэффициентов стесненности / демонтажа
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemRatioGroup?: Maybe<UercWorkVolumeItemRatioGroupCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Подраздел"
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemUerGroupNameFilter?: Maybe<UercWorkVolumeItemUerGroupNameFilterCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Раздел"
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemUerSectionNameFilter?: Maybe<UercWorkVolumeItemUerSectionNameFilterCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Ед.изм."
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeItemUnitFilter?: Maybe<UercWorkVolumeItemUnitFilterCollectionSegment>;
  /**
   * Получает строки ведомости объемов работ для расчета НМЦ.
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeItems?: Maybe<UercWorkVolumeItemsCollectionSegment>;
  /**
   * Получает строки ведомости МТР.
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeMtrSelectionList?: Maybe<UercWorkVolumeMtrSelectionListCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Шифр"
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeMtrSelectionListCodeFilter?: Maybe<UercWorkVolumeMtrSelectionListCodeFilterCollectionSegment>;
  /**
   * Получает значения для фильтрации по колонке "Наименование"
   *
   *
   * **Returns:**
   * Массив строк
   */
  uercWorkVolumeMtrSelectionListNameFilter?: Maybe<UercWorkVolumeMtrSelectionListNameFilterCollectionSegment>;
  uercWorkVolumeObjectAdditional: WorkVolumeObjectAdditionalData;
  /**
   * Получает объекты строительства ведомости объемов работ для расчета НМЦ.
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeObjects: Array<WorkVolumeObjectData>;
  /**
   * Получает строки ведомости коэффициентов со связанными расценками
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeRatioCollectionUersSelectionList?: Maybe<UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment>;
  /**
   * Получает строки ведомости коэффициентов
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeRatiosSelectionList?: Maybe<UercWorkVolumeRatiosSelectionListCollectionSegment>;
  /**
   * Получает строки ведомости коэффициентов со связанными расценками
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeRatiosWithUersSelectionList?: Maybe<UercWorkVolumeRatiosWithUersSelectionListCollectionSegment>;
  /**
   * Получает значения фильтрации для строк ведомости коэффициентов со связанными расценками по полю "Раздел"
   *
   *
   * **Returns:**
   * Данные ведомости объемов работ
   */
  uercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilter?: Maybe<UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterCollectionSegment>;
};


export type QueryAppModuleReportArgs = {
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAppModulesReportArgs = {
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
  modules?: InputMaybe<Array<ModuleEnum>>;
  order?: InputMaybe<Array<ServiceDataResultOfAppModuleReportSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceDataResultOfAppModuleReportFilterInput>;
};


export type QueryBimActKc2GroupChapterFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfNullableOfBimChapterEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfBimChapterEnumFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupConstructionTypeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupCostGroupFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfCostGroupEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupDateFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfNullableOfDateTimeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateTimeFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupNumberFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupObjectFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupWorkOrderPriceCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2GroupWorkOrderPriceNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2OtherArgs = {
  actKC2OtherId: Scalars['Long'];
};


export type QueryBimActKc2OtherDefaultsArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimActKc2OtherTotalsArgs = {
  actKC2OtherId: Scalars['Long'];
  order?: InputMaybe<Array<BimActKc2OtherTotalItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2OtherTotalItemDataFilterInput>;
};


export type QueryBimActKc2PriceRowsArgs = {
  actKC2Id: Scalars['Long'];
  order?: InputMaybe<Array<BimActKc2PriceRowDataSortInput>>;
  priceLevel: BimPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2PriceRowDataFilterInput>;
};


export type QueryBimActKc2TotalsArgs = {
  actKC2Id: Scalars['Long'];
  order?: InputMaybe<Array<BimActKc2TotalItemDataSortInput>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2TotalItemDataFilterInput>;
};


export type QueryBimActKc2VersionOtherArgs = {
  actKC2VersionOtherId: Scalars['Long'];
};


export type QueryBimActKc2VersionOtherTotalsArgs = {
  actKC2VersionOtherId: Scalars['Long'];
  order?: InputMaybe<Array<BimActKc2VersionOtherTotalItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionOtherTotalItemDataFilterInput>;
};


export type QueryBimActKc2VersionPriceRowsArgs = {
  actKC2VersionId: Scalars['Long'];
  order?: InputMaybe<Array<BimActKc2VersionPriceRowDataSortInput>>;
  priceLevel: BimPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionPriceRowDataFilterInput>;
};


export type QueryBimActKc2VersionTotalsArgs = {
  actKC2VersionId: Scalars['Long'];
  order?: InputMaybe<Array<BimActKc2VersionTotalItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionTotalItemDataFilterInput>;
};


export type QueryBimActsKc2Args = {
  order?: InputMaybe<Array<BimActKc2DataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2DataFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimActsKc2GroupArgs = {
  actKC2GroupId: Scalars['Long'];
};


export type QueryBimActsKc2OtherArgs = {
  order?: InputMaybe<Array<BimActKc2OtherItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2OtherItemDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimActsKc2VersionArgs = {
  order?: InputMaybe<Array<BimActKc2VersionDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionDataFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimActsKc2VersionOtherArgs = {
  order?: InputMaybe<Array<BimActKc2VersionOtherItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionOtherItemDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimAppModuleReportArgs = {
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBimCalcWorkOrderChangeOtherDistributionArgs = {
  input: BimWorkOrderChangeOtherPriceCalcInput;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimCalcWorkOrderOtherDistributionArgs = {
  input: BimWorkOrderOtherPriceCalcInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type QueryBimCalculationArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimContractArgs = {
  contractId: Scalars['Long'];
};


export type QueryBimContractCommonDataArgs = {
  contractUniqueId: Scalars['String'];
};


export type QueryBimContractConstructionTypesArgs = {
  contractId: Scalars['Long'];
};


export type QueryBimContractDefaultsArgs = {
  projectUniqueId: Scalars['String'];
};


export type QueryBimContractObjectsArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<BimContractObjectDataSortInput>>;
  where?: InputMaybe<BimContractObjectDataFilterInput>;
};


export type QueryBimContractOtherCostArgs = {
  contractOtherCostId: Scalars['Long'];
};


export type QueryBimContractOtherCostIncludedInActKc2FilterArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfBooleanFilterInput>;
};


export type QueryBimContractOtherCostIncludedInWorkOrderFilterArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfBooleanFilterInput>;
};


export type QueryBimContractOtherCostNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryBimContractOtherCostTypesArgs = {
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
};


export type QueryBimContractOtherCostsArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<BimContractOtherCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimContractOtherCostItemDataFilterInput>;
};


export type QueryBimContractSeasonsArgs = {
  contractId: Scalars['Long'];
};


export type QueryBimExportWorkOrderArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimExportWorkOrderChangeArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimExportWorkOrderChangeAnalyticsAsExcelArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderVersionId: Scalars['Long'];
};


export type QueryBimExportWorkOrderPricesArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimFrameContractResultsArgs = {
  contractId: Scalars['Long'];
};


export type QueryBimGlobalOtherCostsForContractArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
};


export type QueryBimIsContractConstructionTypeUsedArgs = {
  code: Scalars['String'];
};


export type QueryBimIsUniqueActKc2GroupNameArgs = {
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
  groupName: Scalars['String'];
  workOrderId: Scalars['Long'];
};


export type QueryBimIsUniqueActKc2OtherInternalNumberArgs = {
  actKC2OtherId?: InputMaybe<Scalars['Long']>;
  actKC2OtherNumber: Scalars['Long'];
  workOrderId: Scalars['Long'];
};


export type QueryBimIsUniqueContractInternalNumberArgs = {
  contractId?: InputMaybe<Scalars['Long']>;
  internalNumber: Scalars['String'];
};


export type QueryBimIsUniqueContractObjectNameArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  name: Scalars['String'];
  objectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimIsUniqueContractOtherCostArgs = {
  calculatingType: OtherCostCalculationTypeEnum;
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  section: SectionEnum;
};


export type QueryBimIsUniqueContractOtherCostNameArgs = {
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryBimIsUniqueContractSubObjectNameArgs = {
  contractObjectId: Scalars['Long'];
  contractSubObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryBimIsUniqueWorkOrderChangeInternalNumberArgs = {
  internalNumber: Scalars['String'];
  workOrderChangeId?: InputMaybe<Scalars['Long']>;
  workOrderId: Scalars['Long'];
};


export type QueryBimNormalContractResultsArgs = {
  contractId: Scalars['Long'];
};


export type QueryBimPriceAnalyticsArgs = {
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  refWorkOrderPriceId: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimPriceRowAnalyticsArgs = {
  order?: InputMaybe<Array<BimPriceAnalyticsItemSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  refWorkOrderPriceId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimPriceAnalyticsItemFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimPriceRowAnalyticsCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  refWorkOrderPriceId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimPriceRowAnalyticsNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  refWorkOrderPriceId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimPriceRowAnalyticsSectionFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  refWorkOrderPriceId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimPriceRowAnalyticsSubsectionFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  refWorkOrderPriceId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimPriceRowAnalyticsUnitFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  refWorkOrderPriceId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderActsKc2Args = {
  groupType?: InputMaybe<BimActKc2GroupTypeEnum>;
  order?: InputMaybe<Array<BimActKc2ListItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  utcOffset?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<BimActKc2ListItemDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderActsKc2SelectionListArgs = {
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<BimActKc2SelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  utcOffset?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<BimActKc2SelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeChapterPriceCountsArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeConstructionTypesArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeDefaultsArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeLastSeasonSelectionListArgs = {
  where?: InputMaybe<BimContractSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeObjectOtherTotalsArgs = {
  order?: InputMaybe<Array<BimWorkOrderChangeObjectOtherTotalDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeObjectOtherTotalDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeObjectSmrTotalsArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<BimWorkOrderChangeObjectSmrTotalDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeObjectSmrTotalDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeObjectSelectionListArgs = {
  order?: InputMaybe<Array<BimWorkOrderChangeObjectSelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeObjectSelectionDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeObjectsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeObjectDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeOtherDataArgs = {
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeOtherDistributionArgs = {
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeOtherNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeOtherPricesArgs = {
  order?: InputMaybe<Array<BimWorkOrderChangeOtherPriceDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeOtherPriceDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeOtherSelectionListArgs = {
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<BimWorkOrderChangeOtherSelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeOtherSelectionDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangePreviousVersionsAsyncArgs = {
  order?: InputMaybe<Array<BimWorkOrderVersionListItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionListItemFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangePriceCodeFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceNameFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceObjectNameFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRationaleFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRevisionCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRevisionNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRevisionsArgs = {
  order?: InputMaybe<Array<BimWorkOrderChangePriceRevisionDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangePriceRevisionDataFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRowCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRowNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceRowsArgs = {
  order?: InputMaybe<Array<BimWorkOrderChangePriceRowDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangePriceRowDataFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePriceStatesArgs = {
  chapter: BimChapterEnum;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangePricesArgs = {
  chapter: BimChapterEnum;
  includeRows: Scalars['Boolean'];
  order?: InputMaybe<Array<BimWorkOrderChangePriceDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangePriceDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChangeSeasonSelectionListArgs = {
  order?: InputMaybe<Array<BimWorkOrderChangeSeasonDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeSeasonsArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryBimWorkOrderChangeTotalsArgs = {
  chapter?: InputMaybe<BimChapterEnum>;
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BimWorkOrderChangeTotalItemDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  useInPrices: Scalars['Boolean'];
  where?: InputMaybe<BimWorkOrderChangeTotalItemDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderChapterDataArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderConstructionTypesArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderObjectSelectionListArgs = {
  order?: InputMaybe<Array<BimWorkOrderObjectSelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderObjectSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderObjectsArgs = {
  order?: InputMaybe<Array<BimWorkOrderObjectDataSortInput>>;
  rootsOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderObjectDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderOtherDataArgs = {
  workOrderOtherPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderOtherDistributionArgs = {
  workOrderOtherPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderOtherForActArgs = {
  order?: InputMaybe<Array<BimWorkOrderOtherDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderOtherDataFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderOtherPricesArgs = {
  order?: InputMaybe<Array<BimWorkOrderOtherPriceDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderOtherPriceDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderOthersArgs = {
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<BimWorkOrderOtherDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderOtherDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceCodeFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceMtrDistributionArgs = {
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceMtrDistributionTotalArgs = {
  input: BimWorkOrderPriceMtrDistributionInput;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceNameFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceObjectNameFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceRevisionCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceRevisionNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceRevisionsArgs = {
  order?: InputMaybe<Array<BimWorkOrderPriceRevisionDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderPriceRevisionDataFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceRowCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceRowNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceRowsArgs = {
  order?: InputMaybe<Array<BimWorkOrderPriceRowDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderPriceRowDataFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderPriceStatesArgs = {
  chapter: BimChapterEnum;
  workOrderObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderPricesArgs = {
  chapter: BimChapterEnum;
  includeRows: Scalars['Boolean'];
  order?: InputMaybe<Array<BimWorkOrderPriceDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderPriceDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderSeasonSelectionListArgs = {
  order?: InputMaybe<Array<BimWorkOrderSeasonSelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderSeasonSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderSeasonsArgs = {
  order?: InputMaybe<Array<BimWorkOrderSeasonDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderSeasonDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderSeasonsRangeArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryBimWorkOrderTotalsArgs = {
  chapter?: InputMaybe<BimChapterEnum>;
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BimWorkOrderTotalItemDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  useInPrices: Scalars['Boolean'];
  where?: InputMaybe<BimWorkOrderTotalItemDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderVersionArgs = {
  workOrderVersionId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionChapterPriceCountsArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderVersionConstructionTypesArgs = {
  workOrderVersionId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionObjectArgs = {
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionObjectsArgs = {
  order?: InputMaybe<Array<BimWorkOrderVersionObjectDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionObjectDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionOtherDataArgs = {
  workOrderVersionOtherPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionOtherPriceNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionOtherPricesArgs = {
  order?: InputMaybe<Array<BimWorkOrderVersionOtherPriceDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionOtherPriceDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceCodeFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceNameFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceObjectNameFilterArgs = {
  chapter: BimChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceRevisionCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceRevisionNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceRevisionsArgs = {
  order?: InputMaybe<Array<BimWorkOrderVersionPriceRevisionDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionPriceRevisionDataFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceRowCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceRowNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceRowsArgs = {
  order?: InputMaybe<Array<BimWorkOrderVersionPriceRowDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionPriceRowDataFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPriceStatesArgs = {
  chapter: BimChapterEnum;
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionPricesArgs = {
  chapter: BimChapterEnum;
  includeRows: Scalars['Boolean'];
  order?: InputMaybe<Array<BimWorkOrderVersionPriceDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionPriceDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionSeasonsArgs = {
  workOrderVersionId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionSubObjectArgs = {
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryBimWorkOrderVersionTotalsArgs = {
  chapter?: InputMaybe<BimChapterEnum>;
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<BimWorkOrderVersionTotalItemDataSortInput>>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  useInPrices: Scalars['Boolean'];
  where?: InputMaybe<BimWorkOrderVersionTotalItemDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimWorkOrderVersionsArgs = {
  order?: InputMaybe<Array<BimWorkOrderVersionListItemSortInput>>;
  where?: InputMaybe<BimWorkOrderVersionListItemFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryBimcAggregateEstimateArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
};


export type QueryBimcAggregateEstimateCompositionArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
  order?: InputMaybe<Array<LocalEstimateTableItemDataSortInput>>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalEstimateTableItemDataFilterInput>;
};


export type QueryBimcAggregateEstimateCompositionCodeFilterArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcAggregateEstimateCompositionNameFilterArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcAggregateEstimateCompositionObjectFilterArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcAggregateEstimateCompositionSubObjectFilterArgs = {
  aggregateLocalEstimateId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcAggregateEstimateLsrSelectionArgs = {
  calculationId: Scalars['Long'];
  chapter: Scalars['String'];
  constructionTypeId: Scalars['Int'];
  objectId: Scalars['Long'];
  priceLevel: BimcPriceLevelEnum;
};


export type QueryBimcAppModuleReportArgs = {
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBimcCalculationArgs = {
  calculationId: Scalars['Long'];
};


export type QueryBimcCalculationCommonDataArgs = {
  calculationUniqueId: Scalars['String'];
};


export type QueryBimcCalculationConstructionTypeByCalculationUniqueIdArgs = {
  calculationUniqueId: Scalars['String'];
};


export type QueryBimcCalculationDefaultsArgs = {
  projectUniqueId: Scalars['String'];
};


export type QueryBimcCalculationLimitedCostForUpdateArgs = {
  calculationId: Scalars['Long'];
  limitedCostId: Scalars['Long'];
};


export type QueryBimcCalculationLimitedCostNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryBimcCalculationLimitedCostTypesArgs = {
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<CatalogLimitedCostTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogLimitedCostTypeDataFilterInput>;
};


export type QueryBimcCalculationLimitedCostsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationObjectsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimcCalculationOtherCostForUpdateArgs = {
  calculationId: Scalars['Long'];
  otherCostId: Scalars['Long'];
};


export type QueryBimcCalculationOtherCostNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationOtherCostTypesArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput>>;
  otherCostId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
};


export type QueryBimcCalculationOtherCostsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<BimcCalculationOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimcCalculationOtherCostDataFilterInput>;
};


export type QueryBimcCalculationPreviewArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Array<BimcCalculationPreviewRowDataSortInput>>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimcCalculationPreviewRowDataFilterInput>;
};


export type QueryBimcCalculationPreviewCodeFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationPreviewNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationPreviewObjectFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationPreviewSeasonFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationPreviewSectionFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationPreviewSubObjectFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  guaranteedVolume?: InputMaybe<Scalars['Boolean']>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcCalculationSeasonsArgs = {
  calculationId: Scalars['Long'];
};


export type QueryBimcCalculationTotalsArgs = {
  calculationId: Scalars['Long'];
  chapter?: InputMaybe<Scalars['Short']>;
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimcDownloadCalculationOtherCostFileArgs = {
  calculationId: Scalars['Long'];
  otherCostId: Scalars['Long'];
};


export type QueryBimcExtractTotalSumArgs = {
  input: FileInput;
};


export type QueryBimcGlobalLimitedCostsForCalculationArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalLimitedCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalLimitedCostDataFilterInput>;
};


export type QueryBimcGlobalOtherCostsForCalculationArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
};


export type QueryBimcIsCalculationConstructionTypeUsedArgs = {
  code: Scalars['String'];
};


export type QueryBimcIsCalculationLimitedCostCodeUniqueArgs = {
  calculationId: Scalars['Long'];
  key: Scalars['String'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimcIsCalculationLimitedCostNameUniqueArgs = {
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryBimcIsCalculationOtherCostCodeUniqueArgs = {
  calculationId: Scalars['Long'];
  key: Scalars['String'];
  otherCostId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimcIsCalculationOtherCostNameUniqueArgs = {
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnum>;
  calculationId: Scalars['Long'];
  chapter?: InputMaybe<ChapterEnum>;
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  section?: InputMaybe<SectionEnum>;
};


export type QueryBimcIsUniqueCalculationObjectCodeArgs = {
  calculationId: Scalars['Long'];
  code: Scalars['String'];
  excludeObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryBimcIsUniqueCalculationObjectNameArgs = {
  calculationId: Scalars['Long'];
  excludeObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryBimcIsUniqueCalculationSubObjectNameArgs = {
  calculationObjectId: Scalars['Long'];
  excludeObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryBimcLocalEstimateCompositionArgs = {
  localEstimateId: Scalars['Long'];
  order?: InputMaybe<Array<LocalEstimateCompositionRowDataSortInput>>;
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalEstimateCompositionRowDataFilterInput>;
};


export type QueryBimcLocalEstimateCompositionCodeFilterArgs = {
  localEstimateId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcLocalEstimateCompositionNameFilterArgs = {
  localEstimateId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcLocalEstimateEditDataArgs = {
  localEstimateId: Scalars['Long'];
};


export type QueryBimcLocalEstimateMtrDistributionArgs = {
  localEstimateId: Scalars['Long'];
};


export type QueryBimcLocalEstimateMtrDistributionTotalArgs = {
  input: LocalEstimateMtrDistributionInput;
  localEstimateId: Scalars['Long'];
};


export type QueryBimcLocalEstimateTableCodeFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcLocalEstimateTableNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcLocalEstimateTableObjectFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBimcLocalEstimatesTableArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  priceLevel: BimcPriceLevelEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalEstimateTableItemDataFilterInput>;
};


export type QueryCatalogArgs = {
  catalogUniqueId: Scalars['String'];
};


export type QueryCatalogConstructionTypeIsUsedInProjectsArgs = {
  code: Scalars['String'];
};


export type QueryCatalogConstructionTypeItemsArgs = {
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<ConstructionTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
};


export type QueryCatalogConstructionTypesArgs = {
  order?: InputMaybe<Array<ConstructionTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
};


export type QueryCatalogConstructionTypesUpdatedDateArgs = {
  catalogId: Scalars['Long'];
};


export type QueryCatalogIsUniqueConstructionTypeCodeArgs = {
  catalogConstructionTypeId?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
};


export type QueryCatalogIsUniqueConstructionTypeFieldsArgs = {
  catalogConstructionTypeId?: InputMaybe<Scalars['Int']>;
  contractFileName: Scalars['String'];
  fullName: Scalars['String'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};


export type QueryCatalogIsUniqueWorkTypeCodeArgs = {
  catalogWorkTypeId?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
};


export type QueryCatalogNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogOtherCostVariableArgs = {
  otherCostVariableId: Scalars['Long'];
};


export type QueryCatalogOtherCostVariableDataSourcesArgs = {
  entityUniqueIds?: InputMaybe<Array<Scalars['String']>>;
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableDataSourceItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostVariableDataSourceItemDataFilterInput>;
};


export type QueryCatalogOtherCostVariableEntitiesArgs = {
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableEntityItemDataSortInput>>;
  where?: InputMaybe<CatalogOtherCostVariableEntityItemDataFilterInput>;
};


export type QueryCatalogOtherCostVariableGroupListArgs = {
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableGroupItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostVariableGroupItemDataFilterInput>;
};


export type QueryCatalogOtherCostVariableSelectionItemsArgs = {
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableISelectionItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostVariableISelectionItemDataFilterInput>;
};


export type QueryCatalogOtherCostVariablesArgs = {
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostVariableItemDataFilterInput>;
};


export type QueryCatalogOtherCostVariablesGroupFilterArgs = {
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogOtherCostVariablesNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogOtherCostVariablesSubsidiaryNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogParseUerBaseCostBasisArgs = {
  content: FileInput;
};


export type QueryCatalogRatioArgs = {
  id: Scalars['Int'];
};


export type QueryCatalogRatioCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioGroupFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioGroupsArgs = {
  ratioType: RatioTypeEnum;
  where?: InputMaybe<CatalogRatioGroupDataFilterInput>;
};


export type QueryCatalogRatioHistoryCodeFilterArgs = {
  changeType?: InputMaybe<HistoryChangeType>;
  endDate: Scalars['DateTime'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioHistoryGroupFilterArgs = {
  changeType?: InputMaybe<HistoryChangeType>;
  endDate: Scalars['DateTime'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioHistoryItemsArgs = {
  changeType?: InputMaybe<HistoryChangeType>;
  order?: InputMaybe<Array<CatalogRatioHistoryDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioHistoryDataFilterInput>;
};


export type QueryCatalogRatioHistoryJustificationFilterArgs = {
  changeType?: InputMaybe<HistoryChangeType>;
  endDate: Scalars['DateTime'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioHistoryNameFilterArgs = {
  changeType?: InputMaybe<HistoryChangeType>;
  endDate: Scalars['DateTime'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioHistoryStatusCountsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  where?: InputMaybe<ServiceDataResultOfHistoryStatusCountDataFilterInput>;
};


export type QueryCatalogRatioHistoryTypeFilterArgs = {
  changeType?: InputMaybe<HistoryChangeType>;
  endDate: Scalars['DateTime'];
  skip?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCatalogRatioNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogRatioSubGroupsArgs = {
  parentId: Scalars['Long'];
};


export type QueryCatalogRatioTypeFilterArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCatalogRatioTypesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCatalogRatiosArgs = {
  order?: InputMaybe<Array<CatalogRatioDataForListSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataForListFilterInput>;
};


export type QueryCatalogSubsidiaryFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogTypesArgs = {
  order?: InputMaybe<Array<CatalogTypeDataSortInput>>;
  where?: InputMaybe<CatalogTypeDataFilterInput>;
};


export type QueryCatalogUerBaseCostArgs = {
  catalogUniqueId: Scalars['String'];
  uerBaseCostId: Scalars['Long'];
};


export type QueryCatalogUerBaseCostChangeFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfUerBaseCostChangeTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfUerBaseCostChangeTypeFilterInput>;
};


export type QueryCatalogUerBaseCostChapterFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
};


export type QueryCatalogUerBaseCostCodeFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostConstructionTypesArgs = {
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<ConstructionTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
};


export type QueryCatalogUerBaseCostEstimateBasisArgs = {
  catalogUniqueId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostEstimateBasisItemFilterInput>;
};


export type QueryCatalogUerBaseCostEstimateBasisResourcesArgs = {
  catalogUniqueId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostEstimateBasisItemFilterInput>;
};


export type QueryCatalogUerBaseCostEstimateBasisRowsArgs = {
  catalogUniqueId: Scalars['String'];
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostEstimateBasisRowFilterInput>;
};


export type QueryCatalogUerBaseCostGroupFullNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostGroupNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryChapterFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryCodeFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryGroupFullNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfCatalogUerBaseCostGroupFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryItemsArgs = {
  catalogUniqueId: Scalars['String'];
  changeType?: InputMaybe<UerBaseCostChangeType>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogUerBaseCostHistoryDataFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryJustificationFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryStatusCountsArgs = {
  catalogUniqueId: Scalars['String'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  where?: InputMaybe<ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryUerClassifierFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryUpdateUerDateFilterArgs = {
  catalogUerBaseCostHistoryId: Scalars['Long'];
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfDateOnlySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfDateOnlyFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryWorkScopeFilterArgs = {
  catalogUniqueId: Scalars['String'];
  endDate?: InputMaybe<Scalars['Date']>;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerBaseCostChangeTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Date']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryWorkScopeNameFilterArgs = {
  catalogUerBaseCostHistoryId: Scalars['Long'];
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostHistoryWorkScopesArgs = {
  catalogUniqueId: Scalars['String'];
  historyRecordId: Scalars['Long'];
  where?: InputMaybe<ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput>;
};


export type QueryCatalogUerBaseCostItemsArgs = {
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
};


export type QueryCatalogUerBaseCostNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostSectionNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerBaseCostTotalsArgs = {
  catalogUniqueId: Scalars['String'];
  uerBaseCostId: Scalars['Long'];
};


export type QueryCatalogUerBaseCostUerClassifierFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
};


export type QueryCatalogUerBaseCostUpdateDateFilterArgs = {
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfNullableOfDateTimeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateTimeFilterInput>;
};


export type QueryCatalogUerBaseCostWorkScopeChangeFilterArgs = {
  catalogUerBaseCostHistoryId: Scalars['Long'];
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfNullableOfUerBaseCostChangeTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput>;
};


export type QueryCatalogUerBaseCostWorkScopesArgs = {
  catalogUniqueId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostWorkScopeBaseDataFilterInput>;
};


export type QueryCatalogUerBaseCostWorktypeFOsummFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfWorkInSumEnumSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
};


export type QueryCatalogUerBaseCostWorktypeNameFilterArgs = {
  catalogUniqueId: Scalars['String'];
  input: CatalogUerBaseCostFilterInput;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogUerOtherCostTemplateArgs = {
  id: Scalars['Int'];
};


export type QueryCatalogUerOtherCostTemplateFilesArgs = {
  ids: Array<Scalars['Int']>;
};


export type QueryCatalogUerOtherCostTemplatesArgs = {
  order?: InputMaybe<Array<CatalogUerOtherCostTemplateDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogUerOtherCostTemplateDataFilterInput>;
};


export type QueryCatalogUpdatedAtArgs = {
  catalogUniqueId: Scalars['String'];
};


export type QueryCatalogWorkTypeCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogWorkTypeItemsArgs = {
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<CatalogWorkTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogWorkTypeDataFilterInput>;
};


export type QueryCatalogWorkTypeNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryCatalogWorkTypesArgs = {
  order?: InputMaybe<Array<CatalogWorkTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogWorkTypeDataFilterInput>;
};


export type QueryCatalogWorkTypesUpdatedDateArgs = {
  catalogId: Scalars['Long'];
};


export type QueryCatalogsArgs = {
  order?: InputMaybe<Array<CatalogItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogItemDataFilterInput>;
};


export type QueryCatalogsMethodologyFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfProjectMethodologyEnumSortInput>>;
  where?: InputMaybe<FilterValueOfProjectMethodologyEnumFilterInput>;
};


export type QueryCatalogsNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryExportCatalogUerAsExcelArgs = {
  catalogUniqueId: Scalars['String'];
};


export type QueryExportCatalogUerBaseCostHistoryAsExcelArgs = {
  catalogUniqueId: Scalars['String'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryGlobalConstructionTypesArgs = {
  order?: InputMaybe<Array<ConstructionTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
};


export type QueryGlobalLimitedCostCandidateTypesArgs = {
  excludeGlobalLimitedCostId?: InputMaybe<Scalars['Long']>;
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogLimitedCostTypeExtendedDataSortInput>>;
  where?: InputMaybe<CatalogLimitedCostTypeExtendedDataFilterInput>;
};


export type QueryGlobalLimitedCostsArgs = {
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<GlobalLimitedCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalLimitedCostDataFilterInput>;
};


export type QueryGlobalOtherCostCandidateTypesArgs = {
  excludeGlobalOtherCostId?: InputMaybe<Scalars['Long']>;
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput>>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
};


export type QueryGlobalOtherCostsArgs = {
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
};


export type QueryGlobalOtherCostsSelectionArgs = {
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
};


export type QueryIsUniqueGlobalLimitedCostArgs = {
  id?: InputMaybe<Scalars['Long']>;
  methodology: ProjectMethodologyEnum;
  name: Scalars['String'];
};


export type QueryIsUniqueGlobalOtherCostArgs = {
  calculatingType: OtherCostCalculationTypeEnum;
  id?: InputMaybe<Scalars['Long']>;
  methodology: ProjectMethodologyEnum;
  name: Scalars['String'];
  section: SectionEnum;
};


export type QueryIsUniqueLimitedCostTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: CatalogLimitedCostTypeInput;
};


export type QueryIsUniqueOtherCostTypeArgs = {
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  methodology: ProjectMethodologyEnum;
  name: Scalars['String'];
};


export type QueryIsUniqueProjectCodeArgs = {
  projectCode: Scalars['String'];
  uniqueId?: InputMaybe<Scalars['String']>;
};


export type QueryIsUniqueProjectNameArgs = {
  projectName: Scalars['String'];
  uniqueId?: InputMaybe<Scalars['String']>;
};


export type QueryIsUniqueVariableGroupArgs = {
  catalogUniqueId: Scalars['String'];
  groupId?: InputMaybe<Scalars['Int']>;
  groupName: Scalars['String'];
  isGlobal: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
};


export type QueryIsUniqueVariableNameArgs = {
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  variableId?: InputMaybe<Scalars['Long']>;
  variableName: Scalars['String'];
  variableType: CatalogOtherCostVariableTypeEnum;
};


export type QueryLimitedCostTypesArgs = {
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogLimitedCostTypeExtendedDataSortInput>>;
  where?: InputMaybe<CatalogLimitedCostTypeExtendedDataFilterInput>;
};


export type QueryOtherCostTypesArgs = {
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput>>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
};


export type QueryProjectArgs = {
  uniqueId: Scalars['String'];
};


export type QueryProjectsArgs = {
  order?: InputMaybe<Array<ProjectItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectItemDataFilterInput>;
};


export type QueryProjectsAuthoredByFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryProjectsContractTypeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfProjectContractTypeEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfProjectContractTypeEnumFilterInput>;
};


export type QueryProjectsMethodologyFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfProjectMethodologyEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfProjectMethodologyEnumFilterInput>;
};


export type QueryProjectsNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryProjectsStageFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfProjectStageEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfProjectStageEnumFilterInput>;
};


export type QueryProjectsStatusFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfProjectStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfProjectStatusEnumFilterInput>;
};


export type QueryProjectsSubsidiaryFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfCompanyDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfCompanyDataFilterInput>;
};


export type QueryUerActKc2Args = {
  actKC2Id: Scalars['Long'];
};


export type QueryUerActKc2GroupConstructionTypeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerActKc2GroupCostGroupFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfCostGroupEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerActKc2GroupDateFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfNullableOfDateOnlySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerActKc2GroupNumberFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerActKc2GroupObjectFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerActKc2LimitedCostItemsArgs = {
  actKC2Id: Scalars['Long'];
  order?: InputMaybe<Array<ActKc2LimitedCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2LimitedCostItemDataFilterInput>;
};


export type QueryUerActKc2OtherPriceItemsArgs = {
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2OtherPriceItemFilterInput>;
};


export type QueryUerActKc2OtherTotalsArgs = {
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2TotalItemFilterInput>;
};


export type QueryUerActKc2SmrPriceItemsArgs = {
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2SmrPriceItemFilterInput>;
};


export type QueryUerActKc2SmrTotalsArgs = {
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2TotalItemFilterInput>;
};


export type QueryUerActKc2SmrValueArgs = {
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerActKc2VolumeVariableSelectionItemsArgs = {
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2VolumeVariableSelectionItemFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerActKc3Args = {
  actKC3Id: Scalars['Long'];
};


export type QueryUerActKc3ActsArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ActKc2ItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2ItemFilterInput>;
  withoutCorrection?: Scalars['Boolean'];
};


export type QueryUerActKc3ActsConstructionTypeFilterArgs = {
  actKC3Id: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerActKc3ActsCostGroupFilterArgs = {
  actKC3Id: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfCostGroupEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
};


export type QueryUerActKc3ActsKc2ActKc2CostGroupFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfCostGroupEnumSortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2ActKc2DateFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfDateOnlySortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2ActKc2FinishDateFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfDateOnlySortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2ActKc2NumberFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueContainerOfStringSortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueContainerOfStringFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2ActKc2StartDateFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfDateOnlySortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2ConstructionTypeIdFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfInt32SortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfInt32FilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2ContractObjectNameFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2SelectionListArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ActKc3ActsKc2SelectionItemSortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc3ActsKc2SelectionItemFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsKc2WorkOrderInternalNumberFilterArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerActKc3ActsObjectFilterArgs = {
  actKC3Id: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerActKc3TotalsArgs = {
  actKC3Id: Scalars['Long'];
};


export type QueryUerActKc3WithActsArgs = {
  actKC3Id: Scalars['Long'];
  includeOnlySelfAktsKC2?: Scalars['Boolean'];
};


export type QueryUerActsKc2AnalyticsBySeasonsArgs = {
  seasonYear?: InputMaybe<Scalars['Short']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2UerCostPlotDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryUerActsKc2AnalyticsByUerArgs = {
  order?: InputMaybe<Array<ActKc2UerCostChartDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2UerCostChartDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryUerActsKc2GroupArgs = {
  actKC2GroupId: Scalars['Long'];
};


export type QueryUerAppModuleReportArgs = {
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUerCalcWorkOrderChangeOtherDistributionArgs = {
  input: WorkOrderChangeOtherPriceCalcInput;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerCalcWorkOrderOtherDistributionArgs = {
  input: WorkOrderOtherPriceCalcInput;
  workOrderOtherPriceId: Scalars['Long'];
};


export type QueryUerCatalogsArgs = {
  order?: InputMaybe<Array<CatalogItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogItemDataFilterInput>;
};


export type QueryUerClosingWorkOrderChangeDefaultsArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerContractArgs = {
  contractId: Scalars['Long'];
};


export type QueryUerContractActionLogEntriesArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<UerActionLogDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UerActionLogDataFilterInput>;
};


export type QueryUerContractActsKc3Args = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ActKc3RegistryItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc3RegistryItemFilterInput>;
};


export type QueryUerContractActsKc3DateFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfDateOnlySortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
};


export type QueryUerContractActsKc3FullNumberFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeArgs = {
  contractChangeId: Scalars['Long'];
};


export type QueryUerContractChangeCreatedAtFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfDateTimeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfDateTimeFilterInput>;
};


export type QueryUerContractChangeInternalNumberFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrForIncludingCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrForIncludingIsIncludedInActFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfBooleanFilterInput>;
};


export type QueryUerContractChangeMtrForIncludingIsIncludedInWorkOrderFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfBooleanFilterInput>;
};


export type QueryUerContractChangeMtrForIncludingNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrForIncludingStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfMtrRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfMtrRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeMtrForIncludingUnitFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrJustificationFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeMtrStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfMtrRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfMtrRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeMtrSupplyByFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfContragentTypeEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfContragentTypeEnumFilterInput>;
};


export type QueryUerContractChangeMtrUnitFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeOtherCostRowsArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
};


export type QueryUerContractChangeOtherCostRowsForIncludingArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
};


export type QueryUerContractChangePriceListMtrArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
};


export type QueryUerContractChangePriceListRatioArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
};


export type QueryUerContractChangePriceListRatioRowsArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioCoefficientRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioCoefficientRowDataFilterInput>;
};


export type QueryUerContractChangePriceListUerArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
};


export type QueryUerContractChangeRatioAppliesToCodeNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioAppliesToLinkStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeRatioCodeAndAppliesNamesToFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioNameFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioNameFilterDataFilterInput>;
};


export type QueryUerContractChangeRatioCodeAndAppliesToFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioFilterDataFilterInput>;
};


export type QueryUerContractChangeRatioCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingAppliesToCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingAppliesToCodeNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingAppliesToLinkStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingIsIncludedInActFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfBooleanFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingIsIncludedInWorkOrderFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfBooleanFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingLinkStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeRatioForIncludingWorkConditionsFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioGroupFullNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioIsIncludedInWorkOrderChangeArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfBooleanFilterInput>;
};


export type QueryUerContractChangeRatioRowForIncludingIsIncludedInWorkOrderChangeArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfBooleanFilterInput>;
};


export type QueryUerContractChangeRatioSectionNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfRatioRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeRatioWorkConditionsFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeRatioWorkTypeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeSigningDateFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfDateTimeSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDateTimeFilterInput>;
};


export type QueryUerContractChangeStatusFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfContractChangeStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfContractChangeStatusEnumFilterInput>;
};


export type QueryUerContractChangeSubjectFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerAndWorkScopeForIncludingNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerAndWorkScopeNameDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerAndWorkScopeNameDataFilterInput>;
};


export type QueryUerContractChangeUerAndWorkScopeNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerAndWorkScopeNameDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerAndWorkScopeNameDataFilterInput>;
};


export type QueryUerContractChangeUerChapterFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
};


export type QueryUerContractChangeUerCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerForIncludingCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerForIncludingGroupFullNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerForIncludingIsIncludedInActFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfBooleanFilterInput>;
};


export type QueryUerContractChangeUerForIncludingIsIncludedInWorkOrderFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfBooleanSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfBooleanFilterInput>;
};


export type QueryUerContractChangeUerForIncludingLinkStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfPriceConstructionTypeRelationStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput>;
};


export type QueryUerContractChangeUerForIncludingNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerForIncludingSectionNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerForIncludingStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfUerRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfUerRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeUerForIncludingUnitFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerGroupFullNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerJustificationFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerSectionNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfUerRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfUerRecordStatusEnumFilterInput>;
};


export type QueryUerContractChangeUerTypeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
};


export type QueryUerContractChangeUerUnitFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerWorkScopDescriptionFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangeUerWorkTypeInSumFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfWorkInSumEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
};


export type QueryUerContractChangeUerWorkTypeNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractChangesArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractChangeItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractChangeItemDataFilterInput>;
};


export type QueryUerContractCommonDataArgs = {
  contractUniqueId: Scalars['String'];
};


export type QueryUerContractConstructionTypesArgs = {
  contractId: Scalars['Long'];
};


export type QueryUerContractLimitedCostItemsArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractLimitedCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractLimitedCostItemDataFilterInput>;
};


export type QueryUerContractLimitedCostNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractObjectsArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractObjectDataSortInput>>;
  where?: InputMaybe<ContractObjectDataFilterInput>;
};


export type QueryUerContractObjectsToAddToWorkOrderChangeArgs = {
  constructionTypeId: Scalars['Long'];
  parentWorkOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerContractOtherCostCalculatingTypeFilterArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfOtherCostCalculationTypeEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfOtherCostCalculationTypeEnumFilterInput>;
};


export type QueryUerContractOtherCostForUpdateArgs = {
  contractId: Scalars['Long'];
  contractOtherCostId: Scalars['Long'];
  editConstructionTypeId?: InputMaybe<Scalars['Int']>;
};


export type QueryUerContractOtherCostLimitSpanSelectionListArgs = {
  contractId: Scalars['Long'];
  otherCostId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerContractOtherCostNameFilterArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerContractOtherCostStatusFilterArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfContractOtherStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfContractOtherStatusEnumFilterInput>;
};


export type QueryUerContractOtherCostTypesArgs = {
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
};


export type QueryUerContractOtherCostsArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
};


export type QueryUerContractOtherCostsConstructionTypeLimitArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
};


export type QueryUerContractOtherRelationStatusFilterArgs = {
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfContractOtherConstructionTypeRelationStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput>;
};


export type QueryUerContractResultsArgs = {
  contractId: Scalars['Long'];
};


export type QueryUerContractSeasonsArgs = {
  contractId: Scalars['Long'];
};


export type QueryUerContractWorkOrdersArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractWorkOrderDataSortInput>>;
  where?: InputMaybe<ContractWorkOrderDataFilterInput>;
};


export type QueryUerCurrentEstimateBasisArgs = {
  chapter: ChapterEnum;
  uerBaseRowId: Scalars['Long'];
};


export type QueryUerExportActKc2AsExcelArgs = {
  actKC2Id: Scalars['Long'];
};


export type QueryUerExportActKc2TemplateAsExcelArgs = {
  input: ActKc2TemplateInput;
  workOrderId: Scalars['Long'];
};


export type QueryUerExportActKc3AsExcelArgs = {
  actKC3Id: Scalars['Long'];
  includeOtherDetails: Scalars['Boolean'];
};


export type QueryUerExportContractChangeAnalyticsAsExcelArgs = {
  contractChangeId: Scalars['Long'];
  contractChangeToCompareWithId?: InputMaybe<Scalars['Long']>;
  priceListType: Array<PriceListTypeEnum>;
};


export type QueryUerExportContractResultsArgs = {
  contractId: Scalars['Long'];
};


export type QueryUerExportWorkOrderChangeAnalyticsArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerExportWorkOrderChangeAsExcelArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerExportWorkOrderPricesArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerGlobalOtherCostsForContractArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
};


export type QueryUerIsContractConstructionTypeUsedArgs = {
  code: Scalars['String'];
};


export type QueryUerIsUniqueActKc2GroupNameArgs = {
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
  groupName: Scalars['String'];
  workOrderId: Scalars['Long'];
};


export type QueryUerIsUniqueActKc2InternalNumberArgs = {
  actKC2Id?: InputMaybe<Scalars['Long']>;
  actKC2Number: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerIsUniqueActKc3InternalNumberArgs = {
  actKC3Id?: InputMaybe<Scalars['Long']>;
  actKC3Number: Scalars['Long'];
  contractId: Scalars['Long'];
};


export type QueryUerIsUniqueContractChangeInternalNumberArgs = {
  contractChangeId?: InputMaybe<Scalars['Long']>;
  contractId: Scalars['Long'];
  number: Scalars['String'];
};


export type QueryUerIsUniqueContractInternalNumberArgs = {
  contractId?: InputMaybe<Scalars['Long']>;
  internalNumber: Scalars['String'];
};


export type QueryUerIsUniqueContractObjectCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
  contractId: Scalars['Long'];
  contractObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerIsUniqueContractObjectNameArgs = {
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  contractObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryUerIsUniqueContractOtherCostKeyArgs = {
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryUerIsUniqueContractOtherNameArgs = {
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  otherName: Scalars['String'];
};


export type QueryUerIsUniqueContractSubObjectNameArgs = {
  contractObjectId: Scalars['Long'];
  contractSubObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryUerIsUniquePriceListMtrRowCodeArgs = {
  contractId: Scalars['Long'];
  inputCode: Scalars['String'];
  mtrRowId?: InputMaybe<Scalars['Long']>;
  mtrType: MtrTypeEnum;
  supplyBy: ContragentTypeEnum;
};


export type QueryUerIsUniquePriceListMtrRowKeyArgs = {
  contractId: Scalars['Long'];
  key?: InputMaybe<Scalars['String']>;
  mtrRowId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerIsUniqueRatioWorkConditionsArgs = {
  contractId: Scalars['Long'];
  ratioRowId?: InputMaybe<Scalars['Long']>;
  workConditions: Scalars['String'];
};


export type QueryUerIsUniqueWorkOrderChangeInternalNumberArgs = {
  number: Scalars['String'];
  workOrderChangeId?: InputMaybe<Scalars['Long']>;
  workOrderId: Scalars['Long'];
};


export type QueryUerIsValidActKc3DateArgs = {
  actKC3Id: Scalars['Long'];
  date: Scalars['Date'];
};


export type QueryUerMtrRowsForComparisonArgs = {
  contractId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
};


export type QueryUerOthersForIncludingToContractChangeCalculatingTypeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfOtherCostCalculationTypeEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfOtherCostCalculationTypeEnumFilterInput>;
};


export type QueryUerOthersForIncludingToContractChangeNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerParsedEstimateBasisArgs = {
  chapter: ChapterEnum;
  contractId: Scalars['Long'];
  fileContent: FileInput;
  uerClassifier?: InputMaybe<UerClassifierEnum>;
};


export type QueryUerPriceListMtrArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
};


export type QueryUerPriceListMtrCodeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListMtrForIncludingToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
};


export type QueryUerPriceListMtrJustificationFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListMtrNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListMtrRowArgs = {
  mtrRowId: Scalars['Long'];
};


export type QueryUerPriceListMtrStatusFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfMtrRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfMtrRecordStatusEnumFilterInput>;
};


export type QueryUerPriceListMtrSupplyByFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfContragentTypeEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfContragentTypeEnumFilterInput>;
};


export type QueryUerPriceListMtrTypeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfMtrTypeEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfMtrTypeEnumFilterInput>;
};


export type QueryUerPriceListMtrUnitFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
};


export type QueryUerPriceListRatioAppliesToFullNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioCodeAndAppliesNamesToFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioNameFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioNameFilterDataFilterInput>;
};


export type QueryUerPriceListRatioCodeAndAppliesToFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioFilterDataFilterInput>;
};


export type QueryUerPriceListRatioCodeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioForIncludingToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
};


export type QueryUerPriceListRatioForIncludingToContractChangeCodeFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioCode: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioForIncludingToContractChangeNameFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioCode: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioForIncludingToContractChangeStatusFilterArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput>>;
  ratioCode: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerPriceListRatioGroupFullNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioRowArgs = {
  ratioRowId: Scalars['Long'];
};


export type QueryUerPriceListRatioRowsArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioCoefficientRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioCoefficientRowDataFilterInput>;
};


export type QueryUerPriceListRatioRowsWithScopesArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRatioRowSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseRowId: Scalars['Long'];
  where?: InputMaybe<PriceListUerRatioRowFilterInput>;
};


export type QueryUerPriceListRatioSectionNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioStatusFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfRatioRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerPriceListRatioUerRowsArgs = {
  order?: InputMaybe<Array<PriceListRatioUerRowDataSortInput>>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioUerRowDataFilterInput>;
};


export type QueryUerPriceListRatioWorkConditionsFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListRatioWorkTypeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
};


export type QueryUerPriceListUerAndWorkScopeNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerAndWorkScopeNameDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerAndWorkScopeNameDataFilterInput>;
};


export type QueryUerPriceListUerChapterFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
};


export type QueryUerPriceListUerCodeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerForConstraintRatioArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRowBaseSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowBaseFilterInput>;
};


export type QueryUerPriceListUerForDismantlingRatioArgs = {
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  order?: InputMaybe<Array<PriceListUerDismantlingRatioDataSortInput>>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']>>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerDismantlingRatioDataFilterInput>;
};


export type QueryUerPriceListUerForDismantlingRatioUerCodeFilterArgs = {
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']>>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerForDismantlingRatioUerGroupFilterArgs = {
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']>>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerForDismantlingRatioUerNameFilterArgs = {
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']>>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerForDismantlingRatioUerUnitFilterArgs = {
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']>>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerForIncludingToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
};


export type QueryUerPriceListUerForTechPartRatioArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRowBaseSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowBaseFilterInput>;
};


export type QueryUerPriceListUerGroupDataFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringAndStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringAndStringFilterInput>;
};


export type QueryUerPriceListUerGroupFullNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerJustificationFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerRatioRowsCodeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseRowId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerRatioRowsNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseRowId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerRowArgs = {
  uerBaseRowId: Scalars['Long'];
};


export type QueryUerPriceListUerRowWithRatioArgs = {
  uerBaseRowId: Scalars['Long'];
};


export type QueryUerPriceListUerSectionForConstraintRatioArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerSectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerSectionDataFilterInput>;
};


export type QueryUerPriceListUerSectionNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerStatusFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfUerRecordStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfUerRecordStatusEnumFilterInput>;
};


export type QueryUerPriceListUerTypeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
};


export type QueryUerPriceListUerUnitFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerWorkCodeFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerWorkInSumFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfWorkInSumEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
};


export type QueryUerPriceListUerWorkNameFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerPriceListUerWorkUnitFilterArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerRatioAppliesToCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerRatioAppliesToCodeNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerRatioAppliesToLinkStatusFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput>>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
};


export type QueryUerRatioCollectionArgs = {
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<RatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RatioRowDataFilterInput>;
};


export type QueryUerRatioRowDefaultsArgs = {
  contractId: Scalars['Long'];
  ratioType: RatioTypeEnum;
  uerBaseRowId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerRatioRowForIncludingToContractChangeArgs = {
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<ContractRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractRatioRowDataFilterInput>;
};


export type QueryUerRatioUerRowItemListForWorkOrderObjectsArgs = {
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<PriceListRatioUerRowForWorkOrderChangeSortInput>>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioUerRowForWorkOrderChangeFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerRatioUerRowItemListForWorkOrderRootObjectArgs = {
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<PriceListRatioUerRowForWorkOrderChangeSortInput>>;
  ratioRowId: Scalars['Long'];
  rootObjectIds: WorkOrderChangeObjectIdInput;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioUerRowForWorkOrderChangeFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerRatioUerRowItemsForWorkOrderObjectsArgs = {
  order?: InputMaybe<Array<RatioUerRowItemSortInput>>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RatioUerRowItemFilterInput>;
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerRatioUerRowItemsForWorkOrderRootObjectArgs = {
  order?: InputMaybe<Array<RatioUerRowItemSortInput>>;
  ratioRowId: Scalars['Long'];
  rootObjectId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RatioUerRowItemFilterInput>;
};


export type QueryUerSkzsContractArgs = {
  contractInternalNumber: Scalars['String'];
};


export type QueryUerSkzsContractsInProgressArgs = {
  order?: InputMaybe<Array<SkzsContractDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkzsContractDataFilterInput>;
};


export type QueryUerSkzsUerPriceListArgs = {
  contractUniqueId: Scalars['String'];
  order?: InputMaybe<Array<SkzsUerDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkzsUerDataFilterInput>;
};


export type QueryUerSkzsWorkOrderObjectsArgs = {
  contractUniqueId: Scalars['String'];
  order?: InputMaybe<Array<SkzsWorkOrderObjectDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkzsWorkOrderObjectDataFilterInput>;
  workOrderUniqueId: Scalars['String'];
};


export type QueryUerSkzsWorkOrderPricesArgs = {
  order?: InputMaybe<Array<SkzsWorkOrderPriceDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkzsWorkOrderPriceDataFilterInput>;
  workOrderUniqueId: Scalars['String'];
};


export type QueryUerSkzsWorkOrdersInProgressArgs = {
  contractUniqueId: Scalars['String'];
  order?: InputMaybe<Array<SkzsWorkOrderDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkzsWorkOrderDataFilterInput>;
};


export type QueryUerUerRowReadyInfoArgs = {
  contractId: Scalars['Long'];
};


export type QueryUerWorkOrderArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderActKc2MtrForInflationDistributionArgs = {
  actKC2Id: Scalars['Long'];
  chapter: ChapterEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderMtrInflationDataFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderActsArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderActKc2DataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderActsKc2Args = {
  actCostGroup: CostGroupEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderActKc2DataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderActsKc2RegistryArgs = {
  groupType?: InputMaybe<ActKc2GroupTypeEnum>;
  order?: InputMaybe<Array<ActKc2ListItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  utcOffset?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<ActKc2ListItemDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderActsKc2RegistrySelectionListArgs = {
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<ActKc2SelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  utcOffset?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<ActKc2SelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeAllowedSeasonsArgs = {
  where?: InputMaybe<ContractSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeDraftInfoArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeLastSeasonSelectionListArgs = {
  where?: InputMaybe<ContractSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeLimitedCostItemsArgs = {
  order?: InputMaybe<Array<WorkOrderChangeLimitedCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeLimitedCostItemDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeObjectItemsArgs = {
  order?: InputMaybe<Array<WorkOrderChangeObjectItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeObjectItemFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeObjectResultArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  order?: InputMaybe<Array<WorkOrderChangeObjectResultDataSortInput>>;
  section?: InputMaybe<SectionEnum>;
  where?: InputMaybe<WorkOrderChangeObjectResultDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeObjectSelectionListArgs = {
  order?: InputMaybe<Array<WorkOrderChangeObjectSelectionItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeObjectSelectionItemFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeObjectTotalsArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeObjectsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeObjectDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeObjectsForRemindersArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeOtherCostSelectonListArgs = {
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderChangeOtherCostItemFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeOtherForDistributionArgs = {
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeOtherListQueryArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeOtherAggregationDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeOtherPriceListArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeOtherPriceDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeOtherPriceNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeOtherPriceRationaleArgs = {
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeOtherPriceStatusFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfNullableOfContractOtherStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfContractOtherStatusEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePreviousVersionsArgs = {
  order?: InputMaybe<Array<WorkOrderVersionListItemSortInput>>;
  where?: InputMaybe<WorkOrderVersionListItemFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceCodeFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfWorkOrderChangePriceCodeFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceItemChapterFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemCodeFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemStatusFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemUnitFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemWorkInSumFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkInSumEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemWorkNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemWorkPlanFilterArgs = {
  constructionTypeId: Scalars['Int'];
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceItemsArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangePriceItemFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceListArgs = {
  chapter: ChapterEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangePriceDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceListMtrQueryArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceListRatioForObjectsArgs = {
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceListRatioForRootObjectArgs = {
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput>>;
  rootObjectIds: WorkOrderChangeObjectIdInput;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangePriceListRatioQueryArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceListUerQueryArgs = {
  chapter: ChapterEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceNameFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceRationaleArgs = {
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangePriceStatusFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeResultArgs = {
  order?: InputMaybe<Array<WorkOrderChangeResultDataSortInput>>;
  where?: InputMaybe<WorkOrderChangeResultDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeSeasonPriceCompletedVolumeFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfNullableOfDecimalSortInput>>;
  seasonId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeSeasonPricePlanVolumeFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfNullableOfDecimalSortInput>>;
  seasonId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeSeasonPriceRemainderVolumeFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfNullableOfDecimalSortInput>>;
  seasonId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeSeasonsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeTotalsArgs = {
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeUerRemaindersArgs = {
  chapter: ChapterEnum;
  workOrderChangeId: Scalars['Long'];
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderChangeUersSelectionListArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<WorkOrderChangeUerItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderChangeUerItemDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeUsersSelectionListCodeFilterArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeUsersSelectionListGroupFilterArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeUsersSelectionListNameFilterArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeUsersSelectionListSectionFilterArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
};


export type QueryUerWorkOrderChangeWorkRatioInfoArgs = {
  constructionTypeId: Scalars['Int'];
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderConstructionTypesArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderDraftInfoArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderExportAsExcelArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderLimitedCostItemsArgs = {
  order?: InputMaybe<Array<WorkOrderLimitedCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderLimitedCostItemDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderMtrRowsForComparisonArgs = {
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderObjectResultArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  order?: InputMaybe<Array<WorkOrderObjectResultDataSortInput>>;
  section?: InputMaybe<SectionEnum>;
  where?: InputMaybe<WorkOrderObjectResultDataFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderObjectSelectionListArgs = {
  order?: InputMaybe<Array<WorkOrderObjectSelectionDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderObjectSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderObjectTotalsArgs = {
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderObjectsArgs = {
  order?: InputMaybe<Array<WorkOrderObjectDataSortInput>>;
  where?: InputMaybe<WorkOrderObjectDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherCostSelectionListArgs = {
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderOtherCostItemFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherForDistributionArgs = {
  workOrderId: Scalars['Long'];
  workOrderOtherPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherPriceListArgs = {
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherPriceNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderOtherPriceObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherPriceRationaleArgs = {
  workOrderOtherPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherPriceStatusFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfContractOtherStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfContractOtherStatusEnumFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderOtherPriceObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderOtherPricesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderOtherPriceDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderOthersForActKc2Args = {
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceCodeFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfWorkOrderPriceCodeFilterDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceCodeFilterDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderPriceObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemChapterFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemCodeFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemObjectNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueContainerOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemRootObjectNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueContainerOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemStatusFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemUnitFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemWorkInSumFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkInSumEnumFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemWorkNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceItemsArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderPriceItemFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListArgs = {
  chapter: ChapterEnum;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderViewDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
  workOrderSubObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListMtrArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListMtrAssignCodeFilterArgs = {
  contractId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerWorkOrderPriceListMtrAssignNameFilterArgs = {
  contractId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUerWorkOrderPriceListRatioArgs = {
  order?: InputMaybe<Array<PriceListRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListRatioCodeFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioType: RatioTypeEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListRatioForObjectsArgs = {
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerWorkOrderPriceListRatioForRootObjectArgs = {
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListRatioNameFilterArgs = {
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  ratioType: RatioTypeEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListUerArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<PriceListUerRowDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListUerCodeFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListUerNameFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListUerSectionFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceListUerSubSectionFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceNameFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderPriceObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceRationaleArgs = {
  workOrderPriceId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceStatusFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfWorkOrderPriceStatusEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceStatusEnumFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderPriceObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPriceUnitFilterArgs = {
  chapter: ChapterEnum;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderPriceObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderPricesArgs = {
  chapter: ChapterEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderPriceDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderResultArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderSKzSInfoArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderSeasonsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderSeasonDataFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderTotalsArgs = {
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderUersSelectionListAsyncArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<WorkOrderUerItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderUerItemDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerWorkOrderUsersSelectionListCodeFilterArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerWorkOrderUsersSelectionListGroupFilterArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerWorkOrderUsersSelectionListNameFilterArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerWorkOrderUsersSelectionListSectionFilterArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']>;
};


export type QueryUerWorkOrderVersionArgs = {
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionActsArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionActKc2DataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionActsKc2VersionArgs = {
  costGroup?: InputMaybe<CostGroupEnum>;
  order?: InputMaybe<Array<WorkOrderVersionActKc2VersionDataSortInput>>;
  where?: InputMaybe<WorkOrderVersionActKc2VersionDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUerWorkOrderVersionLimitedCostItemsArgs = {
  order?: InputMaybe<Array<WorkOrderVersionLimitedCostItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionLimitedCostItemDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionObjectResultsArgs = {
  chapter?: InputMaybe<ChapterEnum>;
  order?: InputMaybe<Array<WorkOrderVersionObjectResultDataSortInput>>;
  section?: InputMaybe<SectionEnum>;
  where?: InputMaybe<WorkOrderVersionObjectResultDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionObjectTotalsArgs = {
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionObjectsArgs = {
  order?: InputMaybe<Array<WorkOrderVersionObjectDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionObjectDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionOtherPriceListArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionOtherPriceDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemChapterFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemCodeFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemObjectNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueContainerOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemRootObjectNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueContainerOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemStatusFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemUnitFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemWorkInSumFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkInSumEnumFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemWorkNameFilterArgs = {
  constructionTypeId: Scalars['Int'];
  objectId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceItemsArgs = {
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionPriceItemFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionPriceListArgs = {
  chapter: ChapterEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionPriceDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionResultsArgs = {
  order?: InputMaybe<Array<WorkOrderVersionResultDataSortInput>>;
  where?: InputMaybe<WorkOrderVersionResultDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionSeasonsArgs = {
  order?: InputMaybe<Array<WorkOrderVersionSeasonDataSortInput>>;
  where?: InputMaybe<WorkOrderVersionSeasonDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionTotalsArgs = {
  workOrderVersionId: Scalars['Long'];
};


export type QueryUerWorkOrderVersionsArgs = {
  order?: InputMaybe<Array<WorkOrderVersionListItemSortInput>>;
  where?: InputMaybe<WorkOrderVersionListItemFilterInput>;
  workOrderId: Scalars['Long'];
};


export type QueryUerWorkOrderWorkRatioInfoArgs = {
  constructionTypeId: Scalars['Int'];
  workOrderId: Scalars['Long'];
};


export type QueryUercAppModuleReportArgs = {
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUercCalculationArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercCalculationCommonDataArgs = {
  calculationUniqueId: Scalars['String'];
};


export type QueryUercCalculationComputedDataArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CalculationComputeRowFilterInput>;
};


export type QueryUercCalculationComputedRowsChapterFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCalculationComputedRowsCodeExtendedFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkVolumeItemCodeFilterDataFilterInput>;
};


export type QueryUercCalculationComputedRowsCodeFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCalculationComputedRowsNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCalculationComputedRowsWorkInSumFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCalculationComputedRowsWorkNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCalculationComputedTotalsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUercCalculationConstructionTypesArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercCalculationDefaultsArgs = {
  projectUniqueId: Scalars['String'];
};


export type QueryUercCalculationLimitedCostForUpdateArgs = {
  calculationId: Scalars['Long'];
  editConstructionTypeId?: InputMaybe<Scalars['Int']>;
  limitedCostId: Scalars['Long'];
};


export type QueryUercCalculationLimitedCostNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCalculationLimitedCostTypesArgs = {
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<CatalogLimitedCostTypeDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogLimitedCostTypeDataFilterInput>;
};


export type QueryUercCalculationLimitedCostsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<UercCalculationLimitedCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UercCalculationLimitedCostDataFilterInput>;
};


export type QueryUercCalculationObjectsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Long']>;
};


export type QueryUercCalculationObjectsWithVolumesArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<CalculationObjectDataSortInput>>;
};


export type QueryUercCalculationOtherCostForUpdateArgs = {
  calculationId: Scalars['Long'];
  editConstructionTypeId?: InputMaybe<Scalars['Int']>;
  otherCostId: Scalars['Long'];
};


export type QueryUercCalculationOtherCostNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCalculationOtherCostTypesQueryArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput>>;
  otherCostId?: InputMaybe<Scalars['Long']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
};


export type QueryUercCalculationOtherCostsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<UercCalculationOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UercCalculationOtherCostDataFilterInput>;
};


export type QueryUercCalculationSeasonsArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercCatalogRatiosNotInCollectionArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogRatioDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataFilterInput>;
};


export type QueryUercCheckConstructionTypesToAddUersArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
};


export type QueryUercCollectionMtrItemCodeFilterQueryArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
};


export type QueryUercCollectionMtrItemMtrTypeFilterQueryArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
};


export type QueryUercCollectionMtrItemNameFilterQueryArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
};


export type QueryUercCollectionMtrItemPricingTypeFilterQueryArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
};


export type QueryUercCollectionMtrItemQueryArgs = {
  calculationId: Scalars['Long'];
  mtrId: Scalars['Long'];
};


export type QueryUercCollectionMtrItemSupplyByFilterQueryArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
};


export type QueryUercCollectionMtrItemValuesTotalsQueryArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercCollectionMtrItemsByGroupQueryArgs = {
  calculationId: Scalars['Long'];
  groupName: MtrGroupName;
};


export type QueryUercCollectionMtrItemsNoPricingQueryArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercCollectionMtrItemsQueryArgs = {
  calculationId: Scalars['Long'];
  showUsers: Scalars['Boolean'];
  where?: InputMaybe<CollectionMtrUersItemFilterInput>;
};


export type QueryUercCollectionMtrSelectionListArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercCollectionRatioArgs = {
  calculationId: Scalars['Long'];
  id: Scalars['Long'];
};


export type QueryUercCollectionRatioCodeFilterArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionRatioGroupFilterArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionRatioGroupsArgs = {
  calculationId: Scalars['Long'];
  ratioType: RatioTypeEnum;
};


export type QueryUercCollectionRatioGroupsWithCostsArgs = {
  calculationId: Scalars['Long'];
  ratioType: RatioTypeEnum;
};


export type QueryUercCollectionRatioJustificationFilterArgs = {
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCollectionRatioNameFilterArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionRatioStatusFilterArgs = {
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCollectionRatioTypeFilterArgs = {
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCollectionRatioTypesArgs = {
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCollectionRatiosArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionRatioDataForListSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataForListFilterInput>;
};


export type QueryUercCollectionUerBaseCostArgs = {
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
};


export type QueryUercCollectionUerBaseCostChapterFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
};


export type QueryUercCollectionUerBaseCostCodeFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostEstimateBasisArgs = {
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostEstimateBasisDataFilterInput>;
};


export type QueryUercCollectionUerBaseCostEstimateBasisResourcesArgs = {
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostEstimateBasisDataFilterInput>;
};


export type QueryUercCollectionUerBaseCostEstimateBasisRowsArgs = {
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostEstimateBasisRowFilterInput>;
};


export type QueryUercCollectionUerBaseCostFullNameFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostGroupNameFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsHavingRatioArgs = {
  calculationId: Scalars['Long'];
  collectionRatioId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsHavingRatioGroupArgs = {
  calculationId: Scalars['Long'];
  collectionRatioGroupId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsToAddToWorArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsToAddToWorCodeFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsToAddToWorGroupNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsToAddToWorNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostItemsToAddToWorSectionNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostNameFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostSectionNameFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostStatusFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercCollectionUerBaseCostTotalsArgs = {
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
};


export type QueryUercCollectionUerBaseCostUerClassifierFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
};


export type QueryUercCollectionUerBaseCostWorkInSumFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfWorkInSumEnumSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
};


export type QueryUercCollectionUerBaseCostWorkNameFilterArgs = {
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
};


export type QueryUercCollectionUerBaseCostWorkScopesArgs = {
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostWorkScopeDataFilterInput>;
};


export type QueryUercDownloadCalculationLimitedCostFileArgs = {
  calculationId: Scalars['Long'];
  limitedCostId: Scalars['Long'];
};


export type QueryUercDownloadCalculationOtherCostFileArgs = {
  calculationId: Scalars['Long'];
  otherCostId: Scalars['Long'];
};


export type QueryUercExportCollectionMtrAsExcelArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercExportPrintFormArgs = {
  calculationId: Scalars['Long'];
  modes: Array<ContragentTypeEnum>;
};


export type QueryUercExportWorAsExcelArgs = {
  calculationId: Scalars['Long'];
  fileType?: InputMaybe<WorExcelFileType>;
  verticalSortType?: InputMaybe<WorUerSortType>;
};


export type QueryUercExportWorTemplateAsExcelArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercExtractCalculationLimitedCostsTotalPercentageArgs = {
  input: FileInput;
};


export type QueryUercExtractTotalSumArgs = {
  input: FileInput;
};


export type QueryUercFindUersToAddArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
};


export type QueryUercGlobalLimitedCostsForCalculationArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalLimitedCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalLimitedCostDataFilterInput>;
};


export type QueryUercGlobalOtherCostsForCalculationArgs = {
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
};


export type QueryUercHasMtrForReplacementArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercIsCalculationConstructionTypeUsedArgs = {
  code: Scalars['String'];
};


export type QueryUercIsCalculationLimitedCostCodeUniqueArgs = {
  calculationId: Scalars['Long'];
  key: Scalars['String'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
};


export type QueryUercIsCalculationLimitedCostNameUniqueArgs = {
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryUercIsCalculationOtherCostCodeUniqueArgs = {
  calculationId: Scalars['Long'];
  key: Scalars['String'];
  otherCostId?: InputMaybe<Scalars['Long']>;
};


export type QueryUercIsCollectionRatioNameUniqueArgs = {
  calculationId: Scalars['Long'];
  collectionRatioId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
};


export type QueryUercIsUniqueCalculationObjectCodeArgs = {
  calculationId: Scalars['Long'];
  calculationObjectId?: InputMaybe<Scalars['Long']>;
  code?: InputMaybe<Scalars['String']>;
};


export type QueryUercIsUniqueCalculationObjectNameArgs = {
  calculationId: Scalars['Long'];
  calculationObjectId?: InputMaybe<Scalars['Long']>;
  constructionTypeId: Scalars['Int'];
  name: Scalars['String'];
};


export type QueryUercIsUniqueCalculationSubObjectNameArgs = {
  calculationObjectId: Scalars['Long'];
  name: Scalars['String'];
  subObjectId?: InputMaybe<Scalars['Long']>;
};


export type QueryUercParseUerBaseCostBasisArgs = {
  content: FileInput;
};


export type QueryUercUersToAddCodeFilterArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  filter?: InputMaybe<UersToAddFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercUersToAddConstructionTypeFilterArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  filter?: InputMaybe<UersToAddFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercUersToAddGroupNameFilterArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  filter?: InputMaybe<UersToAddFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercUersToAddNameFilterArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  filter?: InputMaybe<UersToAddFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercUersToAddSectionNameFilterArgs = {
  calculationConstructionTypes: Array<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  filter?: InputMaybe<UersToAddFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercWorkVolumeArgs = {
  calculationId: Scalars['Long'];
};


export type QueryUercWorkVolumeFormulaVariablesArgs = {
  calculationId: Scalars['Long'];
  calculationObjectId: Scalars['Long'];
  calculationSeasonId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkVolumeFormulaVariableDataFilterInput>;
  worRowId: Scalars['Long'];
};


export type QueryUercWorkVolumeItemCodeExtendedFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfWorkVolumeItemCodeFilterDataFilterInput>;
};


export type QueryUercWorkVolumeItemCodeFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercWorkVolumeItemNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercWorkVolumeItemRatioGroupArgs = {
  ratioType: RatioTypeEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerId: Scalars['Long'];
};


export type QueryUercWorkVolumeItemUerGroupNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercWorkVolumeItemUerSectionNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercWorkVolumeItemUnitFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUercWorkVolumeItemsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeItemFilterInput>;
  order?: InputMaybe<Array<WorkVolumeItemDataSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkVolumeItemDataFilterInput>;
};


export type QueryUercWorkVolumeMtrSelectionListArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionMtrItemShortFilterInput>;
  worParentId: Scalars['Long'];
};


export type QueryUercWorkVolumeMtrSelectionListCodeFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerRowId: Scalars['Long'];
};


export type QueryUercWorkVolumeMtrSelectionListNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerRowId: Scalars['Long'];
};


export type QueryUercWorkVolumeObjectAdditionalArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeItemFilterInput>;
  objectId: Scalars['Long'];
  seasonId: Scalars['Long'];
};


export type QueryUercWorkVolumeObjectsArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<WorkVolumeObjectDataSortInput>>;
};


export type QueryUercWorkVolumeRatioCollectionUersSelectionListArgs = {
  order?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalSortInput>>;
  ratioId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostRatioMinimalFilterInput>;
};


export type QueryUercWorkVolumeRatiosSelectionListArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<CollectionRatioDataShortSortInput>>;
  ratioType: RatioTypeEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerRowId: Scalars['Long'];
  where?: InputMaybe<CollectionRatioDataShortFilterInput>;
};


export type QueryUercWorkVolumeRatiosWithUersSelectionListArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  order?: InputMaybe<Array<CollectionRatioUersDataShortSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioUersDataShortFilterInput>;
};


export type QueryUercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterArgs = {
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export enum RatioRecordStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type RatioRecordStatusEnumOperationFilterInput = {
  eq?: InputMaybe<RatioRecordStatusEnum>;
  in?: InputMaybe<Array<RatioRecordStatusEnum>>;
  neq?: InputMaybe<RatioRecordStatusEnum>;
  nin?: InputMaybe<Array<RatioRecordStatusEnum>>;
};

/** Структура данных представления коэффициента */
export type RatioRowData = {
  __typename?: 'RatioRowData';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы коэффициента */
  groupId?: Maybe<Scalars['Long']>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: Maybe<Scalars['Boolean']>;
  /** Наименование группы коэффициента */
  groupName?: Maybe<Scalars['String']>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: Maybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент создан вручную */
  isCustom?: Maybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: Maybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Номер из шифра */
  number?: Maybe<Scalars['Int']>;
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: RatioRecordStatusEnum;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: Maybe<Scalars['Long']>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: Maybe<Scalars['String']>;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

/** Структура данных представления коэффициента */
export type RatioRowDataFilterInput = {
  and?: InputMaybe<Array<RatioRowDataFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<NullableOfDismantlingCoefficientTypeEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<BooleanOperationFilterInput>;
  /** Обоснование */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  /** Номер из шифра */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RatioRowDataFilterInput>>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Статус коэффициента */
  status?: InputMaybe<RatioRecordStatusEnumOperationFilterInput>;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Условия производства работ */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Структура данных представления коэффициента */
export type RatioRowDataInput = {
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<Scalars['Long']>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<Scalars['Boolean']>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<Scalars['String']>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<Scalars['Boolean']>;
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Коэффициент эксплуатации машин */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов */
  kmat?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли */
  ksp: Scalars['Decimal'];
  /** Коэффициент трудозатрат рабочих */
  ktz: Scalars['Decimal'];
  /** Коэффициент заработной платы машинистов */
  ktzzpm: Scalars['Decimal'];
  /** Номер из шифра */
  number?: InputMaybe<Scalars['Int']>;
  /** Тип коэффициента */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента */
  status: RatioRecordStatusEnum;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<Scalars['Long']>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<Scalars['String']>;
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

/** Структура данных представления коэффициента */
export type RatioRowDataSortInput = {
  /** Код шифра */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор группы коэффициента */
  groupId?: InputMaybe<SortEnumType>;
  /** Признак вспомогательной группы для которой требуется ручной перевыбор */
  groupIsArtificial?: InputMaybe<SortEnumType>;
  /** Наименование группы коэффициента */
  groupName?: InputMaybe<SortEnumType>;
  /** Значения перечисления для типов коэффициентов демонтажа */
  groupType?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Коэффициент создан вручную */
  isCustom?: InputMaybe<SortEnumType>;
  /** Обоснование */
  justification?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<SortEnumType>;
  /** Коэффициент трудозатрат рабочих */
  ktz?: InputMaybe<SortEnumType>;
  /** Коэффициент заработной платы машинистов */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Номер из шифра */
  number?: InputMaybe<SortEnumType>;
  /** Тип коэффициента */
  ratioType?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор подгруппы коэффициента */
  subGroupId?: InputMaybe<SortEnumType>;
  /** Наименование подгруппы коэффициента */
  subGroupName?: InputMaybe<SortEnumType>;
  /** Условия производства работ */
  workConditions?: InputMaybe<SortEnumType>;
};

export enum RatioTypeEnum {
  /** Коэффициент стесненности, соответствуют коэффициенты с маской "КОУ####" */
  ConstraintCoef = 'CONSTRAINT_COEF',
  /** Коэффициент на демонтаж, соответствуют коэффициенты с маской "КД####" */
  DismantlingCoef = 'DISMANTLING_COEF',
  /** Коэффициент технической части, соответствуют коэффициенты с маской "К####" */
  TechPartCoef = 'TECH_PART_COEF'
}

export type RatioTypeEnumOperationFilterInput = {
  eq?: InputMaybe<RatioTypeEnum>;
  in?: InputMaybe<Array<RatioTypeEnum>>;
  neq?: InputMaybe<RatioTypeEnum>;
  nin?: InputMaybe<Array<RatioTypeEnum>>;
};

/** Модель для ответа, содержащего информацию о расценках и коэффициентах */
export type RatioUerRowItem = {
  __typename?: 'RatioUerRowItem';
  /** Шифр расценки */
  appliesToCode: Scalars['String'];
  /** Наименование расценки */
  appliesToCodeName: Scalars['String'];
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId: Scalars['Long'];
  /** Статус связи коэффициент-расценка */
  appliesToLinkStatus: Scalars['String'];
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id: Scalars['Long'];
};

/** Модель для ответа, содержащего информацию о расценках и коэффициентах */
export type RatioUerRowItemFilterInput = {
  and?: InputMaybe<Array<RatioUerRowItemFilterInput>>;
  /** Шифр расценки */
  appliesToCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование расценки */
  appliesToCodeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId?: InputMaybe<LongOperationFilterInput>;
  /** Статус связи коэффициент-расценка */
  appliesToLinkStatus?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RatioUerRowItemFilterInput>>;
};

/** Модель для ответа, содержащего информацию о расценках и коэффициентах */
export type RatioUerRowItemSortInput = {
  /** Шифр расценки */
  appliesToCode?: InputMaybe<SortEnumType>;
  /** Наименование расценки */
  appliesToCodeName?: InputMaybe<SortEnumType>;
  /** Идентификатор примененной расценки из Прейскуранта расценок */
  appliesToId?: InputMaybe<SortEnumType>;
  /** Статус связи коэффициент-расценка */
  appliesToLinkStatus?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента из Прейскуранта коэффициентов */
  id?: InputMaybe<SortEnumType>;
};

export type RemoveCollectionMtrInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
};

/** Кортеж удаляемых ЛСР */
export type RemoveLsrRequestInput = {
  /** Id ЛСР */
  id: Scalars['Long'];
  /** Тип ЛСР */
  localEstimateType: BimcLocalEstimateTypeEnum;
};

/** Сформированная позиция после замены позиций МТР */
export type ReplaceCollectionMtrItemData = {
  __typename?: 'ReplaceCollectionMtrItemData';
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Идентификатор родительского объекта из ВОР */
  parentId: Scalars['Long'];
  /** Идентификатор корневого объекта из ВОР */
  rootObjectId: Scalars['Long'];
  /** Статус записи */
  status?: Maybe<MtrStatus>;
  /** Идентификатор расценки из ВОР */
  uerRowId: Scalars['Long'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: Maybe<Scalars['Decimal']>;
};

/** Сформированная позиция после замены позиций МТР */
export type ReplaceCollectionMtrItemDataInput = {
  /** Код шифра */
  code: Scalars['String'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  name: Scalars['String'];
  /** Идентификатор родительского объекта из ВОР */
  parentId: Scalars['Long'];
  /** Идентификатор корневого объекта из ВОР */
  rootObjectId: Scalars['Long'];
  /** Статус записи */
  status?: InputMaybe<MtrStatus>;
  /** Идентификатор расценки из ВОР */
  uerRowId: Scalars['Long'];
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для замены выбранных позиций на одну */
export type ReplaceCollectionMtrItemInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /**
   * Уникальный идентификатор позиции МТР, на которую производится замена (в случае, если это существующая позиция из Ведомости МТР)
   * если производится создание то Id = null
   */
  id?: InputMaybe<Scalars['Long']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификаторы для замены (удаления) */
  replaceIds: Array<Scalars['Long']>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
};

export type SeasonReminderData = {
  __typename?: 'SeasonReminderData';
  completedVolume?: Maybe<Scalars['Decimal']>;
  planVolume?: Maybe<Scalars['Decimal']>;
  remainderVolume?: Maybe<Scalars['Decimal']>;
  seasonId: Scalars['Long'];
  seasonYear: Scalars['Short'];
};

export type SeasonResultData = {
  __typename?: 'SeasonResultData';
  /** Идентификатор сезона договора */
  contractSeasonId: Scalars['Long'];
  /** Значение по сезону */
  value?: Maybe<Scalars['Decimal']>;
  /** Год сезона договора */
  year: Scalars['Short'];
};

export type SeasonResultDataInput = {
  /** Идентификатор сезона договора */
  contractSeasonId: Scalars['Long'];
  /** Значение по сезону */
  value?: InputMaybe<Scalars['Decimal']>;
  /** Год сезона договора */
  year: Scalars['Short'];
};

/** Строка итога по сезону */
export type SeasonTotalData = {
  __typename?: 'SeasonTotalData';
  /** Затраты по сезону */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Разделы */
export enum SectionEnum {
  /** Лимиты заказчика */
  CustomerLimits = 'CUSTOMER_LIMITS',
  /** Лимитированные затраты */
  LimitedCost = 'LIMITED_COST',
  /** Прочие */
  Others = 'OTHERS',
  /** Итоги НЗ */
  WorkOrderTotals = 'WORK_ORDER_TOTALS'
}

export type SectionEnumOperationFilterInput = {
  eq?: InputMaybe<SectionEnum>;
  in?: InputMaybe<Array<SectionEnum>>;
  neq?: InputMaybe<SectionEnum>;
  nin?: InputMaybe<Array<SectionEnum>>;
};

export type ServiceDataResultOfActKc2CommentData = {
  __typename?: 'ServiceDataResultOfActKC2CommentData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ActKc2CommentData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc2CommentData;
  withButtonText: ServiceDataResultOfActKc2CommentData;
  withCode: ServiceDataResultOfActKc2CommentData;
  withData: ServiceDataResultOfActKc2CommentData;
  withHideValidation: ServiceDataResultOfActKc2CommentData;
  withMessage: ServiceDataResultOfActKc2CommentData;
  withValidation: ServiceDataResultOfActKc2CommentData;
};


export type ServiceDataResultOfActKc2CommentDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc2CommentDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2CommentDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2CommentDataWithDataArgs = {
  data?: InputMaybe<ActKc2CommentDataInput>;
};


export type ServiceDataResultOfActKc2CommentDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc2CommentDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2CommentDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc2Data = {
  __typename?: 'ServiceDataResultOfActKC2Data';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ActKc2Data>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfActKc2GroupAttributeData = {
  __typename?: 'ServiceDataResultOfActKC2GroupAttributeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ActKc2GroupAttributeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc2GroupAttributeData;
  withButtonText: ServiceDataResultOfActKc2GroupAttributeData;
  withCode: ServiceDataResultOfActKc2GroupAttributeData;
  withData: ServiceDataResultOfActKc2GroupAttributeData;
  withHideValidation: ServiceDataResultOfActKc2GroupAttributeData;
  withMessage: ServiceDataResultOfActKc2GroupAttributeData;
  withValidation: ServiceDataResultOfActKc2GroupAttributeData;
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithDataArgs = {
  data?: InputMaybe<ActKc2GroupAttributeDataInput>;
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2GroupAttributeDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc2StatusData__ = {
  __typename?: 'ServiceDataResultOfActKC2StatusData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ActKc2StatusData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc2StatusData__;
  withButtonText: ServiceDataResultOfActKc2StatusData__;
  withCode: ServiceDataResultOfActKc2StatusData__;
  withData: ServiceDataResultOfActKc2StatusData__;
  withHideValidation: ServiceDataResultOfActKc2StatusData__;
  withMessage: ServiceDataResultOfActKc2StatusData__;
  withValidation: ServiceDataResultOfActKc2StatusData__;
};


export type ServiceDataResultOfActKc2StatusData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc2StatusData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2StatusData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2StatusData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ActKc2StatusDataInput>>>;
};


export type ServiceDataResultOfActKc2StatusData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc2StatusData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2StatusData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc2TemplateImport__ = {
  __typename?: 'ServiceDataResultOfActKC2TemplateImport__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ActKc2TemplateImport>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc2TemplateImport__;
  withButtonText: ServiceDataResultOfActKc2TemplateImport__;
  withCode: ServiceDataResultOfActKc2TemplateImport__;
  withData: ServiceDataResultOfActKc2TemplateImport__;
  withHideValidation: ServiceDataResultOfActKc2TemplateImport__;
  withMessage: ServiceDataResultOfActKc2TemplateImport__;
  withValidation: ServiceDataResultOfActKc2TemplateImport__;
};


export type ServiceDataResultOfActKc2TemplateImport__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc2TemplateImport__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2TemplateImport__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2TemplateImport__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ActKc2TemplateImportInput>>>;
};


export type ServiceDataResultOfActKc2TemplateImport__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc2TemplateImport__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2TemplateImport__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc2WorkVolumeData = {
  __typename?: 'ServiceDataResultOfActKC2WorkVolumeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ActKc2WorkVolumeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc2WorkVolumeData;
  withButtonText: ServiceDataResultOfActKc2WorkVolumeData;
  withCode: ServiceDataResultOfActKc2WorkVolumeData;
  withData: ServiceDataResultOfActKc2WorkVolumeData;
  withHideValidation: ServiceDataResultOfActKc2WorkVolumeData;
  withMessage: ServiceDataResultOfActKc2WorkVolumeData;
  withValidation: ServiceDataResultOfActKc2WorkVolumeData;
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithDataArgs = {
  data?: InputMaybe<ActKc2WorkVolumeDataInput>;
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2WorkVolumeDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc2WorkVolumeData__ = {
  __typename?: 'ServiceDataResultOfActKC2WorkVolumeData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ActKc2WorkVolumeData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc2WorkVolumeData__;
  withButtonText: ServiceDataResultOfActKc2WorkVolumeData__;
  withCode: ServiceDataResultOfActKc2WorkVolumeData__;
  withData: ServiceDataResultOfActKc2WorkVolumeData__;
  withHideValidation: ServiceDataResultOfActKc2WorkVolumeData__;
  withMessage: ServiceDataResultOfActKc2WorkVolumeData__;
  withValidation: ServiceDataResultOfActKc2WorkVolumeData__;
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ActKc2WorkVolumeDataInput>>>;
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc2WorkVolumeData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc3Data = {
  __typename?: 'ServiceDataResultOfActKC3Data';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ActKc3Data>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfActKc3DataWithActs = {
  __typename?: 'ServiceDataResultOfActKC3DataWithActs';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ActKc3DataWithActs>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc3DataWithActs;
  withButtonText: ServiceDataResultOfActKc3DataWithActs;
  withCode: ServiceDataResultOfActKc3DataWithActs;
  withData: ServiceDataResultOfActKc3DataWithActs;
  withHideValidation: ServiceDataResultOfActKc3DataWithActs;
  withMessage: ServiceDataResultOfActKc3DataWithActs;
  withValidation: ServiceDataResultOfActKc3DataWithActs;
};


export type ServiceDataResultOfActKc3DataWithActsWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc3DataWithActsWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc3DataWithActsWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc3DataWithActsWithDataArgs = {
  data?: InputMaybe<ActKc3DataWithActsInput>;
};


export type ServiceDataResultOfActKc3DataWithActsWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc3DataWithActsWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc3DataWithActsWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfActKc3TotalData__ = {
  __typename?: 'ServiceDataResultOfActKC3TotalData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ActKc3TotalData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfActKc3TotalData__;
  withButtonText: ServiceDataResultOfActKc3TotalData__;
  withCode: ServiceDataResultOfActKc3TotalData__;
  withData: ServiceDataResultOfActKc3TotalData__;
  withHideValidation: ServiceDataResultOfActKc3TotalData__;
  withMessage: ServiceDataResultOfActKc3TotalData__;
  withValidation: ServiceDataResultOfActKc3TotalData__;
};


export type ServiceDataResultOfActKc3TotalData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfActKc3TotalData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc3TotalData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc3TotalData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ActKc3TotalDataInput>>>;
};


export type ServiceDataResultOfActKc3TotalData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfActKc3TotalData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfActKc3TotalData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfAddUersToCollectionUerBaseCostData = {
  __typename?: 'ServiceDataResultOfAddUersToCollectionUERBaseCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<AddUersToCollectionUerBaseCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  withButtonText: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  withCode: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  withData: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  withHideValidation: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  withMessage: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
  withValidation: ServiceDataResultOfAddUersToCollectionUerBaseCostData;
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithDataArgs = {
  data?: InputMaybe<AddUersToCollectionUerBaseCostDataInput>;
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAddUersToCollectionUerBaseCostDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateData = {
  __typename?: 'ServiceDataResultOfAggregateLocalEstimateCreateUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<AggregateLocalEstimateCreateUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  withButtonText: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  withCode: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  withData: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  withHideValidation: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  withMessage: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
  withValidation: ServiceDataResultOfAggregateLocalEstimateCreateUpdateData;
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithDataArgs = {
  data?: InputMaybe<AggregateLocalEstimateCreateUpdateDataInput>;
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAggregateLocalEstimateCreateUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfAggregateLocalEstimateData = {
  __typename?: 'ServiceDataResultOfAggregateLocalEstimateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<AggregateLocalEstimateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfAggregateLocalEstimateData;
  withButtonText: ServiceDataResultOfAggregateLocalEstimateData;
  withCode: ServiceDataResultOfAggregateLocalEstimateData;
  withData: ServiceDataResultOfAggregateLocalEstimateData;
  withHideValidation: ServiceDataResultOfAggregateLocalEstimateData;
  withMessage: ServiceDataResultOfAggregateLocalEstimateData;
  withValidation: ServiceDataResultOfAggregateLocalEstimateData;
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithDataArgs = {
  data?: InputMaybe<AggregateLocalEstimateDataInput>;
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfAggregateLocalEstimateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfAppHealthCheckData = {
  __typename?: 'ServiceDataResultOfAppHealthCheckData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<AppHealthCheckData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfAppModuleInfo = {
  __typename?: 'ServiceDataResultOfAppModuleInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<AppModuleInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfAppModuleReport = {
  __typename?: 'ServiceDataResultOfAppModuleReport';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<AppModuleReport>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfAppModuleReportFilterInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ServiceDataResultOfAppModuleReportFilterInput>>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  data?: InputMaybe<AppModuleReportFilterInput>;
  /** Признак наличия сообщений валидации */
  hasValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ServiceDataResultOfAppModuleReportFilterInput>>;
  /** Признак успешного выполнения */
  result?: InputMaybe<BooleanOperationFilterInput>;
  /** Список сообщений валидации */
  validation?: InputMaybe<ListFilterInputTypeOfValidationMessageFilterInput>;
};

export type ServiceDataResultOfAppModuleReportSortInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<SortEnumType>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<SortEnumType>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<SortEnumType>;
  data?: InputMaybe<AppModuleReportSortInput>;
  /** Признак наличия сообщений валидации */
  hasValidation?: InputMaybe<SortEnumType>;
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<SortEnumType>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<SortEnumType>;
  /** Признак успешного выполнения */
  result?: InputMaybe<SortEnumType>;
};

export type ServiceDataResultOfBimActKc2GroupAttributeData = {
  __typename?: 'ServiceDataResultOfBimActKC2GroupAttributeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimActKc2GroupAttributeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimActKc2GroupAttributeData;
  withButtonText: ServiceDataResultOfBimActKc2GroupAttributeData;
  withCode: ServiceDataResultOfBimActKc2GroupAttributeData;
  withData: ServiceDataResultOfBimActKc2GroupAttributeData;
  withHideValidation: ServiceDataResultOfBimActKc2GroupAttributeData;
  withMessage: ServiceDataResultOfBimActKc2GroupAttributeData;
  withValidation: ServiceDataResultOfBimActKc2GroupAttributeData;
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithDataArgs = {
  data?: InputMaybe<BimActKc2GroupAttributeDataInput>;
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2GroupAttributeDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimActKc2OtherData = {
  __typename?: 'ServiceDataResultOfBimActKC2OtherData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimActKc2OtherData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimActKc2OtherDefaultData = {
  __typename?: 'ServiceDataResultOfBimActKC2OtherDefaultData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimActKc2OtherDefaultData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimActKc2OtherDefaultData;
  withButtonText: ServiceDataResultOfBimActKc2OtherDefaultData;
  withCode: ServiceDataResultOfBimActKc2OtherDefaultData;
  withData: ServiceDataResultOfBimActKc2OtherDefaultData;
  withHideValidation: ServiceDataResultOfBimActKc2OtherDefaultData;
  withMessage: ServiceDataResultOfBimActKc2OtherDefaultData;
  withValidation: ServiceDataResultOfBimActKc2OtherDefaultData;
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithDataArgs = {
  data?: InputMaybe<BimActKc2OtherDefaultDataInput>;
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2OtherDefaultDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimActKc2VersionOtherData = {
  __typename?: 'ServiceDataResultOfBimActKC2VersionOtherData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimActKc2VersionOtherData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimActKc2VersionOtherData;
  withButtonText: ServiceDataResultOfBimActKc2VersionOtherData;
  withCode: ServiceDataResultOfBimActKc2VersionOtherData;
  withData: ServiceDataResultOfBimActKc2VersionOtherData;
  withHideValidation: ServiceDataResultOfBimActKc2VersionOtherData;
  withMessage: ServiceDataResultOfBimActKc2VersionOtherData;
  withValidation: ServiceDataResultOfBimActKc2VersionOtherData;
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithDataArgs = {
  data?: InputMaybe<BimActKc2VersionOtherDataInput>;
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimActKc2VersionOtherDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimCalculationData = {
  __typename?: 'ServiceDataResultOfBimCalculationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimCalculationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimContractData = {
  __typename?: 'ServiceDataResultOfBimContractData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimContractData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimContractDefaultData = {
  __typename?: 'ServiceDataResultOfBimContractDefaultData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimContractDefaultData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimContractDefaultData;
  withButtonText: ServiceDataResultOfBimContractDefaultData;
  withCode: ServiceDataResultOfBimContractDefaultData;
  withData: ServiceDataResultOfBimContractDefaultData;
  withHideValidation: ServiceDataResultOfBimContractDefaultData;
  withMessage: ServiceDataResultOfBimContractDefaultData;
  withValidation: ServiceDataResultOfBimContractDefaultData;
};


export type ServiceDataResultOfBimContractDefaultDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimContractDefaultDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractDefaultDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractDefaultDataWithDataArgs = {
  data?: InputMaybe<BimContractDefaultDataInput>;
};


export type ServiceDataResultOfBimContractDefaultDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimContractDefaultDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractDefaultDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimContractObjectData = {
  __typename?: 'ServiceDataResultOfBimContractObjectData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimContractObjectData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimContractOtherCostData = {
  __typename?: 'ServiceDataResultOfBimContractOtherCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimContractOtherCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimContractResultsViewData = {
  __typename?: 'ServiceDataResultOfBimContractResultsViewData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimContractResultsViewData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimContractResultsViewData;
  withButtonText: ServiceDataResultOfBimContractResultsViewData;
  withCode: ServiceDataResultOfBimContractResultsViewData;
  withData: ServiceDataResultOfBimContractResultsViewData;
  withHideValidation: ServiceDataResultOfBimContractResultsViewData;
  withMessage: ServiceDataResultOfBimContractResultsViewData;
  withValidation: ServiceDataResultOfBimContractResultsViewData;
};


export type ServiceDataResultOfBimContractResultsViewDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimContractResultsViewDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractResultsViewDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractResultsViewDataWithDataArgs = {
  data?: InputMaybe<BimContractResultsViewDataInput>;
};


export type ServiceDataResultOfBimContractResultsViewDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimContractResultsViewDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractResultsViewDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimContractSeasonData__ = {
  __typename?: 'ServiceDataResultOfBimContractSeasonData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimContractSeasonData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimContractSeasonData__;
  withButtonText: ServiceDataResultOfBimContractSeasonData__;
  withCode: ServiceDataResultOfBimContractSeasonData__;
  withData: ServiceDataResultOfBimContractSeasonData__;
  withHideValidation: ServiceDataResultOfBimContractSeasonData__;
  withMessage: ServiceDataResultOfBimContractSeasonData__;
  withValidation: ServiceDataResultOfBimContractSeasonData__;
};


export type ServiceDataResultOfBimContractSeasonData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimContractSeasonData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractSeasonData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractSeasonData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimContractSeasonDataInput>>>;
};


export type ServiceDataResultOfBimContractSeasonData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimContractSeasonData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimContractSeasonData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimNormalContractResultData__ = {
  __typename?: 'ServiceDataResultOfBimNormalContractResultData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimNormalContractResultData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimNormalContractResultData__;
  withButtonText: ServiceDataResultOfBimNormalContractResultData__;
  withCode: ServiceDataResultOfBimNormalContractResultData__;
  withData: ServiceDataResultOfBimNormalContractResultData__;
  withHideValidation: ServiceDataResultOfBimNormalContractResultData__;
  withMessage: ServiceDataResultOfBimNormalContractResultData__;
  withValidation: ServiceDataResultOfBimNormalContractResultData__;
};


export type ServiceDataResultOfBimNormalContractResultData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimNormalContractResultData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimNormalContractResultData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimNormalContractResultData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimNormalContractResultDataInput>>>;
};


export type ServiceDataResultOfBimNormalContractResultData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimNormalContractResultData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimNormalContractResultData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimPriceAnalyticsData = {
  __typename?: 'ServiceDataResultOfBimPriceAnalyticsData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimPriceAnalyticsData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimPriceAnalyticsData;
  withButtonText: ServiceDataResultOfBimPriceAnalyticsData;
  withCode: ServiceDataResultOfBimPriceAnalyticsData;
  withData: ServiceDataResultOfBimPriceAnalyticsData;
  withHideValidation: ServiceDataResultOfBimPriceAnalyticsData;
  withMessage: ServiceDataResultOfBimPriceAnalyticsData;
  withValidation: ServiceDataResultOfBimPriceAnalyticsData;
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithDataArgs = {
  data?: InputMaybe<BimPriceAnalyticsDataInput>;
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimPriceAnalyticsDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeChapterData__ = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeChapterData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimWorkOrderChangeChapterData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  withCode: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  withData: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  withMessage: ServiceDataResultOfBimWorkOrderChangeChapterData__;
  withValidation: ServiceDataResultOfBimWorkOrderChangeChapterData__;
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimWorkOrderChangeChapterDataInput>>>;
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeChapterData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeData;
  withCode: ServiceDataResultOfBimWorkOrderChangeData;
  withData: ServiceDataResultOfBimWorkOrderChangeData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeData;
  withMessage: ServiceDataResultOfBimWorkOrderChangeData;
  withValidation: ServiceDataResultOfBimWorkOrderChangeData;
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangeDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeDefaultData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeDefaultData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangeDefaultData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  withCode: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  withData: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  withMessage: ServiceDataResultOfBimWorkOrderChangeDefaultData;
  withValidation: ServiceDataResultOfBimWorkOrderChangeDefaultData;
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangeDefaultDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeDefaultDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeObjectData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeObjectData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangeObjectData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeObjectData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeObjectData;
  withCode: ServiceDataResultOfBimWorkOrderChangeObjectData;
  withData: ServiceDataResultOfBimWorkOrderChangeObjectData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeObjectData;
  withMessage: ServiceDataResultOfBimWorkOrderChangeObjectData;
  withValidation: ServiceDataResultOfBimWorkOrderChangeObjectData;
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangeObjectDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeObjectDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeOtherDistributionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangeOtherDistributionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  withCode: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  withData: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  withMessage: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
  withValidation: ServiceDataResultOfBimWorkOrderChangeOtherDistributionData;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangeOtherDistributionDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherDistributionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__ = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimWorkOrderChangeOtherPriceCostData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  withCode: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  withData: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  withMessage: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
  withValidation: ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimWorkOrderChangeOtherPriceCostDataInput>>>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangePriceStatesData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangePriceStatesData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangePriceStatesData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  withCode: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  withData: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  withMessage: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
  withValidation: ServiceDataResultOfBimWorkOrderChangePriceStatesData;
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangePriceStatesDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangePriceStatesDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeSeasonsData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeSeasonsData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangeSeasonsData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  withCode: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  withData: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  withMessage: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
  withValidation: ServiceDataResultOfBimWorkOrderChangeSeasonsData;
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangeSeasonsDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeSeasonsDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChangeTotalData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChangeTotalData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderChangeTotalData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChangeTotalData;
  withButtonText: ServiceDataResultOfBimWorkOrderChangeTotalData;
  withCode: ServiceDataResultOfBimWorkOrderChangeTotalData;
  withData: ServiceDataResultOfBimWorkOrderChangeTotalData;
  withHideValidation: ServiceDataResultOfBimWorkOrderChangeTotalData;
  withMessage: ServiceDataResultOfBimWorkOrderChangeTotalData;
  withValidation: ServiceDataResultOfBimWorkOrderChangeTotalData;
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderChangeTotalDataInput>;
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChangeTotalDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderChapterData__ = {
  __typename?: 'ServiceDataResultOfBimWorkOrderChapterData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimWorkOrderChapterData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderChapterData__;
  withButtonText: ServiceDataResultOfBimWorkOrderChapterData__;
  withCode: ServiceDataResultOfBimWorkOrderChapterData__;
  withData: ServiceDataResultOfBimWorkOrderChapterData__;
  withHideValidation: ServiceDataResultOfBimWorkOrderChapterData__;
  withMessage: ServiceDataResultOfBimWorkOrderChapterData__;
  withValidation: ServiceDataResultOfBimWorkOrderChapterData__;
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimWorkOrderChapterDataInput>>>;
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderChapterData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimWorkOrderOtherDistributionData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderOtherDistributionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderOtherDistributionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  withButtonText: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  withCode: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  withData: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  withHideValidation: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  withMessage: ServiceDataResultOfBimWorkOrderOtherDistributionData;
  withValidation: ServiceDataResultOfBimWorkOrderOtherDistributionData;
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderOtherDistributionDataInput>;
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherDistributionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__ = {
  __typename?: 'ServiceDataResultOfBimWorkOrderOtherPriceCostData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimWorkOrderOtherPriceCostData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  withButtonText: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  withCode: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  withData: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  withHideValidation: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  withMessage: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
  withValidation: ServiceDataResultOfBimWorkOrderOtherPriceCostData__;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimWorkOrderOtherPriceCostDataInput>>>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceCostData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderOtherPriceData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderOtherPriceData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderOtherPriceData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderOtherPriceData;
  withButtonText: ServiceDataResultOfBimWorkOrderOtherPriceData;
  withCode: ServiceDataResultOfBimWorkOrderOtherPriceData;
  withData: ServiceDataResultOfBimWorkOrderOtherPriceData;
  withHideValidation: ServiceDataResultOfBimWorkOrderOtherPriceData;
  withMessage: ServiceDataResultOfBimWorkOrderOtherPriceData;
  withValidation: ServiceDataResultOfBimWorkOrderOtherPriceData;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderOtherPriceDataInput>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderOtherPriceDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderPriceMTRDistributionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderPriceMtrDistributionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  withButtonText: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  withCode: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  withData: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  withHideValidation: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  withMessage: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
  withValidation: ServiceDataResultOfBimWorkOrderPriceMtrDistributionData;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderPriceMtrDistributionDataInput>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderPriceMTRDistributionTotalData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderPriceMtrDistributionTotalData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  withButtonText: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  withCode: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  withData: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  withHideValidation: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  withMessage: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
  withValidation: ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalData;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderPriceMtrDistributionTotalDataInput>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceMtrDistributionTotalDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderPriceStatesData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderPriceStatesData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderPriceStatesData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderPriceStatesData;
  withButtonText: ServiceDataResultOfBimWorkOrderPriceStatesData;
  withCode: ServiceDataResultOfBimWorkOrderPriceStatesData;
  withData: ServiceDataResultOfBimWorkOrderPriceStatesData;
  withHideValidation: ServiceDataResultOfBimWorkOrderPriceStatesData;
  withMessage: ServiceDataResultOfBimWorkOrderPriceStatesData;
  withValidation: ServiceDataResultOfBimWorkOrderPriceStatesData;
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderPriceStatesDataInput>;
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderPriceStatesDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderSeasonsData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderSeasonsData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderSeasonsData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderSeasonsData;
  withButtonText: ServiceDataResultOfBimWorkOrderSeasonsData;
  withCode: ServiceDataResultOfBimWorkOrderSeasonsData;
  withData: ServiceDataResultOfBimWorkOrderSeasonsData;
  withHideValidation: ServiceDataResultOfBimWorkOrderSeasonsData;
  withMessage: ServiceDataResultOfBimWorkOrderSeasonsData;
  withValidation: ServiceDataResultOfBimWorkOrderSeasonsData;
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderSeasonsDataInput>;
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderSeasonsDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderTotalData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderTotalData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderTotalData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfBimWorkOrderVersionChapterData__ = {
  __typename?: 'ServiceDataResultOfBimWorkOrderVersionChapterData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<BimWorkOrderVersionChapterData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  withButtonText: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  withCode: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  withData: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  withHideValidation: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  withMessage: ServiceDataResultOfBimWorkOrderVersionChapterData__;
  withValidation: ServiceDataResultOfBimWorkOrderVersionChapterData__;
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<BimWorkOrderVersionChapterDataInput>>>;
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionChapterData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderVersionData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderVersionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderVersionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderVersionData;
  withButtonText: ServiceDataResultOfBimWorkOrderVersionData;
  withCode: ServiceDataResultOfBimWorkOrderVersionData;
  withData: ServiceDataResultOfBimWorkOrderVersionData;
  withHideValidation: ServiceDataResultOfBimWorkOrderVersionData;
  withMessage: ServiceDataResultOfBimWorkOrderVersionData;
  withValidation: ServiceDataResultOfBimWorkOrderVersionData;
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderVersionDataInput>;
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderVersionObjectViewData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderVersionObjectViewData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderVersionObjectViewData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  withButtonText: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  withCode: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  withData: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  withHideValidation: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  withMessage: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
  withValidation: ServiceDataResultOfBimWorkOrderVersionObjectViewData;
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderVersionObjectViewDataInput>;
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionObjectViewDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderVersionSeasonsData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderVersionSeasonsData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderVersionSeasonsData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  withButtonText: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  withCode: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  withData: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  withHideValidation: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  withMessage: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
  withValidation: ServiceDataResultOfBimWorkOrderVersionSeasonsData;
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderVersionSeasonsDataInput>;
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSeasonsDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewData = {
  __typename?: 'ServiceDataResultOfBimWorkOrderVersionSubObjectViewData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimWorkOrderVersionSubObjectViewData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  withButtonText: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  withCode: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  withData: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  withHideValidation: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  withMessage: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
  withValidation: ServiceDataResultOfBimWorkOrderVersionSubObjectViewData;
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithDataArgs = {
  data?: InputMaybe<BimWorkOrderVersionSubObjectViewDataInput>;
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimWorkOrderVersionSubObjectViewDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimcCalculationData = {
  __typename?: 'ServiceDataResultOfBimcCalculationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcCalculationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimcCalculationData;
  withButtonText: ServiceDataResultOfBimcCalculationData;
  withCode: ServiceDataResultOfBimcCalculationData;
  withData: ServiceDataResultOfBimcCalculationData;
  withHideValidation: ServiceDataResultOfBimcCalculationData;
  withMessage: ServiceDataResultOfBimcCalculationData;
  withValidation: ServiceDataResultOfBimcCalculationData;
};


export type ServiceDataResultOfBimcCalculationDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimcCalculationDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationDataWithDataArgs = {
  data?: InputMaybe<BimcCalculationDataInput>;
};


export type ServiceDataResultOfBimcCalculationDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimcCalculationDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimcCalculationDefaultData = {
  __typename?: 'ServiceDataResultOfBimcCalculationDefaultData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcCalculationDefaultData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimcCalculationDefaultData;
  withButtonText: ServiceDataResultOfBimcCalculationDefaultData;
  withCode: ServiceDataResultOfBimcCalculationDefaultData;
  withData: ServiceDataResultOfBimcCalculationDefaultData;
  withHideValidation: ServiceDataResultOfBimcCalculationDefaultData;
  withMessage: ServiceDataResultOfBimcCalculationDefaultData;
  withValidation: ServiceDataResultOfBimcCalculationDefaultData;
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithDataArgs = {
  data?: InputMaybe<BimcCalculationDefaultDataInput>;
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationDefaultDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimcCalculationLimitedCostUpdateData = {
  __typename?: 'ServiceDataResultOfBimcCalculationLimitedCostUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcCalculationLimitedCostUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  withButtonText: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  withCode: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  withData: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  withHideValidation: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  withMessage: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
  withValidation: ServiceDataResultOfBimcCalculationLimitedCostUpdateData;
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithDataArgs = {
  data?: InputMaybe<BimcCalculationLimitedCostUpdateDataInput>;
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationLimitedCostUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimcCalculationOtherCostUpdateData = {
  __typename?: 'ServiceDataResultOfBimcCalculationOtherCostUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcCalculationOtherCostUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  withButtonText: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  withCode: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  withData: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  withHideValidation: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  withMessage: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
  withValidation: ServiceDataResultOfBimcCalculationOtherCostUpdateData;
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithDataArgs = {
  data?: InputMaybe<BimcCalculationOtherCostUpdateDataInput>;
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationOtherCostUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfBimcCalculationResultData = {
  __typename?: 'ServiceDataResultOfBimcCalculationResultData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<BimcCalculationResultData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfBimcCalculationResultData;
  withButtonText: ServiceDataResultOfBimcCalculationResultData;
  withCode: ServiceDataResultOfBimcCalculationResultData;
  withData: ServiceDataResultOfBimcCalculationResultData;
  withHideValidation: ServiceDataResultOfBimcCalculationResultData;
  withMessage: ServiceDataResultOfBimcCalculationResultData;
  withValidation: ServiceDataResultOfBimcCalculationResultData;
};


export type ServiceDataResultOfBimcCalculationResultDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfBimcCalculationResultDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationResultDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationResultDataWithDataArgs = {
  data?: InputMaybe<BimcCalculationResultDataInput>;
};


export type ServiceDataResultOfBimcCalculationResultDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfBimcCalculationResultDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfBimcCalculationResultDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCalculationCommonData = {
  __typename?: 'ServiceDataResultOfCalculationCommonData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Uerc_CalculationCommonData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCalculationComputeRow = {
  __typename?: 'ServiceDataResultOfCalculationComputeRow';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CalculationComputeRow>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCalculationComputeRow;
  withButtonText: ServiceDataResultOfCalculationComputeRow;
  withCode: ServiceDataResultOfCalculationComputeRow;
  withData: ServiceDataResultOfCalculationComputeRow;
  withHideValidation: ServiceDataResultOfCalculationComputeRow;
  withMessage: ServiceDataResultOfCalculationComputeRow;
  withValidation: ServiceDataResultOfCalculationComputeRow;
};


export type ServiceDataResultOfCalculationComputeRowWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCalculationComputeRowWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationComputeRowWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationComputeRowWithDataArgs = {
  data?: InputMaybe<CalculationComputeRowInput>;
};


export type ServiceDataResultOfCalculationComputeRowWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCalculationComputeRowWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationComputeRowWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCalculationNavigationData = {
  __typename?: 'ServiceDataResultOfCalculationNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CalculationNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCalculationNavigationDataInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<CalculationNavigationDataInput>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCalculationObjectData = {
  __typename?: 'ServiceDataResultOfCalculationObjectData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CalculationObjectData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCalculationObjectData;
  withButtonText: ServiceDataResultOfCalculationObjectData;
  withCode: ServiceDataResultOfCalculationObjectData;
  withData: ServiceDataResultOfCalculationObjectData;
  withHideValidation: ServiceDataResultOfCalculationObjectData;
  withMessage: ServiceDataResultOfCalculationObjectData;
  withValidation: ServiceDataResultOfCalculationObjectData;
};


export type ServiceDataResultOfCalculationObjectDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCalculationObjectDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationObjectDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationObjectDataWithDataArgs = {
  data?: InputMaybe<CalculationObjectDataInput>;
};


export type ServiceDataResultOfCalculationObjectDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCalculationObjectDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationObjectDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCalculationOtherCostTotalSum = {
  __typename?: 'ServiceDataResultOfCalculationOtherCostTotalSum';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CalculationOtherCostTotalSum>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCalculationOtherCostTotalSum;
  withButtonText: ServiceDataResultOfCalculationOtherCostTotalSum;
  withCode: ServiceDataResultOfCalculationOtherCostTotalSum;
  withData: ServiceDataResultOfCalculationOtherCostTotalSum;
  withHideValidation: ServiceDataResultOfCalculationOtherCostTotalSum;
  withMessage: ServiceDataResultOfCalculationOtherCostTotalSum;
  withValidation: ServiceDataResultOfCalculationOtherCostTotalSum;
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithDataArgs = {
  data?: InputMaybe<CalculationOtherCostTotalSumInput>;
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCalculationOtherCostTotalSumWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCalculationPriceData = {
  __typename?: 'ServiceDataResultOfCalculationPriceData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CalculationPriceData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCalculationPriceDataInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<CalculationPriceDataInput>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogConstructionTypeChangesData = {
  __typename?: 'ServiceDataResultOfCatalogConstructionTypeChangesData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogConstructionTypeChangesData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCatalogData = {
  __typename?: 'ServiceDataResultOfCatalogData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCatalogLimitedCostTypeExtendedData = {
  __typename?: 'ServiceDataResultOfCatalogLimitedCostTypeExtendedData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogLimitedCostTypeExtendedData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  withButtonText: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  withCode: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  withData: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  withHideValidation: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  withMessage: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
  withValidation: ServiceDataResultOfCatalogLimitedCostTypeExtendedData;
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithDataArgs = {
  data?: InputMaybe<CatalogLimitedCostTypeExtendedDataInput>;
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogLimitedCostTypeExtendedDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogOtherCostTypeData = {
  __typename?: 'ServiceDataResultOfCatalogOtherCostTypeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogOtherCostTypeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogOtherCostTypeData;
  withButtonText: ServiceDataResultOfCatalogOtherCostTypeData;
  withCode: ServiceDataResultOfCatalogOtherCostTypeData;
  withData: ServiceDataResultOfCatalogOtherCostTypeData;
  withHideValidation: ServiceDataResultOfCatalogOtherCostTypeData;
  withMessage: ServiceDataResultOfCatalogOtherCostTypeData;
  withValidation: ServiceDataResultOfCatalogOtherCostTypeData;
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithDataArgs = {
  data?: InputMaybe<CatalogOtherCostTypeDataInput>;
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogOtherCostTypeDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogOtherCostVariableData = {
  __typename?: 'ServiceDataResultOfCatalogOtherCostVariableData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogOtherCostVariableData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCatalogOtherCostVariableGroupData = {
  __typename?: 'ServiceDataResultOfCatalogOtherCostVariableGroupData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogOtherCostVariableGroupData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCatalogRatioData = {
  __typename?: 'ServiceDataResultOfCatalogRatioData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogRatioData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogRatioData;
  withButtonText: ServiceDataResultOfCatalogRatioData;
  withCode: ServiceDataResultOfCatalogRatioData;
  withData: ServiceDataResultOfCatalogRatioData;
  withHideValidation: ServiceDataResultOfCatalogRatioData;
  withMessage: ServiceDataResultOfCatalogRatioData;
  withValidation: ServiceDataResultOfCatalogRatioData;
};


export type ServiceDataResultOfCatalogRatioDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogRatioDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogRatioDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogRatioDataWithDataArgs = {
  data?: InputMaybe<CatalogRatioDataInput>;
};


export type ServiceDataResultOfCatalogRatioDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogRatioDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogRatioDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogUerBaseCostData = {
  __typename?: 'ServiceDataResultOfCatalogUERBaseCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogUerBaseCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCatalogUerBaseCostDetailedData = {
  __typename?: 'ServiceDataResultOfCatalogUERBaseCostDetailedData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogUerBaseCostDetailedData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  withButtonText: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  withCode: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  withData: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  withHideValidation: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  withMessage: ServiceDataResultOfCatalogUerBaseCostDetailedData;
  withValidation: ServiceDataResultOfCatalogUerBaseCostDetailedData;
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithDataArgs = {
  data?: InputMaybe<CatalogUerBaseCostDetailedDataInput>;
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostDetailedDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData = {
  __typename?: 'ServiceDataResultOfCatalogUERBaseCostHistoryStatusCountData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogUerBaseCostHistoryStatusCountData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  withButtonText: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  withCode: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  withData: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  withHideValidation: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  withMessage: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
  withValidation: ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountData;
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithDataArgs = {
  data?: InputMaybe<CatalogUerBaseCostHistoryStatusCountDataInput>;
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataFilterInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataFilterInput>>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  data?: InputMaybe<CatalogUerBaseCostHistoryStatusCountDataFilterInput>;
  /** Признак наличия сообщений валидации */
  hasValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ServiceDataResultOfCatalogUerBaseCostHistoryStatusCountDataFilterInput>>;
  /** Признак успешного выполнения */
  result?: InputMaybe<BooleanOperationFilterInput>;
  /** Список сообщений валидации */
  validation?: InputMaybe<ListFilterInputTypeOfValidationMessageFilterInput>;
};

export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount = {
  __typename?: 'ServiceDataResultOfCatalogUERBaseCostWorkScopeHistoryWithStatusCount';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogUerBaseCostWorkScopeHistoryWithStatusCount>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  withButtonText: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  withCode: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  withData: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  withHideValidation: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  withMessage: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
  withValidation: ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCount;
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithDataArgs = {
  data?: InputMaybe<CatalogUerBaseCostWorkScopeHistoryWithStatusCountInput>;
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput>>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  data?: InputMaybe<CatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput>;
  /** Признак наличия сообщений валидации */
  hasValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ServiceDataResultOfCatalogUerBaseCostWorkScopeHistoryWithStatusCountFilterInput>>;
  /** Признак успешного выполнения */
  result?: InputMaybe<BooleanOperationFilterInput>;
  /** Список сообщений валидации */
  validation?: InputMaybe<ListFilterInputTypeOfValidationMessageFilterInput>;
};

export type ServiceDataResultOfCatalogUerOtherCostTemplateData = {
  __typename?: 'ServiceDataResultOfCatalogUEROtherCostTemplateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogUerOtherCostTemplateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  withButtonText: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  withCode: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  withData: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  withHideValidation: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  withMessage: ServiceDataResultOfCatalogUerOtherCostTemplateData;
  withValidation: ServiceDataResultOfCatalogUerOtherCostTemplateData;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithDataArgs = {
  data?: InputMaybe<CatalogUerOtherCostTemplateDataInput>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData = {
  __typename?: 'ServiceDataResultOfCatalogUEROtherCostTemplateExtendedData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogUerOtherCostTemplateExtendedData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  withButtonText: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  withCode: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  withData: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  withHideValidation: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  withMessage: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
  withValidation: ServiceDataResultOfCatalogUerOtherCostTemplateExtendedData;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithDataArgs = {
  data?: InputMaybe<CatalogUerOtherCostTemplateExtendedDataInput>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogUerOtherCostTemplateExtendedDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCatalogWorkTypeChangesData = {
  __typename?: 'ServiceDataResultOfCatalogWorkTypeChangesData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogWorkTypeChangesData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfCatalogWorkTypeData = {
  __typename?: 'ServiceDataResultOfCatalogWorkTypeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CatalogWorkTypeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCatalogWorkTypeData;
  withButtonText: ServiceDataResultOfCatalogWorkTypeData;
  withCode: ServiceDataResultOfCatalogWorkTypeData;
  withData: ServiceDataResultOfCatalogWorkTypeData;
  withHideValidation: ServiceDataResultOfCatalogWorkTypeData;
  withMessage: ServiceDataResultOfCatalogWorkTypeData;
  withValidation: ServiceDataResultOfCatalogWorkTypeData;
};


export type ServiceDataResultOfCatalogWorkTypeDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCatalogWorkTypeDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogWorkTypeDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogWorkTypeDataWithDataArgs = {
  data?: InputMaybe<CatalogWorkTypeDataInput>;
};


export type ServiceDataResultOfCatalogWorkTypeDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCatalogWorkTypeDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCatalogWorkTypeDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCheckConstructionTypesToAddUersData = {
  __typename?: 'ServiceDataResultOfCheckConstructionTypesToAddUersData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CheckConstructionTypesToAddUersData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  withButtonText: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  withCode: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  withData: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  withHideValidation: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  withMessage: ServiceDataResultOfCheckConstructionTypesToAddUersData;
  withValidation: ServiceDataResultOfCheckConstructionTypesToAddUersData;
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithDataArgs = {
  data?: InputMaybe<CheckConstructionTypesToAddUersDataInput>;
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCheckConstructionTypesToAddUersDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCollectionMtrItem = {
  __typename?: 'ServiceDataResultOfCollectionMtrItem';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CollectionMtrItem>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCollectionMtrItem;
  withButtonText: ServiceDataResultOfCollectionMtrItem;
  withCode: ServiceDataResultOfCollectionMtrItem;
  withData: ServiceDataResultOfCollectionMtrItem;
  withHideValidation: ServiceDataResultOfCollectionMtrItem;
  withMessage: ServiceDataResultOfCollectionMtrItem;
  withValidation: ServiceDataResultOfCollectionMtrItem;
};


export type ServiceDataResultOfCollectionMtrItemWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCollectionMtrItemWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionMtrItemWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionMtrItemWithDataArgs = {
  data?: InputMaybe<CollectionMtrItemInput>;
};


export type ServiceDataResultOfCollectionMtrItemWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCollectionMtrItemWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionMtrItemWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCollectionRatioData = {
  __typename?: 'ServiceDataResultOfCollectionRatioData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CollectionRatioData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCollectionRatioData;
  withButtonText: ServiceDataResultOfCollectionRatioData;
  withCode: ServiceDataResultOfCollectionRatioData;
  withData: ServiceDataResultOfCollectionRatioData;
  withHideValidation: ServiceDataResultOfCollectionRatioData;
  withMessage: ServiceDataResultOfCollectionRatioData;
  withValidation: ServiceDataResultOfCollectionRatioData;
};


export type ServiceDataResultOfCollectionRatioDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCollectionRatioDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionRatioDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionRatioDataWithDataArgs = {
  data?: InputMaybe<CollectionRatioDataInput>;
};


export type ServiceDataResultOfCollectionRatioDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCollectionRatioDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionRatioDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCollectionRatioDataWithCosts = {
  __typename?: 'ServiceDataResultOfCollectionRatioDataWithCosts';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CollectionRatioDataWithCosts>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCollectionRatioDataWithCosts;
  withButtonText: ServiceDataResultOfCollectionRatioDataWithCosts;
  withCode: ServiceDataResultOfCollectionRatioDataWithCosts;
  withData: ServiceDataResultOfCollectionRatioDataWithCosts;
  withHideValidation: ServiceDataResultOfCollectionRatioDataWithCosts;
  withMessage: ServiceDataResultOfCollectionRatioDataWithCosts;
  withValidation: ServiceDataResultOfCollectionRatioDataWithCosts;
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithDataArgs = {
  data?: InputMaybe<CollectionRatioDataWithCostsInput>;
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionRatioDataWithCostsWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCollectionUerBaseCostData = {
  __typename?: 'ServiceDataResultOfCollectionUERBaseCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CollectionUerBaseCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfCollectionUerBaseCostData;
  withButtonText: ServiceDataResultOfCollectionUerBaseCostData;
  withCode: ServiceDataResultOfCollectionUerBaseCostData;
  withData: ServiceDataResultOfCollectionUerBaseCostData;
  withHideValidation: ServiceDataResultOfCollectionUerBaseCostData;
  withMessage: ServiceDataResultOfCollectionUerBaseCostData;
  withValidation: ServiceDataResultOfCollectionUerBaseCostData;
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithDataArgs = {
  data?: InputMaybe<CollectionUerBaseCostDataInput>;
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfCollectionUerBaseCostDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfConstructionTypeData = {
  __typename?: 'ServiceDataResultOfConstructionTypeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ConstructionTypeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfConstructionTypeData__ = {
  __typename?: 'ServiceDataResultOfConstructionTypeData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ConstructionTypeData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfConstructionTypeData__;
  withButtonText: ServiceDataResultOfConstructionTypeData__;
  withCode: ServiceDataResultOfConstructionTypeData__;
  withData: ServiceDataResultOfConstructionTypeData__;
  withHideValidation: ServiceDataResultOfConstructionTypeData__;
  withMessage: ServiceDataResultOfConstructionTypeData__;
  withValidation: ServiceDataResultOfConstructionTypeData__;
};


export type ServiceDataResultOfConstructionTypeData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfConstructionTypeData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfConstructionTypeData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfConstructionTypeData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ConstructionTypeDataInput>>>;
};


export type ServiceDataResultOfConstructionTypeData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfConstructionTypeData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfConstructionTypeData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractChangeData = {
  __typename?: 'ServiceDataResultOfContractChangeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractChangeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfContractCommonData = {
  __typename?: 'ServiceDataResultOfContractCommonData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Uer_ContractCommonData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfContractNavigationData = {
  __typename?: 'ServiceDataResultOfContractNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfContractNavigationDataInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<ContractNavigationDataInput>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractObjectData = {
  __typename?: 'ServiceDataResultOfContractObjectData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractObjectData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfContractObjectData;
  withButtonText: ServiceDataResultOfContractObjectData;
  withCode: ServiceDataResultOfContractObjectData;
  withData: ServiceDataResultOfContractObjectData;
  withHideValidation: ServiceDataResultOfContractObjectData;
  withMessage: ServiceDataResultOfContractObjectData;
  withValidation: ServiceDataResultOfContractObjectData;
};


export type ServiceDataResultOfContractObjectDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfContractObjectDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractObjectDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractObjectDataWithDataArgs = {
  data?: InputMaybe<ContractObjectDataInput>;
};


export type ServiceDataResultOfContractObjectDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfContractObjectDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractObjectDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractOtherCostData = {
  __typename?: 'ServiceDataResultOfContractOtherCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractOtherCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfContractOtherCostData;
  withButtonText: ServiceDataResultOfContractOtherCostData;
  withCode: ServiceDataResultOfContractOtherCostData;
  withData: ServiceDataResultOfContractOtherCostData;
  withHideValidation: ServiceDataResultOfContractOtherCostData;
  withMessage: ServiceDataResultOfContractOtherCostData;
  withValidation: ServiceDataResultOfContractOtherCostData;
};


export type ServiceDataResultOfContractOtherCostDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfContractOtherCostDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractOtherCostDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractOtherCostDataWithDataArgs = {
  data?: InputMaybe<ContractOtherCostDataInput>;
};


export type ServiceDataResultOfContractOtherCostDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfContractOtherCostDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractOtherCostDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractOtherCostUpdateData = {
  __typename?: 'ServiceDataResultOfContractOtherCostUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractOtherCostUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfContractOtherCostUpdateData;
  withButtonText: ServiceDataResultOfContractOtherCostUpdateData;
  withCode: ServiceDataResultOfContractOtherCostUpdateData;
  withData: ServiceDataResultOfContractOtherCostUpdateData;
  withHideValidation: ServiceDataResultOfContractOtherCostUpdateData;
  withMessage: ServiceDataResultOfContractOtherCostUpdateData;
  withValidation: ServiceDataResultOfContractOtherCostUpdateData;
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithDataArgs = {
  data?: InputMaybe<ContractOtherCostUpdateDataInput>;
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractOtherCostUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractPriceData = {
  __typename?: 'ServiceDataResultOfContractPriceData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractPriceData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfContractPriceDataInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<ContractPriceDataInput>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractResultsViewData = {
  __typename?: 'ServiceDataResultOfContractResultsViewData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ContractResultsViewData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfContractResultsViewData;
  withButtonText: ServiceDataResultOfContractResultsViewData;
  withCode: ServiceDataResultOfContractResultsViewData;
  withData: ServiceDataResultOfContractResultsViewData;
  withHideValidation: ServiceDataResultOfContractResultsViewData;
  withMessage: ServiceDataResultOfContractResultsViewData;
  withValidation: ServiceDataResultOfContractResultsViewData;
};


export type ServiceDataResultOfContractResultsViewDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfContractResultsViewDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractResultsViewDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractResultsViewDataWithDataArgs = {
  data?: InputMaybe<ContractResultsViewDataInput>;
};


export type ServiceDataResultOfContractResultsViewDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfContractResultsViewDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractResultsViewDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractSeasonData__ = {
  __typename?: 'ServiceDataResultOfContractSeasonData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ContractSeasonData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfContractSeasonData__;
  withButtonText: ServiceDataResultOfContractSeasonData__;
  withCode: ServiceDataResultOfContractSeasonData__;
  withData: ServiceDataResultOfContractSeasonData__;
  withHideValidation: ServiceDataResultOfContractSeasonData__;
  withMessage: ServiceDataResultOfContractSeasonData__;
  withValidation: ServiceDataResultOfContractSeasonData__;
};


export type ServiceDataResultOfContractSeasonData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfContractSeasonData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractSeasonData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractSeasonData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ContractSeasonDataInput>>>;
};


export type ServiceDataResultOfContractSeasonData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfContractSeasonData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractSeasonData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfContractStatusData__ = {
  __typename?: 'ServiceDataResultOfContractStatusData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<ContractStatusData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfContractStatusData__;
  withButtonText: ServiceDataResultOfContractStatusData__;
  withCode: ServiceDataResultOfContractStatusData__;
  withData: ServiceDataResultOfContractStatusData__;
  withHideValidation: ServiceDataResultOfContractStatusData__;
  withMessage: ServiceDataResultOfContractStatusData__;
  withValidation: ServiceDataResultOfContractStatusData__;
};


export type ServiceDataResultOfContractStatusData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfContractStatusData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractStatusData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractStatusData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<ContractStatusDataInput>>>;
};


export type ServiceDataResultOfContractStatusData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfContractStatusData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfContractStatusData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfCountData = {
  __typename?: 'ServiceDataResultOfCountData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<CountData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfFileContent = {
  __typename?: 'ServiceDataResultOfFileContent';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<FileContent>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfFileContent;
  withButtonText: ServiceDataResultOfFileContent;
  withCode: ServiceDataResultOfFileContent;
  withData: ServiceDataResultOfFileContent;
  withHideValidation: ServiceDataResultOfFileContent;
  withMessage: ServiceDataResultOfFileContent;
  withValidation: ServiceDataResultOfFileContent;
};


export type ServiceDataResultOfFileContentWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfFileContentWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfFileContentWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfFileContentWithDataArgs = {
  data?: InputMaybe<FileContentInput>;
};


export type ServiceDataResultOfFileContentWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfFileContentWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfFileContentWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfFindUersToAddData = {
  __typename?: 'ServiceDataResultOfFindUersToAddData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<FindUersToAddData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfFindUersToAddData;
  withButtonText: ServiceDataResultOfFindUersToAddData;
  withCode: ServiceDataResultOfFindUersToAddData;
  withData: ServiceDataResultOfFindUersToAddData;
  withHideValidation: ServiceDataResultOfFindUersToAddData;
  withMessage: ServiceDataResultOfFindUersToAddData;
  withValidation: ServiceDataResultOfFindUersToAddData;
};


export type ServiceDataResultOfFindUersToAddDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfFindUersToAddDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfFindUersToAddDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfFindUersToAddDataWithDataArgs = {
  data?: InputMaybe<FindUersToAddDataInput>;
};


export type ServiceDataResultOfFindUersToAddDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfFindUersToAddDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfFindUersToAddDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfGlobalLimitedCostData = {
  __typename?: 'ServiceDataResultOfGlobalLimitedCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<GlobalLimitedCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfGlobalLimitedCostData;
  withButtonText: ServiceDataResultOfGlobalLimitedCostData;
  withCode: ServiceDataResultOfGlobalLimitedCostData;
  withData: ServiceDataResultOfGlobalLimitedCostData;
  withHideValidation: ServiceDataResultOfGlobalLimitedCostData;
  withMessage: ServiceDataResultOfGlobalLimitedCostData;
  withValidation: ServiceDataResultOfGlobalLimitedCostData;
};


export type ServiceDataResultOfGlobalLimitedCostDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfGlobalLimitedCostDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfGlobalLimitedCostDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfGlobalLimitedCostDataWithDataArgs = {
  data?: InputMaybe<GlobalLimitedCostDataInput>;
};


export type ServiceDataResultOfGlobalLimitedCostDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfGlobalLimitedCostDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfGlobalLimitedCostDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfGlobalOtherCostData = {
  __typename?: 'ServiceDataResultOfGlobalOtherCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<GlobalOtherCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfHistoryStatusCountData = {
  __typename?: 'ServiceDataResultOfHistoryStatusCountData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<HistoryStatusCountData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfHistoryStatusCountData;
  withButtonText: ServiceDataResultOfHistoryStatusCountData;
  withCode: ServiceDataResultOfHistoryStatusCountData;
  withData: ServiceDataResultOfHistoryStatusCountData;
  withHideValidation: ServiceDataResultOfHistoryStatusCountData;
  withMessage: ServiceDataResultOfHistoryStatusCountData;
  withValidation: ServiceDataResultOfHistoryStatusCountData;
};


export type ServiceDataResultOfHistoryStatusCountDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfHistoryStatusCountDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfHistoryStatusCountDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfHistoryStatusCountDataWithDataArgs = {
  data?: InputMaybe<HistoryStatusCountDataInput>;
};


export type ServiceDataResultOfHistoryStatusCountDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfHistoryStatusCountDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfHistoryStatusCountDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfHistoryStatusCountDataFilterInput = {
  /** Признак обязательного действия */
  actionRequired?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ServiceDataResultOfHistoryStatusCountDataFilterInput>>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код ошибки. Зарезервировано */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  data?: InputMaybe<HistoryStatusCountDataFilterInput>;
  /** Признак наличия сообщений валидации */
  hasValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: InputMaybe<BooleanOperationFilterInput>;
  /** Общее сообщение о результате выполнения метода */
  message?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ServiceDataResultOfHistoryStatusCountDataFilterInput>>;
  /** Признак успешного выполнения */
  result?: InputMaybe<BooleanOperationFilterInput>;
  /** Список сообщений валидации */
  validation?: InputMaybe<ListFilterInputTypeOfValidationMessageFilterInput>;
};

export type ServiceDataResultOfInt32__ = {
  __typename?: 'ServiceDataResultOfInt32__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Scalars['Int']>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfInt32__;
  withButtonText: ServiceDataResultOfInt32__;
  withCode: ServiceDataResultOfInt32__;
  withData: ServiceDataResultOfInt32__;
  withHideValidation: ServiceDataResultOfInt32__;
  withMessage: ServiceDataResultOfInt32__;
  withValidation: ServiceDataResultOfInt32__;
};


export type ServiceDataResultOfInt32__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfInt32__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfInt32__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfInt32__WithDataArgs = {
  data?: InputMaybe<Array<Scalars['Int']>>;
};


export type ServiceDataResultOfInt32__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfInt32__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfInt32__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfInt64__ = {
  __typename?: 'ServiceDataResultOfInt64__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Scalars['Long']>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfListOfCatalogUerBaseCostData = {
  __typename?: 'ServiceDataResultOfListOfCatalogUERBaseCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<CatalogUerBaseCostData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfListOfCatalogUerBaseCostData;
  withButtonText: ServiceDataResultOfListOfCatalogUerBaseCostData;
  withCode: ServiceDataResultOfListOfCatalogUerBaseCostData;
  withData: ServiceDataResultOfListOfCatalogUerBaseCostData;
  withHideValidation: ServiceDataResultOfListOfCatalogUerBaseCostData;
  withMessage: ServiceDataResultOfListOfCatalogUerBaseCostData;
  withValidation: ServiceDataResultOfListOfCatalogUerBaseCostData;
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<CatalogUerBaseCostDataInput>>>;
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfListOfCatalogUerBaseCostDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfListOfLocalEstimateImportItemData = {
  __typename?: 'ServiceDataResultOfListOfLocalEstimateImportItemData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<LocalEstimateImportItemData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfListOfLocalEstimateImportItemData;
  withButtonText: ServiceDataResultOfListOfLocalEstimateImportItemData;
  withCode: ServiceDataResultOfListOfLocalEstimateImportItemData;
  withData: ServiceDataResultOfListOfLocalEstimateImportItemData;
  withHideValidation: ServiceDataResultOfListOfLocalEstimateImportItemData;
  withMessage: ServiceDataResultOfListOfLocalEstimateImportItemData;
  withValidation: ServiceDataResultOfListOfLocalEstimateImportItemData;
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<LocalEstimateImportItemDataInput>>>;
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfListOfLocalEstimateImportItemDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfLocalEstimateEditData = {
  __typename?: 'ServiceDataResultOfLocalEstimateEditData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<LocalEstimateEditData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfLocalEstimateEditData;
  withButtonText: ServiceDataResultOfLocalEstimateEditData;
  withCode: ServiceDataResultOfLocalEstimateEditData;
  withData: ServiceDataResultOfLocalEstimateEditData;
  withHideValidation: ServiceDataResultOfLocalEstimateEditData;
  withMessage: ServiceDataResultOfLocalEstimateEditData;
  withValidation: ServiceDataResultOfLocalEstimateEditData;
};


export type ServiceDataResultOfLocalEstimateEditDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfLocalEstimateEditDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateEditDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateEditDataWithDataArgs = {
  data?: InputMaybe<LocalEstimateEditDataInput>;
};


export type ServiceDataResultOfLocalEstimateEditDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfLocalEstimateEditDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateEditDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfLocalEstimateMtrDistributionData = {
  __typename?: 'ServiceDataResultOfLocalEstimateMtrDistributionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<LocalEstimateMtrDistributionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfLocalEstimateMtrDistributionData;
  withButtonText: ServiceDataResultOfLocalEstimateMtrDistributionData;
  withCode: ServiceDataResultOfLocalEstimateMtrDistributionData;
  withData: ServiceDataResultOfLocalEstimateMtrDistributionData;
  withHideValidation: ServiceDataResultOfLocalEstimateMtrDistributionData;
  withMessage: ServiceDataResultOfLocalEstimateMtrDistributionData;
  withValidation: ServiceDataResultOfLocalEstimateMtrDistributionData;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithDataArgs = {
  data?: InputMaybe<LocalEstimateMtrDistributionDataInput>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfLocalEstimateMtrDistributionTotalData = {
  __typename?: 'ServiceDataResultOfLocalEstimateMtrDistributionTotalData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<LocalEstimateMtrDistributionTotalData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  withButtonText: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  withCode: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  withData: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  withHideValidation: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  withMessage: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
  withValidation: ServiceDataResultOfLocalEstimateMtrDistributionTotalData;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithDataArgs = {
  data?: InputMaybe<LocalEstimateMtrDistributionTotalDataInput>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfLocalEstimateMtrDistributionTotalDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfObject = {
  __typename?: 'ServiceDataResultOfObject';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfObject;
  withButtonText: ServiceDataResultOfObject;
  withCode: ServiceDataResultOfObject;
  withHideValidation: ServiceDataResultOfObject;
  withMessage: ServiceDataResultOfObject;
  withValidation: ServiceDataResultOfObject;
};


export type ServiceDataResultOfObjectWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfObjectWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfObjectWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfObjectWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfObjectWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfObjectWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfPriceItemWorkRatioInfo = {
  __typename?: 'ServiceDataResultOfPriceItemWorkRatioInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceItemWorkRatioInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfPriceItemWorkRatioInfo;
  withButtonText: ServiceDataResultOfPriceItemWorkRatioInfo;
  withCode: ServiceDataResultOfPriceItemWorkRatioInfo;
  withData: ServiceDataResultOfPriceItemWorkRatioInfo;
  withHideValidation: ServiceDataResultOfPriceItemWorkRatioInfo;
  withMessage: ServiceDataResultOfPriceItemWorkRatioInfo;
  withValidation: ServiceDataResultOfPriceItemWorkRatioInfo;
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithDataArgs = {
  data?: InputMaybe<PriceItemWorkRatioInfoInput>;
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfPriceItemWorkRatioInfoWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfPriceListMtrRowData = {
  __typename?: 'ServiceDataResultOfPriceListMtrRowData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceListMtrRowData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfPriceListRatioGroupedRowData = {
  __typename?: 'ServiceDataResultOfPriceListRatioGroupedRowData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceListRatioGroupedRowData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfPriceListUerRowBasisData = {
  __typename?: 'ServiceDataResultOfPriceListUerRowBasisData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceListUerRowBasisData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfPriceListUerRowData = {
  __typename?: 'ServiceDataResultOfPriceListUerRowData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceListUerRowData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfPriceListUerRowReadyInfo = {
  __typename?: 'ServiceDataResultOfPriceListUerRowReadyInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceListUerRowReadyInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfPriceListUerRowReadyInfo;
  withButtonText: ServiceDataResultOfPriceListUerRowReadyInfo;
  withCode: ServiceDataResultOfPriceListUerRowReadyInfo;
  withData: ServiceDataResultOfPriceListUerRowReadyInfo;
  withHideValidation: ServiceDataResultOfPriceListUerRowReadyInfo;
  withMessage: ServiceDataResultOfPriceListUerRowReadyInfo;
  withValidation: ServiceDataResultOfPriceListUerRowReadyInfo;
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithDataArgs = {
  data?: InputMaybe<PriceListUerRowReadyInfoInput>;
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfPriceListUerRowReadyInfoWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfPriceListUerRowWithRatioData = {
  __typename?: 'ServiceDataResultOfPriceListUerRowWithRatioData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<PriceListUerRowWithRatioData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfProjectData = {
  __typename?: 'ServiceDataResultOfProjectData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ProjectData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfRatioRowData = {
  __typename?: 'ServiceDataResultOfRatioRowData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<RatioRowData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfRatioRowData;
  withButtonText: ServiceDataResultOfRatioRowData;
  withCode: ServiceDataResultOfRatioRowData;
  withData: ServiceDataResultOfRatioRowData;
  withHideValidation: ServiceDataResultOfRatioRowData;
  withMessage: ServiceDataResultOfRatioRowData;
  withValidation: ServiceDataResultOfRatioRowData;
};


export type ServiceDataResultOfRatioRowDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfRatioRowDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfRatioRowDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfRatioRowDataWithDataArgs = {
  data?: InputMaybe<RatioRowDataInput>;
};


export type ServiceDataResultOfRatioRowDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfRatioRowDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfRatioRowDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfReplaceCollectionMtrItemData = {
  __typename?: 'ServiceDataResultOfReplaceCollectionMtrItemData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<ReplaceCollectionMtrItemData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfReplaceCollectionMtrItemData;
  withButtonText: ServiceDataResultOfReplaceCollectionMtrItemData;
  withCode: ServiceDataResultOfReplaceCollectionMtrItemData;
  withData: ServiceDataResultOfReplaceCollectionMtrItemData;
  withHideValidation: ServiceDataResultOfReplaceCollectionMtrItemData;
  withMessage: ServiceDataResultOfReplaceCollectionMtrItemData;
  withValidation: ServiceDataResultOfReplaceCollectionMtrItemData;
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithDataArgs = {
  data?: InputMaybe<ReplaceCollectionMtrItemDataInput>;
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfReplaceCollectionMtrItemDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfSkzsActKc2Data__ = {
  __typename?: 'ServiceDataResultOfSkzsActKC2Data__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<SkzsActKc2Data>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfSkzsActKc2Data__;
  withButtonText: ServiceDataResultOfSkzsActKc2Data__;
  withCode: ServiceDataResultOfSkzsActKc2Data__;
  withData: ServiceDataResultOfSkzsActKc2Data__;
  withHideValidation: ServiceDataResultOfSkzsActKc2Data__;
  withMessage: ServiceDataResultOfSkzsActKc2Data__;
  withValidation: ServiceDataResultOfSkzsActKc2Data__;
};


export type ServiceDataResultOfSkzsActKc2Data__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfSkzsActKc2Data__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfSkzsActKc2Data__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfSkzsActKc2Data__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<SkzsActKc2DataInput>>>;
};


export type ServiceDataResultOfSkzsActKc2Data__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfSkzsActKc2Data__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfSkzsActKc2Data__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfSkzsContractData = {
  __typename?: 'ServiceDataResultOfSkzsContractData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<SkzsContractData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfSkzsContractData;
  withButtonText: ServiceDataResultOfSkzsContractData;
  withCode: ServiceDataResultOfSkzsContractData;
  withData: ServiceDataResultOfSkzsContractData;
  withHideValidation: ServiceDataResultOfSkzsContractData;
  withMessage: ServiceDataResultOfSkzsContractData;
  withValidation: ServiceDataResultOfSkzsContractData;
};


export type ServiceDataResultOfSkzsContractDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfSkzsContractDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfSkzsContractDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfSkzsContractDataWithDataArgs = {
  data?: InputMaybe<SkzsContractDataInput>;
};


export type ServiceDataResultOfSkzsContractDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfSkzsContractDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfSkzsContractDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfString = {
  __typename?: 'ServiceDataResultOfString';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfString;
  withButtonText: ServiceDataResultOfString;
  withCode: ServiceDataResultOfString;
  withData: ServiceDataResultOfString;
  withHideValidation: ServiceDataResultOfString;
  withMessage: ServiceDataResultOfString;
  withValidation: ServiceDataResultOfString;
};


export type ServiceDataResultOfStringWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfStringWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfStringWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfStringWithDataArgs = {
  data?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfStringWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfStringWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfStringWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfUerContractData = {
  __typename?: 'ServiceDataResultOfUerContractData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerContractData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfUerEstimateBaseCostData = {
  __typename?: 'ServiceDataResultOfUerEstimateBaseCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerEstimateBaseCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfUercCalculationData = {
  __typename?: 'ServiceDataResultOfUercCalculationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercCalculationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfUercCalculationDefaultData = {
  __typename?: 'ServiceDataResultOfUercCalculationDefaultData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercCalculationDefaultData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfUercCalculationDefaultData;
  withButtonText: ServiceDataResultOfUercCalculationDefaultData;
  withCode: ServiceDataResultOfUercCalculationDefaultData;
  withData: ServiceDataResultOfUercCalculationDefaultData;
  withHideValidation: ServiceDataResultOfUercCalculationDefaultData;
  withMessage: ServiceDataResultOfUercCalculationDefaultData;
  withValidation: ServiceDataResultOfUercCalculationDefaultData;
};


export type ServiceDataResultOfUercCalculationDefaultDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfUercCalculationDefaultDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationDefaultDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationDefaultDataWithDataArgs = {
  data?: InputMaybe<UercCalculationDefaultDataInput>;
};


export type ServiceDataResultOfUercCalculationDefaultDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfUercCalculationDefaultDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationDefaultDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfUercCalculationLimitedCostPercentage = {
  __typename?: 'ServiceDataResultOfUercCalculationLimitedCostPercentage';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercCalculationLimitedCostPercentage>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  withButtonText: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  withCode: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  withData: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  withHideValidation: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  withMessage: ServiceDataResultOfUercCalculationLimitedCostPercentage;
  withValidation: ServiceDataResultOfUercCalculationLimitedCostPercentage;
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithDataArgs = {
  data?: InputMaybe<UercCalculationLimitedCostPercentageInput>;
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostPercentageWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfUercCalculationLimitedCostUpdateData = {
  __typename?: 'ServiceDataResultOfUercCalculationLimitedCostUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercCalculationLimitedCostUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  withButtonText: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  withCode: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  withData: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  withHideValidation: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  withMessage: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
  withValidation: ServiceDataResultOfUercCalculationLimitedCostUpdateData;
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithDataArgs = {
  data?: InputMaybe<UercCalculationLimitedCostUpdateDataInput>;
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationLimitedCostUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfUercCalculationOtherCostUpdateData = {
  __typename?: 'ServiceDataResultOfUercCalculationOtherCostUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercCalculationOtherCostUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  withButtonText: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  withCode: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  withData: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  withHideValidation: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  withMessage: ServiceDataResultOfUercCalculationOtherCostUpdateData;
  withValidation: ServiceDataResultOfUercCalculationOtherCostUpdateData;
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithDataArgs = {
  data?: InputMaybe<UercCalculationOtherCostUpdateDataInput>;
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUercCalculationOtherCostUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse = {
  __typename?: 'ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UpdateCollectionMtrUnitCurrentPriceResponse>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  withButtonText: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  withCode: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  withData: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  withHideValidation: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  withMessage: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
  withValidation: ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse;
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithDataArgs = {
  data?: InputMaybe<UpdateCollectionMtrUnitCurrentPriceResponseInput>;
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponseWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfUpdateResponseCollectionMtrData = {
  __typename?: 'ServiceDataResultOfUpdateResponseCollectionMtrData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UpdateResponseCollectionMtrData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfUpdateResponseCollectionMtrData;
  withButtonText: ServiceDataResultOfUpdateResponseCollectionMtrData;
  withCode: ServiceDataResultOfUpdateResponseCollectionMtrData;
  withData: ServiceDataResultOfUpdateResponseCollectionMtrData;
  withHideValidation: ServiceDataResultOfUpdateResponseCollectionMtrData;
  withMessage: ServiceDataResultOfUpdateResponseCollectionMtrData;
  withValidation: ServiceDataResultOfUpdateResponseCollectionMtrData;
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithDataArgs = {
  data?: InputMaybe<UpdateResponseCollectionMtrDataInput>;
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfUpdateResponseCollectionMtrDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeData = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderChangeData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfWorkOrderChangeDraftInfo = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeDraftInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderChangeDraftInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeDraftInfo;
  withButtonText: ServiceDataResultOfWorkOrderChangeDraftInfo;
  withCode: ServiceDataResultOfWorkOrderChangeDraftInfo;
  withData: ServiceDataResultOfWorkOrderChangeDraftInfo;
  withHideValidation: ServiceDataResultOfWorkOrderChangeDraftInfo;
  withMessage: ServiceDataResultOfWorkOrderChangeDraftInfo;
  withValidation: ServiceDataResultOfWorkOrderChangeDraftInfo;
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithDataArgs = {
  data?: InputMaybe<WorkOrderChangeDraftInfoInput>;
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeDraftInfoWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeModifyItemIds = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeModifyItemIds';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderChangeModifyItemIds>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  withButtonText: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  withCode: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  withData: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  withHideValidation: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  withMessage: ServiceDataResultOfWorkOrderChangeModifyItemIds;
  withValidation: ServiceDataResultOfWorkOrderChangeModifyItemIds;
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithDataArgs = {
  data?: InputMaybe<WorkOrderChangeModifyItemIdsInput>;
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeModifyItemIdsWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeObjectData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeObjectData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderChangeObjectData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeObjectData__;
  withButtonText: ServiceDataResultOfWorkOrderChangeObjectData__;
  withCode: ServiceDataResultOfWorkOrderChangeObjectData__;
  withData: ServiceDataResultOfWorkOrderChangeObjectData__;
  withHideValidation: ServiceDataResultOfWorkOrderChangeObjectData__;
  withMessage: ServiceDataResultOfWorkOrderChangeObjectData__;
  withValidation: ServiceDataResultOfWorkOrderChangeObjectData__;
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderChangeObjectDataInput>>>;
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeObjectData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeOtherDistributionData = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeOtherDistributionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderChangeOtherDistributionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  withButtonText: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  withCode: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  withData: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  withHideValidation: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  withMessage: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
  withValidation: ServiceDataResultOfWorkOrderChangeOtherDistributionData;
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithDataArgs = {
  data?: InputMaybe<WorkOrderChangeOtherDistributionDataInput>;
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherDistributionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeOtherPriceCostData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderChangeOtherPriceCostData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  withButtonText: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  withCode: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  withData: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  withHideValidation: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  withMessage: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
  withValidation: ServiceDataResultOfWorkOrderChangeOtherPriceCostData__;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderChangeOtherPriceCostDataInput>>>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceCostData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderChangeOtherPriceRationaleData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  withButtonText: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  withCode: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  withData: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  withHideValidation: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  withMessage: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
  withValidation: ServiceDataResultOfWorkOrderChangeOtherPriceRationaleData;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithDataArgs = {
  data?: InputMaybe<WorkOrderChangeOtherPriceRationaleDataInput>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeOtherPriceRationaleDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangePriceIds__ = {
  __typename?: 'ServiceDataResultOfWorkOrderChangePriceIds__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderChangePriceIds>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangePriceIds__;
  withButtonText: ServiceDataResultOfWorkOrderChangePriceIds__;
  withCode: ServiceDataResultOfWorkOrderChangePriceIds__;
  withData: ServiceDataResultOfWorkOrderChangePriceIds__;
  withHideValidation: ServiceDataResultOfWorkOrderChangePriceIds__;
  withMessage: ServiceDataResultOfWorkOrderChangePriceIds__;
  withValidation: ServiceDataResultOfWorkOrderChangePriceIds__;
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderChangePriceIdsInput>>>;
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangePriceIds__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangePriceRationaleData = {
  __typename?: 'ServiceDataResultOfWorkOrderChangePriceRationaleData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderChangePriceRationaleData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  withButtonText: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  withCode: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  withData: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  withHideValidation: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  withMessage: ServiceDataResultOfWorkOrderChangePriceRationaleData;
  withValidation: ServiceDataResultOfWorkOrderChangePriceRationaleData;
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithDataArgs = {
  data?: InputMaybe<WorkOrderChangePriceRationaleDataInput>;
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangePriceRationaleDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeStatusData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeStatusData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderChangeStatusData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeStatusData__;
  withButtonText: ServiceDataResultOfWorkOrderChangeStatusData__;
  withCode: ServiceDataResultOfWorkOrderChangeStatusData__;
  withData: ServiceDataResultOfWorkOrderChangeStatusData__;
  withHideValidation: ServiceDataResultOfWorkOrderChangeStatusData__;
  withMessage: ServiceDataResultOfWorkOrderChangeStatusData__;
  withValidation: ServiceDataResultOfWorkOrderChangeStatusData__;
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderChangeStatusDataInput>>>;
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeStatusData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderChangeTotalData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderChangeTotalData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderChangeTotalData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderChangeTotalData__;
  withButtonText: ServiceDataResultOfWorkOrderChangeTotalData__;
  withCode: ServiceDataResultOfWorkOrderChangeTotalData__;
  withData: ServiceDataResultOfWorkOrderChangeTotalData__;
  withHideValidation: ServiceDataResultOfWorkOrderChangeTotalData__;
  withMessage: ServiceDataResultOfWorkOrderChangeTotalData__;
  withValidation: ServiceDataResultOfWorkOrderChangeTotalData__;
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderChangeTotalDataInput>>>;
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderChangeTotalData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderData = {
  __typename?: 'ServiceDataResultOfWorkOrderData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceDataResultOfWorkOrderDraftInfo = {
  __typename?: 'ServiceDataResultOfWorkOrderDraftInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderDraftInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderDraftInfo;
  withButtonText: ServiceDataResultOfWorkOrderDraftInfo;
  withCode: ServiceDataResultOfWorkOrderDraftInfo;
  withData: ServiceDataResultOfWorkOrderDraftInfo;
  withHideValidation: ServiceDataResultOfWorkOrderDraftInfo;
  withMessage: ServiceDataResultOfWorkOrderDraftInfo;
  withValidation: ServiceDataResultOfWorkOrderDraftInfo;
};


export type ServiceDataResultOfWorkOrderDraftInfoWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderDraftInfoWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderDraftInfoWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderDraftInfoWithDataArgs = {
  data?: InputMaybe<WorkOrderDraftInfoInput>;
};


export type ServiceDataResultOfWorkOrderDraftInfoWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderDraftInfoWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderDraftInfoWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderModifyItemIds = {
  __typename?: 'ServiceDataResultOfWorkOrderModifyItemIds';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderModifyItemIds>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderModifyItemIds;
  withButtonText: ServiceDataResultOfWorkOrderModifyItemIds;
  withCode: ServiceDataResultOfWorkOrderModifyItemIds;
  withData: ServiceDataResultOfWorkOrderModifyItemIds;
  withHideValidation: ServiceDataResultOfWorkOrderModifyItemIds;
  withMessage: ServiceDataResultOfWorkOrderModifyItemIds;
  withValidation: ServiceDataResultOfWorkOrderModifyItemIds;
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithDataArgs = {
  data?: InputMaybe<WorkOrderModifyItemIdsInput>;
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderModifyItemIdsWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderObjectData = {
  __typename?: 'ServiceDataResultOfWorkOrderObjectData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderObjectData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderObjectData;
  withButtonText: ServiceDataResultOfWorkOrderObjectData;
  withCode: ServiceDataResultOfWorkOrderObjectData;
  withData: ServiceDataResultOfWorkOrderObjectData;
  withHideValidation: ServiceDataResultOfWorkOrderObjectData;
  withMessage: ServiceDataResultOfWorkOrderObjectData;
  withValidation: ServiceDataResultOfWorkOrderObjectData;
};


export type ServiceDataResultOfWorkOrderObjectDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderObjectDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderObjectDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderObjectDataWithDataArgs = {
  data?: InputMaybe<WorkOrderObjectDataInput>;
};


export type ServiceDataResultOfWorkOrderObjectDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderObjectDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderObjectDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderObjectToAddEntry__ = {
  __typename?: 'ServiceDataResultOfWorkOrderObjectToAddEntry__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderObjectToAddEntry>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  withButtonText: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  withCode: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  withData: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  withHideValidation: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  withMessage: ServiceDataResultOfWorkOrderObjectToAddEntry__;
  withValidation: ServiceDataResultOfWorkOrderObjectToAddEntry__;
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderObjectToAddEntryInput>>>;
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderObjectToAddEntry__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderOtherDistributionData = {
  __typename?: 'ServiceDataResultOfWorkOrderOtherDistributionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderOtherDistributionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderOtherDistributionData;
  withButtonText: ServiceDataResultOfWorkOrderOtherDistributionData;
  withCode: ServiceDataResultOfWorkOrderOtherDistributionData;
  withData: ServiceDataResultOfWorkOrderOtherDistributionData;
  withHideValidation: ServiceDataResultOfWorkOrderOtherDistributionData;
  withMessage: ServiceDataResultOfWorkOrderOtherDistributionData;
  withValidation: ServiceDataResultOfWorkOrderOtherDistributionData;
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithDataArgs = {
  data?: InputMaybe<WorkOrderOtherDistributionDataInput>;
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherDistributionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderOtherPriceCostData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderOtherPriceCostData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderOtherPriceCostData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  withButtonText: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  withCode: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  withData: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  withHideValidation: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  withMessage: ServiceDataResultOfWorkOrderOtherPriceCostData__;
  withValidation: ServiceDataResultOfWorkOrderOtherPriceCostData__;
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderOtherPriceCostDataInput>>>;
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceCostData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderOtherPriceData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderOtherPriceData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderOtherPriceData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderOtherPriceData__;
  withButtonText: ServiceDataResultOfWorkOrderOtherPriceData__;
  withCode: ServiceDataResultOfWorkOrderOtherPriceData__;
  withData: ServiceDataResultOfWorkOrderOtherPriceData__;
  withHideValidation: ServiceDataResultOfWorkOrderOtherPriceData__;
  withMessage: ServiceDataResultOfWorkOrderOtherPriceData__;
  withValidation: ServiceDataResultOfWorkOrderOtherPriceData__;
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderOtherPriceDataInput>>>;
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderOtherPriceRationaleData = {
  __typename?: 'ServiceDataResultOfWorkOrderOtherPriceRationaleData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderOtherPriceRationaleData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  withButtonText: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  withCode: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  withData: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  withHideValidation: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  withMessage: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
  withValidation: ServiceDataResultOfWorkOrderOtherPriceRationaleData;
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithDataArgs = {
  data?: InputMaybe<WorkOrderOtherPriceRationaleDataInput>;
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderOtherPriceRationaleDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderPriceRationaleData = {
  __typename?: 'ServiceDataResultOfWorkOrderPriceRationaleData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderPriceRationaleData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderPriceRationaleData;
  withButtonText: ServiceDataResultOfWorkOrderPriceRationaleData;
  withCode: ServiceDataResultOfWorkOrderPriceRationaleData;
  withData: ServiceDataResultOfWorkOrderPriceRationaleData;
  withHideValidation: ServiceDataResultOfWorkOrderPriceRationaleData;
  withMessage: ServiceDataResultOfWorkOrderPriceRationaleData;
  withValidation: ServiceDataResultOfWorkOrderPriceRationaleData;
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithDataArgs = {
  data?: InputMaybe<WorkOrderPriceRationaleDataInput>;
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderPriceRationaleDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderSKzSInfo = {
  __typename?: 'ServiceDataResultOfWorkOrderSKzSInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderSKzSInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderSKzSInfo;
  withButtonText: ServiceDataResultOfWorkOrderSKzSInfo;
  withCode: ServiceDataResultOfWorkOrderSKzSInfo;
  withData: ServiceDataResultOfWorkOrderSKzSInfo;
  withHideValidation: ServiceDataResultOfWorkOrderSKzSInfo;
  withMessage: ServiceDataResultOfWorkOrderSKzSInfo;
  withValidation: ServiceDataResultOfWorkOrderSKzSInfo;
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithDataArgs = {
  data?: InputMaybe<WorkOrderSKzSInfoInput>;
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderSKzSInfoWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderSeasonsUpdateData = {
  __typename?: 'ServiceDataResultOfWorkOrderSeasonsUpdateData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderSeasonsUpdateData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  withButtonText: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  withCode: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  withData: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  withHideValidation: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  withMessage: ServiceDataResultOfWorkOrderSeasonsUpdateData;
  withValidation: ServiceDataResultOfWorkOrderSeasonsUpdateData;
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithDataArgs = {
  data?: InputMaybe<WorkOrderSeasonsUpdateDataInput>;
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderSeasonsUpdateDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderTotalData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderTotalData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderTotalData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderTotalData__;
  withButtonText: ServiceDataResultOfWorkOrderTotalData__;
  withCode: ServiceDataResultOfWorkOrderTotalData__;
  withData: ServiceDataResultOfWorkOrderTotalData__;
  withHideValidation: ServiceDataResultOfWorkOrderTotalData__;
  withMessage: ServiceDataResultOfWorkOrderTotalData__;
  withValidation: ServiceDataResultOfWorkOrderTotalData__;
};


export type ServiceDataResultOfWorkOrderTotalData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderTotalData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderTotalData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderTotalData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderTotalDataInput>>>;
};


export type ServiceDataResultOfWorkOrderTotalData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderTotalData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderTotalData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderVersionData = {
  __typename?: 'ServiceDataResultOfWorkOrderVersionData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkOrderVersionData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderVersionData;
  withButtonText: ServiceDataResultOfWorkOrderVersionData;
  withCode: ServiceDataResultOfWorkOrderVersionData;
  withData: ServiceDataResultOfWorkOrderVersionData;
  withHideValidation: ServiceDataResultOfWorkOrderVersionData;
  withMessage: ServiceDataResultOfWorkOrderVersionData;
  withValidation: ServiceDataResultOfWorkOrderVersionData;
};


export type ServiceDataResultOfWorkOrderVersionDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderVersionDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderVersionDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderVersionDataWithDataArgs = {
  data?: InputMaybe<WorkOrderVersionDataInput>;
};


export type ServiceDataResultOfWorkOrderVersionDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderVersionDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderVersionDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkOrderVersionTotalData__ = {
  __typename?: 'ServiceDataResultOfWorkOrderVersionTotalData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkOrderVersionTotalData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkOrderVersionTotalData__;
  withButtonText: ServiceDataResultOfWorkOrderVersionTotalData__;
  withCode: ServiceDataResultOfWorkOrderVersionTotalData__;
  withData: ServiceDataResultOfWorkOrderVersionTotalData__;
  withHideValidation: ServiceDataResultOfWorkOrderVersionTotalData__;
  withMessage: ServiceDataResultOfWorkOrderVersionTotalData__;
  withValidation: ServiceDataResultOfWorkOrderVersionTotalData__;
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkOrderVersionTotalDataInput>>>;
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkOrderVersionTotalData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkVolumeImportResult = {
  __typename?: 'ServiceDataResultOfWorkVolumeImportResult';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<WorkVolumeImportResult>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkVolumeImportResult;
  withButtonText: ServiceDataResultOfWorkVolumeImportResult;
  withCode: ServiceDataResultOfWorkVolumeImportResult;
  withData: ServiceDataResultOfWorkVolumeImportResult;
  withHideValidation: ServiceDataResultOfWorkVolumeImportResult;
  withMessage: ServiceDataResultOfWorkVolumeImportResult;
  withValidation: ServiceDataResultOfWorkVolumeImportResult;
};


export type ServiceDataResultOfWorkVolumeImportResultWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkVolumeImportResultWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkVolumeImportResultWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkVolumeImportResultWithDataArgs = {
  data?: InputMaybe<WorkVolumeImportResultInput>;
};


export type ServiceDataResultOfWorkVolumeImportResultWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkVolumeImportResultWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkVolumeImportResultWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceDataResultOfWorkVolumeValueData__ = {
  __typename?: 'ServiceDataResultOfWorkVolumeValueData__';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<WorkVolumeValueData>>>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: ServiceDataResultOfWorkVolumeValueData__;
  withButtonText: ServiceDataResultOfWorkVolumeValueData__;
  withCode: ServiceDataResultOfWorkVolumeValueData__;
  withData: ServiceDataResultOfWorkVolumeValueData__;
  withHideValidation: ServiceDataResultOfWorkVolumeValueData__;
  withMessage: ServiceDataResultOfWorkVolumeValueData__;
  withValidation: ServiceDataResultOfWorkVolumeValueData__;
};


export type ServiceDataResultOfWorkVolumeValueData__WithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type ServiceDataResultOfWorkVolumeValueData__WithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkVolumeValueData__WithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkVolumeValueData__WithDataArgs = {
  data?: InputMaybe<Array<InputMaybe<WorkVolumeValueDataInput>>>;
};


export type ServiceDataResultOfWorkVolumeValueData__WithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceDataResultOfWorkVolumeValueData__WithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type ServiceDataResultOfWorkVolumeValueData__WithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceIdResultOfBoolean = {
  __typename?: 'ServiceIdResultOfBoolean';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withButtonText: ServiceIdResultOfBoolean;
  withCode: ServiceIdResultOfBoolean;
  withHideValidation: ServiceIdResultOfBoolean;
  withId: ServiceIdResultOfBoolean;
  withMessage: ServiceIdResultOfBoolean;
  withValidation: ServiceIdResultOfBoolean;
};


export type ServiceIdResultOfBooleanWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type ServiceIdResultOfBooleanWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type ServiceIdResultOfBooleanWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceIdResultOfBooleanWithIdArgs = {
  id?: InputMaybe<Scalars['Boolean']>;
};


export type ServiceIdResultOfBooleanWithMessageArgs = {
  message: Scalars['String'];
};


export type ServiceIdResultOfBooleanWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type ServiceIdResultOfInt32 = {
  __typename?: 'ServiceIdResultOfInt32';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type ServiceIdResultOfInt64 = {
  __typename?: 'ServiceIdResultOfInt64';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Long']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

/** Определение обобщенного результата выполнения метода сервиса */
export type ServiceResult = {
  __typename?: 'ServiceResult';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

/** Данные для заполненения данных об объёме или формулы */
export type SetWorkVolumeValueInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Формула для рпасчёта объёма */
  formula?: InputMaybe<Scalars['String']>;
  /** Значение объёма */
  value?: InputMaybe<Scalars['Decimal']>;
  /** Комплексный идентификатор, позволяющий однозначно идентифицировать ячейку с данными об объёмах ВОР */
  worItemValueComplexIdentifier?: InputMaybe<WorkVolumeItemValueComplexIdentifierInput>;
  /** Идентификатор записи об объёмах ВОР */
  worItemValueId?: InputMaybe<Scalars['Long']>;
};

export type ShortOperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']>;
  gt?: InputMaybe<Scalars['Short']>;
  gte?: InputMaybe<Scalars['Short']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']>>>;
  lt?: InputMaybe<Scalars['Short']>;
  lte?: InputMaybe<Scalars['Short']>;
  neq?: InputMaybe<Scalars['Short']>;
  ngt?: InputMaybe<Scalars['Short']>;
  ngte?: InputMaybe<Scalars['Short']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']>>>;
  nlt?: InputMaybe<Scalars['Short']>;
  nlte?: InputMaybe<Scalars['Short']>;
};

export type SkzsActKc2Data = {
  __typename?: 'SkzsActKC2Data';
  /** Идентификатор Акта КС-2 */
  actKC2UniqueId: Scalars['String'];
  /** Идентификатор договора */
  contractUniqueId: Scalars['String'];
  /** Дата окончания отчетного периода */
  reportingFinishDate: Scalars['Date'];
  /** Дата начала отчетного периода */
  reportingStartDate: Scalars['Date'];
  /** Идентификатор объекта */
  rootObjectUniqueId: Scalars['String'];
  /** Статус СКзС */
  status: SkzsActKc2StatusEnum;
  /** Идентификатор НЗ */
  workOrderUniqueId: Scalars['String'];
};

export type SkzsActKc2DataInput = {
  /** Идентификатор Акта КС-2 */
  actKC2UniqueId: Scalars['String'];
  /** Идентификатор договора */
  contractUniqueId: Scalars['String'];
  /** Дата окончания отчетного периода */
  reportingFinishDate: Scalars['Date'];
  /** Дата начала отчетного периода */
  reportingStartDate: Scalars['Date'];
  /** Идентификатор объекта */
  rootObjectUniqueId: Scalars['String'];
  /** Статус СКзС */
  status: SkzsActKc2StatusEnum;
  /** Идентификатор НЗ */
  workOrderUniqueId: Scalars['String'];
};

export enum SkzsActKc2StatusEnum {
  /** Скорректированный */
  Corrected = 'CORRECTED',
  /** Новый */
  New = 'NEW',
  /** Обновленный */
  Updated = 'UPDATED'
}

/** Данные договора для СКзС */
export type SkzsContractData = {
  __typename?: 'SkzsContractData';
  /** Название подрядчика */
  contractorName: Scalars['String'];
  /** Внутренний номер договора */
  internalNumber: Scalars['String'];
  /** Название дочернего общества */
  subsidiaryName: Scalars['String'];
  /** Уникальный идентификатор договора */
  uniqueId: Scalars['String'];
};

/** Данные договора для СКзС */
export type SkzsContractDataFilterInput = {
  and?: InputMaybe<Array<SkzsContractDataFilterInput>>;
  /** Название подрядчика */
  contractorName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Внутренний номер договора */
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<SkzsContractDataFilterInput>>;
  /** Название дочернего общества */
  subsidiaryName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор договора */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные договора для СКзС */
export type SkzsContractDataInput = {
  /** Название подрядчика */
  contractorName: Scalars['String'];
  /** Внутренний номер договора */
  internalNumber: Scalars['String'];
  /** Название дочернего общества */
  subsidiaryName: Scalars['String'];
  /** Уникальный идентификатор договора */
  uniqueId: Scalars['String'];
};

/** Данные договора для СКзС */
export type SkzsContractDataSortInput = {
  /** Название подрядчика */
  contractorName?: InputMaybe<SortEnumType>;
  /** Внутренний номер договора */
  internalNumber?: InputMaybe<SortEnumType>;
  /** Название дочернего общества */
  subsidiaryName?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор договора */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Данные для создания Акта КС2 из СКзС */
export type SkzsKc6aCreateInput = {
  /** Идентификатор объекта/подобъекта строительства НЗ */
  objectUniqueId: Scalars['String'];
  /** Дата окончания отчетного периода */
  reportingFinishDate: Scalars['Date'];
  /** Дата начала отчетного периода */
  reportingStartDate: Scalars['Date'];
  /** Код расценки УЕР */
  uerCode?: InputMaybe<Scalars['String']>;
  /** Единица измерения расценки УЕР */
  uerUnit?: InputMaybe<Scalars['String']>;
  /** Объем */
  volume: Scalars['Decimal'];
  /** Идентификатор расценки наряд-заказа */
  workOrderPriceUniqueId?: InputMaybe<Scalars['String']>;
  /** Идентификатор НЗ */
  workOrderUniqueId: Scalars['String'];
};

/** Данные для обновления Акта КС2 из СКзС */
export type SkzsKc6aUpdateInput = {
  /** Идентификатор Акта КС-2 */
  actKC2UniqueId: Scalars['String'];
  /** Идентификатор объекта/подобъекта строительства НЗ */
  objectUniqueId?: InputMaybe<Scalars['String']>;
  /** Код расценки УЕР */
  uerCode?: InputMaybe<Scalars['String']>;
  /** Единица измерения расценки УЕР */
  uerUnit?: InputMaybe<Scalars['String']>;
  /** Объем */
  volume: Scalars['Decimal'];
  /** Идентификатор расценки наряд-заказа */
  workOrderPriceUniqueId?: InputMaybe<Scalars['String']>;
};

export type SkzsPriceWorkKindData = {
  __typename?: 'SkzsPriceWorkKindData';
  /** Объём рассчитанный по виду работ */
  workPlan: Scalars['Decimal'];
  /** Идентификатор вида работ в справочнике Видов Работ */
  workUniqueId: Scalars['String'];
};

export type SkzsPriceWorkKindDataFilterInput = {
  and?: InputMaybe<Array<SkzsPriceWorkKindDataFilterInput>>;
  or?: InputMaybe<Array<SkzsPriceWorkKindDataFilterInput>>;
  /** Объём рассчитанный по виду работ */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type SkzsPriceWorkKindDataSortInput = {
  /** Объём рассчитанный по виду работ */
  workPlan?: InputMaybe<SortEnumType>;
  /** Идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<SortEnumType>;
};

export type SkzsRatioData = {
  __typename?: 'SkzsRatioData';
  /** Код шифра */
  code: Scalars['String'];
  /** Условия производства работ */
  workConditions: Scalars['String'];
};

export type SkzsRatioDataFilterInput = {
  and?: InputMaybe<Array<SkzsRatioDataFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<SkzsRatioDataFilterInput>>;
  /** Условия производства работ */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные расценки УЕР для СКзС */
export type SkzsUerData = {
  __typename?: 'SkzsUerData';
  /** Уникальный шифр расценки */
  code: Scalars['String'];
  /** Наименование расценки, которое включает название группы */
  fullName: Scalars['String'];
  /** Наименование расценки */
  name: Scalars['String'];
  /** Статус расценки */
  status: UerRecordStatusEnum;
  /** Единица измерения расценки */
  unit: Scalars['String'];
  /** Вид работ */
  workKind: SkzsUerWorkKindData;
  /** Коэффициент перехода */
  workRatio: Scalars['Decimal'];
  /** Состав работ расценки */
  workScopes: Array<SkzsWorkScope>;
};

/** Данные расценки УЕР для СКзС */
export type SkzsUerDataFilterInput = {
  and?: InputMaybe<Array<SkzsUerDataFilterInput>>;
  /** Уникальный шифр расценки */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование расценки, которое включает название группы */
  fullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование расценки */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<SkzsUerDataFilterInput>>;
  /** Статус расценки */
  status?: InputMaybe<UerRecordStatusEnumOperationFilterInput>;
  /** Единица измерения расценки */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид работ */
  workKind?: InputMaybe<SkzsUerWorkKindDataFilterInput>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Состав работ расценки */
  workScopes?: InputMaybe<ListFilterInputTypeOfSkzsWorkScopeFilterInput>;
};

/** Данные расценки УЕР для СКзС */
export type SkzsUerDataSortInput = {
  /** Уникальный шифр расценки */
  code?: InputMaybe<SortEnumType>;
  /** Наименование расценки, которое включает название группы */
  fullName?: InputMaybe<SortEnumType>;
  /** Наименование расценки */
  name?: InputMaybe<SortEnumType>;
  /** Статус расценки */
  status?: InputMaybe<SortEnumType>;
  /** Единица измерения расценки */
  unit?: InputMaybe<SortEnumType>;
  /** Вид работ */
  workKind?: InputMaybe<SkzsUerWorkKindDataSortInput>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<SortEnumType>;
};

/** Виды работы в расценке УЕР для СКзС */
export type SkzsUerWorkKindData = {
  __typename?: 'SkzsUerWorkKindData';
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** Идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: Maybe<Scalars['String']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

/** Виды работы в расценке УЕР для СКзС */
export type SkzsUerWorkKindDataFilterInput = {
  and?: InputMaybe<Array<SkzsUerWorkKindDataFilterInput>>;
  or?: InputMaybe<Array<SkzsUerWorkKindDataFilterInput>>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Виды работы в расценке УЕР для СКзС */
export type SkzsUerWorkKindDataSortInput = {
  /** Шифр */
  workCode?: InputMaybe<SortEnumType>;
  /** Наименование */
  workName?: InputMaybe<SortEnumType>;
  /** Идентификатор вида работ в справочнике Видов Работ */
  workUniqueId?: InputMaybe<SortEnumType>;
  /** Ед.изм. */
  workUnit?: InputMaybe<SortEnumType>;
};

export type SkzsWorkOrderData = {
  __typename?: 'SkzsWorkOrderData';
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Сезоны из Наряд-заказа */
  seasons: Array<Scalars['Short']>;
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Предмет */
  subject?: Maybe<Scalars['String']>;
  /** Идентификатор НЗ */
  uniqueId: Scalars['String'];
};

export type SkzsWorkOrderDataFilterInput = {
  and?: InputMaybe<Array<SkzsWorkOrderDataFilterInput>>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<SkzsWorkOrderDataFilterInput>>;
  /** Сезоны из Наряд-заказа */
  seasons?: InputMaybe<ListShortOperationFilterInput>;
  /** Дата подписания */
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Предмет */
  subject?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор НЗ */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type SkzsWorkOrderDataSortInput = {
  /** Внутренний номер */
  internalNumber?: InputMaybe<SortEnumType>;
  /** Дата подписания */
  signingDate?: InputMaybe<SortEnumType>;
  /** Предмет */
  subject?: InputMaybe<SortEnumType>;
  /** Идентификатор НЗ */
  uniqueId?: InputMaybe<SortEnumType>;
};

/** Объект/подобъект строительства наряд-заказа */
export type SkzsWorkOrderObjectData = {
  __typename?: 'SkzsWorkOrderObjectData';
  /** Наименование вида строительства */
  constructionTypeName: Scalars['String'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentUniqueId?: Maybe<Scalars['String']>;
  /** Идентификатор */
  uniqueId: Scalars['String'];
};

/** Объект/подобъект строительства наряд-заказа */
export type SkzsWorkOrderObjectDataFilterInput = {
  and?: InputMaybe<Array<SkzsWorkOrderObjectDataFilterInput>>;
  /** Наименование вида строительства */
  constructionTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<SkzsWorkOrderObjectDataFilterInput>>;
  /** Идентификатор родительского объекта/подобъекта */
  parentUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Объект/подобъект строительства наряд-заказа */
export type SkzsWorkOrderObjectDataSortInput = {
  /** Наименование вида строительства */
  constructionTypeName?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentUniqueId?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
};

export type SkzsWorkOrderPriceData = {
  __typename?: 'SkzsWorkOrderPriceData';
  /** Наименование вида строительства */
  constructionTypeName: Scalars['String'];
  /** Идентификатор объекта/подобъекта наряд-заказа */
  objectUniqueId: Scalars['String'];
  /** Коэффициенты расценки */
  ratios: Array<SkzsRatioData>;
  /** Плановый объем всего по расценке */
  totalPlanVolume: Scalars['Decimal'];
  /** Код расценки */
  uerCode: Scalars['String'];
  /** Единица измерения расценки */
  uerUnit: Scalars['String'];
  /** Идентификатор */
  uniqueId: Scalars['String'];
  /** Данные по виду работы */
  workKind: SkzsPriceWorkKindData;
  /** Коэффициент перехода */
  workRatio: Scalars['Decimal'];
};

export type SkzsWorkOrderPriceDataFilterInput = {
  and?: InputMaybe<Array<SkzsWorkOrderPriceDataFilterInput>>;
  /** Наименование вида строительства */
  constructionTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор объекта/подобъекта наряд-заказа */
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<SkzsWorkOrderPriceDataFilterInput>>;
  /** Коэффициенты расценки */
  ratios?: InputMaybe<ListFilterInputTypeOfSkzsRatioDataFilterInput>;
  /** Плановый объем всего по расценке */
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Код расценки */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Единица измерения расценки */
  uerUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Данные по виду работы */
  workKind?: InputMaybe<SkzsPriceWorkKindDataFilterInput>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
};

export type SkzsWorkOrderPriceDataSortInput = {
  /** Наименование вида строительства */
  constructionTypeName?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта/подобъекта наряд-заказа */
  objectUniqueId?: InputMaybe<SortEnumType>;
  /** Плановый объем всего по расценке */
  totalPlanVolume?: InputMaybe<SortEnumType>;
  /** Код расценки */
  uerCode?: InputMaybe<SortEnumType>;
  /** Единица измерения расценки */
  uerUnit?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  uniqueId?: InputMaybe<SortEnumType>;
  /** Данные по виду работы */
  workKind?: InputMaybe<SkzsPriceWorkKindDataSortInput>;
  /** Коэффициент перехода */
  workRatio?: InputMaybe<SortEnumType>;
};

/** Cостав работ */
export type SkzsWorkScope = {
  __typename?: 'SkzsWorkScope';
  /** Описание */
  description: Scalars['String'];
  /** Порядковый номер */
  number: Scalars['Int'];
};

/** Cостав работ */
export type SkzsWorkScopeFilterInput = {
  and?: InputMaybe<Array<SkzsWorkScopeFilterInput>>;
  /** Описание */
  description?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Порядковый номер */
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SkzsWorkScopeFilterInput>>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInputTypeExFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInputTypeExFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  endsWithi?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  ncontainsi?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  nendsWithi?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  neqi?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  nstartsWithi?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInputTypeExFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
  startsWithi?: InputMaybe<Scalars['String']>;
};

export type TransferWorkVolumeInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Список объектов с процентами переноса */
  objectTransfers: Array<ObjectTransferItemInput>;
  /** Идентификатор сезона-источника */
  sourceSeasonId: Scalars['Long'];
  /** Идентификатор целевого сезона */
  targetSeasonId: Scalars['Long'];
};

/** Общие данные Расчета НМЦ */
export type Uerc_CalculationCommonData = {
  __typename?: 'UERC_CalculationCommonData';
  /** Навигация Расчета */
  calculationNavigation: UercCalculationNavigationData;
  /** Данные стоимости Расчета */
  calculationPrice?: Maybe<CalculationPriceData>;
};

/** Общие данные Договора */
export type Uerc_ContractCommonData = {
  __typename?: 'UERC_ContractCommonData';
  /** Навигация Договора */
  contractNavigation: UercContractNavigationData;
  /** Данные стоимости Договора */
  contractPrice: ContractPriceData;
};

/** Способ распределения лимитов по сезонам */
export enum Uerc_LimitDistributionMethodEnum {
  /** Автоматически */
  Auto = 'AUTO',
  /** Равномерно по сезонам */
  EvenlyBySeason = 'EVENLY_BY_SEASON',
  /** Первый сезон */
  FirstSeason = 'FIRST_SEASON',
  /** Последний сезон */
  LastSeason = 'LAST_SEASON',
  /** Вручную */
  Manual = 'MANUAL'
}

export type Uerc_ServiceDataResultOfAppHealthCheckData = {
  __typename?: 'UERC_ServiceDataResultOfAppHealthCheckData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercAppHealthCheckData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uerc_ServiceDataResultOfAppModuleInfo = {
  __typename?: 'UERC_ServiceDataResultOfAppModuleInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercAppModuleInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uerc_ServiceDataResultOfAppModuleReport = {
  __typename?: 'UERC_ServiceDataResultOfAppModuleReport';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercAppModuleReport>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uerc_ServiceDataResultOfCalculationNavigationData = {
  __typename?: 'UERC_ServiceDataResultOfCalculationNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercCalculationNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uerc_ServiceDataResultOfContractNavigationData = {
  __typename?: 'UERC_ServiceDataResultOfContractNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UercContractNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uerc_ServiceDataResultOfUerEstimateBaseCostData = {
  __typename?: 'UERC_ServiceDataResultOfUerEstimateBaseCostData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerEstimateBaseCostData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
  withActionRequired: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
  withButtonText: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
  withCode: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
  withData: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
  withHideValidation: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
  withMessage: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
  withValidation: Uerc_ServiceDataResultOfUerEstimateBaseCostData;
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithActionRequiredArgs = {
  actionRequired: Scalars['Boolean'];
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithButtonTextArgs = {
  text?: InputMaybe<Scalars['String']>;
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithCodeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithDataArgs = {
  data?: InputMaybe<UerEstimateBaseCostDataInput>;
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithHideValidationArgs = {
  hide?: InputMaybe<Scalars['Boolean']>;
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithMessageArgs = {
  message?: InputMaybe<Scalars['String']>;
};


export type Uerc_ServiceDataResultOfUerEstimateBaseCostDataWithValidationArgs = {
  validation?: InputMaybe<Array<ValidationMessageInput>>;
};

export type Uerc_WorkOrderChangeNavData = {
  __typename?: 'UERC_WorkOrderChangeNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания изма */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус изма */
  status: WorkOrderChangeStatusEnum;
  /** Внутренний номер изма */
  workOrderChangeNumber: Scalars['String'];
  /** Внутренний номер НЗ */
  workOrderNumber: Scalars['String'];
};

/** Данные навигации НЗ */
export type Uerc_WorkOrderNavData = {
  __typename?: 'UERC_WorkOrderNavData';
  /** Список актов НЗ */
  actKC2Navs?: Maybe<Array<ActKc2NavData>>;
  /** Список справок НЗ */
  actKC3Navs?: Maybe<Array<ActKc3NavData>>;
  /** Узел навигации реестра актов КС-2 */
  actsKC2Node?: Maybe<Uer_ContractItemNavData>;
  /** Узел навигации реестра справок КС-3 */
  actsKC3Node?: Maybe<Uer_ContractItemNavData>;
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Внутренний номкр НЗ */
  internalNumber: Scalars['String'];
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания НЗ */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Ствтус НЗ */
  status: WorkOrderStatusEnum;
  /** Изм примененый к НЗ */
  workOrderChange?: Maybe<Uerc_WorkOrderChangeNavData>;
  /** Список навигации измов НЗ */
  workOrderChanges?: Maybe<Array<Uerc_WorkOrderChangeNavData>>;
};

/** Общие данные Расчета НМЦ */
export type Uer_CalculationCommonData = {
  __typename?: 'UER_CalculationCommonData';
  /** Навигация Расчета */
  calculationNavigation: UerCalculationNavigationData;
  /** Данные стоимости Расчета */
  calculationPrice?: Maybe<CalculationPriceData>;
};

/** Данные элемента навигации расчета */
export type Uer_CalculationItemNavData = {
  __typename?: 'UER_CalculationItemNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Данные навигации расчета */
export type Uer_CalculationNavData = {
  __typename?: 'UER_CalculationNavData';
  /** Флаг наличия расчета */
  hasCalculation: Scalars['Boolean'];
  /** Флаг наличия объектов строительства */
  hasCalculationObjects: Scalars['Boolean'];
  /** Флаг наличия ВОР */
  hasWOR: Scalars['Boolean'];
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Общие данные Договора */
export type Uer_ContractCommonData = {
  __typename?: 'UER_ContractCommonData';
  /** Навигация Договора */
  contractNavigation: UerContractNavigationData;
  /** Данные стоимости Договора */
  contractPrice: ContractPriceData;
};

/** Данные навигации договора */
export type Uer_ContractItemNavData = {
  __typename?: 'UER_ContractItemNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
};

/** Данные навигации договора */
export type Uer_ContractNavData = {
  __typename?: 'UER_ContractNavData';
  /** Имя создателя сущности договора */
  authoredBy?: Maybe<Scalars['String']>;
  /** Время зоздания сущности договора */
  createdAt: Scalars['DateTime'];
  /** Флаг наличия договора */
  hasContract: Scalars['Boolean'];
  /** Флаг наличия НЗ */
  hasWorkOrders: Scalars['Boolean'];
  /** Идентификатор договора */
  id: Scalars['Long'];
  /** Внутренний номер договора */
  internalNumber?: Maybe<Scalars['String']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Статус договора */
  status: ContractStatusEnum;
};

export type Uer_ServiceDataResultOfAppHealthCheckData = {
  __typename?: 'UER_ServiceDataResultOfAppHealthCheckData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerAppHealthCheckData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uer_ServiceDataResultOfAppModuleInfo = {
  __typename?: 'UER_ServiceDataResultOfAppModuleInfo';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerAppModuleInfo>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uer_ServiceDataResultOfAppModuleReport = {
  __typename?: 'UER_ServiceDataResultOfAppModuleReport';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerAppModuleReport>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uer_ServiceDataResultOfCalculationNavigationData = {
  __typename?: 'UER_ServiceDataResultOfCalculationNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerCalculationNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

export type Uer_ServiceDataResultOfContractNavigationData = {
  __typename?: 'UER_ServiceDataResultOfContractNavigationData';
  /** Признак обязательного действия */
  actionRequired?: Maybe<Scalars['Boolean']>;
  /** Текст кнопки подтверждения сообщения о выполнении */
  buttonText?: Maybe<Scalars['String']>;
  /** Код ошибки. Зарезервировано */
  code?: Maybe<Scalars['String']>;
  data?: Maybe<UerContractNavigationData>;
  /** Признак наличия сообщений валидации */
  hasValidation: Scalars['Boolean'];
  /** Признак сокрытия списка сообщений валидации */
  hideValidation?: Maybe<Scalars['Boolean']>;
  /** Общее сообщение о результате выполнения метода */
  message?: Maybe<Scalars['String']>;
  /** Признак успешного выполнения */
  result: Scalars['Boolean'];
  /** Список сообщений валидации */
  validation?: Maybe<Array<ValidationMessage>>;
};

/** A segment of a collection. */
export type UerActKc2GroupConstructionTypeFilterCollectionSegment = {
  __typename?: 'UerActKC2GroupConstructionTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2GroupCostGroupFilterCollectionSegment = {
  __typename?: 'UerActKC2GroupCostGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCostGroupEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2GroupDateFilterCollectionSegment = {
  __typename?: 'UerActKC2GroupDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateOnly>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2GroupNumberFilterCollectionSegment = {
  __typename?: 'UerActKC2GroupNumberFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2GroupObjectFilterCollectionSegment = {
  __typename?: 'UerActKC2GroupObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2LimitedCostItemsCollectionSegment = {
  __typename?: 'UerActKC2LimitedCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2LimitedCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2OtherPriceItemsCollectionSegment = {
  __typename?: 'UerActKC2OtherPriceItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2OtherPriceItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2OtherTotalsCollectionSegment = {
  __typename?: 'UerActKC2OtherTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2TotalItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2SmrPriceItemsCollectionSegment = {
  __typename?: 'UerActKC2SmrPriceItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2SmrPriceItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2SmrTotalsCollectionSegment = {
  __typename?: 'UerActKC2SmrTotalsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2TotalItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc2VolumeVariableSelectionItemsCollectionSegment = {
  __typename?: 'UerActKC2VolumeVariableSelectionItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2VolumeVariableSelectionItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsCollectionSegment = {
  __typename?: 'UerActKC3ActsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2Item>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsConstructionTypeFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsConstructionTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsCostGroupFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsCostGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCostGroupEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ActKc2CostGroupFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ActKC2CostGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCostGroupEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ActKc2DateFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ActKC2DateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateOnly>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ActKc2FinishDateFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ActKC2FinishDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateOnly>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ActKc2NumberFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ActKC2NumberFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueContainerOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ActKc2StartDateFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ActKC2StartDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateOnly>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ConstructionTypeIdFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ConstructionTypeIdFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfInt32>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2ContractObjectNameFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2ContractObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2SelectionListCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2SelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc3ActsKc2SelectionItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsKc2WorkOrderInternalNumberFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsKC2WorkOrderInternalNumberFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActKc3ActsObjectFilterCollectionSegment = {
  __typename?: 'UerActKC3ActsObjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** История изменений УЭР */
export type UerActionLogData = {
  __typename?: 'UerActionLogData';
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Дата изменения сущности */
  date: Scalars['Date'];
  /** Название сущности на русском языке */
  entityDisplayName: Scalars['String'];
  /** Название сущности */
  entityName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор профиля пользователя */
  userLogin: Scalars['String'];
};

/** История изменений УЭР */
export type UerActionLogDataFilterInput = {
  and?: InputMaybe<Array<UerActionLogDataFilterInput>>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Дата изменения сущности */
  date?: InputMaybe<DateOperationFilterInput>;
  /** Название сущности на русском языке */
  entityDisplayName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Название сущности */
  entityName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UerActionLogDataFilterInput>>;
  /** Идентификатор профиля пользователя */
  userLogin?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** История изменений УЭР */
export type UerActionLogDataSortInput = {
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Дата изменения сущности */
  date?: InputMaybe<SortEnumType>;
  /** Название сущности на русском языке */
  entityDisplayName?: InputMaybe<SortEnumType>;
  /** Название сущности */
  entityName?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Идентификатор профиля пользователя */
  userLogin?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type UerActsKc2AnalyticsBySeasonsCollectionSegment = {
  __typename?: 'UerActsKC2AnalyticsBySeasonsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2UerCostPlotData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerActsKc2AnalyticsByUerCollectionSegment = {
  __typename?: 'UerActsKC2AnalyticsByUerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2UerCostChartData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum UerBaseCostChangeType {
  Deleted = 'DELETED',
  New = 'NEW',
  Updated = 'UPDATED'
}

export type UerBaseCostChangeTypeOperationFilterInput = {
  eq?: InputMaybe<UerBaseCostChangeType>;
  in?: InputMaybe<Array<UerBaseCostChangeType>>;
  neq?: InputMaybe<UerBaseCostChangeType>;
  nin?: InputMaybe<Array<UerBaseCostChangeType>>;
};

/** Тип позиции в справочнике расценки сметы основания */
export enum UerBasisPriceTypeEnum {
  Mtr = 'MTR',
  Uer = 'UER'
}

/** Тип ресурса для позиции в справочнике расценки сметы основания */
export enum UerBasisResourceCostTypeEnum {
  /** МТР */
  Mat = 'MAT',
  /** Машины и механизмы */
  Mch = 'MCH',
  /** Трудозатраты машинистов */
  Tm = 'TM',
  /** Трудозатраты рабочих */
  Tz = 'TZ'
}

/** Навигация расчета */
export type UerCalculationNavigationData = {
  __typename?: 'UerCalculationNavigationData';
  /** Данные расчета */
  calculationNavData: Uer_CalculationNavData;
  /** Список элементов навигации расчета */
  calculationNavItems?: Maybe<Array<Uer_CalculationItemNavData>>;
};

/** A segment of a collection. */
export type UerCatalogsCollectionSegment = {
  __typename?: 'UerCatalogsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Код классификатора УЕР */
export enum UerClassifierEnum {
  /** ПНР */
  Commissioning = 'COMMISSIONING',
  /** Строительные */
  Construction = 'CONSTRUCTION',
  /** Демонтаж */
  Disassembly = 'DISASSEMBLY',
  /** Изготовление */
  Manufacture = 'MANUFACTURE',
  /** Монтажные */
  Mounting = 'MOUNTING',
  /** Испытание свай */
  PileTesting = 'PILE_TESTING',
  /** Рекультивация нарушенных земель */
  Reclamation = 'RECLAMATION',
  /** Ремонт и содержание дорог */
  RoadMaintenance = 'ROAD_MAINTENANCE',
  /** Уборка снега */
  SnowRemoval = 'SNOW_REMOVAL',
  /** Транспортировка + ПРР */
  Transportation = 'TRANSPORTATION',
  /** Тип исключение / добавление */
  TypeExclusionOrAdd = 'TYPE_EXCLUSION_OR_ADD',
  /** ВЗиС */
  Vzis = 'VZIS'
}

/** A segment of a collection. */
export type UerContractActionLogEntriesCollectionSegment = {
  __typename?: 'UerContractActionLogEntriesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<UerActionLogData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractActsKc3CollectionSegment = {
  __typename?: 'UerContractActsKC3CollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc3RegistryItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractActsKc3DateFilterCollectionSegment = {
  __typename?: 'UerContractActsKC3DateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateOnly>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractActsKc3FullNumberFilterCollectionSegment = {
  __typename?: 'UerContractActsKC3FullNumberFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeCreatedAtFilterCollectionSegment = {
  __typename?: 'UerContractChangeCreatedAtFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfDateTime>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeInternalNumberFilterCollectionSegment = {
  __typename?: 'UerContractChangeInternalNumberFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrForIncludingCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrForIncludingCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrForIncludingIsIncludedInActFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrForIncludingIsIncludedInActFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrForIncludingIsIncludedInWorkOrderFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrForIncludingIsIncludedInWorkOrderFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrForIncludingNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrForIncludingNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrForIncludingStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrForIncludingStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfMtrRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrForIncludingUnitFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrForIncludingUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrJustificationFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfMtrRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrSupplyByFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrSupplyByFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfContragentTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeMtrUnitFilterCollectionSegment = {
  __typename?: 'UerContractChangeMtrUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeOtherCostRowsCollectionSegment = {
  __typename?: 'UerContractChangeOtherCostRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractOtherCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeOtherCostRowsForIncludingCollectionSegment = {
  __typename?: 'UerContractChangeOtherCostRowsForIncludingCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractOtherCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangePriceListMtrCollectionSegment = {
  __typename?: 'UerContractChangePriceListMtrCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangePriceListRatioCollectionSegment = {
  __typename?: 'UerContractChangePriceListRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangePriceListRatioRowsCollectionSegment = {
  __typename?: 'UerContractChangePriceListRatioRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioCoefficientRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangePriceListUerCollectionSegment = {
  __typename?: 'UerContractChangePriceListUerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioAppliesToCodeNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioAppliesToCodeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioAppliesToLinkStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioAppliesToLinkStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioCodeAndAppliesNamesToFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioCodeAndAppliesNamesToFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioNameFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioCodeAndAppliesToFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioCodeAndAppliesToFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingAppliesToCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingAppliesToCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingAppliesToCodeNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingAppliesToCodeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingAppliesToLinkStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingAppliesToLinkStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingIsIncludedInActFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingIsIncludedInActFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingIsIncludedInWorkOrderFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingIsIncludedInWorkOrderFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingLinkStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingLinkStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioForIncludingWorkConditionsFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioForIncludingWorkConditionsFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioGroupFullNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioIsIncludedInWorkOrderChangeCollectionSegment = {
  __typename?: 'UerContractChangeRatioIsIncludedInWorkOrderChangeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioRowForIncludingIsIncludedInWorkOrderChangeCollectionSegment = {
  __typename?: 'UerContractChangeRatioRowForIncludingIsIncludedInWorkOrderChangeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioSectionNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioWorkConditionsFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioWorkConditionsFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeRatioWorkTypeFilterCollectionSegment = {
  __typename?: 'UerContractChangeRatioWorkTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeSigningDateFilterCollectionSegment = {
  __typename?: 'UerContractChangeSigningDateFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDateTime>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfContractChangeStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeSubjectFilterCollectionSegment = {
  __typename?: 'UerContractChangeSubjectFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerAndWorkScopeForIncludingNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerAndWorkScopeForIncludingNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerAndWorkScopeNameData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerAndWorkScopeNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerAndWorkScopeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerAndWorkScopeNameData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerChapterFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingCodeFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingGroupFullNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingIsIncludedInActFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingIsIncludedInActFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingIsIncludedInWorkOrderFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingIsIncludedInWorkOrderFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfBoolean>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingLinkStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingLinkStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfPriceConstructionTypeRelationStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingSectionNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfUerRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerForIncludingUnitFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerForIncludingUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerGroupFullNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerJustificationFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerSectionNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerStatusFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfUerRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerTypeFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfUerClassifierEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerUnitFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerWorkScopDescriptionFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerWorkScopDescriptionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerWorkTypeInSumFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerWorkTypeInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangeUerWorkTypeNameFilterCollectionSegment = {
  __typename?: 'UerContractChangeUerWorkTypeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractChangesCollectionSegment = {
  __typename?: 'UerContractChangesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractChangeItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UerContractData = {
  __typename?: 'UerContractData';
  account?: Maybe<Scalars['String']>;
  actualCost?: Maybe<Scalars['Decimal']>;
  amountWithTax?: Maybe<Scalars['Decimal']>;
  amountWithoutTax?: Maybe<Scalars['Decimal']>;
  authoredBy: Scalars['String'];
  /** Справочник расценок */
  catalogUerBase: CatalogUerBase;
  codeOKPD?: Maybe<Scalars['String']>;
  codeOKUD?: Maybe<Scalars['String']>;
  constructionTypeAttributes?: Maybe<Array<ConstructionTypeAttributeData>>;
  constructionTypes?: Maybe<Array<ConstructionTypeData>>;
  contractPlans?: Maybe<Array<ContractResultPlanData>>;
  contractor?: Maybe<Scalars['String']>;
  contractorAddress?: Maybe<Scalars['String']>;
  contractorOKPO?: Maybe<Scalars['String']>;
  conversionIndices?: Maybe<Array<ContractConversionIndexData>>;
  /** Cтоимость договора */
  cost: ContractCostData;
  /** Округление стоимости (разрядность) */
  costRounding: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customer?: Maybe<Scalars['String']>;
  customerAddress?: Maybe<Scalars['String']>;
  customerOKPO?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  finishDate?: Maybe<Scalars['DateTime']>;
  hasContractChanges: Scalars['Boolean'];
  /** Флаг наличия в договоре прочих с незаполненной формулой */
  hasEmptyFormulaInContract: Scalars['Boolean'];
  /** Флаг наличия в договоре прочих с незаполненным типом */
  hasEmptyOtherCostTypeInContract: Scalars['Boolean'];
  /** Признак заполненности поля 'Адрес подрядчика' */
  hasFilledAddresses: Scalars['Boolean'];
  hasFilledMandatoryProperties: Scalars['Boolean'];
  /** Признак договоров без плана разделенного по видам строительства */
  hasNoPlanByConstructionType?: Maybe<Scalars['Boolean']>;
  hasOthers: Scalars['Boolean'];
  hasPriceListRatio: Scalars['Boolean'];
  hasPriceParams: Scalars['Boolean'];
  hasSupplyBasisInContract: Scalars['Boolean'];
  id: Scalars['Long'];
  internalNumber: Scalars['String'];
  isEditablePriceParams: Scalars['Boolean'];
  isPriceCollectionLoaded: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  noWorkKindUerRowCount: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  otherCosts?: Maybe<Array<ContractOtherCostData>>;
  projectName: Scalars['String'];
  remainder?: Maybe<Scalars['Decimal']>;
  seasons?: Maybe<Array<ContractSeasonData>>;
  seasonsInflation?: Maybe<Array<ContractSeasonInflationData>>;
  signingDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: ContractStatusEnum;
  statusFollowers: Array<ContractStatusEnum>;
  subject?: Maybe<Scalars['String']>;
  supplyBasis: Scalars['String'];
  tax?: Maybe<Scalars['Decimal']>;
  /** @deprecated Использовать значение из атрибутов по виду строительства */
  uerOthersPercent?: Maybe<Scalars['Decimal']>;
  unreadyUerRowCount: Scalars['Int'];
  workOrderNavs?: Maybe<Array<UerWorkOrderNavData>>;
};

export type UerContractDataInput = {
  account?: InputMaybe<Scalars['String']>;
  actualCost?: InputMaybe<Scalars['Decimal']>;
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  authoredBy: Scalars['String'];
  /** Справочник расценок */
  catalogUerBase: CatalogUerBaseInput;
  codeOKPD?: InputMaybe<Scalars['String']>;
  codeOKUD?: InputMaybe<Scalars['String']>;
  constructionTypeAttributes?: InputMaybe<Array<ConstructionTypeAttributeDataInput>>;
  constructionTypes?: InputMaybe<Array<ConstructionTypeDataInput>>;
  contractPlans?: InputMaybe<Array<ContractResultPlanDataInput>>;
  contractor?: InputMaybe<Scalars['String']>;
  contractorAddress?: InputMaybe<Scalars['String']>;
  contractorOKPO?: InputMaybe<Scalars['String']>;
  conversionIndices?: InputMaybe<Array<ContractConversionIndexDataInput>>;
  /** Cтоимость договора */
  cost: ContractCostDataInput;
  /** Округление стоимости (разрядность) */
  costRounding: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customer?: InputMaybe<Scalars['String']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  customerOKPO?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  finishDate?: InputMaybe<Scalars['DateTime']>;
  hasContractChanges: Scalars['Boolean'];
  /** Флаг наличия в договоре прочих с незаполненной формулой */
  hasEmptyFormulaInContract: Scalars['Boolean'];
  /** Флаг наличия в договоре прочих с незаполненным типом */
  hasEmptyOtherCostTypeInContract: Scalars['Boolean'];
  /** Признак заполненности поля 'Адрес подрядчика' */
  hasFilledAddresses: Scalars['Boolean'];
  hasFilledMandatoryProperties: Scalars['Boolean'];
  /** Признак договоров без плана разделенного по видам строительства */
  hasNoPlanByConstructionType?: InputMaybe<Scalars['Boolean']>;
  hasOthers: Scalars['Boolean'];
  hasPriceListRatio: Scalars['Boolean'];
  hasPriceParams: Scalars['Boolean'];
  hasSupplyBasisInContract: Scalars['Boolean'];
  id: Scalars['Long'];
  internalNumber: Scalars['String'];
  isEditablePriceParams: Scalars['Boolean'];
  isPriceCollectionLoaded: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  noWorkKindUerRowCount: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  otherCosts?: InputMaybe<Array<ContractOtherCostDataInput>>;
  projectName: Scalars['String'];
  remainder?: InputMaybe<Scalars['Decimal']>;
  seasons?: InputMaybe<Array<ContractSeasonDataInput>>;
  seasonsInflation?: InputMaybe<Array<ContractSeasonInflationDataInput>>;
  signingDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: ContractStatusEnum;
  statusFollowers: Array<ContractStatusEnum>;
  subject?: InputMaybe<Scalars['String']>;
  supplyBasis: Scalars['String'];
  tax?: InputMaybe<Scalars['Decimal']>;
  /** @deprecated Использовать значение из атрибутов по виду строительства */
  uerOthersPercent?: InputMaybe<Scalars['Decimal']>;
  unreadyUerRowCount: Scalars['Int'];
  workOrderNavs?: InputMaybe<Array<WorkOrderNavDataInput>>;
};

/** A segment of a collection. */
export type UerContractLimitedCostItemsCollectionSegment = {
  __typename?: 'UerContractLimitedCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractLimitedCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractLimitedCostNameFilterCollectionSegment = {
  __typename?: 'UerContractLimitedCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Навигация договора */
export type UerContractNavigationData = {
  __typename?: 'UerContractNavigationData';
  /** Данные договора */
  contractNavData: Uer_ContractNavData;
  /** Список элементов навигации договора (ДС, прейскуранты, лимиты прочих затрат) */
  contractNavItems?: Maybe<Array<Uer_ContractItemNavData>>;
  /** Список навигации НЗ */
  workOrderNavs?: Maybe<Array<UerWorkOrderNavData>>;
};

/** A segment of a collection. */
export type UerContractOtherCostCalculatingTypeFilterCollectionSegment = {
  __typename?: 'UerContractOtherCostCalculatingTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfOtherCostCalculationTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractOtherCostNameFilterCollectionSegment = {
  __typename?: 'UerContractOtherCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractOtherCostStatusFilterCollectionSegment = {
  __typename?: 'UerContractOtherCostStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfContractOtherStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractOtherCostTypesCollectionSegment = {
  __typename?: 'UerContractOtherCostTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractOtherCostsCollectionSegment = {
  __typename?: 'UerContractOtherCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractOtherCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractOtherCostsConstructionTypeLimitCollectionSegment = {
  __typename?: 'UerContractOtherCostsConstructionTypeLimitCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractOtherCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerContractOtherRelationStatusFilterCollectionSegment = {
  __typename?: 'UerContractOtherRelationStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfContractOtherConstructionTypeRelationStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Коэффициенты конвертации */
export type UerConversionCoefficients = {
  __typename?: 'UerConversionCoefficients';
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: Maybe<Scalars['Decimal']>;
  /** Коэффициент оборудования */
  keqp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент материально-технических ресурсов */
  kmtr?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: Maybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: Maybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: Maybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: Maybe<Scalars['Decimal']>;
};

/** Коэффициенты конвертации */
export type UerConversionCoefficientsInput = {
  /** Коэффициент эксплуатации машин и механизмов */
  kemm?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент оборудования */
  keqp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент материально-технических ресурсов */
  kmtr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов */
  knr?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент основной заработной платы */
  kozp?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент проектно-изыскательских работ */
  kpir?: InputMaybe<Scalars['Decimal']>;
  /** Коэффициент сметной прибыли */
  ksp?: InputMaybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCost = {
  __typename?: 'UerEstimateBaseCost';
  directCost?: Maybe<Scalars['Decimal']>;
  emm?: Maybe<Scalars['Decimal']>;
  eqp?: Maybe<Scalars['Decimal']>;
  fot?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  pir?: Maybe<Scalars['Decimal']>;
  sections: Array<UerEstimateBaseCostSection>;
  sp?: Maybe<Scalars['Decimal']>;
  tm?: Maybe<Scalars['Decimal']>;
  trn?: Maybe<Scalars['Decimal']>;
  tz?: Maybe<Scalars['Decimal']>;
  unitCost: Scalars['Decimal'];
  zpm?: Maybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostData = {
  __typename?: 'UerEstimateBaseCostData';
  baseCost: UerEstimateBaseCost;
  catFile?: Maybe<Scalars['String']>;
  general: UerEstimateCost;
  uerNacl?: Maybe<Scalars['Long']>;
  uerPlan?: Maybe<Scalars['Long']>;
  version?: Maybe<Scalars['String']>;
  workID?: Maybe<Scalars['String']>;
  workTypeItems?: Maybe<Array<UerEstimateWorkTypeItem>>;
};

export type UerEstimateBaseCostDataInput = {
  baseCost: UerEstimateBaseCostInput;
  catFile?: InputMaybe<Scalars['String']>;
  general: UerEstimateCostInput;
  uerNacl?: InputMaybe<Scalars['Long']>;
  uerPlan?: InputMaybe<Scalars['Long']>;
  version?: InputMaybe<Scalars['String']>;
  workID?: InputMaybe<Scalars['String']>;
  workTypeItems?: InputMaybe<Array<UerEstimateWorkTypeItemInput>>;
};

export type UerEstimateBaseCostInput = {
  directCost?: InputMaybe<Scalars['Decimal']>;
  emm?: InputMaybe<Scalars['Decimal']>;
  eqp?: InputMaybe<Scalars['Decimal']>;
  fot?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  pir?: InputMaybe<Scalars['Decimal']>;
  sections: Array<UerEstimateBaseCostSectionInput>;
  sp?: InputMaybe<Scalars['Decimal']>;
  tm?: InputMaybe<Scalars['Decimal']>;
  trn?: InputMaybe<Scalars['Decimal']>;
  tz?: InputMaybe<Scalars['Decimal']>;
  unitCost: Scalars['Decimal'];
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostPrice = {
  __typename?: 'UerEstimateBaseCostPrice';
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: Maybe<Scalars['Boolean']>;
  naclMask?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: UerEstimateBaseCostPriceQuantity;
  resources: Array<UerEstimateBaseCostResource>;
  totalCost?: Maybe<UerEstimateBaseCostPriceTotalCost>;
  totalWorkCost?: Maybe<UerEstimateBaseCostPriceWorkCost>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: Maybe<UerEstimateBaseCostPriceUnitCost>;
  unitWorkCost?: Maybe<UerEstimateBaseCostPriceWorkCost>;
  vr2001?: Maybe<Scalars['String']>;
};

export type UerEstimateBaseCostPriceInput = {
  code: Scalars['String'];
  estimateTotal: Scalars['Decimal'];
  hasConsumptionRateMtr?: InputMaybe<Scalars['Boolean']>;
  naclMask?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: UerEstimateBaseCostPriceQuantityInput;
  resources: Array<UerEstimateBaseCostResourceInput>;
  totalCost?: InputMaybe<UerEstimateBaseCostPriceTotalCostInput>;
  totalWorkCost?: InputMaybe<UerEstimateBaseCostPriceWorkCostInput>;
  type: UerBasisPriceTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<UerEstimateBaseCostPriceUnitCostInput>;
  unitWorkCost?: InputMaybe<UerEstimateBaseCostPriceWorkCostInput>;
  vr2001?: InputMaybe<Scalars['String']>;
};

export type UerEstimateBaseCostPriceQuantity = {
  __typename?: 'UerEstimateBaseCostPriceQuantity';
  consumptionRateMtr?: Maybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  unit: Scalars['Decimal'];
};

export type UerEstimateBaseCostPriceQuantityInput = {
  consumptionRateMtr?: InputMaybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  unit: Scalars['Decimal'];
};

export type UerEstimateBaseCostPriceTotalCost = {
  __typename?: 'UerEstimateBaseCostPriceTotalCost';
  emm?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  sp?: Maybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  zpm?: Maybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostPriceTotalCostInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  nr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  sp?: InputMaybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostPriceUnitCost = {
  __typename?: 'UerEstimateBaseCostPriceUnitCost';
  emm?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  zpm?: Maybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostPriceUnitCostInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostPriceWorkCost = {
  __typename?: 'UerEstimateBaseCostPriceWorkCost';
  tm: Scalars['Decimal'];
  tz: Scalars['Decimal'];
};

export type UerEstimateBaseCostPriceWorkCostInput = {
  tm: Scalars['Decimal'];
  tz: Scalars['Decimal'];
};

export type UerEstimateBaseCostResource = {
  __typename?: 'UerEstimateBaseCostResource';
  code: Scalars['String'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isNotCount?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  quantity: UerEstimateBaseCostResourceQuantity;
  totalCost?: Maybe<UerEstimateBaseCostResourceCost>;
  type: UerBasisResourceCostTypeEnum;
  unit: Scalars['String'];
  unitCost?: Maybe<UerEstimateBaseCostResourceCost>;
};

export type UerEstimateBaseCostResourceCost = {
  __typename?: 'UerEstimateBaseCostResourceCost';
  emm?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  zpm?: Maybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostResourceCostInput = {
  emm?: InputMaybe<Scalars['Decimal']>;
  mtr?: InputMaybe<Scalars['Decimal']>;
  ozp?: InputMaybe<Scalars['Decimal']>;
  total: Scalars['Decimal'];
  zpm?: InputMaybe<Scalars['Decimal']>;
};

export type UerEstimateBaseCostResourceInput = {
  code: Scalars['String'];
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isNotCount?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  quantity: UerEstimateBaseCostResourceQuantityInput;
  totalCost?: InputMaybe<UerEstimateBaseCostResourceCostInput>;
  type: UerBasisResourceCostTypeEnum;
  unit: Scalars['String'];
  unitCost?: InputMaybe<UerEstimateBaseCostResourceCostInput>;
};

export type UerEstimateBaseCostResourceQuantity = {
  __typename?: 'UerEstimateBaseCostResourceQuantity';
  total: Scalars['Decimal'];
  unit: Scalars['Decimal'];
};

export type UerEstimateBaseCostResourceQuantityInput = {
  total: Scalars['Decimal'];
  unit: Scalars['Decimal'];
};

export type UerEstimateBaseCostSection = {
  __typename?: 'UerEstimateBaseCostSection';
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  prices: Array<UerEstimateBaseCostPrice>;
};

export type UerEstimateBaseCostSectionInput = {
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  prices: Array<UerEstimateBaseCostPriceInput>;
};

export type UerEstimateCost = {
  __typename?: 'UerEstimateCost';
  chapter?: Maybe<ChapterEnum>;
  code: Scalars['String'];
  groupName: Scalars['String'];
  name: Scalars['String'];
  sectionName: Scalars['String'];
  unit: Scalars['String'];
  workScopes: Array<UerEstimateCostWorkScope>;
};

export type UerEstimateCostInput = {
  chapter?: InputMaybe<ChapterEnum>;
  code: Scalars['String'];
  groupName: Scalars['String'];
  name: Scalars['String'];
  sectionName: Scalars['String'];
  unit: Scalars['String'];
  workScopes: Array<UerEstimateCostWorkScopeInput>;
};

export type UerEstimateCostWorkScope = {
  __typename?: 'UerEstimateCostWorkScope';
  name: Scalars['String'];
  number: Scalars['Long'];
};

export type UerEstimateCostWorkScopeInput = {
  name: Scalars['String'];
  number: Scalars['Long'];
};

export type UerEstimateCurrentCost = {
  __typename?: 'UerEstimateCurrentCost';
  constructionTypeId: Scalars['Int'];
  directCost?: Maybe<Scalars['Decimal']>;
  emm?: Maybe<Scalars['Decimal']>;
  eqp?: Maybe<Scalars['Decimal']>;
  fot?: Maybe<Scalars['Decimal']>;
  mtr?: Maybe<Scalars['Decimal']>;
  nr?: Maybe<Scalars['Decimal']>;
  ozp?: Maybe<Scalars['Decimal']>;
  pir?: Maybe<Scalars['Decimal']>;
  sections: Array<UerEstimateBaseCostSection>;
  sp?: Maybe<Scalars['Decimal']>;
  tm?: Maybe<Scalars['Decimal']>;
  trn?: Maybe<Scalars['Decimal']>;
  tz?: Maybe<Scalars['Decimal']>;
  unitCost: Scalars['Decimal'];
  unitCostWithOther?: Maybe<Scalars['Decimal']>;
  zpm?: Maybe<Scalars['Decimal']>;
};

export type UerEstimateCurrentCostData = {
  __typename?: 'UerEstimateCurrentCostData';
  baseCost: UerEstimateBaseCost;
  currentCosts: Array<UerEstimateCurrentCost>;
  general: UerEstimateCost;
  version?: Maybe<Scalars['String']>;
};

export type UerEstimateWorkTypeItem = {
  __typename?: 'UerEstimateWorkTypeItem';
  caption?: Maybe<Scalars['String']>;
  catFile: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  nacl?: Maybe<Scalars['String']>;
  naclCurr?: Maybe<Scalars['String']>;
  naclMask?: Maybe<Scalars['String']>;
  nrCode?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  planCurr?: Maybe<Scalars['String']>;
  planMask?: Maybe<Scalars['String']>;
  spCode?: Maybe<Scalars['String']>;
  workID: Scalars['String'];
};

export type UerEstimateWorkTypeItemInput = {
  caption?: InputMaybe<Scalars['String']>;
  catFile: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  nacl?: InputMaybe<Scalars['String']>;
  naclCurr?: InputMaybe<Scalars['String']>;
  naclMask?: InputMaybe<Scalars['String']>;
  nrCode?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  planCurr?: InputMaybe<Scalars['String']>;
  planMask?: InputMaybe<Scalars['String']>;
  spCode?: InputMaybe<Scalars['String']>;
  workID: Scalars['String'];
};

/** A segment of a collection. */
export type UerGlobalOtherCostsForContractCollectionSegment = {
  __typename?: 'UerGlobalOtherCostsForContractCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerMtrRowsForComparisonCollectionSegment = {
  __typename?: 'UerMtrRowsForComparisonCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Входные данные для добавления прочей в Акт КС-2 */
export type UerOtherCostInput = {
  /** Идентификатор прочей */
  otherCostId: Scalars['Long'];
  /** Обоснование добавления (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
};

/** A segment of a collection. */
export type UerOthersForIncludingToContractChangeCalculatingTypeFilterCollectionSegment = {
  __typename?: 'UerOthersForIncludingToContractChangeCalculatingTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfOtherCostCalculationTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerOthersForIncludingToContractChangeNameFilterCollectionSegment = {
  __typename?: 'UerOthersForIncludingToContractChangeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrCollectionSegment = {
  __typename?: 'UerPriceListMtrCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrForIncludingToContractChangeCollectionSegment = {
  __typename?: 'UerPriceListMtrForIncludingToContractChangeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrJustificationFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrNameFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrStatusFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfMtrRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrSupplyByFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrSupplyByFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfContragentTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrTypeFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfMtrTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListMtrUnitFilterCollectionSegment = {
  __typename?: 'UerPriceListMtrUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioAppliesToFullNameFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioAppliesToFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioCodeAndAppliesNamesToFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioCodeAndAppliesNamesToFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioNameFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioCodeAndAppliesToFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioCodeAndAppliesToFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioCollectionSegment = {
  __typename?: 'UerPriceListRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioForIncludingToContractChangeCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioForIncludingToContractChangeCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioForIncludingToContractChangeCollectionSegment = {
  __typename?: 'UerPriceListRatioForIncludingToContractChangeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioForIncludingToContractChangeNameFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioForIncludingToContractChangeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioForIncludingToContractChangeStatusFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioForIncludingToContractChangeStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioGroupFullNameFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioRowsCollectionSegment = {
  __typename?: 'UerPriceListRatioRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioCoefficientRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioRowsWithScopesCollectionSegment = {
  __typename?: 'UerPriceListRatioRowsWithScopesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRatioRow>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioSectionNameFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioStatusFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioUerRowsCollectionSegment = {
  __typename?: 'UerPriceListRatioUerRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioUerRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioWorkConditionsFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioWorkConditionsFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListRatioWorkTypeFilterCollectionSegment = {
  __typename?: 'UerPriceListRatioWorkTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerAndWorkScopeNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerAndWorkScopeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerAndWorkScopeNameData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerChapterFilterCollectionSegment = {
  __typename?: 'UerPriceListUerChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListUerCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerCollectionSegment = {
  __typename?: 'UerPriceListUerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForConstraintRatioCollectionSegment = {
  __typename?: 'UerPriceListUerForConstraintRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowBase>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForDismantlingRatioCollectionSegment = {
  __typename?: 'UerPriceListUerForDismantlingRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerDismantlingRatioData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForDismantlingRatioUerCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListUerForDismantlingRatioUerCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForDismantlingRatioUerGroupFilterCollectionSegment = {
  __typename?: 'UerPriceListUerForDismantlingRatioUerGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForDismantlingRatioUerNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerForDismantlingRatioUerNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForDismantlingRatioUerUnitFilterCollectionSegment = {
  __typename?: 'UerPriceListUerForDismantlingRatioUerUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForIncludingToContractChangeCollectionSegment = {
  __typename?: 'UerPriceListUerForIncludingToContractChangeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerForTechPartRatioCollectionSegment = {
  __typename?: 'UerPriceListUerForTechPartRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowBase>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerGroupDataFilterCollectionSegment = {
  __typename?: 'UerPriceListUerGroupDataFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfStringAndString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerGroupFullNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerGroupFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerJustificationFilterCollectionSegment = {
  __typename?: 'UerPriceListUerJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerRatioRowsCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListUerRatioRowsCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerRatioRowsNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerRatioRowsNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerSectionForConstraintRatioCollectionSegment = {
  __typename?: 'UerPriceListUerSectionForConstraintRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerSectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerSectionNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerStatusFilterCollectionSegment = {
  __typename?: 'UerPriceListUerStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfUerRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerTypeFilterCollectionSegment = {
  __typename?: 'UerPriceListUerTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfUerClassifierEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerUnitFilterCollectionSegment = {
  __typename?: 'UerPriceListUerUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerWorkCodeFilterCollectionSegment = {
  __typename?: 'UerPriceListUerWorkCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerWorkInSumFilterCollectionSegment = {
  __typename?: 'UerPriceListUerWorkInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerWorkNameFilterCollectionSegment = {
  __typename?: 'UerPriceListUerWorkNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerPriceListUerWorkUnitFilterCollectionSegment = {
  __typename?: 'UerPriceListUerWorkUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioAppliesToCodeFilterCollectionSegment = {
  __typename?: 'UerRatioAppliesToCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioAppliesToCodeNameFilterCollectionSegment = {
  __typename?: 'UerRatioAppliesToCodeNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioAppliesToLinkStatusFilterCollectionSegment = {
  __typename?: 'UerRatioAppliesToLinkStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioRecordStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioCollectionCollectionSegment = {
  __typename?: 'UerRatioCollectionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioRowForIncludingToContractChangeCollectionSegment = {
  __typename?: 'UerRatioRowForIncludingToContractChangeCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContractRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioUerRowItemListForWorkOrderObjectsCollectionSegment = {
  __typename?: 'UerRatioUerRowItemListForWorkOrderObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioUerRowForWorkOrderChange>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioUerRowItemListForWorkOrderRootObjectCollectionSegment = {
  __typename?: 'UerRatioUerRowItemListForWorkOrderRootObjectCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioUerRowForWorkOrderChange>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioUerRowItemsForWorkOrderObjectsCollectionSegment = {
  __typename?: 'UerRatioUerRowItemsForWorkOrderObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RatioUerRowItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerRatioUerRowItemsForWorkOrderRootObjectCollectionSegment = {
  __typename?: 'UerRatioUerRowItemsForWorkOrderRootObjectCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RatioUerRowItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum UerRecordStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  NewRecord = 'NEW_RECORD'
}

export type UerRecordStatusEnumOperationFilterInput = {
  eq?: InputMaybe<UerRecordStatusEnum>;
  in?: InputMaybe<Array<UerRecordStatusEnum>>;
  neq?: InputMaybe<UerRecordStatusEnum>;
  nin?: InputMaybe<Array<UerRecordStatusEnum>>;
};

export type UerRowConstructionTypeData = {
  __typename?: 'UerRowConstructionTypeData';
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  iconCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isUsedLink: Scalars['Boolean'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UerRowConstructionTypeDataInput = {
  catalogId: Scalars['Long'];
  code: Scalars['String'];
  contractFileName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fullName: Scalars['String'];
  iconCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isUsedLink: Scalars['Boolean'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  uniqueId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UerRowRatioGroupData = {
  __typename?: 'UerRowRatioGroupData';
  groupId: Scalars['Long'];
  isArtificial?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UerRowRatioGroupDataInput = {
  groupId: Scalars['Long'];
  isArtificial?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UerRowRatioItemData = {
  __typename?: 'UerRowRatioItemData';
  code?: Maybe<Scalars['String']>;
  isUsedLink: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  rationId: Scalars['Long'];
};

export type UerRowRatioItemDataInput = {
  code?: InputMaybe<Scalars['String']>;
  isUsedLink: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  rationId: Scalars['Long'];
};

/** A segment of a collection. */
export type UerSkzsContractsInProgressCollectionSegment = {
  __typename?: 'UerSkzsContractsInProgressCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SkzsContractData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerSkzsUerPriceListCollectionSegment = {
  __typename?: 'UerSkzsUerPriceListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SkzsUerData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerSkzsWorkOrderObjectsCollectionSegment = {
  __typename?: 'UerSkzsWorkOrderObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SkzsWorkOrderObjectData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerSkzsWorkOrderPricesCollectionSegment = {
  __typename?: 'UerSkzsWorkOrderPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SkzsWorkOrderPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerSkzsWorkOrdersInProgressCollectionSegment = {
  __typename?: 'UerSkzsWorkOrdersInProgressCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SkzsWorkOrderData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Сквозной тип элемента итогов */
export enum UerTotal_AlcTypeEnum {
  /** Итого с НДС */
  Gross = 'GROSS',
  /** Лимитированные затраты Доп.транспорт ОП (ДТОП) глав 1-7 */
  LimitedCostAdditionalTransportContractorEquipment = 'LIMITED_COST_ADDITIONAL_TRANSPORT_CONTRACTOR_EQUIPMENT',
  /** Лимитированные затраты Доп.транспорт МП (ДТМП) глав 1-7 */
  LimitedCostAdditionalTransportContractorMaterial = 'LIMITED_COST_ADDITIONAL_TRANSPORT_CONTRACTOR_MATERIAL',
  /** Лимитированные затраты Доп.транспорт ОЗ (ДТОЗ) глав 1-7 */
  LimitedCostAdditionalTransportCustomerEquipment = 'LIMITED_COST_ADDITIONAL_TRANSPORT_CUSTOMER_EQUIPMENT',
  /** Лимитированные затраты Доп.транспорт МЗ (ДТМЗ) глав 1-7 */
  LimitedCostAdditionalTransportCustomerMaterial = 'LIMITED_COST_ADDITIONAL_TRANSPORT_CUSTOMER_MATERIAL',
  /** в том числе МТР Подрядчика */
  MpChapter1_7 = 'MP_CHAPTER1_7',
  /** Стоимость неценообразующих МТР */
  MtrNoPricingChapter1_7 = 'MTR_NO_PRICING_CHAPTER1_7',
  /** Итого МТР Заказчика */
  MzChapter1_7 = 'MZ_CHAPTER1_7',
  /** В том числе МТР Заказчика по главе 8 */
  MzChapter8 = 'MZ_CHAPTER8',
  /** В том числе МТР Заказчика по главе 9 */
  MzChapter9 = 'MZ_CHAPTER9',
  /** Итого оборудование Подрядчика */
  OpChapter1_7 = 'OP_CHAPTER1_7',
  /** Прочая затрата */
  Other = 'OTHER',
  /** Прочие затраты */
  Others = 'OTHERS',
  /** Итого оборудование Заказчика */
  OzChapter1_7 = 'OZ_CHAPTER1_7',
  /** НДС, 20% */
  Tax = 'TAX',
  /** Итого услуги подрядчика по итогам глав 1-7 с учетом прочих, учтенных в УЕР, без учета МТР Заказчика, руб. без НДС */
  TotalChapter1_7 = 'TOTAL_CHAPTER1_7',
  /** Итого услуги Подрядчика по итогам глав 1-8 с учетом прочих, учтенных в УЕР, без учета МТР Заказчика */
  TotalChapter1_8 = 'TOTAL_CHAPTER1_8',
  /** Итого услуги Подрядчика по итогам глав 1-9 с учетом прочих, учтенных в УЕР, без учета МТР Заказчика */
  TotalChapter1_9 = 'TOTAL_CHAPTER1_9',
  /** Итого по главе 8 "Временные здания и сооружения" */
  TotalChapter8 = 'TOTAL_CHAPTER8',
  /** Итого по главе 9 "Прочие работы и затраты" */
  TotalChapter9 = 'TOTAL_CHAPTER9',
  /** Итого услуги Подрядчика по итогам глав 1-9, с учетом прочих, учтенных в УЕР, без учета МТР Заказчика, с учетом инфляции */
  TotalContractorServiceInflationChapter1_9 = 'TOTAL_CONTRACTOR_SERVICE_INFLATION_CHAPTER1_9',
  /** Итого "Непредвиденные и мотивационные затраты" (Итого Лимиты Заказчика) */
  TotalCustomerLimits = 'TOTAL_CUSTOMER_LIMITS',
  /** Итого услуги Подрядчика с учетом Прочих, учтенных в УЕР, непредвиденных и мотивационных затрат, без учета МТР Заказчика */
  TotalCustomerLimitsChapter1_9 = 'TOTAL_CUSTOMER_LIMITS_CHAPTER1_9',
  /** Инфляция по итогам глав 1-9 с учетом прочих, учтенных в УЕР, с учетом оборудования Подрядчика, без учета МТР Заказчика */
  TotalInflationChapter1_9 = 'TOTAL_INFLATION_CHAPTER1_9',
  /** Итого услуги Подрядчика по итогам глав 1-7 с учетом прочих, учтенных в УЕР, с учетом МТР Заказчика */
  TotalMzChapter1_7 = 'TOTAL_MZ_CHAPTER1_7',
  /** Итого услуги Подрядчика по итогам глав 1-7 без учета прочих, учтенных в УЕР, с учетом МТР Заказчика */
  TotalMzWithoutOtherChapter1_7 = 'TOTAL_MZ_WITHOUT_OTHER_CHAPTER1_7'
}

/** A segment of a collection. */
export type UerWorkOrderActKc2MtrForInflationDistributionCollectionSegment = {
  __typename?: 'UerWorkOrderActKC2MtrForInflationDistributionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderMtrInflationData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderActsCollectionSegment = {
  __typename?: 'UerWorkOrderActsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderActKc2Data>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderActsKc2CollectionSegment = {
  __typename?: 'UerWorkOrderActsKC2CollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderActKc2Data>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderActsKc2RegistryCollectionSegment = {
  __typename?: 'UerWorkOrderActsKC2RegistryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2ListItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderActsKc2RegistrySelectionListCollectionSegment = {
  __typename?: 'UerWorkOrderActsKC2RegistrySelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ActKc2SelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeLimitedCostItemsCollectionSegment = {
  __typename?: 'UerWorkOrderChangeLimitedCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeLimitedCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UerWorkOrderChangeNavData = {
  __typename?: 'UerWorkOrderChangeNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания изма */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус изма */
  status: WorkOrderChangeStatusEnum;
  /** Внутренний номер изма */
  workOrderChangeNumber: Scalars['String'];
  /** Внутренний номер НЗ */
  workOrderNumber: Scalars['String'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeObjectItemsCollectionSegment = {
  __typename?: 'UerWorkOrderChangeObjectItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeObjectItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeObjectSelectionListCollectionSegment = {
  __typename?: 'UerWorkOrderChangeObjectSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeObjectSelectionItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeObjectsCollectionSegment = {
  __typename?: 'UerWorkOrderChangeObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeObjectData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeOtherListQueryCollectionSegment = {
  __typename?: 'UerWorkOrderChangeOtherListQueryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeOtherAggregationData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeOtherPriceListCollectionSegment = {
  __typename?: 'UerWorkOrderChangeOtherPriceListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeOtherPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeOtherPriceNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeOtherPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeOtherPriceStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeOtherPriceStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfContractOtherStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkOrderChangePriceCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemChapterFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkOrderPriceItemCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemUnitFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemWorkInSumFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemWorkInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemWorkNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemWorkNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemWorkPlanFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemWorkPlanFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfDecimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceItemsCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangePriceItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceListCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangePriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceListMtrQueryCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceListMtrQueryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceListRatioForObjectsCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceListRatioForObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderPriceRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceListRatioForRootObjectCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceListRatioForRootObjectCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderPriceRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceListRatioQueryCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceListRatioQueryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceListUerQueryCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceListUerQueryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangePriceStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangePriceStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeSeasonPriceCompletedVolumeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeSeasonPriceCompletedVolumeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDecimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeSeasonPricePlanVolumeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeSeasonPricePlanVolumeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDecimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeSeasonPriceRemainderVolumeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeSeasonPriceRemainderVolumeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfDecimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeSeasonsCollectionSegment = {
  __typename?: 'UerWorkOrderChangeSeasonsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeSeasonData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeUersSelectionListCollectionSegment = {
  __typename?: 'UerWorkOrderChangeUersSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderChangeUerItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeUsersSelectionListCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeUsersSelectionListCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeUsersSelectionListGroupFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeUsersSelectionListGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeUsersSelectionListNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeUsersSelectionListNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderChangeUsersSelectionListSectionFilterCollectionSegment = {
  __typename?: 'UerWorkOrderChangeUsersSelectionListSectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderLimitedCostItemsCollectionSegment = {
  __typename?: 'UerWorkOrderLimitedCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderLimitedCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderMtrRowsForComparisonCollectionSegment = {
  __typename?: 'UerWorkOrderMtrRowsForComparisonCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Данные навигации НЗ */
export type UerWorkOrderNavData = {
  __typename?: 'UerWorkOrderNavData';
  /** Список актов НЗ */
  actKC2Navs?: Maybe<Array<ActKc2NavData>>;
  /** Список справок НЗ */
  actKC3Navs?: Maybe<Array<ActKc3NavData>>;
  /** Узел навигации реестра актов КС-2 */
  actsKC2Node?: Maybe<Uer_ContractItemNavData>;
  /** Узел навигации реестра справок КС-3 */
  actsKC3Node?: Maybe<Uer_ContractItemNavData>;
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Внутренний номкр НЗ */
  internalNumber: Scalars['String'];
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания НЗ */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Ствтус НЗ */
  status: WorkOrderStatusEnum;
  /** Изм примененый к НЗ */
  workOrderChange?: Maybe<UerWorkOrderChangeNavData>;
  /** Список навигации измов НЗ */
  workOrderChanges?: Maybe<Array<UerWorkOrderChangeNavData>>;
};

/** A segment of a collection. */
export type UerWorkOrderObjectSelectionListCollectionSegment = {
  __typename?: 'UerWorkOrderObjectSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderObjectSelectionData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderOtherPriceNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderOtherPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderOtherPriceStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderOtherPriceStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfContractOtherStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderOtherPricesCollectionSegment = {
  __typename?: 'UerWorkOrderOtherPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderOtherPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkOrderPriceCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemChapterFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkOrderPriceItemCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemObjectNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueContainerOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemRootObjectNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemRootObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueContainerOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemUnitFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemWorkInSumFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemWorkInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemWorkNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemWorkNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceItemsCollectionSegment = {
  __typename?: 'UerWorkOrderPriceItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderPriceItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListMtrAssignCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListMtrAssignCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListMtrAssignNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListMtrAssignNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListMtrCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListMtrCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListMtrRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListRatioCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListRatioCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListRatioCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListRatioForObjectsCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListRatioForObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderPriceRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListRatioForRootObjectCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListRatioForRootObjectCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderPriceRatioRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListRatioNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListRatioNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListUerCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListUerCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListUerCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListUerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PriceListUerRowData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListUerNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListUerNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListUerSectionFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListUerSectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceListUerSubSectionFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceListUerSubSectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkOrderPriceStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPriceUnitFilterCollectionSegment = {
  __typename?: 'UerWorkOrderPriceUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderPricesCollectionSegment = {
  __typename?: 'UerWorkOrderPricesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderSeasonsCollectionSegment = {
  __typename?: 'UerWorkOrderSeasonsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderSeasonData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderUersSelectionListAsyncCollectionSegment = {
  __typename?: 'UerWorkOrderUersSelectionListAsyncCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderUerItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderUsersSelectionListCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderUsersSelectionListCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderUsersSelectionListGroupFilterCollectionSegment = {
  __typename?: 'UerWorkOrderUsersSelectionListGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderUsersSelectionListNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderUsersSelectionListNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderUsersSelectionListSectionFilterCollectionSegment = {
  __typename?: 'UerWorkOrderUsersSelectionListSectionFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionActsCollectionSegment = {
  __typename?: 'UerWorkOrderVersionActsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderVersionActKc2Data>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionLimitedCostItemsCollectionSegment = {
  __typename?: 'UerWorkOrderVersionLimitedCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderVersionLimitedCostItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionObjectsCollectionSegment = {
  __typename?: 'UerWorkOrderVersionObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderVersionObjectData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionOtherPriceListCollectionSegment = {
  __typename?: 'UerWorkOrderVersionOtherPriceListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderVersionOtherPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemChapterFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemCodeFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkOrderPriceItemCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemObjectNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueContainerOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemRootObjectNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemRootObjectNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueContainerOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemStatusFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkOrderPriceStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemUnitFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemWorkInSumFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemWorkInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemWorkNameFilterCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemWorkNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceItemsCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderVersionPriceItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UerWorkOrderVersionPriceListCollectionSegment = {
  __typename?: 'UerWorkOrderVersionPriceListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkOrderVersionPriceData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedDataCollectionSegment = {
  __typename?: 'UercCalculationComputedDataCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CalculationComputeRow>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedRowsChapterFilterCollectionSegment = {
  __typename?: 'UercCalculationComputedRowsChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedRowsCodeExtendedFilterCollectionSegment = {
  __typename?: 'UercCalculationComputedRowsCodeExtendedFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkVolumeItemCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedRowsCodeFilterCollectionSegment = {
  __typename?: 'UercCalculationComputedRowsCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedRowsNameFilterCollectionSegment = {
  __typename?: 'UercCalculationComputedRowsNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedRowsWorkInSumFilterCollectionSegment = {
  __typename?: 'UercCalculationComputedRowsWorkInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationComputedRowsWorkNameFilterCollectionSegment = {
  __typename?: 'UercCalculationComputedRowsWorkNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UercCalculationConstructionTypeData = {
  __typename?: 'UercCalculationConstructionTypeData';
  /** Коэффициенты конвертации */
  coefficients: UerConversionCoefficients;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Значение процента  прочих в УЕР по главам 1-9 */
  uerOtherPercent?: Maybe<Scalars['Decimal']>;
  /** Признак наличия расценок для вида строительства на странице "Сборник расценок" */
  usedInCollection: Scalars['Boolean'];
  /** Признак наличия объектов в структуре для вида строительства */
  usedInObjects: Scalars['Boolean'];
  /** Признак наличия прочих / лимитированных для вида строительства */
  usedInOthers: Scalars['Boolean'];
};

export type UercCalculationConstructionTypeDataInput = {
  /** Коэффициенты конвертации */
  coefficients: UerConversionCoefficientsInput;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Значение процента  прочих в УЕР по главам 1-9 */
  uerOtherPercent?: InputMaybe<Scalars['Decimal']>;
  /** Признак наличия расценок для вида строительства на странице "Сборник расценок" */
  usedInCollection: Scalars['Boolean'];
  /** Признак наличия объектов в структуре для вида строительства */
  usedInObjects: Scalars['Boolean'];
  /** Признак наличия прочих / лимитированных для вида строительства */
  usedInOthers: Scalars['Boolean'];
};

export type UercCalculationConstructionTypeInput = {
  /** Коэффициенты конвертации */
  coefficients: UerConversionCoefficientsInput;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Значение процента  прочих в УЕР по главам 1-7 */
  uerOtherPercent?: InputMaybe<Scalars['Decimal']>;
};

export type UercCalculationCreateInput = {
  /** Id справочника расценок */
  catalogUERBaseUniqueId: Scalars['String'];
  /** Индексы перевода в текущий уровень цен */
  constructionTypes: Array<UercCalculationConstructionTypeInput>;
  /** Округление - количество знаков после запятой */
  costRounding?: Scalars['Int'];
  /** Адрес заказчика */
  customerAddress?: InputMaybe<Scalars['String']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']>;
  /** Внешний идентификатор проекта */
  projectUniqueId: Scalars['String'];
  /** Инфляция по сезонам расчетам */
  seasonsInflation: Array<UercCalculationSeasonInflationInput>;
  /** Дата составления */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: CalculationStatusEnum;
  /** Предмет расчета */
  subject?: InputMaybe<Scalars['String']>;
  /** Базис поставки */
  supplyBasis: Scalars['String'];
  /** Ставка НДС, % */
  taxPercent?: InputMaybe<Scalars['Decimal']>;
};

/** Расчет НМЦ */
export type UercCalculationData = {
  __typename?: 'UercCalculationData';
  /** Сумма с НДС */
  amountWithTax?: Maybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: Maybe<Scalars['Decimal']>;
  /** Автор */
  authoredBy: Scalars['String'];
  /** Справочник расценок */
  catalogUerBase: CatalogUerBase;
  /** Дата изменения */
  changeDate?: Maybe<Scalars['DateTime']>;
  /** Информация о сборнике расценок */
  collectionUerInfo: CollectionUerInfoData;
  /** Виды строительства */
  constructionTypes: Array<UercCalculationConstructionTypeData>;
  /** Размерность округления */
  costRounding: Scalars['Int'];
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Заказчик */
  customer: Scalars['String'];
  /** Адрес заказчика */
  customerAddress?: Maybe<Scalars['String']>;
  /** Признак что для расчета НМЦ были расчитаны итоги */
  hasCalculationExecuted: Scalars['Boolean'];
  /** Признак наличия загруженных объектов структуры расчета */
  hasCalculationObjects: Scalars['Boolean'];
  /** Идентификатор расчета */
  id: Scalars['Long'];
  /** Дата последнего выполнения вычисления итогов расчета НМЦ. null если еще не запускался. */
  lastComputedAt?: Maybe<Scalars['DateTime']>;
  /** Примечание */
  note?: Maybe<Scalars['String']>;
  /** Внешний идентификатор проекта */
  projectUniqueId: Scalars['String'];
  /** Начальный сезон расчета */
  seasons: Array<UercCalculationSeasonData>;
  /** Инфляция по сезонам расчетам */
  seasonsInflation: Array<UercCalculationSeasonInflationData>;
  /** дата создания (составления) карточки Расчета НМЦ */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: CalculationStatusEnum;
  /** Статусы доступные для установки из текущего статуса */
  statusFollowers: Array<CalculationStatusEnum>;
  /** Предмет расчета */
  subject: Scalars['String'];
  /** Базис поставки */
  supplyBasis: Scalars['String'];
  /** НДС */
  tax?: Maybe<Scalars['Decimal']>;
  /** Ставка НДС, % */
  taxPercent?: Maybe<Scalars['Decimal']>;
  /** Внешний идентификатор */
  uniqueId: Scalars['String'];
};

/** Расчет НМЦ */
export type UercCalculationDataInput = {
  /** Сумма с НДС */
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  /** Сумма без НДС */
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  /** Автор */
  authoredBy: Scalars['String'];
  /** Справочник расценок */
  catalogUerBase: CatalogUerBaseInput;
  /** Дата изменения */
  changeDate?: InputMaybe<Scalars['DateTime']>;
  /** Информация о сборнике расценок */
  collectionUerInfo: CollectionUerInfoDataInput;
  /** Виды строительства */
  constructionTypes: Array<UercCalculationConstructionTypeDataInput>;
  /** Размерность округления */
  costRounding: Scalars['Int'];
  /** Дата создания */
  createdAt: Scalars['DateTime'];
  /** Заказчик */
  customer: Scalars['String'];
  /** Адрес заказчика */
  customerAddress?: InputMaybe<Scalars['String']>;
  /** Признак что для расчета НМЦ были расчитаны итоги */
  hasCalculationExecuted: Scalars['Boolean'];
  /** Признак наличия загруженных объектов структуры расчета */
  hasCalculationObjects: Scalars['Boolean'];
  /** Идентификатор расчета */
  id: Scalars['Long'];
  /** Дата последнего выполнения вычисления итогов расчета НМЦ. null если еще не запускался. */
  lastComputedAt?: InputMaybe<Scalars['DateTime']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']>;
  /** Внешний идентификатор проекта */
  projectUniqueId: Scalars['String'];
  /** Начальный сезон расчета */
  seasons: Array<UercCalculationSeasonDataInput>;
  /** Инфляция по сезонам расчетам */
  seasonsInflation: Array<UercCalculationSeasonInflationDataInput>;
  /** дата создания (составления) карточки Расчета НМЦ */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: CalculationStatusEnum;
  /** Статусы доступные для установки из текущего статуса */
  statusFollowers: Array<CalculationStatusEnum>;
  /** Предмет расчета */
  subject: Scalars['String'];
  /** Базис поставки */
  supplyBasis: Scalars['String'];
  /** НДС */
  tax?: InputMaybe<Scalars['Decimal']>;
  /** Ставка НДС, % */
  taxPercent?: InputMaybe<Scalars['Decimal']>;
  /** Внешний идентификатор */
  uniqueId: Scalars['String'];
};

/** Начальные данные для создания расчета НМЦ */
export type UercCalculationDefaultData = {
  __typename?: 'UercCalculationDefaultData';
  /** Автор */
  authoredBy: Scalars['String'];
  /** Заказчик */
  customer: Scalars['String'];
  /** Статус */
  status: CalculationStatusEnum;
  /** Ставка НДС, % */
  taxPercent: Scalars['Decimal'];
};

/** Начальные данные для создания расчета НМЦ */
export type UercCalculationDefaultDataInput = {
  /** Автор */
  authoredBy: Scalars['String'];
  /** Заказчик */
  customer: Scalars['String'];
  /** Статус */
  status: CalculationStatusEnum;
  /** Ставка НДС, % */
  taxPercent: Scalars['Decimal'];
};

/** DTO объект "Связь "прочие затраты - вид строительства" расчета НМЦ" */
export type UercCalculationLimitedCostConstructionTypeData = {
  __typename?: 'UercCalculationLimitedCostConstructionTypeData';
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Вида строительства */
  constructionType?: Maybe<ConstructionTypeData>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
};

/** DTO объект "Связь "прочие затраты - вид строительства" расчета НМЦ" */
export type UercCalculationLimitedCostConstructionTypeDataInput = {
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Вида строительства */
  constructionType?: InputMaybe<ConstructionTypeDataInput>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
};

/** Данные для создания / редактирования связи лимитированной затраты и вида стоительства */
export type UercCalculationLimitedCostConstructionTypeInput = {
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
};

/** DTO записи "Доп. транспорт и лимитированные затраты" (в разрезе вида строительства) */
export type UercCalculationLimitedCostData = {
  __typename?: 'UercCalculationLimitedCostData';
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Глава */
  chapter: ChapterEnum;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату */
  isEditable: Scalars['Boolean'];
  /** Код */
  key?: Maybe<Scalars['String']>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: Maybe<Array<UercCalculationLimitedCostLimitData>>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
  /** Раздел */
  section: SectionEnum;
  /** Общий лимит  по виду строительства */
  totalCost: Scalars['Decimal'];
};

/** DTO записи "Доп. транспорт и лимитированные затраты" (в разрезе вида строительства) */
export type UercCalculationLimitedCostDataFilterInput = {
  and?: InputMaybe<Array<UercCalculationLimitedCostDataFilterInput>>;
  /** % лимитированных */
  calculatingValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор расчета НМЦ */
  calculationId?: InputMaybe<LongOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnumOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Возможность редактировать прочую затрату */
  isEditable?: InputMaybe<BooleanOperationFilterInput>;
  /** Код */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: InputMaybe<ListFilterInputTypeOfUercCalculationLimitedCostLimitDataFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<UercCalculationLimitedCostDataFilterInput>>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Раздел */
  section?: InputMaybe<SectionEnumOperationFilterInput>;
  /** Общий лимит  по виду строительства */
  totalCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** DTO записи "Доп. транспорт и лимитированные затраты" (в разрезе вида строительства) */
export type UercCalculationLimitedCostDataSortInput = {
  /** % лимитированных */
  calculatingValue?: InputMaybe<SortEnumType>;
  /** Идентификатор расчета НМЦ */
  calculationId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Возможность редактировать прочую затрату */
  isEditable?: InputMaybe<SortEnumType>;
  /** Код */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Общий лимит  по виду строительства */
  totalCost?: InputMaybe<SortEnumType>;
};

/** Данные для создания лимитированной затраты расчета НМЦ */
export type UercCalculationLimitedCostInput = {
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов лимитированных */
  catalogLimitedCostTypeId: Scalars['Int'];
  /** Глава */
  chapter: ChapterEnum;
  /** Виды строительства, для которых прочая затрата будет применена */
  constructionTypes: Array<UercCalculationLimitedCostConstructionTypeInput>;
  /** Содержимое файла, использованного в качестве источника для получения значения */
  file?: InputMaybe<FileInput>;
  /** Формула */
  formula: Scalars['String'];
  /** Идентификатор записи справочника методологий прочих */
  globalLimitedCostId?: InputMaybe<Scalars['Long']>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Код */
  key?: InputMaybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
  /** Идентификатор (альт. ключ) */
  uniqueId: Scalars['String'];
};

/** DTO объект "Лимиты лимитированных затрат по виду строительства для расчета НМЦ" */
export type UercCalculationLimitedCostLimitData = {
  __typename?: 'UercCalculationLimitedCostLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** DTO объект "Лимиты лимитированных затрат по виду строительства для расчета НМЦ" */
export type UercCalculationLimitedCostLimitDataFilterInput = {
  and?: InputMaybe<Array<UercCalculationLimitedCostLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UercCalculationLimitedCostLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** DTO объект "Лимиты лимитированных затрат по виду строительства для расчета НМЦ" */
export type UercCalculationLimitedCostLimitDataInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** A segment of a collection. */
export type UercCalculationLimitedCostNameFilterCollectionSegment = {
  __typename?: 'UercCalculationLimitedCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type UercCalculationLimitedCostPercentage = {
  __typename?: 'UercCalculationLimitedCostPercentage';
  /** Сумма лимита */
  percentage: Scalars['Decimal'];
};

export type UercCalculationLimitedCostPercentageInput = {
  /** Сумма лимита */
  percentage: Scalars['Decimal'];
};

/** A segment of a collection. */
export type UercCalculationLimitedCostTypesCollectionSegment = {
  __typename?: 'UercCalculationLimitedCostTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogLimitedCostTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** DTO записи "Доп. транспорт и лимитированные затраты" (для редактора) */
export type UercCalculationLimitedCostUpdateData = {
  __typename?: 'UercCalculationLimitedCostUpdateData';
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Запись справочника типа прочих */
  catalogLimitedCostType?: Maybe<CatalogLimitedCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter: ChapterEnum;
  /** Связь "прочие затраты - вид строительства" */
  constructionTypes?: Maybe<Array<UercCalculationLimitedCostConstructionTypeData>>;
  /** Содержимое файла, использованного в качестве источника для получения значения */
  file?: Maybe<FileContent>;
  /** Формула прочих способа расчета Процент */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор записи справочника лимитированных затрат */
  globalLimitedCostId?: Maybe<Scalars['Long']>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату */
  isEditable: Scalars['Boolean'];
  /** Код */
  key?: Maybe<Scalars['String']>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: Maybe<Array<UercCalculationLimitedCostLimitData>>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
  /** Раздел */
  section: SectionEnum;
  /** Идентификатор (альт. ключ) */
  uniqueId: Scalars['String'];
};

/** DTO записи "Доп. транспорт и лимитированные затраты" (для редактора) */
export type UercCalculationLimitedCostUpdateDataInput = {
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Запись справочника типа прочих */
  catalogLimitedCostType?: InputMaybe<CatalogLimitedCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogLimitedCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter: ChapterEnum;
  /** Связь "прочие затраты - вид строительства" */
  constructionTypes?: InputMaybe<Array<UercCalculationLimitedCostConstructionTypeDataInput>>;
  /** Содержимое файла, использованного в качестве источника для получения значения */
  file?: InputMaybe<FileContentInput>;
  /** Формула прочих способа расчета Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника лимитированных затрат */
  globalLimitedCostId?: InputMaybe<Scalars['Long']>;
  /** Признак необходимости учитывать лимитированные затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату */
  isEditable: Scalars['Boolean'];
  /** Код */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: InputMaybe<Array<UercCalculationLimitedCostLimitDataInput>>;
  /** Наименование */
  name: Scalars['String'];
  /** Обоснование */
  rationale: Scalars['String'];
  /** Раздел */
  section: SectionEnum;
  /** Идентификатор (альт. ключ) */
  uniqueId: Scalars['String'];
};

/** A segment of a collection. */
export type UercCalculationLimitedCostsCollectionSegment = {
  __typename?: 'UercCalculationLimitedCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<UercCalculationLimitedCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Навигация расчета */
export type UercCalculationNavigationData = {
  __typename?: 'UercCalculationNavigationData';
  /** Данные расчета */
  calculationNavData: Uer_CalculationNavData;
  /** Список элементов навигации расчета */
  calculationNavItems?: Maybe<Array<Uer_CalculationItemNavData>>;
};

/** DTO объект "Связь "прочие затраты - вид строительства" расчета НМЦ" */
export type UercCalculationOtherCostConstructionTypeData = {
  __typename?: 'UercCalculationOtherCostConstructionTypeData';
  /** Вида строительства */
  constructionType?: Maybe<ConstructionTypeData>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Способ распределения лимитов по сезонам */
  distributionMethod?: Maybe<Uerc_LimitDistributionMethodEnum>;
  /** Суммарный лимит стоимости по виду строительства */
  totalCostLimit?: Maybe<Scalars['Decimal']>;
};

/** DTO объект "Связь "прочие затраты - вид строительства" расчета НМЦ" */
export type UercCalculationOtherCostConstructionTypeDataInput = {
  /** Вида строительства */
  constructionType?: InputMaybe<ConstructionTypeDataInput>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Способ распределения лимитов по сезонам */
  distributionMethod?: InputMaybe<Uerc_LimitDistributionMethodEnum>;
  /** Суммарный лимит стоимости по виду строительства */
  totalCostLimit?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для создания / редактирования связи прочей затраты и вида стоительства */
export type UercCalculationOtherCostConstructionTypeInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Лимит затраты по виду строительства (указывается только в случае ручного режима ввода) */
  costLimit?: InputMaybe<Scalars['Decimal']>;
  /** Способ распределения лимитов по сезонам */
  distributionMethod?: InputMaybe<Uerc_LimitDistributionMethodEnum>;
};

/** DTO объект "Прочая затрата расчета НМЦ" */
export type UercCalculationOtherCostData = {
  __typename?: 'UercCalculationOtherCostData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /**
   * Величина, % для CalculatingType = OtherCostCalculationTypeEnum.Percent
   * Сумма лимитов прочих затрат для CalculatingType = OtherCostCalculationTypeEnum.Calculation
   */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId?: Maybe<Scalars['Long']>;
  /** Признак необходимости распределить лимиты по сезонам */
  hasToDistributeLimitsBySeasonsManualy: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Код */
  key?: Maybe<Scalars['String']>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: Maybe<Array<UercCalculationOtherCostLimitData>>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Общий лимит  по виду строительства */
  totalCost: Scalars['Decimal'];
};

/** DTO объект "Прочая затрата расчета НМЦ" */
export type UercCalculationOtherCostDataFilterInput = {
  and?: InputMaybe<Array<UercCalculationOtherCostDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /**
   * Величина, % для CalculatingType = OtherCostCalculationTypeEnum.Percent
   * Сумма лимитов прочих затрат для CalculatingType = OtherCostCalculationTypeEnum.Calculation
   */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор расчета НМЦ */
  calculationId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Признак необходимости распределить лимиты по сезонам */
  hasToDistributeLimitsBySeasonsManualy?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Возможность редактировать прочую затрату */
  isEditable?: InputMaybe<BooleanOperationFilterInput>;
  /** Код */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: InputMaybe<ListFilterInputTypeOfUercCalculationOtherCostLimitDataFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<UercCalculationOtherCostDataFilterInput>>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Общий лимит  по виду строительства */
  totalCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** DTO объект "Прочая затрата расчета НМЦ" */
export type UercCalculationOtherCostDataSortInput = {
  /** Способ начисления */
  calculatingType?: InputMaybe<SortEnumType>;
  /**
   * Величина, % для CalculatingType = OtherCostCalculationTypeEnum.Percent
   * Сумма лимитов прочих затрат для CalculatingType = OtherCostCalculationTypeEnum.Calculation
   */
  calculatingTypeValue?: InputMaybe<SortEnumType>;
  /** Идентификатор расчета НМЦ */
  calculationId?: InputMaybe<SortEnumType>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId?: InputMaybe<SortEnumType>;
  /** Признак необходимости распределить лимиты по сезонам */
  hasToDistributeLimitsBySeasonsManualy?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Возможность редактировать прочую затрату */
  isEditable?: InputMaybe<SortEnumType>;
  /** Код */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Раздел */
  section?: InputMaybe<SortEnumType>;
  /** Общий лимит  по виду строительства */
  totalCost?: InputMaybe<SortEnumType>;
};

/** Данные для создания прочей затраты расчета НМЦ */
export type UercCalculationOtherCostInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор Расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId: Scalars['Int'];
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Виды строительства */
  constructionTypes: Array<UercCalculationOtherCostConstructionTypeInput>;
  /** Содержимое файла, использованного в качестве источника для получения значения */
  file?: InputMaybe<FileInput>;
  /** Формула прочих способа расчета Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId?: InputMaybe<Scalars['Long']>;
  /** Признак необходимости учитывать прочие затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Признак, что сумма лимитов прочих загружена из файла */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически) */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты по видам строительства и сезонам */
  limits?: InputMaybe<Array<UercCalculationOtherCostLimitInput>>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
  /** Идентификатор (альт. ключ) */
  uniqueId: Scalars['String'];
};

/** DTO объект "Лимиты прочих затрат по виду строительства для расчета НМЦ" */
export type UercCalculationOtherCostLimitData = {
  __typename?: 'UercCalculationOtherCostLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** DTO объект "Лимиты прочих затрат по виду строительства для расчета НМЦ" */
export type UercCalculationOtherCostLimitDataFilterInput = {
  and?: InputMaybe<Array<UercCalculationOtherCostLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<UercCalculationOtherCostLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** DTO объект "Лимиты прочих затрат по виду строительства для расчета НМЦ" */
export type UercCalculationOtherCostLimitDataInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** DTO объект "Лимиты прочих затрат по виду строительства для расчета НМЦ" */
export type UercCalculationOtherCostLimitInput = {
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** A segment of a collection. */
export type UercCalculationOtherCostNameFilterCollectionSegment = {
  __typename?: 'UercCalculationOtherCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCalculationOtherCostTypesQueryCollectionSegment = {
  __typename?: 'UercCalculationOtherCostTypesQueryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogOtherCostTypeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** DTO объект "Прочая затрата расчета НМЦ (для редактора)" */
export type UercCalculationOtherCostUpdateData = {
  __typename?: 'UercCalculationOtherCostUpdateData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /**
   * Величина, % для CalculatingType = OtherCostCalculationTypeEnum.Percent
   * Сумма лимитов прочих затрат для CalculatingType = OtherCostCalculationTypeEnum.Calculation
   */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Связь "прочие затраты - вид строительства" */
  constructionTypes?: Maybe<Array<UercCalculationOtherCostConstructionTypeData>>;
  /** Содержимое файла, использованного в качестве источника для получения значения */
  file?: Maybe<FileContent>;
  /** Формула прочих способа расчета Процент */
  formula?: Maybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId?: Maybe<Scalars['Long']>;
  /** Признак необходимости учитывать прочие затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: Maybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату */
  isEditable?: Maybe<Scalars['Boolean']>;
  /** Признак, что сумма лимитов прочих загружена из файла */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически) */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код */
  key?: Maybe<Scalars['String']>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: Maybe<Array<UercCalculationOtherCostLimitData>>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Идентификатор (альт. ключ) */
  uniqueId: Scalars['String'];
};

/** DTO объект "Прочая затрата расчета НМЦ (для редактора)" */
export type UercCalculationOtherCostUpdateDataInput = {
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /**
   * Величина, % для CalculatingType = OtherCostCalculationTypeEnum.Percent
   * Сумма лимитов прочих затрат для CalculatingType = OtherCostCalculationTypeEnum.Calculation
   */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор расчета НМЦ */
  calculationId: Scalars['Long'];
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Связь "прочие затраты - вид строительства" */
  constructionTypes?: InputMaybe<Array<UercCalculationOtherCostConstructionTypeDataInput>>;
  /** Содержимое файла, использованного в качестве источника для получения значения */
  file?: InputMaybe<FileContentInput>;
  /** Формула прочих способа расчета Процент */
  formula?: InputMaybe<Scalars['String']>;
  /** Идентификатор записи справочника методологий прочих */
  globalOtherCostId?: InputMaybe<Scalars['Long']>;
  /** Признак необходимости учитывать прочие затраты в УЕР */
  hasCalculatingParticipation: Scalars['Boolean'];
  /** Флаг незаполненной формулы прочей */
  hasEmptyFormula?: InputMaybe<Scalars['Boolean']>;
  /** Флаг незаполненного типа прочей */
  hasEmptyOtherCostType?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Возможность редактировать прочую затрату */
  isEditable?: InputMaybe<Scalars['Boolean']>;
  /** Признак, что сумма лимитов прочих загружена из файла */
  isLimitsTotalFromFile: Scalars['Boolean'];
  /** Способ распределения лимитов по видам строительства (true: Вручную, false: Автоматически) */
  isManualLimitsDistribution: Scalars['Boolean'];
  /** Код */
  key?: InputMaybe<Scalars['String']>;
  /** Лимиты прочей затраты расчета НМЦ */
  limits?: InputMaybe<Array<UercCalculationOtherCostLimitDataInput>>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
  /** Идентификатор (альт. ключ) */
  uniqueId: Scalars['String'];
};

/** A segment of a collection. */
export type UercCalculationOtherCostsCollectionSegment = {
  __typename?: 'UercCalculationOtherCostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<UercCalculationOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Сезон расчета */
export type UercCalculationSeasonData = {
  __typename?: 'UercCalculationSeasonData';
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Сезон расчета */
export type UercCalculationSeasonDataInput = {
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Инфляция по сезонам расчета */
export type UercCalculationSeasonInflationData = {
  __typename?: 'UercCalculationSeasonInflationData';
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Инфляция по сезонам расчета */
export type UercCalculationSeasonInflationDataInput = {
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  year: Scalars['Short'];
};

/** Инфляция по сезонам расчета */
export type UercCalculationSeasonInflationInput = {
  /** Коэффициент инфляции */
  inflationRate: Scalars['Decimal'];
  /** Год сезона */
  seasonYear: Scalars['Short'];
};

/** Входные данные операции обновления статуса расчета НМЦ */
export type UercCalculationStatusInput = {
  /** Уникальный идентификатор Проекта */
  calculationUniqueId?: InputMaybe<Scalars['String']>;
  /** Статус */
  status: CalculationStatusEnum;
};

export type UercCalculationUpdateInput = {
  /** Индексы перевода в текущий уровень цен */
  constructionTypes: Array<UercCalculationConstructionTypeInput>;
  /** Округление - количество знаков после запятой */
  costRounding?: Scalars['Int'];
  /** Адрес заказчика */
  customerAddress?: InputMaybe<Scalars['String']>;
  /** Идентификатор расчета */
  id: Scalars['Long'];
  /** Примечание */
  note?: InputMaybe<Scalars['String']>;
  /** Инфляция по сезонам расчетам */
  seasonsInflation: Array<UercCalculationSeasonInflationInput>;
  /** Дата составления */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: CalculationStatusEnum;
  /** Предмет расчета */
  subject?: InputMaybe<Scalars['String']>;
  /** Базис поставки */
  supplyBasis: Scalars['String'];
  /** Ставка НДС, % */
  taxPercent?: InputMaybe<Scalars['Decimal']>;
};

/** A segment of a collection. */
export type UercCatalogRatiosNotInCollectionCollectionSegment = {
  __typename?: 'UercCatalogRatiosNotInCollectionCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CatalogRatioData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioCodeFilterCollectionSegment = {
  __typename?: 'UercCollectionRatioCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioGroupFilterCollectionSegment = {
  __typename?: 'UercCollectionRatioGroupFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioJustificationFilterCollectionSegment = {
  __typename?: 'UercCollectionRatioJustificationFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioNameFilterCollectionSegment = {
  __typename?: 'UercCollectionRatioNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioStatusFilterCollectionSegment = {
  __typename?: 'UercCollectionRatioStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCollectionRatioStatusEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioTypeFilterCollectionSegment = {
  __typename?: 'UercCollectionRatioTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfRatioTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatioTypesCollectionSegment = {
  __typename?: 'UercCollectionRatioTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RatioTypeEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionRatiosCollectionSegment = {
  __typename?: 'UercCollectionRatiosCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionRatioDataForList>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostChapterFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostChapterFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfChapterEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostCodeFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostEstimateBasisCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostEstimateBasisCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostEstimateBasisData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostEstimateBasisResourcesCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostEstimateBasisResourcesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostEstimateBasisData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostFullNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostFullNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostGroupNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostGroupNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostItemMinimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsHavingRatioCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsHavingRatioCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostItemMinimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsHavingRatioGroupCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsHavingRatioGroupCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostItemMinimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsToAddToWorCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsToAddToWORCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostItem>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsToAddToWorCodeFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsToAddToWorCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsToAddToWorGroupNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsToAddToWorNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsToAddToWorNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostItemsToAddToWorSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostSectionNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostStatusFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostStatusFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfCollectionUerBaseCostStatus>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostUerClassifierFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostUerClassifierFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfNullableOfUerClassifierEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostWorkInSumFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostWorkInSumFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkInSumEnum>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostWorkNameFilterCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostWorkNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercCollectionUerBaseCostWorkScopesCollectionSegment = {
  __typename?: 'UercCollectionUERBaseCostWorkScopesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostWorkScopeData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Навигация договора */
export type UercContractNavigationData = {
  __typename?: 'UercContractNavigationData';
  /** Данные договора */
  contractNavData: Uer_ContractNavData;
  /** Список элементов навигации договора (ДС, прейскуранты, лимиты прочих затрат) */
  contractNavItems?: Maybe<Array<Uer_ContractItemNavData>>;
  /** Список навигации НЗ */
  workOrderNavs?: Maybe<Array<Uerc_WorkOrderNavData>>;
};

/** A segment of a collection. */
export type UercGlobalLimitedCostsForCalculationCollectionSegment = {
  __typename?: 'UercGlobalLimitedCostsForCalculationCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalLimitedCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercGlobalOtherCostsForCalculationCollectionSegment = {
  __typename?: 'UercGlobalOtherCostsForCalculationCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GlobalOtherCostData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercUersToAddCodeFilterCollectionSegment = {
  __typename?: 'UercUersToAddCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercUersToAddConstructionTypeFilterCollectionSegment = {
  __typename?: 'UercUersToAddConstructionTypeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercUersToAddGroupNameFilterCollectionSegment = {
  __typename?: 'UercUersToAddGroupNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercUersToAddNameFilterCollectionSegment = {
  __typename?: 'UercUersToAddNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercUersToAddSectionNameFilterCollectionSegment = {
  __typename?: 'UercUersToAddSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeFormulaVariablesCollectionSegment = {
  __typename?: 'UercWorkVolumeFormulaVariablesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkVolumeFormulaVariableData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemCodeExtendedFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeItemCodeExtendedFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfWorkVolumeItemCodeFilterData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemCodeFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeItemCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemNameFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeItemNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemRatioGroupCollectionSegment = {
  __typename?: 'UercWorkVolumeItemRatioGroupCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionRatioGroupData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemUerGroupNameFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeItemUerGroupNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemUerSectionNameFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeItemUerSectionNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemUnitFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeItemUnitFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeItemsCollectionSegment = {
  __typename?: 'UercWorkVolumeItemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WorkVolumeItemData>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeMtrSelectionListCodeFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeMtrSelectionListCodeFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeMtrSelectionListCollectionSegment = {
  __typename?: 'UercWorkVolumeMtrSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionMtrItemShort>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeMtrSelectionListNameFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeMtrSelectionListNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment = {
  __typename?: 'UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionUerBaseCostRatioMinimal>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeRatiosSelectionListCollectionSegment = {
  __typename?: 'UercWorkVolumeRatiosSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionRatioDataShort>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeRatiosWithUersSelectionListCollectionSegment = {
  __typename?: 'UercWorkVolumeRatiosWithUersSelectionListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CollectionRatioUersDataShort>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** A segment of a collection. */
export type UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterCollectionSegment = {
  __typename?: 'UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<FilterValueOfString>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/** Выбранные значения фильтров каскадной фильтрации УЭР при добавлении в сборник расценок */
export type UersToAddFilterInput = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  constructionTypeNames?: InputMaybe<Array<Scalars['String']>>;
  groupNames?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  sectionNames?: InputMaybe<Array<Scalars['String']>>;
};

/** Input обновления укрупнённой сметы. */
export type UpdateAggregateEstimateInput = {
  /** Глава сметы. */
  chapter?: InputMaybe<BimChapterEnum>;
  /** Коэффициент. */
  coefficient: Scalars['Decimal'];
  /** Идентификатор укрупнённой сметы. */
  id: Scalars['Long'];
  /** Участвует ли агрегат в расчёте процента прочих и лимитированных затрат. */
  inPercentOtherAndLimit: Scalars['Boolean'];
  /** Идентификаторы ЛСР (простых смет), включаемых в укрупнённую смету. */
  localEstimateIds: Array<Scalars['Long']>;
  /** Идентификатор объекта/подобъекта структуры расчёта (негарантированный объём). */
  objectId: Scalars['Long'];
  /** Идентификатор корневого объекта/подобъекта структуры расчёта. Если не передан — вычисляется. */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Шифр (Value_Code). */
  valueCode: Scalars['String'];
  /** Наименование (Value_Name). */
  valueName: Scalars['String'];
  /** Кол-во сейчас. */
  valueQuantityNow: Scalars['Decimal'];
  /** Кол-во по целевым показателям. */
  valueQuantityTarget: Scalars['Decimal'];
  /** Ед. изм (Value_Unit). */
  valueUnit: Scalars['String'];
};

export type UpdateCatalogUerBaseCostInput = {
  catFile?: InputMaybe<Scalars['String']>;
  /** Идентификатор каталога */
  catalogId: Scalars['Long'];
  /** Виды работ */
  catalogUERBaseCostWorkScopes?: InputMaybe<Array<CatalogUerBaseCostWorkScopeBaseDataInput>>;
  /** Глава в расчете */
  chapter?: InputMaybe<ChapterEnum>;
  /** Код */
  code: Scalars['String'];
  /** Типы строительства */
  constructionTypes: Array<Scalars['Int']>;
  /** Эксплуатация машин и механизмов */
  emm?: InputMaybe<Scalars['Decimal']>;
  /** Оборудование */
  eqp?: InputMaybe<Scalars['Decimal']>;
  /** Фот */
  fot?: InputMaybe<Scalars['Decimal']>;
  /** Код подраздела */
  groupCode?: InputMaybe<Scalars['String']>;
  /** Подраздел */
  groupName: Scalars['String'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Обоснование */
  justification?: InputMaybe<Scalars['String']>;
  /** Материально-технические ресурсы */
  mtr?: InputMaybe<Scalars['Decimal']>;
  /** Имя */
  name: Scalars['String'];
  /** Накладные расходы */
  nr?: InputMaybe<Scalars['Decimal']>;
  /** Основная заработная плата */
  ozp?: InputMaybe<Scalars['Decimal']>;
  /** Проектно-изыскательские работы */
  pir?: InputMaybe<Scalars['Decimal']>;
  /** коэффициенты */
  ratioGroups: Array<Scalars['Long']>;
  /** коэффициенты */
  ratios: Array<Scalars['Long']>;
  /** Раздел */
  sectionName?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<Array<CatalogUerBaseCostEstimateBasisSectionUpdateInput>>;
  /** Сметная прибыль */
  sp?: InputMaybe<Scalars['Decimal']>;
  /** ТЗМ */
  tm?: InputMaybe<Scalars['Decimal']>;
  /** Перевозка */
  trn?: InputMaybe<Scalars['Decimal']>;
  /** Трудозатраты */
  tz?: InputMaybe<Scalars['Decimal']>;
  /** Тип расценки */
  uerClassifier?: InputMaybe<UerClassifierEnum>;
  /** Накладные расходы для УЕР (проценты) */
  uerNacl?: InputMaybe<Scalars['Long']>;
  /** Плановая прибыль для УЕР (проценты) */
  uerPlan?: InputMaybe<Scalars['Long']>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базовом уровне цен */
  unitCost: Scalars['Decimal'];
  /** Версия справочника */
  version?: InputMaybe<Scalars['String']>;
  workID?: InputMaybe<Scalars['String']>;
  /** Вид работ */
  workType: CatalogUerBaseWorkDataInput;
  /** Виды работ из Гранд-сметы, используемые в расценке */
  workTypeItems?: InputMaybe<Array<CatalogUerBaseCostWorkTypeItemInput>>;
  /** Заработная плата машинистов */
  zpm?: InputMaybe<Scalars['Decimal']>;
};

/** Модель обновления позиции МТР */
export type UpdateCollectionMtrInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Величина нормы расхода ресурса */
  consumptionrateMtr?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор МТР */
  id: Scalars['Long'];
  /**  Признак исключения/включения из расчета доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для обновления МТР в ВОР */
export type UpdateCollectionMtrToWorkVolumeInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Величина нормы расхода ресурса */
  consumptionrateMtr?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор МТР */
  id: Scalars['Long'];
  /**  Признак исключения/включения из расчета доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор ВОР */
  worId: Scalars['Long'];
};

/** Модель обновления стоимости единицы в текущем уровне цен для позиции МТР */
export type UpdateCollectionMtrUnitCurrentPriceInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  id: Scalars['Long'];
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost: Scalars['Decimal'];
};

/** Модель ответа после изменения стоимости единицы МТР */
export type UpdateCollectionMtrUnitCurrentPriceResponse = {
  __typename?: 'UpdateCollectionMtrUnitCurrentPriceResponse';
  /** Все объекты/подобъекты по расчету НМЦ */
  calculationObjects: Array<CollectionMtrCalculationObjectData>;
  /** Данные строки МТР */
  collectionMtrItem: CollectionMtrUersItem;
  /** Значения позиций Ведомости МТР */
  collectionMtrItemValues: Array<CollectionMtrItemValue>;
  /** Итоговая стоимости в текущем уровне цен для позиций Материалов и Оборудования Подрядчика на форме Ведомости МТР */
  collectionMtrTotals: CollectionMtrTotals;
  /** Все сезоны по расчету НМЦ */
  seasons: Array<Scalars['Short']>;
};

/** Модель ответа после изменения стоимости единицы МТР */
export type UpdateCollectionMtrUnitCurrentPriceResponseInput = {
  /** Все объекты/подобъекты по расчету НМЦ */
  calculationObjects: Array<CollectionMtrCalculationObjectDataInput>;
  /** Данные строки МТР */
  collectionMtrItem: CollectionMtrUersItemInput;
  /** Значения позиций Ведомости МТР */
  collectionMtrItemValues: Array<CollectionMtrItemValueInput>;
  /** Итоговая стоимости в текущем уровне цен для позиций Материалов и Оборудования Подрядчика на форме Ведомости МТР */
  collectionMtrTotals: CollectionMtrTotalsInput;
  /** Все сезоны по расчету НМЦ */
  seasons: Array<Scalars['Short']>;
};

/** Модель обновления признака учета/не учета в расчете доп. транспорта */
export type UpdateIsIncludedInTransportCalculationInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
  /** Признак учета/не учета в расчете доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
};

/** Модель ответа после создания / обносвления МТР */
export type UpdateResponseCollectionMtrData = {
  __typename?: 'UpdateResponseCollectionMtrData';
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Код шифра */
  code: Scalars['String'];
  /** Величина нормы расхода ресурса */
  consumptionrateMtr?: Maybe<Scalars['Decimal']>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr: Scalars['Boolean'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
  /**  Признак исключения/включения из расчета доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: Maybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: Maybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Статус записи */
  status?: Maybe<MtrStatus>;
  /** Кем поставляется */
  supplyBy?: Maybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: Maybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: Maybe<Scalars['Decimal']>;
};

/** Модель ответа после создания / обносвления МТР */
export type UpdateResponseCollectionMtrDataInput = {
  /** Идентификатор НМЦ */
  calculationId: Scalars['Long'];
  /** Код шифра */
  code: Scalars['String'];
  /** Величина нормы расхода ресурса */
  consumptionrateMtr?: InputMaybe<Scalars['Decimal']>;
  /** Наличие нормы расхода ресурса */
  hasConsumptionrateMtr: Scalars['Boolean'];
  /** Идентификатор позиции МТР */
  id: Scalars['Long'];
  /**  Признак исключения/включения из расчета доп. транспорта */
  isIncludedInTransportCalculation: Scalars['Boolean'];
  /** Код МТР */
  mtrKind?: InputMaybe<Scalars['String']>;
  /** Тип МТР */
  mtrType?: InputMaybe<MtrTypeEnum>;
  /** Наименование */
  name: Scalars['String'];
  /** Статус записи */
  status?: InputMaybe<MtrStatus>;
  /** Кем поставляется */
  supplyBy?: InputMaybe<ContragentTypeEnum>;
  /** Единица измерения */
  unit: Scalars['String'];
  /** Стоимость единицы в базисном уровне цен */
  unitBaseCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость единицы в текущем уровне цен */
  unitCurrentCost?: InputMaybe<Scalars['Decimal']>;
  /** Вес единицы, тонн */
  unitWeight?: InputMaybe<Scalars['Decimal']>;
};

/** Входные данные для изменения прочей затраты Изма */
export type UpdateWorkOrderChangeOtherPriceItemInput = {
  /** Идентификатор прочей затраты договора */
  otherCostId: Scalars['Long'];
  /** Объекты строительства для распределения стоимости прочих затрат */
  otherCostObjects: Array<WorkOrderChangeOtherObjectInput>;
  /** Список прочих затрат по сезонам для изменения в наряд-заказе */
  otherSeasonPrices?: InputMaybe<Array<UpdateWorkOrderChangeOtherSeasonPriceItemInput>>;
};

/** Входные данные для изменения прочей затраты по сезонам */
export type UpdateWorkOrderChangeOtherSeasonPriceItemInput = {
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Включено в наряд-заказ */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Входные данные для изменения прочих затрат в наряд-заказе */
export type UpdateWorkOrderOtherCostInput = {
  /** Идентификатор типа строительства */
  constructionTypeId: Scalars['Int'];
  /** Список прочих затрат для изменения в наряд-заказе */
  otherPrices: Array<UpdateWorkOrderOtherPriceInput>;
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
};

/** Входные данные для изменения прочей затраты */
export type UpdateWorkOrderOtherPriceInput = {
  /** Идентификаторы объектов строительства для распределения стоимости прочих затрат */
  objectIdList: Array<Scalars['Long']>;
  /** Идентификатор прочей затраты договора */
  otherCostId: Scalars['Long'];
  /** Список прочих затрат по сезонам для изменения в наряд-заказе */
  otherSeasonPrices: Array<UpdateWorkOrderOtherSeasonPriceInput>;
};

/** Входные данные для изменения прочей затраты НЗ */
export type UpdateWorkOrderOtherPriceItemInput = {
  /** Идентификатор прочей затраты договора */
  otherCostId: Scalars['Long'];
  /** Идентификаторы объектов строительства для распределения стоимости прочих затрат */
  otherCostObjects: Array<WorkOrderOtherObjectInput>;
  /** Список прочих затрат по сезонам для изменения в наряд-заказе */
  otherSeasonPrices?: InputMaybe<Array<UpdateWorkOrderOtherSeasonPriceItemInput>>;
};

/** Входные данные для изменения прочей затраты по сезонам */
export type UpdateWorkOrderOtherSeasonPriceInput = {
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Включено в наряд-заказ */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Входные данные для изменения прочей затраты по сезонам */
export type UpdateWorkOrderOtherSeasonPriceItemInput = {
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Включено в наряд-заказ */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Long']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Long'];
  lastName: Scalars['String'];
  userId: Scalars['UUID'];
  username: Scalars['String'];
};

export type UserProfileFilterInput = {
  and?: InputMaybe<Array<UserProfileFilterInput>>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<UserProfileFilterInput>>;
  userId?: InputMaybe<UuidOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type UserProfileInput = {
  company?: InputMaybe<CompanyInput>;
  companyId?: InputMaybe<Scalars['Long']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Long'];
  lastName: Scalars['String'];
  userId: Scalars['UUID'];
  username: Scalars['String'];
};

export type UserProfileSortInput = {
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

/** Сообщение об ошибке валидации */
export type ValidationMessage = {
  __typename?: 'ValidationMessage';
  /** Сообщение об ошибке валидации */
  message: Scalars['String'];
  /** Метаданные */
  metadata?: Maybe<Scalars['String']>;
  /** Имя свойства */
  property?: Maybe<Scalars['String']>;
  /** Данные о месте возникновения ошибки */
  source?: Maybe<Scalars['String']>;
};

/** Сообщение об ошибке валидации */
export type ValidationMessageFilterInput = {
  and?: InputMaybe<Array<ValidationMessageFilterInput>>;
  /** Сообщение об ошибке валидации */
  message?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Метаданные */
  metadata?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<ValidationMessageFilterInput>>;
  /** Имя свойства */
  property?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Данные о месте возникновения ошибки */
  source?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Сообщение об ошибке валидации */
export type ValidationMessageInput = {
  /** Сообщение об ошибке валидации */
  message: Scalars['String'];
  /** Метаданные */
  metadata?: InputMaybe<Scalars['String']>;
  /** Имя свойства */
  property?: InputMaybe<Scalars['String']>;
  /** Данные о месте возникновения ошибки */
  source?: InputMaybe<Scalars['String']>;
};

/** Данные позиции для переноса объёма из одного сезона в другой */
export type VolumeTransferDataInput = {
  /** Значение для переноса */
  transferValue: Scalars['Decimal'];
  /** ID позиции изма к НЗ */
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  /** ID позиции НЗ */
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};

/** Тип файла ВОР Excel */
export enum WorExcelFileType {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

/** Варианты сортировки расценок в файле Вертикального ВОР и при формировании расчёта */
export enum WorUerSortType {
  /** Сортировка по коду */
  ByCode = 'BY_CODE',
  /** Сортировка по порядку следования в документе, без номера - в конец */
  ToEnd = 'TO_END'
}

/** Участие в суммировании ФО. */
export enum WorkInSumEnum {
  /** 0 - не участвует */
  NotParticipate = 'NOT_PARTICIPATE',
  /** Ф - участвует, К=1 */
  Participate = 'PARTICIPATE',
  /** Ф с коэффициентом - участвует, применяется значение коэффициента */
  ParticipateWithRatio = 'PARTICIPATE_WITH_RATIO'
}

export type WorkInSumEnumOperationFilterInput = {
  eq?: InputMaybe<WorkInSumEnum>;
  in?: InputMaybe<Array<WorkInSumEnum>>;
  neq?: InputMaybe<WorkInSumEnum>;
  nin?: InputMaybe<Array<WorkInSumEnum>>;
};

/** Модель данных акта КС-2 для отображения на формах НЗ */
export type WorkOrderActKc2Data = {
  __typename?: 'WorkOrderActKC2Data';
  /** Признак превышения согласованной стоимости */
  acceptedCostDeviation?: Maybe<DeviationEnum>;
  /** Признак превышения согласованного объема */
  acceptedVolumeDeviation?: Maybe<DeviationEnum>;
  /** Признак возможности создания корректировочного акта */
  canCreateCorrection?: Maybe<Scalars['Boolean']>;
  /** Дата корректировки корректировочного акта */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Дата акта */
  date?: Maybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор акта */
  id: Scalars['Long'];
  /** Идентификатор сезона инфляции акта */
  inflationSeasonId?: Maybe<Scalars['Long']>;
  /** Сезон инфляции акта */
  inflationSeasonYear?: Maybe<Scalars['Int']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Идентификатор сезона инфляции акта */
  isDistributionOfMtrInflation: Scalars['Boolean'];
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: Maybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied: Scalars['Boolean'];
  /** Признак того, что копирование объёма из СКзС заблокировано */
  isSKzSCopyLock: Scalars['Boolean'];
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated: Scalars['Boolean'];
  /** Номер акта */
  number?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта акта */
  objectId: Scalars['Long'];
  /** Признак превышения плановой стоимости */
  planCostDeviation?: Maybe<DeviationEnum>;
  /** Признак превышения планового объема */
  planVolumeDeviation?: Maybe<DeviationEnum>;
  /** Дата окончания отчетного периода */
  reportingFinishDate?: Maybe<Scalars['Date']>;
  /** Дата начала отчетного периода */
  reportingStartDate?: Maybe<Scalars['Date']>;
  /** Идентификатор сезона акта */
  seasonId: Scalars['Long'];
  /** Сезон акта */
  seasonYear: Scalars['Int'];
  /** Статус акта */
  status: ActKc2StatusEnum;
  /** Статус СКзС */
  statusSKzS?: Maybe<SkzsActKc2StatusEnum>;
};

/** Модель данных акта КС-2 для отображения на формах НЗ */
export type WorkOrderActKc2DataFilterInput = {
  /** Признак превышения согласованной стоимости */
  acceptedCostDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Признак превышения согласованного объема */
  acceptedVolumeDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderActKc2DataFilterInput>>;
  /** Признак возможности создания корректировочного акта */
  canCreateCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Дата корректировки корректировочного акта */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Дата акта */
  date?: InputMaybe<DateOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор акта */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона инфляции акта */
  inflationSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон инфляции акта */
  inflationSeasonYear?: InputMaybe<IntOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор сезона инфляции акта */
  isDistributionOfMtrInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что копирование объёма из СКзС заблокировано */
  isSKzSCopyLock?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер акта */
  number?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта акта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderActKc2DataFilterInput>>;
  /** Признак превышения плановой стоимости */
  planCostDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Признак превышения планового объема */
  planVolumeDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Дата окончания отчетного периода */
  reportingFinishDate?: InputMaybe<DateOperationFilterInput>;
  /** Дата начала отчетного периода */
  reportingStartDate?: InputMaybe<DateOperationFilterInput>;
  /** Идентификатор сезона акта */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон акта */
  seasonYear?: InputMaybe<IntOperationFilterInput>;
  /** Статус акта */
  status?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  /** Статус СКзС */
  statusSKzS?: InputMaybe<NullableOfSkzsActKc2StatusEnumOperationFilterInput>;
};

export type WorkOrderActKc2OtherAggregationData = {
  __typename?: 'WorkOrderActKC2OtherAggregationData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Признак наличия у прочей лимита в сезоне акта */
  hasSeasonLimit: Scalars['Boolean'];
  /** Лимиты прочей затраты наряд-заказа */
  limits: Array<WorkOrderCostLimitData>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Раздел */
  status: ContractOtherStatusEnum;
};

export type WorkOrderActKc2PriceData = {
  __typename?: 'WorkOrderActKC2PriceData';
  acceptedCost?: Maybe<Scalars['Decimal']>;
  acceptedVolume?: Maybe<Scalars['Decimal']>;
  acceptedVolumeDeviation?: Maybe<DeviationEnum>;
  actKC2Id: Scalars['Long'];
  hasDistributionOfMtrInflation: Scalars['Boolean'];
  id?: Maybe<Scalars['Long']>;
  inflationSeasonId?: Maybe<Scalars['Long']>;
  isCorrection?: Maybe<Scalars['Boolean']>;
  isEditableCost?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isReadOnly?: Maybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated: Scalars['Boolean'];
  planCost?: Maybe<Scalars['Decimal']>;
  planVolume?: Maybe<Scalars['Decimal']>;
  planVolumeDeviation?: Maybe<DeviationEnum>;
};

export type WorkOrderActKc2PriceDataFilterInput = {
  acceptedCost?: InputMaybe<DecimalOperationFilterInput>;
  acceptedVolume?: InputMaybe<DecimalOperationFilterInput>;
  acceptedVolumeDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderActKc2PriceDataFilterInput>>;
  hasDistributionOfMtrInflation?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inflationSeasonId?: InputMaybe<LongOperationFilterInput>;
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  isEditableCost?: InputMaybe<BooleanOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderActKc2PriceDataFilterInput>>;
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  planVolumeDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
};

/** Данные итога наряд-заказа по акту выполненных работ */
export type WorkOrderActKc2ResultData = {
  __typename?: 'WorkOrderActKC2ResultData';
  /** Идентификатор акта выполненных работ */
  actKC2Id: Scalars['Long'];
  /** Значение итога */
  value: Scalars['Decimal'];
};

/** Входные данные для создания закрывающего Изма к НЗ */
export type WorkOrderChangeClosingInput = {
  /** Комментарий */
  description?: InputMaybe<Scalars['String']>;
  /** Внутренний номер */
  internalNumber: Scalars['String'];
  /** Дата подписания */
  signingDate: Scalars['DateTime'];
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

export type WorkOrderChangeConstructionObjectInput = {
  /** Стоимость позиции прочей */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Составной идентификатор объекта Изма */
  objectIds: WorkOrderChangeObjectIdInput;
  /** Идентификатор cезона */
  seasonId: Scalars['Long'];
};

/** Лимиты прочей затраты Изма */
export type WorkOrderChangeCostLimitData = {
  __typename?: 'WorkOrderChangeCostLimitData';
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонений */
  deviation: DeviationTipEnum;
  /** Сезон Изма */
  season?: Maybe<WorkOrderChangeSeasonData>;
  /** Остаток */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Лимиты прочей затраты Изма */
export type WorkOrderChangeCostLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeCostLimitDataFilterInput>>;
  /** Лимит по договору */
  costLimit?: InputMaybe<DecimalOperationFilterInput>;
  /** Диапазон отклонений */
  deviation?: InputMaybe<DeviationTipEnumOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeCostLimitDataFilterInput>>;
  /** Сезон Изма */
  season?: InputMaybe<WorkOrderChangeSeasonDataFilterInput>;
  /** Остаток */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Лимит прочей с данными распределения по сезонам Изма */
export type WorkOrderChangeCostLimitDistributionData = {
  __typename?: 'WorkOrderChangeCostLimitDistributionData';
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонений */
  deviation: DeviationTipEnum;
  /** Стоимость, включенная в Изм (для способа распределения Расчет) */
  includedCost?: Maybe<Scalars['Decimal']>;
  /** Включено в Изм (для способа распределения %) */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation?: Maybe<Scalars['Boolean']>;
  /** Сезон Изма */
  season?: Maybe<WorkOrderChangeSeasonData>;
  /** Остаток */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Лимит прочей с данными распределения по сезонам Изма */
export type WorkOrderChangeCostLimitDistributionDataInput = {
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонений */
  deviation: DeviationTipEnum;
  /** Стоимость, включенная в Изм (для способа распределения Расчет) */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Включено в Изм (для способа распределения %) */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation?: InputMaybe<Scalars['Boolean']>;
  /** Сезон Изма */
  season?: InputMaybe<WorkOrderChangeSeasonDataInput>;
  /** Остаток */
  totalRemainderCost?: InputMaybe<Scalars['Decimal']>;
};

export type WorkOrderChangeData = {
  __typename?: 'WorkOrderChangeData';
  /** Создатель изма */
  authoredBy: Scalars['String'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Текст предмета договора */
  contractSubjectText?: Maybe<Scalars['String']>;
  /** Дата создания изма */
  createdAt: Scalars['DateTime'];
  /** Комментарий */
  description?: Maybe<Scalars['String']>;
  /** Количество черновиков */
  draftCount: Scalars['Int'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: Maybe<Scalars['String']>;
  /** Признак того что это закрывающий изм */
  isClosing: Scalars['Boolean'];
  /** Дата подписания */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Переходы статуса */
  statusFollowers: Array<WorkOrderChangeStatusEnum>;
  /** Дата изменения изма */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
  /** Текст номера НЗ */
  workOrderNumberText?: Maybe<Scalars['String']>;
  /** Дата подписания НЗ */
  workOrderSigningDate?: Maybe<Scalars['DateTime']>;
};

export type WorkOrderChangeDataInput = {
  /** Создатель изма */
  authoredBy: Scalars['String'];
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Текст предмета договора */
  contractSubjectText?: InputMaybe<Scalars['String']>;
  /** Дата создания изма */
  createdAt: Scalars['DateTime'];
  /** Комментарий */
  description?: InputMaybe<Scalars['String']>;
  /** Количество черновиков */
  draftCount: Scalars['Int'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Признак того что это закрывающий изм */
  isClosing: Scalars['Boolean'];
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Переходы статуса */
  statusFollowers: Array<WorkOrderChangeStatusEnum>;
  /** Дата изменения изма */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
  /** Текст номера НЗ */
  workOrderNumberText?: InputMaybe<Scalars['String']>;
  /** Дата подписания НЗ */
  workOrderSigningDate?: InputMaybe<Scalars['DateTime']>;
};

/** Данные по черновикам Изма к НЗ */
export type WorkOrderChangeDraftInfo = {
  __typename?: 'WorkOrderChangeDraftInfo';
  /** Количество черновиков Изма к НЗ */
  draftCount: Scalars['Int'];
};

/** Данные по черновикам Изма к НЗ */
export type WorkOrderChangeDraftInfoInput = {
  /** Количество черновиков Изма к НЗ */
  draftCount: Scalars['Int'];
};

export type WorkOrderChangeInput = {
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Комментарий */
  description?: InputMaybe<Scalars['String']>;
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

export type WorkOrderChangeItem = {
  __typename?: 'WorkOrderChangeItem';
  id: Scalars['Long'];
  internalNumber?: Maybe<Scalars['String']>;
  signingDate?: Maybe<Scalars['DateTime']>;
};

export type WorkOrderChangeItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeItemFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeItemFilterInput>>;
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type WorkOrderChangeItemInput = {
  id: Scalars['Long'];
  internalNumber?: InputMaybe<Scalars['String']>;
  signingDate?: InputMaybe<Scalars['DateTime']>;
};

export type WorkOrderChangeItemSortInput = {
  id?: InputMaybe<SortEnumType>;
  internalNumber?: InputMaybe<SortEnumType>;
  signingDate?: InputMaybe<SortEnumType>;
};

/** Лимиты по виду строительства «Изм. к НЗ» */
export type WorkOrderChangeLimitedCostConstructionTypeLimitData = {
  __typename?: 'WorkOrderChangeLimitedCostConstructionTypeLimitData';
  calculatingValue: Scalars['Decimal'];
  constructionType: ConstructionTypeData;
  seasonLimits: Array<WorkOrderChangeLimitedCostSeasonLimitData>;
};

/** Лимиты по виду строительства «Изм. к НЗ» */
export type WorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput>>;
  calculatingValue?: InputMaybe<DecimalOperationFilterInput>;
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput>>;
  seasonLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeLimitedCostSeasonLimitDataFilterInput>;
};

/** Модель данных лимитированной затраты «Изм. к НЗ» для списка */
export type WorkOrderChangeLimitedCostItemData = {
  __typename?: 'WorkOrderChangeLimitedCostItemData';
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  chapter?: Maybe<Scalars['String']>;
  constructionTypeLimits: Array<WorkOrderChangeLimitedCostConstructionTypeLimitData>;
  id: Scalars['Long'];
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  workOrderChangeId: Scalars['Long'];
};

/** Модель данных лимитированной затраты «Изм. к НЗ» для списка */
export type WorkOrderChangeLimitedCostItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeLimitedCostItemDataFilterInput>>;
  catalogLimitedCostTypeId?: InputMaybe<IntOperationFilterInput>;
  chapter?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  constructionTypeLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeLimitedCostConstructionTypeLimitDataFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeLimitedCostItemDataFilterInput>>;
  workOrderChangeId?: InputMaybe<LongOperationFilterInput>;
};

/** Модель данных лимитированной затраты «Изм. к НЗ» для списка */
export type WorkOrderChangeLimitedCostItemDataSortInput = {
  catalogLimitedCostTypeId?: InputMaybe<SortEnumType>;
  chapter?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  key?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  workOrderChangeId?: InputMaybe<SortEnumType>;
};

/** Сезонный лимит лимитированной затраты «Изм. к НЗ» */
export type WorkOrderChangeLimitedCostSeasonLimitData = {
  __typename?: 'WorkOrderChangeLimitedCostSeasonLimitData';
  constructionTypeId: Scalars['Int'];
  cost: Scalars['Decimal'];
  seasonId: Scalars['Long'];
};

/** Сезонный лимит лимитированной затраты «Изм. к НЗ» */
export type WorkOrderChangeLimitedCostSeasonLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeLimitedCostSeasonLimitDataFilterInput>>;
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeLimitedCostSeasonLimitDataFilterInput>>;
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные обновления элементов Изма */
export type WorkOrderChangeModifyItemIds = {
  __typename?: 'WorkOrderChangeModifyItemIds';
  /** Идентификаторы обновленных элементов Изма */
  itemIds?: Maybe<Array<Scalars['Long']>>;
  /** Идентификатор Изма */
  workOrderChangeId: Scalars['Long'];
};

/** Данные обновления элементов Изма */
export type WorkOrderChangeModifyItemIdsInput = {
  /** Идентификаторы обновленных элементов Изма */
  itemIds?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификатор Изма */
  workOrderChangeId: Scalars['Long'];
};

export type WorkOrderChangeNavData = {
  __typename?: 'WorkOrderChangeNavData';
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания изма */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Статус изма */
  status: WorkOrderChangeStatusEnum;
  /** Внутренний номер изма */
  workOrderChangeNumber: Scalars['String'];
  /** Внутренний номер НЗ */
  workOrderNumber: Scalars['String'];
};

export type WorkOrderChangeNavDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeNavDataFilterInput>>;
  /** Идентификатор объекта */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Название элемента */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор элемента */
  navLinkId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeNavDataFilterInput>>;
  /** Дата подписания изма */
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Статус изма */
  status?: InputMaybe<WorkOrderChangeStatusEnumOperationFilterInput>;
  /** Внутренний номер изма */
  workOrderChangeNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Внутренний номер НЗ */
  workOrderNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type WorkOrderChangeNavDataInput = {
  /** Идентификатор объекта */
  id?: InputMaybe<Scalars['Long']>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания изма */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус изма */
  status: WorkOrderChangeStatusEnum;
  /** Внутренний номер изма */
  workOrderChangeNumber: Scalars['String'];
  /** Внутренний номер НЗ */
  workOrderNumber: Scalars['String'];
};

export type WorkOrderChangeNavDataSortInput = {
  /** Идентификатор объекта */
  id?: InputMaybe<SortEnumType>;
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<SortEnumType>;
  /** Название элемента */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор элемента */
  navLinkId?: InputMaybe<SortEnumType>;
  /** Дата подписания изма */
  signingDate?: InputMaybe<SortEnumType>;
  /** Статус изма */
  status?: InputMaybe<SortEnumType>;
  /** Внутренний номер изма */
  workOrderChangeNumber?: InputMaybe<SortEnumType>;
  /** Внутренний номер НЗ */
  workOrderNumber?: InputMaybe<SortEnumType>;
};

/** Объект/подобъект строительства Изма к НЗ */
export type WorkOrderChangeObjectData = {
  __typename?: 'WorkOrderChangeObjectData';
  /** Код шифра */
  code?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Есть ли у объекта факт */
  hasAcceptedCost: Scalars['Boolean'];
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Объект добавлен в изме НЗ */
  isAddedObject?: Maybe<Scalars['Boolean']>;
  /** Признак того, что у объекта нет дочерних элементов */
  isLeaf: Scalars['Boolean'];
  /** Признак требования удаления объекта */
  isRemovedObject?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор изма НЗ */
  workOrderChangeId: Scalars['Long'];
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор родительского объекта/подобъекта НЗ */
  workOrderParentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства НЗ */
  workOrderRootObjectId?: Maybe<Scalars['Long']>;
};

/** Объект/подобъект строительства Изма к НЗ */
export type WorkOrderChangeObjectDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeObjectDataFilterInput>>;
  /** Код шифра */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Есть ли у объекта факт */
  hasAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Объект добавлен в изме НЗ */
  isAddedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что у объекта нет дочерних элементов */
  isLeaf?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления объекта */
  isRemovedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeObjectDataFilterInput>>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор изма НЗ */
  workOrderChangeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта НЗ */
  workOrderParentId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор корневого объекта строительства НЗ */
  workOrderRootObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Объект/подобъект строительства Изма к НЗ */
export type WorkOrderChangeObjectDataInput = {
  /** Код шифра */
  code?: InputMaybe<Scalars['String']>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeDataInput;
  /** Есть ли у объекта факт */
  hasAcceptedCost: Scalars['Boolean'];
  /** Идентификатор объекта */
  id?: InputMaybe<Scalars['Long']>;
  /** Объект добавлен в изме НЗ */
  isAddedObject?: InputMaybe<Scalars['Boolean']>;
  /** Признак того, что у объекта нет дочерних элементов */
  isLeaf: Scalars['Boolean'];
  /** Признак требования удаления объекта */
  isRemovedObject?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор изма НЗ */
  workOrderChangeId: Scalars['Long'];
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор родительского объекта/подобъекта НЗ */
  workOrderParentId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства НЗ */
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
};

/** Пара идентификаторов объекта Изма к НЗ */
export type WorkOrderChangeObjectIdInput = {
  /** Идентификатор объекта Изма к НЗ */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

/** Модель добавления объекта в Изм */
export type WorkOrderChangeObjectInput = {
  /** Код шифра */
  code?: InputMaybe<Scalars['String']>;
  /** ID вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Имя объекта */
  name: Scalars['String'];
  /** Родитель для нового объекта, при null объект будет корневым */
  parentWorkOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** ID Изма */
  workOrderChangeId: Scalars['Long'];
};

/** Данные объекта Изма к НЗ */
export type WorkOrderChangeObjectItem = {
  __typename?: 'WorkOrderChangeObjectItem';
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Объект Договора */
  contractObject?: Maybe<ContractObjectData>;
  /** Признак наличия факта по объекту */
  hasAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта Договора */
  id?: Maybe<Scalars['Long']>;
  /** Признак создания объекта НЗ на этапе приемки */
  isActKC2WorkOrderObject?: Maybe<Scalars['Boolean']>;
  /** Признак добавления объекта в Изме */
  isAddedObject?: Maybe<Scalars['Boolean']>;
  /** Признак отсутствия объектов-наследников */
  isLeaf: Scalars['Boolean'];
  /** Признак требования удаления объекта */
  isRemovedObject?: Maybe<Scalars['Boolean']>;
  /** Наименование объекта */
  name: Scalars['String'];
  /** Уникальный идентификатор объекта изма */
  objectUniqueId?: Maybe<Scalars['String']>;
  /** Идентификатор родительского объекта/подобъекта Договора */
  parentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства Договора */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Уникальный идентификатор корневого объекта изма */
  rootObjectUniqueId?: Maybe<Scalars['String']>;
  /** Идентификатор Изма к НЗ */
  workOrderChangeId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор родительского объекта/подобъекта Изма */
  workOrderChangeParentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства Изма */
  workOrderChangeRootObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор НЗ */
  workOrderId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор родительского объекта/подобъекта НЗ */
  workOrderParentId?: Maybe<Scalars['Long']>;
  /** Идентификатор корневого объекта строительства НЗ */
  workOrderRootObjectId?: Maybe<Scalars['Long']>;
};

/** Данные объекта Изма к НЗ */
export type WorkOrderChangeObjectItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeObjectItemFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Объект Договора */
  contractObject?: InputMaybe<ContractObjectDataFilterInput>;
  /** Признак наличия факта по объекту */
  hasAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта Договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак создания объекта НЗ на этапе приемки */
  isActKC2WorkOrderObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак добавления объекта в Изме */
  isAddedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак отсутствия объектов-наследников */
  isLeaf?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления объекта */
  isRemovedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование объекта */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор объекта изма */
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeObjectItemFilterInput>>;
  /** Идентификатор родительского объекта/подобъекта Договора */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор корневого объекта строительства Договора */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Уникальный идентификатор корневого объекта изма */
  rootObjectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор Изма к НЗ */
  workOrderChangeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта Изма */
  workOrderChangeParentId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор корневого объекта строительства Изма */
  workOrderChangeRootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор родительского объекта/подобъекта НЗ */
  workOrderParentId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор корневого объекта строительства НЗ */
  workOrderRootObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные объекта Изма к НЗ */
export type WorkOrderChangeObjectItemSortInput = {
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Объект Договора */
  contractObject?: InputMaybe<ContractObjectDataSortInput>;
  /** Признак наличия факта по объекту */
  hasAcceptedCost?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Договора */
  id?: InputMaybe<SortEnumType>;
  /** Признак создания объекта НЗ на этапе приемки */
  isActKC2WorkOrderObject?: InputMaybe<SortEnumType>;
  /** Признак добавления объекта в Изме */
  isAddedObject?: InputMaybe<SortEnumType>;
  /** Признак отсутствия объектов-наследников */
  isLeaf?: InputMaybe<SortEnumType>;
  /** Признак требования удаления объекта */
  isRemovedObject?: InputMaybe<SortEnumType>;
  /** Наименование объекта */
  name?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор объекта изма */
  objectUniqueId?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта Договора */
  parentId?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства Договора */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Уникальный идентификатор корневого объекта изма */
  rootObjectUniqueId?: InputMaybe<SortEnumType>;
  /** Идентификатор Изма к НЗ */
  workOrderChangeId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта Изма */
  workOrderChangeParentId?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства Изма */
  workOrderChangeRootObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта НЗ */
  workOrderParentId?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства НЗ */
  workOrderRootObjectId?: InputMaybe<SortEnumType>;
};

/** Данные раздела итога по объекту Изма */
export type WorkOrderChangeObjectResultData = {
  __typename?: 'WorkOrderChangeObjectResultData';
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Список итогов Изма */
  costResultData: Array<WorkOrderCostResultData>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Название раздела */
  title: Scalars['String'];
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Данные раздела итога по объекту Изма */
export type WorkOrderChangeObjectResultDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeObjectResultDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Список итогов Изма */
  costResultData?: InputMaybe<ListFilterInputTypeOfWorkOrderCostResultDataFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeObjectResultDataFilterInput>>;
  /** Секция */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Название раздела */
  title?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные раздела итога по объекту Изма */
export type WorkOrderChangeObjectResultDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Секция */
  section?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Название раздела */
  title?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** Объект выбора Изма к НЗ */
export type WorkOrderChangeObjectSelectionItem = {
  __typename?: 'WorkOrderChangeObjectSelectionItem';
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR: Scalars['Boolean'];
  /** Признак наличия Актов КС-2 */
  hasActsKC2: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Содержит позиции прочих */
  hasOtherPrices: Scalars['Boolean'];
  /** Содержит позиции СМР */
  hasPrices: Scalars['Boolean'];
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Признак создания объекта НЗ на этапе приемки */
  isActKC2WorkOrderObject?: Maybe<Scalars['Boolean']>;
  /** Позиция добавлена в Изме к НЗ */
  isAddedObject?: Maybe<Scalars['Boolean']>;
  /** Признак использования в других Измах или НЗ */
  isInUse: Scalars['Boolean'];
  /** Признак включения в структуру Изма */
  isIncluded: Scalars['Boolean'];
  /** Признак требования удаления объекта */
  isRemovedObject?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: ContractObjectStatusEnum;
  /** Идентификатор Изма к НЗ */
  workOrderChangeId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор НЗ */
  workOrderId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Объект выбора Изма к НЗ */
export type WorkOrderChangeObjectSelectionItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeObjectSelectionItemFilterInput>>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия Актов КС-2 */
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Содержит позиции прочих */
  hasOtherPrices?: InputMaybe<BooleanOperationFilterInput>;
  /** Содержит позиции СМР */
  hasPrices?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак создания объекта НЗ на этапе приемки */
  isActKC2WorkOrderObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в Изме к НЗ */
  isAddedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак использования в других Измах или НЗ */
  isInUse?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак включения в структуру Изма */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления объекта */
  isRemovedObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeObjectSelectionItemFilterInput>>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<ContractObjectStatusEnumOperationFilterInput>;
  /** Идентификатор Изма к НЗ */
  workOrderChangeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Объект выбора Изма к НЗ */
export type WorkOrderChangeObjectSelectionItemSortInput = {
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR?: InputMaybe<SortEnumType>;
  /** Признак наличия Актов КС-2 */
  hasActsKC2?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Содержит позиции прочих */
  hasOtherPrices?: InputMaybe<SortEnumType>;
  /** Содержит позиции СМР */
  hasPrices?: InputMaybe<SortEnumType>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  /** Признак создания объекта НЗ на этапе приемки */
  isActKC2WorkOrderObject?: InputMaybe<SortEnumType>;
  /** Позиция добавлена в Изме к НЗ */
  isAddedObject?: InputMaybe<SortEnumType>;
  /** Признак использования в других Измах или НЗ */
  isInUse?: InputMaybe<SortEnumType>;
  /** Признак включения в структуру Изма */
  isIncluded?: InputMaybe<SortEnumType>;
  /** Признак требования удаления объекта */
  isRemovedObject?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор Изма к НЗ */
  workOrderChangeId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderChangeObjectId?: InputMaybe<SortEnumType>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

export type WorkOrderChangeObjectVolumesTransferInput = {
  /** Исходный сезон Изма к НЗ, из которого будут перенесены объёмы */
  sourceSeasonId: Scalars['Long'];
  targetData: Array<ObjectVolumeTransferDataInput>;
  /** Целевой сезон, в который будут перенесены объёмы */
  targetSeasonId: Scalars['Long'];
};

export type WorkOrderChangeOtherAggregationData = {
  __typename?: 'WorkOrderChangeOtherAggregationData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Лимиты прочей затраты Изма */
  limits: Array<WorkOrderChangeCostLimitData>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Раздел */
  status: ContractOtherStatusEnum;
};

export type WorkOrderChangeOtherAggregationDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeOtherAggregationDataFilterInput>>;
  /** Способ начисления */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId?: InputMaybe<LongOperationFilterInput>;
  /** Лимиты прочей затраты Изма */
  limits?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeCostLimitDataFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeOtherAggregationDataFilterInput>>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Раздел */
  status?: InputMaybe<ContractOtherStatusEnumOperationFilterInput>;
};

/** Входные данные для изменения прочих затрат в Изме */
export type WorkOrderChangeOtherCostDistributionInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherId: Scalars['Long'];
  /** Идентификаторы объектов и сезонов для распределения стоимости прочей затраты */
  objectList: Array<WorkOrderChangeConstructionObjectInput>;
  /** Список прочих затрат по сезонам Изма */
  otherSeasonPrices: Array<WorkOrderChangeOtherSeasonPriceInput>;
};

/** Данные прочей Изма */
export type WorkOrderChangeOtherCostItem = {
  __typename?: 'WorkOrderChangeOtherCostItem';
  /** Требуется ввод плана по сезонам */
  hasSeasonLimits: Scalars['Boolean'];
  /** Данные прочей */
  otherCost: ContractOtherCostBase;
  /** Лимиты прочей затраты наряд-заказа */
  seasonLimits?: Maybe<Array<WorkOrderChangeOtherCostSeasonLimitData>>;
  /** Признак сортировки */
  sortPart: Scalars['Int'];
  /** Данные объектов привязки прочих */
  workOrderChangeObjects: Array<WorkOrderChangeOtherCostObjectItem>;
};

/** Данные прочей Изма */
export type WorkOrderChangeOtherCostItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeOtherCostItemFilterInput>>;
  /** Требуется ввод плана по сезонам */
  hasSeasonLimits?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeOtherCostItemFilterInput>>;
  /** Данные прочей */
  otherCost?: InputMaybe<ContractOtherCostBaseFilterInput>;
  /** Лимиты прочей затраты наряд-заказа */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeOtherCostSeasonLimitDataFilterInput>;
  /** Признак сортировки */
  sortPart?: InputMaybe<IntOperationFilterInput>;
  /** Данные объектов привязки прочих */
  workOrderChangeObjects?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeOtherCostObjectItemFilterInput>;
};

/** Данные корневого объекта привязки прочей в Изме */
export type WorkOrderChangeOtherCostObjectItem = {
  __typename?: 'WorkOrderChangeOtherCostObjectItem';
  /** Признак возможности добавления прочей к объекту */
  canAddOther: Scalars['Boolean'];
  /** Признак возможности удаления прочей из объекта */
  canRemoveOther: Scalars['Boolean'];
  /** Идентификатор объекта договора */
  contractObjectId: Scalars['Long'];
  /** Признак наличия факта прочей у объекта */
  hasActualCost?: Maybe<Scalars['Boolean']>;
  /** Признак добавления прочей к объекту в работе */
  isActKC2Cost?: Maybe<Scalars['Boolean']>;
  /** Признак привязки прочей к объекту */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Наименование объекта */
  name: Scalars['String'];
  /** Обоснование позиции прочей */
  rationale?: Maybe<Scalars['String']>;
  /** Составной идентификатор корневого объекта Изма */
  rootObjectId: ObjectIds;
};

/** Данные корневого объекта привязки прочей в Изме */
export type WorkOrderChangeOtherCostObjectItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeOtherCostObjectItemFilterInput>>;
  /** Признак возможности добавления прочей к объекту */
  canAddOther?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак возможности удаления прочей из объекта */
  canRemoveOther?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  contractObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Признак наличия факта прочей у объекта */
  hasActualCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак добавления прочей к объекту в работе */
  isActKC2Cost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак привязки прочей к объекту */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование объекта */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeOtherCostObjectItemFilterInput>>;
  /** Обоснование позиции прочей */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Составной идентификатор корневого объекта Изма */
  rootObjectId?: InputMaybe<ObjectIdsFilterInput>;
};

/** Данные корневого объекта привязки прочей в Изме */
export type WorkOrderChangeOtherCostObjectItemInput = {
  /** Признак возможности добавления прочей к объекту */
  canAddOther: Scalars['Boolean'];
  /** Признак возможности удаления прочей из объекта */
  canRemoveOther: Scalars['Boolean'];
  /** Идентификатор объекта договора */
  contractObjectId: Scalars['Long'];
  /** Признак наличия факта прочей у объекта */
  hasActualCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак добавления прочей к объекту в работе */
  isActKC2Cost?: InputMaybe<Scalars['Boolean']>;
  /** Признак привязки прочей к объекту */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Наименование объекта */
  name: Scalars['String'];
  /** Обоснование позиции прочей */
  rationale?: InputMaybe<Scalars['String']>;
  /** Составной идентификатор корневого объекта Изма */
  rootObjectId: ObjectIdsInput;
};

/** Данные о Лимитах и остатках прочей затраты */
export type WorkOrderChangeOtherCostSeasonLimitData = {
  __typename?: 'WorkOrderChangeOtherCostSeasonLimitData';
  /** Факт по договору */
  actualCost?: Maybe<Scalars['Decimal']>;
  /** Диапазон отклонений */
  deviation?: Maybe<DeviationTipEnum>;
  /** Включено в НЗ по сезону */
  includedCost?: Maybe<Scalars['Decimal']>;
  /** Признак включения прочей в НЗ */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Лимит по договору */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по договору */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона Изма */
  workOrderChangeSeasonId: Scalars['Long'];
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: Maybe<Scalars['Long']>;
  /** Сезон */
  year: Scalars['Short'];
};

/** Данные о Лимитах и остатках прочей затраты */
export type WorkOrderChangeOtherCostSeasonLimitDataFilterInput = {
  /** Факт по договору */
  actualCost?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderChangeOtherCostSeasonLimitDataFilterInput>>;
  /** Диапазон отклонений */
  deviation?: InputMaybe<NullableOfDeviationTipEnumOperationFilterInput>;
  /** Включено в НЗ по сезону */
  includedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Признак включения прочей в НЗ */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeOtherCostSeasonLimitDataFilterInput>>;
  /** Лимит по договору */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по договору */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сезона Изма */
  workOrderChangeSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Прочая затрата Изма с данными распределения лимитов по сезонам и объектам */
export type WorkOrderChangeOtherDistributionData = {
  __typename?: 'WorkOrderChangeOtherDistributionData';
  /** Прочая затрата договора */
  contractOtherCost: ContractOtherCostBaseData;
  /** Лимиты прочей с данными распределения по сезонам Изма */
  limits: Array<WorkOrderChangeCostLimitDistributionData>;
  /** Данные распределения прочей затраты по объектам и сезонам */
  objectSeasonDistributions: Array<WorkOrderChangeOtherPriceCostData>;
  /** Объекты Изма, по которым распределена прочая затрата */
  objects: Array<WorkOrderChangeOtherCostObjectItem>;
  /** Идентификатор прочей затраты Изма */
  workOrderChangeOtherPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: Maybe<Scalars['Long']>;
};

/** Прочая затрата Изма с данными распределения лимитов по сезонам и объектам */
export type WorkOrderChangeOtherDistributionDataInput = {
  /** Прочая затрата договора */
  contractOtherCost: ContractOtherCostBaseDataInput;
  /** Лимиты прочей с данными распределения по сезонам Изма */
  limits: Array<WorkOrderChangeCostLimitDistributionDataInput>;
  /** Данные распределения прочей затраты по объектам и сезонам */
  objectSeasonDistributions: Array<WorkOrderChangeOtherPriceCostDataInput>;
  /** Объекты Изма, по которым распределена прочая затрата */
  objects: Array<WorkOrderChangeOtherCostObjectItemInput>;
  /** Идентификатор прочей затраты Изма */
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};

/** Данные по добавляемой позиции */
export type WorkOrderChangeOtherObjectInput = {
  /** Идентификатор прочей */
  objectId: ObjectIdsInput;
  /** Обоснование добавления (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Данные распределения прочей затраты по объектам и сезонам Изма к НЗ */
export type WorkOrderChangeOtherPriceCalcInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в Изм */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона НЗ */
  seasonId: Scalars['Long'];
  /** Идентификаторы объектов Изма для распределения */
  workOrderChangeObjectItemIds: Array<WorkOrderChangeObjectIdInput>;
};

/** Объект Изма с данными распределения прочей затраты */
export type WorkOrderChangeOtherPriceCostData = {
  __typename?: 'WorkOrderChangeOtherPriceCostData';
  /** Стоимость позиции прочей */
  cost?: Maybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Включено в Изм */
  isIncluded: Scalars['Boolean'];
  /** Идентификатор cезона */
  seasonId: Scalars['Long'];
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Объект Изма с данными распределения прочей затраты */
export type WorkOrderChangeOtherPriceCostDataInput = {
  /** Стоимость позиции прочей */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  /** Включено в Изм */
  isIncluded: Scalars['Boolean'];
  /** Идентификатор cезона */
  seasonId: Scalars['Long'];
  /** Идентификатор объекта Изма */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

export type WorkOrderChangeOtherPriceData = {
  __typename?: 'WorkOrderChangeOtherPriceData';
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты НЗ или Идентификатор прочей затраты Изма к НЗ со знаком "-" */
  clientId?: Maybe<Scalars['Long']>;
  /** Идентификатор прочей затраты договора */
  contractOtherId: Scalars['Long'];
  /** Признак наличия согласованной стоимости */
  hasAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам изма */
  hasEmptySeasonCost?: Maybe<Scalars['Boolean']>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan: Scalars['Boolean'];
  /** Строка добавлена для акта КС-2 */
  isActKC2Price?: Maybe<Scalars['Boolean']>;
  /** Позиция добавлена в изме НЗ */
  isAddedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак требования удаления позиции */
  isRemovedPrice?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Код прочей затраты договора */
  otherCostKey?: Maybe<Scalars['String']>;
  /** Обоснование добавления прочей в Изм (Примечание) */
  rationale?: Maybe<Scalars['String']>;
  /** Список прочих затрат по сезонам */
  seasonPrices?: Maybe<Array<WorkOrderChangeOtherSeasonPriceData>>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status?: Maybe<ContractOtherStatusEnum>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  totalDeviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от плана */
  totalDeviationTip?: Maybe<DeviationTipEnum>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: Maybe<Scalars['Long']>;
};

export type WorkOrderChangeOtherPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeOtherPriceDataFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор прочей затраты НЗ или Идентификатор прочей затраты Изма к НЗ со знаком "-" */
  clientId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор прочей затраты договора */
  contractOtherId?: InputMaybe<LongOperationFilterInput>;
  /** Признак наличия согласованной стоимости */
  hasAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам изма */
  hasEmptySeasonCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: InputMaybe<BooleanOperationFilterInput>;
  /** Строка добавлена для акта КС-2 */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак требования удаления позиции */
  isRemovedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeOtherPriceDataFilterInput>>;
  /** Код прочей затраты договора */
  otherCostKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Обоснование добавления прочей в Изм (Примечание) */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Список прочих затрат по сезонам */
  seasonPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeOtherSeasonPriceDataFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfContractOtherStatusEnumOperationFilterInput>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение расходов от плана */
  totalDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Диапазон отклонения остатка от плана */
  totalDeviationTip?: InputMaybe<NullableOfDeviationTipEnumOperationFilterInput>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<LongOperationFilterInput>;
};

/** Составной идентификатор прочей затраты Изма к НЗ */
export type WorkOrderChangeOtherPriceIdsInput = {
  /** Идентификатор прочей затраты Изма */
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};

/** Входные данные для добавления прочей затраты в Изм */
export type WorkOrderChangeOtherPriceInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherId: Scalars['Long'];
  /** Идентификаторы объектов строительства Изма для распределения стоимости прочих затрат */
  objectIdList?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификаторы объектов строительства Изма для распределения стоимости прочих затрат */
  objectIdsList: Array<WorkOrderChangeObjectIdInput>;
  /** Список прочих затрат по сезонам Изма */
  otherSeasonPrices: Array<WorkOrderChangeOtherSeasonPriceInput>;
  /** Обоснование добавления прочей в Изм (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Данные для редактирования обоснования добавления прочей в Изм к НЗ (Примечания) */
export type WorkOrderChangeOtherPriceRationaleData = {
  __typename?: 'WorkOrderChangeOtherPriceRationaleData';
  /** Наименование прочей */
  name: Scalars['String'];
  /** Обоснование добавления прочей в Изм к НЗ (Примечание) */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор строки прочей затраты Изма */
  workOrderChangeOtherPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор строки прочей затраты НЗ */
  workOrderOtherPriceId?: Maybe<Scalars['Long']>;
};

/** Данные для редактирования обоснования добавления прочей в Изм к НЗ (Примечания) */
export type WorkOrderChangeOtherPriceRationaleDataInput = {
  /** Наименование прочей */
  name: Scalars['String'];
  /** Обоснование добавления прочей в Изм к НЗ (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор строки прочей затраты Изма */
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор строки прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
};

/** Данные для обновления обоснования добавления прочей в Изм к НЗ */
export type WorkOrderChangeOtherPriceRationaleUpdateInput = {
  /** Обоснование добавления прочей в Изм к НЗ */
  rationale?: InputMaybe<Scalars['String']>;
};

export type WorkOrderChangeOtherSeasonPriceData = {
  __typename?: 'WorkOrderChangeOtherSeasonPriceData';
  /** Стоимость выполненных работ по сезону */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от плана */
  deviationTip?: Maybe<DeviationTipEnum>;
  /** Ошибки вычисления значения прочей */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Флаг Только для чтения */
  isReadOnly?: Maybe<Scalars['Boolean']>;
  /** Стоимость работ по сезону */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по сезону */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона Изма к НЗ */
  workOrderChangeSeasonId?: Maybe<Scalars['Long']>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор сезона НЗ */
  workOrderSeasonId?: Maybe<Scalars['Long']>;
  /** Год */
  year: Scalars['Short'];
};

export type WorkOrderChangeOtherSeasonPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeOtherSeasonPriceDataFilterInput>>;
  /** Стоимость выполненных работ по сезону */
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Диапазон отклонения остатка от плана */
  deviationTip?: InputMaybe<NullableOfDeviationTipEnumOperationFilterInput>;
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Только для чтения */
  isReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeOtherSeasonPriceDataFilterInput>>;
  /** Стоимость работ по сезону */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по сезону */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор прочей затраты Изма к НЗ */
  workOrderChangeOtherPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона Изма к НЗ */
  workOrderChangeSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор прочей затраты НЗ */
  workOrderOtherPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона НЗ */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Год */
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** Входные данные для добавления прочей затраты по сезонам */
export type WorkOrderChangeOtherSeasonPriceInput = {
  /** Стоимость, которую необходимо включить в Изм */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Включено в Изм */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation?: InputMaybe<Scalars['Boolean']>;
  /** Идентификатор сезона Изма */
  seasonId: Scalars['Long'];
};

/** Входные данные для добавления прочих затрат в Изм */
export type WorkOrderChangeOthersInput = {
  /** Идентификатор типа строительства */
  constructionTypeId: Scalars['Int'];
  /** Список прочих затрат для добаления в Изм */
  otherPrices: Array<WorkOrderChangeOtherPriceInput>;
  /** Идентификатор Изма */
  workOrderChangeId: Scalars['Long'];
};

export type WorkOrderChangePriceCodeFilterData = {
  __typename?: 'WorkOrderChangePriceCodeFilterData';
  /** Код позиции */
  code: Scalars['String'];
  /** Код родительской позиции */
  parentCode: Scalars['String'];
};

export type WorkOrderChangePriceCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangePriceCodeFilterDataFilterInput>>;
  /** Код позиции */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangePriceCodeFilterDataFilterInput>>;
  /** Код родительской позиции */
  parentCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type WorkOrderChangePriceCodeFilterDataSortInput = {
  /** Код позиции */
  code?: InputMaybe<SortEnumType>;
  /** Код родительской позиции */
  parentCode?: InputMaybe<SortEnumType>;
};

export type WorkOrderChangePriceData = {
  __typename?: 'WorkOrderChangePriceData';
  chapter: ChapterEnum;
  clientId?: Maybe<Scalars['Long']>;
  clientParentId?: Maybe<Scalars['Long']>;
  code: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  /** Прозиция имеет фактическое выполнение */
  hasAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного объема по сезонам изма */
  hasEmptySeasonVolume?: Maybe<Scalars['Boolean']>;
  /** Позиция, которая была добавлене для актов НЗ, НЗ в статусе в "В работе" */
  isActKC2Price?: Maybe<Scalars['Boolean']>;
  /** Позиция добавлена в изме */
  isAddedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак заблокированной позиции */
  isBlockedPrice?: Maybe<Scalars['Boolean']>;
  /** Свойство определяет, что позиция является коэффициентом */
  isCoefficient: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Метка позиции, котороя должна быть удалена из НЗ */
  isRemovedPrice?: Maybe<Scalars['Boolean']>;
  /** Код МТР */
  mtrRowKey?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priceListId: Scalars['Long'];
  /** Обоснование добавления расценки/МТР/коэффициента в Изм (Примечание) */
  rationale?: Maybe<Scalars['String']>;
  seasonPrices?: Maybe<Array<WorkOrderChangeSeasonPriceData>>;
  shortName?: Maybe<Scalars['String']>;
  status: WorkOrderPriceStatusEnum;
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  totalCompletedVolume?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  totalDeviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от плана */
  totalDeviationTip?: Maybe<DeviationTipEnum>;
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  totalPlanVolume?: Maybe<Scalars['Decimal']>;
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  totalRemainderVolume?: Maybe<Scalars['Decimal']>;
  type: WorkOrderPriceTypeEnum;
  typeVal: Scalars['Int'];
  uerCode: Scalars['String'];
  uerCodeId?: Maybe<Scalars['Long']>;
  uerId: Scalars['Long'];
  unit: Scalars['String'];
  unitCost: Scalars['Decimal'];
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Выполнено (Кол-во) */
  workCompleted?: Maybe<Scalars['Decimal']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum: WorkInSumEnum;
  /** К перехода из расценки */
  workKindWorkRatio?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  workOrderChangeObjectParentId?: Maybe<Scalars['Long']>;
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  workOrderChangePriceParentId?: Maybe<Scalars['Long']>;
  workOrderObjectId?: Maybe<Scalars['Long']>;
  workOrderPriceId?: Maybe<Scalars['Long']>;
  workOrderPriceParentId?: Maybe<Scalars['Long']>;
  workOrderRootObjectId?: Maybe<Scalars['Long']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода позиции */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Остаток (Кол-во) */
  workReminder?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

export type WorkOrderChangePriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangePriceDataFilterInput>>;
  chapter?: InputMaybe<ChapterEnumOperationFilterInput>;
  clientId?: InputMaybe<LongOperationFilterInput>;
  clientParentId?: InputMaybe<LongOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Прозиция имеет фактическое выполнение */
  hasAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного объема по сезонам изма */
  hasEmptySeasonVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция, которая была добавлене для актов НЗ, НЗ в статусе в "В работе" */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме */
  isAddedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак заблокированной позиции */
  isBlockedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Свойство определяет, что позиция является коэффициентом */
  isCoefficient?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Метка позиции, котороя должна быть удалена из НЗ */
  isRemovedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Код МТР */
  mtrRowKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangePriceDataFilterInput>>;
  priceListId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование добавления расценки/МТР/коэффициента в Изм (Примечание) */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  seasonPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeSeasonPriceDataFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  status?: InputMaybe<WorkOrderPriceStatusEnumOperationFilterInput>;
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  totalCompletedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение расходов от плана */
  totalDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Диапазон отклонения остатка от плана */
  totalDeviationTip?: InputMaybe<NullableOfDeviationTipEnumOperationFilterInput>;
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  totalRemainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<WorkOrderPriceTypeEnumOperationFilterInput>;
  typeVal?: InputMaybe<IntOperationFilterInput>;
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  uerId?: InputMaybe<LongOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено (Кол-во) */
  workCompleted?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<WorkInSumEnumOperationFilterInput>;
  /** К перехода из расценки */
  workKindWorkRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  workOrderChangeObjectParentId?: InputMaybe<LongOperationFilterInput>;
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  workOrderChangePriceParentId?: InputMaybe<LongOperationFilterInput>;
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
  workOrderPriceParentId?: InputMaybe<LongOperationFilterInput>;
  workOrderRootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода позиции */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток (Кол-во) */
  workReminder?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type WorkOrderChangePriceIds = {
  __typename?: 'WorkOrderChangePriceIds';
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  workOrderPriceId?: Maybe<Scalars['Long']>;
};

export type WorkOrderChangePriceIdsInput = {
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};

/** Модель позиции Изма НЗ */
export type WorkOrderChangePriceItem = {
  __typename?: 'WorkOrderChangePriceItem';
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Глава позиции */
  chapter?: Maybe<ChapterEnum>;
  /** Уникальный идентификатор позиции */
  clientId: Scalars['String'];
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор типа сущности */
  entityTypeId?: Maybe<Scalars['Int']>;
  /** Название типа сущности */
  entityTypeName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор типа сущности */
  entityTypeUniqueId?: Maybe<Scalars['String']>;
  /**
   * Идентификар сущности, на которую ссылается позиция, в договоре.
   *             Либо:
   *             - идентификатор объекта договора
   *             - идентификатор в прейскуранте
   *             - идентификатор прочей договора
   */
  entryId?: Maybe<Scalars['Long']>;
  /** Прозиция имеет фактическое выполнение */
  hasAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: Maybe<Scalars['Boolean']>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: Maybe<Scalars['Boolean']>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: Maybe<Scalars['Boolean']>;
  /** Позиция добавлена в изме НЗ */
  isAddedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак заблокированной позиции */
  isBlockedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак строки части данных раздела прочих НЗ */
  isOtherGroup: Scalars['Boolean'];
  /** Признак строки части данных позиции прочих НЗ */
  isOtherItem: Scalars['Boolean'];
  /** Признак строки части данных корневого объекта НЗ */
  isRootObject: Scalars['Boolean'];
  /** Признак строки части данных позиции СМР НЗ */
  isSMRItem: Scalars['Boolean'];
  /** Идентификатор сущности позиции */
  itemId: Scalars['Long'];
  /** Код МТР */
  mtrKey?: Maybe<Scalars['String']>;
  /** Наимеование */
  name?: Maybe<Scalars['String']>;
  /** Код объекта\подобъекта */
  objectCode?: Maybe<Scalars['String']>;
  /** Название онечного объекта */
  objectName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор конечного объекта */
  objectUniqueId?: Maybe<Scalars['String']>;
  /** Код прочей */
  otherCostKey?: Maybe<Scalars['String']>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: Maybe<Scalars['String']>;
  /** Название корневого объекта */
  rootObjectName: Scalars['String'];
  /** Уникальный идентификатор корневого объекта */
  rootObjectUniqueId?: Maybe<Scalars['String']>;
  /** Плановые и фактические хначения по сезонам по пасценке */
  seasonValues?: Maybe<Array<WorkOrderChangePriceSeasonValue>>;
  /** Признак сортировки групп Прочих */
  sortOtherPart?: Maybe<Scalars['Int']>;
  /** Признак сортировки частей НЗ */
  sortPart?: Maybe<Scalars['Int']>;
  /** Признак сортировки типов позиций СМР */
  sortSMRPart?: Maybe<Scalars['Int']>;
  /** Статус */
  status?: Maybe<WorkOrderPriceStatusEnum>;
  /** Статус в форме строки */
  statusTip?: Maybe<Scalars['String']>;
  /** Общая фактическая стоимость по позиции */
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  /** Общий фактический выполненный объекм по позиции */
  totalCompletedVolume?: Maybe<Scalars['Decimal']>;
  /** Общая плановая стоимость по позиции */
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  /** Общий плановый объекм по позиции */
  totalPlanVolume?: Maybe<Scalars['Decimal']>;
  /** Общий остаток стоимости по позиции */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  /** Остаток общего плана по позиции */
  totalRemainderVolume?: Maybe<Scalars['Decimal']>;
  /** Тип позиции */
  type?: Maybe<WorkOrderPriceTypeEnum>;
  /** Шифр расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerCode?: Maybe<Scalars['String']>;
  /** Идентификатор позиции расценки УЕР для позиции самой расценки и ее потомков */
  uerCodeId?: Maybe<Scalars['Long']>;
  /** Идентификатор расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerId?: Maybe<Scalars['Long']>;
  /** Идентификатор */
  uniqueId?: Maybe<Scalars['String']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Выполнено (Кол-во) */
  workCompleted?: Maybe<Scalars['Decimal']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: Maybe<WorkInSumEnum>;
  /** К перехода из расценки */
  workKindWorkRatio?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** Id конечного объекта из Изма */
  workOrderChangeObjectId?: Maybe<Scalars['Long']>;
  /** Id позиции из Изма */
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  /** Id корневого объекта из Изма */
  workOrderChangeRootObjectId?: Maybe<Scalars['Long']>;
  /** Id конечного объекта из НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
  /** Id позиции из НЗ */
  workOrderPriceId?: Maybe<Scalars['Long']>;
  /** Id корневого объекта из НЗ */
  workOrderRootObjectId?: Maybe<Scalars['Long']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода позиции */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Остаток (Кол-во) */
  workReminder?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

/** Модель позиции Изма НЗ */
export type WorkOrderChangePriceItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangePriceItemFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Глава позиции */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Уникальный идентификатор позиции */
  clientId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор типа сущности */
  entityTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Название типа сущности */
  entityTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор типа сущности */
  entityTypeUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /**
   * Идентификар сущности, на которую ссылается позиция, в договоре.
   *             Либо:
   *             - идентификатор объекта договора
   *             - идентификатор в прейскуранте
   *             - идентификатор прочей договора
   */
  entryId?: InputMaybe<LongOperationFilterInput>;
  /** Прозиция имеет фактическое выполнение */
  hasAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Позиция добавлена в изме НЗ */
  isAddedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак заблокированной позиции */
  isBlockedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных раздела прочих НЗ */
  isOtherGroup?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных позиции прочих НЗ */
  isOtherItem?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных корневого объекта НЗ */
  isRootObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных позиции СМР НЗ */
  isSMRItem?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор сущности позиции */
  itemId?: InputMaybe<LongOperationFilterInput>;
  /** Код МТР */
  mtrKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наимеование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код объекта\подобъекта */
  objectCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Название онечного объекта */
  objectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор конечного объекта */
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangePriceItemFilterInput>>;
  /** Код прочей */
  otherCostKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Название корневого объекта */
  rootObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор корневого объекта */
  rootObjectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Плановые и фактические хначения по сезонам по пасценке */
  seasonValues?: InputMaybe<ListFilterInputTypeOfWorkOrderChangePriceSeasonValueFilterInput>;
  /** Признак сортировки групп Прочих */
  sortOtherPart?: InputMaybe<IntOperationFilterInput>;
  /** Признак сортировки частей НЗ */
  sortPart?: InputMaybe<IntOperationFilterInput>;
  /** Признак сортировки типов позиций СМР */
  sortSMRPart?: InputMaybe<IntOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfWorkOrderPriceStatusEnumOperationFilterInput>;
  /** Статус в форме строки */
  statusTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Общая фактическая стоимость по позиции */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий фактический выполненный объекм по позиции */
  totalCompletedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Общая плановая стоимость по позиции */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий плановый объекм по позиции */
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий остаток стоимости по позиции */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток общего плана по позиции */
  totalRemainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Тип позиции */
  type?: InputMaybe<NullableOfWorkOrderPriceTypeEnumOperationFilterInput>;
  /** Шифр расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор позиции расценки УЕР для позиции самой расценки и ее потомков */
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор */
  uniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено (Кол-во) */
  workCompleted?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<NullableOfWorkInSumEnumOperationFilterInput>;
  /** К перехода из расценки */
  workKindWorkRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id конечного объекта из Изма */
  workOrderChangeObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Id позиции из Изма */
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  /** Id корневого объекта из Изма */
  workOrderChangeRootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Id конечного объекта из НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Id позиции из НЗ */
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Id корневого объекта из НЗ */
  workOrderRootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода позиции */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток (Кол-во) */
  workReminder?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные для редактирования обоснования добавления расценки/МТР/коэффициента в Изм к НЗ (Примечания) */
export type WorkOrderChangePriceRationaleData = {
  __typename?: 'WorkOrderChangePriceRationaleData';
  /** Шифр расценки/МТР/коэффициента */
  code: Scalars['String'];
  /** Наименование расценки/МТР/коэффициента */
  name: Scalars['String'];
  /** Обоснование добавления расценки/МТР/коэффициента в Изм к НЗ (Примечание) */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор строки прайса Изма */
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  /** Идентификатор строки прайса НЗ */
  workOrderPriceId?: Maybe<Scalars['Long']>;
};

/** Данные для редактирования обоснования добавления расценки/МТР/коэффициента в Изм к НЗ (Примечания) */
export type WorkOrderChangePriceRationaleDataInput = {
  /** Шифр расценки/МТР/коэффициента */
  code: Scalars['String'];
  /** Наименование расценки/МТР/коэффициента */
  name: Scalars['String'];
  /** Обоснование добавления расценки/МТР/коэффициента в Изм к НЗ (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор строки прайса Изма */
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  /** Идентификатор строки прайса НЗ */
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
};

/** Данные для обновления обоснования добавления расценки/МТР/коэффициента в Изм к НЗ */
export type WorkOrderChangePriceRationaleUpdateInput = {
  /** Обоснование добавления расценки/МТР/коэффициента в Изм к НЗ */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Модель значенийпозиции Изма НЗ */
export type WorkOrderChangePriceSeasonValue = {
  __typename?: 'WorkOrderChangePriceSeasonValue';
  /** Фактическая стоимость за сезон */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** Фактически выполненный объем за сезон */
  completedVolume?: Maybe<Scalars['Decimal']>;
  /** Ошибки расчета по формуле */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибкок расчета по формуле */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Признак вида позиции: СМР, Прочие */
  itemTip: Scalars['Int'];
  /** Плановая стоимость в сезоне для прочих */
  planCost?: Maybe<Scalars['Decimal']>;
  planTerms?: Maybe<Array<Scalars['Decimal']>>;
  /** Плановое значение объема в сезоне */
  planVolume?: Maybe<Scalars['Decimal']>;
  /** Остаток стоимости за сезон */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Остаток объема за сезон */
  remainderVolume?: Maybe<Scalars['Decimal']>;
  /** Год сезона */
  seasonYear: Scalars['Int'];
  /** Id позиции из Изма */
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  /** Id сезона из Изма */
  workOrderChangeSeasonId?: Maybe<Scalars['Long']>;
  /** Id позиции из НЗ */
  workOrderPriceId?: Maybe<Scalars['Long']>;
  /** Id сезона из НЗ */
  workOrderSeasonId?: Maybe<Scalars['Long']>;
};

/** Модель значенийпозиции Изма НЗ */
export type WorkOrderChangePriceSeasonValueFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangePriceSeasonValueFilterInput>>;
  /** Фактическая стоимость за сезон */
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Фактически выполненный объем за сезон */
  completedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Ошибки расчета по формуле */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия ошибкок расчета по формуле */
  hasErrors?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак вида позиции: СМР, Прочие */
  itemTip?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangePriceSeasonValueFilterInput>>;
  /** Плановая стоимость в сезоне для прочих */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planTerms?: InputMaybe<ListDecimalOperationFilterInput>;
  /** Плановое значение объема в сезоне */
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток стоимости за сезон */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток объема за сезон */
  remainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Год сезона */
  seasonYear?: InputMaybe<IntOperationFilterInput>;
  /** Id позиции из Изма */
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  /** Id сезона из Изма */
  workOrderChangeSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Id позиции из НЗ */
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
  /** Id сезона из НЗ */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные раздела итога Изма */
export type WorkOrderChangeResultData = {
  __typename?: 'WorkOrderChangeResultData';
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор раздела */
  resultSectionId: Scalars['Long'];
  /** Список итогов по сезонам Изма */
  seasonResults: Array<WorkOrderChangeSeasonResultData>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Название раздела c итогами наряд-заказа */
  title: Scalars['String'];
  /** Выполнено по наряд-заказу */
  totalCompletedCost: Scalars['Decimal'];
  /** План по наряд-заказу */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по наряд-заказу */
  totalRemainderCost: Scalars['Decimal'];
};

/** Данные раздела итога Изма */
export type WorkOrderChangeResultDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeResultDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeResultDataFilterInput>>;
  /** Идентификатор раздела */
  resultSectionId?: InputMaybe<LongOperationFilterInput>;
  /** Список итогов по сезонам Изма */
  seasonResults?: InputMaybe<ListFilterInputTypeOfWorkOrderChangeSeasonResultDataFilterInput>;
  /** Секция */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Название раздела c итогами наряд-заказа */
  title?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено по наряд-заказу */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** План по наряд-заказу */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные раздела итога Изма */
export type WorkOrderChangeResultDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  resultSectionId?: InputMaybe<SortEnumType>;
  /** Секция */
  section?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Название раздела c итогами наряд-заказа */
  title?: InputMaybe<SortEnumType>;
  /** Выполнено по наряд-заказу */
  totalCompletedCost?: InputMaybe<SortEnumType>;
  /** План по наряд-заказу */
  totalPlanCost?: InputMaybe<SortEnumType>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<SortEnumType>;
};

export type WorkOrderChangeSeasonData = {
  __typename?: 'WorkOrderChangeSeasonData';
  id: Scalars['Long'];
  workOrderSeasonId?: Maybe<Scalars['Long']>;
  year: Scalars['Short'];
};

export type WorkOrderChangeSeasonDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeSeasonDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeSeasonDataFilterInput>>;
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  year?: InputMaybe<ShortOperationFilterInput>;
};

export type WorkOrderChangeSeasonDataInput = {
  id: Scalars['Long'];
  workOrderSeasonId?: InputMaybe<Scalars['Long']>;
  year: Scalars['Short'];
};

export type WorkOrderChangeSeasonPriceData = {
  __typename?: 'WorkOrderChangeSeasonPriceData';
  completedCost?: Maybe<Scalars['Decimal']>;
  completedVolume?: Maybe<Scalars['Decimal']>;
  /** Отклонение расходов от плана */
  deviation?: Maybe<DeviationEnum>;
  /** Диапазон отклонения остатка от плана */
  deviationTip?: Maybe<DeviationTipEnum>;
  planCost?: Maybe<Scalars['Decimal']>;
  planVolume?: Maybe<Scalars['Decimal']>;
  planVolumeTerms?: Maybe<Array<Scalars['Decimal']>>;
  remainderCost?: Maybe<Scalars['Decimal']>;
  remainderVolume?: Maybe<Scalars['Decimal']>;
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  workOrderChangeSeasonId?: Maybe<Scalars['Long']>;
  workOrderPriceId?: Maybe<Scalars['Long']>;
  workOrderSeasonId?: Maybe<Scalars['Long']>;
  year: Scalars['Short'];
};

export type WorkOrderChangeSeasonPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeSeasonPriceDataFilterInput>>;
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  completedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение расходов от плана */
  deviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Диапазон отклонения остатка от плана */
  deviationTip?: InputMaybe<NullableOfDeviationTipEnumOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeSeasonPriceDataFilterInput>>;
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  planVolumeTerms?: InputMaybe<ListDecimalOperationFilterInput>;
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  remainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  workOrderChangePriceId?: InputMaybe<LongOperationFilterInput>;
  workOrderChangeSeasonId?: InputMaybe<LongOperationFilterInput>;
  workOrderPriceId?: InputMaybe<LongOperationFilterInput>;
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  year?: InputMaybe<ShortOperationFilterInput>;
};

export type WorkOrderChangeSeasonPriceRemainder = {
  __typename?: 'WorkOrderChangeSeasonPriceRemainder';
  clientId?: Maybe<Scalars['Long']>;
  code: Scalars['String'];
  name: Scalars['String'];
  reminderData: Array<SeasonReminderData>;
  type: WorkOrderPriceTypeEnum;
  workOrderChangePriceId?: Maybe<Scalars['Long']>;
  workOrderPriceId?: Maybe<Scalars['Long']>;
};

/** Данные итога Изма по сезону */
export type WorkOrderChangeSeasonResultData = {
  __typename?: 'WorkOrderChangeSeasonResultData';
  /** Идентификатор сезона Изма */
  seasonId: Scalars['Long'];
  /** Значение итога */
  value: Scalars['Decimal'];
};

/** Данные итога Изма по сезону */
export type WorkOrderChangeSeasonResultDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeSeasonResultDataFilterInput>>;
  or?: InputMaybe<Array<WorkOrderChangeSeasonResultDataFilterInput>>;
  /** Идентификатор сезона Изма */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Значение итога */
  value?: InputMaybe<DecimalOperationFilterInput>;
};

/** Строка итога по сезону Изма к НЗ */
export type WorkOrderChangeSeasonTotalData = {
  __typename?: 'WorkOrderChangeSeasonTotalData';
  /** Выполнено по сезону Изма */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** План по сезону Изма */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона Изма */
  seasonId: Scalars['Long'];
};

/** Строка итога по сезону Изма к НЗ */
export type WorkOrderChangeSeasonTotalDataInput = {
  /** Выполнено по сезону Изма */
  completedCost?: InputMaybe<Scalars['Decimal']>;
  /** План по сезону Изма */
  planCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона Изма */
  seasonId: Scalars['Long'];
};

/** Статус дополнительного соглашения */
export type WorkOrderChangeStatusData = {
  __typename?: 'WorkOrderChangeStatusData';
  /** Список статусов, возможных для перехода из Status */
  followers: Array<WorkOrderChangeStatusEnum>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
};

/** Статус дополнительного соглашения */
export type WorkOrderChangeStatusDataInput = {
  /** Список статусов, возможных для перехода из Status */
  followers: Array<WorkOrderChangeStatusEnum>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
};

export enum WorkOrderChangeStatusEnum {
  /** Согласован */
  Approved = 'APPROVED',
  /** На согласовании */
  Approving = 'APPROVING',
  /** На формировании */
  OnFormation = 'ON_FORMATION'
}

export type WorkOrderChangeStatusEnumOperationFilterInput = {
  eq?: InputMaybe<WorkOrderChangeStatusEnum>;
  in?: InputMaybe<Array<WorkOrderChangeStatusEnum>>;
  neq?: InputMaybe<WorkOrderChangeStatusEnum>;
  nin?: InputMaybe<Array<WorkOrderChangeStatusEnum>>;
};

/** Строка итога Изма к НЗ */
export type WorkOrderChangeTotalData = {
  __typename?: 'WorkOrderChangeTotalData';
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Список строк итогов по сезонам Изма к НЗ */
  seasonTotals: Array<WorkOrderChangeSeasonTotalData>;
  /** Выполнено по НЗ */
  totalCompletedCost: Scalars['Decimal'];
  /** План по НЗ */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по НЗ */
  totalRemainderCost: Scalars['Decimal'];
};

/** Строка итога Изма к НЗ */
export type WorkOrderChangeTotalDataInput = {
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Список строк итогов по сезонам Изма к НЗ */
  seasonTotals: Array<WorkOrderChangeSeasonTotalDataInput>;
  /** Выполнено по НЗ */
  totalCompletedCost: Scalars['Decimal'];
  /** План по НЗ */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по НЗ */
  totalRemainderCost: Scalars['Decimal'];
};

/** Данные расценки Изма НЗ */
export type WorkOrderChangeUerItemData = {
  __typename?: 'WorkOrderChangeUerItemData';
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Шифр */
  code: Scalars['String'];
  groupFullName: Scalars['String'];
  /** Наименование подраздела */
  groupId: Scalars['Long'];
  /** Наименование подраздела */
  groupName: Scalars['String'];
  /** Идентификатор расценки */
  id: Scalars['Long'];
  /** Примечание */
  justification?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор раздела */
  sectionId: Scalars['Long'];
  /** Наименование раздела */
  sectionName: Scalars['String'];
  /** Статус */
  status: UerRecordStatusEnum;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость единицы измерения */
  unitCost?: Maybe<Scalars['Decimal']>;
};

/** Данные расценки Изма НЗ */
export type WorkOrderChangeUerItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderChangeUerItemDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupFullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование подраздела */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование подраздела */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор расценки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Примечание */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderChangeUerItemDataFilterInput>>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус */
  status?: InputMaybe<UerRecordStatusEnumOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы измерения */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные расценки Изма НЗ */
export type WorkOrderChangeUerItemDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  groupFullName?: InputMaybe<SortEnumType>;
  /** Наименование подраздела */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование подраздела */
  groupName?: InputMaybe<SortEnumType>;
  /** Идентификатор расценки */
  id?: InputMaybe<SortEnumType>;
  /** Примечание */
  justification?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<SortEnumType>;
  /** Наименование раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы измерения */
  unitCost?: InputMaybe<SortEnumType>;
};

export type WorkOrderChangeUerVolumesTransferInput = {
  /** Глава */
  chapter: ChapterEnum;
  /** Исходный сезон Изма к НЗ, из которого будут перенесены объёмы */
  sourceSeasonId: Scalars['Long'];
  /** Данные по позициям */
  targetData: Array<VolumeTransferDataInput>;
  /** Целевой сезон, в который будут перенесены объёмы */
  targetSeasonId: Scalars['Long'];
  /** ID объекта изма к НЗ */
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  /** ID объекта НЗ */
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
};

export type WorkOrderChangeUpdateInput = {
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Комментарий */
  description?: InputMaybe<Scalars['String']>;
  /** Идентификатор Изма */
  id: Scalars['Long'];
  /** Внутренний номер */
  internalNumber?: InputMaybe<Scalars['String']>;
  /** Дата подписания */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Статус */
  status: WorkOrderChangeStatusEnum;
  /** Идентификатор НЗ */
  workOrderId: Scalars['Long'];
};

export type WorkOrderConstructionTypeResultData = {
  __typename?: 'WorkOrderConstructionTypeResultData';
  /** Выполнено по вид строительства (статус Акта: "Согласован") */
  completedPrice?: Maybe<Scalars['Decimal']>;
  /** Выполнено по сезонам НЗ */
  completedPriceSeasons?: Maybe<Array<SeasonResultData>>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по виду строительства */
  planPrice?: Maybe<Scalars['Decimal']>;
  /** Суммы планов по сезонам НЗ */
  planPriceSeasons?: Maybe<Array<SeasonResultData>>;
};

export type WorkOrderConstructionTypeResultDataInput = {
  /** Выполнено по вид строительства (статус Акта: "Согласован") */
  completedPrice?: InputMaybe<Scalars['Decimal']>;
  /** Выполнено по сезонам НЗ */
  completedPriceSeasons?: InputMaybe<Array<SeasonResultDataInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Суммарная стоимость работ по виду строительства */
  planPrice?: InputMaybe<Scalars['Decimal']>;
  /** Суммы планов по сезонам НЗ */
  planPriceSeasons?: InputMaybe<Array<SeasonResultDataInput>>;
};

/** Лимиты прочей затраты наряд-заказа */
export type WorkOrderCostLimitData = {
  __typename?: 'WorkOrderCostLimitData';
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонений */
  deviation: DeviationTipEnum;
  /** Сезон наряд-заказа */
  season?: Maybe<WorkOrderSeasonData>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Лимит прочей с данными распределения по сезонам наряд-заказа */
export type WorkOrderCostLimitDistributionData = {
  __typename?: 'WorkOrderCostLimitDistributionData';
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонений */
  deviation: DeviationTipEnum;
  /** Стоимость, включенная в наряд-заказ */
  includedCost?: Maybe<Scalars['Decimal']>;
  /** Включено в наряд-заказ */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Сезон наряд-заказа */
  season?: Maybe<WorkOrderSeasonData>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Лимит прочей с данными распределения по сезонам наряд-заказа */
export type WorkOrderCostLimitDistributionDataInput = {
  /** Лимит по договору */
  costLimit: Scalars['Decimal'];
  /** Диапазон отклонений */
  deviation: DeviationTipEnum;
  /** Стоимость, включенная в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Включено в наряд-заказ */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Флаг системного расчета */
  isSystemCalculation: Scalars['Boolean'];
  /** Сезон наряд-заказа */
  season?: InputMaybe<WorkOrderSeasonDataInput>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<Scalars['Decimal']>;
};

/** Данные итога наряд-заказа по сезону */
export type WorkOrderCostResultData = {
  __typename?: 'WorkOrderCostResultData';
  /** Название итога */
  name: Scalars['String'];
  /** Значение итога */
  value: Scalars['Decimal'];
  /** Год */
  year: Scalars['Short'];
};

/** Данные итога наряд-заказа по сезону */
export type WorkOrderCostResultDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderCostResultDataFilterInput>>;
  /** Название итога */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderCostResultDataFilterInput>>;
  /** Значение итога */
  value?: InputMaybe<DecimalOperationFilterInput>;
  /** Год */
  year?: InputMaybe<ShortOperationFilterInput>;
};

export type WorkOrderData = {
  __typename?: 'WorkOrderData';
  actsKC2SKzSNewCount: Scalars['Int'];
  actsKC2SKzSUpdatedCount: Scalars['Int'];
  amountWithTax: Scalars['Decimal'];
  amountWithoutTax: Scalars['Decimal'];
  authoredBy: Scalars['String'];
  canRollbackWorkOrderChange: Scalars['Boolean'];
  contractor: Scalars['String'];
  contractorAddress?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  draftCount: Scalars['Int'];
  finishDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  inflationData?: Maybe<Array<ContractSeasonInflationData>>;
  internalNumber: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  newRecordsCount?: Maybe<Scalars['Int']>;
  remainder: Scalars['Decimal'];
  signingDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
  statusFollowers: Array<WorkOrderStatusEnum>;
  subject: Scalars['String'];
  tax: Scalars['Decimal'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vorType?: Maybe<WorkOrderVorTypeEnum>;
  workOrderChange?: Maybe<WorkOrderChangeItem>;
};

export type WorkOrderDataInput = {
  actsKC2SKzSNewCount: Scalars['Int'];
  actsKC2SKzSUpdatedCount: Scalars['Int'];
  amountWithTax: Scalars['Decimal'];
  amountWithoutTax: Scalars['Decimal'];
  authoredBy: Scalars['String'];
  canRollbackWorkOrderChange: Scalars['Boolean'];
  contractor: Scalars['String'];
  contractorAddress?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  draftCount: Scalars['Int'];
  finishDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  inflationData?: InputMaybe<Array<ContractSeasonInflationDataInput>>;
  internalNumber: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  newRecordsCount?: InputMaybe<Scalars['Int']>;
  remainder: Scalars['Decimal'];
  signingDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
  statusFollowers: Array<WorkOrderStatusEnum>;
  subject: Scalars['String'];
  tax: Scalars['Decimal'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vorType?: InputMaybe<WorkOrderVorTypeEnum>;
  workOrderChange?: InputMaybe<WorkOrderChangeItemInput>;
};

/** Данные по черновикам НЗ */
export type WorkOrderDraftInfo = {
  __typename?: 'WorkOrderDraftInfo';
  /** Количество черновиков НЗ */
  draftCount: Scalars['Int'];
};

/** Данные по черновикам НЗ */
export type WorkOrderDraftInfoInput = {
  /** Количество черновиков НЗ */
  draftCount: Scalars['Int'];
};

/** Лимиты по виду строительства наряд-заказа */
export type WorkOrderLimitedCostConstructionTypeLimitData = {
  __typename?: 'WorkOrderLimitedCostConstructionTypeLimitData';
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Лимиты затрат по сезонам */
  seasonLimits: Array<WorkOrderLimitedCostSeasonLimitData>;
};

/** Лимиты по виду строительства наряд-заказа */
export type WorkOrderLimitedCostConstructionTypeLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderLimitedCostConstructionTypeLimitDataFilterInput>>;
  /** % лимитированных */
  calculatingValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  or?: InputMaybe<Array<WorkOrderLimitedCostConstructionTypeLimitDataFilterInput>>;
  /** Лимиты затрат по сезонам */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderLimitedCostSeasonLimitDataFilterInput>;
};

/** Модель данных лимитированной затраты наряд-заказа для списка */
export type WorkOrderLimitedCostItemData = {
  __typename?: 'WorkOrderLimitedCostItemData';
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<Scalars['String']>;
  /** Лимиты по виду строительства */
  constructionTypeLimits: Array<WorkOrderLimitedCostConstructionTypeLimitData>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Шифр ДТ */
  key?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор наряд-заказа */
  workOrderId: Scalars['Long'];
};

/** Модель данных лимитированной затраты наряд-заказа для списка */
export type WorkOrderLimitedCostItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderLimitedCostItemDataFilterInput>>;
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Лимиты по виду строительства */
  constructionTypeLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderLimitedCostConstructionTypeLimitDataFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Шифр ДТ */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderLimitedCostItemDataFilterInput>>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
};

/** Модель данных лимитированной затраты наряд-заказа для списка */
export type WorkOrderLimitedCostItemDataSortInput = {
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Шифр ДТ */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор наряд-заказа */
  workOrderId?: InputMaybe<SortEnumType>;
};

/** Сезонный лимит лимитированной затраты наряд-заказа */
export type WorkOrderLimitedCostSeasonLimitData = {
  __typename?: 'WorkOrderLimitedCostSeasonLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Сезонный лимит лимитированной затраты наряд-заказа */
export type WorkOrderLimitedCostSeasonLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderLimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderLimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные обновления элементов НЗ\Расчета */
export type WorkOrderModifyItemIds = {
  __typename?: 'WorkOrderModifyItemIds';
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: Maybe<Scalars['Boolean']>;
  /** Идентификаторы обновленных элементов НЗ\Расчета */
  itemIds?: Maybe<Array<Scalars['Long']>>;
  /** Идентификатор НЗ\Расчета */
  workOrderId: Scalars['Long'];
};

/** Данные обновления элементов НЗ\Расчета */
export type WorkOrderModifyItemIdsInput = {
  /** Признак необходимости изма НЗ */
  isWorkOrderChangeRequired?: InputMaybe<Scalars['Boolean']>;
  /** Идентификаторы обновленных элементов НЗ\Расчета */
  itemIds?: InputMaybe<Array<Scalars['Long']>>;
  /** Идентификатор НЗ\Расчета */
  workOrderId: Scalars['Long'];
};

export type WorkOrderMtrInflationData = {
  __typename?: 'WorkOrderMtrInflationData';
  code: Scalars['String'];
  id: Scalars['Long'];
  inflationSeasonId?: Maybe<Scalars['Long']>;
  mtrRowId?: Maybe<Scalars['Long']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Long']>;
  seasonId: Scalars['Long'];
  status: WorkOrderPriceStatusEnum;
  type: WorkOrderPriceTypeEnum;
  uerCode: Scalars['String'];
  uerCodeId?: Maybe<Scalars['Long']>;
  uerId: Scalars['Long'];
};

export type WorkOrderMtrInflationDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderMtrInflationDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inflationSeasonId?: InputMaybe<LongOperationFilterInput>;
  mtrRowId?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderMtrInflationDataFilterInput>>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  seasonId?: InputMaybe<LongOperationFilterInput>;
  status?: InputMaybe<WorkOrderPriceStatusEnumOperationFilterInput>;
  type?: InputMaybe<WorkOrderPriceTypeEnumOperationFilterInput>;
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  uerId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные навигации НЗ */
export type WorkOrderNavData = {
  __typename?: 'WorkOrderNavData';
  /** Список актов НЗ */
  actKC2Navs?: Maybe<Array<ActKc2NavData>>;
  /** Список справок НЗ */
  actKC3Navs?: Maybe<Array<ActKc3NavData>>;
  /** Узел навигации реестра актов КС-2 */
  actsKC2Node?: Maybe<ContractItemNavData>;
  /** Узел навигации реестра справок КС-3 */
  actsKC3Node?: Maybe<ContractItemNavData>;
  /** Идентификатор объекта */
  id?: Maybe<Scalars['Long']>;
  /** Внутренний номкр НЗ */
  internalNumber: Scalars['String'];
  /** Дополнительная информация для элемента навигации */
  metadata?: Maybe<Scalars['JSON']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания НЗ */
  signingDate?: Maybe<Scalars['DateTime']>;
  /** Ствтус НЗ */
  status: WorkOrderStatusEnum;
  /** Изм примененый к НЗ */
  workOrderChange?: Maybe<WorkOrderChangeNavData>;
  /** Список навигации измов НЗ */
  workOrderChanges?: Maybe<Array<WorkOrderChangeNavData>>;
};

/** Данные навигации НЗ */
export type WorkOrderNavDataInput = {
  /** Список актов НЗ */
  actKC2Navs?: InputMaybe<Array<ActKc2NavDataInput>>;
  /** Список справок НЗ */
  actKC3Navs?: InputMaybe<Array<ActKc3NavDataInput>>;
  /** Узел навигации реестра актов КС-2 */
  actsKC2Node?: InputMaybe<ContractItemNavDataInput>;
  /** Узел навигации реестра справок КС-3 */
  actsKC3Node?: InputMaybe<ContractItemNavDataInput>;
  /** Идентификатор объекта */
  id?: InputMaybe<Scalars['Long']>;
  /** Внутренний номкр НЗ */
  internalNumber: Scalars['String'];
  /** Дополнительная информация для элемента навигации */
  metadata?: InputMaybe<Scalars['String']>;
  /** Название элемента */
  name: Scalars['String'];
  /** Идентификатор элемента */
  navLinkId: Scalars['String'];
  /** Дата подписания НЗ */
  signingDate?: InputMaybe<Scalars['DateTime']>;
  /** Ствтус НЗ */
  status: WorkOrderStatusEnum;
  /** Изм примененый к НЗ */
  workOrderChange?: InputMaybe<WorkOrderChangeNavDataInput>;
  /** Список навигации измов НЗ */
  workOrderChanges?: InputMaybe<Array<WorkOrderChangeNavDataInput>>;
};

export type WorkOrderObjectData = {
  __typename?: 'WorkOrderObjectData';
  code?: Maybe<Scalars['String']>;
  constructionType: ConstructionTypeData;
  contractObject?: Maybe<ContractObjectData>;
  fromWorkOrder: Scalars['Boolean'];
  fromWorkOrderVOR: Scalars['Boolean'];
  hasActsKC2?: Maybe<Scalars['Boolean']>;
  hasCompletedActsKC2?: Maybe<Scalars['Boolean']>;
  hasCompletedOtherActsKC2?: Maybe<Scalars['Boolean']>;
  hasCompletedSkzsActsKC2?: Maybe<Scalars['Boolean']>;
  hasCompletedSmrActsKC2?: Maybe<Scalars['Boolean']>;
  hasOngoingActsKC2?: Maybe<Scalars['Boolean']>;
  hasOngoingOtherActsKC2?: Maybe<Scalars['Boolean']>;
  hasOngoingSkzsActsKC2?: Maybe<Scalars['Boolean']>;
  hasOngoingSmrActsKC2?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  isActKC2Object?: Maybe<Scalars['Boolean']>;
  isLeaf: Scalars['Boolean'];
  name: Scalars['String'];
  objectUniqueId: Scalars['String'];
  parentId?: Maybe<Scalars['Long']>;
  rootObjectId?: Maybe<Scalars['Long']>;
  rootObjectUniqueId?: Maybe<Scalars['String']>;
  workOrderId: Scalars['Long'];
};

export type WorkOrderObjectDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderObjectDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  contractObject?: InputMaybe<ContractObjectDataFilterInput>;
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  fromWorkOrderVOR?: InputMaybe<BooleanOperationFilterInput>;
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasCompletedActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasCompletedOtherActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasCompletedSkzsActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasCompletedSmrActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasOngoingActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasOngoingOtherActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasOngoingSkzsActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  hasOngoingSmrActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  isLeaf?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderObjectDataFilterInput>>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  rootObjectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  workOrderId?: InputMaybe<LongOperationFilterInput>;
};

export type WorkOrderObjectDataInput = {
  code?: InputMaybe<Scalars['String']>;
  constructionType: ConstructionTypeDataInput;
  contractObject?: InputMaybe<ContractObjectDataInput>;
  fromWorkOrder: Scalars['Boolean'];
  fromWorkOrderVOR: Scalars['Boolean'];
  hasActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasCompletedActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasCompletedOtherActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasCompletedSkzsActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasCompletedSmrActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasOngoingActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasOngoingOtherActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasOngoingSkzsActsKC2?: InputMaybe<Scalars['Boolean']>;
  hasOngoingSmrActsKC2?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  isActKC2Object?: InputMaybe<Scalars['Boolean']>;
  isLeaf: Scalars['Boolean'];
  name: Scalars['String'];
  objectUniqueId: Scalars['String'];
  parentId?: InputMaybe<Scalars['Long']>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  rootObjectUniqueId?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['Long'];
};

export type WorkOrderObjectDataSortInput = {
  code?: InputMaybe<SortEnumType>;
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  contractObject?: InputMaybe<ContractObjectDataSortInput>;
  fromWorkOrder?: InputMaybe<SortEnumType>;
  fromWorkOrderVOR?: InputMaybe<SortEnumType>;
  hasActsKC2?: InputMaybe<SortEnumType>;
  hasCompletedActsKC2?: InputMaybe<SortEnumType>;
  hasCompletedOtherActsKC2?: InputMaybe<SortEnumType>;
  hasCompletedSkzsActsKC2?: InputMaybe<SortEnumType>;
  hasCompletedSmrActsKC2?: InputMaybe<SortEnumType>;
  hasOngoingActsKC2?: InputMaybe<SortEnumType>;
  hasOngoingOtherActsKC2?: InputMaybe<SortEnumType>;
  hasOngoingSkzsActsKC2?: InputMaybe<SortEnumType>;
  hasOngoingSmrActsKC2?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActKC2Object?: InputMaybe<SortEnumType>;
  isLeaf?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  objectUniqueId?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  rootObjectId?: InputMaybe<SortEnumType>;
  rootObjectUniqueId?: InputMaybe<SortEnumType>;
  workOrderId?: InputMaybe<SortEnumType>;
};

/** Данные раздела итога  по объекту наряд-заказа */
export type WorkOrderObjectResultData = {
  __typename?: 'WorkOrderObjectResultData';
  /** Идентификатор акта выполненных работ КС-2 */
  actKC2Id?: Maybe<Scalars['Long']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Список итогов наряд-заказа */
  costResultData: Array<WorkOrderCostResultData>;
  /** Идентификатор объекта строительства */
  objectId: Scalars['Long'];
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Название раздела */
  title: Scalars['String'];
};

/** Данные раздела итога  по объекту наряд-заказа */
export type WorkOrderObjectResultDataFilterInput = {
  /** Идентификатор акта выполненных работ КС-2 */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderObjectResultDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Список итогов наряд-заказа */
  costResultData?: InputMaybe<ListFilterInputTypeOfWorkOrderCostResultDataFilterInput>;
  /** Идентификатор объекта строительства */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderObjectResultDataFilterInput>>;
  /** Секция */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Название раздела */
  title?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные раздела итога  по объекту наряд-заказа */
export type WorkOrderObjectResultDataSortInput = {
  /** Идентификатор акта выполненных работ КС-2 */
  actKC2Id?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта строительства */
  objectId?: InputMaybe<SortEnumType>;
  /** Секция */
  section?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Название раздела */
  title?: InputMaybe<SortEnumType>;
};

/** Данные для выборв объекта/подобъекта договора в указанный НЗ */
export type WorkOrderObjectSelectionData = {
  __typename?: 'WorkOrderObjectSelectionData';
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Идентификатор договора */
  contractId: Scalars['Long'];
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR: Scalars['Boolean'];
  /** Признак того, что объект/подобъект был создан вручную для указанного НЗ */
  fromWorkOrder: Scalars['Boolean'];
  /** Признак того, что объект/подобъект был создан в указанном НЗ через загрузку ВОР */
  fromWorkOrderVOR: Scalars['Boolean'];
  /** Признак наличия актов для объекта в указанном НЗ */
  hasActsKC2: Scalars['Boolean'];
  /** Гарантированный объем */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Конечный объект/подобъект в указанном НЗ содержит позиции СМР */
  hasPrices: Scalars['Boolean'];
  /** Конечный объект/подобъект в указанном НЗ содержит позиции прочих */
  hasPricesOther: Scalars['Boolean'];
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: Maybe<Scalars['Boolean']>;
  /** Идентификатор объекта договора */
  id: Scalars['Long'];
  /** Признак создания на этапе приемки (статус НЗ "В работе") */
  isActKC2Object?: Maybe<Scalars['Boolean']>;
  /** Признак того, что объект/подобъект используется в других НЗ кроме указанного */
  isInUse: Scalars['Boolean'];
  /** Признак использования объекта/подобъекта в указанном НЗ */
  isIncluded: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: Maybe<Scalars['Long']>;
  /** Обоснование */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Статус объекта */
  status: ContractObjectStatusEnum;
  /** Идентификатор НЗ */
  workOrderId?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: Maybe<Scalars['Long']>;
};

/** Данные для выборв объекта/подобъекта договора в указанный НЗ */
export type WorkOrderObjectSelectionDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderObjectSelectionDataFilterInput>>;
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<LongOperationFilterInput>;
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что объект/подобъект был создан вручную для указанного НЗ */
  fromWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что объект/подобъект был создан в указанном НЗ через загрузку ВОР */
  fromWorkOrderVOR?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия актов для объекта в указанном НЗ */
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Конечный объект/подобъект в указанном НЗ содержит позиции СМР */
  hasPrices?: InputMaybe<BooleanOperationFilterInput>;
  /** Конечный объект/подобъект в указанном НЗ содержит позиции прочих */
  hasPricesOther?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак создания на этапе приемки (статус НЗ "В работе") */
  isActKC2Object?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что объект/подобъект используется в других НЗ кроме указанного */
  isInUse?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак использования объекта/подобъекта в указанном НЗ */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderObjectSelectionDataFilterInput>>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Статус объекта */
  status?: InputMaybe<ContractObjectStatusEnumOperationFilterInput>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные для выборв объекта/подобъекта договора в указанный НЗ */
export type WorkOrderObjectSelectionDataSortInput = {
  /** Уникальный идентификатор элемента иерархической структуры работ */
  codeWBS?: InputMaybe<SortEnumType>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  /** Идентификатор договора */
  contractId?: InputMaybe<SortEnumType>;
  /** Объект был добавлен в договор через загрузку ВОР */
  fromVOR?: InputMaybe<SortEnumType>;
  /** Признак того, что объект/подобъект был создан вручную для указанного НЗ */
  fromWorkOrder?: InputMaybe<SortEnumType>;
  /** Признак того, что объект/подобъект был создан в указанном НЗ через загрузку ВОР */
  fromWorkOrderVOR?: InputMaybe<SortEnumType>;
  /** Признак наличия актов для объекта в указанном НЗ */
  hasActsKC2?: InputMaybe<SortEnumType>;
  /** Гарантированный объем */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Конечный объект/подобъект в указанном НЗ содержит позиции СМР */
  hasPrices?: InputMaybe<SortEnumType>;
  /** Конечный объект/подобъект в указанном НЗ содержит позиции прочих */
  hasPricesOther?: InputMaybe<SortEnumType>;
  /** Признак наличия объектов в НЗ в статусе 'В работе' */
  hasWorkOrdersInProgress?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта договора */
  id?: InputMaybe<SortEnumType>;
  /** Признак создания на этапе приемки (статус НЗ "В работе") */
  isActKC2Object?: InputMaybe<SortEnumType>;
  /** Признак того, что объект/подобъект используется в других НЗ кроме указанного */
  isInUse?: InputMaybe<SortEnumType>;
  /** Признак использования объекта/подобъекта в указанном НЗ */
  isIncluded?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор родительского объекта/подобъекта */
  parentId?: InputMaybe<SortEnumType>;
  /** Обоснование */
  rationale?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Статус объекта */
  status?: InputMaybe<SortEnumType>;
  /** Идентификатор НЗ */
  workOrderId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта НЗ */
  workOrderObjectId?: InputMaybe<SortEnumType>;
};

/** Модель объекта из договора, который можно добавить в Изм */
export type WorkOrderObjectToAddEntry = {
  __typename?: 'WorkOrderObjectToAddEntry';
  /** Код шифра */
  code?: Maybe<Scalars['String']>;
  /** Вид строительства */
  constructionTypeId: Scalars['Long'];
  /** ID объекта договора */
  contractObjectId: Scalars['Long'];
  /** Имя объекта */
  name: Scalars['String'];
  /** Использован ли объект в Изме */
  used: Scalars['Boolean'];
};

/** Модель объекта из договора, который можно добавить в Изм */
export type WorkOrderObjectToAddEntryInput = {
  /** Код шифра */
  code?: InputMaybe<Scalars['String']>;
  /** Вид строительства */
  constructionTypeId: Scalars['Long'];
  /** ID объекта договора */
  contractObjectId: Scalars['Long'];
  /** Имя объекта */
  name: Scalars['String'];
  /** Использован ли объект в Изме */
  used: Scalars['Boolean'];
};

/** Стоимость выполненных работ по прочим затратам акта КС-2 */
export type WorkOrderOtherActKc2PriceData = {
  __typename?: 'WorkOrderOtherActKC2PriceData';
  /** Стоимость (согласовано) */
  acceptedCost?: Maybe<Scalars['Decimal']>;
  /** Отклонение стоимости (согласовано) */
  acceptedCostDeviation?: Maybe<DeviationEnum>;
  /** Идентификатор акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Стоимость (план) */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Отклонение стоимости (план) */
  planCostDeviation?: Maybe<DeviationEnum>;
};

/** Стоимость выполненных работ по прочим затратам акта КС-2 */
export type WorkOrderOtherActKc2PriceDataFilterInput = {
  /** Стоимость (согласовано) */
  acceptedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение стоимости (согласовано) */
  acceptedCostDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Идентификатор акта КС-2 */
  actKC2Id?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderOtherActKc2PriceDataFilterInput>>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderOtherActKc2PriceDataFilterInput>>;
  /** Стоимость (план) */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение стоимости (план) */
  planCostDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
};

/** Стоимость выполненных работ по прочим затратам акта КС-2 */
export type WorkOrderOtherActKc2PriceDataInput = {
  /** Стоимость (согласовано) */
  acceptedCost?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение стоимости (согласовано) */
  acceptedCostDeviation?: InputMaybe<DeviationEnum>;
  /** Идентификатор акта КС-2 */
  actKC2Id: Scalars['Long'];
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<Scalars['Boolean']>;
  /** Стоимость (план) */
  planCost?: InputMaybe<Scalars['Decimal']>;
  /** Отклонение стоимости (план) */
  planCostDeviation?: InputMaybe<DeviationEnum>;
};

/** Прочая затрата для включения в наряд-заказ */
export type WorkOrderOtherAggregationData = {
  __typename?: 'WorkOrderOtherAggregationData';
  /** Способ начисления */
  calculatingType: OtherCostCalculationTypeEnum;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Лимиты прочей затраты наряд-заказа */
  limits: Array<WorkOrderCostLimitData>;
  /** Наименование */
  name: Scalars['String'];
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Раздел */
  status: ContractOtherStatusEnum;
};

/** Данные прочей НЗ */
export type WorkOrderOtherCostItem = {
  __typename?: 'WorkOrderOtherCostItem';
  /** Требуется ввод плана по сезрнам */
  hasSeasonLimits: Scalars['Boolean'];
  /** Данные прочей */
  otherCost: ContractOtherCostBase;
  /** Лимиты прочей затраты наряд-заказа */
  seasonLimits?: Maybe<Array<WorkOrderOtherCostSeasonLimitData>>;
  /** Признак сортировки */
  sortPart: Scalars['Int'];
  /** Данные объектов привязки прочих */
  workOrderObjects: Array<WorkOrderOtherCostObjectItem>;
};

/** Данные прочей НЗ */
export type WorkOrderOtherCostItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderOtherCostItemFilterInput>>;
  /** Требуется ввод плана по сезрнам */
  hasSeasonLimits?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderOtherCostItemFilterInput>>;
  /** Данные прочей */
  otherCost?: InputMaybe<ContractOtherCostBaseFilterInput>;
  /** Лимиты прочей затраты наряд-заказа */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderOtherCostSeasonLimitDataFilterInput>;
  /** Признак сортировки */
  sortPart?: InputMaybe<IntOperationFilterInput>;
  /** Данные объектов привязки прочих */
  workOrderObjects?: InputMaybe<ListFilterInputTypeOfWorkOrderOtherCostObjectItemFilterInput>;
};

/** Данные корневого объекта привязки прочей в НЗ */
export type WorkOrderOtherCostObjectItem = {
  __typename?: 'WorkOrderOtherCostObjectItem';
  /** Признак возможности добавления прочей к объекту */
  canAddOther: Scalars['Boolean'];
  /** Признак возможности удаления прочей из объекта */
  canRemoveOther: Scalars['Boolean'];
  /** Идентификатор объекта договора */
  contractObjectId: Scalars['Long'];
  /** Признак наличия актов прочих у объекта */
  hasActsKC2?: Maybe<Scalars['Boolean']>;
  /** Признак наличия факта прочей у объекта */
  hasActualCost?: Maybe<Scalars['Boolean']>;
  /** Признак добавления прочей к объекту в работе */
  isActKC2Cost?: Maybe<Scalars['Boolean']>;
  /** Признак привязки прочей к объекту */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Наименование объекта */
  name: Scalars['String'];
  /** Обоснование позиции прочей */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор корневого объекта НЗ */
  workOrderRootObjectId: Scalars['Long'];
};

/** Данные корневого объекта привязки прочей в НЗ */
export type WorkOrderOtherCostObjectItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderOtherCostObjectItemFilterInput>>;
  /** Признак возможности добавления прочей к объекту */
  canAddOther?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак возможности удаления прочей из объекта */
  canRemoveOther?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор объекта договора */
  contractObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Признак наличия актов прочих у объекта */
  hasActsKC2?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия факта прочей у объекта */
  hasActualCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак добавления прочей к объекту в работе */
  isActKC2Cost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак привязки прочей к объекту */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование объекта */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderOtherCostObjectItemFilterInput>>;
  /** Обоснование позиции прочей */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор корневого объекта НЗ */
  workOrderRootObjectId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные корневого объекта привязки прочей в НЗ */
export type WorkOrderOtherCostObjectItemInput = {
  /** Признак возможности добавления прочей к объекту */
  canAddOther: Scalars['Boolean'];
  /** Признак возможности удаления прочей из объекта */
  canRemoveOther: Scalars['Boolean'];
  /** Идентификатор объекта договора */
  contractObjectId: Scalars['Long'];
  /** Признак наличия актов прочих у объекта */
  hasActsKC2?: InputMaybe<Scalars['Boolean']>;
  /** Признак наличия факта прочей у объекта */
  hasActualCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак добавления прочей к объекту в работе */
  isActKC2Cost?: InputMaybe<Scalars['Boolean']>;
  /** Признак привязки прочей к объекту */
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Наименование объекта */
  name: Scalars['String'];
  /** Обоснование позиции прочей */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор корневого объекта НЗ */
  workOrderRootObjectId: Scalars['Long'];
};

/** Данные о Лимитах и остатках прочей затраты */
export type WorkOrderOtherCostSeasonLimitData = {
  __typename?: 'WorkOrderOtherCostSeasonLimitData';
  /** Факт по договору */
  actualCost?: Maybe<Scalars['Decimal']>;
  /** Диапазон отклонений */
  deviation?: Maybe<DeviationTipEnum>;
  /** Включено в НЗ по сезону */
  includedCost?: Maybe<Scalars['Decimal']>;
  /** Признак включения прочей в НЗ */
  isIncluded?: Maybe<Scalars['Boolean']>;
  /** Лимит по договору */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по договору */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId: Scalars['Long'];
  /** Сезон наряд-заказа */
  workOrderSeasonYear: Scalars['Short'];
};

/** Данные о Лимитах и остатках прочей затраты */
export type WorkOrderOtherCostSeasonLimitDataFilterInput = {
  /** Факт по договору */
  actualCost?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderOtherCostSeasonLimitDataFilterInput>>;
  /** Диапазон отклонений */
  deviation?: InputMaybe<NullableOfDeviationTipEnumOperationFilterInput>;
  /** Включено в НЗ по сезону */
  includedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Признак включения прочей в НЗ */
  isIncluded?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderOtherCostSeasonLimitDataFilterInput>>;
  /** Лимит по договору */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по договору */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  workOrderSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон наряд-заказа */
  workOrderSeasonYear?: InputMaybe<ShortOperationFilterInput>;
};

/** Прочая затрата наряд-заказа с данными распределения по сезонам и объектам */
export type WorkOrderOtherDistributionData = {
  __typename?: 'WorkOrderOtherDistributionData';
  /** Прочая затрата наряд-заказа договора */
  contractOtherCost: ContractOtherCostBaseData;
  /** Лимиты прочей с данными распределения по сезонам наряд-заказа */
  limits: Array<WorkOrderCostLimitDistributionData>;
  /** Данные распределения прочей затраты по объектам и сезонам */
  objectSeasonDistributions: Array<WorkOrderOtherPriceCostData>;
  /** Объекты наряд-заказа, по которым распределена прочая затрата */
  workOrderObjects: Array<WorkOrderOtherCostObjectItem>;
};

/** Прочая затрата наряд-заказа с данными распределения по сезонам и объектам */
export type WorkOrderOtherDistributionDataInput = {
  /** Прочая затрата наряд-заказа договора */
  contractOtherCost: ContractOtherCostBaseDataInput;
  /** Лимиты прочей с данными распределения по сезонам наряд-заказа */
  limits: Array<WorkOrderCostLimitDistributionDataInput>;
  /** Данные распределения прочей затраты по объектам и сезонам */
  objectSeasonDistributions: Array<WorkOrderOtherPriceCostDataInput>;
  /** Объекты наряд-заказа, по которым распределена прочая затрата */
  workOrderObjects: Array<WorkOrderOtherCostObjectItemInput>;
};

/** Входные данные для изменения прочих затрат в наряд-заказе */
export type WorkOrderOtherDistributionUpdateInput = {
  /** Идентификаторы объектов и сезонов для распределения стоимости прочей затраты */
  objectList: Array<ConstructionObjectInput>;
  /** Идентификатор прочей затраты договора */
  otherCostId: Scalars['Long'];
  /** Список прочих затрат по сезонам для изменения в наряд-заказе */
  otherSeasonPrices: Array<UpdateWorkOrderOtherSeasonPriceInput>;
};

/** Данные по добавляемой позиции */
export type WorkOrderOtherObjectInput = {
  /** Идентификатор прочей */
  objectId: Scalars['Long'];
  /** Обоснование добавления (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Данные распределения прочей затраты по объектам и сезонам */
export type WorkOrderOtherPriceCalcInput = {
  /** Идентификатор прочей затраты договора */
  contractOtherCostId: Scalars['Long'];
  /** Стоимость, которую необходимо включить в наряд-заказ */
  includedCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона НЗ */
  seasonId: Scalars['Long'];
  /** Идентификаторы объектов для распределения */
  workOrderObjectIds: Array<Scalars['Long']>;
};

/** Данные распределения прочей затраты по объектам и сезонам */
export type WorkOrderOtherPriceCostData = {
  __typename?: 'WorkOrderOtherPriceCostData';
  /** Стоимость позиции прочей */
  cost?: Maybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Включено в наряд-заказ */
  isIncluded: Scalars['Boolean'];
  /** Идентификатор объекта строительства */
  objectId: Scalars['Long'];
  /** Идентификатор cезона */
  seasonId: Scalars['Long'];
};

/** Данные распределения прочей затраты по объектам и сезонам */
export type WorkOrderOtherPriceCostDataInput = {
  /** Стоимость позиции прочей */
  cost?: InputMaybe<Scalars['Decimal']>;
  /** Список ошибок при расчете */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  /** Включено в наряд-заказ */
  isIncluded: Scalars['Boolean'];
  /** Идентификатор объекта строительства */
  objectId: Scalars['Long'];
  /** Идентификатор cезона */
  seasonId: Scalars['Long'];
};

/** Прочая затрата наряд-заказа */
export type WorkOrderOtherPriceData = {
  __typename?: 'WorkOrderOtherPriceData';
  /** Список прочих затрат по актам */
  actKC2Prices?: Maybe<Array<WorkOrderOtherActKc2PriceData>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор из договора */
  contractOtherId: Scalars['Long'];
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам НЗ */
  hasEmptySeasonCost?: Maybe<Scalars['Boolean']>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Код прочей */
  otherCostKey?: Maybe<Scalars['String']>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: Maybe<Scalars['String']>;
  /** Список прочих затрат по сезонам */
  seasonPrices?: Maybe<Array<WorkOrderOtherSeasonPriceData>>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status?: Maybe<ContractOtherStatusEnum>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Прочая затрата наряд-заказа */
export type WorkOrderOtherPriceDataFilterInput = {
  /** Список прочих затрат по актам */
  actKC2Prices?: InputMaybe<ListFilterInputTypeOfWorkOrderOtherActKc2PriceDataFilterInput>;
  and?: InputMaybe<Array<WorkOrderOtherPriceDataFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор из договора */
  contractOtherId?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам НЗ */
  hasEmptySeasonCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderOtherPriceDataFilterInput>>;
  /** Код прочей */
  otherCostKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Список прочих затрат по сезонам */
  seasonPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderOtherSeasonPriceDataFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfContractOtherStatusEnumOperationFilterInput>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Прочая затрата наряд-заказа */
export type WorkOrderOtherPriceDataInput = {
  /** Список прочих затрат по актам */
  actKC2Prices?: InputMaybe<Array<WorkOrderOtherActKc2PriceDataInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<Scalars['Decimal']>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  /** Глава */
  chapter?: InputMaybe<ChapterEnum>;
  /** Идентификатор из договора */
  contractOtherId: Scalars['Long'];
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам НЗ */
  hasEmptySeasonCost?: InputMaybe<Scalars['Boolean']>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan: Scalars['Boolean'];
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Код прочей */
  otherCostKey?: InputMaybe<Scalars['String']>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: InputMaybe<Scalars['String']>;
  /** Список прочих затрат по сезонам */
  seasonPrices?: InputMaybe<Array<WorkOrderOtherSeasonPriceDataInput>>;
  /** Раздел */
  section?: InputMaybe<SectionEnum>;
  /** Статус */
  status?: InputMaybe<ContractOtherStatusEnum>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: InputMaybe<Scalars['Decimal']>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: InputMaybe<Scalars['Decimal']>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<Scalars['Decimal']>;
};

/** Данные для редактирования обоснования добавления прочей в Акт КС-2 (Примечания) */
export type WorkOrderOtherPriceRationaleData = {
  __typename?: 'WorkOrderOtherPriceRationaleData';
  /** Наименование прочей */
  name: Scalars['String'];
  /** Обоснование добавления прочей в Акт КС-2 (Примечание) */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор строки прочей затраты наряд-заказа */
  workOrderOtherPriceId: Scalars['Long'];
};

/** Данные для редактирования обоснования добавления прочей в Акт КС-2 (Примечания) */
export type WorkOrderOtherPriceRationaleDataInput = {
  /** Наименование прочей */
  name: Scalars['String'];
  /** Обоснование добавления прочей в Акт КС-2 (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор строки прочей затраты наряд-заказа */
  workOrderOtherPriceId: Scalars['Long'];
};

/** Данные для обновления обоснования добавления прочей в Акт КС-2 */
export type WorkOrderOtherPriceRationaleUpdateInput = {
  /** Обоснование добавления прочей в Акт КС-2 */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Сезонная прочая затрата наряд-заказа */
export type WorkOrderOtherSeasonPriceData = {
  __typename?: 'WorkOrderOtherSeasonPriceData';
  /** Стоимость выполненных работ по сезону */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** Ошибки вычисления значения прочей */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Флаг Только для чтения */
  isReadOnly?: Maybe<Scalars['Boolean']>;
  /** Стоимость работ по сезону */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по сезону */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона наряд-заказа */
  seasonId: Scalars['Long'];
};

/** Сезонная прочая затрата наряд-заказа */
export type WorkOrderOtherSeasonPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderOtherSeasonPriceDataFilterInput>>;
  /** Стоимость выполненных работ по сезону */
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<BooleanOperationFilterInput>;
  /** Флаг Только для чтения */
  isReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderOtherSeasonPriceDataFilterInput>>;
  /** Стоимость работ по сезону */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по сезону */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сезона наряд-заказа */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Сезонная прочая затрата наряд-заказа */
export type WorkOrderOtherSeasonPriceDataInput = {
  /** Стоимость выполненных работ по сезону */
  completedCost?: InputMaybe<Scalars['Decimal']>;
  /** Ошибки вычисления значения прочей */
  errors?: InputMaybe<Array<Scalars['String']>>;
  /** Признак наличия ошибок вычисления значения прочей */
  hasErrors?: InputMaybe<Scalars['Boolean']>;
  /** Флаг Только для чтения */
  isReadOnly?: InputMaybe<Scalars['Boolean']>;
  /** Стоимость работ по сезону */
  planCost?: InputMaybe<Scalars['Decimal']>;
  /** Остаток по сезону */
  remainderCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона наряд-заказа */
  seasonId: Scalars['Long'];
};

/** Отображение прочих затрат наряд-заказа */
export type WorkOrderOtherViewData = {
  __typename?: 'WorkOrderOtherViewData';
  /** Список актов выполненных работ по прочим наряд-заказа */
  actsKC2: Array<WorkOrderActKc2Data>;
  /** Список прочих затрат наряд-заказа */
  otherPriceList: Array<WorkOrderOtherPriceData>;
  /** Список сезонов наряд-заказа */
  seasons: Array<WorkOrderSeasonData>;
};

/** Модель значения позиции в сезоне по акту */
export type WorkOrderPriceActValue = {
  __typename?: 'WorkOrderPriceActValue';
  /** Значение согласованной стоимости в сезоне по позиции */
  actCostAccepted?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по согласованной стоимости в сезоне по позиции */
  actCostAcceptedDeviation?: Maybe<DeviationEnum>;
  /** Группа затрат акта */
  actCostGroup: CostGroupEnum;
  /** Значение плана стоимости в сезоне по позиции */
  actCostPlan?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по стоимости плана в сезоне по позиции */
  actCostPlanDeviation?: Maybe<DeviationEnum>;
  /** Формула */
  actFormula?: Maybe<Scalars['String']>;
  /** Визуальное представление формулы */
  actFormulaDisplayText?: Maybe<Scalars['String']>;
  /** Ошибки формулы */
  actFormulaErrors?: Maybe<Array<Scalars['String']>>;
  /** Признак редактируемости стоимости в акте по позиции */
  actHasEditableCost?: Maybe<Scalars['Boolean']>;
  /** Идентификатор акта */
  actId: Scalars['Long'];
  /** Сезон распределением инфляции по позициям МТ */
  actInflationSeasonId?: Maybe<Scalars['Long']>;
  /** Статус акта в строке */
  actStatus: ActKc2StatusEnum;
  /** Статус СКзС */
  actStatusSKzS?: Maybe<SkzsActKc2StatusEnum>;
  /** Значение согласованного объема в сезоне по позиции */
  actVolumeAccepted?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по согласованного объему в сезоне по позиции */
  actVolumeAcceptedDeviation?: Maybe<DeviationEnum>;
  /** Признак нередактируемого объема */
  actVolumeIsReadOnly?: Maybe<Scalars['Boolean']>;
  /** Значение плана объема в сезоне по позиции */
  actVolumePlan?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по объему плана в сезоне по позиции */
  actVolumePlanDeviation?: Maybe<DeviationEnum>;
  /** Объем (план) из СКзС */
  actVolumePlanSKzS?: Maybe<Scalars['Decimal']>;
  /** Комментарий к расценке или прочей в акте */
  comment?: Maybe<Scalars['String']>;
  /** Признак наличия формулы */
  hasActFormula?: Maybe<Scalars['Boolean']>;
  /** Признак акта с распределением инфляции по позициям МТР */
  isActKC2DistributionOfMtrInflation?: Maybe<Scalars['Boolean']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: Maybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied?: Maybe<Scalars['Boolean']>;
  /** Признак того, что копирование объёма из СКзС заблокировано */
  isSKzSCopyLock?: Maybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated?: Maybe<Scalars['Boolean']>;
};

/** Модель значения позиции в сезоне по акту */
export type WorkOrderPriceActValueFilterInput = {
  /** Значение согласованной стоимости в сезоне по позиции */
  actCostAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по согласованной стоимости в сезоне по позиции */
  actCostAcceptedDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Группа затрат акта */
  actCostGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Значение плана стоимости в сезоне по позиции */
  actCostPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по стоимости плана в сезоне по позиции */
  actCostPlanDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Формула */
  actFormula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Визуальное представление формулы */
  actFormulaDisplayText?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Ошибки формулы */
  actFormulaErrors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак редактируемости стоимости в акте по позиции */
  actHasEditableCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор акта */
  actId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон распределением инфляции по позициям МТ */
  actInflationSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Статус акта в строке */
  actStatus?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  /** Статус СКзС */
  actStatusSKzS?: InputMaybe<NullableOfSkzsActKc2StatusEnumOperationFilterInput>;
  /** Значение согласованного объема в сезоне по позиции */
  actVolumeAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по согласованного объему в сезоне по позиции */
  actVolumeAcceptedDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Признак нередактируемого объема */
  actVolumeIsReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  /** Значение плана объема в сезоне по позиции */
  actVolumePlan?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по объему плана в сезоне по позиции */
  actVolumePlanDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Объем (план) из СКзС */
  actVolumePlanSKzS?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderPriceActValueFilterInput>>;
  /** Комментарий к расценке или прочей в акте */
  comment?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия формулы */
  hasActFormula?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак акта с распределением инфляции по позициям МТР */
  isActKC2DistributionOfMtrInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что копирование объёма из СКзС заблокировано */
  isSKzSCopyLock?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceActValueFilterInput>>;
};

export type WorkOrderPriceCodeFilterData = {
  __typename?: 'WorkOrderPriceCodeFilterData';
  /** Код позиции */
  code: Scalars['String'];
  isMtr: Scalars['Boolean'];
  isRatio: Scalars['Boolean'];
  isUer: Scalars['Boolean'];
  /** УЕР код */
  uerCode: Scalars['String'];
};

export type WorkOrderPriceCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderPriceCodeFilterDataFilterInput>>;
  /** Код позиции */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  isMtr?: InputMaybe<BooleanOperationFilterInput>;
  isRatio?: InputMaybe<BooleanOperationFilterInput>;
  isUer?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceCodeFilterDataFilterInput>>;
  /** УЕР код */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

export type WorkOrderPriceCodeFilterDataSortInput = {
  /** Код позиции */
  code?: InputMaybe<SortEnumType>;
  isMtr?: InputMaybe<SortEnumType>;
  isRatio?: InputMaybe<SortEnumType>;
  isUer?: InputMaybe<SortEnumType>;
  /** УЕР код */
  uerCode?: InputMaybe<SortEnumType>;
};

export type WorkOrderPriceData = {
  __typename?: 'WorkOrderPriceData';
  actKC2Prices: Array<WorkOrderActKc2PriceData>;
  code: Scalars['String'];
  /** Комментарий */
  comment?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  /** Имеет плановую стоимость, загруженную из Excel */
  hasCostPlan?: Maybe<Scalars['Boolean']>;
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного согласованного объема по актам */
  hasEmptyActAcceptedVolume?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного планового объема по актам */
  hasEmptyActPlanVolume?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  isActKC2Price: Scalars['Boolean'];
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Код МТР */
  mtrKey?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Long']>;
  priceListId: Scalars['Long'];
  /** Обоснование добавления расценки/МТР/коэффициента в Акт КС-2 */
  rationale?: Maybe<Scalars['String']>;
  seasonPrices: Array<WorkOrderSeasonPriceData>;
  shortName?: Maybe<Scalars['String']>;
  status: WorkOrderPriceStatusEnum;
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  totalCompletedVolume?: Maybe<Scalars['Decimal']>;
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  totalPlanVolume?: Maybe<Scalars['Decimal']>;
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  totalRemainderVolume?: Maybe<Scalars['Decimal']>;
  type: WorkOrderPriceTypeEnum;
  uerCode: Scalars['String'];
  uerCodeId?: Maybe<Scalars['Long']>;
  uerId: Scalars['Long'];
  unit: Scalars['String'];
  unitCost: Scalars['Decimal'];
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Выполнено (Кол-во) */
  workCompleted?: Maybe<Scalars['Decimal']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum: WorkInSumEnum;
  /** К перехода из расценки */
  workKindWorkRatio?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода позиции */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Остаток (Кол-во) */
  workReminder?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

export type WorkOrderPriceDataFilterInput = {
  actKC2Prices?: InputMaybe<ListFilterInputTypeOfWorkOrderActKc2PriceDataFilterInput>;
  and?: InputMaybe<Array<WorkOrderPriceDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Комментарий */
  comment?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Имеет плановую стоимость, загруженную из Excel */
  hasCostPlan?: InputMaybe<BooleanOperationFilterInput>;
  hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного согласованного объема по актам */
  hasEmptyActAcceptedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного планового объема по актам */
  hasEmptyActPlanVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Код МТР */
  mtrKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceDataFilterInput>>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  priceListId?: InputMaybe<LongOperationFilterInput>;
  /** Обоснование добавления расценки/МТР/коэффициента в Акт КС-2 */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  seasonPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderSeasonPriceDataFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  status?: InputMaybe<WorkOrderPriceStatusEnumOperationFilterInput>;
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  totalCompletedVolume?: InputMaybe<DecimalOperationFilterInput>;
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  totalRemainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<WorkOrderPriceTypeEnumOperationFilterInput>;
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  uerId?: InputMaybe<LongOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено (Кол-во) */
  workCompleted?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<WorkInSumEnumOperationFilterInput>;
  /** К перехода из расценки */
  workKindWorkRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода позиции */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток (Кол-во) */
  workReminder?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Модель позиции НЗ */
export type WorkOrderPriceItem = {
  __typename?: 'WorkOrderPriceItem';
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Глава позиции */
  chapter?: Maybe<ChapterEnum>;
  /** Уникальный идентификатор позиции */
  clientId: Scalars['String'];
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор типа сущности */
  entityTypeId?: Maybe<Scalars['Int']>;
  /** Название типа сущности */
  entityTypeName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор типа сущности */
  entityTypeUniqueId?: Maybe<Scalars['String']>;
  /**
   * Идентификар сущности, на которую ссылается позиция, в договоре.
   *             Либо:
   *             - идентификатор объекта договора
   *             - идентификатор в прейскуранте
   *             - идентификатор прочей договора
   */
  entryId?: Maybe<Scalars['Long']>;
  /** Признак того, что имеются акты прочих в статусе согласован */
  hasCompletedOtherActs?: Maybe<Scalars['Boolean']>;
  /** Признак того, что имеются акты СКзС в статусе согласован */
  hasCompletedSkzsActs?: Maybe<Scalars['Boolean']>;
  /** Признак того, что имеются акты СМР в статусе согласован */
  hasCompletedSmrActs?: Maybe<Scalars['Boolean']>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного согласованного объема по актам */
  hasEmptyActAcceptedVolume?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного планового объема по актам */
  hasEmptyActPlanVolume?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: Maybe<Scalars['Boolean']>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: Maybe<Scalars['Boolean']>;
  /** Признак того, что имеются акты прочих в работе или на проверке */
  hasOngoingOtherActs?: Maybe<Scalars['Boolean']>;
  /** Признак того, что имеются акты СКзС в работе или на проверке */
  hasOngoingSkzsActs?: Maybe<Scalars['Boolean']>;
  /** Признак того, что имеются акты СМР в работе или на проверке */
  hasOngoingSmrActs?: Maybe<Scalars['Boolean']>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: Maybe<Scalars['Boolean']>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак строки части данных раздела прочих НЗ */
  isOtherGroup: Scalars['Boolean'];
  /** Признак строки части данных позиции прочих НЗ */
  isOtherItem: Scalars['Boolean'];
  /** Признак строки части данных корневого объекта НЗ */
  isRootObject: Scalars['Boolean'];
  /** Признак строки части данных позиции СМР НЗ */
  isSMRItem: Scalars['Boolean'];
  /** Идентификатор сущности позиции */
  itemId: Scalars['Long'];
  /** Код МТР */
  mtrKey?: Maybe<Scalars['String']>;
  /** Наимеование */
  name?: Maybe<Scalars['String']>;
  /** Код объекта\подобъекта */
  objectCode?: Maybe<Scalars['String']>;
  /** Id конечного объекта */
  objectId?: Maybe<Scalars['Long']>;
  /** Название онечного объекта */
  objectName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор конечного объекта */
  objectUniqueId?: Maybe<Scalars['String']>;
  /** Код прочей */
  otherCostKey?: Maybe<Scalars['String']>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: Maybe<Scalars['String']>;
  /** Id корневого объекта */
  rootObjectId: Scalars['Long'];
  /** Название корневого объекта */
  rootObjectName: Scalars['String'];
  /** Уникальный идентификатор корневого объекта */
  rootObjectUniqueId?: Maybe<Scalars['String']>;
  /** Плановые и фактические значения по сезонам по пасценке */
  seasonValues?: Maybe<Array<WorkOrderPriceSeasonValue>>;
  /** Признак сортировки групп Прочих */
  sortOtherPart?: Maybe<Scalars['Int']>;
  /** Признак сортировки частей НЗ */
  sortPart?: Maybe<Scalars['Int']>;
  /** Признак сортировки типов позиций СМР */
  sortSMRPart?: Maybe<Scalars['Int']>;
  /** Статус */
  status?: Maybe<WorkOrderPriceStatusEnum>;
  /** Статус в форме строки */
  statusTip?: Maybe<Scalars['String']>;
  /** Общая фактическая стоимость по позиции */
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  /** Общий фактический выполненный объекм по позиции */
  totalCompletedVolume?: Maybe<Scalars['Decimal']>;
  /** Общая плановая стоимость по позиции */
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  /** Общий плановый объекм по позиции */
  totalPlanVolume?: Maybe<Scalars['Decimal']>;
  /** Общий остаток стоимости по позиции */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  /** Остаток общего плана по позиции */
  totalRemainderVolume?: Maybe<Scalars['Decimal']>;
  /** Тип позиции */
  type?: Maybe<WorkOrderPriceTypeEnum>;
  /** Шифр расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerCode?: Maybe<Scalars['String']>;
  /** Идентификатор позиции расценки УЕР для позиции самой расценки и ее потомков */
  uerCodeId?: Maybe<Scalars['Long']>;
  /** Идентификатор расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerId?: Maybe<Scalars['Long']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Выполнено (Кол-во) */
  workCompleted?: Maybe<Scalars['Decimal']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: Maybe<WorkInSumEnum>;
  /** К перехода из расценки */
  workKindWorkRatio?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода позиции */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Остаток (Кол-во) */
  workReminder?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

export type WorkOrderPriceItemCodeFilterData = {
  __typename?: 'WorkOrderPriceItemCodeFilterData';
  /** Шифр позиции */
  code: Scalars['String'];
  /** Признак МТР */
  isMtr: Scalars['Boolean'];
  /** Признак коэффициента */
  isRatio: Scalars['Boolean'];
  /** Признак расценки */
  isUer: Scalars['Boolean'];
  /** Признак типа позиции */
  sortSMRPart: Scalars['Int'];
  /** Шифр УЕР */
  uerCode: Scalars['String'];
  /** Id позиции расценкт */
  uerCodeId?: Maybe<Scalars['Long']>;
};

export type WorkOrderPriceItemCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderPriceItemCodeFilterDataFilterInput>>;
  /** Шифр позиции */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак МТР */
  isMtr?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак коэффициента */
  isRatio?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак расценки */
  isUer?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceItemCodeFilterDataFilterInput>>;
  /** Признак типа позиции */
  sortSMRPart?: InputMaybe<IntOperationFilterInput>;
  /** Шифр УЕР */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id позиции расценкт */
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
};

/** Модель позиции НЗ */
export type WorkOrderPriceItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderPriceItemFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Глава позиции */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Уникальный идентификатор позиции */
  clientId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор типа сущности */
  entityTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Название типа сущности */
  entityTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор типа сущности */
  entityTypeUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /**
   * Идентификар сущности, на которую ссылается позиция, в договоре.
   *             Либо:
   *             - идентификатор объекта договора
   *             - идентификатор в прейскуранте
   *             - идентификатор прочей договора
   */
  entryId?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что имеются акты прочих в статусе согласован */
  hasCompletedOtherActs?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что имеются акты СКзС в статусе согласован */
  hasCompletedSkzsActs?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что имеются акты СМР в статусе согласован */
  hasCompletedSmrActs?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного согласованного объема по актам */
  hasEmptyActAcceptedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActPlanCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного планового объема по актам */
  hasEmptyActPlanVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что имеются акты прочих в работе или на проверке */
  hasOngoingOtherActs?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что имеются акты СКзС в работе или на проверке */
  hasOngoingSkzsActs?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что имеются акты СМР в работе или на проверке */
  hasOngoingSmrActs?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных раздела прочих НЗ */
  isOtherGroup?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных позиции прочих НЗ */
  isOtherItem?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных корневого объекта НЗ */
  isRootObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных позиции СМР НЗ */
  isSMRItem?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор сущности позиции */
  itemId?: InputMaybe<LongOperationFilterInput>;
  /** Код МТР */
  mtrKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наимеование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код объекта\подобъекта */
  objectCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id конечного объекта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  /** Название онечного объекта */
  objectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор конечного объекта */
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceItemFilterInput>>;
  /** Код прочей */
  otherCostKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id корневого объекта */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Название корневого объекта */
  rootObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор корневого объекта */
  rootObjectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Плановые и фактические значения по сезонам по пасценке */
  seasonValues?: InputMaybe<ListFilterInputTypeOfWorkOrderPriceSeasonValueFilterInput>;
  /** Признак сортировки групп Прочих */
  sortOtherPart?: InputMaybe<IntOperationFilterInput>;
  /** Признак сортировки частей НЗ */
  sortPart?: InputMaybe<IntOperationFilterInput>;
  /** Признак сортировки типов позиций СМР */
  sortSMRPart?: InputMaybe<IntOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfWorkOrderPriceStatusEnumOperationFilterInput>;
  /** Статус в форме строки */
  statusTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Общая фактическая стоимость по позиции */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий фактический выполненный объекм по позиции */
  totalCompletedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Общая плановая стоимость по позиции */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий плановый объекм по позиции */
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий остаток стоимости по позиции */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток общего плана по позиции */
  totalRemainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Тип позиции */
  type?: InputMaybe<NullableOfWorkOrderPriceTypeEnumOperationFilterInput>;
  /** Шифр расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор позиции расценки УЕР для позиции самой расценки и ее потомков */
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerId?: InputMaybe<LongOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено (Кол-во) */
  workCompleted?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<NullableOfWorkInSumEnumOperationFilterInput>;
  /** К перехода из расценки */
  workKindWorkRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода позиции */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток (Кол-во) */
  workReminder?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Модель коэффициента стесненности */
export type WorkOrderPriceRatioRowData = {
  __typename?: 'WorkOrderPriceRatioRowData';
  /** Шифр коэффициента */
  code: Scalars['String'];
  /** Идентификатор области применения коэффициента */
  groupId: Scalars['Long'];
  /** Наименование области применения коэффициента */
  groupName: Scalars['String'];
  /** Идентификатор коэффициента */
  id: Scalars['Long'];
  /** Признак добавления коэффициента в Акт КС-2 */
  isIncludedInAct: Scalars['Boolean'];
  /** Признак добавления коэффициента в Наряд-заказ */
  isIncludedInWorkOrder: Scalars['Boolean'];
  /** Коэффициент эксплуатации машин (Кэм) */
  kem: Scalars['Decimal'];
  /** Коэффициент материалов (Кмат) */
  kmat?: Maybe<Scalars['Decimal']>;
  /** Коэффициент накладных расходов (Кнр) */
  knr: Scalars['Decimal'];
  /** Коэффициент основной заработной платы (Козп) */
  kozp: Scalars['Decimal'];
  /** Коэффициент сметной прибыли (Ксп) */
  ksp: Scalars['Decimal'];
  /** Значение коэффициента трудозатрат рабочих (Ктз) */
  ktz: Scalars['Decimal'];
  /** Значение коэффициента заработной платы машинистов (Ктззпм) */
  ktzzpm: Scalars['Decimal'];
  /** Статус коэффициента */
  ratioStatus?: Maybe<RatioRecordStatusEnum>;
  /** Тип коэффициента (только 'ConstraintCoefficient') */
  ratioType: RatioTypeEnum;
  /** Статус коэффициента в строковом виде */
  status?: Maybe<Scalars['String']>;
  /** Наименование коэффициента (условия производства работ) */
  workConditions: Scalars['String'];
};

/** Модель коэффициента стесненности */
export type WorkOrderPriceRatioRowDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderPriceRatioRowDataFilterInput>>;
  /** Шифр коэффициента */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор области применения коэффициента */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование области применения коэффициента */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор коэффициента */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак добавления коэффициента в Акт КС-2 */
  isIncludedInAct?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак добавления коэффициента в Наряд-заказ */
  isIncludedInWorkOrder?: InputMaybe<BooleanOperationFilterInput>;
  /** Коэффициент эксплуатации машин (Кэм) */
  kem?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент материалов (Кмат) */
  kmat?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент накладных расходов (Кнр) */
  knr?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент основной заработной платы (Козп) */
  kozp?: InputMaybe<DecimalOperationFilterInput>;
  /** Коэффициент сметной прибыли (Ксп) */
  ksp?: InputMaybe<DecimalOperationFilterInput>;
  /** Значение коэффициента трудозатрат рабочих (Ктз) */
  ktz?: InputMaybe<DecimalOperationFilterInput>;
  /** Значение коэффициента заработной платы машинистов (Ктззпм) */
  ktzzpm?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceRatioRowDataFilterInput>>;
  /** Статус коэффициента */
  ratioStatus?: InputMaybe<NullableOfRatioRecordStatusEnumOperationFilterInput>;
  /** Тип коэффициента (только 'ConstraintCoefficient') */
  ratioType?: InputMaybe<RatioTypeEnumOperationFilterInput>;
  /** Статус коэффициента в строковом виде */
  status?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование коэффициента (условия производства работ) */
  workConditions?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Модель коэффициента стесненности */
export type WorkOrderPriceRatioRowDataSortInput = {
  /** Шифр коэффициента */
  code?: InputMaybe<SortEnumType>;
  /** Идентификатор области применения коэффициента */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование области применения коэффициента */
  groupName?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента */
  id?: InputMaybe<SortEnumType>;
  /** Признак добавления коэффициента в Акт КС-2 */
  isIncludedInAct?: InputMaybe<SortEnumType>;
  /** Признак добавления коэффициента в Наряд-заказ */
  isIncludedInWorkOrder?: InputMaybe<SortEnumType>;
  /** Коэффициент эксплуатации машин (Кэм) */
  kem?: InputMaybe<SortEnumType>;
  /** Коэффициент материалов (Кмат) */
  kmat?: InputMaybe<SortEnumType>;
  /** Коэффициент накладных расходов (Кнр) */
  knr?: InputMaybe<SortEnumType>;
  /** Коэффициент основной заработной платы (Козп) */
  kozp?: InputMaybe<SortEnumType>;
  /** Коэффициент сметной прибыли (Ксп) */
  ksp?: InputMaybe<SortEnumType>;
  /** Значение коэффициента трудозатрат рабочих (Ктз) */
  ktz?: InputMaybe<SortEnumType>;
  /** Значение коэффициента заработной платы машинистов (Ктззпм) */
  ktzzpm?: InputMaybe<SortEnumType>;
  /** Статус коэффициента */
  ratioStatus?: InputMaybe<SortEnumType>;
  /** Тип коэффициента (только 'ConstraintCoefficient') */
  ratioType?: InputMaybe<SortEnumType>;
  /** Статус коэффициента в строковом виде */
  status?: InputMaybe<SortEnumType>;
  /** Наименование коэффициента (условия производства работ) */
  workConditions?: InputMaybe<SortEnumType>;
};

/** Данные для редактирования обоснования добавления расценки/МТР/коэффициента в Акт КС-2 (Примечания) */
export type WorkOrderPriceRationaleData = {
  __typename?: 'WorkOrderPriceRationaleData';
  /** Шифр расценки/МТР/коэффициента */
  code: Scalars['String'];
  /** Наименование расценки/МТР/коэффициента */
  name: Scalars['String'];
  /** Обоснование добавления расценки/МТР/коэффициента в Акт КС-2 (Примечание) */
  rationale?: Maybe<Scalars['String']>;
  /** Идентификатор строки прайса наряд-заказа */
  workOrderPriceId: Scalars['Long'];
};

/** Данные для редактирования обоснования добавления расценки/МТР/коэффициента в Акт КС-2 (Примечания) */
export type WorkOrderPriceRationaleDataInput = {
  /** Шифр расценки/МТР/коэффициента */
  code: Scalars['String'];
  /** Наименование расценки/МТР/коэффициента */
  name: Scalars['String'];
  /** Обоснование добавления расценки/МТР/коэффициента в Акт КС-2 (Примечание) */
  rationale?: InputMaybe<Scalars['String']>;
  /** Идентификатор строки прайса наряд-заказа */
  workOrderPriceId: Scalars['Long'];
};

/** Данные для обновления обоснования добавления расценки/МТР/коэффициента в Акт КС-2 */
export type WorkOrderPriceRationaleUpdateInput = {
  /** Обоснование добавления расценки/МТР/коэффициента в Акт КС-2 */
  rationale?: InputMaybe<Scalars['String']>;
};

/** Тип ревизии сметы наряд-заказа */
export enum WorkOrderPriceRevisionTypeEnum {
  None = 'NONE',
  /** Ревизия */
  Revision = 'REVISION',
  /** Обновление */
  Update = 'UPDATE'
}

/** Модель значения позиции в сезоне */
export type WorkOrderPriceSeasonValue = {
  __typename?: 'WorkOrderPriceSeasonValue';
  /** Значения позиции по актам в сезоне */
  actValues: Array<WorkOrderPriceActValue>;
  /** Фактическая стоимость за сезон */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** Фактически выполненный объем за сезон */
  completedVolume?: Maybe<Scalars['Decimal']>;
  /** Ошибки расчета по формуле */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибкок расчета по формуле */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Признак вида позиции: СМР, Прочие */
  itemTip: Scalars['Int'];
  /** Плановая стоимость в сезоне для прочих */
  planCost?: Maybe<Scalars['Decimal']>;
  planTerms?: Maybe<Array<Scalars['Decimal']>>;
  /** Плановое значение объема в сезоне */
  planVolume?: Maybe<Scalars['Decimal']>;
  /** Идентификатор позиции */
  priceId: Scalars['Long'];
  /** Остаток стоимости за сезон */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Остаток объема за сезон */
  remainderVolume?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  seasonYear: Scalars['Int'];
};

/** Модель значения позиции в сезоне */
export type WorkOrderPriceSeasonValueFilterInput = {
  /** Значения позиции по актам в сезоне */
  actValues?: InputMaybe<ListFilterInputTypeOfWorkOrderPriceActValueFilterInput>;
  and?: InputMaybe<Array<WorkOrderPriceSeasonValueFilterInput>>;
  /** Фактическая стоимость за сезон */
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Фактически выполненный объем за сезон */
  completedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Ошибки расчета по формуле */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия ошибкок расчета по формуле */
  hasErrors?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак вида позиции: СМР, Прочие */
  itemTip?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderPriceSeasonValueFilterInput>>;
  /** Плановая стоимость в сезоне для прочих */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planTerms?: InputMaybe<ListDecimalOperationFilterInput>;
  /** Плановое значение объема в сезоне */
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор позиции */
  priceId?: InputMaybe<LongOperationFilterInput>;
  /** Остаток стоимости за сезон */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток объема за сезон */
  remainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  seasonYear?: InputMaybe<IntOperationFilterInput>;
};

export enum WorkOrderPriceStatusEnum {
  /** Условие ДС */
  AdditionalCondition = 'ADDITIONAL_CONDITION',
  /** Условие договора */
  ContractCondition = 'CONTRACT_CONDITION',
  /** Черновик */
  Draft = 'DRAFT',
  /** Новая запись */
  NewRecord = 'NEW_RECORD',
  /** Нет */
  None = 'NONE'
}

export type WorkOrderPriceStatusEnumOperationFilterInput = {
  eq?: InputMaybe<WorkOrderPriceStatusEnum>;
  in?: InputMaybe<Array<WorkOrderPriceStatusEnum>>;
  neq?: InputMaybe<WorkOrderPriceStatusEnum>;
  nin?: InputMaybe<Array<WorkOrderPriceStatusEnum>>;
};

/** Типы позиций в НЗ/Изме/Версии */
export enum WorkOrderPriceTypeEnum {
  /** Коэффициент */
  Coefficient = 'COEFFICIENT',
  /** Коэффициент стесненности */
  ConstraintCoefficient = 'CONSTRAINT_COEFFICIENT',
  /** Коэффициент демонтажа */
  DismantlingCoefficient = 'DISMANTLING_COEFFICIENT',
  /** МТР */
  Mtr = 'MTR',
  /** МТР (оборудование подрядчика) */
  MtrContractorEquipment = 'MTR_CONTRACTOR_EQUIPMENT',
  /** МТР (материал подрядчика) */
  MtrContractorMaterial = 'MTR_CONTRACTOR_MATERIAL',
  /** МТР (оборудование заказчика) */
  MtrCustomerEquipment = 'MTR_CUSTOMER_EQUIPMENT',
  /** МТР (материал заказчика) */
  MtrCustomerMaterial = 'MTR_CUSTOMER_MATERIAL',
  /** Нет */
  None = 'NONE',
  /** Конечный объект */
  Object = 'OBJECT',
  /** Прочая */
  Other = 'OTHER',
  /** Раздел Прочих */
  OtherGroup = 'OTHER_GROUP',
  /** Корневой объект */
  RootObject = 'ROOT_OBJECT',
  /** Коэффициент технической части */
  TechPartCoefficient = 'TECH_PART_COEFFICIENT',
  /** УЕР */
  Uer = 'UER'
}

export type WorkOrderPriceTypeEnumOperationFilterInput = {
  eq?: InputMaybe<WorkOrderPriceTypeEnum>;
  in?: InputMaybe<Array<WorkOrderPriceTypeEnum>>;
  neq?: InputMaybe<WorkOrderPriceTypeEnum>;
  nin?: InputMaybe<Array<WorkOrderPriceTypeEnum>>;
};

/** Данные раздела итога наряд-заказа */
export type WorkOrderResultData = {
  __typename?: 'WorkOrderResultData';
  /** Список итогов по актам наряд-заказа */
  actKC2Results: Array<WorkOrderActKc2ResultData>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор раздела */
  resultSectionId: Scalars['Long'];
  /** Список итогов по сезонам наряд-заказа */
  seasonResults: Array<WorkOrderSeasonResultData>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Название раздела c итогами наряд-заказа */
  title: Scalars['String'];
  /** Выполнено по наряд-заказу */
  totalCompletedCost: Scalars['Decimal'];
  /** План по наряд-заказу */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по наряд-заказу */
  totalRemainderCost: Scalars['Decimal'];
};

/** Отображение итогов наряд-заказа */
export type WorkOrderResultViewData = {
  __typename?: 'WorkOrderResultViewData';
  /** Список актов выполненных работ по наряд-заказу */
  actKC2s: Array<WorkOrderActKc2Data>;
  /** Список данных итогов наряд-заказа */
  results: Array<WorkOrderResultData>;
  /** Список сезонов наряд-заказа */
  seasons: Array<WorkOrderSeasonData>;
};

/** Информация о свойствах СКзС в НЗ */
export type WorkOrderSKzSInfo = {
  __typename?: 'WorkOrderSKzSInfo';
  /** Количество новых Актов КС-2 СКзС */
  actsKC2SKzSNewCount: Scalars['Int'];
  /** Количество обновлённых Актов КС-2 СКзС */
  actsKC2SKzSUpdatedCount: Scalars['Int'];
};

/** Информация о свойствах СКзС в НЗ */
export type WorkOrderSKzSInfoInput = {
  /** Количество новых Актов КС-2 СКзС */
  actsKC2SKzSNewCount: Scalars['Int'];
  /** Количество обновлённых Актов КС-2 СКзС */
  actsKC2SKzSUpdatedCount: Scalars['Int'];
};

export type WorkOrderSeasonData = {
  __typename?: 'WorkOrderSeasonData';
  id: Scalars['Long'];
  year: Scalars['Short'];
};

export type WorkOrderSeasonDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderSeasonDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderSeasonDataFilterInput>>;
  year?: InputMaybe<ShortOperationFilterInput>;
};

export type WorkOrderSeasonDataInput = {
  id: Scalars['Long'];
  year: Scalars['Short'];
};

export type WorkOrderSeasonPriceData = {
  __typename?: 'WorkOrderSeasonPriceData';
  completedCost?: Maybe<Scalars['Decimal']>;
  completedVolume?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Long']>;
  planCost?: Maybe<Scalars['Decimal']>;
  planVolume?: Maybe<Scalars['Decimal']>;
  planVolumeTerms?: Maybe<Array<Scalars['Decimal']>>;
  remainderCost?: Maybe<Scalars['Decimal']>;
  remainderVolume?: Maybe<Scalars['Decimal']>;
  seasonId: Scalars['Long'];
};

export type WorkOrderSeasonPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderSeasonPriceDataFilterInput>>;
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  completedVolume?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderSeasonPriceDataFilterInput>>;
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  planVolumeTerms?: InputMaybe<ListDecimalOperationFilterInput>;
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  remainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные итога наряд-заказа по сезону */
export type WorkOrderSeasonResultData = {
  __typename?: 'WorkOrderSeasonResultData';
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Значение итога */
  value: Scalars['Decimal'];
};

/** Строка итога по сезону НЗ */
export type WorkOrderSeasonTotalData = {
  __typename?: 'WorkOrderSeasonTotalData';
  /** Выполнено по сезону НЗ */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** План по сезону НЗ */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Строка итога по сезону НЗ */
export type WorkOrderSeasonTotalDataInput = {
  /** Выполнено по сезону НЗ */
  completedCost?: InputMaybe<Scalars['Decimal']>;
  /** План по сезону НЗ */
  planCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Входные данные для обновления сезонов НЗ */
export type WorkOrderSeasonsInput = {
  /** Идентификатор начального сезона Договора */
  firstContractSeasonId: Scalars['Long'];
  /** Идентификатор конечного сезона Договора */
  lastContractSeasonId: Scalars['Long'];
};

/** Выходные данные после обновления сезонов НЗ */
export type WorkOrderSeasonsUpdateData = {
  __typename?: 'WorkOrderSeasonsUpdateData';
  /** Идентификатор начального сезона Договора */
  firstContractSeasonId: Scalars['Long'];
  /** Идентификатор конечного сезона Договора */
  lastContractSeasonId: Scalars['Long'];
};

/** Выходные данные после обновления сезонов НЗ */
export type WorkOrderSeasonsUpdateDataInput = {
  /** Идентификатор начального сезона Договора */
  firstContractSeasonId: Scalars['Long'];
  /** Идентификатор конечного сезона Договора */
  lastContractSeasonId: Scalars['Long'];
};

export enum WorkOrderStatusEnum {
  /** Завершен */
  Completed = 'COMPLETED',
  /** Отложен */
  Delayed = 'DELAYED',
  /** В работе */
  InProgress = 'IN_PROGRESS',
  /** На формировании */
  OnFormation = 'ON_FORMATION'
}

export type WorkOrderStatusEnumOperationFilterInput = {
  eq?: InputMaybe<WorkOrderStatusEnum>;
  in?: InputMaybe<Array<WorkOrderStatusEnum>>;
  neq?: InputMaybe<WorkOrderStatusEnum>;
  nin?: InputMaybe<Array<WorkOrderStatusEnum>>;
};

/** Строка итога НЗ */
export type WorkOrderTotalData = {
  __typename?: 'WorkOrderTotalData';
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Список строк итогов по сезонам НЗ */
  seasonTotals: Array<WorkOrderSeasonTotalData>;
  /** Выполнено по НЗ */
  totalCompletedCost: Scalars['Decimal'];
  /** План по НЗ */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по НЗ */
  totalRemainderCost: Scalars['Decimal'];
};

/** Строка итога НЗ */
export type WorkOrderTotalDataInput = {
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** Список строк итогов по сезонам НЗ */
  seasonTotals: Array<WorkOrderSeasonTotalDataInput>;
  /** Выполнено по НЗ */
  totalCompletedCost: Scalars['Decimal'];
  /** План по НЗ */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по НЗ */
  totalRemainderCost: Scalars['Decimal'];
};

/** Данные расценки НЗ */
export type WorkOrderUerItemData = {
  __typename?: 'WorkOrderUerItemData';
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Шифр */
  code: Scalars['String'];
  groupFullName: Scalars['String'];
  /** Наименование подраздела */
  groupId: Scalars['Long'];
  /** Наименование подраздела */
  groupName: Scalars['String'];
  /** Идентификатор расценки */
  id: Scalars['Long'];
  /** Примечание */
  justification?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор раздела */
  sectionId: Scalars['Long'];
  /** Наименование раздела */
  sectionName: Scalars['String'];
  /** Статус */
  status: UerRecordStatusEnum;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость единицы измерения */
  unitCost?: Maybe<Scalars['Decimal']>;
};

/** Данные расценки НЗ */
export type WorkOrderUerItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderUerItemDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupFullName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование подраздела */
  groupId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование подраздела */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор расценки */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Примечание */
  justification?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderUerItemDataFilterInput>>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Статус */
  status?: InputMaybe<UerRecordStatusEnumOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость единицы измерения */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные расценки НЗ */
export type WorkOrderUerItemDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  groupFullName?: InputMaybe<SortEnumType>;
  /** Наименование подраздела */
  groupId?: InputMaybe<SortEnumType>;
  /** Наименование подраздела */
  groupName?: InputMaybe<SortEnumType>;
  /** Идентификатор расценки */
  id?: InputMaybe<SortEnumType>;
  /** Примечание */
  justification?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  sectionId?: InputMaybe<SortEnumType>;
  /** Наименование раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Статус */
  status?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  /** Стоимость единицы измерения */
  unitCost?: InputMaybe<SortEnumType>;
};

export type WorkOrderUpdateInput = {
  finishDate: Scalars['DateTime'];
  id: Scalars['Long'];
  internalNumber?: InputMaybe<Scalars['String']>;
  signingDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  status: WorkOrderStatusEnum;
  subject?: InputMaybe<Scalars['String']>;
};

export type WorkOrderVersionActKc2Data = {
  __typename?: 'WorkOrderVersionActKC2Data';
  /** Дата корректировки корректировочного акта */
  correctionDate?: Maybe<Scalars['DateTime']>;
  /** Номер коррекции акта */
  correctionNumber?: Maybe<Scalars['Long']>;
  /** Группа затрат */
  costGroup: CostGroupEnum;
  /** Дата акта */
  date?: Maybe<Scalars['Date']>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: Maybe<Scalars['String']>;
  /** Идентификатор акта */
  id: Scalars['Long'];
  /** Идентификатор сезона инфляции акта */
  inflationSeasonId?: Maybe<Scalars['Long']>;
  /** Сезон инфляции акта */
  inflationSeasonYear?: Maybe<Scalars['Int']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Идентификатор сезона инфляции акта */
  isDistributionOfMtrInflation: Scalars['Boolean'];
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: Maybe<Scalars['Boolean']>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied: Scalars['Boolean'];
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated: Scalars['Boolean'];
  /** Номер акта */
  number?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта акта */
  objectId: Scalars['Long'];
  /** Дата окончания отчетного периода */
  reportingFinishDate?: Maybe<Scalars['Date']>;
  /** Дата начала отчетного периода */
  reportingStartDate?: Maybe<Scalars['Date']>;
  /** Идентификатор сезона акта */
  seasonId: Scalars['Long'];
  /** Сезон акта */
  seasonYear: Scalars['Int'];
  /** Статус акта */
  status: ActKc2StatusEnum;
  /** Статус СКзС */
  statusSKzS?: Maybe<SkzsActKc2StatusEnum>;
};

export type WorkOrderVersionActKc2DataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionActKc2DataFilterInput>>;
  /** Дата корректировки корректировочного акта */
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Номер коррекции акта */
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  /** Группа затрат */
  costGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Дата акта */
  date?: InputMaybe<DateOperationFilterInput>;
  /** Полный номер акта, с учётом номера коррекции */
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор акта */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона инфляции акта */
  inflationSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон инфляции акта */
  inflationSeasonYear?: InputMaybe<IntOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор сезона инфляции акта */
  isDistributionOfMtrInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено копирование объёма из СКзС */
  isSKzSCopied?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что было выполнено обновление объёма из СКзС */
  isSKzSUpdated?: InputMaybe<BooleanOperationFilterInput>;
  /** Номер акта */
  number?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта акта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionActKc2DataFilterInput>>;
  /** Дата окончания отчетного периода */
  reportingFinishDate?: InputMaybe<DateOperationFilterInput>;
  /** Дата начала отчетного периода */
  reportingStartDate?: InputMaybe<DateOperationFilterInput>;
  /** Идентификатор сезона акта */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон акта */
  seasonYear?: InputMaybe<IntOperationFilterInput>;
  /** Статус акта */
  status?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  /** Статус СКзС */
  statusSKzS?: InputMaybe<NullableOfSkzsActKc2StatusEnumOperationFilterInput>;
};

export type WorkOrderVersionActKc2VersionData = {
  __typename?: 'WorkOrderVersionActKC2VersionData';
  correctionDate?: Maybe<Scalars['DateTime']>;
  correctionNumber?: Maybe<Scalars['Long']>;
  date?: Maybe<Scalars['DateTime']>;
  fullNumber?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  isCorrection?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  number?: Maybe<Scalars['Long']>;
  seasonId: Scalars['Long'];
  status: ActKc2StatusEnum;
};

export type WorkOrderVersionActKc2VersionDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionActKc2VersionDataFilterInput>>;
  correctionDate?: InputMaybe<DateTimeOperationFilterInput>;
  correctionNumber?: InputMaybe<LongOperationFilterInput>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  fullNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  number?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionActKc2VersionDataFilterInput>>;
  seasonId?: InputMaybe<LongOperationFilterInput>;
  status?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
};

export type WorkOrderVersionActKc2VersionDataSortInput = {
  correctionDate?: InputMaybe<SortEnumType>;
  correctionNumber?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  fullNumber?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isCorrection?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  seasonId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

export type WorkOrderVersionActKc2VersionPriceData = {
  __typename?: 'WorkOrderVersionActKC2VersionPriceData';
  acceptedCost?: Maybe<Scalars['Decimal']>;
  acceptedVolume?: Maybe<Scalars['Decimal']>;
  acceptedVolumeDeviation?: Maybe<DeviationEnum>;
  actKC2VersionId: Scalars['Long'];
  actKC2VersionSeasonId: Scalars['Long'];
  actKC2VersionStatus: ActKc2StatusEnum;
  id?: Maybe<Scalars['Long']>;
  planCost?: Maybe<Scalars['Decimal']>;
  planVolume?: Maybe<Scalars['Decimal']>;
  planVolumeDeviation?: Maybe<DeviationEnum>;
};

export type WorkOrderVersionActKc2VersionPriceDataFilterInput = {
  acceptedCost?: InputMaybe<DecimalOperationFilterInput>;
  acceptedVolume?: InputMaybe<DecimalOperationFilterInput>;
  acceptedVolumeDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  actKC2VersionId?: InputMaybe<LongOperationFilterInput>;
  actKC2VersionSeasonId?: InputMaybe<LongOperationFilterInput>;
  actKC2VersionStatus?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionActKc2VersionPriceDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionActKc2VersionPriceDataFilterInput>>;
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  planVolumeDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
};

/** Данные итога версии наряд-заказа по версии акта КС-2 */
export type WorkOrderVersionActKc2VersionResultData = {
  __typename?: 'WorkOrderVersionActKC2VersionResultData';
  /** Идентификатор версии акта КС-2 */
  actKC2VersionId: Scalars['Long'];
  /** Значение итога */
  value: Scalars['Decimal'];
};

/** Данные итога версии наряд-заказа по версии акта КС-2 */
export type WorkOrderVersionActKc2VersionResultDataFilterInput = {
  /** Идентификатор версии акта КС-2 */
  actKC2VersionId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionActKc2VersionResultDataFilterInput>>;
  or?: InputMaybe<Array<WorkOrderVersionActKc2VersionResultDataFilterInput>>;
  /** Значение итога */
  value?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные итога версии наряд-заказа по сезону */
export type WorkOrderVersionCostResultData = {
  __typename?: 'WorkOrderVersionCostResultData';
  /** Название итога */
  name: Scalars['String'];
  /** Значение итога */
  value: Scalars['Decimal'];
  /** Год */
  year: Scalars['Short'];
};

/** Данные итога версии наряд-заказа по сезону */
export type WorkOrderVersionCostResultDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionCostResultDataFilterInput>>;
  /** Название итога */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionCostResultDataFilterInput>>;
  /** Значение итога */
  value?: InputMaybe<DecimalOperationFilterInput>;
  /** Год */
  year?: InputMaybe<ShortOperationFilterInput>;
};

export type WorkOrderVersionData = {
  __typename?: 'WorkOrderVersionData';
  amountWithTax: Scalars['Decimal'];
  amountWithoutTax: Scalars['Decimal'];
  authoredBy: Scalars['String'];
  contractor?: Maybe<Scalars['String']>;
  contractorAddress?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  finishDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  inflationData: Array<ContractSeasonInflationData>;
  internalNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  newRecordsCount?: Maybe<Scalars['Int']>;
  remainder: Scalars['Decimal'];
  signingDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
  subject?: Maybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vorType: WorkOrderVorTypeEnum;
  workOrderChange?: Maybe<WorkOrderChangeItem>;
};

export type WorkOrderVersionDataInput = {
  amountWithTax: Scalars['Decimal'];
  amountWithoutTax: Scalars['Decimal'];
  authoredBy: Scalars['String'];
  contractor?: InputMaybe<Scalars['String']>;
  contractorAddress?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  finishDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Long'];
  inflationData: Array<ContractSeasonInflationDataInput>;
  internalNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newRecordsCount?: InputMaybe<Scalars['Int']>;
  remainder: Scalars['Decimal'];
  signingDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
  subject?: InputMaybe<Scalars['String']>;
  tax: Scalars['Decimal'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vorType: WorkOrderVorTypeEnum;
  workOrderChange?: InputMaybe<WorkOrderChangeItemInput>;
};

export type WorkOrderVersionItem = {
  __typename?: 'WorkOrderVersionItem';
  id: Scalars['Long'];
  internalNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  signingDate?: Maybe<Scalars['DateTime']>;
  status: WorkOrderStatusEnum;
};

export type WorkOrderVersionItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionItemFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  internalNumber?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionItemFilterInput>>;
  signingDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<WorkOrderStatusEnumOperationFilterInput>;
};

export type WorkOrderVersionItemSortInput = {
  id?: InputMaybe<SortEnumType>;
  internalNumber?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  signingDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
};

/** Лимиты по виду строительства версии наряд-заказа */
export type WorkOrderVersionLimitedCostConstructionTypeLimitData = {
  __typename?: 'WorkOrderVersionLimitedCostConstructionTypeLimitData';
  /** % лимитированных */
  calculatingValue: Scalars['Decimal'];
  /** Вид строительства */
  constructionType: ConstructionTypeData;
  /** Лимиты затрат по сезонам */
  seasonLimits: Array<WorkOrderVersionLimitedCostSeasonLimitData>;
};

/** Лимиты по виду строительства версии наряд-заказа */
export type WorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput>>;
  /** % лимитированных */
  calculatingValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Вид строительства */
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput>>;
  /** Лимиты затрат по сезонам */
  seasonLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionLimitedCostSeasonLimitDataFilterInput>;
};

/** Модель данных лимитированной затраты версии наряд-заказа для списка */
export type WorkOrderVersionLimitedCostItemData = {
  __typename?: 'WorkOrderVersionLimitedCostItemData';
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<Scalars['String']>;
  /** Лимиты по виду строительства */
  constructionTypeLimits: Array<WorkOrderVersionLimitedCostConstructionTypeLimitData>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Шифр ДТ */
  key?: Maybe<Scalars['String']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId: Scalars['Long'];
};

/** Модель данных лимитированной затраты версии наряд-заказа для списка */
export type WorkOrderVersionLimitedCostItemDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionLimitedCostItemDataFilterInput>>;
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Лимиты по виду строительства */
  constructionTypeLimits?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionLimitedCostConstructionTypeLimitDataFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Шифр ДТ */
  key?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionLimitedCostItemDataFilterInput>>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
};

/** Модель данных лимитированной затраты версии наряд-заказа для списка */
export type WorkOrderVersionLimitedCostItemDataSortInput = {
  /** Идентификатор типа лимитированной затраты (каталог ДТ) */
  catalogLimitedCostTypeId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор */
  id?: InputMaybe<SortEnumType>;
  /** Шифр ДТ */
  key?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор версии наряд-заказа */
  workOrderVersionId?: InputMaybe<SortEnumType>;
};

/** Сезонный лимит лимитированной затраты версии наряд-заказа */
export type WorkOrderVersionLimitedCostSeasonLimitData = {
  __typename?: 'WorkOrderVersionLimitedCostSeasonLimitData';
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Стоимость */
  cost: Scalars['Decimal'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Сезонный лимит лимитированной затраты версии наряд-заказа */
export type WorkOrderVersionLimitedCostSeasonLimitDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionLimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Стоимость */
  cost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionLimitedCostSeasonLimitDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

export type WorkOrderVersionListItem = {
  __typename?: 'WorkOrderVersionListItem';
  workOrderChangeItem?: Maybe<WorkOrderChangeItem>;
  workOrderVersionItem: WorkOrderVersionItem;
};

export type WorkOrderVersionListItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionListItemFilterInput>>;
  or?: InputMaybe<Array<WorkOrderVersionListItemFilterInput>>;
  workOrderChangeItem?: InputMaybe<WorkOrderChangeItemFilterInput>;
  workOrderVersionItem?: InputMaybe<WorkOrderVersionItemFilterInput>;
};

export type WorkOrderVersionListItemSortInput = {
  workOrderChangeItem?: InputMaybe<WorkOrderChangeItemSortInput>;
  workOrderVersionItem?: InputMaybe<WorkOrderVersionItemSortInput>;
};

export type WorkOrderVersionObjectData = {
  __typename?: 'WorkOrderVersionObjectData';
  code?: Maybe<Scalars['String']>;
  codeWBS?: Maybe<Scalars['String']>;
  constructionType: ConstructionTypeData;
  hasPrices: Scalars['Boolean'];
  hasPricesOther: Scalars['Boolean'];
  id: Scalars['Long'];
  name: Scalars['String'];
  objectUniqueId: Scalars['String'];
  parentId?: Maybe<Scalars['Long']>;
  rootObjectId?: Maybe<Scalars['Long']>;
  rootObjectUniqueId?: Maybe<Scalars['String']>;
  status: ContractObjectStatusEnum;
  workOrderVersionId: Scalars['Long'];
};

export type WorkOrderVersionObjectDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionObjectDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  codeWBS?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  constructionType?: InputMaybe<ConstructionTypeDataFilterInput>;
  hasPrices?: InputMaybe<BooleanOperationFilterInput>;
  hasPricesOther?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionObjectDataFilterInput>>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  rootObjectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  status?: InputMaybe<ContractObjectStatusEnumOperationFilterInput>;
  workOrderVersionId?: InputMaybe<LongOperationFilterInput>;
};

export type WorkOrderVersionObjectDataSortInput = {
  code?: InputMaybe<SortEnumType>;
  codeWBS?: InputMaybe<SortEnumType>;
  constructionType?: InputMaybe<ConstructionTypeDataSortInput>;
  hasPrices?: InputMaybe<SortEnumType>;
  hasPricesOther?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  objectUniqueId?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  rootObjectId?: InputMaybe<SortEnumType>;
  rootObjectUniqueId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  workOrderVersionId?: InputMaybe<SortEnumType>;
};

/** Данные раздела итога по объекту версии наряд-заказа */
export type WorkOrderVersionObjectResultData = {
  __typename?: 'WorkOrderVersionObjectResultData';
  /** Идентификатор версии акта выполненных работ КС-2 */
  actKC2VersionId?: Maybe<Scalars['Long']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Список итогов наряд-заказа */
  costResults: Array<WorkOrderVersionCostResultData>;
  /** Идентификатор объекта строительства */
  objectId: Scalars['Long'];
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Название раздела */
  title: Scalars['String'];
};

/** Данные раздела итога по объекту версии наряд-заказа */
export type WorkOrderVersionObjectResultDataFilterInput = {
  /** Идентификатор версии акта выполненных работ КС-2 */
  actKC2VersionId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionObjectResultDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Список итогов наряд-заказа */
  costResults?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionCostResultDataFilterInput>;
  /** Идентификатор объекта строительства */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionObjectResultDataFilterInput>>;
  /** Секция */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Название раздела */
  title?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Данные раздела итога по объекту версии наряд-заказа */
export type WorkOrderVersionObjectResultDataSortInput = {
  /** Идентификатор версии акта выполненных работ КС-2 */
  actKC2VersionId?: InputMaybe<SortEnumType>;
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта строительства */
  objectId?: InputMaybe<SortEnumType>;
  /** Секция */
  section?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Название раздела */
  title?: InputMaybe<SortEnumType>;
};

/** Стоимость выполненных работ по прочим затратам версии акта КС-2 */
export type WorkOrderVersionOtherActKc2VersionPriceData = {
  __typename?: 'WorkOrderVersionOtherActKC2VersionPriceData';
  /** Стоимость (согласовано) */
  acceptedCost?: Maybe<Scalars['Decimal']>;
  /** Отклонение стоимости (согласовано) */
  acceptedCostDeviation?: Maybe<DeviationEnum>;
  /** Идентификатор версии акта КС-2 */
  actKC2VersionId: Scalars['Long'];
  /** Идентификатор сезона версии акта КС-2 */
  actKC2VersionSeasonId: Scalars['Long'];
  /** Статус версии акта КС-2 */
  actKC2VersionStatus: ActKc2StatusEnum;
  /** Стоимость (план) */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Отклонение стоимости (план) */
  planCostDeviation?: Maybe<DeviationEnum>;
};

/** Стоимость выполненных работ по прочим затратам версии акта КС-2 */
export type WorkOrderVersionOtherActKc2VersionPriceDataFilterInput = {
  /** Стоимость (согласовано) */
  acceptedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение стоимости (согласовано) */
  acceptedCostDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Идентификатор версии акта КС-2 */
  actKC2VersionId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор сезона версии акта КС-2 */
  actKC2VersionSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Статус версии акта КС-2 */
  actKC2VersionStatus?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionOtherActKc2VersionPriceDataFilterInput>>;
  or?: InputMaybe<Array<WorkOrderVersionOtherActKc2VersionPriceDataFilterInput>>;
  /** Стоимость (план) */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Отклонение стоимости (план) */
  planCostDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
};

/** Прочая затрата версии наряд-заказа */
export type WorkOrderVersionOtherPriceData = {
  __typename?: 'WorkOrderVersionOtherPriceData';
  /** Список прочих затрат по актам */
  actKC2VersionPrices?: Maybe<Array<WorkOrderVersionOtherActKc2VersionPriceData>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: Maybe<CatalogOtherCostTypeData>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: Maybe<Scalars['Int']>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор из договора */
  contractOtherId: Scalars['Long'];
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActVersionAcceptedCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActVersionPlanCost?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам НЗ */
  hasEmptySeasonCost?: Maybe<Scalars['Boolean']>;
  /** Идентификатор */
  id: Scalars['Long'];
  /** Признак того, что прочая затрата относится к актам */
  isActKC2VersionPrice: Scalars['Boolean'];
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Наименование */
  name: Scalars['String'];
  /** Список прочих затрат по сезонам */
  seasonPrices?: Maybe<Array<WorkOrderVersionOtherSeasonPriceData>>;
  /** Раздел */
  section?: Maybe<SectionEnum>;
  /** Статус */
  status?: Maybe<ContractOtherStatusEnum>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
};

/** Прочая затрата версии наряд-заказа */
export type WorkOrderVersionOtherPriceDataFilterInput = {
  /** Список прочих затрат по актам */
  actKC2VersionPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionOtherActKc2VersionPriceDataFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionOtherPriceDataFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Запись справочника типа прочих */
  catalogOtherCostType?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  /** Идентификатор записи справочника типов прочих */
  catalogOtherCostTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Идентификатор из договора */
  contractOtherId?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что нет ни одной заданной согласованной стоимости по актам */
  hasEmptyActVersionAcceptedCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной плановой стоимости по актам */
  hasEmptyActVersionPlanCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одной заданной стоимости по сезонам НЗ */
  hasEmptySeasonCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2VersionPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionOtherPriceDataFilterInput>>;
  /** Список прочих затрат по сезонам */
  seasonPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionOtherSeasonPriceDataFilterInput>;
  /** Раздел */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfContractOtherStatusEnumOperationFilterInput>;
  /** Стоимость выполненных работ по наряд-заказу */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Стоимость всего по наряд-заказу */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Сезонная прочая затрата версии наряд-заказа */
export type WorkOrderVersionOtherSeasonPriceData = {
  __typename?: 'WorkOrderVersionOtherSeasonPriceData';
  /** Стоимость выполненных работ по сезону */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** Стоимость работ по сезону */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Остаток по сезону */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона версии наряд-заказа */
  seasonId: Scalars['Long'];
};

/** Сезонная прочая затрата версии наряд-заказа */
export type WorkOrderVersionOtherSeasonPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionOtherSeasonPriceDataFilterInput>>;
  /** Стоимость выполненных работ по сезону */
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionOtherSeasonPriceDataFilterInput>>;
  /** Стоимость работ по сезону */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по сезону */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сезона версии наряд-заказа */
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Модель значения позиции в сезоне по акту */
export type WorkOrderVersionPriceActValue = {
  __typename?: 'WorkOrderVersionPriceActValue';
  /** Значение согласованной стоимости в сезоне по позиции */
  actCostAccepted?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по согласованной стоимости в сезоне по позиции */
  actCostAcceptedDeviation?: Maybe<DeviationEnum>;
  /** Группа затрат акта */
  actCostGroup: CostGroupEnum;
  /** Значение плана стоимости в сезоне по позиции */
  actCostPlan?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по стоимости плана в сезоне по позиции */
  actCostPlanDeviation?: Maybe<DeviationEnum>;
  /** Признак редактируемости стоимости в акте по позиции */
  actHasEditableCost?: Maybe<Scalars['Boolean']>;
  /** Идентификатор акта */
  actId: Scalars['Long'];
  /** Сезон распределением инфляции по позицииям МТ */
  actInflationSeasonId?: Maybe<Scalars['Long']>;
  /** Статус акта в строке */
  actStatus: ActKc2StatusEnum;
  /** Статус СКзС */
  actStatusSKzS?: Maybe<SkzsActKc2StatusEnum>;
  /** Значение согласованного объема в сезоне по позиции */
  actVolumeAccepted?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по согласованного объему в сезоне по позиции */
  actVolumeAcceptedDeviation?: Maybe<DeviationEnum>;
  /** Признак нередактируемого объема */
  actVolumeIsReadOnly?: Maybe<Scalars['Boolean']>;
  /** Значение плана объема в сезоне по позиции */
  actVolumePlan?: Maybe<Scalars['Decimal']>;
  /** Индикатор превышения по объему плана в сезоне по позиции */
  actVolumePlanDeviation?: Maybe<DeviationEnum>;
  /** Объем (план) из СКзС */
  actVolumePlanSKzS?: Maybe<Scalars['Decimal']>;
  /** Комментарий к расценке или прочей в акте */
  comment?: Maybe<Scalars['String']>;
  /** Признак акта с распределением инфляции по позицииям МТР */
  isActKC2DistributionOfMtrInflation?: Maybe<Scalars['Boolean']>;
  /** Признак корректировочного акта */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** Признак неактивного акта */
  isInactive?: Maybe<Scalars['Boolean']>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: Maybe<Scalars['Boolean']>;
};

/** Модель значения позиции в сезоне по акту */
export type WorkOrderVersionPriceActValueFilterInput = {
  /** Значение согласованной стоимости в сезоне по позиции */
  actCostAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по согласованной стоимости в сезоне по позиции */
  actCostAcceptedDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Группа затрат акта */
  actCostGroup?: InputMaybe<CostGroupEnumOperationFilterInput>;
  /** Значение плана стоимости в сезоне по позиции */
  actCostPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по стоимости плана в сезоне по позиции */
  actCostPlanDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Признак редактируемости стоимости в акте по позиции */
  actHasEditableCost?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор акта */
  actId?: InputMaybe<LongOperationFilterInput>;
  /** Сезон распределением инфляции по позицииям МТ */
  actInflationSeasonId?: InputMaybe<LongOperationFilterInput>;
  /** Статус акта в строке */
  actStatus?: InputMaybe<ActKc2StatusEnumOperationFilterInput>;
  /** Статус СКзС */
  actStatusSKzS?: InputMaybe<NullableOfSkzsActKc2StatusEnumOperationFilterInput>;
  /** Значение согласованного объема в сезоне по позиции */
  actVolumeAccepted?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по согласованного объему в сезоне по позиции */
  actVolumeAcceptedDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Признак нередактируемого объема */
  actVolumeIsReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  /** Значение плана объема в сезоне по позиции */
  actVolumePlan?: InputMaybe<DecimalOperationFilterInput>;
  /** Индикатор превышения по объему плана в сезоне по позиции */
  actVolumePlanDeviation?: InputMaybe<NullableOfDeviationEnumOperationFilterInput>;
  /** Объем (план) из СКзС */
  actVolumePlanSKzS?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionPriceActValueFilterInput>>;
  /** Комментарий к расценке или прочей в акте */
  comment?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак акта с распределением инфляции по позицииям МТР */
  isActKC2DistributionOfMtrInflation?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак корректировочного акта */
  isCorrection?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак неактивного акта */
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что акт загружен из СКзС */
  isSKzS?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionPriceActValueFilterInput>>;
};

export type WorkOrderVersionPriceData = {
  __typename?: 'WorkOrderVersionPriceData';
  actKC2VersionPrices?: Maybe<Array<WorkOrderVersionActKc2VersionPriceData>>;
  code: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  /** Признак того, что нет ни одного заданного согласованного объема по актам */
  hasEmptyActVersionAcceptedVolume?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного планового объема по актам */
  hasEmptyActVersionPlanVolume?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  isActKC2VersionPrice: Scalars['Boolean'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Long']>;
  priceListId: Scalars['Long'];
  seasonPrices?: Maybe<Array<WorkOrderVersionSeasonPriceData>>;
  shortName?: Maybe<Scalars['String']>;
  status: WorkOrderPriceStatusEnum;
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  totalCompletedVolume?: Maybe<Scalars['Decimal']>;
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  totalPlanVolume?: Maybe<Scalars['Decimal']>;
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  totalRemainderVolume?: Maybe<Scalars['Decimal']>;
  type: WorkOrderPriceTypeEnum;
  uerCode: Scalars['String'];
  uerCodeId: Scalars['Long'];
  uerId: Scalars['Long'];
  unit: Scalars['String'];
  unitCost: Scalars['Decimal'];
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Выполнено (Кол-во) */
  workCompleted?: Maybe<Scalars['Decimal']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum: WorkInSumEnum;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Остаток (Кол-во) */
  workReminder?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

export type WorkOrderVersionPriceDataFilterInput = {
  actKC2VersionPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionActKc2VersionPriceDataFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionPriceDataFilterInput>>;
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак того, что нет ни одного заданного согласованного объема по актам */
  hasEmptyActVersionAcceptedVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного планового объема по актам */
  hasEmptyActVersionPlanVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActKC2VersionPrice?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionPriceDataFilterInput>>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  priceListId?: InputMaybe<LongOperationFilterInput>;
  seasonPrices?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionSeasonPriceDataFilterInput>;
  shortName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  status?: InputMaybe<WorkOrderPriceStatusEnumOperationFilterInput>;
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  totalCompletedVolume?: InputMaybe<DecimalOperationFilterInput>;
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  totalRemainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  type?: InputMaybe<WorkOrderPriceTypeEnumOperationFilterInput>;
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  uerId?: InputMaybe<LongOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено (Кол-во) */
  workCompleted?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<WorkInSumEnumOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток (Кол-во) */
  workReminder?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Модель позиции версии НЗ */
export type WorkOrderVersionPriceItem = {
  __typename?: 'WorkOrderVersionPriceItem';
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: Maybe<OtherCostCalculationTypeEnum>;
  /** Величина, % */
  calculatingTypeValue?: Maybe<Scalars['Decimal']>;
  /** Глава позиции */
  chapter?: Maybe<ChapterEnum>;
  /** Уникальный идентификатор позиции */
  clientId: Scalars['String'];
  /** Шифр */
  code?: Maybe<Scalars['String']>;
  /** Идентификатор вида строительства */
  constructionTypeId: Scalars['Int'];
  /** Идентификатор типа сущности */
  entityTypeId?: Maybe<Scalars['Int']>;
  /** Название типа сущности */
  entityTypeName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор типа сущности */
  entityTypeUniqueId?: Maybe<Scalars['String']>;
  /**
   * Идентификар сущности, на которую ссылается позиция, в договоре.
   *             Либо:
   *             - идентификатор объекта договора
   *             - идентификатор в прейскуранте
   *             - идентификатор прочей договора
   */
  entryId?: Maybe<Scalars['Long']>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: Maybe<Scalars['Boolean']>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: Maybe<Scalars['Boolean']>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: Maybe<Scalars['Boolean']>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: Maybe<Scalars['Boolean']>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: Maybe<Scalars['Boolean']>;
  /** Признак исключения позиции */
  isExcludedPrice?: Maybe<Scalars['Boolean']>;
  /** Признак строки части данных раздела прочих НЗ */
  isOtherGroup: Scalars['Boolean'];
  /** Признак строки части данных позиции прочих НЗ */
  isOtherItem: Scalars['Boolean'];
  /** Признак строки части данных корневого объекта НЗ */
  isRootObject: Scalars['Boolean'];
  /** Признак строки части данных позиции СМР НЗ */
  isSMRItem: Scalars['Boolean'];
  /** Идентификатор сущности позиции */
  itemId: Scalars['Long'];
  /** Код МТР */
  mtrKey?: Maybe<Scalars['String']>;
  /** Наимеование */
  name?: Maybe<Scalars['String']>;
  /** Код объекта\подобъекта */
  objectCode?: Maybe<Scalars['String']>;
  /** Id конечного объекта */
  objectId?: Maybe<Scalars['Long']>;
  /** Название онечного объекта */
  objectName?: Maybe<Scalars['String']>;
  /** Уникальный идентификатор конечного объекта */
  objectUniqueId?: Maybe<Scalars['String']>;
  /** Код прочей */
  otherCostKey?: Maybe<Scalars['String']>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: Maybe<Scalars['String']>;
  /** Id корневого объекта */
  rootObjectId: Scalars['Long'];
  /** Название корневого объекта */
  rootObjectName: Scalars['String'];
  /** Уникальный идентификатор корневого объекта */
  rootObjectUniqueId?: Maybe<Scalars['String']>;
  /** Плановые и фактические значения по сезонам по пасценке */
  seasonValues?: Maybe<Array<WorkOrderVersionPriceSeasonValue>>;
  /** Признак сортировки групп Прочих */
  sortOtherPart?: Maybe<Scalars['Int']>;
  /** Признак сортировки частей НЗ */
  sortPart?: Maybe<Scalars['Int']>;
  /** Признак сортировки типов позиций СМР */
  sortSMRPart?: Maybe<Scalars['Int']>;
  /** Статус */
  status?: Maybe<WorkOrderPriceStatusEnum>;
  /** Статус в форме строки */
  statusTip?: Maybe<Scalars['String']>;
  /** Общая фактическая стоимость по позиции */
  totalCompletedCost?: Maybe<Scalars['Decimal']>;
  /** Общий фактический выполненный объекм по позиции */
  totalCompletedVolume?: Maybe<Scalars['Decimal']>;
  /** Общая плановая стоимость по позиции */
  totalPlanCost?: Maybe<Scalars['Decimal']>;
  /** Общий плановый объекм по позиции */
  totalPlanVolume?: Maybe<Scalars['Decimal']>;
  /** Общий остаток стоимости по позиции */
  totalRemainderCost?: Maybe<Scalars['Decimal']>;
  /** Остаток общего плана по позиции */
  totalRemainderVolume?: Maybe<Scalars['Decimal']>;
  /** Тип позиции */
  type?: Maybe<WorkOrderPriceTypeEnum>;
  /** Шифр расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerCode?: Maybe<Scalars['String']>;
  /** Идентификатор позиции расценки УЕР для позиции самой расценки и ее потомков */
  uerCodeId?: Maybe<Scalars['Long']>;
  /** Идентификатор расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerId?: Maybe<Scalars['Long']>;
  /** Единица измерения */
  unit?: Maybe<Scalars['String']>;
  /** Стоимость за единицу */
  unitCost?: Maybe<Scalars['Decimal']>;
  /** Шифр */
  workCode?: Maybe<Scalars['String']>;
  /** Выполнено (Кол-во) */
  workCompleted?: Maybe<Scalars['Decimal']>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: Maybe<WorkInSumEnum>;
  /** К перехода из расценки */
  workKindWorkRatio?: Maybe<Scalars['Decimal']>;
  /** Наименование */
  workName?: Maybe<Scalars['String']>;
  /** План (Кол-во) */
  workPlan?: Maybe<Scalars['Decimal']>;
  /** К перехода позиции */
  workRatio?: Maybe<Scalars['Decimal']>;
  /** Остаток (Кол-во) */
  workReminder?: Maybe<Scalars['Decimal']>;
  /** Ед.изм. */
  workUnit?: Maybe<Scalars['String']>;
};

/** Модель позиции версии НЗ */
export type WorkOrderVersionPriceItemFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionPriceItemFilterInput>>;
  /** Вид вычисления стоимости прочих затрат договора */
  calculatingType?: InputMaybe<NullableOfOtherCostCalculationTypeEnumOperationFilterInput>;
  /** Величина, % */
  calculatingTypeValue?: InputMaybe<DecimalOperationFilterInput>;
  /** Глава позиции */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  /** Уникальный идентификатор позиции */
  clientId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор вида строительства */
  constructionTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Идентификатор типа сущности */
  entityTypeId?: InputMaybe<IntOperationFilterInput>;
  /** Название типа сущности */
  entityTypeName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор типа сущности */
  entityTypeUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /**
   * Идентификар сущности, на которую ссылается позиция, в договоре.
   *             Либо:
   *             - идентификатор объекта договора
   *             - идентификатор в прейскуранте
   *             - идентификатор прочей договора
   */
  entryId?: InputMaybe<LongOperationFilterInput>;
  /** Признак наличия схожих позиций */
  hasDuplicates?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что нет ни одного заданного объема по сезонам НЗ */
  hasEmptySeasonVolume?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак наличия перераспределения в прочей */
  hasLimitSpan?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того, что прочая затрата относится к актам */
  isActKC2Price?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак того что расценка была создана из СКзС */
  isCreatedFromSKzS?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак исключения позиции */
  isExcludedPrice?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных раздела прочих НЗ */
  isOtherGroup?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных позиции прочих НЗ */
  isOtherItem?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных корневого объекта НЗ */
  isRootObject?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак строки части данных позиции СМР НЗ */
  isSMRItem?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор сущности позиции */
  itemId?: InputMaybe<LongOperationFilterInput>;
  /** Код МТР */
  mtrKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Наимеование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код объекта\подобъекта */
  objectCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id конечного объекта */
  objectId?: InputMaybe<LongOperationFilterInput>;
  /** Название онечного объекта */
  objectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор конечного объекта */
  objectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionPriceItemFilterInput>>;
  /** Код прочей */
  otherCostKey?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Обоснование добавления прочей затраты в Акт КС-2 */
  rationale?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id корневого объекта */
  rootObjectId?: InputMaybe<LongOperationFilterInput>;
  /** Название корневого объекта */
  rootObjectName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Уникальный идентификатор корневого объекта */
  rootObjectUniqueId?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Плановые и фактические значения по сезонам по пасценке */
  seasonValues?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionPriceSeasonValueFilterInput>;
  /** Признак сортировки групп Прочих */
  sortOtherPart?: InputMaybe<IntOperationFilterInput>;
  /** Признак сортировки частей НЗ */
  sortPart?: InputMaybe<IntOperationFilterInput>;
  /** Признак сортировки типов позиций СМР */
  sortSMRPart?: InputMaybe<IntOperationFilterInput>;
  /** Статус */
  status?: InputMaybe<NullableOfWorkOrderPriceStatusEnumOperationFilterInput>;
  /** Статус в форме строки */
  statusTip?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Общая фактическая стоимость по позиции */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий фактический выполненный объекм по позиции */
  totalCompletedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Общая плановая стоимость по позиции */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий плановый объекм по позиции */
  totalPlanVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Общий остаток стоимости по позиции */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток общего плана по позиции */
  totalRemainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Тип позиции */
  type?: InputMaybe<NullableOfWorkOrderPriceTypeEnumOperationFilterInput>;
  /** Шифр расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор позиции расценки УЕР для позиции самой расценки и ее потомков */
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор расценки УЕР из прейскуранта для позиции самой расценки и ее потомков */
  uerId?: InputMaybe<LongOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Стоимость за единицу */
  unitCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Шифр */
  workCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено (Кол-во) */
  workCompleted?: InputMaybe<DecimalOperationFilterInput>;
  /**
   * Участие в суммировании ФО.
   * Значения: "Ф - участвует, К=1", "Ф с коэффициентом - участвует, применяется значение коэффициента", "0 - не участвует"
   */
  workInSum?: InputMaybe<NullableOfWorkInSumEnumOperationFilterInput>;
  /** К перехода из расценки */
  workKindWorkRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Наименование */
  workName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** План (Кол-во) */
  workPlan?: InputMaybe<DecimalOperationFilterInput>;
  /** К перехода позиции */
  workRatio?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток (Кол-во) */
  workReminder?: InputMaybe<DecimalOperationFilterInput>;
  /** Ед.изм. */
  workUnit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
};

/** Модель значения позиции в сезоне */
export type WorkOrderVersionPriceSeasonValue = {
  __typename?: 'WorkOrderVersionPriceSeasonValue';
  /** Значения позиции по актам в сезоне */
  actValues: Array<WorkOrderVersionPriceActValue>;
  /** Фактическая стоимость за сезон */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** Фактически выполненный объем за сезон */
  completedVolume?: Maybe<Scalars['Decimal']>;
  /** Ошибки расчета по формуле */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Признак наличия ошибкок расчета по формуле */
  hasErrors?: Maybe<Scalars['Boolean']>;
  /** Признак вида позиции: СМР, Прочие */
  itemTip: Scalars['Int'];
  /** Плановая стоимость в сезоне для прочих */
  planCost?: Maybe<Scalars['Decimal']>;
  planTerms?: Maybe<Array<Scalars['Decimal']>>;
  /** Плановое значение объема в сезоне */
  planVolume?: Maybe<Scalars['Decimal']>;
  /** Идентификатор позиции */
  priceId: Scalars['Long'];
  /** Остаток стоимости за сезон */
  remainderCost?: Maybe<Scalars['Decimal']>;
  /** Остаток объема за сезон */
  remainderVolume?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  seasonYear: Scalars['Int'];
};

/** Модель значения позиции в сезоне */
export type WorkOrderVersionPriceSeasonValueFilterInput = {
  /** Значения позиции по актам в сезоне */
  actValues?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionPriceActValueFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionPriceSeasonValueFilterInput>>;
  /** Фактическая стоимость за сезон */
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Фактически выполненный объем за сезон */
  completedVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Ошибки расчета по формуле */
  errors?: InputMaybe<ListStringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия ошибкок расчета по формуле */
  hasErrors?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак вида позиции: СМР, Прочие */
  itemTip?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionPriceSeasonValueFilterInput>>;
  /** Плановая стоимость в сезоне для прочих */
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planTerms?: InputMaybe<ListDecimalOperationFilterInput>;
  /** Плановое значение объема в сезоне */
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор позиции */
  priceId?: InputMaybe<LongOperationFilterInput>;
  /** Остаток стоимости за сезон */
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток объема за сезон */
  remainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Год сезона */
  seasonYear?: InputMaybe<IntOperationFilterInput>;
};

/** Данные раздела итога версии наряд-заказа */
export type WorkOrderVersionResultData = {
  __typename?: 'WorkOrderVersionResultData';
  /** Список итогов по версиям актов версии наряд-заказа */
  actKC2VersionResults: Array<WorkOrderVersionActKc2VersionResultData>;
  /** Глава */
  chapter?: Maybe<ChapterEnum>;
  /** Идентификатор раздела */
  resultSectionId: Scalars['Long'];
  /** Список итогов по сезонам версии наряд-заказа */
  seasonResults: Array<WorkOrderVersionSeasonResultData>;
  /** Секция */
  section?: Maybe<SectionEnum>;
  /** Сортировка */
  sortOrder: Scalars['Short'];
  /** Название раздела c итогами наряд-заказа */
  title: Scalars['String'];
  /** Выполнено по наряд-заказу */
  totalCompletedCost: Scalars['Decimal'];
  /** План по наряд-заказу */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по наряд-заказу */
  totalRemainderCost: Scalars['Decimal'];
};

/** Данные раздела итога версии наряд-заказа */
export type WorkOrderVersionResultDataFilterInput = {
  /** Список итогов по версиям актов версии наряд-заказа */
  actKC2VersionResults?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionActKc2VersionResultDataFilterInput>;
  and?: InputMaybe<Array<WorkOrderVersionResultDataFilterInput>>;
  /** Глава */
  chapter?: InputMaybe<NullableOfChapterEnumOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionResultDataFilterInput>>;
  /** Идентификатор раздела */
  resultSectionId?: InputMaybe<LongOperationFilterInput>;
  /** Список итогов по сезонам версии наряд-заказа */
  seasonResults?: InputMaybe<ListFilterInputTypeOfWorkOrderVersionSeasonResultDataFilterInput>;
  /** Секция */
  section?: InputMaybe<NullableOfSectionEnumOperationFilterInput>;
  /** Сортировка */
  sortOrder?: InputMaybe<ShortOperationFilterInput>;
  /** Название раздела c итогами наряд-заказа */
  title?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Выполнено по наряд-заказу */
  totalCompletedCost?: InputMaybe<DecimalOperationFilterInput>;
  /** План по наряд-заказу */
  totalPlanCost?: InputMaybe<DecimalOperationFilterInput>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<DecimalOperationFilterInput>;
};

/** Данные раздела итога версии наряд-заказа */
export type WorkOrderVersionResultDataSortInput = {
  /** Глава */
  chapter?: InputMaybe<SortEnumType>;
  /** Идентификатор раздела */
  resultSectionId?: InputMaybe<SortEnumType>;
  /** Секция */
  section?: InputMaybe<SortEnumType>;
  /** Сортировка */
  sortOrder?: InputMaybe<SortEnumType>;
  /** Название раздела c итогами наряд-заказа */
  title?: InputMaybe<SortEnumType>;
  /** Выполнено по наряд-заказу */
  totalCompletedCost?: InputMaybe<SortEnumType>;
  /** План по наряд-заказу */
  totalPlanCost?: InputMaybe<SortEnumType>;
  /** Остаток по наряд-заказу */
  totalRemainderCost?: InputMaybe<SortEnumType>;
};

export type WorkOrderVersionSeasonData = {
  __typename?: 'WorkOrderVersionSeasonData';
  id: Scalars['Long'];
  year: Scalars['Short'];
};

export type WorkOrderVersionSeasonDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionSeasonDataFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionSeasonDataFilterInput>>;
  year?: InputMaybe<ShortOperationFilterInput>;
};

export type WorkOrderVersionSeasonDataSortInput = {
  id?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type WorkOrderVersionSeasonPriceData = {
  __typename?: 'WorkOrderVersionSeasonPriceData';
  completedCost?: Maybe<Scalars['Decimal']>;
  completedVolume?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['Long']>;
  planCost?: Maybe<Scalars['Decimal']>;
  planVolume?: Maybe<Scalars['Decimal']>;
  planVolumeTerms?: Maybe<Array<Scalars['Decimal']>>;
  remainderCost?: Maybe<Scalars['Decimal']>;
  remainderVolume?: Maybe<Scalars['Decimal']>;
  seasonId: Scalars['Long'];
};

export type WorkOrderVersionSeasonPriceDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionSeasonPriceDataFilterInput>>;
  completedCost?: InputMaybe<DecimalOperationFilterInput>;
  completedVolume?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkOrderVersionSeasonPriceDataFilterInput>>;
  planCost?: InputMaybe<DecimalOperationFilterInput>;
  planVolume?: InputMaybe<DecimalOperationFilterInput>;
  planVolumeTerms?: InputMaybe<ListDecimalOperationFilterInput>;
  remainderCost?: InputMaybe<DecimalOperationFilterInput>;
  remainderVolume?: InputMaybe<DecimalOperationFilterInput>;
  seasonId?: InputMaybe<LongOperationFilterInput>;
};

/** Данные итога версии наряд-заказа по сезону */
export type WorkOrderVersionSeasonResultData = {
  __typename?: 'WorkOrderVersionSeasonResultData';
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Значение итога */
  value: Scalars['Decimal'];
};

/** Данные итога версии наряд-заказа по сезону */
export type WorkOrderVersionSeasonResultDataFilterInput = {
  and?: InputMaybe<Array<WorkOrderVersionSeasonResultDataFilterInput>>;
  or?: InputMaybe<Array<WorkOrderVersionSeasonResultDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /** Значение итога */
  value?: InputMaybe<DecimalOperationFilterInput>;
};

/** Строка итога по сезону версии НЗ */
export type WorkOrderVersionSeasonTotalData = {
  __typename?: 'WorkOrderVersionSeasonTotalData';
  /** Выполнено по сезону НЗ */
  completedCost?: Maybe<Scalars['Decimal']>;
  /** План по сезону НЗ */
  planCost?: Maybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Строка итога по сезону версии НЗ */
export type WorkOrderVersionSeasonTotalDataInput = {
  /** Выполнено по сезону НЗ */
  completedCost?: InputMaybe<Scalars['Decimal']>;
  /** План по сезону НЗ */
  planCost?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
};

/** Строка итога версии НЗ */
export type WorkOrderVersionTotalData = {
  __typename?: 'WorkOrderVersionTotalData';
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** &gt;Список строк итогов по сезонам версии НЗ */
  seasonTotals: Array<WorkOrderVersionSeasonTotalData>;
  /** Выполнено по НЗ */
  totalCompletedCost: Scalars['Decimal'];
  /** План по НЗ */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по НЗ */
  totalRemainderCost: Scalars['Decimal'];
};

/** Строка итога версии НЗ */
export type WorkOrderVersionTotalDataInput = {
  /** Признак строки заголовка (серая строка) */
  isHeadLine: Scalars['Boolean'];
  /** Наименование */
  name: Scalars['String'];
  /** &gt;Список строк итогов по сезонам версии НЗ */
  seasonTotals: Array<WorkOrderVersionSeasonTotalDataInput>;
  /** Выполнено по НЗ */
  totalCompletedCost: Scalars['Decimal'];
  /** План по НЗ */
  totalPlanCost: Scalars['Decimal'];
  /** Остаток по НЗ */
  totalRemainderCost: Scalars['Decimal'];
};

export type WorkOrderViewData = {
  __typename?: 'WorkOrderViewData';
  actsKC2: Array<WorkOrderActKc2Data>;
  priceList: Array<WorkOrderPriceData>;
  seasons: Array<WorkOrderSeasonData>;
};

export type WorkOrderViewDataFilterInput = {
  actsKC2?: InputMaybe<ListFilterInputTypeOfWorkOrderActKc2DataFilterInput>;
  and?: InputMaybe<Array<WorkOrderViewDataFilterInput>>;
  or?: InputMaybe<Array<WorkOrderViewDataFilterInput>>;
  priceList?: InputMaybe<ListFilterInputTypeOfWorkOrderPriceDataFilterInput>;
  seasons?: InputMaybe<ListFilterInputTypeOfWorkOrderSeasonDataFilterInput>;
};

export enum WorkOrderVorTypeEnum {
  /** Формат Rivx */
  Rivx = 'RIVX',
  /** Набор файлов Xml */
  XmlBundle = 'XML_BUNDLE'
}

/** Данные ведомости объемов работ. */
export type WorkVolumeData = {
  __typename?: 'WorkVolumeData';
  /** Дата создания ВОР */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Номер ВОР */
  number: Scalars['Int'];
};

/** Выбранные значения фильтров каскадной фильтрации работ */
export type WorkVolumeFilterInput = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  groupNames?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  sectionNames?: InputMaybe<Array<Scalars['String']>>;
  units?: InputMaybe<Array<Scalars['String']>>;
};

/** Данные переменной для формулы ВОР */
export type WorkVolumeFormulaVariableData = {
  __typename?: 'WorkVolumeFormulaVariableData';
  /** Строка коэффициентов переменной */
  coefficients?: Maybe<Scalars['String']>;
  /** Идентификатор переменной */
  id: Scalars['Long'];
  /** Наименование переменной */
  name: Scalars['String'];
};

/** Данные переменной для формулы ВОР */
export type WorkVolumeFormulaVariableDataFilterInput = {
  and?: InputMaybe<Array<WorkVolumeFormulaVariableDataFilterInput>>;
  /** Строка коэффициентов переменной */
  coefficients?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор переменной */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Наименование переменной */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkVolumeFormulaVariableDataFilterInput>>;
};

/** Результат импорта файла ВОР */
export type WorkVolumeImportResult = {
  __typename?: 'WorkVolumeImportResult';
  /** Количество добавленных записей МТР */
  addedMtrsQuantity: Scalars['Int'];
  /** Количество загруженных записей МТР без объёмов */
  addedMtrsWithoutVolumesQuantity: Scalars['Int'];
  /** Количество добавленных коэффициентов */
  addedRatiosQuantity: Scalars['Int'];
  /** Количество добавленных связей между расценкой и видом строительства */
  addedUerConstructionTypeLinksQuantity: Scalars['Int'];
  /** Количество добавленных расценок */
  addedUersQuantity: Scalars['Int'];
  /** Кандидаты на сопоставление МТР; непустой список ⇒ импорт НЕ зафиксирован, ждёт выбора. */
  mtrCandidates?: Maybe<Array<MtrImportCandidate>>;
  /** Дополнительные предупредительные сообщения */
  warnings: Array<Scalars['String']>;
};

/** Результат импорта файла ВОР */
export type WorkVolumeImportResultInput = {
  /** Количество добавленных записей МТР */
  addedMtrsQuantity: Scalars['Int'];
  /** Количество загруженных записей МТР без объёмов */
  addedMtrsWithoutVolumesQuantity: Scalars['Int'];
  /** Количество добавленных коэффициентов */
  addedRatiosQuantity: Scalars['Int'];
  /** Количество добавленных связей между расценкой и видом строительства */
  addedUerConstructionTypeLinksQuantity: Scalars['Int'];
  /** Количество добавленных расценок */
  addedUersQuantity: Scalars['Int'];
  /** Кандидаты на сопоставление МТР; непустой список ⇒ импорт НЕ зафиксирован, ждёт выбора. */
  mtrCandidates?: InputMaybe<Array<MtrImportCandidateInput>>;
  /** Дополнительные предупредительные сообщения */
  warnings: Array<Scalars['String']>;
};

export type WorkVolumeItemCodeFilterData = {
  __typename?: 'WorkVolumeItemCodeFilterData';
  /** Шифр позиции */
  code: Scalars['String'];
  /** Признак МТР */
  isMtr: Scalars['Boolean'];
  /** Признак коэффициента */
  isRatio: Scalars['Boolean'];
  /** Признак расценки */
  isUer: Scalars['Boolean'];
  /** Порядок сортировки внутри группы */
  order: Scalars['Int'];
  /** Шифр УЕР */
  uerCode: Scalars['String'];
  /** Id позиции расценкт */
  uerCodeId?: Maybe<Scalars['Long']>;
};

export type WorkVolumeItemCodeFilterDataFilterInput = {
  and?: InputMaybe<Array<WorkVolumeItemCodeFilterDataFilterInput>>;
  /** Шифр позиции */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак МТР */
  isMtr?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак коэффициента */
  isRatio?: InputMaybe<BooleanOperationFilterInput>;
  /** Признак расценки */
  isUer?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<WorkVolumeItemCodeFilterDataFilterInput>>;
  /** Порядок сортировки внутри группы */
  order?: InputMaybe<IntOperationFilterInput>;
  /** Шифр УЕР */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Id позиции расценкт */
  uerCodeId?: InputMaybe<LongOperationFilterInput>;
};

/** DTO объект "Строка ведомости объемов работ" */
export type WorkVolumeItemData = {
  __typename?: 'WorkVolumeItemData';
  /** Шифр */
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** Наименование подраздела */
  groupName?: Maybe<Scalars['String']>;
  /** Признак наличия нормы расхода ресурса для строки, содержащей МТР */
  hasConsumptionRate?: Maybe<Scalars['Boolean']>;
  /** Идентификатор строки ВОР */
  id: Scalars['Long'];
  /** Признак для позиций расценок, которые были обновлены из сборника расценок */
  isUpdatedFromUERBaseCosts: Scalars['Boolean'];
  /** Величина нормы расхода ресурса для строки, содержащей МТР */
  mtrConsumptionRate?: Maybe<Scalars['Decimal']>;
  /** Идентификатор МТР */
  mtrRowId?: Maybe<Scalars['Long']>;
  /** Наименование */
  name: Scalars['String'];
  /** Идентификатор родительской строки ВОР. Для расценок - не заполняется. */
  parentId?: Maybe<Scalars['Long']>;
  /** Идентификатор коэффициента */
  ratioRowId?: Maybe<Scalars['Long']>;
  /** Наименование раздела */
  sectionName?: Maybe<Scalars['String']>;
  /** Код родительской расценки. Для строки расценки будет равен свойству Code. */
  uerCode: Scalars['String'];
  /** Идентификатор расценки */
  uerRowId?: Maybe<Scalars['Long']>;
  /** Единица измерения */
  unit: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Значения объемов по данной строке ВОР в разрезе объектов строительства и сезонов */
  values: Array<WorkVolumeValueData>;
};

/** DTO объект "Строка ведомости объемов работ" */
export type WorkVolumeItemDataFilterInput = {
  and?: InputMaybe<Array<WorkVolumeItemDataFilterInput>>;
  /** Шифр */
  code?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Наименование подраздела */
  groupName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак наличия нормы расхода ресурса для строки, содержащей МТР */
  hasConsumptionRate?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор строки ВОР */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Признак для позиций расценок, которые были обновлены из сборника расценок */
  isUpdatedFromUERBaseCosts?: InputMaybe<BooleanOperationFilterInput>;
  /** Величина нормы расхода ресурса для строки, содержащей МТР */
  mtrConsumptionRate?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор МТР */
  mtrRowId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование */
  name?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  or?: InputMaybe<Array<WorkVolumeItemDataFilterInput>>;
  /** Идентификатор родительской строки ВОР. Для расценок - не заполняется. */
  parentId?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор коэффициента */
  ratioRowId?: InputMaybe<LongOperationFilterInput>;
  /** Наименование раздела */
  sectionName?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Код родительской расценки. Для строки расценки будет равен свойству Code. */
  uerCode?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Идентификатор расценки */
  uerRowId?: InputMaybe<LongOperationFilterInput>;
  /** Единица измерения */
  unit?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Значения объемов по данной строке ВОР в разрезе объектов строительства и сезонов */
  values?: InputMaybe<ListFilterInputTypeOfWorkVolumeValueDataFilterInput>;
};

/** DTO объект "Строка ведомости объемов работ" */
export type WorkVolumeItemDataSortInput = {
  /** Шифр */
  code?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  /** Наименование подраздела */
  groupName?: InputMaybe<SortEnumType>;
  /** Признак наличия нормы расхода ресурса для строки, содержащей МТР */
  hasConsumptionRate?: InputMaybe<SortEnumType>;
  /** Идентификатор строки ВОР */
  id?: InputMaybe<SortEnumType>;
  /** Признак для позиций расценок, которые были обновлены из сборника расценок */
  isUpdatedFromUERBaseCosts?: InputMaybe<SortEnumType>;
  /** Величина нормы расхода ресурса для строки, содержащей МТР */
  mtrConsumptionRate?: InputMaybe<SortEnumType>;
  /** Идентификатор МТР */
  mtrRowId?: InputMaybe<SortEnumType>;
  /** Наименование */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор родительской строки ВОР. Для расценок - не заполняется. */
  parentId?: InputMaybe<SortEnumType>;
  /** Идентификатор коэффициента */
  ratioRowId?: InputMaybe<SortEnumType>;
  /** Наименование раздела */
  sectionName?: InputMaybe<SortEnumType>;
  /** Код родительской расценки. Для строки расценки будет равен свойству Code. */
  uerCode?: InputMaybe<SortEnumType>;
  /** Идентификатор расценки */
  uerRowId?: InputMaybe<SortEnumType>;
  /** Единица измерения */
  unit?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
};

/** Типы фильтрации строк WorkVolumeItem в таблице ВОР */
export enum WorkVolumeItemFilterEnum {
  /** Незаполненные объемы */
  EmptyVolumes = 'EMPTY_VOLUMES',
  /** Заполненные объемы */
  FilledVolumes = 'FILLED_VOLUMES',
  /** Строки с ошибками */
  RowsWithErrors = 'ROWS_WITH_ERRORS',
  /** Поиск по наименованию */
  SearchByName = 'SEARCH_BY_NAME',
  /** Поиск по объему */
  SearchByVolume = 'SEARCH_BY_VOLUME'
}

/** Параметры фильтра для ВОР */
export type WorkVolumeItemFilterInput = {
  /**
   * Значение для поиска по наименованию.
   * Используется при  =
   */
  filterName?: InputMaybe<Scalars['String']>;
  /**
   * Значение для поиска по объему.
   * Используется при  = .
   */
  filterVolume?: InputMaybe<Scalars['Decimal']>;
  /** Тип фильтрации */
  type: WorkVolumeItemFilterEnum;
};

/** Комплексный идентификатор, позволяющий однозначно идентифицировать ячейку с данными об объёмах ВОР */
export type WorkVolumeItemValueComplexIdentifierInput = {
  /** Идентификатор объекта/подобъекта */
  calculationObjectId: Scalars['Long'];
  /** Идентификатор сезона */
  calculationSeasonId: Scalars['Long'];
  /** Идентификатор строки ВОР */
  worItemId: Scalars['Long'];
};

/** Дополнительная информация об объекте строительства в сезоне в контексте ВОР */
export type WorkVolumeObjectAdditionalData = {
  __typename?: 'WorkVolumeObjectAdditionalData';
  /** Номера строк, где будет ошибки текста формулы */
  formulaErrorRowNumbers: Array<Scalars['Long']>;
  /** Номера строк, где будет признак рассогласования данных по объемам у расценки, и подчиненных МТР. */
  inconsistentWorRowNumbers: Array<Scalars['Long']>;
};

/** Информация об объекте/подобъекте строительства по сезону в контексте ВОР */
export type WorkVolumeObjectData = {
  __typename?: 'WorkVolumeObjectData';
  /** Признак наличия ошибок формулы для расчёта значения объёма */
  hasFormulaErrorVolumes: Scalars['Boolean'];
  /** Признак гарантированного объема */
  hasGuaranteedVolume?: Maybe<Scalars['Boolean']>;
  /** Признак рассогласования данных по объемам у расценки, и подчиненных МТР. */
  hasInconsistentWorVolumes: Scalars['Boolean'];
  /** Идентификатор объекта/подобъекта */
  id: Scalars['Long'];
  /** Наименование объекта/подобъекта строительства */
  name: Scalars['String'];
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: Maybe<Scalars['Long']>;
  /** Наименование корневого объекта строительства */
  rootObjectName?: Maybe<Scalars['String']>;
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /** Год сезона */
  seasonYear: Scalars['Short'];
};

/** Информация об объекте/подобъекте строительства по сезону в контексте ВОР */
export type WorkVolumeObjectDataSortInput = {
  /** Признак наличия ошибок формулы для расчёта значения объёма */
  hasFormulaErrorVolumes?: InputMaybe<SortEnumType>;
  /** Признак гарантированного объема */
  hasGuaranteedVolume?: InputMaybe<SortEnumType>;
  /** Признак рассогласования данных по объемам у расценки, и подчиненных МТР. */
  hasInconsistentWorVolumes?: InputMaybe<SortEnumType>;
  /** Идентификатор объекта/подобъекта */
  id?: InputMaybe<SortEnumType>;
  /** Наименование объекта/подобъекта строительства */
  name?: InputMaybe<SortEnumType>;
  /** Идентификатор корневого объекта строительства */
  rootObjectId?: InputMaybe<SortEnumType>;
  /** Наименование корневого объекта строительства */
  rootObjectName?: InputMaybe<SortEnumType>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<SortEnumType>;
  /** Год сезона */
  seasonYear?: InputMaybe<SortEnumType>;
};

/** Значение по сезону объект/подобъекта */
export type WorkVolumeValueData = {
  __typename?: 'WorkVolumeValueData';
  /** Формула для расчёта значения объёма */
  formula?: Maybe<Scalars['String']>;
  /** Текст ошибки формулы для расчёта значения объёма */
  formulaError?: Maybe<Scalars['String']>;
  /** Признак рассогласования данных по объемам у расценки, и подчиненных МТР. */
  hasInconsistentWorVolumes: Scalars['Boolean'];
  /** Идентификатор значения позиции по сезонам и объектам ВОР */
  id?: Maybe<Scalars['Long']>;
  /** Идентификатор объекта/подобъекта строительства */
  objectId: Scalars['Long'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /**
   * Строка слагаемых, из которых образован итоговый объём (например, "25 + 100.3 + 10.1"),
   * или null, если суммирования не было.
   */
  summationDetails?: Maybe<Scalars['String']>;
  /** Объем */
  value?: Maybe<Scalars['Decimal']>;
  /** Идентификатор значения строки ВОР */
  worRowId?: Maybe<Scalars['Long']>;
};

/** Значение по сезону объект/подобъекта */
export type WorkVolumeValueDataFilterInput = {
  and?: InputMaybe<Array<WorkVolumeValueDataFilterInput>>;
  /** Формула для расчёта значения объёма */
  formula?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Текст ошибки формулы для расчёта значения объёма */
  formulaError?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Признак рассогласования данных по объемам у расценки, и подчиненных МТР. */
  hasInconsistentWorVolumes?: InputMaybe<BooleanOperationFilterInput>;
  /** Идентификатор значения позиции по сезонам и объектам ВОР */
  id?: InputMaybe<LongOperationFilterInput>;
  /** Идентификатор объекта/подобъекта строительства */
  objectId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<WorkVolumeValueDataFilterInput>>;
  /** Идентификатор сезона */
  seasonId?: InputMaybe<LongOperationFilterInput>;
  /**
   * Строка слагаемых, из которых образован итоговый объём (например, "25 + 100.3 + 10.1"),
   * или null, если суммирования не было.
   */
  summationDetails?: InputMaybe<StringOperationFilterInputTypeExFilterInput>;
  /** Объем */
  value?: InputMaybe<DecimalOperationFilterInput>;
  /** Идентификатор значения строки ВОР */
  worRowId?: InputMaybe<LongOperationFilterInput>;
};

/** Значение по сезону объект/подобъекта */
export type WorkVolumeValueDataInput = {
  /** Формула для расчёта значения объёма */
  formula?: InputMaybe<Scalars['String']>;
  /** Текст ошибки формулы для расчёта значения объёма */
  formulaError?: InputMaybe<Scalars['String']>;
  /** Признак рассогласования данных по объемам у расценки, и подчиненных МТР. */
  hasInconsistentWorVolumes: Scalars['Boolean'];
  /** Идентификатор значения позиции по сезонам и объектам ВОР */
  id?: InputMaybe<Scalars['Long']>;
  /** Идентификатор объекта/подобъекта строительства */
  objectId: Scalars['Long'];
  /** Идентификатор сезона */
  seasonId: Scalars['Long'];
  /**
   * Строка слагаемых, из которых образован итоговый объём (например, "25 + 100.3 + 10.1"),
   * или null, если суммирования не было.
   */
  summationDetails?: InputMaybe<Scalars['String']>;
  /** Объем */
  value?: InputMaybe<Scalars['Decimal']>;
  /** Идентификатор значения строки ВОР */
  worRowId?: InputMaybe<Scalars['Long']>;
};

export type BimAppHealthCheckData = {
  __typename?: 'bimAppHealthCheckData';
  duration: Scalars['String'];
  healthChecks?: Maybe<Array<AppHealthCheckInfo>>;
  status: HealthStatus;
};

export type BimAppModuleInfo = {
  __typename?: 'bimAppModuleInfo';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type BimAppModuleReport = {
  __typename?: 'bimAppModuleReport';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  healthCheckData?: Maybe<BimAppHealthCheckData>;
  id: Scalars['String'];
  moduleResources?: Maybe<BimAppModuleResources>;
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type BimAppModuleResources = {
  __typename?: 'bimAppModuleResources';
  cpuUsedPercentage: Scalars['String'];
  guaranteedToMaxCpu: Scalars['String'];
  guaranteedToMaxMemory: Scalars['String'];
  memoryUsedInBytes: Scalars['String'];
  memoryUsedPercentage: Scalars['String'];
  time: Scalars['String'];
};

export type UerAppHealthCheckData = {
  __typename?: 'uerAppHealthCheckData';
  duration: Scalars['String'];
  healthChecks?: Maybe<Array<AppHealthCheckInfo>>;
  status: HealthStatus;
};

export type UerAppModuleInfo = {
  __typename?: 'uerAppModuleInfo';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type UerAppModuleReport = {
  __typename?: 'uerAppModuleReport';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  healthCheckData?: Maybe<UerAppHealthCheckData>;
  id: Scalars['String'];
  moduleResources?: Maybe<UerAppModuleResources>;
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type UerAppModuleResources = {
  __typename?: 'uerAppModuleResources';
  cpuUsedPercentage: Scalars['String'];
  guaranteedToMaxCpu: Scalars['String'];
  guaranteedToMaxMemory: Scalars['String'];
  memoryUsedInBytes: Scalars['String'];
  memoryUsedPercentage: Scalars['String'];
  time: Scalars['String'];
};

export type UercAppHealthCheckData = {
  __typename?: 'uercAppHealthCheckData';
  duration: Scalars['String'];
  healthChecks?: Maybe<Array<AppHealthCheckInfo>>;
  status: HealthStatus;
};

export type UercAppModuleInfo = {
  __typename?: 'uercAppModuleInfo';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type UercAppModuleReport = {
  __typename?: 'uercAppModuleReport';
  branch: Scalars['String'];
  buildDate?: Maybe<Scalars['DateTime']>;
  commit: Scalars['String'];
  description: Scalars['String'];
  healthCheckData?: Maybe<UercAppHealthCheckData>;
  id: Scalars['String'];
  moduleResources?: Maybe<UercAppModuleResources>;
  name: Scalars['String'];
  release: Scalars['String'];
  tag?: Maybe<Scalars['String']>;
};

export type UercAppModuleResources = {
  __typename?: 'uercAppModuleResources';
  cpuUsedPercentage: Scalars['String'];
  guaranteedToMaxCpu: Scalars['String'];
  guaranteedToMaxMemory: Scalars['String'];
  memoryUsedInBytes: Scalars['String'];
  memoryUsedPercentage: Scalars['String'];
  time: Scalars['String'];
};

export type UerPriceListUerForTechPartRatioQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<PriceListUerRowBaseFilterInput>;
  order?: InputMaybe<Array<PriceListUerRowBaseSortInput> | PriceListUerRowBaseSortInput>;
}>;


export type UerPriceListUerForTechPartRatioQuery = { __typename?: 'Query', uerPriceListUerForTechPartRatio?: { __typename?: 'UerPriceListUerForTechPartRatioCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'PriceListUerRowBase', chapter?: ChapterEnum | null, code: string, groupCode?: string | null, groupId: any, groupName: string, id: any, justification?: string | null, name: string, sectionId: any, sectionName: string, status: UerRecordStatusEnum, uerClassifier?: UerClassifierEnum | null, unit: string, linkStatus: PriceConstructionTypeRelationStatusEnum }> | null } | null };

export type UerPriceListUerForDismantlingRatioUerCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerPriceListUerForDismantlingRatioUerCodeFilterQuery = { __typename?: 'Query', uerPriceListUerForDismantlingRatioUerCodeFilter?: { __typename?: 'UerPriceListUerForDismantlingRatioUerCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerPriceListUerForDismantlingRatioUerNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerPriceListUerForDismantlingRatioUerNameFilterQuery = { __typename?: 'Query', uerPriceListUerForDismantlingRatioUerNameFilter?: { __typename?: 'UerPriceListUerForDismantlingRatioUerNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerPriceListUerForDismantlingRatioUerGroupFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerPriceListUerForDismantlingRatioUerGroupFilterQuery = { __typename?: 'Query', uerPriceListUerForDismantlingRatioUerGroupFilter?: { __typename?: 'UerPriceListUerForDismantlingRatioUerGroupFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerPriceListUerForDismantlingRatioUerUnitFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  rationRowId?: InputMaybe<Scalars['Long']>;
  preselectedUerBaseRowIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerPriceListUerForDismantlingRatioUerUnitFilterQuery = { __typename?: 'Query', uerPriceListUerForDismantlingRatioUerUnitFilter?: { __typename?: 'UerPriceListUerForDismantlingRatioUerUnitFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerRatioCollectionQueryVariables = Exact<{
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<RatioRowDataSortInput> | RatioRowDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RatioRowDataFilterInput>;
}>;


export type UerRatioCollectionQuery = { __typename?: 'Query', uerRatioCollection?: { __typename?: 'UerRatioCollectionCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'RatioRowData', id: any, code: string, workConditions: string, ratioType: RatioTypeEnum, kozp: any, knr: any, ksp: any, kem: any, kmat?: any | null, ktz: any, ktzzpm: any, groupId?: any | null, groupName?: string | null, subGroupId?: any | null, subGroupName?: string | null }> | null } | null };

export type IsUniqueProjectNameQueryVariables = Exact<{
  uniqueId?: InputMaybe<Scalars['String']>;
  projectName: Scalars['String'];
}>;


export type IsUniqueProjectNameQuery = { __typename?: 'Query', isUniqueProjectName: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type DeleteProjectMutationVariables = Exact<{
  uniqueId: Scalars['String'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'ServiceDataResultOfString', data?: string | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type ProjectQueryVariables = Exact<{
  uniqueId: Scalars['String'];
}>;


export type ProjectQuery = { __typename?: 'Query', project: { __typename?: 'ServiceDataResultOfProjectData', result: boolean, message?: string | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'ProjectData', code?: string | null, uniqueId: string, statusFollowers: Array<ProjectStatusEnum>, stageFollowers: Array<ProjectStageEnum>, name: string, stage: ProjectStageEnum, status: ProjectStatusEnum, methodology: ProjectMethodologyEnum, contractType?: ProjectContractTypeEnum | null, contractId?: any | null, contractUniqueId?: string | null, createdAt: any, updatedAt?: any | null, authoredBy: string, calculationId?: any | null, calculationStatus?: CalculationStatusEnum | null, calculationUniqueId?: string | null, closedAt?: any | null, contractInternalNumber?: string | null, contractStatus?: ContractStatusEnum | null, calculationNavigation?: { __typename?: 'ServiceDataResultOfCalculationNavigationData', result: boolean, message?: string | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', metadata?: string | null, property?: string | null, message: string }> | null, data?: { __typename?: 'CalculationNavigationData', metadata?: any | null, calculationNavData: { __typename?: 'CalculationNavData', name: string, hasCalculation: boolean, hasCalculationObjects: boolean, hasWOR: boolean, navLinkId: string, metadata?: any | null, id?: any | null }, calculationNavItems?: Array<{ __typename?: 'CalculationItemNavData', navLinkId: string, name: string, metadata?: any | null, id?: any | null }> | null } | null } | null, contractNavigation?: { __typename?: 'ServiceDataResultOfContractNavigationData', result: boolean, message?: string | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', metadata?: string | null, property?: string | null, message: string }> | null, data?: { __typename?: 'ContractNavigationData', contractNavData: { __typename?: 'ContractNavData', id: any, hasContract: boolean, hasWorkOrders: boolean, status: ContractStatusEnum, internalNumber?: string | null, authoredBy?: string | null, createdAt: any, navLinkId: string, name: string, metadata?: any | null }, contractNavItems?: Array<{ __typename?: 'ContractItemNavData', navLinkId: string, name: string, metadata?: any | null, id?: any | null }> | null, workOrderNavs?: Array<{ __typename?: 'WorkOrderNavData', id?: any | null, name: string, status: WorkOrderStatusEnum, internalNumber: string, navLinkId: string, signingDate?: any | null, metadata?: any | null, actKC2Navs?: Array<{ __typename?: 'ActKC2NavData', id: any, date?: any | null, number?: any | null, status: ActKc2StatusEnum, costGroup: CostGroupEnum, correctionNumber?: any | null, correctionDate?: any | null, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, season: { __typename?: 'ContractSeasonNav', id: any, year: any } }> | null, actKC3Navs?: Array<{ __typename?: 'ActKC3NavData', id: any, number?: any | null, date?: any | null, correctionNumber?: any | null, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, actsKC2?: Array<{ __typename?: 'ActKC2NavData', id: any, date?: any | null, number?: any | null, status: ActKc2StatusEnum, costGroup: CostGroupEnum, correctionNumber?: any | null, correctionDate?: any | null, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, season: { __typename?: 'ContractSeasonNav', id: any, year: any } }> | null }> | null, workOrderChange?: { __typename?: 'WorkOrderChangeNavData', id?: any | null, name: string, signingDate?: any | null, workOrderNumber: string, workOrderChangeNumber: string, status: WorkOrderChangeStatusEnum, navLinkId: string } | null, workOrderChanges?: Array<{ __typename?: 'WorkOrderChangeNavData', id?: any | null, signingDate?: any | null, workOrderNumber: string, workOrderChangeNumber: string, status: WorkOrderChangeStatusEnum, navLinkId: string, name: string }> | null }> | null } | null } | null, subsidiary?: { __typename?: 'CompanyData', id: any, name: string } | null, contractPrice?: { __typename?: 'ServiceDataResultOfContractPriceData', hasValidation: boolean, result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null, data?: { __typename?: 'ContractPriceData', contractPlan?: any | null, actualCost?: any | null, hasActualCost?: boolean | null } | null } | null, calculationPrice?: { __typename?: 'ServiceDataResultOfCalculationPriceData', hasValidation: boolean, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null, data?: { __typename?: 'CalculationPriceData', priceNMC?: any | null } | null } | null } | null } };

export type LogUserClientMutationVariables = Exact<{
  loginOp: AuditLogClientOperationEnum;
  userName: Scalars['String'];
}>;


export type LogUserClientMutation = { __typename?: 'Mutation', logUserClient: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogConstructionTypesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ConstructionTypeDataSortInput> | ConstructionTypeDataSortInput>;
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
}>;


export type CatalogConstructionTypesQuery = { __typename?: 'Query', catalogConstructionTypes?: { __typename?: 'CatalogConstructionTypesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConstructionTypeData', catalogId: any, code: string, fullName: string, iconCode?: string | null, id: number, name: string, shortName: string, uniqueId?: string | null, updatedAt?: any | null, contractFileName: string, createdAt: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogConstructionTypeItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ConstructionTypeDataSortInput> | ConstructionTypeDataSortInput>;
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
  catalogUniqueId: Scalars['String'];
}>;


export type CatalogConstructionTypeItemsQuery = { __typename?: 'Query', catalogConstructionTypeItems?: { __typename?: 'CatalogConstructionTypeItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConstructionTypeData', contractFileName: string, catalogId: any, code: string, fullName: string, iconCode?: string | null, id: number, name: string, shortName: string, uniqueId?: string | null, updatedAt?: any | null, createdAt: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogIsUniqueConstructionTypeFieldsQueryVariables = Exact<{
  catalogConstructionTypeId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  fullName: Scalars['String'];
  shortName: Scalars['String'];
  contractFileName: Scalars['String'];
}>;


export type CatalogIsUniqueConstructionTypeFieldsQuery = { __typename?: 'Query', catalogIsUniqueConstructionTypeFields: { __typename?: 'ServiceResult', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type CatalogConstructionTypesUpdatedDateQueryVariables = Exact<{
  catalogId: Scalars['Long'];
}>;


export type CatalogConstructionTypesUpdatedDateQuery = { __typename?: 'Query', catalogConstructionTypesUpdatedDate: { __typename?: 'ServiceDataResultOfCatalogConstructionTypeChangesData', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null, data?: { __typename?: 'CatalogConstructionTypeChangesData', catalogId: any, updatedAt?: any | null } | null } };

export type CatalogCreateConstructionTypeMutationVariables = Exact<{
  input: CatalogConstructionTypeCreateInput;
}>;


export type CatalogCreateConstructionTypeMutation = { __typename?: 'Mutation', catalogCreateConstructionType: { __typename?: 'ServiceDataResultOfConstructionTypeData', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null, data?: { __typename?: 'ConstructionTypeData', catalogId: any, code: string, fullName: string, iconCode?: string | null, id: number, name: string, shortName: string, uniqueId?: string | null, updatedAt?: any | null, contractFileName: string, createdAt: any } | null } };

export type CatalogUpdateConstructionTypeMutationVariables = Exact<{
  input: CatalogConstructionTypeUpdateInput;
}>;


export type CatalogUpdateConstructionTypeMutation = { __typename?: 'Mutation', catalogUpdateConstructionType: { __typename?: 'ServiceDataResultOfConstructionTypeData', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null, data?: { __typename?: 'ConstructionTypeData', catalogId: any, code: string, fullName: string, iconCode?: string | null, id: number, name: string, shortName: string, uniqueId?: string | null, updatedAt?: any | null, contractFileName: string, createdAt: any } | null } };

export type CatalogRemoveConstructionTypeMutationVariables = Exact<{
  catalogConstructionTypeId: Scalars['Int'];
}>;


export type CatalogRemoveConstructionTypeMutation = { __typename?: 'Mutation', catalogRemoveConstructionType: { __typename?: 'ServiceIdResultOfInt32', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, id?: number | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type CatalogIsUniqueConstructionTypeCodeQueryVariables = Exact<{
  catalogConstructionTypeId?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
}>;


export type CatalogIsUniqueConstructionTypeCodeQuery = { __typename?: 'Query', catalogIsUniqueConstructionTypeCode: { __typename?: 'ServiceResult', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type CatalogConstructionTypeIsUsedInProjectsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type CatalogConstructionTypeIsUsedInProjectsQuery = { __typename?: 'Query', catalogConstructionTypeIsUsedInProjects: { __typename?: 'ServiceResult', result: boolean, message?: string | null, actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type CatalogQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
}>;


export type CatalogQuery = { __typename?: 'Query', catalog: { __typename?: 'ServiceDataResultOfCatalogData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'CatalogData', authoredBy?: string | null, createdAt: any, id: any, name: string, subsidiaryId?: any | null, subsidiaryName?: string | null, uniqueId: string, updatedAt?: any | null, metadata?: any | null, type: { __typename?: 'CatalogTypeData', allowMultiple: boolean, canCreate: boolean, methodologies: Array<ProjectMethodologyEnum>, name: string, uniqueId: string } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogItemDataFilterInput>;
  order?: InputMaybe<Array<CatalogItemDataSortInput> | CatalogItemDataSortInput>;
}>;


export type CatalogsQuery = { __typename?: 'Query', catalogs?: { __typename?: 'CatalogsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogItemData', authoredBy?: string | null, createdAt: any, id: any, name: string, subsidiaryId?: any | null, subsidiaryName?: string | null, uniqueId: string, updatedAt?: any | null, type: { __typename?: 'CatalogTypeData', uniqueId: string, name: string, methodologies: Array<ProjectMethodologyEnum>, allowMultiple: boolean, canCreate: boolean } }> | null } | null };

export type CatalogsMethodologyFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfProjectMethodologyEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfProjectMethodologyEnumSortInput> | FilterValueOfProjectMethodologyEnumSortInput>;
}>;


export type CatalogsMethodologyFilterQuery = { __typename?: 'Query', catalogsMethodologyFilter: Array<{ __typename?: 'FilterValueOfProjectMethodologyEnum', value: ProjectMethodologyEnum }> };

export type CatalogsNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type CatalogsNameFilterQuery = { __typename?: 'Query', catalogsNameFilter?: { __typename?: 'CatalogsNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogSubsidiaryFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type CatalogSubsidiaryFilterQuery = { __typename?: 'Query', catalogSubsidiaryFilter?: { __typename?: 'CatalogSubsidiaryFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogRemoveWorkTypesMutationVariables = Exact<{
  catalogWorkTypeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CatalogRemoveWorkTypesMutation = { __typename?: 'Mutation', catalogRemoveWorkTypes: { __typename?: 'ServiceDataResultOfInt32__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hideValidation?: boolean | null, hasValidation: boolean, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogCreateWorkTypeMutationVariables = Exact<{
  input: CatalogWorkTypeCreateInput;
}>;


export type CatalogCreateWorkTypeMutation = { __typename?: 'Mutation', catalogCreateWorkType: { __typename?: 'ServiceDataResultOfCatalogWorkTypeData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'CatalogWorkTypeData', code: string, hasPrice: boolean, id: number, name: string, uniqueId: string, unit: string, updatedAt?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUpdateWorkTypeMutationVariables = Exact<{
  input: CatalogWorkTypeUpdateInput;
}>;


export type CatalogUpdateWorkTypeMutation = { __typename?: 'Mutation', catalogUpdateWorkType: { __typename?: 'ServiceDataResultOfCatalogWorkTypeData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'CatalogWorkTypeData', id: number, code: string, hasPrice: boolean, name: string, uniqueId: string, unit: string, updatedAt?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogWorkTypeCodeFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogWorkTypeCodeFilterQuery = { __typename?: 'Query', catalogWorkTypeCodeFilter?: { __typename?: 'CatalogWorkTypeCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogWorkTypeNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogWorkTypeNameFilterQuery = { __typename?: 'Query', catalogWorkTypeNameFilter?: { __typename?: 'CatalogWorkTypeNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogWorkTypeItemsQueryVariables = Exact<{
  order?: InputMaybe<Array<CatalogWorkTypeDataSortInput> | CatalogWorkTypeDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogWorkTypeDataFilterInput>;
  catalogUniqueId: Scalars['String'];
}>;


export type CatalogWorkTypeItemsQuery = { __typename?: 'Query', catalogWorkTypeItems?: { __typename?: 'CatalogWorkTypeItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogWorkTypeData', code: string, hasPrice: boolean, id: number, name: string, uniqueId: string, unit: string, updatedAt?: any | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogWorkTypesUpdatedDateQueryVariables = Exact<{
  catalogId: Scalars['Long'];
}>;


export type CatalogWorkTypesUpdatedDateQuery = { __typename?: 'Query', catalogWorkTypesUpdatedDate: { __typename?: 'ServiceDataResultOfCatalogWorkTypeChangesData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'CatalogWorkTypeChangesData', catalogId: any, updatedAt?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogIsUniqueWorkTypeCodeQueryVariables = Exact<{
  catalogWorkTypeId?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
}>;


export type CatalogIsUniqueWorkTypeCodeQuery = { __typename?: 'Query', catalogIsUniqueWorkTypeCode: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogImportUerBaseCostWorkTypesMutationVariables = Exact<{
  file: FileInput;
  catalogId: Scalars['Long'];
}>;


export type CatalogImportUerBaseCostWorkTypesMutation = { __typename?: 'Mutation', catalogImportUerBaseCostWorkTypes: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null, source?: string | null }> | null } };

export type CatalogUerBaseCostItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput> | CatalogUerBaseCostDataSortInput>;
}>;


export type CatalogUerBaseCostItemsQuery = { __typename?: 'Query', catalogUERBaseCostItems?: { __typename?: 'CatalogUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostData', chapter?: ChapterEnum | null, code: string, version?: string | null, emm?: any | null, eqp?: any | null, groupId: any, groupName: string, id: any, mtr?: any | null, name: string, nr?: any | null, ozp?: any | null, pir?: any | null, sectionId: any, sectionName: string, sp?: any | null, trn?: any | null, uerClassifier?: UerClassifierEnum | null, uniqueId: string, unit: string, unitCost: any, updatedAt?: any | null, zpm?: any | null, justification?: string | null, catalogUERBaseCostWorkScopes: Array<{ __typename?: 'CatalogUERBaseCostWorkScopeData', id: any, name: string, number: any }>, constructionTypes: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }>, workType: { __typename?: 'CatalogUERBaseWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null } }> | null } | null };

export type CatalogUerBaseCostUpdateDateFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfNullableOfDateTimeFilterInput>;
  catalogUniqueId: Scalars['String'];
}>;


export type CatalogUerBaseCostUpdateDateFilterQuery = { __typename?: 'Query', catalogUERBaseCostUpdateDateFilter?: { __typename?: 'CatalogUERBaseCostUpdateDateFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfDateTime', value?: any | null }> | null } | null };

export type CatalogUerBaseCostSectionNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostSectionNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostSectionNameFilter?: { __typename?: 'CatalogUERBaseCostSectionNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostGroupNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostGroupNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostGroupNameFilter?: { __typename?: 'CatalogUERBaseCostGroupNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostCodeFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostCodeFilterQuery = { __typename?: 'Query', catalogUERBaseCostCodeFilter?: { __typename?: 'CatalogUERBaseCostCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostNameFilter?: { __typename?: 'CatalogUERBaseCostNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostChapterFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput> | FilterValueOfNullableOfChapterEnumSortInput>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostChapterFilterQuery = { __typename?: 'Query', catalogUERBaseCostChapterFilter?: { __typename?: 'CatalogUERBaseCostChapterFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type CatalogUerBaseCostUerClassifierFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput> | FilterValueOfNullableOfUerClassifierEnumSortInput>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostUerClassifierFilterQuery = { __typename?: 'Query', catalogUERBaseCostUerClassifierFilter?: { __typename?: 'CatalogUERBaseCostUerClassifierFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfUerClassifierEnum', value?: UerClassifierEnum | null }> | null } | null };

export type CatalogUerBaseCostWorktypeNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostWorktypeNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostWorktypeNameFilter?: { __typename?: 'CatalogUERBaseCostWorktypeNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostWorktypeFOsummFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
  catalogUniqueId: Scalars['String'];
  order?: InputMaybe<Array<FilterValueOfWorkInSumEnumSortInput> | FilterValueOfWorkInSumEnumSortInput>;
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  input: CatalogUerBaseCostFilterInput;
}>;


export type CatalogUerBaseCostWorktypeFOsummFilterQuery = { __typename?: 'Query', catalogUERBaseCostWorktypeFOsummFilter?: { __typename?: 'CatalogUERBaseCostWorktypeFOsummFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfWorkInSumEnum', value: WorkInSumEnum }> | null } | null };

export type CatalogUpdateUerBaseCostMutationVariables = Exact<{
  costData: UpdateCatalogUerBaseCostInput;
}>;


export type CatalogUpdateUerBaseCostMutation = { __typename?: 'Mutation', catalogUpdateUerBaseCost: { __typename?: 'ServiceDataResultOfCatalogUERBaseCostData', code?: string | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CatalogUERBaseCostData', chapter?: ChapterEnum | null, code: string, emm?: any | null, eqp?: any | null, groupId: any, groupName: string, id: any, mtr?: any | null, name: string, nr?: any | null, ozp?: any | null, pir?: any | null, sectionId: any, sectionName: string, sp?: any | null, trn?: any | null, uerClassifier?: UerClassifierEnum | null, uniqueId: string, unit: string, unitCost: any, updatedAt?: any | null, zpm?: any | null, catalogUERBaseCostWorkScopes: Array<{ __typename?: 'CatalogUERBaseCostWorkScopeData', id: any, name: string, number: any }>, constructionTypes: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }>, workType: { __typename?: 'CatalogUERBaseWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogRemoveUerBaseCostMutationVariables = Exact<{
  uerBaseCostIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type CatalogRemoveUerBaseCostMutation = { __typename?: 'Mutation', catalogRemoveUerBaseCost: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, code?: string | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUerBaseCostEstimateBasisRowsQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostEstimateBasisRowFilterInput>;
}>;


export type CatalogUerBaseCostEstimateBasisRowsQuery = { __typename?: 'Query', catalogUERBaseCostEstimateBasisRows: Array<{ __typename?: 'CatalogUERBaseCostEstimateBasisRow', code?: string | null, estimateTotal?: any | null, isDeleted?: boolean | null, isNotCount?: boolean | null, isPriceHeadLine: boolean, isSectionHeadLine: boolean, name: string, number?: number | null, parentRowId?: string | null, priceId?: any | null, resourceId?: any | null, rowId: string, sectionId: any, unit?: string | null, quantity?: { __typename?: 'CatalogUERBaseCostEstimateBasisRowQuantityData', total: any, unit: any } | null, totalCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisRowTotalCostData', emm?: any | null, mtr?: any | null, ozp?: any | null, total: any, zpm?: any | null, nr?: any | null, sp?: any | null } | null, totalWorkCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisRowWorkCostData', tm?: any | null, tz?: any | null } | null, unitCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisRowUnitCostData', emm?: any | null, mtr?: any | null, ozp?: any | null, total: any, zpm?: any | null } | null, unitWorkCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisRowWorkCostData', tm?: any | null, tz?: any | null } | null }> };

export type CatalogUerBaseCostTotalsQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  uerBaseCostId: Scalars['Long'];
}>;


export type CatalogUerBaseCostTotalsQuery = { __typename?: 'Query', catalogUERBaseCostTotals: Array<{ __typename?: 'CatalogUERBaseCostTotalItem', hasIndent: boolean, isHeadLine: boolean, name: string, sortOrder: number, value?: any | null }> };

export type CatalogUerBaseCostWorkScopesQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostWorkScopeBaseDataFilterInput>;
}>;


export type CatalogUerBaseCostWorkScopesQuery = { __typename?: 'Query', catalogUERBaseCostWorkScopes?: { __typename?: 'CatalogUERBaseCostWorkScopesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostWorkScopeBaseData', name: string, number: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogUerBaseCostEstimateBasisResourcesQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostEstimateBasisItemFilterInput>;
}>;


export type CatalogUerBaseCostEstimateBasisResourcesQuery = { __typename?: 'Query', catalogUERBaseCostEstimateBasisResources?: { __typename?: 'CatalogUERBaseCostEstimateBasisResourcesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostEstimateBasisItem', code?: string | null, group: CatalogUerBaseCostEstimateBasisDataGroupEnum, id?: any | null, isDeleted?: boolean | null, isHeadLine: boolean, isNotCount?: boolean | null, name: string, unit?: string | null, unitCost?: any | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogUerBaseCostEstimateBasisQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseCostId: Scalars['Long'];
  where?: InputMaybe<CatalogUerBaseCostEstimateBasisItemFilterInput>;
}>;


export type CatalogUerBaseCostEstimateBasisQuery = { __typename?: 'Query', catalogUERBaseCostEstimateBasis?: { __typename?: 'CatalogUERBaseCostEstimateBasisCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostEstimateBasisItem', code?: string | null, group: CatalogUerBaseCostEstimateBasisDataGroupEnum, id?: any | null, isDeleted?: boolean | null, isHeadLine: boolean, isNotCount?: boolean | null, name: string, unit?: string | null, unitCost?: any | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogUerBaseCostHistoryItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  where?: InputMaybe<CatalogUerBaseCostHistoryDataFilterInput>;
}>;


export type CatalogUerBaseCostHistoryItemsQuery = { __typename?: 'Query', catalogUERBaseCostHistoryItems?: { __typename?: 'CatalogUERBaseCostHistoryItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostHistoryData', id?: any | null, isHeadLine?: boolean | null, catalogId?: any | null, uerBaseCostId?: any | null, uerBaseCostCode?: string | null, uerBaseCostChangeType?: UerBaseCostChangeType | null, updateUerDate?: any | null, catalogUERBaseCostChange?: { __typename?: 'CatalogUERBaseCostChangeData', groupCode?: string | null, groupCodeCng?: boolean | null, groupFullName?: string | null, groupFullNameCng?: boolean | null, code?: string | null, codeCng?: boolean | null, unit?: string | null, unitCng?: boolean | null, name?: string | null, nameCng?: boolean | null, ozp?: any | null, ozpCng?: boolean | null, emm?: any | null, emmCng?: boolean | null, zpm?: any | null, zpmCng?: boolean | null, mtr?: any | null, mtrCng?: boolean | null, fot?: any | null, fotCng?: boolean | null, eqp?: any | null, eqpCng?: boolean | null, pir?: any | null, pirCng?: boolean | null, trn?: any | null, trnCng?: boolean | null, nr?: any | null, nrCng?: boolean | null, sp?: any | null, spCng?: boolean | null, tz?: any | null, tzCng?: boolean | null, tm?: any | null, tmCng?: boolean | null, chapter?: ChapterEnum | null, chapterCng?: boolean | null, uerClassifier?: UerClassifierEnum | null, uerClassifierCng?: boolean | null, hasWorkScopesHistory?: boolean | null, constructionTypeCng?: boolean | null, justification?: string | null, justificationCng?: boolean | null, unitCost?: any | null, unitCostCng?: boolean | null, constructionTypes?: Array<{ __typename?: 'ConstructionTypeData', id: number, name: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }> | null } | null }> | null } | null };

export type UpdateCatalogUerBaseCostWorkScopesMutationVariables = Exact<{
  uerBaseCostId: Scalars['Long'];
  inputs: Array<CatalogUerBaseCostWorkScopeUpdateInput> | CatalogUerBaseCostWorkScopeUpdateInput;
}>;


export type UpdateCatalogUerBaseCostWorkScopesMutation = { __typename?: 'Mutation', updateCatalogUERBaseCostWorkScopes: { __typename?: 'ServiceResult', code?: string | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUerBaseCostHistoryStatusCountsQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type CatalogUerBaseCostHistoryStatusCountsQuery = { __typename?: 'Query', catalogUERBaseCostHistoryStatusCounts: { __typename?: 'ServiceDataResultOfCatalogUERBaseCostHistoryStatusCountData', result: boolean, data?: { __typename?: 'CatalogUERBaseCostHistoryStatusCountData', newCostsCount: number, deletedCostsCount: number, updatedCostsCount: number } | null } };

export type ExportCatalogUerBaseCostHistoryAsExcelQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportCatalogUerBaseCostHistoryAsExcelQuery = { __typename?: 'Query', exportCatalogUERBaseCostHistoryAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUpsertMultiUerBaseCostBasisesMutationVariables = Exact<{
  input: CatalogUpsertMultiUerBaseCostBasisesInput;
}>;


export type CatalogUpsertMultiUerBaseCostBasisesMutation = { __typename?: 'Mutation', catalogUpsertMultiUerBaseCostBasises: { __typename?: 'ServiceDataResultOfListOfCatalogUERBaseCostData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null, data?: Array<{ __typename?: 'CatalogUERBaseCostData', version?: string | null, uerNacl?: any | null, uerPlan?: any | null, catFile?: string | null, workID?: string | null } | null> | null } };

export type CatalogUpsertArchiveUerBaseCostBasisesMutationVariables = Exact<{
  input: CatalogUpsertArchiveUerBaseCostBasisesInput;
}>;


export type CatalogUpsertArchiveUerBaseCostBasisesMutation = { __typename?: 'Mutation', catalogUpsertArchiveUerBaseCostBasises: { __typename?: 'ServiceDataResultOfListOfCatalogUERBaseCostData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null, source?: string | null }> | null, data?: Array<{ __typename?: 'CatalogUERBaseCostData', version?: string | null, uerNacl?: any | null, uerPlan?: any | null, catFile?: string | null, workID?: string | null } | null> | null } };

export type ExportCatalogUerAsExcelQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
}>;


export type ExportCatalogUerAsExcelQuery = { __typename?: 'Query', exportCatalogUERAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, actionRequired?: boolean | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } };

export type SetCatalogUerBaseCostPropertiesMutationVariables = Exact<{
  catalogId: Scalars['Long'];
  input: CatalogUerBaseCostPropertiesInput;
}>;


export type SetCatalogUerBaseCostPropertiesMutation = { __typename?: 'Mutation', setCatalogUERBaseCostProperties: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, actionRequired?: boolean | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUerBaseCostHistoryGroupFullNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput>;
  order?: InputMaybe<Array<FilterValueOfCatalogUerBaseCostGroupFilterDataSortInput> | FilterValueOfCatalogUerBaseCostGroupFilterDataSortInput>;
}>;


export type CatalogUerBaseCostHistoryGroupFullNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryGroupFullNameFilter?: { __typename?: 'CatalogUERBaseCostHistoryGroupFullNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfCatalogUerBaseCostGroupFilterData', value?: { __typename?: 'CatalogUerBaseCostGroupFilterData', groupCode?: string | null, groupName?: string | null } | null }> | null } | null };

export type CatalogUerBaseCostHistoryCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type CatalogUerBaseCostHistoryCodeFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryCodeFilter?: { __typename?: 'CatalogUERBaseCostHistoryCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostHistoryNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type CatalogUerBaseCostHistoryNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryNameFilter?: { __typename?: 'CatalogUERBaseCostHistoryNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostHistoryChapterFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput> | FilterValueOfNullableOfChapterEnumSortInput>;
}>;


export type CatalogUerBaseCostHistoryChapterFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryChapterFilter?: { __typename?: 'CatalogUERBaseCostHistoryChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type CatalogUerBaseCostHistoryUerClassifierFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput> | FilterValueOfNullableOfUerClassifierEnumSortInput>;
}>;


export type CatalogUerBaseCostHistoryUerClassifierFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryUerClassifierFilter?: { __typename?: 'CatalogUERBaseCostHistoryUerClassifierFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfUerClassifierEnum', value?: UerClassifierEnum | null }> | null } | null };

export type CatalogUerBaseCostHistoryJustificationFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type CatalogUerBaseCostHistoryJustificationFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryJustificationFilter?: { __typename?: 'CatalogUERBaseCostHistoryJustificationFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerBaseCostHistoryWorkScopeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  where?: InputMaybe<FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerBaseCostChangeTypeSortInput> | FilterValueOfNullableOfUerBaseCostChangeTypeSortInput>;
}>;


export type CatalogUerBaseCostHistoryWorkScopeFilterQuery = { __typename?: 'Query', catalogUERBaseCostHistoryWorkScopeFilter?: { __typename?: 'CatalogUERBaseCostHistoryWorkScopeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfUerBaseCostChangeType', value?: UerBaseCostChangeType | null } | null> | null } | null };

export type CatalogUerBaseCostHistoryWorkScopesQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  historyRecordId: Scalars['Long'];
}>;


export type CatalogUerBaseCostHistoryWorkScopesQuery = { __typename?: 'Query', catalogUERBaseCostHistoryWorkScopes: { __typename?: 'ServiceDataResultOfCatalogUERBaseCostWorkScopeHistoryWithStatusCount', data?: { __typename?: 'CatalogUERBaseCostWorkScopeHistoryWithStatusCount', counts: { __typename?: 'CatalogUERBaseCostWorkScopeHistoryStatusCount', newScopesCount: number, deletedScopesCount: number, updatedScopesCount: number }, workScopeItems: Array<{ __typename?: 'CatalogUERBaseCostWorkScopeItems', updateUerDate: any, number: any, workScopeNumberCng?: boolean | null, name: string, workScopeNameCng?: boolean | null, changeType?: UerBaseCostChangeType | null }> } | null } };

export type CatalogUerOtherCostTemplatesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogUerOtherCostTemplateDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerOtherCostTemplateDataSortInput> | CatalogUerOtherCostTemplateDataSortInput>;
}>;


export type CatalogUerOtherCostTemplatesQuery = { __typename?: 'Query', catalogUEROtherCostTemplates?: { __typename?: 'CatalogUEROtherCostTemplatesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'CatalogUEROtherCostTemplateData', id: number, name: string, updatedAt?: any | null }> | null } | null };

export type CatalogUerOtherCostTemplateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CatalogUerOtherCostTemplateQuery = { __typename?: 'Query', catalogUEROtherCostTemplate: { __typename?: 'ServiceDataResultOfCatalogUEROtherCostTemplateExtendedData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, data?: { __typename?: 'CatalogUEROtherCostTemplateExtendedData', id: number, name: string, updatedAt?: any | null, file: { __typename?: 'FileContent', name: string, size: any, dataUrl: string, count: number } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogUerOtherCostTemplateNamesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogUerOtherCostTemplateDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerOtherCostTemplateDataSortInput> | CatalogUerOtherCostTemplateDataSortInput>;
}>;


export type CatalogUerOtherCostTemplateNamesQuery = { __typename?: 'Query', catalogUEROtherCostTemplates?: { __typename?: 'CatalogUEROtherCostTemplatesCollectionSegment', items?: Array<{ __typename?: 'CatalogUEROtherCostTemplateData', name: string }> | null } | null };

export type RemoveCatalogUerOtherCostTemplatesMutationVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type RemoveCatalogUerOtherCostTemplatesMutation = { __typename?: 'Mutation', removeCatalogUEROtherCostTemplates: { __typename?: 'ServiceResult', result: boolean, message?: string | null } };

export type UpdateCatalogUerOtherCostTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CatalogUerOtherCostTemplateInput;
}>;


export type UpdateCatalogUerOtherCostTemplateMutation = { __typename?: 'Mutation', updateCatalogUEROtherCostTemplate: { __typename?: 'ServiceDataResultOfCatalogUEROtherCostTemplateData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, data?: { __typename?: 'CatalogUEROtherCostTemplateData', id: number, name: string, updatedAt?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CreateCatalogUerOtherCostTemplateMutationVariables = Exact<{
  input: CatalogUerOtherCostTemplateInput;
}>;


export type CreateCatalogUerOtherCostTemplateMutation = { __typename?: 'Mutation', createCatalogUEROtherCostTemplate: { __typename?: 'ServiceIdResultOfInt32', id?: number | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogIsUniqueNameOtherCostTemplateQueryVariables = Exact<{
  where?: InputMaybe<CatalogUerOtherCostTemplateDataFilterInput>;
}>;


export type CatalogIsUniqueNameOtherCostTemplateQuery = { __typename?: 'Query', catalogUEROtherCostTemplates?: { __typename?: 'CatalogUEROtherCostTemplatesCollectionSegment', totalCount: number } | null };

export type CatalogRatioSubGroupsQueryVariables = Exact<{
  parentId: Scalars['Long'];
}>;


export type CatalogRatioSubGroupsQuery = { __typename?: 'Query', catalogRatioSubGroups: Array<{ __typename?: 'CatalogRatioGroupData', name: string, id: any }> };

export type AddRatiosModalCodeFilterQueryVariables = Exact<{
  order?: InputMaybe<Array<CatalogRatioDataForListSortInput> | CatalogRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataForListFilterInput>;
}>;


export type AddRatiosModalCodeFilterQuery = { __typename?: 'Query', catalogRatios?: { __typename?: 'CatalogRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioDataForList', code: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type AddRatiosModalNameFilterQueryVariables = Exact<{
  order?: InputMaybe<Array<CatalogRatioDataForListSortInput> | CatalogRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataForListFilterInput>;
}>;


export type AddRatiosModalNameFilterQuery = { __typename?: 'Query', catalogRatios?: { __typename?: 'CatalogRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioDataForList', name: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type IsUniqueLimitedCostTypeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  input: CatalogLimitedCostTypeInput;
}>;


export type IsUniqueLimitedCostTypeQuery = { __typename?: 'Query', isUniqueLimitedCostType: { __typename?: 'ServiceResult', result: boolean } };

export type LimitedCostTypesQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
}>;


export type LimitedCostTypesQuery = { __typename?: 'Query', limitedCostTypes: Array<{ __typename?: 'CatalogLimitedCostTypeExtendedData', canDelete: boolean, id: number, isSystem: boolean, name: string, uniqueId: string }> };

export type CreateCatalogLimitedCostTypeMutationVariables = Exact<{
  input: CatalogLimitedCostTypeInput;
}>;


export type CreateCatalogLimitedCostTypeMutation = { __typename?: 'Mutation', createCatalogLimitedCostType: { __typename?: 'ServiceDataResultOfCatalogLimitedCostTypeExtendedData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UpdateCatalogLimitedCostTypeMutationVariables = Exact<{
  id: Scalars['Int'];
  input: CatalogLimitedCostTypeInput;
}>;


export type UpdateCatalogLimitedCostTypeMutation = { __typename?: 'Mutation', updateCatalogLimitedCostType: { __typename?: 'ServiceDataResultOfCatalogLimitedCostTypeExtendedData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type RemoveLimitedCostTypeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveLimitedCostTypeMutation = { __typename?: 'Mutation', removeCatalogLimitedCostType: { __typename?: 'ServiceIdResultOfInt32', result: boolean, message?: string | null, id?: number | null } };

export type GlobalOtherCostsQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput> | GlobalOtherCostDataSortInput>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
}>;


export type GlobalOtherCostsQuery = { __typename?: 'Query', globalOtherCosts?: { __typename?: 'GlobalOtherCostsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'GlobalOtherCostData', id: any, name: string, methodology: ProjectMethodologyEnum, section?: SectionEnum | null, chapter?: ChapterEnum | null, calculatingType: OtherCostCalculationTypeEnum, formula?: string | null, otherCostType: { __typename?: 'CatalogOtherCostTypeBase', id: number, uniqueId: string, name: string } }> | null } | null };

export type GlobalLimitedCostsQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<GlobalLimitedCostDataSortInput> | GlobalLimitedCostDataSortInput>;
  where?: InputMaybe<GlobalLimitedCostDataFilterInput>;
}>;


export type GlobalLimitedCostsQuery = { __typename?: 'Query', globalLimitedCosts?: { __typename?: 'GlobalLimitedCostsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'GlobalLimitedCostData', id: any, name: string, methodology: ProjectMethodologyEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, catalogLimitedCostType?: { __typename?: 'CatalogLimitedCostTypeData', id: number, uniqueId: string, name: string } | null }> | null } | null };

export type GlobalOtherCostCandidateTypesQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
  excludeGlobalOtherCostId?: InputMaybe<Scalars['Long']>;
}>;


export type GlobalOtherCostCandidateTypesQuery = { __typename?: 'Query', globalOtherCostCandidateTypes: Array<{ __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, isSystem: boolean }> };

export type GlobalLimitedCostCandidateTypesQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
  excludeGlobalLimitedCostId?: InputMaybe<Scalars['Long']>;
}>;


export type GlobalLimitedCostCandidateTypesQuery = { __typename?: 'Query', globalLimitedCostCandidateTypes: Array<{ __typename?: 'CatalogLimitedCostTypeExtendedData', id: number, uniqueId: string, name: string, isSystem: boolean }> };

export type IsUniqueGlobalOtherCostQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  section: SectionEnum;
  methodology: ProjectMethodologyEnum;
  calculatingType: OtherCostCalculationTypeEnum;
}>;


export type IsUniqueGlobalOtherCostQuery = { __typename?: 'Query', isUniqueGlobalOtherCost: { __typename?: 'ServiceResult', result: boolean } };

export type IsUniqueGlobalLimitedCostQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  methodology: ProjectMethodologyEnum;
}>;


export type IsUniqueGlobalLimitedCostQuery = { __typename?: 'Query', isUniqueGlobalLimitedCost: { __typename?: 'ServiceResult', result: boolean } };

export type CreateGlobalOtherCostMutationVariables = Exact<{
  input: GlobalOtherCostCreateInput;
}>;


export type CreateGlobalOtherCostMutation = { __typename?: 'Mutation', createGlobalOtherCost: { __typename?: 'ServiceDataResultOfGlobalOtherCostData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'GlobalOtherCostData', id: any } | null } };

export type UpdateGlobalOtherCostMutationVariables = Exact<{
  input: GlobalOtherCostUpdateInput;
}>;


export type UpdateGlobalOtherCostMutation = { __typename?: 'Mutation', updateGlobalOtherCost: { __typename?: 'ServiceDataResultOfGlobalOtherCostData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'GlobalOtherCostData', id: any } | null } };

export type RemoveGlobalOtherCostMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type RemoveGlobalOtherCostMutation = { __typename?: 'Mutation', removeGlobalOtherCost: { __typename?: 'ServiceIdResultOfInt64', result: boolean, id?: any | null, message?: string | null } };

export type CreateGlobalLimitedCostMutationVariables = Exact<{
  input: GlobalLimitedCostCreateInput;
}>;


export type CreateGlobalLimitedCostMutation = { __typename?: 'Mutation', createGlobalLimitedCost: { __typename?: 'ServiceDataResultOfGlobalLimitedCostData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'GlobalLimitedCostData', id: any } | null } };

export type UpdateGlobalLimitedCostMutationVariables = Exact<{
  input: GlobalLimitedCostUpdateInput;
}>;


export type UpdateGlobalLimitedCostMutation = { __typename?: 'Mutation', updateGlobalLimitedCost: { __typename?: 'ServiceDataResultOfGlobalLimitedCostData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'GlobalLimitedCostData', id: any } | null } };

export type RemoveGlobalLimitedCostMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type RemoveGlobalLimitedCostMutation = { __typename?: 'Mutation', removeGlobalLimitedCost: { __typename?: 'ServiceIdResultOfInt64', result: boolean, id?: any | null, message?: string | null } };

export type OtherCostTypesQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput> | CatalogOtherCostTypeDataSortInput>;
}>;


export type OtherCostTypesQuery = { __typename?: 'Query', otherCostTypes: Array<{ __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, isSystem: boolean, canDelete: boolean }> };

export type IsUniqueOtherCostTypeQueryVariables = Exact<{
  catalogOtherCostTypeId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  methodology: ProjectMethodologyEnum;
}>;


export type IsUniqueOtherCostTypeQuery = { __typename?: 'Query', isUniqueOtherCostType: { __typename?: 'ServiceResult', result: boolean } };

export type CreateCatalogOtherCostTypeMutationVariables = Exact<{
  input: CatalogOtherCostTypeCreateInput;
}>;


export type CreateCatalogOtherCostTypeMutation = { __typename?: 'Mutation', createCatalogOtherCostType: { __typename?: 'ServiceDataResultOfCatalogOtherCostTypeData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UpdateCatalogOtherCostTypeMutationVariables = Exact<{
  input: CatalogOtherCostTypeUpdateInput;
}>;


export type UpdateCatalogOtherCostTypeMutation = { __typename?: 'Mutation', updateCatalogOtherCostType: { __typename?: 'ServiceDataResultOfCatalogOtherCostTypeData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type RemoveCatalogOtherCostTypeMutationVariables = Exact<{
  catalogOtherCostTypeId: Scalars['Int'];
}>;


export type RemoveCatalogOtherCostTypeMutation = { __typename?: 'Mutation', removeCatalogOtherCostType: { __typename?: 'ServiceIdResultOfInt32', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogRatiosQueryVariables = Exact<{
  order?: InputMaybe<Array<CatalogRatioDataForListSortInput> | CatalogRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataForListFilterInput>;
}>;


export type CatalogRatiosQuery = { __typename?: 'Query', catalogRatios?: { __typename?: 'CatalogRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioDataForList', id: any, code: string, hasCosts: boolean, name: string, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioGroupFilterQueryVariables = Exact<{
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogRatioGroupFilterQuery = { __typename?: 'Query', catalogRatioGroupFilter?: { __typename?: 'CatalogRatioGroupFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioCodeFilterQueryVariables = Exact<{
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogRatioCodeFilterQuery = { __typename?: 'Query', catalogRatioCodeFilter?: { __typename?: 'CatalogRatioCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogRatioTypeFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type CatalogRatioTypeFilterQuery = { __typename?: 'Query', catalogRatioTypeFilter?: { __typename?: 'CatalogRatioTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfRatioTypeEnum', value: RatioTypeEnum }> | null } | null };

export type CatalogRatioNameFilterQueryVariables = Exact<{
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogRatioNameFilterQuery = { __typename?: 'Query', catalogRatioNameFilter?: { __typename?: 'CatalogRatioNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type RemoveCatalogRatioMutationVariables = Exact<{
  catalogRatioId: Scalars['Long'];
}>;


export type RemoveCatalogRatioMutation = { __typename?: 'Mutation', removeCatalogRatio: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, id?: any | null } };

export type CatalogRatioHistoryItemsQueryVariables = Exact<{
  order?: InputMaybe<Array<CatalogRatioHistoryDataSortInput> | CatalogRatioHistoryDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioHistoryDataFilterInput>;
  changeType?: InputMaybe<HistoryChangeType>;
}>;


export type CatalogRatioHistoryItemsQuery = { __typename?: 'Query', catalogRatioHistoryItems?: { __typename?: 'CatalogRatioHistoryItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioHistoryData', catalogRatioId?: any | null, id?: any | null, isHeadLine?: boolean | null, ratioType?: RatioTypeEnum | null, code?: string | null, name?: string | null, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, justification?: string | null, changeType?: HistoryChangeType | null, changeDate?: any | null, changeData?: { __typename?: 'CatalogRatioHistoryChange', name?: string | null, nameCng?: boolean | null, kmat?: any | null, kmatCng?: boolean | null, ktz?: any | null, ktzCng?: boolean | null, ktzzpm?: any | null, ktzzpmCng?: boolean | null, kozp?: any | null, kozpCng?: boolean | null, knr?: any | null, knrCng?: boolean | null, ksp?: any | null, kspCng?: boolean | null, kem?: any | null, kemCng?: boolean | null, justification?: string | null, justificationCng?: boolean | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioHistoryStatusCountsQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  where?: InputMaybe<ServiceDataResultOfHistoryStatusCountDataFilterInput>;
}>;


export type CatalogRatioHistoryStatusCountsQuery = { __typename?: 'Query', catalogRatioHistoryStatusCounts: { __typename?: 'ServiceDataResultOfHistoryStatusCountData', data?: { __typename?: 'HistoryStatusCountData', newCount: number, updatedCount: number, deletedCount: number } | null } };

export type CatalogRatioHistoryCodeFilterQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  changeType?: InputMaybe<HistoryChangeType>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogRatioHistoryCodeFilterQuery = { __typename?: 'Query', catalogRatioHistoryCodeFilter?: { __typename?: 'CatalogRatioHistoryCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioHistoryNameFilterQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  changeType?: InputMaybe<HistoryChangeType>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogRatioHistoryNameFilterQuery = { __typename?: 'Query', catalogRatioHistoryNameFilter?: { __typename?: 'CatalogRatioHistoryNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioHistoryTypeFilterQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  changeType?: InputMaybe<HistoryChangeType>;
}>;


export type CatalogRatioHistoryTypeFilterQuery = { __typename?: 'Query', catalogRatioHistoryTypeFilter?: { __typename?: 'CatalogRatioHistoryTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfRatioTypeEnum', value?: RatioTypeEnum | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioHistoryGroupFilterQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  changeType?: InputMaybe<HistoryChangeType>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type CatalogRatioHistoryGroupFilterQuery = { __typename?: 'Query', catalogRatioHistoryGroupFilter?: { __typename?: 'CatalogRatioHistoryGroupFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogRatioHistoryJustificationFilterQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  changeType?: InputMaybe<HistoryChangeType>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogRatioHistoryJustificationFilterQuery = { __typename?: 'Query', catalogRatioHistoryJustificationFilter?: { __typename?: 'CatalogRatioHistoryJustificationFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type RemoveCatalogOtherCostVariableMutationVariables = Exact<{
  otherCostVariableId: Scalars['Long'];
}>;


export type RemoveCatalogOtherCostVariableMutation = { __typename?: 'Mutation', removeCatalogOtherCostVariable: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogsNamesByFilterQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogItemDataFilterInput>;
}>;


export type CatalogsNamesByFilterQuery = { __typename?: 'Query', catalogs?: { __typename?: 'CatalogsCollectionSegment', items?: Array<{ __typename?: 'CatalogItemData', name: string }> | null } | null };

export type CatalogOtherCostVariablesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  where?: InputMaybe<CatalogOtherCostVariableItemDataFilterInput>;
  order?: InputMaybe<Array<CatalogOtherCostVariableItemDataSortInput> | CatalogOtherCostVariableItemDataSortInput>;
}>;


export type CatalogOtherCostVariablesQuery = { __typename?: 'Query', catalogOtherCostVariables?: { __typename?: 'CatalogOtherCostVariablesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogOtherCostVariableItemData', canDelete: boolean, dataSourceName?: string | null, formula?: string | null, groupName: string, id: any, name: string, type: CatalogOtherCostVariableTypeEnum, dataSourceId?: string | null, groupId: number, uniqueId: string, otherCostTypeId?: number | null, limitedCostTypeId?: number | null, subsidiaryId?: any | null, subsidiaryName?: string | null, entities: Array<{ __typename?: 'CatalogOtherCostVariableEntityData', isSystem: boolean, name: string, uniqueId: string }>, otherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, isSystem: boolean, name: string, uniqueId: string } | null, limitedCostType?: { __typename?: 'CatalogLimitedCostTypeExtendedData', id: number, isSystem: boolean, name: string, uniqueId: string } | null }> | null } | null };

export type CatalogOtherCostVariablesNameFilterQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogOtherCostVariablesNameFilterQuery = { __typename?: 'Query', catalogOtherCostVariablesNameFilter?: { __typename?: 'CatalogOtherCostVariablesNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogOtherCostVariablesGroupFilterQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogOtherCostVariablesGroupFilterQuery = { __typename?: 'Query', catalogOtherCostVariablesGroupFilter?: { __typename?: 'CatalogOtherCostVariablesGroupFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogOtherCostVariablesSubsidiaryNameFilterQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type CatalogOtherCostVariablesSubsidiaryNameFilterQuery = { __typename?: 'Query', catalogOtherCostVariablesSubsidiaryNameFilter?: { __typename?: 'CatalogOtherCostVariablesSubsidiaryNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type IsUniqueVariableGroupQueryVariables = Exact<{
  groupName: Scalars['String'];
  catalogUniqueId: Scalars['String'];
  groupId?: InputMaybe<Scalars['Int']>;
  isGlobal: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
}>;


export type IsUniqueVariableGroupQuery = { __typename?: 'Query', isUniqueVariableGroup: { __typename?: 'ServiceResult', result: boolean } };

export type CreateCatalogOtherCostVariableGroupMutationVariables = Exact<{
  input: CatalogOtherCostVariableGroupCreateInput;
}>;


export type CreateCatalogOtherCostVariableGroupMutation = { __typename?: 'Mutation', createCatalogOtherCostVariableGroup: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableGroupData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UpdateCatalogOtherCostVariableGroupMutationVariables = Exact<{
  input: CatalogOtherCostVariableGroupUpdateInput;
}>;


export type UpdateCatalogOtherCostVariableGroupMutation = { __typename?: 'Mutation', updateCatalogOtherCostVariableGroup: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableGroupData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type RemoveCatalogOtherCostVariableGroupMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type RemoveCatalogOtherCostVariableGroupMutation = { __typename?: 'Mutation', removeCatalogOtherCostVariableGroup: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableGroupData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogOtherCostVariableGroupListQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableGroupItemDataSortInput> | CatalogOtherCostVariableGroupItemDataSortInput>;
}>;


export type CatalogOtherCostVariableGroupListQuery = { __typename?: 'Query', catalogOtherCostVariableGroupList?: { __typename?: 'CatalogOtherCostVariableGroupListCollectionSegment', items?: Array<{ __typename?: 'CatalogOtherCostVariableGroupItemData', id: number, name: string, variableCount: number, methodology: ProjectMethodologyEnum }> | null } | null };

export type CatalogOtherCostVariableQueryVariables = Exact<{
  otherCostVariableId: Scalars['Long'];
}>;


export type CatalogOtherCostVariableQuery = { __typename?: 'Query', catalogOtherCostVariable: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableData', data?: { __typename?: 'CatalogOtherCostVariableData', formula?: string | null, name: string, type: CatalogOtherCostVariableTypeEnum, otherCostTypeId?: number | null, limitedCostTypeId?: number | null, dataSource?: { __typename?: 'CatalogOtherCostVariableDataSourceData', id: number, name: string } | null, entities: Array<{ __typename?: 'CatalogOtherCostVariableEntityData', name: string, uniqueId: string }>, group: { __typename?: 'CatalogOtherCostVariableGroupData', id: number, name: string } } | null } };

export type CatalogOtherCostVariableEntitiesQueryVariables = Exact<{
  methodology: ProjectMethodologyEnum;
  where?: InputMaybe<CatalogOtherCostVariableEntityItemDataFilterInput>;
  order?: InputMaybe<Array<CatalogOtherCostVariableEntityItemDataSortInput> | CatalogOtherCostVariableEntityItemDataSortInput>;
}>;


export type CatalogOtherCostVariableEntitiesQuery = { __typename?: 'Query', catalogOtherCostVariableEntities: Array<{ __typename?: 'CatalogOtherCostVariableEntityItemData', name: string, uniqueId: string }> };

export type IsUniqueVariableNameQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  variableId?: InputMaybe<Scalars['Long']>;
  variableType: CatalogOtherCostVariableTypeEnum;
  variableName: Scalars['String'];
  globalOnly: Scalars['Boolean'];
  methodology: ProjectMethodologyEnum;
}>;


export type IsUniqueVariableNameQuery = { __typename?: 'Query', isUniqueVariableName: { __typename?: 'ServiceResult', result: boolean } };

export type CreateCatalogOtherCostVariableMutationVariables = Exact<{
  input: CatalogOtherCostVariableCreateInput;
}>;


export type CreateCatalogOtherCostVariableMutation = { __typename?: 'Mutation', createCatalogOtherCostVariable: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UpdateCatalogOtherCostVariableMutationVariables = Exact<{
  input: CatalogOtherCostVariableUpdateInput;
}>;


export type UpdateCatalogOtherCostVariableMutation = { __typename?: 'Mutation', updateCatalogOtherCostVariable: { __typename?: 'ServiceDataResultOfCatalogOtherCostVariableData', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogOtherCostVariableDataSourcesQueryVariables = Exact<{
  entityUniqueIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  methodology: ProjectMethodologyEnum;
  order?: InputMaybe<Array<CatalogOtherCostVariableDataSourceItemDataSortInput> | CatalogOtherCostVariableDataSourceItemDataSortInput>;
}>;


export type CatalogOtherCostVariableDataSourcesQuery = { __typename?: 'Query', catalogOtherCostVariableDataSources?: { __typename?: 'CatalogOtherCostVariableDataSourcesCollectionSegment', items?: Array<{ __typename?: 'CatalogOtherCostVariableDataSourceItemData', id: number, name: string }> | null } | null };

export type GlobalConstructionTypesQueryVariables = Exact<{
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ConstructionTypeDataSortInput> | ConstructionTypeDataSortInput>;
}>;


export type GlobalConstructionTypesQuery = { __typename?: 'Query', globalConstructionTypes?: { __typename?: 'GlobalConstructionTypesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }> | null } | null };

export type CatalogRatioGroupsQueryVariables = Exact<{
  ratioType: RatioTypeEnum;
  where?: InputMaybe<CatalogRatioGroupDataFilterInput>;
}>;


export type CatalogRatioGroupsQuery = { __typename?: 'Query', catalogRatioGroups: Array<{ __typename?: 'CatalogRatioGroupData', id: any, name: string, groupType?: DismantlingCoefficientTypeEnum | null, parentId?: any | null }> };

export type CatalogRatioTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CatalogRatioTypesQuery = { __typename?: 'Query', catalogRatioTypes?: { __typename?: 'CatalogRatioTypesCollectionSegment', items?: Array<RatioTypeEnum> | null } | null };

export type CatalogRatioQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CatalogRatioQuery = { __typename?: 'Query', catalogRatio: { __typename?: 'ServiceDataResultOfCatalogRatioData', data?: { __typename?: 'CatalogRatioData', id: any, name: string, ratioType: RatioTypeEnum, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, code: string, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any } | null } };

export type CreateCatalogRatioMutationVariables = Exact<{
  input: CatalogRatioCreateInput;
}>;


export type CreateCatalogRatioMutation = { __typename?: 'Mutation', createCatalogRatio: { __typename?: 'ServiceDataResultOfCatalogRatioData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'CatalogRatioData', id: any, code: string, name: string, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any, justification?: string | null } | null } };

export type UpdateCatalogRatioMutationVariables = Exact<{
  input: CatalogRatioUpdateInput;
}>;


export type UpdateCatalogRatioMutation = { __typename?: 'Mutation', updateCatalogRatio: { __typename?: 'ServiceDataResultOfCatalogRatioData', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'CatalogRatioData', id: any, code: string, name: string, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any, justification?: string | null } | null } };

export type CatalogRatioMassApplyMutationVariables = Exact<{
  input: CatalogRatioMassApplyInput;
}>;


export type CatalogRatioMassApplyMutation = { __typename?: 'Mutation', catalogRatioMassApply: { __typename?: 'ServiceResult', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type MassApplicationBaseCostsSectionNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput> | CatalogUerBaseCostDataSortInput>;
}>;


export type MassApplicationBaseCostsSectionNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostItems?: { __typename?: 'CatalogUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostData', id: any, sectionName: string }> | null } | null };

export type MassApplicationBaseCostsGroupNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput> | CatalogUerBaseCostDataSortInput>;
}>;


export type MassApplicationBaseCostsGroupNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostItems?: { __typename?: 'CatalogUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostData', id: any, groupName: string }> | null } | null };

export type MassApplicationBaseCostsCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput> | CatalogUerBaseCostDataSortInput>;
}>;


export type MassApplicationBaseCostsCodeFilterQuery = { __typename?: 'Query', catalogUERBaseCostItems?: { __typename?: 'CatalogUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostData', id: any, code: string }> | null } | null };

export type MassApplicationBaseCostsNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  ratioGroupIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput> | CatalogUerBaseCostDataSortInput>;
}>;


export type MassApplicationBaseCostsNameFilterQuery = { __typename?: 'Query', catalogUERBaseCostItems?: { __typename?: 'CatalogUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostData', id: any, name: string }> | null } | null };

export type CatalogTypesQueryVariables = Exact<{
  where?: InputMaybe<CatalogTypeDataFilterInput>;
  order?: InputMaybe<Array<CatalogTypeDataSortInput> | CatalogTypeDataSortInput>;
}>;


export type CatalogTypesQuery = { __typename?: 'Query', catalogTypes: Array<{ __typename?: 'CatalogTypeData', uniqueId: string, name: string, methodologies: Array<ProjectMethodologyEnum>, allowMultiple: boolean, canCreate: boolean }> };

export type CreateCatalogMutationVariables = Exact<{
  catalogInput: CatalogCreateInput;
}>;


export type CreateCatalogMutation = { __typename?: 'Mutation', createCatalog: { __typename?: 'ServiceDataResultOfCatalogData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CatalogData', uniqueId: string, type: { __typename?: 'CatalogTypeData', uniqueId: string } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUerBaseCostQueryVariables = Exact<{
  catalogUniqueId: Scalars['String'];
  uerBaseCostId: Scalars['Long'];
}>;


export type CatalogUerBaseCostQuery = { __typename?: 'Query', catalogUERBaseCost: { __typename?: 'ServiceDataResultOfCatalogUERBaseCostDetailedData', data?: { __typename?: 'CatalogUERBaseCostDetailedData', chapter?: ChapterEnum | null, code: string, version?: string | null, directCost?: any | null, emm?: any | null, eqp?: any | null, fot?: any | null, groupId: any, groupName: string, id: any, mtr?: any | null, name: string, nr?: any | null, ozp?: any | null, pir?: any | null, sectionId: any, sectionName: string, sp?: any | null, trn?: any | null, tz?: any | null, tm?: any | null, uerClassifier?: UerClassifierEnum | null, uniqueId: string, unit: string, unitCost: any, updatedAt?: any | null, zpm?: any | null, justification?: string | null, catalogUERBaseCostWorkScopes: Array<{ __typename?: 'CatalogUERBaseCostWorkScopeData', id: any, name: string, number: any }>, constructionTypes: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }>, ratios: Array<{ __typename?: 'CatalogRatioShortData', code: string, id: any, name: string, ratioType: RatioTypeEnum, catalogRatioGroupId?: any | null }>, ratioGroups: Array<{ __typename?: 'CatalogRatioGroupData', groupType?: DismantlingCoefficientTypeEnum | null, id: any, name: string, parentId?: any | null }>, workType: { __typename?: 'CatalogUERBaseWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null }, sections?: Array<{ __typename?: 'CatalogUERBaseCostEstimateBasisSectionData', id: any, order?: number | null, name: string, prices?: Array<{ __typename?: 'CatalogUERBaseCostEstimateBasisData', id: any, code: string, name: string, unit: string, estimateTotal: any, type: UerBasisPriceTypeEnum, hasConsumptionRateMtr?: boolean | null, quantity: { __typename?: 'CatalogUERBaseCostEstimateBasisQuantityData', unit: any, total: any, consumptionRateMtr?: any | null }, unitCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisUnitCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisTotalCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, nr?: any | null, sp?: any | null } | null, unitWorkCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisWorkCostData', tz?: any | null, tm?: any | null } | null, totalWorkCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisWorkCostData', tz?: any | null, tm?: any | null } | null, resources?: Array<{ __typename?: 'CatalogUERBaseCostEstimateBasisResourceData', id: any, code: string, name: string, unit: string, type: UerBasisResourceCostTypeEnum, isDeleted?: boolean | null, isNotCount?: boolean | null, quantity: { __typename?: 'CatalogUERBaseCostEstimateBasisResourceQuantityData', unit: any, total: any }, unitCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisResourceCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'CatalogUERBaseCostEstimateBasisResourceCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null }> | null }> | null }> | null } | null } };

export type CatalogParseUerBaseCostBasisQueryVariables = Exact<{
  content: FileInput;
}>;


export type CatalogParseUerBaseCostBasisQuery = { __typename?: 'Query', catalogParseUerBaseCostBasis: { __typename?: 'ServiceDataResultOfUerEstimateBaseCostData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'UerEstimateBaseCostData', version?: string | null, uerNacl?: any | null, uerPlan?: any | null, catFile?: string | null, workID?: string | null, baseCost: { __typename?: 'UerEstimateBaseCost', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, fot?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost: any, directCost?: any | null, tz?: any | null, tm?: any | null, sections: Array<{ __typename?: 'UerEstimateBaseCostSection', order?: number | null, name: string, prices: Array<{ __typename?: 'UerEstimateBaseCostPrice', code: string, name: string, unit: string, estimateTotal: any, type: UerBasisPriceTypeEnum, hasConsumptionRateMtr?: boolean | null, vr2001?: string | null, naclMask?: string | null, quantity: { __typename?: 'UerEstimateBaseCostPriceQuantity', unit: any, total: any, consumptionRateMtr?: any | null }, unitCost?: { __typename?: 'UerEstimateBaseCostPriceUnitCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'UerEstimateBaseCostPriceTotalCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, nr?: any | null, sp?: any | null } | null, unitWorkCost?: { __typename?: 'UerEstimateBaseCostPriceWorkCost', tz: any, tm: any } | null, totalWorkCost?: { __typename?: 'UerEstimateBaseCostPriceWorkCost', tz: any, tm: any } | null, resources: Array<{ __typename?: 'UerEstimateBaseCostResource', code: string, name: string, unit: string, type: UerBasisResourceCostTypeEnum, isDeleted?: boolean | null, isNotCount?: boolean | null, quantity: { __typename?: 'UerEstimateBaseCostResourceQuantity', unit: any, total: any }, unitCost?: { __typename?: 'UerEstimateBaseCostResourceCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'UerEstimateBaseCostResourceCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null }> }> }> }, general: { __typename?: 'UerEstimateCost', sectionName: string, groupName: string, code: string, name: string, chapter?: ChapterEnum | null, unit: string, workScopes: Array<{ __typename?: 'UerEstimateCostWorkScope', number: any, name: string }> }, workTypeItems?: Array<{ __typename?: 'UerEstimateWorkTypeItem', caption?: string | null, category?: string | null, nacl?: string | null, naclCurr?: string | null, naclMask?: string | null, plan?: string | null, planCurr?: string | null, planMask?: string | null, nrCode?: string | null, spCode?: string | null, workID: string, catFile: string }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogUerBaseCostConstructionTypesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  where?: InputMaybe<ConstructionTypeDataFilterInput>;
  order?: InputMaybe<Array<ConstructionTypeDataSortInput> | ConstructionTypeDataSortInput>;
}>;


export type CatalogUerBaseCostConstructionTypesQuery = { __typename?: 'Query', catalogUERBaseCostConstructionTypes?: { __typename?: 'CatalogUERBaseCostConstructionTypesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConstructionTypeData', contractFileName: string, catalogId: any, code: string, fullName: string, iconCode?: string | null, id: number, name: string, shortName: string, uniqueId?: string | null, updatedAt?: any | null, createdAt: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogCreateUerBaseCostMutationVariables = Exact<{
  costData: CreateCatalogUerBaseCostInput;
}>;


export type CatalogCreateUerBaseCostMutation = { __typename?: 'Mutation', catalogCreateUerBaseCost: { __typename?: 'ServiceDataResultOfCatalogUERBaseCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CatalogUERBaseCostData', chapter?: ChapterEnum | null, code: string, emm?: any | null, eqp?: any | null, groupId: any, groupName: string, id: any, mtr?: any | null, name: string, nr?: any | null, ozp?: any | null, pir?: any | null, sectionId: any, sectionName: string, sp?: any | null, trn?: any | null, uerClassifier?: UerClassifierEnum | null, uniqueId: string, unit: string, unitCost: any, updatedAt?: any | null, zpm?: any | null, catalogUERBaseCostWorkScopes: Array<{ __typename?: 'CatalogUERBaseCostWorkScopeData', id: any, name: string, number: any }>, constructionTypes: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }>, workType: { __typename?: 'CatalogUERBaseWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcCalculationLimitedCostsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type BimcCalculationLimitedCostsQuery = { __typename?: 'Query', bimcCalculationLimitedCosts?: { __typename?: 'BimcCalculationLimitedCostsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimcCalculationLimitedCostData', id: any, calculationId: any, rationale?: string | null, name: string, key?: string | null, chapter: ChapterEnum, calculatingValue: any, formula?: string | null, hasFormulaError: boolean, hasCalculatingParticipation: boolean, isEditable: boolean, isNorthernAllowance: boolean, isManualLimitsDistribution: boolean, globalLimitedCostId?: any | null, catalogLimitedCostTypeId?: number | null, seasonAmounts?: Array<{ __typename?: 'BimcCalculationLimitedCostLimitData', constructionTypeId: number, seasonId: any, cost: any }> | null }> | null } | null };

export type BimcCalculationLimitedCostNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type BimcCalculationLimitedCostNameFilterQuery = { __typename?: 'Query', bimcCalculationLimitedCostNameFilter?: { __typename?: 'BimcCalculationLimitedCostNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcRemoveCalculationLimitedCostsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  ids: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimcRemoveCalculationLimitedCostsMutation = { __typename?: 'Mutation', bimcRemoveCalculationLimitedCosts: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimcGlobalLimitedCostsForCalculationQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalLimitedCostDataSortInput> | GlobalLimitedCostDataSortInput>;
  where?: InputMaybe<GlobalLimitedCostDataFilterInput>;
}>;


export type BimcGlobalLimitedCostsForCalculationQuery = { __typename?: 'Query', bimcGlobalLimitedCostsForCalculation?: { __typename?: 'BimcGlobalLimitedCostsForCalculationCollectionSegment', items?: Array<{ __typename?: 'GlobalLimitedCostData', id: any, name: string, methodology: ProjectMethodologyEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, hasCalculatingParticipation: boolean, isSystem: boolean, catalogLimitedCostType?: { __typename?: 'CatalogLimitedCostTypeData', name: string, id: number, uniqueId: string } | null }> | null } | null };

export type BimcCalculationLimitedCostTypesQueryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<CatalogLimitedCostTypeDataFilterInput>;
  order?: InputMaybe<Array<CatalogLimitedCostTypeDataSortInput> | CatalogLimitedCostTypeDataSortInput>;
}>;


export type BimcCalculationLimitedCostTypesQueryQuery = { __typename?: 'Query', bimcCalculationLimitedCostTypes?: { __typename?: 'BimcCalculationLimitedCostTypesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'CatalogLimitedCostTypeData', id: number, uniqueId: string, name: string }> | null } | null };

export type BimcIsCalculationLimitedCostCodeUniqueQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  key: Scalars['String'];
}>;


export type BimcIsCalculationLimitedCostCodeUniqueQuery = { __typename?: 'Query', bimcIsCalculationLimitedCostCodeUnique: { __typename?: 'ServiceIdResultOfBoolean', result: boolean, isUnique?: boolean | null } };

export type BimcIsCalculationLimitedCostNameUniqueQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type BimcIsCalculationLimitedCostNameUniqueQuery = { __typename?: 'Query', bimcIsCalculationLimitedCostNameUnique: { __typename?: 'ServiceIdResultOfBoolean', result: boolean, isUnique?: boolean | null } };

export type BimcCreateCalculationLimitedCostMutationVariables = Exact<{
  input: BimcCalculationLimitedCostInput;
}>;


export type BimcCreateCalculationLimitedCostMutation = { __typename?: 'Mutation', bimcCreateCalculationLimitedCost: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimcUpdateCalculationLimitedCostMutationVariables = Exact<{
  id: Scalars['Long'];
  input: BimcCalculationLimitedCostInput;
}>;


export type BimcUpdateCalculationLimitedCostMutation = { __typename?: 'Mutation', bimcUpdateCalculationLimitedCost: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimcCalculationLimitedCostForUpdateQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostId: Scalars['Long'];
}>;


export type BimcCalculationLimitedCostForUpdateQuery = { __typename?: 'Query', bimcCalculationLimitedCostForUpdate: { __typename?: 'ServiceDataResultOfBimcCalculationLimitedCostUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'BimcCalculationLimitedCostUpdateData', id: any, uniqueId: string, calculationId: any, catalogLimitedCostTypeId?: number | null, globalLimitedCostId?: any | null, chapter: ChapterEnum, formula?: string | null, hasCalculatingParticipation: boolean, isEditable: boolean, isNorthernAllowance: boolean, isManualLimitsDistribution: boolean, key?: string | null, name: string, rationale?: string | null, catalogLimitedCostType?: { __typename?: 'CatalogLimitedCostTypeData', id: number, name: string, uniqueId: string } | null, groupConstructionLimits?: Array<{ __typename?: 'BimcCalculationLimitedCostConstructionTypeData', constructionTypeId: number, calculatingValue: any }> | null, limits?: Array<{ __typename?: 'BimcCalculationLimitedCostLimitData', constructionTypeId: number, seasonId: any, cost: any }> | null, file?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcLocalEstimatesTableQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  priceLevel: BimcPriceLevelEnum;
  where?: InputMaybe<LocalEstimateTableItemDataFilterInput>;
}>;


export type BimcLocalEstimatesTableQuery = { __typename?: 'Query', bimcLocalEstimatesTable?: { __typename?: 'BimcLocalEstimatesTableCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'LocalEstimateTableItemData', entityType: LocalEstimateRowTypeEnum, localEstimateId?: any | null, localEstimateType: BimcLocalEstimateTypeEnum, chapter?: string | null, code?: string | null, emm?: any | null, hasGuaranteedVolume: boolean, hasRemovedLsrs?: boolean | null, inPercentOtherAndLimit: boolean, isUpdatedPrice: boolean, mp?: any | null, mtr?: any | null, mz?: any | null, name?: string | null, nr?: any | null, objectId?: any | null, objectName?: string | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzm?: any | null, tzr?: any | null, unit?: string | null, zpm?: any | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimcLocalEstimateCompositionQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  localEstimateId: Scalars['Long'];
  priceLevel: BimcPriceLevelEnum;
  where?: InputMaybe<LocalEstimateCompositionRowDataFilterInput>;
  order?: InputMaybe<Array<LocalEstimateCompositionRowDataSortInput> | LocalEstimateCompositionRowDataSortInput>;
}>;


export type BimcLocalEstimateCompositionQuery = { __typename?: 'Query', bimcLocalEstimateComposition?: { __typename?: 'BimcLocalEstimateCompositionCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'LocalEstimateCompositionRowData', id: any, sectionId?: any | null, sectionName?: string | null, srcOrder: number, type: string, ratios: Array<{ __typename?: 'LocalEstimateRatioData', code: string, em?: any | null, id: any, mt?: any | null, name: string, oz?: any | null, pz?: any | null, rowId: any, srcOrder: number, tz?: any | null, tzm?: any | null, zm?: any | null }>, value: { __typename?: 'LocalEstimateCompositionValueData', code?: string | null, emm?: any | null, mp?: any | null, mtr?: any | null, mz?: any | null, name?: string | null, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzm?: any | null, tzr?: any | null, unit?: string | null, unitCost?: any | null, zpm?: any | null } }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimcLocalEstimateCompositionCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  localEstimateId: Scalars['Long'];
}>;


export type BimcLocalEstimateCompositionCodeFilterQuery = { __typename?: 'Query', bimcLocalEstimateCompositionCodeFilter?: { __typename?: 'BimcLocalEstimateCompositionCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcLocalEstimateCompositionNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  localEstimateId: Scalars['Long'];
}>;


export type BimcLocalEstimateCompositionNameFilterQuery = { __typename?: 'Query', bimcLocalEstimateCompositionNameFilter?: { __typename?: 'BimcLocalEstimateCompositionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcLoadLocalEstimatesMutationVariables = Exact<{
  input: LocalEstimateImportMutationInput;
}>;


export type BimcLoadLocalEstimatesMutation = { __typename?: 'Mutation', bimcLoadLocalEstimates: { __typename?: 'ServiceDataResultOfListOfLocalEstimateImportItemData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: Array<{ __typename?: 'LocalEstimateImportItemData', code?: string | null, fileName: string, localEstimateId?: any | null, name?: string | null } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcLocalEstimateEditDataQueryVariables = Exact<{
  localEstimateId: Scalars['Long'];
}>;


export type BimcLocalEstimateEditDataQuery = { __typename?: 'Query', bimcLocalEstimateEditData: { __typename?: 'ServiceDataResultOfLocalEstimateEditData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'LocalEstimateEditData', chapter?: string | null, code: string, id: any, inPercentOtherAndLimit: boolean, objectId?: any | null, objectName?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcUpdateLocalEstimateMutationVariables = Exact<{
  localEstimateId: Scalars['Long'];
  inPercentOtherAndLimit: Scalars['Boolean'];
}>;


export type BimcUpdateLocalEstimateMutation = { __typename?: 'Mutation', bimcUpdateLocalEstimate: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcRedistributeLocalEstimateMtrMutationVariables = Exact<{
  localEstimateId: Scalars['Long'];
  input: LocalEstimateMtrDistributionInput;
}>;


export type BimcRedistributeLocalEstimateMtrMutation = { __typename?: 'Mutation', bimcRedistributeLocalEstimateMtr: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, id?: any | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcLocalEstimateTableCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type BimcLocalEstimateTableCodeFilterQuery = { __typename?: 'Query', bimcLocalEstimateTableCodeFilter?: { __typename?: 'BimcLocalEstimateTableCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcLocalEstimateTableNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type BimcLocalEstimateTableNameFilterQuery = { __typename?: 'Query', bimcLocalEstimateTableNameFilter?: { __typename?: 'BimcLocalEstimateTableNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcLocalEstimateTableObjectFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type BimcLocalEstimateTableObjectFilterQuery = { __typename?: 'Query', bimcLocalEstimateTableObjectFilter?: { __typename?: 'BimcLocalEstimateTableObjectFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcAggregateEstimateLsrSelectionQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  objectId: Scalars['Long'];
  chapter: Scalars['String'];
  priceLevel: BimcPriceLevelEnum;
}>;


export type BimcAggregateEstimateLsrSelectionQuery = { __typename?: 'Query', bimcAggregateEstimateLsrSelection: Array<{ __typename?: 'LocalEstimateTableItemData', chapter?: string | null, code?: string | null, emm?: any | null, entityType: LocalEstimateRowTypeEnum, hasGuaranteedVolume: boolean, inPercentOtherAndLimit: boolean, isUpdatedPrice: boolean, localEstimateId?: any | null, localEstimateType: BimcLocalEstimateTypeEnum, mp?: any | null, mtr?: any | null, mz?: any | null, name?: string | null, nr?: any | null, objectId?: any | null, objectName?: string | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, subObjectName?: string | null, total?: any | null, tzm?: any | null, tzr?: any | null, unit?: string | null, zpm?: any | null }> };

export type BimcCreateAggregateEstimateMutationVariables = Exact<{
  input: CreateAggregateEstimateInput;
}>;


export type BimcCreateAggregateEstimateMutation = { __typename?: 'Mutation', bimcCreateAggregateEstimate: { __typename?: 'ServiceDataResultOfAggregateLocalEstimateCreateUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcAggregateEstimateQueryVariables = Exact<{
  aggregateLocalEstimateId: Scalars['Long'];
}>;


export type BimcAggregateEstimateQuery = { __typename?: 'Query', bimcAggregateEstimate: { __typename?: 'ServiceDataResultOfAggregateLocalEstimateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null, data?: { __typename?: 'AggregateLocalEstimateData', id: any, calculationObjectId?: any | null, rootObjectId: any, chapter: string, valueCode: string, valueName: string, valueUnit: string, valueQuantityNow?: any | null, valueQuantityTarget?: any | null, coefficient?: any | null, inPercentOtherAndLimit: boolean, lsrs: Array<{ __typename?: 'AggregateLocalEstimateLsrData', id: any, number: number }> } | null } };

export type BimcUpdateAggregateEstimateMutationVariables = Exact<{
  input: UpdateAggregateEstimateInput;
}>;


export type BimcUpdateAggregateEstimateMutation = { __typename?: 'Mutation', bimcUpdateAggregateEstimate: { __typename?: 'ServiceDataResultOfAggregateLocalEstimateCreateUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcAggregateEstimateCompositionQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  aggregateLocalEstimateId: Scalars['Long'];
  priceLevel: BimcPriceLevelEnum;
  where?: InputMaybe<LocalEstimateTableItemDataFilterInput>;
}>;


export type BimcAggregateEstimateCompositionQuery = { __typename?: 'Query', bimcAggregateEstimateComposition?: { __typename?: 'BimcAggregateEstimateCompositionCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'LocalEstimateTableItemData', entityType: LocalEstimateRowTypeEnum, localEstimateId?: any | null, localEstimateType: BimcLocalEstimateTypeEnum, objectId?: any | null, objectName?: string | null, subObjectName?: string | null, chapter?: string | null, code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, mtr?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null, tzm?: any | null, inPercentOtherAndLimit: boolean, isUpdatedPrice: boolean, hasGuaranteedVolume: boolean }> | null } | null };

export type BimcAggregateEstimateCompositionCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  aggregateLocalEstimateId: Scalars['Long'];
}>;


export type BimcAggregateEstimateCompositionCodeFilterQuery = { __typename?: 'Query', bimcAggregateEstimateCompositionCodeFilter?: { __typename?: 'BimcAggregateEstimateCompositionCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcAggregateEstimateCompositionNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  aggregateLocalEstimateId: Scalars['Long'];
}>;


export type BimcAggregateEstimateCompositionNameFilterQuery = { __typename?: 'Query', bimcAggregateEstimateCompositionNameFilter?: { __typename?: 'BimcAggregateEstimateCompositionNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcAggregateEstimateCompositionObjectFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  aggregateLocalEstimateId: Scalars['Long'];
}>;


export type BimcAggregateEstimateCompositionObjectFilterQuery = { __typename?: 'Query', bimcAggregateEstimateCompositionObjectFilter?: { __typename?: 'BimcAggregateEstimateCompositionObjectFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcAggregateEstimateCompositionSubObjectFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  aggregateLocalEstimateId: Scalars['Long'];
}>;


export type BimcAggregateEstimateCompositionSubObjectFilterQuery = { __typename?: 'Query', bimcAggregateEstimateCompositionSubObjectFilter?: { __typename?: 'BimcAggregateEstimateCompositionSubObjectFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcRemoveLocalEstimatesMutationVariables = Exact<{
  input: LocalEstimateRemoveMutationInput;
}>;


export type BimcRemoveLocalEstimatesMutation = { __typename?: 'Mutation', bimcRemoveLocalEstimates: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null, source?: string | null }> | null } };

export type BimcGlobalOtherCostsForCalculationQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput> | GlobalOtherCostDataSortInput>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
}>;


export type BimcGlobalOtherCostsForCalculationQuery = { __typename?: 'Query', bimcGlobalOtherCostsForCalculation?: { __typename?: 'BimcGlobalOtherCostsForCalculationCollectionSegment', items?: Array<{ __typename?: 'GlobalOtherCostData', id: any, name: string, methodology: ProjectMethodologyEnum, calculatingType: OtherCostCalculationTypeEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, isSystem: boolean, otherCostType: { __typename?: 'CatalogOtherCostTypeBase', name: string, id: number, uniqueId: string } }> | null } | null };

export type BimcCreateCalculationOtherCostMutationVariables = Exact<{
  input: BimcCalculationOtherCostInput;
}>;


export type BimcCreateCalculationOtherCostMutation = { __typename?: 'Mutation', bimcCreateCalculationOtherCost: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimcUpdateCalculationOtherCostMutationVariables = Exact<{
  id: Scalars['Long'];
  input: BimcCalculationOtherCostInput;
}>;


export type BimcUpdateCalculationOtherCostMutation = { __typename?: 'Mutation', bimcUpdateCalculationOtherCost: { __typename?: 'ServiceDataResultOfBimcCalculationOtherCostUpdateData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, data?: { __typename?: 'BimcCalculationOtherCostUpdateData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimcCalculationOtherCostForUpdateQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  otherCostId: Scalars['Long'];
}>;


export type BimcCalculationOtherCostForUpdateQuery = { __typename?: 'Query', bimcCalculationOtherCostForUpdate: { __typename?: 'ServiceDataResultOfBimcCalculationOtherCostUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'BimcCalculationOtherCostUpdateData', calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, calculationId: any, catalogOtherCostTypeId: number, chapter?: ChapterEnum | null, formula?: string | null, globalOtherCostId?: any | null, hasEmptyFormula?: boolean | null, hasEmptyOtherCostType?: boolean | null, id: any, isEditable?: boolean | null, key?: string | null, name: string, section?: SectionEnum | null, uniqueId: string, hasCalculatingParticipation: boolean, isLimitsTotalFromFile: boolean, isManualLimitsDistribution: boolean, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, name: string, uniqueId: string } | null, groupConstructionLimits?: Array<{ __typename?: 'BimcCalculationOtherCostConstructionTypeData', constructionTypeId: number, distributionMethod?: Uerc_LimitDistributionMethodEnum | null, totalCostLimit?: any | null }> | null, file?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, limits?: Array<{ __typename?: 'BimcCalculationOtherCostLimitData', constructionTypeId: number, cost: any, seasonId: any }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcCalculationOtherCostTypesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  otherCostId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput> | CatalogOtherCostTypeDataSortInput>;
}>;


export type BimcCalculationOtherCostTypesQuery = { __typename?: 'Query', bimcCalculationOtherCostTypes?: { __typename?: 'BimcCalculationOtherCostTypesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, isSystem: boolean, id: number, uniqueId: string, name: string }> | null } | null };

export type BimcCalculationOtherCostsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<BimcCalculationOtherCostDataFilterInput>;
  order?: InputMaybe<Array<BimcCalculationOtherCostDataSortInput> | BimcCalculationOtherCostDataSortInput>;
}>;


export type BimcCalculationOtherCostsQuery = { __typename?: 'Query', bimcCalculationOtherCosts?: { __typename?: 'BimcCalculationOtherCostsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimcCalculationOtherCostData', id: any, calculationId: any, globalOtherCostId?: any | null, name: string, key?: string | null, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, isEditable?: boolean | null, isManualLimitsDistribution: boolean, hasFormulaError: boolean, total: any, createdAt: any, seasonAmounts?: Array<{ __typename?: 'BimcCalculationOtherCostLimitData', constructionTypeId: number, seasonId: any, cost: any }> | null }> | null } | null };

export type BimcRemoveCalculationOtherCostsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  ids: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimcRemoveCalculationOtherCostsMutation = { __typename?: 'Mutation', bimcRemoveCalculationOtherCosts: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimcCalculationOtherCostNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type BimcCalculationOtherCostNameFilterQuery = { __typename?: 'Query', bimcCalculationOtherCostNameFilter?: { __typename?: 'BimcCalculationOtherCostNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimcCatalogOtherCostTemplateFilesQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type BimcCatalogOtherCostTemplateFilesQuery = { __typename?: 'Query', catalogUEROtherCostTemplateFiles: { __typename?: 'ServiceDataResultOfFileContent', buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } };

export type IsBimcCalculationOtherCostCodeUniqueQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  otherCostId?: InputMaybe<Scalars['Long']>;
  key: Scalars['String'];
}>;


export type IsBimcCalculationOtherCostCodeUniqueQuery = { __typename?: 'Query', bimcIsCalculationOtherCostCodeUnique: { __typename?: 'ServiceIdResultOfBoolean', result: boolean, isUnique?: boolean | null } };

export type BimcExtractTotalSumQueryVariables = Exact<{
  input: FileInput;
}>;


export type BimcExtractTotalSumQuery = { __typename?: 'Query', bimcExtractTotalSum: { __typename?: 'ServiceDataResultOfCalculationOtherCostTotalSum', result: boolean, message?: string | null, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null, data?: { __typename?: 'CalculationOtherCostTotalSum', sum: any } | null } };

export type BimcCalculationDefaultsQueryVariables = Exact<{
  projectUniqueId: Scalars['String'];
}>;


export type BimcCalculationDefaultsQuery = { __typename?: 'Query', bimcCalculationDefaults: { __typename?: 'ServiceDataResultOfBimcCalculationDefaultData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimcCalculationDefaultData', authoredBy: string, contractType: ContractTypeEnum, customer: string, costRounding: number, supplyBasis?: string | null, taxPercent: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcCalculationQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type BimcCalculationQuery = { __typename?: 'Query', bimcCalculation: { __typename?: 'ServiceDataResultOfBimcCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimcCalculationData', authoredBy: string, changeDate?: any | null, contractType: ContractTypeEnum, createdAt: any, customer: string, customerAddress?: string | null, id: any, lastComputedAt?: any | null, nmcWithNmdc: any, nmcWithoutNmdc: any, nmdc: any, taxPercent?: any | null, note?: string | null, projectUniqueId: string, costRounding: number, startDate?: any | null, status: CalculationStatusEnum, subject: string, supplyBasis: string, uniqueId: string, constructionTypes: Array<{ __typename?: 'BimcCalculationConstructionTypeData', id: any, name: string, coefficients?: { __typename?: 'BimConversionCoefficientsData', kozp?: any | null, kemm?: any | null, kzpm?: any | null, kmtr?: any | null, keqp?: any | null, kmz?: any | null, koz?: any | null, knr?: any | null, ksp?: any | null, kpir?: any | null } | null, constructionType?: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } | null }>, seasons: Array<{ __typename?: 'BimcCalculationSeasonData', inflation: any, id: any, isActive: boolean, year: number }>, seasonsInflation: Array<{ __typename?: 'BimcCalculationSeasonInflationData', inflation: any, year: number }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcCalculationSeasonsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type BimcCalculationSeasonsQuery = { __typename?: 'Query', bimcCalculationSeasons: Array<{ __typename?: 'BimcCalculationSeasonData', id: any, year: number, inflation: any, isActive: boolean }> };

export type BimcCreateCalculationMutationVariables = Exact<{
  input: BimcCalculationCreateInput;
}>;


export type BimcCreateCalculationMutation = { __typename?: 'Mutation', bimcCreateCalculation: { __typename?: 'ServiceDataResultOfBimcCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimcCalculationData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcUpdateCalculationMutationVariables = Exact<{
  calculationInput: BimcCalculationUpdateInput;
}>;


export type BimcUpdateCalculationMutation = { __typename?: 'Mutation', bimcUpdateCalculation: { __typename?: 'ServiceDataResultOfBimcCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimcCalculationData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcCalculationObjectsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Long']>;
}>;


export type BimcCalculationObjectsQuery = { __typename?: 'Query', bimcCalculationObjects: Array<{ __typename?: 'BimcCalculationObjectData', calculationId: any, hasGuaranteedVolume: boolean, id: any, name: string, order: number, parentId?: any | null, codeWBS?: string | null, constructionTypeId: number, rootObjectId: any, seasons: Array<{ __typename?: 'CalculationObjectSeasonData', calculationSeasonId: any, id: any, percent: any, year: number }> }> };

export type BimcCreateCalculationObjectMutationVariables = Exact<{
  input: BimcCalculationObjectCreateInput;
}>;


export type BimcCreateCalculationObjectMutation = { __typename?: 'Mutation', bimcCreateCalculationObject: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean } };

export type BimcCreateCalculationSubObjectMutationVariables = Exact<{
  input: BimcCalculationSubObjectCreateInput;
}>;


export type BimcCreateCalculationSubObjectMutation = { __typename?: 'Mutation', bimcCreateCalculationSubObject: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean } };

export type BimcUpdateCalculationObjectMutationVariables = Exact<{
  input: BimcCalculationObjectUpdateInput;
}>;


export type BimcUpdateCalculationObjectMutation = { __typename?: 'Mutation', bimcUpdateCalculationObject: { __typename?: 'ServiceResult', result: boolean } };

export type BimcUpdateSeasonDistributionMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  items: Array<CalculationObjectSeasonDistributionInput> | CalculationObjectSeasonDistributionInput;
}>;


export type BimcUpdateSeasonDistributionMutation = { __typename?: 'Mutation', bimcUpdateSeasonDistribution: boolean };

export type BimcRemoveCalculationObjectMutationVariables = Exact<{
  objectId: Scalars['Long'];
}>;


export type BimcRemoveCalculationObjectMutation = { __typename?: 'Mutation', bimcRemoveCalculationObject: { __typename?: 'ServiceResult', result: boolean } };

export type BimcIsUniqueCalculationObjectNameQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  name: Scalars['String'];
  excludeObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimcIsUniqueCalculationObjectNameQuery = { __typename?: 'Query', bimcIsUniqueCalculationObjectName: boolean };

export type BimcIsUniqueCalculationSubObjectNameQueryVariables = Exact<{
  calculationObjectId: Scalars['Long'];
  name: Scalars['String'];
  excludeObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimcIsUniqueCalculationSubObjectNameQuery = { __typename?: 'Query', bimcIsUniqueCalculationSubObjectName: boolean };

export type BimcIsUniqueCalculationObjectCodeQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  code: Scalars['String'];
  excludeObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimcIsUniqueCalculationObjectCodeQuery = { __typename?: 'Query', bimcIsUniqueCalculationObjectCode: boolean };

export type BimcSetCalculationObjectGuaranteedVolumeMutationVariables = Exact<{
  input: CalculationObjectGuaranteedVolumeInput;
}>;


export type BimcSetCalculationObjectGuaranteedVolumeMutation = { __typename?: 'Mutation', bimcSetCalculationObjectGuaranteedVolume: boolean };

export type BimcImportCalculationStructureMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type BimcImportCalculationStructureMutation = { __typename?: 'Mutation', bimcImportCalculationStructure: { __typename?: 'ServiceDataResultOfCountData', buttonText?: string | null, code?: string | null, message?: string | null, result: boolean, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimcMoveCalculationObjectMutationVariables = Exact<{
  input: CalculationObjectMoveInput;
}>;


export type BimcMoveCalculationObjectMutation = { __typename?: 'Mutation', bimcMoveCalculationObject: boolean };

export type BimContractQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type BimContractQuery = { __typename?: 'Query', bimContract: { __typename?: 'ServiceDataResultOfBimContractData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractData', hasNoPlanByConstructionType?: boolean | null, authoredBy: string, contractType: ProjectContractTypeEnum, createdAt: any, id: any, projectUniqueId: string, status: BimContractStatusEnum, supplyBasis: string, uniqueId: string, limitedCostCalcMethod: BimLimitedCostCalcMethodEnum, hasObjectStructure: boolean, statusFollowers: Array<BimContractStatusEnum>, hasFilledAddresses: boolean, constructionTypes: Array<{ __typename?: 'BimContractConstructionTypeData', id: number, code: string, name: string, shortName: string, usedInObjectStructure: boolean }>, conversionIndices: Array<{ __typename?: 'BimContractConversionIndexData', id: any, coefficients: { __typename?: 'ConversionCoefficientsData', kozp?: any | null, kemm?: any | null, kmtr?: any | null, keqp?: any | null, knr?: any | null, ksp?: any | null, kpir?: any | null, kzpm?: any | null, kmz?: any | null, koz?: any | null }, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, generalInfo: { __typename?: 'BimContractGeneralData', amountWithTax?: any | null, amountWithoutTax?: any | null, contractor: string, contractorAddress?: string | null, contractorOKPO?: string | null, customer: string, customerAddress?: string | null, customerOKPO?: string | null, finishDate?: any | null, internalNumber: string, name?: string | null, note?: string | null, okpd?: string | null, okud?: string | null, signingDate?: any | null, startDate?: any | null, subject: string, tax?: any | null }, limitedCosts: Array<{ __typename?: 'BimContractLimitedCostData', id: any, regionalFactor?: any | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, items: Array<{ __typename?: 'BimContractLimitedCostItemData', id: any, rateValue: any, type: BimLimitedCostTypeEnum, fotValue?: any | null }> }>, otherDistributions: Array<{ __typename?: 'BimContractSeasonDistributionData', id: any, seasonValue?: any | null, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }>, plan: { __typename?: 'BimContractPlanData', chapter12?: any | null, chapter1_7?: any | null, chapter8?: any | null, chapter9?: any | null, equipmentContractor?: any | null, equipmentCustomer?: any | null, materialContractor?: any | null, materialCustomer?: any | null, northernAllowance?: any | null }, seasons: Array<{ __typename?: 'BimContractSeasonData', id: any, year: any }>, seasonsInflation: Array<{ __typename?: 'BimContractSeasonInflationData', id: any, inflationRate: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }>, smrDistributions: Array<{ __typename?: 'BimContractSeasonDistributionData', id: any, seasonValue?: any | null, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }>, resultPlan: Array<{ __typename?: 'BimContractResultPlanData', name: string, totalType?: BimTotal_AlcTypeEnum | null, isHeadLine: boolean, isEditable: boolean, contractPlan?: any | null, hasSeason: boolean, contractSeasonYear?: any | null, isLimitPrice: boolean, constructionTypePlanResults?: Array<{ __typename?: 'BimContractConstructionTypeResultData', constructionTypeId: number, contractPlan?: any | null }> | null }>, cost: { __typename?: 'ContractCostData', contractPlan?: any | null, contractPlanReminderPercent?: any | null, contractPlanReminderWithTax?: any | null, contractPlanTax?: any | null, contractPlanWithTax?: any | null, deviationTip?: DeviationTipEnum | null, workOrdersPlanCost?: any | null, workOrdersPlanCostWithTax?: any | null } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractDefaultsQueryVariables = Exact<{
  projectUniqueId: Scalars['String'];
}>;


export type BimContractDefaultsQuery = { __typename?: 'Query', bimContractDefaults: { __typename?: 'ServiceDataResultOfBimContractDefaultData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractDefaultData', status: BimContractStatusEnum, contractType: ProjectContractTypeEnum, customer: string, authoredBy: string, resultPlan: Array<{ __typename?: 'BimContractResultPlanData', name: string, totalType?: BimTotal_AlcTypeEnum | null, isHeadLine: boolean, isEditable: boolean, contractPlan?: any | null, hasSeason: boolean, contractSeasonYear?: any | null, isLimitPrice: boolean, constructionTypePlanResults?: Array<{ __typename?: 'BimContractConstructionTypeResultData', constructionTypeId: number, contractPlan?: any | null }> | null }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateContractMutationVariables = Exact<{
  contractInput: BimContractCreateInput;
}>;


export type BimCreateContractMutation = { __typename?: 'Mutation', bimCreateContract: { __typename?: 'ServiceDataResultOfBimContractData', message?: string | null, result: boolean, code?: string | null, data?: { __typename?: 'BimContractData', id: any, uniqueId: string, projectUniqueId: string, status: BimContractStatusEnum, contractType: ProjectContractTypeEnum, createdAt: any, authoredBy: string, constructionTypes: Array<{ __typename?: 'BimContractConstructionTypeData', id: number, name: string }>, seasons: Array<{ __typename?: 'BimContractSeasonData', id: any, year: any }>, generalInfo: { __typename?: 'BimContractGeneralData', internalNumber: string, subject: string, customer: string, contractor: string }, conversionIndices: Array<{ __typename?: 'BimContractConversionIndexData', id: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, name: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, coefficients: { __typename?: 'ConversionCoefficientsData', kozp?: any | null, kemm?: any | null, kmz?: any | null, koz?: any | null } }>, seasonsInflation: Array<{ __typename?: 'BimContractSeasonInflationData', id: any, inflationRate: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }>, limitedCosts: Array<{ __typename?: 'BimContractLimitedCostData', id: any, regionalFactor?: any | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, name: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, items: Array<{ __typename?: 'BimContractLimitedCostItemData', type: BimLimitedCostTypeEnum, rateValue: any }> }>, plan: { __typename?: 'BimContractPlanData', chapter1_7?: any | null, chapter9?: any | null, equipmentCustomer?: any | null }, smrDistributions: Array<{ __typename?: 'BimContractSeasonDistributionData', id: any, seasonValue?: any | null, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }>, otherDistributions: Array<{ __typename?: 'BimContractSeasonDistributionData', id: any, seasonValue?: any | null, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateContractMutationVariables = Exact<{
  contractInput: BimContractUpdateInput;
}>;


export type BimUpdateContractMutation = { __typename?: 'Mutation', bimUpdateContract: { __typename?: 'ServiceDataResultOfBimContractData', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'BimContractData', id: any } | null } };

export type BimIsUniqueContractInternalNumberQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Long']>;
  internalNumber: Scalars['String'];
}>;


export type BimIsUniqueContractInternalNumberQuery = { __typename?: 'Query', bimIsUniqueContractInternalNumber: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimFrameContractResultsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type BimFrameContractResultsQuery = { __typename?: 'Query', bimFrameContractResults: { __typename?: 'ServiceDataResultOfBimContractResultsViewData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractResultsViewData', workOrders?: Array<{ __typename?: 'BimWorkOrderNavData', signingDate?: any | null, internalNumber: string, status: WorkOrderStatusEnum, navLinkId: string, name: string, metadata?: string | null, id?: any | null, actKC2Navs?: Array<{ __typename?: 'ActKC2NavData', id: any, date?: any | null, number?: any | null, status: ActKc2StatusEnum, costGroup: CostGroupEnum, season: { __typename?: 'ContractSeasonNav', id: any, year: any } }> | null, actKC3Navs?: Array<{ __typename?: 'ActKC3NavData', id: any, number?: any | null, date?: any | null, actsKC2?: Array<{ __typename?: 'ActKC2NavData', id: any, date?: any | null, number?: any | null, status: ActKc2StatusEnum, costGroup: CostGroupEnum, season: { __typename?: 'ContractSeasonNav', id: any, year: any } }> | null }> | null, workOrderChanges?: Array<{ __typename?: 'BimWorkOrderChangeNavData', id?: any | null, signingDate?: any | null, workOrderNumber: string, workOrderChangeNumber: string, status: WorkOrderChangeStatusEnum }> | null, workOrderChange?: { __typename?: 'BimWorkOrderChangeNavData', id?: any | null, signingDate?: any | null, workOrderNumber: string, workOrderChangeNumber: string, status: WorkOrderChangeStatusEnum } | null }> | null, contractResults?: Array<{ __typename?: 'BimContractResultData', workOrderPlanSum?: any | null, name: string, isHeadLine: boolean, contractPlan?: any | null, contractRemainder?: any | null, deviation?: DeviationEnum | null, deviationTip?: DeviationTipEnum | null, totalType?: BimTotal_AlcTypeEnum | null, completed?: any | null, completedDeviation?: DeviationEnum | null, completedRemainder?: any | null, completedRemainderDeviationTip?: DeviationTipEnum | null, workOrderResults: Array<{ __typename?: 'BimContractWorkOrderResultData', workOrderId: any, planPrice?: any | null, completedPrice?: any | null, deviation?: DeviationEnum | null, constructionTypeResults: Array<{ __typename?: 'BimWorkOrderConstructionTypeResultData', constructionTypeId: number, completedPrice?: any | null, planPrice?: any | null }> }>, constructionTypePlanResults?: Array<{ __typename?: 'BimContractConstructionTypeResultData', constructionTypeId: number, contractPlan?: any | null }> | null }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimNormalContractResultsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type BimNormalContractResultsQuery = { __typename?: 'Query', bimNormalContractResults: { __typename?: 'ServiceDataResultOfBimNormalContractResultData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'BimNormalContractResultData', actKC2CompletedSum?: any | null, name: string, isHeadLine: boolean, contractPlan?: any | null, contractRemainder?: any | null, deviation?: DeviationEnum | null, deviationTip?: DeviationTipEnum | null, totalType?: BimTotal_AlcTypeEnum | null, constructionTypeCompletedResult: Array<{ __typename?: 'BimConstructionTypeCompletedResultData', deviation?: DeviationEnum | null, completedPrice?: any | null, constructionTypeId: number }>, constructionTypePlanResults?: Array<{ __typename?: 'BimContractConstructionTypeResultData', constructionTypeId: number, contractPlan?: any | null }> | null } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractObjectsQueryVariables = Exact<{
  contractId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimContractObjectDataFilterInput>;
  order?: InputMaybe<Array<BimContractObjectDataSortInput> | BimContractObjectDataSortInput>;
}>;


export type BimContractObjectsQuery = { __typename?: 'Query', bimContractObjects: Array<{ __typename?: 'BimContractObjectData', id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, order: number, canSetGuaranteedVolume: boolean, parentBasedOrder: number, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, shortName: string, name: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }> };

export type BimImportContractObjectsMutationVariables = Exact<{
  contractId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type BimImportContractObjectsMutation = { __typename?: 'Mutation', bimImportContractObjects: { __typename?: 'ServiceDataResultOfBimContractData', result: boolean, message?: string | null, buttonText?: string | null, code?: string | null, data?: { __typename?: 'BimContractData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateContractObjectMutationVariables = Exact<{
  contractObjectInput: BimContractObjectCreateInput;
}>;


export type BimCreateContractObjectMutation = { __typename?: 'Mutation', bimCreateContractObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimContractObjectData', canSetGuaranteedVolume: boolean, contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, order: number, parentBasedOrder: number, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateContractObjectMutationVariables = Exact<{
  contractObjectInput: BimContractObjectUpdateInput;
}>;


export type BimUpdateContractObjectMutation = { __typename?: 'Mutation', bimUpdateContractObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimContractObjectData', canSetGuaranteedVolume: boolean, contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, order: number, parentBasedOrder: number, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateContractSubObjectMutationVariables = Exact<{
  contractObjectInput: BimContractSubObjectCreateInput;
}>;


export type BimCreateContractSubObjectMutation = { __typename?: 'Mutation', bimCreateContractSubObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimContractObjectData', canSetGuaranteedVolume: boolean, contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, order: number, parentBasedOrder: number, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateContractSubObjectMutationVariables = Exact<{
  contractObjectInput: BimContractSubObjectUpdateInput;
}>;


export type BimUpdateContractSubObjectMutation = { __typename?: 'Mutation', bimUpdateContractSubObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimContractObjectData', canSetGuaranteedVolume: boolean, contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, order: number, parentBasedOrder: number, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimIsUniqueContractObjectNameQueryVariables = Exact<{
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  name: Scalars['String'];
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimIsUniqueContractObjectNameQuery = { __typename?: 'Query', bimIsUniqueContractObjectName: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimIsUniqueContractSubObjectNameQueryVariables = Exact<{
  contractObjectId: Scalars['Long'];
  contractSubObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type BimIsUniqueContractSubObjectNameQuery = { __typename?: 'Query', bimIsUniqueContractSubObjectName: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimDeleteContractObjectMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
}>;


export type BimDeleteContractObjectMutation = { __typename?: 'Mutation', bimDeleteContractObject: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimMoveContractObjectMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  insertAfterObjectId?: InputMaybe<Scalars['Long']>;
  newParentObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimMoveContractObjectMutation = { __typename?: 'Mutation', bimMoveContractObject: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateActKc2TotalsMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  uploadId: Scalars['String'];
  actsKC2Ids: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimUpdateActKc2TotalsMutation = { __typename?: 'Mutation', bimUpdateActKC2Totals: { __typename?: 'ServiceDataResultOfInt64__', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: Array<any> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderOthersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<BimWorkOrderOtherDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderOtherDataSortInput> | BimWorkOrderOtherDataSortInput>;
}>;


export type BimWorkOrderOthersQuery = { __typename?: 'Query', bimWorkOrderOthers?: { __typename?: 'BimWorkOrderOthersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderOtherData', contractOtherCostId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum }> | null } | null };

export type BimWorkOrderOtherForActQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderOtherDataSortInput> | BimWorkOrderOtherDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderOtherDataFilterInput>;
  workOrderObjectId: Scalars['Long'];
}>;


export type BimWorkOrderOtherForActQuery = { __typename?: 'Query', bimWorkOrderOtherForAct?: { __typename?: 'BimWorkOrderOtherForActCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderOtherData', contractOtherCostId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum }> | null } | null };

export type BimAddWorkOrderOthersMutationVariables = Exact<{
  contractType: ProjectContractTypeEnum;
  input: BimWorkOrderOtherInput;
}>;


export type BimAddWorkOrderOthersMutation = { __typename?: 'Mutation', bimAddWorkOrderOthers: { __typename?: 'ServiceDataResultOfWorkOrderModifyItemIds', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'WorkOrderModifyItemIds', itemIds?: Array<any> | null, isWorkOrderChangeRequired?: boolean | null } | null } };

export type BimAddWorkOrderOtherForActMutationVariables = Exact<{
  contractOtherCostIds: Array<Scalars['Long']> | Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
}>;


export type BimAddWorkOrderOtherForActMutation = { __typename?: 'Mutation', bimAddWorkOrderOtherForAct: { __typename?: 'ServiceDataResultOfWorkOrderModifyItemIds', result: boolean, message?: string | null, code?: string | null, actionRequired?: boolean | null, data?: { __typename?: 'WorkOrderModifyItemIds', itemIds?: Array<any> | null, workOrderId: any, isWorkOrderChangeRequired?: boolean | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimCreateActKc2OtherCorrectionMutationVariables = Exact<{
  input: BimActKc2OtherCorrectionCreateInput;
}>;


export type BimCreateActKc2OtherCorrectionMutation = { __typename?: 'Mutation', bimCreateActKC2OtherCorrection: { __typename?: 'ServiceDataResultOfBimActKC2OtherData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimActKC2OtherData', authoredBy?: string | null, contractId: any, contractor: string, contractorAddress?: string | null, createdAt: any, date?: any | null, finishDate?: any | null, hasPlanValues: boolean, id: any, number?: number | null, startDate?: any | null, status: BimActKc2OtherStatusEnum, statusFollowers: Array<BimActKc2OtherStatusEnum>, uniqueId: string, updatedAt?: any | null, updatedBy?: string | null, workOrderId: any, fullNumber?: string | null, correctionDate?: any | null, isInactive?: boolean | null, isCorrection?: boolean | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, workOrderObject: { __typename?: 'BimWorkOrderObjectData', canSetGuaranteedVolume: boolean, contractId: any, fromWorkOrder: boolean, hasGuaranteedVolume?: boolean | null, id: any, isActKC2Object: boolean, name: string, order: number, parentBasedOrder: number, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, workOrderId: any, workOrderObjectId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }, workOrderSeason: { __typename?: 'BimWorkOrderSeasonData', id: any, workOrderId: any, workOrderSeasonId: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateActKc2OtherCorrectionMutationVariables = Exact<{
  input: BimActKc2OtherCorrectionUpdateInput;
}>;


export type BimUpdateActKc2OtherCorrectionMutation = { __typename?: 'Mutation', bimUpdateActKC2OtherCorrection: { __typename?: 'ServiceDataResultOfBimActKC2OtherData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimActKC2OtherData', authoredBy?: string | null, contractId: any, contractor: string, contractorAddress?: string | null, createdAt: any, date?: any | null, finishDate?: any | null, hasPlanValues: boolean, id: any, number?: number | null, startDate?: any | null, status: BimActKc2OtherStatusEnum, statusFollowers: Array<BimActKc2OtherStatusEnum>, uniqueId: string, updatedAt?: any | null, updatedBy?: string | null, workOrderId: any, fullNumber?: string | null, correctionDate?: any | null, isInactive?: boolean | null, isCorrection?: boolean | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, workOrderObject: { __typename?: 'BimWorkOrderObjectData', canSetGuaranteedVolume: boolean, contractId: any, fromWorkOrder: boolean, hasGuaranteedVolume?: boolean | null, id: any, isActKC2Object: boolean, name: string, order: number, parentBasedOrder: number, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, workOrderId: any, workOrderObjectId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }, workOrderSeason: { __typename?: 'BimWorkOrderSeasonData', id: any, workOrderId: any, workOrderSeasonId: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderQuery = { __typename?: 'Query', bimWorkOrder: { __typename?: 'ServiceDataResultOfBimWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimWorkOrderData', id: any, status: WorkOrderStatusEnum, statusFollowers: Array<WorkOrderStatusEnum>, formationStage?: BimWorkOrderFormationStageEnum | null, subject?: string | null, internalNumber?: string | null, signingDate?: any | null, startDate?: any | null, finishDate?: any | null, contractor: string, amountWithTax?: any | null, amountWithoutTax?: any | null, tax?: any | null, createdAt: any, remainder?: any | null, updatedAt?: any | null, authoredBy?: string | null, updatedBy?: string | null, hasActsKC2?: boolean | null, hasOtherActsKC2?: boolean | null, hasSMRActsKC2?: boolean | null, isWorkOrderChangeRequired?: boolean | null, seasons?: Array<{ __typename?: 'BimWorkOrderSeasonData', workOrderId: any, workOrderSeasonId: any, id: any, year: any }> | null, seasonDistributions?: Array<{ __typename?: 'BimWorkOrderSeasonDistributionData', seasonValue?: any | null, workOrderSeasonId: any }> | null, workOrderChange?: { __typename?: 'BimWorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderMutationVariables = Exact<{
  workOrderInput: BimWorkOrderUpdateInput;
}>;


export type BimUpdateWorkOrderMutation = { __typename?: 'Mutation', bimUpdateWorkOrder: { __typename?: 'ServiceDataResultOfBimWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimWorkOrderData', id: any, isWorkOrderChangeRequired?: boolean | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCalculationRequisitesQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimCalculationRequisitesQuery = { __typename?: 'Query', bimCalculation: { __typename?: 'ServiceDataResultOfBimCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimCalculationData', id: any, status: WorkOrderStatusEnum, statusFollowers: Array<WorkOrderStatusEnum>, hasActsKC2?: boolean | null, hasSMRActsKC2?: boolean | null, hasOtherActsKC2?: boolean | null, isWorkOrderChangeRequired?: boolean | null, seasons?: Array<{ __typename?: 'BimWorkOrderSeasonData', id: any, workOrderId: any, workOrderSeasonId: any, year: any }> | null, seasonDistributions?: Array<{ __typename?: 'BimWorkOrderSeasonDistributionData', workOrderSeasonId: any, seasonValue?: any | null }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateCalculationMutationVariables = Exact<{
  calculationInput: BimCalculationUpdateInput;
}>;


export type BimUpdateCalculationMutation = { __typename?: 'Mutation', bimUpdateCalculation: { __typename?: 'ServiceDataResultOfBimCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimCalculationData', id: any, isWorkOrderChangeRequired?: boolean | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimActKc2TotalsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2Id: Scalars['Long'];
  readOnly?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<BimActKc2TotalItemDataFilterInput>;
  order?: InputMaybe<Array<BimActKc2TotalItemDataSortInput> | BimActKc2TotalItemDataSortInput>;
}>;


export type BimActKc2TotalsQuery = { __typename?: 'Query', bimActKC2Totals?: { __typename?: 'BimActKC2TotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2TotalItemData', id: any, totalId?: any | null, workOrderSeasonId?: any | null, workOrderActiveSeasonId?: any | null, name: string, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, tzr?: any | null, sortOrder: any, parentId?: number | null, isEditable: boolean, isInflation: boolean, isLimitPrice: boolean, limitedCostType?: BimLimitedCostTypeEnum | null, isSelected: boolean, isInputValue: boolean }> | null } | null };

export type BimUseActKc2TotalLimitedMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  limitedItems: Array<BimLimitedCostTypeEnum> | BimLimitedCostTypeEnum;
  useLimited: Scalars['Boolean'];
}>;


export type BimUseActKc2TotalLimitedMutation = { __typename?: 'Mutation', bimUseActKC2TotalLimited: { __typename?: 'ServiceResult', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimResetActKc2AllCalculatedTotalMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  useCalculated: Scalars['Boolean'];
}>;


export type BimResetActKc2AllCalculatedTotalMutation = { __typename?: 'Mutation', bimResetActKC2AllCalculatedTotal: { __typename?: 'ServiceResult', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimResetActKc2CalculatedTotalItemMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  useCalculated: Scalars['Boolean'];
  actKC2TotalItemId: Scalars['Long'];
}>;


export type BimResetActKc2CalculatedTotalItemMutation = { __typename?: 'Mutation', bimResetActKC2CalculatedTotalItem: { __typename?: 'ServiceResult', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimSetActKc2InputValueMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  actKC2TotalItemId: Scalars['Long'];
  value: Scalars['Decimal'];
}>;


export type BimSetActKc2InputValueMutation = { __typename?: 'Mutation', bimSetActKC2InputValue: { __typename?: 'ServiceResult', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimActKc2PriceRowsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2Id: Scalars['Long'];
  priceLevel: BimPriceLevelEnum;
  where?: InputMaybe<BimActKc2PriceRowDataFilterInput>;
  order?: InputMaybe<Array<BimActKc2PriceRowDataSortInput> | BimActKc2PriceRowDataSortInput>;
}>;


export type BimActKc2PriceRowsQuery = { __typename?: 'Query', bimActKC2PriceRows?: { __typename?: 'BimActKC2PriceRowsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2PriceRowData', id: any, name: string, sectionId?: any | null, sectionName?: string | null, serialNumber: number, number?: string | null, code: string, unit?: string | null, quantity?: any | null, unitCost?: any | null, total?: any | null, inactiveMtr?: boolean | null }> | null } | null };

export type BimUseActKc2TotalInflationMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderSeasonId: Scalars['Long'];
}>;


export type BimUseActKc2TotalInflationMutation = { __typename?: 'Mutation', bimUseActKC2TotalInflation: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimUseActKc2InflationValueMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  calculateInflation: BimCalculateInflationEnum;
}>;


export type BimUseActKc2InflationValueMutation = { __typename?: 'Mutation', bimUseActKC2InflationValue: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderActsKc2QueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  groupType?: InputMaybe<BimActKc2GroupTypeEnum>;
  where?: InputMaybe<BimActKc2ListItemDataFilterInput>;
  order?: InputMaybe<Array<BimActKc2ListItemDataSortInput> | BimActKc2ListItemDataSortInput>;
}>;


export type BimWorkOrderActsKc2Query = { __typename?: 'Query', bimWorkOrderActsKC2?: { __typename?: 'BimWorkOrderActsKC2CollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2ListItemData', actDate?: any | null, actId: any, actMonth?: number | null, actYear?: number | null, chapter?: BimChapterEnum | null, chapterTip: string, constructionTypeId: number, costGroup: CostGroupEnum, costWithoutTax?: any | null, finishDate?: any | null, groupCostWithoutTax?: any | null, groupCount: number, groupId?: any | null, groupName?: string | null, groupUniqueId?: string | null, isIncluded?: boolean | null, number?: string | null, startDate?: any | null, status?: BimActKc2StatusEnum | null, statusTip: string, workOrderObjectId: any, workOrderObjectName: string, workOrderPriceCode?: string | null, workOrderPriceName?: string | null, isInactive?: boolean | null, isCorrection?: boolean | null, fullNumber?: string | null, correctionNumber?: any | null, correctionDate?: any | null, constructionType: { __typename?: 'ConstructionType', id: number, code: string, name: string, fullName: string, shortName: string, contractFileName: string, catalogId: any, createdAt: any, uniqueId: string } }> | null } | null };

export type BimWorkOrderActsKc2SelectionListQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<BimActKc2SelectionDataFilterInput>;
  order?: InputMaybe<Array<BimActKc2SelectionDataSortInput> | BimActKc2SelectionDataSortInput>;
}>;


export type BimWorkOrderActsKc2SelectionListQuery = { __typename?: 'Query', bimWorkOrderActsKC2SelectionList?: { __typename?: 'BimWorkOrderActsKC2SelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2SelectionData', groupId?: any | null, groupName?: string | null, actId: any, number?: string | null, actDate?: any | null, startDate?: any | null, finishDate?: any | null, costGroup: CostGroupEnum, workOrderObjectName: string, costWithoutTax?: any | null, isIncluded?: boolean | null, chapter?: BimChapterEnum | null, chapterTip: string, status?: BimActKc2StatusEnum | null, statusTip: string, workOrderPriceCode?: string | null, workOrderPriceName?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, correctionNumber?: any | null, fullNumber?: string | null, correctionDate?: any | null, constructionType: { __typename?: 'ConstructionType', id: number, code: string, name: string, fullName: string, shortName: string, contractFileName: string, catalogId: any, createdAt: any, uniqueId: string } }> | null } | null };

export type BimCreateWorkOrderActsKc2GroupMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  input: BimActKc2GroupInput;
}>;


export type BimCreateWorkOrderActsKc2GroupMutation = { __typename?: 'Mutation', bimCreateWorkOrderActsKC2Group: { __typename?: 'ServiceIdResultOfInt64', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderActsKc2GroupMutationVariables = Exact<{
  actKC2GroupId: Scalars['Long'];
  input: BimActKc2GroupInput;
}>;


export type BimUpdateWorkOrderActsKc2GroupMutation = { __typename?: 'Mutation', bimUpdateWorkOrderActsKC2Group: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderActsKc2GroupMutationVariables = Exact<{
  actKC2GroupId: Scalars['Long'];
}>;


export type BimRemoveWorkOrderActsKc2GroupMutation = { __typename?: 'Mutation', bimRemoveWorkOrderActsKC2Group: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimActKc2GroupNumberFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimActKc2GroupNumberFilterQuery = { __typename?: 'Query', bimActKC2GroupNumberFilter?: { __typename?: 'BimActKC2GroupNumberFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimActKc2GroupDateFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDateTimeFilterInput>;
}>;


export type BimActKc2GroupDateFilterQuery = { __typename?: 'Query', bimActKC2GroupDateFilter?: { __typename?: 'BimActKC2GroupDateFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDateTime', value?: any | null }> | null } | null };

export type BimActKc2GroupCostGroupFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
}>;


export type BimActKc2GroupCostGroupFilterQuery = { __typename?: 'Query', bimActKC2GroupCostGroupFilter?: { __typename?: 'BimActKC2GroupCostGroupFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfCostGroupEnum', value: CostGroupEnum }> | null } | null };

export type BimActKc2GroupConstructionTypeFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimActKc2GroupConstructionTypeFilterQuery = { __typename?: 'Query', bimActKC2GroupConstructionTypeFilter?: { __typename?: 'BimActKC2GroupConstructionTypeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimActKc2GroupObjectFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimActKc2GroupObjectFilterQuery = { __typename?: 'Query', bimActKC2GroupObjectFilter?: { __typename?: 'BimActKC2GroupObjectFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimActKc2GroupChapterFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfBimChapterEnumFilterInput>;
}>;


export type BimActKc2GroupChapterFilterQuery = { __typename?: 'Query', bimActKC2GroupChapterFilter?: { __typename?: 'BimActKC2GroupChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfBimChapterEnum', value?: BimChapterEnum | null }> | null } | null };

export type BimActKc2GroupWorkOrderPriceCodeFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimActKc2GroupWorkOrderPriceCodeFilterQuery = { __typename?: 'Query', bimActKC2GroupWorkOrderPriceCodeFilter?: { __typename?: 'BimActKC2GroupWorkOrderPriceCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimIsUniqueActKc2GroupNameQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  groupName: Scalars['String'];
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
}>;


export type BimIsUniqueActKc2GroupNameQuery = { __typename?: 'Query', bimIsUniqueActKC2GroupName: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimActKc2OtherTotalsQueryVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
}>;


export type BimActKc2OtherTotalsQuery = { __typename?: 'Query', bimActKC2OtherTotals?: { __typename?: 'BimActKC2OtherTotalsCollectionSegment', items?: Array<{ __typename?: 'BimActKC2OtherTotalItemData', id: any, workOrderSeasonId?: any | null, isInflation: boolean, workOrderActiveSeasonId?: any | null, name: string, total?: any | null, sortOrder: any, hasTotals: boolean }> | null } | null };

export type BimUseActKc2OtherTotalInflationMutationVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
  workOrderSeasonId?: InputMaybe<Scalars['Long']>;
}>;


export type BimUseActKc2OtherTotalInflationMutation = { __typename?: 'Mutation', bimUseActKC2OtherTotalInflation: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderConstructionTypesQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderConstructionTypesQuery = { __typename?: 'Query', bimWorkOrderConstructionTypes: { __typename?: 'ServiceDataResultOfConstructionTypeData__', data?: Array<{ __typename?: 'ConstructionTypeData', name: string, id: number, catalogId: any, fullName: string } | null> | null } };

export type BimWorkOrderOtherPricesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  where?: InputMaybe<BimWorkOrderOtherPriceDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderOtherPriceDataSortInput> | BimWorkOrderOtherPriceDataSortInput>;
}>;


export type BimWorkOrderOtherPricesQuery = { __typename?: 'Query', bimWorkOrderOtherPrices?: { __typename?: 'BimWorkOrderOtherPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderOtherPriceData', id: any, contractOtherCostId: any, name: string, calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status?: BimContractOtherStatusEnum | null, isActKC2Price: boolean, isExcludedRow?: boolean | null, hasEmptyActPlanCost?: boolean | null, hasEmptyActAcceptedCost?: boolean | null, hasActualCost?: boolean | null, completedOtherDeviation?: DeviationEnum | null, planValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, completedValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, remainderValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, actKC2OtherCosts: Array<{ __typename?: 'BimActKC2OtherCostData', actKC2Id: any, costPlan?: any | null, costAccepted?: any | null, comment?: string | null }> }> | null } | null };

export type BimActsKc2OtherQueryVariables = Exact<{
  order?: InputMaybe<Array<BimActKc2OtherItemDataSortInput> | BimActKc2OtherItemDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2OtherItemDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimActsKc2OtherQuery = { __typename?: 'Query', bimActsKC2Other?: { __typename?: 'BimActsKC2OtherCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2OtherItemData', id: any, status: BimActKc2OtherStatusEnum, number?: number | null, date?: any | null, correctionDate?: any | null, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimIsUniqueActKc2OtherInternalNumberQueryVariables = Exact<{
  actKC2OtherId?: InputMaybe<Scalars['Long']>;
  actKC2OtherNumber: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type BimIsUniqueActKc2OtherInternalNumberQuery = { __typename?: 'Query', bimIsUniqueActKC2OtherInternalNumber: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimSetActKc2OtherPlanCostMutationVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
  cost: Scalars['Decimal'];
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimSetActKc2OtherPlanCostMutation = { __typename?: 'Mutation', bimSetActKC2OtherPlanCost: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimSetActKc2OtherAcceptedCostMutationVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
  cost: Scalars['Decimal'];
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimSetActKc2OtherAcceptedCostMutation = { __typename?: 'Mutation', bimSetActKC2OtherAcceptedCost: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderOthersMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderOtherIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimRemoveWorkOrderOthersMutation = { __typename?: 'Mutation', bimRemoveWorkOrderOthers: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderOtherForActMutationVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  workOrderOtherIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimRemoveWorkOrderOtherForActMutation = { __typename?: 'Mutation', bimRemoveWorkOrderOtherForAct: { __typename?: 'ServiceDataResultOfWorkOrderModifyItemIds', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderModifyItemIds', itemIds?: Array<any> | null, workOrderId: any, isWorkOrderChangeRequired?: boolean | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderOtherDistributionMutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  input: BimWorkOrderOtherDistributionInput;
}>;


export type BimUpdateWorkOrderOtherDistributionMutation = { __typename?: 'Mutation', bimUpdateWorkOrderOtherDistribution: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderOtherMutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  input: BimContractOtherCostUpdateInput;
}>;


export type BimUpdateWorkOrderOtherMutation = { __typename?: 'Mutation', bimUpdateWorkOrderOther: { __typename?: 'ServiceDataResultOfBimWorkOrderOtherPriceData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimWorkOrderOtherPriceData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderOtherForActMutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  input: BimContractOtherCostUpdateInput;
}>;


export type BimUpdateWorkOrderOtherForActMutation = { __typename?: 'Mutation', bimUpdateWorkOrderOtherForAct: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderOtherDistributionToActKc2MutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  input: BimWorkOrderOtherDistributionInput;
}>;


export type BimUpdateWorkOrderOtherDistributionToActKc2Mutation = { __typename?: 'Mutation', bimUpdateWorkOrderOtherDistributionToActKC2: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimSetActKc2OtherCostCommentMutationVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
  comment?: InputMaybe<Scalars['String']>;
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimSetActKc2OtherCostCommentMutation = { __typename?: 'Mutation', bimSetActKC2OtherCostComment: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderOtherDataQueryVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimWorkOrderOtherDataQuery = { __typename?: 'Query', bimWorkOrderOtherData: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', data?: { __typename?: 'BimContractOtherCostData', id: any, formula?: string | null, contractId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, isGlobalOtherCost: boolean, rationale?: string | null, catalogOtherCostTypeId?: number | null, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, canDelete: boolean, isSystem: boolean } | null } | null } };

export type BimWorkOrderOtherDistributionQueryVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimWorkOrderOtherDistributionQuery = { __typename?: 'Query', bimWorkOrderOtherDistribution: { __typename?: 'ServiceDataResultOfBimWorkOrderOtherDistributionData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimWorkOrderOtherDistributionData', contractOtherCost: { __typename?: 'BimContractOtherCostBaseData', id: any, contractId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, isGlobalOtherCost: boolean, formula?: string | null }, limit: { __typename?: 'BimWorkOrderCostLimitDistributionData', costLimit: any, totalRemainderCost?: any | null, includedCost?: any | null, isSystemCalculation: boolean }, objectDistribution: Array<{ __typename?: 'BimWorkOrderObjectDistributionData', id: any, workOrderObjectId: any, name: string, isIncluded?: boolean | null, cost?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null }> } | null } };

export type BimPriceRowAnalyticsQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  where?: InputMaybe<BimPriceAnalyticsItemFilterInput>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type BimPriceRowAnalyticsQuery = { __typename?: 'Query', bimPriceRowAnalytics?: { __typename?: 'BimPriceRowAnalyticsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimPriceAnalyticsItem', section: { __typename?: 'BimHeaderAnalyticsRowData', sysId: any, order: number, status: BimPriceAnalyticsItemStatus, changedProperties?: Array<string> | null, topHeaderValue?: { __typename?: 'BimWorkOrderPriceSectionData', name?: string | null } | null, refHeaderValue?: { __typename?: 'BimWorkOrderPriceSectionData', name?: string | null } | null }, subsection?: { __typename?: 'BimHeaderAnalyticsRowData', sysId: any, order: number, status: BimPriceAnalyticsItemStatus, changedProperties?: Array<string> | null, topHeaderValue?: { __typename?: 'BimWorkOrderPriceSectionData', name?: string | null } | null, refHeaderValue?: { __typename?: 'BimWorkOrderPriceSectionData', name?: string | null } | null } | null, price: { __typename?: 'BimPriceAnalyticsRowData', sysId: any, order: number, status: BimPriceAnalyticsItemStatus, changedProperties?: Array<string> | null, topPriceValue?: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, emm?: any | null, mp?: any | null, mz?: any | null, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzr?: any | null, unit?: string | null, unitCost?: any | null, zpm?: any | null } | null, refPriceValue?: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, emm?: any | null, mp?: any | null, mz?: any | null, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzr?: any | null, unit?: string | null, unitCost?: any | null, zpm?: any | null } | null } }> | null } | null };

export type BimPriceAnalyticsQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimPriceAnalyticsQuery = { __typename?: 'Query', bimPriceAnalytics: { __typename?: 'ServiceDataResultOfBimPriceAnalyticsData', result: boolean, message?: string | null, data?: { __typename?: 'BimPriceAnalyticsData', topPriceId: any, refPriceId: any, topPriceValue?: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, emm?: any | null, mp?: any | null, mz?: any | null, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzr?: any | null, unit?: string | null, unitCost?: any | null, zpm?: any | null } | null, refPriceValue?: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, emm?: any | null, mp?: any | null, mz?: any | null, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzr?: any | null, unit?: string | null, unitCost?: any | null, zpm?: any | null } | null, statusCounts: Array<{ __typename?: 'BimPriceAnalyticsStatusItem', status: BimPriceAnalyticsItemStatus, count: number }> } | null } };

export type BimWorkOrderPriceAnalyticsPriceVersionsQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
}>;


export type BimWorkOrderPriceAnalyticsPriceVersionsQuery = { __typename?: 'Query', bimWorkOrderPriceRevisions?: { __typename?: 'BimWorkOrderPriceRevisionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderPriceRevisionData', id: any, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, priceUpdateDate?: any | null, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null } }> | null } | null };

export type BimPriceRowAnalyticsSectionFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimPriceRowAnalyticsSectionFilterQuery = { __typename?: 'Query', bimPriceRowAnalyticsSectionFilter?: { __typename?: 'BimPriceRowAnalyticsSectionFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimPriceRowAnalyticsSubsectionFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimPriceRowAnalyticsSubsectionFilterQuery = { __typename?: 'Query', bimPriceRowAnalyticsSubsectionFilter?: { __typename?: 'BimPriceRowAnalyticsSubsectionFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimPriceRowAnalyticsCodeFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimPriceRowAnalyticsCodeFilterQuery = { __typename?: 'Query', bimPriceRowAnalyticsCodeFilter?: { __typename?: 'BimPriceRowAnalyticsCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimPriceRowAnalyticsNameFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimPriceRowAnalyticsNameFilterQuery = { __typename?: 'Query', bimPriceRowAnalyticsNameFilter?: { __typename?: 'BimPriceRowAnalyticsNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimPriceRowAnalyticsUnitFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  refWorkOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimPriceRowAnalyticsUnitFilterQuery = { __typename?: 'Query', bimPriceRowAnalyticsUnitFilter?: { __typename?: 'BimPriceRowAnalyticsUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimWorkOrderPriceRevisionCodeFilterQueryVariables = Exact<{
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceRevisionCodeFilterQuery = { __typename?: 'Query', bimWorkOrderPriceRevisionCodeFilter?: { __typename?: 'BimWorkOrderPriceRevisionCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderPriceRevisionNameFilterQueryVariables = Exact<{
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceRevisionNameFilterQuery = { __typename?: 'Query', bimWorkOrderPriceRevisionNameFilter?: { __typename?: 'BimWorkOrderPriceRevisionNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPricesQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  includeRows: Scalars['Boolean'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionPriceDataFilterInput>;
}>;


export type BimWorkOrderVersionPricesQuery = { __typename?: 'Query', bimWorkOrderVersionPrices?: { __typename?: 'BimWorkOrderVersionPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderVersionPriceData', id: any, chapter: BimChapterEnum, workOrderVersionId: any, workOrderVersionObjectId: any, isLimitPrice: boolean, hasRevisions: boolean, hasActKC2: boolean, hasUpdates: boolean, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, isActKC2Price: boolean, completedTotalDeviation?: DeviationEnum | null, object: { __typename?: 'BimWorkOrderVersionObjectItem', id: any, name: string }, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderPricesQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  includeRows: Scalars['Boolean'];
  priceLevel: BimPriceLevelEnum;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderPriceDataFilterInput>;
}>;


export type BimWorkOrderPricesQuery = { __typename?: 'Query', bimWorkOrderPrices?: { __typename?: 'BimWorkOrderPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderPriceData', id: any, chapter: BimChapterEnum, workOrderId: any, workOrderObjectId: any, isLimitPrice: boolean, hasRevisions: boolean, hasActKC2: boolean, hasUpdates: boolean, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, isActKC2Price: boolean, canRemovedToActKC2: boolean, completedTotalDeviation?: DeviationEnum | null, object: { __typename?: 'BimWorkOrderObjectItem', id: any, contractObjectId: any, name: string }, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderPriceRowsQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimWorkOrderPriceRowsQuery = { __typename?: 'Query', bimWorkOrderPriceRows?: { __typename?: 'BimWorkOrderPriceRowsCollectionSegment', items?: Array<{ __typename?: 'BimWorkOrderPriceRowData', id: any, workOrderId: any, workOrderPriceId: any, type: BimWorkOrderPriceRowTypeEnum, sectionId?: any | null, sectionNane?: string | null, value: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, mz?: any | null, total?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimRemoveWorkOrderPricesMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimRemoveWorkOrderPricesMutation = { __typename?: 'Mutation', bimRemoveWorkOrderPrices: { __typename?: 'ServiceDataResultOfBimWorkOrderTotalData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderTotalData', workOrderId: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderPricesToActKc2MutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type BimRemoveWorkOrderPricesToActKc2Mutation = { __typename?: 'Mutation', bimRemoveWorkOrderPricesToActKC2: { __typename?: 'ServiceDataResultOfWorkOrderModifyItemIds', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderModifyItemIds', itemIds?: Array<any> | null, workOrderId: any, isWorkOrderChangeRequired?: boolean | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderPriceRevisionsQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderPriceRevisionDataSortInput> | BimWorkOrderPriceRevisionDataSortInput>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderPriceRevisionDataFilterInput>;
  workOrderPriceId: Scalars['Long'];
}>;


export type BimWorkOrderPriceRevisionsQuery = { __typename?: 'Query', bimWorkOrderPriceRevisions?: { __typename?: 'BimWorkOrderPriceRevisionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderPriceRevisionData', id: any, priceUpdateDate?: any | null, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderVersionPriceRevisionsQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderVersionPriceRevisionDataSortInput> | BimWorkOrderVersionPriceRevisionDataSortInput>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionPriceRevisionDataFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
}>;


export type BimWorkOrderVersionPriceRevisionsQuery = { __typename?: 'Query', bimWorkOrderVersionPriceRevisions?: { __typename?: 'BimWorkOrderVersionPriceRevisionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderVersionPriceRevisionData', id: any, priceUpdateDate?: any | null, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimActsKc2QueryVariables = Exact<{
  order?: InputMaybe<Array<BimActKc2DataSortInput> | BimActKc2DataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2DataFilterInput>;
  workOrderPriceId: Scalars['Long'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimActsKc2Query = { __typename?: 'Query', bimActsKC2?: { __typename?: 'BimActsKC2CollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimActKC2Data', id: any, calcMethod: BimActKc2TotalCalcMethodEnum, currentPriceTotal?: any | null, workOrderId: any, year: any, month: any, number: string, date: any, startDate: any, finishDate: any, canRemoved: boolean, useInflationValue: boolean, isCorrection?: boolean | null, isInactive?: boolean | null, correctionNumber?: any | null, fullNumber?: string | null, hasDeflation?: boolean | null, value: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimRemoveActsKc2MutationVariables = Exact<{
  actKC2Ids: Array<Scalars['Long']> | Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
}>;


export type BimRemoveActsKc2Mutation = { __typename?: 'Mutation', bimRemoveActsKC2: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderPriceCodeFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceCodeFilterQuery = { __typename?: 'Query', bimWorkOrderPriceCodeFilter?: { __typename?: 'BimWorkOrderPriceCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderPriceNameFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceNameFilterQuery = { __typename?: 'Query', bimWorkOrderPriceNameFilter?: { __typename?: 'BimWorkOrderPriceNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderPriceObjectNameFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceObjectNameFilterQuery = { __typename?: 'Query', bimWorkOrderPriceObjectNameFilter?: { __typename?: 'BimWorkOrderPriceObjectNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderPriceRowCodeFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceRowCodeFilterQuery = { __typename?: 'Query', bimWorkOrderPriceRowCodeFilter?: { __typename?: 'BimWorkOrderPriceRowCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderPriceRowNameFilterQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderPriceRowNameFilterQuery = { __typename?: 'Query', bimWorkOrderPriceRowNameFilter?: { __typename?: 'BimWorkOrderPriceRowNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderObjectsQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderObjectDataSortInput> | BimWorkOrderObjectDataSortInput>;
  rootsOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderObjectDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderObjectsQuery = { __typename?: 'Query', bimWorkOrderObjects?: { __typename?: 'BimWorkOrderObjectsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderObjectData', workOrderObjectId: any, workOrderId: any, fromWorkOrder: boolean, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean } } | null };

export type BimWorkOrderObjectsForListQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderObjectDataSortInput> | BimWorkOrderObjectDataSortInput>;
  rootsOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderObjectDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderObjectsForListQuery = { __typename?: 'Query', bimWorkOrderObjects?: { __typename?: 'BimWorkOrderObjectsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderObjectData', id: any, name: string, parentId?: any | null, workOrderObjectId: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean } } | null };

export type BimUploadPriceFilesMutationVariables = Exact<{
  chapter: BimChapterEnum;
  filesContent: Array<FileInput> | FileInput;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
}>;


export type BimUploadPriceFilesMutation = { __typename?: 'Mutation', bimUploadPriceFiles: { __typename?: 'ServiceDataResultOfBimWorkOrderTotalData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderTotalData', workOrderId: any, uploadPriceActs?: string | null, isWorkOrderChangeRequired?: boolean | null, itemIds?: Array<any> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractSeasonsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type BimContractSeasonsQuery = { __typename?: 'Query', bimContractSeasons: { __typename?: 'ServiceDataResultOfBimContractSeasonData__', data?: Array<{ __typename?: 'BimContractSeasonData', id: any, year: any } | null> | null } };

export type BimWorkOrderSeasonsRangeQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderSeasonsRangeQuery = { __typename?: 'Query', bimWorkOrderSeasonsRange: { __typename?: 'ServiceDataResultOfBimWorkOrderSeasonsData', data?: { __typename?: 'BimWorkOrderSeasonsData', firstSeason: { __typename?: 'BimWorkOrderSeasonData', workOrderId: any, workOrderSeasonId: any, id: any, year: any }, lastSeason: { __typename?: 'BimWorkOrderSeasonData', workOrderId: any, workOrderSeasonId: any, id: any, year: any } } | null } };

export type BimUpdateWorkOrderSeasonsMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  input: BimWorkOrderSeasonsInput;
}>;


export type BimUpdateWorkOrderSeasonsMutation = { __typename?: 'Mutation', bimUpdateWorkOrderSeasons: { __typename?: 'ServiceDataResultOfBimWorkOrderSeasonsData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderObjectSelectionListQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderObjectSelectionDataSortInput> | BimWorkOrderObjectSelectionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderObjectSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderObjectSelectionListQuery = { __typename?: 'Query', bimWorkOrderObjectSelectionList?: { __typename?: 'BimWorkOrderObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimWorkOrderObjectSelectionData', fromWorkOrder: boolean, workOrderObjectId?: any | null, workOrderId?: any | null, isActKC2Object: boolean, isIncluded: boolean, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, order: number, hasPrices: boolean, hasActsKC2: boolean, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }> | null } | null };

export type BimWorkOrderObjectSelectionListIsIncludedQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderObjectSelectionDataSortInput> | BimWorkOrderObjectSelectionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderObjectSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderObjectSelectionListIsIncludedQuery = { __typename?: 'Query', bimWorkOrderObjectSelectionList?: { __typename?: 'BimWorkOrderObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimWorkOrderObjectSelectionData', isIncluded: boolean, id: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null } | null };

export type BimIncludeContractObjectToWorkOrderMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type BimIncludeContractObjectToWorkOrderMutation = { __typename?: 'Mutation', bimIncludeContractObjectToWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimExcludeContractObjectFromWorkOrderMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type BimExcludeContractObjectFromWorkOrderMutation = { __typename?: 'Mutation', bimExcludeContractObjectFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimIncludeWorkOrderSeasonMutationVariables = Exact<{
  contractSeasonId: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type BimIncludeWorkOrderSeasonMutation = { __typename?: 'Mutation', bimIncludeWorkOrderSeason: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCompleteStructureFormationMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimCompleteStructureFormationMutation = { __typename?: 'Mutation', bimCompleteStructureFormation: { __typename?: 'ServiceDataResultOfBimWorkOrderData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderObjectMutationVariables = Exact<{
  input: BimContractObjectCreateInput;
  workOrderId: Scalars['Long'];
}>;


export type BimCreateWorkOrderObjectMutation = { __typename?: 'Mutation', bimCreateWorkOrderObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimContractObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderSubObjectMutationVariables = Exact<{
  input: BimContractSubObjectCreateInput;
  workOrderId: Scalars['Long'];
}>;


export type BimCreateWorkOrderSubObjectMutation = { __typename?: 'Mutation', bimCreateWorkOrderSubObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimContractObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderObjectMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  contractObjectId: Scalars['Long'];
}>;


export type BimRemoveWorkOrderObjectMutation = { __typename?: 'Mutation', bimRemoveWorkOrderObject: { __typename?: 'ServiceDataResultOfWorkOrderModifyItemIds', buttonText?: string | null, actionRequired?: boolean | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null, data?: { __typename?: 'WorkOrderModifyItemIds', itemIds?: Array<any> | null, workOrderId: any, isWorkOrderChangeRequired?: boolean | null } | null } };

export type BimWorkOrderPriceMtrDistributionQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
}>;


export type BimWorkOrderPriceMtrDistributionQuery = { __typename?: 'Query', bimWorkOrderPriceMTRDistribution: { __typename?: 'ServiceDataResultOfBimWorkOrderPriceMTRDistributionData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderPriceMTRDistributionData', mp?: any | null, op?: any | null, mz?: any | null, oz?: any | null, total?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderPriceMtrDistributionTotalQueryVariables = Exact<{
  input: BimWorkOrderPriceMtrDistributionInput;
  workOrderPriceId: Scalars['Long'];
}>;


export type BimWorkOrderPriceMtrDistributionTotalQuery = { __typename?: 'Query', bimWorkOrderPriceMTRDistributionTotal: { __typename?: 'ServiceDataResultOfBimWorkOrderPriceMTRDistributionTotalData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderPriceMTRDistributionTotalData', total?: any | null, deviation?: DeviationEnum | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderPriceMtrDistributionMutationVariables = Exact<{
  input: BimWorkOrderPriceMtrDistributionInput;
  workOrderPriceId: Scalars['Long'];
}>;


export type BimUpdateWorkOrderPriceMtrDistributionMutation = { __typename?: 'Mutation', bimUpdateWorkOrderPriceMTRDistribution: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChapterDataQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimWorkOrderChapterDataQuery = { __typename?: 'Query', bimWorkOrderChapterData: { __typename?: 'ServiceDataResultOfBimWorkOrderChapterData__', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, data?: Array<{ __typename?: 'BimWorkOrderChapterData', chapter: BimChapterEnum, pricesCount: number } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimUpdateWorkOrderSubObjectMutationVariables = Exact<{
  input: BimContractSubObjectUpdateInput;
  workOrderId: Scalars['Long'];
}>;


export type BimUpdateWorkOrderSubObjectMutation = { __typename?: 'Mutation', bimUpdateWorkOrderSubObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimContractObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderObjectMutationVariables = Exact<{
  input: BimContractObjectUpdateInput;
  workOrderId: Scalars['Long'];
}>;


export type BimUpdateWorkOrderObjectMutation = { __typename?: 'Mutation', bimUpdateWorkOrderObject: { __typename?: 'ServiceDataResultOfBimContractObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimContractObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimIncludeAllObjectsToWorkOrderMutationVariables = Exact<{
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
}>;


export type BimIncludeAllObjectsToWorkOrderMutation = { __typename?: 'Mutation', bimIncludeAllObjectsToWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimExcludeAllObjectsFromWorkOrderMutationVariables = Exact<{
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
}>;


export type BimExcludeAllObjectsFromWorkOrderMutation = { __typename?: 'Mutation', bimExcludeAllObjectsFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUploadPriceActsMutationVariables = Exact<{
  chapter: BimChapterEnum;
  filesContent: Array<FileInput> | FileInput;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
  hasTotalsFromXml: Scalars['Boolean'];
}>;


export type BimUploadPriceActsMutation = { __typename?: 'Mutation', bimUploadPriceActs: { __typename?: 'ServiceDataResultOfBimWorkOrderTotalData', actionRequired?: boolean | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderTotalData', workOrderId: any, uploadPriceActs?: string | null, isWorkOrderChangeRequired?: boolean | null, itemIds?: Array<any> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderTotalsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  chapter?: InputMaybe<BimChapterEnum>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  useInPrices: Scalars['Boolean'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimWorkOrderTotalsQuery = { __typename?: 'Query', bimWorkOrderTotals?: { __typename?: 'BimWorkOrderTotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderTotalItemData', emm?: any | null, mp?: any | null, mz?: any | null, name: string, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sortOrder: any, sp?: any | null, total?: any | null, tzr?: any | null, zpm?: any | null, completedValue: { __typename?: 'BimWorkOrderPriceValue', smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderSeasonsQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderSeasonDataSortInput> | BimWorkOrderSeasonDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderSeasonDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderSeasonsQuery = { __typename?: 'Query', bimWorkOrderSeasons?: { __typename?: 'BimWorkOrderSeasonsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimWorkOrderSeasonData', workOrderId: any, workOrderSeasonId: any, id: any, year: any }> | null } | null };

export type BimExportWorkOrderQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimExportWorkOrderQuery = { __typename?: 'Query', bimExportWorkOrder: { __typename?: 'ServiceDataResultOfFileContent', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimExportWorkOrderPricesQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimExportWorkOrderPricesQuery = { __typename?: 'Query', bimExportWorkOrderPrices: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, code?: string | null, actionRequired?: boolean | null, data?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimActKc2OtherQueryVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
}>;


export type BimActKc2OtherQuery = { __typename?: 'Query', bimActKC2Other: { __typename?: 'ServiceDataResultOfBimActKC2OtherData', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimActKC2OtherData', id: any, uniqueId: string, contractId: any, workOrderId: any, status: BimActKc2OtherStatusEnum, number?: number | null, date?: any | null, startDate?: any | null, finishDate?: any | null, contractor: string, contractorAddress?: string | null, createdAt: any, updatedAt?: any | null, authoredBy?: string | null, updatedBy?: string | null, statusFollowers: Array<BimActKc2OtherStatusEnum>, hasPlanValues: boolean, isCorrection?: boolean | null, isInactive?: boolean | null, fullNumber?: string | null, correctionDate?: any | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, workOrderObject: { __typename?: 'BimWorkOrderObjectData', workOrderObjectId: any, workOrderId: any, fromWorkOrder: boolean, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, order: number, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }, workOrderSeason: { __typename?: 'BimWorkOrderSeasonData', workOrderId: any, workOrderSeasonId: any, id: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimCreateActKc2OtherMutationVariables = Exact<{
  input: BimActKc2OtherCreateInput;
}>;


export type BimCreateActKc2OtherMutation = { __typename?: 'Mutation', bimCreateActKC2Other: { __typename?: 'ServiceDataResultOfBimActKC2OtherData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimActKC2OtherData', id: any, status: BimActKc2OtherStatusEnum, workOrderId: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateActKc2OtherMutationVariables = Exact<{
  input: BimActKc2OtherUpdateInput;
}>;


export type BimUpdateActKc2OtherMutation = { __typename?: 'Mutation', bimUpdateActKC2Other: { __typename?: 'ServiceDataResultOfBimActKC2OtherData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimActKC2OtherData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveActKc2OtherMutationVariables = Exact<{
  actKC2OtherId: Scalars['Long'];
}>;


export type BimRemoveActKc2OtherMutation = { __typename?: 'Mutation', bimRemoveActKC2Other: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimActKc2OtherDefaultsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimActKc2OtherDefaultsQuery = { __typename?: 'Query', bimActKC2OtherDefaults: { __typename?: 'ServiceDataResultOfBimActKC2OtherDefaultData', result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimActKC2OtherDefaultData', status: BimActKc2OtherStatusEnum, contractor: string, contractorAddress?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderPriceStatesQueryVariables = Exact<{
  chapter: BimChapterEnum;
  workOrderObjectId: Scalars['Long'];
}>;


export type BimWorkOrderPriceStatesQuery = { __typename?: 'Query', bimWorkOrderPriceStates: { __typename?: 'ServiceDataResultOfBimWorkOrderPriceStatesData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderPriceStatesData', hasExcessCompletedTotalSMR: boolean, hasExcessCompletedOthers: boolean } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCalcWorkOrderOtherDistributionQueryVariables = Exact<{
  input: BimWorkOrderOtherPriceCalcInput;
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimCalcWorkOrderOtherDistributionQuery = { __typename?: 'Query', bimCalcWorkOrderOtherDistribution: { __typename?: 'ServiceDataResultOfBimWorkOrderOtherPriceCostData__', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: Array<{ __typename?: 'BimWorkOrderOtherPriceCostData', workOrderObjectId: any, others?: any | null, hasErrors: boolean, errors?: Array<string> | null } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChangeObjectsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeObjectsQuery = { __typename?: 'Query', bimWorkOrderChangeObjects?: { __typename?: 'BimWorkOrderChangeObjectsCollectionSegment', items?: Array<{ __typename?: 'BimWorkOrderChangeObjectData', workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null, constructionTypeId: number, isRootObject: boolean, fromWorkOrder: boolean, fromWorkOrderChange: boolean, isActKC2Object: boolean, isAddedObject?: boolean | null, isRemovedObject?: boolean | null, canSetGuaranteedVolume: boolean, isExcludedObject?: boolean | null, hasChildren?: boolean | null, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, order: number, parentBasedOrder: number, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }> | null } | null };

export type BimWorkOrderChangeChapterPriceCountsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimWorkOrderChangeChapterPriceCountsQuery = { __typename?: 'Query', bimWorkOrderChangeChapterPriceCounts: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeChapterData__', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, data?: Array<{ __typename?: 'BimWorkOrderChangeChapterData', chapter: BimChapterEnum, pricesCount: number } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderChangePriceStatesQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
}>;


export type BimWorkOrderChangePriceStatesQuery = { __typename?: 'Query', bimWorkOrderChangePriceStates: { __typename?: 'ServiceDataResultOfBimWorkOrderChangePriceStatesData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderChangePriceStatesData', hasExcessCompletedTotalSMR: boolean, hasExcessCompletedOthers: boolean } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderChangeObjectMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  contractObjectId: Scalars['Long'];
}>;


export type BimRemoveWorkOrderChangeObjectMutation = { __typename?: 'Mutation', bimRemoveWorkOrderChangeObject: { __typename?: 'ServiceResult', buttonText?: string | null, actionRequired?: boolean | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type BimWorkOrderChangeOtherDistributionQueryVariables = Exact<{
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type BimWorkOrderChangeOtherDistributionQuery = { __typename?: 'Query', bimWorkOrderChangeOtherDistribution: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeOtherDistributionData', result: boolean, data?: { __typename?: 'BimWorkOrderChangeOtherDistributionData', contractOtherCost: { __typename?: 'BimContractOtherCostBaseData', id: any, contractId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, status: BimContractOtherStatusEnum, isGlobalOtherCost: boolean, rationale?: string | null }, limit: { __typename?: 'BimWorkOrderChangeCostLimitDistributionData', costLimit: any, totalRemainderCost?: any | null, includedCost?: any | null, isSystemCalculation: boolean }, objectDistribution: Array<{ __typename?: 'BimWorkOrderChangeObjectDistributionData', contractObjectId: any, workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null, name: string, isIncluded?: boolean | null, cost?: any | null, errors?: Array<string> | null }> } | null } };

export type BimUpdateWorkChangeOrderOtherDistributionMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  input: BimWorkOrderChangeOtherDistributionInput;
}>;


export type BimUpdateWorkChangeOrderOtherDistributionMutation = { __typename?: 'Mutation', bimUpdateWorkChangeOrderOtherDistribution: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCalcWorkOrderChangeOtherDistributionQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  input: BimWorkOrderChangeOtherPriceCalcInput;
}>;


export type BimCalcWorkOrderChangeOtherDistributionQuery = { __typename?: 'Query', bimCalcWorkOrderChangeOtherDistribution: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeOtherPriceCostData__', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: Array<{ __typename?: 'BimWorkOrderChangeOtherPriceCostData', workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null, others?: any | null, hasErrors: boolean, errors?: Array<string> | null } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChangeOtherDataQueryVariables = Exact<{
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type BimWorkOrderChangeOtherDataQuery = { __typename?: 'Query', bimWorkOrderChangeOtherData: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractOtherCostData', id: any, contractId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, status: BimContractOtherStatusEnum, isGlobalOtherCost: boolean, rationale?: string | null, catalogOtherCostTypeId?: number | null, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, id: number, isSystem: boolean, name: string, uniqueId: string } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderChangeOtherMutationVariables = Exact<{
  workOrderChangeOtherPriceId: Scalars['Long'];
  input: BimContractOtherCostUpdateInput;
}>;


export type BimUpdateWorkOrderChangeOtherMutation = { __typename?: 'Mutation', bimUpdateWorkOrderChangeOther: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderChangePriceRationaleMutationVariables = Exact<{
  workOrderChangePriceId: Scalars['Long'];
  input: BimWorkOrderChangePriceRationaleUpdateInput;
}>;


export type BimUpdateWorkOrderChangePriceRationaleMutation = { __typename?: 'Mutation', bimUpdateWorkOrderChangePriceRationale: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderChangeOtherPricesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<BimWorkOrderChangeOtherPriceDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderChangeOtherPriceDataSortInput> | BimWorkOrderChangeOtherPriceDataSortInput>;
}>;


export type BimWorkOrderChangeOtherPricesQuery = { __typename?: 'Query', bimWorkOrderChangeOtherPrices?: { __typename?: 'BimWorkOrderChangeOtherPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderChangeOtherPriceData', workOrderOtherPriceId?: any | null, workOrderChangeOtherPriceId?: any | null, contractOtherCostId: any, name: string, calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, canExcludeRow: boolean, chapter?: ChapterEnum | null, section?: SectionEnum | null, status?: BimContractOtherStatusEnum | null, hasActAcceptedCost?: boolean | null, isActKC2Price: boolean, isAddedRow?: boolean | null, isRemovedRow?: boolean | null, isExcludedRow?: boolean | null, completedOtherDeviation?: DeviationEnum | null, rationale?: string | null, planValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, completedValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, remainderValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null }> | null } | null };

export type BimWorkOrderChangeOtherNameFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimWorkOrderChangeOtherNameFilterQuery = { __typename?: 'Query', bimWorkOrderChangeOtherNameFilter?: { __typename?: 'BimWorkOrderChangeOtherNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimRemoveWorkOrderChangeOthersMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceIds: Array<BimWorkOrderChangeOtherPriceIdsInput> | BimWorkOrderChangeOtherPriceIdsInput;
}>;


export type BimRemoveWorkOrderChangeOthersMutation = { __typename?: 'Mutation', bimRemoveWorkOrderChangeOthers: { __typename?: 'ServiceDataResultOfWorkOrderChangeModifyItemIds', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderChangeModifyItemIds', itemIds?: Array<any> | null, workOrderChangeId: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimExcludeWorkOrderChangeOtherMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId: BimWorkOrderChangeOtherPriceIdsInput;
}>;


export type BimExcludeWorkOrderChangeOtherMutation = { __typename?: 'Mutation', bimExcludeWorkOrderChangeOther: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChangePricesQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
  includeRows: Scalars['Boolean'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  where?: InputMaybe<BimWorkOrderChangePriceDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderChangePriceDataSortInput> | BimWorkOrderChangePriceDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderChangePricesQuery = { __typename?: 'Query', bimWorkOrderChangePrices?: { __typename?: 'BimWorkOrderChangePricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderChangePriceData', workOrderPriceId?: any | null, workOrderChangePriceId?: any | null, workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null, chapter: BimChapterEnum, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, hasRevisions: boolean, hasUpdates: boolean, isLimitPrice: boolean, isActKC2Price: boolean, isAddedRow?: boolean | null, isRemovedRow?: boolean | null, isExcludedRow?: boolean | null, hasActKC2: boolean, canRemoved: boolean, completedTotalDeviation?: DeviationEnum | null, rationale?: string | null, object: { __typename?: 'BimWorkOrderChangeObjectItem', workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null, contractObjectId: any, name: string }, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, priceRows?: Array<{ __typename?: 'BimWorkOrderChangePriceRowData', id: any, workOrderPriceId?: any | null, workOrderChangePriceId?: any | null, type: BimWorkOrderPriceRowTypeEnum, workOrderSectionId?: any | null, workOrderChangeSectionId?: any | null, sectionName?: string | null, value: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null }> | null } | null };

export type BimRemoveWorkOrderChangePricesMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  priceIds: Array<BimWorkOrderChangePriceIdsInput> | BimWorkOrderChangePriceIdsInput;
}>;


export type BimRemoveWorkOrderChangePricesMutation = { __typename?: 'Mutation', bimRemoveWorkOrderChangePrices: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChangePriceCodeFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimWorkOrderChangePriceCodeFilterQuery = { __typename?: 'Query', bimWorkOrderChangePriceCodeFilter?: { __typename?: 'BimWorkOrderChangePriceCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimWorkOrderChangePriceNameFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimWorkOrderChangePriceNameFilterQuery = { __typename?: 'Query', bimWorkOrderChangePriceNameFilter?: { __typename?: 'BimWorkOrderChangePriceNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimWorkOrderChangePriceObjectNameFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimWorkOrderChangePriceObjectNameFilterQuery = { __typename?: 'Query', bimWorkOrderChangePriceObjectNameFilter?: { __typename?: 'BimWorkOrderChangePriceObjectNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimWorkOrderChangePriceRationaleFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimWorkOrderChangePriceRationaleFilterQuery = { __typename?: 'Query', bimWorkOrderChangePriceRationaleFilter?: { __typename?: 'BimWorkOrderChangePriceRationaleFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type BimWorkOrderChangePriceRowsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  where?: InputMaybe<BimWorkOrderChangePriceRowDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderChangePriceRowDataSortInput> | BimWorkOrderChangePriceRowDataSortInput>;
}>;


export type BimWorkOrderChangePriceRowsQuery = { __typename?: 'Query', bimWorkOrderChangePriceRows?: { __typename?: 'BimWorkOrderChangePriceRowsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderChangePriceRowData', id: any, workOrderPriceId?: any | null, workOrderChangePriceId?: any | null, type: BimWorkOrderPriceRowTypeEnum, workOrderSectionId?: any | null, workOrderChangeSectionId?: any | null, sectionName?: string | null, value: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderChangePriceRevisionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  where?: InputMaybe<BimWorkOrderChangePriceRevisionDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderChangePriceRevisionDataSortInput> | BimWorkOrderChangePriceRevisionDataSortInput>;
}>;


export type BimWorkOrderChangePriceRevisionsQuery = { __typename?: 'Query', bimWorkOrderChangePriceRevisions?: { __typename?: 'BimWorkOrderChangePriceRevisionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderChangePriceRevisionData', workOrderPriceId?: any | null, workOrderChangePriceId?: any | null, isRevisionPrice?: boolean | null, isUpdatedPrice?: boolean | null, order?: number | null, priceUpdateDate?: any | null, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderChangeOtherSelectionListQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<BimWorkOrderChangeOtherSelectionDataFilterInput>;
}>;


export type BimWorkOrderChangeOtherSelectionListQuery = { __typename?: 'Query', bimWorkOrderChangeOtherSelectionList?: { __typename?: 'BimWorkOrderChangeOtherSelectionListCollectionSegment', items?: Array<{ __typename?: 'BimWorkOrderChangeOtherSelectionData', contractOtherCostId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum }> | null } | null };

export type BimAddWorkOrderChangeOthersMutationVariables = Exact<{
  input: BimWorkOrderChangeOtherInput;
}>;


export type BimAddWorkOrderChangeOthersMutation = { __typename?: 'Mutation', bimAddWorkOrderChangeOthers: { __typename?: 'ServiceDataResultOfWorkOrderChangeModifyItemIds', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderChangeModifyItemIds', itemIds?: Array<any> | null, workOrderChangeId: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUploadPriceFilesForWorkOrderChangeMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  chapter: BimChapterEnum;
  rationale: Scalars['String'];
  filesContent: Array<FileInput> | FileInput;
}>;


export type BimUploadPriceFilesForWorkOrderChangeMutation = { __typename?: 'Mutation', bimUploadPriceFilesForWorkOrderChange: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeTotalData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderChangeTotalData', itemIds?: Array<any> | null, workOrderChangeId: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimExportWorkOrderChangeQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimExportWorkOrderChangeQuery = { __typename?: 'Query', bimExportWorkOrderChange: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, code?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChangeQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeQuery = { __typename?: 'Query', bimWorkOrderChange: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeData', data?: { __typename?: 'BimWorkOrderChangeData', authoredBy: string, comment?: string | null, createdAt: any, id: any, internalNumber: string, signingDate?: any | null, status: WorkOrderChangeStatusEnum, statusFollowers: Array<WorkOrderChangeStatusEnum>, subject?: string | null, updatedAt?: any | null, workOrderId: any, seasons: Array<{ __typename?: 'BimWorkOrderChangeSeasonData', id?: any | null, workOrderSeason?: { __typename?: 'BimWorkOrderSeasonData', year: any } | null }>, seasonDistributions: Array<{ __typename?: 'BimWorkOrderChangeSeasonDistributionData', workOrderChangeSeasonId: any, seasonValue?: any | null }> } | null } };

export type BimWorkOrderChangeTotalsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  chapter?: InputMaybe<BimChapterEnum>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  useInPrices: Scalars['Boolean'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
  where?: InputMaybe<BimWorkOrderChangeTotalItemDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderChangeTotalItemDataSortInput> | BimWorkOrderChangeTotalItemDataSortInput>;
}>;


export type BimWorkOrderChangeTotalsQuery = { __typename?: 'Query', bimWorkOrderChangeTotals?: { __typename?: 'BimWorkOrderChangeTotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderChangeTotalItemData', name: string, quantity?: any | null, sortOrder: any, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null, nr?: any | null }, completedValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderChangeObjectSelectionListQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderChangeObjectSelectionDataSortInput> | BimWorkOrderChangeObjectSelectionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeObjectSelectionDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeObjectSelectionListQuery = { __typename?: 'Query', bimWorkOrderChangeObjectSelectionList?: { __typename?: 'BimWorkOrderChangeObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimWorkOrderChangeObjectSelectionData', fromWorkOrder: boolean, workOrderObjectId?: any | null, workOrderChangeId?: any | null, isActKC2Object: boolean, isIncluded: boolean, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, order: number, hasPrices: boolean, hasActsKC2: boolean, isInUse?: boolean | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimContractObjectSeasonDistributionData', id: any, seasonValue: any, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }> }> | null } | null };

export type BimWorkOrderChangeObjectSelectionListIsIncludedQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderChangeObjectSelectionDataSortInput> | BimWorkOrderChangeObjectSelectionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderChangeObjectSelectionDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeObjectSelectionListIsIncludedQuery = { __typename?: 'Query', bimWorkOrderChangeObjectSelectionList?: { __typename?: 'BimWorkOrderChangeObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimWorkOrderChangeObjectSelectionData', isIncluded: boolean, id: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null } | null };

export type BimWorkOrderChangeSeasonsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeSeasonsQuery = { __typename?: 'Query', bimWorkOrderChangeSeasons: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeSeasonsData', data?: { __typename?: 'BimWorkOrderChangeSeasonsData', firstSeason: { __typename?: 'BimWorkOrderChangeSeasonData', id?: any | null, workOrderSeason?: { __typename?: 'BimWorkOrderSeasonData', id: any, workOrderId: any, workOrderSeasonId: any, year: any } | null, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } }, lastSeason: { __typename?: 'BimWorkOrderChangeSeasonData', id?: any | null, workOrderSeason?: { __typename?: 'BimWorkOrderSeasonData', id: any, workOrderId: any, workOrderSeasonId: any, year: any } | null, contractSeason: { __typename?: 'BimContractSeasonData', id: any, year: any } } } | null } };

export type BimIncludeContractObjectToWorkOrderChangeMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
}>;


export type BimIncludeContractObjectToWorkOrderChangeMutation = { __typename?: 'Mutation', bimIncludeContractObjectToWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimExcludeContractObjectFromWorkOrderChangeMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
}>;


export type BimExcludeContractObjectFromWorkOrderChangeMutation = { __typename?: 'Mutation', bimExcludeContractObjectFromWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderChangeObjectMutationVariables = Exact<{
  input: BimContractObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type BimCreateWorkOrderChangeObjectMutation = { __typename?: 'Mutation', bimCreateWorkOrderChangeObject: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderChangeObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderChangeSubObjectMutationVariables = Exact<{
  input: BimContractSubObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type BimCreateWorkOrderChangeSubObjectMutation = { __typename?: 'Mutation', bimCreateWorkOrderChangeSubObject: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderChangeObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderChangeObjectMutationVariables = Exact<{
  input: BimContractObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type BimUpdateWorkOrderChangeObjectMutation = { __typename?: 'Mutation', bimUpdateWorkOrderChangeObject: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderChangeObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderChangeSubObjectMutationVariables = Exact<{
  input: BimContractSubObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type BimUpdateWorkOrderChangeSubObjectMutation = { __typename?: 'Mutation', bimUpdateWorkOrderChangeSubObject: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderChangeObjectData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateWorkOrderChangeSeasonsMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  contractSeasonId: Scalars['Long'];
}>;


export type BimUpdateWorkOrderChangeSeasonsMutation = { __typename?: 'Mutation', bimUpdateWorkOrderChangeSeasons: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeSeasonsData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderChangeLastSeasonSelectionListQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeLastSeasonSelectionListQuery = { __typename?: 'Query', bimWorkOrderChangeLastSeasonSelectionList: Array<{ __typename?: 'BimContractSeasonData', id: any, year: any }> };

export type BimWorkOrderChangeConstructionTypesQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimWorkOrderChangeConstructionTypesQuery = { __typename?: 'Query', bimWorkOrderChangeConstructionTypes: { __typename?: 'ServiceDataResultOfConstructionTypeData__', data?: Array<{ __typename?: 'ConstructionTypeData', name: string, id: number, catalogId: any, fullName: string } | null> | null } };

export type BimWorkOrderChangeDefaultsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimWorkOrderChangeDefaultsQuery = { __typename?: 'Query', bimWorkOrderChangeDefaults: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeDefaultData', data?: { __typename?: 'BimWorkOrderChangeDefaultData', authoredBy: string, createdAt: any, status: WorkOrderChangeStatusEnum, subject?: string | null, seasonDistributions: Array<{ __typename?: 'BimWorkOrderChangeSeasonDistributionDefaultData', seasonValue?: any | null, year: any }> } | null } };

export type BimIsUniqueWorkOrderChangeInternalNumberQueryVariables = Exact<{
  workOrderChangeId?: InputMaybe<Scalars['Long']>;
  workOrderId: Scalars['Long'];
  internalNumber: Scalars['String'];
}>;


export type BimIsUniqueWorkOrderChangeInternalNumberQuery = { __typename?: 'Query', bimIsUniqueWorkOrderChangeInternalNumber: { __typename?: 'ServiceResult', result: boolean } };

export type BimCreateWorkOrderChangeMutationVariables = Exact<{
  input: BimWorkOrderChangeCreateInput;
}>;


export type BimCreateWorkOrderChangeMutation = { __typename?: 'Mutation', bimCreateWorkOrderChange: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeData', message?: string | null, result: boolean, data?: { __typename?: 'BimWorkOrderChangeData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimUpdateWorkOrderChangeMutationVariables = Exact<{
  input: BimWorkOrderChangeUpdateInput;
}>;


export type BimUpdateWorkOrderChangeMutation = { __typename?: 'Mutation', bimUpdateWorkOrderChange: { __typename?: 'ServiceDataResultOfBimWorkOrderChangeData', message?: string | null, result: boolean, data?: { __typename?: 'BimWorkOrderChangeData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderVersionSeasonsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
}>;


export type BimWorkOrderVersionSeasonsQuery = { __typename?: 'Query', bimWorkOrderVersionSeasons: { __typename?: 'ServiceDataResultOfBimWorkOrderVersionSeasonsData', data?: { __typename?: 'BimWorkOrderVersionSeasonsData', firstSeason: { __typename?: 'BimWorkOrderVersionSeasonData', workOrderVersionId: any, id: any, year: any }, lastSeason: { __typename?: 'BimWorkOrderVersionSeasonData', workOrderVersionId: any, id: any, year: any } } | null } };

export type BimWorkOrderVersionConstructionTypesQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
}>;


export type BimWorkOrderVersionConstructionTypesQuery = { __typename?: 'Query', bimWorkOrderVersionConstructionTypes: { __typename?: 'ServiceDataResultOfConstructionTypeData__', data?: Array<{ __typename?: 'ConstructionTypeData', name: string, id: number, catalogId: any, fullName: string } | null> | null } };

export type BimActKc2VersionTotalsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2VersionId: Scalars['Long'];
  where?: InputMaybe<BimActKc2VersionTotalItemDataFilterInput>;
  order?: InputMaybe<Array<BimActKc2VersionTotalItemDataSortInput> | BimActKc2VersionTotalItemDataSortInput>;
}>;


export type BimActKc2VersionTotalsQuery = { __typename?: 'Query', bimActKC2VersionTotals?: { __typename?: 'BimActKC2VersionTotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2VersionTotalItemData', id: any, totalId?: any | null, workOrderVersionSeasonId?: any | null, workOrderVersionActiveSeasonId?: any | null, name: string, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, tzr?: any | null, sortOrder: any, parentId?: number | null, isInflation: boolean, isLimitPrice: boolean }> | null } | null };

export type BimActKc2VersionPriceRowsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2VersionId: Scalars['Long'];
  priceLevel: BimPriceLevelEnum;
  where?: InputMaybe<BimActKc2VersionPriceRowDataFilterInput>;
  order?: InputMaybe<Array<BimActKc2VersionPriceRowDataSortInput> | BimActKc2VersionPriceRowDataSortInput>;
}>;


export type BimActKc2VersionPriceRowsQuery = { __typename?: 'Query', bimActKC2VersionPriceRows?: { __typename?: 'BimActKC2VersionPriceRowsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2VersionPriceRowData', id: any, name: string, sectionId?: any | null, sectionName?: string | null, serialNumber: number, number?: string | null, code: string, unit?: string | null, quantity?: any | null, unitCost?: any | null, total?: any | null, inactiveMtr?: boolean | null }> | null } | null };

export type BimActsKc2VersionQueryVariables = Exact<{
  order?: InputMaybe<Array<BimActKc2VersionDataSortInput> | BimActKc2VersionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionDataFilterInput>;
  workOrderVersionPriceId: Scalars['Long'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimActsKc2VersionQuery = { __typename?: 'Query', bimActsKC2Version?: { __typename?: 'BimActsKC2VersionCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BimActKC2VersionData', id: any, calcMethod: BimActKc2TotalCalcMethodEnum, correctionDate?: any | null, currentPriceTotal?: any | null, workOrderVersionId: any, year: any, month: any, number: string, date: any, startDate: any, finishDate: any, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, value: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderVersionsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  order?: InputMaybe<Array<BimWorkOrderVersionListItemSortInput> | BimWorkOrderVersionListItemSortInput>;
}>;


export type BimWorkOrderVersionsQuery = { __typename?: 'Query', bimWorkOrderVersions: Array<{ __typename?: 'BimWorkOrderVersionListItem', workOrderVersionItem: { __typename?: 'BimWorkOrderVersionItem', id: any, internalNumber?: string | null, signingDate?: any | null }, workOrderChangeItem?: { __typename?: 'BimWorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null }> };

export type BimWorkOrderVersionQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
}>;


export type BimWorkOrderVersionQuery = { __typename?: 'Query', bimWorkOrderVersion: { __typename?: 'ServiceDataResultOfBimWorkOrderVersionData', data?: { __typename?: 'BimWorkOrderVersionData', id: any, amountWithoutTax?: any | null, tax?: any | null, remainder?: any | null, startDate?: any | null, finishDate?: any | null, status: WorkOrderStatusEnum, subject?: string | null, internalNumber?: string | null, signingDate?: any | null, contractor?: string | null, workOrderChangeNumber?: string | null, workOrderChangeSigningDate?: any | null, amountWithTax?: any | null, seasonDistributions?: Array<{ __typename?: 'BimWorkOrderVersionSeasonDistributionData', workOrderVersionSeasonId: any, year: any, seasonValue?: any | null }> | null } | null } };

export type BimWorkOrderVersionObjectsQueryVariables = Exact<{
  order?: InputMaybe<Array<BimWorkOrderVersionObjectDataSortInput> | BimWorkOrderVersionObjectDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimWorkOrderVersionObjectDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
}>;


export type BimWorkOrderVersionObjectsQuery = { __typename?: 'Query', bimWorkOrderVersionObjects?: { __typename?: 'BimWorkOrderVersionObjectsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderVersionObjectData', fromWorkOrder: boolean, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, workOrderVersionId: any, rationale?: string | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimWorkOrderVersionObjectSeasonDistributionData', id: any, seasonValue: any, season?: { __typename?: 'BimWorkOrderVersionSeasonData', id: any, workOrderVersionId: any, year: any } | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionOtherPricesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
  where?: InputMaybe<BimWorkOrderVersionOtherPriceDataFilterInput>;
  order?: InputMaybe<Array<BimWorkOrderVersionOtherPriceDataSortInput> | BimWorkOrderVersionOtherPriceDataSortInput>;
}>;


export type BimWorkOrderVersionOtherPricesQuery = { __typename?: 'Query', bimWorkOrderVersionOtherPrices?: { __typename?: 'BimWorkOrderVersionOtherPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderVersionOtherPriceData', id: any, contractOtherCostId: any, name: string, calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status?: BimContractOtherStatusEnum | null, isActKC2Price: boolean, hasEmptyActPlanCost?: boolean | null, hasEmptyActAcceptedCost?: boolean | null, completedOtherDeviation?: DeviationEnum | null, planValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, completedValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, remainderValue?: { __typename?: 'BimWorkOrderOtherPriceValueData', others?: any | null, total?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null } | null, actKC2OtherCosts: Array<{ __typename?: 'BimActKC2OtherCostData', actKC2Id: any, costPlan?: any | null, costAccepted?: any | null, comment?: string | null }> }> | null } | null };

export type BimWorkOrderVersionPriceRowsQueryVariables = Exact<{
  workOrderVersionPriceId: Scalars['Long'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimWorkOrderVersionPriceRowsQuery = { __typename?: 'Query', bimWorkOrderVersionPriceRows?: { __typename?: 'BimWorkOrderVersionPriceRowsCollectionSegment', items?: Array<{ __typename?: 'BimWorkOrderVersionPriceRowData', id: any, workOrderVersionId: any, workOrderVersionPriceId: any, type: BimWorkOrderPriceRowTypeEnum, sectionId?: any | null, sectionName?: string | null, value: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, name?: string | null, unit?: string | null, quantity?: any | null, smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, mz?: any | null, total?: any | null, oz?: any | null, tzr?: any | null } }> | null } | null };

export type BimWorkOrderVersionPriceRowCodeFilterQueryVariables = Exact<{
  workOrderVersionPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceRowCodeFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceRowCodeFilter?: { __typename?: 'BimWorkOrderVersionPriceRowCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPriceRowNameFilterQueryVariables = Exact<{
  workOrderVersionPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceRowNameFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceRowNameFilter?: { __typename?: 'BimWorkOrderVersionPriceRowNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPriceCodeFilterQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceCodeFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceCodeFilter?: { __typename?: 'BimWorkOrderVersionPriceCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPriceNameFilterQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceNameFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceNameFilter?: { __typename?: 'BimWorkOrderVersionPriceNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPriceObjectNameFilterQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionRootObjectId: Scalars['Long'];
  chapter: BimChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceObjectNameFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceObjectNameFilter?: { __typename?: 'BimWorkOrderVersionPriceObjectNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPriceRevisionNameFilterQueryVariables = Exact<{
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  workOrderVersionPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceRevisionNameFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceRevisionNameFilter?: { __typename?: 'BimWorkOrderVersionPriceRevisionNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimWorkOrderVersionPriceRevisionCodeFilterQueryVariables = Exact<{
  revisionType?: InputMaybe<WorkOrderPriceRevisionTypeEnum>;
  workOrderVersionPriceId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type BimWorkOrderVersionPriceRevisionCodeFilterQuery = { __typename?: 'Query', bimWorkOrderVersionPriceRevisionCodeFilter?: { __typename?: 'BimWorkOrderVersionPriceRevisionCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimActsKc2VersionOtherQueryVariables = Exact<{
  order?: InputMaybe<Array<BimActKc2VersionOtherItemDataSortInput> | BimActKc2VersionOtherItemDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimActKc2VersionOtherItemDataFilterInput>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimActsKc2VersionOtherQuery = { __typename?: 'Query', bimActsKC2VersionOther?: { __typename?: 'BimActsKC2VersionOtherCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimActKC2VersionOtherItemData', id: any, status: BimActKc2OtherStatusEnum, number?: number | null, date?: any | null, correctionDate?: any | null, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimActKc2VersionOtherTotalsQueryVariables = Exact<{
  actKC2VersionOtherId: Scalars['Long'];
}>;


export type BimActKc2VersionOtherTotalsQuery = { __typename?: 'Query', bimActKC2VersionOtherTotals?: { __typename?: 'BimActKC2VersionOtherTotalsCollectionSegment', items?: Array<{ __typename?: 'BimActKC2VersionOtherTotalItemData', id: any, workOrderVersionSeasonId?: any | null, isInflation: boolean, workOrderVersionActiveSeasonId?: any | null, name: string, total?: any | null, sortOrder: any }> | null } | null };

export type BimActKc2VersionOtherQueryVariables = Exact<{
  actKC2VersionOtherId: Scalars['Long'];
}>;


export type BimActKc2VersionOtherQuery = { __typename?: 'Query', bimActKC2VersionOther: { __typename?: 'ServiceDataResultOfBimActKC2VersionOtherData', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, data?: { __typename?: 'BimActKC2VersionOtherData', id: any, contractId: any, workOrderVersionId: any, status: BimActKc2OtherStatusEnum, number?: number | null, date?: any | null, startDate?: any | null, finishDate?: any | null, contractor: string, contractorAddress?: string | null, createdAt: any, updatedAt?: any | null, authoredBy?: string | null, updatedBy?: string | null, statusFollowers: Array<BimActKc2OtherStatusEnum>, hasPlanValues: boolean, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, workOrderVersionObject: { __typename?: 'BimWorkOrderVersionObjectData', workOrderVersionId: any, fromWorkOrder: boolean, id: any, contractId: any, parentId?: any | null, rootObjectId?: any | null, status: BimContractObjectStatusEnum, name: string, hasGuaranteedVolume?: boolean | null, rationale?: string | null, order: number, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, objectSeasonDistributions: Array<{ __typename?: 'BimWorkOrderVersionObjectSeasonDistributionData', id: any, seasonValue: any, season?: { __typename?: 'BimWorkOrderVersionSeasonData', id: any, workOrderVersionId: any, year: any } | null }> }, workOrderVersionSeason: { __typename?: 'BimWorkOrderVersionSeasonData', workOrderVersionId: any, id: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderVersionTotalsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  chapter?: InputMaybe<BimChapterEnum>;
  workOrderVersionObjectId?: InputMaybe<Scalars['Long']>;
  useInPrices: Scalars['Boolean'];
  priceLevel?: InputMaybe<BimPriceLevelEnum>;
}>;


export type BimWorkOrderVersionTotalsQuery = { __typename?: 'Query', bimWorkOrderVersionTotals?: { __typename?: 'BimWorkOrderVersionTotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimWorkOrderVersionTotalItemData', name: string, completedValue: { __typename?: 'BimWorkOrderPriceValue', smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, remainderValue: { __typename?: 'BimWorkOrderPriceValue', smrTotal?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mp?: any | null, nr?: any | null, sp?: any | null, op?: any | null, others?: any | null, total?: any | null, mz?: any | null, oz?: any | null, tzr?: any | null }, planValue: { __typename?: 'BimWorkOrderPriceValue', code?: string | null, emm?: any | null, mp?: any | null, mz?: any | null, name?: string | null, nr?: any | null, op?: any | null, others?: any | null, oz?: any | null, ozp?: any | null, quantity?: any | null, smrTotal?: any | null, sp?: any | null, total?: any | null, tzr?: any | null, unit?: string | null, zpm?: any | null } }> | null } | null };

export type BimWorkOrderVersionChapterPriceCountsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  workOrderVersionRootObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type BimWorkOrderVersionChapterPriceCountsQuery = { __typename?: 'Query', bimWorkOrderVersionChapterPriceCounts: { __typename?: 'ServiceDataResultOfBimWorkOrderVersionChapterData__', hideValidation?: boolean | null, hasValidation: boolean, result: boolean, message?: string | null, code?: string | null, data?: Array<{ __typename?: 'BimWorkOrderVersionChapterData', chapter: BimChapterEnum, pricesCount: number } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type BimWorkOrderVersionPriceStatesQueryVariables = Exact<{
  chapter: BimChapterEnum;
  workOrderVersionObjectId: Scalars['Long'];
}>;


export type BimWorkOrderVersionPriceStatesQuery = { __typename?: 'Query', bimWorkOrderVersionPriceStates: { __typename?: 'ServiceDataResultOfBimWorkOrderPriceStatesData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'BimWorkOrderPriceStatesData', hasExcessCompletedTotalSMR: boolean, hasExcessCompletedOthers: boolean } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderMutationVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type BimCreateWorkOrderMutation = { __typename?: 'Mutation', bimCreateWorkOrder: { __typename?: 'ServiceDataResultOfBimWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimWorkOrderData', id: any, isWorkOrderChangeRequired?: boolean | null, status: WorkOrderStatusEnum } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimRemoveWorkOrderMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type BimRemoveWorkOrderMutation = { __typename?: 'Mutation', bimRemoveWorkOrder: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimDeleteWorkOrderChangeMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type BimDeleteWorkOrderChangeMutation = { __typename?: 'Mutation', bimDeleteWorkOrderChange: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderUsersSelectionListCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderUsersSelectionListCodeFilterQuery = { __typename?: 'Query', uerWorkOrderUsersSelectionListCodeFilter?: { __typename?: 'UerWorkOrderUsersSelectionListCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderUsersSelectionListNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderUsersSelectionListNameFilterQuery = { __typename?: 'Query', uerWorkOrderUsersSelectionListNameFilter?: { __typename?: 'UerWorkOrderUsersSelectionListNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderUsersSelectionListGroupFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderUsersSelectionListGroupFilterQuery = { __typename?: 'Query', uerWorkOrderUsersSelectionListGroupFilter?: { __typename?: 'UerWorkOrderUsersSelectionListGroupFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderUsersSelectionListSectionFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderUsersSelectionListSectionFilterQuery = { __typename?: 'Query', uerWorkOrderUsersSelectionListSectionFilter?: { __typename?: 'UerWorkOrderUsersSelectionListSectionFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type GlobalOtherCostsForContractQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput> | GlobalOtherCostDataSortInput>;
}>;


export type GlobalOtherCostsForContractQuery = { __typename?: 'Query', uerGlobalOtherCostsForContract?: { __typename?: 'UerGlobalOtherCostsForContractCollectionSegment', items?: Array<{ __typename?: 'GlobalOtherCostData', id: any, name: string, methodology: ProjectMethodologyEnum, calculatingType: OtherCostCalculationTypeEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, isSystem: boolean, otherCostType: { __typename?: 'CatalogOtherCostTypeBase', name: string, id: number, uniqueId: string } }> | null } | null };

export type UerCreateContractOtherCostMutationVariables = Exact<{
  contractId: Scalars['Long'];
  createInput: ContractOtherCreateInput;
}>;


export type UerCreateContractOtherCostMutation = { __typename?: 'Mutation', uerCreateContractOtherCost: { __typename?: 'ServiceDataResultOfContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostData', id: any, name: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCreateContractOtherCostFromCatalogMutationVariables = Exact<{
  contractId: Scalars['Long'];
  createInput: ContractOtherCreateFromCatalogInput;
}>;


export type UerCreateContractOtherCostFromCatalogMutation = { __typename?: 'Mutation', uerCreateContractOtherCostFromCatalog: { __typename?: 'ServiceDataResultOfContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostData', id: any, name: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueContractOtherCostKeyQueryVariables = Exact<{
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  key?: InputMaybe<Scalars['String']>;
}>;


export type UerIsUniqueContractOtherCostKeyQuery = { __typename?: 'Query', uerIsUniqueContractOtherCostKey: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimGlobalOtherCostsForContractQueryVariables = Exact<{
  contractId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput> | GlobalOtherCostDataSortInput>;
}>;


export type BimGlobalOtherCostsForContractQuery = { __typename?: 'Query', bimGlobalOtherCostsForContract?: { __typename?: 'BimGlobalOtherCostsForContractCollectionSegment', items?: Array<{ __typename?: 'GlobalOtherCostData', id: any, name: string, methodology: ProjectMethodologyEnum, calculatingType: OtherCostCalculationTypeEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, isSystem: boolean, otherCostType: { __typename?: 'CatalogOtherCostTypeBase', uniqueId: string, id: number, name: string } }> | null } | null };

export type BimCreateContractConditionOtherCostMutationVariables = Exact<{
  input: BimContractConditionOtherCostInput;
}>;


export type BimCreateContractConditionOtherCostMutation = { __typename?: 'Mutation', bimCreateContractConditionOtherCost: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractOtherCostData', id: any, name: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderOtherFromCatalogMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  input: BimContractOtherCostFromCatalogInput;
}>;


export type BimCreateWorkOrderOtherFromCatalogMutation = { __typename?: 'Mutation', bimCreateWorkOrderOtherFromCatalog: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderOtherFromInputMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  input: BimContractOtherCostInput;
}>;


export type BimCreateWorkOrderOtherFromInputMutation = { __typename?: 'Mutation', bimCreateWorkOrderOtherFromInput: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderOtherFromCatalogForActMutationVariables = Exact<{
  input: BimContractOtherCostFromCatalogInput;
  workOrderObjectId: Scalars['Long'];
}>;


export type BimCreateWorkOrderOtherFromCatalogForActMutation = { __typename?: 'Mutation', bimCreateWorkOrderOtherFromCatalogForAct: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderOtherFromInputForActMutationVariables = Exact<{
  input: BimContractOtherCostInput;
  workOrderObjectId: Scalars['Long'];
}>;


export type BimCreateWorkOrderOtherFromInputForActMutation = { __typename?: 'Mutation', bimCreateWorkOrderOtherFromInputForAct: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderChangeOtherFromCatalogMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  input: BimContractOtherCostFromCatalogInput;
}>;


export type BimCreateWorkOrderChangeOtherFromCatalogMutation = { __typename?: 'Mutation', bimCreateWorkOrderChangeOtherFromCatalog: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimCreateWorkOrderChangeOtherFromInputMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  input: BimContractOtherCostInput;
}>;


export type BimCreateWorkOrderChangeOtherFromInputMutation = { __typename?: 'Mutation', bimCreateWorkOrderChangeOtherFromInput: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractOtherCostMutationVariables = Exact<{
  contractId: Scalars['Long'];
  updateInput: ContractOtherUpdateInput;
}>;


export type UerUpdateContractOtherCostMutation = { __typename?: 'Mutation', uerUpdateContractOtherCost: { __typename?: 'ServiceDataResultOfContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractOtherCostToWorkOrderFromPriceListMutationVariables = Exact<{
  input: ContractOtherUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type UerUpdateContractOtherCostToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerUpdateContractOtherCostToWorkOrderFromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractOtherCostFromCatalogMutationVariables = Exact<{
  contractId: Scalars['Long'];
  updateInput: ContractOtherUpdateInput;
}>;


export type UerUpdateContractOtherCostFromCatalogMutation = { __typename?: 'Mutation', uerUpdateContractOtherCostFromCatalog: { __typename?: 'ServiceDataResultOfContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateOtherCostToActKc2MutationVariables = Exact<{
  updateInput: ContractOtherUpdateInput;
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type UerUpdateOtherCostToActKc2Mutation = { __typename?: 'Mutation', uerUpdateOtherCostToActKC2: { __typename?: 'ServiceDataResultOfContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractOtherCostForUpdateQueryVariables = Exact<{
  contractId: Scalars['Long'];
  contractOtherCostId: Scalars['Long'];
  editConstructionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type UerContractOtherCostForUpdateQuery = { __typename?: 'Query', uerContractOtherCostForUpdate: { __typename?: 'ServiceDataResultOfContractOtherCostUpdateData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostUpdateData', key?: string | null, canUseOtherSpans: boolean, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, canEditSection: boolean, canDelete: boolean, canEdit: boolean, canEditCalculationType?: boolean | null, canEditCalculationTypeValue?: boolean | null, canEditLimits: boolean, canEditName?: boolean | null, canEditType?: boolean | null, catalogOtherCostTypeId?: number | null, chapter?: ChapterEnum | null, formula?: string | null, hasEmptyFormula?: boolean | null, hasEmptyOtherCostType?: boolean | null, id: any, isEditable?: boolean | null, isFormulaEditable: boolean, isGlobalOtherCost: boolean, isInUse: boolean, name: string, rationale?: string | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, id: number, isSystem: boolean, name: string, uniqueId: string } | null, groupConstructionLimits: Array<{ __typename?: 'ContractOtherCostGroupConstructionLimitData', canEditConstructionType: boolean, canEditCost: boolean, canEditDistributionMethod: boolean, canEditLimit: boolean, canEditLimitSpan: boolean, canExclude: boolean, cost: any, distributionMethod: LimitDistributionMethodEnum, hasActualCost: boolean, hasLimitSpan: boolean, isInUse: boolean, linkageStatus?: ContractOtherConstructionTypeRelationStatusEnum | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, limits: Array<{ __typename?: 'ContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, season: { __typename?: 'ContractSeasonData', id: any, year: any } }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractOtherCostTypesQueryVariables = Exact<{
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput> | CatalogOtherCostTypeDataSortInput>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type UerContractOtherCostTypesQuery = { __typename?: 'Query', uerContractOtherCostTypes?: { __typename?: 'UerContractOtherCostTypesCollectionSegment', items?: Array<{ __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, isSystem: boolean, canDelete: boolean }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimContractOtherCostQueryVariables = Exact<{
  contractOtherCostId: Scalars['Long'];
}>;


export type BimContractOtherCostQuery = { __typename?: 'Query', bimContractOtherCost: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractOtherCostData', formula?: string | null, id: any, contractId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, isGlobalOtherCost: boolean, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, isSystem: boolean } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimUpdateContractOtherCostMutationVariables = Exact<{
  input: BimContractOtherCostUpdateInput;
}>;


export type BimUpdateContractOtherCostMutation = { __typename?: 'Mutation', bimUpdateContractOtherCost: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractOtherCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractOtherCostTypesQueryVariables = Exact<{
  contractId: Scalars['Long'];
  contractOtherCostId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput> | CatalogOtherCostTypeDataSortInput>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type BimContractOtherCostTypesQuery = { __typename?: 'Query', bimContractOtherCostTypes?: { __typename?: 'BimContractOtherCostTypesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, isSystem: boolean, canDelete: boolean }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimModifyContractOtherCostMutationVariables = Exact<{
  input: BimContractOtherCostModifyInput;
}>;


export type BimModifyContractOtherCostMutation = { __typename?: 'Mutation', bimModifyContractOtherCost: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'BimContractOtherCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerModifyContractOtherCostMutationVariables = Exact<{
  input: ContractOtherModifyInput;
}>;


export type UerModifyContractOtherCostMutation = { __typename?: 'Mutation', uerModifyContractOtherCost: { __typename?: 'ServiceDataResultOfContractOtherCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractOtherCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractOtherCostViewQueryVariables = Exact<{
  contractOtherCostId: Scalars['Long'];
}>;


export type BimContractOtherCostViewQuery = { __typename?: 'Query', bimContractOtherCost: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', data?: { __typename?: 'BimContractOtherCostData', calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, formula?: string | null, isGlobalOtherCost: boolean, name: string, status: BimContractOtherStatusEnum, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, canDelete: boolean, isSystem: boolean } | null } | null } };

export type BimWorkOrderOtherDataViewQueryVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type BimWorkOrderOtherDataViewQuery = { __typename?: 'Query', bimWorkOrderOtherData: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', data?: { __typename?: 'BimContractOtherCostData', calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, formula?: string | null, isGlobalOtherCost: boolean, name: string, status: BimContractOtherStatusEnum, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, canDelete: boolean, isSystem: boolean } | null } | null } };

export type BimWorkOrderVersionOtherDataQueryVariables = Exact<{
  workOrderVersionOtherPriceId: Scalars['Long'];
}>;


export type BimWorkOrderVersionOtherDataQuery = { __typename?: 'Query', bimWorkOrderVersionOtherData: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', data?: { __typename?: 'BimContractOtherCostData', calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, formula?: string | null, isGlobalOtherCost: boolean, name: string, status: BimContractOtherStatusEnum, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, canDelete: boolean, isSystem: boolean } | null } | null } };

export type UerContractOtherCostViewQueryVariables = Exact<{
  contractId: Scalars['Long'];
  contractOtherCostId: Scalars['Long'];
}>;


export type UerContractOtherCostViewQuery = { __typename?: 'Query', uerContractOtherCostForUpdate: { __typename?: 'ServiceDataResultOfContractOtherCostUpdateData', data?: { __typename?: 'ContractOtherCostUpdateData', key?: string | null, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, isGlobalOtherCost: boolean, name: string, status: ContractOtherStatusEnum, formula?: string | null, groupConstructionLimits: Array<{ __typename?: 'ContractOtherCostGroupConstructionLimitData', cost: any, distributionMethod: LimitDistributionMethodEnum, canEditLimitSpan: boolean, hasActualCost: boolean, hasLimitSpan: boolean, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, limits: Array<{ __typename?: 'ContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, shortName: string, name: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, season: { __typename?: 'ContractSeasonData', id: any, year: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, isSystem: boolean } | null } | null } };

export type BimWorkOrderChangeOtherDataViewQueryVariables = Exact<{
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type BimWorkOrderChangeOtherDataViewQuery = { __typename?: 'Query', bimWorkOrderChangeOtherData: { __typename?: 'ServiceDataResultOfBimContractOtherCostData', data?: { __typename?: 'BimContractOtherCostData', name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, formula?: string | null, isGlobalOtherCost: boolean, status: BimContractOtherStatusEnum, otherCostLimits: Array<{ __typename?: 'BimContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, uniqueId: string, name: string, canDelete: boolean, isSystem: boolean } | null } | null } };

export type GetUerContractHasOthersQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type GetUerContractHasOthersQuery = { __typename?: 'Query', uerContract: { __typename?: 'ServiceDataResultOfUerContractData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UerContractData', hasOthers: boolean } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractOtherCostsQueryVariables = Exact<{
  contractId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput> | ContractOtherCostItemDataSortInput>;
}>;


export type UerContractOtherCostsQuery = { __typename?: 'Query', uerContractOtherCosts?: { __typename?: 'UerContractOtherCostsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ContractOtherCostItemData', key?: string | null, isInUse: boolean, canDelete: boolean, canEdit: boolean, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, constructionTypeId: number, contractId: any, id: any, isGlobalOtherCost: boolean, isIncludedInActKc2?: boolean | null, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, name: string, section?: SectionEnum | null, status: ContractOtherStatusEnum, isEditable?: boolean | null, hasEmptyFormula?: boolean | null, hasEmptyOtherCostType?: boolean | null, constructionTypeLimits: Array<{ __typename?: 'ConstructionTypeLimitData', relationStatus: ContractOtherConstructionTypeRelationStatusEnum }>, seasonLimits: Array<{ __typename?: 'ContractOtherCostSeasonLimitData', cost: any, seasonId: any }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerDeleteContractOtherCostMutationVariables = Exact<{
  contractOtherCostId: Scalars['Long'];
}>;


export type UerDeleteContractOtherCostMutation = { __typename?: 'Mutation', uerDeleteContractOtherCost: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, id?: any | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractOtherCostsQueryVariables = Exact<{
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BimContractOtherCostItemDataFilterInput>;
  order?: InputMaybe<Array<BimContractOtherCostItemDataSortInput> | BimContractOtherCostItemDataSortInput>;
}>;


export type BimContractOtherCostsQuery = { __typename?: 'Query', bimContractOtherCosts?: { __typename?: 'BimContractOtherCostsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BimContractOtherCostItemData', constructionTypeId: number, cost: any, isIncludedInWorkOrder?: boolean | null, isIncludedInActKc2?: boolean | null, id: any, contractId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: BimContractOtherStatusEnum, isGlobalOtherCost: boolean, isIncludedInWorkOrderChange?: boolean | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BimDeleteContractOtherCostMutationVariables = Exact<{
  contractOtherCostId: Scalars['Long'];
}>;


export type BimDeleteContractOtherCostMutation = { __typename?: 'Mutation', bimDeleteContractOtherCost: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, id?: any | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractOtherCostNameFilterQueryVariables = Exact<{
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type BimContractOtherCostNameFilterQuery = { __typename?: 'Query', bimContractOtherCostNameFilter?: { __typename?: 'BimContractOtherCostNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerRemoveUnusedContractOtherCostsMutationVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerRemoveUnusedContractOtherCostsMutation = { __typename?: 'Mutation', uerRemoveUnusedContractOtherCosts: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractOtherCostNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerContractOtherCostNameFilterQuery = { __typename?: 'Query', uerContractOtherCostNameFilter?: { __typename?: 'UerContractOtherCostNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractOtherCostCalculatingTypeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfOtherCostCalculationTypeEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfOtherCostCalculationTypeEnumSortInput> | FilterValueOfOtherCostCalculationTypeEnumSortInput>;
}>;


export type UerContractOtherCostCalculatingTypeFilterQuery = { __typename?: 'Query', uerContractOtherCostCalculatingTypeFilter?: { __typename?: 'UerContractOtherCostCalculatingTypeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfOtherCostCalculationTypeEnum', value: OtherCostCalculationTypeEnum }> | null } | null };

export type UerContractOtherCostStatusFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfContractOtherStatusEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfContractOtherStatusEnumSortInput> | FilterValueOfContractOtherStatusEnumSortInput>;
}>;


export type UerContractOtherCostStatusFilterQuery = { __typename?: 'Query', uerContractOtherCostStatusFilter?: { __typename?: 'UerContractOtherCostStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfContractOtherStatusEnum', value: ContractOtherStatusEnum }> | null } | null };

export type UerContractOtherRelationStatusFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfContractOtherConstructionTypeRelationStatusEnumSortInput> | FilterValueOfContractOtherConstructionTypeRelationStatusEnumSortInput>;
}>;


export type UerContractOtherRelationStatusFilterQuery = { __typename?: 'Query', uerContractOtherRelationStatusFilter?: { __typename?: 'UerContractOtherRelationStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfContractOtherConstructionTypeRelationStatusEnum', value: ContractOtherConstructionTypeRelationStatusEnum }> | null } | null };

export type UerContractConstructionTypesQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerContractConstructionTypesQuery = { __typename?: 'Query', uerContractConstructionTypes: { __typename?: 'ServiceDataResultOfConstructionTypeData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'ConstructionTypeData', id: number, name: string, code: string, shortName: string, catalogId: any, fullName: string } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimContractConstructionTypesQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type BimContractConstructionTypesQuery = { __typename?: 'Query', bimContractConstructionTypes: { __typename?: 'ServiceDataResultOfConstructionTypeData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'ConstructionTypeData', id: number, name: string, shortName: string, code: string, catalogId: any, fullName: string } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CatalogOtherCostVariableSelectionItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  methodology: ProjectMethodologyEnum;
  globalOnly: Scalars['Boolean'];
}>;


export type CatalogOtherCostVariableSelectionItemsQuery = { __typename?: 'Query', catalogOtherCostVariableSelectionItems?: { __typename?: 'CatalogOtherCostVariableSelectionItemsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'CatalogOtherCostVariableISelectionItemData', uniqueId: string, name: string, entityUniqueId: string, entityName: string, dataSourceId?: string | null, dataSourceName?: string | null, type: CatalogOtherCostVariableTypeEnum, otherTypeUniqueId?: string | null, isGlobal: boolean }> | null } | null };

export type GetContractSeasonsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type GetContractSeasonsQuery = { __typename?: 'Query', uerContractSeasons: { __typename?: 'ServiceDataResultOfContractSeasonData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'ContractSeasonData', id: any, year: any } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerExportWorkOrderChangeAsExcelQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type UerExportWorkOrderChangeAsExcelQuery = { __typename?: 'Query', uerExportWorkOrderChangeAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimExportWorkOrderChangeAnalyticsAsExcelQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderVersionId: Scalars['Long'];
}>;


export type BimExportWorkOrderChangeAnalyticsAsExcelQuery = { __typename?: 'Query', bimExportWorkOrderChangeAnalyticsAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type BimWorkOrderChangePreviousVersionsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  order?: InputMaybe<Array<BimWorkOrderVersionListItemSortInput> | BimWorkOrderVersionListItemSortInput>;
}>;


export type BimWorkOrderChangePreviousVersionsQuery = { __typename?: 'Query', bimWorkOrderChangePreviousVersionsAsync?: { __typename?: 'BimWorkOrderChangePreviousVersionsAsyncCollectionSegment', items?: Array<{ __typename?: 'BimWorkOrderVersionListItem', workOrderVersionItem: { __typename?: 'BimWorkOrderVersionItem', id: any, internalNumber?: string | null, signingDate?: any | null }, workOrderChangeItem?: { __typename?: 'BimWorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null }> | null } | null };

export type UerExportWorkOrderChangeAnalyticsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderVersionId: Scalars['Long'];
}>;


export type UerExportWorkOrderChangeAnalyticsQuery = { __typename?: 'Query', uerExportWorkOrderChangeAnalytics: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangePreviousVersionsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  order?: InputMaybe<Array<WorkOrderVersionListItemSortInput> | WorkOrderVersionListItemSortInput>;
}>;


export type UerWorkOrderChangePreviousVersionsQuery = { __typename?: 'Query', uerWorkOrderChangePreviousVersions: Array<{ __typename?: 'WorkOrderVersionListItem', workOrderVersionItem: { __typename?: 'WorkOrderVersionItem', id: any, internalNumber?: string | null, signingDate?: any | null, status: WorkOrderStatusEnum }, workOrderChangeItem?: { __typename?: 'WorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null }> };

export type CopyProjectMutationVariables = Exact<{
  uniqueId: Scalars['String'];
}>;


export type CopyProjectMutation = { __typename?: 'Mutation', copyProject: { __typename?: 'ServiceDataResultOfProjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'ProjectData', uniqueId: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String'];
  stage: ProjectStageEnum;
  status: ProjectStatusEnum;
  methodology: ProjectMethodologyEnum;
  contractType: ProjectContractTypeEnum;
  code?: InputMaybe<Scalars['String']>;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'ServiceDataResultOfProjectData', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ProjectData', uniqueId: string, methodology: ProjectMethodologyEnum, name: string, contractType?: ProjectContractTypeEnum | null, stage: ProjectStageEnum, subsidiary?: { __typename?: 'CompanyData', name: string } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type ProjectsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectItemDataFilterInput>;
  order?: InputMaybe<Array<ProjectItemDataSortInput> | ProjectItemDataSortInput>;
}>;


export type ProjectsQuery = { __typename?: 'Query', projects?: { __typename?: 'ProjectsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'ProjectItemData', uniqueId: string, priceNMC?: any | null, lotPrice?: any | null, actualPrice?: any | null, createdAt: any, updatedAt?: any | null, authoredBy: string, name: string, isOwn: boolean, subsidiaryId?: any | null, subsidiaryName?: string | null, stage: ProjectStageEnum, status: ProjectStatusEnum, methodology: ProjectMethodologyEnum, contractType?: ProjectContractTypeEnum | null, contractUniqueId?: string | null }> | null } | null };

export type ProjectsNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type ProjectsNameFilterQuery = { __typename?: 'Query', projectsNameFilter?: { __typename?: 'ProjectsNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type ProjectsMethodologyFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfProjectMethodologyEnumFilterInput>;
}>;


export type ProjectsMethodologyFilterQuery = { __typename?: 'Query', projectsMethodologyFilter?: { __typename?: 'ProjectsMethodologyFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfProjectMethodologyEnum', value: ProjectMethodologyEnum }> | null } | null };

export type ProjectsStageFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfProjectStageEnumFilterInput>;
}>;


export type ProjectsStageFilterQuery = { __typename?: 'Query', projectsStageFilter?: { __typename?: 'ProjectsStageFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfProjectStageEnum', value: ProjectStageEnum }> | null } | null };

export type ProjectsStatusFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfProjectStatusEnumFilterInput>;
}>;


export type ProjectsStatusFilterQuery = { __typename?: 'Query', projectsStatusFilter?: { __typename?: 'ProjectsStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfProjectStatusEnum', value: ProjectStatusEnum }> | null } | null };

export type ProjectsAuthoredByFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type ProjectsAuthoredByFilterQuery = { __typename?: 'Query', projectsAuthoredByFilter?: { __typename?: 'ProjectsAuthoredByFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type ProjectsSubsidiaryFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfCompanyDataFilterInput>;
}>;


export type ProjectsSubsidiaryFilterQuery = { __typename?: 'Query', projectsSubsidiaryFilter?: { __typename?: 'ProjectsSubsidiaryFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfCompanyData', value?: { __typename?: 'CompanyData', id: any, name: string } | null }> | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  uniqueId: Scalars['String'];
  name: Scalars['String'];
  stage: ProjectStageEnum;
  status: ProjectStatusEnum;
  contractType?: InputMaybe<ProjectContractTypeEnum>;
  code?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'ServiceDataResultOfProjectData', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ProjectData', uniqueId: string, name: string, stage: ProjectStageEnum, status: ProjectStatusEnum, methodology: ProjectMethodologyEnum, createdAt: any, authoredBy: string, subsidiary?: { __typename?: 'CompanyData', id: any, name: string } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type IsUniqueProjectCodeQueryVariables = Exact<{
  uniqueId?: InputMaybe<Scalars['String']>;
  projectCode: Scalars['String'];
}>;


export type IsUniqueProjectCodeQuery = { __typename?: 'Query', isUniqueProjectCode: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractActsKc3QueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<ActKc3RegistryItemFilterInput>;
  order?: InputMaybe<Array<ActKc3RegistryItemSortInput> | ActKc3RegistryItemSortInput>;
}>;


export type UerContractActsKc3Query = { __typename?: 'Query', uerContractActsKC3?: { __typename?: 'UerContractActsKC3CollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC3RegistryItem', actKC2Date?: any | null, actKC2FullNumber?: string | null, actKC2Id: any, actKC2ReportingFinishDate?: any | null, actKC2ReportingStartDate?: any | null, actKC2Status: ActKc2StatusEnum, actKC2TotalCost?: any | null, actKC2TotalCostWithTax?: any | null, actKC3CanDelete?: boolean | null, actKC3CanEdit?: boolean | null, actKC3CorrectionNumber?: any | null, actKC3Date?: any | null, actKC3FromWorkStartCost?: any | null, actKC3FromYearStartCost?: any | null, actKC3FullNumber?: string | null, actKC3Id: any, actKC3IsCorrection?: boolean | null, actKC3IsInactive?: boolean | null, actKC3Number?: any | null, actKC3ReportedPeriodCost?: any | null, actKC3ReportingFinishDate?: any | null, actKC3ReportingStartDate?: any | null, actKC3TotalCostWithTax?: any | null, contractId: any, isFinal: boolean, rootContractObjectId?: any | null, workOrderId?: any | null }> | null } | null };

export type UerContractActsKc3FullNumberFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractActsKc3FullNumberFilterQuery = { __typename?: 'Query', uerContractActsKC3FullNumberFilter?: { __typename?: 'UerContractActsKC3FullNumberFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractActsKc3DateFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
}>;


export type UerContractActsKc3DateFilterQuery = { __typename?: 'Query', uerContractActsKC3DateFilter?: { __typename?: 'UerContractActsKC3DateFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDateOnly', value?: any | null }> | null } | null };

export type UerRemoveActsKc3MutationVariables = Exact<{
  contractId: Scalars['Long'];
  actKC3Ids: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveActsKc3Mutation = { __typename?: 'Mutation', uerRemoveActsKC3: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractCommonDataQueryVariables = Exact<{
  contractUniqueId: Scalars['String'];
}>;


export type UerContractCommonDataQuery = { __typename?: 'Query', uerContractCommonData: { __typename?: 'ServiceDataResultOfContractCommonData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UER_ContractCommonData', contractNavigation: { __typename?: 'UerContractNavigationData', workOrderNavs?: Array<{ __typename?: 'UerWorkOrderNavData', id?: any | null, internalNumber: string, name: string, signingDate?: any | null, status: WorkOrderStatusEnum, actKC2Navs?: Array<{ __typename?: 'ActKC2NavData', id: any, status: ActKc2StatusEnum }> | null }> | null } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerChangeActKc3LevelMutationVariables = Exact<{
  actKC3Level: ActKc3LevelEnum;
  contractId: Scalars['Long'];
}>;


export type UerChangeActKc3LevelMutation = { __typename?: 'Mutation', uerChangeActKC3Level: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc3TotalsQueryVariables = Exact<{
  actKC3Id: Scalars['Long'];
}>;


export type UerActKc3TotalsQuery = { __typename?: 'Query', uerActKC3Totals: { __typename?: 'ServiceDataResultOfActKC3TotalData__', data?: Array<{ __typename?: 'ActKC3TotalData', name: string, isHeadLine: boolean, startWorkCost?: any | null, startYearCost?: any | null, reportingPeriodCost?: any | null, isOtherCost: boolean, totalType?: UerTotal_AlcTypeEnum | null } | null> | null } };

export type UerIsUniqueActKc3InternalNumberQueryVariables = Exact<{
  actKC3Id?: InputMaybe<Scalars['Long']>;
  actKC3Number: Scalars['Long'];
  contractId: Scalars['Long'];
}>;


export type UerIsUniqueActKc3InternalNumberQuery = { __typename?: 'Query', uerIsUniqueActKC3InternalNumber: { __typename?: 'ServiceResult', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCreateActKc3MutationVariables = Exact<{
  actKC3Input: ActKc3Input;
}>;


export type UerCreateActKc3Mutation = { __typename?: 'Mutation', uerCreateActKC3: { __typename?: 'ServiceDataResultOfActKC3Data', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ActKC3Data', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateActKc3MutationVariables = Exact<{
  actKC3Input: ActKc3UpdateInput;
}>;


export type UerUpdateActKc3Mutation = { __typename?: 'Mutation', uerUpdateActKC3: { __typename?: 'ServiceDataResultOfActKC3Data', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ActKC3Data', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc3ActsKc2SelectionListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<ActKc3ActsKc2SelectionItemFilterInput>;
  order?: InputMaybe<Array<ActKc3ActsKc2SelectionItemSortInput> | ActKc3ActsKc2SelectionItemSortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2SelectionListQuery = { __typename?: 'Query', uerActKC3ActsKC2SelectionList?: { __typename?: 'UerActKC3ActsKC2SelectionListCollectionSegment', items?: Array<{ __typename?: 'ActKC3ActsKC2SelectionItem', actKC2CorrectionNumber?: any | null, actKC2CostGroup: CostGroupEnum, actKC2Date?: any | null, actKC2FinishDate?: any | null, actKC2FullNumber: string, actKC2Id: any, actKC2IsCorrection?: boolean | null, actKC2IsCorrectionOfActKC3: boolean, actKC2IsIncludedToPrimaryActKC3?: boolean | null, actKC2IsInactive?: boolean | null, actKC2Number?: any | null, actKC2StartDate?: any | null, actKC2Status: ActKc2StatusEnum, constructionTypeId: number, constructionTypeName: string, constructionTypeShortName: string, contractId: any, contractObjectId?: any | null, contractObjectName: string, isSelected: boolean, workOrderDate?: any | null, workOrderId: any, workOrderInternalNumber?: string | null, workOrderName?: string | null, workOrderObjectId: any, workOrderStatus: WorkOrderStatusEnum, workOrderSubject?: string | null }> | null } | null };

export type UerActKc3QueryVariables = Exact<{
  actKC3Id: Scalars['Long'];
}>;


export type UerActKc3Query = { __typename?: 'Query', uerActKC3: { __typename?: 'ServiceDataResultOfActKC3Data', data?: { __typename?: 'ActKC3Data', id: any, contractId: any, number?: any | null, date?: any | null, reportingStartDate?: any | null, reportingFinishDate?: any | null, actKC2Ids?: Array<any> | null, isCorrection?: boolean | null, isInactive?: boolean | null, correctionNumber?: any | null, fullNumber?: string | null } | null } };

export type UerExportActKc3AsExcelQueryVariables = Exact<{
  actKC3Id: Scalars['Long'];
  includeOtherDetails: Scalars['Boolean'];
}>;


export type UerExportActKc3AsExcelQuery = { __typename?: 'Query', uerExportActKC3AsExcel: { __typename?: 'ServiceDataResultOfFileContent', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc3ActsKc2ActKc2NumberFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueContainerOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueContainerOfStringSortInput> | FilterValueContainerOfStringSortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2ActKc2NumberFilterQuery = { __typename?: 'Query', uerActKC3ActsKC2ActKC2NumberFilter?: { __typename?: 'UerActKC3ActsKC2ActKC2NumberFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueContainerOfString', id: any, value?: string | null }> | null } | null };

export type UerActKc3ActsKc2ActKc2DateFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfDateOnlySortInput> | FilterValueOfNullableOfDateOnlySortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2ActKc2DateFilterQuery = { __typename?: 'Query', uerActKC3ActsKC2ActKC2DateFilter?: { __typename?: 'UerActKC3ActsKC2ActKC2DateFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDateOnly', value?: any | null }> | null } | null };

export type UerActKc3ActsKc2ActKc2CostGroupFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfCostGroupEnumSortInput> | FilterValueOfCostGroupEnumSortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2ActKc2CostGroupFilterQuery = { __typename?: 'Query', uerActKC3ActsKC2ActKC2CostGroupFilter?: { __typename?: 'UerActKC3ActsKC2ActKC2CostGroupFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfCostGroupEnum', value: CostGroupEnum }> | null } | null };

export type UerActKc3ActsKc2ConstructionTypeIdFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfInt32FilterInput>;
  order?: InputMaybe<Array<FilterValueOfInt32SortInput> | FilterValueOfInt32SortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2ConstructionTypeIdFilterQuery = { __typename?: 'Query', uerActKC3ActsKC2ConstructionTypeIdFilter?: { __typename?: 'UerActKC3ActsKC2ConstructionTypeIdFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfInt32', value: number }> | null } | null };

export type UerActKc3ActsKc2ContractObjectNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2ContractObjectNameFilterQuery = { __typename?: 'Query', uerActKC3ActsKC2ContractObjectNameFilter?: { __typename?: 'UerActKC3ActsKC2ContractObjectNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerActKc3ActsKc2WorkOrderInternalNumberFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  actKC3Id?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  rootContractObjectId?: InputMaybe<Scalars['Long']>;
  workOrderId?: InputMaybe<Scalars['Long']>;
}>;


export type UerActKc3ActsKc2WorkOrderInternalNumberFilterQuery = { __typename?: 'Query', uerActKC3ActsKC2WorkOrderInternalNumberFilter?: { __typename?: 'UerActKC3ActsKC2WorkOrderInternalNumberFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerIsValidActKc3DateQueryVariables = Exact<{
  actKC3Id: Scalars['Long'];
  date: Scalars['Date'];
}>;


export type UerIsValidActKc3DateQuery = { __typename?: 'Query', uerIsValidActKC3Date: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListRatioForIncludingToContractChangeCodeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  ratioCode: Scalars['String'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioForIncludingToContractChangeCodeFilterQuery = { __typename?: 'Query', uerPriceListRatioForIncludingToContractChangeCodeFilter?: { __typename?: 'UerPriceListRatioForIncludingToContractChangeCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioForIncludingToContractChangeNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  ratioCode: Scalars['String'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioForIncludingToContractChangeNameFilterQuery = { __typename?: 'Query', uerPriceListRatioForIncludingToContractChangeNameFilter?: { __typename?: 'UerPriceListRatioForIncludingToContractChangeNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioForIncludingToContractChangeStatusFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  ratioCode: Scalars['String'];
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
}>;


export type UerPriceListRatioForIncludingToContractChangeStatusFilterQuery = { __typename?: 'Query', uerPriceListRatioForIncludingToContractChangeStatusFilter?: { __typename?: 'UerPriceListRatioForIncludingToContractChangeStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfRatioRecordStatusEnum', value: RatioRecordStatusEnum }> | null } | null };

export type UerContractChangesQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<ContractChangeItemDataFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<ContractChangeItemDataSortInput> | ContractChangeItemDataSortInput>;
}>;


export type UerContractChangesQuery = { __typename?: 'Query', uerContractChanges?: { __typename?: 'UerContractChangesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ContractChangeItemData', id: any, status: ContractChangeStatusEnum, subject?: string | null, signingDate?: any | null, internalNumber?: string | null, createdAt: any, uerRowCount?: number | null, mtrRowCount?: number | null, ratioRowCount?: number | null }> | null } | null };

export type UerContractChangeSubjectFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeSubjectFilterQuery = { __typename?: 'Query', uerContractChangeSubjectFilter?: { __typename?: 'UerContractChangeSubjectFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeInternalNumberFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeInternalNumberFilterQuery = { __typename?: 'Query', uerContractChangeInternalNumberFilter?: { __typename?: 'UerContractChangeInternalNumberFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeSigningDateFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDateTimeFilterInput>;
}>;


export type UerContractChangeSigningDateFilterQuery = { __typename?: 'Query', uerContractChangeSigningDateFilter?: { __typename?: 'UerContractChangeSigningDateFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDateTime', value?: any | null }> | null } | null };

export type UerContractChangeCreatedAtFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfDateTimeFilterInput>;
}>;


export type UerContractChangeCreatedAtFilterQuery = { __typename?: 'Query', uerContractChangeCreatedAtFilter?: { __typename?: 'UerContractChangeCreatedAtFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfDateTime', value: any }> | null } | null };

export type UerContractChangeStatusFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfContractChangeStatusEnumFilterInput>;
}>;


export type UerContractChangeStatusFilterQuery = { __typename?: 'Query', uerContractChangeStatusFilter?: { __typename?: 'UerContractChangeStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfContractChangeStatusEnum', value?: ContractChangeStatusEnum | null }> | null } | null };

export type UerCreateContractChangeMutationVariables = Exact<{
  input: ContractChangeInput;
}>;


export type UerCreateContractChangeMutation = { __typename?: 'Mutation', uerCreateContractChange: { __typename?: 'ServiceDataResultOfContractChangeData', buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, result: boolean, message?: string | null, data?: { __typename?: 'ContractChangeData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractChangeMutationVariables = Exact<{
  contractChangeInput: ContractChangeUpdateInput;
}>;


export type UerUpdateContractChangeMutation = { __typename?: 'Mutation', uerUpdateContractChange: { __typename?: 'ServiceDataResultOfContractChangeData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractChangeData', id: any, status: ContractChangeStatusEnum } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractChangeQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeQuery = { __typename?: 'Query', uerContractChange: { __typename?: 'ServiceDataResultOfContractChangeData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractChangeData', id: any, contractId: any, status: ContractChangeStatusEnum, statusFollowers: Array<ContractChangeStatusEnum>, subject?: string | null, signingDate?: any | null, internalNumber?: string | null, createdAt: any, uerRowCount?: number | null, mtrRowCount?: number | null, otherRowCount?: number | null, ratioRowCount?: number | null, authoredBy: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerDeleteContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerDeleteContractChangeMutation = { __typename?: 'Mutation', uerDeleteContractChange: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueContractChangeInternalNumberQueryVariables = Exact<{
  contractChangeId?: InputMaybe<Scalars['Long']>;
  number: Scalars['String'];
  contractId: Scalars['Long'];
}>;


export type UerIsUniqueContractChangeInternalNumberQuery = { __typename?: 'Query', uerIsUniqueContractChangeInternalNumber: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractChangePriceListMtrQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
}>;


export type UerContractChangePriceListMtrQuery = { __typename?: 'Query', uerContractChangePriceListMtr?: { __typename?: 'UerContractChangePriceListMtrCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListMtrRowData', id: any, contractId: any, code: string, name: string, unit: string, volume?: any | null, unitWeight?: any | null, unitCost: any, supplyBy?: ContragentTypeEnum | null, supplyBasis?: string | null, mtrType?: MtrTypeEnum | null, pricingType: PricingTypeEnum, note?: string | null, status: MtrRecordStatusEnum, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, mtrSupplyAndType: MtrSupplyAndTypeEnum, hasDuplicateNeighbours: boolean }> | null } | null };

export type UerAddMtrsToContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  mtrRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddMtrsToContractChangeMutation = { __typename?: 'Mutation', uerAddMtrsToContractChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListMtrForIncludingToContractChangeQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
}>;


export type UerPriceListMtrForIncludingToContractChangeQuery = { __typename?: 'Query', uerPriceListMtrForIncludingToContractChange?: { __typename?: 'UerPriceListMtrForIncludingToContractChangeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListMtrRowData', mtrType?: MtrTypeEnum | null, id: any, pricingType: PricingTypeEnum, note?: string | null, status: MtrRecordStatusEnum, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, mtrSupplyAndType: MtrSupplyAndTypeEnum, hasDuplicateNeighbours: boolean, contractId: any, code: string, name: string, unit: string, volume?: any | null, unitWeight?: any | null, unitCost: any, supplyBy?: ContragentTypeEnum | null, supplyBasis?: string | null }> | null } | null };

export type UerContractChangeMtrCodeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrCodeFilterQuery = { __typename?: 'Query', uerContractChangeMtrCodeFilter?: { __typename?: 'UerContractChangeMtrCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeMtrNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrNameFilterQuery = { __typename?: 'Query', uerContractChangeMtrNameFilter?: { __typename?: 'UerContractChangeMtrNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeMtrUnitFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrUnitFilterQuery = { __typename?: 'Query', uerContractChangeMtrUnitFilter?: { __typename?: 'UerContractChangeMtrUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeMtrSupplyByFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeMtrSupplyByFilterQuery = { __typename?: 'Query', uerContractChangeMtrSupplyByFilter?: { __typename?: 'UerContractChangeMtrSupplyByFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfContragentTypeEnum', value: ContragentTypeEnum }> | null } | null };

export type UerContractChangeMtrStatusFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeMtrStatusFilterQuery = { __typename?: 'Query', uerContractChangeMtrStatusFilter?: { __typename?: 'UerContractChangeMtrStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfMtrRecordStatusEnum', value: MtrRecordStatusEnum }> | null } | null };

export type UerContractChangeMtrJustificationFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrJustificationFilterQuery = { __typename?: 'Query', uerContractChangeMtrJustificationFilter?: { __typename?: 'UerContractChangeMtrJustificationFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangePriceListUerQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
}>;


export type UerContractChangePriceListUerQuery = { __typename?: 'Query', uerContractChangePriceListUer?: { __typename?: 'UerContractChangePriceListUerCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerRowData', isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, isIncludedInAct: boolean, id: any, sectionId: any, sectionName: string, groupId: any, groupCode?: string | null, groupName: string, unit: string, code: string, name: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, status: UerRecordStatusEnum, justification?: string | null, basePrice: { __typename?: 'PriceListUerRowPriceData', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', id: any, constructionTypeId: number, constructionTypeName: string, constructionTypeRelationStatus?: PriceConstructionTypeRelationStatusEnum | null, unitCostWithOther?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', id: any, number: number, description: string }>, workKind: { __typename?: 'PriceListUerRowWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null } }> | null } | null };

export type UerAddUersToContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  uerBaseRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddUersToContractChangeMutation = { __typename?: 'Mutation', uerAddUersToContractChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerForIncludingToContractChangeQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
}>;


export type UerPriceListUerForIncludingToContractChangeQuery = { __typename?: 'Query', uerPriceListUerForIncludingToContractChange?: { __typename?: 'UerPriceListUerForIncludingToContractChangeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerRowData', isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, isIncludedInAct: boolean, id: any, sectionId: any, sectionName: string, groupId: any, groupCode?: string | null, groupName: string, unit: string, code: string, name: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, status: UerRecordStatusEnum, justification?: string | null, linkStatus: PriceConstructionTypeRelationStatusEnum, basePrice: { __typename?: 'PriceListUerRowPriceData', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', id: any, constructionTypeId: number, constructionTypeName: string, unitCostWithOther?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', id: any, number: number, description: string }> }> | null } | null };

export type UerContractChangeUerCodeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerCodeFilterQuery = { __typename?: 'Query', uerContractChangeUerCodeFilter?: { __typename?: 'UerContractChangeUerCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerAndWorkScopeNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<PriceListUerAndWorkScopeNameDataFilterInput>;
}>;


export type UerContractChangeUerAndWorkScopeNameFilterQuery = { __typename?: 'Query', uerContractChangeUerAndWorkScopeNameFilter?: { __typename?: 'UerContractChangeUerAndWorkScopeNameFilterCollectionSegment', items?: Array<{ __typename?: 'PriceListUerAndWorkScopeNameData', id: any, name: string, isUer: boolean, isWorkScope: boolean }> | null } | null };

export type UerContractChangeUerTypeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerTypeFilterQuery = { __typename?: 'Query', uerContractChangeUerTypeFilter?: { __typename?: 'UerContractChangeUerTypeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfUerClassifierEnum', value?: UerClassifierEnum | null }> | null } | null };

export type UerContractChangeUerChapterFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerChapterFilterQuery = { __typename?: 'Query', uerContractChangeUerChapterFilter?: { __typename?: 'UerContractChangeUerChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type UerContractChangeUerStatusFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerStatusFilterQuery = { __typename?: 'Query', uerContractChangeUerStatusFilter?: { __typename?: 'UerContractChangeUerStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfUerRecordStatusEnum', value: UerRecordStatusEnum }> | null } | null };

export type UerContractChangeUerJustificationFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerJustificationFilterQuery = { __typename?: 'Query', uerContractChangeUerJustificationFilter?: { __typename?: 'UerContractChangeUerJustificationFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerExportContractChangeAnalyticsAsExcelQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  contractChangeToCompareWithId?: InputMaybe<Scalars['Long']>;
  priceListType: Array<PriceListTypeEnum> | PriceListTypeEnum;
}>;


export type UerExportContractChangeAnalyticsAsExcelQuery = { __typename?: 'Query', uerExportContractChangeAnalyticsAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractChangePriceListRatioRowsQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioCoefficientRowDataSortInput> | PriceListRatioCoefficientRowDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioCoefficientRowDataFilterInput>;
}>;


export type UerContractChangePriceListRatioRowsQuery = { __typename?: 'Query', uerContractChangePriceListRatioRows?: { __typename?: 'UerContractChangePriceListRatioRowsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListRatioCoefficientRowData', code: string, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, status: RatioRecordStatusEnum, workConditions: string }> | null } | null };

export type UerRatioRowForIncludingToContractChangeQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContractRatioRowDataFilterInput>;
}>;


export type UerRatioRowForIncludingToContractChangeQuery = { __typename?: 'Query', uerRatioRowForIncludingToContractChange?: { __typename?: 'UerRatioRowForIncludingToContractChangeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ContractRatioRowData', id: any, code: string, number?: number | null, workConditions: string, justification?: string | null, status: RatioRecordStatusEnum, ratioType: RatioTypeEnum, groupId?: any | null, groupName?: string | null, groupIsArtificial?: boolean | null, kem: any, kmat?: any | null, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, isIncludedInWorkOrderChange?: boolean | null, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, isCustom?: boolean | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerPriceListRatioForIncludingToContractChangeQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
}>;


export type UerPriceListRatioForIncludingToContractChangeQuery = { __typename?: 'Query', uerPriceListRatioForIncludingToContractChange?: { __typename?: 'UerPriceListRatioForIncludingToContractChangeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListRatioRowData', id: any, appliesToId: any, appliesToCode: string, appliesToCodeName: string, appliesToLinkStatus: RatioRecordStatusEnum }> | null } | null };

export type UerAddRatiosToContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  ratioRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddRatiosToContractChangeMutation = { __typename?: 'Mutation', uerAddRatiosToContractChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, buttonText?: string | null, hasValidation: boolean, message?: string | null, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractChangeRatioWorkConditionsFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioWorkConditionsFilterQuery = { __typename?: 'Query', uerContractChangeRatioWorkConditionsFilter?: { __typename?: 'UerContractChangeRatioWorkConditionsFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioWorkTypeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeRatioWorkTypeFilterQuery = { __typename?: 'Query', uerContractChangeRatioWorkTypeFilter?: { __typename?: 'UerContractChangeRatioWorkTypeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioStatusFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeRatioStatusFilterQuery = { __typename?: 'Query', uerContractChangeRatioStatusFilter?: { __typename?: 'UerContractChangeRatioStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfRatioRecordStatusEnum', value?: RatioRecordStatusEnum | null }> | null } | null };

export type UerRemoveUersFromContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  uerIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveUersFromContractChangeMutation = { __typename?: 'Mutation', uerRemoveUersFromContractChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveMtrsFromContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  mtrIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveMtrsFromContractChangeMutation = { __typename?: 'Mutation', uerRemoveMtrsFromContractChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveRatiosFromContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  ratioIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveRatiosFromContractChangeMutation = { __typename?: 'Mutation', uerRemoveRatiosFromContractChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractChangeUerForIncludingNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerForIncludingNameFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingNameFilter?: { __typename?: 'UerContractChangeUerForIncludingNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerForIncludingCodeFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerForIncludingCodeFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingCodeFilter?: { __typename?: 'UerContractChangeUerForIncludingCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerForIncludingLinkStatusFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput>;
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerForIncludingLinkStatusFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingLinkStatusFilter?: { __typename?: 'UerContractChangeUerForIncludingLinkStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfPriceConstructionTypeRelationStatusEnum', value: PriceConstructionTypeRelationStatusEnum }> | null } | null };

export type UerContractChangeUerForIncludingStatusFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfUerRecordStatusEnumFilterInput>;
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerForIncludingStatusFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingStatusFilter?: { __typename?: 'UerContractChangeUerForIncludingStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfUerRecordStatusEnum', value: UerRecordStatusEnum }> | null } | null };

export type UerContractChangeUerForIncludingUnitFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  contractChangeId: Scalars['Long'];
}>;


export type UerContractChangeUerForIncludingUnitFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingUnitFilter?: { __typename?: 'UerContractChangeUerForIncludingUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeMtrForIncludingCodeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrForIncludingCodeFilterQuery = { __typename?: 'Query', uerContractChangeMtrForIncludingCodeFilter?: { __typename?: 'UerContractChangeMtrForIncludingCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeMtrForIncludingNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrForIncludingNameFilterQuery = { __typename?: 'Query', uerContractChangeMtrForIncludingNameFilter?: { __typename?: 'UerContractChangeMtrForIncludingNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeMtrForIncludingUnitFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeMtrForIncludingUnitFilterQuery = { __typename?: 'Query', uerContractChangeMtrForIncludingUnitFilter?: { __typename?: 'UerContractChangeMtrForIncludingUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioForIncludingCodeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioForIncludingCodeFilterQuery = { __typename?: 'Query', uerContractChangeRatioForIncludingCodeFilter?: { __typename?: 'UerContractChangeRatioForIncludingCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioForIncludingWorkConditionsFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioForIncludingWorkConditionsFilterQuery = { __typename?: 'Query', uerContractChangeRatioForIncludingWorkConditionsFilter?: { __typename?: 'UerContractChangeRatioForIncludingWorkConditionsFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioForIncludingStatusFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
}>;


export type UerContractChangeRatioForIncludingStatusFilterQuery = { __typename?: 'Query', uerContractChangeRatioForIncludingStatusFilter?: { __typename?: 'UerContractChangeRatioForIncludingStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfRatioRecordStatusEnum', value: RatioRecordStatusEnum }> | null } | null };

export type UerContractChangeRatioSectionNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioSectionNameFilterQuery = { __typename?: 'Query', uerContractChangeRatioSectionNameFilter?: { __typename?: 'UerContractChangeRatioSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerSectionNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerSectionNameFilterQuery = { __typename?: 'Query', uerContractChangeUerSectionNameFilter?: { __typename?: 'UerContractChangeUerSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerGroupFullNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerGroupFullNameFilterQuery = { __typename?: 'Query', uerContractChangeUerGroupFullNameFilter?: { __typename?: 'UerContractChangeUerGroupFullNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerWorkTypeNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerWorkTypeNameFilterQuery = { __typename?: 'Query', uerContractChangeUerWorkTypeNameFilter?: { __typename?: 'UerContractChangeUerWorkTypeNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerWorkTypeInSumFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
}>;


export type UerContractChangeUerWorkTypeInSumFilterQuery = { __typename?: 'Query', uerContractChangeUerWorkTypeInSumFilter?: { __typename?: 'UerContractChangeUerWorkTypeInSumFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkInSumEnum', value: WorkInSumEnum }> | null } | null };

export type UerContractChangeUerNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerNameFilterQuery = { __typename?: 'Query', uerContractChangeUerNameFilter?: { __typename?: 'UerContractChangeUerNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioGroupFullNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioGroupFullNameFilterQuery = { __typename?: 'Query', uerContractChangeRatioGroupFullNameFilter?: { __typename?: 'UerContractChangeRatioGroupFullNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioAppliesToCodeNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioAppliesToCodeNameFilterQuery = { __typename?: 'Query', uerContractChangeRatioAppliesToCodeNameFilter?: { __typename?: 'UerContractChangeRatioAppliesToCodeNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioCodeFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeRatioCodeFilterQuery = { __typename?: 'Query', uerContractChangeRatioCodeFilter?: { __typename?: 'UerContractChangeRatioCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeRatioAppliesToLinkStatusFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfRatioRecordStatusEnumFilterInput>;
}>;


export type UerContractChangeRatioAppliesToLinkStatusFilterQuery = { __typename?: 'Query', uerContractChangeRatioAppliesToLinkStatusFilter?: { __typename?: 'UerContractChangeRatioAppliesToLinkStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfRatioRecordStatusEnum', value: RatioRecordStatusEnum }> | null } | null };

export type UerContractChangeUerForIncludingSectionNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerForIncludingSectionNameFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingSectionNameFilter?: { __typename?: 'UerContractChangeUerForIncludingSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeUerForIncludingGroupFullNameFilterQueryVariables = Exact<{
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerContractChangeUerForIncludingGroupFullNameFilterQuery = { __typename?: 'Query', uerContractChangeUerForIncludingGroupFullNameFilter?: { __typename?: 'UerContractChangeUerForIncludingGroupFullNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerContractChangeOtherCostRowsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractChangeId: Scalars['Long'];
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput> | ContractOtherCostItemDataSortInput>;
}>;


export type UerContractChangeOtherCostRowsQuery = { __typename?: 'Query', uerContractChangeOtherCostRows?: { __typename?: 'UerContractChangeOtherCostRowsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ContractOtherCostItemData', canEdit: boolean, canDelete: boolean, isInUse: boolean, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, catalogOtherCostTypeId?: number | null, chapter?: ChapterEnum | null, constructionTypeId: number, contractId: any, formula?: string | null, hasEmptyFormula?: boolean | null, hasEmptyOtherCostType?: boolean | null, id: any, isEditable?: boolean | null, isGlobalOtherCost: boolean, isIncludedInActKc2?: boolean | null, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, name: string, rationale?: string | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, id: number, isSystem: boolean, name: string, uniqueId: string } | null, constructionTypeLimits: Array<{ __typename?: 'ConstructionTypeLimitData', relationStatus: ContractOtherConstructionTypeRelationStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, seasonLimits: Array<{ __typename?: 'ContractOtherCostSeasonLimitData', constructionTypeId: number, cost: any, seasonId: any }> }>, seasonLimits: Array<{ __typename?: 'ContractOtherCostSeasonLimitData', constructionTypeId: number, cost: any, seasonId: any }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerContractChangeOtherCostRowsForIncludingQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<ContractOtherCostItemDataFilterInput>;
  order?: InputMaybe<Array<ContractOtherCostItemDataSortInput> | ContractOtherCostItemDataSortInput>;
}>;


export type UerContractChangeOtherCostRowsForIncludingQuery = { __typename?: 'Query', uerContractChangeOtherCostRowsForIncluding?: { __typename?: 'UerContractChangeOtherCostRowsForIncludingCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ContractOtherCostItemData', canDelete: boolean, canEdit: boolean, isInUse: boolean, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, catalogOtherCostTypeId?: number | null, chapter?: ChapterEnum | null, constructionTypeId: number, contractId: any, formula?: string | null, hasEmptyFormula?: boolean | null, hasEmptyOtherCostType?: boolean | null, id: any, isEditable?: boolean | null, isGlobalOtherCost: boolean, isIncludedInActKc2?: boolean | null, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, name: string, rationale?: string | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, id: number, isSystem: boolean, name: string, uniqueId: string } | null, constructionTypeLimits: Array<{ __typename?: 'ConstructionTypeLimitData', relationStatus: ContractOtherConstructionTypeRelationStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, seasonLimits: Array<{ __typename?: 'ContractOtherCostSeasonLimitData', constructionTypeId: number, cost: any, seasonId: any }> }>, seasonLimits: Array<{ __typename?: 'ContractOtherCostSeasonLimitData', constructionTypeId: number, cost: any, seasonId: any }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerAddOthersToContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  contractOtherCostIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddOthersToContractChangeMutation = { __typename?: 'Mutation', uerAddOthersToContractChange: { __typename?: 'ServiceDataResultOfInt64__', code?: string | null, buttonText?: string | null, data?: Array<any> | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveOtherCostsFromContractChangeMutationVariables = Exact<{
  contractChangeId: Scalars['Long'];
  contractOtherCostIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveOtherCostsFromContractChangeMutation = { __typename?: 'Mutation', uerRemoveOtherCostsFromContractChange: { __typename?: 'ServiceDataResultOfInt64__', buttonText?: string | null, code?: string | null, data?: Array<any> | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerOthersForIncludingToContractChangeNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerOthersForIncludingToContractChangeNameFilterQuery = { __typename?: 'Query', uerOthersForIncludingToContractChangeNameFilter?: { __typename?: 'UerOthersForIncludingToContractChangeNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerOthersForIncludingToContractChangeCalculatingTypeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfOtherCostCalculationTypeEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfOtherCostCalculationTypeEnumSortInput> | FilterValueOfOtherCostCalculationTypeEnumSortInput>;
}>;


export type UerOthersForIncludingToContractChangeCalculatingTypeFilterQuery = { __typename?: 'Query', uerOthersForIncludingToContractChangeCalculatingTypeFilter?: { __typename?: 'UerOthersForIncludingToContractChangeCalculatingTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfOtherCostCalculationTypeEnum', value: OtherCostCalculationTypeEnum }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCalculationLimitedCostsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<UercCalculationLimitedCostDataFilterInput>;
  order?: InputMaybe<Array<UercCalculationLimitedCostDataSortInput> | UercCalculationLimitedCostDataSortInput>;
}>;


export type UercCalculationLimitedCostsQuery = { __typename?: 'Query', uercCalculationLimitedCosts?: { __typename?: 'UercCalculationLimitedCostsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'UercCalculationLimitedCostData', id: any, calculationId: any, rationale: string, name: string, key?: string | null, chapter: ChapterEnum, calculatingValue: any, totalCost: any, limits?: Array<{ __typename?: 'UercCalculationLimitedCostLimitData', constructionTypeId: number, seasonId: any, cost?: any | null }> | null }> | null } | null };

export type UercCalculationLimitedCostNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UercCalculationLimitedCostNameFilterQuery = { __typename?: 'Query', uercCalculationLimitedCostNameFilter?: { __typename?: 'UercCalculationLimitedCostNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercRemoveCalculationLimitedCostsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UercRemoveCalculationLimitedCostsMutation = { __typename?: 'Mutation', uercRemoveCalculationLimitedCosts: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercGlobalLimitedCostsForCalculationQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalLimitedCostDataSortInput> | GlobalLimitedCostDataSortInput>;
  where?: InputMaybe<GlobalLimitedCostDataFilterInput>;
}>;


export type UercGlobalLimitedCostsForCalculationQuery = { __typename?: 'Query', uercGlobalLimitedCostsForCalculation?: { __typename?: 'UercGlobalLimitedCostsForCalculationCollectionSegment', items?: Array<{ __typename?: 'GlobalLimitedCostData', id: any, name: string, methodology: ProjectMethodologyEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, hasCalculatingParticipation: boolean, isSystem: boolean, catalogLimitedCostType?: { __typename?: 'CatalogLimitedCostTypeData', name: string, id: number, uniqueId: string } | null }> | null } | null };

export type UercCalculationLimitedCostTypesQueryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<CatalogLimitedCostTypeDataFilterInput>;
  order?: InputMaybe<Array<CatalogLimitedCostTypeDataSortInput> | CatalogLimitedCostTypeDataSortInput>;
}>;


export type UercCalculationLimitedCostTypesQueryQuery = { __typename?: 'Query', uercCalculationLimitedCostTypes?: { __typename?: 'UercCalculationLimitedCostTypesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'CatalogLimitedCostTypeData', id: number, uniqueId: string, name: string }> | null } | null };

export type IsUercCalculationLimitedCostCodeUniqueQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  key: Scalars['String'];
}>;


export type IsUercCalculationLimitedCostCodeUniqueQuery = { __typename?: 'Query', uercIsCalculationLimitedCostCodeUnique: { __typename?: 'ServiceIdResultOfBoolean', result: boolean, isUnique?: boolean | null } };

export type UercIsCalculationLimitedCostNameUniqueQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type UercIsCalculationLimitedCostNameUniqueQuery = { __typename?: 'Query', uercIsCalculationLimitedCostNameUnique: { __typename?: 'ServiceIdResultOfBoolean', result: boolean, isUnique?: boolean | null } };

export type UercCreateCalculationLimitedCostMutationVariables = Exact<{
  input: UercCalculationLimitedCostInput;
}>;


export type UercCreateCalculationLimitedCostMutation = { __typename?: 'Mutation', uercCreateCalculationLimitedCost: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercUpdateCalculationLimitedCostMutationVariables = Exact<{
  id: Scalars['Long'];
  input: UercCalculationLimitedCostInput;
}>;


export type UercUpdateCalculationLimitedCostMutation = { __typename?: 'Mutation', uercUpdateCalculationLimitedCost: { __typename?: 'ServiceDataResultOfUercCalculationLimitedCostUpdateData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, data?: { __typename?: 'UercCalculationLimitedCostUpdateData', calculationId: any, catalogLimitedCostTypeId?: number | null, chapter: ChapterEnum, formula?: string | null, globalLimitedCostId?: any | null, hasCalculatingParticipation: boolean, id: any, isEditable: boolean, name: string, key?: string | null, rationale: string, section: SectionEnum, uniqueId: string, catalogLimitedCostType?: { __typename?: 'CatalogLimitedCostTypeData', id: number, uniqueId: string, name: string } | null, constructionTypes?: Array<{ __typename?: 'UercCalculationLimitedCostConstructionTypeData', constructionTypeId: number, calculatingValue: any, constructionType?: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } | null }> | null, limits?: Array<{ __typename?: 'UercCalculationLimitedCostLimitData', constructionTypeId: number, seasonId: any, cost?: any | null }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercCalculationLimitedCostForUpdateQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  limitedCostId: Scalars['Long'];
  editConstructionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type UercCalculationLimitedCostForUpdateQuery = { __typename?: 'Query', uercCalculationLimitedCostForUpdate: { __typename?: 'ServiceDataResultOfUercCalculationLimitedCostUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'UercCalculationLimitedCostUpdateData', calculationId: any, catalogLimitedCostTypeId?: number | null, chapter: ChapterEnum, formula?: string | null, globalLimitedCostId?: any | null, hasCalculatingParticipation: boolean, id: any, isEditable: boolean, key?: string | null, name: string, section: SectionEnum, uniqueId: string, rationale: string, catalogLimitedCostType?: { __typename?: 'CatalogLimitedCostTypeData', id: number, name: string, uniqueId: string } | null, constructionTypes?: Array<{ __typename?: 'UercCalculationLimitedCostConstructionTypeData', constructionTypeId: number, calculatingValue: any, constructionType?: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } | null }> | null, limits?: Array<{ __typename?: 'UercCalculationLimitedCostLimitData', constructionTypeId: number, cost?: any | null, seasonId: any }> | null, file?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCollectionMtrItemsQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  showUsers: Scalars['Boolean'];
  where?: InputMaybe<CollectionMtrUersItemFilterInput>;
}>;


export type UercCollectionMtrItemsQueryQuery = { __typename?: 'Query', uercCollectionMtrItemsQuery: Array<{ __typename?: 'CollectionMtrUersItem', id: any, code?: string | null, name: string, unit: string, unitBaseCost?: any | null, unitCurrentCost?: any | null, consumptionRate?: any | null, hasConsumptionrateMtr: boolean, supplyBy?: ContragentTypeEnum | null, mtrType?: MtrTypeEnum | null, mtrKind?: string | null, isUpdatedFromUERBaseCosts: boolean, unitWeight?: any | null, pricingType?: PricingTypeEnum | null, updatedAt?: any | null, hasWOR: boolean, isRecommended: boolean, status?: MtrStatus | null, isIncludedInTransportCalculation: boolean, uers?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string }> | null }> };

export type UercCollectionMtrItemValuesTotalsQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCollectionMtrItemValuesTotalsQueryQuery = { __typename?: 'Query', uercCollectionMtrItemValuesTotalsQuery: { __typename?: 'CollectionMtrItemValueTotals', seasons: Array<any>, calculationObjects: Array<{ __typename?: 'CollectionMtrCalculationObjectData', calculationObjectId: any, constructionTypeCode: string, constructionTypeId: any, constructionTypeShortName: string, name: string, order?: number | null }>, collectionMtrItemValues: Array<{ __typename?: 'CollectionMtrItemValue', id?: any | null, mtrType?: MtrTypeEnum | null, supplyBy?: ContragentTypeEnum | null, totalGuaranteedVolume?: any | null, totalNotGuaranteedVolume?: any | null, totalVolume?: any | null, seasonsData: Array<{ __typename?: 'ObjectSeasonsData', calculationObjectId: any, seasonPrice?: any | null, seasonVolume?: any | null, year: any }> }> } };

export type UercCollectionMtrTotalsQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCollectionMtrTotalsQueryQuery = { __typename?: 'Query', uercCollectionMtrTotalsQuery: { __typename?: 'CollectionMtrItemValueTotals', collectionMtrTotals: { __typename?: 'CollectionMtrTotals', equipment: any, material: any } } };

export type UercCollectionMtrItemCodeFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
}>;


export type UercCollectionMtrItemCodeFilterQueryQuery = { __typename?: 'Query', uercCollectionMtrItemCodeFilterQuery: Array<{ __typename?: 'MtrCodeFilter', codes: Array<string>, groupName: string }> };

export type UercCollectionMtrItemNameFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
}>;


export type UercCollectionMtrItemNameFilterQueryQuery = { __typename?: 'Query', uercCollectionMtrItemNameFilterQuery: Array<string> };

export type UercCollectionMtrItemSupplyByFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
}>;


export type UercCollectionMtrItemSupplyByFilterQueryQuery = { __typename?: 'Query', uercCollectionMtrItemSupplyByFilterQuery: Array<ContragentTypeEnum> };

export type UercCollectionMtrItemMtrTypeFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
}>;


export type UercCollectionMtrItemMtrTypeFilterQueryQuery = { __typename?: 'Query', uercCollectionMtrItemMtrTypeFilterQuery: Array<MtrTypeEnum> };

export type UercCollectionMtrItemPricingTypeFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  filter?: InputMaybe<MtrFilterInput>;
}>;


export type UercCollectionMtrItemPricingTypeFilterQueryQuery = { __typename?: 'Query', uercCollectionMtrItemPricingTypeFilterQuery: Array<PricingTypeEnum> };

export type UercCreateCollectionMtrMutationMutationVariables = Exact<{
  input: CreateCollectionMtrInput;
}>;


export type UercCreateCollectionMtrMutationMutation = { __typename?: 'Mutation', uercCreateCollectionMtr: { __typename?: 'ServiceDataResultOfUpdateResponseCollectionMtrData', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'UpdateResponseCollectionMtrData', id: any } | null } };

export type UercUpdateCollectionMtrMutationMutationVariables = Exact<{
  input: UpdateCollectionMtrInput;
}>;


export type UercUpdateCollectionMtrMutationMutation = { __typename?: 'Mutation', uercUpdateCollectionMtr: { __typename?: 'ServiceDataResultOfUpdateResponseCollectionMtrData', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateCollectionMtrUnitCurrentPriceMutationMutationVariables = Exact<{
  input: UpdateCollectionMtrUnitCurrentPriceInput;
}>;


export type UercUpdateCollectionMtrUnitCurrentPriceMutationMutation = { __typename?: 'Mutation', uercUpdateCollectionMtrUnitCurrentPrice: { __typename?: 'ServiceDataResultOfUpdateCollectionMtrUnitCurrentPriceResponse', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'UpdateCollectionMtrUnitCurrentPriceResponse', collectionMtrItem: { __typename?: 'CollectionMtrUersItem', id: any, code?: string | null, name: string, unit: string, unitBaseCost?: any | null, unitCurrentCost?: any | null, consumptionRate?: any | null, hasConsumptionrateMtr: boolean, supplyBy?: ContragentTypeEnum | null, mtrType?: MtrTypeEnum | null, mtrKind?: string | null, isUpdatedFromUERBaseCosts: boolean, unitWeight?: any | null, pricingType?: PricingTypeEnum | null, updatedAt?: any | null, hasWOR: boolean, isRecommended: boolean, status?: MtrStatus | null, isIncludedInTransportCalculation: boolean, uers?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string }> | null } } | null } };

export type UercRemoveCollectionMtrMutationMutationVariables = Exact<{
  input: RemoveCollectionMtrInput;
}>;


export type UercRemoveCollectionMtrMutationMutation = { __typename?: 'Mutation', uercRemoveCollectionMtr: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercRemoveUnusedCollectionMtrMutationMutationVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercRemoveUnusedCollectionMtrMutationMutation = { __typename?: 'Mutation', uercRemoveUnusedCollectionMtr: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercExportCollectionMtrAsExcelQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercExportCollectionMtrAsExcelQueryQuery = { __typename?: 'Query', uercExportCollectionMtrAsExcel: { __typename?: 'ServiceDataResultOfFileContent', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', count: number, name: string, dataUrl: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCollectionMtrSelectionListQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCollectionMtrSelectionListQuery = { __typename?: 'Query', uercCollectionMtrSelectionList: Array<{ __typename?: 'CollectionMtrForReplacementData', id: any, code: string, name: string, unit: string, unitCurrentCost?: any | null, mtrType?: MtrTypeEnum | null }> };

export type UercReplaceCollectionMtrItemMutationVariables = Exact<{
  input: ReplaceCollectionMtrItemInput;
}>;


export type UercReplaceCollectionMtrItemMutation = { __typename?: 'Mutation', uercReplaceCollectionMtrItem: { __typename?: 'ServiceDataResultOfReplaceCollectionMtrItemData', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercImportCollectionMtrMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type UercImportCollectionMtrMutation = { __typename?: 'Mutation', uercImportCollectionMtr: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateIsIncludedInTransportCalculationMutationVariables = Exact<{
  input: UpdateIsIncludedInTransportCalculationInput;
}>;


export type UercUpdateIsIncludedInTransportCalculationMutation = { __typename?: 'Mutation', uercUpdateIsIncludedInTransportCalculation: { __typename?: 'ServiceDataResultOfUpdateResponseCollectionMtrData', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercGlobalOtherCostsForCalculationQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<GlobalOtherCostDataSortInput> | GlobalOtherCostDataSortInput>;
  where?: InputMaybe<GlobalOtherCostDataFilterInput>;
}>;


export type UercGlobalOtherCostsForCalculationQuery = { __typename?: 'Query', uercGlobalOtherCostsForCalculation?: { __typename?: 'UercGlobalOtherCostsForCalculationCollectionSegment', items?: Array<{ __typename?: 'GlobalOtherCostData', id: any, name: string, methodology: ProjectMethodologyEnum, calculatingType: OtherCostCalculationTypeEnum, chapter?: ChapterEnum | null, section?: SectionEnum | null, formula?: string | null, isSystem: boolean, otherCostType: { __typename?: 'CatalogOtherCostTypeBase', name: string, id: number, uniqueId: string } }> | null } | null };

export type UercCreateCalculationOtherCostMutationVariables = Exact<{
  input: UercCalculationOtherCostInput;
}>;


export type UercCreateCalculationOtherCostMutation = { __typename?: 'Mutation', uercCreateCalculationOtherCost: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercUpdateCalculationOtherCostMutationVariables = Exact<{
  id: Scalars['Long'];
  input: UercCalculationOtherCostInput;
}>;


export type UercUpdateCalculationOtherCostMutation = { __typename?: 'Mutation', uercUpdateCalculationOtherCost: { __typename?: 'ServiceDataResultOfUercCalculationOtherCostUpdateData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, data?: { __typename?: 'UercCalculationOtherCostUpdateData', hasEmptyOtherCostType?: boolean | null, hasEmptyFormula?: boolean | null, id: any, uniqueId: string, calculationId: any, catalogOtherCostTypeId?: number | null, globalOtherCostId?: any | null, name: string, key?: string | null, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, isEditable?: boolean | null, formula?: string | null, file?: { __typename?: 'FileContent', name: string, count: number, size: any, dataUrl: string } | null, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, isSystem: boolean, id: number, uniqueId: string, name: string } | null, limits?: Array<{ __typename?: 'UercCalculationOtherCostLimitData', constructionTypeId: number, seasonId: any, cost: any }> | null, constructionTypes?: Array<{ __typename?: 'UercCalculationOtherCostConstructionTypeData', constructionTypeId: number, distributionMethod?: Uerc_LimitDistributionMethodEnum | null, constructionType?: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } | null }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercCalculationOtherCostForUpdateQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  otherCostId: Scalars['Long'];
  editConstructionTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type UercCalculationOtherCostForUpdateQuery = { __typename?: 'Query', uercCalculationOtherCostForUpdate: { __typename?: 'ServiceDataResultOfUercCalculationOtherCostUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'UercCalculationOtherCostUpdateData', calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, calculationId: any, catalogOtherCostTypeId?: number | null, chapter?: ChapterEnum | null, formula?: string | null, globalOtherCostId?: any | null, hasEmptyFormula?: boolean | null, hasEmptyOtherCostType?: boolean | null, id: any, isEditable?: boolean | null, key?: string | null, name: string, section?: SectionEnum | null, uniqueId: string, hasCalculatingParticipation: boolean, isLimitsTotalFromFile: boolean, isManualLimitsDistribution: boolean, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', id: number, name: string, uniqueId: string } | null, constructionTypes?: Array<{ __typename?: 'UercCalculationOtherCostConstructionTypeData', constructionTypeId: number, distributionMethod?: Uerc_LimitDistributionMethodEnum | null, totalCostLimit?: any | null, constructionType?: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } | null }> | null, file?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, limits?: Array<{ __typename?: 'UercCalculationOtherCostLimitData', constructionTypeId: number, cost: any, seasonId: any }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationOtherCostTypesQueryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  otherCostId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<CatalogOtherCostTypeDataFilterInput>;
  order?: InputMaybe<Array<CatalogOtherCostTypeDataSortInput> | CatalogOtherCostTypeDataSortInput>;
}>;


export type UercCalculationOtherCostTypesQueryQuery = { __typename?: 'Query', uercCalculationOtherCostTypesQuery?: { __typename?: 'UercCalculationOtherCostTypesQueryCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, isSystem: boolean, id: number, uniqueId: string, name: string }> | null } | null };

export type UercCalculationOtherCostsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<UercCalculationOtherCostDataFilterInput>;
  order?: InputMaybe<Array<UercCalculationOtherCostDataSortInput> | UercCalculationOtherCostDataSortInput>;
}>;


export type UercCalculationOtherCostsQuery = { __typename?: 'Query', uercCalculationOtherCosts?: { __typename?: 'UercCalculationOtherCostsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'UercCalculationOtherCostData', id: any, calculationId: any, globalOtherCostId?: any | null, name: string, key?: string | null, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, isEditable?: boolean | null, totalCost: any, hasToDistributeLimitsBySeasonsManualy: boolean, limits?: Array<{ __typename?: 'UercCalculationOtherCostLimitData', constructionTypeId: number, seasonId: any, cost: any }> | null }> | null } | null };

export type UercRemoveCalculationOtherCostsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  calculationOtherCostIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UercRemoveCalculationOtherCostsMutation = { __typename?: 'Mutation', uercRemoveCalculationOtherCosts: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercCalculationOtherCostNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UercCalculationOtherCostNameFilterQuery = { __typename?: 'Query', uercCalculationOtherCostNameFilter?: { __typename?: 'UercCalculationOtherCostNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type CatalogUerOtherCostTemplateFilesQueryVariables = Exact<{
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CatalogUerOtherCostTemplateFilesQuery = { __typename?: 'Query', catalogUEROtherCostTemplateFiles: { __typename?: 'ServiceDataResultOfFileContent', buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } };

export type IsUercCalculationOtherCostCodeUniqueQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  otherCostId?: InputMaybe<Scalars['Long']>;
  key: Scalars['String'];
}>;


export type IsUercCalculationOtherCostCodeUniqueQuery = { __typename?: 'Query', uercIsCalculationOtherCostCodeUnique: { __typename?: 'ServiceIdResultOfBoolean', result: boolean, isUnique?: boolean | null } };

export type UercCalculationComputedDataQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CalculationComputeRowFilterInput>;
}>;


export type UercCalculationComputedDataQuery = { __typename?: 'Query', uercCalculationComputedData?: { __typename?: 'UercCalculationComputedDataCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CalculationComputeRow', chapter?: ChapterEnum | null, code?: string | null, entityId: any, entityType?: ComputeRowTypeEnum | null, computedCostId?: any | null, name?: string | null, objectId?: any | null, objectName?: string | null, rootObjectId: any, rootObjectName: string, totalCost?: any | null, totalVolume?: any | null, unit?: string | null, unitCost?: any | null, workCode?: string | null, workInSum?: WorkInSumEnum | null, workName?: string | null, workPlan?: any | null, workRatio?: any | null, workUnit?: string | null, uerCode?: string | null, seasonValues?: Array<{ __typename?: 'CalculationComputeSeasonValue', seasonId: any, volume?: any | null, cost?: any | null, errors?: Array<string> | null }> | null }> | null } | null };

export type UercComputeCalculationMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  sortType?: InputMaybe<WorUerSortType>;
}>;


export type UercComputeCalculationMutation = { __typename?: 'Mutation', uercComputeCalculation: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, actionRequired?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationComputedTotalsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UercCalculationComputedTotalsQuery = { __typename?: 'Query', uercCalculationComputedTotals: { __typename?: 'CalculationComputeTotalData', guaranteedVolume?: Array<{ __typename?: 'CalculationComputeTotalRow', isHeadLine: boolean, name: string, totalCost: any, seasonTotal: Array<{ __typename?: 'SeasonTotalData', seasonId: any, cost: any }> }> | null, nonguaranteedVolume?: Array<{ __typename?: 'CalculationComputeTotalRow', isHeadLine: boolean, name: string, totalCost: any, seasonTotal: Array<{ __typename?: 'SeasonTotalData', seasonId: any, cost: any }> }> | null, summary: Array<{ __typename?: 'CalculationComputeTotalRow', isHeadLine: boolean, name: string, totalCost: any, seasonTotal: Array<{ __typename?: 'SeasonTotalData', seasonId: any, cost: any }> }> } };

export type UercCalculationComputedRowsChapterFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type UercCalculationComputedRowsChapterFilterQuery = { __typename?: 'Query', uercCalculationComputedRowsChapterFilter?: { __typename?: 'UercCalculationComputedRowsChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfChapterEnum', value: ChapterEnum }> | null } | null };

export type UercCalculationComputedRowsCodeExtendedFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
  where?: InputMaybe<FilterValueOfWorkVolumeItemCodeFilterDataFilterInput>;
}>;


export type UercCalculationComputedRowsCodeExtendedFilterQuery = { __typename?: 'Query', uercCalculationComputedRowsCodeExtendedFilter?: { __typename?: 'UercCalculationComputedRowsCodeExtendedFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkVolumeItemCodeFilterData', value?: { __typename?: 'WorkVolumeItemCodeFilterData', code: string, isMtr: boolean, isRatio: boolean, isUer: boolean, order: number, uerCode: string, uerCodeId?: any | null } | null }> | null } | null };

export type UercCalculationComputedRowsNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type UercCalculationComputedRowsNameFilterQuery = { __typename?: 'Query', uercCalculationComputedRowsNameFilter?: { __typename?: 'UercCalculationComputedRowsNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCalculationComputedRowsWorkInSumFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type UercCalculationComputedRowsWorkInSumFilterQuery = { __typename?: 'Query', uercCalculationComputedRowsWorkInSumFilter?: { __typename?: 'UercCalculationComputedRowsWorkInSumFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkInSumEnum', value: WorkInSumEnum }> | null } | null };

export type UercCalculationComputedRowsWorkNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  guaranteedVolume: Scalars['Boolean'];
}>;


export type UercCalculationComputedRowsWorkNameFilterQuery = { __typename?: 'Query', uercCalculationComputedRowsWorkNameFilter?: { __typename?: 'UercCalculationComputedRowsWorkNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercReorderCalculationComputedUerMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  movedComputedCostId: Scalars['Long'];
  placeAfterComputedCostId?: InputMaybe<Scalars['Long']>;
}>;


export type UercReorderCalculationComputedUerMutation = { __typename?: 'Mutation', uercReorderCalculationComputedUer: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateComputedCostWorkRatioMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  computedCostId: Scalars['Long'];
  ratio: Scalars['Decimal'];
}>;


export type UercUpdateComputedCostWorkRatioMutation = { __typename?: 'Mutation', uercUpdateComputedCostWorkRatio: { __typename?: 'ServiceDataResultOfCalculationComputeRow', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'CalculationComputeRow', computedCostId?: any | null, chapter?: ChapterEnum | null, code?: string | null, entityId: any, entityType?: ComputeRowTypeEnum | null, name?: string | null, objectId?: any | null, objectName?: string | null, rootObjectId: any, rootObjectName: string, totalCost?: any | null, totalVolume?: any | null, unit?: string | null, unitCost?: any | null, workCode?: string | null, workInSum?: WorkInSumEnum | null, workName?: string | null, workPlan?: any | null, workRatio?: any | null, workUnit?: string | null, uerCode?: string | null, seasonValues?: Array<{ __typename?: 'CalculationComputeSeasonValue', seasonId: any, volume?: any | null, cost?: any | null, errors?: Array<string> | null }> | null } | null } };

export type UercExportPrintFormQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  modes: Array<ContragentTypeEnum> | ContragentTypeEnum;
}>;


export type UercExportPrintFormQuery = { __typename?: 'Query', uercExportPrintForm: { __typename?: 'ServiceDataResultOfFileContent', code?: string | null, result: boolean, message?: string | null, data?: { __typename?: 'FileContent', name: string, size: any, dataUrl: string } | null } };

export type UercImportEstimateBasisFilesMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  input: CollectionUerBaseCostImportFilesInput;
  files: Array<FileInput> | FileInput;
}>;


export type UercImportEstimateBasisFilesMutation = { __typename?: 'Mutation', uercImportEstimateBasisFiles: { __typename?: 'ServiceDataResultOfInt64__', buttonText?: string | null, code?: string | null, data?: Array<any> | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercImportUerBaseCostCollectionMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeIds: Array<Scalars['Int']> | Scalars['Int'];
  file: FileInput;
  copyRatios: Scalars['Boolean'];
}>;


export type UercImportUerBaseCostCollectionMutation = { __typename?: 'Mutation', uercImportUerBaseCostCollection: { __typename?: 'ServiceDataResultOfInt64__', buttonText?: string | null, code?: string | null, data?: Array<any> | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationCatalogInfoQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCalculationCatalogInfoQuery = { __typename?: 'Query', uercCalculation: { __typename?: 'ServiceDataResultOfUercCalculationData', data?: { __typename?: 'UercCalculationData', id: any, catalogUerBase: { __typename?: 'CatalogUerBase', uniqueId?: string | null }, constructionTypes: Array<{ __typename?: 'UercCalculationConstructionTypeData', constructionType: { __typename?: 'ConstructionTypeData', id: number, name: string } }> } | null } };

export type UercCheckConstructionTypesToAddUersQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercCheckConstructionTypesToAddUersQuery = { __typename?: 'Query', uercCheckConstructionTypesToAddUers: { __typename?: 'ServiceDataResultOfCheckConstructionTypesToAddUersData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CheckConstructionTypesToAddUersData', data: Array<{ __typename?: 'ConstructionTypeAvailabilityData', calculationConstructionType: number, status: boolean }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercFindUersToAddQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercFindUersToAddQuery = { __typename?: 'Query', uercFindUersToAdd: { __typename?: 'ServiceDataResultOfFindUersToAddData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FindUersToAddData', constructionTypes: Array<number>, ids: Array<any> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercAddUersToCollectionUerBaseCostMutationVariables = Exact<{
  input: AddUersToCollectionUerBaseCostInput;
}>;


export type UercAddUersToCollectionUerBaseCostMutation = { __typename?: 'Mutation', uercAddUersToCollectionUERBaseCost: { __typename?: 'ServiceDataResultOfAddUersToCollectionUERBaseCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'AddUersToCollectionUERBaseCostData', constructionTypes: Array<number>, data: Array<any> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUersToAddConstructionTypeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercUersToAddConstructionTypeFilterQuery = { __typename?: 'Query', uercUersToAddConstructionTypeFilter?: { __typename?: 'UercUersToAddConstructionTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercUersToAddSectionNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercUersToAddSectionNameFilterQuery = { __typename?: 'Query', uercUersToAddSectionNameFilter?: { __typename?: 'UercUersToAddSectionNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercUersToAddCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercUersToAddCodeFilterQuery = { __typename?: 'Query', uercUersToAddCodeFilter?: { __typename?: 'UercUersToAddCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercUersToAddGroupNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercUersToAddGroupNameFilterQuery = { __typename?: 'Query', uercUersToAddGroupNameFilter?: { __typename?: 'UercUersToAddGroupNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercUersToAddNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  catalogUerBaseUniqueId: Scalars['String'];
  calculationConstructionTypes: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UercUersToAddNameFilterQuery = { __typename?: 'Query', uercUersToAddNameFilter?: { __typename?: 'UercUersToAddNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CatalogUersToAddItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  catalogUniqueId: Scalars['String'];
  where?: InputMaybe<CatalogUerBaseCostDataFilterInput>;
  order?: InputMaybe<Array<CatalogUerBaseCostDataSortInput> | CatalogUerBaseCostDataSortInput>;
}>;


export type CatalogUersToAddItemsQuery = { __typename?: 'Query', catalogUERBaseCostItems?: { __typename?: 'CatalogUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogUERBaseCostData', id: any, sectionName: string, groupName: string, code: string, name: string, unit: string, unitCost: any, constructionTypes: Array<{ __typename?: 'ConstructionTypeData', id: number, name: string }> }> | null } | null };

export type UercCopyCollectionUerBaseCostsFromCatalogMutationVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCopyCollectionUerBaseCostsFromCatalogMutation = { __typename?: 'Mutation', uercCopyCollectionUERBaseCostsFromCatalog: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercRemoveAllCollectionUerBaseCostRowsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercRemoveAllCollectionUerBaseCostRowsMutation = { __typename?: 'Mutation', uercRemoveAllCollectionUERBaseCostRows: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercImportCollectionUerBaseCostWorkTypesMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  file: FileInput;
}>;


export type UercImportCollectionUerBaseCostWorkTypesMutation = { __typename?: 'Mutation', uercImportCollectionUerBaseCostWorkTypes: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, source?: string | null }> | null } };

export type UerCollectionUerBaseCostWorkScopesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  baseRowId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostWorkScopeDataFilterInput>;
}>;


export type UerCollectionUerBaseCostWorkScopesQuery = { __typename?: 'Query', uercCollectionUERBaseCostWorkScopes?: { __typename?: 'UercCollectionUERBaseCostWorkScopesCollectionSegment', items?: Array<{ __typename?: 'CollectionUERBaseCostWorkScopeData', number: any, name: string }> | null } | null };

export type UerCollectionUerBaseCostEstimateBasisQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  baseRowId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostEstimateBasisDataFilterInput>;
}>;


export type UerCollectionUerBaseCostEstimateBasisQuery = { __typename?: 'Query', uercCollectionUERBaseCostEstimateBasis?: { __typename?: 'UercCollectionUERBaseCostEstimateBasisCollectionSegment', items?: Array<{ __typename?: 'CollectionUERBaseCostEstimateBasisData', id?: any | null, code?: string | null, name: string, unit?: string | null, group: CollectionUerBaseCostEstimateBasisDataGroupEnum, isHeadLine: boolean, unitCost?: any | null, isDeleted?: boolean | null, isNotCount?: boolean | null }> | null } | null };

export type UerCollectionUerBaseCostEstimateBasisResourceQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  baseRowId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostEstimateBasisDataFilterInput>;
}>;


export type UerCollectionUerBaseCostEstimateBasisResourceQuery = { __typename?: 'Query', uercCollectionUERBaseCostEstimateBasisResources?: { __typename?: 'UercCollectionUERBaseCostEstimateBasisResourcesCollectionSegment', items?: Array<{ __typename?: 'CollectionUERBaseCostEstimateBasisData', id?: any | null, code?: string | null, name: string, unit?: string | null, group: CollectionUerBaseCostEstimateBasisDataGroupEnum, isHeadLine: boolean, unitCost?: any | null, isDeleted?: boolean | null, isNotCount?: boolean | null }> | null } | null };

export type UercCollectionUerBaseCostQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  baseRowId: Scalars['Long'];
}>;


export type UercCollectionUerBaseCostQuery = { __typename?: 'Query', uercCollectionUERBaseCost: { __typename?: 'ServiceDataResultOfCollectionUERBaseCostData', hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'CollectionUERBaseCostData', sectionName: string, id: any, groupName: string, code: string, name: string, unit: string, unitCost: any, directCost?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, fot?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, tz?: any | null, tm?: any | null, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, constructionTypes: Array<{ __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }>, workScopes: Array<{ __typename?: 'CollectionUERBaseCostWorkScopeData', number: any, name: string }>, estimateBasisSections: Array<{ __typename?: 'CollectionUERBaseCostEstimateBasisSectionData', id: any, order?: number | null, name: string, estimateBasisRows: Array<{ __typename?: 'CollectionUERBaseCostEstimateBasisDetailedData', id: any, type: UerBasisPriceTypeEnum, hasConsumptionRateMtr?: boolean | null, code: string, name: string, unit: string, estimateTotal: any, quantity: { __typename?: 'CollectionUERBaseCostEstimateBasisQuantityData', unit: any, total: any, consumptionRateMtr?: any | null }, unitCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisUnitCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, unitWorkCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisWorkCostData', tz?: any | null, tm?: any | null } | null, totalWorkCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisWorkCostData', tz?: any | null, tm?: any | null } | null, resources: Array<{ __typename?: 'CollectionUERBaseCostEstimateBasisResourceData', id: any, code: string, name: string, unit: string, type: UerBasisResourceCostTypeEnum, isDeleted?: boolean | null, isNotCount?: boolean | null, quantity: { __typename?: 'CollectionUERBaseCostEstimateBasisResourceQuantityData', unit: any, total: any }, unitCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisResourceCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisResourceCostData', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null }> }> }>, workType: { __typename?: 'CollectionUERBaseWorkData', workUniqueId?: string | null, workCode?: string | null, workName?: string | null, workUnit?: string | null, workInSum: WorkInSumEnum, workRatio?: any | null }, ratios: Array<{ __typename?: 'CollectionRatioShortData', id: any, ratioType: RatioTypeEnum, code: string, name: string, collectionRatioGroupId?: any | null }>, ratioGroups: Array<{ __typename?: 'CollectionRatioGroupData', id: any, name: string, parentId?: any | null, groupType?: DismantlingCoefficientTypeEnum | null }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateCollectionUerBaseCostMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  input: CollectionUerBaseCostUpdateInput;
}>;


export type UercUpdateCollectionUerBaseCostMutation = { __typename?: 'Mutation', uercUpdateCollectionUERBaseCost: { __typename?: 'ServiceDataResultOfCollectionUERBaseCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CollectionUERBaseCostData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationConstructionTypesQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCalculationConstructionTypesQuery = { __typename?: 'Query', uercCalculationConstructionTypes: Array<{ __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string }> };

export type UercParseUerBaseCostBasisQueryVariables = Exact<{
  content: FileInput;
}>;


export type UercParseUerBaseCostBasisQuery = { __typename?: 'Query', uercParseUerBaseCostBasis: { __typename?: 'ServiceDataResultOfUerEstimateBaseCostData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UerEstimateBaseCostData', baseCost: { __typename?: 'UerEstimateBaseCost', unitCost: any, directCost?: any | null, emm?: any | null, eqp?: any | null, fot?: any | null, mtr?: any | null, nr?: any | null, ozp?: any | null, pir?: any | null, sp?: any | null, tm?: any | null, trn?: any | null, tz?: any | null, zpm?: any | null, sections: Array<{ __typename?: 'UerEstimateBaseCostSection', order?: number | null, name: string, prices: Array<{ __typename?: 'UerEstimateBaseCostPrice', type: UerBasisPriceTypeEnum, hasConsumptionRateMtr?: boolean | null, vr2001?: string | null, naclMask?: string | null, code: string, name: string, unit: string, estimateTotal: any, quantity: { __typename?: 'UerEstimateBaseCostPriceQuantity', unit: any, total: any, consumptionRateMtr?: any | null }, unitCost?: { __typename?: 'UerEstimateBaseCostPriceUnitCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'UerEstimateBaseCostPriceTotalCost', nr?: any | null, sp?: any | null, total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, unitWorkCost?: { __typename?: 'UerEstimateBaseCostPriceWorkCost', tz: any, tm: any } | null, totalWorkCost?: { __typename?: 'UerEstimateBaseCostPriceWorkCost', tz: any, tm: any } | null, resources: Array<{ __typename?: 'UerEstimateBaseCostResource', code: string, name: string, unit: string, type: UerBasisResourceCostTypeEnum, isDeleted?: boolean | null, isNotCount?: boolean | null, quantity: { __typename?: 'UerEstimateBaseCostResourceQuantity', unit: any, total: any }, unitCost?: { __typename?: 'UerEstimateBaseCostResourceCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null, totalCost?: { __typename?: 'UerEstimateBaseCostResourceCost', total: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null } | null }> }> }> }, general: { __typename?: 'UerEstimateCost', sectionName: string, groupName: string, code: string, name: string, chapter?: ChapterEnum | null, unit: string, workScopes: Array<{ __typename?: 'UerEstimateCostWorkScope', number: any, name: string }> } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCollectionRatioGroupsQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  ratioType: RatioTypeEnum;
}>;


export type UercCollectionRatioGroupsQueryQuery = { __typename?: 'Query', uercCollectionRatioGroups: Array<{ __typename?: 'CollectionRatioGroupData', id: any, name: string, parentId?: any | null, groupType?: DismantlingCoefficientTypeEnum | null }> };

export type CollectionRatiosQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionRatioDataForListSortInput> | CollectionRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataForListFilterInput>;
}>;


export type CollectionRatiosQuery = { __typename?: 'Query', collectionRatios?: { __typename?: 'UercCollectionRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioDataForList', id: any, code: string, name: string, collectionRatioGroupId?: any | null, collectionRatioGroupName?: string | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CollectionRatioCodeFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionRatioDataForListSortInput> | CollectionRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataForListFilterInput>;
}>;


export type CollectionRatioCodeFilterQueryQuery = { __typename?: 'Query', collectionRatioCodeFilterQuery?: { __typename?: 'UercCollectionRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioDataForList', id: any, code: string, name: string, collectionRatioGroupId?: any | null, collectionRatioGroupName?: string | null, ratioType: RatioTypeEnum }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CollectionRatioNameFilterQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionRatioDataForListSortInput> | CollectionRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataForListFilterInput>;
}>;


export type CollectionRatioNameFilterQueryQuery = { __typename?: 'Query', collectionRatioNameFilterQuery?: { __typename?: 'UercCollectionRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioDataForList', id: any, code: string, name: string, collectionRatioGroupId?: any | null, collectionRatioGroupName?: string | null, ratioType: RatioTypeEnum }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerCollectionUerBaseCostItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput> | CollectionUerBaseCostItemSortInput>;
}>;


export type UerCollectionUerBaseCostItemsQuery = { __typename?: 'Query', uercCollectionUERBaseCostItems?: { __typename?: 'UercCollectionUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItem', id: any, sectionName: string, groupName: string, code: string, name: string, unit: string, unitCost: any, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, chapter?: ChapterEnum | null, dataSource: CollectionUerDataSourceEnum, constructionTypeNames: Array<string>, uerClassifier?: UerClassifierEnum | null, hasRatios: boolean, status?: CollectionUerBaseCostStatus | null, workType: { __typename?: 'CatalogUERBaseWorkData', workUniqueId?: string | null, workCode?: string | null, workName?: string | null, workUnit?: string | null, workInSum: WorkInSumEnum, workRatio?: any | null } }> | null } | null };

export type UercCollectionUerBaseCostSectionNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostSectionNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostSectionNameFilter?: { __typename?: 'UercCollectionUERBaseCostSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostStatusFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostStatusFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostStatusFilter?: { __typename?: 'UercCollectionUERBaseCostStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfCollectionUERBaseCostStatus', value: CollectionUerBaseCostStatus }> | null } | null };

export type UercCollectionUerBaseCostGroupNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostGroupNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostGroupNameFilter?: { __typename?: 'UercCollectionUERBaseCostGroupNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostCodeFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostCodeFilter?: { __typename?: 'UercCollectionUERBaseCostCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostNameFilter?: { __typename?: 'UercCollectionUERBaseCostNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostChapterFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfChapterEnumSortInput> | FilterValueOfNullableOfChapterEnumSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostChapterFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostChapterFilter?: { __typename?: 'UercCollectionUERBaseCostChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type UercCollectionUerBaseCostUerClassifierFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfUerClassifierEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfNullableOfUerClassifierEnumSortInput> | FilterValueOfNullableOfUerClassifierEnumSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostUerClassifierFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostUerClassifierFilter?: { __typename?: 'UercCollectionUERBaseCostUerClassifierFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfUerClassifierEnum', value?: UerClassifierEnum | null }> | null } | null };

export type UercCollectionUerBaseCostWorkNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostWorkNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostWorkNameFilter?: { __typename?: 'UercCollectionUERBaseCostWorkNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostWorkInSumFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
  order?: InputMaybe<Array<FilterValueOfWorkInSumEnumSortInput> | FilterValueOfWorkInSumEnumSortInput>;
  filter?: InputMaybe<CollectionUerFilterInput>;
}>;


export type UercCollectionUerBaseCostWorkInSumFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostWorkInSumFilter?: { __typename?: 'UercCollectionUERBaseCostWorkInSumFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkInSumEnum', value: WorkInSumEnum }> | null } | null };

export type UercCollectionUerBaseCostEstimateBasisRowsQueryVariables = Exact<{
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostEstimateBasisRowFilterInput>;
}>;


export type UercCollectionUerBaseCostEstimateBasisRowsQuery = { __typename?: 'Query', uercCollectionUERBaseCostEstimateBasisRows: Array<{ __typename?: 'CollectionUERBaseCostEstimateBasisRow', code?: string | null, estimateTotal?: any | null, isDeleted?: boolean | null, isNotCount?: boolean | null, isPriceHeadLine: boolean, isSectionHeadLine: boolean, name: string, number?: number | null, parentRowId?: string | null, priceId?: any | null, resourceId?: any | null, rowId: string, sectionId: any, unit?: string | null, quantity?: { __typename?: 'CollectionUERBaseCostEstimateBasisRowQuantityData', total: any, unit: any } | null, totalCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisRowTotalCostData', emm?: any | null, mtr?: any | null, ozp?: any | null, total: any, zpm?: any | null, nr?: any | null, sp?: any | null } | null, totalWorkCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisRowWorkCostData', tm?: any | null, tz?: any | null } | null, unitCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisRowUnitCostData', emm?: any | null, mtr?: any | null, ozp?: any | null, total: any, zpm?: any | null } | null, unitWorkCost?: { __typename?: 'CollectionUERBaseCostEstimateBasisRowWorkCostData', tm?: any | null, tz?: any | null } | null }> };

export type UercCollectionUerBaseCostTotalsQueryVariables = Exact<{
  baseRowId: Scalars['Long'];
  calculationId: Scalars['Long'];
}>;


export type UercCollectionUerBaseCostTotalsQuery = { __typename?: 'Query', uercCollectionUERBaseCostTotals: Array<{ __typename?: 'CollectionUERBaseCostTotalItem', hasIndent: boolean, isHeadLine: boolean, name: string, sortOrder: number, value?: any | null }> };

export type UercRemoveCollectionUerBaseCostRowsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  baseRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UercRemoveCollectionUerBaseCostRowsMutation = { __typename?: 'Mutation', uercRemoveCollectionUERBaseCostRows: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationCollectionUerInfoQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCalculationCollectionUerInfoQuery = { __typename?: 'Query', uercCalculation: { __typename?: 'ServiceDataResultOfUercCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UercCalculationData', collectionUerInfo: { __typename?: 'CollectionUERInfoData', dataSource?: CollectionUerDataSourceEnum | null, pricesWithoutUerClassifierOrChapterCount: number, hasCatalogPrices: boolean, hasWorItems: boolean } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerGetCollectionUerBaseCostWorkScopesForUpdateQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  baseRowId: Scalars['Long'];
}>;


export type UerGetCollectionUerBaseCostWorkScopesForUpdateQuery = { __typename?: 'Query', uercCollectionUERBaseCostWorkScopes?: { __typename?: 'UercCollectionUERBaseCostWorkScopesCollectionSegment', items?: Array<{ __typename?: 'CollectionUERBaseCostWorkScopeData', number: any, name: string }> | null } | null };

export type UerUpdateCollectionUerBaseCostWorkScopesMutationVariables = Exact<{
  baseRowId: Scalars['Long'];
  inputs: Array<CollectionUerBaseCostWorkScopeUpdateInput> | CollectionUerBaseCostWorkScopeUpdateInput;
}>;


export type UerUpdateCollectionUerBaseCostWorkScopesMutation = { __typename?: 'Mutation', uercUpdateCollectionUERBaseCostWorkScopes: { __typename?: 'ServiceResult', code?: string | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercSetCollectionUerBaseCostRowPropertiesMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  input: CollectionUerBaseCostSetPropertiesInput;
}>;


export type UercSetCollectionUerBaseCostRowPropertiesMutation = { __typename?: 'Mutation', uercSetCollectionUERBaseCostRowProperties: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationDefaultsQueryVariables = Exact<{
  projectUniqueId: Scalars['String'];
}>;


export type UercCalculationDefaultsQuery = { __typename?: 'Query', uercCalculationDefaults: { __typename?: 'ServiceDataResultOfUercCalculationDefaultData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UercCalculationDefaultData', authoredBy: string, customer: string, status: CalculationStatusEnum, taxPercent: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCalculationQuery = { __typename?: 'Query', uercCalculation: { __typename?: 'ServiceDataResultOfUercCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UercCalculationData', hasCalculationObjects: boolean, amountWithTax?: any | null, amountWithoutTax?: any | null, authoredBy: string, costRounding: number, changeDate?: any | null, createdAt: any, customer: string, customerAddress?: string | null, id: any, note?: string | null, projectUniqueId: string, startDate?: any | null, status: CalculationStatusEnum, statusFollowers: Array<CalculationStatusEnum>, subject: string, supplyBasis: string, tax?: any | null, uniqueId: string, hasCalculationExecuted: boolean, lastComputedAt?: any | null, taxPercent?: any | null, catalogUerBase: { __typename?: 'CatalogUerBase', hasWorkKind?: boolean | null, name?: string | null, uniqueId?: string | null, version?: string | null }, constructionTypes: Array<{ __typename?: 'UercCalculationConstructionTypeData', id: any, uerOtherPercent?: any | null, usedInObjects: boolean, usedInOthers: boolean, coefficients: { __typename?: 'UerConversionCoefficients', kemm?: any | null, keqp?: any | null, kmtr?: any | null, knr?: any | null, kozp?: any | null, kpir?: any | null, ksp?: any | null }, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }>, seasons: Array<{ __typename?: 'UercCalculationSeasonData', seasonId: any, year: any }>, seasonsInflation: Array<{ __typename?: 'UercCalculationSeasonInflationData', inflationRate: any, seasonId: any, year: any }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCreateCalculationMutationVariables = Exact<{
  calculationInput: UercCalculationCreateInput;
}>;


export type UercCreateCalculationMutation = { __typename?: 'Mutation', uercCreateCalculation: { __typename?: 'ServiceDataResultOfUercCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UercCalculationData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateCalculationMutationVariables = Exact<{
  calculationInput: UercCalculationUpdateInput;
}>;


export type UercUpdateCalculationMutation = { __typename?: 'Mutation', uercUpdateCalculation: { __typename?: 'ServiceDataResultOfUercCalculationData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UercCalculationData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationObjectsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId?: InputMaybe<Scalars['Long']>;
}>;


export type UercCalculationObjectsQuery = { __typename?: 'Query', uercCalculationObjects: Array<{ __typename?: 'CalculationObjectData', codeWBS?: string | null, calculationId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, order?: number | null, parentId?: any | null, rootObjectId?: any | null, hasWorItems: boolean, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any, iconCode?: string | null } }> };

export type UercCreateCalculationObjectMutationVariables = Exact<{
  input: CalculationObjectCreateInput;
}>;


export type UercCreateCalculationObjectMutation = { __typename?: 'Mutation', uercCreateCalculationObject: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCreateCalculationSubObjectMutationVariables = Exact<{
  input: CalculationSubObjectCreateInput;
}>;


export type UercCreateCalculationSubObjectMutation = { __typename?: 'Mutation', uercCreateCalculationSubObject: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercRemoveCalculationObjectMutationVariables = Exact<{
  calculationObjectId: Scalars['Long'];
}>;


export type UercRemoveCalculationObjectMutation = { __typename?: 'Mutation', uercRemoveCalculationObject: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercIsUniqueCalculationObjectNameQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  calculationObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type UercIsUniqueCalculationObjectNameQuery = { __typename?: 'Query', uercIsUniqueCalculationObjectName: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercIsUniqueCalculationSubObjectNameQueryVariables = Exact<{
  calculationObjectId: Scalars['Long'];
  name: Scalars['String'];
  subObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UercIsUniqueCalculationSubObjectNameQuery = { __typename?: 'Query', uercIsUniqueCalculationSubObjectName: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercIsUniqueCalculationObjectCodeQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  calculationObjectId?: InputMaybe<Scalars['Long']>;
  code?: InputMaybe<Scalars['String']>;
}>;


export type UercIsUniqueCalculationObjectCodeQuery = { __typename?: 'Query', uercIsUniqueCalculationObjectCode: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UercUpdateCalculationObjectMutationVariables = Exact<{
  input: CalculationObjectUpdateInput;
}>;


export type UercUpdateCalculationObjectMutation = { __typename?: 'Mutation', uercUpdateCalculationObject: { __typename?: 'ServiceDataResultOfCalculationObjectData', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateCalculationSubObjectMutationVariables = Exact<{
  input: CalculationObjectUpdateInput;
}>;


export type UercUpdateCalculationSubObjectMutation = { __typename?: 'Mutation', uercUpdateCalculationSubObject: { __typename?: 'ServiceDataResultOfCalculationObjectData', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercSetCalculationObjectGuaranteedVolumeMutationVariables = Exact<{
  input: CalculationObjectGuaranteedVolumeInput;
}>;


export type UercSetCalculationObjectGuaranteedVolumeMutation = { __typename?: 'Mutation', uercSetCalculationObjectGuaranteedVolume: { __typename?: 'ServiceDataResultOfInt64__', buttonText?: string | null, code?: string | null, data?: Array<any> | null, message?: string | null, result: boolean, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercImportCalculationObjectsMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type UercImportCalculationObjectsMutation = { __typename?: 'Mutation', uercImportCalculationObjects: { __typename?: 'ServiceDataResultOfCountData', buttonText?: string | null, code?: string | null, message?: string | null, result: boolean, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercMoveCalculationObjectMutationVariables = Exact<{
  calculationObjectId: Scalars['Long'];
  newParentObjectId?: InputMaybe<Scalars['Long']>;
  insertAfterObjectId: Scalars['Long'];
}>;


export type UercMoveCalculationObjectMutation = { __typename?: 'Mutation', uercMoveCalculationObject: { __typename?: 'ServiceIdResultOfInt64', buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, id?: any | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCalculationObjectsWithVolumesQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
}>;


export type UercCalculationObjectsWithVolumesQuery = { __typename?: 'Query', uercCalculationObjectsWithVolumes: Array<{ __typename?: 'CalculationObjectData', id: any, name: string, order?: number | null, parentId?: any | null, rootObjectId?: any | null }> };

export type UercCopyCalculationObjectMutationVariables = Exact<{
  input: CalculationObjectCopyInput;
}>;


export type UercCopyCalculationObjectMutation = { __typename?: 'Mutation', uercCopyCalculationObject: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, id?: any | null } };

export type UercCollectionRatiosQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionRatioDataForListSortInput> | CollectionRatioDataForListSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataForListFilterInput>;
}>;


export type UercCollectionRatiosQuery = { __typename?: 'Query', uercCollectionRatios?: { __typename?: 'UercCollectionRatiosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioDataForList', id: any, status: CollectionRatioStatusEnum, code: string, name: string, collectionRatioGroupId?: any | null, collectionRatioGroupName?: string | null, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any, justification?: string | null, isCustom: boolean, isUsed: boolean, hasCosts: boolean }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  id: Scalars['Long'];
}>;


export type UercCollectionRatioQuery = { __typename?: 'Query', uercCollectionRatio: { __typename?: 'ServiceDataResultOfCollectionRatioDataWithCosts', data?: { __typename?: 'CollectionRatioDataWithCosts', code: string, collectionRatioGroupId?: any | null, collectionRatioGroupName?: string | null, id: any, isCustom: boolean, justification?: string | null, kem: any, kmat: any, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, name: string, ratioType: RatioTypeEnum, status: CollectionRatioStatusEnum, updatedAt?: any | null, uerBaseCostItems: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string }>, collectionRatioGroup?: { __typename?: 'CollectionRatioGroupDataWithCosts', id: any, name: string, parentId?: any | null, groupType?: DismantlingCoefficientTypeEnum | null, uerBaseCostItems: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string }> } | null } | null } };

export type UercCollectionUerBaseCostItemsHavingRatioQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsHavingRatioQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsHavingRatio?: { __typename?: 'UercCollectionUERBaseCostItemsHavingRatioCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, fullName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionUerBaseCostItemsHavingRatioNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsHavingRatioNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsHavingRatio?: { __typename?: 'UercCollectionUERBaseCostItemsHavingRatioCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', fullName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UercCollectionRatioCodeFilterQuery = { __typename?: 'Query', uercCollectionRatioCodeFilter?: { __typename?: 'UercCollectionRatioCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UercCollectionRatioNameFilterQuery = { __typename?: 'Query', uercCollectionRatioNameFilter?: { __typename?: 'UercCollectionRatioNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioGroupFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UercCollectionRatioGroupFilterQuery = { __typename?: 'Query', uercCollectionRatioGroupFilter?: { __typename?: 'UercCollectionRatioGroupFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioTypeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCollectionRatioTypeFilterQuery = { __typename?: 'Query', uercCollectionRatioTypeFilter?: { __typename?: 'UercCollectionRatioTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfRatioTypeEnum', value: RatioTypeEnum }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioStatusFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCollectionRatioStatusFilterQuery = { __typename?: 'Query', uercCollectionRatioStatusFilter?: { __typename?: 'UercCollectionRatioStatusFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfCollectionRatioStatusEnum', value: CollectionRatioStatusEnum }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionRatioJustificationFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercCollectionRatioJustificationFilterQuery = { __typename?: 'Query', uercCollectionRatioJustificationFilter?: { __typename?: 'UercCollectionRatioJustificationFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCatalogRatiosNotInCollectionQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogRatioDataSortInput> | CatalogRatioDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataFilterInput>;
}>;


export type UercCatalogRatiosNotInCollectionQuery = { __typename?: 'Query', uercCatalogRatiosNotInCollection?: { __typename?: 'UercCatalogRatiosNotInCollectionCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioData', id: any, code: string, name: string, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any, justification?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCatalogRatiosNotInCollectionRatioGroupFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogRatioDataSortInput> | CatalogRatioDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataFilterInput>;
}>;


export type UercCatalogRatiosNotInCollectionRatioGroupFilterQuery = { __typename?: 'Query', uercCatalogRatiosNotInCollectionRatioGroupFilter?: { __typename?: 'UercCatalogRatiosNotInCollectionCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioData', catalogRatioGroupName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCatalogRatiosNotInCollectionNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogRatioDataSortInput> | CatalogRatioDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogRatioDataFilterInput>;
}>;


export type UercCatalogRatiosNotInCollectionNameFilterQuery = { __typename?: 'Query', uercCatalogRatiosNotInCollectionNameFilter?: { __typename?: 'UercCatalogRatiosNotInCollectionCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioData', name: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCatalogRatiosNotInCollectionCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CatalogRatioDataSortInput> | CatalogRatioDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: CatalogRatioDataFilterInput;
}>;


export type UercCatalogRatiosNotInCollectionCodeFilterQuery = { __typename?: 'Query', uercCatalogRatiosNotInCollectionCodeFilter?: { __typename?: 'UercCatalogRatiosNotInCollectionCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogRatioData', code: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCopyCatalogRatiosToCollectionMutationMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  catalogRatioIdList: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UercCopyCatalogRatiosToCollectionMutationMutation = { __typename?: 'Mutation', uercCopyCatalogRatiosToCollection: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercIsCollectionRatioNameUniqueQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type UercIsCollectionRatioNameUniqueQueryQuery = { __typename?: 'Query', uercIsCollectionRatioNameUnique: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, actionRequired?: boolean | null, buttonText?: string | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercCollectionRatioGroupsWithCostsQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  ratioType: RatioTypeEnum;
}>;


export type UercCollectionRatioGroupsWithCostsQueryQuery = { __typename?: 'Query', uercCollectionRatioGroupsWithCosts: Array<{ __typename?: 'CollectionRatioGroupDataWithCosts', id: any, name: string, parentId?: any | null, groupType?: DismantlingCoefficientTypeEnum | null, uerBaseCostItems: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string, fullName?: string | null }> }> };

export type UercRemoveCollectionRatioMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioId: Scalars['Long'];
}>;


export type UercRemoveCollectionRatioMutation = { __typename?: 'Mutation', uercRemoveCollectionRatio: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, code?: string | null, id?: any | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercCollectionUerBaseCostItemsHavingRatioGroupQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioGroupId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsHavingRatioGroupQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsHavingRatioGroup?: { __typename?: 'UercCollectionUERBaseCostItemsHavingRatioGroupCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string, fullName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionUerBaseCostItemsHavingRatioGroupTotalCountQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioGroupId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsHavingRatioGroupTotalCountQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsHavingRatioGroupTotalCount?: { __typename?: 'UercCollectionUERBaseCostItemsHavingRatioGroupCollectionSegment', totalCount: number } | null };

export type UercCollectionUerBaseCostItemsHavingRatioGroupCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioGroupId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsHavingRatioGroupCodeFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsHavingRatioGroupCodeFilter?: { __typename?: 'UercCollectionUERBaseCostItemsHavingRatioGroupCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', code: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionUerBaseCostItemsHavingRatioGroupNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  collectionRatioGroupId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsHavingRatioGroupNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsHavingRatioGroupNameFilter?: { __typename?: 'UercCollectionUERBaseCostItemsHavingRatioGroupCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', fullName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerCollectionUerBaseCostItemsListQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput> | CollectionUerBaseCostItemSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
}>;


export type UerCollectionUerBaseCostItemsListQuery = { __typename?: 'Query', uercCollectionUERBaseCostItems?: { __typename?: 'UercCollectionUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItem', id: any, code: string, name: string, unit: string, groupName: string, fullName: string }> | null } | null };

export type UerCollectionUerBaseCostItemsCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput> | CollectionUerBaseCostItemSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
}>;


export type UerCollectionUerBaseCostItemsCodeFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsCodeFilter?: { __typename?: 'UercCollectionUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItem', code: string }> | null } | null };

export type UerCollectionUerBaseCostItemsNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput> | CollectionUerBaseCostItemSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
}>;


export type UerCollectionUerBaseCostItemsNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsNameFilter?: { __typename?: 'UercCollectionUERBaseCostItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItem', fullName: string }> | null } | null };

export type UercCreateCollectionRatioMutationVariables = Exact<{
  input: CollectionRatioCreateInput;
}>;


export type UercCreateCollectionRatioMutation = { __typename?: 'Mutation', uercCreateCollectionRatio: { __typename?: 'ServiceDataResultOfCollectionRatioDataWithCosts', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'CollectionRatioDataWithCosts', id: any, code: string, name: string, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any, justification?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercUpdateCollectionRatioMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  input: CollectionRatioUpdateInput;
}>;


export type UercUpdateCollectionRatioMutation = { __typename?: 'Mutation', uercUpdateCollectionRatio: { __typename?: 'ServiceDataResultOfCollectionRatioDataWithCosts', result: boolean, message?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, actionRequired?: boolean | null, buttonText?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null, data?: { __typename?: 'CollectionRatioDataWithCosts', id: any, code: string, name: string, updatedAt?: any | null, ratioType: RatioTypeEnum, kmat: any, ktz: any, ktzzpm: any, kozp: any, knr: any, ksp: any, kem: any, justification?: string | null } | null } };

export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroup?: { __typename?: 'UercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', id: any, code: string, name: string, unit: string, fullName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCodeFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCodeFilter?: { __typename?: 'UercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', code: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemMinimalSortInput> | CollectionUerBaseCostItemMinimalSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemMinimalFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupNameFilter?: { __typename?: 'UercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItemMinimal', fullName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercWorkVolumeItemsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeItemFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<WorkVolumeItemDataSortInput> | WorkVolumeItemDataSortInput>;
  where?: InputMaybe<WorkVolumeItemDataFilterInput>;
}>;


export type UercWorkVolumeItemsQuery = { __typename?: 'Query', uercWorkVolumeItems?: { __typename?: 'UercWorkVolumeItemsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkVolumeItemData', code: string, groupName?: string | null, hasConsumptionRate?: boolean | null, id: any, mtrConsumptionRate?: any | null, mtrRowId?: any | null, name: string, ratioRowId?: any | null, sectionName?: string | null, uerRowId?: any | null, unit: string, parentId?: any | null, isUpdatedFromUERBaseCosts: boolean, uerCode: string, updatedAt?: any | null, createdAt: any, values: Array<{ __typename?: 'WorkVolumeValueData', id?: any | null, objectId: any, seasonId: any, value?: any | null, formula?: string | null, formulaError?: string | null, hasInconsistentWorVolumes: boolean, worRowId?: any | null, summationDetails?: string | null }> }> | null } | null };

export type UercWorkVolumeObjectsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
}>;


export type UercWorkVolumeObjectsQuery = { __typename?: 'Query', uercWorkVolumeObjects: Array<{ __typename?: 'WorkVolumeObjectData', hasGuaranteedVolume?: boolean | null, id: any, name: string, rootObjectId?: any | null, rootObjectName?: string | null, seasonId: any, seasonYear: any, hasInconsistentWorVolumes: boolean, hasFormulaErrorVolumes: boolean }> };

export type UercWorkVolumeItemUerSectionNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
}>;


export type UercWorkVolumeItemUerSectionNameFilterQuery = { __typename?: 'Query', uercWorkVolumeItemUerSectionNameFilter?: { __typename?: 'UercWorkVolumeItemUerSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercWorkVolumeItemCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
}>;


export type UercWorkVolumeItemCodeFilterQuery = { __typename?: 'Query', uercWorkVolumeItemCodeFilter?: { __typename?: 'UercWorkVolumeItemCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercWorkVolumeItemCodeExtendedFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfWorkVolumeItemCodeFilterDataFilterInput>;
  filter?: InputMaybe<WorkVolumeFilterInput>;
}>;


export type UercWorkVolumeItemCodeExtendedFilterQuery = { __typename?: 'Query', uercWorkVolumeItemCodeExtendedFilter?: { __typename?: 'UercWorkVolumeItemCodeExtendedFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkVolumeItemCodeFilterData', value?: { __typename?: 'WorkVolumeItemCodeFilterData', uerCodeId?: any | null, uerCode: string, code: string, isUer: boolean, isRatio: boolean, isMtr: boolean, order: number } | null }> | null } | null };

export type UercWorkVolumeItemNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
}>;


export type UercWorkVolumeItemNameFilterQuery = { __typename?: 'Query', uercWorkVolumeItemNameFilter?: { __typename?: 'UercWorkVolumeItemNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercWorkVolumeItemUerGroupNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
}>;


export type UercWorkVolumeItemUerGroupNameFilterQuery = { __typename?: 'Query', uercWorkVolumeItemUerGroupNameFilter?: { __typename?: 'UercWorkVolumeItemUerGroupNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercWorkVolumeItemUnitFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeFilterInput>;
}>;


export type UercWorkVolumeItemUnitFilterQuery = { __typename?: 'Query', uercWorkVolumeItemUnitFilter?: { __typename?: 'UercWorkVolumeItemUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercAddCostsToWorMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  costIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UercAddCostsToWorMutation = { __typename?: 'Mutation', uercAddCostsToWor: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCollectionUerBaseCostItemsToAddToWorQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<CollectionUerBaseCostItemSortInput> | CollectionUerBaseCostItemSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionUerBaseCostItemFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsToAddToWorQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsToAddToWOR?: { __typename?: 'UercCollectionUERBaseCostItemsToAddToWORCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostItem', id: any, sectionName: string, groupName: string, code: string, name: string, unit: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercWorkVolumeMtrSelectionListQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  worParentId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionMtrItemShortFilterInput>;
}>;


export type UercWorkVolumeMtrSelectionListQuery = { __typename?: 'Query', uercWorkVolumeMtrSelectionList?: { __typename?: 'UercWorkVolumeMtrSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionMtrItemShort', id: any, name: string, code?: string | null, mtrType?: MtrTypeEnum | null, supplyBy?: ContragentTypeEnum | null, unit: string }> | null } | null };

export type UercWorkVolumeMtrSelectionListNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  uerRowId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type UercWorkVolumeMtrSelectionListNameFilterQuery = { __typename?: 'Query', uercWorkVolumeMtrSelectionListNameFilter?: { __typename?: 'UercWorkVolumeMtrSelectionListNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercWorkVolumeMtrSelectionListCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  uerRowId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type UercWorkVolumeMtrSelectionListCodeFilterQuery = { __typename?: 'Query', uercWorkVolumeMtrSelectionListCodeFilter?: { __typename?: 'UercWorkVolumeMtrSelectionListCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionMtrItemQueryQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  mtrId: Scalars['Long'];
}>;


export type UercCollectionMtrItemQueryQuery = { __typename?: 'Query', uercCollectionMtrItemQuery: { __typename?: 'ServiceDataResultOfCollectionMtrItem', data?: { __typename?: 'CollectionMtrItem', id: any, code?: string | null, name: string, unit: string, unitBaseCost?: any | null, unitCurrentCost?: any | null, consumptionRate?: any | null, hasConsumptionrateMtr: boolean, supplyBy?: ContragentTypeEnum | null, mtrType?: MtrTypeEnum | null, mtrKind?: string | null, unitWeight?: any | null, pricingType?: PricingTypeEnum | null, isUpdatedFromUERBaseCosts: boolean, updatedAt?: any | null, isIncludedInTransportCalculation: boolean, isRecommended: boolean } | null } };

export type UercAddMtrsToWorkVolumeFromCollectionMtrMutationVariables = Exact<{
  input: AddCollectionMtrToWorkVolumeInput;
}>;


export type UercAddMtrsToWorkVolumeFromCollectionMtrMutation = { __typename?: 'Mutation', uercAddMtrsToWorkVolumeFromCollectionMTR: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercUpdateCollectionMtrToWorkVolumeMutationVariables = Exact<{
  input: UpdateCollectionMtrToWorkVolumeInput;
}>;


export type UercUpdateCollectionMtrToWorkVolumeMutation = { __typename?: 'Mutation', uercUpdateCollectionMtrToWorkVolume: { __typename?: 'ServiceDataResultOfUpdateResponseCollectionMtrData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsToAddToWorSectionNameFilter?: { __typename?: 'UercCollectionUERBaseCostItemsToAddToWorSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsToAddToWorGroupNameFilter?: { __typename?: 'UercCollectionUERBaseCostItemsToAddToWorGroupNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostItemsToAddToWorNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsToAddToWorNameFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsToAddToWorNameFilter?: { __typename?: 'UercCollectionUERBaseCostItemsToAddToWorNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercCollectionUerBaseCostItemsToAddToWorCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  filter?: InputMaybe<CollectionUerToAddToWorFilterInput>;
}>;


export type UercCollectionUerBaseCostItemsToAddToWorCodeFilterQuery = { __typename?: 'Query', uercCollectionUERBaseCostItemsToAddToWorCodeFilter?: { __typename?: 'UercCollectionUERBaseCostItemsToAddToWorCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercWorkVolumeQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercWorkVolumeQuery = { __typename?: 'Query', uercWorkVolume: { __typename?: 'WorkVolumeData', number: number, createdAt?: any | null } };

export type UercCreateCollectionRatioToWorkVolumeMutationVariables = Exact<{
  input: CreateCollectionRatioToWorkVolumeInput;
}>;


export type UercCreateCollectionRatioToWorkVolumeMutation = { __typename?: 'Mutation', uercCreateCollectionRatioToWorkVolume: { __typename?: 'ServiceDataResultOfCollectionRatioData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercWorkVolumeRatiosSelectionListQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  uerRowId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  ratioType: RatioTypeEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioDataShortSortInput> | CollectionRatioDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosSelectionListQuery = { __typename?: 'Query', uercWorkVolumeRatiosSelectionList?: { __typename?: 'UercWorkVolumeRatiosSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioDataShort', id: any, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, name: string, code: string, kem: any, kmat: any, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioType: RatioTypeEnum }> | null } | null };

export type UercWorkVolumeRatiosSelectionListNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  uerRowId: Scalars['Long'];
  ratioType: RatioTypeEnum;
  constructionTypeId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioDataShortSortInput> | CollectionRatioDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosSelectionListNameFilterQuery = { __typename?: 'Query', uercWorkVolumeRatiosSelectionListNameFilter?: { __typename?: 'UercWorkVolumeRatiosSelectionListCollectionSegment', items?: Array<{ __typename?: 'CollectionRatioDataShort', name: string }> | null } | null };

export type UercWorkVolumeRatiosSelectionListCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  uerRowId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  ratioType: RatioTypeEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionRatioDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioDataShortSortInput> | CollectionRatioDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosSelectionListCodeFilterQuery = { __typename?: 'Query', uercWorkVolumeRatiosSelectionListCodeFilter?: { __typename?: 'UercWorkVolumeRatiosSelectionListCollectionSegment', items?: Array<{ __typename?: 'CollectionRatioDataShort', code: string }> | null } | null };

export type UercRemoveFromWorMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  worRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UercRemoveFromWorMutation = { __typename?: 'Mutation', uercRemoveFromWor: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercAddRatiosToWorkVolumeFromCollectionRatioMutationVariables = Exact<{
  input: AddRatiosToWorkVolumeInput;
}>;


export type UercAddRatiosToWorkVolumeFromCollectionRatioMutation = { __typename?: 'Mutation', uercAddRatiosToWorkVolumeFromCollectionRatio: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercExportWorTemplateAsExcelQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type UercExportWorTemplateAsExcelQuery = { __typename?: 'Query', uercExportWorTemplateAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, actionRequired?: boolean | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } };

export type UercExportWorAsExcelQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  fileType?: InputMaybe<WorExcelFileType>;
  verticalSortType?: InputMaybe<WorUerSortType>;
}>;


export type UercExportWorAsExcelQuery = { __typename?: 'Query', uercExportWorAsExcel: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, buttonText?: string | null, actionRequired?: boolean | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null } };

export type UercSetWorkVolumeValueMutationVariables = Exact<{
  input: SetWorkVolumeValueInput;
}>;


export type UercSetWorkVolumeValueMutation = { __typename?: 'Mutation', uercSetWorkVolumeValue: { __typename?: 'ServiceDataResultOfWorkVolumeValueData__', result: boolean, message?: string | null, data?: Array<{ __typename?: 'WorkVolumeValueData', id?: any | null, objectId: any, seasonId: any, value?: any | null, formula?: string | null, formulaError?: string | null, hasInconsistentWorVolumes: boolean, worRowId?: any | null, summationDetails?: string | null } | null> | null } };

export type UercWorkVolumeFormulaVariablesQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  worRowId: Scalars['Long'];
  calculationObjectId: Scalars['Long'];
  calculationSeasonId: Scalars['Long'];
}>;


export type UercWorkVolumeFormulaVariablesQuery = { __typename?: 'Query', uercWorkVolumeFormulaVariables?: { __typename?: 'UercWorkVolumeFormulaVariablesCollectionSegment', items?: Array<{ __typename?: 'WorkVolumeFormulaVariableData', id: any, name: string, coefficients?: string | null }> | null } | null };

export type UercWorkVolumeRatiosWithUersSelectionListQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<CollectionRatioUersDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioUersDataShortSortInput> | CollectionRatioUersDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosWithUersSelectionListQuery = { __typename?: 'Query', uercWorkVolumeRatiosWithUersSelectionList?: { __typename?: 'UercWorkVolumeRatiosWithUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioUersDataShort', id: any, name: string, code: string, ratioType: RatioTypeEnum, catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null, kem: any, kmat: any, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any }> | null } | null };

export type UercWorkVolumeRatiosWithUersSelectionListRatioGroupsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<CollectionRatioUersDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioUersDataShortSortInput> | CollectionRatioUersDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosWithUersSelectionListRatioGroupsQuery = { __typename?: 'Query', uercWorkVolumeRatiosWithUersSelectionListRatioGroups?: { __typename?: 'UercWorkVolumeRatiosWithUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionRatioUersDataShort', catalogRatioGroupId?: any | null, catalogRatioGroupName?: string | null }> | null } | null };

export type UercWorkVolumeRatiosWithUersSelectionListCodeFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<CollectionRatioUersDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioUersDataShortSortInput> | CollectionRatioUersDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosWithUersSelectionListCodeFilterQuery = { __typename?: 'Query', uercWorkVolumeRatiosWithUersSelectionListCodeFilter?: { __typename?: 'UercWorkVolumeRatiosWithUersSelectionListCollectionSegment', items?: Array<{ __typename?: 'CollectionRatioUersDataShort', code: string }> | null } | null };

export type UercWorkVolumeRatiosWithUersSelectionListNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<CollectionRatioUersDataShortFilterInput>;
  order?: InputMaybe<Array<CollectionRatioUersDataShortSortInput> | CollectionRatioUersDataShortSortInput>;
}>;


export type UercWorkVolumeRatiosWithUersSelectionListNameFilterQuery = { __typename?: 'Query', uercWorkVolumeRatiosWithUersSelectionListNameFilter?: { __typename?: 'UercWorkVolumeRatiosWithUersSelectionListCollectionSegment', items?: Array<{ __typename?: 'CollectionRatioUersDataShort', name: string }> | null } | null };

export type UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  constructionTypeId: Scalars['Int'];
}>;


export type UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterQuery = { __typename?: 'Query', uercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilter?: { __typename?: 'UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UercAddRatiosMassToWorkVolumeFromCollectionRatioMutationVariables = Exact<{
  input: AddRatiosMassToWorkVolumeInput;
}>;


export type UercAddRatiosMassToWorkVolumeFromCollectionRatioMutation = { __typename?: 'Mutation', uercAddRatiosMassToWorkVolumeFromCollectionRatio: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercCreateCollectionRatioMassToWorkVolumeMutationVariables = Exact<{
  input: CreateCollectionRatioMassToWorkVolumeInput;
}>;


export type UercCreateCollectionRatioMassToWorkVolumeMutation = { __typename?: 'Mutation', uercCreateCollectionRatioMassToWorkVolume: { __typename?: 'ServiceDataResultOfCollectionRatioData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercRemoveUnusedCollectionMtrToWorkVolumeMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Long'];
}>;


export type UercRemoveUnusedCollectionMtrToWorkVolumeMutation = { __typename?: 'Mutation', uercRemoveUnusedCollectionMtrToWorkVolume: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercWorkVolumeItemRatioGroupQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerId: Scalars['Long'];
  ratioType: RatioTypeEnum;
}>;


export type UercWorkVolumeItemRatioGroupQuery = { __typename?: 'Query', uercWorkVolumeItemRatioGroup?: { __typename?: 'UercWorkVolumeItemRatioGroupCollectionSegment', items?: Array<{ __typename?: 'CollectionRatioGroupData', id: any, name: string, parentId?: any | null, groupType?: DismantlingCoefficientTypeEnum | null }> | null } | null };

export type UercWorkVolumeRatioCollectionUersSelectionListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostRatioMinimalFilterInput>;
  order?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalSortInput> | CollectionUerBaseCostRatioMinimalSortInput>;
}>;


export type UercWorkVolumeRatioCollectionUersSelectionListQuery = { __typename?: 'Query', uercWorkVolumeRatioCollectionUersSelectionList?: { __typename?: 'UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostRatioMinimal', code: string, fullName?: string | null, id: any, name: string, ratioId: any, status?: CollectionUerBaseCostStatus | null, unit: string }> | null } | null };

export type UercWorkVolumeRatioCollectionUersSelectionListCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostRatioMinimalFilterInput>;
  order?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalSortInput> | CollectionUerBaseCostRatioMinimalSortInput>;
}>;


export type UercWorkVolumeRatioCollectionUersSelectionListCodeFilterQuery = { __typename?: 'Query', uercWorkVolumeRatioCollectionUersSelectionListCodeFilter?: { __typename?: 'UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostRatioMinimal', code: string }> | null } | null };

export type UercWorkVolumeRatioCollectionUersSelectionListFullNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostRatioMinimalFilterInput>;
  order?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalSortInput> | CollectionUerBaseCostRatioMinimalSortInput>;
}>;


export type UercWorkVolumeRatioCollectionUersSelectionListFullNameFilterQuery = { __typename?: 'Query', uercWorkVolumeRatioCollectionUersSelectionListFullNameFilter?: { __typename?: 'UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostRatioMinimal', fullName?: string | null }> | null } | null };

export type UercWorkVolumeRatioCollectionUersSelectionListStatusFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioId: Scalars['Long'];
  where?: InputMaybe<CollectionUerBaseCostRatioMinimalFilterInput>;
  order?: InputMaybe<Array<CollectionUerBaseCostRatioMinimalSortInput> | CollectionUerBaseCostRatioMinimalSortInput>;
}>;


export type UercWorkVolumeRatioCollectionUersSelectionListStatusFilterQuery = { __typename?: 'Query', uercWorkVolumeRatioCollectionUersSelectionListStatusFilter?: { __typename?: 'UercWorkVolumeRatioCollectionUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CollectionUerBaseCostRatioMinimal', status?: CollectionUerBaseCostStatus | null }> | null } | null };

export type UercTransferWorkVolumeMutationVariables = Exact<{
  input: TransferWorkVolumeInput;
}>;


export type UercTransferWorkVolumeMutation = { __typename?: 'Mutation', uercTransferWorkVolume: { __typename?: 'ServiceResult', result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UercChangeSeasonWorkVolumeMutationVariables = Exact<{
  input: ChangeSeasonWorkVolumeInput;
}>;


export type UercChangeSeasonWorkVolumeMutation = { __typename?: 'Mutation', uercChangeSeasonWorkVolume: { __typename?: 'ServiceResult', result: boolean, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UercWorkVolumeObjectAdditionalQueryVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  filter?: InputMaybe<WorkVolumeItemFilterInput>;
  objectId: Scalars['Long'];
  seasonId: Scalars['Long'];
}>;


export type UercWorkVolumeObjectAdditionalQuery = { __typename?: 'Query', uercWorkVolumeObjectAdditional: { __typename?: 'WorkVolumeObjectAdditionalData', inconsistentWorRowNumbers: Array<any>, formulaErrorRowNumbers: Array<any> } };

export type UercImportWorkVolumeXmlMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  seasonId: Scalars['Long'];
  files: Array<FileInput> | FileInput;
  mtrSelections?: InputMaybe<Array<MtrSelectionInput> | MtrSelectionInput>;
}>;


export type UercImportWorkVolumeXmlMutation = { __typename?: 'Mutation', uercImportWorkVolumeXml: { __typename?: 'ServiceDataResultOfWorkVolumeImportResult', result: boolean, message?: string | null, code?: string | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null, data?: { __typename?: 'WorkVolumeImportResult', addedUersQuantity: number, addedRatiosQuantity: number, addedMtrsQuantity: number, addedMtrsWithoutVolumesQuantity: number, addedUerConstructionTypeLinksQuantity: number, warnings: Array<string>, mtrCandidates?: Array<{ __typename?: 'MtrImportCandidate', key: string, name: string, consumptionRate?: any | null, selectedCollectionMtrId?: any | null, uerCode: string, unit: string, candidates: Array<{ __typename?: 'MtrCandidateItem', unit: string, name: string, mtrType?: MtrTypeEnum | null, id: any, cost?: any | null, contragentType?: ContragentTypeEnum | null, consumptionRateMtr?: any | null, code?: string | null }> }> | null } | null } };

export type UercImportExcelWorMutationVariables = Exact<{
  calculationId: Scalars['Long'];
  fileContent: FileInput;
  fileType?: InputMaybe<WorExcelFileType>;
  mtrSelections?: InputMaybe<Array<MtrSelectionInput> | MtrSelectionInput>;
}>;


export type UercImportExcelWorMutation = { __typename?: 'Mutation', uercImportExcelWor: { __typename?: 'ServiceDataResultOfWorkVolumeImportResult', result: boolean, message?: string | null, code?: string | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null, data?: { __typename?: 'WorkVolumeImportResult', addedUersQuantity: number, addedMtrsQuantity: number, addedRatiosQuantity: number, addedMtrsWithoutVolumesQuantity: number, addedUerConstructionTypeLinksQuantity: number, warnings: Array<string>, mtrCandidates?: Array<{ __typename?: 'MtrImportCandidate', key: string, name: string, consumptionRate?: any | null, selectedCollectionMtrId?: any | null, uerCode: string, unit: string, candidates: Array<{ __typename?: 'MtrCandidateItem', unit: string, name: string, mtrType?: MtrTypeEnum | null, id: any, cost?: any | null, contragentType?: ContragentTypeEnum | null, consumptionRateMtr?: any | null, code?: string | null }> }> | null } | null } };

export type GetCalculationSeasonsQueryVariables = Exact<{
  calculationId: Scalars['Long'];
}>;


export type GetCalculationSeasonsQuery = { __typename?: 'Query', uercCalculationSeasons: Array<{ __typename?: 'UercCalculationSeasonData', seasonId: any, year: any }> };

export type UerCreateContractMutationVariables = Exact<{
  fileContent: FileInput;
  importOption?: InputMaybe<ContractImportEnum>;
  projectUniqueId: Scalars['String'];
  catalogUERBaseUniqueId?: InputMaybe<Scalars['String']>;
}>;


export type UerCreateContractMutation = { __typename?: 'Mutation', uerCreateContract: { __typename?: 'ServiceDataResultOfUerContractData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UerContractData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractMutationVariables = Exact<{
  id: Scalars['Long'];
  name: Scalars['String'];
  status: ContractStatusEnum;
  subject: Scalars['String'];
  internalNumber: Scalars['String'];
  customer?: InputMaybe<Scalars['String']>;
  customerAddress?: InputMaybe<Scalars['String']>;
  contractor: Scalars['String'];
  contractorAddress?: InputMaybe<Scalars['String']>;
  account?: InputMaybe<Scalars['String']>;
  signingDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  finishDate?: InputMaybe<Scalars['DateTime']>;
  amountWithoutTax?: InputMaybe<Scalars['Decimal']>;
  amountWithTax?: InputMaybe<Scalars['Decimal']>;
  tax?: InputMaybe<Scalars['Decimal']>;
  note?: InputMaybe<Scalars['String']>;
  supplyBasis: Scalars['String'];
  codeOKPD?: InputMaybe<Scalars['String']>;
  codeOKUD?: InputMaybe<Scalars['String']>;
  contractorOKPO?: InputMaybe<Scalars['String']>;
  customerOKPO?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  priceParameters?: InputMaybe<ContractPriceParamsUpdateInput>;
  remainder?: InputMaybe<Scalars['Decimal']>;
  costRounding: Scalars['Int'];
}>;


export type UerUpdateContractMutation = { __typename?: 'Mutation', uerUpdateContract: { __typename?: 'ServiceDataResultOfUerContractData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UerContractData', id: any, signingDate?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueContractInternalNumberQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['Long']>;
  internalNumber: Scalars['String'];
}>;


export type UerIsUniqueContractInternalNumberQuery = { __typename?: 'Query', uerIsUniqueContractInternalNumber: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSetContractSeasonsMutationVariables = Exact<{
  contractId: Scalars['Long'];
  years: Array<Scalars['Short']> | Scalars['Short'];
}>;


export type UerSetContractSeasonsMutation = { __typename?: 'Mutation', uerSetContractSeasons: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractObjectsQueryVariables = Exact<{
  constructionTypeId?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractObjectDataSortInput> | ContractObjectDataSortInput>;
  where?: InputMaybe<ContractObjectDataFilterInput>;
}>;


export type UerContractObjectsQuery = { __typename?: 'Query', uerContractObjects: Array<{ __typename?: 'ContractObjectData', hasWorkOrdersInProgress?: boolean | null, contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, hasActsKC2?: boolean | null, codeWBS?: string | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> };

export type UerExportContractResultsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerExportContractResultsQuery = { __typename?: 'Query', uerExportContractResults: { __typename?: 'ServiceDataResultOfFileContent', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerContractOtherCostLimitSpanSelectionListQueryVariables = Exact<{
  contractId: Scalars['Long'];
  otherCostId?: InputMaybe<Scalars['Long']>;
}>;


export type UerContractOtherCostLimitSpanSelectionListQuery = { __typename?: 'Query', uerContractOtherCostLimitSpanSelectionList: Array<{ __typename?: 'ContractOtherCostLimitSpanSelectionItem', actual: any, constructionTypeId: any, cost?: any | null, isSelected: boolean, name: string, otherCostTypeUniqueId?: string | null, plan: any, reminder: any, spanId?: any | null, spanType: ContractOtherCostLimitSpanTypeEnum, totalType?: UerTotal_AlcTypeEnum | null, spanSeasons?: Array<{ __typename?: 'LimitSpanReminderSeason', actual?: any | null, contractSeasonId: any, plan?: any | null, reminder?: any | null, year: any, cost?: any | null }> | null }> };

export type UerContractWorkOrdersQueryVariables = Exact<{
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<ContractWorkOrderDataSortInput> | ContractWorkOrderDataSortInput>;
  where?: InputMaybe<ContractWorkOrderDataFilterInput>;
}>;


export type UerContractWorkOrdersQuery = { __typename?: 'Query', uerContractWorkOrders: Array<{ __typename?: 'ContractWorkOrderData', hasActsKC2?: boolean | null, internalNumber: string, signingDate?: any | null, status: WorkOrderStatusEnum, workOrderId: any, workOrderChange?: { __typename?: 'UerWorkOrderChangeNavData', id?: any | null, metadata?: string | null, name: string, navLinkId: string, signingDate?: any | null, status: WorkOrderChangeStatusEnum, workOrderChangeNumber: string, workOrderNumber: string } | null }> };

export type ContractCatalogsQueryVariables = Exact<{
  where?: InputMaybe<CatalogItemDataFilterInput>;
}>;


export type ContractCatalogsQuery = { __typename?: 'Query', catalogs?: { __typename?: 'CatalogsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogItemData', authoredBy?: string | null, createdAt: any, id: any, metadata?: any | null, name: string, subsidiaryId?: any | null, subsidiaryName?: string | null, uniqueId: string, updatedAt?: any | null, type: { __typename?: 'CatalogTypeData', allowMultiple: boolean, canCreate: boolean, methodologies: Array<ProjectMethodologyEnum>, name: string, uniqueId: string } }> | null } | null };

export type UerCatalogsQueryVariables = Exact<{
  where?: InputMaybe<CatalogItemDataFilterInput>;
}>;


export type UerCatalogsQuery = { __typename?: 'Query', uerCatalogs?: { __typename?: 'UerCatalogsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogItemData', id: any, name: string, uniqueId: string, authoredBy?: string | null, createdAt: any, metadata?: any | null, subsidiaryId?: any | null, subsidiaryName?: string | null, updatedAt?: any | null, type: { __typename?: 'CatalogTypeData', allowMultiple: boolean, canCreate: boolean, methodologies: Array<ProjectMethodologyEnum>, name: string, uniqueId: string } }> | null } | null };

export type UerContractActionLogEntriesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<UerActionLogDataFilterInput>;
  order?: InputMaybe<Array<UerActionLogDataSortInput> | UerActionLogDataSortInput>;
}>;


export type UerContractActionLogEntriesQuery = { __typename?: 'Query', uerContractActionLogEntries?: { __typename?: 'UerContractActionLogEntriesCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'UerActionLogData', contractId: any, date: any, entityName: string, id: any, userLogin: string, entityDisplayName: string }> | null } | null };

export type UerContractQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerContractQuery = { __typename?: 'Query', uerContract: { __typename?: 'ServiceDataResultOfUerContractData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UerContractData', costRounding: number, hasFilledAddresses: boolean, hasEmptyFormulaInContract: boolean, hasEmptyOtherCostTypeInContract: boolean, hasNoPlanByConstructionType?: boolean | null, account?: string | null, documentUrl?: string | null, createdAt: any, hasContractChanges: boolean, hasPriceParams: boolean, hasOthers: boolean, isEditablePriceParams: boolean, id: any, codeOKUD?: string | null, codeOKPD?: string | null, customerOKPO?: string | null, contractorOKPO?: string | null, name?: string | null, projectName: string, status: ContractStatusEnum, authoredBy: string, subject?: string | null, internalNumber: string, customer?: string | null, customerAddress?: string | null, contractor?: string | null, contractorAddress?: string | null, signingDate?: any | null, startDate?: any | null, finishDate?: any | null, amountWithTax?: any | null, amountWithoutTax?: any | null, tax?: any | null, remainder?: any | null, note?: string | null, supplyBasis: string, uerOthersPercent?: any | null, hasSupplyBasisInContract: boolean, hasPriceListRatio: boolean, hasFilledMandatoryProperties: boolean, unreadyUerRowCount: number, isPriceCollectionLoaded: boolean, statusFollowers: Array<ContractStatusEnum>, workOrderNavs?: Array<{ __typename?: 'UerWorkOrderNavData', id?: any | null, internalNumber: string, name: string, signingDate?: any | null, status: WorkOrderStatusEnum, actKC2Navs?: Array<{ __typename?: 'ActKC2NavData', date?: any | null, id: any, number?: any | null, status: ActKc2StatusEnum }> | null, workOrderChanges?: Array<{ __typename?: 'UerWorkOrderChangeNavData', id?: any | null, signingDate?: any | null, status: WorkOrderChangeStatusEnum, workOrderChangeNumber: string, workOrderNumber: string }> | null }> | null, constructionTypes?: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }> | null, constructionTypeAttributes?: Array<{ __typename?: 'ConstructionTypeAttributeData', northernAllowancePercent?: any | null, uerOthersPercent?: any | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null, otherCosts?: Array<{ __typename?: 'ContractOtherCostData', id: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, section?: SectionEnum | null, chapter?: ChapterEnum | null, limits: Array<{ __typename?: 'ContractOtherCostLimitData', cost: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, season: { __typename?: 'ContractSeasonData', id: any, year: any } }> }> | null, conversionIndices?: Array<{ __typename?: 'ContractConversionIndexData', id: any, kozp?: any | null, kemm?: any | null, kmtr?: any | null, keqp?: any | null, knr?: any | null, ksp?: any | null, kpir?: any | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, name: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null, seasons?: Array<{ __typename?: 'ContractSeasonData', id: any, year: any }> | null, seasonsInflation?: Array<{ __typename?: 'ContractSeasonInflationData', id: any, year: any, inflationRate: any }> | null, contractPlans?: Array<{ __typename?: 'ContractResultPlanData', name: string, type?: ContractResultEnum | null, contractPlan?: any | null, isHeadLine: boolean, isEditable: boolean, constructionTypePlanResults?: Array<{ __typename?: 'ContractConstructionTypeResultData', constructionTypeId: number, contractPlan?: any | null, status?: ContractOtherConstructionTypeRelationStatusEnum | null }> | null }> | null, cost: { __typename?: 'ContractCostData', contractPlan?: any | null, contractPlanReminderPercent?: any | null, contractPlanReminderWithTax?: any | null, contractPlanTax?: any | null, contractPlanWithTax?: any | null, deviationTip?: DeviationTipEnum | null, workOrdersPlanCost?: any | null, workOrdersPlanCostWithTax?: any | null }, catalogUerBase: { __typename?: 'CatalogUerBase', version?: string | null, uniqueId?: string | null, name?: string | null, hasWorkKind?: boolean | null } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type GetUerContractConstructionTypesAndSeasonsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type GetUerContractConstructionTypesAndSeasonsQuery = { __typename?: 'Query', uerContract: { __typename?: 'ServiceDataResultOfUerContractData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'UerContractData', constructionTypes?: Array<{ __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }> | null, seasons?: Array<{ __typename?: 'ContractSeasonData', id: any, year: any }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractResultsQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerContractResultsQuery = { __typename?: 'Query', uerContractResults: { __typename?: 'ServiceDataResultOfContractResultsViewData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractResultsViewData', workOrders?: Array<{ __typename?: 'UerWorkOrderNavData', id?: any | null, internalNumber: string, signingDate?: any | null, status: WorkOrderStatusEnum }> | null, contractResults?: Array<{ __typename?: 'ContractResultData', type?: ContractResultEnum | null, name: string, isHeadLine: boolean, isEditable: boolean, contractPlan?: any | null, workOrderPlanSum?: any | null, contractRest?: any | null, deviation?: DeviationEnum | null, deviationTip?: DeviationTipEnum | null, completedDeviation?: DeviationEnum | null, completedRestDeviationTip?: DeviationTipEnum | null, completed?: any | null, completedRest?: any | null, code?: string | null, otherCostStatus?: ContractOtherStatusEnum | null, otherCostTypeUniqueId?: string | null, rowType: ContractResultRowTypeEnum, totalType?: UerTotal_AlcTypeEnum | null, workOrderResults: Array<{ __typename?: 'ContractWorkOrderResultData', workOrderId: any, planPrice?: any | null, completedPrice?: any | null, deviation?: DeviationEnum | null, constructionTypeResults: Array<{ __typename?: 'WorkOrderConstructionTypeResultData', constructionTypeId: number, planPrice?: any | null, completedPrice?: any | null }> }>, constructionTypePlanResults?: Array<{ __typename?: 'ContractConstructionTypeResultData', constructionTypeId: number, contractPlan?: any | null, status?: ContractOtherConstructionTypeRelationStatusEnum | null, contractPlanSeasons?: Array<{ __typename?: 'SeasonResultData', contractSeasonId: any, value?: any | null, year: any }> | null, workOrderPlanSumSeasons?: Array<{ __typename?: 'SeasonResultData', contractSeasonId: any, value?: any | null, year: any }> | null }> | null }> | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderMtrRowsForComparisonQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
}>;


export type UerWorkOrderMtrRowsForComparisonQuery = { __typename?: 'Query', uerWorkOrderMtrRowsForComparison?: { __typename?: 'UerWorkOrderMtrRowsForComparisonCollectionSegment', items?: Array<{ __typename?: 'PriceListMtrRowData', key?: string | null, code: string, contractId: any, hasDuplicateNeighbours: boolean, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, justification?: string | null, mtrSupplyAndType: MtrSupplyAndTypeEnum, mtrType?: MtrTypeEnum | null, name: string, note?: string | null, pricingType: PricingTypeEnum, status: MtrRecordStatusEnum, supplyBasis?: string | null, supplyBy?: ContragentTypeEnum | null, unit: string, unitCost: any, unitWeight?: any | null, volume?: any | null }> | null } | null };

export type UerWorkOrderPriceListMtrAssignCodeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceListMtrAssignCodeFilterQuery = { __typename?: 'Query', uerWorkOrderPriceListMtrAssignCodeFilter?: { __typename?: 'UerWorkOrderPriceListMtrAssignCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceListMtrAssignNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceListMtrAssignNameFilterQuery = { __typename?: 'Query', uerWorkOrderPriceListMtrAssignNameFilter?: { __typename?: 'UerWorkOrderPriceListMtrAssignNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListMtrRowQueryVariables = Exact<{
  mtrRowId: Scalars['Long'];
}>;


export type UerPriceListMtrRowQuery = { __typename?: 'Query', uerPriceListMtrRow: { __typename?: 'ServiceDataResultOfPriceListMtrRowData', buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListMtrRowData', id: any, code: string, key?: string | null, name: string, unit: string, volume?: any | null, unitWeight?: any | null, unitCost: any, supplyBy?: ContragentTypeEnum | null, mtrType?: MtrTypeEnum | null, justification?: string | null, status: MtrRecordStatusEnum } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateMtrRowMutationVariables = Exact<{
  chapter?: InputMaybe<ChapterEnum>;
  input: PriceListMtrRowUpdateInput;
}>;


export type UerUpdateMtrRowMutation = { __typename?: 'Mutation', uerUpdateMtrRow: { __typename?: 'ServiceDataResultOfPriceListMtrRowData', result: boolean, message?: string | null, hasValidation: boolean, buttonText?: string | null, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListRatioRowsQueryVariables = Exact<{
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListRatioCoefficientRowDataSortInput> | PriceListRatioCoefficientRowDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioCoefficientRowDataFilterInput>;
}>;


export type UerPriceListRatioRowsQuery = { __typename?: 'Query', uerPriceListRatioRows?: { __typename?: 'UerPriceListRatioRowsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'PriceListRatioCoefficientRowData', code: string, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, status: RatioRecordStatusEnum, workConditions: string }> | null } | null };

export type UerPriceListRatioUerRowsQueryVariables = Exact<{
  order?: InputMaybe<Array<PriceListRatioUerRowDataSortInput> | PriceListRatioUerRowDataSortInput>;
  ratioRowId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListRatioUerRowDataFilterInput>;
}>;


export type UerPriceListRatioUerRowsQuery = { __typename?: 'Query', uerPriceListRatioUerRows?: { __typename?: 'UerPriceListRatioUerRowsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'PriceListRatioUerRowData', appliesToCode: string, appliesToCodeName: string, appliesToId: any, appliesToLinkStatus: RatioRecordStatusEnum, ratioRowId: any }> | null } | null };

export type UerPriceListRatioSectionNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioSectionNameFilterQuery = { __typename?: 'Query', uerPriceListRatioSectionNameFilter?: { __typename?: 'UerPriceListRatioSectionNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioGroupFullNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioGroupFullNameFilterQuery = { __typename?: 'Query', uerPriceListRatioGroupFullNameFilter?: { __typename?: 'UerPriceListRatioGroupFullNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioAppliesToFullNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioAppliesToFullNameFilterQuery = { __typename?: 'Query', uerPriceListRatioAppliesToFullNameFilter?: { __typename?: 'UerPriceListRatioAppliesToFullNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioCodeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioCodeFilterQuery = { __typename?: 'Query', uerPriceListRatioCodeFilter?: { __typename?: 'UerPriceListRatioCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioWorkConditionsFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListRatioWorkConditionsFilterQuery = { __typename?: 'Query', uerPriceListRatioWorkConditionsFilter?: { __typename?: 'UerPriceListRatioWorkConditionsFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioWorkTypeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListRatioWorkTypeFilterQuery = { __typename?: 'Query', uerPriceListRatioWorkTypeFilter?: { __typename?: 'UerPriceListRatioWorkTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListRatioStatusFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListRatioStatusFilterQuery = { __typename?: 'Query', uerPriceListRatioStatusFilter?: { __typename?: 'UerPriceListRatioStatusFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfRatioRecordStatusEnum', value?: RatioRecordStatusEnum | null }> | null } | null };

export type UerRemoveUnusedRatioRowsMutationVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerRemoveUnusedRatioRowsMutation = { __typename?: 'Mutation', uerRemoveUnusedRatioRows: { __typename?: 'ServiceDataResultOfCountData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRatioAppliesToCodeFilterQueryVariables = Exact<{
  ratioRowId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerRatioAppliesToCodeFilterQuery = { __typename?: 'Query', uerRatioAppliesToCodeFilter?: { __typename?: 'UerRatioAppliesToCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerRatioAppliesToCodeNameFilterQueryVariables = Exact<{
  ratioRowId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerRatioAppliesToCodeNameFilterQuery = { __typename?: 'Query', uerRatioAppliesToCodeNameFilter?: { __typename?: 'UerRatioAppliesToCodeNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerRatioAppliesToLinkStatusFilterQueryVariables = Exact<{
  ratioRowId: Scalars['Long'];
  order?: InputMaybe<Array<FilterValueOfRatioRecordStatusEnumSortInput> | FilterValueOfRatioRecordStatusEnumSortInput>;
}>;


export type UerRatioAppliesToLinkStatusFilterQuery = { __typename?: 'Query', uerRatioAppliesToLinkStatusFilter?: { __typename?: 'UerRatioAppliesToLinkStatusFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfRatioRecordStatusEnum', value: RatioRecordStatusEnum }> | null } | null };

export type UerPriceListMtrQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput> | PriceListMtrRowDataSortInput>;
}>;


export type UerPriceListMtrQuery = { __typename?: 'Query', uerPriceListMtr?: { __typename?: 'UerPriceListMtrCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'PriceListMtrRowData', id: any, key?: string | null, code: string, name: string, unit: string, unitCost: any, supplyBy?: ContragentTypeEnum | null, mtrType?: MtrTypeEnum | null, status: MtrRecordStatusEnum, volume?: any | null, unitWeight?: any | null, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null }> | null } | null };

export type PriceListMtrKeyFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
}>;


export type PriceListMtrKeyFilterQuery = { __typename?: 'Query', uerPriceListMtr?: { __typename?: 'UerPriceListMtrCollectionSegment', items?: Array<{ __typename?: 'PriceListMtrRowData', key?: string | null }> | null } | null };

export type UerPriceListMtrCodeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListMtrCodeFilterQuery = { __typename?: 'Query', uerPriceListMtrCodeFilter?: { __typename?: 'UerPriceListMtrCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListMtrNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerPriceListMtrNameFilterQuery = { __typename?: 'Query', uerPriceListMtrNameFilter?: { __typename?: 'UerPriceListMtrNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListMtrUnitFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListMtrUnitFilterQuery = { __typename?: 'Query', uerPriceListMtrUnitFilter?: { __typename?: 'UerPriceListMtrUnitFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListMtrStatusFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListMtrStatusFilterQuery = { __typename?: 'Query', uerPriceListMtrStatusFilter?: { __typename?: 'UerPriceListMtrStatusFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfMtrRecordStatusEnum', value: MtrRecordStatusEnum }> | null } | null };

export type UerPriceListMtrSupplyByFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListMtrSupplyByFilterQuery = { __typename?: 'Query', uerPriceListMtrSupplyByFilter?: { __typename?: 'UerPriceListMtrSupplyByFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfContragentTypeEnum', value: ContragentTypeEnum }> | null } | null };

export type UerPriceListMtrTypeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListMtrTypeFilterQuery = { __typename?: 'Query', uerPriceListMtrTypeFilter?: { __typename?: 'UerPriceListMtrTypeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfMtrTypeEnum', value: MtrTypeEnum }> | null } | null };

export type UerPriceListMtrJustificationFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListMtrJustificationFilterQuery = { __typename?: 'Query', uerPriceListMtrJustificationFilter?: { __typename?: 'UerPriceListMtrJustificationFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerRemoveUnusedMtrRowsMutationVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerRemoveUnusedMtrRowsMutation = { __typename?: 'Mutation', uerRemoveUnusedMtrRows: { __typename?: 'ServiceDataResultOfCountData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerQueryVariables = Exact<{
  contractId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
  order?: InputMaybe<Array<PriceListUerRowDataSortInput> | PriceListUerRowDataSortInput>;
}>;


export type UerPriceListUerQuery = { __typename?: 'Query', uerPriceListUer?: { __typename?: 'UerPriceListUerCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerRowData', version?: string | null, id: any, sectionName: string, groupFullName: string, unit: string, code: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, name: string, status: UerRecordStatusEnum, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', constructionTypeId: number, constructionTypeRelationStatus?: PriceConstructionTypeRelationStatusEnum | null, unitCostWithOther?: any | null, emm?: any | null, ozp?: any | null, pir?: any | null, mtr?: any | null, nr?: any | null, sp?: any | null, eqp?: any | null, trn?: any | null, zpm?: any | null }>, workKind: { __typename?: 'PriceListUerRowWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null } }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerPriceListUerSectionNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerSectionNameFilterQuery = { __typename?: 'Query', uerPriceListUerSectionNameFilter?: { __typename?: 'UerPriceListUerSectionNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerGroupFullNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerGroupFullNameFilterQuery = { __typename?: 'Query', uerPriceListUerGroupFullNameFilter?: { __typename?: 'UerPriceListUerGroupFullNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerGroupDataFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringAndStringFilterInput>;
}>;


export type UerPriceListUerGroupDataFilterQuery = { __typename?: 'Query', uerPriceListUerGroupDataFilter?: { __typename?: 'UerPriceListUerGroupDataFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfStringAndString', id: any, code?: string | null, value?: string | null }> | null } | null };

export type UerPriceListUerCodeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerCodeFilterQuery = { __typename?: 'Query', uerPriceListUerCodeFilter?: { __typename?: 'UerPriceListUerCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerNameFilterQuery = { __typename?: 'Query', uerPriceListUerNameFilter?: { __typename?: 'UerPriceListUerNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerChapterFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListUerChapterFilterQuery = { __typename?: 'Query', uerPriceListUerChapterFilter?: { __typename?: 'UerPriceListUerChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type UerPriceListUerTypeFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListUerTypeFilterQuery = { __typename?: 'Query', uerPriceListUerTypeFilter?: { __typename?: 'UerPriceListUerTypeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfUerClassifierEnum', value?: UerClassifierEnum | null }> | null } | null };

export type UerPriceListUerStatusFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListUerStatusFilterQuery = { __typename?: 'Query', uerPriceListUerStatusFilter?: { __typename?: 'UerPriceListUerStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfUerRecordStatusEnum', value: UerRecordStatusEnum }> | null } | null };

export type UerPriceListUerJustificationFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerJustificationFilterQuery = { __typename?: 'Query', uerPriceListUerJustificationFilter?: { __typename?: 'UerPriceListUerJustificationFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerWorkNameFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerPriceListUerWorkNameFilterQuery = { __typename?: 'Query', uerPriceListUerWorkNameFilter?: { __typename?: 'UerPriceListUerWorkNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerWorkInSumFilterQueryVariables = Exact<{
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfWorkInSumEnumFilterInput>;
}>;


export type UerPriceListUerWorkInSumFilterQuery = { __typename?: 'Query', uerPriceListUerWorkInSumFilter?: { __typename?: 'UerPriceListUerWorkInSumFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkInSumEnum', value: WorkInSumEnum }> | null } | null };

export type UerImportPriceListCollectionMutationVariables = Exact<{
  contractId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type UerImportPriceListCollectionMutation = { __typename?: 'Mutation', uerImportPriceListCollection: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveUnusedUerRowsMutationVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerRemoveUnusedUerRowsMutation = { __typename?: 'Mutation', uerRemoveUnusedUerRows: { __typename?: 'ServiceDataResultOfCountData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUerRowReadyInfoQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerUerRowReadyInfoQuery = { __typename?: 'Query', uerUerRowReadyInfo: { __typename?: 'ServiceDataResultOfPriceListUerRowReadyInfo', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListUerRowReadyInfo', contractId: any, isPriceCollectionLoaded: boolean, unreadyUerRowCount: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerRowQueryVariables = Exact<{
  uerBaseRowId: Scalars['Long'];
}>;


export type UerPriceListUerRowQuery = { __typename?: 'Query', uerPriceListUerRow: { __typename?: 'ServiceDataResultOfPriceListUerRowData', data?: { __typename?: 'PriceListUerRowData', code: string, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', description: string, number: number }> } | null } };

export type UerCreateRatioRowMutationVariables = Exact<{
  input: PriceListRatioRowCreateInput;
}>;


export type UerCreateRatioRowMutation = { __typename?: 'Mutation', uerCreateRatioRow: { __typename?: 'ServiceDataResultOfPriceListRatioGroupedRowData', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListRatioGroupedRowData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerForConstraintRatioQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  contractId: Scalars['Long'];
  where?: InputMaybe<PriceListUerRowBaseFilterInput>;
  order?: InputMaybe<Array<PriceListUerRowBaseSortInput> | PriceListUerRowBaseSortInput>;
}>;


export type UerPriceListUerForConstraintRatioQuery = { __typename?: 'Query', uerPriceListUerForConstraintRatio?: { __typename?: 'UerPriceListUerForConstraintRatioCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'PriceListUerRowBase', chapter?: ChapterEnum | null, code: string, groupCode?: string | null, groupId: any, groupName: string, id: any, justification?: string | null, linkStatus: PriceConstructionTypeRelationStatusEnum, name: string, sectionId: any, sectionName: string, status: UerRecordStatusEnum, uerClassifier?: UerClassifierEnum | null, unit: string, sectionIsArtificial?: boolean | null }> | null } | null };

export type UerPriceListRatioRowQueryVariables = Exact<{
  ratioRowId: Scalars['Long'];
}>;


export type UerPriceListRatioRowQuery = { __typename?: 'Query', uerPriceListRatioRow: { __typename?: 'ServiceDataResultOfPriceListRatioGroupedRowData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListRatioGroupedRowData', code: string, groupId?: any | null, groupName?: string | null, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, justification?: string | null, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioType: RatioTypeEnum, status: RatioRecordStatusEnum, workConditions: string, isCustom?: boolean | null, groupIsArtificial?: boolean | null, groupType?: DismantlingCoefficientTypeEnum | null, appliesTo: Array<{ __typename?: 'PriceListRatioAppliesToData', appliesToCode: string, appliesToCodeName: string, uerPriceListGroupCode?: string | null, uerPriceListGroupId?: any | null, uerPriceListGroupName?: string | null, uerPriceListSectionId?: any | null, uerPriceListSectionName?: string | null, appliesToId: any, isUsedLink: boolean }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateRatioRowMutationVariables = Exact<{
  input: PriceListRatioRowUpdateInput;
}>;


export type UerUpdateRatioRowMutation = { __typename?: 'Mutation', uerUpdateRatioRow: { __typename?: 'ServiceDataResultOfPriceListRatioGroupedRowData', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListRatioGroupedRowData', code: string, groupId?: any | null, groupName?: string | null, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, justification?: string | null, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioType: RatioTypeEnum, status: RatioRecordStatusEnum, workConditions: string, isCustom?: boolean | null, groupIsArtificial?: boolean | null, groupType?: DismantlingCoefficientTypeEnum | null, appliesTo: Array<{ __typename?: 'PriceListRatioAppliesToData', appliesToCode: string, appliesToCodeName: string, uerPriceListGroupCode?: string | null, uerPriceListGroupId?: any | null, uerPriceListGroupName?: string | null, uerPriceListSectionId?: any | null, uerPriceListSectionName?: string | null, appliesToId: any, isUsedLink: boolean }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateRatioToWorkOrderFromPriceListMutationVariables = Exact<{
  input: PriceListRatioRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
}>;


export type UerUpdateRatioToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerUpdateRatioToWorkOrderFromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerSectionForConstraintRatioQueryVariables = Exact<{
  contractId: Scalars['Long'];
}>;


export type UerPriceListUerSectionForConstraintRatioQuery = { __typename?: 'Query', uerPriceListUerSectionForConstraintRatio?: { __typename?: 'UerPriceListUerSectionForConstraintRatioCollectionSegment', items?: Array<{ __typename?: 'PriceListUerSectionData', id: any, name: string, isArtificial?: boolean | null }> | null } | null };

export type UerPriceListUerForDismantlingRatioQueryVariables = Exact<{
  contractId: Scalars['Long'];
  groupType?: InputMaybe<DismantlingCoefficientTypeEnum>;
  order?: InputMaybe<Array<PriceListUerDismantlingRatioDataSortInput> | PriceListUerDismantlingRatioDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerDismantlingRatioDataFilterInput>;
}>;


export type UerPriceListUerForDismantlingRatioQuery = { __typename?: 'Query', uerPriceListUerForDismantlingRatio?: { __typename?: 'UerPriceListUerForDismantlingRatioCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerDismantlingRatioData', ratioCode?: string | null, uerCode?: string | null, uerGroupCode?: string | null, uerGroupName?: string | null, uerName?: string | null, unit?: string | null, uerId?: any | null, clientId: string, isPreselected?: boolean | null, isRatio?: boolean | null, isUerBaseRow?: boolean | null, ratioId?: any | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerRatioRowDefaultsQueryVariables = Exact<{
  contractId: Scalars['Long'];
  ratioType: RatioTypeEnum;
  uerBaseRowId?: InputMaybe<Scalars['Long']>;
}>;


export type UerRatioRowDefaultsQuery = { __typename?: 'Query', uerRatioRowDefaults: { __typename?: 'ServiceDataResultOfRatioRowData', result: boolean, data?: { __typename?: 'RatioRowData', ratioType: RatioTypeEnum, groupType?: DismantlingCoefficientTypeEnum | null, groupId?: any | null, groupName?: string | null, subGroupId?: any | null, subGroupName?: string | null } | null } };

export type UerParsedEstimateBasisQueryVariables = Exact<{
  contractId: Scalars['Long'];
  fileContent: FileInput;
  chapter: ChapterEnum;
  uerClassifier?: InputMaybe<UerClassifierEnum>;
}>;


export type UerParsedEstimateBasisQuery = { __typename?: 'Query', uerParsedEstimateBasis: { __typename?: 'ServiceDataResultOfPriceListUerRowBasisData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'PriceListUerRowBasisData', version?: string | null, section: string, group: string, code: string, name: string, unit: string, chapter?: ChapterEnum | null, basePrice: { __typename?: 'PriceListUerRowPriceBasisData', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentBasisData', unitCost?: any | null, unitCostWithOther?: any | null, constructionTypeId: number, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeBasisData', number: number, description: string }> } | null } };

export type UerAddUerToWorkOrderMutationVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  priceListUerRowInput: PriceListUerRowCreateInput;
}>;


export type UerAddUerToWorkOrderMutation = { __typename?: 'Mutation', uerAddUerToWorkOrder: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCreateUerRowMutationVariables = Exact<{
  input: PriceListUerRowCreateInput;
}>;


export type UerCreateUerRowMutation = { __typename?: 'Mutation', uerCreateUerRow: { __typename?: 'ServiceDataResultOfPriceListUerRowData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListUerRowData', id: any, code: string, name: string, unit: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, status: UerRecordStatusEnum, sectionId: any, sectionName: string, groupId: any, groupCode?: string | null, groupName: string, justification?: string | null, basePrice: { __typename?: 'PriceListUerRowPriceData', ozp?: any | null, emm?: any | null, eqp?: any | null, mtr?: any | null, nr?: any | null, pir?: any | null, sp?: any | null, trn?: any | null, zpm?: any | null, unitCost?: any | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', id: any, constructionTypeId: number, constructionTypeName: string, unitCost?: any | null, unitCostWithOther?: any | null, ozp?: any | null, emm?: any | null, eqp?: any | null, mtr?: any | null, nr?: any | null, pir?: any | null, sp?: any | null, trn?: any | null, zpm?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', number: number, description: string }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateUerRowMutationVariables = Exact<{
  input: PriceListUerRowUpdateInput;
}>;


export type UerUpdateUerRowMutation = { __typename?: 'Mutation', uerUpdateUerRow: { __typename?: 'ServiceDataResultOfPriceListUerRowData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListUerRowData', code: string } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerRowWithRatioQueryVariables = Exact<{
  uerBaseRowId: Scalars['Long'];
}>;


export type UerPriceListUerRowWithRatioQuery = { __typename?: 'Query', uerPriceListUerRowWithRatio: { __typename?: 'ServiceDataResultOfPriceListUerRowWithRatioData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'PriceListUerRowWithRatioData', id: any, version?: string | null, code: string, name: string, unit: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, status: UerRecordStatusEnum, sectionId: any, sectionName: string, groupId: any, groupCode?: string | null, groupName: string, justification?: string | null, sectionIsArtificial?: boolean | null, basePrice: { __typename?: 'PriceListUerRowPriceData', ozp?: any | null, emm?: any | null, eqp?: any | null, mtr?: any | null, nr?: any | null, pir?: any | null, sp?: any | null, trn?: any | null, zpm?: any | null, unitCost?: any | null }, constructionTypes: Array<{ __typename?: 'UerRowConstructionTypeData', id: number, name: string, shortName: string, code: string, isUsedLink: boolean }>, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', id: any, constructionTypeId: number, constructionTypeName: string, constructionTypeRelationStatus?: PriceConstructionTypeRelationStatusEnum | null, unitCost?: any | null, unitCostWithOther?: any | null, ozp?: any | null, emm?: any | null, eqp?: any | null, mtr?: any | null, nr?: any | null, pir?: any | null, sp?: any | null, trn?: any | null, zpm?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', number: number, description: string }>, ratioItems: Array<{ __typename?: 'UerRowRatioItemData', rationId: any, name?: string | null, code?: string | null, isUsedLink: boolean }>, ratioGroups: Array<{ __typename?: 'UerRowRatioGroupData', groupId: any, name?: string | null }>, workKind: { __typename?: 'PriceListUerRowWorkData', workCode?: string | null, workInSum: WorkInSumEnum, workName?: string | null, workRatio?: any | null, workUniqueId?: string | null, workUnit?: string | null } } | null } };

export type UerUpdateUerToWorkOrderFromPriceListMutationVariables = Exact<{
  input: PriceListUerRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
}>;


export type UerUpdateUerToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerUpdateUerToWorkOrderFromPriceList: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCurrentEstimateBasisQueryVariables = Exact<{
  chapter: ChapterEnum;
  uerBaseRowId: Scalars['Long'];
}>;


export type UerCurrentEstimateBasisQuery = { __typename?: 'Query', uerCurrentEstimateBasis: { __typename?: 'ServiceDataResultOfPriceListUerRowBasisData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'PriceListUerRowBasisData', chapter?: ChapterEnum | null, section: string, group: string, code: string, name: string, unit: string, basePrice: { __typename?: 'PriceListUerRowPriceBasisData', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentBasisData', constructionTypeId: number, unitCost?: any | null, unitCostWithOther?: any | null, sp?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeBasisData', number: number, description: string }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerPriceListUerRatioRowsCodeFilterQueryVariables = Exact<{
  uerBaseRowId: Scalars['Long'];
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerRatioRowsCodeFilterQuery = { __typename?: 'Query', uerPriceListUerRatioRowsCodeFilter?: { __typename?: 'UerPriceListUerRatioRowsCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerPriceListUerRatioRowsNameFilterQueryVariables = Exact<{
  uerBaseRowId: Scalars['Long'];
  contractId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerPriceListUerRatioRowsNameFilterQuery = { __typename?: 'Query', uerPriceListUerRatioRowsNameFilter?: { __typename?: 'UerPriceListUerRatioRowsNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderOtherQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  chapter: ChapterEnum;
}>;


export type UerWorkOrderOtherQuery = { __typename?: 'Query', uerWorkOrderOther: Array<{ __typename?: 'WorkOrderOtherAggregationData', contractOtherCostId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, limits: Array<{ __typename?: 'WorkOrderCostLimitData', costLimit: any, totalRemainderCost?: any | null, season?: { __typename?: 'WorkOrderSeasonData', id: any, year: any } | null }> }> };

export type UerAddWorkOrderOtherCostMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  otherCostInput: UpdateWorkOrderOtherCostInput;
}>;


export type UerAddWorkOrderOtherCostMutation = { __typename?: 'Mutation', uerAddWorkOrderOtherCost: { __typename?: 'ServiceDataResultOfWorkOrderOtherPriceData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'WorkOrderOtherPriceData', id: any, name: string } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderOthersForActKc2QueryVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
}>;


export type UerWorkOrderOthersForActKc2Query = { __typename?: 'Query', uerWorkOrderOthersForActKC2: Array<{ __typename?: 'WorkOrderActKC2OtherAggregationData', hasSeasonLimit: boolean, contractOtherCostId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, limits: Array<{ __typename?: 'WorkOrderCostLimitData', costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum, season?: { __typename?: 'WorkOrderSeasonData', year: any, id: any } | null }> }> };

export type UerAddOtherCostToActKc2MutationVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  otherInputs: Array<UerOtherCostInput> | UerOtherCostInput;
}>;


export type UerAddOtherCostToActKc2Mutation = { __typename?: 'Mutation', uerAddOtherCostToActKC2: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderOtherCostSelectionListQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderOtherCostItemFilterInput>;
}>;


export type UerWorkOrderOtherCostSelectionListQuery = { __typename?: 'Query', uerWorkOrderOtherCostSelectionList: Array<{ __typename?: 'WorkOrderOtherCostItem', hasSeasonLimits: boolean, otherCost: { __typename?: 'ContractOtherCostBase', contractOtherCostId: any, catalogOtherCostTypeId?: number | null, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, isSystem: boolean, id: number, uniqueId: string, name: string } | null }, workOrderObjects: Array<{ __typename?: 'WorkOrderOtherCostObjectItem', workOrderRootObjectId: any, hasActsKC2?: boolean | null, hasActualCost?: boolean | null, isActKC2Cost?: boolean | null, contractObjectId: any, name: string, isIncluded?: boolean | null, canAddOther: boolean, canRemoveOther: boolean, rationale?: string | null }>, seasonLimits?: Array<{ __typename?: 'WorkOrderOtherCostSeasonLimitData', workOrderSeasonId: any, workOrderSeasonYear: any, includedCost?: any | null, isIncluded?: boolean | null, planCost?: any | null, actualCost?: any | null, remainderCost?: any | null, deviation?: DeviationTipEnum | null }> | null }> };

export type UerUpdateWorkOrderOtherCostItemsMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  otherPriceInputs: Array<UpdateWorkOrderOtherPriceItemInput> | UpdateWorkOrderOtherPriceItemInput;
}>;


export type UerUpdateWorkOrderOtherCostItemsMutation = { __typename?: 'Mutation', uerUpdateWorkOrderOtherCostItems: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerAddUersToWorkOrderObjectsMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  uerInputs: Array<PriceListUerRowInput> | PriceListUerRowInput;
  constructionTypeId: Scalars['Int'];
  chapter: ChapterEnum;
}>;


export type UerAddUersToWorkOrderObjectsMutation = { __typename?: 'Mutation', uerAddUersToWorkOrderObjects: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerWorkOrderUersSelectionListAsyncQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  chapter?: InputMaybe<ChapterEnum>;
  where?: InputMaybe<WorkOrderUerItemDataFilterInput>;
}>;


export type UerWorkOrderUersSelectionListAsyncQuery = { __typename?: 'Query', uerWorkOrderUersSelectionListAsync?: { __typename?: 'UerWorkOrderUersSelectionListAsyncCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderUerItemData', id: any, sectionId: any, sectionName: string, groupId: any, groupName: string, groupFullName: string, code: string, unit?: string | null, name: string, unitCost?: any | null, chapter?: ChapterEnum | null, status: UerRecordStatusEnum, justification?: string | null }> | null } | null };

export type UerWorkOrderOtherForDistributionQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderOtherPriceId: Scalars['Long'];
}>;


export type UerWorkOrderOtherForDistributionQuery = { __typename?: 'Query', uerWorkOrderOtherForDistribution: { __typename?: 'ServiceDataResultOfWorkOrderOtherDistributionData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: { __typename?: 'WorkOrderOtherDistributionData', contractOtherCost: { __typename?: 'ContractOtherCostBaseData', id: any, key?: string | null, canDelete: boolean, canEdit: boolean, isInUse: boolean, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, isGlobalOtherCost: boolean, status: ContractOtherStatusEnum }, limits: Array<{ __typename?: 'WorkOrderCostLimitDistributionData', includedCost?: any | null, isIncluded?: boolean | null, costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum, isSystemCalculation: boolean, season?: { __typename?: 'WorkOrderSeasonData', id: any, year: any } | null }>, workOrderObjects: Array<{ __typename?: 'WorkOrderOtherCostObjectItem', canAddOther: boolean, canRemoveOther: boolean, contractObjectId: any, hasActsKC2?: boolean | null, hasActualCost?: boolean | null, isActKC2Cost?: boolean | null, isIncluded?: boolean | null, name: string, rationale?: string | null, workOrderRootObjectId: any }>, objectSeasonDistributions: Array<{ __typename?: 'WorkOrderOtherPriceCostData', isIncluded: boolean, hasErrors?: boolean | null, errors?: Array<string> | null, objectId: any, seasonId: any, cost?: any | null }> } | null } };

export type UerUpdateWorkOrderOtherDistributionMutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  updateInput: WorkOrderOtherDistributionUpdateInput;
}>;


export type UerUpdateWorkOrderOtherDistributionMutation = { __typename?: 'Mutation', uerUpdateWorkOrderOtherDistribution: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderOtherDistributionToActKc2MutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  updateInput: WorkOrderOtherDistributionUpdateInput;
}>;


export type UerUpdateWorkOrderOtherDistributionToActKc2Mutation = { __typename?: 'Mutation', uerUpdateWorkOrderOtherDistributionToActKC2: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCalcWorkOrderOtherDistributionQueryVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  input: WorkOrderOtherPriceCalcInput;
}>;


export type UerCalcWorkOrderOtherDistributionQuery = { __typename?: 'Query', uerCalcWorkOrderOtherDistribution: { __typename?: 'ServiceDataResultOfWorkOrderOtherPriceCostData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: Array<{ __typename?: 'WorkOrderOtherPriceCostData', isIncluded: boolean, hasErrors?: boolean | null, errors?: Array<string> | null, objectId: any, seasonId: any, cost?: any | null } | null> | null } };

export type UerCalcWorkOrderChangeOtherDistributionQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  input: WorkOrderChangeOtherPriceCalcInput;
}>;


export type UerCalcWorkOrderChangeOtherDistributionQuery = { __typename?: 'Query', uerCalcWorkOrderChangeOtherDistribution: { __typename?: 'ServiceDataResultOfWorkOrderChangeOtherPriceCostData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null, data?: Array<{ __typename?: 'WorkOrderChangeOtherPriceCostData', isIncluded: boolean, hasErrors?: boolean | null, errors?: Array<string> | null, seasonId: any, cost?: any | null, workOrderChangeObjectId?: any | null, workOrderObjectId?: any | null } | null> | null } };

export type UerExportActKc2TemplateAsExcelQueryVariables = Exact<{
  input: ActKc2TemplateInput;
  workOrderId: Scalars['Long'];
}>;


export type UerExportActKc2TemplateAsExcelQuery = { __typename?: 'Query', uerExportActKC2TemplateAsExcel: { __typename?: 'ServiceDataResultOfFileContent', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerImportActKc2TemplateAsExcelMutationVariables = Exact<{
  actKC2Template: FileInput;
  workOrderId: Scalars['Long'];
}>;


export type UerImportActKc2TemplateAsExcelMutation = { __typename?: 'Mutation', uerImportActKC2TemplateAsExcel: { __typename?: 'ServiceDataResultOfActKC2TemplateImport__', hasValidation: boolean, message?: string | null, result: boolean, buttonText?: string | null, hideValidation?: boolean | null, data?: Array<{ __typename?: 'ActKC2TemplateImport', actKC2Id: any, constructionTypeId: any, workOrderObjectId: any } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderActKc2MtrForInflationDistributionQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2Id: Scalars['Long'];
  chapter: ChapterEnum;
  workOrderObjectId: Scalars['Long'];
  where?: InputMaybe<WorkOrderMtrInflationDataFilterInput>;
}>;


export type UerWorkOrderActKc2MtrForInflationDistributionQuery = { __typename?: 'Query', uerWorkOrderActKC2MtrForInflationDistribution?: { __typename?: 'UerWorkOrderActKC2MtrForInflationDistributionCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderMtrInflationData', code: string, id: any, inflationSeasonId?: any | null, mtrRowId?: any | null, name: string, parentId?: any | null, seasonId: any, status: WorkOrderPriceStatusEnum, type: WorkOrderPriceTypeEnum, uerCode: string, uerCodeId?: any | null, uerId: any }> | null } | null };

export type UerUpdateWorkOrderActKc2MtrForInflationDistributionMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  useInflationMTR: Scalars['Boolean'];
  actKC2MtrItems: Array<ActKc2MtrItemInput> | ActKc2MtrItemInput;
}>;


export type UerUpdateWorkOrderActKc2MtrForInflationDistributionMutation = { __typename?: 'Mutation', uerUpdateWorkOrderActKC2MTRForInflationDistribution: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hideValidation?: boolean | null, hasValidation: boolean, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRollbackWorkOrderChangeMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerRollbackWorkOrderChangeMutation = { __typename?: 'Mutation', uerRollbackWorkOrderChange: { __typename?: 'ServiceResult', hasValidation: boolean, message?: string | null, result: boolean, buttonText?: string | null, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderActsKc2RegistryQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  groupType?: InputMaybe<ActKc2GroupTypeEnum>;
  where?: InputMaybe<ActKc2ListItemDataFilterInput>;
  order?: InputMaybe<Array<ActKc2ListItemDataSortInput> | ActKc2ListItemDataSortInput>;
}>;


export type UerWorkOrderActsKc2RegistryQuery = { __typename?: 'Query', uerWorkOrderActsKC2Registry?: { __typename?: 'UerWorkOrderActsKC2RegistryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2ListItemData', actKC2Id: any, number?: string | null, groupId?: any | null, groupUniqueId?: string | null, groupName?: string | null, groupCount: number, status?: ActKc2StatusEnum | null, actDate?: any | null, actYear?: number | null, actMonth?: number | null, startDate?: any | null, finishDate?: any | null, costGroup: CostGroupEnum, constructionTypeId: number, workOrderObjectId: any, workOrderObjectName: string, costWithoutTax?: any | null, isIncluded?: boolean | null, groupCostWithoutTax?: any | null, isCorrection?: boolean | null, isInactive?: boolean | null, fullNumber?: string | null, correctionDate?: any | null, correctionNumber?: string | null, statusSKzS?: SkzsActKc2StatusEnum | null, constructionType: { __typename?: 'ConstructionType', id: number, code: string, name: string, fullName: string, shortName: string, contractFileName: string, catalogId: any, createdAt: any, uniqueId: string } }> | null } | null };

export type UerWorkOrderActsKc2RegistrySelectionListQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderActsKc2RegistrySelectionListQuery = { __typename?: 'Query', uerWorkOrderActsKC2RegistrySelectionList?: { __typename?: 'UerWorkOrderActsKC2RegistrySelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2SelectionData', groupId?: any | null, actKC2Id: any, groupName?: string | null, number?: string | null, actDate?: any | null, startDate?: any | null, finishDate?: any | null, costGroup: CostGroupEnum, workOrderObjectName: string, costWithoutTax?: any | null, isIncluded?: boolean | null, status?: ActKc2StatusEnum | null, constructionType: { __typename?: 'ConstructionType', id: number, code: string, name: string, fullName: string, shortName: string, contractFileName: string, catalogId: any, createdAt: any, uniqueId: string } }> | null } | null };

export type UerCreateWorkOrderActsKc2GroupMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  input: ActKc2GroupInput;
}>;


export type UerCreateWorkOrderActsKc2GroupMutation = { __typename?: 'Mutation', uerCreateWorkOrderActsKC2Group: { __typename?: 'ServiceIdResultOfInt64', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderActsKc2GroupMutationVariables = Exact<{
  actKC2GroupId: Scalars['Long'];
  input: ActKc2GroupInput;
}>;


export type UerUpdateWorkOrderActsKc2GroupMutation = { __typename?: 'Mutation', uerUpdateWorkOrderActsKC2Group: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveWorkOrderActsKc2GroupMutationVariables = Exact<{
  actKC2GroupId: Scalars['Long'];
}>;


export type UerRemoveWorkOrderActsKc2GroupMutation = { __typename?: 'Mutation', uerRemoveWorkOrderActsKC2Group: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc2GroupNumberFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerActKc2GroupNumberFilterQuery = { __typename?: 'Query', uerActKC2GroupNumberFilter?: { __typename?: 'UerActKC2GroupNumberFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerActKc2GroupDateFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDateOnlyFilterInput>;
}>;


export type UerActKc2GroupDateFilterQuery = { __typename?: 'Query', uerActKC2GroupDateFilter?: { __typename?: 'UerActKC2GroupDateFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDateOnly', value?: any | null }> | null } | null };

export type UerActKc2GroupCostGroupFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfCostGroupEnumFilterInput>;
}>;


export type UerActKc2GroupCostGroupFilterQuery = { __typename?: 'Query', uerActKC2GroupCostGroupFilter?: { __typename?: 'UerActKC2GroupCostGroupFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfCostGroupEnum', value: CostGroupEnum }> | null } | null };

export type UerActKc2GroupConstructionTypeFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerActKc2GroupConstructionTypeFilterQuery = { __typename?: 'Query', uerActKC2GroupConstructionTypeFilter?: { __typename?: 'UerActKC2GroupConstructionTypeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerActKc2GroupObjectFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerActKc2GroupObjectFilterQuery = { __typename?: 'Query', uerActKC2GroupObjectFilter?: { __typename?: 'UerActKC2GroupObjectFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerIsUniqueActKc2GroupNameQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  groupName: Scalars['String'];
  actKC2GroupId?: InputMaybe<Scalars['Long']>;
}>;


export type UerIsUniqueActKc2GroupNameQuery = { __typename?: 'Query', uerIsUniqueActKC2GroupName: { __typename?: 'ServiceResult', buttonText?: string | null, code?: string | null, result: boolean, message?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderPriceListUerQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
  order?: InputMaybe<Array<PriceListUerRowDataSortInput> | PriceListUerRowDataSortInput>;
}>;


export type UerWorkOrderPriceListUerQuery = { __typename?: 'Query', uerWorkOrderPriceListUer?: { __typename?: 'UerWorkOrderPriceListUerCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerRowData', id: any, sectionId: any, sectionName: string, groupId: any, groupName: string, groupCode?: string | null, unit: string, code: string, name: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, status: UerRecordStatusEnum, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, justification?: string | null, basePrice: { __typename?: 'PriceListUerRowPriceData', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', id: any, constructionTypeId: number, constructionTypeName: string, unitCostWithOther?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, unitCost?: any | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', id: any, number: number, description: string }> }> | null } | null };

export type UerAddUerToWorkOrderFromPriceListMutationVariables = Exact<{
  chapter: ChapterEnum;
  workOrderObjectId: Scalars['Long'];
  uerBaseRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddUerToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerAddUerToWorkOrderFromPriceList: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerAddUerToActKc2PriceListMutationVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  uerInputs: Array<PriceListUerRowInput> | PriceListUerRowInput;
}>;


export type UerAddUerToActKc2PriceListMutation = { __typename?: 'Mutation', uerAddUerToActKC2PriceList: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderPriceListUerCodeFilterQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceListUerCodeFilterQuery = { __typename?: 'Query', uerWorkOrderPriceListUerCodeFilter?: { __typename?: 'UerWorkOrderPriceListUerCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceListUerNameFilterQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceListUerNameFilterQuery = { __typename?: 'Query', uerWorkOrderPriceListUerNameFilter?: { __typename?: 'UerWorkOrderPriceListUerNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceListUerSectionFilterQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceListUerSectionFilterQuery = { __typename?: 'Query', uerWorkOrderPriceListUerSectionFilter?: { __typename?: 'UerWorkOrderPriceListUerSectionFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceListUerSubSectionFilterQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceListUerSubSectionFilterQuery = { __typename?: 'Query', uerWorkOrderPriceListUerSubSectionFilter?: { __typename?: 'UerWorkOrderPriceListUerSubSectionFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderOtherPricesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  where?: InputMaybe<WorkOrderOtherPriceDataFilterInput>;
}>;


export type UerWorkOrderOtherPricesQuery = { __typename?: 'Query', uerWorkOrderOtherPrices?: { __typename?: 'UerWorkOrderOtherPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderOtherPriceData', id: any, contractOtherId: any, name: string, calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, rationale?: string | null, status?: ContractOtherStatusEnum | null, totalPlanCost?: any | null, totalCompletedCost?: any | null, totalRemainderCost?: any | null, hasEmptySeasonCost?: boolean | null, hasEmptyActPlanCost?: boolean | null, hasEmptyActAcceptedCost?: boolean | null, isActKC2Price: boolean, isExcludedPrice?: boolean | null, hasLimitSpan: boolean, seasonPrices?: Array<{ __typename?: 'WorkOrderOtherSeasonPriceData', seasonId: any, planCost?: any | null, completedCost?: any | null, remainderCost?: any | null, isReadOnly?: boolean | null, errors?: Array<string> | null, hasErrors?: boolean | null }> | null, actKC2Prices?: Array<{ __typename?: 'WorkOrderOtherActKC2PriceData', acceptedCost?: any | null, acceptedCostDeviation?: DeviationEnum | null, actKC2Id: any, isCorrection?: boolean | null, isInactive?: boolean | null, planCost?: any | null, planCostDeviation?: DeviationEnum | null }> | null }> | null } | null };

export type UerSetActKc2OtherCostPlanCostMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderOtherId: Scalars['Long'];
  cost: Scalars['Decimal'];
}>;


export type UerSetActKc2OtherCostPlanCostMutation = { __typename?: 'Mutation', uerSetActKC2OtherCostPlanCost: { __typename?: 'ServiceDataResultOfInt64__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSetActKc2OtherCostAcceptedCostMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderOtherId: Scalars['Long'];
  cost: Scalars['Decimal'];
}>;


export type UerSetActKc2OtherCostAcceptedCostMutation = { __typename?: 'Mutation', uerSetActKC2OtherCostAcceptedCost: { __typename?: 'ServiceDataResultOfInt64__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderOtherPriceStatusFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderOtherPriceObjectId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfContractOtherStatusEnumFilterInput>;
}>;


export type UerWorkOrderOtherPriceStatusFilterQuery = { __typename?: 'Query', uerWorkOrderOtherPriceStatusFilter?: { __typename?: 'UerWorkOrderOtherPriceStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfContractOtherStatusEnum', value: ContractOtherStatusEnum }> | null } | null };

export type UerWorkOrderOtherPriceNameFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderOtherPriceObjectId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderOtherPriceNameFilterQuery = { __typename?: 'Query', uerWorkOrderOtherPriceNameFilter?: { __typename?: 'UerWorkOrderOtherPriceNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceCodeFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  chapter: ChapterEnum;
  workOrderPriceObjectId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfWorkOrderPriceCodeFilterDataFilterInput>;
  order?: InputMaybe<Array<FilterValueOfWorkOrderPriceCodeFilterDataSortInput> | FilterValueOfWorkOrderPriceCodeFilterDataSortInput>;
}>;


export type UerWorkOrderPriceCodeFilterQuery = { __typename?: 'Query', uerWorkOrderPriceCodeFilter?: { __typename?: 'UerWorkOrderPriceCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkOrderPriceCodeFilterData', value?: { __typename?: 'WorkOrderPriceCodeFilterData', uerCode: string, code: string, isUer: boolean, isRatio: boolean, isMtr: boolean } | null }> | null } | null };

export type UerWorkOrderPriceStatusFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  chapter: ChapterEnum;
  workOrderPriceObjectId: Scalars['Long'];
}>;


export type UerWorkOrderPriceStatusFilterQuery = { __typename?: 'Query', uerWorkOrderPriceStatusFilter?: { __typename?: 'UerWorkOrderPriceStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkOrderPriceStatusEnum', value: WorkOrderPriceStatusEnum }> | null } | null };

export type UerWorkOrderPriceNameFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  chapter: ChapterEnum;
  workOrderPriceObjectId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceNameFilterQuery = { __typename?: 'Query', uerWorkOrderPriceNameFilter?: { __typename?: 'UerWorkOrderPriceNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceUnitFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  chapter: ChapterEnum;
  workOrderPriceObjectId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderPriceUnitFilterQuery = { __typename?: 'Query', uerWorkOrderPriceUnitFilter?: { __typename?: 'UerWorkOrderPriceUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerSetActKc2AcceptedCostMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
  cost: Scalars['Decimal'];
}>;


export type UerSetActKc2AcceptedCostMutation = { __typename?: 'Mutation', uerSetActKC2AcceptedCost: { __typename?: 'ServiceDataResultOfInt64__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, data?: Array<any> | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSetActKc2PlanCostMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
  cost: Scalars['Decimal'];
}>;


export type UerSetActKc2PlanCostMutation = { __typename?: 'Mutation', uerSetActKC2PlanCost: { __typename?: 'ServiceDataResultOfInt64__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, data?: Array<any> | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc2VolumeVariableSelectionItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<ActKc2VolumeVariableSelectionItemFilterInput>;
}>;


export type UerActKc2VolumeVariableSelectionItemsQuery = { __typename?: 'Query', uerActKC2VolumeVariableSelectionItems?: { __typename?: 'UerActKC2VolumeVariableSelectionItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2VolumeVariableSelectionItem', uniqueId: string, name: string, coefficients: Array<string>, isUer: boolean, isMtr: boolean }> | null } | null };

export type UerActKc2SmrValueQueryVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
}>;


export type UerActKc2SmrValueQuery = { __typename?: 'Query', uerActKC2SmrValue: { __typename?: 'ServiceDataResultOfActKC2WorkVolumeData', data?: { __typename?: 'ActKC2WorkVolumeData', id: any, formula?: string | null } | null } };

export type UerSetActKc2FormulaMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
  formula?: InputMaybe<Scalars['String']>;
}>;


export type UerSetActKc2FormulaMutation = { __typename?: 'Mutation', uerSetActKC2Formula: { __typename?: 'ServiceDataResultOfInt64__', result: boolean, data?: Array<any> | null, message?: string | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerActKc2CopyPlanVolumeSKzSuerMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
}>;


export type UerActKc2CopyPlanVolumeSKzSuerMutation = { __typename?: 'Mutation', uerActKC2CopyPlanVolumeSKzSUER: { __typename?: 'ServiceDataResultOfActKC2WorkVolumeData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ActKC2WorkVolumeData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc2CopyPlanVolumeSKzSMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
}>;


export type UerActKc2CopyPlanVolumeSKzSMutation = { __typename?: 'Mutation', uerActKC2CopyPlanVolumeSKzS: { __typename?: 'ServiceDataResultOfActKC2WorkVolumeData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'ActKC2WorkVolumeData', id: any } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderWorkRatioInfoQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
}>;


export type UerWorkOrderWorkRatioInfoQuery = { __typename?: 'Query', uerWorkOrderWorkRatioInfo: { __typename?: 'ServiceDataResultOfPriceItemWorkRatioInfo', result: boolean, message?: string | null, data?: { __typename?: 'PriceItemWorkRatioInfo', hasEmptyWorkRatios: boolean } | null } };

export type UerWorkOrderPriceItemChapterFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemChapterFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemChapterFilter?: { __typename?: 'UerWorkOrderPriceItemChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type UerWorkOrderPriceItemStatusFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemStatusFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemStatusFilter?: { __typename?: 'UerWorkOrderPriceItemStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkOrderPriceStatusEnum', value?: WorkOrderPriceStatusEnum | null }> | null } | null };

export type UerWorkOrderPriceItemCodeFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemCodeFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemCodeFilter?: { __typename?: 'UerWorkOrderPriceItemCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkOrderPriceItemCodeFilterData', value?: { __typename?: 'WorkOrderPriceItemCodeFilterData', uerCodeId?: any | null, uerCode: string, code: string, sortSMRPart: number, isUer: boolean, isRatio: boolean, isMtr: boolean } | null }> | null } | null };

export type UerWorkOrderPriceItemNameFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemNameFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemNameFilter?: { __typename?: 'UerWorkOrderPriceItemNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceItemUnitFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemUnitFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemUnitFilter?: { __typename?: 'UerWorkOrderPriceItemUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceItemWorkNameFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemWorkNameFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemWorkNameFilter?: { __typename?: 'UerWorkOrderPriceItemWorkNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceItemWorkInSumFilterQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<FilterValueOfNullableOfWorkInSumEnumFilterInput>;
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderPriceItemWorkInSumFilterQuery = { __typename?: 'Query', uerWorkOrderPriceItemWorkInSumFilter?: { __typename?: 'UerWorkOrderPriceItemWorkInSumFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkInSumEnum', value?: WorkInSumEnum | null }> | null } | null };

export type UerWorkOrderPricesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<WorkOrderPriceDataFilterInput>;
}>;


export type UerWorkOrderPricesQuery = { __typename?: 'Query', uerWorkOrderPrices?: { __typename?: 'UerWorkOrderPricesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderPriceData', id: any, parentId?: any | null, type: WorkOrderPriceTypeEnum, status: WorkOrderPriceStatusEnum, uerId: any, uerCode: string, uerCodeId?: any | null, priceListId: any, code: string, name: string, groupName?: string | null, shortName?: string | null, rationale?: string | null, unit: string, unitCost: any, hasDuplicates?: boolean | null, totalPlanVolume?: any | null, totalPlanCost?: any | null, totalCompletedVolume?: any | null, totalCompletedCost?: any | null, totalRemainderVolume?: any | null, totalRemainderCost?: any | null, isActKC2Price: boolean, hasEmptySeasonVolume?: boolean | null, hasEmptyActPlanVolume?: boolean | null, hasEmptyActAcceptedVolume?: boolean | null, isExcludedPrice?: boolean | null, hasCostPlan?: boolean | null, workCode?: string | null, workCompleted?: any | null, workInSum: WorkInSumEnum, workName?: string | null, workPlan?: any | null, workRatio?: any | null, workReminder?: any | null, workUnit?: string | null, seasonPrices: Array<{ __typename?: 'WorkOrderSeasonPriceData', id?: any | null, seasonId: any, planVolume?: any | null, planVolumeTerms?: Array<any> | null, planCost?: any | null, completedVolume?: any | null, completedCost?: any | null, remainderVolume?: any | null, remainderCost?: any | null }>, actKC2Prices: Array<{ __typename?: 'WorkOrderActKC2PriceData', acceptedCost?: any | null, acceptedVolume?: any | null, acceptedVolumeDeviation?: DeviationEnum | null, actKC2Id: any, hasDistributionOfMtrInflation: boolean, id?: any | null, inflationSeasonId?: any | null, isCorrection?: boolean | null, isEditableCost?: boolean | null, isInactive?: boolean | null, isReadOnly?: boolean | null, planCost?: any | null, planVolume?: any | null, planVolumeDeviation?: DeviationEnum | null }> }> | null } | null };

export type UerWorkOrderActsKc2QueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
  actCostGroup: CostGroupEnum;
}>;


export type UerWorkOrderActsKc2Query = { __typename?: 'Query', uerWorkOrderActsKC2?: { __typename?: 'UerWorkOrderActsKC2CollectionSegment', items?: Array<{ __typename?: 'WorkOrderActKC2Data', id: any, objectId: any, number?: any | null, date?: any | null, status: ActKc2StatusEnum, seasonId: any, planVolumeDeviation?: DeviationEnum | null, acceptedVolumeDeviation?: DeviationEnum | null, planCostDeviation?: DeviationEnum | null, acceptedCostDeviation?: DeviationEnum | null, isDistributionOfMtrInflation: boolean, correctionNumber?: any | null, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, canCreateCorrection?: boolean | null, correctionDate?: any | null, costGroup: CostGroupEnum, inflationSeasonId?: any | null, inflationSeasonYear?: number | null, reportingFinishDate?: any | null, reportingStartDate?: any | null, seasonYear: number, isSKzSUpdated: boolean, isSKzSCopied: boolean, isSKzSCopyLock: boolean, isSKzS?: boolean | null, statusSKzS?: SkzsActKc2StatusEnum | null }> | null } | null };

export type UerWorkOrderQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderQuery = { __typename?: 'Query', uerWorkOrder: { __typename?: 'ServiceDataResultOfWorkOrderData', buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null, internalNumber: string, subject: string, status: WorkOrderStatusEnum, contractor: string, contractorAddress?: string | null, signingDate?: any | null, amountWithTax: any, amountWithoutTax: any, remainder: any, tax: any, startDate?: any | null, finishDate?: any | null, vorType?: WorkOrderVorTypeEnum | null, statusFollowers: Array<WorkOrderStatusEnum>, inflationData?: Array<{ __typename?: 'ContractSeasonInflationData', id: any, year: any, inflationRate: any }> | null, workOrderChange?: { __typename?: 'WorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderVorTypeQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderVorTypeQuery = { __typename?: 'Query', uerWorkOrder: { __typename?: 'ServiceDataResultOfWorkOrderData', buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', vorType?: WorkOrderVorTypeEnum | null, statusFollowers: Array<WorkOrderStatusEnum> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderMutationVariables = Exact<{
  id: Scalars['Long'];
  status: WorkOrderStatusEnum;
  internalNumber?: InputMaybe<Scalars['String']>;
  signingDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  finishDate: Scalars['DateTime'];
  subject?: InputMaybe<Scalars['String']>;
}>;


export type UerUpdateWorkOrderMutation = { __typename?: 'Mutation', uerUpdateWorkOrder: { __typename?: 'ServiceDataResultOfWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null, internalNumber: string, subject: string, status: WorkOrderStatusEnum, contractor: string, contractorAddress?: string | null, signingDate?: any | null, amountWithTax: any, amountWithoutTax: any, tax: any, startDate?: any | null, finishDate?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerWorkOrderConstructionTypesQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderConstructionTypesQuery = { __typename?: 'Query', uerWorkOrderConstructionTypes: Array<{ __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string }> };

export type UerWorkOrderObjectsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  where?: InputMaybe<WorkOrderObjectDataFilterInput>;
}>;


export type UerWorkOrderObjectsQuery = { __typename?: 'Query', uerWorkOrderObjects: Array<{ __typename?: 'WorkOrderObjectData', objectUniqueId: string, id: any, parentId?: any | null, code?: string | null, name: string, isLeaf: boolean, workOrderId: any, rootObjectId?: any | null, fromWorkOrder: boolean, fromWorkOrderVOR: boolean, hasActsKC2?: boolean | null, hasCompletedSkzsActsKC2?: boolean | null, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', id: any, name: string, status: ContractObjectStatusEnum, parentId?: any | null, rootObjectId?: any | null, fromVOR: boolean, contractId: any, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null }> };

export type UerWorkOrderPriceListMtrQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput> | PriceListMtrRowDataSortInput>;
}>;


export type UerWorkOrderPriceListMtrQuery = { __typename?: 'Query', uerWorkOrderPriceListMtr?: { __typename?: 'UerWorkOrderPriceListMtrCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListMtrRowData', code: string, contractId: any, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, justification?: string | null, mtrType?: MtrTypeEnum | null, name: string, note?: string | null, pricingType: PricingTypeEnum, status: MtrRecordStatusEnum, supplyBasis?: string | null, supplyBy?: ContragentTypeEnum | null, unit: string, unitCost: any, unitWeight?: any | null, volume?: any | null }> | null } | null };

export type UerAddMtrToWorkOrderFromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  mtrRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddMtrToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerAddMtrToWorkOrderFromPriceList: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerAddMtrToActKc2PriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  mtrInputs: Array<PriceListMtrRowInput> | PriceListMtrRowInput;
}>;


export type UerAddMtrToActKc2PriceListMutation = { __typename?: 'Mutation', uerAddMtrToActKC2PriceList: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemovePriceFromWorkOrderMutationVariables = Exact<{
  workOrderPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemovePriceFromWorkOrderMutation = { __typename?: 'Mutation', uerRemovePriceFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveActKc2PriceFromWorkOrderMutationVariables = Exact<{
  workOrderPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveActKc2PriceFromWorkOrderMutation = { __typename?: 'Mutation', uerRemoveActKC2PriceFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveActKc2OtherFromWorkOrderMutationVariables = Exact<{
  workOrderOtherPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveActKc2OtherFromWorkOrderMutation = { __typename?: 'Mutation', uerRemoveActKC2OtherFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveOtherFromWorkOrderMutationVariables = Exact<{
  workOrderOtherPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveOtherFromWorkOrderMutation = { __typename?: 'Mutation', uerRemoveOtherFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderSeasonsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderSeasonsQuery = { __typename?: 'Query', uerWorkOrderSeasons?: { __typename?: 'UerWorkOrderSeasonsCollectionSegment', items?: Array<{ __typename?: 'WorkOrderSeasonData', id: any, year: any }> | null } | null };

export type UerWorkOrderPriceListRatioQueryVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
}>;


export type UerWorkOrderPriceListRatioQuery = { __typename?: 'Query', uerWorkOrderPriceListRatio?: { __typename?: 'UerWorkOrderPriceListRatioCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListRatioRowData', appliesToCode: string, appliesToCodeName: string, appliesToFullName: string, appliesToId: any, appliesToLinkStatus: RatioRecordStatusEnum, code: string, groupId?: any | null, groupIsArtificial?: boolean | null, groupName?: string | null, groupType?: DismantlingCoefficientTypeEnum | null, id: any, isCustom?: boolean | null, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, number?: number | null, ratioType: RatioTypeEnum, status: RatioRecordStatusEnum, subGroupId?: any | null, subGroupName?: string | null, uerPriceListGroupCode?: string | null, uerPriceListGroupFullName?: string | null, uerPriceListGroupId?: any | null, uerPriceListGroupName?: string | null, uerPriceListSectionId?: any | null, uerPriceListSectionName?: string | null, workConditions: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerAddRatioToWorkOrderFromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  ratioRowIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerAddRatioToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerAddRatioToWorkOrderFromPriceList: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerAddRatioToActKc2MutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  ratioInputs: Array<PriceListRatioRowInput> | PriceListRatioRowInput;
  strategy: AddRatioToActKc2StrategyEnum;
  actKC2Id: Scalars['Long'];
}>;


export type UerAddRatioToActKc2Mutation = { __typename?: 'Mutation', uerAddRatioToActKC2: { __typename?: 'ServiceDataResultOfInt64__', result: boolean, message?: string | null, data?: Array<any> | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateSeasonVolumeMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  workOrderSeasonId: Scalars['Long'];
  volume: Scalars['Decimal'];
}>;


export type UerUpdateSeasonVolumeMutation = { __typename?: 'Mutation', uerUpdateSeasonVolume: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerAddMtrRowMutationVariables = Exact<{
  chapter?: InputMaybe<ChapterEnum>;
  input: PriceListMtrRowCreateInput;
}>;


export type UerAddMtrRowMutation = { __typename?: 'Mutation', uerAddMtrRow: { __typename?: 'ServiceDataResultOfPriceListMtrRowData', result: boolean, message?: string | null, hasValidation: boolean, buttonText?: string | null, hideValidation?: boolean | null, data?: { __typename?: 'PriceListMtrRowData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniquePriceListMtrRowKeyQueryVariables = Exact<{
  contractId: Scalars['Long'];
  mtrRowId?: InputMaybe<Scalars['Long']>;
  key?: InputMaybe<Scalars['String']>;
}>;


export type UerIsUniquePriceListMtrRowKeyQuery = { __typename?: 'Query', uerIsUniquePriceListMtrRowKey: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniquePriceListMtrRowCodeQueryVariables = Exact<{
  contractId: Scalars['Long'];
  mtrRowId?: InputMaybe<Scalars['Long']>;
  supplyBy: ContragentTypeEnum;
  mtrType: MtrTypeEnum;
  inputCode: Scalars['String'];
}>;


export type UerIsUniquePriceListMtrRowCodeQuery = { __typename?: 'Query', uerIsUniquePriceListMtrRowCode: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerCreateActKc2MutationVariables = Exact<{
  actKC2Input: ActKc2CreateInput;
}>;


export type UerCreateActKc2Mutation = { __typename?: 'Mutation', uerCreateActKC2: { __typename?: 'ServiceDataResultOfActKC2Data', result: boolean, message?: string | null, hasValidation: boolean, buttonText?: string | null, hideValidation?: boolean | null, data?: { __typename?: 'ActKC2Data', id: any, costGroup: CostGroupEnum, status: ActKc2StatusEnum } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, property?: string | null }> | null } };

export type UerUpdateActKc2MutationVariables = Exact<{
  actKC2Input: ActKc2UpdateInput;
}>;


export type UerUpdateActKc2Mutation = { __typename?: 'Mutation', uerUpdateActKC2: { __typename?: 'ServiceDataResultOfActKC2Data', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ActKC2Data', id: any, costGroup: CostGroupEnum, status: ActKc2StatusEnum } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, property?: string | null }> | null } };

export type UerCopyActKc2MutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
}>;


export type UerCopyActKc2Mutation = { __typename?: 'Mutation', uerCopyActKC2: { __typename?: 'ServiceDataResultOfActKC2Data', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ActKC2Data', id: any, number?: any | null, date?: any | null, object: { __typename?: 'WorkOrderObjectData', name: string } } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, property?: string | null }> | null } };

export type UerDeleteActKc2MutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
}>;


export type UerDeleteActKc2Mutation = { __typename?: 'Mutation', uerDeleteActKC2: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, id?: any | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc2QueryVariables = Exact<{
  actKC2Id: Scalars['Long'];
}>;


export type UerActKc2Query = { __typename?: 'Query', uerActKC2: { __typename?: 'ServiceDataResultOfActKC2Data', result: boolean, message?: string | null, hasValidation: boolean, buttonText?: string | null, hideValidation?: boolean | null, data?: { __typename?: 'ActKC2Data', isCopied?: boolean | null, authoredBy: string, contractor?: string | null, contractorAddress?: string | null, costGroup: CostGroupEnum, createdAt: any, date?: any | null, id: any, isDistributionOfMtrInflation: boolean, number?: any | null, reportingFinishDate?: any | null, reportingStartDate?: any | null, status: ActKc2StatusEnum, updatedAt?: any | null, statusFollowers: Array<ActKc2StatusEnum>, fullNumber?: string | null, isCorrection?: boolean | null, isInactive?: boolean | null, correctionNumber?: any | null, correctionDate?: any | null, isSKzSCopied: boolean, isSKzSCopyLock: boolean, isSKzSUpdated: boolean, canCreateCorrection?: boolean | null, primaryId?: any | null, object: { __typename?: 'WorkOrderObjectData', objectUniqueId: string, id: any, workOrderId: any, code?: string | null, name: string, fromWorkOrder: boolean, fromWorkOrderVOR: boolean, hasActsKC2?: boolean | null, hasCompletedActsKC2?: boolean | null, hasCompletedOtherActsKC2?: boolean | null, hasCompletedSkzsActsKC2?: boolean | null, hasCompletedSmrActsKC2?: boolean | null, hasOngoingActsKC2?: boolean | null, hasOngoingOtherActsKC2?: boolean | null, hasOngoingSkzsActsKC2?: boolean | null, hasOngoingSmrActsKC2?: boolean | null, isActKC2Object?: boolean | null, isLeaf: boolean, parentId?: any | null, rootObjectId?: any | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, shortName: string, name: string, id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null }, season: { __typename?: 'WorkOrderSeasonData', id: any, year: any }, inflationSeason: { __typename?: 'WorkOrderSeasonData', id: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, property?: string | null }> | null } };

export type UerWorkOrderExportAsExcelQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderExportAsExcelQuery = { __typename?: 'Query', uerWorkOrderExportAsExcel: { __typename?: 'ServiceDataResultOfFileContent', message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, result: boolean, data?: { __typename?: 'FileContent', name: string, dataUrl: string, size: any, count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, property?: string | null }> | null } };

export type UerWorkOrderObjectResultQueryVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  chapter?: InputMaybe<ChapterEnum>;
  section?: InputMaybe<SectionEnum>;
}>;


export type UerWorkOrderObjectResultQuery = { __typename?: 'Query', uerWorkOrderObjectResult: Array<{ __typename?: 'WorkOrderObjectResultData', title: string, chapter?: ChapterEnum | null, section?: SectionEnum | null, objectId: any, actKC2Id?: any | null, sortOrder: any, costResultData: Array<{ __typename?: 'WorkOrderCostResultData', year: any, name: string, value: any }> }> };

export type UerApplyMtrToWorkOrderFromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
}>;


export type UerApplyMtrToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerApplyMtrToWorkOrderFromPriceList: { __typename?: 'ServiceIdResultOfInt64', result: boolean, id?: any | null, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, property?: string | null }> | null } };

export type UerWorkOrderResultQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderResultQuery = { __typename?: 'Query', uerWorkOrderResult: { __typename?: 'WorkOrderResultViewData', seasons: Array<{ __typename?: 'WorkOrderSeasonData', id: any, year: any }>, actKC2s: Array<{ __typename?: 'WorkOrderActKC2Data', acceptedCostDeviation?: DeviationEnum | null, acceptedVolumeDeviation?: DeviationEnum | null, canCreateCorrection?: boolean | null, correctionDate?: any | null, correctionNumber?: any | null, costGroup: CostGroupEnum, date?: any | null, fullNumber?: string | null, id: any, inflationSeasonId?: any | null, inflationSeasonYear?: number | null, isCorrection?: boolean | null, isDistributionOfMtrInflation: boolean, isInactive?: boolean | null, isSKzS?: boolean | null, isSKzSUpdated: boolean, number?: any | null, planCostDeviation?: DeviationEnum | null, planVolumeDeviation?: DeviationEnum | null, reportingFinishDate?: any | null, reportingStartDate?: any | null, seasonId: any, seasonYear: number, status: ActKc2StatusEnum, statusSKzS?: SkzsActKc2StatusEnum | null }>, results: Array<{ __typename?: 'WorkOrderResultData', chapter?: ChapterEnum | null, resultSectionId: any, section?: SectionEnum | null, sortOrder: any, title: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, actKC2Results: Array<{ __typename?: 'WorkOrderActKC2ResultData', actKC2Id: any, value: any }>, seasonResults: Array<{ __typename?: 'WorkOrderSeasonResultData', seasonId: any, value: any }> }> } };

export type UerWorkOrderTotalsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderTotalsQuery = { __typename?: 'Query', uerWorkOrderTotals: { __typename?: 'ServiceDataResultOfWorkOrderTotalData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'WorkOrderTotalData', isHeadLine: boolean, name: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonTotals: Array<{ __typename?: 'WorkOrderSeasonTotalData', completedCost?: any | null, planCost?: any | null, seasonId: any }> } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSetActKc2PlanVolumeMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  workOrderPriceId: Scalars['Long'];
  volume?: InputMaybe<Scalars['Decimal']>;
}>;


export type UerSetActKc2PlanVolumeMutation = { __typename?: 'Mutation', uerSetActKC2PlanVolume: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSetActKc2AcceptedVolumeMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  volume?: InputMaybe<Scalars['Decimal']>;
  workOrderPriceId: Scalars['Long'];
}>;


export type UerSetActKc2AcceptedVolumeMutation = { __typename?: 'Mutation', uerSetActKC2AcceptedVolume: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueActKc2InternalNumberQueryVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  actKC2Id?: InputMaybe<Scalars['Long']>;
  actKC2Number: Scalars['Long'];
}>;


export type UerIsUniqueActKc2InternalNumberQuery = { __typename?: 'Query', uerIsUniqueActKC2InternalNumber: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerDeleteWorkOrderMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerDeleteWorkOrderMutation = { __typename?: 'Mutation', uerDeleteWorkOrder: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateMtrToWorkOrderFromPriceListMutationVariables = Exact<{
  input: PriceListMtrRowUpdateInput;
  workOrderPriceId: Scalars['Long'];
}>;


export type UerUpdateMtrToWorkOrderFromPriceListMutation = { __typename?: 'Mutation', uerUpdateMtrToWorkOrderFromPriceList: { __typename?: 'ServiceIdResultOfInt64', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerImportWorkOrderFromRivxMutationVariables = Exact<{
  contractId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type UerImportWorkOrderFromRivxMutation = { __typename?: 'Mutation', uerImportWorkOrderFromRivx: { __typename?: 'ServiceDataResultOfWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerImportWorkOrderFromXmlMutationVariables = Exact<{
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput> | FileInput;
}>;


export type UerImportWorkOrderFromXmlMutation = { __typename?: 'Mutation', uerImportWorkOrderFromXml: { __typename?: 'ServiceDataResultOfWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerAddWorkOrderFromXmlMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput> | FileInput;
}>;


export type UerAddWorkOrderFromXmlMutation = { __typename?: 'Mutation', uerAddWorkOrderFromXml: { __typename?: 'ServiceDataResultOfWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerReplaceWorkOrderFromRivxMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  fileContent: FileInput;
}>;


export type UerReplaceWorkOrderFromRivxMutation = { __typename?: 'Mutation', uerReplaceWorkOrderFromRivx: { __typename?: 'ServiceDataResultOfWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerReplaceWorkOrderFromXmlMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput> | FileInput;
}>;


export type UerReplaceWorkOrderFromXmlMutation = { __typename?: 'Mutation', uerReplaceWorkOrderFromXml: { __typename?: 'ServiceDataResultOfWorkOrderData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderData', id: any, name?: string | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerExportActKc2AsExcelQueryVariables = Exact<{
  actKC2Id: Scalars['Long'];
}>;


export type UerExportActKc2AsExcelQuery = { __typename?: 'Query', uerExportActKC2AsExcel: { __typename?: 'ServiceDataResultOfFileContent', message?: string | null, result: boolean, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueRatioWorkConditionsQueryVariables = Exact<{
  contractId: Scalars['Long'];
  ratioRowId?: InputMaybe<Scalars['Long']>;
  workConditions: Scalars['String'];
}>;


export type UerIsUniqueRatioWorkConditionsQuery = { __typename?: 'Query', uerIsUniqueRatioWorkConditions: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderVersionsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderVersionsQuery = { __typename?: 'Query', uerWorkOrderVersions: Array<{ __typename?: 'WorkOrderVersionListItem', workOrderVersionItem: { __typename?: 'WorkOrderVersionItem', id: any, name?: string | null, internalNumber?: string | null, signingDate?: any | null, status: WorkOrderStatusEnum }, workOrderChangeItem?: { __typename?: 'WorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null }> };

export type UerUpdateMtrToActKc2FromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  input: PriceListMtrRowUpdateInput;
}>;


export type UerUpdateMtrToActKc2FromPriceListMutation = { __typename?: 'Mutation', uerUpdateMtrToActKC2FromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateUerToActKc2FromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  input: PriceListUerRowUpdateInput;
}>;


export type UerUpdateUerToActKc2FromPriceListMutation = { __typename?: 'Mutation', uerUpdateUerToActKC2FromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateRatioToActKc2FromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  input: PriceListRatioRowUpdateInput;
}>;


export type UerUpdateRatioToActKc2FromPriceListMutation = { __typename?: 'Mutation', uerUpdateRatioToActKC2FromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerApplyMtrToActKc2FromPriceListMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  mtrRowId: Scalars['Long'];
}>;


export type UerApplyMtrToActKc2FromPriceListMutation = { __typename?: 'Mutation', uerApplyMtrToActKC2FromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderDraftInfoQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderDraftInfoQuery = { __typename?: 'Query', uerWorkOrderDraftInfo: { __typename?: 'ServiceDataResultOfWorkOrderDraftInfo', data?: { __typename?: 'WorkOrderDraftInfo', draftCount: number } | null } };

export type UerWorkOrderObjectSelectionListQueryVariables = Exact<{
  order?: InputMaybe<Array<WorkOrderObjectSelectionDataSortInput> | WorkOrderObjectSelectionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderObjectSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderObjectSelectionListQuery = { __typename?: 'Query', uerWorkOrderObjectSelectionList?: { __typename?: 'UerWorkOrderObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderObjectSelectionData', codeWBS?: string | null, contractId: any, fromWorkOrder: boolean, hasActsKC2: boolean, hasPricesOther: boolean, hasPrices: boolean, id: any, isInUse: boolean, isIncluded: boolean, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, workOrderId?: any | null, workOrderObjectId?: any | null, fromWorkOrderVOR: boolean, fromVOR: boolean, isActKC2Object?: boolean | null, hasGuaranteedVolume?: boolean | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null } | null };

export type UerWorkOrderObjectSelectionListIsIncludedQueryVariables = Exact<{
  order?: InputMaybe<Array<WorkOrderObjectSelectionDataSortInput> | WorkOrderObjectSelectionDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderObjectSelectionDataFilterInput>;
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderObjectSelectionListIsIncludedQuery = { __typename?: 'Query', uerWorkOrderObjectSelectionList?: { __typename?: 'UerWorkOrderObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderObjectSelectionData', isIncluded: boolean, id: any, fromWorkOrderVOR: boolean, fromVOR: boolean, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null } | null };

export type UerCreateWorkOrderObjectMutationVariables = Exact<{
  input: ContractObjectCreateInput;
  workOrderId: Scalars['Long'];
}>;


export type UerCreateWorkOrderObjectMutation = { __typename?: 'Mutation', uerCreateWorkOrderObject: { __typename?: 'ServiceDataResultOfWorkOrderObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderObjectData', code?: string | null, id: any, isLeaf: boolean, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCreateWorkOrderSubObjectMutationVariables = Exact<{
  input: ContractSubObjectCreateInput;
  workOrderId: Scalars['Long'];
}>;


export type UerCreateWorkOrderSubObjectMutation = { __typename?: 'Mutation', uerCreateWorkOrderSubObject: { __typename?: 'ServiceDataResultOfWorkOrderObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderObjectData', code?: string | null, id: any, isLeaf: boolean, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderObjectMutationVariables = Exact<{
  input: ContractObjectUpdateInput;
  workOrderId: Scalars['Long'];
}>;


export type UerUpdateWorkOrderObjectMutation = { __typename?: 'Mutation', uerUpdateWorkOrderObject: { __typename?: 'ServiceDataResultOfWorkOrderObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderObjectData', code?: string | null, id: any, isLeaf: boolean, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderSubObjectMutationVariables = Exact<{
  input: ContractObjectUpdateInput;
  workOrderId: Scalars['Long'];
}>;


export type UerUpdateWorkOrderSubObjectMutation = { __typename?: 'Mutation', uerUpdateWorkOrderSubObject: { __typename?: 'ServiceDataResultOfWorkOrderObjectData', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'WorkOrderObjectData', code?: string | null, id: any, isLeaf: boolean, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueContractObjectNameQueryVariables = Exact<{
  constructionTypeId: Scalars['Int'];
  contractId: Scalars['Long'];
  contractObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type UerIsUniqueContractObjectNameQuery = { __typename?: 'Query', uerIsUniqueContractObjectName: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerIsUniqueContractSubObjectNameQueryVariables = Exact<{
  contractObjectId: Scalars['Long'];
  contractSubObjectId?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
}>;


export type UerIsUniqueContractSubObjectNameQuery = { __typename?: 'Query', uerIsUniqueContractSubObjectName: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerIsUniqueContractObjectCodeQueryVariables = Exact<{
  contractId: Scalars['Long'];
  contractObjectId?: InputMaybe<Scalars['Long']>;
  code?: InputMaybe<Scalars['String']>;
}>;


export type UerIsUniqueContractObjectCodeQuery = { __typename?: 'Query', uerIsUniqueContractObjectCode: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerRemoveWorkOrderObjectMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type UerRemoveWorkOrderObjectMutation = { __typename?: 'Mutation', uerRemoveWorkOrderObject: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIncludeContractObjectToWorkOrderMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type UerIncludeContractObjectToWorkOrderMutation = { __typename?: 'Mutation', uerIncludeContractObjectToWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerExcludeContractObjectFromWorkOrderMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderId: Scalars['Long'];
}>;


export type UerExcludeContractObjectFromWorkOrderMutation = { __typename?: 'Mutation', uerExcludeContractObjectFromWorkOrder: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderPriceRationaleMutationVariables = Exact<{
  workOrderPriceId: Scalars['Long'];
  input: WorkOrderPriceRationaleUpdateInput;
}>;


export type UerUpdateWorkOrderPriceRationaleMutation = { __typename?: 'Mutation', uerUpdateWorkOrderPriceRationale: { __typename?: 'ServiceIdResultOfInt64', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerUpdateWorkOrderOtherPriceRationaleMutationVariables = Exact<{
  workOrderOtherPriceId: Scalars['Long'];
  input: WorkOrderOtherPriceRationaleUpdateInput;
}>;


export type UerUpdateWorkOrderOtherPriceRationaleMutation = { __typename?: 'Mutation', uerUpdateWorkOrderOtherPriceRationale: { __typename?: 'ServiceIdResultOfInt64', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerExportWorkOrderPricesQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerExportWorkOrderPricesQuery = { __typename?: 'Query', uerExportWorkOrderPrices: { __typename?: 'ServiceDataResultOfFileContent', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, data?: { __typename?: 'FileContent', count: number, dataUrl: string, name: string, size: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCreateActKc2CorrectionMutationVariables = Exact<{
  primaryActKC2Id: Scalars['Long'];
}>;


export type UerCreateActKc2CorrectionMutation = { __typename?: 'Mutation', uerCreateActKC2Correction: { __typename?: 'ServiceDataResultOfActKC2Data', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'ActKC2Data', authoredBy: string, contractor?: string | null, contractorAddress?: string | null, correctionDate?: any | null, correctionNumber?: any | null, costGroup: CostGroupEnum, createdAt: any, date?: any | null, fullNumber?: string | null, id: any, isCopied?: boolean | null, isCorrection?: boolean | null, isDistributionOfMtrInflation: boolean, isInactive?: boolean | null, number?: any | null, reportingFinishDate?: any | null, reportingStartDate?: any | null, status: ActKc2StatusEnum, statusFollowers: Array<ActKc2StatusEnum>, updatedAt?: any | null, isSKzSUpdated: boolean, isSKzSCopied: boolean, isSKzSCopyLock: boolean, inflationSeason: { __typename?: 'WorkOrderSeasonData', id: any, year: any }, object: { __typename?: 'WorkOrderObjectData', code?: string | null, fromWorkOrder: boolean, fromWorkOrderVOR: boolean, id: any, isLeaf: boolean, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderId: any, objectUniqueId: string, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null }, season: { __typename?: 'WorkOrderSeasonData', id: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerUpdateActKc2CorrectionMutationVariables = Exact<{
  input: ActKc2CorrectionUpdateInput;
}>;


export type UerUpdateActKc2CorrectionMutation = { __typename?: 'Mutation', uerUpdateActKC2Correction: { __typename?: 'ServiceDataResultOfActKC2Data', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'ActKC2Data', authoredBy: string, contractor?: string | null, contractorAddress?: string | null, correctionDate?: any | null, correctionNumber?: any | null, costGroup: CostGroupEnum, createdAt: any, date?: any | null, fullNumber?: string | null, id: any, isCopied?: boolean | null, isCorrection?: boolean | null, isDistributionOfMtrInflation: boolean, isInactive?: boolean | null, number?: any | null, reportingFinishDate?: any | null, reportingStartDate?: any | null, status: ActKc2StatusEnum, statusFollowers: Array<ActKc2StatusEnum>, updatedAt?: any | null, inflationSeason: { __typename?: 'WorkOrderSeasonData', id: any, year: any }, object: { __typename?: 'WorkOrderObjectData', code?: string | null, fromWorkOrder: boolean, fromWorkOrderVOR: boolean, id: any, isLeaf: boolean, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null }, season: { __typename?: 'WorkOrderSeasonData', id: any, year: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type CatalogWorkTypesQueryVariables = Exact<{
  order?: InputMaybe<Array<CatalogWorkTypeDataSortInput> | CatalogWorkTypeDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CatalogWorkTypeDataFilterInput>;
}>;


export type CatalogWorkTypesQuery = { __typename?: 'Query', catalogWorkTypes?: { __typename?: 'CatalogWorkTypesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CatalogWorkTypeData', code: string, hasPrice: boolean, id: number, name: string, uniqueId: string, unit: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerSetWorkOrderWorkRatioMutationVariables = Exact<{
  ratio?: InputMaybe<Scalars['Decimal']>;
  workOrderPriceId: Scalars['Long'];
}>;


export type UerSetWorkOrderWorkRatioMutation = { __typename?: 'Mutation', uerSetWorkOrderWorkRatio: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerUpdateWorkOrderSeasonsMutationVariables = Exact<{
  input: WorkOrderSeasonsInput;
  workOrderId: Scalars['Long'];
}>;


export type UerUpdateWorkOrderSeasonsMutation = { __typename?: 'Mutation', uerUpdateWorkOrderSeasons: { __typename?: 'ServiceDataResultOfWorkOrderSeasonsUpdateData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'WorkOrderSeasonsUpdateData', firstContractSeasonId: any, lastContractSeasonId: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderPriceItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderPriceItemFilterInput>;
}>;


export type UerWorkOrderPriceItemsQuery = { __typename?: 'Query', uerWorkOrderPriceItems?: { __typename?: 'UerWorkOrderPriceItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderPriceItem', clientId: string, itemId: any, type?: WorkOrderPriceTypeEnum | null, sortPart?: number | null, sortSMRPart?: number | null, sortOtherPart?: number | null, rootObjectId: any, rootObjectName: string, objectId?: any | null, objectName?: string | null, chapter?: ChapterEnum | null, status?: WorkOrderPriceStatusEnum | null, statusTip?: string | null, entryId?: any | null, code?: string | null, name?: string | null, unit?: string | null, unitCost?: any | null, uerId?: any | null, uerCode?: string | null, uerCodeId?: any | null, entityTypeId?: number | null, entityTypeUniqueId?: string | null, entityTypeName?: string | null, hasDuplicates?: boolean | null, calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, hasLimitSpan?: boolean | null, isActKC2Price?: boolean | null, isExcludedPrice?: boolean | null, rationale?: string | null, isRootObject: boolean, isSMRItem: boolean, isOtherGroup: boolean, isOtherItem: boolean, isCreatedFromSKzS?: boolean | null, workCode?: string | null, workName?: string | null, workUnit?: string | null, workInSum?: WorkInSumEnum | null, workRatio?: any | null, workKindWorkRatio?: any | null, workPlan?: any | null, workCompleted?: any | null, workReminder?: any | null, hasEmptySeasonVolume?: boolean | null, hasEmptyActPlanVolume?: boolean | null, hasEmptyActAcceptedVolume?: boolean | null, hasEmptyActPlanCost?: boolean | null, hasEmptyActAcceptedCost?: boolean | null, hasOngoingOtherActs?: boolean | null, hasOngoingSmrActs?: boolean | null, hasOngoingSkzsActs?: boolean | null, hasCompletedSmrActs?: boolean | null, hasCompletedSkzsActs?: boolean | null, hasCompletedOtherActs?: boolean | null, totalPlanVolume?: any | null, totalPlanCost?: any | null, totalCompletedVolume?: any | null, totalCompletedCost?: any | null, totalRemainderVolume?: any | null, totalRemainderCost?: any | null, seasonValues?: Array<{ __typename?: 'WorkOrderPriceSeasonValue', itemTip: number, priceId: any, seasonId: any, seasonYear: number, planVolume?: any | null, planTerms?: Array<any> | null, planCost?: any | null, completedVolume?: any | null, completedCost?: any | null, remainderCost?: any | null, remainderVolume?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null, actValues: Array<{ __typename?: 'WorkOrderPriceActValue', actId: any, actStatus: ActKc2StatusEnum, actCostGroup: CostGroupEnum, isCorrection?: boolean | null, isInactive?: boolean | null, actHasEditableCost?: boolean | null, isActKC2DistributionOfMtrInflation?: boolean | null, actInflationSeasonId?: any | null, actVolumePlan?: any | null, actVolumePlanDeviation?: DeviationEnum | null, actVolumeAccepted?: any | null, actVolumeAcceptedDeviation?: DeviationEnum | null, actVolumeIsReadOnly?: boolean | null, actCostPlan?: any | null, actCostPlanDeviation?: DeviationEnum | null, actCostAccepted?: any | null, actCostAcceptedDeviation?: DeviationEnum | null, isSKzS?: boolean | null, actStatusSKzS?: SkzsActKc2StatusEnum | null, actVolumePlanSKzS?: any | null, comment?: string | null, isSKzSUpdated?: boolean | null, isSKzSCopied?: boolean | null, isSKzSCopyLock?: boolean | null, actFormula?: string | null, actFormulaDisplayText?: string | null, actFormulaErrors?: Array<string> | null, hasActFormula?: boolean | null }> }> | null }> | null } | null };

export type UerWorkOrderActsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderActKc2DataFilterInput>;
}>;


export type UerWorkOrderActsQuery = { __typename?: 'Query', uerWorkOrderActs?: { __typename?: 'UerWorkOrderActsCollectionSegment', items?: Array<{ __typename?: 'WorkOrderActKC2Data', objectId: any, planVolumeDeviation?: DeviationEnum | null, acceptedVolumeDeviation?: DeviationEnum | null, planCostDeviation?: DeviationEnum | null, acceptedCostDeviation?: DeviationEnum | null, canCreateCorrection?: boolean | null, id: any, number?: any | null, date?: any | null, reportingStartDate?: any | null, reportingFinishDate?: any | null, costGroup: CostGroupEnum, status: ActKc2StatusEnum, seasonYear: number, seasonId: any, inflationSeasonYear?: number | null, inflationSeasonId?: any | null, isDistributionOfMtrInflation: boolean, isCorrection?: boolean | null, isInactive?: boolean | null, correctionNumber?: any | null, fullNumber?: string | null, correctionDate?: any | null, isSKzS?: boolean | null, statusSKzS?: SkzsActKc2StatusEnum | null, isSKzSUpdated: boolean, isSKzSCopyLock: boolean, isSKzSCopied: boolean }> | null } | null };

export type UerWorkOrderSKzSInfoQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderSKzSInfoQuery = { __typename?: 'Query', uerWorkOrderSKzSInfo: { __typename?: 'ServiceDataResultOfWorkOrderSKzSInfo', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'WorkOrderSKzSInfo', actsKC2SKzSNewCount: number, actsKC2SKzSUpdatedCount: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerSetActKc2WorkVolumeCommentMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  priceId: Scalars['Long'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UerSetActKc2WorkVolumeCommentMutation = { __typename?: 'Mutation', uerSetActKC2WorkVolumeComment: { __typename?: 'ServiceDataResultOfActKC2CommentData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerSetActKc2OtherCostCommentMutationVariables = Exact<{
  actKC2Id: Scalars['Long'];
  otherPriceId: Scalars['Long'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UerSetActKc2OtherCostCommentMutation = { __typename?: 'Mutation', uerSetActKC2OtherCostComment: { __typename?: 'ServiceDataResultOfActKC2CommentData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerActsKc2AnalyticsByUerQueryVariables = Exact<{
  order?: InputMaybe<Array<ActKc2UerCostChartDataSortInput> | ActKc2UerCostChartDataSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2UerCostChartDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
}>;


export type UerActsKc2AnalyticsByUerQuery = { __typename?: 'Query', uerActsKC2AnalyticsByUer?: { __typename?: 'UerActsKC2AnalyticsByUerCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2UerCostChartData', rimActKC2WorkCost: any, skzsActKC2WorkCost: any, uerCode: string, uerName: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerActsKc2AnalyticsBySeasonsQueryVariables = Exact<{
  seasonYear?: InputMaybe<Scalars['Short']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2UerCostPlotDataFilterInput>;
  workOrderId: Scalars['Long'];
  workOrderRootObjectId: Scalars['Long'];
}>;


export type UerActsKc2AnalyticsBySeasonsQuery = { __typename?: 'Query', uerActsKC2AnalyticsBySeasons?: { __typename?: 'UerActsKC2AnalyticsBySeasonsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2UerCostPlotData', rimActKC2WorkCost: any, skzsActKC2WorkCost: any, date: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerCreateContractSubObjectMutationVariables = Exact<{
  contractId: Scalars['Long'];
  input: ContractSubObjectCreateInput;
}>;


export type UerCreateContractSubObjectMutation = { __typename?: 'Mutation', uerCreateContractSubObject: { __typename?: 'ServiceDataResultOfContractObjectData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractObjectData', contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerUpdateContractObjectMutationVariables = Exact<{
  contractId: Scalars['Long'];
  input: ContractObjectUpdateInput;
}>;


export type UerUpdateContractObjectMutation = { __typename?: 'Mutation', uerUpdateContractObject: { __typename?: 'ServiceDataResultOfContractObjectData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractSubObjectMutationVariables = Exact<{
  contractId: Scalars['Long'];
  input: ContractSubObjectUpdateInput;
}>;


export type UerUpdateContractSubObjectMutation = { __typename?: 'Mutation', uerUpdateContractSubObject: { __typename?: 'ServiceDataResultOfContractObjectData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'ContractObjectData', contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerRemoveWorkOrderPriceItemsMutationVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderPriceIds: Array<Scalars['Long']> | Scalars['Long'];
  workOrderOtherPriceIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerRemoveWorkOrderPriceItemsMutation = { __typename?: 'Mutation', uerRemoveWorkOrderPriceItems: { __typename?: 'ServiceDataResultOfCountData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderObjectTotalsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
}>;


export type UerWorkOrderObjectTotalsQuery = { __typename?: 'Query', uerWorkOrderObjectTotals: { __typename?: 'ServiceDataResultOfWorkOrderTotalData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'WorkOrderTotalData', isHeadLine: boolean, name: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonTotals: Array<{ __typename?: 'WorkOrderSeasonTotalData', completedCost?: any | null, planCost?: any | null, seasonId: any }> } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerPriceListRatioRowsWithScopesQueryVariables = Exact<{
  contractId: Scalars['Long'];
  order?: InputMaybe<Array<PriceListUerRatioRowSortInput> | PriceListUerRatioRowSortInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  uerBaseRowId: Scalars['Long'];
  where?: InputMaybe<PriceListUerRatioRowFilterInput>;
}>;


export type UerPriceListRatioRowsWithScopesQuery = { __typename?: 'Query', uerPriceListRatioRowsWithScopes?: { __typename?: 'UerPriceListRatioRowsWithScopesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerRatioRow', code: string, groupId?: any | null, groupName?: string | null, id: any, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioType: RatioTypeEnum, status: RatioRecordStatusEnum, workConditions: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerApplyPriceListUerRatioRowsMutationVariables = Exact<{
  ratioRowIds: Array<Scalars['Long']> | Scalars['Long'];
  uerBaseRowId: Scalars['Long'];
}>;


export type UerApplyPriceListUerRatioRowsMutation = { __typename?: 'Mutation', uerApplyPriceListUerRatioRows: { __typename?: 'ServiceDataResultOfCountData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerActKc2SmrPriceItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  actKC2Id: Scalars['Long'];
  where?: InputMaybe<ActKc2SmrPriceItemFilterInput>;
}>;


export type UerActKc2SmrPriceItemsQuery = { __typename?: 'Query', uerActKC2SmrPriceItems?: { __typename?: 'UerActKC2SmrPriceItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2SmrPriceItem', code?: string | null, costAccepted?: any | null, itemId: any, name?: string | null, objectId?: any | null, unit?: string | null, unitCost?: any | null, volumeAccepted?: any | null, type?: WorkOrderPriceTypeEnum | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerActKc2OtherPriceItemsQueryVariables = Exact<{
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2OtherPriceItemFilterInput>;
}>;


export type UerActKc2OtherPriceItemsQuery = { __typename?: 'Query', uerActKC2OtherPriceItems?: { __typename?: 'UerActKC2OtherPriceItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2OtherPriceItem', calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, costAccepted?: any | null, itemId: any, name?: string | null, objectId?: any | null, type?: WorkOrderPriceTypeEnum | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerActKc2SmrTotalsQueryVariables = Exact<{
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2TotalItemFilterInput>;
}>;


export type UerActKc2SmrTotalsQuery = { __typename?: 'Query', uerActKC2SmrTotals?: { __typename?: 'UerActKC2SmrTotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2TotalItem', name?: string | null, sortOrder: any, totalCost?: any | null, isHeadLine?: boolean | null, isActKC2Total: boolean }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerActKc2OtherTotalsQueryVariables = Exact<{
  actKC2Id: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActKc2TotalItemFilterInput>;
}>;


export type UerActKc2OtherTotalsQuery = { __typename?: 'Query', uerActKC2OtherTotals?: { __typename?: 'UerActKC2OtherTotalsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ActKC2TotalItem', name?: string | null, sortOrder: any, totalCost?: any | null, isHeadLine?: boolean | null, isActKC2Total: boolean }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderChangeOtherCostSelectonListQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderChangeOtherCostItemFilterInput>;
}>;


export type UerWorkOrderChangeOtherCostSelectonListQuery = { __typename?: 'Query', uerWorkOrderChangeOtherCostSelectonList: Array<{ __typename?: 'WorkOrderChangeOtherCostItem', hasSeasonLimits: boolean, sortPart: number, otherCost: { __typename?: 'ContractOtherCostBase', contractOtherCostId: any, catalogOtherCostTypeId?: number | null, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, catalogOtherCostType?: { __typename?: 'CatalogOtherCostTypeData', canDelete: boolean, isSystem: boolean, id: number, uniqueId: string, name: string } | null }, workOrderChangeObjects: Array<{ __typename?: 'WorkOrderChangeOtherCostObjectItem', hasActualCost?: boolean | null, isActKC2Cost?: boolean | null, contractObjectId: any, name: string, rationale?: string | null, isIncluded?: boolean | null, canAddOther: boolean, canRemoveOther: boolean, rootObjectId: { __typename?: 'ObjectIds', workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null } }>, seasonLimits?: Array<{ __typename?: 'WorkOrderChangeOtherCostSeasonLimitData', workOrderChangeSeasonId: any, workOrderSeasonId?: any | null, year: any, includedCost?: any | null, isIncluded?: boolean | null, planCost?: any | null, actualCost?: any | null, remainderCost?: any | null, deviation?: DeviationTipEnum | null }> | null }> };

export type UerUpdateWorkOrderChangeOtherCostItemsMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  otherPriceInputs: Array<UpdateWorkOrderChangeOtherPriceItemInput> | UpdateWorkOrderChangeOtherPriceItemInput;
}>;


export type UerUpdateWorkOrderChangeOtherCostItemsMutation = { __typename?: 'Mutation', uerUpdateWorkOrderChangeOtherCostItems: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangeUersSelectionListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  chapter: ChapterEnum;
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  where?: InputMaybe<WorkOrderChangeUerItemDataFilterInput>;
  order?: InputMaybe<Array<WorkOrderChangeUerItemDataSortInput> | WorkOrderChangeUerItemDataSortInput>;
}>;


export type UerWorkOrderChangeUersSelectionListQuery = { __typename?: 'Query', uerWorkOrderChangeUersSelectionList?: { __typename?: 'UerWorkOrderChangeUersSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderChangeUerItemData', id: any, sectionId: any, sectionName: string, groupId: any, groupName: string, groupFullName: string, code: string, name: string, unit?: string | null, unitCost?: any | null, chapter?: ChapterEnum | null, status: UerRecordStatusEnum, justification?: string | null }> | null } | null };

export type UerAddUersToWorkOrderChangeObjectsMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  uerInputs: Array<PriceListUerRowInput> | PriceListUerRowInput;
  constructionTypeId: Scalars['Int'];
  chapter: ChapterEnum;
}>;


export type UerAddUersToWorkOrderChangeObjectsMutation = { __typename?: 'Mutation', uerAddUersToWorkOrderChangeObjects: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null } };

export type UerWorkOrderChangeUsersSelectionListSectionFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderChangeUsersSelectionListSectionFilterQuery = { __typename?: 'Query', uerWorkOrderChangeUsersSelectionListSectionFilter?: { __typename?: 'UerWorkOrderChangeUsersSelectionListSectionFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderChangeUsersSelectionListCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderChangeUsersSelectionListCodeFilterQuery = { __typename?: 'Query', uerWorkOrderChangeUsersSelectionListCodeFilter?: { __typename?: 'UerWorkOrderChangeUsersSelectionListCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderChangeUsersSelectionListGroupFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderChangeUsersSelectionListGroupFilterQuery = { __typename?: 'Query', uerWorkOrderChangeUsersSelectionListGroupFilter?: { __typename?: 'UerWorkOrderChangeUsersSelectionListGroupFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderChangeUsersSelectionListNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  order?: InputMaybe<Array<FilterValueOfStringSortInput> | FilterValueOfStringSortInput>;
}>;


export type UerWorkOrderChangeUsersSelectionListNameFilterQuery = { __typename?: 'Query', uerWorkOrderChangeUsersSelectionListNameFilter?: { __typename?: 'UerWorkOrderChangeUsersSelectionListNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerAddObjectToWorkOrderChangeMutationVariables = Exact<{
  input: WorkOrderChangeObjectInput;
}>;


export type UerAddObjectToWorkOrderChangeMutation = { __typename?: 'Mutation', uerAddObjectToWorkOrderChange: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveWorkOrderChangeObjectMutationVariables = Exact<{
  workOrderChangeObjectId: Scalars['Long'];
}>;


export type UerRemoveWorkOrderChangeObjectMutation = { __typename?: 'Mutation', uerRemoveWorkOrderChangeObject: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRenameWorkOrderChangeObjectMutationVariables = Exact<{
  name: Scalars['String'];
  workOrderChangeObjectId: Scalars['Long'];
}>;


export type UerRenameWorkOrderChangeObjectMutation = { __typename?: 'Mutation', uerRenameWorkOrderChangeObject: { __typename?: 'ServiceResult', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type MoveWorkOrderChangeObjectMutationVariables = Exact<{
  insertAfterObjectId?: InputMaybe<Scalars['Long']>;
  newParentObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId: Scalars['Long'];
}>;


export type MoveWorkOrderChangeObjectMutation = { __typename?: 'Mutation', uerMoveWorkOrderChangeObject: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerContractObjectsToAddToWorkOrderChangeQueryVariables = Exact<{
  constructionTypeId: Scalars['Long'];
  parentWorkOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerContractObjectsToAddToWorkOrderChangeQuery = { __typename?: 'Query', uerContractObjectsToAddToWorkOrderChange: { __typename?: 'ServiceDataResultOfWorkOrderObjectToAddEntry__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'WorkOrderObjectToAddEntry', code?: string | null, constructionTypeId: any, contractObjectId: any, name: string, used: boolean } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangeQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeQuery = { __typename?: 'Query', uerWorkOrderChange: { __typename?: 'ServiceDataResultOfWorkOrderChangeData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderChangeData', id: any, contractId: any, workOrderId: any, contractSubjectText?: string | null, workOrderNumberText?: string | null, workOrderSigningDate?: any | null, status: WorkOrderChangeStatusEnum, statusFollowers: Array<WorkOrderChangeStatusEnum>, internalNumber?: string | null, signingDate?: any | null, description?: string | null, createdAt: any, updatedAt?: any | null, authoredBy: string, draftCount: number, isClosing: boolean } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerCreateWorkOrderChangeMutationVariables = Exact<{
  input: WorkOrderChangeInput;
}>;


export type UerCreateWorkOrderChangeMutation = { __typename?: 'Mutation', uerCreateWorkOrderChange: { __typename?: 'ServiceDataResultOfWorkOrderChangeData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderChangeData', id: any, contractId: any, workOrderId: any, contractSubjectText?: string | null, workOrderNumberText?: string | null, workOrderSigningDate?: any | null, status: WorkOrderChangeStatusEnum, internalNumber?: string | null, signingDate?: any | null, description?: string | null, createdAt: any, updatedAt?: any | null, authoredBy: string, statusFollowers: Array<WorkOrderChangeStatusEnum> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerDeleteWorkOrderChangeMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type UerDeleteWorkOrderChangeMutation = { __typename?: 'Mutation', uerDeleteWorkOrderChange: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderChangeMutationVariables = Exact<{
  workOrderChangeInput: WorkOrderChangeUpdateInput;
}>;


export type UerUpdateWorkOrderChangeMutation = { __typename?: 'Mutation', uerUpdateWorkOrderChange: { __typename?: 'ServiceDataResultOfWorkOrderChangeData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderChangeData', id: any, statusFollowers: Array<WorkOrderChangeStatusEnum> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangeStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type UerWorkOrderChangeStatusesQuery = { __typename?: 'Query', uerWorkOrderChangeStatuses: { __typename?: 'ServiceDataResultOfWorkOrderChangeStatusData__', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: Array<{ __typename?: 'WorkOrderChangeStatusData', status: WorkOrderChangeStatusEnum, followers: Array<WorkOrderChangeStatusEnum> } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerIsUniqueWorkOrderChangeInternalNumberQueryVariables = Exact<{
  workOrderChangeId?: InputMaybe<Scalars['Long']>;
  number: Scalars['String'];
  workOrderId: Scalars['Long'];
}>;


export type UerIsUniqueWorkOrderChangeInternalNumberQuery = { __typename?: 'Query', uerIsUniqueWorkOrderChangeInternalNumber: { __typename?: 'ServiceResult', result: boolean, message?: string | null, code?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangeObjectItemsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  where?: InputMaybe<WorkOrderChangeObjectItemFilterInput>;
}>;


export type UerWorkOrderChangeObjectItemsQuery = { __typename?: 'Query', uerWorkOrderChangeObjectItems?: { __typename?: 'UerWorkOrderChangeObjectItemsCollectionSegment', items?: Array<{ __typename?: 'WorkOrderChangeObjectItem', id?: any | null, code?: string | null, hasAcceptedCost?: boolean | null, isAddedObject?: boolean | null, isLeaf: boolean, isRemovedObject?: boolean | null, name: string, objectUniqueId?: string | null, parentId?: any | null, rootObjectId?: any | null, rootObjectUniqueId?: string | null, workOrderChangeId?: any | null, workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null, isActKC2WorkOrderObject?: boolean | null, workOrderChangeParentId?: any | null, workOrderChangeRootObjectId?: any | null, workOrderId?: any | null, workOrderParentId?: any | null, workOrderRootObjectId?: any | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any }, contractObject?: { __typename?: 'ContractObjectData', id: any, parentId?: any | null, rootObjectId?: any | null, contractId: any, fromVOR: boolean, name: string, status: ContractObjectStatusEnum, constructionType: { __typename?: 'ConstructionTypeData', id: number, code: string, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null }> | null } | null };

export type UerWorkOrderChangePriceListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  chapter: ChapterEnum;
  where?: InputMaybe<WorkOrderChangePriceDataFilterInput>;
}>;


export type UerWorkOrderChangePriceListQuery = { __typename?: 'Query', uerWorkOrderChangePriceList?: { __typename?: 'UerWorkOrderChangePriceListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderChangePriceData', clientId?: any | null, clientParentId?: any | null, workOrderChangePriceId?: any | null, workOrderPriceId?: any | null, workOrderChangePriceParentId?: any | null, workOrderPriceParentId?: any | null, uerCodeId?: any | null, rationale?: string | null, type: WorkOrderPriceTypeEnum, typeVal: number, status: WorkOrderPriceStatusEnum, chapter: ChapterEnum, uerId: any, uerCode: string, priceListId: any, code: string, name: string, unit: string, unitCost: any, totalPlanCost?: any | null, totalPlanVolume?: any | null, totalCompletedCost?: any | null, totalCompletedVolume?: any | null, totalRemainderCost?: any | null, totalRemainderVolume?: any | null, totalDeviation?: DeviationEnum | null, totalDeviationTip?: DeviationTipEnum | null, hasAcceptedCost?: boolean | null, isRemovedPrice?: boolean | null, isAddedPrice?: boolean | null, isBlockedPrice?: boolean | null, isActKC2Price?: boolean | null, isExcludedPrice?: boolean | null, hasEmptySeasonVolume?: boolean | null, workCode?: string | null, workCompleted?: any | null, workInSum: WorkInSumEnum, workName?: string | null, workPlan?: any | null, workRatio?: any | null, workReminder?: any | null, workUnit?: string | null, hasDuplicates?: boolean | null, seasonPrices?: Array<{ __typename?: 'WorkOrderChangeSeasonPriceData', workOrderChangePriceId?: any | null, workOrderPriceId?: any | null, workOrderChangeSeasonId?: any | null, year: any, planVolume?: any | null, planCost?: any | null, remainderVolume?: any | null, remainderCost?: any | null, deviation?: DeviationEnum | null, deviationTip?: DeviationTipEnum | null, planVolumeTerms?: Array<any> | null, workOrderSeasonId?: any | null, completedVolume?: any | null, completedCost?: any | null }> | null }> | null } | null };

export type UerWorkOrderChangeSeasonsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeSeasonsQuery = { __typename?: 'Query', uerWorkOrderChangeSeasons?: { __typename?: 'UerWorkOrderChangeSeasonsCollectionSegment', items?: Array<{ __typename?: 'WorkOrderChangeSeasonData', id: any, workOrderSeasonId?: any | null, year: any }> | null } | null };

export type UerWorkOrderChangeOtherPriceListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<WorkOrderChangeOtherPriceDataFilterInput>;
}>;


export type UerWorkOrderChangeOtherPriceListQuery = { __typename?: 'Query', uerWorkOrderChangeOtherPriceList?: { __typename?: 'UerWorkOrderChangeOtherPriceListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderChangeOtherPriceData', clientId?: any | null, workOrderChangeOtherPriceId?: any | null, workOrderOtherPriceId?: any | null, contractOtherId: any, rationale?: string | null, name: string, calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status?: ContractOtherStatusEnum | null, totalPlanCost?: any | null, totalCompletedCost?: any | null, totalRemainderCost?: any | null, totalDeviation?: DeviationEnum | null, totalDeviationTip?: DeviationTipEnum | null, hasAcceptedCost?: boolean | null, hasEmptySeasonCost?: boolean | null, isAddedPrice?: boolean | null, isRemovedPrice?: boolean | null, isActKC2Price?: boolean | null, isExcludedPrice?: boolean | null, hasLimitSpan: boolean, seasonPrices?: Array<{ __typename?: 'WorkOrderChangeOtherSeasonPriceData', workOrderChangeOtherPriceId?: any | null, workOrderOtherPriceId?: any | null, workOrderChangeSeasonId?: any | null, workOrderSeasonId?: any | null, year: any, planCost?: any | null, completedCost?: any | null, remainderCost?: any | null, deviation?: DeviationEnum | null, deviationTip?: DeviationTipEnum | null, hasErrors?: boolean | null, errors?: Array<string> | null }> | null }> | null } | null };

export type UerRemoveWorkOrderChangePriceItemsMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  priceIds: Array<WorkOrderChangePriceIdsInput> | WorkOrderChangePriceIdsInput;
  otherPriceIds: Array<WorkOrderChangeOtherPriceIdsInput> | WorkOrderChangeOtherPriceIdsInput;
}>;


export type UerRemoveWorkOrderChangePriceItemsMutation = { __typename?: 'Mutation', uerRemoveWorkOrderChangePriceItems: { __typename?: 'ServiceDataResultOfCountData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'CountData', count: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveWorkOrderChangePricesMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  priceIds: Array<WorkOrderChangePriceIdsInput> | WorkOrderChangePriceIdsInput;
}>;


export type UerRemoveWorkOrderChangePricesMutation = { __typename?: 'Mutation', uerRemoveWorkOrderChangePrices: { __typename?: 'ServiceDataResultOfInt64__', result: boolean, data?: Array<any> | null, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangePriceListMtrQueryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<PriceListMtrRowDataFilterInput>;
  order?: InputMaybe<Array<PriceListMtrRowDataSortInput> | PriceListMtrRowDataSortInput>;
}>;


export type UerWorkOrderChangePriceListMtrQueryQuery = { __typename?: 'Query', uerWorkOrderChangePriceListMtrQuery?: { __typename?: 'UerWorkOrderChangePriceListMtrQueryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListMtrRowData', id: any, contractId: any, code: string, name: string, unit: string, volume?: any | null, unitWeight?: any | null, unitCost: any, supplyBy?: ContragentTypeEnum | null, supplyBasis?: string | null, mtrType?: MtrTypeEnum | null, pricingType: PricingTypeEnum, note?: string | null, status: MtrRecordStatusEnum, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, justification?: string | null, mtrSupplyAndType: MtrSupplyAndTypeEnum, hasDuplicateNeighbours: boolean }> | null } | null };

export type UerAddMtrToWorkOrderChangeMutationVariables = Exact<{
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  mtrInputs: Array<PriceListMtrRowInput> | PriceListMtrRowInput;
}>;


export type UerAddMtrToWorkOrderChangeMutation = { __typename?: 'Mutation', uerAddMtrToWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangePriceListUerQueryQueryVariables = Exact<{
  chapter: ChapterEnum;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceListUerRowDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangePriceListUerQueryQuery = { __typename?: 'Query', uerWorkOrderChangePriceListUerQuery?: { __typename?: 'UerWorkOrderChangePriceListUerQueryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListUerRowData', hasNewConstructionTypeRelations?: boolean | null, isIncludedInWorkOrder?: boolean | null, isIncludedInAct: boolean, id: any, sectionId: any, sectionName: string, groupId: any, groupCode?: string | null, groupName: string, unit: string, code: string, name: string, chapter?: ChapterEnum | null, uerClassifier?: UerClassifierEnum | null, status: UerRecordStatusEnum, linkStatus: PriceConstructionTypeRelationStatusEnum, justification?: string | null, basePrice: { __typename?: 'PriceListUerRowPriceData', ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null, constructionTypeRelationStatus?: PriceConstructionTypeRelationStatusEnum | null }, currentPrices: Array<{ __typename?: 'PriceListUerRowPriceCurrentData', id: any, constructionTypeId: number, constructionTypeName: string, unitCostWithOther?: any | null, ozp?: any | null, emm?: any | null, zpm?: any | null, mtr?: any | null, eqp?: any | null, pir?: any | null, trn?: any | null, nr?: any | null, sp?: any | null, unitCost?: any | null, constructionTypeRelationStatus?: PriceConstructionTypeRelationStatusEnum | null }>, workScopes: Array<{ __typename?: 'PriceListUerWorkScopeData', id: any, number: number, description: string }> }> | null } | null };

export type UerAddUerToWorkOrderChangeMutationVariables = Exact<{
  chapter: ChapterEnum;
  uerInputs: Array<PriceListUerRowInput> | PriceListUerRowInput;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerAddUerToWorkOrderChangeMutation = { __typename?: 'Mutation', uerAddUerToWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangePriceListRatioQueryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<PriceListRatioRowDataFilterInput>;
}>;


export type UerWorkOrderChangePriceListRatioQueryQuery = { __typename?: 'Query', uerWorkOrderChangePriceListRatioQuery?: { __typename?: 'UerWorkOrderChangePriceListRatioQueryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListRatioRowData', appliesToCode: string, appliesToCodeName: string, appliesToFullName: string, appliesToId: any, appliesToLinkStatus: RatioRecordStatusEnum, code: string, groupId?: any | null, groupIsArtificial?: boolean | null, groupName?: string | null, groupType?: DismantlingCoefficientTypeEnum | null, id: any, isCustom?: boolean | null, isIncludedInAct: boolean, isIncludedInWorkOrder?: boolean | null, isIncludedInWorkOrderChange?: boolean | null, justification?: string | null, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, number?: number | null, ratioType: RatioTypeEnum, status: RatioRecordStatusEnum, subGroupId?: any | null, subGroupName?: string | null, uerPriceListGroupCode?: string | null, uerPriceListGroupFullName?: string | null, uerPriceListGroupId?: any | null, uerPriceListGroupName?: string | null, uerPriceListSectionId?: any | null, uerPriceListSectionName?: string | null, workConditions: string }> | null } | null };

export type UerAddRatioToWorkOrderChangeMutationVariables = Exact<{
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  ratioInputs: Array<PriceListRatioRowInput> | PriceListRatioRowInput;
  strategy?: InputMaybe<AddRatioToActKc2StrategyEnum>;
}>;


export type UerAddRatioToWorkOrderChangeMutation = { __typename?: 'Mutation', uerAddRatioToWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSaveOrUpdateWorkOrderChangeSeasonVolumeMutationVariables = Exact<{
  volume: Scalars['Decimal'];
  workOrderChangeId: Scalars['Long'];
  workOrderChangeSeasonId: Scalars['Long'];
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type UerSaveOrUpdateWorkOrderChangeSeasonVolumeMutation = { __typename?: 'Mutation', uerSaveOrUpdateWorkOrderChangeSeasonVolume: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, code?: string | null, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangeObjectResultQueryVariables = Exact<{
  chapter?: InputMaybe<ChapterEnum>;
  order?: InputMaybe<Array<WorkOrderChangeObjectResultDataSortInput> | WorkOrderChangeObjectResultDataSortInput>;
  section?: InputMaybe<SectionEnum>;
  where?: InputMaybe<WorkOrderChangeObjectResultDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeObjectResultQuery = { __typename?: 'Query', uerWorkOrderChangeObjectResult: Array<{ __typename?: 'WorkOrderChangeObjectResultData', chapter?: ChapterEnum | null, constructionTypeId: number, section?: SectionEnum | null, sortOrder: any, title: string, workOrderChangeObjectId?: any | null, workOrderObjectId?: any | null, costResultData: Array<{ __typename?: 'WorkOrderCostResultData', name: string, value: any, year: any }> }> };

export type UerWorkOrderChangeResultQueryVariables = Exact<{
  order?: InputMaybe<Array<WorkOrderChangeResultDataSortInput> | WorkOrderChangeResultDataSortInput>;
  where?: InputMaybe<WorkOrderChangeResultDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeResultQuery = { __typename?: 'Query', uerWorkOrderChangeResult: Array<{ __typename?: 'WorkOrderChangeResultData', chapter?: ChapterEnum | null, resultSectionId: any, section?: SectionEnum | null, sortOrder: any, title: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonResults: Array<{ __typename?: 'WorkOrderChangeSeasonResultData', seasonId: any, value: any }> }> };

export type UerWorkOrderChangeOtherListQueryQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderChangeOtherAggregationDataFilterInput>;
}>;


export type UerWorkOrderChangeOtherListQueryQuery = { __typename?: 'Query', uerWorkOrderChangeOtherListQuery?: { __typename?: 'UerWorkOrderChangeOtherListQueryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderChangeOtherAggregationData', contractOtherCostId: any, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, status: ContractOtherStatusEnum, limits: Array<{ __typename?: 'WorkOrderChangeCostLimitData', costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum, season?: { __typename?: 'WorkOrderChangeSeasonData', id: any, workOrderSeasonId?: any | null, year: any } | null }> }> | null } | null };

export type UerAddWorkOrderChangeOtherCostMutationVariables = Exact<{
  input: WorkOrderChangeOthersInput;
}>;


export type UerAddWorkOrderChangeOtherCostMutation = { __typename?: 'Mutation', uerAddWorkOrderChangeOtherCost: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerRemoveWorkOrderChangeOtherCostMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceIds: Array<WorkOrderChangeOtherPriceIdsInput> | WorkOrderChangeOtherPriceIdsInput;
}>;


export type UerRemoveWorkOrderChangeOtherCostMutation = { __typename?: 'Mutation', uerRemoveWorkOrderChangeOtherCost: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangeOtherForDistributionQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeOtherForDistributionQuery = { __typename?: 'Query', uerWorkOrderChangeOtherForDistribution: { __typename?: 'ServiceDataResultOfWorkOrderChangeOtherDistributionData', result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderChangeOtherDistributionData', workOrderChangeOtherPriceId?: any | null, workOrderOtherPriceId?: any | null, contractOtherCost: { __typename?: 'ContractOtherCostBaseData', id: any, key?: string | null, name: string, calculatingType: OtherCostCalculationTypeEnum, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, section?: SectionEnum | null, isGlobalOtherCost: boolean, status: ContractOtherStatusEnum, canEdit: boolean, canDelete: boolean, isInUse: boolean }, objects: Array<{ __typename?: 'WorkOrderChangeOtherCostObjectItem', hasActualCost?: boolean | null, isActKC2Cost?: boolean | null, contractObjectId: any, name: string, rationale?: string | null, isIncluded?: boolean | null, canAddOther: boolean, canRemoveOther: boolean, rootObjectId: { __typename?: 'ObjectIds', workOrderObjectId?: any | null, workOrderChangeObjectId?: any | null } }>, limits: Array<{ __typename?: 'WorkOrderChangeCostLimitDistributionData', includedCost?: any | null, isIncluded?: boolean | null, costLimit: any, totalRemainderCost?: any | null, deviation: DeviationTipEnum, isSystemCalculation?: boolean | null, season?: { __typename?: 'WorkOrderChangeSeasonData', id: any, workOrderSeasonId?: any | null, year: any } | null }>, objectSeasonDistributions: Array<{ __typename?: 'WorkOrderChangeOtherPriceCostData', isIncluded: boolean, hasErrors?: boolean | null, errors?: Array<string> | null, seasonId: any, cost?: any | null, workOrderChangeObjectId?: any | null, workOrderObjectId?: any | null }> } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateWorkOrderChangeOtherDistributionMutationVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  input: WorkOrderChangeOtherCostDistributionInput;
}>;


export type UerUpdateWorkOrderChangeOtherDistributionMutation = { __typename?: 'Mutation', uerUpdateWorkOrderChangeOtherDistribution: { __typename?: 'ServiceDataResultOfInt64__', data?: Array<any> | null, result: boolean, message?: string | null, buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateContractOtherCostToWorkOrderChangeFromPriceListMutationVariables = Exact<{
  input: ContractOtherUpdateInput;
  workOrderChangeOtherPriceId: Scalars['Long'];
}>;


export type UerUpdateContractOtherCostToWorkOrderChangeFromPriceListMutation = { __typename?: 'Mutation', uerUpdateContractOtherCostToWorkOrderChangeFromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerUpdateMtrToWorkOrderChangeFromPriceListMutationVariables = Exact<{
  workOrderChangePriceId: Scalars['Long'];
  input: PriceListMtrRowUpdateInput;
}>;


export type UerUpdateMtrToWorkOrderChangeFromPriceListMutation = { __typename?: 'Mutation', uerUpdateMtrToWorkOrderChangeFromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderChangePriceStatusFilterQueryVariables = Exact<{
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangePriceStatusFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceStatusFilter?: { __typename?: 'UerWorkOrderChangePriceStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkOrderPriceStatusEnum', value?: WorkOrderPriceStatusEnum | null }> | null } | null };

export type UerWorkOrderChangePriceCodeFilterQueryVariables = Exact<{
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangePriceCodeFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceCodeFilter?: { __typename?: 'UerWorkOrderChangePriceCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkOrderChangePriceCodeFilterData', value?: { __typename?: 'WorkOrderChangePriceCodeFilterData', parentCode: string, code: string } | null }> | null } | null };

export type UerWorkOrderChangePriceNameFilterQueryVariables = Exact<{
  chapter: ChapterEnum;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangePriceNameFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceNameFilter?: { __typename?: 'UerWorkOrderChangePriceNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderChangeSeasonPricePlanVolumeFilterQueryVariables = Exact<{
  chapter: ChapterEnum;
  seasonId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeSeasonPricePlanVolumeFilterQuery = { __typename?: 'Query', uerWorkOrderChangeSeasonPricePlanVolumeFilter?: { __typename?: 'UerWorkOrderChangeSeasonPricePlanVolumeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDecimal', value?: any | null }> | null } | null };

export type UerWorkOrderChangeSeasonPriceCompletedVolumeFilterQueryVariables = Exact<{
  chapter: ChapterEnum;
  seasonId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeSeasonPriceCompletedVolumeFilterQuery = { __typename?: 'Query', uerWorkOrderChangeSeasonPriceCompletedVolumeFilter?: { __typename?: 'UerWorkOrderChangeSeasonPriceCompletedVolumeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDecimal', value?: any | null }> | null } | null };

export type UerWorkOrderChangeSeasonPriceRemainderVolumeFilterQueryVariables = Exact<{
  chapter: ChapterEnum;
  seasonId: Scalars['Long'];
  where?: InputMaybe<FilterValueOfNullableOfDecimalFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeSeasonPriceRemainderVolumeFilterQuery = { __typename?: 'Query', uerWorkOrderChangeSeasonPriceRemainderVolumeFilter?: { __typename?: 'UerWorkOrderChangeSeasonPriceRemainderVolumeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfDecimal', value?: any | null }> | null } | null };

export type UerWorkOrderChangeOtherPriceNameFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfStringFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeOtherPriceNameFilterQuery = { __typename?: 'Query', uerWorkOrderChangeOtherPriceNameFilter?: { __typename?: 'UerWorkOrderChangeOtherPriceNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderChangeOtherPriceStatusFilterQueryVariables = Exact<{
  where?: InputMaybe<FilterValueOfNullableOfContractOtherStatusEnumFilterInput>;
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeOtherPriceStatusFilterQuery = { __typename?: 'Query', uerWorkOrderChangeOtherPriceStatusFilter?: { __typename?: 'UerWorkOrderChangeOtherPriceStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfContractOtherStatusEnum', value?: ContractOtherStatusEnum | null }> | null } | null };

export type UerUpdateOrderChangePriceRationaleMutationVariables = Exact<{
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
  input: WorkOrderChangePriceRationaleUpdateInput;
}>;


export type UerUpdateOrderChangePriceRationaleMutation = { __typename?: 'Mutation', uerUpdateOrderChangePriceRationale: { __typename?: 'ServiceIdResultOfInt64', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerUpdateOrderChangeOtherPriceRationaleMutationVariables = Exact<{
  workOrderChangeOtherPriceId?: InputMaybe<Scalars['Long']>;
  workOrderOtherPriceId?: InputMaybe<Scalars['Long']>;
  input: WorkOrderChangeOtherPriceRationaleUpdateInput;
}>;


export type UerUpdateOrderChangeOtherPriceRationaleMutation = { __typename?: 'Mutation', uerUpdateOrderChangeOtherPriceRationale: { __typename?: 'ServiceIdResultOfInt64', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerWorkOrderChangeUerRemaindersQueryVariables = Exact<{
  chapter: ChapterEnum;
  workOrderChangeId: Scalars['Long'];
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeUerRemaindersQuery = { __typename?: 'Query', uerWorkOrderChangeUerRemainders: Array<{ __typename?: 'WorkOrderChangeSeasonPriceRemainder', clientId?: any | null, code: string, name: string, type: WorkOrderPriceTypeEnum, workOrderChangePriceId?: any | null, workOrderPriceId?: any | null, reminderData: Array<{ __typename?: 'SeasonReminderData', completedVolume?: any | null, planVolume?: any | null, remainderVolume?: any | null, seasonId: any, seasonYear: any }> }> };

export type UerMoveWorkOrderChangeUerRemindersMutationVariables = Exact<{
  input: WorkOrderChangeUerVolumesTransferInput;
}>;


export type UerMoveWorkOrderChangeUerRemindersMutation = { __typename?: 'Mutation', uerMoveWorkOrderChangeUerReminders: { __typename?: 'ServiceDataResultOfWorkOrderChangePriceIds__', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerWorkOrderChangeObjectsForRemindersQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeRootObjectId?: InputMaybe<Scalars['Long']>;
  workOrderRootObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeObjectsForRemindersQuery = { __typename?: 'Query', uerWorkOrderChangeObjectsForReminders: { __typename?: 'ServiceDataResultOfWorkOrderChangeObjectData__', message?: string | null, result: boolean, data?: Array<{ __typename?: 'WorkOrderChangeObjectData', code?: string | null, hasAcceptedCost: boolean, id?: any | null, isAddedObject?: boolean | null, isLeaf: boolean, isRemovedObject?: boolean | null, name: string, parentId?: any | null, rootObjectId?: any | null, workOrderChangeId: any, workOrderObjectId?: any | null, workOrderParentId?: any | null, workOrderRootObjectId?: any | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerMoveWorkOrderChangeObjectRemindersMutationVariables = Exact<{
  input: WorkOrderChangeObjectVolumesTransferInput;
}>;


export type UerMoveWorkOrderChangeObjectRemindersMutation = { __typename?: 'Mutation', uerMoveWorkOrderChangeObjectReminders: { __typename?: 'ServiceDataResultOfWorkOrderChangePriceIds__', message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string, metadata?: string | null }> | null } };

export type UerUpdateUerToWorkOrderChangeFromPriceListMutationVariables = Exact<{
  workOrderChangePriceId: Scalars['Long'];
  input: PriceListUerRowUpdateInput;
}>;


export type UerUpdateUerToWorkOrderChangeFromPriceListMutation = { __typename?: 'Mutation', uerUpdateUerToWorkOrderChangeFromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UpdateRatioToWorkOrderChangeFromPriceListMutationVariables = Exact<{
  workOrderChangePriceId: Scalars['Long'];
  input: PriceListRatioRowUpdateInput;
}>;


export type UpdateRatioToWorkOrderChangeFromPriceListMutation = { __typename?: 'Mutation', uerUpdateRatioToWorkOrderChangeFromPriceList: { __typename?: 'ServiceIdResultOfInt64', id?: any | null, result: boolean, message?: string | null, buttonText?: string | null, hideValidation?: boolean | null, hasValidation: boolean, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerSetWorkOrderChangeWorkRatioMutationVariables = Exact<{
  ratio?: InputMaybe<Scalars['Decimal']>;
  workOrderChangePriceId?: InputMaybe<Scalars['Long']>;
  workOrderPriceId?: InputMaybe<Scalars['Long']>;
}>;


export type UerSetWorkOrderChangeWorkRatioMutation = { __typename?: 'Mutation', uerSetWorkOrderChangeWorkRatio: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderChangeObjectSelectionListQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  where?: InputMaybe<WorkOrderChangeObjectSelectionItemFilterInput>;
}>;


export type UerWorkOrderChangeObjectSelectionListQuery = { __typename?: 'Query', uerWorkOrderChangeObjectSelectionList?: { __typename?: 'UerWorkOrderChangeObjectSelectionListCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderChangeObjectSelectionItem', codeWBS?: string | null, contractId: any, fromVOR: boolean, hasGuaranteedVolume?: boolean | null, id: any, isIncluded: boolean, name: string, parentId?: any | null, rationale?: string | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, workOrderChangeId?: any | null, workOrderChangeObjectId?: any | null, workOrderId?: any | null, workOrderObjectId?: any | null, hasActsKC2: boolean, hasOtherPrices: boolean, hasPrices: boolean, isInUse: boolean, isActKC2WorkOrderObject?: boolean | null, isAddedObject?: boolean | null, isRemovedObject?: boolean | null, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderChangeObjectSelectionListIsIncludedQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  where?: InputMaybe<WorkOrderChangeObjectSelectionItemFilterInput>;
}>;


export type UerWorkOrderChangeObjectSelectionListIsIncludedQuery = { __typename?: 'Query', uerWorkOrderChangeObjectSelectionList?: { __typename?: 'UerWorkOrderChangeObjectSelectionListCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderChangeObjectSelectionItem', isIncluded: boolean, id: any, fromVOR: boolean, constructionType: { __typename?: 'ConstructionTypeData', id: number, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null } | null };

export type UerIncludeContractObjectToWorkOrderChangeMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
}>;


export type UerIncludeContractObjectToWorkOrderChangeMutation = { __typename?: 'Mutation', uerIncludeContractObjectToWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, data?: Array<any> | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerExcludeContractObjectFromWorkOrderChangeMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
}>;


export type UerExcludeContractObjectFromWorkOrderChangeMutation = { __typename?: 'Mutation', uerExcludeContractObjectFromWorkOrderChange: { __typename?: 'ServiceDataResultOfInt64__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, data?: Array<any> | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerCreateWorkOrderChangeObjectMutationVariables = Exact<{
  input: ContractObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerCreateWorkOrderChangeObjectMutation = { __typename?: 'Mutation', uerCreateWorkOrderChangeObject: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, id?: any | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerCreateWorkOrderChangeSubObjectMutationVariables = Exact<{
  input: ContractSubObjectCreateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerCreateWorkOrderChangeSubObjectMutation = { __typename?: 'Mutation', uerCreateWorkOrderChangeSubObject: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, id?: any | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerUpdateWorkOrderChangeObjectMutationVariables = Exact<{
  input: ContractObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerUpdateWorkOrderChangeObjectMutation = { __typename?: 'Mutation', uerUpdateWorkOrderChangeObject: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, id?: any | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerUpdateWorkOrderChangeSubObjectMutationVariables = Exact<{
  input: ContractObjectUpdateInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerUpdateWorkOrderChangeSubObjectMutation = { __typename?: 'Mutation', uerUpdateWorkOrderChangeSubObject: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, id?: any | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerRemoveWorkOrderChangeObjectItemMutationVariables = Exact<{
  contractObjectId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
}>;


export type UerRemoveWorkOrderChangeObjectItemMutation = { __typename?: 'Mutation', uerRemoveWorkOrderChangeObjectItem: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerAddWorkOrderChangeFromXmlMutationVariables = Exact<{
  constructionTypeId: Scalars['Int'];
  contractSeasonId: Scalars['Long'];
  filesContent: Array<FileInput> | FileInput;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerAddWorkOrderChangeFromXmlMutation = { __typename?: 'Mutation', uerAddWorkOrderChangeFromXml: { __typename?: 'ServiceDataResultOfWorkOrderChangeData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'WorkOrderChangeData', id: any } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerSetWorkOrderChangeLastSeasonMutationVariables = Exact<{
  contractSeasonId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
}>;


export type UerSetWorkOrderChangeLastSeasonMutation = { __typename?: 'Mutation', uerSetWorkOrderChangeLastSeason: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerApplyMtrToWorkOrderChangeFromPriceListMutationVariables = Exact<{
  mtrRowId: Scalars['Long'];
  workOrderChangePriceId: Scalars['Long'];
}>;


export type UerApplyMtrToWorkOrderChangeFromPriceListMutation = { __typename?: 'Mutation', uerApplyMtrToWorkOrderChangeFromPriceList: { __typename?: 'ServiceIdResultOfInt64', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderChangeDraftInfoQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeDraftInfoQuery = { __typename?: 'Query', uerWorkOrderChangeDraftInfo: { __typename?: 'ServiceDataResultOfWorkOrderChangeDraftInfo', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'WorkOrderChangeDraftInfo', draftCount: number } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderChangeLastSeasonSelectionListQueryVariables = Exact<{
  where?: InputMaybe<ContractSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeLastSeasonSelectionListQuery = { __typename?: 'Query', uerWorkOrderChangeLastSeasonSelectionList: Array<{ __typename?: 'ContractSeasonData', id: any, year: any }> };

export type UerWorkOrderChangeAllowedSeasonsQueryVariables = Exact<{
  where?: InputMaybe<ContractSeasonDataFilterInput>;
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeAllowedSeasonsQuery = { __typename?: 'Query', uerWorkOrderChangeAllowedSeasons: Array<{ __typename?: 'ContractSeasonData', id: any, year: any }> };

export type UerWorkOrderChangeTotalsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
}>;


export type UerWorkOrderChangeTotalsQuery = { __typename?: 'Query', uerWorkOrderChangeTotals: { __typename?: 'ServiceDataResultOfWorkOrderChangeTotalData__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: Array<{ __typename?: 'WorkOrderChangeTotalData', isHeadLine: boolean, name: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonTotals: Array<{ __typename?: 'WorkOrderChangeSeasonTotalData', completedCost?: any | null, planCost?: any | null, seasonId: any }> } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderChangeObjectTotalsQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  workOrderChangeObjectId?: InputMaybe<Scalars['Long']>;
  workOrderObjectId?: InputMaybe<Scalars['Long']>;
}>;


export type UerWorkOrderChangeObjectTotalsQuery = { __typename?: 'Query', uerWorkOrderChangeObjectTotals: { __typename?: 'ServiceDataResultOfWorkOrderChangeTotalData__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: Array<{ __typename?: 'WorkOrderChangeTotalData', isHeadLine: boolean, name: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonTotals: Array<{ __typename?: 'WorkOrderChangeSeasonTotalData', completedCost?: any | null, planCost?: any | null, seasonId: any }> } | null> | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerClosingWorkOrderChangeDefaultsQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerClosingWorkOrderChangeDefaultsQuery = { __typename?: 'Query', uerClosingWorkOrderChangeDefaults: { __typename?: 'ServiceDataResultOfWorkOrderChangeData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'WorkOrderChangeData', authoredBy: string, contractId: any, contractSubjectText?: string | null, createdAt: any, draftCount: number, id: any, isClosing: boolean, status: WorkOrderChangeStatusEnum, updatedAt?: any | null, workOrderId: any, workOrderNumberText?: string | null, workOrderSigningDate?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerCreateClosingWorkOrderChangeMutationVariables = Exact<{
  input: WorkOrderChangeClosingInput;
}>;


export type UerCreateClosingWorkOrderChangeMutation = { __typename?: 'Mutation', uerCreateClosingWorkOrderChange: { __typename?: 'ServiceDataResultOfWorkOrderChangeData', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'WorkOrderChangeData', authoredBy: string, contractId: any, contractSubjectText?: string | null, createdAt: any, description?: string | null, draftCount: number, id: any, internalNumber?: string | null, isClosing: boolean, signingDate?: any | null, status: WorkOrderChangeStatusEnum, statusFollowers: Array<WorkOrderChangeStatusEnum>, updatedAt?: any | null, workOrderId: any, workOrderNumberText?: string | null, workOrderSigningDate?: any | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderChangeWorkRatioInfoQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
}>;


export type UerWorkOrderChangeWorkRatioInfoQuery = { __typename?: 'Query', uerWorkOrderChangeWorkRatioInfo: { __typename?: 'ServiceDataResultOfPriceItemWorkRatioInfo', result: boolean, message?: string | null, data?: { __typename?: 'PriceItemWorkRatioInfo', hasEmptyWorkRatios: boolean } | null } };

export type UerWorkOrderChangePriceItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderChangePriceItemFilterInput>;
}>;


export type UerWorkOrderChangePriceItemsQuery = { __typename?: 'Query', uerWorkOrderChangePriceItems?: { __typename?: 'UerWorkOrderChangePriceItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderChangePriceItem', calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, clientId: string, code?: string | null, constructionTypeId: number, entityTypeId?: number | null, entityTypeName?: string | null, entityTypeUniqueId?: string | null, entryId?: any | null, hasAcceptedCost?: boolean | null, hasDuplicates?: boolean | null, hasEmptySeasonVolume?: boolean | null, hasLimitSpan?: boolean | null, isActKC2Price?: boolean | null, isAddedPrice?: boolean | null, isBlockedPrice?: boolean | null, isExcludedPrice?: boolean | null, isOtherGroup: boolean, isOtherItem: boolean, isRootObject: boolean, isSMRItem: boolean, itemId: any, name?: string | null, objectName?: string | null, rationale?: string | null, rootObjectName: string, sortOtherPart?: number | null, sortPart?: number | null, sortSMRPart?: number | null, status?: WorkOrderPriceStatusEnum | null, statusTip?: string | null, totalCompletedCost?: any | null, totalCompletedVolume?: any | null, totalPlanCost?: any | null, totalPlanVolume?: any | null, totalRemainderCost?: any | null, totalRemainderVolume?: any | null, type?: WorkOrderPriceTypeEnum | null, uerCode?: string | null, uerCodeId?: any | null, uerId?: any | null, unit?: string | null, unitCost?: any | null, workCode?: string | null, workCompleted?: any | null, workInSum?: WorkInSumEnum | null, workKindWorkRatio?: any | null, workName?: string | null, workOrderChangeObjectId?: any | null, workOrderChangePriceId?: any | null, workOrderChangeRootObjectId?: any | null, workOrderObjectId?: any | null, workOrderRootObjectId?: any | null, workOrderPriceId?: any | null, workPlan?: any | null, workRatio?: any | null, workReminder?: any | null, workUnit?: string | null, seasonValues?: Array<{ __typename?: 'WorkOrderChangePriceSeasonValue', workOrderPriceId?: any | null, workOrderChangePriceId?: any | null, workOrderSeasonId?: any | null, workOrderChangeSeasonId?: any | null, itemTip: number, seasonYear: number, planVolume?: any | null, planTerms?: Array<any> | null, planCost?: any | null, completedVolume?: any | null, completedCost?: any | null, remainderVolume?: any | null, remainderCost?: any | null, hasErrors?: boolean | null, errors?: Array<string> | null }> | null }> | null } | null };

export type UerWorkOrderChangePriceItemChapterFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
}>;


export type UerWorkOrderChangePriceItemChapterFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemChapterFilter?: { __typename?: 'UerWorkOrderChangePriceItemChapterFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null } | null };

export type UerWorkOrderChangePriceItemStatusFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
}>;


export type UerWorkOrderChangePriceItemStatusFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemStatusFilter?: { __typename?: 'UerWorkOrderChangePriceItemStatusFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkOrderPriceStatusEnum', value?: WorkOrderPriceStatusEnum | null }> | null } | null };

export type UerWorkOrderChangePriceItemCodeFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>;
}>;


export type UerWorkOrderChangePriceItemCodeFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemCodeFilter?: { __typename?: 'UerWorkOrderChangePriceItemCodeFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfWorkOrderPriceItemCodeFilterData', value?: { __typename?: 'WorkOrderPriceItemCodeFilterData', uerCodeId?: any | null, uerCode: string, code: string, sortSMRPart: number, isUer: boolean, isRatio: boolean, isMtr: boolean } | null }> | null } | null };

export type UerWorkOrderChangePriceItemNameFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderChangePriceItemNameFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemNameFilter?: { __typename?: 'UerWorkOrderChangePriceItemNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderChangePriceItemUnitFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderChangePriceItemUnitFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemUnitFilter?: { __typename?: 'UerWorkOrderChangePriceItemUnitFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderChangePriceItemWorkInSumFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfNullableOfWorkInSumEnumFilterInput>;
}>;


export type UerWorkOrderChangePriceItemWorkInSumFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemWorkInSumFilter?: { __typename?: 'UerWorkOrderChangePriceItemWorkInSumFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkInSumEnum', value?: WorkInSumEnum | null }> | null } | null };

export type UerWorkOrderChangePriceItemWorkNameFilterQueryVariables = Exact<{
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  inputRootObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  inputObject?: InputMaybe<WorkOrderChangeObjectIdInput>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderChangePriceItemWorkNameFilterQuery = { __typename?: 'Query', uerWorkOrderChangePriceItemWorkNameFilter?: { __typename?: 'UerWorkOrderChangePriceItemWorkNameFilterCollectionSegment', items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderPriceListRatioForRootObjectQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectId: Scalars['Long'];
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput> | WorkOrderPriceRatioRowDataSortInput>;
}>;


export type UerWorkOrderPriceListRatioForRootObjectQuery = { __typename?: 'Query', uerWorkOrderPriceListRatioForRootObject?: { __typename?: 'UerWorkOrderPriceListRatioForRootObjectCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderPriceRatioRowData', code: string, groupId: any, groupName: string, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder: boolean, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioType: RatioTypeEnum, status?: string | null, workConditions: string }> | null } | null };

export type UerWorkOrderPriceListRatioForObjectsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput> | WorkOrderPriceRatioRowDataSortInput>;
}>;


export type UerWorkOrderPriceListRatioForObjectsQuery = { __typename?: 'Query', uerWorkOrderPriceListRatioForObjects?: { __typename?: 'UerWorkOrderPriceListRatioForObjectsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderPriceRatioRowData', code: string, groupId: any, groupName: string, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder: boolean, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioType: RatioTypeEnum, status?: string | null, workConditions: string }> | null } | null };

export type UerWorkOrderChangePriceListRatioForRootObjectQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectIds: WorkOrderChangeObjectIdInput;
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput> | WorkOrderPriceRatioRowDataSortInput>;
}>;


export type UerWorkOrderChangePriceListRatioForRootObjectQuery = { __typename?: 'Query', uerWorkOrderChangePriceListRatioForRootObject?: { __typename?: 'UerWorkOrderChangePriceListRatioForRootObjectCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderPriceRatioRowData', code: string, groupId: any, groupName: string, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder: boolean, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioStatus?: RatioRecordStatusEnum | null, ratioType: RatioTypeEnum, status?: string | null, workConditions: string }> | null } | null };

export type UerWorkOrderChangePriceListRatioForObjectsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  where?: InputMaybe<WorkOrderPriceRatioRowDataFilterInput>;
  order?: InputMaybe<Array<WorkOrderPriceRatioRowDataSortInput> | WorkOrderPriceRatioRowDataSortInput>;
}>;


export type UerWorkOrderChangePriceListRatioForObjectsQuery = { __typename?: 'Query', uerWorkOrderChangePriceListRatioForObjects?: { __typename?: 'UerWorkOrderChangePriceListRatioForObjectsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'WorkOrderPriceRatioRowData', code: string, groupId: any, groupName: string, id: any, isIncludedInAct: boolean, isIncludedInWorkOrder: boolean, kem: any, kmat?: any | null, knr: any, kozp: any, ksp: any, ktz: any, ktzzpm: any, ratioStatus?: RatioRecordStatusEnum | null, ratioType: RatioTypeEnum, status?: string | null, workConditions: string }> | null } | null };

export type UerRatioUerRowItemsForWorkOrderObjectsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioRowId: Scalars['Long'];
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  where?: InputMaybe<RatioUerRowItemFilterInput>;
  order?: InputMaybe<Array<RatioUerRowItemSortInput> | RatioUerRowItemSortInput>;
}>;


export type UerRatioUerRowItemsForWorkOrderObjectsQuery = { __typename?: 'Query', uerRatioUerRowItemsForWorkOrderObjects?: { __typename?: 'UerRatioUerRowItemsForWorkOrderObjectsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'RatioUerRowItem', appliesToCode: string, appliesToCodeName: string, appliesToId: any, appliesToLinkStatus: string, id: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerRatioUerRowItemsForWorkOrderRootObjectQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioRowId: Scalars['Long'];
  rootObjectId: Scalars['Long'];
  where?: InputMaybe<RatioUerRowItemFilterInput>;
  order?: InputMaybe<Array<RatioUerRowItemSortInput> | RatioUerRowItemSortInput>;
}>;


export type UerRatioUerRowItemsForWorkOrderRootObjectQuery = { __typename?: 'Query', uerRatioUerRowItemsForWorkOrderRootObject?: { __typename?: 'UerRatioUerRowItemsForWorkOrderRootObjectCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'RatioUerRowItem', appliesToCode: string, appliesToCodeName: string, appliesToId: any, appliesToLinkStatus: string, id: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerApplyRatioToWorkOrderObjectsMutationVariables = Exact<{
  workOrderObjectIds: Array<Scalars['Long']> | Scalars['Long'];
  priceListRatioIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerApplyRatioToWorkOrderObjectsMutation = { __typename?: 'Mutation', uerApplyRatioToWorkOrderObjects: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerApplyWorkOrderPriceRatiosToRootObjectMutationVariables = Exact<{
  workOrderObjectId: Scalars['Long'];
  priceListRatioIds: Array<Scalars['Long']> | Scalars['Long'];
}>;


export type UerApplyWorkOrderPriceRatiosToRootObjectMutation = { __typename?: 'Mutation', uerApplyWorkOrderPriceRatiosToRootObject: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerRatioUerRowItemListForWorkOrderRootObjectQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderChangeId: Scalars['Long'];
  ratioRowId: Scalars['Long'];
  rootObjectIds: WorkOrderChangeObjectIdInput;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<PriceListRatioUerRowForWorkOrderChangeFilterInput>;
  order?: InputMaybe<Array<PriceListRatioUerRowForWorkOrderChangeSortInput> | PriceListRatioUerRowForWorkOrderChangeSortInput>;
}>;


export type UerRatioUerRowItemListForWorkOrderRootObjectQuery = { __typename?: 'Query', uerRatioUerRowItemListForWorkOrderRootObject?: { __typename?: 'UerRatioUerRowItemListForWorkOrderRootObjectCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListRatioUerRowForWorkOrderChange', appliesToCode: string, appliesToCodeName: string, appliesToId: any, appliesToLinkStatus: WorkOrderPriceStatusEnum, id: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerRatioUerRowItemListForWorkOrderObjectsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  ratioRowId: Scalars['Long'];
  workOrderChangeId: Scalars['Long'];
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<PriceListRatioUerRowForWorkOrderChangeFilterInput>;
  order?: InputMaybe<Array<PriceListRatioUerRowForWorkOrderChangeSortInput> | PriceListRatioUerRowForWorkOrderChangeSortInput>;
}>;


export type UerRatioUerRowItemListForWorkOrderObjectsQuery = { __typename?: 'Query', uerRatioUerRowItemListForWorkOrderObjects?: { __typename?: 'UerRatioUerRowItemListForWorkOrderObjectsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PriceListRatioUerRowForWorkOrderChange', appliesToCode: string, appliesToCodeName: string, appliesToId: any, appliesToLinkStatus: WorkOrderPriceStatusEnum, id: any }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerApplyWorkOrderChangePriceRatiosToObjectsMutationVariables = Exact<{
  objectIds: Array<WorkOrderChangeObjectIdInput> | WorkOrderChangeObjectIdInput;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  priceListRatioIds: Array<PriceListRatioRowInput> | PriceListRatioRowInput;
}>;


export type UerApplyWorkOrderChangePriceRatiosToObjectsMutation = { __typename?: 'Mutation', uerApplyWorkOrderChangePriceRatiosToObjects: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerApplyWorkOrderChangePriceRatiosToRootObjectMutationVariables = Exact<{
  rootObjectIds: WorkOrderChangeObjectIdInput;
  workOrderChangeId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  priceListRatioIds: Array<PriceListRatioRowInput> | PriceListRatioRowInput;
}>;


export type UerApplyWorkOrderChangePriceRatiosToRootObjectMutation = { __typename?: 'Mutation', uerApplyWorkOrderChangePriceRatiosToRootObject: { __typename?: 'ServiceResult', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null } };

export type UerWorkOrderVersionOtherPriceListQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WorkOrderVersionOtherPriceDataFilterInput>;
}>;


export type UerWorkOrderVersionOtherPriceListQuery = { __typename?: 'Query', uerWorkOrderVersionOtherPriceList?: { __typename?: 'UerWorkOrderVersionOtherPriceListCollectionSegment', items?: Array<{ __typename?: 'WorkOrderVersionOtherPriceData', id: any, calculatingType?: OtherCostCalculationTypeEnum | null, chapter?: ChapterEnum | null, contractOtherId: any, hasEmptyActVersionAcceptedCost?: boolean | null, hasEmptyActVersionPlanCost?: boolean | null, hasEmptySeasonCost?: boolean | null, isActKC2VersionPrice: boolean, isExcludedPrice?: boolean | null, name: string, section?: SectionEnum | null, status?: ContractOtherStatusEnum | null, totalCompletedCost?: any | null, totalPlanCost?: any | null, totalRemainderCost?: any | null, actKC2VersionPrices?: Array<{ __typename?: 'WorkOrderVersionOtherActKC2VersionPriceData', actKC2VersionStatus: ActKc2StatusEnum, actKC2VersionSeasonId: any, actKC2VersionId: any, acceptedCost?: any | null, planCost?: any | null, acceptedCostDeviation?: DeviationEnum | null, planCostDeviation?: DeviationEnum | null }> | null, seasonPrices?: Array<{ __typename?: 'WorkOrderVersionOtherSeasonPriceData', planCost?: any | null, seasonId: any, remainderCost?: any | null, completedCost?: any | null }> | null }> | null } | null };

export type UerWorkOrderVersionPriceListQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
  workOrderObjectId: Scalars['Long'];
  chapter: ChapterEnum;
  where?: InputMaybe<WorkOrderVersionPriceDataFilterInput>;
}>;


export type UerWorkOrderVersionPriceListQuery = { __typename?: 'Query', uerWorkOrderVersionPriceList?: { __typename?: 'UerWorkOrderVersionPriceListCollectionSegment', items?: Array<{ __typename?: 'WorkOrderVersionPriceData', id: any, parentId?: any | null, type: WorkOrderPriceTypeEnum, status: WorkOrderPriceStatusEnum, uerCodeId: any, uerId: any, uerCode: string, priceListId: any, code: string, name: string, unit: string, unitCost: any, totalPlanVolume?: any | null, totalPlanCost?: any | null, totalCompletedVolume?: any | null, totalCompletedCost?: any | null, totalRemainderVolume?: any | null, totalRemainderCost?: any | null, isActKC2VersionPrice: boolean, hasEmptySeasonVolume?: boolean | null, hasEmptyActVersionPlanVolume?: boolean | null, hasEmptyActVersionAcceptedVolume?: boolean | null, workCode?: string | null, workCompleted?: any | null, workInSum: WorkInSumEnum, workName?: string | null, workPlan?: any | null, workRatio?: any | null, workReminder?: any | null, workUnit?: string | null, seasonPrices?: Array<{ __typename?: 'WorkOrderVersionSeasonPriceData', id?: any | null, completedCost?: any | null, completedVolume?: any | null, planCost?: any | null, planVolume?: any | null, remainderCost?: any | null, remainderVolume?: any | null, planVolumeTerms?: Array<any> | null, seasonId: any }> | null, actKC2VersionPrices?: Array<{ __typename?: 'WorkOrderVersionActKC2VersionPriceData', id?: any | null, planVolume?: any | null, planCost?: any | null, acceptedCost?: any | null, acceptedVolume?: any | null, acceptedVolumeDeviation?: DeviationEnum | null, actKC2VersionId: any, actKC2VersionSeasonId: any, actKC2VersionStatus: ActKc2StatusEnum, planVolumeDeviation?: DeviationEnum | null }> | null }> | null } | null };

export type UerWorkOrderVersionActsKc2VersionQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId?: InputMaybe<Scalars['Long']>;
  order?: InputMaybe<Array<WorkOrderVersionActKc2VersionDataSortInput> | WorkOrderVersionActKc2VersionDataSortInput>;
  where?: InputMaybe<WorkOrderVersionActKc2VersionDataFilterInput>;
}>;


export type UerWorkOrderVersionActsKc2VersionQuery = { __typename?: 'Query', uerWorkOrderVersionActsKC2Version: Array<{ __typename?: 'WorkOrderVersionActKC2VersionData', date?: any | null, id: any, number?: any | null, fullNumber?: string | null, isInactive?: boolean | null, isCorrection?: boolean | null, correctionDate?: any | null, correctionNumber?: any | null, seasonId: any, status: ActKc2StatusEnum }> };

export type UerWorkOrderVersionQueryVariables = Exact<{
  workOrderId: Scalars['Long'];
}>;


export type UerWorkOrderVersionQuery = { __typename?: 'Query', uerWorkOrderVersion: { __typename?: 'ServiceDataResultOfWorkOrderVersionData', buttonText?: string | null, hasValidation: boolean, hideValidation?: boolean | null, data?: { __typename?: 'WorkOrderVersionData', id: any, name?: string | null, internalNumber?: string | null, subject?: string | null, status: WorkOrderStatusEnum, contractor?: string | null, contractorAddress?: string | null, signingDate?: any | null, amountWithTax: any, amountWithoutTax: any, remainder: any, tax: any, startDate?: any | null, finishDate?: any | null, vorType: WorkOrderVorTypeEnum, inflationData: Array<{ __typename?: 'ContractSeasonInflationData', id: any, year: any, inflationRate: any }>, workOrderChange?: { __typename?: 'WorkOrderChangeItem', id: any, internalNumber?: string | null, signingDate?: any | null } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null } };

export type UerWorkOrderVersionObjectsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  where?: InputMaybe<WorkOrderVersionObjectDataFilterInput>;
}>;


export type UerWorkOrderVersionObjectsQuery = { __typename?: 'Query', uerWorkOrderVersionObjects?: { __typename?: 'UerWorkOrderVersionObjectsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderVersionObjectData', codeWBS?: string | null, code?: string | null, hasPrices: boolean, hasPricesOther: boolean, id: any, name: string, parentId?: any | null, rootObjectId?: any | null, status: ContractObjectStatusEnum, workOrderVersionId: any, constructionType: { __typename?: 'ConstructionTypeData', code: string, id: number, name: string, shortName: string, catalogId: any, fullName: string, contractFileName: string, createdAt: any } }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderVersionSeasonsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
}>;


export type UerWorkOrderVersionSeasonsQuery = { __typename?: 'Query', uerWorkOrderVersionSeasons: Array<{ __typename?: 'WorkOrderVersionSeasonData', id: any, year: any }> };

export type UerWorkOrderVersionObjectResultsQueryVariables = Exact<{
  chapter?: InputMaybe<ChapterEnum>;
  section?: InputMaybe<SectionEnum>;
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
  order?: InputMaybe<Array<WorkOrderVersionObjectResultDataSortInput> | WorkOrderVersionObjectResultDataSortInput>;
  where?: InputMaybe<WorkOrderVersionObjectResultDataFilterInput>;
}>;


export type UerWorkOrderVersionObjectResultsQuery = { __typename?: 'Query', uerWorkOrderVersionObjectResults: Array<{ __typename?: 'WorkOrderVersionObjectResultData', actKC2VersionId?: any | null, chapter?: ChapterEnum | null, constructionTypeId: number, objectId: any, section?: SectionEnum | null, sortOrder: any, title: string, costResults: Array<{ __typename?: 'WorkOrderVersionCostResultData', name: string, value: any, year: any }> }> };

export type UerWorkOrderVersionResultsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  order?: InputMaybe<Array<WorkOrderVersionResultDataSortInput> | WorkOrderVersionResultDataSortInput>;
  where?: InputMaybe<WorkOrderVersionResultDataFilterInput>;
}>;


export type UerWorkOrderVersionResultsQuery = { __typename?: 'Query', uerWorkOrderVersionResults: Array<{ __typename?: 'WorkOrderVersionResultData', chapter?: ChapterEnum | null, resultSectionId: any, section?: SectionEnum | null, sortOrder: any, title: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, actKC2VersionResults: Array<{ __typename?: 'WorkOrderVersionActKC2VersionResultData', actKC2VersionId: any, value: any }>, seasonResults: Array<{ __typename?: 'WorkOrderVersionSeasonResultData', seasonId: any, value: any }> }> };

export type UerWorkOrderVersionPriceItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  where?: InputMaybe<WorkOrderVersionPriceItemFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemsQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItems?: { __typename?: 'UerWorkOrderVersionPriceItemsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WorkOrderVersionPriceItem', calculatingType?: OtherCostCalculationTypeEnum | null, calculatingTypeValue?: any | null, chapter?: ChapterEnum | null, clientId: string, code?: string | null, constructionTypeId: number, entityTypeId?: number | null, entityTypeName?: string | null, entityTypeUniqueId?: string | null, entryId?: any | null, hasDuplicates?: boolean | null, hasEmptySeasonVolume?: boolean | null, hasLimitSpan?: boolean | null, isActKC2Price?: boolean | null, isCreatedFromSKzS?: boolean | null, isExcludedPrice?: boolean | null, isOtherGroup: boolean, isOtherItem: boolean, isRootObject: boolean, isSMRItem: boolean, itemId: any, name?: string | null, objectId?: any | null, objectName?: string | null, rationale?: string | null, rootObjectId: any, rootObjectName: string, sortOtherPart?: number | null, sortPart?: number | null, sortSMRPart?: number | null, status?: WorkOrderPriceStatusEnum | null, statusTip?: string | null, totalCompletedCost?: any | null, totalCompletedVolume?: any | null, totalPlanCost?: any | null, totalPlanVolume?: any | null, totalRemainderCost?: any | null, totalRemainderVolume?: any | null, type?: WorkOrderPriceTypeEnum | null, uerCode?: string | null, uerCodeId?: any | null, uerId?: any | null, unit?: string | null, unitCost?: any | null, workCode?: string | null, workCompleted?: any | null, workInSum?: WorkInSumEnum | null, workKindWorkRatio?: any | null, workName?: string | null, workPlan?: any | null, workRatio?: any | null, workReminder?: any | null, workUnit?: string | null, seasonValues?: Array<{ __typename?: 'WorkOrderVersionPriceSeasonValue', completedCost?: any | null, completedVolume?: any | null, errors?: Array<string> | null, hasErrors?: boolean | null, itemTip: number, planCost?: any | null, planTerms?: Array<any> | null, planVolume?: any | null, priceId: any, remainderCost?: any | null, remainderVolume?: any | null, seasonId: any, seasonYear: number, actValues: Array<{ __typename?: 'WorkOrderVersionPriceActValue', actCostAccepted?: any | null, actCostAcceptedDeviation?: DeviationEnum | null, actCostGroup: CostGroupEnum, actCostPlan?: any | null, actCostPlanDeviation?: DeviationEnum | null, actHasEditableCost?: boolean | null, actId: any, actInflationSeasonId?: any | null, actStatus: ActKc2StatusEnum, actStatusSKzS?: SkzsActKc2StatusEnum | null, actVolumeAccepted?: any | null, actVolumeAcceptedDeviation?: DeviationEnum | null, actVolumeIsReadOnly?: boolean | null, actVolumePlan?: any | null, actVolumePlanDeviation?: DeviationEnum | null, actVolumePlanSKzS?: any | null, comment?: string | null, isActKC2DistributionOfMtrInflation?: boolean | null, isCorrection?: boolean | null, isInactive?: boolean | null, isSKzS?: boolean | null }> }> | null }> | null } | null };

export type UerWorkOrderVersionTotalsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
}>;


export type UerWorkOrderVersionTotalsQuery = { __typename?: 'Query', uerWorkOrderVersionTotals: { __typename?: 'ServiceDataResultOfWorkOrderVersionTotalData__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: Array<{ __typename?: 'WorkOrderVersionTotalData', isHeadLine: boolean, name: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonTotals: Array<{ __typename?: 'WorkOrderVersionSeasonTotalData', completedCost?: any | null, planCost?: any | null, seasonId: any }> } | null> | null } };

export type UerWorkOrderVersionObjectTotalsQueryVariables = Exact<{
  workOrderVersionId: Scalars['Long'];
  workOrderVersionObjectId: Scalars['Long'];
}>;


export type UerWorkOrderVersionObjectTotalsQuery = { __typename?: 'Query', uerWorkOrderVersionObjectTotals: { __typename?: 'ServiceDataResultOfWorkOrderVersionTotalData__', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: Array<{ __typename?: 'WorkOrderVersionTotalData', isHeadLine: boolean, name: string, totalCompletedCost: any, totalPlanCost: any, totalRemainderCost: any, seasonTotals: Array<{ __typename?: 'WorkOrderVersionSeasonTotalData', completedCost?: any | null, planCost?: any | null, seasonId: any }> } | null> | null } };

export type UerWorkOrderVersionPriceItemChapterFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfNullableOfChapterEnumFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemChapterFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemChapterFilter?: { __typename?: 'UerWorkOrderVersionPriceItemChapterFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfChapterEnum', value?: ChapterEnum | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderVersionPriceItemStatusFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemStatusFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemStatusFilter?: { __typename?: 'UerWorkOrderVersionPriceItemStatusFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkOrderPriceStatusEnum', value?: WorkOrderPriceStatusEnum | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderVersionPriceItemCodeFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemCodeFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemCodeFilter?: { __typename?: 'UerWorkOrderVersionPriceItemCodeFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfWorkOrderPriceItemCodeFilterData', value?: { __typename?: 'WorkOrderPriceItemCodeFilterData', code: string, isMtr: boolean, isRatio: boolean, isUer: boolean, sortSMRPart: number, uerCode: string, uerCodeId?: any | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderVersionPriceItemNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemNameFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemNameFilter?: { __typename?: 'UerWorkOrderVersionPriceItemNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderVersionPriceItemUnitFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemUnitFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemUnitFilter?: { __typename?: 'UerWorkOrderVersionPriceItemUnitFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UerWorkOrderVersionPriceItemWorkNameFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfStringFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemWorkNameFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemWorkNameFilter?: { __typename?: 'UerWorkOrderVersionPriceItemWorkNameFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfString', value?: string | null }> | null } | null };

export type UerWorkOrderVersionPriceItemWorkInSumFilterQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workOrderVersionId: Scalars['Long'];
  constructionTypeId: Scalars['Int'];
  rootObjectId?: InputMaybe<Scalars['Long']>;
  objectId?: InputMaybe<Scalars['Long']>;
  where?: InputMaybe<FilterValueOfNullableOfWorkInSumEnumFilterInput>;
}>;


export type UerWorkOrderVersionPriceItemWorkInSumFilterQuery = { __typename?: 'Query', uerWorkOrderVersionPriceItemWorkInSumFilter?: { __typename?: 'UerWorkOrderVersionPriceItemWorkInSumFilterCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'FilterValueOfNullableOfWorkInSumEnum', value?: WorkInSumEnum | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UercExtractTotalSumQueryVariables = Exact<{
  input: FileInput;
}>;


export type UercExtractTotalSumQuery = { __typename?: 'Query', uercExtractTotalSum: { __typename?: 'ServiceDataResultOfCalculationOtherCostTotalSum', result: boolean, message?: string | null, hideValidation?: boolean | null, validation?: Array<{ __typename?: 'ValidationMessage', message: string }> | null, data?: { __typename?: 'CalculationOtherCostTotalSum', sum: any } | null } };

export type AppModulesReportQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  modules?: InputMaybe<Array<ModuleEnum> | ModuleEnum>;
  includeHealth?: InputMaybe<Scalars['Boolean']>;
  includeResources?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ServiceDataResultOfAppModuleReportFilterInput>;
  order?: InputMaybe<Array<ServiceDataResultOfAppModuleReportSortInput> | ServiceDataResultOfAppModuleReportSortInput>;
}>;


export type AppModulesReportQuery = { __typename?: 'Query', appModulesReport?: { __typename?: 'AppModulesReportCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ServiceDataResultOfAppModuleReport', actionRequired?: boolean | null, buttonText?: string | null, code?: string | null, hasValidation: boolean, hideValidation?: boolean | null, message?: string | null, result: boolean, data?: { __typename?: 'AppModuleReport', branch: string, buildDate?: any | null, commit: string, description: string, id: string, name: string, release: string, tag?: string | null, healthCheckData?: { __typename?: 'AppHealthCheckData', duration: string, status: HealthStatus, healthChecks?: Array<{ __typename?: 'AppHealthCheckInfo', description?: string | null, duration: string, error?: string | null, name: string, status: HealthStatus, validation?: Array<{ __typename?: 'ValidationMessage', message: string, metadata?: string | null, property?: string | null }> | null }> | null } | null } | null, validation?: Array<{ __typename?: 'ValidationMessage', property?: string | null, message: string }> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };


export const UerPriceListUerForTechPartRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForTechPartRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowBaseFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowBaseSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForTechPartRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"linkStatus"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForTechPartRatioQuery, UerPriceListUerForTechPartRatioQueryVariables>;
export const UerPriceListUerForDismantlingRatioUerCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DismantlingCoefficientTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"rationRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"preselectedUerBaseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForDismantlingRatioUerCodeFilterQuery, UerPriceListUerForDismantlingRatioUerCodeFilterQueryVariables>;
export const UerPriceListUerForDismantlingRatioUerNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DismantlingCoefficientTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"rationRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"preselectedUerBaseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForDismantlingRatioUerNameFilterQuery, UerPriceListUerForDismantlingRatioUerNameFilterQueryVariables>;
export const UerPriceListUerForDismantlingRatioUerGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DismantlingCoefficientTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"rationRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"preselectedUerBaseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForDismantlingRatioUerGroupFilterQuery, UerPriceListUerForDismantlingRatioUerGroupFilterQueryVariables>;
export const UerPriceListUerForDismantlingRatioUerUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DismantlingCoefficientTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatioUerUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"rationRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rationRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"preselectedUerBaseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preselectedUerBaseRowIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForDismantlingRatioUerUnitFilterQuery, UerPriceListUerForDismantlingRatioUerUnitFilterQueryVariables>;
export const UerRatioCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioRowDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupName"}}]}}]}}]}}]} as unknown as DocumentNode<UerRatioCollectionQuery, UerRatioCollectionQueryVariables>;
export const IsUniqueProjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueProjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueProjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<IsUniqueProjectNameQuery, IsUniqueProjectNameQueryVariables>;
export const DeleteProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const ProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"project"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"stageFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"contractUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationNavData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculation"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculationObjects"}},{"kind":"Field","name":{"kind":"Name","value":"hasWOR"}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationNavItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractNavData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasContract"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkOrders"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractNavItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNavs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Navs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC3Navs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"actsKC2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsidiary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculationPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceNMC"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"calculationUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contractInternalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contractStatus"}},{"kind":"Field","name":{"kind":"Name","value":"stageFollowers"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectQuery, ProjectQueryVariables>;
export const LogUserClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"logUserClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loginOp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuditLogClientOperationEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logUserClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loginOp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loginOp"}}},{"kind":"Argument","name":{"kind":"Name","value":"userName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<LogUserClientMutation, LogUserClientMutationVariables>;
export const CatalogConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"iconCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogConstructionTypesQuery, CatalogConstructionTypesQueryVariables>;
export const CatalogConstructionTypeItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogConstructionTypeItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogConstructionTypeItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"iconCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogConstructionTypeItemsQuery, CatalogConstructionTypeItemsQueryVariables>;
export const CatalogIsUniqueConstructionTypeFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogIsUniqueConstructionTypeFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogConstructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractFileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogIsUniqueConstructionTypeFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogConstructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogConstructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"fullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fullName"}}},{"kind":"Argument","name":{"kind":"Name","value":"shortName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortName"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractFileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractFileName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogIsUniqueConstructionTypeFieldsQuery, CatalogIsUniqueConstructionTypeFieldsQueryVariables>;
export const CatalogConstructionTypesUpdatedDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogConstructionTypesUpdatedDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogConstructionTypesUpdatedDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogConstructionTypesUpdatedDateQuery, CatalogConstructionTypesUpdatedDateQueryVariables>;
export const CatalogCreateConstructionTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogCreateConstructionType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogConstructionTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogCreateConstructionType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"iconCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogCreateConstructionTypeMutation, CatalogCreateConstructionTypeMutationVariables>;
export const CatalogUpdateConstructionTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogUpdateConstructionType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogConstructionTypeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUpdateConstructionType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"iconCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUpdateConstructionTypeMutation, CatalogUpdateConstructionTypeMutationVariables>;
export const CatalogRemoveConstructionTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogRemoveConstructionType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogConstructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRemoveConstructionType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogConstructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogConstructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CatalogRemoveConstructionTypeMutation, CatalogRemoveConstructionTypeMutationVariables>;
export const CatalogIsUniqueConstructionTypeCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogIsUniqueConstructionTypeCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogConstructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogIsUniqueConstructionTypeCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogConstructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogConstructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogIsUniqueConstructionTypeCodeQuery, CatalogIsUniqueConstructionTypeCodeQueryVariables>;
export const CatalogConstructionTypeIsUsedInProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogConstructionTypeIsUsedInProjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogConstructionTypeIsUsedInProjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogConstructionTypeIsUsedInProjectsQuery, CatalogConstructionTypeIsUsedInProjectsQueryVariables>;
export const CatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"canCreate"}},{"kind":"Field","name":{"kind":"Name","value":"methodologies"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogQuery, CatalogQueryVariables>;
export const CatalogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodologies"}},{"kind":"Field","name":{"kind":"Name","value":"allowMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"canCreate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogsQuery, CatalogsQueryVariables>;
export const CatalogsMethodologyFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogsMethodologyFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfProjectMethodologyEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfProjectMethodologyEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogsMethodologyFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CatalogsMethodologyFilterQuery, CatalogsMethodologyFilterQueryVariables>;
export const CatalogsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogsNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogsNameFilterQuery, CatalogsNameFilterQueryVariables>;
export const CatalogSubsidiaryFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogSubsidiaryFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogSubsidiaryFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogSubsidiaryFilterQuery, CatalogSubsidiaryFilterQueryVariables>;
export const CatalogRemoveWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogRemoveWorkTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogWorkTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRemoveWorkTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogWorkTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogWorkTypeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogRemoveWorkTypesMutation, CatalogRemoveWorkTypesMutationVariables>;
export const CatalogCreateWorkTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogCreateWorkType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogWorkTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogCreateWorkType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrice"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogCreateWorkTypeMutation, CatalogCreateWorkTypeMutationVariables>;
export const CatalogUpdateWorkTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogUpdateWorkType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogWorkTypeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUpdateWorkType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrice"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUpdateWorkTypeMutation, CatalogUpdateWorkTypeMutationVariables>;
export const CatalogWorkTypeCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogWorkTypeCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogWorkTypeCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogWorkTypeCodeFilterQuery, CatalogWorkTypeCodeFilterQueryVariables>;
export const CatalogWorkTypeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogWorkTypeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogWorkTypeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogWorkTypeNameFilterQuery, CatalogWorkTypeNameFilterQueryVariables>;
export const CatalogWorkTypeItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogWorkTypeItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogWorkTypeDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogWorkTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogWorkTypeItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrice"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogWorkTypeItemsQuery, CatalogWorkTypeItemsQueryVariables>;
export const CatalogWorkTypesUpdatedDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogWorkTypesUpdatedDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogWorkTypesUpdatedDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogWorkTypesUpdatedDateQuery, CatalogWorkTypesUpdatedDateQueryVariables>;
export const CatalogIsUniqueWorkTypeCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogIsUniqueWorkTypeCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogWorkTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogIsUniqueWorkTypeCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogWorkTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogWorkTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogIsUniqueWorkTypeCodeQuery, CatalogIsUniqueWorkTypeCodeQueryVariables>;
export const CatalogImportUerBaseCostWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogImportUerBaseCostWorkTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogImportUerBaseCostWorkTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogImportUerBaseCostWorkTypesMutation, CatalogImportUerBaseCostWorkTypesMutationVariables>;
export const CatalogUerBaseCostItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorkScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostItemsQuery, CatalogUerBaseCostItemsQueryVariables>;
export const CatalogUerBaseCostUpdateDateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostUpdateDateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateTimeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostUpdateDateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostUpdateDateFilterQuery, CatalogUerBaseCostUpdateDateFilterQueryVariables>;
export const CatalogUerBaseCostSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostSectionNameFilterQuery, CatalogUerBaseCostSectionNameFilterQueryVariables>;
export const CatalogUerBaseCostGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostGroupNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostGroupNameFilterQuery, CatalogUerBaseCostGroupNameFilterQueryVariables>;
export const CatalogUerBaseCostCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostCodeFilterQuery, CatalogUerBaseCostCodeFilterQueryVariables>;
export const CatalogUerBaseCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostNameFilterQuery, CatalogUerBaseCostNameFilterQueryVariables>;
export const CatalogUerBaseCostChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostChapterFilterQuery, CatalogUerBaseCostChapterFilterQueryVariables>;
export const CatalogUerBaseCostUerClassifierFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostUerClassifierFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerClassifierEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerClassifierEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostUerClassifierFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostUerClassifierFilterQuery, CatalogUerBaseCostUerClassifierFilterQueryVariables>;
export const CatalogUerBaseCostWorktypeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostWorktypeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorktypeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostWorktypeNameFilterQuery, CatalogUerBaseCostWorktypeNameFilterQueryVariables>;
export const CatalogUerBaseCostWorktypeFOsummFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostWorktypeFOsummFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkInSumEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkInSumEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorktypeFOsummFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostWorktypeFOsummFilterQuery, CatalogUerBaseCostWorktypeFOsummFilterQueryVariables>;
export const CatalogUpdateUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogUpdateUerBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"costData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCatalogUERBaseCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUpdateUerBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"costData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"costData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorkScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUpdateUerBaseCostMutation, CatalogUpdateUerBaseCostMutationVariables>;
export const CatalogRemoveUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogRemoveUerBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRemoveUerBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogRemoveUerBaseCostMutation, CatalogRemoveUerBaseCostMutationVariables>;
export const CatalogUerBaseCostEstimateBasisRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostEstimateBasisRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostEstimateBasisRowFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostEstimateBasisRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTotal"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isSectionHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parentRowId"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostEstimateBasisRowsQuery, CatalogUerBaseCostEstimateBasisRowsQueryVariables>;
export const CatalogUerBaseCostTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasIndent"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostTotalsQuery, CatalogUerBaseCostTotalsQueryVariables>;
export const CatalogUerBaseCostWorkScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostWorkScopes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostWorkScopeBaseDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorkScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostWorkScopesQuery, CatalogUerBaseCostWorkScopesQueryVariables>;
export const CatalogUerBaseCostEstimateBasisResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostEstimateBasisResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostEstimateBasisItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostEstimateBasisResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostEstimateBasisResourcesQuery, CatalogUerBaseCostEstimateBasisResourcesQueryVariables>;
export const CatalogUerBaseCostEstimateBasisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostEstimateBasis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostEstimateBasisItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostEstimateBasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostEstimateBasisQuery, CatalogUerBaseCostEstimateBasisQueryVariables>;
export const CatalogUerBaseCostHistoryItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostHistoryDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"uerBaseCostId"}},{"kind":"Field","name":{"kind":"Name","value":"uerBaseCostCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerBaseCostChangeType"}},{"kind":"Field","name":{"kind":"Name","value":"updateUerDate"}},{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupCodeCng"}},{"kind":"Field","name":{"kind":"Name","value":"groupFullName"}},{"kind":"Field","name":{"kind":"Name","value":"groupFullNameCng"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"codeCng"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCng"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameCng"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"ozpCng"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"emmCng"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"zpmCng"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"mtrCng"}},{"kind":"Field","name":{"kind":"Name","value":"fot"}},{"kind":"Field","name":{"kind":"Name","value":"fotCng"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"eqpCng"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"pirCng"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"trnCng"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"nrCng"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"spCng"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tzCng"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"tmCng"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"chapterCng"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifierCng"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkScopesHistory"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeCng"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"justificationCng"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostCng"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryItemsQuery, CatalogUerBaseCostHistoryItemsQueryVariables>;
export const UpdateCatalogUerBaseCostWorkScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogUERBaseCostWorkScopes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostWorkScopeUpdateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogUERBaseCostWorkScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogUerBaseCostWorkScopesMutation, UpdateCatalogUerBaseCostWorkScopesMutationVariables>;
export const CatalogUerBaseCostHistoryStatusCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryStatusCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryStatusCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCostsCount"}},{"kind":"Field","name":{"kind":"Name","value":"deletedCostsCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedCostsCount"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryStatusCountsQuery, CatalogUerBaseCostHistoryStatusCountsQueryVariables>;
export const ExportCatalogUerBaseCostHistoryAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportCatalogUERBaseCostHistoryAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportCatalogUERBaseCostHistoryAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ExportCatalogUerBaseCostHistoryAsExcelQuery, ExportCatalogUerBaseCostHistoryAsExcelQueryVariables>;
export const CatalogUpsertMultiUerBaseCostBasisesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogUpsertMultiUerBaseCostBasises"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUpsertMultiUerBaseCostBasisesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUpsertMultiUerBaseCostBasises"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"uerNacl"}},{"kind":"Field","name":{"kind":"Name","value":"uerPlan"}},{"kind":"Field","name":{"kind":"Name","value":"catFile"}},{"kind":"Field","name":{"kind":"Name","value":"workID"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUpsertMultiUerBaseCostBasisesMutation, CatalogUpsertMultiUerBaseCostBasisesMutationVariables>;
export const CatalogUpsertArchiveUerBaseCostBasisesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogUpsertArchiveUerBaseCostBasises"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUpsertArchiveUerBaseCostBasisesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUpsertArchiveUerBaseCostBasises"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"uerNacl"}},{"kind":"Field","name":{"kind":"Name","value":"uerPlan"}},{"kind":"Field","name":{"kind":"Name","value":"catFile"}},{"kind":"Field","name":{"kind":"Name","value":"workID"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUpsertArchiveUerBaseCostBasisesMutation, CatalogUpsertArchiveUerBaseCostBasisesMutationVariables>;
export const ExportCatalogUerAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"exportCatalogUERAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportCatalogUERAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]} as unknown as DocumentNode<ExportCatalogUerAsExcelQuery, ExportCatalogUerAsExcelQueryVariables>;
export const SetCatalogUerBaseCostPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setCatalogUERBaseCostProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostPropertiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCatalogUERBaseCostProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SetCatalogUerBaseCostPropertiesMutation, SetCatalogUerBaseCostPropertiesMutationVariables>;
export const CatalogUerBaseCostHistoryGroupFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryGroupFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCatalogUerBaseCostGroupFilterDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryGroupFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryGroupFullNameFilterQuery, CatalogUerBaseCostHistoryGroupFullNameFilterQueryVariables>;
export const CatalogUerBaseCostHistoryCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryCodeFilterQuery, CatalogUerBaseCostHistoryCodeFilterQueryVariables>;
export const CatalogUerBaseCostHistoryNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryNameFilterQuery, CatalogUerBaseCostHistoryNameFilterQueryVariables>;
export const CatalogUerBaseCostHistoryChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryChapterFilterQuery, CatalogUerBaseCostHistoryChapterFilterQueryVariables>;
export const CatalogUerBaseCostHistoryUerClassifierFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryUerClassifierFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerClassifierEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerClassifierEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryUerClassifierFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryUerClassifierFilterQuery, CatalogUerBaseCostHistoryUerClassifierFilterQueryVariables>;
export const CatalogUerBaseCostHistoryJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryJustificationFilterQuery, CatalogUerBaseCostHistoryJustificationFilterQueryVariables>;
export const CatalogUerBaseCostHistoryWorkScopeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryWorkScopeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerBaseCostChangeTypeSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryWorkScopeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryWorkScopeFilterQuery, CatalogUerBaseCostHistoryWorkScopeFilterQueryVariables>;
export const CatalogUerBaseCostHistoryWorkScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostHistoryWorkScopes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"historyRecordId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostHistoryWorkScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"historyRecordId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"historyRecordId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newScopesCount"}},{"kind":"Field","name":{"kind":"Name","value":"deletedScopesCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedScopesCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workScopeItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUerDate"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"workScopeNumberCng"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workScopeNameCng"}},{"kind":"Field","name":{"kind":"Name","value":"changeType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostHistoryWorkScopesQuery, CatalogUerBaseCostHistoryWorkScopesQueryVariables>;
export const CatalogUerOtherCostTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUEROtherCostTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUEROtherCostTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUerOtherCostTemplatesQuery, CatalogUerOtherCostTemplatesQueryVariables>;
export const CatalogUerOtherCostTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUEROtherCostTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUEROtherCostTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<CatalogUerOtherCostTemplateQuery, CatalogUerOtherCostTemplateQueryVariables>;
export const CatalogUerOtherCostTemplateNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUEROtherCostTemplateNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUEROtherCostTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerOtherCostTemplateNamesQuery, CatalogUerOtherCostTemplateNamesQueryVariables>;
export const RemoveCatalogUerOtherCostTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCatalogUEROtherCostTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCatalogUEROtherCostTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RemoveCatalogUerOtherCostTemplatesMutation, RemoveCatalogUerOtherCostTemplatesMutationVariables>;
export const UpdateCatalogUerOtherCostTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogUEROtherCostTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogUEROtherCostTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogUerOtherCostTemplateMutation, UpdateCatalogUerOtherCostTemplateMutationVariables>;
export const CreateCatalogUerOtherCostTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalogUEROtherCostTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogUEROtherCostTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<CreateCatalogUerOtherCostTemplateMutation, CreateCatalogUerOtherCostTemplateMutationVariables>;
export const CatalogIsUniqueNameOtherCostTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogIsUniqueNameOtherCostTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUEROtherCostTemplateDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUEROtherCostTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogIsUniqueNameOtherCostTemplateQuery, CatalogIsUniqueNameOtherCostTemplateQueryVariables>;
export const CatalogRatioSubGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioSubGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioSubGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioSubGroupsQuery, CatalogRatioSubGroupsQueryVariables>;
export const AddRatiosModalCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addRatiosModalCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AddRatiosModalCodeFilterQuery, AddRatiosModalCodeFilterQueryVariables>;
export const AddRatiosModalNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"addRatiosModalNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AddRatiosModalNameFilterQuery, AddRatiosModalNameFilterQueryVariables>;
export const IsUniqueLimitedCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueLimitedCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueLimitedCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<IsUniqueLimitedCostTypeQuery, IsUniqueLimitedCostTypeQueryVariables>;
export const LimitedCostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"limitedCostTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limitedCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}}]}}]} as unknown as DocumentNode<LimitedCostTypesQuery, LimitedCostTypesQueryVariables>;
export const CreateCatalogLimitedCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalogLimitedCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogLimitedCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCatalogLimitedCostTypeMutation, CreateCatalogLimitedCostTypeMutationVariables>;
export const UpdateCatalogLimitedCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogLimitedCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogLimitedCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogLimitedCostTypeMutation, UpdateCatalogLimitedCostTypeMutationVariables>;
export const RemoveLimitedCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeLimitedCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCatalogLimitedCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveLimitedCostTypeMutation, RemoveLimitedCostTypeMutationVariables>;
export const GlobalOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"globalOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GlobalOtherCostsQuery, GlobalOtherCostsQueryVariables>;
export const GlobalLimitedCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"globalLimitedCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalLimitedCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GlobalLimitedCostsQuery, GlobalLimitedCostsQueryVariables>;
export const GlobalOtherCostCandidateTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"globalOtherCostCandidateTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeGlobalOtherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalOtherCostCandidateTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeGlobalOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeGlobalOtherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]} as unknown as DocumentNode<GlobalOtherCostCandidateTypesQuery, GlobalOtherCostCandidateTypesQueryVariables>;
export const GlobalLimitedCostCandidateTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"globalLimitedCostCandidateTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeGlobalLimitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalLimitedCostCandidateTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeGlobalLimitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeGlobalLimitedCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]} as unknown as DocumentNode<GlobalLimitedCostCandidateTypesQuery, GlobalLimitedCostCandidateTypesQueryVariables>;
export const IsUniqueGlobalOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueGlobalOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculatingType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OtherCostCalculationTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueGlobalOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculatingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculatingType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<IsUniqueGlobalOtherCostQuery, IsUniqueGlobalOtherCostQueryVariables>;
export const IsUniqueGlobalLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueGlobalLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueGlobalLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<IsUniqueGlobalLimitedCostQuery, IsUniqueGlobalLimitedCostQueryVariables>;
export const CreateGlobalOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createGlobalOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGlobalOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGlobalOtherCostMutation, CreateGlobalOtherCostMutationVariables>;
export const UpdateGlobalOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGlobalOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGlobalOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGlobalOtherCostMutation, UpdateGlobalOtherCostMutationVariables>;
export const RemoveGlobalOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeGlobalOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGlobalOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RemoveGlobalOtherCostMutation, RemoveGlobalOtherCostMutationVariables>;
export const CreateGlobalLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createGlobalLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGlobalLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGlobalLimitedCostMutation, CreateGlobalLimitedCostMutationVariables>;
export const UpdateGlobalLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateGlobalLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGlobalLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGlobalLimitedCostMutation, UpdateGlobalLimitedCostMutationVariables>;
export const RemoveGlobalLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeGlobalLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGlobalLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<RemoveGlobalLimitedCostMutation, RemoveGlobalLimitedCostMutationVariables>;
export const OtherCostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"otherCostTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}}]}}]} as unknown as DocumentNode<OtherCostTypesQuery, OtherCostTypesQueryVariables>;
export const IsUniqueOtherCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueOtherCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueOtherCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogOtherCostTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogOtherCostTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<IsUniqueOtherCostTypeQuery, IsUniqueOtherCostTypeQueryVariables>;
export const CreateCatalogOtherCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalogOtherCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogOtherCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCatalogOtherCostTypeMutation, CreateCatalogOtherCostTypeMutationVariables>;
export const UpdateCatalogOtherCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogOtherCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogOtherCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogOtherCostTypeMutation, UpdateCatalogOtherCostTypeMutationVariables>;
export const RemoveCatalogOtherCostTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCatalogOtherCostType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCatalogOtherCostType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogOtherCostTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogOtherCostTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveCatalogOtherCostTypeMutation, RemoveCatalogOtherCostTypeMutationVariables>;
export const CatalogRatiosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatios"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasCosts"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatiosQuery, CatalogRatiosQueryVariables>;
export const CatalogRatioGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioGroupFilterQuery, CatalogRatioGroupFilterQueryVariables>;
export const CatalogRatioCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioCodeFilterQuery, CatalogRatioCodeFilterQueryVariables>;
export const CatalogRatioTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioTypeFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioTypeFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioTypeFilterQuery, CatalogRatioTypeFilterQueryVariables>;
export const CatalogRatioNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioNameFilterQuery, CatalogRatioNameFilterQueryVariables>;
export const RemoveCatalogRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCatalogRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogRatioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCatalogRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogRatioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogRatioId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveCatalogRatioMutation, RemoveCatalogRatioMutationVariables>;
export const CatalogRatioHistoryItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioHistoryDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioHistoryDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryChangeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"changeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"changeType"}},{"kind":"Field","name":{"kind":"Name","value":"changeDate"}},{"kind":"Field","name":{"kind":"Name","value":"changeData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameCng"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"kmatCng"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzCng"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpmCng"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"kozpCng"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"knrCng"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kspCng"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kemCng"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"justificationCng"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryItemsQuery, CatalogRatioHistoryItemsQueryVariables>;
export const CatalogRatioHistoryStatusCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryStatusCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceDataResultOfHistoryStatusCountDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryStatusCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedCount"}},{"kind":"Field","name":{"kind":"Name","value":"deletedCount"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryStatusCountsQuery, CatalogRatioHistoryStatusCountsQueryVariables>;
export const CatalogRatioHistoryCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryChangeType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"changeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryCodeFilterQuery, CatalogRatioHistoryCodeFilterQueryVariables>;
export const CatalogRatioHistoryNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryChangeType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"changeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryNameFilterQuery, CatalogRatioHistoryNameFilterQueryVariables>;
export const CatalogRatioHistoryTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryChangeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"changeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryTypeFilterQuery, CatalogRatioHistoryTypeFilterQueryVariables>;
export const CatalogRatioHistoryGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryChangeType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"changeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryGroupFilterQuery, CatalogRatioHistoryGroupFilterQueryVariables>;
export const CatalogRatioHistoryJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioHistoryJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HistoryChangeType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioHistoryJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"changeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changeType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioHistoryJustificationFilterQuery, CatalogRatioHistoryJustificationFilterQueryVariables>;
export const RemoveCatalogOtherCostVariableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCatalogOtherCostVariable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostVariableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCatalogOtherCostVariable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"otherCostVariableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostVariableId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveCatalogOtherCostVariableMutation, RemoveCatalogOtherCostVariableMutationVariables>;
export const CatalogsNamesByFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogsNamesByFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogsNamesByFilterQuery, CatalogsNamesByFilterQueryVariables>;
export const CatalogOtherCostVariablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"dataSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"dataSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"limitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limitedCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariablesQuery, CatalogOtherCostVariablesQueryVariables>;
export const CatalogOtherCostVariablesNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariablesNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariablesNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariablesNameFilterQuery, CatalogOtherCostVariablesNameFilterQueryVariables>;
export const CatalogOtherCostVariablesGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariablesGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariablesGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariablesGroupFilterQuery, CatalogOtherCostVariablesGroupFilterQueryVariables>;
export const CatalogOtherCostVariablesSubsidiaryNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariablesSubsidiaryNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariablesSubsidiaryNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariablesSubsidiaryNameFilterQuery, CatalogOtherCostVariablesSubsidiaryNameFilterQueryVariables>;
export const IsUniqueVariableGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueVariableGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isGlobal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueVariableGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupName"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isGlobal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isGlobal"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<IsUniqueVariableGroupQuery, IsUniqueVariableGroupQueryVariables>;
export const CreateCatalogOtherCostVariableGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalogOtherCostVariableGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableGroupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogOtherCostVariableGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCatalogOtherCostVariableGroupMutation, CreateCatalogOtherCostVariableGroupMutationVariables>;
export const UpdateCatalogOtherCostVariableGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogOtherCostVariableGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableGroupUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogOtherCostVariableGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogOtherCostVariableGroupMutation, UpdateCatalogOtherCostVariableGroupMutationVariables>;
export const RemoveCatalogOtherCostVariableGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCatalogOtherCostVariableGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCatalogOtherCostVariableGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveCatalogOtherCostVariableGroupMutation, RemoveCatalogOtherCostVariableGroupMutationVariables>;
export const CatalogOtherCostVariableGroupListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariableGroupList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableGroupItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariableGroupList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"variableCount"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariableGroupListQuery, CatalogOtherCostVariableGroupListQueryVariables>;
export const CatalogOtherCostVariableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostVariableId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"otherCostVariableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostVariableId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"limitedCostTypeId"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariableQuery, CatalogOtherCostVariableQueryVariables>;
export const CatalogOtherCostVariableEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariableEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableEntityItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableEntityItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariableEntities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariableEntitiesQuery, CatalogOtherCostVariableEntitiesQueryVariables>;
export const IsUniqueVariableNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueVariableName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variableId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variableType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variableName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueVariableName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"variableId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variableId"}}},{"kind":"Argument","name":{"kind":"Name","value":"variableType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variableType"}}},{"kind":"Argument","name":{"kind":"Name","value":"variableName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variableName"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<IsUniqueVariableNameQuery, IsUniqueVariableNameQueryVariables>;
export const CreateCatalogOtherCostVariableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalogOtherCostVariable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogOtherCostVariable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCatalogOtherCostVariableMutation, CreateCatalogOtherCostVariableMutationVariables>;
export const UpdateCatalogOtherCostVariableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogOtherCostVariable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogOtherCostVariable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogOtherCostVariableMutation, UpdateCatalogOtherCostVariableMutationVariables>;
export const CatalogOtherCostVariableDataSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariableDataSources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityUniqueIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostVariableDataSourceItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariableDataSources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityUniqueIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityUniqueIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariableDataSourcesQuery, CatalogOtherCostVariableDataSourcesQueryVariables>;
export const GlobalConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"globalConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"globalConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GlobalConstructionTypesQuery, GlobalConstructionTypesQueryVariables>;
export const CatalogRatioGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioGroupDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioGroupsQuery, CatalogRatioGroupsQueryVariables>;
export const CatalogRatioTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatioTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"}}]}}]}}]} as unknown as DocumentNode<CatalogRatioTypesQuery, CatalogRatioTypesQueryVariables>;
export const CatalogRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogRatioQuery, CatalogRatioQueryVariables>;
export const CreateCatalogRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalogRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalogRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCatalogRatioMutation, CreateCatalogRatioMutationVariables>;
export const UpdateCatalogRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCatalogRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCatalogRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCatalogRatioMutation, UpdateCatalogRatioMutationVariables>;
export const CatalogRatioMassApplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogRatioMassApply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioMassApplyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioMassApply"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogRatioMassApplyMutation, CatalogRatioMassApplyMutationVariables>;
export const MassApplicationBaseCostsSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"massApplicationBaseCostsSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MassApplicationBaseCostsSectionNameFilterQuery, MassApplicationBaseCostsSectionNameFilterQueryVariables>;
export const MassApplicationBaseCostsGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"massApplicationBaseCostsGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MassApplicationBaseCostsGroupNameFilterQuery, MassApplicationBaseCostsGroupNameFilterQueryVariables>;
export const MassApplicationBaseCostsCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"massApplicationBaseCostsCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MassApplicationBaseCostsCodeFilterQuery, MassApplicationBaseCostsCodeFilterQueryVariables>;
export const MassApplicationBaseCostsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"massApplicationBaseCostsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioGroupIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioGroupIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<MassApplicationBaseCostsNameFilterQuery, MassApplicationBaseCostsNameFilterQueryVariables>;
export const CatalogTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodologies"}},{"kind":"Field","name":{"kind":"Name","value":"allowMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"canCreate"}}]}}]}}]} as unknown as DocumentNode<CatalogTypesQuery, CatalogTypesQueryVariables>;
export const CreateCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCatalogMutation, CreateCatalogMutationVariables>;
export const CatalogUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorkScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"directCost"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"fot"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"ratios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratioGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTotal"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionRateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRateMtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostQuery, CatalogUerBaseCostQueryVariables>;
export const CatalogParseUerBaseCostBasisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogParseUerBaseCostBasis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogParseUerBaseCostBasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"fot"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"directCost"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTotal"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionRateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"vr2001"}},{"kind":"Field","name":{"kind":"Name","value":"naclMask"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRateMtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"general"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"workTypeItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"nacl"}},{"kind":"Field","name":{"kind":"Name","value":"naclCurr"}},{"kind":"Field","name":{"kind":"Name","value":"naclMask"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"planCurr"}},{"kind":"Field","name":{"kind":"Name","value":"planMask"}},{"kind":"Field","name":{"kind":"Name","value":"nrCode"}},{"kind":"Field","name":{"kind":"Name","value":"spCode"}},{"kind":"Field","name":{"kind":"Name","value":"workID"}},{"kind":"Field","name":{"kind":"Name","value":"catFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uerNacl"}},{"kind":"Field","name":{"kind":"Name","value":"uerPlan"}},{"kind":"Field","name":{"kind":"Name","value":"catFile"}},{"kind":"Field","name":{"kind":"Name","value":"workID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogParseUerBaseCostBasisQuery, CatalogParseUerBaseCostBasisQueryVariables>;
export const CatalogUerBaseCostConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUERBaseCostConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConstructionTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"iconCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUerBaseCostConstructionTypesQuery, CatalogUerBaseCostConstructionTypesQueryVariables>;
export const CatalogCreateUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"catalogCreateUerBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"costData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCatalogUERBaseCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogCreateUerBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"costData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"costData"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostWorkScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogCreateUerBaseCostMutation, CatalogCreateUerBaseCostMutationVariables>;
export const BimcCalculationLimitedCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationLimitedCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationLimitedCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingValue"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"hasFormulaError"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isNorthernAllowance"}},{"kind":"Field","name":{"kind":"Name","value":"isManualLimitsDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"globalLimitedCostId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonAmounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcCalculationLimitedCostsQuery, BimcCalculationLimitedCostsQueryVariables>;
export const BimcCalculationLimitedCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationLimitedCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationLimitedCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationLimitedCostNameFilterQuery, BimcCalculationLimitedCostNameFilterQueryVariables>;
export const BimcRemoveCalculationLimitedCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcRemoveCalculationLimitedCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcRemoveCalculationLimitedCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimcRemoveCalculationLimitedCostsMutation, BimcRemoveCalculationLimitedCostsMutationVariables>;
export const BimcGlobalLimitedCostsForCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcGlobalLimitedCostsForCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcGlobalLimitedCostsForCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]} as unknown as DocumentNode<BimcGlobalLimitedCostsForCalculationQuery, BimcGlobalLimitedCostsForCalculationQueryVariables>;
export const BimcCalculationLimitedCostTypesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationLimitedCostTypesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationLimitedCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcCalculationLimitedCostTypesQueryQuery, BimcCalculationLimitedCostTypesQueryQueryVariables>;
export const BimcIsCalculationLimitedCostCodeUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcIsCalculationLimitedCostCodeUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcIsCalculationLimitedCostCodeUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","alias":{"kind":"Name","value":"isUnique"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BimcIsCalculationLimitedCostCodeUniqueQuery, BimcIsCalculationLimitedCostCodeUniqueQueryVariables>;
export const BimcIsCalculationLimitedCostNameUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcIsCalculationLimitedCostNameUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcIsCalculationLimitedCostNameUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","alias":{"kind":"Name","value":"isUnique"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BimcIsCalculationLimitedCostNameUniqueQuery, BimcIsCalculationLimitedCostNameUniqueQueryVariables>;
export const BimcCreateCalculationLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcCreateCalculationLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationLimitedCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCreateCalculationLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimcCreateCalculationLimitedCostMutation, BimcCreateCalculationLimitedCostMutationVariables>;
export const BimcUpdateCalculationLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateCalculationLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationLimitedCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateCalculationLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimcUpdateCalculationLimitedCostMutation, BimcUpdateCalculationLimitedCostMutationVariables>;
export const BimcCalculationLimitedCostForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationLimitedCostForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationLimitedCostForUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"globalLimitedCostId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"groupConstructionLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isNorthernAllowance"}},{"kind":"Field","name":{"kind":"Name","value":"isManualLimitsDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationLimitedCostForUpdateQuery, BimcCalculationLimitedCostForUpdateQueryVariables>;
export const BimcLocalEstimatesTableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimatesTable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcPriceLevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateTableItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimatesTable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateId"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateType"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasRemovedLsrs"}},{"kind":"Field","name":{"kind":"Name","value":"inPercentOtherAndLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzm"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimatesTableQuery, BimcLocalEstimatesTableQueryVariables>;
export const BimcLocalEstimateCompositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateComposition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcPriceLevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateCompositionRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateCompositionRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateComposition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"localEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ratios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"em"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"pz"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"srcOrder"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tzm"}},{"kind":"Field","name":{"kind":"Name","value":"zm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"srcOrder"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzm"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateCompositionQuery, BimcLocalEstimateCompositionQueryVariables>;
export const BimcLocalEstimateCompositionCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateCompositionCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateCompositionCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"localEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateCompositionCodeFilterQuery, BimcLocalEstimateCompositionCodeFilterQueryVariables>;
export const BimcLocalEstimateCompositionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateCompositionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateCompositionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"localEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateCompositionNameFilterQuery, BimcLocalEstimateCompositionNameFilterQueryVariables>;
export const BimcLoadLocalEstimatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcLoadLocalEstimates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateImportMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLoadLocalEstimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLoadLocalEstimatesMutation, BimcLoadLocalEstimatesMutationVariables>;
export const BimcLocalEstimateEditDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateEditData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateEditData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"localEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inPercentOtherAndLimit"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateEditDataQuery, BimcLocalEstimateEditDataQueryVariables>;
export const BimcUpdateLocalEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateLocalEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inPercentOtherAndLimit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateLocalEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"localEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inPercentOtherAndLimit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inPercentOtherAndLimit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcUpdateLocalEstimateMutation, BimcUpdateLocalEstimateMutationVariables>;
export const BimcRedistributeLocalEstimateMtrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcRedistributeLocalEstimateMtr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateMtrDistributionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcRedistributeLocalEstimateMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"localEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localEstimateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcRedistributeLocalEstimateMtrMutation, BimcRedistributeLocalEstimateMtrMutationVariables>;
export const BimcLocalEstimateTableCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateTableCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateTableCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateTableCodeFilterQuery, BimcLocalEstimateTableCodeFilterQueryVariables>;
export const BimcLocalEstimateTableNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateTableNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateTableNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateTableNameFilterQuery, BimcLocalEstimateTableNameFilterQueryVariables>;
export const BimcLocalEstimateTableObjectFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcLocalEstimateTableObjectFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcLocalEstimateTableObjectFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcLocalEstimateTableObjectFilterQuery, BimcLocalEstimateTableObjectFilterQueryVariables>;
export const BimcAggregateEstimateLsrSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimateLsrSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcPriceLevelEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimateLsrSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"inPercentOtherAndLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateId"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateType"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"subObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzm"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateLsrSelectionQuery, BimcAggregateEstimateLsrSelectionQueryVariables>;
export const BimcCreateAggregateEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcCreateAggregateEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAggregateEstimateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCreateAggregateEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCreateAggregateEstimateMutation, BimcCreateAggregateEstimateMutationVariables>;
export const BimcAggregateEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"aggregateLocalEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calculationObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"valueCode"}},{"kind":"Field","name":{"kind":"Name","value":"valueName"}},{"kind":"Field","name":{"kind":"Name","value":"valueUnit"}},{"kind":"Field","name":{"kind":"Name","value":"valueQuantityNow"}},{"kind":"Field","name":{"kind":"Name","value":"valueQuantityTarget"}},{"kind":"Field","name":{"kind":"Name","value":"coefficient"}},{"kind":"Field","name":{"kind":"Name","value":"inPercentOtherAndLimit"}},{"kind":"Field","name":{"kind":"Name","value":"lsrs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateQuery, BimcAggregateEstimateQueryVariables>;
export const BimcUpdateAggregateEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateAggregateEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAggregateEstimateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateAggregateEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcUpdateAggregateEstimateMutation, BimcUpdateAggregateEstimateMutationVariables>;
export const BimcAggregateEstimateCompositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimateComposition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcPriceLevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateTableItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimateComposition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateLocalEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateId"}},{"kind":"Field","name":{"kind":"Name","value":"localEstimateType"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"subObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"tzm"}},{"kind":"Field","name":{"kind":"Name","value":"inPercentOtherAndLimit"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateCompositionQuery, BimcAggregateEstimateCompositionQueryVariables>;
export const BimcAggregateEstimateCompositionCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateLocalEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateCompositionCodeFilterQuery, BimcAggregateEstimateCompositionCodeFilterQueryVariables>;
export const BimcAggregateEstimateCompositionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateLocalEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateCompositionNameFilterQuery, BimcAggregateEstimateCompositionNameFilterQueryVariables>;
export const BimcAggregateEstimateCompositionObjectFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionObjectFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionObjectFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateLocalEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateCompositionObjectFilterQuery, BimcAggregateEstimateCompositionObjectFilterQueryVariables>;
export const BimcAggregateEstimateCompositionSubObjectFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionSubObjectFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcAggregateEstimateCompositionSubObjectFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"aggregateLocalEstimateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aggregateLocalEstimateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcAggregateEstimateCompositionSubObjectFilterQuery, BimcAggregateEstimateCompositionSubObjectFilterQueryVariables>;
export const BimcRemoveLocalEstimatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcRemoveLocalEstimates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalEstimateRemoveMutationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcRemoveLocalEstimates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<BimcRemoveLocalEstimatesMutation, BimcRemoveLocalEstimatesMutationVariables>;
export const BimcGlobalOtherCostsForCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcGlobalOtherCostsForCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcGlobalOtherCostsForCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]} as unknown as DocumentNode<BimcGlobalOtherCostsForCalculationQuery, BimcGlobalOtherCostsForCalculationQueryVariables>;
export const BimcCreateCalculationOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcCreateCalculationOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCreateCalculationOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimcCreateCalculationOtherCostMutation, BimcCreateCalculationOtherCostMutationVariables>;
export const BimcUpdateCalculationOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateCalculationOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateCalculationOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimcUpdateCalculationOtherCostMutation, BimcUpdateCalculationOtherCostMutationVariables>;
export const BimcCalculationOtherCostForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationOtherCostForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationOtherCostForUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"groupConstructionLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"globalOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitsTotalFromFile"}},{"kind":"Field","name":{"kind":"Name","value":"isManualLimitsDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationOtherCostForUpdateQuery, BimcCalculationOtherCostForUpdateQueryVariables>;
export const BimcCalculationOtherCostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationOtherCostTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationOtherCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcCalculationOtherCostTypesQuery, BimcCalculationOtherCostTypesQueryVariables>;
export const BimcCalculationOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationOtherCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationOtherCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"globalOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isManualLimitsDistribution"}},{"kind":"Field","name":{"kind":"Name","value":"hasFormulaError"}},{"kind":"Field","name":{"kind":"Name","value":"seasonAmounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimcCalculationOtherCostsQuery, BimcCalculationOtherCostsQueryVariables>;
export const BimcRemoveCalculationOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcRemoveCalculationOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcRemoveCalculationOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimcRemoveCalculationOtherCostsMutation, BimcRemoveCalculationOtherCostsMutationVariables>;
export const BimcCalculationOtherCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationOtherCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationOtherCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationOtherCostNameFilterQuery, BimcCalculationOtherCostNameFilterQueryVariables>;
export const BimcCatalogOtherCostTemplateFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCatalogOtherCostTemplateFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUEROtherCostTemplateFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BimcCatalogOtherCostTemplateFilesQuery, BimcCatalogOtherCostTemplateFilesQueryVariables>;
export const IsBimcCalculationOtherCostCodeUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isBimcCalculationOtherCostCodeUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcIsCalculationOtherCostCodeUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","alias":{"kind":"Name","value":"isUnique"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IsBimcCalculationOtherCostCodeUniqueQuery, IsBimcCalculationOtherCostCodeUniqueQueryVariables>;
export const BimcExtractTotalSumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcExtractTotalSum"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcExtractTotalSum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]} as unknown as DocumentNode<BimcExtractTotalSumQuery, BimcExtractTotalSumQueryVariables>;
export const BimcCalculationDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"costRounding"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"taxPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationDefaultsQuery, BimcCalculationDefaultsQueryVariables>;
export const BimcCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"changeDate"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coefficients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"kemm"}},{"kind":"Field","name":{"kind":"Name","value":"kzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kmtr"}},{"kind":"Field","name":{"kind":"Name","value":"keqp"}},{"kind":"Field","name":{"kind":"Name","value":"kmz"}},{"kind":"Field","name":{"kind":"Name","value":"koz"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kpir"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastComputedAt"}},{"kind":"Field","name":{"kind":"Name","value":"nmcWithNmdc"}},{"kind":"Field","name":{"kind":"Name","value":"nmcWithoutNmdc"}},{"kind":"Field","name":{"kind":"Name","value":"nmdc"}},{"kind":"Field","name":{"kind":"Name","value":"taxPercent"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"projectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"costRounding"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inflation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonsInflation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inflation"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationQuery, BimcCalculationQueryVariables>;
export const BimcCalculationSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"inflation"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<BimcCalculationSeasonsQuery, BimcCalculationSeasonsQueryVariables>;
export const BimcCreateCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcCreateCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCreateCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCreateCalculationMutation, BimcCreateCalculationMutationVariables>;
export const BimcUpdateCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcUpdateCalculationMutation, BimcUpdateCalculationMutationVariables>;
export const BimcCalculationObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcCalculationObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCalculationObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"codeWBS"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]} as unknown as DocumentNode<BimcCalculationObjectsQuery, BimcCalculationObjectsQueryVariables>;
export const BimcCreateCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcCreateCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCreateCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BimcCreateCalculationObjectMutation, BimcCreateCalculationObjectMutationVariables>;
export const BimcCreateCalculationSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcCreateCalculationSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationSubObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcCreateCalculationSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BimcCreateCalculationSubObjectMutation, BimcCreateCalculationSubObjectMutationVariables>;
export const BimcUpdateCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimcCalculationObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BimcUpdateCalculationObjectMutation, BimcUpdateCalculationObjectMutationVariables>;
export const BimcUpdateSeasonDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcUpdateSeasonDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectSeasonDistributionInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcUpdateSeasonDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}}]}]}}]} as unknown as DocumentNode<BimcUpdateSeasonDistributionMutation, BimcUpdateSeasonDistributionMutationVariables>;
export const BimcRemoveCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcRemoveCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcRemoveCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BimcRemoveCalculationObjectMutation, BimcRemoveCalculationObjectMutationVariables>;
export const BimcIsUniqueCalculationObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcIsUniqueCalculationObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcIsUniqueCalculationObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeObjectId"}}}]}]}}]} as unknown as DocumentNode<BimcIsUniqueCalculationObjectNameQuery, BimcIsUniqueCalculationObjectNameQueryVariables>;
export const BimcIsUniqueCalculationSubObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcIsUniqueCalculationSubObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcIsUniqueCalculationSubObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeObjectId"}}}]}]}}]} as unknown as DocumentNode<BimcIsUniqueCalculationSubObjectNameQuery, BimcIsUniqueCalculationSubObjectNameQueryVariables>;
export const BimcIsUniqueCalculationObjectCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimcIsUniqueCalculationObjectCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcIsUniqueCalculationObjectCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeObjectId"}}}]}]}}]} as unknown as DocumentNode<BimcIsUniqueCalculationObjectCodeQuery, BimcIsUniqueCalculationObjectCodeQueryVariables>;
export const BimcSetCalculationObjectGuaranteedVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcSetCalculationObjectGuaranteedVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectGuaranteedVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcSetCalculationObjectGuaranteedVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<BimcSetCalculationObjectGuaranteedVolumeMutation, BimcSetCalculationObjectGuaranteedVolumeMutationVariables>;
export const BimcImportCalculationStructureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcImportCalculationStructure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcImportCalculationStructure"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimcImportCalculationStructureMutation, BimcImportCalculationStructureMutationVariables>;
export const BimcMoveCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimcMoveCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectMoveInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimcMoveCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<BimcMoveCalculationObjectMutation, BimcMoveCalculationObjectMutationVariables>;
export const BimContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNoPlanByConstructionType"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"usedInObjectStructure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"conversionIndices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coefficients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"kemm"}},{"kind":"Field","name":{"kind":"Name","value":"kmtr"}},{"kind":"Field","name":{"kind":"Name","value":"keqp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kpir"}},{"kind":"Field","name":{"kind":"Name","value":"kzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kmz"}},{"kind":"Field","name":{"kind":"Name","value":"koz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"generalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"contractorOKPO"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerOKPO"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"okpd"}},{"kind":"Field","name":{"kind":"Name","value":"okud"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitedCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rateValue"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fotValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"regionalFactor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter12"}},{"kind":"Field","name":{"kind":"Name","value":"chapter1_7"}},{"kind":"Field","name":{"kind":"Name","value":"chapter8"}},{"kind":"Field","name":{"kind":"Name","value":"chapter9"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentContractor"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"materialContractor"}},{"kind":"Field","name":{"kind":"Name","value":"materialCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"northernAllowance"}}]}},{"kind":"Field","name":{"kind":"Name","value":"projectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonsInflation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inflationRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smrDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"limitedCostCalcMethod"}},{"kind":"Field","name":{"kind":"Name","value":"hasObjectStructure"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"resultPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypePlanResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"hasSeason"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasFilledAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanReminderPercent"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanReminderWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanTax"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersPlanCostWithTax"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimContractQuery, BimContractQueryVariables>;
export const BimContractDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"resultPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypePlanResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"hasSeason"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimContractDefaultsQuery, BimContractDefaultsQueryVariables>;
export const BimCreateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"projectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"generalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionIndices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coefficients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"kemm"}},{"kind":"Field","name":{"kind":"Name","value":"kmz"}},{"kind":"Field","name":{"kind":"Name","value":"koz"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonsInflation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inflationRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limitedCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regionalFactor"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rateValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter1_7"}},{"kind":"Field","name":{"kind":"Name","value":"chapter9"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentCustomer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"smrDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimCreateContractMutation, BimCreateContractMutationVariables>;
export const BimUpdateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimUpdateContractMutation, BimUpdateContractMutationVariables>;
export const BimIsUniqueContractInternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimIsUniqueContractInternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIsUniqueContractInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIsUniqueContractInternalNumberQuery, BimIsUniqueContractInternalNumberQueryVariables>;
export const BimFrameContractResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimFrameContractResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimFrameContractResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Navs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC3Navs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"actsKC2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderPlanSum"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"planPrice"}},{"kind":"Field","name":{"kind":"Name","value":"completedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"completedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"planPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"contractRemainder"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completedDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"completedRemainder"}},{"kind":"Field","name":{"kind":"Name","value":"completedRemainderDeviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypePlanResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimFrameContractResultsQuery, BimFrameContractResultsQueryVariables>;
export const BimNormalContractResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimNormalContractResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimNormalContractResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2CompletedSum"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"contractRemainder"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeCompletedResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"completedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypePlanResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimNormalContractResultsQuery, BimNormalContractResultsQueryVariables>;
export const BimContractObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}}]}}]}}]} as unknown as DocumentNode<BimContractObjectsQuery, BimContractObjectsQueryVariables>;
export const BimImportContractObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimImportContractObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimImportContractObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimImportContractObjectsMutation, BimImportContractObjectsMutationVariables>;
export const BimCreateContractObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateContractObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateContractObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateContractObjectMutation, BimCreateContractObjectMutationVariables>;
export const BimUpdateContractObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateContractObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateContractObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateContractObjectMutation, BimUpdateContractObjectMutationVariables>;
export const BimCreateContractSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateContractSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractSubObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateContractSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateContractSubObjectMutation, BimCreateContractSubObjectMutationVariables>;
export const BimUpdateContractSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateContractSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractSubObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateContractSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateContractSubObjectMutation, BimUpdateContractSubObjectMutationVariables>;
export const BimIsUniqueContractObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimIsUniqueContractObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIsUniqueContractObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIsUniqueContractObjectNameQuery, BimIsUniqueContractObjectNameQueryVariables>;
export const BimIsUniqueContractSubObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimIsUniqueContractSubObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSubObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIsUniqueContractSubObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSubObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSubObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIsUniqueContractSubObjectNameQuery, BimIsUniqueContractSubObjectNameQueryVariables>;
export const BimDeleteContractObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimDeleteContractObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimDeleteContractObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimDeleteContractObjectMutation, BimDeleteContractObjectMutationVariables>;
export const BimMoveContractObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimMoveContractObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertAfterObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newParentObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimMoveContractObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"insertAfterObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertAfterObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newParentObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newParentObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimMoveContractObjectMutation, BimMoveContractObjectMutationVariables>;
export const BimUpdateActKc2TotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateActKC2Totals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actsKC2Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateActKC2Totals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uploadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actsKC2Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actsKC2Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<BimUpdateActKc2TotalsMutation, BimUpdateActKc2TotalsMutationVariables>;
export const BimWorkOrderOthersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderOthers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderOthers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderOthersQuery, BimWorkOrderOthersQueryVariables>;
export const BimWorkOrderOtherForActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderOtherForAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderOtherForAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderOtherForActQuery, BimWorkOrderOtherForActQueryVariables>;
export const BimAddWorkOrderOthersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimAddWorkOrderOthers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectContractTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimAddWorkOrderOthers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractType"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}}]}}]}}]} as unknown as DocumentNode<BimAddWorkOrderOthersMutation, BimAddWorkOrderOthersMutationVariables>;
export const BimAddWorkOrderOtherForActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimAddWorkOrderOtherForAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimAddWorkOrderOtherForAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimAddWorkOrderOtherForActMutation, BimAddWorkOrderOtherForActMutationVariables>;
export const BimCreateActKc2OtherCorrectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateActKC2OtherCorrection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2OtherCorrectionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateActKC2OtherCorrection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlanValues"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateActKc2OtherCorrectionMutation, BimCreateActKc2OtherCorrectionMutationVariables>;
export const BimUpdateActKc2OtherCorrectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateActKC2OtherCorrection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2OtherCorrectionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateActKC2OtherCorrection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlanValues"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateActKc2OtherCorrectionMutation, BimUpdateActKc2OtherCorrectionMutationVariables>;
export const BimWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"formationStage"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"remainder"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOtherActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasSMRActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderQuery, BimWorkOrderQueryVariables>;
export const BimUpdateWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderMutation, BimUpdateWorkOrderMutationVariables>;
export const BimCalculationRequisitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimCalculationRequisites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasSMRActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOtherActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<BimCalculationRequisitesQuery, BimCalculationRequisitesQueryVariables>;
export const BimUpdateCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimCalculationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateCalculationMutation, BimUpdateCalculationMutationVariables>;
export const BimActKc2TotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2Totals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"readOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2TotalItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2TotalItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2Totals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"readOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"readOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderActiveSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"limitedCostType"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"isInputValue"}},{"kind":"Field","name":{"kind":"Name","value":"isInflation"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2TotalsQuery, BimActKc2TotalsQueryVariables>;
export const BimUseActKc2TotalLimitedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUseActKC2TotalLimited"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimLimitedCostTypeEnum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useLimited"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUseActKC2TotalLimited"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedItems"}}},{"kind":"Argument","name":{"kind":"Name","value":"useLimited"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useLimited"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUseActKc2TotalLimitedMutation, BimUseActKc2TotalLimitedMutationVariables>;
export const BimResetActKc2AllCalculatedTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimResetActKC2AllCalculatedTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useCalculated"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimResetActKC2AllCalculatedTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"useCalculated"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useCalculated"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimResetActKc2AllCalculatedTotalMutation, BimResetActKc2AllCalculatedTotalMutationVariables>;
export const BimResetActKc2CalculatedTotalItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimResetActKC2CalculatedTotalItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useCalculated"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2TotalItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimResetActKC2CalculatedTotalItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"useCalculated"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useCalculated"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2TotalItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2TotalItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimResetActKc2CalculatedTotalItemMutation, BimResetActKc2CalculatedTotalItemMutationVariables>;
export const BimSetActKc2InputValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimSetActKC2InputValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2TotalItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimSetActKC2InputValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2TotalItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2TotalItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimSetActKc2InputValueMutation, BimSetActKc2InputValueMutationVariables>;
export const BimActKc2PriceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2PriceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2PriceRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2PriceRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2PriceRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"inactiveMtr"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2PriceRowsQuery, BimActKc2PriceRowsQueryVariables>;
export const BimUseActKc2TotalInflationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUseActKC2TotalInflation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUseActKC2TotalInflation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderSeasonId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUseActKc2TotalInflationMutation, BimUseActKc2TotalInflationMutationVariables>;
export const BimUseActKc2InflationValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUseActKC2InflationValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculateInflation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimCalculateInflationEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUseActKC2InflationValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculateInflation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculateInflation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUseActKc2InflationValueMutation, BimUseActKc2InflationValueMutationVariables>;
export const BimWorkOrderActsKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderActsKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2GroupTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2ListItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2ListItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderActsKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actDate"}},{"kind":"Field","name":{"kind":"Name","value":"actId"}},{"kind":"Field","name":{"kind":"Name","value":"actMonth"}},{"kind":"Field","name":{"kind":"Name","value":"actYear"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"chapterTip"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"costWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"groupCostWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"groupCount"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusTip"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceCode"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceName"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderActsKc2Query, BimWorkOrderActsKc2QueryVariables>;
export const BimWorkOrderActsKc2SelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderActsKC2SelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2SelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2SelectionDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderActsKC2SelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"actId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"actDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"costWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"chapterTip"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusTip"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceCode"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceName"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderActsKc2SelectionListQuery, BimWorkOrderActsKc2SelectionListQueryVariables>;
export const BimCreateWorkOrderActsKc2GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderActsKC2Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2GroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderActsKC2Group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderActsKc2GroupMutation, BimCreateWorkOrderActsKc2GroupMutationVariables>;
export const BimUpdateWorkOrderActsKc2GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderActsKC2Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2GroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderActsKC2Group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderActsKc2GroupMutation, BimUpdateWorkOrderActsKc2GroupMutationVariables>;
export const BimRemoveWorkOrderActsKc2GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderActsKC2Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderActsKC2Group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderActsKc2GroupMutation, BimRemoveWorkOrderActsKc2GroupMutationVariables>;
export const BimActKc2GroupNumberFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupNumberFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupNumberFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupNumberFilterQuery, BimActKc2GroupNumberFilterQueryVariables>;
export const BimActKc2GroupDateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupDateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateTimeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupDateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupDateFilterQuery, BimActKc2GroupDateFilterQueryVariables>;
export const BimActKc2GroupCostGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupCostGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCostGroupEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupCostGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupCostGroupFilterQuery, BimActKc2GroupCostGroupFilterQueryVariables>;
export const BimActKc2GroupConstructionTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupConstructionTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupConstructionTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupConstructionTypeFilterQuery, BimActKc2GroupConstructionTypeFilterQueryVariables>;
export const BimActKc2GroupObjectFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupObjectFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupObjectFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupObjectFilterQuery, BimActKc2GroupObjectFilterQueryVariables>;
export const BimActKc2GroupChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfBimChapterEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupChapterFilterQuery, BimActKc2GroupChapterFilterQueryVariables>;
export const BimActKc2GroupWorkOrderPriceCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2GroupWorkOrderPriceCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2GroupWorkOrderPriceCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2GroupWorkOrderPriceCodeFilterQuery, BimActKc2GroupWorkOrderPriceCodeFilterQueryVariables>;
export const BimIsUniqueActKc2GroupNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimIsUniqueActKC2GroupName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIsUniqueActKC2GroupName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupName"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIsUniqueActKc2GroupNameQuery, BimIsUniqueActKc2GroupNameQueryVariables>;
export const BimActKc2OtherTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2OtherTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2OtherTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"isInflation"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderActiveSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"hasTotals"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2OtherTotalsQuery, BimActKc2OtherTotalsQueryVariables>;
export const BimUseActKc2OtherTotalInflationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUseActKC2OtherTotalInflation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderSeasonId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUseActKC2OtherTotalInflation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderSeasonId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<BimUseActKc2OtherTotalInflationMutation, BimUseActKc2OtherTotalInflationMutationVariables>;
export const BimWorkOrderConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderConstructionTypesQuery, BimWorkOrderConstructionTypesQueryVariables>;
export const BimWorkOrderOtherPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderOtherPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherPriceDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherPriceDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderOtherPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedRow"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC2OtherCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"costPlan"}},{"kind":"Field","name":{"kind":"Name","value":"costAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedOtherDeviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderOtherPricesQuery, BimWorkOrderOtherPricesQueryVariables>;
export const BimActsKc2OtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActsKC2Other"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2OtherItemDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2OtherItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActsKC2Other"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimActsKc2OtherQuery, BimActsKc2OtherQueryVariables>;
export const BimIsUniqueActKc2OtherInternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimIsUniqueActKC2OtherInternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIsUniqueActKC2OtherInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimIsUniqueActKc2OtherInternalNumberQuery, BimIsUniqueActKc2OtherInternalNumberQueryVariables>;
export const BimSetActKc2OtherPlanCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimSetActKC2OtherPlanCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimSetActKC2OtherPlanCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimSetActKc2OtherPlanCostMutation, BimSetActKc2OtherPlanCostMutationVariables>;
export const BimSetActKc2OtherAcceptedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimSetActKC2OtherAcceptedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimSetActKC2OtherAcceptedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimSetActKc2OtherAcceptedCostMutation, BimSetActKc2OtherAcceptedCostMutationVariables>;
export const BimRemoveWorkOrderOthersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderOthers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderOthers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderOthersMutation, BimRemoveWorkOrderOthersMutationVariables>;
export const BimRemoveWorkOrderOtherForActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderOtherForAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderOtherForAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderOtherForActMutation, BimRemoveWorkOrderOtherForActMutationVariables>;
export const BimUpdateWorkOrderOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherDistributionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderOtherDistributionMutation, BimUpdateWorkOrderOtherDistributionMutationVariables>;
export const BimUpdateWorkOrderOtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderOther"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderOther"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderOtherMutation, BimUpdateWorkOrderOtherMutationVariables>;
export const BimUpdateWorkOrderOtherForActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderOtherForAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderOtherForAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderOtherForActMutation, BimUpdateWorkOrderOtherForActMutationVariables>;
export const BimUpdateWorkOrderOtherDistributionToActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderOtherDistributionToActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherDistributionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderOtherDistributionToActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderOtherDistributionToActKc2Mutation, BimUpdateWorkOrderOtherDistributionToActKc2MutationVariables>;
export const BimSetActKc2OtherCostCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimSetActKC2OtherCostComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimSetActKC2OtherCostComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimSetActKc2OtherCostCommentMutation, BimSetActKc2OtherCostCommentMutationVariables>;
export const BimWorkOrderOtherDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderOtherData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderOtherData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderOtherDataQuery, BimWorkOrderOtherDataQueryVariables>;
export const BimWorkOrderOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"includedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemCalculation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectDistribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderOtherDistributionQuery, BimWorkOrderOtherDistributionQueryVariables>;
export const BimPriceRowAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceRowAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceAnalyticsItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceRowAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"topHeaderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refHeaderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subsection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"topHeaderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refHeaderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sysId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"topPriceValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refPriceValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changedProperties"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceRowAnalyticsQuery, BimPriceRowAnalyticsQueryVariables>;
export const BimPriceAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"topPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"refPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"topPriceValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refPriceValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceAnalyticsQuery, BimPriceAnalyticsQueryVariables>;
export const BimWorkOrderPriceAnalyticsPriceVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceAnalyticsPriceVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRevisions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"priceUpdateDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceAnalyticsPriceVersionsQuery, BimWorkOrderPriceAnalyticsPriceVersionsQueryVariables>;
export const BimPriceRowAnalyticsSectionFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceRowAnalyticsSectionFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceRowAnalyticsSectionFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceRowAnalyticsSectionFilterQuery, BimPriceRowAnalyticsSectionFilterQueryVariables>;
export const BimPriceRowAnalyticsSubsectionFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceRowAnalyticsSubsectionFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceRowAnalyticsSubsectionFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceRowAnalyticsSubsectionFilterQuery, BimPriceRowAnalyticsSubsectionFilterQueryVariables>;
export const BimPriceRowAnalyticsCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceRowAnalyticsCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceRowAnalyticsCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceRowAnalyticsCodeFilterQuery, BimPriceRowAnalyticsCodeFilterQueryVariables>;
export const BimPriceRowAnalyticsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceRowAnalyticsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceRowAnalyticsNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceRowAnalyticsNameFilterQuery, BimPriceRowAnalyticsNameFilterQueryVariables>;
export const BimPriceRowAnalyticsUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimPriceRowAnalyticsUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimPriceRowAnalyticsUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refWorkOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refWorkOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimPriceRowAnalyticsUnitFilterQuery, BimPriceRowAnalyticsUnitFilterQueryVariables>;
export const BimWorkOrderPriceRevisionCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceRevisionCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRevisionCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceRevisionCodeFilterQuery, BimWorkOrderPriceRevisionCodeFilterQueryVariables>;
export const BimWorkOrderPriceRevisionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceRevisionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRevisionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceRevisionNameFilterQuery, BimWorkOrderPriceRevisionNameFilterQueryVariables>;
export const BimWorkOrderVersionPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRows"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasActKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasUpdates"}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"completedTotalDeviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPricesQuery, BimWorkOrderVersionPricesQueryVariables>;
export const BimWorkOrderPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRows"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasActKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasUpdates"}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"canRemovedToActKC2"}},{"kind":"Field","name":{"kind":"Name","value":"completedTotalDeviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPricesQuery, BimWorkOrderPricesQueryVariables>;
export const BimWorkOrderPriceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionNane"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceRowsQuery, BimWorkOrderPriceRowsQueryVariables>;
export const BimRemoveWorkOrderPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderPricesMutation, BimRemoveWorkOrderPricesMutationVariables>;
export const BimRemoveWorkOrderPricesToActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderPricesToActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderPricesToActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderPricesToActKc2Mutation, BimRemoveWorkOrderPricesToActKc2MutationVariables>;
export const BimWorkOrderPriceRevisionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceRevisions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderPriceRevisionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderPriceRevisionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRevisions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceRevisionsQuery, BimWorkOrderPriceRevisionsQueryVariables>;
export const BimWorkOrderVersionPriceRevisionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRevisions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionPriceRevisionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionPriceRevisionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRevisions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceUpdateDate"}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceRevisionsQuery, BimWorkOrderVersionPriceRevisionsQueryVariables>;
export const BimActsKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActsKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2DataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2DataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActsKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calcMethod"}},{"kind":"Field","name":{"kind":"Name","value":"currentPriceTotal"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canRemoved"}},{"kind":"Field","name":{"kind":"Name","value":"useInflationValue"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"hasDeflation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimActsKc2Query, BimActsKc2QueryVariables>;
export const BimRemoveActsKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveActsKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveActsKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveActsKc2Mutation, BimRemoveActsKc2MutationVariables>;
export const BimWorkOrderPriceCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceCodeFilterQuery, BimWorkOrderPriceCodeFilterQueryVariables>;
export const BimWorkOrderPriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceNameFilterQuery, BimWorkOrderPriceNameFilterQueryVariables>;
export const BimWorkOrderPriceObjectNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceObjectNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceObjectNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceObjectNameFilterQuery, BimWorkOrderPriceObjectNameFilterQueryVariables>;
export const BimWorkOrderPriceRowCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceRowCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRowCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceRowCodeFilterQuery, BimWorkOrderPriceRowCodeFilterQueryVariables>;
export const BimWorkOrderPriceRowNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceRowNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceRowNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceRowNameFilterQuery, BimWorkOrderPriceRowNameFilterQueryVariables>;
export const BimWorkOrderObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootsOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rootsOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootsOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderObjectsQuery, BimWorkOrderObjectsQueryVariables>;
export const BimWorkOrderObjectsForListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderObjectsForList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootsOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rootsOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootsOnly"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderObjectsForListQuery, BimWorkOrderObjectsForListQueryVariables>;
export const BimUploadPriceFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUploadPriceFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUploadPriceFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"uploadPriceActs"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUploadPriceFilesMutation, BimUploadPriceFilesMutationVariables>;
export const BimContractSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]} as unknown as DocumentNode<BimContractSeasonsQuery, BimContractSeasonsQueryVariables>;
export const BimWorkOrderSeasonsRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderSeasonsRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderSeasonsRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderSeasonsRangeQuery, BimWorkOrderSeasonsRangeQueryVariables>;
export const BimUpdateWorkOrderSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderSeasonsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderSeasonsMutation, BimUpdateWorkOrderSeasonsMutationVariables>;
export const BimWorkOrderObjectSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderObjectSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectSelectionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectSelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrices"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderObjectSelectionListQuery, BimWorkOrderObjectSelectionListQueryVariables>;
export const BimWorkOrderObjectSelectionListIsIncludedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderObjectSelectionListIsIncluded"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectSelectionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderObjectSelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderObjectSelectionListIsIncludedQuery, BimWorkOrderObjectSelectionListIsIncludedQueryVariables>;
export const BimIncludeContractObjectToWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimIncludeContractObjectToWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIncludeContractObjectToWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIncludeContractObjectToWorkOrderMutation, BimIncludeContractObjectToWorkOrderMutationVariables>;
export const BimExcludeContractObjectFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimExcludeContractObjectFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExcludeContractObjectFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimExcludeContractObjectFromWorkOrderMutation, BimExcludeContractObjectFromWorkOrderMutationVariables>;
export const BimIncludeWorkOrderSeasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimIncludeWorkOrderSeason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIncludeWorkOrderSeason"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIncludeWorkOrderSeasonMutation, BimIncludeWorkOrderSeasonMutationVariables>;
export const BimCompleteStructureFormationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCompleteStructureFormation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCompleteStructureFormation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCompleteStructureFormationMutation, BimCompleteStructureFormationMutationVariables>;
export const BimCreateWorkOrderObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderObjectMutation, BimCreateWorkOrderObjectMutationVariables>;
export const BimCreateWorkOrderSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractSubObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderSubObjectMutation, BimCreateWorkOrderSubObjectMutationVariables>;
export const BimRemoveWorkOrderObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderObjectMutation, BimRemoveWorkOrderObjectMutationVariables>;
export const BimWorkOrderPriceMtrDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceMTRDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceMTRDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceMtrDistributionQuery, BimWorkOrderPriceMtrDistributionQueryVariables>;
export const BimWorkOrderPriceMtrDistributionTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceMTRDistributionTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderPriceMTRDistributionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceMTRDistributionTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceMtrDistributionTotalQuery, BimWorkOrderPriceMtrDistributionTotalQueryVariables>;
export const BimUpdateWorkOrderPriceMtrDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderPriceMTRDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderPriceMTRDistributionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderPriceMTRDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderPriceMtrDistributionMutation, BimUpdateWorkOrderPriceMtrDistributionMutationVariables>;
export const BimWorkOrderChapterDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChapterData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChapterData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"pricesCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChapterDataQuery, BimWorkOrderChapterDataQueryVariables>;
export const BimUpdateWorkOrderSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractSubObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderSubObjectMutation, BimUpdateWorkOrderSubObjectMutationVariables>;
export const BimUpdateWorkOrderObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderObjectMutation, BimUpdateWorkOrderObjectMutationVariables>;
export const BimIncludeAllObjectsToWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimIncludeAllObjectsToWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIncludeAllObjectsToWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIncludeAllObjectsToWorkOrderMutation, BimIncludeAllObjectsToWorkOrderMutationVariables>;
export const BimExcludeAllObjectsFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimExcludeAllObjectsFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExcludeAllObjectsFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimExcludeAllObjectsFromWorkOrderMutation, BimExcludeAllObjectsFromWorkOrderMutationVariables>;
export const BimUploadPriceActsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUploadPriceActs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasTotalsFromXml"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUploadPriceActs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasTotalsFromXml"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasTotalsFromXml"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"uploadPriceActs"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}},{"kind":"Field","name":{"kind":"Name","value":"itemIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUploadPriceActsMutation, BimUploadPriceActsMutationVariables>;
export const BimWorkOrderTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useInPrices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useInPrices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useInPrices"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderTotalsQuery, BimWorkOrderTotalsQueryVariables>;
export const BimWorkOrderSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderSeasonDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderSeasonDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderSeasonsQuery, BimWorkOrderSeasonsQueryVariables>;
export const BimExportWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimExportWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExportWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimExportWorkOrderQuery, BimExportWorkOrderQueryVariables>;
export const BimExportWorkOrderPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimExportWorkOrderPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExportWorkOrderPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimExportWorkOrderPricesQuery, BimExportWorkOrderPricesQueryVariables>;
export const BimActKc2OtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2Other"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2Other"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlanValues"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimActKc2OtherQuery, BimActKc2OtherQueryVariables>;
export const BimCreateActKc2OtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateActKC2Other"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2OtherCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateActKC2Other"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateActKc2OtherMutation, BimCreateActKc2OtherMutationVariables>;
export const BimUpdateActKc2OtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateActKC2Other"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2OtherUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateActKC2Other"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateActKc2OtherMutation, BimUpdateActKc2OtherMutationVariables>;
export const BimRemoveActKc2OtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveActKC2Other"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveActKC2Other"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2OtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2OtherId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveActKc2OtherMutation, BimRemoveActKc2OtherMutationVariables>;
export const BimActKc2OtherDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2OtherDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2OtherDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2OtherDefaultsQuery, BimActKc2OtherDefaultsQueryVariables>;
export const BimWorkOrderPriceStatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderPriceStates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderPriceStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasExcessCompletedTotalSMR"}},{"kind":"Field","name":{"kind":"Name","value":"hasExcessCompletedOthers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderPriceStatesQuery, BimWorkOrderPriceStatesQueryVariables>;
export const BimCalcWorkOrderOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimCalcWorkOrderOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderOtherPriceCalcInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCalcWorkOrderOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCalcWorkOrderOtherDistributionQuery, BimCalcWorkOrderOtherDistributionQueryVariables>;
export const BimWorkOrderChangeObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"isRootObject"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedObject"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedObject"}},{"kind":"Field","name":{"kind":"Name","value":"canSetGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedObject"}},{"kind":"Field","name":{"kind":"Name","value":"hasChildren"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentBasedOrder"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeObjectsQuery, BimWorkOrderChangeObjectsQueryVariables>;
export const BimWorkOrderChangeChapterPriceCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeChapterPriceCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeChapterPriceCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"pricesCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeChapterPriceCountsQuery, BimWorkOrderChangeChapterPriceCountsQueryVariables>;
export const BimWorkOrderChangePriceStatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceStates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasExcessCompletedTotalSMR"}},{"kind":"Field","name":{"kind":"Name","value":"hasExcessCompletedOthers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceStatesQuery, BimWorkOrderChangePriceStatesQueryVariables>;
export const BimRemoveWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderChangeObjectMutation, BimRemoveWorkOrderChangeObjectMutationVariables>;
export const BimWorkOrderChangeOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"includedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemCalculation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectDistribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeOtherDistributionQuery, BimWorkOrderChangeOtherDistributionQueryVariables>;
export const BimUpdateWorkChangeOrderOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkChangeOrderOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherDistributionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkChangeOrderOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkChangeOrderOtherDistributionMutation, BimUpdateWorkChangeOrderOtherDistributionMutationVariables>;
export const BimCalcWorkOrderChangeOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimCalcWorkOrderChangeOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherPriceCalcInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCalcWorkOrderChangeOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCalcWorkOrderChangeOtherDistributionQuery, BimCalcWorkOrderChangeOtherDistributionQueryVariables>;
export const BimWorkOrderChangeOtherDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeOtherData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeOtherData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeOtherDataQuery, BimWorkOrderChangeOtherDataQueryVariables>;
export const BimUpdateWorkOrderChangeOtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeOther"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeOther"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderChangeOtherMutation, BimUpdateWorkOrderChangeOtherMutationVariables>;
export const BimUpdateWorkOrderChangePriceRationaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderChangePriceRationale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceRationaleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderChangePriceRationale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderChangePriceRationaleMutation, BimUpdateWorkOrderChangePriceRationaleMutationVariables>;
export const BimWorkOrderChangeOtherPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeOtherPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherPriceDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherPriceDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeOtherPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"canExcludeRow"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedRow"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedRow"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedRow"}},{"kind":"Field","name":{"kind":"Name","value":"completedOtherDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"canExcludeRow"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeOtherPricesQuery, BimWorkOrderChangeOtherPricesQueryVariables>;
export const BimWorkOrderChangeOtherNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeOtherNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeOtherNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeOtherNameFilterQuery, BimWorkOrderChangeOtherNameFilterQueryVariables>;
export const BimRemoveWorkOrderChangeOthersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderChangeOthers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherPriceIdsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderChangeOthers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderChangeOthersMutation, BimRemoveWorkOrderChangeOthersMutationVariables>;
export const BimExcludeWorkOrderChangeOtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimExcludeWorkOrderChangeOther"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherPriceIdsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExcludeWorkOrderChangeOther"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimExcludeWorkOrderChangeOtherMutation, BimExcludeWorkOrderChangeOtherMutationVariables>;
export const BimWorkOrderChangePricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeRows"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeRows"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeRows"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasRevisions"}},{"kind":"Field","name":{"kind":"Name","value":"hasUpdates"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedRow"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedRow"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedRow"}},{"kind":"Field","name":{"kind":"Name","value":"hasActKC2"}},{"kind":"Field","name":{"kind":"Name","value":"canRemoved"}},{"kind":"Field","name":{"kind":"Name","value":"completedTotalDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePricesQuery, BimWorkOrderChangePricesQueryVariables>;
export const BimRemoveWorkOrderChangePricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrderChangePrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceIdsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrderChangePrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderChangePricesMutation, BimRemoveWorkOrderChangePricesMutationVariables>;
export const BimWorkOrderChangePriceCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceCodeFilterQuery, BimWorkOrderChangePriceCodeFilterQueryVariables>;
export const BimWorkOrderChangePriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceNameFilterQuery, BimWorkOrderChangePriceNameFilterQueryVariables>;
export const BimWorkOrderChangePriceObjectNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceObjectNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceObjectNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceObjectNameFilterQuery, BimWorkOrderChangePriceObjectNameFilterQueryVariables>;
export const BimWorkOrderChangePriceRationaleFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceRationaleFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceRationaleFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceRationaleFilterQuery, BimWorkOrderChangePriceRationaleFilterQueryVariables>;
export const BimWorkOrderChangePriceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceRowsQuery, BimWorkOrderChangePriceRowsQueryVariables>;
export const BimWorkOrderChangePriceRevisionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePriceRevisions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceRevisionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangePriceRevisionDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePriceRevisions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRevisionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"priceUpdateDate"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePriceRevisionsQuery, BimWorkOrderChangePriceRevisionsQueryVariables>;
export const BimWorkOrderChangeOtherSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeOtherSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherSelectionDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeOtherSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeOtherSelectionListQuery, BimWorkOrderChangeOtherSelectionListQueryVariables>;
export const BimAddWorkOrderChangeOthersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimAddWorkOrderChangeOthers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeOtherInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimAddWorkOrderChangeOthers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimAddWorkOrderChangeOthersMutation, BimAddWorkOrderChangeOthersMutationVariables>;
export const BimUploadPriceFilesForWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUploadPriceFilesForWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rationale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUploadPriceFilesForWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"rationale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rationale"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemIds"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUploadPriceFilesForWorkOrderChangeMutation, BimUploadPriceFilesForWorkOrderChangeMutationVariables>;
export const BimExportWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimExportWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExportWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimExportWorkOrderChangeQuery, BimExportWorkOrderChangeQueryVariables>;
export const BimWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeQuery, BimWorkOrderChangeQueryVariables>;
export const BimWorkOrderChangeTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useInPrices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeTotalItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeTotalItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useInPrices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useInPrices"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeTotalsQuery, BimWorkOrderChangeTotalsQueryVariables>;
export const BimWorkOrderChangeObjectSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeObjectSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeObjectSelectionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeObjectSelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrices"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeObjectSelectionListQuery, BimWorkOrderChangeObjectSelectionListQueryVariables>;
export const BimWorkOrderChangeObjectSelectionListIsIncludedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeObjectSelectionListIsIncluded"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeObjectSelectionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeObjectSelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeObjectSelectionListIsIncludedQuery, BimWorkOrderChangeObjectSelectionListIsIncludedQueryVariables>;
export const BimWorkOrderChangeSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeSeasonsQuery, BimWorkOrderChangeSeasonsQueryVariables>;
export const BimIncludeContractObjectToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimIncludeContractObjectToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIncludeContractObjectToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimIncludeContractObjectToWorkOrderChangeMutation, BimIncludeContractObjectToWorkOrderChangeMutationVariables>;
export const BimExcludeContractObjectFromWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimExcludeContractObjectFromWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExcludeContractObjectFromWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimExcludeContractObjectFromWorkOrderChangeMutation, BimExcludeContractObjectFromWorkOrderChangeMutationVariables>;
export const BimCreateWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderChangeObjectMutation, BimCreateWorkOrderChangeObjectMutationVariables>;
export const BimCreateWorkOrderChangeSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderChangeSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractSubObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderChangeSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderChangeSubObjectMutation, BimCreateWorkOrderChangeSubObjectMutationVariables>;
export const BimUpdateWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderChangeObjectMutation, BimUpdateWorkOrderChangeObjectMutationVariables>;
export const BimUpdateWorkOrderChangeSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractSubObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderChangeSubObjectMutation, BimUpdateWorkOrderChangeSubObjectMutationVariables>;
export const BimUpdateWorkOrderChangeSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderChangeSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderChangeSeasonsMutation, BimUpdateWorkOrderChangeSeasonsMutationVariables>;
export const BimWorkOrderChangeLastSeasonSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeLastSeasonSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeLastSeasonSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeLastSeasonSelectionListQuery, BimWorkOrderChangeLastSeasonSelectionListQueryVariables>;
export const BimWorkOrderChangeConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeConstructionTypesQuery, BimWorkOrderChangeConstructionTypesQueryVariables>;
export const BimWorkOrderChangeDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"seasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeDefaultsQuery, BimWorkOrderChangeDefaultsQueryVariables>;
export const BimIsUniqueWorkOrderChangeInternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimIsUniqueWorkOrderChangeInternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimIsUniqueWorkOrderChangeInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<BimIsUniqueWorkOrderChangeInternalNumberQuery, BimIsUniqueWorkOrderChangeInternalNumberQueryVariables>;
export const BimCreateWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderChangeMutation, BimCreateWorkOrderChangeMutationVariables>;
export const BimUpdateWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderChangeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateWorkOrderChangeMutation, BimUpdateWorkOrderChangeMutationVariables>;
export const BimWorkOrderVersionSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionSeasonsQuery, BimWorkOrderVersionSeasonsQueryVariables>;
export const BimWorkOrderVersionConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionConstructionTypesQuery, BimWorkOrderVersionConstructionTypesQueryVariables>;
export const BimActKc2VersionTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2VersionTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionTotalItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionTotalItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2VersionTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2VersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionActiveSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"isInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitPrice"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2VersionTotalsQuery, BimActKc2VersionTotalsQueryVariables>;
export const BimActKc2VersionPriceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2VersionPriceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionPriceRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionPriceRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2VersionPriceRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2VersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"inactiveMtr"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2VersionPriceRowsQuery, BimActKc2VersionPriceRowsQueryVariables>;
export const BimActsKc2VersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActsKC2Version"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActsKC2Version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calcMethod"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentPriceTotal"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"month"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimActsKc2VersionQuery, BimActsKc2VersionQueryVariables>;
export const BimWorkOrderVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionListItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionsQuery, BimWorkOrderVersionsQueryVariables>;
export const BimWorkOrderVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"remainder"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSigningDate"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"seasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionQuery, BimWorkOrderVersionQueryVariables>;
export const BimWorkOrderVersionObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionObjectDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionObjectDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionObjectsQuery, BimWorkOrderVersionObjectsQueryVariables>;
export const BimWorkOrderVersionOtherPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionOtherPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionOtherPriceDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionOtherPriceDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionOtherPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC2OtherCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"costPlan"}},{"kind":"Field","name":{"kind":"Name","value":"costAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedOtherDeviation"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionOtherPricesQuery, BimWorkOrderVersionOtherPricesQueryVariables>;
export const BimWorkOrderVersionPriceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceRowsQuery, BimWorkOrderVersionPriceRowsQueryVariables>;
export const BimWorkOrderVersionPriceRowCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRowCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRowCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceRowCodeFilterQuery, BimWorkOrderVersionPriceRowCodeFilterQueryVariables>;
export const BimWorkOrderVersionPriceRowNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRowNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRowNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceRowNameFilterQuery, BimWorkOrderVersionPriceRowNameFilterQueryVariables>;
export const BimWorkOrderVersionPriceCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceCodeFilterQuery, BimWorkOrderVersionPriceCodeFilterQueryVariables>;
export const BimWorkOrderVersionPriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceNameFilterQuery, BimWorkOrderVersionPriceNameFilterQueryVariables>;
export const BimWorkOrderVersionPriceObjectNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceObjectNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceObjectNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceObjectNameFilterQuery, BimWorkOrderVersionPriceObjectNameFilterQueryVariables>;
export const BimWorkOrderVersionPriceRevisionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRevisionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRevisionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceRevisionNameFilterQuery, BimWorkOrderVersionPriceRevisionNameFilterQueryVariables>;
export const BimWorkOrderVersionPriceRevisionCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRevisionCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRevisionTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceRevisionCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"revisionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revisionType"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceRevisionCodeFilterQuery, BimWorkOrderVersionPriceRevisionCodeFilterQueryVariables>;
export const BimActsKc2VersionOtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActsKC2VersionOther"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionOtherItemDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimActKC2VersionOtherItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActsKC2VersionOther"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimActsKc2VersionOtherQuery, BimActsKc2VersionOtherQueryVariables>;
export const BimActKc2VersionOtherTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2VersionOtherTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionOtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2VersionOtherTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2VersionOtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionOtherId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"isInflation"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionActiveSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}}]}}]}}]}}]} as unknown as DocumentNode<BimActKc2VersionOtherTotalsQuery, BimActKc2VersionOtherTotalsQueryVariables>;
export const BimActKc2VersionOtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimActKC2VersionOther"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionOtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimActKC2VersionOther"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2VersionOtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2VersionOtherId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlanValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimActKc2VersionOtherQuery, BimActKc2VersionOtherQueryVariables>;
export const BimWorkOrderVersionTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useInPrices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimPriceLevelEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"useInPrices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useInPrices"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainderValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mp"}},{"kind":"Field","name":{"kind":"Name","value":"mz"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"others"}},{"kind":"Field","name":{"kind":"Name","value":"oz"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"smrTotal"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tzr"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionTotalsQuery, BimWorkOrderVersionTotalsQueryVariables>;
export const BimWorkOrderVersionChapterPriceCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionChapterPriceCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionChapterPriceCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionRootObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"pricesCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionChapterPriceCountsQuery, BimWorkOrderVersionChapterPriceCountsQueryVariables>;
export const BimWorkOrderVersionPriceStatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionPriceStates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionPriceStates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasExcessCompletedTotalSMR"}},{"kind":"Field","name":{"kind":"Name","value":"hasExcessCompletedOthers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionPriceStatesQuery, BimWorkOrderVersionPriceStatesQueryVariables>;
export const BimCreateWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkOrderChangeRequired"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderMutation, BimCreateWorkOrderMutationVariables>;
export const BimRemoveWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimRemoveWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimRemoveWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<BimRemoveWorkOrderMutation, BimRemoveWorkOrderMutationVariables>;
export const BimDeleteWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimDeleteWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimDeleteWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<BimDeleteWorkOrderChangeMutation, BimDeleteWorkOrderChangeMutationVariables>;
export const UerWorkOrderUsersSelectionListCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderUsersSelectionListCodeFilterQuery, UerWorkOrderUsersSelectionListCodeFilterQueryVariables>;
export const UerWorkOrderUsersSelectionListNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderUsersSelectionListNameFilterQuery, UerWorkOrderUsersSelectionListNameFilterQueryVariables>;
export const UerWorkOrderUsersSelectionListGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderUsersSelectionListGroupFilterQuery, UerWorkOrderUsersSelectionListGroupFilterQueryVariables>;
export const UerWorkOrderUsersSelectionListSectionFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListSectionFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderUsersSelectionListSectionFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderUsersSelectionListSectionFilterQuery, UerWorkOrderUsersSelectionListSectionFilterQueryVariables>;
export const GlobalOtherCostsForContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"globalOtherCostsForContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerGlobalOtherCostsForContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]} as unknown as DocumentNode<GlobalOtherCostsForContractQuery, GlobalOtherCostsForContractQueryVariables>;
export const UerCreateContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateContractOtherCostMutation, UerCreateContractOtherCostMutationVariables>;
export const UerCreateContractOtherCostFromCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateContractOtherCostFromCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCreateFromCatalogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateContractOtherCostFromCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"createInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateContractOtherCostFromCatalogMutation, UerCreateContractOtherCostFromCatalogMutationVariables>;
export const UerIsUniqueContractOtherCostKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueContractOtherCostKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueContractOtherCostKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueContractOtherCostKeyQuery, UerIsUniqueContractOtherCostKeyQueryVariables>;
export const BimGlobalOtherCostsForContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimGlobalOtherCostsForContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimGlobalOtherCostsForContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimGlobalOtherCostsForContractQuery, BimGlobalOtherCostsForContractQueryVariables>;
export const BimCreateContractConditionOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateContractConditionOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractConditionOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateContractConditionOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateContractConditionOtherCostMutation, BimCreateContractConditionOtherCostMutationVariables>;
export const BimCreateWorkOrderOtherFromCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostFromCatalogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderOtherFromCatalogMutation, BimCreateWorkOrderOtherFromCatalogMutationVariables>;
export const BimCreateWorkOrderOtherFromInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromInput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderOtherFromInputMutation, BimCreateWorkOrderOtherFromInputMutationVariables>;
export const BimCreateWorkOrderOtherFromCatalogForActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromCatalogForAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostFromCatalogInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromCatalogForAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderOtherFromCatalogForActMutation, BimCreateWorkOrderOtherFromCatalogForActMutationVariables>;
export const BimCreateWorkOrderOtherFromInputForActDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromInputForAct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderOtherFromInputForAct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderOtherFromInputForActMutation, BimCreateWorkOrderOtherFromInputForActMutationVariables>;
export const BimCreateWorkOrderChangeOtherFromCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderChangeOtherFromCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostFromCatalogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderChangeOtherFromCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderChangeOtherFromCatalogMutation, BimCreateWorkOrderChangeOtherFromCatalogMutationVariables>;
export const BimCreateWorkOrderChangeOtherFromInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimCreateWorkOrderChangeOtherFromInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimCreateWorkOrderChangeOtherFromInput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimCreateWorkOrderChangeOtherFromInputMutation, BimCreateWorkOrderChangeOtherFromInputMutationVariables>;
export const UerUpdateContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractOtherCostMutation, UerUpdateContractOtherCostMutationVariables>;
export const UerUpdateContractOtherCostToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractOtherCostToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractOtherCostToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractOtherCostToWorkOrderFromPriceListMutation, UerUpdateContractOtherCostToWorkOrderFromPriceListMutationVariables>;
export const UerUpdateContractOtherCostFromCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractOtherCostFromCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractOtherCostFromCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractOtherCostFromCatalogMutation, UerUpdateContractOtherCostFromCatalogMutationVariables>;
export const UerUpdateOtherCostToActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateOtherCostToActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateOtherCostToActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateOtherCostToActKc2Mutation, UerUpdateOtherCostToActKc2MutationVariables>;
export const UerContractOtherCostForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editConstructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostForUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"editConstructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editConstructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"canUseOtherSpans"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"canEditSection"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canEditCalculationType"}},{"kind":"Field","name":{"kind":"Name","value":"canEditCalculationTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"canEditLimits"}},{"kind":"Field","name":{"kind":"Name","value":"canEditName"}},{"kind":"Field","name":{"kind":"Name","value":"canEditType"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"groupConstructionLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEditConstructionType"}},{"kind":"Field","name":{"kind":"Name","value":"canEditCost"}},{"kind":"Field","name":{"kind":"Name","value":"canEditDistributionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"canEditLimit"}},{"kind":"Field","name":{"kind":"Name","value":"canEditLimitSpan"}},{"kind":"Field","name":{"kind":"Name","value":"canExclude"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"linkageStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isFormulaEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostForUpdateQuery, UerContractOtherCostForUpdateQueryVariables>;
export const UerContractOtherCostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostTypesQuery, UerContractOtherCostTypesQueryVariables>;
export const BimContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimContractOtherCostQuery, BimContractOtherCostQueryVariables>;
export const BimUpdateContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimUpdateContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimUpdateContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimUpdateContractOtherCostMutation, BimUpdateContractOtherCostMutationVariables>;
export const BimContractOtherCostTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractOtherCostTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractOtherCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimContractOtherCostTypesQuery, BimContractOtherCostTypesQueryVariables>;
export const BimModifyContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimModifyContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostModifyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimModifyContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimModifyContractOtherCostMutation, BimModifyContractOtherCostMutationVariables>;
export const UerModifyContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerModifyContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherModifyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerModifyContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerModifyContractOtherCostMutation, UerModifyContractOtherCostMutationVariables>;
export const BimContractOtherCostViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractOtherCostView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimContractOtherCostViewQuery, BimContractOtherCostViewQueryVariables>;
export const BimWorkOrderOtherDataViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderOtherDataView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderOtherData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderOtherDataViewQuery, BimWorkOrderOtherDataViewQueryVariables>;
export const BimWorkOrderVersionOtherDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderVersionOtherData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderVersionOtherData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderVersionOtherDataQuery, BimWorkOrderVersionOtherDataQueryVariables>;
export const UerContractOtherCostViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostForUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupConstructionLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"canEditLimitSpan"}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostViewQuery, UerContractOtherCostViewQueryVariables>;
export const BimWorkOrderChangeOtherDataViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangeOtherDataView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangeOtherData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangeOtherDataViewQuery, BimWorkOrderChangeOtherDataViewQueryVariables>;
export const GetUerContractHasOthersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUerContractHasOthers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasOthers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetUerContractHasOthersQuery, GetUerContractHasOthersQueryVariables>;
export const UerContractOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCostItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCostItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relationStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInActKc2"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostsQuery, UerContractOtherCostsQueryVariables>;
export const UerDeleteContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerDeleteContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerDeleteContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerDeleteContractOtherCostMutation, UerDeleteContractOtherCostMutationVariables>;
export const BimContractOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimContractOtherCostItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInActKc2"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimContractOtherCostsQuery, BimContractOtherCostsQueryVariables>;
export const BimDeleteContractOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bimDeleteContractOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimDeleteContractOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimDeleteContractOtherCostMutation, BimDeleteContractOtherCostMutationVariables>;
export const BimContractOtherCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractOtherCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractOtherCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BimContractOtherCostNameFilterQuery, BimContractOtherCostNameFilterQueryVariables>;
export const UerRemoveUnusedContractOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveUnusedContractOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveUnusedContractOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveUnusedContractOtherCostsMutation, UerRemoveUnusedContractOtherCostsMutationVariables>;
export const UerContractOtherCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostNameFilterQuery, UerContractOtherCostNameFilterQueryVariables>;
export const UerContractOtherCostCalculatingTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostCalculatingTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfOtherCostCalculationTypeEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfOtherCostCalculationTypeEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostCalculatingTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostCalculatingTypeFilterQuery, UerContractOtherCostCalculatingTypeFilterQueryVariables>;
export const UerContractOtherCostStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfContractOtherStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfContractOtherStatusEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostStatusFilterQuery, UerContractOtherCostStatusFilterQueryVariables>;
export const UerContractOtherRelationStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherRelationStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfContractOtherConstructionTypeRelationStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfContractOtherConstructionTypeRelationStatusEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherRelationStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherRelationStatusFilterQuery, UerContractOtherRelationStatusFilterQueryVariables>;
export const UerContractConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractConstructionTypesQuery, UerContractConstructionTypesQueryVariables>;
export const BimContractConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimContractConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimContractConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimContractConstructionTypesQuery, BimContractConstructionTypesQueryVariables>;
export const CatalogOtherCostVariableSelectionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogOtherCostVariableSelectionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostVariableSelectionItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"Argument","name":{"kind":"Name","value":"globalOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"globalOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"dataSourceId"}},{"kind":"Field","name":{"kind":"Name","value":"dataSourceName"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"otherTypeUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobal"}}]}}]}}]}}]} as unknown as DocumentNode<CatalogOtherCostVariableSelectionItemsQuery, CatalogOtherCostVariableSelectionItemsQueryVariables>;
export const GetContractSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getContractSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetContractSeasonsQuery, GetContractSeasonsQueryVariables>;
export const UerExportWorkOrderChangeAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportWorkOrderChangeAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportWorkOrderChangeAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportWorkOrderChangeAsExcelQuery, UerExportWorkOrderChangeAsExcelQueryVariables>;
export const BimExportWorkOrderChangeAnalyticsAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimExportWorkOrderChangeAnalyticsAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimExportWorkOrderChangeAnalyticsAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BimExportWorkOrderChangeAnalyticsAsExcelQuery, BimExportWorkOrderChangeAnalyticsAsExcelQueryVariables>;
export const BimWorkOrderChangePreviousVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bimWorkOrderChangePreviousVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BimWorkOrderVersionListItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bimWorkOrderChangePreviousVersionsAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BimWorkOrderChangePreviousVersionsQuery, BimWorkOrderChangePreviousVersionsQueryVariables>;
export const UerExportWorkOrderChangeAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportWorkOrderChangeAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportWorkOrderChangeAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportWorkOrderChangeAnalyticsQuery, UerExportWorkOrderChangeAnalyticsQueryVariables>;
export const UerWorkOrderChangePreviousVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePreviousVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionListItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePreviousVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePreviousVersionsQuery, UerWorkOrderChangePreviousVersionsQueryVariables>;
export const CopyProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"copyProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CopyProjectMutation, CopyProjectMutationVariables>;
export const CreateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStageEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStatusEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectMethodologyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectContractTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"methodology"},"value":{"kind":"Variable","name":{"kind":"Name","value":"methodology"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const ProjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"priceNMC"}},{"kind":"Field","name":{"kind":"Name","value":"lotPrice"}},{"kind":"Field","name":{"kind":"Name","value":"actualPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOwn"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"contractType"}},{"kind":"Field","name":{"kind":"Name","value":"contractUniqueId"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsQuery, ProjectsQueryVariables>;
export const ProjectsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsNameFilterQuery, ProjectsNameFilterQueryVariables>;
export const ProjectsMethodologyFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsMethodologyFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfProjectMethodologyEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsMethodologyFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsMethodologyFilterQuery, ProjectsMethodologyFilterQueryVariables>;
export const ProjectsStageFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsStageFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfProjectStageEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsStageFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsStageFilterQuery, ProjectsStageFilterQueryVariables>;
export const ProjectsStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfProjectStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsStatusFilterQuery, ProjectsStatusFilterQueryVariables>;
export const ProjectsAuthoredByFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsAuthoredByFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsAuthoredByFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsAuthoredByFilterQuery, ProjectsAuthoredByFilterQueryVariables>;
export const ProjectsSubsidiaryFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"projectsSubsidiaryFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCompanyDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectsSubsidiaryFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProjectsSubsidiaryFilterQuery, ProjectsSubsidiaryFilterQueryVariables>;
export const UpdateProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStageEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectStatusEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectContractTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const IsUniqueProjectCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUniqueProjectCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isUniqueProjectCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<IsUniqueProjectCodeQuery, IsUniqueProjectCodeQueryVariables>;
export const UerContractActsKc3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractActsKC3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3RegistryItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3RegistryItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractActsKC3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Date"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2FullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2ReportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2ReportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Status"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2TotalCost"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2TotalCostWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3CanDelete"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3CanEdit"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3CorrectionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3Date"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3FromWorkStartCost"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3FromYearStartCost"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3FullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3Id"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3IsCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3IsInactive"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3Number"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3ReportedPeriodCost"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3ReportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3ReportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC3TotalCostWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"isFinal"}},{"kind":"Field","name":{"kind":"Name","value":"rootContractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractActsKc3Query, UerContractActsKc3QueryVariables>;
export const UerContractActsKc3FullNumberFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractActsKC3FullNumberFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractActsKC3FullNumberFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractActsKc3FullNumberFilterQuery, UerContractActsKc3FullNumberFilterQueryVariables>;
export const UerContractActsKc3DateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractActsKC3DateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateOnlyFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractActsKC3DateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractActsKc3DateFilterQuery, UerContractActsKc3DateFilterQueryVariables>;
export const UerRemoveActsKc3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveActsKC3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveActsKC3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveActsKc3Mutation, UerRemoveActsKc3MutationVariables>;
export const UerContractCommonDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractCommonData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractCommonData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractNavigation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderNavs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Navs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractCommonDataQuery, UerContractCommonDataQueryVariables>;
export const UerChangeActKc3LevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerChangeActKC3Level"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Level"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3LevelEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerChangeActKC3Level"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Level"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerChangeActKc3LevelMutation, UerChangeActKc3LevelMutationVariables>;
export const UerActKc3TotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3Totals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3Totals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"startWorkCost"}},{"kind":"Field","name":{"kind":"Name","value":"startYearCost"}},{"kind":"Field","name":{"kind":"Name","value":"reportingPeriodCost"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3TotalsQuery, UerActKc3TotalsQueryVariables>;
export const UerIsUniqueActKc3InternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueActKC3InternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueActKC3InternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Number"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueActKc3InternalNumberQuery, UerIsUniqueActKc3InternalNumberQueryVariables>;
export const UerCreateActKc3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateActKC3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateActKC3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateActKc3Mutation, UerCreateActKc3MutationVariables>;
export const UerUpdateActKc3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateActKC3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3UpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateActKC3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateActKc3Mutation, UerUpdateActKc3MutationVariables>;
export const UerActKc3ActsKc2SelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2SelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3ActsKC2SelectionItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC3ActsKC2SelectionItemSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2SelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2CorrectionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2CostGroup"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Date"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2FinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2FullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2IsCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2IsCorrectionOfActKC3"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2IsIncludedToPrimaryActKC3"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2IsInactive"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Number"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Status"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeShortName"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderInternalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderName"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderStatus"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSubject"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2SelectionListQuery, UerActKc3ActsKc2SelectionListQueryVariables>;
export const UerActKc3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Ids"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3Query, UerActKc3QueryVariables>;
export const UerExportActKc3AsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportActKC3AsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOtherDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportActKC3AsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeOtherDetails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOtherDetails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportActKc3AsExcelQuery, UerExportActKc3AsExcelQueryVariables>;
export const UerActKc3ActsKc2ActKc2NumberFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2ActKC2NumberFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueContainerOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueContainerOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2ActKC2NumberFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2ActKc2NumberFilterQuery, UerActKc3ActsKc2ActKc2NumberFilterQueryVariables>;
export const UerActKc3ActsKc2ActKc2DateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2ActKC2DateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateOnlyFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateOnlySortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2ActKC2DateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2ActKc2DateFilterQuery, UerActKc3ActsKc2ActKc2DateFilterQueryVariables>;
export const UerActKc3ActsKc2ActKc2CostGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2ActKC2CostGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCostGroupEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCostGroupEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2ActKC2CostGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2ActKc2CostGroupFilterQuery, UerActKc3ActsKc2ActKc2CostGroupFilterQueryVariables>;
export const UerActKc3ActsKc2ConstructionTypeIdFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2ConstructionTypeIdFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfInt32FilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfInt32SortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2ConstructionTypeIdFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2ConstructionTypeIdFilterQuery, UerActKc3ActsKc2ConstructionTypeIdFilterQueryVariables>;
export const UerActKc3ActsKc2ContractObjectNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2ContractObjectNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2ContractObjectNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2ContractObjectNameFilterQuery, UerActKc3ActsKc2ContractObjectNameFilterQueryVariables>;
export const UerActKc3ActsKc2WorkOrderInternalNumberFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC3ActsKC2WorkOrderInternalNumberFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC3ActsKC2WorkOrderInternalNumberFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootContractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootContractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc3ActsKc2WorkOrderInternalNumberFilterQuery, UerActKc3ActsKc2WorkOrderInternalNumberFilterQueryVariables>;
export const UerIsValidActKc3DateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsValidActKC3Date"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsValidActKC3Date"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC3Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC3Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsValidActKc3DateQuery, UerIsValidActKc3DateQueryVariables>;
export const UerPriceListRatioForIncludingToContractChangeCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChangeCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChangeCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioForIncludingToContractChangeCodeFilterQuery, UerPriceListRatioForIncludingToContractChangeCodeFilterQueryVariables>;
export const UerPriceListRatioForIncludingToContractChangeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChangeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChangeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioForIncludingToContractChangeNameFilterQuery, UerPriceListRatioForIncludingToContractChangeNameFilterQueryVariables>;
export const UerPriceListRatioForIncludingToContractChangeStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChangeStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfRatioRecordStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChangeStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioForIncludingToContractChangeStatusFilterQuery, UerPriceListRatioForIncludingToContractChangeStatusFilterQueryVariables>;
export const UerContractChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractChangeItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractChangeItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChanges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uerRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"mtrRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"ratioRowCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractChangesQuery, UerContractChangesQueryVariables>;
export const UerContractChangeSubjectFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeSubjectFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeSubjectFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeSubjectFilterQuery, UerContractChangeSubjectFilterQueryVariables>;
export const UerContractChangeInternalNumberFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeInternalNumberFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeInternalNumberFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeInternalNumberFilterQuery, UerContractChangeInternalNumberFilterQueryVariables>;
export const UerContractChangeSigningDateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeSigningDateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateTimeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeSigningDateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeSigningDateFilterQuery, UerContractChangeSigningDateFilterQueryVariables>;
export const UerContractChangeCreatedAtFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeCreatedAtFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfDateTimeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeCreatedAtFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeCreatedAtFilterQuery, UerContractChangeCreatedAtFilterQueryVariables>;
export const UerContractChangeStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfContractChangeStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeStatusFilterQuery, UerContractChangeStatusFilterQueryVariables>;
export const UerCreateContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractChangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UerCreateContractChangeMutation, UerCreateContractChangeMutationVariables>;
export const UerUpdateContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractChangeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractChangeMutation, UerUpdateContractChangeMutationVariables>;
export const UerContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uerRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"mtrRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"otherRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"ratioRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeQuery, UerContractChangeQueryVariables>;
export const UerDeleteContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerDeleteContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerDeleteContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerDeleteContractChangeMutation, UerDeleteContractChangeMutationVariables>;
export const UerIsUniqueContractChangeInternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueContractChangeInternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueContractChangeInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueContractChangeInternalNumberQuery, UerIsUniqueContractChangeInternalNumberQueryVariables>;
export const UerContractChangePriceListMtrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangePriceListMtr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangePriceListMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"mtrSupplyAndType"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicateNeighbours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractChangePriceListMtrQuery, UerContractChangePriceListMtrQueryVariables>;
export const UerAddMtrsToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddMtrsToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddMtrsToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddMtrsToContractChangeMutation, UerAddMtrsToContractChangeMutationVariables>;
export const UerPriceListMtrForIncludingToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrForIncludingToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrForIncludingToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"mtrSupplyAndType"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicateNeighbours"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrForIncludingToContractChangeQuery, UerPriceListMtrForIncludingToContractChangeQueryVariables>;
export const UerContractChangeMtrCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrCodeFilterQuery, UerContractChangeMtrCodeFilterQueryVariables>;
export const UerContractChangeMtrNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrNameFilterQuery, UerContractChangeMtrNameFilterQueryVariables>;
export const UerContractChangeMtrUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrUnitFilterQuery, UerContractChangeMtrUnitFilterQueryVariables>;
export const UerContractChangeMtrSupplyByFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrSupplyByFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrSupplyByFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrSupplyByFilterQuery, UerContractChangeMtrSupplyByFilterQueryVariables>;
export const UerContractChangeMtrStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrStatusFilterQuery, UerContractChangeMtrStatusFilterQueryVariables>;
export const UerContractChangeMtrJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrJustificationFilterQuery, UerContractChangeMtrJustificationFilterQueryVariables>;
export const UerContractChangePriceListUerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangePriceListUer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangePriceListUer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeRelationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"workKind"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractChangePriceListUerQuery, UerContractChangePriceListUerQueryVariables>;
export const UerAddUersToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUersToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUersToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddUersToContractChangeMutation, UerAddUersToContractChangeMutationVariables>;
export const UerPriceListUerForIncludingToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForIncludingToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForIncludingToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"linkStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForIncludingToContractChangeQuery, UerPriceListUerForIncludingToContractChangeQueryVariables>;
export const UerContractChangeUerCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerCodeFilterQuery, UerContractChangeUerCodeFilterQueryVariables>;
export const UerContractChangeUerAndWorkScopeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerAndWorkScopeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerAndWorkScopeNameDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerAndWorkScopeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"isWorkScope"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerAndWorkScopeNameFilterQuery, UerContractChangeUerAndWorkScopeNameFilterQueryVariables>;
export const UerContractChangeUerTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerTypeFilterQuery, UerContractChangeUerTypeFilterQueryVariables>;
export const UerContractChangeUerChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerChapterFilterQuery, UerContractChangeUerChapterFilterQueryVariables>;
export const UerContractChangeUerStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerStatusFilterQuery, UerContractChangeUerStatusFilterQueryVariables>;
export const UerContractChangeUerJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerJustificationFilterQuery, UerContractChangeUerJustificationFilterQueryVariables>;
export const UerExportContractChangeAnalyticsAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportContractChangeAnalyticsAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeToCompareWithId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceListType"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListTypeEnum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportContractChangeAnalyticsAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeToCompareWithId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeToCompareWithId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceListType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceListType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportContractChangeAnalyticsAsExcelQuery, UerExportContractChangeAnalyticsAsExcelQueryVariables>;
export const UerContractChangePriceListRatioRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangePriceListRatioRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioCoefficientRowDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioCoefficientRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangePriceListRatioRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractChangePriceListRatioRowsQuery, UerContractChangePriceListRatioRowsQueryVariables>;
export const UerRatioRowForIncludingToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioRowForIncludingToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractRatioRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioRowForIncludingToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupIsArtificial"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerRatioRowForIncludingToContractChangeQuery, UerRatioRowForIncludingToContractChangeQueryVariables>;
export const UerPriceListRatioForIncludingToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioForIncludingToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioForIncludingToContractChangeQuery, UerPriceListRatioForIncludingToContractChangeQueryVariables>;
export const UerAddRatiosToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddRatiosToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddRatiosToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddRatiosToContractChangeMutation, UerAddRatiosToContractChangeMutationVariables>;
export const UerContractChangeRatioWorkConditionsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioWorkConditionsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioWorkConditionsFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioWorkConditionsFilterQuery, UerContractChangeRatioWorkConditionsFilterQueryVariables>;
export const UerContractChangeRatioWorkTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioWorkTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioWorkTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioWorkTypeFilterQuery, UerContractChangeRatioWorkTypeFilterQueryVariables>;
export const UerContractChangeRatioStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioStatusFilterQuery, UerContractChangeRatioStatusFilterQueryVariables>;
export const UerRemoveUersFromContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveUersFromContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveUersFromContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveUersFromContractChangeMutation, UerRemoveUersFromContractChangeMutationVariables>;
export const UerRemoveMtrsFromContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveMtrsFromContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveMtrsFromContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveMtrsFromContractChangeMutation, UerRemoveMtrsFromContractChangeMutationVariables>;
export const UerRemoveRatiosFromContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveRatiosFromContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveRatiosFromContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveRatiosFromContractChangeMutation, UerRemoveRatiosFromContractChangeMutationVariables>;
export const UerContractChangeUerForIncludingNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingNameFilterQuery, UerContractChangeUerForIncludingNameFilterQueryVariables>;
export const UerContractChangeUerForIncludingCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingCodeFilterQuery, UerContractChangeUerForIncludingCodeFilterQueryVariables>;
export const UerContractChangeUerForIncludingLinkStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingLinkStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfPriceConstructionTypeRelationStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingLinkStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingLinkStatusFilterQuery, UerContractChangeUerForIncludingLinkStatusFilterQueryVariables>;
export const UerContractChangeUerForIncludingStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfUerRecordStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingStatusFilterQuery, UerContractChangeUerForIncludingStatusFilterQueryVariables>;
export const UerContractChangeUerForIncludingUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingUnitFilterQuery, UerContractChangeUerForIncludingUnitFilterQueryVariables>;
export const UerContractChangeMtrForIncludingCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrForIncludingCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrForIncludingCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrForIncludingCodeFilterQuery, UerContractChangeMtrForIncludingCodeFilterQueryVariables>;
export const UerContractChangeMtrForIncludingNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrForIncludingNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrForIncludingNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrForIncludingNameFilterQuery, UerContractChangeMtrForIncludingNameFilterQueryVariables>;
export const UerContractChangeMtrForIncludingUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeMtrForIncludingUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeMtrForIncludingUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeMtrForIncludingUnitFilterQuery, UerContractChangeMtrForIncludingUnitFilterQueryVariables>;
export const UerContractChangeRatioForIncludingCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioForIncludingCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioForIncludingCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioForIncludingCodeFilterQuery, UerContractChangeRatioForIncludingCodeFilterQueryVariables>;
export const UerContractChangeRatioForIncludingWorkConditionsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioForIncludingWorkConditionsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioForIncludingWorkConditionsFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioForIncludingWorkConditionsFilterQuery, UerContractChangeRatioForIncludingWorkConditionsFilterQueryVariables>;
export const UerContractChangeRatioForIncludingStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioForIncludingStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfRatioRecordStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioForIncludingStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioForIncludingStatusFilterQuery, UerContractChangeRatioForIncludingStatusFilterQueryVariables>;
export const UerContractChangeRatioSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioSectionNameFilterQuery, UerContractChangeRatioSectionNameFilterQueryVariables>;
export const UerContractChangeUerSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerSectionNameFilterQuery, UerContractChangeUerSectionNameFilterQueryVariables>;
export const UerContractChangeUerGroupFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerGroupFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerGroupFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerGroupFullNameFilterQuery, UerContractChangeUerGroupFullNameFilterQueryVariables>;
export const UerContractChangeUerWorkTypeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerWorkTypeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerWorkTypeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerWorkTypeNameFilterQuery, UerContractChangeUerWorkTypeNameFilterQueryVariables>;
export const UerContractChangeUerWorkTypeInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerWorkTypeInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkInSumEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerWorkTypeInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerWorkTypeInSumFilterQuery, UerContractChangeUerWorkTypeInSumFilterQueryVariables>;
export const UerContractChangeUerNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerNameFilterQuery, UerContractChangeUerNameFilterQueryVariables>;
export const UerContractChangeRatioGroupFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioGroupFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioGroupFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioGroupFullNameFilterQuery, UerContractChangeRatioGroupFullNameFilterQueryVariables>;
export const UerContractChangeRatioAppliesToCodeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioAppliesToCodeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioAppliesToCodeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioAppliesToCodeNameFilterQuery, UerContractChangeRatioAppliesToCodeNameFilterQueryVariables>;
export const UerContractChangeRatioCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioCodeFilterQuery, UerContractChangeRatioCodeFilterQueryVariables>;
export const UerContractChangeRatioAppliesToLinkStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeRatioAppliesToLinkStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfRatioRecordStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeRatioAppliesToLinkStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeRatioAppliesToLinkStatusFilterQuery, UerContractChangeRatioAppliesToLinkStatusFilterQueryVariables>;
export const UerContractChangeUerForIncludingSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingSectionNameFilterQuery, UerContractChangeUerForIncludingSectionNameFilterQueryVariables>;
export const UerContractChangeUerForIncludingGroupFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeUerForIncludingGroupFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeUerForIncludingGroupFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractChangeUerForIncludingGroupFullNameFilterQuery, UerContractChangeUerForIncludingGroupFullNameFilterQueryVariables>;
export const UerContractChangeOtherCostRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeOtherCostRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCostItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCostItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeOtherCostRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInActKc2"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractChangeOtherCostRowsQuery, UerContractChangeOtherCostRowsQueryVariables>;
export const UerContractChangeOtherCostRowsForIncludingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractChangeOtherCostRowsForIncluding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCostItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherCostItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractChangeOtherCostRowsForIncluding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInActKc2"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerContractChangeOtherCostRowsForIncludingQuery, UerContractChangeOtherCostRowsForIncludingQueryVariables>;
export const UerAddOthersToContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddOthersToContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddOthersToContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddOthersToContractChangeMutation, UerAddOthersToContractChangeMutationVariables>;
export const UerRemoveOtherCostsFromContractChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveOtherCostsFromContractChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveOtherCostsFromContractChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractOtherCostIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractOtherCostIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveOtherCostsFromContractChangeMutation, UerRemoveOtherCostsFromContractChangeMutationVariables>;
export const UerOthersForIncludingToContractChangeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerOthersForIncludingToContractChangeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerOthersForIncludingToContractChangeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerOthersForIncludingToContractChangeNameFilterQuery, UerOthersForIncludingToContractChangeNameFilterQueryVariables>;
export const UerOthersForIncludingToContractChangeCalculatingTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerOthersForIncludingToContractChangeCalculatingTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfOtherCostCalculationTypeEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfOtherCostCalculationTypeEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerOthersForIncludingToContractChangeCalculatingTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerOthersForIncludingToContractChangeCalculatingTypeFilterQuery, UerOthersForIncludingToContractChangeCalculatingTypeFilterQueryVariables>;
export const UercCalculationLimitedCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationLimitedCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationLimitedCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationLimitedCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationLimitedCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingValue"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCalculationLimitedCostsQuery, UercCalculationLimitedCostsQueryVariables>;
export const UercCalculationLimitedCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationLimitedCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationLimitedCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationLimitedCostNameFilterQuery, UercCalculationLimitedCostNameFilterQueryVariables>;
export const UercRemoveCalculationLimitedCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveCalculationLimitedCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveCalculationLimitedCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UercRemoveCalculationLimitedCostsMutation, UercRemoveCalculationLimitedCostsMutationVariables>;
export const UercGlobalLimitedCostsForCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercGlobalLimitedCostsForCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalLimitedCostDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercGlobalLimitedCostsForCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]} as unknown as DocumentNode<UercGlobalLimitedCostsForCalculationQuery, UercGlobalLimitedCostsForCalculationQueryVariables>;
export const UercCalculationLimitedCostTypesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationLimitedCostTypesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogLimitedCostTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationLimitedCostTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCalculationLimitedCostTypesQueryQuery, UercCalculationLimitedCostTypesQueryQueryVariables>;
export const IsUercCalculationLimitedCostCodeUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUercCalculationLimitedCostCodeUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsCalculationLimitedCostCodeUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","alias":{"kind":"Name","value":"isUnique"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IsUercCalculationLimitedCostCodeUniqueQuery, IsUercCalculationLimitedCostCodeUniqueQueryVariables>;
export const UercIsCalculationLimitedCostNameUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercIsCalculationLimitedCostNameUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsCalculationLimitedCostNameUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","alias":{"kind":"Name","value":"isUnique"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UercIsCalculationLimitedCostNameUniqueQuery, UercIsCalculationLimitedCostNameUniqueQueryVariables>;
export const UercCreateCalculationLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCalculationLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationLimitedCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCalculationLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UercCreateCalculationLimitedCostMutation, UercCreateCalculationLimitedCostMutationVariables>;
export const UercUpdateCalculationLimitedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCalculationLimitedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationLimitedCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCalculationLimitedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingValue"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"globalLimitedCostId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UercUpdateCalculationLimitedCostMutation, UercUpdateCalculationLimitedCostMutationVariables>;
export const UercCalculationLimitedCostForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationLimitedCostForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editConstructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationLimitedCostForUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"editConstructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editConstructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogLimitedCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"globalLimitedCostId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationLimitedCostForUpdateQuery, UercCalculationLimitedCostForUpdateQueryVariables>;
export const UercCollectionMtrItemsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"showUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMtrUersItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"showUsers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"showUsers"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitBaseCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCurrentCost"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionrateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"mtrKind"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedFromUERBaseCosts"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedFromUERBaseCosts"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasWOR"}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInTransportCalculation"}},{"kind":"Field","name":{"kind":"Name","value":"uers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionMtrItemsQueryQuery, UercCollectionMtrItemsQueryQueryVariables>;
export const UercCollectionMtrItemValuesTotalsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemValuesTotalsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemValuesTotalsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeShortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionMtrItemValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"seasonsData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrice"}},{"kind":"Field","name":{"kind":"Name","value":"seasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"totalGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalNotGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalVolume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasons"}}]}}]}}]} as unknown as DocumentNode<UercCollectionMtrItemValuesTotalsQueryQuery, UercCollectionMtrItemValuesTotalsQueryQueryVariables>;
export const UercCollectionMtrTotalsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrTotalsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionMtrTotalsQuery"},"name":{"kind":"Name","value":"uercCollectionMtrItemValuesTotalsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionMtrTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"material"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionMtrTotalsQueryQuery, UercCollectionMtrTotalsQueryQueryVariables>;
export const UercCollectionMtrItemCodeFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemCodeFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemCodeFilterQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codes"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<UercCollectionMtrItemCodeFilterQueryQuery, UercCollectionMtrItemCodeFilterQueryQueryVariables>;
export const UercCollectionMtrItemNameFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemNameFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemNameFilterQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<UercCollectionMtrItemNameFilterQueryQuery, UercCollectionMtrItemNameFilterQueryQueryVariables>;
export const UercCollectionMtrItemSupplyByFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemSupplyByFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemSupplyByFilterQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<UercCollectionMtrItemSupplyByFilterQueryQuery, UercCollectionMtrItemSupplyByFilterQueryQueryVariables>;
export const UercCollectionMtrItemMtrTypeFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemMtrTypeFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemMtrTypeFilterQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<UercCollectionMtrItemMtrTypeFilterQueryQuery, UercCollectionMtrItemMtrTypeFilterQueryQueryVariables>;
export const UercCollectionMtrItemPricingTypeFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemPricingTypeFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemPricingTypeFilterQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<UercCollectionMtrItemPricingTypeFilterQueryQuery, UercCollectionMtrItemPricingTypeFilterQueryQueryVariables>;
export const UercCreateCollectionMtrMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCollectionMtrMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollectionMtrInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCollectionMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCollectionMtrMutationMutation, UercCreateCollectionMtrMutationMutationVariables>;
export const UercUpdateCollectionMtrMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCollectionMtrMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCollectionMtrInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCollectionMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCollectionMtrMutationMutation, UercUpdateCollectionMtrMutationMutationVariables>;
export const UercUpdateCollectionMtrUnitCurrentPriceMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCollectionMtrUnitCurrentPriceMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCollectionMtrUnitCurrentPriceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCollectionMtrUnitCurrentPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionMtrItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitBaseCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCurrentCost"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionrateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"mtrKind"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedFromUERBaseCosts"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedFromUERBaseCosts"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasWOR"}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInTransportCalculation"}},{"kind":"Field","name":{"kind":"Name","value":"uers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCollectionMtrUnitCurrentPriceMutationMutation, UercUpdateCollectionMtrUnitCurrentPriceMutationMutationVariables>;
export const UercRemoveCollectionMtrMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveCollectionMtrMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveCollectionMtrInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveCollectionMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveCollectionMtrMutationMutation, UercRemoveCollectionMtrMutationMutationVariables>;
export const UercRemoveUnusedCollectionMtrMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveUnusedCollectionMtrMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveUnusedCollectionMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveUnusedCollectionMtrMutationMutation, UercRemoveUnusedCollectionMtrMutationMutationVariables>;
export const UercExportCollectionMtrAsExcelQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercExportCollectionMtrAsExcelQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercExportCollectionMtrAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercExportCollectionMtrAsExcelQueryQuery, UercExportCollectionMtrAsExcelQueryQueryVariables>;
export const UercCollectionMtrSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCurrentCost"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}}]}}]}}]} as unknown as DocumentNode<UercCollectionMtrSelectionListQuery, UercCollectionMtrSelectionListQueryVariables>;
export const UercReplaceCollectionMtrItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercReplaceCollectionMtrItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReplaceCollectionMtrItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercReplaceCollectionMtrItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercReplaceCollectionMtrItemMutation, UercReplaceCollectionMtrItemMutationVariables>;
export const UercImportCollectionMtrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportCollectionMtr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportCollectionMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercImportCollectionMtrMutation, UercImportCollectionMtrMutationVariables>;
export const UercUpdateIsIncludedInTransportCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateIsIncludedInTransportCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIsIncludedInTransportCalculationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateIsIncludedInTransportCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateIsIncludedInTransportCalculationMutation, UercUpdateIsIncludedInTransportCalculationMutationVariables>;
export const UercGlobalOtherCostsForCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercGlobalOtherCostsForCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalOtherCostDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercGlobalOtherCostsForCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"methodology"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}}]}}]}}]}}]} as unknown as DocumentNode<UercGlobalOtherCostsForCalculationQuery, UercGlobalOtherCostsForCalculationQueryVariables>;
export const UercCreateCalculationOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCalculationOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCalculationOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UercCreateCalculationOtherCostMutation, UercCreateCalculationOtherCostMutationVariables>;
export const UercUpdateCalculationOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCalculationOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCalculationOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UercUpdateCalculationOtherCostMutation, UercUpdateCalculationOtherCostMutationVariables>;
export const UercCalculationOtherCostForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationOtherCostForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"editConstructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationOtherCostForUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"editConstructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"editConstructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"distributionMethod"}},{"kind":"Field","name":{"kind":"Name","value":"totalCostLimit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"globalOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormula"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculatingParticipation"}},{"kind":"Field","name":{"kind":"Name","value":"isLimitsTotalFromFile"}},{"kind":"Field","name":{"kind":"Name","value":"isManualLimitsDistribution"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationOtherCostForUpdateQuery, UercCalculationOtherCostForUpdateQueryVariables>;
export const UercCalculationOtherCostTypesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationOtherCostTypesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogOtherCostTypeDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationOtherCostTypesQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCalculationOtherCostTypesQueryQuery, UercCalculationOtherCostTypesQueryQueryVariables>;
export const UercCalculationOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationOtherCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationOtherCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"globalOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasToDistributeLimitsBySeasonsManualy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCalculationOtherCostsQuery, UercCalculationOtherCostsQueryVariables>;
export const UercRemoveCalculationOtherCostsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveCalculationOtherCosts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationOtherCostIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveCalculationOtherCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationOtherCostIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationOtherCostIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<UercRemoveCalculationOtherCostsMutation, UercRemoveCalculationOtherCostsMutationVariables>;
export const UercCalculationOtherCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationOtherCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationOtherCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationOtherCostNameFilterQuery, UercCalculationOtherCostNameFilterQueryVariables>;
export const CatalogUerOtherCostTemplateFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUEROtherCostTemplateFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUEROtherCostTemplateFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<CatalogUerOtherCostTemplateFilesQuery, CatalogUerOtherCostTemplateFilesQueryVariables>;
export const IsUercCalculationOtherCostCodeUniqueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"isUercCalculationOtherCostCodeUnique"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsCalculationOtherCostCodeUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","alias":{"kind":"Name","value":"isUnique"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<IsUercCalculationOtherCostCodeUniqueQuery, IsUercCalculationOtherCostCodeUniqueQueryVariables>;
export const UercCalculationComputedDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationComputeRowFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"computedCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalVolume"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedDataQuery, UercCalculationComputedDataQueryVariables>;
export const UercComputeCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercComputeCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorUerSortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercComputeCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercComputeCalculationMutation, UercComputeCalculationMutationVariables>;
export const UercCalculationComputedTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guaranteedVolume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nonguaranteedVolume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedTotalsQuery, UercCalculationComputedTotalsQueryVariables>;
export const UercCalculationComputedRowsChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedRowsChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedRowsChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedRowsChapterFilterQuery, UercCalculationComputedRowsChapterFilterQueryVariables>;
export const UercCalculationComputedRowsCodeExtendedFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedRowsCodeExtendedFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkVolumeItemCodeFilterDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedRowsCodeExtendedFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedRowsCodeExtendedFilterQuery, UercCalculationComputedRowsCodeExtendedFilterQueryVariables>;
export const UercCalculationComputedRowsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedRowsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedRowsNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedRowsNameFilterQuery, UercCalculationComputedRowsNameFilterQueryVariables>;
export const UercCalculationComputedRowsWorkInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedRowsWorkInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedRowsWorkInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedRowsWorkInSumFilterQuery, UercCalculationComputedRowsWorkInSumFilterQueryVariables>;
export const UercCalculationComputedRowsWorkNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationComputedRowsWorkNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationComputedRowsWorkNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"guaranteedVolume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guaranteedVolume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationComputedRowsWorkNameFilterQuery, UercCalculationComputedRowsWorkNameFilterQueryVariables>;
export const UercReorderCalculationComputedUerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercReorderCalculationComputedUer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"movedComputedCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeAfterComputedCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercReorderCalculationComputedUer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"movedComputedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"movedComputedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"placeAfterComputedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeAfterComputedCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercReorderCalculationComputedUerMutation, UercReorderCalculationComputedUerMutationVariables>;
export const UercUpdateComputedCostWorkRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateComputedCostWorkRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"computedCostId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateComputedCostWorkRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"computedCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computedCostId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratio"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"computedCostId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalVolume"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateComputedCostWorkRatioMutation, UercUpdateComputedCostWorkRatioMutationVariables>;
export const UercExportPrintFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercExportPrintForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContragentTypeEnum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercExportPrintForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"modes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}}]}}]}}]}}]} as unknown as DocumentNode<UercExportPrintFormQuery, UercExportPrintFormQueryVariables>;
export const UercImportEstimateBasisFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportEstimateBasisFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostImportFilesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportEstimateBasisFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"files"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercImportEstimateBasisFilesMutation, UercImportEstimateBasisFilesMutationVariables>;
export const UercImportUerBaseCostCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportUerBaseCostCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"copyRatios"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportUerBaseCostCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"copyRatios"},"value":{"kind":"Variable","name":{"kind":"Name","value":"copyRatios"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercImportUerBaseCostCollectionMutation, UercImportUerBaseCostCollectionMutationVariables>;
export const UercCalculationCatalogInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationCatalogInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogUerBase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationCatalogInfoQuery, UercCalculationCatalogInfoQueryVariables>;
export const UercCheckConstructionTypesToAddUersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCheckConstructionTypesToAddUers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCheckConstructionTypesToAddUers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculationConstructionType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCheckConstructionTypesToAddUersQuery, UercCheckConstructionTypesToAddUersQueryVariables>;
export const UercFindUersToAddDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercFindUersToAdd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercFindUersToAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"ids"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercFindUersToAddQuery, UercFindUersToAddQueryVariables>;
export const UercAddUersToCollectionUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercAddUersToCollectionUERBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUersToCollectionUERBaseCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercAddUersToCollectionUERBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercAddUersToCollectionUerBaseCostMutation, UercAddUersToCollectionUerBaseCostMutationVariables>;
export const UercUersToAddConstructionTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercUersToAddConstructionTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUersToAddConstructionTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercUersToAddConstructionTypeFilterQuery, UercUersToAddConstructionTypeFilterQueryVariables>;
export const UercUersToAddSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercUersToAddSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUersToAddSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercUersToAddSectionNameFilterQuery, UercUersToAddSectionNameFilterQueryVariables>;
export const UercUersToAddCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercUersToAddCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUersToAddCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercUersToAddCodeFilterQuery, UercUersToAddCodeFilterQueryVariables>;
export const UercUersToAddGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercUersToAddGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUersToAddGroupNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercUersToAddGroupNameFilterQuery, UercUersToAddGroupNameFilterQueryVariables>;
export const UercUersToAddNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercUersToAddNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUersToAddNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUerBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUerBaseUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationConstructionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationConstructionTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercUersToAddNameFilterQuery, UercUersToAddNameFilterQueryVariables>;
export const CatalogUersToAddItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogUersToAddItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogUERBaseCostDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogUersToAddItemsQuery, CatalogUersToAddItemsQueryVariables>;
export const UercCopyCollectionUerBaseCostsFromCatalogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCopyCollectionUERBaseCostsFromCatalog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCopyCollectionUERBaseCostsFromCatalog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCopyCollectionUerBaseCostsFromCatalogMutation, UercCopyCollectionUerBaseCostsFromCatalogMutationVariables>;
export const UercRemoveAllCollectionUerBaseCostRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveAllCollectionUERBaseCostRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveAllCollectionUERBaseCostRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveAllCollectionUerBaseCostRowsMutation, UercRemoveAllCollectionUerBaseCostRowsMutationVariables>;
export const UercImportCollectionUerBaseCostWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportCollectionUerBaseCostWorkTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportCollectionUerBaseCostWorkTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<UercImportCollectionUerBaseCostWorkTypesMutation, UercImportCollectionUerBaseCostWorkTypesMutationVariables>;
export const UerCollectionUerBaseCostWorkScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostWorkScopes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostWorkScopeDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostWorkScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostWorkScopesQuery, UerCollectionUerBaseCostWorkScopesQueryVariables>;
export const UerCollectionUerBaseCostEstimateBasisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostEstimateBasis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostEstimateBasisDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostEstimateBasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}}]}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostEstimateBasisQuery, UerCollectionUerBaseCostEstimateBasisQueryVariables>;
export const UerCollectionUerBaseCostEstimateBasisResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostEstimateBasisResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostEstimateBasisDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostEstimateBasisResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}}]}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostEstimateBasisResourceQuery, UerCollectionUerBaseCostEstimateBasisResourceQueryVariables>;
export const UercCollectionUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimateBasisSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"estimateBasisRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionRateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTotal"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRateMtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"directCost"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"fot"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"workType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratioGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostQuery, UercCollectionUerBaseCostQueryVariables>;
export const UercUpdateCollectionUerBaseCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCollectionUERBaseCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCollectionUERBaseCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCollectionUerBaseCostMutation, UercUpdateCollectionUerBaseCostMutationVariables>;
export const UercCalculationConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<UercCalculationConstructionTypesQuery, UercCalculationConstructionTypesQueryVariables>;
export const UercParseUerBaseCostBasisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercParseUerBaseCostBasis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercParseUerBaseCostBasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"directCost"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionRateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"vr2001"}},{"kind":"Field","name":{"kind":"Name","value":"naclMask"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTotal"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRateMtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fot"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"general"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercParseUerBaseCostBasisQuery, UercParseUerBaseCostBasisQueryVariables>;
export const UercCollectionRatioGroupsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioGroupsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioGroupsQueryQuery, UercCollectionRatioGroupsQueryQueryVariables>;
export const CollectionRatiosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionRatios"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionRatios"},"name":{"kind":"Name","value":"uercCollectionRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CollectionRatiosQuery, CollectionRatiosQueryVariables>;
export const CollectionRatioCodeFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionRatioCodeFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionRatioCodeFilterQuery"},"name":{"kind":"Name","value":"uercCollectionRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CollectionRatioCodeFilterQueryQuery, CollectionRatioCodeFilterQueryQueryVariables>;
export const CollectionRatioNameFilterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionRatioNameFilterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"collectionRatioNameFilterQuery"},"name":{"kind":"Name","value":"uercCollectionRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CollectionRatioNameFilterQueryQuery, CollectionRatioNameFilterQueryQueryVariables>;
export const UerCollectionUerBaseCostItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeNames"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"workType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasRatios"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostItemsQuery, UerCollectionUerBaseCostItemsQueryVariables>;
export const UercCollectionUerBaseCostSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostSectionNameFilterQuery, UercCollectionUerBaseCostSectionNameFilterQueryVariables>;
export const UercCollectionUerBaseCostStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostStatusFilterQuery, UercCollectionUerBaseCostStatusFilterQueryVariables>;
export const UercCollectionUerBaseCostGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostGroupNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostGroupNameFilterQuery, UercCollectionUerBaseCostGroupNameFilterQueryVariables>;
export const UercCollectionUerBaseCostCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostCodeFilterQuery, UercCollectionUerBaseCostCodeFilterQueryVariables>;
export const UercCollectionUerBaseCostNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostNameFilterQuery, UercCollectionUerBaseCostNameFilterQueryVariables>;
export const UercCollectionUerBaseCostChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostChapterFilterQuery, UercCollectionUerBaseCostChapterFilterQueryVariables>;
export const UercCollectionUerBaseCostUerClassifierFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostUerClassifierFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerClassifierEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfUerClassifierEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostUerClassifierFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostUerClassifierFilterQuery, UercCollectionUerBaseCostUerClassifierFilterQueryVariables>;
export const UercCollectionUerBaseCostWorkNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostWorkNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostWorkNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostWorkNameFilterQuery, UercCollectionUerBaseCostWorkNameFilterQueryVariables>;
export const UercCollectionUerBaseCostWorkInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostWorkInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkInSumEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkInSumEnumSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostWorkInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostWorkInSumFilterQuery, UercCollectionUerBaseCostWorkInSumFilterQueryVariables>;
export const UercCollectionUerBaseCostEstimateBasisRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostEstimateBasisRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostEstimateBasisRowFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostEstimateBasisRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTotal"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"isNotCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isSectionHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parentRowId"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"rowId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitWorkCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tm"}},{"kind":"Field","name":{"kind":"Name","value":"tz"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostEstimateBasisRowsQuery, UercCollectionUerBaseCostEstimateBasisRowsQueryVariables>;
export const UercCollectionUerBaseCostTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasIndent"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostTotalsQuery, UercCollectionUerBaseCostTotalsQueryVariables>;
export const UercRemoveCollectionUerBaseCostRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveCollectionUERBaseCostRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveCollectionUERBaseCostRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"baseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveCollectionUerBaseCostRowsMutation, UercRemoveCollectionUerBaseCostRowsMutationVariables>;
export const UercCalculationCollectionUerInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationCollectionUerInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionUerInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataSource"}},{"kind":"Field","name":{"kind":"Name","value":"pricesWithoutUerClassifierOrChapterCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatalogPrices"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorItems"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationCollectionUerInfoQuery, UercCalculationCollectionUerInfoQueryVariables>;
export const UerGetCollectionUerBaseCostWorkScopesForUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerGetCollectionUERBaseCostWorkScopesForUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostWorkScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UerGetCollectionUerBaseCostWorkScopesForUpdateQuery, UerGetCollectionUerBaseCostWorkScopesForUpdateQueryVariables>;
export const UerUpdateCollectionUerBaseCostWorkScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateCollectionUERBaseCostWorkScopes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostWorkScopeUpdateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCollectionUERBaseCostWorkScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"baseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateCollectionUerBaseCostWorkScopesMutation, UerUpdateCollectionUerBaseCostWorkScopesMutationVariables>;
export const UercSetCollectionUerBaseCostRowPropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercSetCollectionUERBaseCostRowProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERBaseCostSetPropertiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercSetCollectionUERBaseCostRowProperties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercSetCollectionUerBaseCostRowPropertiesMutation, UercSetCollectionUerBaseCostRowPropertiesMutationVariables>;
export const UercCalculationDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"projectUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"taxPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationDefaultsQuery, UercCalculationDefaultsQueryVariables>;
export const UercCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCalculationObjects"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"catalogUerBase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasWorkKind"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costRounding"}},{"kind":"Field","name":{"kind":"Name","value":"changeDate"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coefficients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kemm"}},{"kind":"Field","name":{"kind":"Name","value":"keqp"}},{"kind":"Field","name":{"kind":"Name","value":"kmtr"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"kpir"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uerOtherPercent"}},{"kind":"Field","name":{"kind":"Name","value":"usedInObjects"}},{"kind":"Field","name":{"kind":"Name","value":"usedInOthers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"projectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonsInflation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inflationRate"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCalculationExecuted"}},{"kind":"Field","name":{"kind":"Name","value":"lastComputedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCalculationQuery, UercCalculationQueryVariables>;
export const UercCreateCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCalculationMutation, UercCreateCalculationMutationVariables>;
export const UercUpdateCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UercCalculationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCalculation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCalculationMutation, UercUpdateCalculationMutationVariables>;
export const UercCalculationObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeWBS"}},{"kind":"Field","name":{"kind":"Name","value":"calculationId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"iconCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorItems"}}]}}]}}]} as unknown as DocumentNode<UercCalculationObjectsQuery, UercCalculationObjectsQueryVariables>;
export const UercCreateCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCalculationObjectMutation, UercCreateCalculationObjectMutationVariables>;
export const UercCreateCalculationSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCalculationSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationSubObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCalculationSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCalculationSubObjectMutation, UercCreateCalculationSubObjectMutationVariables>;
export const UercRemoveCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveCalculationObjectMutation, UercRemoveCalculationObjectMutationVariables>;
export const UercIsUniqueCalculationObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercIsUniqueCalculationObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsUniqueCalculationObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercIsUniqueCalculationObjectNameQuery, UercIsUniqueCalculationObjectNameQueryVariables>;
export const UercIsUniqueCalculationSubObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercIsUniqueCalculationSubObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsUniqueCalculationSubObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"subObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercIsUniqueCalculationSubObjectNameQuery, UercIsUniqueCalculationSubObjectNameQueryVariables>;
export const UercIsUniqueCalculationObjectCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercIsUniqueCalculationObjectCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsUniqueCalculationObjectCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UercIsUniqueCalculationObjectCodeQuery, UercIsUniqueCalculationObjectCodeQueryVariables>;
export const UercUpdateCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCalculationObjectMutation, UercUpdateCalculationObjectMutationVariables>;
export const UercUpdateCalculationSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCalculationSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCalculationSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCalculationSubObjectMutation, UercUpdateCalculationSubObjectMutationVariables>;
export const UercSetCalculationObjectGuaranteedVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercSetCalculationObjectGuaranteedVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectGuaranteedVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercSetCalculationObjectGuaranteedVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercSetCalculationObjectGuaranteedVolumeMutation, UercSetCalculationObjectGuaranteedVolumeMutationVariables>;
export const UercImportCalculationObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportCalculationObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportCalculationObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercImportCalculationObjectsMutation, UercImportCalculationObjectsMutationVariables>;
export const UercMoveCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercMoveCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newParentObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertAfterObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercMoveCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newParentObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newParentObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"insertAfterObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertAfterObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercMoveCalculationObjectMutation, UercMoveCalculationObjectMutationVariables>;
export const UercCalculationObjectsWithVolumesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCalculationObjectsWithVolumes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationObjectsWithVolumes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}}]}}]}}]} as unknown as DocumentNode<UercCalculationObjectsWithVolumesQuery, UercCalculationObjectsWithVolumesQueryVariables>;
export const UercCopyCalculationObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCopyCalculationObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalculationObjectCopyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCopyCalculationObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UercCopyCalculationObjectMutation, UercCopyCalculationObjectMutationVariables>;
export const UercCollectionRatiosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatios"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataForListFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"isUsed"}},{"kind":"Field","name":{"kind":"Name","value":"hasCosts"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatiosQuery, UercCollectionRatiosQueryVariables>;
export const UercCollectionRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uerBaseCostItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionRatioGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"uerBaseCostItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioQuery, UercCollectionRatioQueryVariables>;
export const UercCollectionUerBaseCostItemsHavingRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsHavingRatioQuery, UercCollectionUerBaseCostItemsHavingRatioQueryVariables>;
export const UercCollectionUerBaseCostItemsHavingRatioNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsHavingRatioNameFilterQuery, UercCollectionUerBaseCostItemsHavingRatioNameFilterQueryVariables>;
export const UercCollectionRatioCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioCodeFilterQuery, UercCollectionRatioCodeFilterQueryVariables>;
export const UercCollectionRatioNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioNameFilterQuery, UercCollectionRatioNameFilterQueryVariables>;
export const UercCollectionRatioGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioGroupFilterQuery, UercCollectionRatioGroupFilterQueryVariables>;
export const UercCollectionRatioTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioTypeFilterQuery, UercCollectionRatioTypeFilterQueryVariables>;
export const UercCollectionRatioStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioStatusFilterQuery, UercCollectionRatioStatusFilterQueryVariables>;
export const UercCollectionRatioJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioJustificationFilterQuery, UercCollectionRatioJustificationFilterQueryVariables>;
export const UercCatalogRatiosNotInCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCatalogRatiosNotInCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCatalogRatiosNotInCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCatalogRatiosNotInCollectionQuery, UercCatalogRatiosNotInCollectionQueryVariables>;
export const UercCatalogRatiosNotInCollectionRatioGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCatalogRatiosNotInCollectionRatioGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCatalogRatiosNotInCollectionRatioGroupFilter"},"name":{"kind":"Name","value":"uercCatalogRatiosNotInCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCatalogRatiosNotInCollectionRatioGroupFilterQuery, UercCatalogRatiosNotInCollectionRatioGroupFilterQueryVariables>;
export const UercCatalogRatiosNotInCollectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCatalogRatiosNotInCollectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCatalogRatiosNotInCollectionNameFilter"},"name":{"kind":"Name","value":"uercCatalogRatiosNotInCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCatalogRatiosNotInCollectionNameFilterQuery, UercCatalogRatiosNotInCollectionNameFilterQueryVariables>;
export const UercCatalogRatiosNotInCollectionCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCatalogRatiosNotInCollectionCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogRatioDataFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCatalogRatiosNotInCollectionCodeFilter"},"name":{"kind":"Name","value":"uercCatalogRatiosNotInCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCatalogRatiosNotInCollectionCodeFilterQuery, UercCatalogRatiosNotInCollectionCodeFilterQueryVariables>;
export const UercCopyCatalogRatiosToCollectionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCopyCatalogRatiosToCollectionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogRatioIdList"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCopyCatalogRatiosToCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogRatioIdList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogRatioIdList"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UercCopyCatalogRatiosToCollectionMutationMutation, UercCopyCatalogRatiosToCollectionMutationMutationVariables>;
export const UercIsCollectionRatioNameUniqueQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercIsCollectionRatioNameUniqueQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercIsCollectionRatioNameUnique"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UercIsCollectionRatioNameUniqueQueryQuery, UercIsCollectionRatioNameUniqueQueryQueryVariables>;
export const UercCollectionRatioGroupsWithCostsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionRatioGroupsWithCostsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionRatioGroupsWithCosts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"uerBaseCostItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionRatioGroupsWithCostsQueryQuery, UercCollectionRatioGroupsWithCostsQueryQueryVariables>;
export const UercRemoveCollectionRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveCollectionRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveCollectionRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveCollectionRatioMutation, UercRemoveCollectionRatioMutationVariables>;
export const UercCollectionUerBaseCostItemsHavingRatioGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsHavingRatioGroupQuery, UercCollectionUerBaseCostItemsHavingRatioGroupQueryVariables>;
export const UercCollectionUerBaseCostItemsHavingRatioGroupTotalCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroupTotalCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroupTotalCount"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsHavingRatioGroupTotalCountQuery, UercCollectionUerBaseCostItemsHavingRatioGroupTotalCountQueryVariables>;
export const UercCollectionUerBaseCostItemsHavingRatioGroupCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroupCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroupCodeFilter"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsHavingRatioGroupCodeFilterQuery, UercCollectionUerBaseCostItemsHavingRatioGroupCodeFilterQueryVariables>;
export const UercCollectionUerBaseCostItemsHavingRatioGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroupNameFilter"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsHavingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionRatioGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionRatioGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsHavingRatioGroupNameFilterQuery, UercCollectionUerBaseCostItemsHavingRatioGroupNameFilterQueryVariables>;
export const UerCollectionUerBaseCostItemsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostItemsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostItemsListQuery, UerCollectionUerBaseCostItemsListQueryVariables>;
export const UerCollectionUerBaseCostItemsCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostItemsCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsCodeFilter"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostItemsCodeFilterQuery, UerCollectionUerBaseCostItemsCodeFilterQueryVariables>;
export const UerCollectionUerBaseCostItemsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCollectionUERBaseCostItemsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsNameFilter"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerCollectionUerBaseCostItemsNameFilterQuery, UerCollectionUerBaseCostItemsNameFilterQueryVariables>;
export const UercCreateCollectionRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCollectionRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCollectionRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCollectionRatioMutation, UercCreateCollectionRatioMutationVariables>;
export const UercUpdateCollectionRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCollectionRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCollectionRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}}]}}]}}]} as unknown as DocumentNode<UercUpdateCollectionRatioMutation, UercUpdateCollectionRatioMutationVariables>;
export const UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupQuery, UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupQueryVariables>;
export const UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupCodeFilter"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCodeFilterQuery, UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupCodeFilterQueryVariables>;
export const UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemMinimalFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroupNameFilter"},"name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsForAddingToDismantlingRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupNameFilterQuery, UercCollectionUerBaseCostItemsForAddingToDismantlingRatioGroupNameFilterQueryVariables>;
export const UercWorkVolumeItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeItemDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mtrConsumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"mtrRowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ratioRowId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"uerRowId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedFromUERBaseCosts"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"formulaError"}},{"kind":"Field","name":{"kind":"Name","value":"hasInconsistentWorVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"worRowId"}},{"kind":"Field","name":{"kind":"Name","value":"summationDetails"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemsQuery, UercWorkVolumeItemsQueryVariables>;
export const UercWorkVolumeObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"hasInconsistentWorVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"hasFormulaErrorVolumes"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeObjectsQuery, UercWorkVolumeObjectsQueryVariables>;
export const UercWorkVolumeItemUerSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemUerSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemUerSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemUerSectionNameFilterQuery, UercWorkVolumeItemUerSectionNameFilterQueryVariables>;
export const UercWorkVolumeItemCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemCodeFilterQuery, UercWorkVolumeItemCodeFilterQueryVariables>;
export const UercWorkVolumeItemCodeExtendedFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemCodeExtendedFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkVolumeItemCodeFilterDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemCodeExtendedFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemCodeExtendedFilterQuery, UercWorkVolumeItemCodeExtendedFilterQueryVariables>;
export const UercWorkVolumeItemNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemNameFilterQuery, UercWorkVolumeItemNameFilterQueryVariables>;
export const UercWorkVolumeItemUerGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemUerGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemUerGroupNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemUerGroupNameFilterQuery, UercWorkVolumeItemUerGroupNameFilterQueryVariables>;
export const UercWorkVolumeItemUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemUnitFilterQuery, UercWorkVolumeItemUnitFilterQueryVariables>;
export const UercAddCostsToWorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercAddCostsToWor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"costIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercAddCostsToWor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"costIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"costIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercAddCostsToWorMutation, UercAddCostsToWorMutationVariables>;
export const UercCollectionUerBaseCostItemsToAddToWorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWOR"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWOR"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsToAddToWorQuery, UercCollectionUerBaseCostItemsToAddToWorQueryVariables>;
export const UercWorkVolumeMtrSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeMtrSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worParentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionMtrItemShortFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeMtrSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worParentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeMtrSelectionListQuery, UercWorkVolumeMtrSelectionListQueryVariables>;
export const UercWorkVolumeMtrSelectionListNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeMtrSelectionListNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeMtrSelectionListNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeMtrSelectionListNameFilterQuery, UercWorkVolumeMtrSelectionListNameFilterQueryVariables>;
export const UercWorkVolumeMtrSelectionListCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeMtrSelectionListCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeMtrSelectionListCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeMtrSelectionListCodeFilterQuery, UercWorkVolumeMtrSelectionListCodeFilterQueryVariables>;
export const UercCollectionMtrItemQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionMtrItemQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionMtrItemQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitBaseCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCurrentCost"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsumptionrateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"mtrKind"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdatedFromUERBaseCosts"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInTransportCalculation"}},{"kind":"Field","name":{"kind":"Name","value":"isRecommended"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionMtrItemQueryQuery, UercCollectionMtrItemQueryQueryVariables>;
export const UercAddMtrsToWorkVolumeFromCollectionMtrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercAddMtrsToWorkVolumeFromCollectionMTR"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCollectionMtrToWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercAddMtrsToWorkVolumeFromCollectionMTR"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercAddMtrsToWorkVolumeFromCollectionMtrMutation, UercAddMtrsToWorkVolumeFromCollectionMtrMutationVariables>;
export const UercUpdateCollectionMtrToWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercUpdateCollectionMtrToWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCollectionMtrToWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercUpdateCollectionMtrToWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercUpdateCollectionMtrToWorkVolumeMutation, UercUpdateCollectionMtrToWorkVolumeMutationVariables>;
export const UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERToAddToWorFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterQuery, UercCollectionUerBaseCostItemsToAddToWorSectionNameFilterQueryVariables>;
export const UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERToAddToWorFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorGroupNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterQuery, UercCollectionUerBaseCostItemsToAddToWorGroupNameFilterQueryVariables>;
export const UercCollectionUerBaseCostItemsToAddToWorNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERToAddToWorFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsToAddToWorNameFilterQuery, UercCollectionUerBaseCostItemsToAddToWorNameFilterQueryVariables>;
export const UercCollectionUerBaseCostItemsToAddToWorCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUERToAddToWorFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCollectionUERBaseCostItemsToAddToWorCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercCollectionUerBaseCostItemsToAddToWorCodeFilterQuery, UercCollectionUerBaseCostItemsToAddToWorCodeFilterQueryVariables>;
export const UercWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeQuery, UercWorkVolumeQueryVariables>;
export const UercCreateCollectionRatioToWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCollectionRatioToWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollectionRatioToWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCollectionRatioToWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCollectionRatioToWorkVolumeMutation, UercCreateCollectionRatioToWorkVolumeMutationVariables>;
export const UercWorkVolumeRatiosSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosSelectionListQuery, UercWorkVolumeRatiosSelectionListQueryVariables>;
export const UercWorkVolumeRatiosSelectionListNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionListNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionListNameFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosSelectionListNameFilterQuery, UercWorkVolumeRatiosSelectionListNameFilterQueryVariables>;
export const UercWorkVolumeRatiosSelectionListCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionListCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionListCodeFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatiosSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosSelectionListCodeFilterQuery, UercWorkVolumeRatiosSelectionListCodeFilterQueryVariables>;
export const UercRemoveFromWorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveFromWor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveFromWor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveFromWorMutation, UercRemoveFromWorMutationVariables>;
export const UercAddRatiosToWorkVolumeFromCollectionRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercAddRatiosToWorkVolumeFromCollectionRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddRatiosToWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercAddRatiosToWorkVolumeFromCollectionRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercAddRatiosToWorkVolumeFromCollectionRatioMutation, UercAddRatiosToWorkVolumeFromCollectionRatioMutationVariables>;
export const UercExportWorTemplateAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercExportWorTemplateAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercExportWorTemplateAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]} as unknown as DocumentNode<UercExportWorTemplateAsExcelQuery, UercExportWorTemplateAsExcelQueryVariables>;
export const UercExportWorAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercExportWorAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorExcelFileType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"verticalSortType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorUerSortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercExportWorAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}},{"kind":"Argument","name":{"kind":"Name","value":"verticalSortType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"verticalSortType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]} as unknown as DocumentNode<UercExportWorAsExcelQuery, UercExportWorAsExcelQueryVariables>;
export const UercSetWorkVolumeValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercSetWorkVolumeValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetWorkVolumeValueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercSetWorkVolumeValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}},{"kind":"Field","name":{"kind":"Name","value":"formulaError"}},{"kind":"Field","name":{"kind":"Name","value":"hasInconsistentWorVolumes"}},{"kind":"Field","name":{"kind":"Name","value":"worRowId"}},{"kind":"Field","name":{"kind":"Name","value":"summationDetails"}}]}}]}}]}}]} as unknown as DocumentNode<UercSetWorkVolumeValueMutation, UercSetWorkVolumeValueMutationVariables>;
export const UercWorkVolumeFormulaVariablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeFormulaVariables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"worRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeFormulaVariables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"worRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"worRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"calculationSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationSeasonId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coefficients"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeFormulaVariablesQuery, UercWorkVolumeFormulaVariablesQueryVariables>;
export const UercWorkVolumeRatiosWithUersSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosWithUersSelectionListQuery, UercWorkVolumeRatiosWithUersSelectionListQueryVariables>;
export const UercWorkVolumeRatiosWithUersSelectionListRatioGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListRatioGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListRatioGroups"},"name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogRatioGroupName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosWithUersSelectionListRatioGroupsQuery, UercWorkVolumeRatiosWithUersSelectionListRatioGroupsQueryVariables>;
export const UercWorkVolumeRatiosWithUersSelectionListCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListCodeFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosWithUersSelectionListCodeFilterQuery, UercWorkVolumeRatiosWithUersSelectionListCodeFilterQueryVariables>;
export const UercWorkVolumeRatiosWithUersSelectionListNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionRatioUersDataShortSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListNameFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosWithUersSelectionListNameFilterQuery, UercWorkVolumeRatiosWithUersSelectionListNameFilterQueryVariables>;
export const UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterQuery, UercWorkVolumeRatiosWithUersSelectionListRatioGroupNameFilterQueryVariables>;
export const UercAddRatiosMassToWorkVolumeFromCollectionRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercAddRatiosMassToWorkVolumeFromCollectionRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddRatiosMassToWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercAddRatiosMassToWorkVolumeFromCollectionRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercAddRatiosMassToWorkVolumeFromCollectionRatioMutation, UercAddRatiosMassToWorkVolumeFromCollectionRatioMutationVariables>;
export const UercCreateCollectionRatioMassToWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercCreateCollectionRatioMassToWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollectionRatioMassToWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCreateCollectionRatioMassToWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercCreateCollectionRatioMassToWorkVolumeMutation, UercCreateCollectionRatioMassToWorkVolumeMutationVariables>;
export const UercRemoveUnusedCollectionMtrToWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercRemoveUnusedCollectionMtrToWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercRemoveUnusedCollectionMtrToWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercRemoveUnusedCollectionMtrToWorkVolumeMutation, UercRemoveUnusedCollectionMtrToWorkVolumeMutationVariables>;
export const UercWorkVolumeItemRatioGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeItemRatioGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeItemRatioGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}}]}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeItemRatioGroupQuery, UercWorkVolumeItemRatioGroupQueryVariables>;
export const UercWorkVolumeRatioCollectionUersSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ratioId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatioCollectionUersSelectionListQuery, UercWorkVolumeRatioCollectionUersSelectionListQueryVariables>;
export const UercWorkVolumeRatioCollectionUersSelectionListCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionListCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionListCodeFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatioCollectionUersSelectionListCodeFilterQuery, UercWorkVolumeRatioCollectionUersSelectionListCodeFilterQueryVariables>;
export const UercWorkVolumeRatioCollectionUersSelectionListFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionListFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionListFullNameFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatioCollectionUersSelectionListFullNameFilterQuery, UercWorkVolumeRatioCollectionUersSelectionListFullNameFilterQueryVariables>;
export const UercWorkVolumeRatioCollectionUersSelectionListStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionListStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionUerBaseCostRatioMinimalSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionListStatusFilter"},"name":{"kind":"Name","value":"uercWorkVolumeRatioCollectionUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeRatioCollectionUersSelectionListStatusFilterQuery, UercWorkVolumeRatioCollectionUersSelectionListStatusFilterQueryVariables>;
export const UercTransferWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercTransferWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransferWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercTransferWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UercTransferWorkVolumeMutation, UercTransferWorkVolumeMutationVariables>;
export const UercChangeSeasonWorkVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercChangeSeasonWorkVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangeSeasonWorkVolumeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercChangeSeasonWorkVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UercChangeSeasonWorkVolumeMutation, UercChangeSeasonWorkVolumeMutationVariables>;
export const UercWorkVolumeObjectAdditionalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercWorkVolumeObjectAdditional"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkVolumeItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercWorkVolumeObjectAdditional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inconsistentWorRowNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"formulaErrorRowNumbers"}}]}}]}}]} as unknown as DocumentNode<UercWorkVolumeObjectAdditionalQuery, UercWorkVolumeObjectAdditionalQueryVariables>;
export const UercImportWorkVolumeXmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportWorkVolumeXml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrSelections"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrSelectionInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportWorkVolumeXml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"files"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrSelections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrSelections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedUersQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedRatiosQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedMtrsQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedMtrsWithoutVolumesQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedUerConstructionTypeLinksQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}},{"kind":"Field","name":{"kind":"Name","value":"mtrCandidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"selectedCollectionMtrId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"candidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"contragentType"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercImportWorkVolumeXmlMutation, UercImportWorkVolumeXmlMutationVariables>;
export const UercImportExcelWorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uercImportExcelWor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorExcelFileType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrSelections"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrSelectionInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercImportExcelWor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrSelections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrSelections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedUersQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedMtrsQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedRatiosQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedMtrsWithoutVolumesQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"addedUerConstructionTypeLinksQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}},{"kind":"Field","name":{"kind":"Name","value":"mtrCandidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRate"}},{"kind":"Field","name":{"kind":"Name","value":"selectedCollectionMtrId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"candidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"contragentType"}},{"kind":"Field","name":{"kind":"Name","value":"consumptionRateMtr"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UercImportExcelWorMutation, UercImportExcelWorMutationVariables>;
export const GetCalculationSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCalculationSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercCalculationSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"calculationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"calculationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<GetCalculationSeasonsQuery, GetCalculationSeasonsQueryVariables>;
export const UerCreateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"importOption"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractImportEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"catalogUERBaseUniqueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"importOption"},"value":{"kind":"Variable","name":{"kind":"Name","value":"importOption"}}},{"kind":"Argument","name":{"kind":"Name","value":"projectUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectUniqueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"catalogUERBaseUniqueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"catalogUERBaseUniqueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateContractMutation, UerCreateContractMutationVariables>;
export const UerUpdateContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractStatusEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractorAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"account"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signingDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amountWithoutTax"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amountWithTax"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tax"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplyBasis"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeOKPD"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeOKUD"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractorOKPO"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerOKPO"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceParameters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractPriceParamsUpdateInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remainder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"costRounding"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"internalNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractorAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractorAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"Variable","name":{"kind":"Name","value":"account"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signingDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signingDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"finishDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"amountWithoutTax"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amountWithoutTax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"amountWithTax"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amountWithTax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tax"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"supplyBasis"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplyBasis"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codeOKPD"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeOKPD"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codeOKUD"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeOKUD"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contractorOKPO"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractorOKPO"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customerOKPO"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerOKPO"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"documentUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priceParameters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceParameters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"remainder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remainder"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"costRounding"},"value":{"kind":"Variable","name":{"kind":"Name","value":"costRounding"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractMutation, UerUpdateContractMutationVariables>;
export const UerIsUniqueContractInternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueContractInternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueContractInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"internalNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueContractInternalNumberQuery, UerIsUniqueContractInternalNumberQueryVariables>;
export const UerSetContractSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetContractSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"years"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Short"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetContractSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"years"},"value":{"kind":"Variable","name":{"kind":"Name","value":"years"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetContractSeasonsMutation, UerSetContractSeasonsMutationVariables>;
export const UerContractObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkOrdersInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"codeWBS"}}]}}]}}]} as unknown as DocumentNode<UerContractObjectsQuery, UerContractObjectsQueryVariables>;
export const UerExportContractResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportContractResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportContractResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportContractResultsQuery, UerExportContractResultsQueryVariables>;
export const UerContractOtherCostLimitSpanSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractOtherCostLimitSpanSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractOtherCostLimitSpanSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostTypeUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"spanId"}},{"kind":"Field","name":{"kind":"Name","value":"spanType"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}},{"kind":"Field","name":{"kind":"Name","value":"spanSeasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actual"}},{"kind":"Field","name":{"kind":"Name","value":"contractSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"reminder"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractOtherCostLimitSpanSelectionListQuery, UerContractOtherCostLimitSpanSelectionListQueryVariables>;
export const UerContractWorkOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractWorkOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractWorkOrderDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractWorkOrderDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"navLinkId"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}}]}}]} as unknown as DocumentNode<UerContractWorkOrdersQuery, UerContractWorkOrdersQueryVariables>;
export const ContractCatalogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contractCatalogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"canCreate"}},{"kind":"Field","name":{"kind":"Name","value":"methodologies"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ContractCatalogsQuery, ContractCatalogsQueryVariables>;
export const UerCatalogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCatalogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCatalogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryId"}},{"kind":"Field","name":{"kind":"Name","value":"subsidiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowMultiple"}},{"kind":"Field","name":{"kind":"Name","value":"canCreate"}},{"kind":"Field","name":{"kind":"Name","value":"methodologies"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerCatalogsQuery, UerCatalogsQueryVariables>;
export const UerContractActionLogEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractActionLogEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UerActionLogDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UerActionLogDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractActionLogEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"entityName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userLogin"}},{"kind":"Field","name":{"kind":"Name","value":"entityDisplayName"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractActionLogEntriesQuery, UerContractActionLogEntriesQueryVariables>;
export const UerContractDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"costRounding"}},{"kind":"Field","name":{"kind":"Name","value":"hasFilledAddresses"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyFormulaInContract"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyOtherCostTypeInContract"}},{"kind":"Field","name":{"kind":"Name","value":"hasNoPlanByConstructionType"}},{"kind":"Field","name":{"kind":"Name","value":"account"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNavs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Navs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasContractChanges"}},{"kind":"Field","name":{"kind":"Name","value":"hasPriceParams"}},{"kind":"Field","name":{"kind":"Name","value":"hasOthers"}},{"kind":"Field","name":{"kind":"Name","value":"isEditablePriceParams"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"codeOKUD"}},{"kind":"Field","name":{"kind":"Name","value":"codeOKPD"}},{"kind":"Field","name":{"kind":"Name","value":"customerOKPO"}},{"kind":"Field","name":{"kind":"Name","value":"contractorOKPO"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"customerAddress"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"remainder"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"uerOthersPercent"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"northernAllowancePercent"}},{"kind":"Field","name":{"kind":"Name","value":"uerOthersPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasSupplyBasisInContract"}},{"kind":"Field","name":{"kind":"Name","value":"hasPriceListRatio"}},{"kind":"Field","name":{"kind":"Name","value":"hasFilledMandatoryProperties"}},{"kind":"Field","name":{"kind":"Name","value":"unreadyUerRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceCollectionLoaded"}},{"kind":"Field","name":{"kind":"Name","value":"otherCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"conversionIndices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"kemm"}},{"kind":"Field","name":{"kind":"Name","value":"kmtr"}},{"kind":"Field","name":{"kind":"Name","value":"keqp"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"kpir"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonsInflation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"inflationRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypePlanResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanReminderPercent"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanReminderWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanTax"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"workOrdersPlanCostWithTax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"catalogUerBase"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasWorkKind"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractQuery, UerContractQueryVariables>;
export const GetUerContractConstructionTypesAndSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUerContractConstructionTypesAndSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<GetUerContractConstructionTypesAndSeasonsQuery, GetUerContractConstructionTypesAndSeasonsQueryVariables>;
export const UerContractResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPlanSum"}},{"kind":"Field","name":{"kind":"Name","value":"contractRest"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"completedDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"completedRestDeviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"completedRest"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"planPrice"}},{"kind":"Field","name":{"kind":"Name","value":"completedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"planPrice"}},{"kind":"Field","name":{"kind":"Name","value":"completedPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypePlanResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlanSeasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPlanSumSeasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostStatus"}},{"kind":"Field","name":{"kind":"Name","value":"otherCostTypeUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"rowType"}},{"kind":"Field","name":{"kind":"Name","value":"totalType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractResultsQuery, UerContractResultsQueryVariables>;
export const UerWorkOrderMtrRowsForComparisonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderMtrRowsForComparison"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderMtrRowsForComparison"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicateNeighbours"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"mtrSupplyAndType"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderMtrRowsForComparisonQuery, UerWorkOrderMtrRowsForComparisonQueryVariables>;
export const UerWorkOrderPriceListMtrAssignCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListMtrAssignCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListMtrAssignCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListMtrAssignCodeFilterQuery, UerWorkOrderPriceListMtrAssignCodeFilterQueryVariables>;
export const UerWorkOrderPriceListMtrAssignNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListMtrAssignNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListMtrAssignNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListMtrAssignNameFilterQuery, UerWorkOrderPriceListMtrAssignNameFilterQueryVariables>;
export const UerPriceListMtrRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrRowQuery, UerPriceListMtrRowQueryVariables>;
export const UerUpdateMtrRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateMtrRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateMtrRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateMtrRowMutation, UerUpdateMtrRowMutationVariables>;
export const UerPriceListRatioRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioCoefficientRowDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioCoefficientRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioRowsQuery, UerPriceListRatioRowsQueryVariables>;
export const UerPriceListRatioUerRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioUerRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioUerRowDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioUerRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioUerRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ratioRowId"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioUerRowsQuery, UerPriceListRatioUerRowsQueryVariables>;
export const UerPriceListRatioSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioSectionNameFilterQuery, UerPriceListRatioSectionNameFilterQueryVariables>;
export const UerPriceListRatioGroupFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioGroupFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioGroupFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioGroupFullNameFilterQuery, UerPriceListRatioGroupFullNameFilterQueryVariables>;
export const UerPriceListRatioAppliesToFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioAppliesToFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioAppliesToFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioAppliesToFullNameFilterQuery, UerPriceListRatioAppliesToFullNameFilterQueryVariables>;
export const UerPriceListRatioCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioCodeFilterQuery, UerPriceListRatioCodeFilterQueryVariables>;
export const UerPriceListRatioWorkConditionsFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioWorkConditionsFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioWorkConditionsFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioWorkConditionsFilterQuery, UerPriceListRatioWorkConditionsFilterQueryVariables>;
export const UerPriceListRatioWorkTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioWorkTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioWorkTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioWorkTypeFilterQuery, UerPriceListRatioWorkTypeFilterQueryVariables>;
export const UerPriceListRatioStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioStatusFilterQuery, UerPriceListRatioStatusFilterQueryVariables>;
export const UerRemoveUnusedRatioRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveUnusedRatioRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveUnusedRatioRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveUnusedRatioRowsMutation, UerRemoveUnusedRatioRowsMutationVariables>;
export const UerRatioAppliesToCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioAppliesToCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioAppliesToCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerRatioAppliesToCodeFilterQuery, UerRatioAppliesToCodeFilterQueryVariables>;
export const UerRatioAppliesToCodeNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioAppliesToCodeNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioAppliesToCodeNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerRatioAppliesToCodeNameFilterQuery, UerRatioAppliesToCodeNameFilterQueryVariables>;
export const UerRatioAppliesToLinkStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioAppliesToLinkStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfRatioRecordStatusEnumSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioAppliesToLinkStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerRatioAppliesToLinkStatusFilterQuery, UerRatioAppliesToLinkStatusFilterQueryVariables>;
export const UerPriceListMtrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrQuery, UerPriceListMtrQueryVariables>;
export const PriceListMtrKeyFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"priceListMtrKeyFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<PriceListMtrKeyFilterQuery, PriceListMtrKeyFilterQueryVariables>;
export const UerPriceListMtrCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrCodeFilterQuery, UerPriceListMtrCodeFilterQueryVariables>;
export const UerPriceListMtrNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrNameFilterQuery, UerPriceListMtrNameFilterQueryVariables>;
export const UerPriceListMtrUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrUnitFilterQuery, UerPriceListMtrUnitFilterQueryVariables>;
export const UerPriceListMtrStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrStatusFilterQuery, UerPriceListMtrStatusFilterQueryVariables>;
export const UerPriceListMtrSupplyByFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrSupplyByFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrSupplyByFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrSupplyByFilterQuery, UerPriceListMtrSupplyByFilterQueryVariables>;
export const UerPriceListMtrTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrTypeFilterQuery, UerPriceListMtrTypeFilterQueryVariables>;
export const UerPriceListMtrJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListMtrJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListMtrJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListMtrJustificationFilterQuery, UerPriceListMtrJustificationFilterQueryVariables>;
export const UerRemoveUnusedMtrRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveUnusedMtrRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveUnusedMtrRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveUnusedMtrRowsMutation, UerRemoveUnusedMtrRowsMutationVariables>;
export const UerPriceListUerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupFullName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeRelationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"workKind"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerQuery, UerPriceListUerQueryVariables>;
export const UerPriceListUerSectionNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerSectionNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerSectionNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerSectionNameFilterQuery, UerPriceListUerSectionNameFilterQueryVariables>;
export const UerPriceListUerGroupFullNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerGroupFullNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerGroupFullNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerGroupFullNameFilterQuery, UerPriceListUerGroupFullNameFilterQueryVariables>;
export const UerPriceListUerGroupDataFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerGroupDataFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringAndStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerGroupDataFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerGroupDataFilterQuery, UerPriceListUerGroupDataFilterQueryVariables>;
export const UerPriceListUerCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerCodeFilterQuery, UerPriceListUerCodeFilterQueryVariables>;
export const UerPriceListUerNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerNameFilterQuery, UerPriceListUerNameFilterQueryVariables>;
export const UerPriceListUerChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerChapterFilterQuery, UerPriceListUerChapterFilterQueryVariables>;
export const UerPriceListUerTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerTypeFilterQuery, UerPriceListUerTypeFilterQueryVariables>;
export const UerPriceListUerStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerStatusFilterQuery, UerPriceListUerStatusFilterQueryVariables>;
export const UerPriceListUerJustificationFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerJustificationFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerJustificationFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerJustificationFilterQuery, UerPriceListUerJustificationFilterQueryVariables>;
export const UerPriceListUerWorkNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerWorkNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerWorkNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerWorkNameFilterQuery, UerPriceListUerWorkNameFilterQueryVariables>;
export const UerPriceListUerWorkInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerWorkInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkInSumEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerWorkInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerWorkInSumFilterQuery, UerPriceListUerWorkInSumFilterQueryVariables>;
export const UerImportPriceListCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerImportPriceListCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerImportPriceListCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerImportPriceListCollectionMutation, UerImportPriceListCollectionMutationVariables>;
export const UerRemoveUnusedUerRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveUnusedUerRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveUnusedUerRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveUnusedUerRowsMutation, UerRemoveUnusedUerRowsMutationVariables>;
export const UerUerRowReadyInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerUerRowReadyInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUerRowReadyInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"isPriceCollectionLoaded"}},{"kind":"Field","name":{"kind":"Name","value":"unreadyUerRowCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUerRowReadyInfoQuery, UerUerRowReadyInfoQueryVariables>;
export const UerPriceListUerRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerRowQuery, UerPriceListUerRowQueryVariables>;
export const UerCreateRatioRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateRatioRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateRatioRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateRatioRowMutation, UerCreateRatioRowMutationVariables>;
export const UerPriceListUerForConstraintRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForConstraintRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowBaseFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowBaseSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForConstraintRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"linkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"sectionIsArtificial"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForConstraintRatioQuery, UerPriceListUerForConstraintRatioQueryVariables>;
export const UerPriceListRatioRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"isUsedLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"groupIsArtificial"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioRowQuery, UerPriceListRatioRowQueryVariables>;
export const UerUpdateRatioRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateRatioRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateRatioRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"isUsedLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"groupIsArtificial"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateRatioRowMutation, UerUpdateRatioRowMutationVariables>;
export const UerUpdateRatioToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateRatioToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateRatioToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateRatioToWorkOrderFromPriceListMutation, UerUpdateRatioToWorkOrderFromPriceListMutationVariables>;
export const UerPriceListUerSectionForConstraintRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerSectionForConstraintRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerSectionForConstraintRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isArtificial"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerSectionForConstraintRatioQuery, UerPriceListUerSectionForConstraintRatioQueryVariables>;
export const UerPriceListUerForDismantlingRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DismantlingCoefficientTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerDismantlingRatioDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerDismantlingRatioDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerForDismantlingRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ratioCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"isPreselected"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isUerBaseRow"}},{"kind":"Field","name":{"kind":"Name","value":"ratioCode"}},{"kind":"Field","name":{"kind":"Name","value":"ratioId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"uerName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerForDismantlingRatioQuery, UerPriceListUerForDismantlingRatioQueryVariables>;
export const UerRatioRowDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioRowDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioRowDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioType"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupName"}}]}}]}}]}}]} as unknown as DocumentNode<UerRatioRowDefaultsQuery, UerRatioRowDefaultsQueryVariables>;
export const UerParsedEstimateBasisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerParsedEstimateBasis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerClassifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UerClassifierEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerParsedEstimateBasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerClassifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerClassifier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerParsedEstimateBasisQuery, UerParsedEstimateBasisQueryVariables>;
export const UerAddUerToWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUerToWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceListUerRowInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUerToWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceListUerRowInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceListUerRowInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddUerToWorkOrderMutation, UerAddUerToWorkOrderMutationVariables>;
export const UerCreateUerRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateUerRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateUerRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateUerRowMutation, UerCreateUerRowMutationVariables>;
export const UerUpdateUerRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateUerRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateUerRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateUerRowMutation, UerUpdateUerRowMutationVariables>;
export const UerPriceListUerRowWithRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerRowWithRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerRowWithRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isUsedLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeRelationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratioItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isUsedLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ratioGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionIsArtificial"}},{"kind":"Field","name":{"kind":"Name","value":"workKind"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerRowWithRatioQuery, UerPriceListUerRowWithRatioQueryVariables>;
export const UerUpdateUerToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateUerToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateUerToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateUerToWorkOrderFromPriceListMutation, UerUpdateUerToWorkOrderFromPriceListMutationVariables>;
export const UerCurrentEstimateBasisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCurrentEstimateBasis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCurrentEstimateBasis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCurrentEstimateBasisQuery, UerCurrentEstimateBasisQueryVariables>;
export const UerPriceListUerRatioRowsCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerRatioRowsCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerRatioRowsCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerRatioRowsCodeFilterQuery, UerPriceListUerRatioRowsCodeFilterQueryVariables>;
export const UerPriceListUerRatioRowsNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListUerRatioRowsNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListUerRatioRowsNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerPriceListUerRatioRowsNameFilterQuery, UerPriceListUerRatioRowsNameFilterQueryVariables>;
export const UerWorkOrderOtherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOther"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOther"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOtherQuery, UerWorkOrderOtherQueryVariables>;
export const UerAddWorkOrderOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddWorkOrderOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherCostInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWorkOrderOtherCostInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddWorkOrderOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherCostInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherCostInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddWorkOrderOtherCostMutation, UerAddWorkOrderOtherCostMutationVariables>;
export const UerWorkOrderOthersForActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOthersForActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOthersForActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasSeasonLimit"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOthersForActKc2Query, UerWorkOrderOthersForActKc2QueryVariables>;
export const UerAddOtherCostToActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddOtherCostToActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UerOtherCostInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddOtherCostToActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"otherInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherInputs"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UerAddOtherCostToActKc2Mutation, UerAddOtherCostToActKc2MutationVariables>;
export const UerWorkOrderOtherCostSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOtherCostSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderOtherCostItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOtherCostSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderRootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Cost"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"canAddOther"}},{"kind":"Field","name":{"kind":"Name","value":"canRemoveOther"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"includedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasSeasonLimits"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOtherCostSelectionListQuery, UerWorkOrderOtherCostSelectionListQueryVariables>;
export const UerUpdateWorkOrderOtherCostItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherCostItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWorkOrderOtherPriceItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherPriceInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderOtherCostItemsMutation, UerUpdateWorkOrderOtherCostItemsMutationVariables>;
export const UerAddUersToWorkOrderObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUersToWorkOrderObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUersToWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerAddUersToWorkOrderObjectsMutation, UerAddUersToWorkOrderObjectsMutationVariables>;
export const UerWorkOrderUersSelectionListAsyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderUersSelectionListAsync"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderUerItemDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderUersSelectionListAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupFullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderUersSelectionListAsyncQuery, UerWorkOrderUersSelectionListAsyncQueryVariables>;
export const UerWorkOrderOtherForDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOtherForDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOtherForDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemCalculation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAddOther"}},{"kind":"Field","name":{"kind":"Name","value":"canRemoveOther"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Cost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderRootObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOtherForDistributionQuery, UerWorkOrderOtherForDistributionQueryVariables>;
export const UerUpdateWorkOrderOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderOtherDistributionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderOtherDistributionMutation, UerUpdateWorkOrderOtherDistributionMutationVariables>;
export const UerUpdateWorkOrderOtherDistributionToActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherDistributionToActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderOtherDistributionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherDistributionToActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderOtherDistributionToActKc2Mutation, UerUpdateWorkOrderOtherDistributionToActKc2MutationVariables>;
export const UerCalcWorkOrderOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCalcWorkOrderOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderOtherPriceCalcInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCalcWorkOrderOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}}]}}]}}]}}]} as unknown as DocumentNode<UerCalcWorkOrderOtherDistributionQuery, UerCalcWorkOrderOtherDistributionQueryVariables>;
export const UerCalcWorkOrderChangeOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerCalcWorkOrderChangeOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherPriceCalcInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCalcWorkOrderChangeOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}}]}}]}}]} as unknown as DocumentNode<UerCalcWorkOrderChangeOtherDistributionQuery, UerCalcWorkOrderChangeOtherDistributionQueryVariables>;
export const UerExportActKc2TemplateAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportActKC2TemplateAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2TemplateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportActKC2TemplateAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportActKc2TemplateAsExcelQuery, UerExportActKc2TemplateAsExcelQueryVariables>;
export const UerImportActKc2TemplateAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerImportActKC2TemplateAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Template"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerImportActKC2TemplateAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Template"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Template"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerImportActKc2TemplateAsExcelMutation, UerImportActKc2TemplateAsExcelMutationVariables>;
export const UerWorkOrderActKc2MtrForInflationDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderActKC2MtrForInflationDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderMtrInflationDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderActKC2MtrForInflationDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"mtrRowId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderActKc2MtrForInflationDistributionQuery, UerWorkOrderActKc2MtrForInflationDistributionQueryVariables>;
export const UerUpdateWorkOrderActKc2MtrForInflationDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderActKC2MTRForInflationDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useInflationMTR"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2MtrItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2MtrItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderActKC2MTRForInflationDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"useInflationMTR"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useInflationMTR"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2MtrItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2MtrItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderActKc2MtrForInflationDistributionMutation, UerUpdateWorkOrderActKc2MtrForInflationDistributionMutationVariables>;
export const UerRollbackWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRollbackWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRollbackWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRollbackWorkOrderChangeMutation, UerRollbackWorkOrderChangeMutationVariables>;
export const UerWorkOrderActsKc2RegistryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderActsKC2Registry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2GroupTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2ListItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2ListItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderActsKC2Registry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupType"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupCount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actDate"}},{"kind":"Field","name":{"kind":"Name","value":"actYear"}},{"kind":"Field","name":{"kind":"Name","value":"actMonth"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"costWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"groupCostWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"statusSKzS"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderActsKc2RegistryQuery, UerWorkOrderActsKc2RegistryQueryVariables>;
export const UerWorkOrderActsKc2RegistrySelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderActsKC2RegistrySelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderActsKC2RegistrySelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"actDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"costWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderActsKc2RegistrySelectionListQuery, UerWorkOrderActsKc2RegistrySelectionListQueryVariables>;
export const UerCreateWorkOrderActsKc2GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateWorkOrderActsKC2Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2GroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateWorkOrderActsKC2Group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateWorkOrderActsKc2GroupMutation, UerCreateWorkOrderActsKc2GroupMutationVariables>;
export const UerUpdateWorkOrderActsKc2GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderActsKC2Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2GroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderActsKC2Group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderActsKc2GroupMutation, UerUpdateWorkOrderActsKc2GroupMutationVariables>;
export const UerRemoveWorkOrderActsKc2GroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderActsKC2Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderActsKC2Group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderActsKc2GroupMutation, UerRemoveWorkOrderActsKc2GroupMutationVariables>;
export const UerActKc2GroupNumberFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2GroupNumberFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2GroupNumberFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2GroupNumberFilterQuery, UerActKc2GroupNumberFilterQueryVariables>;
export const UerActKc2GroupDateFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2GroupDateFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDateOnlyFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2GroupDateFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2GroupDateFilterQuery, UerActKc2GroupDateFilterQueryVariables>;
export const UerActKc2GroupCostGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2GroupCostGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfCostGroupEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2GroupCostGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2GroupCostGroupFilterQuery, UerActKc2GroupCostGroupFilterQueryVariables>;
export const UerActKc2GroupConstructionTypeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2GroupConstructionTypeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2GroupConstructionTypeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2GroupConstructionTypeFilterQuery, UerActKc2GroupConstructionTypeFilterQueryVariables>;
export const UerActKc2GroupObjectFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2GroupObjectFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2GroupObjectFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2GroupObjectFilterQuery, UerActKc2GroupObjectFilterQueryVariables>;
export const UerIsUniqueActKc2GroupNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueActKC2GroupName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueActKC2GroupName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupName"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2GroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2GroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueActKc2GroupNameQuery, UerIsUniqueActKc2GroupNameQueryVariables>;
export const UerWorkOrderPriceListUerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListUer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListUer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListUerQuery, UerWorkOrderPriceListUerQueryVariables>;
export const UerAddUerToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUerToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUerToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddUerToWorkOrderFromPriceListMutation, UerAddUerToWorkOrderFromPriceListMutationVariables>;
export const UerAddUerToActKc2PriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUerToActKC2PriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUerToActKC2PriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddUerToActKc2PriceListMutation, UerAddUerToActKc2PriceListMutationVariables>;
export const UerWorkOrderPriceListUerCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListUerCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListUerCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListUerCodeFilterQuery, UerWorkOrderPriceListUerCodeFilterQueryVariables>;
export const UerWorkOrderPriceListUerNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListUerNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListUerNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListUerNameFilterQuery, UerWorkOrderPriceListUerNameFilterQueryVariables>;
export const UerWorkOrderPriceListUerSectionFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListUerSectionFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListUerSectionFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListUerSectionFilterQuery, UerWorkOrderPriceListUerSectionFilterQueryVariables>;
export const UerWorkOrderPriceListUerSubSectionFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListUerSubSectionFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListUerSubSectionFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListUerSubSectionFilterQuery, UerWorkOrderPriceListUerSubSectionFilterQueryVariables>;
export const UerWorkOrderOtherPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOtherPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderOtherPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOtherPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"isReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCostDeviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOtherPricesQuery, UerWorkOrderOtherPricesQueryVariables>;
export const UerSetActKc2OtherCostPlanCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2OtherCostPlanCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2OtherCostPlanCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2OtherCostPlanCostMutation, UerSetActKc2OtherCostPlanCostMutationVariables>;
export const UerSetActKc2OtherCostAcceptedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2OtherCostAcceptedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2OtherCostAcceptedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2OtherCostAcceptedCostMutation, UerSetActKc2OtherCostAcceptedCostMutationVariables>;
export const UerWorkOrderOtherPriceStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOtherPriceStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfContractOtherStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOtherPriceStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOtherPriceStatusFilterQuery, UerWorkOrderOtherPriceStatusFilterQueryVariables>;
export const UerWorkOrderOtherPriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderOtherPriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderOtherPriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderOtherPriceNameFilterQuery, UerWorkOrderOtherPriceNameFilterQueryVariables>;
export const UerWorkOrderPriceCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkOrderPriceCodeFilterDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkOrderPriceCodeFilterDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceCodeFilterQuery, UerWorkOrderPriceCodeFilterQueryVariables>;
export const UerWorkOrderPriceStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceStatusFilterQuery, UerWorkOrderPriceStatusFilterQueryVariables>;
export const UerWorkOrderPriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceNameFilterQuery, UerWorkOrderPriceNameFilterQueryVariables>;
export const UerWorkOrderPriceUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceUnitFilterQuery, UerWorkOrderPriceUnitFilterQueryVariables>;
export const UerSetActKc2AcceptedCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2AcceptedCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2AcceptedCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2AcceptedCostMutation, UerSetActKc2AcceptedCostMutationVariables>;
export const UerSetActKc2PlanCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2PlanCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cost"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2PlanCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cost"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cost"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2PlanCostMutation, UerSetActKc2PlanCostMutationVariables>;
export const UerActKc2VolumeVariableSelectionItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2VolumeVariableSelectionItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2VolumeVariableSelectionItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2VolumeVariableSelectionItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coefficients"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2VolumeVariableSelectionItemsQuery, UerActKc2VolumeVariableSelectionItemsQueryVariables>;
export const UerActKc2SmrValueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2SmrValue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2SmrValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formula"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2SmrValueQuery, UerActKc2SmrValueQueryVariables>;
export const UerSetActKc2FormulaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2Formula"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formula"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2Formula"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"formula"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formula"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2FormulaMutation, UerSetActKc2FormulaMutationVariables>;
export const UerActKc2CopyPlanVolumeSKzSuerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerActKC2CopyPlanVolumeSKzSUER"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2CopyPlanVolumeSKzSUER"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2CopyPlanVolumeSKzSuerMutation, UerActKc2CopyPlanVolumeSKzSuerMutationVariables>;
export const UerActKc2CopyPlanVolumeSKzSDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerActKC2CopyPlanVolumeSKzS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2CopyPlanVolumeSKzS"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerActKc2CopyPlanVolumeSKzSMutation, UerActKc2CopyPlanVolumeSKzSMutationVariables>;
export const UerWorkOrderWorkRatioInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderWorkRatioInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderWorkRatioInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasEmptyWorkRatios"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderWorkRatioInfoQuery, UerWorkOrderWorkRatioInfoQueryVariables>;
export const UerWorkOrderPriceItemChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemChapterFilterQuery, UerWorkOrderPriceItemChapterFilterQueryVariables>;
export const UerWorkOrderPriceItemStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemStatusFilterQuery, UerWorkOrderPriceItemStatusFilterQueryVariables>;
export const UerWorkOrderPriceItemCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sortSMRPart"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemCodeFilterQuery, UerWorkOrderPriceItemCodeFilterQueryVariables>;
export const UerWorkOrderPriceItemNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemNameFilterQuery, UerWorkOrderPriceItemNameFilterQueryVariables>;
export const UerWorkOrderPriceItemUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemUnitFilterQuery, UerWorkOrderPriceItemUnitFilterQueryVariables>;
export const UerWorkOrderPriceItemWorkNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemWorkNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemWorkNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemWorkNameFilterQuery, UerWorkOrderPriceItemWorkNameFilterQueryVariables>;
export const UerWorkOrderPriceItemWorkInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItemWorkInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkInSumEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItemWorkInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemWorkInSumFilterQuery, UerWorkOrderPriceItemWorkInSumFilterQueryVariables>;
export const UerWorkOrderPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"priceListId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeTerms"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"hasDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isEditableCost"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeDeviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActAcceptedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasCostPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workReminder"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPricesQuery, UerWorkOrderPricesQueryVariables>;
export const UerWorkOrderActsKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderActsKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actCostGroup"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CostGroupEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderActsKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actCostGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actCostGroup"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"planCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"isDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopyLock"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"statusSKzS"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderActsKc2Query, UerWorkOrderActsKc2QueryVariables>;
export const UerWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"remainder"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"inflationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"inflationRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vorType"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderQuery, UerWorkOrderQueryVariables>;
export const UerWorkOrderVorTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVorType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vorType"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVorTypeQuery, UerWorkOrderVorTypeQueryVariables>;
export const UerUpdateWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderStatusEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signingDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"internalNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"internalNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signingDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signingDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"finishDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderMutation, UerUpdateWorkOrderMutationVariables>;
export const UerWorkOrderConstructionTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderConstructionTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderConstructionTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderConstructionTypesQuery, UerWorkOrderConstructionTypesQueryVariables>;
export const UerWorkOrderObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderObjectDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSkzsActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderObjectsQuery, UerWorkOrderObjectsQueryVariables>;
export const UerWorkOrderPriceListMtrDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListMtr"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListMtr"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListMtrQuery, UerWorkOrderPriceListMtrQueryVariables>;
export const UerAddMtrToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddMtrToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddMtrToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddMtrToWorkOrderFromPriceListMutation, UerAddMtrToWorkOrderFromPriceListMutationVariables>;
export const UerAddMtrToActKc2PriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddMtrToActKC2PriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddMtrToActKC2PriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddMtrToActKc2PriceListMutation, UerAddMtrToActKc2PriceListMutationVariables>;
export const UerRemovePriceFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemovePriceFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemovePriceFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerRemovePriceFromWorkOrderMutation, UerRemovePriceFromWorkOrderMutationVariables>;
export const UerRemoveActKc2PriceFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveActKC2PriceFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveActKC2PriceFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerRemoveActKc2PriceFromWorkOrderMutation, UerRemoveActKc2PriceFromWorkOrderMutationVariables>;
export const UerRemoveActKc2OtherFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveActKC2OtherFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveActKC2OtherFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerRemoveActKc2OtherFromWorkOrderMutation, UerRemoveActKc2OtherFromWorkOrderMutationVariables>;
export const UerRemoveOtherFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveOtherFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveOtherFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerRemoveOtherFromWorkOrderMutation, UerRemoveOtherFromWorkOrderMutationVariables>;
export const UerWorkOrderSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderSeasonsQuery, UerWorkOrderSeasonsQueryVariables>;
export const UerWorkOrderPriceListRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToFullName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupIsArtificial"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupFullName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionName"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListRatioQuery, UerWorkOrderPriceListRatioQueryVariables>;
export const UerAddRatioToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddRatioToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddRatioToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddRatioToWorkOrderFromPriceListMutation, UerAddRatioToWorkOrderFromPriceListMutationVariables>;
export const UerAddRatioToActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddRatioToActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"strategy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddRatioToActKc2StrategyEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddRatioToActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioInputs"}}},{"kind":"Argument","name":{"kind":"Name","value":"strategy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"strategy"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerAddRatioToActKc2Mutation, UerAddRatioToActKc2MutationVariables>;
export const UerUpdateSeasonVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateSeasonVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"volume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateSeasonVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"volume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"volume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerUpdateSeasonVolumeMutation, UerUpdateSeasonVolumeMutationVariables>;
export const UerAddMtrRowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddMtrRow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddMtrRow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerAddMtrRowMutation, UerAddMtrRowMutationVariables>;
export const UerIsUniquePriceListMtrRowKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniquePriceListMtrRowKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniquePriceListMtrRowKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniquePriceListMtrRowKeyQuery, UerIsUniquePriceListMtrRowKeyQueryVariables>;
export const UerIsUniquePriceListMtrRowCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniquePriceListMtrRowCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplyBy"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContragentTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MtrTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniquePriceListMtrRowCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplyBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplyBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrType"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniquePriceListMtrRowCodeQuery, UerIsUniquePriceListMtrRowCodeQueryVariables>;
export const UerCreateActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2CreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerCreateActKc2Mutation, UerCreateActKc2MutationVariables>;
export const UerUpdateActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2UpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerUpdateActKc2Mutation, UerUpdateActKc2MutationVariables>;
export const UerCopyActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCopyActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCopyActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerCopyActKc2Mutation, UerCopyActKc2MutationVariables>;
export const UerDeleteActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerDeleteActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerDeleteActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerDeleteActKc2Mutation, UerDeleteActKc2MutationVariables>;
export const UerActKc2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCopied"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedOtherActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSkzsActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSmrActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingOtherActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingSkzsActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingSmrActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopyLock"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"primaryId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerActKc2Query, UerActKc2QueryVariables>;
export const UerWorkOrderExportAsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderExportAsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderExportAsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderExportAsExcelQuery, UerWorkOrderExportAsExcelQueryVariables>;
export const UerWorkOrderObjectResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderObjectResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderObjectResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"costResultData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderObjectResultQuery, UerWorkOrderObjectResultQueryVariables>;
export const UerApplyMtrToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyMtrToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyMtrToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyMtrToWorkOrderFromPriceListMutation, UerApplyMtrToWorkOrderFromPriceListMutationVariables>;
export const UerWorkOrderResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC2s"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptedCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"planCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusSKzS"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2Id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"resultSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderResultQuery, UerWorkOrderResultQueryVariables>;
export const UerWorkOrderTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderTotalsQuery, UerWorkOrderTotalsQueryVariables>;
export const UerSetActKc2PlanVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2PlanVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"volume"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2PlanVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"volume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"volume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2PlanVolumeMutation, UerSetActKc2PlanVolumeMutationVariables>;
export const UerSetActKc2AcceptedVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2AcceptedVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"volume"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2AcceptedVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"volume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"volume"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2AcceptedVolumeMutation, UerSetActKc2AcceptedVolumeMutationVariables>;
export const UerIsUniqueActKc2InternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueActKC2InternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueActKC2InternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Number"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueActKc2InternalNumberQuery, UerIsUniqueActKc2InternalNumberQueryVariables>;
export const UerDeleteWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerDeleteWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerDeleteWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerDeleteWorkOrderMutation, UerDeleteWorkOrderMutationVariables>;
export const UerUpdateMtrToWorkOrderFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateMtrToWorkOrderFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateMtrToWorkOrderFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateMtrToWorkOrderFromPriceListMutation, UerUpdateMtrToWorkOrderFromPriceListMutationVariables>;
export const UerImportWorkOrderFromRivxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerImportWorkOrderFromRivx"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerImportWorkOrderFromRivx"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerImportWorkOrderFromRivxMutation, UerImportWorkOrderFromRivxMutationVariables>;
export const UerImportWorkOrderFromXmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerImportWorkOrderFromXml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerImportWorkOrderFromXml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerImportWorkOrderFromXmlMutation, UerImportWorkOrderFromXmlMutationVariables>;
export const UerAddWorkOrderFromXmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddWorkOrderFromXml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddWorkOrderFromXml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddWorkOrderFromXmlMutation, UerAddWorkOrderFromXmlMutationVariables>;
export const UerReplaceWorkOrderFromRivxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerReplaceWorkOrderFromRivx"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerReplaceWorkOrderFromRivx"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerReplaceWorkOrderFromRivxMutation, UerReplaceWorkOrderFromRivxMutationVariables>;
export const UerReplaceWorkOrderFromXmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerReplaceWorkOrderFromXml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerReplaceWorkOrderFromXml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerReplaceWorkOrderFromXmlMutation, UerReplaceWorkOrderFromXmlMutationVariables>;
export const UerExportActKc2AsExcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportActKC2AsExcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportActKC2AsExcel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportActKc2AsExcelQuery, UerExportActKc2AsExcelQueryVariables>;
export const UerIsUniqueRatioWorkConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueRatioWorkConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workConditions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueRatioWorkConditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workConditions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workConditions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueRatioWorkConditionsQuery, UerIsUniqueRatioWorkConditionsQueryVariables>;
export const UerWorkOrderVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionsQuery, UerWorkOrderVersionsQueryVariables>;
export const UerUpdateMtrToActKc2FromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateMtrToActKC2FromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateMtrToActKC2FromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateMtrToActKc2FromPriceListMutation, UerUpdateMtrToActKc2FromPriceListMutationVariables>;
export const UerUpdateUerToActKc2FromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateUerToActKC2FromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateUerToActKC2FromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateUerToActKc2FromPriceListMutation, UerUpdateUerToActKc2FromPriceListMutationVariables>;
export const UerUpdateRatioToActKc2FromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateRatioToActKC2FromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateRatioToActKC2FromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateRatioToActKc2FromPriceListMutation, UerUpdateRatioToActKc2FromPriceListMutationVariables>;
export const UerApplyMtrToActKc2FromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyMtrToActKC2FromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyMtrToActKC2FromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyMtrToActKc2FromPriceListMutation, UerApplyMtrToActKc2FromPriceListMutationVariables>;
export const UerWorkOrderDraftInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderDraftInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderDraftInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftCount"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderDraftInfoQuery, UerWorkOrderDraftInfoQueryVariables>;
export const UerWorkOrderObjectSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderObjectSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderObjectSelectionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderObjectSelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeWBS"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasPricesOther"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrices"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderVOR"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasPricesOther"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Object"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderObjectSelectionListQuery, UerWorkOrderObjectSelectionListQueryVariables>;
export const UerWorkOrderObjectSelectionListIsIncludedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderObjectSelectionListIsIncluded"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderObjectSelectionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderObjectSelectionDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderVOR"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderObjectSelectionListIsIncludedQuery, UerWorkOrderObjectSelectionListIsIncludedQueryVariables>;
export const UerCreateWorkOrderObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateWorkOrderObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateWorkOrderObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateWorkOrderObjectMutation, UerCreateWorkOrderObjectMutationVariables>;
export const UerCreateWorkOrderSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateWorkOrderSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSubObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateWorkOrderSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateWorkOrderSubObjectMutation, UerCreateWorkOrderSubObjectMutationVariables>;
export const UerUpdateWorkOrderObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderObjectMutation, UerUpdateWorkOrderObjectMutationVariables>;
export const UerUpdateWorkOrderSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderSubObjectMutation, UerUpdateWorkOrderSubObjectMutationVariables>;
export const UerIsUniqueContractObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueContractObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueContractObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueContractObjectNameQuery, UerIsUniqueContractObjectNameQueryVariables>;
export const UerIsUniqueContractSubObjectNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueContractSubObjectName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSubObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueContractSubObjectName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSubObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSubObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueContractSubObjectNameQuery, UerIsUniqueContractSubObjectNameQueryVariables>;
export const UerIsUniqueContractObjectCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueContractObjectCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueContractObjectCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueContractObjectCodeQuery, UerIsUniqueContractObjectCodeQueryVariables>;
export const UerRemoveWorkOrderObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderObjectMutation, UerRemoveWorkOrderObjectMutationVariables>;
export const UerIncludeContractObjectToWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerIncludeContractObjectToWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIncludeContractObjectToWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIncludeContractObjectToWorkOrderMutation, UerIncludeContractObjectToWorkOrderMutationVariables>;
export const UerExcludeContractObjectFromWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerExcludeContractObjectFromWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExcludeContractObjectFromWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExcludeContractObjectFromWorkOrderMutation, UerExcludeContractObjectFromWorkOrderMutationVariables>;
export const UerUpdateWorkOrderPriceRationaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderPriceRationale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRationaleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderPriceRationale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderPriceRationaleMutation, UerUpdateWorkOrderPriceRationaleMutationVariables>;
export const UerUpdateWorkOrderOtherPriceRationaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherPriceRationale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderOtherPriceRationaleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderOtherPriceRationale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderOtherPriceRationaleMutation, UerUpdateWorkOrderOtherPriceRationaleMutationVariables>;
export const UerExportWorkOrderPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerExportWorkOrderPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExportWorkOrderPrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"dataUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerExportWorkOrderPricesQuery, UerExportWorkOrderPricesQueryVariables>;
export const UerCreateActKc2CorrectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateActKC2Correction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primaryActKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateActKC2Correction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"primaryActKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primaryActKC2Id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderVOR"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"objectUniqueId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopyLock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateActKc2CorrectionMutation, UerCreateActKc2CorrectionMutationVariables>;
export const UerUpdateActKc2CorrectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateActKC2Correction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2CorrectionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateActKC2Correction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"fromWorkOrderVOR"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateActKc2CorrectionMutation, UerUpdateActKc2CorrectionMutationVariables>;
export const CatalogWorkTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"catalogWorkTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogWorkTypeDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CatalogWorkTypeDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catalogWorkTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrice"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CatalogWorkTypesQuery, CatalogWorkTypesQueryVariables>;
export const UerSetWorkOrderWorkRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetWorkOrderWorkRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratio"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetWorkOrderWorkRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratio"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetWorkOrderWorkRatioMutation, UerSetWorkOrderWorkRatioMutationVariables>;
export const UerUpdateWorkOrderSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderSeasonsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstContractSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"lastContractSeasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderSeasonsMutation, UerUpdateWorkOrderSeasonsMutationVariables>;
export const UerWorkOrderPriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"sortPart"}},{"kind":"Field","name":{"kind":"Name","value":"sortSMRPart"}},{"kind":"Field","name":{"kind":"Name","value":"sortOtherPart"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusTip"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"isRootObject"}},{"kind":"Field","name":{"kind":"Name","value":"isSMRItem"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherGroup"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherItem"}},{"kind":"Field","name":{"kind":"Name","value":"isCreatedFromSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workKindWorkRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workReminder"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemTip"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planTerms"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"actValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actId"}},{"kind":"Field","name":{"kind":"Name","value":"actStatus"}},{"kind":"Field","name":{"kind":"Name","value":"actCostGroup"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"actHasEditableCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2DistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"actInflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumePlan"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumePlanDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumeAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumeAcceptedDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumeIsReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"actCostPlan"}},{"kind":"Field","name":{"kind":"Name","value":"actCostPlanDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actCostAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"actCostAcceptedDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"actStatusSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumePlanSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopied"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopyLock"}},{"kind":"Field","name":{"kind":"Name","value":"actFormula"}},{"kind":"Field","name":{"kind":"Name","value":"actFormulaDisplayText"}},{"kind":"Field","name":{"kind":"Name","value":"actFormulaErrors"}},{"kind":"Field","name":{"kind":"Name","value":"hasActFormula"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActAcceptedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingOtherActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingSmrActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasOngoingSkzsActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSmrActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSkzsActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedOtherActs"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedOtherActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSkzsActs"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedSmrActs"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceItemsQuery, UerWorkOrderPriceItemsQueryVariables>;
export const UerWorkOrderActsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderActs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderActKC2DataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderActs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"planCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"canCreateCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"reportingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"reportingFinishDate"}},{"kind":"Field","name":{"kind":"Name","value":"costGroup"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"inflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"isDistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"statusSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopyLock"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzSCopied"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderActsQuery, UerWorkOrderActsQueryVariables>;
export const UerWorkOrderSKzSInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderSKzSInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderSKzSInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actsKC2SKzSNewCount"}},{"kind":"Field","name":{"kind":"Name","value":"actsKC2SKzSUpdatedCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderSKzSInfoQuery, UerWorkOrderSKzSInfoQueryVariables>;
export const UerSetActKc2WorkVolumeCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2WorkVolumeComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2WorkVolumeComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2WorkVolumeCommentMutation, UerSetActKc2WorkVolumeCommentMutationVariables>;
export const UerSetActKc2OtherCostCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetActKC2OtherCostComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetActKC2OtherCostComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerSetActKc2OtherCostCommentMutation, UerSetActKc2OtherCostCommentMutationVariables>;
export const UerActsKc2AnalyticsByUerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActsKC2AnalyticsByUer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2UerCostChartDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2UerCostChartDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActsKC2AnalyticsByUer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rimActKC2WorkCost"}},{"kind":"Field","name":{"kind":"Name","value":"skzsActKC2WorkCost"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerActsKc2AnalyticsByUerQuery, UerActsKc2AnalyticsByUerQueryVariables>;
export const UerActsKc2AnalyticsBySeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActsKC2AnalyticsBySeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Short"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2UerCostPlotDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActsKC2AnalyticsBySeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"seasonYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonYear"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rimActKC2WorkCost"}},{"kind":"Field","name":{"kind":"Name","value":"skzsActKC2WorkCost"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerActsKc2AnalyticsBySeasonsQuery, UerActsKc2AnalyticsBySeasonsQueryVariables>;
export const UerCreateContractSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateContractSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSubObjectCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateContractSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerCreateContractSubObjectMutation, UerCreateContractSubObjectMutationVariables>;
export const UerUpdateContractObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractObjectMutation, UerUpdateContractObjectMutationVariables>;
export const UerUpdateContractSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSubObjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractSubObjectMutation, UerUpdateContractSubObjectMutationVariables>;
export const UerRemoveWorkOrderPriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderPriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderPriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderPriceItemsMutation, UerRemoveWorkOrderPriceItemsMutationVariables>;
export const UerWorkOrderObjectTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderObjectTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderObjectTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderObjectTotalsQuery, UerWorkOrderObjectTotalsQueryVariables>;
export const UerPriceListRatioRowsWithScopesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerPriceListRatioRowsWithScopes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRatioRowSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRatioRowFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerPriceListRatioRowsWithScopes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerPriceListRatioRowsWithScopesQuery, UerPriceListRatioRowsWithScopesQueryVariables>;
export const UerApplyPriceListUerRatioRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyPriceListUerRatioRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyPriceListUerRatioRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratioRowIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerBaseRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerBaseRowId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyPriceListUerRatioRowsMutation, UerApplyPriceListUerRatioRowsMutationVariables>;
export const UerActKc2SmrPriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2SmrPriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2SmrPriceItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2SmrPriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"costAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"volumeAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerActKc2SmrPriceItemsQuery, UerActKc2SmrPriceItemsQueryVariables>;
export const UerActKc2OtherPriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2OtherPriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2OtherPriceItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2OtherPriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"costAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerActKc2OtherPriceItemsQuery, UerActKc2OtherPriceItemsQueryVariables>;
export const UerActKc2SmrTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2SmrTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2TotalItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2SmrTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerActKc2SmrTotalsQuery, UerActKc2SmrTotalsQueryVariables>;
export const UerActKc2OtherTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerActKC2OtherTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ActKC2TotalItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerActKC2OtherTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"actKC2Id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actKC2Id"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"totalCost"}},{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerActKc2OtherTotalsQuery, UerActKc2OtherTotalsQueryVariables>;
export const UerWorkOrderChangeOtherCostSelectonListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeOtherCostSelectonList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherCostItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeOtherCostSelectonList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"catalogOtherCostType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isSystem"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Cost"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"canAddOther"}},{"kind":"Field","name":{"kind":"Name","value":"canRemoveOther"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seasonLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"includedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasSeasonLimits"}},{"kind":"Field","name":{"kind":"Name","value":"sortPart"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeOtherCostSelectonListQuery, UerWorkOrderChangeOtherCostSelectonListQueryVariables>;
export const UerUpdateWorkOrderChangeOtherCostItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeOtherCostItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateWorkOrderChangeOtherPriceItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeOtherCostItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherPriceInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderChangeOtherCostItemsMutation, UerUpdateWorkOrderChangeOtherCostItemsMutationVariables>;
export const UerWorkOrderChangeUersSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeUersSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeUerItemDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeUerItemDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeUersSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupFullName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeUersSelectionListQuery, UerWorkOrderChangeUersSelectionListQueryVariables>;
export const UerAddUersToWorkOrderChangeObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUersToWorkOrderChangeObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUersToWorkOrderChangeObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}}]}}]}}]} as unknown as DocumentNode<UerAddUersToWorkOrderChangeObjectsMutation, UerAddUersToWorkOrderChangeObjectsMutationVariables>;
export const UerWorkOrderChangeUsersSelectionListSectionFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListSectionFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListSectionFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeUsersSelectionListSectionFilterQuery, UerWorkOrderChangeUsersSelectionListSectionFilterQueryVariables>;
export const UerWorkOrderChangeUsersSelectionListCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeUsersSelectionListCodeFilterQuery, UerWorkOrderChangeUsersSelectionListCodeFilterQueryVariables>;
export const UerWorkOrderChangeUsersSelectionListGroupFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListGroupFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListGroupFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeUsersSelectionListGroupFilterQuery, UerWorkOrderChangeUsersSelectionListGroupFilterQueryVariables>;
export const UerWorkOrderChangeUsersSelectionListNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeUsersSelectionListNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeUsersSelectionListNameFilterQuery, UerWorkOrderChangeUsersSelectionListNameFilterQueryVariables>;
export const UerAddObjectToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddObjectToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddObjectToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddObjectToWorkOrderChangeMutation, UerAddObjectToWorkOrderChangeMutationVariables>;
export const UerRemoveWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderChangeObjectMutation, UerRemoveWorkOrderChangeObjectMutationVariables>;
export const UerRenameWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRenameWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRenameWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRenameWorkOrderChangeObjectMutation, UerRenameWorkOrderChangeObjectMutationVariables>;
export const MoveWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moveWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insertAfterObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newParentObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerMoveWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"insertAfterObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insertAfterObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newParentObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newParentObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MoveWorkOrderChangeObjectMutation, MoveWorkOrderChangeObjectMutationVariables>;
export const UerContractObjectsToAddToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerContractObjectsToAddToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentWorkOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerContractObjectsToAddToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parentWorkOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentWorkOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"used"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerContractObjectsToAddToWorkOrderChangeQuery, UerContractObjectsToAddToWorkOrderChangeQueryVariables>;
export const UerWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSubjectText"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumberText"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSigningDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSigningDate"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"draftCount"}},{"kind":"Field","name":{"kind":"Name","value":"isClosing"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeQuery, UerWorkOrderChangeQueryVariables>;
export const UerCreateWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSubjectText"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumberText"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSigningDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateWorkOrderChangeMutation, UerCreateWorkOrderChangeMutationVariables>;
export const UerDeleteWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerDeleteWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerDeleteWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerDeleteWorkOrderChangeMutation, UerDeleteWorkOrderChangeMutationVariables>;
export const UerUpdateWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderChangeMutation, UerUpdateWorkOrderChangeMutationVariables>;
export const UerWorkOrderChangeStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"followers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeStatusesQuery, UerWorkOrderChangeStatusesQueryVariables>;
export const UerIsUniqueWorkOrderChangeInternalNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerIsUniqueWorkOrderChangeInternalNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIsUniqueWorkOrderChangeInternalNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerIsUniqueWorkOrderChangeInternalNumberQuery, UerIsUniqueWorkOrderChangeInternalNumberQueryVariables>;
export const UerWorkOrderChangeObjectItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeObjectItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeObjectItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedObject"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedObject"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2WorkOrderObject"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeParentId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderParentId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderRootObjectId"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeObjectItemsQuery, UerWorkOrderChangeObjectItemsQueryVariables>;
export const UerWorkOrderChangePriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangePriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"clientParentId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceParentId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceParentId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeVal"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"priceListId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"totalDeviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeTerms"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isBlockedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workReminder"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceListQuery, UerWorkOrderChangePriceListQueryVariables>;
export const UerWorkOrderChangeSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeSeasonsQuery, UerWorkOrderChangeSeasonsQueryVariables>;
export const UerWorkOrderChangeOtherPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeOtherPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeOtherPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"totalDeviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"deviationTip"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonCost"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeOtherPriceListQuery, UerWorkOrderChangeOtherPriceListQueryVariables>;
export const UerRemoveWorkOrderChangePriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderChangePriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangePriceIdsInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherPriceIdsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderChangePriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderChangePriceItemsMutation, UerRemoveWorkOrderChangePriceItemsMutationVariables>;
export const UerRemoveWorkOrderChangePricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderChangePrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangePriceIdsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderChangePrices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderChangePricesMutation, UerRemoveWorkOrderChangePricesMutationVariables>;
export const UerWorkOrderChangePriceListMtrQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceListMtrQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceListMtrQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"unitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBy"}},{"kind":"Field","name":{"kind":"Name","value":"supplyBasis"}},{"kind":"Field","name":{"kind":"Name","value":"mtrType"}},{"kind":"Field","name":{"kind":"Name","value":"pricingType"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"mtrSupplyAndType"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicateNeighbours"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceListMtrQueryQuery, UerWorkOrderChangePriceListMtrQueryQueryVariables>;
export const UerAddMtrToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddMtrToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddMtrToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mtrInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrInputs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddMtrToWorkOrderChangeMutation, UerAddMtrToWorkOrderChangeMutationVariables>;
export const UerWorkOrderChangePriceListUerQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceListUerQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceListUerQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeRelationStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"unitCostWithOther"}},{"kind":"Field","name":{"kind":"Name","value":"ozp"}},{"kind":"Field","name":{"kind":"Name","value":"emm"}},{"kind":"Field","name":{"kind":"Name","value":"zpm"}},{"kind":"Field","name":{"kind":"Name","value":"mtr"}},{"kind":"Field","name":{"kind":"Name","value":"eqp"}},{"kind":"Field","name":{"kind":"Name","value":"pir"}},{"kind":"Field","name":{"kind":"Name","value":"trn"}},{"kind":"Field","name":{"kind":"Name","value":"nr"}},{"kind":"Field","name":{"kind":"Name","value":"sp"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeRelationStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasNewConstructionTypeRelations"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"workScopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionName"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupCode"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"uerClassifier"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"linkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceListUerQueryQuery, UerWorkOrderChangePriceListUerQueryQueryVariables>;
export const UerAddUerToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddUerToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddUerToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"uerInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uerInputs"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddUerToWorkOrderChangeMutation, UerAddUerToWorkOrderChangeMutationVariables>;
export const UerWorkOrderChangePriceListRatioQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceListRatioQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceListRatioQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToFullName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupIsArtificial"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"groupType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrderChange"}},{"kind":"Field","name":{"kind":"Name","value":"justification"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"subGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupFullName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"uerPriceListSectionName"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceListRatioQueryQuery, UerWorkOrderChangePriceListRatioQueryQueryVariables>;
export const UerAddRatioToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddRatioToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioInputs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"strategy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddRatioToActKc2StrategyEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddRatioToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioInputs"}}},{"kind":"Argument","name":{"kind":"Name","value":"strategy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"strategy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddRatioToWorkOrderChangeMutation, UerAddRatioToWorkOrderChangeMutationVariables>;
export const UerSaveOrUpdateWorkOrderChangeSeasonVolumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSaveOrUpdateWorkOrderChangeSeasonVolume"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"volume"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSaveOrUpdateWorkOrderChangeSeasonVolume"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"volume"},"value":{"kind":"Variable","name":{"kind":"Name","value":"volume"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerSaveOrUpdateWorkOrderChangeSeasonVolumeMutation, UerSaveOrUpdateWorkOrderChangeSeasonVolumeMutationVariables>;
export const UerWorkOrderChangeObjectResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeObjectResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectResultDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectResultDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeObjectResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"costResultData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeObjectResultQuery, UerWorkOrderChangeObjectResultQueryVariables>;
export const UerWorkOrderChangeResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeResultDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeResultDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"resultSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeResultQuery, UerWorkOrderChangeResultQueryVariables>;
export const UerWorkOrderChangeOtherListQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeOtherListQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherAggregationDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeOtherListQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherCostId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeOtherListQueryQuery, UerWorkOrderChangeOtherListQueryQueryVariables>;
export const UerAddWorkOrderChangeOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddWorkOrderChangeOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOthersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddWorkOrderChangeOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UerAddWorkOrderChangeOtherCostMutation, UerAddWorkOrderChangeOtherCostMutationVariables>;
export const UerRemoveWorkOrderChangeOtherCostDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderChangeOtherCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherPriceIdsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderChangeOtherCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderChangeOtherCostMutation, UerRemoveWorkOrderChangeOtherCostMutationVariables>;
export const UerWorkOrderChangeOtherForDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeOtherForDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeOtherForDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderOtherPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobalOtherCost"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasActualCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Cost"}},{"kind":"Field","name":{"kind":"Name","value":"contractObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"canAddOther"}},{"kind":"Field","name":{"kind":"Name","value":"canRemoveOther"}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"includedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costLimit"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"deviation"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemCalculation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectSeasonDistributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeOtherForDistributionQuery, UerWorkOrderChangeOtherForDistributionQueryVariables>;
export const UerUpdateWorkOrderChangeOtherDistributionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeOtherDistribution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherCostDistributionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeOtherDistribution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderChangeOtherDistributionMutation, UerUpdateWorkOrderChangeOtherDistributionMutationVariables>;
export const UerUpdateContractOtherCostToWorkOrderChangeFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateContractOtherCostToWorkOrderChangeFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractOtherUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateContractOtherCostToWorkOrderChangeFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateContractOtherCostToWorkOrderChangeFromPriceListMutation, UerUpdateContractOtherCostToWorkOrderChangeFromPriceListMutationVariables>;
export const UerUpdateMtrToWorkOrderChangeFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateMtrToWorkOrderChangeFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListMtrRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateMtrToWorkOrderChangeFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateMtrToWorkOrderChangeFromPriceListMutation, UerUpdateMtrToWorkOrderChangeFromPriceListMutationVariables>;
export const UerWorkOrderChangePriceStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceStatusFilterQuery, UerWorkOrderChangePriceStatusFilterQueryVariables>;
export const UerWorkOrderChangePriceCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceCodeFilterQuery, UerWorkOrderChangePriceCodeFilterQueryVariables>;
export const UerWorkOrderChangePriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceNameFilterQuery, UerWorkOrderChangePriceNameFilterQueryVariables>;
export const UerWorkOrderChangeSeasonPricePlanVolumeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeSeasonPricePlanVolumeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDecimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeSeasonPricePlanVolumeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeSeasonPricePlanVolumeFilterQuery, UerWorkOrderChangeSeasonPricePlanVolumeFilterQueryVariables>;
export const UerWorkOrderChangeSeasonPriceCompletedVolumeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeSeasonPriceCompletedVolumeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDecimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeSeasonPriceCompletedVolumeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeSeasonPriceCompletedVolumeFilterQuery, UerWorkOrderChangeSeasonPriceCompletedVolumeFilterQueryVariables>;
export const UerWorkOrderChangeSeasonPriceRemainderVolumeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeSeasonPriceRemainderVolumeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfDecimalFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeSeasonPriceRemainderVolumeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeSeasonPriceRemainderVolumeFilterQuery, UerWorkOrderChangeSeasonPriceRemainderVolumeFilterQueryVariables>;
export const UerWorkOrderChangeOtherPriceNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeOtherPriceNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeOtherPriceNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeOtherPriceNameFilterQuery, UerWorkOrderChangeOtherPriceNameFilterQueryVariables>;
export const UerWorkOrderChangeOtherPriceStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeOtherPriceStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfContractOtherStatusEnumFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeOtherPriceStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeOtherPriceStatusFilterQuery, UerWorkOrderChangeOtherPriceStatusFilterQueryVariables>;
export const UerUpdateOrderChangePriceRationaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateOrderChangePriceRationale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangePriceRationaleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateOrderChangePriceRationale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateOrderChangePriceRationaleMutation, UerUpdateOrderChangePriceRationaleMutationVariables>;
export const UerUpdateOrderChangeOtherPriceRationaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateOrderChangeOtherPriceRationale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeOtherPriceRationaleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateOrderChangeOtherPriceRationale"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderOtherPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderOtherPriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateOrderChangeOtherPriceRationaleMutation, UerUpdateOrderChangeOtherPriceRationaleMutationVariables>;
export const UerWorkOrderChangeUerRemaindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeUerRemainders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeUerRemainders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reminderData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeUerRemaindersQuery, UerWorkOrderChangeUerRemaindersQueryVariables>;
export const UerMoveWorkOrderChangeUerRemindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerMoveWorkOrderChangeUerReminders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeUerVolumesTransferInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerMoveWorkOrderChangeUerReminders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerMoveWorkOrderChangeUerRemindersMutation, UerMoveWorkOrderChangeUerRemindersMutationVariables>;
export const UerWorkOrderChangeObjectsForRemindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeObjectsForReminders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeObjectsForReminders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderRootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderRootObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedObject"}},{"kind":"Field","name":{"kind":"Name","value":"isLeaf"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedObject"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderParentId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderRootObjectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeObjectsForRemindersQuery, UerWorkOrderChangeObjectsForRemindersQueryVariables>;
export const UerMoveWorkOrderChangeObjectRemindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerMoveWorkOrderChangeObjectReminders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectVolumesTransferInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerMoveWorkOrderChangeObjectReminders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]} as unknown as DocumentNode<UerMoveWorkOrderChangeObjectRemindersMutation, UerMoveWorkOrderChangeObjectRemindersMutationVariables>;
export const UerUpdateUerToWorkOrderChangeFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateUerToWorkOrderChangeFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListUerRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateUerToWorkOrderChangeFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateUerToWorkOrderChangeFromPriceListMutation, UerUpdateUerToWorkOrderChangeFromPriceListMutationVariables>;
export const UpdateRatioToWorkOrderChangeFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRatioToWorkOrderChangeFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateRatioToWorkOrderChangeFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateRatioToWorkOrderChangeFromPriceListMutation, UpdateRatioToWorkOrderChangeFromPriceListMutationVariables>;
export const UerSetWorkOrderChangeWorkRatioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetWorkOrderChangeWorkRatio"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratio"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetWorkOrderChangeWorkRatio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ratio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratio"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderPriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderPriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetWorkOrderChangeWorkRatioMutation, UerSetWorkOrderChangeWorkRatioMutationVariables>;
export const UerWorkOrderChangeObjectSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeObjectSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectSelectionItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeWBS"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}},{"kind":"Field","name":{"kind":"Name","value":"hasGuaranteedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"hasActsKC2"}},{"kind":"Field","name":{"kind":"Name","value":"hasOtherPrices"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrices"}},{"kind":"Field","name":{"kind":"Name","value":"isInUse"}},{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2WorkOrderObject"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedObject"}},{"kind":"Field","name":{"kind":"Name","value":"isRemovedObject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeObjectSelectionListQuery, UerWorkOrderChangeObjectSelectionListQueryVariables>;
export const UerWorkOrderChangeObjectSelectionListIsIncludedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeObjectSelectionListIsIncluded"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectSelectionItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeObjectSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fromVOR"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeObjectSelectionListIsIncludedQuery, UerWorkOrderChangeObjectSelectionListIsIncludedQueryVariables>;
export const UerIncludeContractObjectToWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerIncludeContractObjectToWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerIncludeContractObjectToWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerIncludeContractObjectToWorkOrderChangeMutation, UerIncludeContractObjectToWorkOrderChangeMutationVariables>;
export const UerExcludeContractObjectFromWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerExcludeContractObjectFromWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerExcludeContractObjectFromWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerExcludeContractObjectFromWorkOrderChangeMutation, UerExcludeContractObjectFromWorkOrderChangeMutationVariables>;
export const UerCreateWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateWorkOrderChangeObjectMutation, UerCreateWorkOrderChangeObjectMutationVariables>;
export const UerCreateWorkOrderChangeSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateWorkOrderChangeSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSubObjectCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateWorkOrderChangeSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateWorkOrderChangeSubObjectMutation, UerCreateWorkOrderChangeSubObjectMutationVariables>;
export const UerUpdateWorkOrderChangeObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderChangeObjectMutation, UerUpdateWorkOrderChangeObjectMutationVariables>;
export const UerUpdateWorkOrderChangeSubObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeSubObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractObjectUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerUpdateWorkOrderChangeSubObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerUpdateWorkOrderChangeSubObjectMutation, UerUpdateWorkOrderChangeSubObjectMutationVariables>;
export const UerRemoveWorkOrderChangeObjectItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerRemoveWorkOrderChangeObjectItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRemoveWorkOrderChangeObjectItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerRemoveWorkOrderChangeObjectItemMutation, UerRemoveWorkOrderChangeObjectItemMutationVariables>;
export const UerAddWorkOrderChangeFromXmlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerAddWorkOrderChangeFromXml"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerAddWorkOrderChangeFromXml"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filesContent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filesContent"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerAddWorkOrderChangeFromXmlMutation, UerAddWorkOrderChangeFromXmlMutationVariables>;
export const UerSetWorkOrderChangeLastSeasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerSetWorkOrderChangeLastSeason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerSetWorkOrderChangeLastSeason"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractSeasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractSeasonId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerSetWorkOrderChangeLastSeasonMutation, UerSetWorkOrderChangeLastSeasonMutationVariables>;
export const UerApplyMtrToWorkOrderChangeFromPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyMtrToWorkOrderChangeFromPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyMtrToWorkOrderChangeFromPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mtrRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mtrRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangePriceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangePriceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyMtrToWorkOrderChangeFromPriceListMutation, UerApplyMtrToWorkOrderChangeFromPriceListMutationVariables>;
export const UerWorkOrderChangeDraftInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeDraftInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeDraftInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeDraftInfoQuery, UerWorkOrderChangeDraftInfoQueryVariables>;
export const UerWorkOrderChangeLastSeasonSelectionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeLastSeasonSelectionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSeasonDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeLastSeasonSelectionList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeLastSeasonSelectionListQuery, UerWorkOrderChangeLastSeasonSelectionListQueryVariables>;
export const UerWorkOrderChangeAllowedSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeAllowedSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSeasonDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeAllowedSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeAllowedSeasonsQuery, UerWorkOrderChangeAllowedSeasonsQueryVariables>;
export const UerWorkOrderChangeTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeTotalsQuery, UerWorkOrderChangeTotalsQueryVariables>;
export const UerWorkOrderChangeObjectTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeObjectTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeObjectTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeObjectTotalsQuery, UerWorkOrderChangeObjectTotalsQueryVariables>;
export const UerClosingWorkOrderChangeDefaultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerClosingWorkOrderChangeDefaults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerClosingWorkOrderChangeDefaults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSubjectText"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"draftCount"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isClosing"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumberText"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSigningDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerClosingWorkOrderChangeDefaultsQuery, UerClosingWorkOrderChangeDefaultsQueryVariables>;
export const UerCreateClosingWorkOrderChangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerCreateClosingWorkOrderChange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeClosingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCreateClosingWorkOrderChange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authoredBy"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}},{"kind":"Field","name":{"kind":"Name","value":"contractSubjectText"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"draftCount"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isClosing"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusFollowers"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNumberText"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSigningDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerCreateClosingWorkOrderChangeMutation, UerCreateClosingWorkOrderChangeMutationVariables>;
export const UerWorkOrderChangeWorkRatioInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangeWorkRatioInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangeWorkRatioInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasEmptyWorkRatios"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangeWorkRatioInfoQuery, UerWorkOrderChangeWorkRatioInfoQueryVariables>;
export const UerWorkOrderChangePriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangePriceItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"hasAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isAddedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isBlockedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherGroup"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherItem"}},{"kind":"Field","name":{"kind":"Name","value":"isRootObject"}},{"kind":"Field","name":{"kind":"Name","value":"isSMRItem"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"itemTip"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planTerms"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortOtherPart"}},{"kind":"Field","name":{"kind":"Name","value":"sortPart"}},{"kind":"Field","name":{"kind":"Name","value":"sortSMRPart"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusTip"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workKindWorkRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChangeRootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderRootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderPriceId"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workReminder"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemsQuery, UerWorkOrderChangePriceItemsQueryVariables>;
export const UerWorkOrderChangePriceItemChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemChapterFilterQuery, UerWorkOrderChangePriceItemChapterFilterQueryVariables>;
export const UerWorkOrderChangePriceItemStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemStatusFilterQuery, UerWorkOrderChangePriceItemStatusFilterQueryVariables>;
export const UerWorkOrderChangePriceItemCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"sortSMRPart"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemCodeFilterQuery, UerWorkOrderChangePriceItemCodeFilterQueryVariables>;
export const UerWorkOrderChangePriceItemNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemNameFilterQuery, UerWorkOrderChangePriceItemNameFilterQueryVariables>;
export const UerWorkOrderChangePriceItemUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemUnitFilterQuery, UerWorkOrderChangePriceItemUnitFilterQueryVariables>;
export const UerWorkOrderChangePriceItemWorkInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemWorkInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkInSumEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemWorkInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemWorkInSumFilterQuery, UerWorkOrderChangePriceItemWorkInSumFilterQueryVariables>;
export const UerWorkOrderChangePriceItemWorkNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemWorkNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceItemWorkNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputRootObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputRootObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"inputObject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputObject"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceItemWorkNameFilterQuery, UerWorkOrderChangePriceItemWorkNameFilterQueryVariables>;
export const UerWorkOrderPriceListRatioForRootObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListRatioForRootObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListRatioForRootObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListRatioForRootObjectQuery, UerWorkOrderPriceListRatioForRootObjectQueryVariables>;
export const UerWorkOrderPriceListRatioForObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderPriceListRatioForObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderPriceListRatioForObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderPriceListRatioForObjectsQuery, UerWorkOrderPriceListRatioForObjectsQueryVariables>;
export const UerWorkOrderChangePriceListRatioForRootObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceListRatioForRootObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceListRatioForRootObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceListRatioForRootObjectQuery, UerWorkOrderChangePriceListRatioForRootObjectQueryVariables>;
export const UerWorkOrderChangePriceListRatioForObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderChangePriceListRatioForObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPriceRatioRowDataSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderChangePriceListRatioForObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInAct"}},{"kind":"Field","name":{"kind":"Name","value":"isIncludedInWorkOrder"}},{"kind":"Field","name":{"kind":"Name","value":"kem"}},{"kind":"Field","name":{"kind":"Name","value":"kmat"}},{"kind":"Field","name":{"kind":"Name","value":"knr"}},{"kind":"Field","name":{"kind":"Name","value":"kozp"}},{"kind":"Field","name":{"kind":"Name","value":"ksp"}},{"kind":"Field","name":{"kind":"Name","value":"ktz"}},{"kind":"Field","name":{"kind":"Name","value":"ktzzpm"}},{"kind":"Field","name":{"kind":"Name","value":"ratioStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ratioType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workConditions"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderChangePriceListRatioForObjectsQuery, UerWorkOrderChangePriceListRatioForObjectsQueryVariables>;
export const UerRatioUerRowItemsForWorkOrderObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioUerRowItemsForWorkOrderObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioUerRowItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioUerRowItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioUerRowItemsForWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerRatioUerRowItemsForWorkOrderObjectsQuery, UerRatioUerRowItemsForWorkOrderObjectsQueryVariables>;
export const UerRatioUerRowItemsForWorkOrderRootObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioUerRowItemsForWorkOrderRootObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioUerRowItemFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RatioUerRowItemSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioUerRowItemsForWorkOrderRootObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerRatioUerRowItemsForWorkOrderRootObjectQuery, UerRatioUerRowItemsForWorkOrderRootObjectQueryVariables>;
export const UerApplyRatioToWorkOrderObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyRatioToWorkOrderObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyRatioToWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceListRatioIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyRatioToWorkOrderObjectsMutation, UerApplyRatioToWorkOrderObjectsMutationVariables>;
export const UerApplyWorkOrderPriceRatiosToRootObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyWorkOrderPriceRatiosToRootObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyWorkOrderPriceRatiosToRootObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceListRatioIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyWorkOrderPriceRatiosToRootObjectMutation, UerApplyWorkOrderPriceRatiosToRootObjectMutationVariables>;
export const UerRatioUerRowItemListForWorkOrderRootObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioUerRowItemListForWorkOrderRootObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioUerRowForWorkOrderChangeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioUerRowForWorkOrderChangeSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioUerRowItemListForWorkOrderRootObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerRatioUerRowItemListForWorkOrderRootObjectQuery, UerRatioUerRowItemListForWorkOrderRootObjectQueryVariables>;
export const UerRatioUerRowItemListForWorkOrderObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerRatioUerRowItemListForWorkOrderObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioUerRowForWorkOrderChangeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioUerRowForWorkOrderChangeSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerRatioUerRowItemListForWorkOrderObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"ratioRowId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ratioRowId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appliesToCode"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToCodeName"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToId"}},{"kind":"Field","name":{"kind":"Name","value":"appliesToLinkStatus"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerRatioUerRowItemListForWorkOrderObjectsQuery, UerRatioUerRowItemListForWorkOrderObjectsQueryVariables>;
export const UerApplyWorkOrderChangePriceRatiosToObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyWorkOrderChangePriceRatiosToObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyWorkOrderChangePriceRatiosToObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceListRatioIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyWorkOrderChangePriceRatiosToObjectsMutation, UerApplyWorkOrderChangePriceRatiosToObjectsMutationVariables>;
export const UerApplyWorkOrderChangePriceRatiosToRootObjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uerApplyWorkOrderChangePriceRatiosToRootObject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderChangeObjectIdInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceListRatioRowInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerApplyWorkOrderChangePriceRatiosToRootObject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rootObjectIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderChangeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderChangeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"priceListRatioIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceListRatioIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}}]}}]} as unknown as DocumentNode<UerApplyWorkOrderChangePriceRatiosToRootObjectMutation, UerApplyWorkOrderChangePriceRatiosToRootObjectMutationVariables>;
export const UerWorkOrderVersionOtherPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionOtherPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionOtherPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionOtherPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionId"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedCostDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"planCostDeviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"contractOtherId"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActVersionAcceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActVersionPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonCost"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2VersionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionOtherPriceListQuery, UerWorkOrderVersionOtherPriceListQueryVariables>;
export const UerWorkOrderVersionPriceListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionPriceDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"priceListId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeTerms"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionPrices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedCost"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedVolumeDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionId"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"planVolumeDeviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2VersionPrice"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActVersionPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptyActVersionAcceptedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workReminder"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceListQuery, UerWorkOrderVersionPriceListQueryVariables>;
export const UerWorkOrderVersionActsKc2VersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionActsKC2Version"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionActKC2VersionDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionActKC2VersionDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionActsKC2Version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"fullNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"correctionDate"}},{"kind":"Field","name":{"kind":"Name","value":"correctionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionActsKc2VersionQuery, UerWorkOrderVersionActsKc2VersionQueryVariables>;
export const UerWorkOrderVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"contractor"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAddress"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithTax"}},{"kind":"Field","name":{"kind":"Name","value":"amountWithoutTax"}},{"kind":"Field","name":{"kind":"Name","value":"remainder"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"finishDate"}},{"kind":"Field","name":{"kind":"Name","value":"inflationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"inflationRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vorType"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"signingDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionQuery, UerWorkOrderVersionQueryVariables>;
export const UerWorkOrderVersionObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionObjectDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionObjects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codeWBS"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"shortName"}},{"kind":"Field","name":{"kind":"Name","value":"catalogId"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"contractFileName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasPrices"}},{"kind":"Field","name":{"kind":"Name","value":"hasPricesOther"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderVersionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionObjectsQuery, UerWorkOrderVersionObjectsQueryVariables>;
export const UerWorkOrderVersionSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionSeasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionSeasonsQuery, UerWorkOrderVersionSeasonsQueryVariables>;
export const UerWorkOrderVersionObjectResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionObjectResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChapterEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SectionEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionObjectResultDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionObjectResultDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionObjectResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chapter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chapter"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionId"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"costResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionObjectResultsQuery, UerWorkOrderVersionObjectResultsQueryVariables>;
export const UerWorkOrderVersionResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionResultDataSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionResultDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actKC2VersionId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"resultSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionResultsQuery, UerWorkOrderVersionResultsQueryVariables>;
export const UerWorkOrderVersionPriceItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderVersionPriceItemFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calculatingType"}},{"kind":"Field","name":{"kind":"Name","value":"calculatingTypeValue"}},{"kind":"Field","name":{"kind":"Name","value":"chapter"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"constructionTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"entityTypeUniqueId"}},{"kind":"Field","name":{"kind":"Name","value":"entryId"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"hasEmptySeasonVolume"}},{"kind":"Field","name":{"kind":"Name","value":"hasLimitSpan"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2Price"}},{"kind":"Field","name":{"kind":"Name","value":"isCreatedFromSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"isExcludedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherGroup"}},{"kind":"Field","name":{"kind":"Name","value":"isOtherItem"}},{"kind":"Field","name":{"kind":"Name","value":"isRootObject"}},{"kind":"Field","name":{"kind":"Name","value":"isSMRItem"}},{"kind":"Field","name":{"kind":"Name","value":"itemId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"objectName"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"rootObjectName"}},{"kind":"Field","name":{"kind":"Name","value":"seasonValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actCostAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"actCostAcceptedDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actCostGroup"}},{"kind":"Field","name":{"kind":"Name","value":"actCostPlan"}},{"kind":"Field","name":{"kind":"Name","value":"actCostPlanDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actHasEditableCost"}},{"kind":"Field","name":{"kind":"Name","value":"actId"}},{"kind":"Field","name":{"kind":"Name","value":"actInflationSeasonId"}},{"kind":"Field","name":{"kind":"Name","value":"actStatus"}},{"kind":"Field","name":{"kind":"Name","value":"actStatusSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumeAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumeAcceptedDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumeIsReadOnly"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumePlan"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumePlanDeviation"}},{"kind":"Field","name":{"kind":"Name","value":"actVolumePlanSKzS"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isActKC2DistributionOfMtrInflation"}},{"kind":"Field","name":{"kind":"Name","value":"isCorrection"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"isSKzS"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"completedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"hasErrors"}},{"kind":"Field","name":{"kind":"Name","value":"itemTip"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"planTerms"}},{"kind":"Field","name":{"kind":"Name","value":"planVolume"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"remainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"remainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortOtherPart"}},{"kind":"Field","name":{"kind":"Name","value":"sortPart"}},{"kind":"Field","name":{"kind":"Name","value":"sortSMRPart"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusTip"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanVolume"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderVolume"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"uerId"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitCost"}},{"kind":"Field","name":{"kind":"Name","value":"workCode"}},{"kind":"Field","name":{"kind":"Name","value":"workCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"workInSum"}},{"kind":"Field","name":{"kind":"Name","value":"workKindWorkRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workName"}},{"kind":"Field","name":{"kind":"Name","value":"workPlan"}},{"kind":"Field","name":{"kind":"Name","value":"workRatio"}},{"kind":"Field","name":{"kind":"Name","value":"workReminder"}},{"kind":"Field","name":{"kind":"Name","value":"workUnit"}}]}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemsQuery, UerWorkOrderVersionPriceItemsQueryVariables>;
export const UerWorkOrderVersionTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionTotalsQuery, UerWorkOrderVersionTotalsQueryVariables>;
export const UerWorkOrderVersionObjectTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionObjectTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionObjectTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionObjectId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isHeadLine"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seasonTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedCost"}},{"kind":"Field","name":{"kind":"Name","value":"planCost"}},{"kind":"Field","name":{"kind":"Name","value":"seasonId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCompletedCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlanCost"}},{"kind":"Field","name":{"kind":"Name","value":"totalRemainderCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionObjectTotalsQuery, UerWorkOrderVersionObjectTotalsQueryVariables>;
export const UerWorkOrderVersionPriceItemChapterFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemChapterFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfChapterEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemChapterFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemChapterFilterQuery, UerWorkOrderVersionPriceItemChapterFilterQueryVariables>;
export const UerWorkOrderVersionPriceItemStatusFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemStatusFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemStatusFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemStatusFilterQuery, UerWorkOrderVersionPriceItemStatusFilterQueryVariables>;
export const UerWorkOrderVersionPriceItemCodeFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemCodeFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfWorkOrderPriceItemCodeFilterDataFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemCodeFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isMtr"}},{"kind":"Field","name":{"kind":"Name","value":"isRatio"}},{"kind":"Field","name":{"kind":"Name","value":"isUer"}},{"kind":"Field","name":{"kind":"Name","value":"sortSMRPart"}},{"kind":"Field","name":{"kind":"Name","value":"uerCode"}},{"kind":"Field","name":{"kind":"Name","value":"uerCodeId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemCodeFilterQuery, UerWorkOrderVersionPriceItemCodeFilterQueryVariables>;
export const UerWorkOrderVersionPriceItemNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemNameFilterQuery, UerWorkOrderVersionPriceItemNameFilterQueryVariables>;
export const UerWorkOrderVersionPriceItemUnitFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemUnitFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemUnitFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemUnitFilterQuery, UerWorkOrderVersionPriceItemUnitFilterQueryVariables>;
export const UerWorkOrderVersionPriceItemWorkNameFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemWorkNameFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfStringFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemWorkNameFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemWorkNameFilterQuery, UerWorkOrderVersionPriceItemWorkNameFilterQueryVariables>;
export const UerWorkOrderVersionPriceItemWorkInSumFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemWorkInSumFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterValueOfNullableOfWorkInSumEnumFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uerWorkOrderVersionPriceItemWorkInSumFilter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderVersionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"constructionTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constructionTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rootObjectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rootObjectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<UerWorkOrderVersionPriceItemWorkInSumFilterQuery, UerWorkOrderVersionPriceItemWorkInSumFilterQueryVariables>;
export const UercExtractTotalSumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"uercExtractTotalSum"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uercExtractTotalSum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"}}]}}]}}]}}]} as unknown as DocumentNode<UercExtractTotalSumQuery, UercExtractTotalSumQueryVariables>;
export const AppModulesReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appModulesReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modules"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ModuleEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeHealth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeResources"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceDataResultOfAppModuleReportFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceDataResultOfAppModuleReportSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appModulesReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"modules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modules"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeHealth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeHealth"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeResources"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeResources"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"branch"}},{"kind":"Field","name":{"kind":"Name","value":"buildDate"}},{"kind":"Field","name":{"kind":"Name","value":"commit"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"healthCheckData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"healthChecks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"property"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"release"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasValidation"}},{"kind":"Field","name":{"kind":"Name","value":"hideValidation"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"validation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AppModulesReportQuery, AppModulesReportQueryVariables>;